export const users = {
  list: {
    users: [
      {
        _id: "666c002685672a7368dac285",
        uid: "666c002685672a7368dac285",
        userIds: ["666c002685672a7368dac285"],
        wallets: [
          {
            status: "verified",
            walletId: "683749437a939d1fbcfd4e98",
            ecosystem: "evm",
            walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 60,
        walletTotalValue: 42048108659.34924,
        walletAge: "7y1m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "Universa",
              symbol: "UTNP",
              address: "0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7",
              price: 2817.85,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "10",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "WhiteBIT Token",
              symbol: "WBT",
              address: "0x925206b8a707096Ed26ae47C84747fE0bb734F59",
              price: 30.26,
            },
            {
              chainId: "1",
              name: "Gate",
              symbol: "GT",
              address: "0xe66747a101bff2dba3697199dcce5b743b454759",
              price: 21.81,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "UNUS SED LEO",
              symbol: "LEO",
              address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
              price: 8.85,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Bitget Token",
              symbol: "BGB",
              address: "0x19de6b897ed14a376dda0fe53a5420d2ac828a28",
              price: 5.03,
            },
            {
              chainId: "1",
              name: "Dohrnii",
              symbol: "DHN",
              address: "0x32462ba310e447ef34ff0d15bce8613aa8c4a244",
              price: 2.58,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "10",
              name: "Dai",
              symbol: "dai",
              address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
              price: 0.999847,
            },
            {
              chainId: "137",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "StablR USD",
              symbol: "USDR",
              address: "0x7b43e3875440b44613dc3bc08e7763e6da63c8f8",
              price: 0.999582,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "137",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7",
              price: 0.541937,
            },
            {
              chainId: "1",
              name: "Fenerbahçe Token",
              symbol: "FB",
              address: "0xfb19075d77a0f111796fb259819830f4780f1429",
              price: 0.426695,
            },
            {
              chainId: "137",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0xbbba073c31bf03b8acf7c28ef0738decf3695683",
              price: 0.32675,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "POL (ex-MATIC)",
              symbol: "POL",
              address: "0x455e53cbb86018ac2b8092fdcd39d8444affc3f6",
              price: 0.241124,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "SWM",
              address: "0x9e88613418cf03dca54d6a2cf6ad934a78c7a17a",
              price: 0.219705,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Starknet",
              symbol: "STRK",
              address: "0xca14007eff0db1f8135f4c25b34de49ab0d42766",
              price: 0.161629,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Dora Factory",
              symbol: "DORA",
              address: "0x4957805230831401caad5b690aa138143b711358",
              price: 0.02540621,
            },
            {
              chainId: "1",
              name: "Wrapped Nine Chronicles",
              symbol: "WNCG",
              address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
              price: 0.0247011,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Streamr",
              symbol: "DATA",
              address: "0x8f693ca8d21b157107184d29d398a8d082b38b76",
              price: 0.01748672,
            },
            {
              chainId: "1",
              name: "Wagmi",
              symbol: "WAGMI",
              address: "0x92cc36d66e9d739d50673d1f27929a371fb83a67",
              price: 0.0077906,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "RWAX",
              symbol: "APP",
              address: "0xc5d27f27f08d1fd1e3ebbaa50b3442e6c0d50439",
              price: 0.00453831,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "1",
              name: "Loom Network [OLD]",
              symbol: "LOOM",
              address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
              price: 0.00370114,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Lif3",
              symbol: "LIF3",
              address: "0x7138eb0d563f3f6722500936a11dcae99d738a2c",
              price: 0.00240961,
            },
            {
              chainId: "137",
              name: "Snook",
              symbol: "SNK",
              address: "0x689f8e5913c158ffb5ac5aeb83b3c875f5d20309",
              price: 0.00240428,
            },
            {
              chainId: "137",
              name: "REVV",
              symbol: "REVV",
              address: "0x70c006878a5A50Ed185ac4C87d837633923De296",
              price: 0.00144624,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "137",
              name: "Tower",
              symbol: "TOWER",
              address: "0x2bc07124d8dac638e290f401046ad584546bc47b",
              price: 0.00044296,
            },
            {
              chainId: "1",
              name: "Karate Combat",
              symbol: "KARATE",
              address: "0x80008bcd713c38af90a9930288d446bc3bd2e684",
              price: 0.00015916,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Peezy (peezy.vip)",
              symbol: "PEEZY",
              address: "0x698b1d54e936b9f772b8f58447194bbc82ec1933",
              price: 0.00000357,
            },
            {
              chainId: "1",
              name: "Chickencoin",
              symbol: "CHKN",
              address: "0xd55210bb6898c021a19de1f58d27b71f095921ee",
              price: 3.8381e-8,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161],
        cexLabels: ["Bitfinex"],
        tags: [
          {
            _id: "654265fee31a7181bb7e57b8",
            value: "uso1111",
            color: "#FAA7E0",
          },
          {
            _id: "65a626d81c255bb47d031d17",
            value: "kfc",
            color: "#D6BBFB",
          },
          {
            _id: "67bffb2d03b9853db6a7022d",
            value: "Wow",
            color: "#F3E87F",
          },
          {
            _id: "682711d3e3a4af454ea23f25",
            value: "l",
            color: "#EBD9B7",
          },
          {
            _id: "682711d8e3a4af454ea23f37",
            value: "nj",
            color: "#D0D5DD",
          },
          {
            _id: "682711dbe3a4af454ea23f54",
            value: "kj",
            color: "#EABBFB",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-14T08:34:25.304Z",
          type: "contractImport",
        },
      },
      {
        _id: "66b2df93eb9d48f61f022008",
        uid: "66b2df93eb9d48f61f022008",
        userIds: ["66b2df93eb9d48f61f022008"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd8c02",
            ecosystem: "evm",
            walletAddress: "0xF977814e90dA44bFA03b6295A0616a897441aceC",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 232,
        walletTotalValue: 31159263850.817947,
        walletAge: "5y10m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Huobi BTC",
              symbol: "HBTC",
              address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
              price: 11110.54,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "10",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Wrapped Beacon ETH",
              symbol: "WBETH",
              address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
              price: 1918.25,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "42161",
              name: "WETH",
              symbol: "WETH",
              address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
              price: 1795.73,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Binance Wrapped DOT",
              symbol: "BDOT",
              address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
              price: 4.29,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Mettalex",
              symbol: "MTLX",
              address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
              price: 2.11,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "42161",
              name: "Gains Network",
              symbol: "GNS",
              address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
              price: 1.51,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "10",
              name: "Tether",
              symbol: "usdt",
              address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
              price: 0.999984,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "42161",
              name: "Dai",
              symbol: "DAI",
              address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
              price: 0.999647,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "10",
              name: "Optimism",
              symbol: "op",
              address: "0x4200000000000000000000000000000000000042",
              price: 0.764988,
            },
            {
              chainId: "10",
              name: "Synthetix Network",
              symbol: "snx",
              address: "0x8700daec35af8ff88c16bdf0418774cb3d7599b4",
              price: 0.764947,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "42161",
              name: "Synapse",
              symbol: "SYN",
              address: "0x080f6aed32fc474dd5717105dba5ea57268f46eb",
              price: 0.542161,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "8217",
              name: "KAIA",
              symbol: "KAIA",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 0.224765,
            },
            {
              chainId: "1",
              name: "Cortex",
              symbol: "CTXC",
              address: "0xea11755ae41d889ceec39a63e6ff75a02bc1c00d",
              price: 0.210565,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "42161",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0x6694340fc020c5E6B96567843da2df01b2CE1eb6",
              price: 0.181186,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
              price: 0.0245393,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Lunyr",
              symbol: "LUN",
              address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
              price: 0.01190772,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "SwftCoin",
              symbol: "SWFTC",
              address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
              price: 0.00906635,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Bread",
              symbol: "BRD",
              address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
              price: 0.00579243,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "pNetwork",
              symbol: "PNT",
              address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
              price: 0.0033276,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "GuildFi",
              symbol: "GF",
              address: "0xaaef88cea01475125522e117bfe45cf32044e238",
              price: 0.00314237,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Wabi",
              symbol: "WABI",
              address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
              price: 0.00109904,
            },
            {
              chainId: "1",
              name: "Agrello",
              symbol: "DLT",
              address: "0x07e3c70653548B04f0A75970C1F81B4CBbFB606f",
              price: 0.00097389,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0xeca82185adce47f39c684352b0439f030f860318",
              price: 0.00047299,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Substratum",
              symbol: "SUB",
              address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
              price: 0.00034775,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Etherparty",
              symbol: "FUEL",
              address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
              price: 0.0000579,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Cult DAO",
              symbol: "CULT",
              address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
              price: 0.00000126,
            },
            {
              chainId: "1",
              name: "VIBE",
              symbol: "VIBE",
              address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
              price: 0.00000115,
            },
            {
              chainId: "1",
              name: "Bolt Token",
              symbol: "BOLT",
              address: "0x9f235d23354857efe6c541db92a9ef1877689bcb",
              price: 6.288e-8,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "Ryoshis Vision",
              symbol: "RYOSHI",
              address: "0x777E2ae845272a2F540ebf6a3D03734A5a8f618e",
              price: 2.295e-9,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
          ],
        },
        chainIds: [1, 10, 42161, 8217],
        cexLabels: ["Unknown"],
        tags: [
          {
            _id: "654265fee31a7181bb7e57b8",
            value: "uso1111",
            color: "#FAA7E0",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
          {
            _id: "6769c75336571c603eac7538",
            value: "lalala",
            color: "#BBFDA4",
          },
          {
            _id: "67bffb2d03b9853db6a7022d",
            value: "Wow",
            color: "#F3E87F",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:35.168Z",
          type: "csvImport",
        },
      },
      {
        _id: "66b2df95eb9d48f61f022154",
        uid: "66b2df95eb9d48f61f022154",
        userIds: ["66b2df95eb9d48f61f022154"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd8ebd",
            ecosystem: "evm",
            walletAddress: "0x5a52E96BAcdaBb82fd05763E25335261B270Efcb",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 125,
        walletTotalValue: 3390685306.4125032,
        walletAge: "0y9m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Wabi",
              symbol: "WABI",
              address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
              price: 0.00109904,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "PLEB Token",
              symbol: "PLEB",
              address: "0xe19f85c920b572ca48942315b06d6cac86585c87",
              price: 1.379e-9,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:37.838Z",
          type: "csvImport",
        },
      },
      {
        _id: "666bfe3c85672a7368da6ddc",
        uid: "666bfe3c85672a7368da6ddc",
        userIds: ["666bfe3c85672a7368da6ddc"],
        wallets: [
          {
            status: "verified",
            walletId: "683749437a939d1fbcfd1e08",
            ecosystem: "evm",
            walletAddress: "0xFBb1b73C4f0BDa4f67dcA266ce6Ef42f520fBB98",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 337,
        walletTotalValue: 3219897558.392873,
        walletAge: "9y9m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "CACHE Gold",
              symbol: "CGT",
              address: "0xf5238462e7235c7b62811567e63dd17d12c2eaa0",
              price: 84.62,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Inverse Finance",
              symbol: "INV",
              address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
              price: 48.04,
            },
            {
              chainId: "1",
              name: "NFTX",
              symbol: "NFTX",
              address: "0x87d73e916d7057945c9bcd8cdd94e42a6f47f776",
              price: 46.8,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Strike",
              symbol: "STRK",
              address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
              price: 12.59,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "YF Link",
              symbol: "YFL",
              address: "0x28cb7e841ee97947a86b06fa4090c8451f64c0be",
              price: 7.34,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Uquid Coin",
              symbol: "UQC",
              address: "0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2",
              price: 5.23,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Aventus",
              symbol: "AVT",
              address: "0x0d88ed6e74bbfd96b831231638b66c05571e824f",
              price: 2.34,
            },
            {
              chainId: "1",
              name: "Tokamak Network",
              symbol: "TON",
              address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
              price: 1.78,
            },
            {
              chainId: "1",
              name: "TOM Finance",
              symbol: "TOM",
              address: "0xf7970499814654cd13cb7b6e7634a12a7a8a9abc",
              price: 1.75,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Poundtoken",
              symbol: "GBPT",
              address: "0x86B4dBE5D203e634a12364C0e428fa242A3FbA98",
              price: 1.32,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "Euro Coin",
              symbol: "EUROC",
              address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
              price: 1.038,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "Parallel",
              symbol: "PAR",
              address: "0x68037790a0229e9ce6eaa8a99ea92964106c4703",
              price: 0.998418,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "1",
              name: "Reserve",
              symbol: "RSV",
              address: "0x196f4727526eA7FB1e17b2071B3d8eAA38486988",
              price: 0.914392,
            },
            {
              chainId: "1",
              name: "Bitpanda Ecosystem Token",
              symbol: "BEST",
              address: "0x1b073382e63411e3bcffe90ac1b9a43fefa1ec6f",
              price: 0.894907,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "GPEX",
              symbol: "GPX",
              address: "0x3e7804c51a70ba26e904c2e0ab440c5623a8a83f",
              price: 0.780128,
            },
            {
              chainId: "1",
              name: "Agoras",
              symbol: "AGRS",
              address: "0x738865301a9b7dd80dc3666dd48cf034ec42bdda",
              price: 0.778602,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "GET Protocol",
              symbol: "GET",
              address: "0x8a854288a5976036a725879164ca3e91d30c6a1b",
              price: 0.67031,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "OriginTrail",
              symbol: "TRAC",
              address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
              price: 0.623907,
            },
            {
              chainId: "1",
              name: "Rook",
              symbol: "ROOK",
              address: "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
              price: 0.622491,
            },
            {
              chainId: "1",
              name: "PTON",
              symbol: "PTON",
              address: "0x4946583c5b86e01ccd30c71a05617d06e3e73060",
              price: 0.620987,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "Gomining Token",
              symbol: "GMT",
              address: "0x7ddc52c4de30e94be3a6a0a2b259b2850f421989",
              price: 0.517705,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "Metronome",
              symbol: "MET",
              address: "0x2Ebd53d035150f328bd754D6DC66B99B0eDB89aa",
              price: 0.369542,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "REAL",
              symbol: "REAL",
              address: "0x9214ec02cb71cba0ada6896b8da260736a67ab10",
              price: 0.29851,
            },
            {
              chainId: "1",
              name: "Mysterium",
              symbol: "MYST",
              address: "0x4cf89ca06ad997bc732dc876ed2a7f26a9e7f361",
              price: 0.295197,
            },
            {
              chainId: "1",
              name: "Morpheus Network",
              symbol: "MNW",
              address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
              price: 0.286024,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Braintrust",
              symbol: "BTRST",
              address: "0x799ebfabe77a6e34311eeee9825190b9ece32824",
              price: 0.264272,
            },
            {
              chainId: "1",
              name: "Quantum Resistant Ledger",
              symbol: "QRL",
              address: "0x697beac28b09e122c4332d163985e8a73121b97f",
              price: 0.253108,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "SWM",
              address: "0x9e88613418cf03dca54d6a2cf6ad934a78c7a17a",
              price: 0.219705,
            },
            {
              chainId: "1",
              name: "Vesper",
              symbol: "VSP",
              address: "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
              price: 0.212157,
            },
            {
              chainId: "1",
              name: "LockTrip",
              symbol: "LOC",
              address: "0x5e3346444010135322268a4630d2ed5f8d09446c",
              price: 0.209365,
            },
            {
              chainId: "1",
              name: "Blox",
              symbol: "CDT",
              address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
              price: 0.205372,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "SocialGood",
              symbol: "SG",
              address: "0xddf7fd345d54ff4b40079579d4c4670415dbfd0a",
              price: 0.182196,
            },
            {
              chainId: "1",
              name: "ERC20",
              symbol: "ERC20",
              address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
              price: 0.181667,
            },
            {
              chainId: "1",
              name: "Rari Governance Token",
              symbol: "RGT",
              address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
              price: 0.180052,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Opus",
              symbol: "OPT",
              address: "0x4355fC160f74328f9b383dF2EC589bB3dFd82Ba0",
              price: 0.159029,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Function X",
              symbol: "FX",
              address: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
              price: 0.138919,
            },
            {
              chainId: "1",
              name: "Internxt",
              symbol: "INXT",
              address: "0x4a8f5f96d5436e43112c2fbc6a9f70da9e4e16d4",
              price: 0.127643,
            },
            {
              chainId: "1",
              name: "Chromia",
              symbol: "CHR",
              address: "0x915044526758533dfB918ecEb6e44bc21632060D",
              price: 0.117663,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "EdenLoop",
              symbol: "ELT",
              address: "0xfC1Cb4920dC1110fD61AfaB75Cf085C1f871b8C6",
              price: 0.100016,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "1",
              name: "SMART VALOR",
              symbol: "VALOR",
              address: "0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a",
              price: 0.088166,
            },
            {
              chainId: "1",
              name: "KING DAG",
              symbol: "KDAG",
              address: "0x95e40e065afb3059dcabe4aaf404c1f92756603a",
              price: 0.08648,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "1",
              name: "VLaunch",
              symbol: "VPAD",
              address: "0x51FE2E572e97BFEB1D719809d743Ec2675924EDc",
              price: 0.08336,
            },
            {
              chainId: "1",
              name: "XELS",
              symbol: "XELS",
              address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
              price: 0.080759,
            },
            {
              chainId: "1",
              name: "IQeon",
              symbol: "IQN",
              address: "0x0DB8D8b76BC361bAcbB72E2C491E06085A97Ab31",
              price: 0.0788,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Sentinel Protocol",
              symbol: "UPP",
              address: "0xc86d054809623432210c107af2e3f619dcfbf652",
              price: 0.076931,
            },
            {
              chainId: "1",
              name: "Assemble Protocol",
              symbol: "ASM",
              address: "0x2565ae0385659badcada1031db704442e1b69982",
              price: 0.071723,
            },
            {
              chainId: "1",
              name: "Castello Coin",
              symbol: "CAST",
              address: "0x3fab0bbaa03bceaf7c49e2b12877db0142be65fc",
              price: 0.070792,
            },
            {
              chainId: "1",
              name: "RAMP",
              symbol: "RAMP",
              address: "0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
              price: 0.069918,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "Mossland",
              symbol: "MOC",
              address: "0x865ec58b06bF6305B886793AA20A2da31D034E68",
              price: 0.062272,
            },
            {
              chainId: "1",
              name: "SUKU",
              symbol: "SUKU",
              address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
              price: 0.061202,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "1peco",
              symbol: "1PECO",
              address: "0x7169ba45cf03e0377b464462aacbccdf1f721125",
              price: 0.055828,
            },
            {
              chainId: "1",
              name: "Dragonchain",
              symbol: "DRGN",
              address: "0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e",
              price: 0.05525,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "My Crypto Heroes",
              symbol: "MCHC",
              address: "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
              price: 0.051445,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "SpaceChain",
              symbol: "SPC",
              address: "0x86ed939b500e121c0c5f493f399084db596dad20",
              price: 0.04315581,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "PolySwarm",
              symbol: "NCT",
              address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
              price: 0.03448223,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "1",
              name: "Tranche Finance",
              symbol: "SLICE",
              address: "0x0aee8703d34dd9ae107386d3eff22ae75dd616d1",
              price: 0.03388895,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "1",
              name: "SunContract",
              symbol: "SNC",
              address: "0xF4134146AF2d511Dd5EA8cDB1C4AC88C57D60404",
              price: 0.03191363,
            },
            {
              chainId: "1",
              name: "FirmaChain",
              symbol: "FCT",
              address: "0xE1bAD922F84b198A08292FB600319300ae32471b",
              price: 0.03107092,
            },
            {
              chainId: "1",
              name: "Covesting",
              symbol: "COV",
              address: "0xe2fb6529ef566a080e6d23de0bd351311087d567",
              price: 0.02852131,
            },
            {
              chainId: "1",
              name: "BiLira",
              symbol: "TRYB",
              address: "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
              price: 0.02837526,
            },
            {
              chainId: "1",
              name: "Orbs",
              symbol: "ORBS",
              address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
              price: 0.02748275,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
              price: 0.02641525,
            },
            {
              chainId: "1",
              name: "Privatix",
              symbol: "PRIX",
              address: "0x3adfc4999f77d04c8341bac5f3a76f58dff5b37a",
              price: 0.02555552,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Juggernaut",
              symbol: "JGN",
              address: "0x73374ea518de7addd4c2b624c0e8b113955ee041",
              price: 0.01925424,
            },
            {
              chainId: "1",
              name: "NAGA",
              symbol: "NGC",
              address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
              price: 0.0183165,
            },
            {
              chainId: "1",
              name: "Swarm City",
              symbol: "SWT",
              address: "0xb9e7f8568e08d5659f5d29c4997173d84cdf2607",
              price: 0.01830079,
            },
            {
              chainId: "1",
              name: "Bit2Me",
              symbol: "B2M",
              address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
              price: 0.01691978,
            },
            {
              chainId: "1",
              name: "Saltmarble",
              symbol: "SML",
              address: "0x1A403E1c96792dFedb8232cF56400Eb72Ab95Acb",
              price: 0.01567203,
            },
            {
              chainId: "1",
              name: "Dvision Network",
              symbol: "DVI",
              address: "0x10633216e7e8281e33c86f02bf8e565a635d9770",
              price: 0.0148875,
            },
            {
              chainId: "1",
              name: "Bistroo",
              symbol: "BIST",
              address: "0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f",
              price: 0.01430946,
            },
            {
              chainId: "1",
              name: "Linework Coin",
              symbol: "LWC",
              address: "0xa6a1cc527d48585538b137e6abc14b2a55489d11",
              price: 0.01417351,
            },
            {
              chainId: "1",
              name: "Obortech",
              symbol: "OBOT",
              address: "0xeDADeB5fAa413e6c8623461849DFD0B7C3790c32",
              price: 0.01329397,
            },
            {
              chainId: "1",
              name: "BOSAGORA",
              symbol: "BOA",
              address: "0x746dda2ea243400d5a63e0700f190ab79f06489e",
              price: 0.01322151,
            },
            {
              chainId: "1",
              name: "Bubblefong",
              symbol: "BBF",
              address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
              price: 0.01299892,
            },
            {
              chainId: "1",
              name: "Unibright",
              symbol: "UBT",
              address: "0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e",
              price: 0.01273273,
            },
            {
              chainId: "1",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
              price: 0.01210312,
            },
            {
              chainId: "1",
              name: "Covenant",
              symbol: "COVN",
              address: "0x19ac2659599fd01c853de846919544276ad26f50",
              price: 0.01204608,
            },
            {
              chainId: "1",
              name: "Lunyr",
              symbol: "LUN",
              address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
              price: 0.01190772,
            },
            {
              chainId: "1",
              name: "Zeptacoin",
              symbol: "ZPTC",
              address: "0x39ae6d231d831756079ec23589d2d37a739f2e89",
              price: 0.01167557,
            },
            {
              chainId: "1",
              name: "HYVE.works",
              symbol: "HYVE",
              address: "0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4",
              price: 0.01167148,
            },
            {
              chainId: "1",
              name: "Wrapped Accumulate",
              symbol: "WACME",
              address: "0xDF4Ef6EE483953fE3B84ABd08C6A060445c01170",
              price: 0.01129819,
            },
            {
              chainId: "1",
              name: "Hxro",
              symbol: "HXRO",
              address: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
              price: 0.01106095,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "Panther Protocol",
              symbol: "ZKP",
              address: "0x909E34d3f6124C324ac83DccA84b74398a6fa173",
              price: 0.01066803,
            },
            {
              chainId: "1",
              name: "BLOCKv",
              symbol: "VEE",
              address: "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
              price: 0.0104663,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "HedgeTrade",
              symbol: "HEDG",
              address: "0xf1290473e210b2108a85237fbcd7b6eb42cc654f",
              price: 0.00991916,
            },
            {
              chainId: "1",
              name: "CUDOS",
              symbol: "CUDOS",
              address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
              price: 0.00963311,
            },
            {
              chainId: "1",
              name: "KickToken (old)",
              symbol: "KICK",
              address: "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
              price: 0.00860573,
            },
            {
              chainId: "1",
              name: "PointPay",
              symbol: "PXP",
              address: "0x95aa5d2dbd3c16ee3fdea82d5c6ec3e38ce3314f",
              price: 0.00851488,
            },
            {
              chainId: "1",
              name: "FLIP",
              symbol: "FLP",
              address: "0x3a1bda28adb5b0a812a7cf10a1950c920f79bcd3",
              price: 0.00827169,
            },
            {
              chainId: "1",
              name: "O3 Swap",
              symbol: "O3",
              address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
              price: 0.00803362,
            },
            {
              chainId: "1",
              name: "GNY",
              symbol: "GNY",
              address: "0xb1f871ae9462f1b2c6826e88a7827e76f86751d4",
              price: 0.00797152,
            },
            {
              chainId: "1",
              name: "AI Network",
              symbol: "AIN",
              address: "0x3a810ff7211b40c4fa76205a14efe161615d0385",
              price: 0.00774991,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "Vivid Labs",
              symbol: "VID",
              address: "0x2c9023bbc572ff8dc1228c7858a280046ea8c9e5",
              price: 0.00712976,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "Cosplay Token",
              symbol: "COT",
              address: "0x5cac718a3ae330d361e39244bf9e67ab17514ce8",
              price: 0.00670004,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Xaurum",
              symbol: "XAUR",
              address: "0x4df812f6064def1e5e029f1ca858777cc98d2d81",
              price: 0.00628105,
            },
            {
              chainId: "1",
              name: "Polkacity",
              symbol: "POLC",
              address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
              price: 0.00600761,
            },
            {
              chainId: "1",
              name: "TenX",
              symbol: "PAY",
              address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
              price: 0.00586091,
            },
            {
              chainId: "1",
              name: "Dorado",
              symbol: "DOR",
              address: "0x906b3f8b7845840188eab53c3f5ad348a787752f",
              price: 0.00556955,
            },
            {
              chainId: "1",
              name: "SkinCoin",
              symbol: "SKIN",
              address: "0x2bdc0d42996017fce214b21607a515da41a9e0c5",
              price: 0.00552725,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "Bloom",
              symbol: "BLT",
              address: "0x107c4504cd79c5d2696ea0030a8dd4e92601b82e",
              price: 0.00500121,
            },
            {
              chainId: "1",
              name: "Mimo Governance Token",
              symbol: "MIMO",
              address: "0x90b831fa3bebf58e9744a14d638e25b4ee06f9bc",
              price: 0.00473819,
            },
            {
              chainId: "1",
              name: "Hifi Finance (old)",
              symbol: "MFT",
              address: "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
              price: 0.00464541,
            },
            {
              chainId: "1",
              name: "Civilization",
              symbol: "CIV",
              address: "0x37fe0f067fa808ffbdd12891c0858532cfe7361d",
              price: 0.004435997972434388,
            },
            {
              chainId: "1",
              name: "Databroker",
              symbol: "DTX",
              address: "0x765f0c16d1ddc279295c1a7c24b0883f62d33f75",
              price: 0.00432293,
            },
            {
              chainId: "1",
              name: "Abyss Finance",
              symbol: "ABYSS",
              address: "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
              price: 0.00411388,
            },
            {
              chainId: "1",
              name: "Dawn Protocol",
              symbol: "DAWN",
              address: "0x580c8520deda0a441522aeae0f9f7a5f29629afa",
              price: 0.00404123,
            },
            {
              chainId: "1",
              name: "Solve",
              symbol: "SOLVE",
              address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
              price: 0.00402632,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "apM Coin",
              symbol: "APM",
              address: "0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c",
              price: 0.00345688,
            },
            {
              chainId: "1",
              name: "Globe Derivative Exchange",
              symbol: "GDT",
              address: "0xc67b12049c2d0cf6e476bc64c7f82fc6c63cffc5",
              price: 0.00334436,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "ShareToken",
              symbol: "SHR",
              address: "0xd98F75b1A3261dab9eEd4956c93F33749027a964",
              price: 0.00315436,
            },
            {
              chainId: "1",
              name: "MetaRare",
              symbol: "MTRA",
              address: "0xc62def1701309bb76e6b39b6ab8b5fac910a3c87",
              price: 0.00299926,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Public Mint",
              symbol: "MINT",
              address: "0x0cdf9acd87e940837ff21bb40c9fd55f68bba059",
              price: 0.00275821,
            },
            {
              chainId: "1",
              name: "EQIFI",
              symbol: "EQX",
              address: "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
              price: 0.0024537,
            },
            {
              chainId: "1",
              name: "ALIS",
              symbol: "ALIS",
              address: "0xEA610B1153477720748DC13ED378003941d84fAB",
              price: 0.00239809,
            },
            {
              chainId: "1",
              name: "GameCredits",
              symbol: "GAME",
              address: "0x63f88a2298a5c4aee3c216aa6d926b184a4b2437",
              price: 0.00234548,
            },
            {
              chainId: "1",
              name: "Label",
              symbol: "LBL",
              address: "0x2162f572b25f7358db9376ab58a947a4e45cede1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "Label Foundation",
              symbol: "LBL",
              address: "0x2162f572B25f7358db9376AB58a947a4e45CeDE1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "ETHA Lend",
              symbol: "ETHA",
              address: "0x59e9261255644c411afdd00bd89162d09d862e38",
              price: 0.00220437,
            },
            {
              chainId: "1",
              name: "BiFi",
              symbol: "BIFI",
              address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
              price: 0.00209525,
            },
            {
              chainId: "1",
              name: "Hydro",
              symbol: "HYDRO",
              address: "0x946112efab61c3636cbd52de2e1392d7a75a6f01",
              price: 0.00202679,
            },
            {
              chainId: "1",
              name: "Humaniq",
              symbol: "HMQ",
              address: "0xcbcc0f036ed4788f63fc0fee32873d6a7487b908",
              price: 0.0019938,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Statera",
              symbol: "STA",
              address: "0xa7DE087329BFcda5639247F96140f9DAbe3DeED1",
              price: 0.00188553,
            },
            {
              chainId: "1",
              name: "BnkToTheFuture",
              symbol: "BFT",
              address: "0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f",
              price: 0.00172378,
            },
            {
              chainId: "1",
              name: "VEMP",
              symbol: "VEMP",
              address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
              price: 0.00171918,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "Arowana Token",
              symbol: "ARW",
              address: "0x351caa9045d65107b9d311d922d15887cfd634e4",
              price: 0.00162324,
            },
            {
              chainId: "1",
              name: "Change",
              symbol: "CAG",
              address: "0x7d4b8cce0591c9044a22ee543533b72e976e36c3",
              price: 0.00161374,
            },
            {
              chainId: "1",
              name: "Project TXA",
              symbol: "TXA",
              address: "0x4463e6A3dEd0dBE3F6e15bC8420dFc55e5FeA830",
              price: 0.00158853,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "Balkari Token",
              symbol: "BKR",
              address: "0x77271813bd9167e75b5df9c230cf58d64f0a58fd",
              price: 0.00140985,
            },
            {
              chainId: "1",
              name: "REVV",
              symbol: "REVV",
              address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
              price: 0.00135141,
            },
            {
              chainId: "1",
              name: "ARTIC Foundation",
              symbol: "ARTIC",
              address: "0xe83d5fb2c60b3a2597452e248cf7b2f52a7e731e",
              price: 0.00129841,
            },
            {
              chainId: "1",
              name: "28VCK",
              symbol: "VCK",
              address: "0xfa5b75a9e13df9775cf5b996a049d9cc07c15731",
              price: 0.00124927,
            },
            {
              chainId: "1",
              name: "YIELD App",
              symbol: "YLD",
              address: "0xf94b5c5651c888d928439ab6514b93944eee6f48",
              price: 0.00124088,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
              price: 0.00119494,
            },
            {
              chainId: "1",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
              price: 0.00110671,
            },
            {
              chainId: "1",
              name: "Tap",
              symbol: "XTP",
              address: "0x6368e1E18c4C419DDFC608A0BEd1ccb87b9250fc",
              price: 0.00101058,
            },
            {
              chainId: "1",
              name: "RFOX",
              symbol: "RFOX",
              address: "0xa1d6df714f91debf4e0802a542e13067f31b8262",
              price: 0.00099509,
            },
            {
              chainId: "1",
              name: "Fox Trading",
              symbol: "FOXT",
              address: "0xfbe878ced08132bd8396988671b450793c44bc12",
              price: 0.0009139,
            },
            {
              chainId: "1",
              name: "Sylo",
              symbol: "SYLO",
              address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
              price: 0.00089542,
            },
            {
              chainId: "1",
              name: "SpaceMine",
              symbol: "MINE",
              address: "0xb7DE92bE975ccb27e7352a1D47512aCBdb0BaC32",
              price: 0.00086926,
            },
            {
              chainId: "1",
              name: "HEROcoin",
              symbol: "PLAY",
              address: "0xe477292f1b3268687a29376116b0ed27a9c76170",
              price: 0.00086413,
            },
            {
              chainId: "1",
              name: "Student Coin",
              symbol: "STC",
              address: "0x15b543e986b8c34074dfc9901136d9355a537e7e",
              price: 0.00084146,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Meta Finance",
              symbol: "MF1",
              address: "0x9b5161a41b58498eb9c5febf89d60714089d2253",
              price: 0.00079875,
            },
            {
              chainId: "1",
              name: "Erugo World Coin",
              symbol: "EWC",
              address: "0xcd74cf66c43e45abd5703f3642f73d0675d6aff7",
              price: 0.00079585,
            },
            {
              chainId: "1",
              name: "UniX Gaming",
              symbol: "UNIX",
              address: "0xddd6a0ecc3c6f6c102e5ea3d8af7b801d1a77ac8",
              price: 0.00078189,
            },
            {
              chainId: "1",
              name: "DigitalBits",
              symbol: "XDB",
              address: "0xb9eefc4b0d472a44be93970254df4f4016569d27",
              price: 0.00074882,
            },
            {
              chainId: "1",
              name: "DMarket",
              symbol: "DMT",
              address: "0x2ccbff3a042c68716ed2a2cb0c544a9f1d1935e1",
              price: 0.00065251,
            },
            {
              chainId: "1",
              name: "Pollchain",
              symbol: "POLL",
              address: "0x4b0f027d0b694aae2761ed2d426295d4f949f5d0",
              price: 0.00061796,
            },
            {
              chainId: "1",
              name: "SIRIN LABS Token",
              symbol: "SRN",
              address: "0x68d57c9a1c35f63e2c83ee8e49a64e9d70528d25",
              price: 0.00057791,
            },
            {
              chainId: "1",
              name: "CPChain",
              symbol: "CPC",
              address: "0xfae4ee59cdd86e3be9e8b90b53aa866327d7c090",
              price: 0.00054942,
            },
            {
              chainId: "1",
              name: "BaaSid",
              symbol: "BAAS",
              address: "0x5d929aa919e489505ccaad8a199619c6dca0c2de",
              price: 0.00050021,
            },
            {
              chainId: "1",
              name: "300FIT",
              symbol: "FIT",
              address: "0x3c72fca8523686fd9e5740b0826fa4bb376e0241",
              price: 0.00049592,
            },
            {
              chainId: "1",
              name: "Trazable",
              symbol: "TRZ",
              address: "0x394a16744dcd805bb0ca7252e70691f0dcac56aa",
              price: 0.00048933,
            },
            {
              chainId: "1",
              name: "Casino Betting Coin",
              symbol: "CBC",
              address: "0x26DB5439F651CAF491A87d48799dA81F191bDB6b",
              price: 0.00047991,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Lympo",
              symbol: "LYM",
              address: "0x57ad67acf9bf015e4820fbd66ea1a21bed8852ec",
              price: 0.00041799,
            },
            {
              chainId: "1",
              name: "POPKON",
              symbol: "POPK",
              address: "0xaC12e8f6b0C17d7B736A800920b336d764b59973",
              price: 0.00040965,
            },
            {
              chainId: "1",
              name: "ONSTON",
              symbol: "ONSTON",
              address: "0x47b9f01b16e9c9cb99191dca68c9cc5bf6403957",
              price: 0.00038967,
            },
            {
              chainId: "1",
              name: "MARS4",
              symbol: "MARS4",
              address: "0x16cda4028e9e872a38acb903176719299beaed87",
              price: 0.00038566,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "Guppy",
              symbol: "GUP",
              address: "0xf7b098298f7c69fc14610bf71d5e02c60792894c",
              price: 0.00035556,
            },
            {
              chainId: "1",
              name: "Misbloc",
              symbol: "MSB",
              address: "0x84c722e6f1363e8d5c6db3ea600bef9a006da824",
              price: 0.00033227,
            },
            {
              chainId: "1",
              name: "AnteDAO",
              symbol: "ANTE",
              address: "0xbb70AdbE39408cB1E5258702ea8ADa7c81165b73",
              price: 0.00032988,
            },
            {
              chainId: "1",
              name: "eosDAC",
              symbol: "EOSDAC",
              address: "0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba",
              price: 0.00032044,
            },
            {
              chainId: "1",
              name: "Phoenix DAO",
              symbol: "PHNX",
              address: "0x38A2fDc11f526Ddd5a607C1F251C065f40fBF2f7",
              price: 0.00031199,
            },
            {
              chainId: "1",
              name: "Niftify",
              symbol: "NIFT",
              address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
              price: 0.00027324,
            },
            {
              chainId: "1",
              name: "Cratos",
              symbol: "CRTS",
              address: "0x678e840c640f619e17848045d23072844224dd37",
              price: 0.00025931,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "Atari Token",
              symbol: "ATRI",
              address: "0xdacd69347de42babfaecd09dc88958378780fb62",
              price: 0.00024522,
            },
            {
              chainId: "1",
              name: "Keystone of Opportunity & Knowledge",
              symbol: "KOK",
              address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
              price: 0.00022317,
            },
            {
              chainId: "1",
              name: "AidCoin",
              symbol: "AID",
              address: "0x37e8789bb9996cac9156cd5f5fd32599e6b91289",
              price: 0.0002168,
            },
            {
              chainId: "1",
              name: "Pando",
              symbol: "PANDO",
              address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
              price: 0.00021312,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "APIX",
              symbol: "APIX",
              address: "0xf51EBf9a26DbC02B13F8B3a9110dac47a4d62D78",
              price: 0.00014913,
            },
            {
              chainId: "1",
              name: "CyberVein",
              symbol: "CVT",
              address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
              price: 0.00013269,
            },
            {
              chainId: "1",
              name: "Cell Network",
              symbol: "ECELL",
              address: "0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f",
              price: 0.00011999,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Cindrum",
              symbol: "CIND",
              address: "0xac0968a3e2020ac8ca83e60ccf69081ebc6d3bc3",
              price: 0.00011276,
            },
            {
              chainId: "1",
              name: "BTRIPS",
              symbol: "BTR",
              address: "0x5ea82c27efc7634f1c5ad20a3561c453433a2f3a",
              price: 0.00011052,
            },
            {
              chainId: "1",
              name: "HyperDAO",
              symbol: "HDAO",
              address: "0x74faab6986560fd1140508e4266d8a7b87274ffd",
              price: 0.00010993,
            },
            {
              chainId: "1",
              name: "Plasma Finance",
              symbol: "PPAY",
              address: "0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2",
              price: 0.00010669,
            },
            {
              chainId: "1",
              name: "Digitex Token",
              symbol: "DGTX",
              address: "0xc666081073e8dff8d3d1c2292a29ae1a2153ec09",
              price: 0.00009659,
            },
            {
              chainId: "1",
              name: "BNS",
              symbol: "BNS",
              address: "0x19e2a43fbbc643c3b2d9667d858d49cad17bc2b5",
              price: 0.00008747,
            },
            {
              chainId: "1",
              name: "Loon Network",
              symbol: "LOON",
              address: "0x7C5d5100B339Fe7D995a893AF6CB496B9474373c",
              price: 0.00008231,
            },
            {
              chainId: "1",
              name: "Cyclub",
              symbol: "CYCLUB",
              address: "0x3b58c52c03ca5eb619eba171091c86c34d603e5f",
              price: 0.00008134,
            },
            {
              chainId: "1",
              name: "BABB",
              symbol: "BAX",
              address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
              price: 0.00007559,
            },
            {
              chainId: "1",
              name: "Golden Goose",
              symbol: "GOLD",
              address: "0x40d1f63b5d2048e67e9bedb1b4c2f1a9fb4b6817",
              price: 0.00007198,
            },
            {
              chainId: "1",
              name: "YellowHeart Protocol",
              symbol: "HRTS",
              address: "0xCeB53519a2B891d33b36E3826962D2a48f878e45",
              price: 0.00007,
            },
            {
              chainId: "1",
              name: "IHT Real Estate Protocol",
              symbol: "IHT",
              address: "0xEda8B016efA8b1161208Cf041cD86972eeE0F31E",
              price: 0.00006175,
            },
            {
              chainId: "1",
              name: "12Ships",
              symbol: "TSHP",
              address: "0x525794473f7ab5715c81d06d10f52d11cc052804",
              price: 0.0000536,
            },
            {
              chainId: "1",
              name: "Endor Protocol",
              symbol: "EDR",
              address: "0xc528c28fec0a90c083328bc45f587ee215760a0f",
              price: 0.00004926,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "CORE MultiChain",
              symbol: "CMCX",
              address: "0x5b685863494c33f344081f75e5430c260c224a32",
              price: 0.00004491,
            },
            {
              chainId: "1",
              name: "Astra Guild Ventures",
              symbol: "AGV",
              address: "0xf4f618eff5ef36cde2fca4fbd86554c62fb1382b",
              price: 0.00004036,
            },
            {
              chainId: "1",
              name: "Bitspawn",
              symbol: "SPWN",
              address: "0xe516d78d784c77d479977be58905b3f2b1111126",
              price: 0.0000353,
            },
            {
              chainId: "1",
              name: "Revain",
              symbol: "REV",
              address: "0x2ef52ed7de8c5ce03a4ef0efbe9b7450f2d7edc9",
              price: 0.00003314,
            },
            {
              chainId: "1",
              name: "Odyssey",
              symbol: "OCN",
              address: "0x4092678e4E78230F46A1534C0fbc8fA39780892B",
              price: 0.00003048,
            },
            {
              chainId: "1",
              name: "SaTT",
              symbol: "SATT",
              address: "0xdf49c9f599a0a9049d97cff34d0c30e468987389",
              price: 0.00002993,
            },
            {
              chainId: "1",
              name: "Refereum",
              symbol: "RFR",
              address: "0xd0929d411954c47438dc1d871dd6081f5c5e149c",
              price: 0.00002511,
            },
            {
              chainId: "1",
              name: "carVertical",
              symbol: "CV",
              address: "0x50bc2ecc0bfdf5666640048038c1aba7b7525683",
              price: 0.00002506,
            },
            {
              chainId: "1",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Krypton Galaxy Coin",
              symbol: "KGC",
              address: "0xa8262Eb913FccEa4C3f77fc95b8b4043B384cFbB",
              price: 0.00001418,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "PumaPay",
              symbol: "PMA",
              address: "0x846c66cf71c43f80403b51fe3906b3599d63336f",
              price: 0.0000123,
            },
            {
              chainId: "1",
              name: "Mongol NFT",
              symbol: "MNFT",
              address: "0x3235B13708F178Af6F110dE7177ED5De10c1093d",
              price: 0.00001181,
            },
            {
              chainId: "1",
              name: "TrueFeedBack",
              symbol: "TFBX",
              address: "0x4057db5bd9f67a566aa10e5587b1a964affc6a16",
              price: 0.00001061,
            },
            {
              chainId: "1",
              name: "MiraQle",
              symbol: "MQL",
              address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
              price: 0.0000093,
            },
            {
              chainId: "1",
              name: "PlayChip",
              symbol: "PLA",
              address: "0x0198f46f520f33cd4329bd4be380a25a90536cd5",
              price: 0.00000639,
            },
            {
              chainId: "1",
              name: "Dentacoin",
              symbol: "DCN",
              address: "0x08d32b0da63e2C3bcF8019c9c5d849d7a9d791e6",
              price: 0.00000199,
            },
            {
              chainId: "1",
              name: "Red Token",
              symbol: "RED",
              address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
              price: 0.00000179,
            },
            {
              chainId: "1",
              name: "Brother Music Platform",
              symbol: "BMP",
              address: "0x01b23286ff60a543ec29366ae8d6b6274ca20541",
              price: 0.00000143,
            },
            {
              chainId: "1",
              name: "LGCY Network",
              symbol: "LGCY",
              address: "0xae697f994fc5ebc000f8e22ebffee04612f98a0d",
              price: 0.00000107,
            },
            {
              chainId: "1",
              name: "Metis",
              symbol: "MTS",
              address: "0xA9598333B99d14D90Bc81CAd8Af82C4C70625e75",
              price: 8.09916e-7,
            },
            {
              chainId: "1",
              name: "PREMA",
              symbol: "PRMX",
              address: "0xe4dae00bc1c46ea2F44ae71B1BEb8b171C15d812",
              price: 6.08679e-7,
            },
            {
              chainId: "1",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "1",
              name: "8X8 PROTOCOL",
              symbol: "EXE",
              address: "0x412d397ddca07d753e3e0c61e367fb1b474b3e7d",
              price: 1.9993e-8,
            },
            {
              chainId: "1",
              name: "MYCE",
              symbol: "MYCE",
              address: "0xe9966c1184f8552fcb16f65addba9dd08fe8f4ea",
              price: 1.0002e-8,
            },
            {
              chainId: "1",
              name: "Auditchain",
              symbol: "AUDT",
              address: "0xb90cb79b72eb10c39cbdf86e50b1c89f6a235f2e",
              price: 0,
            },
          ],
        },
        chainIds: [1],
        cexLabels: [],
        tags: [
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-14T08:26:14.177Z",
          type: "contractImport",
        },
      },
      {
        _id: "66b2dfa0eb9d48f61f022700",
        uid: "66b2dfa0eb9d48f61f022700",
        userIds: ["66b2dfa0eb9d48f61f022700"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd940a",
            ecosystem: "evm",
            walletAddress: "0x18709E89BD403F470088aBDAcEbE86CC60dda12e",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 202,
        walletTotalValue: 2888527560.5397735,
        walletAge: "0y9m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Huobi BTC",
              symbol: "HBTC",
              address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
              price: 11110.54,
            },
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "42161",
              name: "Camelot Token",
              symbol: "GRAIL",
              address: "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8",
              price: 519.69,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "OKB",
              symbol: "OKB",
              address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
              price: 51.17,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Inverse Finance",
              symbol: "INV",
              address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
              price: 48.04,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "WhiteBIT Token",
              symbol: "WBT",
              address: "0x925206b8a707096Ed26ae47C84747fE0bb734F59",
              price: 30.26,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "STK",
              symbol: "STK",
              address: "0xaE73B38d1c9A8b274127ec30160a4927C4d71824",
              price: 15.35,
            },
            {
              chainId: "1",
              name: "Maple",
              symbol: "MPL",
              address: "0x33349b282065b0284d756f0577fb39c158f935e6",
              price: 12.05,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Binance Wrapped DOT",
              symbol: "BDOT",
              address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
              price: 4.29,
            },
            {
              chainId: "1",
              name: "Euler",
              symbol: "EUL",
              address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
              price: 4.17,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "MX Token",
              symbol: "MX",
              address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
              price: 3.66,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Fellaz",
              symbol: "FLZ",
              address: "0x8e964e35a76103af4c7d7318e1b1a82c682ae296",
              price: 2.02,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Elastos",
              symbol: "ELA",
              address: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
              price: 1.81,
            },
            {
              chainId: "42161",
              name: "Gains Network",
              symbol: "GNS",
              address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
              price: 1.51,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Unicly",
              symbol: "UNIC",
              address: "0x94e0bab2f6ab1f19f4750e42d7349f2740513ad5",
              price: 0.366642,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "MATH",
              symbol: "MATH",
              address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
              price: 0.200963,
            },
            {
              chainId: "1",
              name: "Realio Network",
              symbol: "RIO",
              address: "0xf21661d0d1d76d3ecb8e1b9f1c923dbfffae4097",
              price: 0.199678,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "1",
              name: "CNH Tether ",
              symbol: "CNHT",
              address: "0x6E109E9dD7Fa1a58BC3eff667e8e41fC3cc07AEF",
              price: 0.121353,
            },
            {
              chainId: "1",
              name: "sudoswap",
              symbol: "SUDO",
              address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
              price: 0.119429,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "dHEDGE",
              symbol: "DHT",
              address: "0xca1207647Ff814039530D7d35df0e1Dd2e91Fa84",
              price: 0.077542,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "PolySwarm",
              symbol: "NCT",
              address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
              price: 0.03448223,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Talken",
              symbol: "TALK",
              address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
              price: 0.02205094,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Poolz",
              symbol: "POOLZ",
              address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
              price: 0.01719548,
            },
            {
              chainId: "1",
              name: "Hillstone",
              symbol: "HSF",
              address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
              price: 0.01562664,
            },
            {
              chainId: "1",
              name: "1Sol",
              symbol: "1SOL",
              address: "0x009178997aff09a67d4caccfeb897fb79d036214",
              price: 0.01509453,
            },
            {
              chainId: "1",
              name: "EDEN",
              symbol: "EDEN",
              address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
              price: 0.01375941,
            },
            {
              chainId: "1",
              name: "Bubblefong",
              symbol: "BBF",
              address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
              price: 0.01299892,
            },
            {
              chainId: "1",
              name: "Ambire Wallet",
              symbol: "WALLET",
              address: "0x88800092ff476844f74dc2fc427974bbee2794ae",
              price: 0.01295567,
            },
            {
              chainId: "1",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
              price: 0.01210312,
            },
            {
              chainId: "1",
              name: "Lunyr",
              symbol: "LUN",
              address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
              price: 0.01190772,
            },
            {
              chainId: "1",
              name: "Torum",
              symbol: "XTM",
              address: "0xcd1faff6e578fa5cac469d2418c95671ba1a62fe",
              price: 0.01165386,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "1",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "SwftCoin",
              symbol: "SWFTC",
              address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
              price: 0.00906635,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "IOI Token",
              symbol: "IOI",
              address: "0x8b3870df408ff4d7c3a26df852d41034eda11d81",
              price: 0.00627625,
            },
            {
              chainId: "1",
              name: "Golff",
              symbol: "GOF",
              address: "0x488E0369f9BC5C40C002eA7c1fe4fd01A198801c",
              price: 0.00590861,
            },
            {
              chainId: "1",
              name: "TenX",
              symbol: "PAY",
              address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
              price: 0.00586091,
            },
            {
              chainId: "1",
              name: "EPIK Prime",
              symbol: "EPIK",
              address: "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
              price: 0.0056189,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "MVL",
              symbol: "MVL",
              address: "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
              price: 0.00443705,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "42161",
              name: "Rabbit Wallet",
              symbol: "RAB",
              address: "0x24ef78c7092d255ed14a0281ac1800c359af3afe",
              price: 0.00255511,
            },
            {
              chainId: "1",
              name: "Thrupenny",
              symbol: "TPY",
              address: "0x968Cbe62c830A0Ccf4381614662398505657A2A9",
              price: 0.00254616,
            },
            {
              chainId: "1",
              name: "Curate",
              symbol: "XCUR",
              address: "0xE1c7E30C42C24582888C758984f6e382096786bd",
              price: 0.00217892,
            },
            {
              chainId: "1",
              name: "Efforce",
              symbol: "WOZX",
              address: "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f",
              price: 0.00210115,
            },
            {
              chainId: "1",
              name: "Rikkei Finance",
              symbol: "RIFI",
              address: "0xc8ef1460277ea47d179dec66d1c5f8b7f7ae5a28",
              price: 0.00201816,
            },
            {
              chainId: "1",
              name: "BnkToTheFuture",
              symbol: "BFT",
              address: "0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f",
              price: 0.00172378,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "IndiGG",
              symbol: "INDI",
              address: "0x3392d8a60b77f8d3eaa4fb58f09d835bd31add29",
              price: 0.00169575,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "OrbCity",
              symbol: "ORB",
              address: "0x3c917054e03485808137eb306eafa8da0ab695cd",
              price: 0.00085895,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Airbloc",
              symbol: "ABL",
              address: "0xf8b358b3397a8ea5464f8cc753645d42e14b79ea",
              price: 0.00074102,
            },
            {
              chainId: "1",
              name: "SIRIN LABS Token",
              symbol: "SRN",
              address: "0x68d57c9a1c35f63e2c83ee8e49a64e9d70528d25",
              price: 0.00057791,
            },
            {
              chainId: "1",
              name: "Pibble",
              symbol: "PIB",
              address: "0x1864ce27e9f7517047933caae530674e8c70b8a7",
              price: 0.00056614,
            },
            {
              chainId: "1",
              name: "Waltonchain",
              symbol: "WTC",
              address: "0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74",
              price: 0.00049764,
            },
            {
              chainId: "1",
              name: "300FIT",
              symbol: "FIT",
              address: "0x3c72fca8523686fd9e5740b0826fa4bb376e0241",
              price: 0.00049592,
            },
            {
              chainId: "1",
              name: "EdgeSwap",
              symbol: "EGS",
              address: "0xB009BFaAF85e53F55d8657781Eb69feAaed83672",
              price: 0.00048175,
            },
            {
              chainId: "1",
              name: "hi Dollar",
              symbol: "HI",
              address: "0xc4f6e93aeddc11dc22268488465babcaf09399ac",
              price: 0.00048153,
            },
            {
              chainId: "1",
              name: "Define",
              symbol: "DFA",
              address: "0x62959c699a52ec647622c91e79ce73344e4099f5",
              price: 0.00043759,
            },
            {
              chainId: "1",
              name: "Game.com",
              symbol: "GTC",
              address: "0xB70835D7822eBB9426B56543E391846C107bd32C",
              price: 0.00038213,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Medicalchain",
              symbol: "MTN",
              address: "0x41dbecc1cdc5517c6f76f6a6e836adbee2754de3",
              price: 0.00031106,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "Beyond Protocol",
              symbol: "BP",
              address: "0xdF290B162a7D3E0A328cF198308D421954f08b94",
              price: 0.0002357,
            },
            {
              chainId: "1",
              name: "SIGNIN",
              symbol: "SIGN",
              address: "0xb06B8186cc008A79FD6722B1eefad07c14E97dA0",
              price: 0.00023275,
            },
            {
              chainId: "1",
              name: "Pando",
              symbol: "PANDO",
              address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
              price: 0.00021312,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "Ruff",
              symbol: "RUFF",
              address: "0xf278c1ca969095ffddded020290cf8b5c424ace2",
              price: 0.00017599,
            },
            {
              chainId: "1",
              name: "Koi Network",
              symbol: "KOI",
              address: "0xe84d9e32dC8cE819b8D6c83e50EDAfD46c6354dB",
              price: 0.00017229,
            },
            {
              chainId: "1",
              name: "Konnect",
              symbol: "KCT",
              address: "0x4c601dc69AfFb0D4Fc8dE1Ac303705e432A4A27E",
              price: 0.00017204,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "Pawtocol",
              symbol: "UPI",
              address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
              price: 0.00016276,
            },
            {
              chainId: "1",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "1",
              name: "StonkLeague",
              symbol: "AEGIS",
              address: "0x15Dd37a83564559927bBDcDbfcF85F60A2C6a419",
              price: 0.00008924,
            },
            {
              chainId: "1",
              name: "Huobi Pool Token",
              symbol: "HPT",
              address: "0xa66daa57432024023db65477ba87d4e7f5f95213",
              price: 0.00005947,
            },
            {
              chainId: "1",
              name: "CNNS",
              symbol: "CNNS",
              address: "0x6c3be406174349cfa4501654313d97e6a31072e1",
              price: 0.00005554,
            },
            {
              chainId: "1",
              name: "Endor Protocol",
              symbol: "EDR",
              address: "0xc528c28fec0a90c083328bc45f587ee215760a0f",
              price: 0.00004926,
            },
            {
              chainId: "1",
              name: "EchoLink",
              symbol: "EKO",
              address: "0xa6a840e50bcaa50da017b91a0d86b8b2d41156ee",
              price: 0.00004499,
            },
            {
              chainId: "1",
              name: "Launchblock",
              symbol: "LBP",
              address: "0xa23C1194d421F252b4e6D5edcc3205F7650a4eBE",
              price: 0.00003319,
            },
            {
              chainId: "1",
              name: "Vader Protocol",
              symbol: "VADER",
              address: "0x2602278ee1882889b946eb11dc0e810075650983",
              price: 0.00003072,
            },
            {
              chainId: "1",
              name: "Metababy",
              symbol: "BABY",
              address: "0x1cCF27211e8bf052f6255329ed641B4E94E80603",
              price: 0.00002874,
            },
            {
              chainId: "1",
              name: "Time New Bank",
              symbol: "TNB",
              address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
              price: 0.00002548,
            },
            {
              chainId: "1",
              name: "Seele",
              symbol: "SEELE",
              address: "0xb1e93236ab6073fdac58ada5564897177d4bcc43",
              price: 0.0000191,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "COVA",
              symbol: "COVA",
              address: "0xb37a769b37224449d92aac57de379e1267cd3b00",
              price: 0.00001469,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Musk Dao",
              symbol: "MUSK",
              address: "0x719e7f0daDFdeA25B78595da944F44d15d7E6795",
              price: 0.00001054,
            },
            {
              chainId: "1",
              name: "Vidy",
              symbol: "VIDY",
              address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
              price: 0.00000873,
            },
            {
              chainId: "1",
              name: "XMax",
              symbol: "XMX",
              address: "0x0f8c45b896784a1e408526b9300519ef8660209c",
              price: 0.00000823,
            },
            {
              chainId: "1",
              name: "SRT",
              symbol: "SRT",
              address: "0x22987407FD1fC5A971e3FDA3B3e74C88666cDa91",
              price: 0.00000766,
            },
            {
              chainId: "1",
              name: "FansTime",
              symbol: "FTI",
              address: "0x943ed852dadb5c3938ecdc6883718df8142de4c8",
              price: 0.0000075,
            },
            {
              chainId: "1",
              name: "Egretia",
              symbol: "EGT",
              address: "0x8e1b448ec7adfc7fa35fc2e885678bd323176e34",
              price: 0.00000708,
            },
            {
              chainId: "1",
              name: "U Network",
              symbol: "UUU",
              address: "0x3543638ed4a9006e4840b105944271bcea15605d",
              price: 0.0000054,
            },
            {
              chainId: "1",
              name: "DATA",
              symbol: "DTA",
              address: "0x69b148395ce0015c13e36bffbad63f49ef874e03",
              price: 0.00000371,
            },
            {
              chainId: "1",
              name: "Zipper",
              symbol: "ZIP",
              address: "0xa9d2927d3a04309e008b6af6e2e282ae2952e7fd",
              price: 0.0000037,
            },
            {
              chainId: "1",
              name: "Smartshare",
              symbol: "SSP",
              address: "0x624d520bab2e4ad83935fa503fb130614374e850",
              price: 0.000002,
            },
            {
              chainId: "1",
              name: "PhotoChromic",
              symbol: "PHCR",
              address: "0x37e83a94c6b1bdb816b59ac71dd02cf154d8111f",
              price: 0.00000117,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "A Hunters Dream",
              symbol: "CAW",
              address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
              price: 4.5523e-8,
            },
            {
              chainId: "1",
              name: "Die Protocol",
              symbol: "DIE",
              address: "0x6ef6610d24593805144d73b13d4405e00a4e4ac7",
              price: 1.6031e-8,
            },
            {
              chainId: "1",
              name: "Vita Inu",
              symbol: "VINU",
              address: "0xAFCdd4f666c84Fed1d8BD825aA762e3714F652c9",
              price: 1.2511e-8,
            },
            {
              chainId: "1",
              name: "POOH",
              symbol: "POOH",
              address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
              price: 1.0227e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "Shiba Predator",
              symbol: "QOM",
              address: "0xa71d0588eaf47f12b13cf8ec750430d21df04974",
              price: 3.923e-9,
            },
            {
              chainId: "1",
              name: "I will poop it NFT",
              symbol: "SHIT",
              address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
              price: 1.538e-9,
            },
            {
              chainId: "42161",
              name: "ArbDoge AI",
              symbol: "AIDOGE",
              address: "0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b",
              price: 2.6422e-10,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:48.591Z",
          type: "csvImport",
        },
      },
      {
        _id: "666bfc5285672a7368da1d02",
        uid: "666bfc5285672a7368da1d02",
        userIds: ["666bfc5285672a7368da1d02"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce88181",
            ecosystem: "evm",
            walletAddress: "0x6cC5F688a315f3dC28A7781717a9A798a59fDA7b",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 321,
        walletTotalValue: 1960333418.6527803,
        walletAge: "0y11m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Huobi BTC",
              symbol: "HBTC",
              address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
              price: 11110.54,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Doge Killer",
              symbol: "LEASH",
              address: "0x27c70cd1946795b66be9d954418546998b546634",
              price: 241.51,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "OKB",
              symbol: "OKB",
              address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
              price: 51.17,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "STK",
              symbol: "STK",
              address: "0xaE73B38d1c9A8b274127ec30160a4927C4d71824",
              price: 15.35,
            },
            {
              chainId: "1",
              name: "Strike",
              symbol: "STRK",
              address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
              price: 12.59,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "UNUS SED LEO",
              symbol: "LEO",
              address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
              price: 8.85,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "YF Link",
              symbol: "YFL",
              address: "0x28cb7e841ee97947a86b06fa4090c8451f64c0be",
              price: 7.34,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Aventus",
              symbol: "AVT",
              address: "0x0d88ed6e74bbfd96b831231638b66c05571e824f",
              price: 2.34,
            },
            {
              chainId: "1",
              name: "Robonomics Network",
              symbol: "XRT",
              address: "0x7de91b204c1c737bcee6f000aaa6569cf7061cb7",
              price: 2.09,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "Rarible",
              symbol: "RARI",
              address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
              price: 1.44,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Pluton",
              symbol: "PLU",
              address: "0xD8912C10681D8B21Fd3742244f44658dBA12264E",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "Euro Tether",
              symbol: "EURT",
              address: "0xc581b735a1688071a1746c968e0798d642ede491",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Edge",
              symbol: "DADI",
              address: "0xfb2f26f266fb2805a387230f2aa0a331b4d96fba",
              price: 1.019,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "Gemini Dollar",
              symbol: "GUSD",
              address: "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
              price: 0.999716,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Pickle Finance",
              symbol: "PICKLE",
              address: "0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
              price: 0.969209,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "BitDAO",
              symbol: "BIT",
              address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
              price: 0.805153,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "Tokenlon",
              symbol: "LON",
              address: "0x0000000000095413afc295d19edeb1ad7b71c952",
              price: 0.700937,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "WHALE",
              symbol: "WHALE",
              address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
              price: 0.620746,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "BZZ",
              address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
              price: 0.357921,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "SwissBorg",
              symbol: "CHSB",
              address: "0xba9d4199fab4f26efe3551d490e3821486f135ba",
              price: 0.323951,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "Wrapped Centrifuge",
              symbol: "WCFG",
              address: "0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
              price: 0.267137,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "MATH",
              symbol: "MATH",
              address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
              price: 0.200963,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "ERC20",
              symbol: "ERC20",
              address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
              price: 0.181667,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Crust",
              symbol: "CRU",
              address: "0x32a7c02e79c4ea1008dd6564b35f131428673c41",
              price: 0.151675,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Santiment Network Token",
              symbol: "SAN",
              address: "0x7c5a0ce9267ed19b22f8cae653f198e3e8daf098",
              price: 0.111756,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "NuCypher",
              symbol: "NU",
              address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
              price: 0.083335,
            },
            {
              chainId: "1",
              name: "dHEDGE",
              symbol: "DHT",
              address: "0xca1207647Ff814039530D7d35df0e1Dd2e91Fa84",
              price: 0.077542,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "Wrapped Paycoin",
              symbol: "WPCI",
              address: "0x3c2a309d9005433c1bc2c92ef1be06489e5bf258",
              price: 0.07108,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Symbiosis Finance",
              symbol: "SIS",
              address: "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
              price: 0.062595,
            },
            {
              chainId: "1",
              name: "Props",
              symbol: "PROPS",
              address: "0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41",
              price: 0.05987,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "DoraFactory",
              symbol: "DORA",
              address: "0xbc4171f45ef0ef66e76f979df021a34b46dcc81d",
              price: 0.05151,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "56",
              name: "Biswap",
              symbol: "BSW",
              address: "0x965f527d9159dce6288a2219db51fc6eef120dd1",
              price: 0.03340309,
            },
            {
              chainId: "1",
              name: "SunContract",
              symbol: "SNC",
              address: "0xF4134146AF2d511Dd5EA8cDB1C4AC88C57D60404",
              price: 0.03191363,
            },
            {
              chainId: "1",
              name: "mStable Governance Token",
              symbol: "MTA",
              address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
              price: 0.03171461,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "FirmaChain",
              symbol: "FCT",
              address: "0xE1bAD922F84b198A08292FB600319300ae32471b",
              price: 0.03107092,
            },
            {
              chainId: "1",
              name: "Town Star",
              symbol: "TOWN",
              address: "0x3dd98c8a089dbcff7e8fc8d4f532bd493501ab7f",
              price: 0.03080765,
            },
            {
              chainId: "1",
              name: "UniTrade",
              symbol: "TRADE",
              address: "0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
              price: 0.03005136,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "Orbs",
              symbol: "ORBS",
              address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
              price: 0.02748275,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Guild of Guardians",
              symbol: "GOG",
              address: "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62",
              price: 0.02583595,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "LATOKEN",
              symbol: "LA",
              address: "0xe50365f5d679cb98a1dd62d6f6e58e59321bcddf",
              price: 0.02511463,
            },
            {
              chainId: "1",
              name: "Wrapped Nine Chronicles",
              symbol: "WNCG",
              address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
              price: 0.0247011,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "Talken",
              symbol: "TALK",
              address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
              price: 0.02205094,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "Kleros",
              symbol: "PNK",
              address: "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
              price: 0.02138943,
            },
            {
              chainId: "1",
              name: "Tokenomy",
              symbol: "TEN",
              address: "0xdd16ec0f66e54d453e6756713e533355989040e4",
              price: 0.02127344,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Value Liquidity",
              symbol: "VALUE",
              address: "0x49e833337ece7afe375e44f4e3e8481029218e5c",
              price: 0.01919647,
            },
            {
              chainId: "1",
              name: "NAGA",
              symbol: "NGC",
              address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
              price: 0.0183165,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "EDEN",
              symbol: "EDEN",
              address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
              price: 0.01375941,
            },
            {
              chainId: "1",
              name: "Hxro",
              symbol: "HXRO",
              address: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
              price: 0.01106095,
            },
            {
              chainId: "1",
              name: "BLOCKv",
              symbol: "VEE",
              address: "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
              price: 0.0104663,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0xD04E772BC0d591fBD288f2E2a86aFA3D3CB647F8",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "doc.com",
              symbol: "MTC",
              address: "0x905E337c6c8645263D3521205Aa37bf4d034e745",
              price: 0.00908496,
            },
            {
              chainId: "1",
              name: "SwftCoin",
              symbol: "SWFTC",
              address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
              price: 0.00906635,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Gearbox Protocol",
              symbol: "GEAR",
              address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
              price: 0.00627808,
            },
            {
              chainId: "1",
              name: "TenX",
              symbol: "PAY",
              address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
              price: 0.00586091,
            },
            {
              chainId: "1",
              name: "Bread",
              symbol: "BRD",
              address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
              price: 0.00579243,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "StormX",
              symbol: "STMX",
              address: "0xbE9375C6a420D2eEB258962efB95551A5b722803",
              price: 0.00535924,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "ZKSpace",
              symbol: "ZKS",
              address: "0xe4815ae53b124e7263f08dcdbbb757d41ed658c6",
              price: 0.00518445,
            },
            {
              chainId: "1",
              name: "Konomi Network",
              symbol: "KONO",
              address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
              price: 0.00472211,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "apM Coin",
              symbol: "APM",
              address: "0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c",
              price: 0.00345688,
            },
            {
              chainId: "1",
              name: "Kine Protocol",
              symbol: "KINE",
              address: "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d",
              price: 0.00328062,
            },
            {
              chainId: "1",
              name: "Zap",
              symbol: "ZAP",
              address: "0x6781a0f84c7e9e846dcb84a9a5bd49333067b104",
              price: 0.00323945,
            },
            {
              chainId: "1",
              name: "GuildFi",
              symbol: "GF",
              address: "0xaaef88cea01475125522e117bfe45cf32044e238",
              price: 0.00314237,
            },
            {
              chainId: "1",
              name: "AICHAIN",
              symbol: "AIT",
              address: "0x79650799e7899a802cb96c0bc33a6a8d4ce4936c",
              price: 0.00309719,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "1",
              name: "MicroMoney",
              symbol: "AMM",
              address: "0x8b1f49491477e0fb46a29fef53f1ea320d13c349",
              price: 0.00288078,
            },
            {
              chainId: "1",
              name: "Wirex",
              symbol: "WXT",
              address: "0xa02120696c7b8fe16c09c749e4598819b2b0e915",
              price: 0.00287729,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "S.Finance",
              symbol: "SFG",
              address: "0x8a6aca71a218301c7081d4e96d64292d3b275ce0",
              price: 0.00232494,
            },
            {
              chainId: "1",
              name: "Carry Protocol",
              symbol: "CRE",
              address: "0x115eC79F1de567eC68B7AE7eDA501b406626478e",
              price: 0.00214345,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Statera",
              symbol: "STA",
              address: "0xa7DE087329BFcda5639247F96140f9DAbe3DeED1",
              price: 0.00188553,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "Change",
              symbol: "CAG",
              address: "0x7d4b8cce0591c9044a22ee543533b72e976e36c3",
              price: 0.00161374,
            },
            {
              chainId: "1",
              name: "Blockchain Brawlers",
              symbol: "BRWL",
              address: "0x4086e77c5e993fdb90a406285d00111a974f877a",
              price: 0.00154996,
            },
            {
              chainId: "1",
              name: "Delphy",
              symbol: "DPY",
              address: "0x6c2adc2073994fb2ccc5032cc2906fa221e9b391",
              price: 0.0014884,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "SmartMesh",
              symbol: "SMT",
              address: "0x55f93985431fc9304077687a35a1ba103dc1e081",
              price: 0.00135904,
            },
            {
              chainId: "1",
              name: "REVV",
              symbol: "REVV",
              address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
              price: 0.00135141,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
              price: 0.00119494,
            },
            {
              chainId: "1",
              name: "RioDeFi",
              symbol: "RFUEL",
              address: "0xaf9f549774ecedbd0966c52f250acc548d3f36e5",
              price: 0.00119316,
            },
            {
              chainId: "1",
              name: "DMM: Governance",
              symbol: "DMG",
              address: "0xEd91879919B71bB6905f23af0A68d231EcF87b14",
              price: 0.00113509,
            },
            {
              chainId: "1",
              name: "NEST Protocol",
              symbol: "NEST",
              address: "0x04abeda201850ac0124161f037efd70c74ddc74c",
              price: 0.00099809,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Primas",
              symbol: "PST",
              address: "0xe3fedaecd47aa8eab6b23227b0ee56f092c967a9",
              price: 0.00092638,
            },
            {
              chainId: "1",
              name: "Sentinel",
              symbol: "DVPN",
              address: "0xa44E5137293E855B1b7bC7E2C6f8cD796fFCB037",
              price: 0.00092027,
            },
            {
              chainId: "1",
              name: "The Doge NFT",
              symbol: "DOG",
              address: "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
              price: 0.00091842,
            },
            {
              chainId: "1",
              name: "OrbCity",
              symbol: "ORB",
              address: "0x3c917054e03485808137eb306eafa8da0ab695cd",
              price: 0.00085895,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "BitKan",
              symbol: "KAN",
              address: "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a",
              price: 0.00078224,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "Umee",
              symbol: "UMEE",
              address: "0xc0a4df35568f116c370e6a6a6022ceb908eeddac",
              price: 0.00062095,
            },
            {
              chainId: "1",
              name: "Fodl Finance",
              symbol: "FODL",
              address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
              price: 0.00056514,
            },
            {
              chainId: "1",
              name: "Tamadoge",
              symbol: "TAMA",
              address: "0x12b6893ce26ea6341919fe289212ef77e51688c8",
              price: 0.00052927,
            },
            {
              chainId: "1",
              name: "DOSE",
              symbol: "DOSE",
              address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "Skeb Coin",
              symbol: "SKEB",
              address: "0x6D614686550B9E1c1DF4b2cD8f91C9D4df66C810",
              price: 0.00050016,
            },
            {
              chainId: "1",
              name: "Waltonchain",
              symbol: "WTC",
              address: "0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74",
              price: 0.00049764,
            },
            {
              chainId: "1",
              name: "Trade Token",
              symbol: "TIO",
              address: "0x80bc5512561c7f85a3a9508c7df7901b370fa1df",
              price: 0.00045062,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "Kambria",
              symbol: "KAT",
              address: "0x14da230d6726c50f759bc1838717f8ce6373509c",
              price: 0.00042042,
            },
            {
              chainId: "1",
              name: "Game.com",
              symbol: "GTC",
              address: "0xB70835D7822eBB9426B56543E391846C107bd32C",
              price: 0.00038213,
            },
            {
              chainId: "1",
              name: "Saitama V2",
              symbol: "SAITAMA",
              address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
              price: 0.00035045,
            },
            {
              chainId: "1",
              name: "Substratum",
              symbol: "SUB",
              address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
              price: 0.00034775,
            },
            {
              chainId: "1",
              name: "eosDAC",
              symbol: "EOSDAC",
              address: "0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba",
              price: 0.00032044,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "1",
              name: "Ecomi",
              symbol: "OMI",
              address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
              price: 0.00027862,
            },
            {
              chainId: "1",
              name: "Dogechain",
              symbol: "DC",
              address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
              price: 0.00025429,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "Wojak",
              symbol: "WOJAK",
              address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
              price: 0.00024381,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "BoringDAO",
              symbol: "BORING",
              address: "0xbc19712feb3a26080ebf6f2f7849b417fdd792ca",
              price: 0.00018729,
            },
            {
              chainId: "1",
              name: "Mithril",
              symbol: "MITH",
              address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
              price: 0.00017659,
            },
            {
              chainId: "1",
              name: "Lithium Finance",
              symbol: "LITH",
              address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
              price: 0.0001711,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "WallStreetBets DApp",
              symbol: "WSB",
              address: "0xe1590a6fa0cff9c960181cb77d8a873601772f64",
              price: 0.00016178,
            },
            {
              chainId: "1",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "1",
              name: "APIX",
              symbol: "APIX",
              address: "0xf51EBf9a26DbC02B13F8B3a9110dac47a4d62D78",
              price: 0.00014913,
            },
            {
              chainId: "1",
              name: "CyberVein",
              symbol: "CVT",
              address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
              price: 0.00013269,
            },
            {
              chainId: "1",
              name: "Global Social Chain",
              symbol: "GSC",
              address: "0x228ba514309ffdf03a81a205a6d040e429d6e80c",
              price: 0.00012405,
            },
            {
              chainId: "1",
              name: "Cell Network",
              symbol: "ECELL",
              address: "0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f",
              price: 0.00011999,
            },
            {
              chainId: "1",
              name: "HyperDAO",
              symbol: "HDAO",
              address: "0x74faab6986560fd1140508e4266d8a7b87274ffd",
              price: 0.00010993,
            },
            {
              chainId: "1",
              name: "CyDotori",
              symbol: "DOTR",
              address: "0x26524e35e44e265eb181c7ba6ec084983181aae3",
              price: 0.00009013,
            },
            {
              chainId: "1",
              name: "Loon Network",
              symbol: "LOON",
              address: "0x7C5d5100B339Fe7D995a893AF6CB496B9474373c",
              price: 0.00008231,
            },
            {
              chainId: "1",
              name: "DeHorizon",
              symbol: "DEVT",
              address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
              price: 0.00007233,
            },
            {
              chainId: "1",
              name: "Convergence Finance",
              symbol: "CONV",
              address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
              price: 0.00006394,
            },
            {
              chainId: "1",
              name: "Endor Protocol",
              symbol: "EDR",
              address: "0xc528c28fec0a90c083328bc45f587ee215760a0f",
              price: 0.00004926,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "Kollect",
              symbol: "KOL",
              address: "0x1cc30e2eac975416060ec6fe682041408420d414",
              price: 0.00004726,
            },
            {
              chainId: "1",
              name: "Revain",
              symbol: "REV",
              address: "0x2ef52ed7de8c5ce03a4ef0efbe9b7450f2d7edc9",
              price: 0.00003314,
            },
            {
              chainId: "1",
              name: "Element Black",
              symbol: "ELT",
              address: "0xc0ae17eb994fa828540ffa53776b3830233a1b02",
              price: 0.00003206,
            },
            {
              chainId: "1",
              name: "Odyssey",
              symbol: "OCN",
              address: "0x4092678e4E78230F46A1534C0fbc8fA39780892B",
              price: 0.00003048,
            },
            {
              chainId: "1",
              name: "Celestial",
              symbol: "CELT",
              address: "0xf6e06B54855eFf198a2d9A8686113665499a6134",
              price: 0.0000285,
            },
            {
              chainId: "1",
              name: "Ludena Protocol",
              symbol: "LDN",
              address: "0xb29663aa4e2e81e425294193616c1b102b70a158",
              price: 0.00002574,
            },
            {
              chainId: "1",
              name: "Sponge",
              symbol: "$SPONGE",
              address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
              price: 0.00002552,
            },
            {
              chainId: "1",
              name: "Time New Bank",
              symbol: "TNB",
              address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
              price: 0.00002548,
            },
            {
              chainId: "1",
              name: "Refereum",
              symbol: "RFR",
              address: "0xd0929d411954c47438dc1d871dd6081f5c5e149c",
              price: 0.00002511,
            },
            {
              chainId: "1",
              name: "All Sports",
              symbol: "SOC",
              address: "0xeb6026d3beaa308d5822c44cdd2ca8c7714237ec",
              price: 0.000022,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "56",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
              price: 0.00001275,
            },
            {
              chainId: "1",
              name: "PumaPay",
              symbol: "PMA",
              address: "0x846c66cf71c43f80403b51fe3906b3599d63336f",
              price: 0.0000123,
            },
            {
              chainId: "1",
              name: "Echoin",
              symbol: "EC",
              address: "0x12fd19dac0fab61bed5e0f09091b470c452d4d61",
              price: 0.00001116,
            },
            {
              chainId: "1",
              name: "The Midas Touch Gold",
              symbol: "TMTG",
              address: "0x10086399DD8c1e3De736724AF52587a2044c9fA2",
              price: 0.00000999,
            },
            {
              chainId: "1",
              name: "Vidy",
              symbol: "VIDY",
              address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
              price: 0.00000873,
            },
            {
              chainId: "1",
              name: "Egretia",
              symbol: "EGT",
              address: "0x8e1b448ec7adfc7fa35fc2e885678bd323176e34",
              price: 0.00000708,
            },
            {
              chainId: "1",
              name: "Po.et",
              symbol: "POE",
              address: "0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195",
              price: 0.00000552,
            },
            {
              chainId: "1",
              name: "DATA",
              symbol: "DTA",
              address: "0x69b148395ce0015c13e36bffbad63f49ef874e03",
              price: 0.00000371,
            },
            {
              chainId: "1",
              name: "Zipper",
              symbol: "ZIP",
              address: "0xa9d2927d3a04309e008b6af6e2e282ae2952e7fd",
              price: 0.0000037,
            },
            {
              chainId: "1",
              name: "Facts",
              symbol: "BKC",
              address: "0x34bdf48A8F753de4822a6CFB1FEE275F9b4D662e",
              price: 0.00000339,
            },
            {
              chainId: "1",
              name: "Smartshare",
              symbol: "SSP",
              address: "0x624d520bab2e4ad83935fa503fb130614374e850",
              price: 0.000002,
            },
            {
              chainId: "1",
              name: "MixTrust",
              symbol: "MXT",
              address: "0x6251e725cd45fb1af99354035a414a2c0890b929",
              price: 0.00000107,
            },
            {
              chainId: "1",
              name: "StarLink",
              symbol: "STARL",
              address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
              price: 7.98843e-7,
            },
            {
              chainId: "1",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "Akita Inu",
              symbol: "AKITA",
              address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
              price: 8.8739e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "8X8 PROTOCOL",
              symbol: "EXE",
              address: "0x412d397ddca07d753e3e0c61e367fb1b474b3e7d",
              price: 1.9993e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "1",
              name: "Shiba Predator",
              symbol: "QOM",
              address: "0xa71d0588eaf47f12b13cf8ec750430d21df04974",
              price: 3.923e-9,
            },
            {
              chainId: "1",
              name: "Kuma Inu",
              symbol: "KUMA",
              address: "0x48c276e8d03813224bb1e55f953adb6d02fd3e02",
              price: 3.148e-9,
            },
            {
              chainId: "1",
              name: "I will poop it NFT",
              symbol: "SHIT",
              address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
              price: 1.538e-9,
            },
            {
              chainId: "1",
              name: "Kishu Inu",
              symbol: "KISHU",
              address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
              price: 3.12047e-10,
            },
            {
              chainId: "1",
              name: "FEG token",
              symbol: "FEG",
              address: "0x389999216860ab8e0175387a0c90e5c52522c945",
              price: 9.0222e-11,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 56],
        cexLabels: [],
        tags: [
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-17T11:28:54.078Z",
          type: "contractImport",
        },
      },
      {
        _id: "666bfc4d85672a7368da1916",
        uid: "666bfc4d85672a7368da1916",
        userIds: ["666bfc4d85672a7368da1916"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce87e27",
            ecosystem: "evm",
            walletAddress: "0x28C6c06298d514Db089934071355E5743bf21d60",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 332,
        walletTotalValue: 1893395398.4407022,
        walletAge: "0y11m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Huobi BTC",
              symbol: "HBTC",
              address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
              price: 11110.54,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "10",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "137",
              name: "WETH",
              symbol: "WETH",
              address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Wrapped Beacon ETH",
              symbol: "WBETH",
              address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
              price: 1918.25,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "56",
              name: "WETH",
              symbol: "WETH",
              address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
              price: 1795.73,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Quickswap (OLD)",
              symbol: "QUICK",
              address: "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
              price: 35.75,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "56",
              name: "ChainLink",
              symbol: "LINK",
              address: "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd",
              price: 13.2,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "56",
              name: "Uniswap",
              symbol: "UNI",
              address: "0xbf5140a22578168fd562dccf235e5d43a02ce9b1",
              price: 6.02,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Binance Wrapped DOT",
              symbol: "BDOT",
              address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
              price: 4.29,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Rai Reflex Index",
              symbol: "RAI",
              address: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
              price: 3,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Mettalex",
              symbol: "MTLX",
              address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
              price: 2.11,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Tokamak Network",
              symbol: "TON",
              address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
              price: 1.78,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "10",
              name: "USD Coin",
              symbol: "usdc",
              address: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
              price: 0.999963,
            },
            {
              chainId: "56",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
              price: 0.999963,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Travala",
              symbol: "AVA",
              address: "0x442b153f6f61c0c99a33aa4170dcb31e1abda1d0",
              price: 0.871989,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "56",
              name: "SafePal",
              symbol: "SFP",
              address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
              price: 0.64872,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Magic",
              symbol: "MAGIC",
              address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
              price: 0.361285,
            },
            {
              chainId: "1",
              name: "COMBO (Cocos-BCX)",
              symbol: "COMBO",
              address: "0xc4c7ea4fab34bd9fb9a5e1b1a98df76e26e6407c",
              price: 0.359251,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "BZZ",
              address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
              price: 0.357921,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "56",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Tokemak",
              symbol: "TOKE",
              address: "0x2e9d63788249371f1DFC918a52f8d799F4a38C94",
              price: 0.232818,
            },
            {
              chainId: "1",
              name: "Cortex",
              symbol: "CTXC",
              address: "0xea11755ae41d889ceec39a63e6ff75a02bc1c00d",
              price: 0.210565,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "Blox",
              symbol: "CDT",
              address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
              price: 0.205372,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "Rari Governance Token",
              symbol: "RGT",
              address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
              price: 0.180052,
            },
            {
              chainId: "56",
              name: "Ontology",
              symbol: "ONT",
              address: "0xfd7b3a77848f1c2d67e05e54d78d174a0c850335",
              price: 0.179923,
            },
            {
              chainId: "1",
              name: "Merit Circle",
              symbol: "MC",
              address: "0x949d48eca67b17269629c7194f4b727d4ef9e5d6",
              price: 0.17546,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "56",
              name: "Hooked Protocol",
              symbol: "HOOK",
              address: "0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0",
              price: 0.128704,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "Keep network",
              symbol: "KEEP",
              address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
              price: 0.126376,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "TrustSwap",
              symbol: "SWAP",
              address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
              price: 0.122692,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "YOUcash",
              symbol: "YOUC",
              address: "0x3d371413dd5489f3a04c07c0c2ce369c20986ceb",
              price: 0.088049,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "1",
              name: "NuCypher",
              symbol: "NU",
              address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
              price: 0.083335,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "Newscrypto Coin",
              symbol: "NWC",
              address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
              price: 0.080218,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "RAMP",
              symbol: "RAMP",
              address: "0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
              price: 0.069918,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "56",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0xe6ce27025f13f5213bbc560dc275e292965a392f",
              price: 0.056247,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "Neos Credits",
              symbol: "NCR",
              address: "0xdb5c3c46e28b53a39c255aa39a411dd64e5fed9c",
              price: 0.04979571,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "Merchant Token",
              symbol: "MTO",
              address: "0xe66b3aa360bb78468c00bebe163630269db3324f",
              price: 0.04814714,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "SpaceChain",
              symbol: "SPC",
              address: "0x86ed939b500e121c0c5f493f399084db596dad20",
              price: 0.04315581,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "Unification",
              symbol: "FUND",
              address: "0xbe6ac6b50f577205c9d107f37b6e205aa6acc5d4",
              price: 0.03419847,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "1",
              name: "UniLayer",
              symbol: "LAYER",
              address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
              price: 0.03082503,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "WadzPay",
              symbol: "WTK",
              address: "0x4cff49d0a19ed6ff845a9122fa912abcfb1f68a6",
              price: 0.02758275,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
              price: 0.0245393,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "Red Kite",
              symbol: "PKF",
              address: "0x8b39b70e39aa811b69365398e0aace9bee238aeb",
              price: 0.02199272,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "ONBUFF",
              symbol: "ONIT",
              address: "0x410e731c2970Dce3AdD351064AcF5cE9E33FDBf0",
              price: 0.01976704,
            },
            {
              chainId: "1",
              name: "KeyFi",
              symbol: "KEYFI",
              address: "0xb8647e90c0645152fccf4d9abb6b59eb4aa99052",
              price: 0.01908941,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Polkamarkets",
              symbol: "POLK",
              address: "0xD478161C952357F05f0292B56012Cd8457F1cfbF",
              price: 0.0124688,
            },
            {
              chainId: "1",
              name: "Voyager Token",
              symbol: "VGX",
              address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
              price: 0.01113651,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "OnX Finance",
              symbol: "ONX",
              address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
              price: 0.00951438,
            },
            {
              chainId: "1",
              name: "EasyFi ",
              symbol: "EZ",
              address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
              price: 0.00815894,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "GYEN",
              symbol: "GYEN",
              address: "0xc08512927d12348f6620a698105e1baac6ecd911",
              price: 0.00638966,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Bread",
              symbol: "BRD",
              address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
              price: 0.00579243,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "StormX",
              symbol: "STMX",
              address: "0xbE9375C6a420D2eEB258962efB95551A5b722803",
              price: 0.00535924,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "Hifi Finance (old)",
              symbol: "MFT",
              address: "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
              price: 0.00464541,
            },
            {
              chainId: "1",
              name: "Bridge Mutual",
              symbol: "BMI",
              address: "0x725c263e32c72ddc3a19bea12c5a0479a81ee688",
              price: 0.00403866,
            },
            {
              chainId: "1",
              name: "Solve",
              symbol: "SOLVE",
              address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
              price: 0.00402632,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Loom Network [OLD]",
              symbol: "LOOM",
              address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
              price: 0.00370114,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "DREP",
              symbol: "DREP",
              address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
              price: 0.00339307,
            },
            {
              chainId: "1",
              name: "pNetwork",
              symbol: "PNT",
              address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
              price: 0.0033276,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "CropBytes",
              symbol: "CBX",
              address: "0x37fc4b48ce93469dbea9918468993c735049642a",
              price: 0.00318043,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "1",
              name: "Label",
              symbol: "LBL",
              address: "0x2162f572b25f7358db9376ab58a947a4e45cede1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "Label Foundation",
              symbol: "LBL",
              address: "0x2162f572B25f7358db9376AB58a947a4e45CeDE1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "Carry Protocol",
              symbol: "CRE",
              address: "0x115eC79F1de567eC68B7AE7eDA501b406626478e",
              price: 0.00214345,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "137",
              name: "Gaia Everworld",
              symbol: "GAIA",
              address: "0x723b17718289a91af252d616de2c77944962d122",
              price: 0.00197659,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Wabi",
              symbol: "WABI",
              address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
              price: 0.00109904,
            },
            {
              chainId: "1",
              name: "Shyft Network",
              symbol: "SHFT",
              address: "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85",
              price: 0.00101292,
            },
            {
              chainId: "1",
              name: "Agrello",
              symbol: "DLT",
              address: "0x07e3c70653548B04f0A75970C1F81B4CBbFB606f",
              price: 0.00097389,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "Waltonchain",
              symbol: "WTC",
              address: "0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74",
              price: 0.00049764,
            },
            {
              chainId: "1",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0xeca82185adce47f39c684352b0439f030f860318",
              price: 0.00047299,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Substratum",
              symbol: "SUB",
              address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
              price: 0.00034775,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "1",
              name: "Dogechain",
              symbol: "DC",
              address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
              price: 0.00025429,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "Mithril",
              symbol: "MITH",
              address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
              price: 0.00017659,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "137",
              name: "Attack Wagon",
              symbol: "ATK",
              address: "0xF868939Ee81F04f463010BC52EAb91c0839eF08c",
              price: 0.00013393,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Etherparty",
              symbol: "FUEL",
              address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
              price: 0.0000579,
            },
            {
              chainId: "56",
              name: "WEYU",
              symbol: "WEYU",
              address: "0xfafd4cb703b25cb22f43d017e7e0d75febc26743",
              price: 0.00004982,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "Vabble",
              symbol: "VAB",
              address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
              price: 0.00003008,
            },
            {
              chainId: "1",
              name: "Time New Bank",
              symbol: "TNB",
              address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
              price: 0.00002548,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Vidy",
              symbol: "VIDY",
              address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
              price: 0.00000873,
            },
            {
              chainId: "1",
              name: "Po.et",
              symbol: "POE",
              address: "0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195",
              price: 0.00000552,
            },
            {
              chainId: "1",
              name: "PhotoChromic",
              symbol: "PHCR",
              address: "0x37e83a94c6b1bdb816b59ac71dd02cf154d8111f",
              price: 0.00000117,
            },
            {
              chainId: "1",
              name: "VIBE",
              symbol: "VIBE",
              address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
              price: 0.00000115,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
            {
              chainId: "1",
              name: "Ben",
              symbol: "BEN",
              address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
              price: 1.157e-9,
            },
            {
              chainId: "1",
              name: "Kishu Inu",
              symbol: "KISHU",
              address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
              price: 3.12047e-10,
            },
            {
              chainId: "1",
              name: "CanYaCoin",
              symbol: "CAN",
              address: "0x1d462414fe14cf489c7a21cac78509f4bf8cd7c0",
              price: 0,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 56],
        cexLabels: ["Unknown"],
        tags: [
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-07-03T08:47:08.869Z",
          type: "contractImport",
        },
      },
      {
        _id: "66b2df93eb9d48f61f022002",
        uid: "66b2df93eb9d48f61f022002",
        userIds: ["66b2df93eb9d48f61f022002"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd8bfe",
            ecosystem: "evm",
            walletAddress: "0xF3FC178157fb3c87548bAA86F9d24BA38E649B58",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 1,
        walletTotalValue: 1595022729.0575402,
        walletAge: "0y9m",
        tokens: {
          token: [
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
          ],
        },
        chainIds: [42161],
        cexLabels: [],
        tags: [
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:35.111Z",
          type: "csvImport",
        },
      },
      {
        _id: "666c002585672a7368dac237",
        uid: "666c002585672a7368dac237",
        userIds: ["666c002585672a7368dac237"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce88347",
            ecosystem: "evm",
            walletAddress: "0xf89d7b9c864f589bbF53a82105107622B35EaA40",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 293,
        walletTotalValue: 1486633630.9408584,
        walletAge: "0y11m",
        tokens: {
          token: [
            {
              chainId: "56",
              name: "Bitcoin BEP2",
              symbol: "BTCB",
              address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
              price: 81551,
            },
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "42161",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "10",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "81457",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "5000",
              name: "wETH",
              symbol: "wETH",
              address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111",
              price: 2575,
            },
            {
              chainId: "137",
              name: "WETH",
              symbol: "WETH",
              address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
              price: 2575,
            },
            {
              chainId: "1",
              name: "weETH",
              symbol: "weETH",
              address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
              price: 1915.54,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "56",
              name: "WETH",
              symbol: "WETH",
              address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
              price: 1795.73,
            },
            {
              chainId: "42161",
              name: "WETH",
              symbol: "WETH",
              address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
              price: 1795.73,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "56",
              name: "Wrapped BNB",
              symbol: "WBNB",
              address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
              price: 599.66,
            },
            {
              chainId: "56",
              name: "Wrapped Solana",
              symbol: "SOL",
              address: "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
              price: 167.37,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "56",
              name: "Litecoin",
              symbol: "LTC",
              address: "0x4338665cbb7b2485a8855a139b75d5e34ab0db94",
              price: 103.13,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "56",
              name: "chrono.tech",
              symbol: "TIME",
              address: "0x3b198e26e473b8fab2085b37978e36c9de5d7f68",
              price: 17.25,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "42161",
              name: "Dopex",
              symbol: "DPX",
              address: "0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55",
              price: 16.48,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "56",
              name: "Hector Network",
              symbol: "HEC",
              address: "0x638eebe886b0e9e7c6929e69490064a6c94d204d",
              price: 7.24,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Instadapp",
              symbol: "INST",
              address: "0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb",
              price: 5.45,
            },
            {
              chainId: "1",
              name: "MX Token",
              symbol: "MX",
              address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
              price: 3.66,
            },
            {
              chainId: "56",
              name: "Wrapped Near",
              symbol: "WNEAR",
              address: "0x1fa4a73a3f0133f0025378af00236f3abdee5d63",
              price: 3.4,
            },
            {
              chainId: "1",
              name: "Echelon Prime",
              symbol: "PRIME",
              address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
              price: 3.34,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "56",
              name: "PancakeSwap",
              symbol: "CAKE",
              address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
              price: 2.32,
            },
            {
              chainId: "56",
              name: "XRPL",
              symbol: "XRP",
              address: "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe",
              price: 2.06,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "ApeX Protocol",
              symbol: "APEX",
              address: "0x52a8845df664d76c69d2eea607cd793565af42b8",
              price: 1.51,
            },
            {
              chainId: "42161",
              name: "ApeX Protocol",
              symbol: "APEX",
              address: "0x61a1ff55c5216b636a294a07d77c6f4df10d3b56",
              price: 1.51,
            },
            {
              chainId: "42161",
              name: "Gains Network",
              symbol: "GNS",
              address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
              price: 1.51,
            },
            {
              chainId: "137",
              name: "Gains Network",
              symbol: "GNS",
              address: "0xe5417af564e4bfda1c483642db72007871397896",
              price: 1.41,
            },
            {
              chainId: "56",
              name: "Anyswap",
              symbol: "ANY",
              address: "0xf68c9df95a18b2a5a5fa1124d79eeeffbad0b6fa",
              price: 1.4,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Router Protocol",
              symbol: "ROUTE",
              address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
              price: 1.093,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "Euro Coin",
              symbol: "EUROC",
              address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
              price: 1.038,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "10",
              name: "Tether",
              symbol: "usdt",
              address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
              price: 0.999984,
            },
            {
              chainId: "5000",
              name: "USDT",
              symbol: "USDT",
              address: "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae",
              price: 0.999984,
            },
            {
              chainId: "137",
              name: "Tether",
              symbol: "USDT",
              address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
              price: 0.999982,
            },
            {
              chainId: "10",
              name: "USD Coin",
              symbol: "usdc",
              address: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
              price: 0.999963,
            },
            {
              chainId: "56",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
              price: 0.999963,
            },
            {
              chainId: "42161",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
              price: 0.999889,
            },
            {
              chainId: "137",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "56",
              name: "Dai",
              symbol: "DAI",
              address: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
              price: 0.999783,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "56",
              name: "USDD",
              symbol: "USDD",
              address: "0xd17479997f34dd9156deef8f95a52d81d265be9c",
              price: 0.996134,
            },
            {
              chainId: "56",
              name: "Travala",
              symbol: "AVA",
              address: "0x13616f44ba82d63c8c0dc3ff843d36a8ec1c05a9",
              price: 0.871989,
            },
            {
              chainId: "56",
              name: "Seedify.fund",
              symbol: "SFUND",
              address: "0x477bc8d23c634c154061869478bce96be6045d12",
              price: 0.868498,
            },
            {
              chainId: "1",
              name: "BitDAO",
              symbol: "BIT",
              address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
              price: 0.805153,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "10",
              name: "Optimism",
              symbol: "op",
              address: "0x4200000000000000000000000000000000000042",
              price: 0.764988,
            },
            {
              chainId: "5000",
              name: "MNT",
              symbol: "MNT",
              address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
              price: 0.72034,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "56",
              name: "SafePal",
              symbol: "SFP",
              address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
              price: 0.64872,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "137",
              name: "Nakamoto Games",
              symbol: "NAKA",
              address: "0x311434160d7537be358930def317afb606c0d737",
              price: 0.456567,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "56",
              name: "Polygon",
              symbol: "MATIC",
              address: "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
              price: 0.436806,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "Fenerbahçe Token",
              symbol: "FB",
              address: "0xfb19075d77a0f111796fb259819830f4780f1429",
              price: 0.426695,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Kryll",
              symbol: "KRL",
              address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
              price: 0.35556,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "Clearpool",
              symbol: "CPOOL",
              address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
              price: 0.304535,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "AIOZ Network",
              symbol: "AIOZ",
              address: "0x626e8036deb333b408be468f951bdb42433cbf18",
              price: 0.242007,
            },
            {
              chainId: "56",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "56",
              name: "Dogecoin",
              symbol: "DOGE",
              address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
              price: 0.227176,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "56",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "56",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xb0d502e938ed5f4df2e681fe6e419ff29631d62b",
              price: 0.205851,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "ERC20",
              symbol: "ERC20",
              address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
              price: 0.181667,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "137",
              name: "Wrapped Matic",
              symbol: "WMATIC",
              address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
              price: 0.178256,
            },
            {
              chainId: "56",
              name: "Diamond Launch",
              symbol: "DLC",
              address: "0xdE83180dD1166D4f8E5c2b7De14A2163b1Bb4a87",
              price: 0.17469,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Pintu Token",
              symbol: "PTU",
              address: "0xC229c69eB3BB51828D0cAA3509A05a51083898dd",
              price: 0.168104,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "56",
              name: "Shattered Legion",
              symbol: "SLG",
              address: "0x2348b010fa9c0ce30bb042d54c298a3411361a01",
              price: 0.153734,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "56",
              name: "RecoveryDAO",
              symbol: "REC",
              address: "0xb922AA024e71A25077D78B593Bd6f11f2F412e72",
              price: 0.138984,
            },
            {
              chainId: "56",
              name: "ChainGPT",
              symbol: "CGPT",
              address: "0x9840652DC04fb9db2C43853633f0F62BE6f00f98",
              price: 0.137011,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "56",
              name: "Hooked Protocol",
              symbol: "HOOK",
              address: "0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0",
              price: 0.128704,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "56",
              name: "MOBOX",
              symbol: "MBOX",
              address: "0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377",
              price: 0.115132,
            },
            {
              chainId: "1",
              name: "Zignaly",
              symbol: "ZIG",
              address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
              price: 0.109712,
            },
            {
              chainId: "1",
              name: "Forta",
              symbol: "FORT",
              address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
              price: 0.098713,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "VLaunch",
              symbol: "VPAD",
              address: "0x51FE2E572e97BFEB1D719809d743Ec2675924EDc",
              price: 0.08336,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "56",
              name: "Coin98",
              symbol: "C98",
              address: "0xaec945e04baf28b135fa7c640f624f8d90f1c3a6",
              price: 0.064487,
            },
            {
              chainId: "1",
              name: "Symbiosis Finance",
              symbol: "SIS",
              address: "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
              price: 0.062595,
            },
            {
              chainId: "1",
              name: "ECOx",
              symbol: "ECOx",
              address: "0xcccD1Ba9f7acD6117834E0D28F25645dECb1736a",
              price: 0.05339,
            },
            {
              chainId: "56",
              name: "STEPN",
              symbol: "GMT",
              address: "0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1",
              price: 0.04773271,
            },
            {
              chainId: "1",
              name: "HarryPotterObamaSonic10Inu",
              symbol: "BITCOIN",
              address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
              price: 0.04305609,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "56",
              name: "MarsDAO",
              symbol: "MDAO",
              address: "0x60322971a672b81bcce5947706d22c19daecf6fb",
              price: 0.03026802,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Palette",
              symbol: "PLT",
              address: "0x0944d5848bd9f60a34ba92aea300d4286696eb76",
              price: 0.02846661,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "TRVL",
              symbol: "TRVL",
              address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "137",
              name: "Kasta",
              symbol: "KASTA",
              address: "0x235737dbb56e8517391473f7c964db31fa6ef280",
              price: 0.02210131,
            },
            {
              chainId: "1",
              name: "ParaSwap",
              symbol: "PSP",
              address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
              price: 0.02181516,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Altava",
              symbol: "TAVA",
              address: "0xdebe620609674F21B1089042527F420372eA98A5",
              price: 0.01951552,
            },
            {
              chainId: "56",
              name: "Gala",
              symbol: "GALA",
              address: "0x7ddee176f665cd201f93eede625770e2fd911990",
              price: 0.01720889,
            },
            {
              chainId: "42161",
              name: "Vela Token",
              symbol: "VELA",
              address: "0x088cd8f5ef3652623c22d48b1605dcfe860cd704",
              price: 0.0159526,
            },
            {
              chainId: "56",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0x23396cf899ca06c4472205fc903bdb4de249d6fc",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "42161",
              name: "OpenbetAI",
              symbol: "OPENBET",
              address: "0x2c7513F299778A84797F293503DB1A73A15FD48D",
              price: 0.01406102,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "56",
              name: "Creo Engine",
              symbol: "CREO",
              address: "0x9521728bF66a867BC65A93Ece4a543D817871Eb7",
              price: 0.01393549,
            },
            {
              chainId: "56",
              name: "Monopoly Millionaire Control",
              symbol: "MMC",
              address: "0xbe3fd4d1e0d244ddd98686a28f67355efe223346",
              price: 0.0125539,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "56",
              name: "Qmall",
              symbol: "QMALL",
              address: "0x07e551e31a793e20dc18494ff6b03095a8f8ee36",
              price: 0.01069137,
            },
            {
              chainId: "137",
              name: "GensoKishi",
              symbol: "MV",
              address: "0xA3c322Ad15218fBFAEd26bA7f616249f7705D945",
              price: 0.01039675,
            },
            {
              chainId: "1",
              name: "Lumerin",
              symbol: "LMR",
              address: "0x4b1d0b9f081468d780ca1d5d79132b64301085d1",
              price: 0.0101826,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "56",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0x153C0c947177e631e3DFc594ba28750d3a921FB5",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0xD04E772BC0d591fBD288f2E2a86aFA3D3CB647F8",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "izumi Finance",
              symbol: "IZI",
              address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
              price: 0.00756683,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "Cosplay Token",
              symbol: "COT",
              address: "0x5cac718a3ae330d361e39244bf9e67ab17514ce8",
              price: 0.00670004,
            },
            {
              chainId: "137",
              name: "Cosplay Token",
              symbol: "COT",
              address: "0x8d520c8e66091cfd6743fe37fbe3a09505616c4b",
              price: 0.00670004,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "56",
              name: "Okratech",
              symbol: "ORT",
              address: "0x9e711221b34a2d4b8f552bd5f4a6c4e7934920f7",
              price: 0.00632469,
            },
            {
              chainId: "137",
              name: "Medieval Empires",
              symbol: "MEE",
              address: "0xEB7eaB87837f4Dad1bb80856db9E4506Fc441f3D",
              price: 0.00612625,
            },
            {
              chainId: "1",
              name: "VEGA Protocol",
              symbol: "VEGA",
              address: "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e",
              price: 0.00611416,
            },
            {
              chainId: "56",
              name: "Position",
              symbol: "POSI",
              address: "0x5CA42204cDaa70d5c773946e69dE942b85CA6706",
              price: 0.00604107,
            },
            {
              chainId: "56",
              name: "Chirpley",
              symbol: "CHRP",
              address: "0xed00fc7d48b57b81fe65d1ce71c0985e4cf442cb",
              price: 0.00538804,
            },
            {
              chainId: "1",
              name: "Ternoa",
              symbol: "CAPS",
              address: "0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2",
              price: 0.00514558,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "1",
              name: "MVL",
              symbol: "MVL",
              address: "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
              price: 0.00443705,
            },
            {
              chainId: "1",
              name: "XI Protocol",
              symbol: "XI",
              address: "0x295B42684F90c77DA7ea46336001010F2791Ec8c",
              price: 0.0037862,
            },
            {
              chainId: "1",
              name: "ChainGuardians",
              symbol: "CGG",
              address: "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
              price: 0.00335146,
            },
            {
              chainId: "1",
              name: "CropBytes",
              symbol: "CBX",
              address: "0x37fc4b48ce93469dbea9918468993c735049642a",
              price: 0.00318043,
            },
            {
              chainId: "1",
              name: "HAVAH",
              symbol: "HVH",
              address: "0xd076c4ba62c57b3fa10800bcfd8da66742110e0e",
              price: 0.0030758,
            },
            {
              chainId: "56",
              name: "OKSE",
              symbol: "OKSE",
              address: "0x606FB7969fC1b5CAd58e64b12Cf827FB65eE4875",
              price: 0.00303607,
            },
            {
              chainId: "1",
              name: "Sidus Heroes",
              symbol: "SIDUS",
              address: "0x549020a9Cb845220D66d3E9c6D9F9eF61C981102",
              price: 0.00293755,
            },
            {
              chainId: "56",
              name: "BabySwap",
              symbol: "BABY",
              address: "0x53e562b9b7e5e94b81f10e96ee70ad06df3d2657",
              price: 0.00233659,
            },
            {
              chainId: "56",
              name: "GunStar Metaverse",
              symbol: "GSTS",
              address: "0x7eDC0eC89F987ECd85617b891c44fE462a325869",
              price: 0.00229594,
            },
            {
              chainId: "56",
              name: "Degen Zoo",
              symbol: "DZOO",
              address: "0x56d06a78Ef8E95D6043341f24759e2834BE6f97B",
              price: 0.00222518,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "56",
              name: "Legend of Fantasy War",
              symbol: "LFW",
              address: "0xD71239a33C8542Bd42130c1B4ACA0673B4e4f48B",
              price: 0.00199829,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "56",
              name: "AI Trader",
              symbol: "AIT",
              address: "0x4238E5Ccc619dCC8c00ADE4cfc5d3D9020b24898",
              price: 0.00166909,
            },
            {
              chainId: "137",
              name: "MetaBeat",
              symbol: "BEAT",
              address: "0xb78cf9ac0f47f1d69cba861deda29814d285c834",
              price: 0.00154437,
            },
            {
              chainId: "137",
              name: "ROND",
              symbol: "ROND",
              address: "0x204820B6e6FEae805e376D2C6837446186e57981",
              price: 0.00149816,
            },
            {
              chainId: "1",
              name: "MixMarvel",
              symbol: "MIX",
              address: "0x5d285f735998f36631f678ff41fb56a10a4d0429",
              price: 0.00117,
            },
            {
              chainId: "1",
              name: "Throne",
              symbol: "THN",
              address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
              price: 0.00113916,
            },
            {
              chainId: "1",
              name: "Melos Studio",
              symbol: "MELOS",
              address: "0x1afb69dbc9f54d08dab1bd3436f8da1af819e647",
              price: 0.00113651,
            },
            {
              chainId: "56",
              name: "Metahero",
              symbol: "HERO",
              address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
              price: 0.00103651,
            },
            {
              chainId: "1",
              name: "Degen Zoo",
              symbol: "DZOO",
              address: "0xc97d6C52F3ADD91Fa1c5287a453d7444aECBca83",
              price: 0.00099931,
            },
            {
              chainId: "56",
              name: "MagicCraft",
              symbol: "MCRT",
              address: "0x4b8285ab433d8f69cb48d5ad62b415ed1a221e4f",
              price: 0.00077029,
            },
            {
              chainId: "56",
              name: "Legion Network",
              symbol: "LGX",
              address: "0x9096b4309224d751fcb43d7eb178dcffc122ad15",
              price: 0.00071825,
            },
            {
              chainId: "1",
              name: "Rainmaker Games",
              symbol: "RAIN",
              address: "0x71Fc1F555a39E0B698653AB0b475488EC3c34D57",
              price: 0.00071487,
            },
            {
              chainId: "56",
              name: "SEOR",
              symbol: "SEOR",
              address: "0x800a25741a414ea6e6e2b382435081a479a8cc3c",
              price: 0.00067282,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "56",
              name: "StreamCoin",
              symbol: "STRM",
              address: "0xc598275452fa319d75ee5f176fd3b8384925b425",
              price: 0.00061318,
            },
            {
              chainId: "56",
              name: "WeWay",
              symbol: "WWY",
              address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
              price: 0.00060192,
            },
            {
              chainId: "56",
              name: "Ertha",
              symbol: "ERTHA",
              address: "0x62823659d09f9f9d2222058878f89437425eb261",
              price: 0.00058349,
            },
            {
              chainId: "56",
              name: "Tap Fantasy",
              symbol: "TAP",
              address: "0x35bEdBF9291b22218a0dA863170dcC9329Ef2563",
              price: 0.00057469,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "56",
              name: "Kunci Coin",
              symbol: "KUNCI",
              address: "0x6cf271270662be1c4fc1b7bb7d7d7fc60cc19125",
              price: 0.0005046,
            },
            {
              chainId: "56",
              name: "Monster Galaxy",
              symbol: "GGM",
              address: "0x4301a638fcb45c4bb65230b87f3797c213f832b8",
              price: 0.00044662,
            },
            {
              chainId: "1",
              name: "Saitama V2",
              symbol: "SAITAMA",
              address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
              price: 0.00035045,
            },
            {
              chainId: "56",
              name: "AMAZY",
              symbol: "AZY",
              address: "0x7b665b2f633d9363b89a98b094b1f9e732bd8f86",
              price: 0.00031764,
            },
            {
              chainId: "56",
              name: "Souni",
              symbol: "SON",
              address: "0x3b0e967ce7712ec68131a809db4f78ce9490e779",
              price: 0.00024593,
            },
            {
              chainId: "1",
              name: "Wojak",
              symbol: "WOJAK",
              address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
              price: 0.00024381,
            },
            {
              chainId: "56",
              name: "XCAD Network",
              symbol: "PLAY",
              address: "0xD069599E718f963bD84502b49ba8F8657fAF5B3a",
              price: 0.00022962,
            },
            {
              chainId: "1",
              name: "Keystone of Opportunity & Knowledge",
              symbol: "KOK",
              address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
              price: 0.00022317,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "56",
              name: "X World Games",
              symbol: "XWG",
              address: "0x6b23c89196deb721e6fd9726e6c76e4810a464bc",
              price: 0.0001516,
            },
            {
              chainId: "1",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "56",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "56",
              name: "Everdome",
              symbol: "DOME",
              address: "0x475bfaa1848591ae0e6ab69600f48d828f61a80e",
              price: 0.000143,
            },
            {
              chainId: "56",
              name: "Fame MMA",
              symbol: "FAME",
              address: "0x28ce223853d123b52c74439b10b43366d73fd3b5",
              price: 0.00014272,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "56",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xbbcf57177d8752b21d080bf30a06ce20ad6333f8",
              price: 0.00013236,
            },
            {
              chainId: "1",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xd373576a9e738F37Dc6882328358Ff69c4cAf4c6",
              price: 0.00013236,
            },
            {
              chainId: "56",
              name: "IL CAPO OF CRYPTO",
              symbol: "CAPO",
              address: "0x922722e9ef614ec9a3e94b78496e92abfbb5a624",
              price: 0.0001025,
            },
            {
              chainId: "56",
              name: "Ookeenga",
              symbol: "OKG",
              address: "0x7758a52c1Bb823d02878B67aD87B6bA37a0CDbF5",
              price: 0.00007905,
            },
            {
              chainId: "56",
              name: "Chitaverse",
              symbol: "BCT",
              address: "0xf6d2657EBb5602bF823901412c5e41e030f3ece2",
              price: 0.0000724,
            },
            {
              chainId: "1",
              name: "DeHorizon",
              symbol: "DEVT",
              address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
              price: 0.00007233,
            },
            {
              chainId: "56",
              name: "Antex",
              symbol: "ANTEX",
              address: "0xCA1aCAB14e85F30996aC83c64fF93Ded7586977C",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "DRIVEZ",
              symbol: "DRIV",
              address: "0x461dab902f38210b42b7d8b4bfc71296e0629006",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "KENKA METAVERSE",
              symbol: "KENKA",
              address: "0x578300CC8db63F871643307D553E485982E4f2C1",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Trust Wallet Token",
              symbol: "TWT",
              address: "0x4b0f1812e5df2a09796481ff14017e6005508003",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "BIDR",
              symbol: "BIDR",
              address: "0x9a2f5556e9a637e8fbce886d8e3cf8b316a1d8a2",
              price: 0.00006365,
            },
            {
              chainId: "56",
              name: "Menzy",
              symbol: "MNZ",
              address: "0x861f1E1397daD68289e8f6a09a2ebb567f1B895C",
              price: 0.00005955,
            },
            {
              chainId: "1",
              name: "Aurigami",
              symbol: "PLY",
              address: "0x1ab43204a195a0fd37edec621482afd3792ef90b",
              price: 0.00005744,
            },
            {
              chainId: "56",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xfb5B838b6cfEEdC2873aB27866079AC55363D37E",
              price: 0.00005734,
            },
            {
              chainId: "56",
              name: "MOVEZ",
              symbol: "MOVEZ",
              address: "0x039cd22cb49084142d55fcd4b6096a4f51ffb3b4",
              price: 0.00004472,
            },
            {
              chainId: "1",
              name: "DEFY",
              symbol: "DEFY",
              address: "0x205eD31C867bF715E4182137Af95AFE9177Cd8E7",
              price: 0.00004439,
            },
            {
              chainId: "1",
              name: "Element Black",
              symbol: "ELT",
              address: "0xc0ae17eb994fa828540ffa53776b3830233a1b02",
              price: 0.00003206,
            },
            {
              chainId: "137",
              name: "Nexus Dubai",
              symbol: "NXD",
              address: "0x228b5c21ac00155cf62c57bcc704c0da8187950b",
              price: 0.00003027,
            },
            {
              chainId: "1",
              name: "Sponge",
              symbol: "$SPONGE",
              address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
              price: 0.00002552,
            },
            {
              chainId: "56",
              name: "LUSD",
              symbol: "LUSD",
              address: "0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e",
              price: 0.00001967,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "56",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
              price: 0.00001275,
            },
            {
              chainId: "1",
              name: "MOBLAND",
              symbol: "SYNR",
              address: "0xbc6e06778708177a18210181b073da747c88490a",
              price: 0.00001147,
            },
            {
              chainId: "1",
              name: "TomTomCoin",
              symbol: "TOMS",
              address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
              price: 0.00001099,
            },
            {
              chainId: "137",
              name: "iNFTspace",
              symbol: "INS",
              address: "0xb988bd378a0754957d5d9471c96e0f8051645a26",
              price: 0.00000377,
            },
            {
              chainId: "1",
              name: "Cult DAO",
              symbol: "CULT",
              address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
              price: 0.00000126,
            },
            {
              chainId: "56",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "56",
              name: "Bitgert",
              symbol: "BRISE",
              address: "0x8fff93e810a2edaafc326edee51071da9d398e83",
              price: 1.00301e-7,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "Pancake Games",
              symbol: "GCAKE",
              address: "0x5f944b0c4315cb7c3a846b025ab4045da44abf6c",
              price: 4.9573e-8,
            },
            {
              chainId: "56",
              name: "Pancake Games",
              symbol: "GCAKE",
              address: "0x61d5822dd7b3ed495108733e6550d4529480c8f6",
              price: 4.9573e-8,
            },
            {
              chainId: "56",
              name: "Vita Inu",
              symbol: "VINU",
              address: "0xfEbe8C1eD424DbF688551D4E2267e7A53698F0aa",
              price: 2.3883e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "56",
              name: "Web3Camp",
              symbol: "3P",
              address: "0xB806FA32eBDC04E5Dbdd2ad83E75C8F7D8E8ef8b",
              price: 4.543e-9,
            },
            {
              chainId: "56",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xc748673057861a797275cd8a068abb95a902e8de",
              price: 1.196e-9,
            },
            {
              chainId: "1",
              name: "Ben",
              symbol: "BEN",
              address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
              price: 1.157e-9,
            },
            {
              chainId: "56",
              name: "SpacePi",
              symbol: "SPACEPI",
              address: "0x69b14e8D3CEBfDD8196Bfe530954A0C226E5008E",
              price: 9.35511e-10,
            },
            {
              chainId: "1",
              name: "Kishu Inu",
              symbol: "KISHU",
              address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
              price: 3.12047e-10,
            },
            {
              chainId: "42161",
              name: "ArbDoge AI",
              symbol: "AIDOGE",
              address: "0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b",
              price: 2.6422e-10,
            },
            {
              chainId: "42161",
              name: "BullBear AI",
              symbol: "AIBB",
              address: "0xB9AF4762c039D63e30039F1712dfaB77026408c7",
              price: 1.15256e-10,
            },
            {
              chainId: "56",
              name: "Oggy Inu",
              symbol: "OGGY",
              address: "0x92ed61fb8955cc4e392781cb8b7cd04aadc43d0c",
              price: 3.128e-12,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 5000, 56, 81457],
        cexLabels: ["Unknown"],
        tags: [
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:35.478Z",
          type: "csvImport",
        },
      },
      {
        _id: "666c002685672a7368dac257",
        uid: "666c002685672a7368dac257",
        userIds: ["666c002685672a7368dac257"],
        wallets: [
          {
            status: "verified",
            walletId: "683749437a939d1fbcfd4abb",
            ecosystem: "evm",
            walletAddress: "0xD6216fC19DB775Df9774a6E33526131dA7D19a2c",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 347,
        walletTotalValue: 1138641271.490839,
        walletAge: "4y7m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "42161",
              name: "Camelot Token",
              symbol: "GRAIL",
              address: "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8",
              price: 519.69,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "YFDAI.finance",
              symbol: "YF-DAI",
              address: "0xf4cd3d3fda8d7fd6c5a500203e38640a70bf9577",
              price: 24.71,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "1",
              name: "chrono.tech",
              symbol: "TIME",
              address: "0x485d17a6f1b8780392d53d64751824253011a260",
              price: 17.25,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Strike",
              symbol: "STRK",
              address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
              price: 12.59,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "HAPI",
              symbol: "HAPI",
              address: "0xD9c2D319Cd7e6177336b0a9c93c21cb48d84Fb54",
              price: 8.41,
            },
            {
              chainId: "1",
              name: "Oraichain Token",
              symbol: "ORAI",
              address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
              price: 7.29,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Uquid Coin",
              symbol: "UQC",
              address: "0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2",
              price: 5.23,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Euler",
              symbol: "EUL",
              address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
              price: 4.17,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "42161",
              name: "Gains Network",
              symbol: "GNS",
              address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
              price: 1.51,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "Pluton",
              symbol: "PLU",
              address: "0xD8912C10681D8B21Fd3742244f44658dBA12264E",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Router Protocol",
              symbol: "ROUTE",
              address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
              price: 1.093,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Origin Dollar",
              symbol: "OUSD",
              address: "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
              price: 0.996947,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "OriginTrail",
              symbol: "TRAC",
              address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
              price: 0.623907,
            },
            {
              chainId: "1",
              name: "WHALE",
              symbol: "WHALE",
              address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
              price: 0.620746,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "MahaDAO",
              symbol: "MAHA",
              address: "0x745407c86DF8DB893011912d3aB28e68B62E49B0",
              price: 0.578542,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Polytrade",
              symbol: "TRADE",
              address: "0x6e5970dbd6fc7eb1f29c6d2edf2bc4c36124c0c1",
              price: 0.40536,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Kryll",
              symbol: "KRL",
              address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
              price: 0.35556,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "Clearpool",
              symbol: "CPOOL",
              address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
              price: 0.304535,
            },
            {
              chainId: "1",
              name: "Fracton Protocol",
              symbol: "FT",
              address: "0xEe9E7Bb7E55bBc86414047B61D65c9C0d91fFBd0",
              price: 0.295777,
            },
            {
              chainId: "1",
              name: "Vectorspace AI",
              symbol: "VXV",
              address: "0x7D29A64504629172a429e64183D6673b9dAcbFCe",
              price: 0.291574,
            },
            {
              chainId: "1",
              name: "Morpheus Network",
              symbol: "MNW",
              address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
              price: 0.286024,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "OVR",
              symbol: "OVR",
              address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
              price: 0.276292,
            },
            {
              chainId: "1",
              name: "BitMart Token",
              symbol: "BMX",
              address: "0x986EE2B944c42D017F52Af21c4c69B84DBeA35d8",
              price: 0.258578,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "AIOZ Network",
              symbol: "AIOZ",
              address: "0x626e8036deb333b408be468f951bdb42433cbf18",
              price: 0.242007,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "Alkimi",
              symbol: "$ADS",
              address: "0x3106a0a076bedae847652f42ef07fd58589e001f",
              price: 0.215736,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Function X",
              symbol: "FX",
              address: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
              price: 0.138919,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Aleph.im",
              symbol: "ALEPH",
              address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
              price: 0.116863,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "1",
              name: "Polychain Monsters",
              symbol: "PMON",
              address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
              price: 0.114137,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "Polkadex",
              symbol: "PDEX",
              address: "0xf59ae934f6fe444afc309586cc60a84a0f89aaea",
              price: 0.099452,
            },
            {
              chainId: "1",
              name: "Forta",
              symbol: "FORT",
              address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
              price: 0.098713,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "1",
              name: "Singularity DAO",
              symbol: "SDAO",
              address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
              price: 0.092064,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Atlas Navi",
              symbol: "NAVI",
              address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
              price: 0.090082,
            },
            {
              chainId: "1",
              name: "NuCypher",
              symbol: "NU",
              address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
              price: 0.083335,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "Newscrypto Coin",
              symbol: "NWC",
              address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
              price: 0.080218,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Skey Network",
              symbol: "SKEY",
              address: "0x06a01a4d579479dd5d884ebf61a31727a3d8d442",
              price: 0.075926,
            },
            {
              chainId: "1",
              name: "Push Protocol",
              symbol: "PUSH",
              address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
              price: 0.075692,
            },
            {
              chainId: "1",
              name: "Ultra",
              symbol: "UOS",
              address: "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c",
              price: 0.074555,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Geeq",
              symbol: "GEEQ",
              address: "0x6b9f031d718dded0d681c20cb754f97b3bb81b78",
              price: 0.063412,
            },
            {
              chainId: "1",
              name: "Unmarshal",
              symbol: "MARSH",
              address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
              price: 0.063323,
            },
            {
              chainId: "1",
              name: "SUKU",
              symbol: "SUKU",
              address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
              price: 0.061202,
            },
            {
              chainId: "1",
              name: "Opulous ",
              symbol: "OPUL",
              address: "0x80D55c03180349Fff4a229102F62328220A96444",
              price: 0.059933,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "ECOx",
              symbol: "ECOx",
              address: "0xcccD1Ba9f7acD6117834E0D28F25645dECb1736a",
              price: 0.05339,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "Lossless Protocol",
              symbol: "LSS",
              address: "0x3b9be07d622accaed78f479bc0edabfd6397e320",
              price: 0.04878451,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Fear",
              symbol: "FEAR",
              address: "0x88a9a52f944315d5b4e917b9689e65445c401e83",
              price: 0.04334569,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "Netvrk",
              symbol: "NTVRK",
              address: "0xfc0d6cf33e38bce7ca7d89c0e292274031b7157a",
              price: 0.04143016,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "Humans.ai",
              symbol: "HEART",
              address: "0x8FAc8031e079F409135766C7d5De29cf22EF897C",
              price: 0.03829733,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "AscendEx Token",
              symbol: "ASD",
              address: "0xff742d05420b6aca4481f635ad8341f81a6300c2",
              price: 0.03628634,
            },
            {
              chainId: "1",
              name: "XDEFI Wallet",
              symbol: "XDEFI",
              address: "0x72b886d09c117654ab7da13a14d603001de0b777",
              price: 0.03577743,
            },
            {
              chainId: "1",
              name: "Tranche Finance",
              symbol: "SLICE",
              address: "0x0aee8703d34dd9ae107386d3eff22ae75dd616d1",
              price: 0.03388895,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "UniLayer",
              symbol: "LAYER",
              address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
              price: 0.03082503,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "AllianceBlock Nexera",
              symbol: "NXRA",
              address: "0x644192291cc835A93d6330b24EA5f5FEdD0eEF9e",
              price: 0.02779917,
            },
            {
              chainId: "1",
              name: "Orbs",
              symbol: "ORBS",
              address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
              price: 0.02748275,
            },
            {
              chainId: "1",
              name: "VAIOT",
              symbol: "VAI",
              address: "0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c",
              price: 0.02690659,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "hiPENGUINS",
              symbol: "HIPENGUINS",
              address: "0x669dB4c47f89f21554Ebd825A744888725FD9491",
              price: 0.02621072,
            },
            {
              chainId: "1",
              name: "TRVL",
              symbol: "TRVL",
              address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "GamerCoin",
              symbol: "GHX",
              address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
              price: 0.02555778,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "Gold Fever",
              symbol: "NGL",
              address: "0x2653891204f463fb2a2f4f412564b19e955166ae",
              price: 0.0217287,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "NAGA",
              symbol: "NGC",
              address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
              price: 0.0183165,
            },
            {
              chainId: "1",
              name: "Shopping.io Token",
              symbol: "SHOP",
              address: "0x64b78325d7495d6d4be92f234fa3f3b8d8964b8b",
              price: 0.01807887,
            },
            {
              chainId: "1",
              name: "Nord Finance",
              symbol: "NORD",
              address: "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
              price: 0.0180385,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "42161",
              name: "Sperax",
              symbol: "SPA",
              address: "0x5575552988A3A80504bBaeB1311674fCFd40aD4B",
              price: 0.0152261,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "ClinTex",
              symbol: "CTI",
              address: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
              price: 0.01384061,
            },
            {
              chainId: "1",
              name: "Sperax",
              symbol: "SPA",
              address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
              price: 0.01312954,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Polkamarkets",
              symbol: "POLK",
              address: "0xD478161C952357F05f0292B56012Cd8457F1cfbF",
              price: 0.0124688,
            },
            {
              chainId: "1",
              name: "Locus Chain",
              symbol: "LOCUS",
              address: "0xc64500dd7b0f1794807e67802f8abbf5f8ffb054",
              price: 0.01212623,
            },
            {
              chainId: "1",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
              price: 0.01210312,
            },
            {
              chainId: "1",
              name: "hiAZUKI",
              symbol: "HIAZUKI",
              address: "0x4DB26817c88A57D2ef84cFd90168f535Ee83bDA9",
              price: 0.01197541,
            },
            {
              chainId: "1",
              name: "UnoRe",
              symbol: "UNO",
              address: "0x474021845c4643113458ea4414bdb7fb74a01a77",
              price: 0.01192575,
            },
            {
              chainId: "1",
              name: "HYVE.works",
              symbol: "HYVE",
              address: "0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4",
              price: 0.01167148,
            },
            {
              chainId: "1",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "ZeroSwap Token",
              symbol: "ZEE",
              address: "0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
              price: 0.01048836,
            },
            {
              chainId: "1",
              name: "Credefi ",
              symbol: "CREDI",
              address: "0xaE6e307c3Fe9E922E5674DBD7F830Ed49c014c6B",
              price: 0.01039157,
            },
            {
              chainId: "1",
              name: "Crypterium",
              symbol: "CRPT",
              address: "0x08389495D7456E1951ddF7c3a1314A4bfb646d8B",
              price: 0.01027737,
            },
            {
              chainId: "1",
              name: "Lumerin",
              symbol: "LMR",
              address: "0x4b1d0b9f081468d780ca1d5d79132b64301085d1",
              price: 0.0101826,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "CUDOS",
              symbol: "CUDOS",
              address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
              price: 0.00963311,
            },
            {
              chainId: "1",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0xD04E772BC0d591fBD288f2E2a86aFA3D3CB647F8",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "SwftCoin",
              symbol: "SWFTC",
              address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
              price: 0.00906635,
            },
            {
              chainId: "1",
              name: "izumi Finance",
              symbol: "IZI",
              address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
              price: 0.00756683,
            },
            {
              chainId: "1",
              name: "Antimatter",
              symbol: "MATTER",
              address: "0x9B99CcA871Be05119B2012fd4474731dd653FEBe",
              price: 0.00753904,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "Ferrum Network",
              symbol: "FRM",
              address: "0xe5caef4af8780e59df925470b050fb23c43ca68c",
              price: 0.00700849,
            },
            {
              chainId: "1",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
              price: 0.00696,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "IOI Token",
              symbol: "IOI",
              address: "0x8b3870df408ff4d7c3a26df852d41034eda11d81",
              price: 0.00627625,
            },
            {
              chainId: "1",
              name: "VEGA Protocol",
              symbol: "VEGA",
              address: "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e",
              price: 0.00611416,
            },
            {
              chainId: "1",
              name: "Chronicle",
              symbol: "XNL",
              address: "0x06a00715e6f92210af9d7680b584931faf71a833",
              price: 0.00599054,
            },
            {
              chainId: "1",
              name: "Bit.Store",
              symbol: "STORE",
              address: "0x31ea0de8119307aa264bb4b38727aab4e36b074f",
              price: 0.00598265,
            },
            {
              chainId: "1",
              name: "Cirus",
              symbol: "CIRUS",
              address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
              price: 0.00585288,
            },
            {
              chainId: "1",
              name: "EPIK Prime",
              symbol: "EPIK",
              address: "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
              price: 0.0056189,
            },
            {
              chainId: "1",
              name: "hiDOODLES",
              symbol: "HIDOODLES",
              address: "0x3700Adfd26d5bC062cB8b8a77e68fbd43F58eCAB",
              price: 0.00557793,
            },
            {
              chainId: "1",
              name: "Swash",
              symbol: "SWASH",
              address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
              price: 0.00505555,
            },
            {
              chainId: "1",
              name: "delta.theta",
              symbol: "DLTA",
              address: "0x0000000DE40dfa9B17854cBC7869D80f9F98D823",
              price: 0.00484398,
            },
            {
              chainId: "1",
              name: "Konomi Network",
              symbol: "KONO",
              address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
              price: 0.00472211,
            },
            {
              chainId: "1",
              name: "Acquire.Fi",
              symbol: "ACQ",
              address: "0x4bdcb66b968060d9390c1d12bd29734496205581",
              price: 0.00468929,
            },
            {
              chainId: "1",
              name: "Dfyn",
              symbol: "DFYN",
              address: "0x9695e0114e12C0d3A3636fAb5A18e6b737529023",
              price: 0.0045632,
            },
            {
              chainId: "1",
              name: "Taraxa",
              symbol: "TARA",
              address: "0xf001937650bb4f62b57521824b2c20f5b91bea05",
              price: 0.00455298,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "1",
              name: "Oddz Finance",
              symbol: "ODDZ",
              address: "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
              price: 0.00437637,
            },
            {
              chainId: "1",
              name: "Solve",
              symbol: "SOLVE",
              address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
              price: 0.00402632,
            },
            {
              chainId: "1",
              name: "ThunderCore",
              symbol: "TT",
              address: "0x1e053d89e08c24aa2ce5c5b4206744dc2d7bd8f5",
              price: 0.00385625,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "Standard Protocol ",
              symbol: "STND",
              address: "0x9040e237C3bF18347bb00957Dc22167D0f2b999d",
              price: 0.00317739,
            },
            {
              chainId: "1",
              name: "ShareToken",
              symbol: "SHR",
              address: "0xd98F75b1A3261dab9eEd4956c93F33749027a964",
              price: 0.00315436,
            },
            {
              chainId: "1",
              name: "dAppstore",
              symbol: "DAPPX",
              address: "0x00d8318e44780edeefcf3020a5448f636788883c",
              price: 0.00302272,
            },
            {
              chainId: "1",
              name: "High Performance Blockchain",
              symbol: "HPB",
              address: "0x38c6a68304cdefb9bec48bbfaaba5c5b47818bb2",
              price: 0.00301968,
            },
            {
              chainId: "1",
              name: "Sidus Heroes",
              symbol: "SIDUS",
              address: "0x549020a9Cb845220D66d3E9c6D9F9eF61C981102",
              price: 0.00293755,
            },
            {
              chainId: "1",
              name: "hiENS3",
              symbol: "HIENS3",
              address: "0xa88842ae47dbe87116cf7001dddd1b246fcd8262",
              price: 0.00293103,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "EQIFI",
              symbol: "EQX",
              address: "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
              price: 0.0024537,
            },
            {
              chainId: "1",
              name: "Acent",
              symbol: "ACE",
              address: "0xec5483804e637d45cde22fa0869656b64b5ab1ab",
              price: 0.00221717,
            },
            {
              chainId: "1",
              name: "BiFi",
              symbol: "BIFI",
              address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
              price: 0.00209525,
            },
            {
              chainId: "1",
              name: "hiSAND33",
              symbol: "HISAND33",
              address: "0x12AEf5C60C2C86c8ECD3079f22F285f326371340",
              price: 0.00202645,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "VEMP",
              symbol: "VEMP",
              address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
              price: 0.00171918,
            },
            {
              chainId: "1",
              name: "Change",
              symbol: "CAG",
              address: "0x7d4b8cce0591c9044a22ee543533b72e976e36c3",
              price: 0.00161374,
            },
            {
              chainId: "1",
              name: "Project TXA",
              symbol: "TXA",
              address: "0x4463e6A3dEd0dBE3F6e15bC8420dFc55e5FeA830",
              price: 0.00158853,
            },
            {
              chainId: "1",
              name: "Blockchain Brawlers",
              symbol: "BRWL",
              address: "0x4086e77c5e993fdb90a406285d00111a974f877a",
              price: 0.00154996,
            },
            {
              chainId: "1",
              name: "ClearDAO",
              symbol: "CLH",
              address: "0xd7d8f3b8bc8bc48d3acc37879eaba7b85889fa52",
              price: 0.00154543,
            },
            {
              chainId: "1",
              name: "hiMEEBITS",
              symbol: "HIMEEBITS",
              address: "0xBBeca80A4c99c3b1BD3C10E64595d0Fc7dC26eE0",
              price: 0.00139375,
            },
            {
              chainId: "1",
              name: "REVV",
              symbol: "REVV",
              address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
              price: 0.00135141,
            },
            {
              chainId: "1",
              name: "YIELD App",
              symbol: "YLD",
              address: "0xf94b5c5651c888d928439ab6514b93944eee6f48",
              price: 0.00124088,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Melos Studio",
              symbol: "MELOS",
              address: "0x1afb69dbc9f54d08dab1bd3436f8da1af819e647",
              price: 0.00113651,
            },
            {
              chainId: "1",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
              price: 0.00110671,
            },
            {
              chainId: "1",
              name: "Tower",
              symbol: "TOWER",
              address: "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
              price: 0.00109538,
            },
            {
              chainId: "1",
              name: "Ideaology",
              symbol: "IDEA",
              address: "0x5d3a4F62124498092Ce665f865E0b38fF6F5FbEa",
              price: 0.00108711,
            },
            {
              chainId: "1",
              name: "Astra Protocol",
              symbol: "ASTRA",
              address: "0x201332Bd45c8628D814F870bFb584B385A7C351e",
              price: 0.00107095,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "Sylo",
              symbol: "SYLO",
              address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
              price: 0.00089542,
            },
            {
              chainId: "1",
              name: "hiVALHALLA",
              symbol: "HIVALHALLA",
              address: "0x5C0590cDE44569bf39ef79e859B367e39cB000F1",
              price: 0.00088965,
            },
            {
              chainId: "1",
              name: "Student Coin",
              symbol: "STC",
              address: "0x15b543e986b8c34074dfc9901136d9355a537e7e",
              price: 0.00084146,
            },
            {
              chainId: "1",
              name: "hiMOONBIRDS",
              symbol: "HIMOONBIRDS",
              address: "0x0a7b89e66a1dc16633abdfd132bae05827d3bfa5",
              price: 0.0007864,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Tokoin",
              symbol: "TOKO",
              address: "0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675",
              price: 0.0005868,
            },
            {
              chainId: "1",
              name: "hiMFERS",
              symbol: "HIMFERS",
              address: "0xB755D5bC7de83232b9df1886bD5CdB38895933B0",
              price: 0.00051914,
            },
            {
              chainId: "1",
              name: "DOSE",
              symbol: "DOSE",
              address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "hiOD",
              symbol: "HIOD",
              address: "0x7a83FF237e7870d8d6C3485920EBe654D2841315",
              price: 0.00051324,
            },
            {
              chainId: "1",
              name: "hiODBS",
              symbol: "HIODBS",
              address: "0x33bD66c334274989b673a8e8C8d1A3f1B8De5889",
              price: 0.00049499,
            },
            {
              chainId: "1",
              name: "hiBEANZ",
              symbol: "HIBEANZ",
              address: "0x23ddbd36547d43627afa9b42d4e9fb0515f48b09",
              price: 0.00046543,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Geojam",
              symbol: "JAM",
              address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
              price: 0.00040671,
            },
            {
              chainId: "1",
              name: "MARS4",
              symbol: "MARS4",
              address: "0x16cda4028e9e872a38acb903176719299beaed87",
              price: 0.00038566,
            },
            {
              chainId: "1",
              name: "Ispolink",
              symbol: "ISP",
              address: "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
              price: 0.00037618,
            },
            {
              chainId: "1",
              name: "ROOBEE",
              symbol: "ROOBEE",
              address: "0xa31b1767e09f842ecfd4bc471fe44f830e3891aa",
              price: 0.00035719,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Franklin",
              symbol: "FLY",
              address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Phoenix DAO",
              symbol: "PHNX",
              address: "0x38A2fDc11f526Ddd5a607C1F251C065f40fBF2f7",
              price: 0.00031199,
            },
            {
              chainId: "1",
              name: "WOMBAT",
              symbol: "WOMBAT",
              address: "0x0C9c7712C83B3C70e7c5E11100D33D9401BdF9dd",
              price: 0.00024997,
            },
            {
              chainId: "1",
              name: "Gemie",
              symbol: "GEM",
              address: "0x9008064E6cf73e27a3Aba4B10E69f855A4F8efcC",
              price: 0.00023819,
            },
            {
              chainId: "1",
              name: "Keystone of Opportunity & Knowledge",
              symbol: "KOK",
              address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
              price: 0.00022317,
            },
            {
              chainId: "1",
              name: "EarthFund",
              symbol: "1EARTH",
              address: "0x9e04f519b094f5f8210441e285f603f4d2b50084",
              price: 0.00021091,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "BEPRO Network",
              symbol: "BEPRO",
              address: "0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a",
              price: 0.00019527,
            },
            {
              chainId: "1",
              name: "hiRENGA",
              symbol: "HIRENGA",
              address: "0x1de852cd18323bc5ebda842b8eef46c6e551aa47",
              price: 0.0001869,
            },
            {
              chainId: "1",
              name: "hiUNDEAD",
              symbol: "HIUNDEAD",
              address: "0x70d0ff0d3b3F5E69220c09bEFC70606Fa5F89293",
              price: 0.00017669,
            },
            {
              chainId: "1",
              name: "Lithium Finance",
              symbol: "LITH",
              address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
              price: 0.0001711,
            },
            {
              chainId: "1",
              name: "Unbound Finance",
              symbol: "UNB",
              address: "0x8db253a1943dddf1af9bcf8706ac9a0ce939d922",
              price: 0.00015672,
            },
            {
              chainId: "1",
              name: "hiFRIENDS",
              symbol: "HIFRIENDS",
              address: "0xeb2f5a4e1441df330670dc7b0cf4eac0f7ab5fa5",
              price: 0.00014147,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "RankerDAO",
              symbol: "RANKER",
              address: "0x6431FA4B812a2DCC062A38CB55cc7D18135AdEAd",
              price: 0.00013079,
            },
            {
              chainId: "1",
              name: "AllianceBlock",
              symbol: "ALBT",
              address: "0x00a8b738E453fFd858a7edf03bcCfe20412f0Eb0",
              price: 0.00013065,
            },
            {
              chainId: "1",
              name: "ODEM",
              symbol: "ODE",
              address: "0xbf52f2ab39e26e0951d2a02b49b7702abe30406a",
              price: 0.00011895,
            },
            {
              chainId: "1",
              name: "DSLA Protocol",
              symbol: "DSLA",
              address: "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
              price: 0.00010587,
            },
            {
              chainId: "1",
              name: "YOP Finance",
              symbol: "YOP",
              address: "0xae1eaae3f627aaca434127644371b67b18444051",
              price: 0.00009227,
            },
            {
              chainId: "1",
              name: "Multiverse",
              symbol: "AI",
              address: "0xc91b523a59acc63a64f61fc7bbfb4bfc82dd25f2",
              price: 0.00009049,
            },
            {
              chainId: "1",
              name: "Verse",
              symbol: "VERSE",
              address: "0x249cA82617eC3DfB2589c4c17ab7EC9765350a18",
              price: 0.0000766,
            },
            {
              chainId: "1",
              name: "BABB",
              symbol: "BAX",
              address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
              price: 0.00007559,
            },
            {
              chainId: "1",
              name: "hiENS4",
              symbol: "HIENS4",
              address: "0x00a7ec2f2b451cb0233e8adbf4c9a951027c2b02",
              price: 0.00005359,
            },
            {
              chainId: "1",
              name: "Tidal Finance",
              symbol: "TIDAL",
              address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
              price: 0.00004985,
            },
            {
              chainId: "1",
              name: "TribeOne",
              symbol: "HAKA",
              address: "0xd85ad783cc94bd04196a13dc042a3054a9b52210",
              price: 0.00004609,
            },
            {
              chainId: "1",
              name: "ReapChain",
              symbol: "REAP",
              address: "0x1fc5EF0337AEA85C5f9198853a6E3A579a7A6987",
              price: 0.00004155,
            },
            {
              chainId: "1",
              name: "Cappasity",
              symbol: "CAPP",
              address: "0x11613b1f840bb5a40f8866d857e24da126b79d73",
              price: 0.00003674,
            },
            {
              chainId: "1",
              name: "Launchblock",
              symbol: "LBP",
              address: "0xa23C1194d421F252b4e6D5edcc3205F7650a4eBE",
              price: 0.00003319,
            },
            {
              chainId: "1",
              name: "SOCOL",
              symbol: "SIMP",
              address: "0x41C21693e60FC1a5dBb7c50e54E7A6016aA44C99",
              price: 0.00003014,
            },
            {
              chainId: "1",
              name: "SaTT",
              symbol: "SATT",
              address: "0xdf49c9f599a0a9049d97cff34d0c30e468987389",
              price: 0.00002993,
            },
            {
              chainId: "1",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Frontrow",
              symbol: "FRR",
              address: "0xe6602b34d8510b033e000975b3322537c7172441",
              price: 0.00001434,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Every Game",
              symbol: "EGAME",
              address: "0x62d3c05b9c3d916fbc111819bbd3cee52906c1ae",
              price: 0.00001004,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
              price: 2.36911e-7,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:40.539Z",
          type: "csvImport",
        },
      },
      {
        _id: "666c002685672a7368dac26e",
        uid: "666c002685672a7368dac26e",
        userIds: ["666c002685672a7368dac26e"],
        wallets: [
          {
            status: "verified",
            walletId: "683749437a939d1fbcfd4c3f",
            ecosystem: "evm",
            walletAddress: "0xC882b111A75C0c657fC507C04FbFcD2cC984F071",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 156,
        walletTotalValue: 963912171.1469394,
        walletAge: "2y8m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "WhiteBIT Token",
              symbol: "WBT",
              address: "0x925206b8a707096Ed26ae47C84747fE0bb734F59",
              price: 30.26,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Maple",
              symbol: "MPL",
              address: "0x33349b282065b0284d756f0577fb39c158f935e6",
              price: 12.05,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Oraichain Token",
              symbol: "ORAI",
              address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
              price: 7.29,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Echelon Prime",
              symbol: "PRIME",
              address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
              price: 3.34,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Chicken Token",
              symbol: "KFC",
              address: "0xe63684bcf2987892cefb4caa79bd21b34e98a291",
              price: 3.01,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Waves",
              symbol: "WAVES",
              address: "0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a",
              price: 1.58,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Goldfinch",
              symbol: "GFI",
              address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
              price: 0.941368,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Agoras",
              symbol: "AGRS",
              address: "0x738865301a9b7dd80dc3666dd48cf034ec42bdda",
              price: 0.778602,
            },
            {
              chainId: "5000",
              name: "MNT",
              symbol: "MNT",
              address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
              price: 0.72034,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Crown Token",
              symbol: "CROWN",
              address: "0xF3Bb9F16677F2B86EfD1DFca1c141A99783Fde58",
              price: 0.519661,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Chintai",
              symbol: "CHEX",
              address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
              price: 0.465696,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Polytrade",
              symbol: "TRADE",
              address: "0x6e5970dbd6fc7eb1f29c6d2edf2bc4c36124c0c1",
              price: 0.40536,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Clearpool",
              symbol: "CPOOL",
              address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
              price: 0.304535,
            },
            {
              chainId: "1",
              name: "Morpheus Network",
              symbol: "MNW",
              address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
              price: 0.286024,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "Blox",
              symbol: "CDT",
              address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
              price: 0.205372,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "BitMEX Token",
              symbol: "BMEX",
              address: "0xb113c6cf239f60d380359b762e95c13817275277",
              price: 0.164769,
            },
            {
              chainId: "1",
              name: "Swarm Markets",
              symbol: "SMT",
              address: "0xb17548c7b510427baac4e267bea62e800b247173",
              price: 0.163673,
            },
            {
              chainId: "1",
              name: "Gelato",
              symbol: "GEL",
              address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
              price: 0.162866,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Aleph.im",
              symbol: "ALEPH",
              address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
              price: 0.116863,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "1",
              name: "DIMO",
              symbol: "DIMO",
              address: "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
              price: 0.10982,
            },
            {
              chainId: "1",
              name: "Zignaly",
              symbol: "ZIG",
              address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
              price: 0.109712,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "1",
              name: "Atlas Navi",
              symbol: "NAVI",
              address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
              price: 0.090082,
            },
            {
              chainId: "1",
              name: "Ultra",
              symbol: "UOS",
              address: "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c",
              price: 0.074555,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "HOPR Token",
              symbol: "HOPR",
              address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
              price: 0.060076,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "Lossless Protocol",
              symbol: "LSS",
              address: "0x3b9be07d622accaed78f479bc0edabfd6397e320",
              price: 0.04878451,
            },
            {
              chainId: "1",
              name: "Big Data Protocol",
              symbol: "BDP",
              address: "0xf3dcbc6D72a4E1892f7917b7C43b74131Df8480e",
              price: 0.04866796,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "QANplatform",
              symbol: "QANX",
              address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
              price: 0.04278893,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "Mintlayer",
              symbol: "ML",
              address: "0x059956483753947536204e89bfaD909E1a434Cc6",
              price: 0.03113184,
            },
            {
              chainId: "1",
              name: "Hello Pets",
              symbol: "PET",
              address: "0xB870679a7Fa65b924026F496De7f27c1DD0e5C5F",
              price: 0.02987464,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "dKargo",
              symbol: "DKA",
              address: "0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0",
              price: 0.02821723,
            },
            {
              chainId: "1",
              name: "VAIOT",
              symbol: "VAI",
              address: "0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c",
              price: 0.02690659,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
              price: 0.02641525,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Talken",
              symbol: "TALK",
              address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
              price: 0.02205094,
            },
            {
              chainId: "1",
              name: "Oobit",
              symbol: "OBT",
              address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
              price: 0.02010881,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Media Industry Licensing Content",
              symbol: "MLT",
              address: "0x9506d37f70eB4C3d79C398d326C871aBBf10521d",
              price: 0.017328,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "SmarDex",
              symbol: "SDEX",
              address: "0x5DE8ab7E27f6E7A1fFf3E5B337584Aa43961BEeF",
              price: 0.01537551,
            },
            {
              chainId: "1",
              name: "Choise.com",
              symbol: "CHO",
              address: "0xBBa39Fd2935d5769116ce38d46a71bde9cf03099",
              price: 0.01408598,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Sperax",
              symbol: "SPA",
              address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
              price: 0.01312954,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "CUDOS",
              symbol: "CUDOS",
              address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
              price: 0.00963311,
            },
            {
              chainId: "1",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
              price: 0.00696,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Saito",
              symbol: "SAITO",
              address: "0xfa14fa6958401314851a17d6c5360ca29f74b57b",
              price: 0.00425246,
            },
            {
              chainId: "1",
              name: "Lord of Dragons",
              symbol: "LOGT",
              address: "0xba58444c8050ed9385b7417533a73644036d21eb",
              price: 0.00408551,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "1",
              name: "Undead Blocks",
              symbol: "UNDEAD",
              address: "0x310C8F00b9dE3c31Ab95ea68feb6C877538f7947",
              price: 0.00308739,
            },
            {
              chainId: "1",
              name: "Sidus Heroes",
              symbol: "SIDUS",
              address: "0x549020a9Cb845220D66d3E9c6D9F9eF61C981102",
              price: 0.00293755,
            },
            {
              chainId: "1",
              name: "Proxi DeFi",
              symbol: "CREDIT",
              address: "0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4",
              price: 0.00245371,
            },
            {
              chainId: "1",
              name: "Ally",
              symbol: "ALY",
              address: "0x9d5686eadea7327f5a0c4820dca90457a0e88763",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Taxa Network",
              symbol: "TXT",
              address: "0x547b2F82ceCfAb9C2B1D36fddA96eF9F58C63B8C",
              price: 0.00112344,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "MetaOctagon",
              symbol: "MOTG",
              address: "0x171d76d931529384639BC9aad5b77b77041ED604",
              price: 0.00044182,
            },
            {
              chainId: "1",
              name: "Saitama V2",
              symbol: "SAITAMA",
              address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
              price: 0.00035045,
            },
            {
              chainId: "1",
              name: "Franklin",
              symbol: "FLY",
              address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Ecomi",
              symbol: "OMI",
              address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
              price: 0.00027862,
            },
            {
              chainId: "1",
              name: "Wojak",
              symbol: "WOJAK",
              address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
              price: 0.00024381,
            },
            {
              chainId: "1",
              name: "Spores Network",
              symbol: "SPO",
              address: "0xcbe771323587ea16dacb6016e269d7f08a7acc4e",
              price: 0.00023253,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "DxChain",
              symbol: "DX",
              address: "0x973e52691176d36453868d9d86572788d27041a9",
              price: 0.00002296,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "42161",
              name: "POGAI",
              symbol: "POGAI",
              address: "0x6fD58f5a2F3468e35fEb098b5F59F04157002407",
              price: 0.00001271,
            },
            {
              chainId: "1",
              name: "Red Token",
              symbol: "RED",
              address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
              price: 0.00000179,
            },
            {
              chainId: "1",
              name: "StarLink",
              symbol: "STARL",
              address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
              price: 7.98843e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
              price: 2.36911e-7,
            },
            {
              chainId: "1",
              name: "Akita Inu",
              symbol: "AKITA",
              address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
              price: 8.8739e-8,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "42161",
              name: "ArbDoge AI",
              symbol: "AIDOGE",
              address: "0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b",
              price: 2.6422e-10,
            },
            {
              chainId: "42161",
              name: "AiShiba",
              symbol: "SHIBAI",
              address: "0xFA296FcA3c7DBa4a92A42Ec0B5E2138DA3b29050",
              price: 3.891e-12,
            },
          ],
        },
        chainIds: [1, 42161, 5000],
        cexLabels: [],
        tags: [
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:39.781Z",
          type: "csvImport",
        },
      },
      {
        _id: "666bff4885672a7368da9839",
        uid: "666bff4885672a7368da9839",
        userIds: ["666bff4885672a7368da9839"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ee97a939d1fbce8b210",
            ecosystem: "evm",
            walletAddress: "0xCFFAd3200574698b78f32232aa9D63eABD290703",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 199,
        walletTotalValue: 881974259.976376,
        walletAge: "3y8m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "Doge Killer",
              symbol: "LEASH",
              address: "0x27c70cd1946795b66be9d954418546998b546634",
              price: 241.51,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Quickswap (OLD)",
              symbol: "QUICK",
              address: "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
              price: 35.75,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Oraichain Token",
              symbol: "ORAI",
              address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
              price: 7.29,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Echelon Prime",
              symbol: "PRIME",
              address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
              price: 3.34,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Elastos",
              symbol: "ELA",
              address: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
              price: 1.81,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "Rarible",
              symbol: "RARI",
              address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
              price: 1.44,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Gemini Dollar",
              symbol: "GUSD",
              address: "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
              price: 0.999716,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "XSGD",
              symbol: "XSGD",
              address: "0x70e8de73ce538da2beed35d14187f6959a8eca96",
              price: 0.733494,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "OriginTrail",
              symbol: "TRAC",
              address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
              price: 0.623907,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Kryll",
              symbol: "KRL",
              address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
              price: 0.35556,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Ribbon Finance",
              symbol: "RBN",
              address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
              price: 0.31189,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "AIOZ Network",
              symbol: "AIOZ",
              address: "0x626e8036deb333b408be468f951bdb42433cbf18",
              price: 0.242007,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "1",
              name: "Rari Governance Token",
              symbol: "RGT",
              address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
              price: 0.180052,
            },
            {
              chainId: "1",
              name: "Merit Circle",
              symbol: "MC",
              address: "0x949d48eca67b17269629c7194f4b727d4ef9e5d6",
              price: 0.17546,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Gelato",
              symbol: "GEL",
              address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
              price: 0.162866,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "sudoswap",
              symbol: "SUDO",
              address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
              price: 0.119429,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "DeRace",
              symbol: "DERC",
              address: "0x9fa69536d1cda4a04cfb50688294de75b505a9ae",
              price: 0.084339,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Push Protocol",
              symbol: "PUSH",
              address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
              price: 0.075692,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Minted",
              symbol: "MTD",
              address: "0x809e130e10e787139c54e1d12d3d1971b7a675bf",
              price: 0.01736924,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Sperax",
              symbol: "SPA",
              address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
              price: 0.01312954,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "Crypterium",
              symbol: "CRPT",
              address: "0x08389495D7456E1951ddF7c3a1314A4bfb646d8B",
              price: 0.01027737,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "CUDOS",
              symbol: "CUDOS",
              address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
              price: 0.00963311,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "OpenLeverage",
              symbol: "OLE",
              address: "0x92CfbEC26C206C90aeE3b7C66A9AE673754FaB7e",
              price: 0.00577445,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
              price: 0.00006441,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
          ],
        },
        chainIds: [1, 137],
        cexLabels: ["Binance"],
        tags: [
          {
            _id: "666bfeca85672a7368da84d3",
            value: "OriginTrail",
            color: "#FCCEEE",
          },
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-14T08:34:25.304Z",
          type: "contractImport",
        },
      },
      {
        _id: "66b2df97eb9d48f61f022244",
        uid: "66b2df97eb9d48f61f022244",
        userIds: ["66b2df97eb9d48f61f022244"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd9003",
            ecosystem: "evm",
            walletAddress: "0x835678a611B28684005a5e2233695fB6cbbB0007",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 13,
        walletTotalValue: 674300483.1920341,
        walletAge: "1y5m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:39.605Z",
          type: "csvImport",
        },
      },
      {
        _id: "66b2df93eb9d48f61f022042",
        uid: "66b2df93eb9d48f61f022042",
        userIds: ["66b2df93eb9d48f61f022042"],
        wallets: [
          {
            status: "verified",
            walletId: "683749747a939d1fbcfd8e08",
            ecosystem: "evm",
            walletAddress: "0xee5B5B923fFcE93A870B3104b7CA09c3db80047A",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 12,
        walletTotalValue: 547280920.8870143,
        walletAge: "3y11m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "Throne",
              symbol: "THN",
              address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
              price: 0.00113916,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "csv",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:35.625Z",
          type: "csvImport",
        },
      },
      {
        _id: "666c002685672a7368dac281",
        uid: "666c002685672a7368dac281",
        userIds: ["666c002685672a7368dac281"],
        wallets: [
          {
            status: "verified",
            walletId: "683740797a939d1fbceef983",
            ecosystem: "evm",
            walletAddress: "0x3CC936b795A188F0e246cBB2D74C5Bd190aeCF18",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 460,
        walletTotalValue: 534777252.2824261,
        walletAge: "3y2m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Inverse Finance",
              symbol: "INV",
              address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
              price: 48.04,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Saffron.finance",
              symbol: "SFI",
              address: "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
              price: 21.19,
            },
            {
              chainId: "1",
              name: "Deus Finance",
              symbol: "DEUS",
              address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
              price: 19.2,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "UNIUM",
              symbol: "UNM",
              address: "0x6570ffe19da7e2b425329b157d9109b87f18304b",
              price: 9.66,
            },
            {
              chainId: "1",
              name: "Nation3",
              symbol: "NATION",
              address: "0x333a4823466879eef910a04d473505da62142069",
              price: 8.95,
            },
            {
              chainId: "1",
              name: "HAPI",
              symbol: "HAPI",
              address: "0xD9c2D319Cd7e6177336b0a9c93c21cb48d84Fb54",
              price: 8.41,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Reflexer Ungovernance Token",
              symbol: "FLX",
              address: "0x6243d8cea23066d098a15582d81a598b4e8391f4",
              price: 5.12,
            },
            {
              chainId: "1",
              name: "Bitget Token",
              symbol: "BGB",
              address: "0x19de6b897ed14a376dda0fe53a5420d2ac828a28",
              price: 5.03,
            },
            {
              chainId: "1",
              name: "Euler",
              symbol: "EUL",
              address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
              price: 4.17,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "MX Token",
              symbol: "MX",
              address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
              price: 3.66,
            },
            {
              chainId: "1",
              name: "Wrapped Toncoin",
              symbol: "TONCOIN",
              address: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
              price: 3.53,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pre-Retogeum",
              symbol: "PRTG",
              address: "0xbd04ccc050058a6a422851fa6c0f92bb65eb06ca",
              price: 3.09,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "ApeX Protocol",
              symbol: "APEX",
              address: "0x52a8845df664d76c69d2eea607cd793565af42b8",
              price: 1.51,
            },
            {
              chainId: "1",
              name: "Rarible",
              symbol: "RARI",
              address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
              price: 1.44,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "AirTor Protocol",
              symbol: "ATOR",
              address: "0x0f7b3f5a8fed821c5eb60049538a548db2d479ce",
              price: 1.04,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Goldfinch",
              symbol: "GFI",
              address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
              price: 0.941368,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "1",
              name: "INVI",
              symbol: "INVI",
              address: "0x356a5160f2b34bc8d88fb084745465ebbbed0174",
              price: 0.905331,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "PepeCoin Cryptocurrency",
              symbol: "pepecoin",
              address: "0xA9E8aCf069C58aEc8825542845Fd754e41a9489A",
              price: 0.57721,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Gomining Token",
              symbol: "GMT",
              address: "0x7ddc52c4de30e94be3a6a0a2b259b2850f421989",
              price: 0.517705,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Chintai",
              symbol: "CHEX",
              address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
              price: 0.465696,
            },
            {
              chainId: "1",
              name: "X Protocol",
              symbol: "POT",
              address: "0x049b98b31eF7D6448519f3642AAD92AB5b8aDa52",
              price: 0.452427,
            },
            {
              chainId: "1",
              name: "ROGin",
              symbol: "ROG",
              address: "0x5d43b66da68706D39f6C97F7f1415615672b446b",
              price: 0.44825,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "Monte",
              symbol: "MONTE",
              address: "0x318Ee488AF8881f9945B6d3D69e8B395Fb559bB1",
              price: 0.405615,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Cellframe ",
              symbol: "CELL",
              address: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
              price: 0.399025,
            },
            {
              chainId: "1",
              name: "Unicly",
              symbol: "UNIC",
              address: "0x94e0bab2f6ab1f19f4750e42d7349f2740513ad5",
              price: 0.366642,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "BZZ",
              address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
              price: 0.357921,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "HUNT",
              symbol: "HUNT",
              address: "0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5",
              price: 0.350634,
            },
            {
              chainId: "1",
              name: "Massive Protocol",
              symbol: "MAV",
              address: "0xbe1dBe6741fB988fb571AB1E28CfFB36e3C62629",
              price: 0.346507,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Ribbon Finance",
              symbol: "RBN",
              address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
              price: 0.31189,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "Equilibrium",
              symbol: "EQ",
              address: "0xA5eDE2FEE620ac3d68065EC01F26F9dd99850B82",
              price: 0.299051,
            },
            {
              chainId: "1",
              name: "MetaFinance",
              symbol: "MFI",
              address: "0xEaDC218Ac4cB7895a5A56e6484646b48f841C45a",
              price: 0.283405,
            },
            {
              chainId: "1",
              name: "OVR",
              symbol: "OVR",
              address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
              price: 0.276292,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "IX Swap",
              symbol: "IXS",
              address: "0x73d7c860998ca3c01ce8c808f5577d94d545d1b4",
              price: 0.267945,
            },
            {
              chainId: "1",
              name: "Stratos ",
              symbol: "STOS",
              address: "0x08c32b0726C5684024ea6e141C50aDe9690bBdcc",
              price: 0.261778,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "MATH",
              symbol: "MATH",
              address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
              price: 0.200963,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "SocialGood",
              symbol: "SG",
              address: "0xddf7fd345d54ff4b40079579d4c4670415dbfd0a",
              price: 0.182196,
            },
            {
              chainId: "1",
              name: "Octopus Network",
              symbol: "OCT",
              address: "0xf5cfbc74057c610c8ef151a439252680ac68c6dc",
              price: 0.181571,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Hypercycle",
              symbol: "HYPC",
              address: "0xeA7B7DC089c9a4A916B5a7a37617f59fD54e37E4",
              price: 0.164976,
            },
            {
              chainId: "1",
              name: "Swarm Markets",
              symbol: "SMT",
              address: "0xb17548c7b510427baac4e267bea62e800b247173",
              price: 0.163673,
            },
            {
              chainId: "1",
              name: "Gelato",
              symbol: "GEL",
              address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
              price: 0.162866,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Nuco.cloud",
              symbol: "NCDT",
              address: "0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b",
              price: 0.14153,
            },
            {
              chainId: "1",
              name: "Lattice Token",
              symbol: "LTX",
              address: "0xa393473d64d2f9f026b60b6df7859a689715d092",
              price: 0.141237,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Truebit Protocol",
              symbol: "TRU",
              address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
              price: 0.137801,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "TrustSwap",
              symbol: "SWAP",
              address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
              price: 0.122692,
            },
            {
              chainId: "1",
              name: "Aleph.im",
              symbol: "ALEPH",
              address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
              price: 0.116863,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Xido Finance",
              symbol: "XIDO",
              address: "0xf6650117017ffd48b725b4ec5a00b414097108a7",
              price: 0.110139,
            },
            {
              chainId: "1",
              name: "Zignaly",
              symbol: "ZIG",
              address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
              price: 0.109712,
            },
            {
              chainId: "1",
              name: "Witch Token",
              symbol: "WITCH",
              address: "0xdc524e3c6910257744c1f93cf15e9f472b5bd236",
              price: 0.104827,
            },
            {
              chainId: "1",
              name: "EdenLoop",
              symbol: "ELT",
              address: "0xfC1Cb4920dC1110fD61AfaB75Cf085C1f871b8C6",
              price: 0.100016,
            },
            {
              chainId: "1",
              name: "Forta",
              symbol: "FORT",
              address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
              price: 0.098713,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "B20",
              symbol: "B20",
              address: "0xc4de189abf94c57f396bd4c52ab13b954febefd8",
              price: 0.095322,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "1",
              name: "Singularity DAO",
              symbol: "SDAO",
              address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
              price: 0.092064,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Atlas Navi",
              symbol: "NAVI",
              address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
              price: 0.090082,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "XELS",
              symbol: "XELS",
              address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
              price: 0.080759,
            },
            {
              chainId: "1",
              name: "Push Protocol",
              symbol: "PUSH",
              address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
              price: 0.075692,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "Oxygen",
              symbol: "OXY",
              address: "0x965697b4ef02f0de01384d0d4f9f782b1670c163",
              price: 0.073282,
            },
            {
              chainId: "1",
              name: "OccamFi",
              symbol: "OCC",
              address: "0x2f109021afe75b949429fe30523ee7c0d5b27207",
              price: 0.072545,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Coldstack",
              symbol: "CLS",
              address: "0x675bbc7514013e2073db7a919f6e4cbef576de37",
              price: 0.066447,
            },
            {
              chainId: "1",
              name: "Unmarshal",
              symbol: "MARSH",
              address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
              price: 0.063323,
            },
            {
              chainId: "1",
              name: "HOPR Token",
              symbol: "HOPR",
              address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
              price: 0.060076,
            },
            {
              chainId: "1",
              name: "Opulous ",
              symbol: "OPUL",
              address: "0x80D55c03180349Fff4a229102F62328220A96444",
              price: 0.059933,
            },
            {
              chainId: "1",
              name: "Jubi Token",
              symbol: "JT",
              address: "0xEb7355C2f217b3485a591332Fe13C8c5A76A581D",
              price: 0.056977,
            },
            {
              chainId: "1",
              name: "Aladdin DAO",
              symbol: "ALD",
              address: "0xb26c4b3ca601136daf98593feaeff9e0ca702a8d",
              price: 0.051837,
            },
            {
              chainId: "1",
              name: "My Crypto Heroes",
              symbol: "MCHC",
              address: "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
              price: 0.051445,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLX",
              address: "0x3Ea8ea4237344C9931214796d9417Af1A1180770",
              price: 0.051226,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "Big Data Protocol",
              symbol: "BDP",
              address: "0xf3dcbc6D72a4E1892f7917b7C43b74131Df8480e",
              price: 0.04866796,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "Graphlinq Protocol",
              symbol: "GLQ",
              address: "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24",
              price: 0.0451987,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "HarryPotterObamaSonic10Inu",
              symbol: "BITCOIN",
              address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
              price: 0.04305609,
            },
            {
              chainId: "1",
              name: "SpaceY2025",
              symbol: "SPAY",
              address: "0x58FaD9E3C3AE54c9BA98c3f0E4bF88aB3E8Cf3c5",
              price: 0.04274345,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "1MillionNFT ",
              symbol: "1MIL",
              address: "0xa4eF4b0B23C1fc81d3f9ecF93510e64f58A4A016",
              price: 0.03918949,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "Xend Finance",
              symbol: "XEND",
              address: "0xe4cfe9eaa8cdb0942a80b7bc68fd8ab0f6d44903",
              price: 0.03908406,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "Baanx",
              symbol: "BXX",
              address: "0x6b1a8f210ec6b7b6643cea3583fb0c079f367898",
              price: 0.03686092,
            },
            {
              chainId: "1",
              name: "XY Finance",
              symbol: "XY",
              address: "0x77777777772cf0455fb38ee0e75f38034dfa50de",
              price: 0.03625009,
            },
            {
              chainId: "1",
              name: "GamyFi",
              symbol: "GFX",
              address: "0x65ad6a2288b2dd23e466226397c8f5d1794e58fc",
              price: 0.03589222,
            },
            {
              chainId: "1",
              name: "PolySwarm",
              symbol: "NCT",
              address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
              price: 0.03448223,
            },
            {
              chainId: "1",
              name: "mStable Governance Token",
              symbol: "MTA",
              address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
              price: 0.03171461,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "Mintlayer",
              symbol: "ML",
              address: "0x059956483753947536204e89bfaD909E1a434Cc6",
              price: 0.03113184,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "Metacade",
              symbol: "MCADE",
              address: "0xed328e9c1179a30ddc1e7595e036aed8760c22af",
              price: 0.02907905,
            },
            {
              chainId: "1",
              name: "BiLira",
              symbol: "TRYB",
              address: "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
              price: 0.02837526,
            },
            {
              chainId: "1",
              name: "AllianceBlock Nexera",
              symbol: "NXRA",
              address: "0x644192291cc835A93d6330b24EA5f5FEdD0eEF9e",
              price: 0.02779917,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
              price: 0.02641525,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "TRVL",
              symbol: "TRVL",
              address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "GamerCoin",
              symbol: "GHX",
              address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
              price: 0.02555778,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Altered State Token",
              symbol: "ASTO",
              address: "0x823556202e86763853b40e9cde725f412e294689",
              price: 0.02506057,
            },
            {
              chainId: "1",
              name: "Wrapped Nine Chronicles",
              symbol: "WNCG",
              address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
              price: 0.0247011,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Stobox",
              symbol: "STBU",
              address: "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
              price: 0.02233193,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "ParaSwap",
              symbol: "PSP",
              address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
              price: 0.02181516,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Oobit",
              symbol: "OBT",
              address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
              price: 0.02010881,
            },
            {
              chainId: "1",
              name: "Chainsquare",
              symbol: "CHS",
              address: "0xb41380174d0b06181513a5677b60200b93b5efb4",
              price: 0.02001937,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "DecentraWeb",
              symbol: "DWEB",
              address: "0xe7f58a92476056627f9fdb92286778abd83b285f",
              price: 0.01957874,
            },
            {
              chainId: "1",
              name: "Chain Games",
              symbol: "CHAIN",
              address: "0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
              price: 0.01936457,
            },
            {
              chainId: "1",
              name: "Maxity",
              symbol: "MAX",
              address: "0x63f7B1b538a78cB699E5399621B3d2e047C40de4",
              price: 0.01785833,
            },
            {
              chainId: "1",
              name: "Media Industry Licensing Content",
              symbol: "MLT",
              address: "0x9506d37f70eB4C3d79C398d326C871aBBf10521d",
              price: 0.017328,
            },
            {
              chainId: "1",
              name: "Poolz",
              symbol: "POOLZ",
              address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
              price: 0.01719548,
            },
            {
              chainId: "1",
              name: "Bit2Me",
              symbol: "B2M",
              address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
              price: 0.01691978,
            },
            {
              chainId: "1",
              name: "NuNet",
              symbol: "NTX",
              address: "0xf0d33beda4d734c72684b5f9abbebf715d0a7935",
              price: 0.01690763,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Hillstone",
              symbol: "HSF",
              address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
              price: 0.01562664,
            },
            {
              chainId: "1",
              name: "Medal of Honour",
              symbol: "MOH",
              address: "0xa59e341e8047498700ed244814b01b34547fb21b",
              price: 0.01559381,
            },
            {
              chainId: "1",
              name: "NFT Worlds",
              symbol: "WRLD",
              address: "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9",
              price: 0.01521822,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "THORWallet",
              symbol: "TGT",
              address: "0x108a850856db3f85d0269a2693d896b394c80325",
              price: 0.01414117,
            },
            {
              chainId: "1",
              name: "Choise.com",
              symbol: "CHO",
              address: "0xBBa39Fd2935d5769116ce38d46a71bde9cf03099",
              price: 0.01408598,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "EDEN",
              symbol: "EDEN",
              address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
              price: 0.01375941,
            },
            {
              chainId: "1",
              name: "Bubblefong",
              symbol: "BBF",
              address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
              price: 0.01299892,
            },
            {
              chainId: "1",
              name: "Kapital DAO",
              symbol: "KAP",
              address: "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
              price: 0.01284343,
            },
            {
              chainId: "1",
              name: "RugBank Token",
              symbol: "✺RUG",
              address: "0xd2d8d78087d0e43bc4804b6f946674b2ee406b80",
              price: 0.012783809756506483,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Nexum",
              symbol: "NEXM",
              address: "0xe831f96a7a1dce1aa2eb760b1e296c6a74caa9d5",
              price: 0.01253069,
            },
            {
              chainId: "1",
              name: "Etherisc DIP Token",
              symbol: "DIP",
              address: "0xc719d010b63e5bbf2c0551872cd5316ed26acd83",
              price: 0.0124068,
            },
            {
              chainId: "1",
              name: "Avocado DAO",
              symbol: "AVG",
              address: "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
              price: 0.01205359,
            },
            {
              chainId: "1",
              name: "Covenant",
              symbol: "COVN",
              address: "0x19ac2659599fd01c853de846919544276ad26f50",
              price: 0.01204608,
            },
            {
              chainId: "1",
              name: "InsurAce",
              symbol: "INSUR",
              address: "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
              price: 0.01148638,
            },
            {
              chainId: "1",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "Evrynet",
              symbol: "EVRY",
              address: "0xd7dcd9b99787c619b4d57979521258d1a7267ad7",
              price: 0.01114784,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "Hop Protocol",
              symbol: "HOP",
              address: "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
              price: 0.01089238,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "Credefi ",
              symbol: "CREDI",
              address: "0xaE6e307c3Fe9E922E5674DBD7F830Ed49c014c6B",
              price: 0.01039157,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "Lunr",
              symbol: "LUNR",
              address: "0xA87135285Ae208e22068AcDBFf64B11Ec73EAa5A",
              price: 0.00990949,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "Gourmet Galaxy",
              symbol: "GUM",
              address: "0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24",
              price: 0.00917141,
            },
            {
              chainId: "1",
              name: "BlockWallet",
              symbol: "BLANK",
              address: "0x41a3dba3d677e573636ba691a70ff2d606c29666",
              price: 0.00889921,
            },
            {
              chainId: "1",
              name: "New Paradigm Assets Solution",
              symbol: "NPAS",
              address: "0xEBe807bFDf8b2092E36e964C75463A8Aaa642139",
              price: 0.00873042,
            },
            {
              chainId: "1",
              name: "O3 Swap",
              symbol: "O3",
              address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
              price: 0.00803362,
            },
            {
              chainId: "1",
              name: "AI Network",
              symbol: "AIN",
              address: "0x3a810ff7211b40c4fa76205a14efe161615d0385",
              price: 0.00774991,
            },
            {
              chainId: "1",
              name: "Antimatter",
              symbol: "MATTER",
              address: "0x9B99CcA871Be05119B2012fd4474731dd653FEBe",
              price: 0.00753904,
            },
            {
              chainId: "1",
              name: "ELYSIA",
              symbol: "EL",
              address: "0x2781246fe707bb15cee3e5ea354e2154a2877b16",
              price: 0.00717642,
            },
            {
              chainId: "1",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
              price: 0.00696,
            },
            {
              chainId: "1",
              name: "LOTT",
              symbol: "LOTT",
              address: "0xba93ef534094f8b7001ece2691168140965341ab",
              price: 0.00657432,
            },
            {
              chainId: "1",
              name: "DuckDaoDime",
              symbol: "DDIM",
              address: "0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20",
              price: 0.00649844,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "BBS Network",
              symbol: "BBS",
              address: "0xfe459828c90c0ba4bc8b42f5c5d44f316700b430",
              price: 0.00629815,
            },
            {
              chainId: "1",
              name: "Gearbox Protocol",
              symbol: "GEAR",
              address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
              price: 0.00627808,
            },
            {
              chainId: "1",
              name: "FANC",
              symbol: "FANC",
              address: "0xbB126042235E6bD38B17744cb31a8bF4A206c045",
              price: 0.00622569,
            },
            {
              chainId: "1",
              name: "Integral",
              symbol: "ITGR",
              address: "0xd502f487e1841fdc805130e13eae80c61186bc98",
              price: 0.00617147,
            },
            {
              chainId: "1",
              name: "Dejitaru Tsuka",
              symbol: "TSUKA",
              address: "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed",
              price: 0.00611169,
            },
            {
              chainId: "1",
              name: "Polkacity",
              symbol: "POLC",
              address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
              price: 0.00600761,
            },
            {
              chainId: "1",
              name: "Cirus",
              symbol: "CIRUS",
              address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
              price: 0.00585288,
            },
            {
              chainId: "1",
              name: "EnterDAO",
              symbol: "ENTR",
              address: "0xd779eea9936b4e323cddff2529eb6f13d0a4d66e",
              price: 0.00578618,
            },
            {
              chainId: "1",
              name: "Vodra",
              symbol: "VDR",
              address: "0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe",
              price: 0.00541767,
            },
            {
              chainId: "1",
              name: "PlotX",
              symbol: "PLOT",
              address: "0x72f020f8f3e8fd9382705723cd26380f8d0c66bb",
              price: 0.00529281,
            },
            {
              chainId: "1",
              name: "DoDreamChain",
              symbol: "DRM",
              address: "0x89551b940e2a8ed8eccf509935bac9213fe30584",
              price: 0.0052723,
            },
            {
              chainId: "1",
              name: "Rocki",
              symbol: "ROCKI",
              address: "0xff44b937788215eca197baaf9af69dbdc214aa04",
              price: 0.00521579,
            },
            {
              chainId: "1",
              name: "Deri Protocol",
              symbol: "DERI",
              address: "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
              price: 0.00517315,
            },
            {
              chainId: "1",
              name: "Alpaca City",
              symbol: "ALPA",
              address: "0x7ca4408137eb639570f8e647d9bd7b7e8717514a",
              price: 0.00509111,
            },
            {
              chainId: "1",
              name: "Swash",
              symbol: "SWASH",
              address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
              price: 0.00505555,
            },
            {
              chainId: "1",
              name: "Hourglass",
              symbol: "WAIT",
              address: "0x2559813bbb508c4c79e9ccce4703bcb1f149edd7",
              price: 0.00497387,
            },
            {
              chainId: "1",
              name: "Konomi Network",
              symbol: "KONO",
              address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
              price: 0.00472211,
            },
            {
              chainId: "1",
              name: "The HUSL",
              symbol: "HUSL",
              address: "0xa2881f7f441267042f9778ffa0d4f834693426be",
              price: 0.00459769,
            },
            {
              chainId: "1",
              name: "Got Guaranteed",
              symbol: "GOTG",
              address: "0xceeb07dd26b36287b6d109f0b06d7e8202ce8c1d",
              price: 0.00419452,
            },
            {
              chainId: "1",
              name: "X2Y2",
              symbol: "X2Y2",
              address: "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9",
              price: 0.0041817,
            },
            {
              chainId: "1",
              name: "CPUcoin",
              symbol: "CPU",
              address: "0x6d52dfefb16bb9cdc78bfca09061e44574886626",
              price: 0.00400134,
            },
            {
              chainId: "1",
              name: "Financie Token",
              symbol: "FNCT",
              address: "0x8af78f0c818302164f73b2365fe152c2d1fe80e1",
              price: 0.00388322,
            },
            {
              chainId: "1",
              name: "XI Protocol",
              symbol: "XI",
              address: "0x295B42684F90c77DA7ea46336001010F2791Ec8c",
              price: 0.0037862,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "1",
              name: "Hord",
              symbol: "HORD",
              address: "0x43a96962254855f16b925556f9e97be436a43448",
              price: 0.00371826,
            },
            {
              chainId: "1",
              name: "PolkaFantasy",
              symbol: "XP",
              address: "0x948c70dc6169bfb10028fdbe96cbc72e9562b2ac",
              price: 0.00370077,
            },
            {
              chainId: "1",
              name: "DotOracle",
              symbol: "DTO",
              address: "0xB57420FaD6731B004309D5a0ec7C6C906Adb8df7",
              price: 0.00363424,
            },
            {
              chainId: "1",
              name: "Furucombo",
              symbol: "COMBO",
              address: "0xfFffFffF2ba8F66D4e51811C5190992176930278",
              price: 0.00360684,
            },
            {
              chainId: "1",
              name: "STOA Network",
              symbol: "STA",
              address: "0x06874f973dc3c96dc22a10ef0d0609f877f335ea",
              price: 0.0035228,
            },
            {
              chainId: "1",
              name: "CropBytes",
              symbol: "CBX",
              address: "0x37fc4b48ce93469dbea9918468993c735049642a",
              price: 0.00318043,
            },
            {
              chainId: "1",
              name: "Blockchain Bets",
              symbol: "BCB",
              address: "0x2d886570a0da04885bfd6eb48ed8b8ff01a0eb7e",
              price: 0.00298175,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Art Gobblers Goo",
              symbol: "GOO",
              address: "0x600000000a36f3cd48407e35eb7c5c910dc1f7a8",
              price: 0.00222615,
            },
            {
              chainId: "1",
              name: "ETHA Lend",
              symbol: "ETHA",
              address: "0x59e9261255644c411afdd00bd89162d09d862e38",
              price: 0.00220437,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "HNB Protocol",
              symbol: "HNB",
              address: "0x6E0615a03eD9527a6013FcD5B556E36EF4DaB1FF",
              price: 0.00213527,
            },
            {
              chainId: "1",
              name: "ZigZag",
              symbol: "ZZ",
              address: "0xc91a71a1ffa3d8b22ba615ba1b9c01b2bbbf55ad",
              price: 0.00210589,
            },
            {
              chainId: "1",
              name: "BiFi",
              symbol: "BIFI",
              address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
              price: 0.00209525,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "HYPERCOMIC",
              symbol: "HYCO",
              address: "0x77F76483399Dc6328456105B1db23e2Aca455bf9",
              price: 0.00187065,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "VEMP",
              symbol: "VEMP",
              address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
              price: 0.00171918,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "Arowana Token",
              symbol: "ARW",
              address: "0x351caa9045d65107b9d311d922d15887cfd634e4",
              price: 0.00162324,
            },
            {
              chainId: "1",
              name: "Ojamu",
              symbol: "OJA",
              address: "0x0aa7efe4945db24d95ca6e117bba65ed326e291a",
              price: 0.00159873,
            },
            {
              chainId: "1",
              name: "Project TXA",
              symbol: "TXA",
              address: "0x4463e6A3dEd0dBE3F6e15bC8420dFc55e5FeA830",
              price: 0.00158853,
            },
            {
              chainId: "1",
              name: "DOTMOOVS",
              symbol: "MOOV",
              address: "0x24ec2ca132abf8f6f8a6e24a1b97943e31f256a7",
              price: 0.00153091,
            },
            {
              chainId: "1",
              name: "Super Athletes Token",
              symbol: "SAT",
              address: "0x5ABf88cF3444611D13F6D1B39F3f3EE8575c91a2",
              price: 0.00151163,
            },
            {
              chainId: "1",
              name: "AllPay Coin",
              symbol: "APCG",
              address: "0x434Cb4fC4b952872967914D430878Eee53Ebd502",
              price: 0.00150962,
            },
            {
              chainId: "1",
              name: "Razor Network",
              symbol: "RAZOR",
              address: "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
              price: 0.00149896,
            },
            {
              chainId: "1",
              name: "Deeper Network",
              symbol: "DPR",
              address: "0xf3ae5d769e153ef72b4e3591ac004e89f48107a1",
              price: 0.00139342,
            },
            {
              chainId: "1",
              name: "Fayre",
              symbol: "FAYRE",
              address: "0xAb4C44973BEFba9294F47e21E6BEB79A3C1D7d9F",
              price: 0.00138946,
            },
            {
              chainId: "56",
              name: "MN Bridge",
              symbol: "MNG",
              address: "0x13dfe44c7b461222e10597e517e4485ff4766582",
              price: 0.00135082,
            },
            {
              chainId: "1",
              name: "AME Chain",
              symbol: "AME",
              address: "0x12513335ffD5DAfc2334e98625d27c1CA84bff86",
              price: 0.00131956,
            },
            {
              chainId: "1",
              name: "DeFiato",
              symbol: "DFIAT",
              address: "0x1045F5cCb01DAEA4f8eaB055F5FcBB7C0E7c89F0",
              price: 0.00128607,
            },
            {
              chainId: "1",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
              price: 0.00119494,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Throne",
              symbol: "THN",
              address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
              price: 0.00113916,
            },
            {
              chainId: "1",
              name: "DMM: Governance",
              symbol: "DMG",
              address: "0xEd91879919B71bB6905f23af0A68d231EcF87b14",
              price: 0.00113509,
            },
            {
              chainId: "1",
              name: "Sukhavati Network",
              symbol: "SKT",
              address: "0x012e0e6342308b247f36ee500ecb14dc77a7a8c1",
              price: 0.00111187,
            },
            {
              chainId: "1",
              name: "BlockchainSpace",
              symbol: "GUILD",
              address: "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
              price: 0.00109601,
            },
            {
              chainId: "1",
              name: "Tower",
              symbol: "TOWER",
              address: "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
              price: 0.00109538,
            },
            {
              chainId: "1",
              name: "Artizen",
              symbol: "ATNT",
              address: "0xAA2d8c9a8bd0F7945143bfD509bE3ff23dd78918",
              price: 0.00108477,
            },
            {
              chainId: "1",
              name: "Astra Protocol",
              symbol: "ASTRA",
              address: "0x201332Bd45c8628D814F870bFb584B385A7C351e",
              price: 0.00107095,
            },
            {
              chainId: "1",
              name: "DEVITA",
              symbol: "LIFE",
              address: "0x8640353CDc9778DEaB0dF45D12FB3013dEAC079C",
              price: 0.00106792,
            },
            {
              chainId: "1",
              name: "Qlindo",
              symbol: "QLINDO",
              address: "0xc18c07a18198a6340cf4d94855fe5eb6dd33b46e",
              price: 0.00086279,
            },
            {
              chainId: "1",
              name: "BeyondFi",
              symbol: "BYN",
              address: "0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca",
              price: 0.0008541,
            },
            {
              chainId: "1",
              name: "FreeRossDAO",
              symbol: "FREE",
              address: "0x4cd0c43b0d53bc318cc5342b77eb6f124e47f526",
              price: 0.00082232,
            },
            {
              chainId: "1",
              name: "Erugo World Coin",
              symbol: "EWC",
              address: "0xcd74cf66c43e45abd5703f3642f73d0675d6aff7",
              price: 0.00079585,
            },
            {
              chainId: "1",
              name: "Olea Token",
              symbol: "OLEA",
              address: "0xc6cc3d07c705e39d11c7f60d8836c7c78d4ac5f1",
              price: 0.00079006,
            },
            {
              chainId: "1",
              name: "Betswap.gg",
              symbol: "BSGG",
              address: "0x69570f3e84f51ea70b7b68055c8d667e77735a25",
              price: 0.0007367,
            },
            {
              chainId: "1",
              name: "NvirWorld",
              symbol: "NVIR",
              address: "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
              price: 0.00067707,
            },
            {
              chainId: "1",
              name: "EYES Protocol",
              symbol: "EYES",
              address: "0xe42B7A17336B343569C82f682a493a837B7e0755",
              price: 0.00060086,
            },
            {
              chainId: "1",
              name: "Creaticles",
              symbol: "CRE8",
              address: "0xc36b4311b21fc0c2ead46f1ea6ce97c9c4d98d3d",
              price: 0.00059873,
            },
            {
              chainId: "1",
              name: "Yieldification",
              symbol: "YDF",
              address: "0x30dcba0405004cf124045793e1933c798af9e66a",
              price: 0.00058824,
            },
            {
              chainId: "1",
              name: "Fodl Finance",
              symbol: "FODL",
              address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
              price: 0.00056514,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "DOSE",
              symbol: "DOSE",
              address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "MoonDAO",
              symbol: "MOONEY",
              address: "0x20d4DB1946859E2Adb0e5ACC2eac58047aD41395",
              price: 0.0005079,
            },
            {
              chainId: "1",
              name: "Neighbourhoods",
              symbol: "NHT",
              address: "0x84342e932797FC62814189f01F0Fb05F52519708",
              price: 0.00048342,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Ares Protocol",
              symbol: "ARES",
              address: "0x358AA737e033F34df7c54306960a38d09AaBd523",
              price: 0.00043409,
            },
            {
              chainId: "1",
              name: "Spellfire",
              symbol: "SPELLFIRE",
              address: "0x3A0b022f32b3191D44E5847da12dc0B63fb07C91",
              price: 0.00043085,
            },
            {
              chainId: "1",
              name: "POPKON",
              symbol: "POPK",
              address: "0xaC12e8f6b0C17d7B736A800920b336d764b59973",
              price: 0.00040965,
            },
            {
              chainId: "1",
              name: "BendDAO",
              symbol: "BEND",
              address: "0x0d02755a5700414b26ff040e1de35d337df56218",
              price: 0.00040832,
            },
            {
              chainId: "1",
              name: "EnterButton",
              symbol: "ENTC",
              address: "0x3ecab35b64345bfc472477a653e4a3abe70532d9",
              price: 0.00040056,
            },
            {
              chainId: "1",
              name: "MARS4",
              symbol: "MARS4",
              address: "0x16cda4028e9e872a38acb903176719299beaed87",
              price: 0.00038566,
            },
            {
              chainId: "1",
              name: "Game.com",
              symbol: "GTC",
              address: "0xB70835D7822eBB9426B56543E391846C107bd32C",
              price: 0.00038213,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "ARMOR",
              symbol: "ARMOR",
              address: "0x1337def16f9b486faed0293eb623dc8395dfe46a",
              price: 0.00036815,
            },
            {
              chainId: "1",
              name: "BambooDeFi",
              symbol: "BAMBOO",
              address: "0xf56842Af3B56Fd72d17cB103f92d027bBa912e89",
              price: 0.00033189,
            },
            {
              chainId: "1",
              name: "Play It Forward DAO",
              symbol: "PIF",
              address: "0xb30f5d11b94efbbfdeaa4de38edffceec0be6513",
              price: 0.00031324,
            },
            {
              chainId: "1",
              name: "Franklin",
              symbol: "FLY",
              address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Enjinstarter",
              symbol: "EJS",
              address: "0x96610186F3ab8d73EBEe1CF950C750f3B1Fb79C2",
              price: 0.00027744,
            },
            {
              chainId: "1",
              name: "Niftify",
              symbol: "NIFT",
              address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
              price: 0.00027324,
            },
            {
              chainId: "1",
              name: "2crazyNFT",
              symbol: "2CRZ",
              address: "0x2c9c19ce3b15ae77c6d80aec3c1194cfd6f7f3fa",
              price: 0.00027164,
            },
            {
              chainId: "1",
              name: "Handy",
              symbol: "HANDY",
              address: "0x8bbe1a2961B41340468D0548c2cd5B7DFA9b684c",
              price: 0.00026091,
            },
            {
              chainId: "1",
              name: "Dogechain",
              symbol: "DC",
              address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
              price: 0.00025429,
            },
            {
              chainId: "1",
              name: "NFTY Network",
              symbol: "NFTY",
              address: "0xE1D7C7a4596B038CEd2A84bF65B8647271C53208",
              price: 0.00024635,
            },
            {
              chainId: "1",
              name: "Beyond Protocol",
              symbol: "BP",
              address: "0xdF290B162a7D3E0A328cF198308D421954f08b94",
              price: 0.0002357,
            },
            {
              chainId: "1",
              name: "Pando",
              symbol: "PANDO",
              address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
              price: 0.00021312,
            },
            {
              chainId: "1",
              name: "Cardiocoin",
              symbol: "CRDC",
              address: "0xF81421fc15300c5a8CCa9aFE12F5CBAd502Fa756",
              price: 0.0002024,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "TokenBot",
              symbol: "TKB",
              address: "0x16594930D16f3970e1a4317c6016555cb2e7b7Fc",
              price: 0.00019114,
            },
            {
              chainId: "1",
              name: "LandWorld",
              symbol: "LWD",
              address: "0x786e995A975C2ab7C1dd252A9019fB0c91c9Ca83",
              price: 0.00018524,
            },
            {
              chainId: "1",
              name: "WoofWork.io",
              symbol: "WOOF",
              address: "0x6BC08509B36A98E829dFfAD49Fde5e412645d0a3",
              price: 0.00017883,
            },
            {
              chainId: "1",
              name: "Pawtocol",
              symbol: "UPI",
              address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
              price: 0.00016276,
            },
            {
              chainId: "1",
              name: "Unbound Finance",
              symbol: "UNB",
              address: "0x8db253a1943dddf1af9bcf8706ac9a0ce939d922",
              price: 0.00015672,
            },
            {
              chainId: "1",
              name: "SoonSwap",
              symbol: "SOON",
              address: "0x574D22E2555cAc0ce71e44778f6De2e7487aE229",
              price: 0.00015237,
            },
            {
              chainId: "1",
              name: "CoverCompared",
              symbol: "CVR",
              address: "0x3c03b4ec9477809072ff9cc9292c9b25d4a8e6c6",
              price: 0.00014248,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Dreamverse",
              symbol: "DV",
              address: "0x2a03a891add2dc6d0f7b94419086630ba5cb65b6",
              price: 0.00013514,
            },
            {
              chainId: "1",
              name: "CyberVein",
              symbol: "CVT",
              address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
              price: 0.00013269,
            },
            {
              chainId: "1",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xd373576a9e738F37Dc6882328358Ff69c4cAf4c6",
              price: 0.00013236,
            },
            {
              chainId: "1",
              name: "Aurora Chain",
              symbol: "AOA",
              address: "0x9ab165d795019b6d8b3e971dda91071421305e5a",
              price: 0.00012375,
            },
            {
              chainId: "1",
              name: "AssangeDAO",
              symbol: "JUSTICE",
              address: "0x59d1e836F7b7210A978b25a855085cc46fd090B5",
              price: 0.00012251,
            },
            {
              chainId: "1",
              name: "Cell Network",
              symbol: "ECELL",
              address: "0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f",
              price: 0.00011999,
            },
            {
              chainId: "1",
              name: "Versailles Heroes",
              symbol: "VRH",
              address: "0xead482da0793b00bbae0e34c8cfae6daf29a44b2",
              price: 0.00011931,
            },
            {
              chainId: "1",
              name: "Blocksport",
              symbol: "BSPT",
              address: "0xa350da05405cc204e551c4eed19c3039646528d5",
              price: 0.00011649,
            },
            {
              chainId: "1",
              name: "Aster Coin",
              symbol: "ATC",
              address: "0x0eb3032bcac2be1fa95e296442f225edb80fc3cd",
              price: 0.00011286,
            },
            {
              chainId: "1",
              name: "Woozoo Music",
              symbol: "WZM",
              address: "0xd15a1a2a3211b58113e45809f05934252e34e2f8",
              price: 0.00010069,
            },
            {
              chainId: "1",
              name: "Open Proprietary Protocol",
              symbol: "OPP",
              address: "0xf51ccB15d3F2D304Ae6C409303e8b3a3e397A80b",
              price: 0.00009986,
            },
            {
              chainId: "1",
              name: "Tokenplace",
              symbol: "TOK",
              address: "0x4fb721ef3bf99e0f2c193847afa296b9257d3c30",
              price: 0.00009882,
            },
            {
              chainId: "1",
              name: "DexGame",
              symbol: "DXGM",
              address: "0x66f73d0fd4161cfad4302dc145ff994375c13475",
              price: 0.00009273,
            },
            {
              chainId: "1",
              name: "ANIVERSE",
              symbol: "ANV",
              address: "0x3D382228C54736d831FAC2748F4734D9177c7332",
              price: 0.00008965,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "MOVE Network",
              symbol: "MOVD",
              address: "0x12300ed54f65648524c1bfaf86712927da6cc6fc",
              price: 0.00007517,
            },
            {
              chainId: "1",
              name: "HistoryDAO",
              symbol: "HAO",
              address: "0x3c4008eca800ec1283e4cf500e68d06bfabc00a8",
              price: 0.00007464,
            },
            {
              chainId: "1",
              name: "AFRO MOON DOG",
              symbol: "AMD",
              address: "0xDEF575Aea01bFC170d1839b7Ebd2E5B8eA58c13e",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Akt.io",
              symbol: "AKTIO",
              address: "0xe65d37F18A770643CB14c8611ACa7A67244BA480",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "ARTII",
              symbol: "ARTII",
              address: "0x07a858fc699f99ddf2b186bf162fd7f4d42f7f63",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Bandot Protocol",
              symbol: "BDT",
              address: "0x216e9D8A521d93EC769635859c57938119fE5369",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "BRICKKEN",
              symbol: "BKN",
              address: "0x0a638f07acc6969abf392bb009f216d22adea36d",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "CoinGhost",
              symbol: "COGO",
              address: "0x5F2b130BA4486B2bE05B646B5BCb9A01E4ff51E3",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "GoldenBlock",
              symbol: "GBC",
              address: "0xB7447364eF42CfF09425a0FEaE703EE0b72647f9",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "IMMOPET",
              symbol: "IMPT",
              address: "0x73Da6c5f616EB9d8A3B3a4bb920365eDEf8AF4E4",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "InoFi",
              symbol: "FON",
              address: "0xa4be4cDC552891a6702E1aE9645EF445179a4463",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Lucky Block V2",
              symbol: "LBLOCK",
              address: "0x2b867efD2dE4Ad2B583Ca0CB3dF9C4040Ef4D329",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "NFT Track Protocol",
              symbol: "NTP",
              address: "0x1aF4F195A8AAa7FFd752C28A13B719b84056f0d6",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Ondo Finance",
              symbol: "ONDO",
              address: "0xfAbA6f8e4a5E8Ab82F62fe7C39859FA577269BE3",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Rubic (old)",
              symbol: "RBC",
              address: "0xa4eed63db85311e22df4473f87ccfc3dadcfa3e3",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Suzuverse",
              symbol: "SGT",
              address: "0x5b649C07E7Ba0a1C529DEAabEd0b47699919B4a2",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
              price: 0.00006441,
            },
            {
              chainId: "1",
              name: "Convergence Finance",
              symbol: "CONV",
              address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
              price: 0.00006394,
            },
            {
              chainId: "1",
              name: "Tidal Finance",
              symbol: "TIDAL",
              address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
              price: 0.00004985,
            },
            {
              chainId: "1",
              name: "Gera Coin",
              symbol: "GERA",
              address: "0x80d4F13AcC30968fD6225b1Ea79f5779f09FEE60",
              price: 0.00004776,
            },
            {
              chainId: "1",
              name: "NuriFootBall",
              symbol: "NRFB",
              address: "0x00281dfce4cfd72c0b6fda2aaaf077258743f9e8",
              price: 0.00003648,
            },
            {
              chainId: "1",
              name: "MetaVisa",
              symbol: "MESA",
              address: "0x5afff9876c1f98b7d2b53bcb69eb57e92408319f",
              price: 0.00003347,
            },
            {
              chainId: "1",
              name: "Finance Blocks",
              symbol: "FBX",
              address: "0x60bb16c4a931b1a0b8a7d945c651dd90f41d42cf",
              price: 0.00003081,
            },
            {
              chainId: "1",
              name: "Vader Protocol",
              symbol: "VADER",
              address: "0x2602278ee1882889b946eb11dc0e810075650983",
              price: 0.00003072,
            },
            {
              chainId: "1",
              name: "Golden Goal",
              symbol: "GDG",
              address: "0xFD020998A1bB316dfE7B136Fe59Ae4B365D79978",
              price: 0.00002975,
            },
            {
              chainId: "1",
              name: "Metababy",
              symbol: "BABY",
              address: "0x1cCF27211e8bf052f6255329ed641B4E94E80603",
              price: 0.00002874,
            },
            {
              chainId: "1",
              name: "MurAll",
              symbol: "PAINT",
              address: "0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042",
              price: 0.00002857,
            },
            {
              chainId: "1",
              name: "Ceji",
              symbol: "CEJI",
              address: "0x189fC141854BFc6146777406d53fbC89F4e70407",
              price: 0.00002732,
            },
            {
              chainId: "1",
              name: "Time New Bank",
              symbol: "TNB",
              address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
              price: 0.00002548,
            },
            {
              chainId: "1",
              name: "SpiderDAO",
              symbol: "SPDR",
              address: "0xbcd4b7de6fde81025f74426d43165a5b0d790fdd",
              price: 0.00002524,
            },
            {
              chainId: "1",
              name: "WATTTON",
              symbol: "WATT",
              address: "0xE67F943af5Eb6051ef56f05979cc30B732717fa6",
              price: 0.00002385,
            },
            {
              chainId: "1",
              name: "Dapp.com",
              symbol: "DAPPT",
              address: "0x96184d9c811ea0624fc30c80233b1d749b9e485b",
              price: 0.00002315,
            },
            {
              chainId: "1",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "TomTomCoin",
              symbol: "TOMS",
              address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
              price: 0.00001099,
            },
            {
              chainId: "1",
              name: "NPICK BLOCK",
              symbol: "NPICK",
              address: "0xc3dca8f61b275d1e88f3ea31b3e311c49f56b24b",
              price: 0.00001096,
            },
            {
              chainId: "1",
              name: "TrueFeedBack",
              symbol: "TFBX",
              address: "0x4057db5bd9f67a566aa10e5587b1a964affc6a16",
              price: 0.00001061,
            },
            {
              chainId: "1",
              name: "Centaurify",
              symbol: "CENT",
              address: "0x08ba718f288c3b12b01146816bef9fa03cc635bc",
              price: 0.00001,
            },
            {
              chainId: "1",
              name: "The Midas Touch Gold",
              symbol: "TMTG",
              address: "0x10086399DD8c1e3De736724AF52587a2044c9fA2",
              price: 0.00000999,
            },
            {
              chainId: "1",
              name: "MiraQle",
              symbol: "MQL",
              address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
              price: 0.0000093,
            },
            {
              chainId: "1",
              name: "XMax",
              symbol: "XMX",
              address: "0x0f8c45b896784a1e408526b9300519ef8660209c",
              price: 0.00000823,
            },
            {
              chainId: "1",
              name: "SRT",
              symbol: "SRT",
              address: "0x22987407FD1fC5A971e3FDA3B3e74C88666cDa91",
              price: 0.00000766,
            },
            {
              chainId: "1",
              name: "Jigstack",
              symbol: "STAK",
              address: "0x1f8a626883d7724dbd59ef51cbd4bf1cf2016d13",
              price: 0.00000761,
            },
            {
              chainId: "1",
              name: "AiWork ",
              symbol: "AWO",
              address: "0x68c85b9f78f30a0df5ac5723e4e700037f185415",
              price: 0.00000491,
            },
            {
              chainId: "1",
              name: "Hasaki",
              symbol: "HAHA",
              address: "0xd87D72248093597df8D56d2a53C1ab7c1A0Cc8DA",
              price: 0.00000475,
            },
            {
              chainId: "1",
              name: "Global Digital Content",
              symbol: "GDC",
              address: "0x301C755bA0fcA00B1923768Fffb3Df7f4E63aF31",
              price: 0.00000445,
            },
            {
              chainId: "1",
              name: "POP Network",
              symbol: "POP",
              address: "0x5d858bcd53e085920620549214a8b27ce2f04670",
              price: 0.00000429,
            },
            {
              chainId: "1",
              name: "Soulsaver",
              symbol: "SOUL",
              address: "0x992D339532A9C42F1b0E59A57e95F38da38c66F6",
              price: 0.00000239,
            },
            {
              chainId: "1",
              name: "FourCoin",
              symbol: "FOUR",
              address: "0x244b797d622d4dee8b188b03546acaabd0cf91a0",
              price: 0.00000207,
            },
            {
              chainId: "1",
              name: "Red Token",
              symbol: "RED",
              address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
              price: 0.00000179,
            },
            {
              chainId: "1",
              name: "Moon Rabbit",
              symbol: "AAA",
              address: "0x8c6bf16c273636523c29db7db04396143770f6a0",
              price: 0.0000015,
            },
            {
              chainId: "1",
              name: "MixTrust",
              symbol: "MXT",
              address: "0x6251e725cd45fb1af99354035a414a2c0890b929",
              price: 0.00000107,
            },
            {
              chainId: "1",
              name: "Incube Chain",
              symbol: "ICB",
              address: "0x00166a5b93FD4f87ecA1c267d31D82dF3f133a7F",
              price: 0.00000103,
            },
            {
              chainId: "1",
              name: "The Youth Pay",
              symbol: "TYP",
              address: "0xb46eda6219ba121cE9280388e7afb7dc84be3fF2",
              price: 8.10131e-7,
            },
            {
              chainId: "1",
              name: "StarLink",
              symbol: "STARL",
              address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
              price: 7.98843e-7,
            },
            {
              chainId: "1",
              name: "PREMA",
              symbol: "PRMX",
              address: "0xe4dae00bc1c46ea2F44ae71B1BEb8b171C15d812",
              price: 6.08679e-7,
            },
            {
              chainId: "1",
              name: "Metanept",
              symbol: "NEPT",
              address: "0x355a824bea1adc22733978a3748271e1bbb34130",
              price: 4.49685e-7,
            },
            {
              chainId: "1",
              name: "Clips",
              symbol: "CLIPS",
              address: "0xecbee2fae67709f718426ddc3bf770b26b95ed20",
              price: 3.73805e-7,
            },
            {
              chainId: "1",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
              price: 2.36911e-7,
            },
            {
              chainId: "1",
              name: "P Pizza",
              symbol: "PPIZZA",
              address: "0xab306326bC72c2335Bd08F42cbec383691eF8446",
              price: 1.35035e-7,
            },
            {
              chainId: "1",
              name: "Akita Inu",
              symbol: "AKITA",
              address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
              price: 8.8739e-8,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "A Hunters Dream",
              symbol: "CAW",
              address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
              price: 4.5523e-8,
            },
            {
              chainId: "1",
              name: "Meta MVRS",
              symbol: "MVRS",
              address: "0xBEDE1F59Fa4412556fEF69f1B9969F2003E3f8c1",
              price: 2.2978e-8,
            },
            {
              chainId: "1",
              name: "Pawswap",
              symbol: "PAW",
              address: "0xdc63269ea166b70d4780b3a11f5c825c2b761b01",
              price: 1.0468e-8,
            },
            {
              chainId: "1",
              name: "POOH",
              symbol: "POOH",
              address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
              price: 1.0227e-8,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "1",
              name: "WALL STREET BABY",
              symbol: "WSB",
              address: "0x15F20f9DFDf96CCf6AC96653b7C0aBfe4A9C9f0f",
              price: 6.511e-9,
            },
            {
              chainId: "1",
              name: "GroupDao",
              symbol: "GDO",
              address: "0x16f78145ad0b9af58747e9a97ebd99175378bd3d",
              price: 3.72e-9,
            },
            {
              chainId: "1",
              name: "RushCoin",
              symbol: "RUSH",
              address: "0x382A1667C9062F0621362F49076Ef6e4fE4C9eC7",
              price: 3.602e-9,
            },
            {
              chainId: "1",
              name: "I will poop it NFT",
              symbol: "SHIT",
              address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
              price: 1.538e-9,
            },
            {
              chainId: "1",
              name: "Homer",
              symbol: "SIMPSON",
              address: "0x44aAd22aFbB2606d7828Ca1f8f9E5af00e779AE1",
              price: 1.68e-12,
            },
            {
              chainId: "1",
              name: "CardWallet",
              symbol: "CW",
              address: "0xd55236d48606c295adebf129dad04fc74bfaa708",
              price: 0,
            },
            {
              chainId: "1",
              name: "Maps.me Token",
              symbol: "MAPS",
              address: "0x2b915b505c017abb1547aa5ab355fbe69865cc6d",
              price: 0,
            },
          ],
        },
        chainIds: [1, 42161, 56],
        cexLabels: [],
        tags: [
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-14T08:34:25.304Z",
          type: "contractImport",
        },
      },
      {
        _id: "666bfe8b85672a7368da7809",
        uid: "666bfe8b85672a7368da7809",
        userIds: ["666bfe8b85672a7368da7809"],
        wallets: [
          {
            status: "verified",
            walletId: "683749437a939d1fbcfd324c",
            ecosystem: "evm",
            walletAddress: "0x46f80018211D5cBBc988e853A8683501FCA4ee9b",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 74,
        walletTotalValue: 474358738.14754295,
        walletAge: "2y9m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "Fenerbahçe Token",
              symbol: "FB",
              address: "0xfb19075d77a0f111796fb259819830f4780f1429",
              price: 0.426695,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "Geojam",
              symbol: "JAM",
              address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
              price: 0.00040671,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
          ],
        },
        chainIds: [1, 42161],
        cexLabels: [],
        tags: [
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:37.480Z",
          type: "csvImport",
        },
      },
      {
        _id: "666bfc4d85672a7368da193e",
        uid: "666bfc4d85672a7368da193e",
        userIds: ["666bfc4d85672a7368da193e"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce8848d",
            ecosystem: "evm",
            walletAddress: "0xDFd5293D8e347dFe59E90eFd55b2956a1343963d",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 285,
        walletTotalValue: 434321108.0380994,
        walletAge: "4y0m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "137",
              name: "WETH",
              symbol: "WETH",
              address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Wrapped Beacon ETH",
              symbol: "WBETH",
              address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
              price: 1918.25,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "56",
              name: "WETH",
              symbol: "WETH",
              address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
              price: 1795.73,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Strike",
              symbol: "STRK",
              address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
              price: 12.59,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Neo Tokyo",
              symbol: "BYTES",
              address: "0x7d647b1A0dcD5525e9C6B3D14BE58f27674f8c95",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Binance Wrapped DOT",
              symbol: "BDOT",
              address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
              price: 4.29,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Mettalex",
              symbol: "MTLX",
              address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
              price: 2.11,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "137",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 1.44,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "137",
              name: "Dai",
              symbol: "DAI",
              address: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
              price: 0.999647,
            },
            {
              chainId: "56",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
              price: 0.997802,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Travala",
              symbol: "AVA",
              address: "0x442b153f6f61c0c99a33aa4170dcb31e1abda1d0",
              price: 0.871989,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "56",
              name: "SafePal",
              symbol: "SFP",
              address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
              price: 0.64872,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Magic",
              symbol: "MAGIC",
              address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
              price: 0.361285,
            },
            {
              chainId: "1",
              name: "COMBO (Cocos-BCX)",
              symbol: "COMBO",
              address: "0xc4c7ea4fab34bd9fb9a5e1b1a98df76e26e6407c",
              price: 0.359251,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "56",
              name: "Scallop",
              symbol: "SCLP",
              address: "0xF2c96E402c9199682d5dED26D3771c6B192c01af",
              price: 0.266022,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Cortex",
              symbol: "CTXC",
              address: "0xea11755ae41d889ceec39a63e6ff75a02bc1c00d",
              price: 0.210565,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "Keep network",
              symbol: "KEEP",
              address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
              price: 0.126376,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "Unification",
              symbol: "FUND",
              address: "0xbe6ac6b50f577205c9d107f37b6e205aa6acc5d4",
              price: 0.03419847,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
              price: 0.0245393,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Voyager Token",
              symbol: "VGX",
              address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
              price: 0.01113651,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "OnX Finance",
              symbol: "ONX",
              address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
              price: 0.00951438,
            },
            {
              chainId: "1",
              name: "EasyFi ",
              symbol: "EZ",
              address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
              price: 0.00815894,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "GYEN",
              symbol: "GYEN",
              address: "0xc08512927d12348f6620a698105e1baac6ecd911",
              price: 0.00638966,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Bread",
              symbol: "BRD",
              address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
              price: 0.00579243,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "StormX",
              symbol: "STMX",
              address: "0xbE9375C6a420D2eEB258962efB95551A5b722803",
              price: 0.00535924,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "Solve",
              symbol: "SOLVE",
              address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
              price: 0.00402632,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Loom Network [OLD]",
              symbol: "LOOM",
              address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
              price: 0.00370114,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "DREP",
              symbol: "DREP",
              address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
              price: 0.00339307,
            },
            {
              chainId: "1",
              name: "pNetwork",
              symbol: "PNT",
              address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
              price: 0.0033276,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Wabi",
              symbol: "WABI",
              address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
              price: 0.00109904,
            },
            {
              chainId: "1",
              name: "Agrello",
              symbol: "DLT",
              address: "0x07e3c70653548B04f0A75970C1F81B4CBbFB606f",
              price: 0.00097389,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "137",
              name: "NFT Champions",
              symbol: "CHAMP",
              address: "0x8f9e8e833a69aa467e42c46cca640da84dd4585f",
              price: 0.00092716,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0xeca82185adce47f39c684352b0439f030f860318",
              price: 0.00047299,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Substratum",
              symbol: "SUB",
              address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
              price: 0.00034775,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "Mithril",
              symbol: "MITH",
              address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
              price: 0.00017659,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Life Crypto",
              symbol: "LIFE",
              address: "0x6c936D4AE98E6d2172dB18c16C4b601C99918EE6",
              price: 0.00007288,
            },
            {
              chainId: "1",
              name: "Etherparty",
              symbol: "FUEL",
              address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
              price: 0.0000579,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "Vabble",
              symbol: "VAB",
              address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
              price: 0.00003008,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "56",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
              price: 0.00001275,
            },
            {
              chainId: "1",
              name: "VIBE",
              symbol: "VIBE",
              address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
              price: 0.00000115,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
            {
              chainId: "1",
              name: "Ben",
              symbol: "BEN",
              address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
              price: 1.157e-9,
            },
            {
              chainId: "1",
              name: "CanYaCoin",
              symbol: "CAN",
              address: "0x1d462414fe14cf489c7a21cac78509f4bf8cd7c0",
              price: 0,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 56],
        cexLabels: ["Binance"],
        tags: [
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-17T11:28:54.078Z",
          type: "contractImport",
        },
      },
      {
        _id: "6644a966ef14d0fbb5aad975",
        uid: "6644a966ef14d0fbb5aad975",
        userIds: ["6644a966ef14d0fbb5aad975"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce88ab7",
            ecosystem: "evm",
            walletAddress: "0x0D0707963952f2fBA59dD06f2b425ace40b492Fe",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 1758,
        walletTotalValue: 342221874.90040725,
        walletAge: "7y1m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "tBTC",
              symbol: "TBTC",
              address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
              price: 102691,
            },
            {
              chainId: "4200",
              name: "Wrapped BTC",
              symbol: "WBTC",
              address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
              price: 96087,
            },
            {
              chainId: "4200",
              name: "BTC",
              symbol: "BTC",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 96079,
            },
            {
              chainId: "56",
              name: "Bitcoin BEP2",
              symbol: "BTCB",
              address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
              price: 81551,
            },
            {
              chainId: "137",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "42161",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Huobi BTC",
              symbol: "HBTC",
              address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
              price: 11110.54,
            },
            {
              chainId: "56",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e",
              price: 7650.19,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "534352",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 3640.73,
            },
            {
              chainId: "56",
              name: "Binance Beacon ETH",
              symbol: "BETH",
              address: "0x250632378e573c6be1ac2f97fcdf00515d0aa91b",
              price: 3451.63,
            },
            {
              chainId: "1",
              name: "cVault.finance",
              symbol: "CORE",
              address: "0x62359ed7505efc61ff1d56fef82158ccaffa23d7",
              price: 3449.69,
            },
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "swETH",
              symbol: "SWETH",
              address: "0xf951E335afb289353dc249e82926178EaC7DEd78",
              price: 2640.41,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "10",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "81457",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "5000",
              name: "wETH",
              symbol: "wETH",
              address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111",
              price: 2575,
            },
            {
              chainId: "137",
              name: "WETH",
              symbol: "WETH",
              address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Wrapped Beacon ETH",
              symbol: "WBETH",
              address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
              price: 1918.25,
            },
            {
              chainId: "1",
              name: "weETH",
              symbol: "weETH",
              address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
              price: 1915.54,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "10",
              name: "WETH",
              symbol: "weth",
              address: "0x4200000000000000000000000000000000000006",
              price: 1795.73,
            },
            {
              chainId: "56",
              name: "WETH",
              symbol: "WETH",
              address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
              price: 1795.73,
            },
            {
              chainId: "42161",
              name: "WETH",
              symbol: "WETH",
              address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
              price: 1795.73,
            },
            {
              chainId: "1",
              name: "ether.fi Staked ETH",
              symbol: "eETH",
              address: "0x35fA164735182de50811E8e2E824cFb9B6118ac2",
              price: 1793.73,
            },
            {
              chainId: "1",
              name: "DIGG",
              symbol: "DIGG",
              address: "0x798D1bE841a82a273720CE31c822C61a67a601C3",
              price: 686.86,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "204",
              name: "OpBNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 652.1,
            },
            {
              chainId: "1",
              name: "Wrapped BNB",
              symbol: "WBNB",
              address: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
              price: 627.38,
            },
            {
              chainId: "56",
              name: "Wrapped BNB",
              symbol: "WBNB",
              address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
              price: 599.66,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "42161",
              name: "Camelot Token",
              symbol: "GRAIL",
              address: "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8",
              price: 519.69,
            },
            {
              chainId: "1",
              name: "XMON",
              symbol: "XMON",
              address: "0x3aaDA3e213aBf8529606924d8D1c55CbDc70Bf74",
              price: 495.69,
            },
            {
              chainId: "56",
              name: "Bitcoin Cash",
              symbol: "BCH",
              address: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
              price: 333.26,
            },
            {
              chainId: "56",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0x7f70642d88cf1c4a3a7abb072b53b929b653eda5",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "56",
              name: "Beefy.Finance",
              symbol: "BIFI",
              address: "0xca3f508b8e4dd382ee878a314789373d80a5190a",
              price: 302.62,
            },
            {
              chainId: "56",
              name: "UniCrypt",
              symbol: "UNCX",
              address: "0x09a6c44c3947b69e2b45f4d51b67e6a39acfb506",
              price: 273.04,
            },
            {
              chainId: "1",
              name: "UniCrypt",
              symbol: "UNCX",
              address: "0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
              price: 273.04,
            },
            {
              chainId: "1",
              name: "Doge Killer",
              symbol: "LEASH",
              address: "0x27c70cd1946795b66be9d954418546998b546634",
              price: 241.51,
            },
            {
              chainId: "1",
              name: "SOL (Wormhole)",
              symbol: "SOL",
              address: "0xd31a59c85ae9d8edefec411d448f90841571b89c",
              price: 237.81,
            },
            {
              chainId: "1",
              name: "Alongside Crypto Market Index",
              symbol: "AMKT",
              address: "0xf17a3fe536f8f7847f1385ec1bc967b2ca9cae8d",
              price: 229.43,
            },
            {
              chainId: "56",
              name: "Aave",
              symbol: "AAVE",
              address: "0xfb6115445bff7b52feb98650c87f44907e58f802",
              price: 224.64,
            },
            {
              chainId: "137",
              name: "Aave",
              symbol: "AAVE",
              address: "0xd6df932a45c0f255f85145f286ea0b292b21c90b",
              price: 194.77,
            },
            {
              chainId: "56",
              name: "Wrapped Solana",
              symbol: "SOL",
              address: "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
              price: 167.37,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Mixin",
              symbol: "XIN",
              address: "0xa974c709cfb4566686553a20790685a47aceaa33",
              price: 133.89,
            },
            {
              chainId: "1",
              name: "Olympus v1",
              symbol: "OHM",
              address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
              price: 126.31,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "56",
              name: "Litecoin",
              symbol: "LTC",
              address: "0x4338665cbb7b2485a8855a139b75d5e34ab0db94",
              price: 103.13,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "OKB",
              symbol: "OKB",
              address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
              price: 51.17,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Inverse Finance",
              symbol: "INV",
              address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
              price: 48.04,
            },
            {
              chainId: "1",
              name: "NFTX",
              symbol: "NFTX",
              address: "0x87d73e916d7057945c9bcd8cdd94e42a6f47f776",
              price: 46.8,
            },
            {
              chainId: "1",
              name: "Quickswap (OLD)",
              symbol: "QUICK",
              address: "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
              price: 35.75,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Veritaseum",
              symbol: "VERI",
              address: "0x8f3470A7388c05eE4e7AF3d01D8C722b0FF52374",
              price: 34.01,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "WhiteBIT Token",
              symbol: "WBT",
              address: "0x925206b8a707096Ed26ae47C84747fE0bb734F59",
              price: 30.26,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "YFDAI.finance",
              symbol: "YF-DAI",
              address: "0xf4cd3d3fda8d7fd6c5a500203e38640a70bf9577",
              price: 24.71,
            },
            {
              chainId: "56",
              name: "Avalanche",
              symbol: "AVAX",
              address: "0x1CE0c2827e2eF14D5C4f29a091d735A204794041",
              price: 24.42,
            },
            {
              chainId: "1",
              name: "Olympus",
              symbol: "OHM",
              address: "0x64aa3364f17a4d01c6f1751fd97c2bd3d7e7f1d5",
              price: 23.81,
            },
            {
              chainId: "137",
              name: "Avalanche",
              symbol: "AVAX",
              address: "0x2C89bbc92BD86F8075d1DEcc58C7F4E0107f286b",
              price: 21.88,
            },
            {
              chainId: "1",
              name: "Saffron.finance",
              symbol: "SFI",
              address: "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
              price: 21.19,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "Deus Finance",
              symbol: "DEUS",
              address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
              price: 19.2,
            },
            {
              chainId: "137",
              name: "Deus Finance",
              symbol: "DEUS",
              address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
              price: 19.2,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "56",
              name: "Ethereum Classic",
              symbol: "ETC",
              address: "0x3d6545b08693dae087e957cb1180ee38b9e3c25e",
              price: 18.52,
            },
            {
              chainId: "56",
              name: "chrono.tech",
              symbol: "TIME",
              address: "0x3b198e26e473b8fab2085b37978e36c9de5d7f68",
              price: 17.25,
            },
            {
              chainId: "1",
              name: "chrono.tech",
              symbol: "TIME",
              address: "0x485d17a6f1b8780392d53d64751824253011a260",
              price: 17.25,
            },
            {
              chainId: "137",
              name: "chrono.tech",
              symbol: "TIME",
              address: "0xb970Bc1BD4fCD639c37aa8eFD6713eaDc577252f",
              price: 17.25,
            },
            {
              chainId: "42161",
              name: "GMX",
              symbol: "GMX",
              address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
              price: 16.85,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Wrapped Ampleforth",
              symbol: "WAMPL",
              address: "0xedb171c18ce90b633db442f2a6f72874093b49ef",
              price: 15.61,
            },
            {
              chainId: "56",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0xe552fb52a4f19e44ef5a967632dbc320b0820639",
              price: 15.29,
            },
            {
              chainId: "56",
              name: "Injective",
              symbol: "INJ",
              address: "0xa2b726b1145a4773f68593cf171187d8ebe4d495",
              price: 14.61,
            },
            {
              chainId: "56",
              name: "ChainLink",
              symbol: "LINK",
              address: "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd",
              price: 13.2,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Maple",
              symbol: "MPL",
              address: "0x33349b282065b0284d756f0577fb39c158f935e6",
              price: 12.05,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "56",
              name: "Auto",
              symbol: "AUTO",
              address: "0xa184088a740c695e156f91f5cc086a06bb78b827",
              price: 9.28,
            },
            {
              chainId: "1",
              name: "KittenFinance",
              symbol: "KIF",
              address: "0x177ba0cac51bfc7ea24bad39d81dcefd59d74faa",
              price: 8.85,
            },
            {
              chainId: "1",
              name: "UNUS SED LEO",
              symbol: "LEO",
              address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
              price: 8.85,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "HAPI",
              symbol: "HAPI",
              address: "0xD9c2D319Cd7e6177336b0a9c93c21cb48d84Fb54",
              price: 8.41,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "56",
              name: "Cheelee",
              symbol: "CHEEL",
              address: "0x1f1c90aeb2fd13ea972f0a71e35c0753848e3db0",
              price: 7.74,
            },
            {
              chainId: "56",
              name: "Tao Te Ching",
              symbol: "TTC",
              address: "0x152ad7Dc399269FA65D19BD7A790Ea8aa5b23DaD",
              price: 7.62,
            },
            {
              chainId: "1",
              name: "Oraichain Token",
              symbol: "ORAI",
              address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
              price: 7.29,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Verox",
              symbol: "VRX",
              address: "0x87DE305311D5788e8da38D19bb427645b09CB4e5",
              price: 6.48,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "56",
              name: "Uniswap",
              symbol: "UNI",
              address: "0xbf5140a22578168fd562dccf235e5d43a02ce9b1",
              price: 6.02,
            },
            {
              chainId: "56",
              name: "MANTRA",
              symbol: "OM",
              address: "0xf78d2e7936f5fe18308a3b2951a93b6c4a41f5e2",
              price: 5.87,
            },
            {
              chainId: "42161",
              name: "Uniswap",
              symbol: "UNI",
              address: "0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0",
              price: 5.84,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "56",
              name: "Venus",
              symbol: "XVS",
              address: "0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63",
              price: 5.74,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Decentral Games (Old)",
              symbol: "DG",
              address: "0xee06a81a695750e71a662b51066f2c74cf4478a0",
              price: 5.66,
            },
            {
              chainId: "56",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x99956d38059cf7beda96ec91aa7bb2477e0901dd",
              price: 5.47,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "1",
              name: "Reflexer Ungovernance Token",
              symbol: "FLX",
              address: "0x6243d8cea23066d098a15582d81a598b4e8391f4",
              price: 5.12,
            },
            {
              chainId: "56",
              name: "Polkadot",
              symbol: "DOT",
              address: "0x7083609fce4d1d8dc0c979aab8c869ea2c873402",
              price: 4.87,
            },
            {
              chainId: "56",
              name: "Cosmos",
              symbol: "ATOM",
              address: "0x0eb3a705fc54725037cc9e008bdede697f62f335",
              price: 4.73,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Darwinia Commitment Token",
              symbol: "KTON",
              address: "0x9f284e1337a815fe77d2ff4ae46544645b20c5ff",
              price: 4.19,
            },
            {
              chainId: "1",
              name: "Euler",
              symbol: "EUL",
              address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
              price: 4.17,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "56",
              name: "OG Fan Token",
              symbol: "OG",
              address: "0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c",
              price: 3.93,
            },
            {
              chainId: "56",
              name: "Wrapped Toncoin",
              symbol: "TONCOIN",
              address: "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
              price: 3.9,
            },
            {
              chainId: "1",
              name: "Fasttoken",
              symbol: "FTN",
              address: "0xaedf386b755465871ff874e3e37af5976e247064",
              price: 3.85,
            },
            {
              chainId: "137",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x61299774020dA444Af134c82fa83E3810b309991",
              price: 3.83,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "56",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0x715d400f88c167884bbcc41c5fea407ed4d2f8a0",
              price: 3.72,
            },
            {
              chainId: "1",
              name: "MX Token",
              symbol: "MX",
              address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
              price: 3.66,
            },
            {
              chainId: "1",
              name: "Wrapped Toncoin",
              symbol: "TONCOIN",
              address: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
              price: 3.53,
            },
            {
              chainId: "56",
              name: "SAFE(AnWang)",
              symbol: "SAFE",
              address: "0x4d7fa587ec8e50bd0e9cd837cb4da796f47218a1",
              price: 3.46,
            },
            {
              chainId: "56",
              name: "Wrapped Near",
              symbol: "WNEAR",
              address: "0x1fa4a73a3f0133f0025378af00236f3abdee5d63",
              price: 3.4,
            },
            {
              chainId: "1",
              name: "Echelon Prime",
              symbol: "PRIME",
              address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
              price: 3.34,
            },
            {
              chainId: "56",
              name: "Filecoin",
              symbol: "FIL",
              address: "0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153",
              price: 3.34,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Chicken Token",
              symbol: "KFC",
              address: "0xe63684bcf2987892cefb4caa79bd21b34e98a291",
              price: 3.01,
            },
            {
              chainId: "1",
              name: "Rai Reflex Index",
              symbol: "RAI",
              address: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
              price: 3,
            },
            {
              chainId: "1",
              name: "Aurox Token",
              symbol: "URUS",
              address: "0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b",
              price: 2.71,
            },
            {
              chainId: "56",
              name: "Aurox Token",
              symbol: "URUS",
              address: "0xc6DdDB5bc6E61e0841C54f3e723Ae1f3A807260b",
              price: 2.71,
            },
            {
              chainId: "56",
              name: "Paris Saint-Germain Fan Token",
              symbol: "PSG",
              address: "0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1",
              price: 2.66,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "56",
              name: "Santos FC Fan Token",
              symbol: "SANTOS",
              address: "0xA64455a4553C9034236734FadDAddbb64aCE4Cc7",
              price: 2.51,
            },
            {
              chainId: "1",
              name: "MUX Protocol",
              symbol: "MCB",
              address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
              price: 2.48,
            },
            {
              chainId: "137",
              name: "X Protocol",
              symbol: "POT",
              address: "0xBCB98D98704FCe7Abda63bF733Af2a9e28C161C8",
              price: 2.48,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Aventus",
              symbol: "AVT",
              address: "0x0d88ed6e74bbfd96b831231638b66c05571e824f",
              price: 2.34,
            },
            {
              chainId: "56",
              name: "PancakeSwap",
              symbol: "CAKE",
              address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
              price: 2.32,
            },
            {
              chainId: "56",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x2ed9a5c8c13b93955103b9a7c167b67ef4d568a3",
              price: 2.2,
            },
            {
              chainId: "1",
              name: "Strong",
              symbol: "STRONG",
              address: "0x990f341946a3fdb507ae7e52d17851b87168017c",
              price: 2.1,
            },
            {
              chainId: "56",
              name: "XRPL",
              symbol: "XRP",
              address: "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe",
              price: 2.06,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Elastos",
              symbol: "ELA",
              address: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
              price: 1.81,
            },
            {
              chainId: "1",
              name: "Tokamak Network",
              symbol: "TON",
              address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
              price: 1.78,
            },
            {
              chainId: "1",
              name: "Alpha Quark Token",
              symbol: "AQT",
              address: "0x2a9bdcff37ab68b95a53435adfd8892e86084f93",
              price: 1.75,
            },
            {
              chainId: "137",
              name: "Balancer",
              symbol: "BAL",
              address: "0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "56",
              name: "AS Roma Fan Token",
              symbol: "ASR",
              address: "0x80D5f92C2c8C682070C95495313dDB680B267320",
              price: 1.67,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "56",
              name: "Synthetix",
              symbol: "SNX",
              address: "0x9ac983826058b8a9c7aa1c9171441191232e8404",
              price: 1.58,
            },
            {
              chainId: "1",
              name: "Waves",
              symbol: "WAVES",
              address: "0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a",
              price: 1.58,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "42161",
              name: "Gains Network",
              symbol: "GNS",
              address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
              price: 1.51,
            },
            {
              chainId: "56",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.49,
            },
            {
              chainId: "1",
              name: "Rarible",
              symbol: "RARI",
              address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
              price: 1.44,
            },
            {
              chainId: "137",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 1.44,
            },
            {
              chainId: "137",
              name: "Gains Network",
              symbol: "GNS",
              address: "0xe5417af564e4bfda1c483642db72007871397896",
              price: 1.41,
            },
            {
              chainId: "56",
              name: "Anyswap",
              symbol: "ANY",
              address: "0xf68c9df95a18b2a5a5fa1124d79eeeffbad0b6fa",
              price: 1.4,
            },
            {
              chainId: "1",
              name: "Anyswap",
              symbol: "ANY",
              address: "0xf99d58e463a2e07e5692127302c20a191861b4d6",
              price: 1.4,
            },
            {
              chainId: "1",
              name: "Poundtoken",
              symbol: "GBPT",
              address: "0x86B4dBE5D203e634a12364C0e428fa242A3FbA98",
              price: 1.32,
            },
            {
              chainId: "56",
              name: "Phoenix",
              symbol: "PHB",
              address: "0x0409633A72D846fc5BBe2f98D88564D35987904D",
              price: 1.31,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Universal Liquidity Union",
              symbol: "ULU",
              address: "0x035bfe6057e15ea692c0dfdcab3bb41a64dd2ad4",
              price: 1.28,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "56",
              name: "GameFi",
              symbol: "GAFI",
              address: "0x89Af13A10b32F1b2f8d1588f93027F69B6F4E27e",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Million",
              symbol: "MM",
              address: "0x6b4c7a5e3f0b99fcd83e9c089bddd6c7fce5c611",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "TosDis",
              symbol: "DIS",
              address: "0x220B71671b649c03714dA9c621285943f3cbcDC6",
              price: 1.19,
            },
            {
              chainId: "56",
              name: "AmazingTeamDAO",
              symbol: "AMAZINGTEAM",
              address: "0x44ece1031e5b5e2d9169546cc10ea5c95ba96237",
              price: 1.17,
            },
            {
              chainId: "56",
              name: "Landshare",
              symbol: "LAND",
              address: "0x9d986a3f147212327dd658f712d5264a73a1fdb0",
              price: 1.17,
            },
            {
              chainId: "1",
              name: "One Share",
              symbol: "ONS",
              address: "0x5BB29c33C4A3C29f56F8ACa40B4dB91d8a5fe2c5",
              price: 1.15,
            },
            {
              chainId: "56",
              name: "Alpine F1 Team Fan Token",
              symbol: "ALPINE",
              address: "0x287880ea252b52b63cc5f40a2d3e5a44aa665a76",
              price: 1.13,
            },
            {
              chainId: "56",
              name: "Lazio Fan Token",
              symbol: "LAZIO",
              address: "0x77d547256a2cd95f32f67ae0313e450ac200648d",
              price: 1.13,
            },
            {
              chainId: "56",
              name: "BinaryX",
              symbol: "BNX",
              address: "0x5b1f874d0b0C5ee17a495CbB70AB8bf64107A3BD",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "56",
              name: "Million",
              symbol: "MM",
              address: "0xBF05279F9Bf1CE69bBFEd670813b7e431142Afa4",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Router Protocol",
              symbol: "ROUTE",
              address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
              price: 1.093,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "Euro Tether",
              symbol: "EURT",
              address: "0xc581b735a1688071a1746c968e0798d642ede491",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Edge",
              symbol: "DADI",
              address: "0xfb2f26f266fb2805a387230f2aa0a331b4d96fba",
              price: 1.019,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "56",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Fei USD",
              symbol: "FEI",
              address: "0x956f47f50a910163d8bf957cf5846d573e7f87ca",
              price: 1,
            },
            {
              chainId: "137",
              name: "MAI",
              symbol: "MIMATIC",
              address: "0xa3fa99a148fa48d14ed51d610c367c61876997f1",
              price: 1,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "204",
              name: "Tether USD",
              symbol: "USDT",
              address: "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
              price: 1,
            },
            {
              chainId: "10",
              name: "Tether",
              symbol: "usdt",
              address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
              price: 0.999984,
            },
            {
              chainId: "5000",
              name: "USDT",
              symbol: "USDT",
              address: "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae",
              price: 0.999984,
            },
            {
              chainId: "137",
              name: "Tether",
              symbol: "USDT",
              address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
              price: 0.999982,
            },
            {
              chainId: "10",
              name: "USD Coin",
              symbol: "usdc",
              address: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
              price: 0.999963,
            },
            {
              chainId: "56",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
              price: 0.999963,
            },
            {
              chainId: "42161",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
              price: 0.999889,
            },
            {
              chainId: "137",
              name: "USD Coin",
              symbol: "USDC",
              address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "56",
              name: "Dai",
              symbol: "DAI",
              address: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
              price: 0.999783,
            },
            {
              chainId: "1",
              name: "Gemini Dollar",
              symbol: "GUSD",
              address: "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
              price: 0.999716,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "137",
              name: "Dai",
              symbol: "DAI",
              address: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
              price: 0.999647,
            },
            {
              chainId: "42161",
              name: "Dai",
              symbol: "DAI",
              address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
              price: 0.999647,
            },
            {
              chainId: "534352",
              name: "Tether USD",
              symbol: "USDT",
              address: "0xf55BEC9cafDbE8730f096Aa55dad6D22d44099Df",
              price: 0.999634,
            },
            {
              chainId: "42161",
              name: "Tether",
              symbol: "USDT",
              address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
              price: 0.999348,
            },
            {
              chainId: "1",
              name: "Frax",
              symbol: "FRAX",
              address: "0x853d955acef822db058eb8505911ed77f175b99e",
              price: 0.999223,
            },
            {
              chainId: "137",
              name: "axlUSDC",
              symbol: "axlUSDC",
              address: "0x750e4C4984a9e0f12978eA6742Bc1c5D248f40ed",
              price: 0.998744,
            },
            {
              chainId: "56",
              name: "True USD",
              symbol: "TUSD",
              address: "0x14016e85a25aeb13065688cafb43044c2ef86784",
              price: 0.998512,
            },
            {
              chainId: "137",
              name: "USD Coin (Wormhole)",
              symbol: "USDC",
              address: "0x4318CB63A2b8edf2De971E2F17F77097e499459D",
              price: 0.998337,
            },
            {
              chainId: "204",
              name: "First Digital USD",
              symbol: "FDUSD",
              address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
              price: 0.997856,
            },
            {
              chainId: "56",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
              price: 0.997802,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Origin Dollar",
              symbol: "OUSD",
              address: "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
              price: 0.996947,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "56",
              name: "USDD",
              symbol: "USDD",
              address: "0xd17479997f34dd9156deef8f95a52d81d265be9c",
              price: 0.996134,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "56",
              name: "dForce",
              symbol: "DF",
              address: "0x4A9A2b2b04549C3927dd2c9668A5eF3fCA473623",
              price: 0.974728,
            },
            {
              chainId: "1",
              name: "Pickle Finance",
              symbol: "PICKLE",
              address: "0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
              price: 0.969209,
            },
            {
              chainId: "56",
              name: "Galxe",
              symbol: "GAL",
              address: "0xe4cc45bb5dbda06db6183e8bf016569f40497aa5",
              price: 0.968704,
            },
            {
              chainId: "56",
              name: "FC Porto",
              symbol: "PORTO",
              address: "0x49f2145d6366099e13B10FbF80646C0F377eE7f6",
              price: 0.963564,
            },
            {
              chainId: "56",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xad6caeb32cd2c308980a548bd0bc5aa4306c6c18",
              price: 0.959082,
            },
            {
              chainId: "137",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
              price: 0.945166,
            },
            {
              chainId: "1",
              name: "Goldfinch",
              symbol: "GFI",
              address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
              price: 0.941368,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "56",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x5f4bde007dc06b867f86ebfe4802e34a1ffeed63",
              price: 0.895801,
            },
            {
              chainId: "1",
              name: "Bitpanda Ecosystem Token",
              symbol: "BEST",
              address: "0x1b073382e63411e3bcffe90ac1b9a43fefa1ec6f",
              price: 0.894907,
            },
            {
              chainId: "56",
              name: "Poolz",
              symbol: "POOLZ",
              address: "0x77018282fd033daf370337a5367e62d8811bc885",
              price: 0.890639,
            },
            {
              chainId: "56",
              name: "Poolz Finance",
              symbol: "POOLX",
              address: "0xbAeA9aBA1454DF334943951d51116aE342eAB255",
              price: 0.890639,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "56",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x947950bcc74888a40ffa2593c5798f11fc9124c4",
              price: 0.886037,
            },
            {
              chainId: "56",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.877737,
            },
            {
              chainId: "56",
              name: "AIOZ Network",
              symbol: "AIOZ",
              address: "0x33d08d8c7a168333a85285a68c0042b39fc3741d",
              price: 0.876971,
            },
            {
              chainId: "1",
              name: "pBTC35A",
              symbol: "pBTC35A",
              address: "0xA8b12Cc90AbF65191532a12bb5394A714A46d358",
              price: 0.872876,
            },
            {
              chainId: "56",
              name: "Travala",
              symbol: "AVA",
              address: "0x13616f44ba82d63c8c0dc3ff843d36a8ec1c05a9",
              price: 0.871989,
            },
            {
              chainId: "56",
              name: "Seedify.fund",
              symbol: "SFUND",
              address: "0x477bc8d23c634c154061869478bce96be6045d12",
              price: 0.868498,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "56",
              name: "The Debt Box",
              symbol: "DEBT",
              address: "0xc632f90affec7121120275610bf17df9963f181c",
              price: 0.825089,
            },
            {
              chainId: "1",
              name: "APED",
              symbol: "APED",
              address: "0xe0151763455a8a021e64880c238ba1cff3787ff0",
              price: 0.819289,
            },
            {
              chainId: "1",
              name: "Base Protocol",
              symbol: "BASE",
              address: "0x07150e919b4de5fd6a63de1f9384828396f25fdc",
              price: 0.80542,
            },
            {
              chainId: "1",
              name: "BitDAO",
              symbol: "BIT",
              address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
              price: 0.805153,
            },
            {
              chainId: "56",
              name: "EOS",
              symbol: "EOS",
              address: "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
              price: 0.803181,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "56",
              name: "Cardano",
              symbol: "ADA",
              address: "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
              price: 0.779615,
            },
            {
              chainId: "1",
              name: "Agoras",
              symbol: "AGRS",
              address: "0x738865301a9b7dd80dc3666dd48cf034ec42bdda",
              price: 0.778602,
            },
            {
              chainId: "10",
              name: "Optimism",
              symbol: "op",
              address: "0x4200000000000000000000000000000000000042",
              price: 0.764988,
            },
            {
              chainId: "10",
              name: "Synthetix Network",
              symbol: "snx",
              address: "0x8700daec35af8ff88c16bdf0418774cb3d7599b4",
              price: 0.764947,
            },
            {
              chainId: "5000",
              name: "MNT",
              symbol: "MNT",
              address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
              price: 0.72034,
            },
            {
              chainId: "56",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0x51ba0b044d96c3abfca52b64d733603ccc4f0d4d",
              price: 0.716825,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "Bird.Money",
              symbol: "BIRD",
              address: "0x70401dfd142a16dc7031c56e862fc88cb9537ce0",
              price: 0.712755,
            },
            {
              chainId: "1",
              name: "Tokenlon",
              symbol: "LON",
              address: "0x0000000000095413afc295d19edeb1ad7b71c952",
              price: 0.700937,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "56",
              name: "Bancor",
              symbol: "BNT",
              address: "0xA069008A669e2Af00a86673D9D584cfb524A42Cc",
              price: 0.677454,
            },
            {
              chainId: "1",
              name: "RabbitX (Strips-Finance)",
              symbol: "STRP",
              address: "0x97872EAfd79940C7b24f7BCc1EADb1457347ADc9",
              price: 0.655342,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "56",
              name: "SafePal",
              symbol: "SFP",
              address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
              price: 0.64872,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "56",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0x4e7f408be2d4e9d60f49a64b89bb619c84c7c6f5",
              price: 0.633711,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "OriginTrail",
              symbol: "TRAC",
              address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
              price: 0.623907,
            },
            {
              chainId: "1",
              name: "Rook",
              symbol: "ROOK",
              address: "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
              price: 0.622491,
            },
            {
              chainId: "1",
              name: "WHALE",
              symbol: "WHALE",
              address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
              price: 0.620746,
            },
            {
              chainId: "137",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0x172370d5cd63279efa6d502dab29171933a610af",
              price: 0.612087,
            },
            {
              chainId: "1",
              name: "88mph",
              symbol: "MPH",
              address: "0x8888801af4d980682e47f1a9036e589479e835c5",
              price: 0.611573,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "MahaDAO",
              symbol: "MAHA",
              address: "0x745407c86DF8DB893011912d3aB28e68B62E49B0",
              price: 0.578542,
            },
            {
              chainId: "1",
              name: "PepeCoin Cryptocurrency",
              symbol: "pepecoin",
              address: "0xA9E8aCf069C58aEc8825542845Fd754e41a9489A",
              price: 0.57721,
            },
            {
              chainId: "137",
              name: "Klima DAO",
              symbol: "KLIMA",
              address: "0x4e78011ce80ee02d2c3e649fb657e45898257815",
              price: 0.57259,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "137",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7",
              price: 0.541937,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "56",
              name: "Synapse",
              symbol: "SYN",
              address: "0xa4080f1778e69467e905b8d6f72f6e441f9e9484",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "56",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b",
              price: 0.525942,
            },
            {
              chainId: "1",
              name: "Crown Token",
              symbol: "CROWN",
              address: "0xF3Bb9F16677F2B86EfD1DFca1c141A99783Fde58",
              price: 0.519661,
            },
            {
              chainId: "1",
              name: "Gomining Token",
              symbol: "GMT",
              address: "0x7ddc52c4de30e94be3a6a0a2b259b2850f421989",
              price: 0.517705,
            },
            {
              chainId: "56",
              name: "Gomining Token",
              symbol: "GMT",
              address: "0x7Ddc52c4De30e94Be3A6A0A2b259b2850f421989",
              price: 0.517705,
            },
            {
              chainId: "56",
              name: "Fantom",
              symbol: "FTM",
              address: "0xad29abb318791d579433d831ed122afeaf29dcfe",
              price: 0.516944,
            },
            {
              chainId: "56",
              name: "Sakai Vault",
              symbol: "SAKAI",
              address: "0x43B35e89d15B91162Dea1C51133C4c93bdd1C4aF",
              price: 0.513914,
            },
            {
              chainId: "56",
              name: "BinaryX (old)",
              symbol: "BNX",
              address: "0x8c851d1a123ff703bd1f9dabe631b69902df5f97",
              price: 0.509864,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "56",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Chintai",
              symbol: "CHEX",
              address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
              price: 0.465696,
            },
            {
              chainId: "56",
              name: "Fetch AI",
              symbol: "FET",
              address: "0x031b41e504677879370e9dbcf937283a8691fa7f",
              price: 0.465389,
            },
            {
              chainId: "137",
              name: "Nakamoto Games",
              symbol: "NAKA",
              address: "0x311434160d7537be358930def317afb606c0d737",
              price: 0.456567,
            },
            {
              chainId: "56",
              name: "Prosper",
              symbol: "PROS",
              address: "0xed8c8aa8299c10f067496bb66f8cc7fb338a3405",
              price: 0.455588,
            },
            {
              chainId: "42161",
              name: "AI CODE",
              symbol: "AICODE",
              address: "0x7c8a1a80fdd00c9cccd6ebd573e9ecb49bfa2a59",
              price: 0.452527,
            },
            {
              chainId: "1",
              name: "X Protocol",
              symbol: "POT",
              address: "0x049b98b31eF7D6448519f3642AAD92AB5b8aDa52",
              price: 0.452427,
            },
            {
              chainId: "56",
              name: "X Protocol",
              symbol: "POT",
              address: "0x4c7b04d50e070848E3c7757995A57624563e0245",
              price: 0.452427,
            },
            {
              chainId: "56",
              name: "MetFi",
              symbol: "METFI",
              address: "0x3E7f1039896454B9cb27c53CC7383e1AB9D9512a",
              price: 0.44646,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "56",
              name: "Polygon",
              symbol: "MATIC",
              address: "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
              price: 0.436806,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "137",
              name: "Croatian FF Fan Token",
              symbol: "VATRENI",
              address: "0xd60deba014459f07bbcc077a5b817f31dafd5229",
              price: 0.43466,
            },
            {
              chainId: "1",
              name: "Float Protocol",
              symbol: "BANK",
              address: "0x24a6a37576377f63f194caa5f518a60f45b42921",
              price: 0.426757,
            },
            {
              chainId: "4200",
              name: "Merlin Chain",
              symbol: "MERL",
              address: "0x5c46bFF4B38dc1EAE09C5BAc65872a1D8bc87378",
              price: 0.418236,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "56",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x8b1f4432f943c465a973fedc6d7aa50fc96f1f65",
              price: 0.407678,
            },
            {
              chainId: "42161",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
              price: 0.406394,
            },
            {
              chainId: "1",
              name: "Polytrade",
              symbol: "TRADE",
              address: "0x6e5970dbd6fc7eb1f29c6d2edf2bc4c36124c0c1",
              price: 0.40536,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Cellframe ",
              symbol: "CELL",
              address: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
              price: 0.399025,
            },
            {
              chainId: "10",
              name: "Across Protocol",
              symbol: "acx",
              address: "0xff733b2a3557a7ed6697007ab5d11b79fdd1b76b",
              price: 0.395604,
            },
            {
              chainId: "56",
              name: "Frontier",
              symbol: "FRONT",
              address: "0x928e55dab735aa8260af3cedada18b5f70c72f1b",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "56",
              name: "Wrapped Flow",
              symbol: "WFLOW",
              address: "0xC943c5320B9c18C153d1e2d12cC3074bebfb31A2",
              price: 0.37157,
            },
            {
              chainId: "1",
              name: "Metronome",
              symbol: "MET",
              address: "0x2Ebd53d035150f328bd754D6DC66B99B0eDB89aa",
              price: 0.369542,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "137",
              name: "Axelar",
              symbol: "AXL",
              address: "0x6e4e624106cb12e168e6533f8ec7c82263358940",
              price: 0.364835,
            },
            {
              chainId: "42161",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x23ee2343B892b1BB63503a4FAbc840E0e2C6810f",
              price: 0.364835,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "PoolTogether",
              symbol: "POOL",
              address: "0x0cec1a9154ff802e7934fc916ed7ca50bde6844e",
              price: 0.361803,
            },
            {
              chainId: "1",
              name: "Magic",
              symbol: "MAGIC",
              address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
              price: 0.361285,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "BZZ",
              address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
              price: 0.357921,
            },
            {
              chainId: "1",
              name: "Kryll",
              symbol: "KRL",
              address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
              price: 0.35556,
            },
            {
              chainId: "1",
              name: "Alchemist",
              symbol: "MIST",
              address: "0x88acdd2a6425c3faae4bc9650fd7e27e0bebb7ab",
              price: 0.354757,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "Moss Carbon Credit",
              symbol: "MCO2",
              address: "0xfc98e825a2264d890f9a1e68ed50e1526abccacd",
              price: 0.34991,
            },
            {
              chainId: "1",
              name: "Multichain",
              symbol: "MULTI",
              address: "0x65ef703f5594d2573eb71aaf55bc0cb548492df4",
              price: 0.343111,
            },
            {
              chainId: "56",
              name: "Multichain",
              symbol: "MULTI",
              address: "0x9fb9a33956351cf4fa040f65a13b835a3c8764e3",
              price: 0.343111,
            },
            {
              chainId: "137",
              name: "Golem",
              symbol: "GLM",
              address: "0x0B220b82F3eA3B7F6d9A1D8ab58930C064A2b5Bf",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "ESG",
              symbol: "ESG",
              address: "0x20cd2e7ec8f5d8b337fe46a4f565ccef1561b9a9",
              price: 0.334684,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "137",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0xbbba073c31bf03b8acf7c28ef0738decf3695683",
              price: 0.32675,
            },
            {
              chainId: "56",
              name: "Tokocrypto",
              symbol: "TKO",
              address: "0x9f589e3eabe42ebc94a44727b3f3531c0c877809",
              price: 0.319638,
            },
            {
              chainId: "56",
              name: "IOTA",
              symbol: "IOTA",
              address: "0xd944f1d1e9d5f9bb90b62f9d45e447d989580782",
              price: 0.316958,
            },
            {
              chainId: "1",
              name: "Ribbon Finance",
              symbol: "RBN",
              address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
              price: 0.31189,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "Clearpool",
              symbol: "CPOOL",
              address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
              price: 0.304535,
            },
            {
              chainId: "56",
              name: "Open Campus",
              symbol: "EDU",
              address: "0xBdEAe1cA48894A1759A8374D63925f21f2Ee2639",
              price: 0.302878,
            },
            {
              chainId: "137",
              name: "Polytrade",
              symbol: "TRADE",
              address: "0x692ac1e363ae34b6b489148152b12e2785a3d8d6",
              price: 0.301644,
            },
            {
              chainId: "1",
              name: "Equilibrium",
              symbol: "EQ",
              address: "0xA5eDE2FEE620ac3d68065EC01F26F9dd99850B82",
              price: 0.299051,
            },
            {
              chainId: "56",
              name: "Thena",
              symbol: "THE",
              address: "0xF4C8E32EaDEC4BFe97E0F595AdD0f4450a863a11",
              price: 0.296236,
            },
            {
              chainId: "4200",
              name: "Bridged BRC20 VOYA",
              symbol: "VOYA",
              address: "0x480E158395cC5b41e5584347c495584cA2cAf78d",
              price: 0.296047,
            },
            {
              chainId: "1",
              name: "Vectorspace AI",
              symbol: "VXV",
              address: "0x7D29A64504629172a429e64183D6673b9dAcbFCe",
              price: 0.291574,
            },
            {
              chainId: "1",
              name: "Morpheus Network",
              symbol: "MNW",
              address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
              price: 0.286024,
            },
            {
              chainId: "1",
              name: "Sovryn",
              symbol: "SOV",
              address: "0xbdab72602e9ad40fc6a6852caf43258113b8f7a5",
              price: 0.285705,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "56",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x7e624fa0e1c4abfd309cc15719b7e2580887f570",
              price: 0.284396,
            },
            {
              chainId: "1",
              name: "OctoFi",
              symbol: "OCTO",
              address: "0x7240aC91f01233BaAf8b064248E80feaA5912BA3",
              price: 0.283249,
            },
            {
              chainId: "1",
              name: "OVR",
              symbol: "OVR",
              address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
              price: 0.276292,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "IAGON",
              symbol: "IAG",
              address: "0x40eb746dee876ac1e78697b7ca85142d178a1fc8",
              price: 0.270477,
            },
            {
              chainId: "1",
              name: "Wrapped Centrifuge",
              symbol: "WCFG",
              address: "0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
              price: 0.267137,
            },
            {
              chainId: "56",
              name: "Scallop",
              symbol: "SCLP",
              address: "0xF2c96E402c9199682d5dED26D3771c6B192c01af",
              price: 0.266022,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Braintrust",
              symbol: "BTRST",
              address: "0x799ebfabe77a6e34311eeee9825190b9ece32824",
              price: 0.264272,
            },
            {
              chainId: "56",
              name: "Future Of Fintech",
              symbol: "FOF",
              address: "0xe8a8db73f7fb1ab5f05c619a8a631c8930c782ae",
              price: 0.262986,
            },
            {
              chainId: "1",
              name: "Stratos ",
              symbol: "STOS",
              address: "0x08c32b0726C5684024ea6e141C50aDe9690bBdcc",
              price: 0.261778,
            },
            {
              chainId: "56",
              name: "Laqira Protocol",
              symbol: "LQR",
              address: "0xbc81ea817b579ec0334bca8e65e436b7cb540147",
              price: 0.261248,
            },
            {
              chainId: "56",
              name: "City Tycoon Games",
              symbol: "CTG",
              address: "0xb3ba14f6a482dfdebc3c2fb726ac10df91ee504c",
              price: 0.247317,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "AIOZ Network",
              symbol: "AIOZ",
              address: "0x626e8036deb333b408be468f951bdb42433cbf18",
              price: 0.242007,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "56",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.241271,
            },
            {
              chainId: "56",
              name: "Phala",
              symbol: "PHA",
              address: "0x0112e557d400474717056C4e6D40eDD846F38351",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "56",
              name: "TRON",
              symbol: "TRX",
              address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
              price: 0.237713,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Tokemak",
              symbol: "TOKE",
              address: "0x2e9d63788249371f1DFC918a52f8d799F4a38C94",
              price: 0.232818,
            },
            {
              chainId: "1",
              name: "LCX",
              symbol: "LCX",
              address: "0x037a54aab062628c9bbae1fdb1583c195585fe41",
              price: 0.22817,
            },
            {
              chainId: "56",
              name: "Dogecoin",
              symbol: "DOGE",
              address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
              price: 0.227176,
            },
            {
              chainId: "1",
              name: "Popsicle Finance",
              symbol: "ICE",
              address: "0xf16e81dce15b08f326220742020379b855b87df9",
              price: 0.225985,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "56",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0xd21d29b38374528675c34936bf7d5dd693d2a577",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "Snowswap",
              symbol: "SNOW",
              address: "0xfe9a29ab92522d14fc65880d817214261d8479ae",
              price: 0.219616,
            },
            {
              chainId: "56",
              name: "SpaceN",
              symbol: "SN",
              address: "0x939Dd9E433552e325D78C33a16EF4cD8004D2F9C",
              price: 0.217014,
            },
            {
              chainId: "1",
              name: "Alkimi",
              symbol: "$ADS",
              address: "0x3106a0a076bedae847652f42ef07fd58589e001f",
              price: 0.215736,
            },
            {
              chainId: "1",
              name: "Vesper",
              symbol: "VSP",
              address: "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
              price: 0.212157,
            },
            {
              chainId: "1",
              name: "IPOR Labs",
              symbol: "IPOR",
              address: "0x1e4746dc744503b53b4a082cb3607b169a289090",
              price: 0.211879,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "56",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "56",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xb0d502e938ed5f4df2e681fe6e419ff29631d62b",
              price: 0.205851,
            },
            {
              chainId: "1",
              name: "Blox",
              symbol: "CDT",
              address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
              price: 0.205372,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Seascape Crowns",
              symbol: "CWS",
              address: "0xac0104cca91d167873b8601d2e71eb3d4d8c33e0",
              price: 0.203993,
            },
            {
              chainId: "56",
              name: "Seascape Crowns",
              symbol: "CWS",
              address: "0xbcf39f0edda668c58371e519af37ca705f2bfcbd",
              price: 0.203993,
            },
            {
              chainId: "1",
              name: "Lien",
              symbol: "LIEN",
              address: "0xab37e1358b639fd877f015027bb62d3ddaa7557e",
              price: 0.203345,
            },
            {
              chainId: "1",
              name: "MATH",
              symbol: "MATH",
              address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
              price: 0.200963,
            },
            {
              chainId: "137",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
              price: 0.199574,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "56",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x4d2d32d8652058bf98c772953e1df5c5c85d9f45",
              price: 0.195949,
            },
            {
              chainId: "56",
              name: "CryptoMines",
              symbol: "ETERNAL",
              address: "0xd44fd09d74cd13838f137b590497595d6b3feea4",
              price: 0.195074,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "Orbler",
              symbol: "ORBR",
              address: "0xda30f261a962d5aae94c9ecd170544600d193766",
              price: 0.192141,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "ERC20",
              symbol: "ERC20",
              address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
              price: 0.181667,
            },
            {
              chainId: "1",
              name: "Octopus Network",
              symbol: "OCT",
              address: "0xf5cfbc74057c610c8ef151a439252680ac68c6dc",
              price: 0.181571,
            },
            {
              chainId: "56",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x101d82428437127bf1608f699cd651e6abf9766e",
              price: 0.181523,
            },
            {
              chainId: "42161",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0x6694340fc020c5E6B96567843da2df01b2CE1eb6",
              price: 0.181186,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "10",
              name: "Thales",
              symbol: "thales",
              address: "0x217d47011b23bb961eb6d93ca9945b7501a5bb11",
              price: 0.180527,
            },
            {
              chainId: "1",
              name: "Thales",
              symbol: "THALES",
              address: "0x8947da500eb47f82df21143d0c01a29862a8c3c5",
              price: 0.180527,
            },
            {
              chainId: "1",
              name: "Rari Governance Token",
              symbol: "RGT",
              address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
              price: 0.180052,
            },
            {
              chainId: "137",
              name: "Wrapped Matic",
              symbol: "WMATIC",
              address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
              price: 0.178256,
            },
            {
              chainId: "56",
              name: "Diamond Launch",
              symbol: "DLC",
              address: "0xdE83180dD1166D4f8E5c2b7De14A2163b1Bb4a87",
              price: 0.17469,
            },
            {
              chainId: "137",
              name: "IX Token",
              symbol: "IXT",
              address: "0xe06bd4f5aac8d0aa337d13ec88db6defc6eaeefe",
              price: 0.174195,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "CyberFi",
              symbol: "CFI",
              address: "0x63b4f3e3fa4e438698ce330e365e831f7ccd1ef4",
              price: 0.172847,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Blocksquare",
              symbol: "BST",
              address: "0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a",
              price: 0.168565,
            },
            {
              chainId: "56",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0x6bff4fb161347ad7de4a625ae5aa3a1ca7077819",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "BitMEX Token",
              symbol: "BMEX",
              address: "0xb113c6cf239f60d380359b762e95c13817275277",
              price: 0.164769,
            },
            {
              chainId: "1",
              name: "Swarm Markets",
              symbol: "SMT",
              address: "0xb17548c7b510427baac4e267bea62e800b247173",
              price: 0.163673,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Gelato",
              symbol: "GEL",
              address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
              price: 0.162866,
            },
            {
              chainId: "1",
              name: "Wrapped Telos",
              symbol: "WTLOS",
              address: "0x7825e833d495f3d1c28872415a4aee339d26ac88",
              price: 0.161006,
            },
            {
              chainId: "56",
              name: "Wrapped Telos",
              symbol: "WTLOS",
              address: "0xb6c53431608e626ac81a9776ac3e999c5556717c",
              price: 0.161006,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "56",
              name: "ArchLoot",
              symbol: "ALT",
              address: "0x1BD55090B8878630E57FAE6eBd11FD61d16DFC9f",
              price: 0.156505,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "56",
              name: "Shattered Legion",
              symbol: "SLG",
              address: "0x2348b010fa9c0ce30bb042d54c298a3411361a01",
              price: 0.153734,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "56",
              name: "Flux",
              symbol: "FLUX",
              address: "0xaff9084f2374585879e8b434c399e29e80cce635",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Crust",
              symbol: "CRU",
              address: "0x32a7c02e79c4ea1008dd6564b35f131428673c41",
              price: 0.151675,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "56",
              name: "BRN Metaverse",
              symbol: "BRN",
              address: "0x926ecC7687fCFB296E97a2b4501F41A6f5F8C214",
              price: 0.146265,
            },
            {
              chainId: "1",
              name: "Moda DAO",
              symbol: "MODA",
              address: "0x1117ac6ad6cdf1a3bc543bad3b133724620522d5",
              price: 0.143395,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Function X",
              symbol: "FX",
              address: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
              price: 0.138919,
            },
            {
              chainId: "56",
              name: "Safuu",
              symbol: "SAFUU",
              address: "0xE5bA47fD94CB645ba4119222e34fB33F59C7CD90",
              price: 0.138361,
            },
            {
              chainId: "1",
              name: "Truebit Protocol",
              symbol: "TRU",
              address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
              price: 0.137801,
            },
            {
              chainId: "56",
              name: "ChainGPT",
              symbol: "CGPT",
              address: "0x9840652DC04fb9db2C43853633f0F62BE6f00f98",
              price: 0.137011,
            },
            {
              chainId: "56",
              name: "BakerySwap",
              symbol: "BAKE",
              address: "0xe02df9e3e622debdd69fb838bb799e3f168902c5",
              price: 0.13676,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "56",
              name: "XAI",
              symbol: "XAI",
              address: "0xD16EaabA33a0822f5cBe4E0C63CA51D3c3fbB08B",
              price: 0.13178,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "56",
              name: "NASDEX",
              symbol: "NSDX",
              address: "0x417871f0682db63924b931fc16ba3ff40343cdcb",
              price: 0.130093,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "56",
              name: "Hooked Protocol",
              symbol: "HOOK",
              address: "0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0",
              price: 0.128704,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "Keep network",
              symbol: "KEEP",
              address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
              price: 0.126376,
            },
            {
              chainId: "137",
              name: "The Graph",
              symbol: "GRT",
              address: "0x5fe2b58c013d7601147dcdd68c143a77499f5531",
              price: 0.125405,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "TrustSwap",
              symbol: "SWAP",
              address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
              price: 0.122692,
            },
            {
              chainId: "56",
              name: "Parex",
              symbol: "PRX",
              address: "0x90e3414e00e231b962666bd94adb811d5bcd0c2a",
              price: 0.122669,
            },
            {
              chainId: "1",
              name: "CNH Tether ",
              symbol: "CNHT",
              address: "0x6E109E9dD7Fa1a58BC3eff667e8e41fC3cc07AEF",
              price: 0.121353,
            },
            {
              chainId: "56",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0xb2bd0749dbe21f623d9baba856d3b0f0e1bfec9c",
              price: 0.120558,
            },
            {
              chainId: "1",
              name: "sudoswap",
              symbol: "SUDO",
              address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
              price: 0.119429,
            },
            {
              chainId: "1",
              name: "Aleph.im",
              symbol: "ALEPH",
              address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
              price: 0.116863,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "56",
              name: "DODO",
              symbol: "DODO",
              address: "0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2",
              price: 0.116718,
            },
            {
              chainId: "56",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x431e0cD023a32532BF3969CddFc002c00E98429d",
              price: 0.115878,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "42161",
              name: "Magic",
              symbol: "MAGIC",
              address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
              price: 0.115143,
            },
            {
              chainId: "56",
              name: "MOBOX",
              symbol: "MBOX",
              address: "0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377",
              price: 0.115132,
            },
            {
              chainId: "1",
              name: "Polychain Monsters",
              symbol: "PMON",
              address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
              price: 0.114137,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "56",
              name: "CryptoBlades",
              symbol: "SKILL",
              address: "0x154a9f9cbd3449ad22fdae23044319d6ef2a1fab",
              price: 0.112753,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "DeGate",
              symbol: "DG",
              address: "0x53c8395465a84955c95159814461466053dedede",
              price: 0.110768,
            },
            {
              chainId: "1",
              name: "DIMO",
              symbol: "DIMO",
              address: "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
              price: 0.10982,
            },
            {
              chainId: "137",
              name: "DIMO",
              symbol: "DIMO",
              address: "0xe261d618a959afffd53168cd07d12e37b26761db",
              price: 0.10982,
            },
            {
              chainId: "1",
              name: "Zignaly",
              symbol: "ZIG",
              address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
              price: 0.109712,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "56",
              name: "Tranchess",
              symbol: "CHESS",
              address: "0x20de22029ab63cf9a7cf5feb2b737ca1ee4c82a6",
              price: 0.108883,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "Perion",
              symbol: "PERC",
              address: "0x60be1e1fe41c1370adaf5d8e66f07cf1c2df2268",
              price: 0.103679,
            },
            {
              chainId: "56",
              name: "Alpaca Finance",
              symbol: "ALPACA",
              address: "0x8f0528ce5ef7b51152a59745befdd91d97091d2f",
              price: 0.101034,
            },
            {
              chainId: "56",
              name: "Tenset",
              symbol: "10SET",
              address: "0x1AE369A6AB222aFF166325B7b87Eb9aF06C86E57",
              price: 0.10034,
            },
            {
              chainId: "1",
              name: "EdenLoop",
              symbol: "ELT",
              address: "0xfC1Cb4920dC1110fD61AfaB75Cf085C1f871b8C6",
              price: 0.100016,
            },
            {
              chainId: "1",
              name: "Polkadex",
              symbol: "PDEX",
              address: "0xf59ae934f6fe444afc309586cc60a84a0f89aaea",
              price: 0.099452,
            },
            {
              chainId: "1",
              name: "Forta",
              symbol: "FORT",
              address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
              price: 0.098713,
            },
            {
              chainId: "1",
              name: "Stake",
              symbol: "STAKE",
              address: "0x0Ae055097C6d159879521C384F1D2123D1f195e6",
              price: 0.098531,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "56",
              name: "CryptoTycoon ",
              symbol: "CTT",
              address: "0x464863745ed3af8b9f8871f1082211c55f8f884d",
              price: 0.096198,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "56",
              name: "Magpie",
              symbol: "MGP",
              address: "0xd06716e1ff2e492cc5034c2e81805562dd3b45fa",
              price: 0.092364,
            },
            {
              chainId: "1",
              name: "Singularity DAO",
              symbol: "SDAO",
              address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
              price: 0.092064,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Atlas Navi",
              symbol: "NAVI",
              address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
              price: 0.090082,
            },
            {
              chainId: "56",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x8da443f84fea710266c8eb6bc34b71702d033ef2",
              price: 0.087314,
            },
            {
              chainId: "56",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x23ce9e926048273ef83be0a3a8ba9cb6d45cd978",
              price: 0.084843,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "56",
              name: "DeRace",
              symbol: "DERC",
              address: "0x373e768f79c820aa441540d254dca6d045c6d25b",
              price: 0.084339,
            },
            {
              chainId: "1",
              name: "DAOSquare",
              symbol: "RICE",
              address: "0xbd9908b0cdd50386f92efcc8e1d71766c2782df0",
              price: 0.083887,
            },
            {
              chainId: "1",
              name: "NuCypher",
              symbol: "NU",
              address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
              price: 0.083335,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "56",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.081695,
            },
            {
              chainId: "1",
              name: "XELS",
              symbol: "XELS",
              address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
              price: 0.080759,
            },
            {
              chainId: "137",
              name: "Swarm Markets",
              symbol: "SMT",
              address: "0xE631DABeF60c37a37d70d3B4f812871df663226f",
              price: 0.080509,
            },
            {
              chainId: "1",
              name: "Newscrypto Coin",
              symbol: "NWC",
              address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
              price: 0.080218,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "AXIS Token",
              symbol: "AXIS",
              address: "0xF0c5831EC3Da15f3696B4DAd8B21c7Ce2f007f28",
              price: 0.077809,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "56",
              name: "LTO Network",
              symbol: "LTO",
              address: "0x857b222fc79e1cbbf8ca5f78cb133d1b7cf34bbd",
              price: 0.077077,
            },
            {
              chainId: "1",
              name: "Sentinel Protocol",
              symbol: "UPP",
              address: "0xc86d054809623432210c107af2e3f619dcfbf652",
              price: 0.076931,
            },
            {
              chainId: "56",
              name: "COTI",
              symbol: "COTI",
              address: "0xadbaf88b39d37dc68775ed1541f1bf83a5a45feb",
              price: 0.076189,
            },
            {
              chainId: "1",
              name: "Push Protocol",
              symbol: "PUSH",
              address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
              price: 0.075692,
            },
            {
              chainId: "1",
              name: "Ultra",
              symbol: "UOS",
              address: "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c",
              price: 0.074555,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "Oxygen",
              symbol: "OXY",
              address: "0x965697b4ef02f0de01384d0d4f9f782b1670c163",
              price: 0.073282,
            },
            {
              chainId: "1",
              name: "OccamFi",
              symbol: "OCC",
              address: "0x2f109021afe75b949429fe30523ee7c0d5b27207",
              price: 0.072545,
            },
            {
              chainId: "1",
              name: "Assemble Protocol",
              symbol: "ASM",
              address: "0x2565ae0385659badcada1031db704442e1b69982",
              price: 0.071723,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "137",
              name: "Voxies",
              symbol: "VOXEL",
              address: "0xd0258a3fD00f38aa8090dfee343f10A9D4d30D3F",
              price: 0.068971,
            },
            {
              chainId: "56",
              name: "ApolloX",
              symbol: "APX",
              address: "0x78f5d389f5cdccfc41594abab4b0ed02f31398b3",
              price: 0.068943,
            },
            {
              chainId: "56",
              name: "Singularity DAO",
              symbol: "SDAO",
              address: "0x90ed8f1dc86388f14b64ba8fb4bbd23099f18240",
              price: 0.068865,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "56",
              name: "Blockasset",
              symbol: "BLOCK",
              address: "0xbc7a566b85ef73f935e640a06b5a8b031cd975df",
              price: 0.068112,
            },
            {
              chainId: "56",
              name: "Hashflow",
              symbol: "HFT",
              address: "0x44Ec807ce2F4a6F2737A92e985f318d035883e47",
              price: 0.06798,
            },
            {
              chainId: "56",
              name: "Mecha Morphing",
              symbol: "MAPE",
              address: "0xCa044F16AfA434C0C17c0478D8A6cE4FEEf46504",
              price: 0.067912,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "56",
              name: "Coin98",
              symbol: "C98",
              address: "0xaec945e04baf28b135fa7c640f624f8d90f1c3a6",
              price: 0.064487,
            },
            {
              chainId: "1",
              name: "Your Future Exchange",
              symbol: "YFX",
              address: "0xf55a93b613d172b86c2ba3981a849dae2aecde2f",
              price: 0.063911,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "56",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "56",
              name: "Unmarshal",
              symbol: "MARSH",
              address: "0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256",
              price: 0.063323,
            },
            {
              chainId: "1",
              name: "Unmarshal",
              symbol: "MARSH",
              address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
              price: 0.063323,
            },
            {
              chainId: "1",
              name: "Symbiosis Finance",
              symbol: "SIS",
              address: "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
              price: 0.062595,
            },
            {
              chainId: "1",
              name: "Zus",
              symbol: "ZCN",
              address: "0xb9ef770b6a5e12e45983c5d80545258aa38f3b78",
              price: 0.061318,
            },
            {
              chainId: "1",
              name: "SUKU",
              symbol: "SUKU",
              address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
              price: 0.061202,
            },
            {
              chainId: "1",
              name: "HOPR Token",
              symbol: "HOPR",
              address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
              price: 0.060076,
            },
            {
              chainId: "56",
              name: "Opulous ",
              symbol: "OPUL",
              address: "0x686318000d982bc8dcc1cdcf8ffd22322f0960ed",
              price: 0.059933,
            },
            {
              chainId: "1",
              name: "Opulous ",
              symbol: "OPUL",
              address: "0x80D55c03180349Fff4a229102F62328220A96444",
              price: 0.059933,
            },
            {
              chainId: "1",
              name: "Props",
              symbol: "PROPS",
              address: "0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41",
              price: 0.05987,
            },
            {
              chainId: "1",
              name: "K21",
              symbol: "K21",
              address: "0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af",
              price: 0.057013,
            },
            {
              chainId: "1",
              name: "Opium Network",
              symbol: "OPIUM",
              address: "0x888888888889c00c67689029d7856aac1065ec11",
              price: 0.05697,
            },
            {
              chainId: "1",
              name: "One Cash",
              symbol: "ONC",
              address: "0xD90E69f67203EBE02c917B5128629E77B4cd92dc",
              price: 0.056641,
            },
            {
              chainId: "56",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0xe6ce27025f13f5213bbc560dc275e292965a392f",
              price: 0.056247,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "56",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.055815,
            },
            {
              chainId: "1",
              name: "Dragonchain",
              symbol: "DRGN",
              address: "0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e",
              price: 0.05525,
            },
            {
              chainId: "1",
              name: "FrogSwap",
              symbol: "FROG",
              address: "0x4fee21439f2b95b72da2f9f901b3956f27fe91d5",
              price: 0.054894,
            },
            {
              chainId: "1",
              name: "ECOx",
              symbol: "ECOx",
              address: "0xcccD1Ba9f7acD6117834E0D28F25645dECb1736a",
              price: 0.05339,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "Yam",
              symbol: "YAM",
              address: "0x0aacfbec6a24756c20d41914f2caba817c0d8521",
              price: 0.052444,
            },
            {
              chainId: "1",
              name: "Hedget",
              symbol: "HGET",
              address: "0x7968bc6a03017eA2de509AAA816F163Db0f35148",
              price: 0.051959,
            },
            {
              chainId: "1",
              name: "Aladdin DAO",
              symbol: "ALD",
              address: "0xb26c4b3ca601136daf98593feaeff9e0ca702a8d",
              price: 0.051837,
            },
            {
              chainId: "1",
              name: "DoraFactory",
              symbol: "DORA",
              address: "0xbc4171f45ef0ef66e76f979df021a34b46dcc81d",
              price: 0.05151,
            },
            {
              chainId: "1",
              name: "Gamma Strategies",
              symbol: "GAMMA",
              address: "0x6bea7cfef803d1e3d5f7c0103f7ded065644e197",
              price: 0.0515,
            },
            {
              chainId: "10",
              name: "Velodrome Finance",
              symbol: "velo",
              address: "0x3c8b650257cfb5f272f799f5e2b4e65093a11a05",
              price: 0.051008,
            },
            {
              chainId: "1",
              name: "Hacken Token",
              symbol: "HAI",
              address: "0x05Fb86775Fd5c16290f1E838F5caaa7342bD9a63",
              price: 0.04948973,
            },
            {
              chainId: "56",
              name: "Hacken Token",
              symbol: "HAI",
              address: "0xaa9e582e5751d703f85912903bacaddfed26484c",
              price: 0.04948973,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "CVI",
              symbol: "GOVI",
              address: "0xeeaa40b28a2d1b0b08f6f97bb1dd4b75316c6107",
              price: 0.04911263,
            },
            {
              chainId: "1",
              name: "Lossless Protocol",
              symbol: "LSS",
              address: "0x3b9be07d622accaed78f479bc0edabfd6397e320",
              price: 0.04878451,
            },
            {
              chainId: "56",
              name: "Lossless Protocol",
              symbol: "LSS",
              address: "0xf7686f43591302cd9b4b9c4fe1291473fae7d9c9",
              price: 0.04878451,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Big Data Protocol",
              symbol: "BDP",
              address: "0xf3dcbc6D72a4E1892f7917b7C43b74131Df8480e",
              price: 0.04866796,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "56",
              name: "STEPN",
              symbol: "GMT",
              address: "0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1",
              price: 0.04773271,
            },
            {
              chainId: "1",
              name: "BreederDAO",
              symbol: "BREED",
              address: "0x94E9EB8b5Ab9fd6B9ea3169D55FFAde62a01702e",
              price: 0.0468615,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "Graphlinq Protocol",
              symbol: "GLQ",
              address: "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24",
              price: 0.0451987,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "HUMAN Protocol",
              symbol: "HMT",
              address: "0xd1ba9bac957322d6e8c07a160a3a8da11a0d2867",
              price: 0.04474936,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "Fear",
              symbol: "FEAR",
              address: "0x88a9a52f944315d5b4e917b9689e65445c401e83",
              price: 0.04334569,
            },
            {
              chainId: "56",
              name: "Fear",
              symbol: "FEAR",
              address: "0x9ba6a67a6f3b21705a46b380a1b97373a33da311",
              price: 0.04334569,
            },
            {
              chainId: "1",
              name: "HarryPotterObamaSonic10Inu",
              symbol: "BITCOIN",
              address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
              price: 0.04305609,
            },
            {
              chainId: "1",
              name: "QANplatform",
              symbol: "QANX",
              address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
              price: 0.04278893,
            },
            {
              chainId: "56",
              name: "QANplatform",
              symbol: "QANX",
              address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
              price: 0.04278893,
            },
            {
              chainId: "1",
              name: "SpaceY2025",
              symbol: "SPAY",
              address: "0x58FaD9E3C3AE54c9BA98c3f0E4bF88aB3E8Cf3c5",
              price: 0.04274345,
            },
            {
              chainId: "1",
              name: "PERI Finance",
              symbol: "PERI",
              address: "0x5d30aD9C6374Bf925D0A75454fa327AACf778492",
              price: 0.04269197,
            },
            {
              chainId: "137",
              name: "PERI Finance",
              symbol: "PERI",
              address: "0xdc0e17eae3b9651875030244b971fa0223a1764f",
              price: 0.04269197,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "56",
              name: "Gold Fever",
              symbol: "NGL",
              address: "0x0f5d8cd195a4539bcf2ec6118c6da50287c6d5f5",
              price: 0.04175879,
            },
            {
              chainId: "1",
              name: "Numbers Protocol",
              symbol: "NUM",
              address: "0x3496b523e5c00a4b4150d6721320cddb234c3079",
              price: 0.04150833,
            },
            {
              chainId: "56",
              name: "PlayZap",
              symbol: "PZP",
              address: "0x6ad9E9c098a45B2B41b519119C31c3DcB02ACcB2",
              price: 0.04091874,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "56",
              name: "Xend Finance",
              symbol: "XEND",
              address: "0x4a080377f83d669d7bb83b3184a8a5e61b500608",
              price: 0.03908406,
            },
            {
              chainId: "1",
              name: "Xend Finance",
              symbol: "XEND",
              address: "0xe4cfe9eaa8cdb0942a80b7bc68fd8ab0f6d44903",
              price: 0.03908406,
            },
            {
              chainId: "56",
              name: "MATH",
              symbol: "MATH",
              address: "0xf218184af829cf2b0019f8e6f0b2423498a36983",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "Filecoin Standard Full Hashrate",
              symbol: "SFIL",
              address: "0x965b85d4674f64422c4898c8f8083187f02b32c0",
              price: 0.03854268,
            },
            {
              chainId: "137",
              name: "iMe Lab",
              symbol: "LIME",
              address: "0x7f67639Ffc8C93dD558d452b8920b28815638c44",
              price: 0.03836654,
            },
            {
              chainId: "56",
              name: "iMe Smart Platform",
              symbol: "LIME",
              address: "0x7bc75e291e656e8658d66be1cc8154a3769a35dd",
              price: 0.03836654,
            },
            {
              chainId: "1",
              name: "iMe Smart Platform",
              symbol: "LIME",
              address: "0x9d0b65a76274645b29e4cc41b8f23081fa09f4a3",
              price: 0.03836654,
            },
            {
              chainId: "56",
              name: "Hypercycle",
              symbol: "HYPC",
              address: "0x7881cD2B5724431372F57C50E91611352557A606",
              price: 0.03835227,
            },
            {
              chainId: "1",
              name: "Humans.ai",
              symbol: "HEART",
              address: "0x8FAc8031e079F409135766C7d5De29cf22EF897C",
              price: 0.03829733,
            },
            {
              chainId: "56",
              name: "Altura",
              symbol: "ALU",
              address: "0x8263cd1601fe73c066bf49cc09841f35348e3be0",
              price: 0.03826055,
            },
            {
              chainId: "56",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xbc7d6b50616989655afd682fb42743507003056d",
              price: 0.03818795,
            },
            {
              chainId: "1",
              name: "Axis DeFi",
              symbol: "AXIS",
              address: "0xecc0f1f860a82ab3b442382d93853c02d6384389",
              price: 0.03717507,
            },
            {
              chainId: "1",
              name: "Basis Share",
              symbol: "BAS",
              address: "0x106538CC16F938776c7c180186975BCA23875287",
              price: 0.03715319,
            },
            {
              chainId: "56",
              name: "Race Kingdom",
              symbol: "ATOZ",
              address: "0x3606f220daeaeb3d47ac1923a8ce2a61205c88cd",
              price: 0.03652451,
            },
            {
              chainId: "1",
              name: "P00LS",
              symbol: "00",
              address: "0x881Ba05de1E78f549cC63a8f6Cabb1d4AD32250D",
              price: 0.03639498,
            },
            {
              chainId: "1",
              name: "AscendEx Token",
              symbol: "ASD",
              address: "0xff742d05420b6aca4481f635ad8341f81a6300c2",
              price: 0.03628634,
            },
            {
              chainId: "1",
              name: "XY Finance",
              symbol: "XY",
              address: "0x77777777772cf0455fb38ee0e75f38034dfa50de",
              price: 0.03625009,
            },
            {
              chainId: "56",
              name: "VeChain",
              symbol: "VET",
              address: "0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888",
              price: 0.03602603,
            },
            {
              chainId: "1",
              name: "XDEFI Wallet",
              symbol: "XDEFI",
              address: "0x72b886d09c117654ab7da13a14d603001de0b777",
              price: 0.03577743,
            },
            {
              chainId: "56",
              name: "A2DAO",
              symbol: "ATD",
              address: "0x1ce440d1a64eea6aa1db2a5aa51c9b326930957c",
              price: 0.03576558,
            },
            {
              chainId: "1",
              name: "A2DAO",
              symbol: "ATD",
              address: "0x8052327f1baf94a9dc8b26b9100f211ee3774f54",
              price: 0.03576558,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "56",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "56",
              name: "Gamestarter",
              symbol: "GAME",
              address: "0x66109633715d2110ddA791E64a7B2afadb517aBB",
              price: 0.03512917,
            },
            {
              chainId: "1",
              name: "Gamestarter",
              symbol: "GAME",
              address: "0xD567B5F02b9073aD3a982a099a23Bf019FF11d1c",
              price: 0.03512917,
            },
            {
              chainId: "56",
              name: "CryptoXpress",
              symbol: "XPRESS",
              address: "0xaa9826732f3a4973ff8b384b3f4e3c70c2984651",
              price: 0.03500007,
            },
            {
              chainId: "1",
              name: "Defactor",
              symbol: "FACTR",
              address: "0xe0bceef36f3a6efdd5eebfacd591423f8549b9d5",
              price: 0.03488977,
            },
            {
              chainId: "1",
              name: "PolySwarm",
              symbol: "NCT",
              address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
              price: 0.03448223,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "56",
              name: "IDEX",
              symbol: "IDEX",
              address: "0x0856978F7fFff0a2471B4520E3521c4B3343e36f",
              price: 0.03389441,
            },
            {
              chainId: "1",
              name: "Tranche Finance",
              symbol: "SLICE",
              address: "0x0aee8703d34dd9ae107386d3eff22ae75dd616d1",
              price: 0.03388895,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "56",
              name: "Biswap",
              symbol: "BSW",
              address: "0x965f527d9159dce6288a2219db51fc6eef120dd1",
              price: 0.03340309,
            },
            {
              chainId: "1",
              name: "Neutrino Index Token",
              symbol: "XTN",
              address: "0x674C6Ad92Fd080e4004b2312b45f796a192D27a0",
              price: 0.03309649,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "56",
              name: "Numbers Protocol",
              symbol: "NUM",
              address: "0xeceb87cf00dcbf2d4e2880223743ff087a995ad9",
              price: 0.03241382,
            },
            {
              chainId: "1",
              name: "mStable Governance Token",
              symbol: "MTA",
              address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
              price: 0.03171461,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "Syntropy",
              symbol: "NOIA",
              address: "0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca",
              price: 0.03117328,
            },
            {
              chainId: "1",
              name: "Mintlayer",
              symbol: "ML",
              address: "0x059956483753947536204e89bfaD909E1a434Cc6",
              price: 0.03113184,
            },
            {
              chainId: "1",
              name: "UniLayer",
              symbol: "LAYER",
              address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
              price: 0.03082503,
            },
            {
              chainId: "1",
              name: "Town Star",
              symbol: "TOWN",
              address: "0x3dd98c8a089dbcff7e8fc8d4f532bd493501ab7f",
              price: 0.03080765,
            },
            {
              chainId: "56",
              name: "SpaceY2025",
              symbol: "SPAY",
              address: "0x13A637026dF26F846D55ACC52775377717345c06",
              price: 0.03063754,
            },
            {
              chainId: "56",
              name: "MarsDAO",
              symbol: "MDAO",
              address: "0x60322971a672b81bcce5947706d22c19daecf6fb",
              price: 0.03026802,
            },
            {
              chainId: "1",
              name: "KIRA Network",
              symbol: "KEX",
              address: "0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8",
              price: 0.03020909,
            },
            {
              chainId: "1",
              name: "UniTrade",
              symbol: "TRADE",
              address: "0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
              price: 0.03005136,
            },
            {
              chainId: "1",
              name: "Hello Pets",
              symbol: "PET",
              address: "0xB870679a7Fa65b924026F496De7f27c1DD0e5C5F",
              price: 0.02987464,
            },
            {
              chainId: "1",
              name: "Blockchain Cuties Universe",
              symbol: "BCUG",
              address: "0x14da7b27b2e0fedefe0a664118b0c9bc68e2e9af",
              price: 0.02978755,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "56",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0864c156b3c5f69824564dec60c629ae6401bf2a",
              price: 0.02936139,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "56",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xe0f94ac5462997d2bc57287ac3a3ae4c31345d66",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "MiniSwap",
              symbol: "MINI",
              address: "0x4d953cf077c0c95ba090226e59a18fcf97db44ec",
              price: 0.02921092,
            },
            {
              chainId: "1",
              name: "dKargo",
              symbol: "DKA",
              address: "0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0",
              price: 0.02821723,
            },
            {
              chainId: "56",
              name: "Artrade",
              symbol: "ATR",
              address: "0x7559C49c3Aec50E763A486bB232fA8d0d76078e4",
              price: 0.02788126,
            },
            {
              chainId: "1",
              name: "AllianceBlock Nexera",
              symbol: "NXRA",
              address: "0x644192291cc835A93d6330b24EA5f5FEdD0eEF9e",
              price: 0.02779917,
            },
            {
              chainId: "1",
              name: "Orbs",
              symbol: "ORBS",
              address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
              price: 0.02748275,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "PureFi",
              symbol: "UFI",
              address: "0xcDa4e840411C00a614aD9205CAEC807c7458a0E3",
              price: 0.02718081,
            },
            {
              chainId: "56",
              name: "PureFi",
              symbol: "UFI",
              address: "0xe2a59D5E33c6540E18aAA46BF98917aC3158Db0D",
              price: 0.02718081,
            },
            {
              chainId: "1",
              name: "VAIOT",
              symbol: "VAI",
              address: "0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c",
              price: 0.02690659,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "56",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x5857c96dae9cf8511b08cb07f85753c472d36ea3",
              price: 0.02641525,
            },
            {
              chainId: "1",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
              price: 0.02641525,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Governor DAO",
              symbol: "GDAO",
              address: "0x515d7e9d75e2b76db60f8a051cd890eba23286bc",
              price: 0.02613436,
            },
            {
              chainId: "56",
              name: "CLV",
              symbol: "CLV",
              address: "0x09e889bb4d5b474f561db0491c38702f367a4e4d",
              price: 0.02610927,
            },
            {
              chainId: "56",
              name: "Grizzly Honey",
              symbol: "GHNY",
              address: "0xa045e37a0d1dd3a45fefb8803d22457abc0a728a",
              price: 0.02589251,
            },
            {
              chainId: "56",
              name: "TRVL",
              symbol: "TRVL",
              address: "0x6a8fd46f88dbd7bdc2d536c604f811c63052ce0f",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "TRVL",
              symbol: "TRVL",
              address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "Guild of Guardians",
              symbol: "GOG",
              address: "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62",
              price: 0.02583595,
            },
            {
              chainId: "56",
              name: "Loop Network",
              symbol: "LOOP",
              address: "0xce186ad6430e2fe494a22c9edbd4c68794a28b35",
              price: 0.02567973,
            },
            {
              chainId: "1",
              name: "GamerCoin",
              symbol: "GHX",
              address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
              price: 0.02555778,
            },
            {
              chainId: "56",
              name: "Hashtagger",
              symbol: "MOOO",
              address: "0xa0b9bb05da11e3b19ffd64554400f59d4a378515",
              price: 0.02539848,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "137",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xB5C064F955D8e7F38fE0460C556a72987494eE17",
              price: 0.02524112,
            },
            {
              chainId: "1",
              name: "Altered State Token",
              symbol: "ASTO",
              address: "0x823556202e86763853b40e9cde725f412e294689",
              price: 0.02506057,
            },
            {
              chainId: "1",
              name: "Cornucopias",
              symbol: "COPI",
              address: "0x42baf1f659d765c65ade5bb7e08eb2c680360d9d",
              price: 0.02493616,
            },
            {
              chainId: "56",
              name: "BSCPAD",
              symbol: "BSCPAD",
              address: "0x5a3010d4d8d3b5fb49f8b6e57fb9e48063f16700",
              price: 0.02488026,
            },
            {
              chainId: "1",
              name: "Wrapped Nine Chronicles",
              symbol: "WNCG",
              address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
              price: 0.0247011,
            },
            {
              chainId: "42161",
              name: "Radiant Capital",
              symbol: "RDNT",
              address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
              price: 0.02462506,
            },
            {
              chainId: "1",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
              price: 0.0245393,
            },
            {
              chainId: "1",
              name: "Fusion",
              symbol: "FSN",
              address: "0x979aca85ba37c675e78322ed5d97fa980b9bdf00",
              price: 0.02450648,
            },
            {
              chainId: "1",
              name: "Kattana",
              symbol: "KTN",
              address: "0x491e136ff7ff03e6ab097e54734697bb5802fc1c",
              price: 0.02446446,
            },
            {
              chainId: "56",
              name: "Kattana",
              symbol: "KTN",
              address: "0xDAe6c2A48BFAA66b43815c5548b10800919c993E",
              price: 0.02446446,
            },
            {
              chainId: "1",
              name: "HiBAYC",
              symbol: "HIBAYC",
              address: "0x83031984B45553070a088273f341BfF7fB4f2F46",
              price: 0.02413121,
            },
            {
              chainId: "1",
              name: "WOM Protocol",
              symbol: "WOM",
              address: "0xbd356a39bff2cada8e9248532dd879147221cf76",
              price: 0.02389788,
            },
            {
              chainId: "56",
              name: "Media Industry Licensing Content",
              symbol: "MLT",
              address: "0x4518231a8fdf6ac553b9bbd51bbb86825b583263",
              price: 0.02369595,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Stobox",
              symbol: "STBU",
              address: "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
              price: 0.02233193,
            },
            {
              chainId: "56",
              name: "Stobox",
              symbol: "STBU",
              address: "0xb0c4080a8Fa7afa11a09473f3be14d44AF3f8743",
              price: 0.02233193,
            },
            {
              chainId: "137",
              name: "Stobox",
              symbol: "STBU",
              address: "0xcf403036bc139d30080d2cf0f5b48066f98191bb",
              price: 0.02233193,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "137",
              name: "Kasta",
              symbol: "KASTA",
              address: "0x235737dbb56e8517391473f7c964db31fa6ef280",
              price: 0.02210131,
            },
            {
              chainId: "56",
              name: "Berry Data",
              symbol: "BRY",
              address: "0xf859bf77cbe8699013d6dbc7c2b926aaf307f830",
              price: 0.02209635,
            },
            {
              chainId: "56",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
              price: 0.02208889,
            },
            {
              chainId: "1",
              name: "Talken",
              symbol: "TALK",
              address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
              price: 0.02205094,
            },
            {
              chainId: "56",
              name: "BullPerks",
              symbol: "BLP",
              address: "0xfe1d7f7a8f0bda6e415593a2e4f82c64b446d404",
              price: 0.02199835,
            },
            {
              chainId: "1",
              name: "Red Kite",
              symbol: "PKF",
              address: "0x8b39b70e39aa811b69365398e0aace9bee238aeb",
              price: 0.02199272,
            },
            {
              chainId: "1",
              name: "ParaSwap",
              symbol: "PSP",
              address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
              price: 0.02181516,
            },
            {
              chainId: "1",
              name: "Gold Fever",
              symbol: "NGL",
              address: "0x2653891204f463fb2a2f4f412564b19e955166ae",
              price: 0.0217287,
            },
            {
              chainId: "56",
              name: "UBXS",
              symbol: "UBXS",
              address: "0x4f1960e29b2ca581a38c5c474e123f420f8092db",
              price: 0.02167213,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "Lootex",
              symbol: "LOOT",
              address: "0x721A1B990699eE9D90b6327FaaD0A3E840aE8335",
              price: 0.02148433,
            },
            {
              chainId: "1",
              name: "Kleros",
              symbol: "PNK",
              address: "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
              price: 0.02138943,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "PAID Network",
              symbol: "PAID",
              address: "0x1614f18fc94f47967a3fbe5ffcd46d4e7da3d787",
              price: 0.02079176,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "137",
              name: "Chain Games",
              symbol: "CHAIN",
              address: "0xd55fCe7CDaB84d84f2EF3F99816D765a2a94a509",
              price: 0.02059801,
            },
            {
              chainId: "56",
              name: "Bitcoin Standard Hashrate Token",
              symbol: "BTCST",
              address: "0x78650b139471520656b9e7aa7a5e9276814a38e9",
              price: 0.020452,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Oobit",
              symbol: "OBT",
              address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
              price: 0.02010881,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "56",
              name: "Pomerium",
              symbol: "PMG",
              address: "0x0733618Ab62eEEC815f2d1739b7a50bF9E74d8a2",
              price: 0.01966403,
            },
            {
              chainId: "1",
              name: "Chain Games",
              symbol: "CHAIN",
              address: "0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
              price: 0.01936457,
            },
            {
              chainId: "1",
              name: "Juggernaut",
              symbol: "JGN",
              address: "0x73374ea518de7addd4c2b624c0e8b113955ee041",
              price: 0.01925424,
            },
            {
              chainId: "56",
              name: "MacaronSwap",
              symbol: "MCRN",
              address: "0xacb2d47827c9813ae26de80965845d80935afd0b",
              price: 0.01920402,
            },
            {
              chainId: "137",
              name: "MacaronSwap",
              symbol: "MCRN",
              address: "0xba25b552c8a098afdf276324c32c71fe28e0ad40",
              price: 0.01920402,
            },
            {
              chainId: "1",
              name: "Value Liquidity",
              symbol: "VALUE",
              address: "0x49e833337ece7afe375e44f4e3e8481029218e5c",
              price: 0.01919647,
            },
            {
              chainId: "56",
              name: "Dark Frontiers",
              symbol: "DARK",
              address: "0x12fc07081fab7de60987cad8e8dc407b606fb2f8",
              price: 0.01838361,
            },
            {
              chainId: "1",
              name: "NAGA",
              symbol: "NGC",
              address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
              price: 0.0183165,
            },
            {
              chainId: "1",
              name: "Morpher",
              symbol: "MPH",
              address: "0x6369c3dadfc00054a42ba8b2c09c48131dd4aa38",
              price: 0.01829804,
            },
            {
              chainId: "56",
              name: "Revolve Games",
              symbol: "RPG",
              address: "0x01e0d17a533e5930a349c2bb71304f04f20ab12b",
              price: 0.01815475,
            },
            {
              chainId: "56",
              name: "MyDeFiPet",
              symbol: "DPET",
              address: "0xfb62ae373aca027177d1c18ee0862817f9080d08",
              price: 0.01814122,
            },
            {
              chainId: "1",
              name: "Nord Finance",
              symbol: "NORD",
              address: "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
              price: 0.0180385,
            },
            {
              chainId: "1",
              name: "DeHive",
              symbol: "DHV",
              address: "0x62dc4817588d53a056cbbd18231d91ffccd34b2a",
              price: 0.01786512,
            },
            {
              chainId: "56",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0xf307910a4c7bbc79691fd374889b36d8531b08e3",
              price: 0.01776753,
            },
            {
              chainId: "1",
              name: "Angle",
              symbol: "ANGLE",
              address: "0x31429d1856ad1377a8a0079410b297e1a9e214c2",
              price: 0.01770152,
            },
            {
              chainId: "56",
              name: "AIPad",
              symbol: "AIPAD",
              address: "0xe55d97a97ae6a17706ee281486e98a84095d8aaf",
              price: 0.01764417,
            },
            {
              chainId: "1",
              name: "Media Industry Licensing Content",
              symbol: "MLT",
              address: "0x9506d37f70eB4C3d79C398d326C871aBBf10521d",
              price: 0.017328,
            },
            {
              chainId: "56",
              name: "Gala",
              symbol: "GALA",
              address: "0x7ddee176f665cd201f93eede625770e2fd911990",
              price: 0.01720889,
            },
            {
              chainId: "1",
              name: "Poolz",
              symbol: "POOLZ",
              address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
              price: 0.01719548,
            },
            {
              chainId: "1",
              name: "Bit2Me",
              symbol: "B2M",
              address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
              price: 0.01691978,
            },
            {
              chainId: "56",
              name: "Hollywood Capital Group WARRIOR",
              symbol: "WOR",
              address: "0xd6edbb510af7901b2c049ce778b65a740c4aeb7f",
              price: 0.01646549,
            },
            {
              chainId: "56",
              name: "DNAxCAT Token",
              symbol: "DXCT",
              address: "0x5b1baec64af6dc54e6e04349315919129a6d3c23",
              price: 0.01642372,
            },
            {
              chainId: "137",
              name: "NASDEX",
              symbol: "NSDX",
              address: "0xE8d17b127BA8b9899a160D9a07b69bCa8E08bfc6",
              price: 0.01617909,
            },
            {
              chainId: "1",
              name: "disBalancer",
              symbol: "DDOS",
              address: "0x7fbec0bb6a7152e77c30d005b5d49cbc08a602c3",
              price: 0.01599044,
            },
            {
              chainId: "42161",
              name: "Vela Token",
              symbol: "VELA",
              address: "0x088cd8f5ef3652623c22d48b1605dcfe860cd704",
              price: 0.0159526,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "56",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0x23396cf899ca06c4472205fc903bdb4de249d6fc",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Hillstone",
              symbol: "HSF",
              address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
              price: 0.01562664,
            },
            {
              chainId: "1",
              name: "Everscale",
              symbol: "EVER",
              address: "0x29d578CEc46B50Fa5C88a99C6A4B70184C062953",
              price: 0.01560956,
            },
            {
              chainId: "1",
              name: "SmarDex",
              symbol: "SDEX",
              address: "0x5DE8ab7E27f6E7A1fFf3E5B337584Aa43961BEeF",
              price: 0.01537551,
            },
            {
              chainId: "1",
              name: "Rejuve.AI",
              symbol: "RJV",
              address: "0x02c3296C6eb50249f290AE596F2bE9454bFfadaB",
              price: 0.01529513,
            },
            {
              chainId: "56",
              name: "Rejuve.AI",
              symbol: "RJV",
              address: "0x1135883a1bc6776bf90c97845adc491922106dfb",
              price: 0.01529513,
            },
            {
              chainId: "42161",
              name: "Sperax",
              symbol: "SPA",
              address: "0x5575552988A3A80504bBaeB1311674fCFd40aD4B",
              price: 0.0152261,
            },
            {
              chainId: "56",
              name: "Cornucopias",
              symbol: "COPI",
              address: "0xfea292e5ea4510881bdb840e3cec63abd43f936f",
              price: 0.01516869,
            },
            {
              chainId: "1",
              name: "Dvision Network",
              symbol: "DVI",
              address: "0x10633216e7e8281e33c86f02bf8e565a635d9770",
              price: 0.0148875,
            },
            {
              chainId: "1",
              name: "e-Radix",
              symbol: "EXRD",
              address: "0x6468e79a80c0eab0f9a2b574c8d5bc374af59414",
              price: 0.01474534,
            },
            {
              chainId: "1",
              name: "Spherium",
              symbol: "SPHRI",
              address: "0x8a0cdfab62ed35b836dc0633482798421c81b3ec",
              price: 0.01472296,
            },
            {
              chainId: "56",
              name: "Wonderman Nation",
              symbol: "WNDR",
              address: "0xDfd7b0dD7Bf1012DfDf3307a964c36b972300Ac8",
              price: 0.01458667,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "56",
              name: "Zilliqa",
              symbol: "ZIL",
              address: "0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787",
              price: 0.01450028,
            },
            {
              chainId: "56",
              name: "Thetan Arena",
              symbol: "THG",
              address: "0x9fd87aefe02441b123c3c32466cd9db4c578618f",
              price: 0.01446348,
            },
            {
              chainId: "1",
              name: "Rubic",
              symbol: "RBC",
              address: "0x3330bfb7332ca23cd071631837dc289b09c33333",
              price: 0.01430848,
            },
            {
              chainId: "56",
              name: "Dypius",
              symbol: "DYP",
              address: "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17",
              price: 0.01415884,
            },
            {
              chainId: "1",
              name: "Dypius",
              symbol: "DYP",
              address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
              price: 0.01415884,
            },
            {
              chainId: "1",
              name: "Choise.com",
              symbol: "CHO",
              address: "0xBBa39Fd2935d5769116ce38d46a71bde9cf03099",
              price: 0.01408598,
            },
            {
              chainId: "1",
              name: "Hypersign",
              symbol: "HID",
              address: "0xB14eBF566511B9e6002bB286016AB2497B9b9c9D",
              price: 0.01402958,
            },
            {
              chainId: "1",
              name: "Sienna Network",
              symbol: "SIENNA",
              address: "0x9b00e6E8D787b13756eb919786c9745054DB64f9",
              price: 0.0140206,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "MicroChains",
              symbol: "MCG",
              address: "0x9ccf191169a613eca433a249d3f40131178caebc",
              price: 0.01396681,
            },
            {
              chainId: "56",
              name: "Creo Engine",
              symbol: "CREO",
              address: "0x9521728bF66a867BC65A93Ece4a543D817871Eb7",
              price: 0.01393549,
            },
            {
              chainId: "56",
              name: "ClinTex",
              symbol: "CTI",
              address: "0x7c3b67b30efbacc8f787f7ebd3bdc65234299f4c",
              price: 0.01384061,
            },
            {
              chainId: "1",
              name: "ClinTex",
              symbol: "CTI",
              address: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
              price: 0.01384061,
            },
            {
              chainId: "1",
              name: "EDEN",
              symbol: "EDEN",
              address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
              price: 0.01375941,
            },
            {
              chainId: "1",
              name: "Liquid Staking Derivative",
              symbol: "LSD",
              address: "0x97d4f49eeb0e2c96d5ebaa71ab8418e563ecd9fd",
              price: 0.01373326,
            },
            {
              chainId: "56",
              name: "KALM",
              symbol: "KALM",
              address: "0x4ba0057f784858a48fe351445c672ff2a3d43515",
              price: 0.01371732,
            },
            {
              chainId: "56",
              name: "MMPRO Token",
              symbol: "MMPRO",
              address: "0x6067490d05f3cf2fdffc0e353b1f5fd6e5ccdf70",
              price: 0.01329526,
            },
            {
              chainId: "1",
              name: "BOSAGORA",
              symbol: "BOA",
              address: "0x746dda2ea243400d5a63e0700f190ab79f06489e",
              price: 0.01322151,
            },
            {
              chainId: "1",
              name: "Sperax",
              symbol: "SPA",
              address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
              price: 0.01312954,
            },
            {
              chainId: "1",
              name: "Bubblefong",
              symbol: "BBF",
              address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
              price: 0.01299892,
            },
            {
              chainId: "1",
              name: "Ambire Wallet",
              symbol: "WALLET",
              address: "0x88800092ff476844f74dc2fc427974bbee2794ae",
              price: 0.01295567,
            },
            {
              chainId: "56",
              name: "TopGoal",
              symbol: "GOAL",
              address: "0xc4736f2611a62d545dc2d0d8f0766283617e6fcb",
              price: 0.0129284,
            },
            {
              chainId: "56",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x1f9f6a696c6fd109cd3956f45dc709d2b3902163",
              price: 0.01284413,
            },
            {
              chainId: "1",
              name: "Kapital DAO",
              symbol: "KAP",
              address: "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
              price: 0.01284343,
            },
            {
              chainId: "56",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4fa7163e153419e0e1064e418dd7a99314ed27b6",
              price: 0.01264827,
            },
            {
              chainId: "1",
              name: "Sommelier",
              symbol: "SOMM",
              address: "0xa670d7237398238DE01267472C6f13e5B8010FD1",
              price: 0.01257291,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Polkamarkets",
              symbol: "POLK",
              address: "0xD478161C952357F05f0292B56012Cd8457F1cfbF",
              price: 0.0124688,
            },
            {
              chainId: "56",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0x7324c7c0d95cebc73eea7e85cbaac0dbdf88a05b",
              price: 0.01246383,
            },
            {
              chainId: "56",
              name: "Carbon",
              symbol: "CSIX",
              address: "0x04756126F044634C9a0f0E985e60c88a51ACC206",
              price: 0.01222779,
            },
            {
              chainId: "1",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
              price: 0.01210312,
            },
            {
              chainId: "1",
              name: "UnoRe",
              symbol: "UNO",
              address: "0x474021845c4643113458ea4414bdb7fb74a01a77",
              price: 0.01192575,
            },
            {
              chainId: "1",
              name: "Lunyr",
              symbol: "LUN",
              address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
              price: 0.01190772,
            },
            {
              chainId: "1",
              name: "Sidus Heroes DAO",
              symbol: "SENATE",
              address: "0x34Be5b8C30eE4fDe069DC878989686aBE9884470",
              price: 0.01180915,
            },
            {
              chainId: "1",
              name: "HYVE.works",
              symbol: "HYVE",
              address: "0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4",
              price: 0.01167148,
            },
            {
              chainId: "1",
              name: "Torum",
              symbol: "XTM",
              address: "0xcd1faff6e578fa5cac469d2418c95671ba1a62fe",
              price: 0.01165386,
            },
            {
              chainId: "56",
              name: "HELLO Labs",
              symbol: "HELLO",
              address: "0x0f1cbed8efa0e012adbccb1638d0ab0147d5ac00",
              price: 0.0116334,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "1",
              name: "InsurAce",
              symbol: "INSUR",
              address: "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
              price: 0.01148638,
            },
            {
              chainId: "1",
              name: "Domi Online",
              symbol: "DOMI",
              address: "0x45c2f8c9b4c0bdc76200448cc26c48ab6ffef83f",
              price: 0.01137077,
            },
            {
              chainId: "137",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x0d6ae2a429df13e44a07cd2969e085e4833f64a0",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "Revomon",
              symbol: "REVO",
              address: "0x155040625D7ae3e9caDA9a73E3E44f76D3Ed1409",
              price: 0.01127051,
            },
            {
              chainId: "56",
              name: "Revomon",
              symbol: "REVO",
              address: "0x155040625D7ae3e9caDA9a73E3E44f76D3Ed1409",
              price: 0.01127051,
            },
            {
              chainId: "56",
              name: "Evrynet",
              symbol: "EVRY",
              address: "0xC2d4A3709e076A7A3487816362994a78ddaeabB6",
              price: 0.01114784,
            },
            {
              chainId: "1",
              name: "Evrynet",
              symbol: "EVRY",
              address: "0xd7dcd9b99787c619b4d57979521258d1a7267ad7",
              price: 0.01114784,
            },
            {
              chainId: "1",
              name: "Voyager Token",
              symbol: "VGX",
              address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
              price: 0.01113651,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "TruePNL",
              symbol: "PNL",
              address: "0x9fc8f0ca1668e87294941b7f627e9c15ea06b459",
              price: 0.01106399,
            },
            {
              chainId: "56",
              name: "DAOLaunch",
              symbol: "DAL",
              address: "0x53e4b7Aa6cACcb9576548Be3259e62dE4Ddd4417",
              price: 0.01102457,
            },
            {
              chainId: "137",
              name: "Forest Knight",
              symbol: "KNIGHT",
              address: "0x4455ef8b4b4a007a93daa12de63a47eeac700d9d",
              price: 0.01093301,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "99Starz",
              symbol: "STZ",
              address: "0x3f5294df68f871241c4b18fcf78ebd8ac18ab654",
              price: 0.01079599,
            },
            {
              chainId: "56",
              name: "99Starz",
              symbol: "STZ",
              address: "0x7fe378c5e0b5c32af2ecc8829bedf02245a0e4ef",
              price: 0.01079599,
            },
            {
              chainId: "1",
              name: "SportsIcon",
              symbol: "ICONS",
              address: "0x3F68e7B44e9bCB486C2FeAdB7A2289D9cdFC9088",
              price: 0.01073482,
            },
            {
              chainId: "56",
              name: "SportsIcon",
              symbol: "ICONS",
              address: "0xe896aa5e01ef58789f2f17f740af5df33d45f311",
              price: 0.01073482,
            },
            {
              chainId: "1",
              name: "ZeroSwap Token",
              symbol: "ZEE",
              address: "0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
              price: 0.01048836,
            },
            {
              chainId: "1",
              name: "BLOCKv",
              symbol: "VEE",
              address: "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
              price: 0.0104663,
            },
            {
              chainId: "137",
              name: "GensoKishi",
              symbol: "MV",
              address: "0xA3c322Ad15218fBFAEd26bA7f616249f7705D945",
              price: 0.01039675,
            },
            {
              chainId: "56",
              name: "Credefi ",
              symbol: "CREDI",
              address: "0x2235e79086dd23135119366da45851c741874e5b",
              price: 0.01039157,
            },
            {
              chainId: "1",
              name: "Credefi ",
              symbol: "CREDI",
              address: "0xaE6e307c3Fe9E922E5674DBD7F830Ed49c014c6B",
              price: 0.01039157,
            },
            {
              chainId: "56",
              name: "Eagle Network",
              symbol: "EGON",
              address: "0x05995a068bdac17c582eC75AB46bb8e7394be1d9",
              price: 0.01030984,
            },
            {
              chainId: "1",
              name: "Crypterium",
              symbol: "CRPT",
              address: "0x08389495D7456E1951ddF7c3a1314A4bfb646d8B",
              price: 0.01027737,
            },
            {
              chainId: "1",
              name: "Divergence",
              symbol: "DIVER",
              address: "0xfb782396c9b20e564a64896181c7ac8d8979d5f4",
              price: 0.01026706,
            },
            {
              chainId: "1",
              name: "Lumerin",
              symbol: "LMR",
              address: "0x4b1d0b9f081468d780ca1d5d79132b64301085d1",
              price: 0.0101826,
            },
            {
              chainId: "1",
              name: "Exeedme",
              symbol: "XED",
              address: "0xee573a945b01b788b9287ce062a0cfc15be9fd86",
              price: 0.01013534,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "56",
              name: "Galaxy Blitz",
              symbol: "MIT",
              address: "0xe6906717f129427eebade5406de68cadd57aa0c0",
              price: 0.01000415,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "56",
              name: "Lunr",
              symbol: "LUNR",
              address: "0x37807d4fbeb84124347b8899dd99616090d3e304",
              price: 0.00990949,
            },
            {
              chainId: "1",
              name: "Lunr",
              symbol: "LUNR",
              address: "0xA87135285Ae208e22068AcDBFf64B11Ec73EAa5A",
              price: 0.00990949,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "Phuture",
              symbol: "PHTR",
              address: "0xE1Fc4455f62a6E89476f1072530C20CF1A0622dA",
              price: 0.0096358,
            },
            {
              chainId: "1",
              name: "CUDOS",
              symbol: "CUDOS",
              address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
              price: 0.00963311,
            },
            {
              chainId: "56",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0x153C0c947177e631e3DFc594ba28750d3a921FB5",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "CryptoGPT",
              symbol: "GPT",
              address: "0xD04E772BC0d591fBD288f2E2a86aFA3D3CB647F8",
              price: 0.0095165,
            },
            {
              chainId: "1",
              name: "OnX Finance",
              symbol: "ONX",
              address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
              price: 0.00951438,
            },
            {
              chainId: "1",
              name: "MAP Protocol ",
              symbol: "MAP",
              address: "0x9e976f211daea0d652912ab99b0dc21a7fd728e4",
              price: 0.00942732,
            },
            {
              chainId: "137",
              name: "Reel Token",
              symbol: "REELT",
              address: "0x19CcfE396006ffe7A92Ab667b0ef90CE61B66f9f",
              price: 0.00933204,
            },
            {
              chainId: "1",
              name: "Gourmet Galaxy",
              symbol: "GUM",
              address: "0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24",
              price: 0.00917141,
            },
            {
              chainId: "56",
              name: "Gourmet Galaxy",
              symbol: "GUM",
              address: "0xc53708664b99DF348dd27C3Ac0759d2DA9c40462",
              price: 0.00917141,
            },
            {
              chainId: "56",
              name: "Deri Protocol",
              symbol: "DERI",
              address: "0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5",
              price: 0.00912747,
            },
            {
              chainId: "1",
              name: "SwftCoin",
              symbol: "SWFTC",
              address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
              price: 0.00906635,
            },
            {
              chainId: "1",
              name: "Kylin Network",
              symbol: "KYL",
              address: "0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c",
              price: 0.00901207,
            },
            {
              chainId: "1",
              name: "BlockWallet",
              symbol: "BLANK",
              address: "0x41a3dba3d677e573636ba691a70ff2d606c29666",
              price: 0.00889921,
            },
            {
              chainId: "1",
              name: "GroveCoin",
              symbol: "GRV",
              address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
              price: 0.00872181,
            },
            {
              chainId: "56",
              name: "GroveCoin",
              symbol: "GRV",
              address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
              price: 0.00872181,
            },
            {
              chainId: "56",
              name: "KickToken",
              symbol: "KICK",
              address: "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
              price: 0.00860573,
            },
            {
              chainId: "1",
              name: "KickToken (old)",
              symbol: "KICK",
              address: "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
              price: 0.00860573,
            },
            {
              chainId: "1",
              name: "Umbrella Network",
              symbol: "UMB",
              address: "0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2",
              price: 0.00848014,
            },
            {
              chainId: "1",
              name: "EasyFi ",
              symbol: "EZ",
              address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
              price: 0.00815894,
            },
            {
              chainId: "56",
              name: "EasyFi ",
              symbol: "EZ",
              address: "0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83",
              price: 0.00815894,
            },
            {
              chainId: "56",
              name: "O3 Swap",
              symbol: "O3",
              address: "0xee9801669c6138e84bd50deb500827b776777d28",
              price: 0.00803362,
            },
            {
              chainId: "1",
              name: "O3 Swap",
              symbol: "O3",
              address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
              price: 0.00803362,
            },
            {
              chainId: "1",
              name: "Shping",
              symbol: "SHPING",
              address: "0x7c84e62859d0715eb77d1b1c4154ecd6abb21bec",
              price: 0.00801046,
            },
            {
              chainId: "56",
              name: "Ramifi Protocol",
              symbol: "RAM",
              address: "0x63290fc683d11ea077aba09596ff7387d49df912",
              price: 0.00798426,
            },
            {
              chainId: "1",
              name: "Token Pocket",
              symbol: "TPT",
              address: "0x4161725d019690a3e0de50f6be67b07a86a9fae1",
              price: 0.00794471,
            },
            {
              chainId: "137",
              name: "Vortex Protocol",
              symbol: "VP",
              address: "0xf46cb10e8c5fb9368bbf497a3176b80c0af66d44",
              price: 0.00790239,
            },
            {
              chainId: "1",
              name: "Velas",
              symbol: "VLX",
              address: "0x8C543AED163909142695f2d2aCd0D55791a9Edb9",
              price: 0.00781491,
            },
            {
              chainId: "56",
              name: "ritestream",
              symbol: "RITE",
              address: "0x0f5d54b27bdb556823f96f2536496550f8816dc5",
              price: 0.00773653,
            },
            {
              chainId: "1",
              name: "izumi Finance",
              symbol: "IZI",
              address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
              price: 0.00756683,
            },
            {
              chainId: "56",
              name: "OpenOcean",
              symbol: "OOE",
              address: "0x9029fdfae9a03135846381c7ce16595c3554e10a",
              price: 0.00750744,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "Alphr.Finance",
              symbol: "ALPHR",
              address: "0xaa99199d1e9644b588796F3215089878440D58e0",
              price: 0.0074394,
            },
            {
              chainId: "56",
              name: "Drunk Robots",
              symbol: "METAL",
              address: "0x200C234721b5e549c3693CCc93cF191f90dC2aF9",
              price: 0.00743107,
            },
            {
              chainId: "137",
              name: "Dfyn",
              symbol: "DFYN",
              address: "0xC168E40227E4ebD8C1caE80F7a55a4F0e6D66C97",
              price: 0.00741766,
            },
            {
              chainId: "1",
              name: "GameZone",
              symbol: "GZONE",
              address: "0xb6adb74efb5801160ff749b1985fd3bd5000e938",
              price: 0.00731751,
            },
            {
              chainId: "56",
              name: "GameZone",
              symbol: "GZONE",
              address: "0xb6adb74efb5801160ff749b1985fd3bd5000e938",
              price: 0.00731751,
            },
            {
              chainId: "56",
              name: "Genesis Shards",
              symbol: "GS",
              address: "0x9bA4c78b048EEed69f4eD3CFddeda7B51BAF7cA8",
              price: 0.00726078,
            },
            {
              chainId: "1",
              name: "Genesis Shards",
              symbol: "GS",
              address: "0xe0b9a2c3e9f40cf74b2c7f591b2b0cca055c3112",
              price: 0.00726078,
            },
            {
              chainId: "1",
              name: "ELYSIA",
              symbol: "EL",
              address: "0x2781246fe707bb15cee3e5ea354e2154a2877b16",
              price: 0.00717642,
            },
            {
              chainId: "1",
              name: "Ferrum Network",
              symbol: "FRM",
              address: "0xe5caef4af8780e59df925470b050fb23c43ca68c",
              price: 0.00700849,
            },
            {
              chainId: "56",
              name: "ChainGuardians",
              symbol: "CGG",
              address: "0x1613957159e9b0ac6c80e824f7eea748a32a0ae2",
              price: 0.00699805,
            },
            {
              chainId: "56",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0x84e9a6f9d240fdd33801f7135908bfa16866939a",
              price: 0.00696,
            },
            {
              chainId: "1",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
              price: 0.00696,
            },
            {
              chainId: "56",
              name: "OpenLeverage",
              symbol: "OLE",
              address: "0xa865197a84e780957422237b5d152772654341f3",
              price: 0.00692275,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "56",
              name: "Velas",
              symbol: "VLX",
              address: "0xE9C803F48dFFE50180Bd5B01dC04DA939E3445Fc",
              price: 0.00684454,
            },
            {
              chainId: "1",
              name: "EHash",
              symbol: "EHASH",
              address: "0x2942e3b38e33123965bfbc21e802be943a76bbc6",
              price: 0.00665937,
            },
            {
              chainId: "1",
              name: "DuckDaoDime",
              symbol: "DDIM",
              address: "0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20",
              price: 0.00649844,
            },
            {
              chainId: "56",
              name: "Polygonum Online",
              symbol: "POG",
              address: "0xFCb0f2D2f83a32A847D8ABb183B724C214CD7dD8",
              price: 0.00646777,
            },
            {
              chainId: "137",
              name: "Rebel Bots",
              symbol: "RBLS",
              address: "0xe26cda27c13f4f87cFFc2F437C5900b27eBb5bbB",
              price: 0.00641042,
            },
            {
              chainId: "1",
              name: "GYEN",
              symbol: "GYEN",
              address: "0xc08512927d12348f6620a698105e1baac6ecd911",
              price: 0.00638966,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "VITE",
              symbol: "VITE",
              address: "0x1b793E49237758dBD8b752AFC9Eb4b329d5Da016",
              price: 0.00634219,
            },
            {
              chainId: "56",
              name: "Okratech",
              symbol: "ORT",
              address: "0x9e711221b34a2d4b8f552bd5f4a6c4e7934920f7",
              price: 0.00632469,
            },
            {
              chainId: "1",
              name: "BBS Network",
              symbol: "BBS",
              address: "0xfe459828c90c0ba4bc8b42f5c5d44f316700b430",
              price: 0.00629815,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Gearbox Protocol",
              symbol: "GEAR",
              address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
              price: 0.00627808,
            },
            {
              chainId: "1",
              name: "IOI Token",
              symbol: "IOI",
              address: "0x8b3870df408ff4d7c3a26df852d41034eda11d81",
              price: 0.00627625,
            },
            {
              chainId: "56",
              name: "IOI Token",
              symbol: "IOI",
              address: "0x959229D94c9060552daea25AC17193bcA65D7884",
              price: 0.00627625,
            },
            {
              chainId: "56",
              name: "Domi Online",
              symbol: "DOMI",
              address: "0xbbca42c60b5290f2c48871a596492f93ff0ddc82",
              price: 0.00620751,
            },
            {
              chainId: "1",
              name: "Integral",
              symbol: "ITGR",
              address: "0xd502f487e1841fdc805130e13eae80c61186bc98",
              price: 0.00617147,
            },
            {
              chainId: "1",
              name: "VEGA Protocol",
              symbol: "VEGA",
              address: "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e",
              price: 0.00611416,
            },
            {
              chainId: "1",
              name: "Dejitaru Tsuka",
              symbol: "TSUKA",
              address: "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed",
              price: 0.00611169,
            },
            {
              chainId: "56",
              name: "Position",
              symbol: "POSI",
              address: "0x5CA42204cDaa70d5c773946e69dE942b85CA6706",
              price: 0.00604107,
            },
            {
              chainId: "1",
              name: "Polkacity",
              symbol: "POLC",
              address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
              price: 0.00600761,
            },
            {
              chainId: "56",
              name: "TOOLS",
              symbol: "TOOLS",
              address: "0x1311b352467d2b5c296881badea82850bcd8f886",
              price: 0.00600422,
            },
            {
              chainId: "1",
              name: "Chronicle",
              symbol: "XNL",
              address: "0x06a00715e6f92210af9d7680b584931faf71a833",
              price: 0.00599054,
            },
            {
              chainId: "1",
              name: "Bit.Store",
              symbol: "STORE",
              address: "0x31ea0de8119307aa264bb4b38727aab4e36b074f",
              price: 0.00598265,
            },
            {
              chainId: "56",
              name: "Monsters Clan",
              symbol: "MONS",
              address: "0xe4c797d43631f4d660ec67b5cb0b78ef5c902532",
              price: 0.00592766,
            },
            {
              chainId: "1",
              name: "Golff",
              symbol: "GOF",
              address: "0x488E0369f9BC5C40C002eA7c1fe4fd01A198801c",
              price: 0.00590861,
            },
            {
              chainId: "1",
              name: "TenX",
              symbol: "PAY",
              address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
              price: 0.00586091,
            },
            {
              chainId: "1",
              name: "Cirus",
              symbol: "CIRUS",
              address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
              price: 0.00585288,
            },
            {
              chainId: "56",
              name: "BovineVerse",
              symbol: "BVT",
              address: "0x1DaCbcD9B3fc2d6A341Dca3634439D12bC71cA4d",
              price: 0.00580204,
            },
            {
              chainId: "1",
              name: "OpenLeverage",
              symbol: "OLE",
              address: "0x92CfbEC26C206C90aeE3b7C66A9AE673754FaB7e",
              price: 0.00577445,
            },
            {
              chainId: "56",
              name: "Splinterlands",
              symbol: "SPS",
              address: "0x1633b7157e7638c4d6593436111bf125ee74703f",
              price: 0.00577062,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "56",
              name: "Shockwaves",
              symbol: "NEUROS",
              address: "0x95b0FFfabD2817959Ce410070600D77BcE93D454",
              price: 0.00570767,
            },
            {
              chainId: "56",
              name: "EPIK Prime",
              symbol: "EPIK",
              address: "0x368ce786Ea190f32439074e8d22e12ecb718B44c",
              price: 0.0056189,
            },
            {
              chainId: "1",
              name: "EPIK Prime",
              symbol: "EPIK",
              address: "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
              price: 0.0056189,
            },
            {
              chainId: "1",
              name: "IMPT",
              symbol: "IMPT",
              address: "0x04c17b9d3b29a78f7bd062a57cf44fc633e71f85",
              price: 0.00558023,
            },
            {
              chainId: "1",
              name: "Orbit Chain",
              symbol: "ORC",
              address: "0x662b67d00a13faf93254714dd601f5ed49ef2f51",
              price: 0.00547857,
            },
            {
              chainId: "1",
              name: "Shadows Network",
              symbol: "DOWS",
              address: "0x661ab0ed68000491d98c796146bcf28c20d7c559",
              price: 0.00545102,
            },
            {
              chainId: "1",
              name: "Vodra",
              symbol: "VDR",
              address: "0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe",
              price: 0.00541767,
            },
            {
              chainId: "1",
              name: "Arc",
              symbol: "ARC",
              address: "0xc82e3db60a52cf7529253b4ec688f631aad9e7c2",
              price: 0.00536411,
            },
            {
              chainId: "1",
              name: "StormX",
              symbol: "STMX",
              address: "0xbE9375C6a420D2eEB258962efB95551A5b722803",
              price: 0.00535924,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "ZKSpace",
              symbol: "ZKS",
              address: "0xe4815ae53b124e7263f08dcdbbb757d41ed658c6",
              price: 0.00518445,
            },
            {
              chainId: "1",
              name: "Deri Protocol",
              symbol: "DERI",
              address: "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
              price: 0.00517315,
            },
            {
              chainId: "1",
              name: "Ternoa",
              symbol: "CAPS",
              address: "0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2",
              price: 0.00514558,
            },
            {
              chainId: "1",
              name: "ADAPad",
              symbol: "ADAPAD",
              address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
              price: 0.00512253,
            },
            {
              chainId: "56",
              name: "ADAPad",
              symbol: "ADAPAD",
              address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
              price: 0.00512253,
            },
            {
              chainId: "1",
              name: "Alpaca City",
              symbol: "ALPA",
              address: "0x7ca4408137eb639570f8e647d9bd7b7e8717514a",
              price: 0.00509111,
            },
            {
              chainId: "1",
              name: "OIN Finance",
              symbol: "OIN",
              address: "0x9aeB50f542050172359A0e1a25a9933Bc8c01259",
              price: 0.00508761,
            },
            {
              chainId: "56",
              name: "ReadFi",
              symbol: "RDF",
              address: "0xf29CCcC3460506e8F9bc038D4716C05b76b0441e",
              price: 0.00507166,
            },
            {
              chainId: "1",
              name: "Swash",
              symbol: "SWASH",
              address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
              price: 0.00505555,
            },
            {
              chainId: "56",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x2222227e22102fe3322098e4cbfe18cfebd57c95",
              price: 0.00504183,
            },
            {
              chainId: "1",
              name: "Thorstarter",
              symbol: "XRUNE",
              address: "0x69fa0fee221ad11012bab0fdb45d444d3d2ce71c",
              price: 0.00500647,
            },
            {
              chainId: "1",
              name: "Tierion",
              symbol: "TNT",
              address: "0x08f5a9235b08173b7569f83645d2c7fb55e8ccd8",
              price: 0.0049523,
            },
            {
              chainId: "1",
              name: "Unistake",
              symbol: "UNISTAKE",
              address: "0x9ed8e7c9604790f7ec589f99b94361d8aab64e5e",
              price: 0.00492486,
            },
            {
              chainId: "1",
              name: "delta.theta",
              symbol: "DLTA",
              address: "0x0000000DE40dfa9B17854cBC7869D80f9F98D823",
              price: 0.00484398,
            },
            {
              chainId: "1",
              name: "Farmland Protocol",
              symbol: "FAR",
              address: "0xaae3cf9968d26925bdb73ce3864e0084a20f4687",
              price: 0.00481441,
            },
            {
              chainId: "1",
              name: "Konomi Network",
              symbol: "KONO",
              address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
              price: 0.00472211,
            },
            {
              chainId: "1",
              name: "Dfyn",
              symbol: "DFYN",
              address: "0x9695e0114e12C0d3A3636fAb5A18e6b737529023",
              price: 0.0045632,
            },
            {
              chainId: "1",
              name: "Taraxa",
              symbol: "TARA",
              address: "0xf001937650bb4f62b57521824b2c20f5b91bea05",
              price: 0.00455298,
            },
            {
              chainId: "1",
              name: "Blocery",
              symbol: "BLY",
              address: "0xf8aD7dFe656188A23e89da09506Adf7ad9290D5d",
              price: 0.00453355,
            },
            {
              chainId: "56",
              name: "Monsta Infinite",
              symbol: "MONI",
              address: "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
              price: 0.00452962,
            },
            {
              chainId: "56",
              name: "Alvey Chain",
              symbol: "WALV",
              address: "0x256D1fCE1b1221e8398f65F9B36033CE50B2D497",
              price: 0.00452526,
            },
            {
              chainId: "1",
              name: "Seigniorage Shares",
              symbol: "SHARE",
              address: "0x39795344CBCc76cC3Fb94B9D1b15C23c2070C66D",
              price: 0.00447518,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "56",
              name: "CumRocket",
              symbol: "CUMMIES",
              address: "0x27ae27110350b98d564b9a3eed31baebc82d878d",
              price: 0.00443912,
            },
            {
              chainId: "1",
              name: "MVL",
              symbol: "MVL",
              address: "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
              price: 0.00443705,
            },
            {
              chainId: "42161",
              name: "TridentDAO",
              symbol: "PSI",
              address: "0x602eb0d99a5e3e76d1510372c4d2020e12eaea8a",
              price: 0.00442884,
            },
            {
              chainId: "1",
              name: "LeisureMeta",
              symbol: "LM",
              address: "0x7bec98609cb6378d6f995e8f8097ee78376fbec9",
              price: 0.00442259,
            },
            {
              chainId: "1",
              name: "Oddz Finance",
              symbol: "ODDZ",
              address: "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
              price: 0.00437637,
            },
            {
              chainId: "1",
              name: "SHOPX",
              symbol: "SHOPX",
              address: "0x7bef710a5759d197ec0bf621c3df802c2d60d848",
              price: 0.00435487,
            },
            {
              chainId: "1",
              name: "Peanut",
              symbol: "NUX",
              address: "0x89bd2e7e388fab44ae88bef4e1ad12b4f1e0911c",
              price: 0.00433468,
            },
            {
              chainId: "1",
              name: "MerchDAO ",
              symbol: "MRCH",
              address: "0xbed4ab0019ff361d83ddeb74883dac8a70f5ea1e",
              price: 0.00430597,
            },
            {
              chainId: "1",
              name: "Zipmex",
              symbol: "ZMT",
              address: "0xaa602de53347579f86b996d2add74bb6f79462b2",
              price: 0.00429681,
            },
            {
              chainId: "56",
              name: "Good Games Guild",
              symbol: "GGG",
              address: "0xd8047afecb86e44eff3add991b9f063ed4ca716b",
              price: 0.00429671,
            },
            {
              chainId: "1",
              name: "Faith Tribe",
              symbol: "FTRB",
              address: "0x2596825a84888E8f24b747DF29e11b5dd03C81D7",
              price: 0.00425821,
            },
            {
              chainId: "137",
              name: "Faith Tribe",
              symbol: "FTRB",
              address: "0xC3f56d567E7663e8932E65d85ae4be7Eb5575cA7",
              price: 0.00425821,
            },
            {
              chainId: "1",
              name: "Saito",
              symbol: "SAITO",
              address: "0xfa14fa6958401314851a17d6c5360ca29f74b57b",
              price: 0.00425246,
            },
            {
              chainId: "1",
              name: "Charged Particles",
              symbol: "IONX",
              address: "0x02d3a27ac3f55d5d91fb0f52759842696a864217",
              price: 0.00424643,
            },
            {
              chainId: "1",
              name: "Karus Starter",
              symbol: "KST",
              address: "0xBc17729fDf562723f0267F79FF25aDE441056d87",
              price: 0.00424507,
            },
            {
              chainId: "1",
              name: "X2Y2",
              symbol: "X2Y2",
              address: "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9",
              price: 0.0041817,
            },
            {
              chainId: "56",
              name: "Green Satoshi Token (BSC)",
              symbol: "GST",
              address: "0x4a2c860cEC6471b9F5F5a336eB4F38bb21683c98",
              price: 0.00410656,
            },
            {
              chainId: "1",
              name: "Lord of Dragons",
              symbol: "LOGT",
              address: "0xba58444c8050ed9385b7417533a73644036d21eb",
              price: 0.00408551,
            },
            {
              chainId: "1",
              name: "Dawn Protocol",
              symbol: "DAWN",
              address: "0x580c8520deda0a441522aeae0f9f7a5f29629afa",
              price: 0.00404123,
            },
            {
              chainId: "1",
              name: "Bridge Mutual",
              symbol: "BMI",
              address: "0x725c263e32c72ddc3a19bea12c5a0479a81ee688",
              price: 0.00403866,
            },
            {
              chainId: "1",
              name: "Carbon",
              symbol: "CRBN",
              address: "0xCdeee767beD58c5325f68500115d4B722b3724EE",
              price: 0.0040124,
            },
            {
              chainId: "56",
              name: "GamesPad",
              symbol: "GMPD",
              address: "0x9720CA160Bbd4E7f3dD4bb3f8BD4227ca0342e63",
              price: 0.00398915,
            },
            {
              chainId: "1",
              name: "Open Platform",
              symbol: "OPEN",
              address: "0x9d86b1b2554ec410eccffbf111a6994910111340",
              price: 0.00396984,
            },
            {
              chainId: "56",
              name: "Duckie Land",
              symbol: "MMETA",
              address: "0x7a9c8d33963aecca9a821802adfaf5bd9392351f",
              price: 0.00396564,
            },
            {
              chainId: "1",
              name: "Stone DeFi",
              symbol: "STN",
              address: "0xe63d6b308bce0f6193aec6b7e6eba005f41e36ab",
              price: 0.00392449,
            },
            {
              chainId: "56",
              name: "RFOX",
              symbol: "RFOX",
              address: "0x0a3a21356793b49154fd3bbe91cbc2a16c0457f5",
              price: 0.00391682,
            },
            {
              chainId: "56",
              name: "Supe Infinity",
              symbol: "SUPE",
              address: "0xb972c4027818223bb7b9399b3ca3ca58186e1590",
              price: 0.00390115,
            },
            {
              chainId: "56",
              name: "Vemate",
              symbol: "VMT",
              address: "0xE615C5e7219f9801C3b75bc76E45a4dab3c38e51",
              price: 0.00389178,
            },
            {
              chainId: "1",
              name: "Gather",
              symbol: "GTH",
              address: "0xeb986da994e4a118d5956b02d8b7c3c7ce373674",
              price: 0.00386969,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "56",
              name: "Mdex",
              symbol: "MDX",
              address: "0x9c65ab58d8d978db963e63f2bfb7121627e3a739",
              price: 0.003754,
            },
            {
              chainId: "56",
              name: "Hord",
              symbol: "HORD",
              address: "0x39d4549908e7adcee9b439429294eeb4c65c2c9e",
              price: 0.00371826,
            },
            {
              chainId: "1",
              name: "Hord",
              symbol: "HORD",
              address: "0x43a96962254855f16b925556f9e97be436a43448",
              price: 0.00371826,
            },
            {
              chainId: "1",
              name: "Loom Network [OLD]",
              symbol: "LOOM",
              address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
              price: 0.00370114,
            },
            {
              chainId: "56",
              name: "Vera",
              symbol: "VERA",
              address: "0x4a0a3902e091cdb3aec4279a6bfac50297f0a79e",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "Brokoli",
              symbol: "BRKL",
              address: "0x4674a4F24C5f63D53F22490Fb3A08eAAAD739ff8",
              price: 0.00363769,
            },
            {
              chainId: "56",
              name: "Brokoli",
              symbol: "BRKL",
              address: "0x66cafcf6c32315623c7ffd3f2ff690aa36ebed38",
              price: 0.00363769,
            },
            {
              chainId: "1",
              name: "Furucombo",
              symbol: "COMBO",
              address: "0xfFffFffF2ba8F66D4e51811C5190992176930278",
              price: 0.00360684,
            },
            {
              chainId: "1",
              name: "DinoLFG",
              symbol: "DINO",
              address: "0x49642110b712c1fd7261bc074105e9e44676c68f",
              price: 0.00359667,
            },
            {
              chainId: "56",
              name: "WeSendit",
              symbol: "WSI",
              address: "0x837a130aed114300bab4f9f1f4f500682f7efd48",
              price: 0.00358393,
            },
            {
              chainId: "56",
              name: "Battle Hero",
              symbol: "BATH",
              address: "0x0bc89aa98ad94e6798ec822d0814d934ccd0c0ce",
              price: 0.00350781,
            },
            {
              chainId: "1",
              name: "CoFiX",
              symbol: "COFI",
              address: "0x1a23a6BfBAdB59fa563008c0fB7cf96dfCF34Ea1",
              price: 0.00350266,
            },
            {
              chainId: "1",
              name: "Drops",
              symbol: "DOP",
              address: "0x6bb61215298f296c55b19ad842d3df69021da2ef",
              price: 0.00339802,
            },
            {
              chainId: "1",
              name: "DREP",
              symbol: "DREP",
              address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
              price: 0.00339307,
            },
            {
              chainId: "56",
              name: "DREP",
              symbol: "DREP",
              address: "0xec583f25a049cc145da9a256cdbe9b6201a705ff",
              price: 0.00339307,
            },
            {
              chainId: "56",
              name: "BSC Station",
              symbol: "BSCS",
              address: "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d",
              price: 0.00335845,
            },
            {
              chainId: "1",
              name: "ChainGuardians",
              symbol: "CGG",
              address: "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
              price: 0.00335146,
            },
            {
              chainId: "1",
              name: "Globe Derivative Exchange",
              symbol: "GDT",
              address: "0xc67b12049c2d0cf6e476bc64c7f82fc6c63cffc5",
              price: 0.00334436,
            },
            {
              chainId: "1",
              name: "NFTrade",
              symbol: "NFTD",
              address: "0x8e0fe2947752be0d5acf73aae77362daf79cb379",
              price: 0.00333074,
            },
            {
              chainId: "1",
              name: "pNetwork",
              symbol: "PNT",
              address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
              price: 0.0033276,
            },
            {
              chainId: "1",
              name: "NAOS Finance",
              symbol: "NAOS",
              address: "0x4a615bb7166210cce20e6642a6f8fb5d4d044496",
              price: 0.00331018,
            },
            {
              chainId: "1",
              name: "Smoothy",
              symbol: "SMTY",
              address: "0xbF776e4FCa664D791C4Ee3A71e2722990E003283",
              price: 0.00330507,
            },
            {
              chainId: "56",
              name: "Smoothy",
              symbol: "SMTY",
              address: "0xbF776e4FCa664D791C4Ee3A71e2722990E003283",
              price: 0.00330507,
            },
            {
              chainId: "1",
              name: "APYSwap",
              symbol: "APYS",
              address: "0xf7413489c474ca4399eee604716c72879eea3615",
              price: 0.00329002,
            },
            {
              chainId: "1",
              name: "Kine Protocol",
              symbol: "KINE",
              address: "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d",
              price: 0.00328062,
            },
            {
              chainId: "1",
              name: "Futureswap",
              symbol: "FST",
              address: "0x0e192d382a36de7011f795acc4391cd302003606",
              price: 0.0032432,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "Sashimi",
              symbol: "SASHIMI",
              address: "0xC28E27870558cF22ADD83540d2126da2e4b464c2",
              price: 0.0032074,
            },
            {
              chainId: "1",
              name: "Legends of Crypto",
              symbol: "LOCG",
              address: "0x60eb57d085c59932d5faa6c6026268a4386927d0",
              price: 0.0031953,
            },
            {
              chainId: "56",
              name: "Age of Gods",
              symbol: "AOG",
              address: "0x40c8225329bd3e28a043b029e0d07a5344d2c27c",
              price: 0.00319153,
            },
            {
              chainId: "1",
              name: "CropBytes",
              symbol: "CBX",
              address: "0x37fc4b48ce93469dbea9918468993c735049642a",
              price: 0.00318043,
            },
            {
              chainId: "1",
              name: "Standard Protocol ",
              symbol: "STND",
              address: "0x9040e237C3bF18347bb00957Dc22167D0f2b999d",
              price: 0.00317739,
            },
            {
              chainId: "1",
              name: "ShareToken",
              symbol: "SHR",
              address: "0xd98F75b1A3261dab9eEd4956c93F33749027a964",
              price: 0.00315436,
            },
            {
              chainId: "56",
              name: "Terran Coin",
              symbol: "TRR",
              address: "0xbB95cc1c662D89822bda29D2e147B124406e6e42",
              price: 0.00313891,
            },
            {
              chainId: "1",
              name: "TotemFi",
              symbol: "TOTM",
              address: "0x6ff1bfa14a57594a5874b37ff6ac5efbd9f9599a",
              price: 0.00312213,
            },
            {
              chainId: "56",
              name: "Metan Evolutions",
              symbol: "METAN",
              address: "0x879D239BCC0356Cf9df8c90442488bCe99554c66",
              price: 0.0031178,
            },
            {
              chainId: "56",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0x070a08BeEF8d36734dD67A491202fF35a6A16d97",
              price: 0.00310926,
            },
            {
              chainId: "56",
              name: "pNetwork",
              symbol: "PNT",
              address: "0xdaacb0ab6fb34d24e8a67bfa14bf4d95d4c7af92",
              price: 0.00310465,
            },
            {
              chainId: "1",
              name: "Undead Blocks",
              symbol: "UNDEAD",
              address: "0x310C8F00b9dE3c31Ab95ea68feb6C877538f7947",
              price: 0.00308739,
            },
            {
              chainId: "56",
              name: "TruePNL",
              symbol: "PNL",
              address: "0xb346c52874c7023df183068c39478c3b7b2515bc",
              price: 0.00306463,
            },
            {
              chainId: "1",
              name: "Nestree",
              symbol: "EGG",
              address: "0x65ccd72c0813ce6f2703593b633202a0f3ca6a0c",
              price: 0.00305161,
            },
            {
              chainId: "56",
              name: "Binamon",
              symbol: "BMON",
              address: "0x08ba0619b1e7a582e0bce5bbe9843322c954c340",
              price: 0.00303869,
            },
            {
              chainId: "1",
              name: "Pine Protocol",
              symbol: "PINE",
              address: "0x569424c5EE13884A193773fDC5d1c5f79C443a51",
              price: 0.0029941,
            },
            {
              chainId: "137",
              name: "Pine Protocol",
              symbol: "PINE",
              address: "0x612D833c0c7A54cdfBe9a4328B6d658020563Ec0",
              price: 0.0029941,
            },
            {
              chainId: "56",
              name: "Blocto",
              symbol: "BLT",
              address: "0x02Bdf640fba368E7Ba5c6429cCaF251512273865",
              price: 0.00296109,
            },
            {
              chainId: "56",
              name: "Polkacity",
              symbol: "POLC",
              address: "0x6ae9701b9c423f40d54556c9a443409d79ce170a",
              price: 0.00295847,
            },
            {
              chainId: "1",
              name: "Meta Gaming Guild",
              symbol: "MGG",
              address: "0x7237C0B30B1355f1B76355582f182F6f04B08740",
              price: 0.00294956,
            },
            {
              chainId: "1",
              name: "Sidus Heroes",
              symbol: "SIDUS",
              address: "0x549020a9Cb845220D66d3E9c6D9F9eF61C981102",
              price: 0.00293755,
            },
            {
              chainId: "137",
              name: "Artmeta",
              symbol: "MART",
              address: "0xDcfF29b7bd211Aaef6E4a3989e4d3F732cF5b4b6",
              price: 0.00291633,
            },
            {
              chainId: "56",
              name: "Planet Sandbox",
              symbol: "PSB",
              address: "0x36bfBb1d5B3C9b336f3D64976599B6020cA805F1",
              price: 0.0029161,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "1",
              name: "Wirex",
              symbol: "WXT",
              address: "0xa02120696c7b8fe16c09c749e4598819b2b0e915",
              price: 0.00287729,
            },
            {
              chainId: "1",
              name: "Knit Finance",
              symbol: "KFT",
              address: "0xef53462838000184f35f7d991452e5f25110b207",
              price: 0.00285801,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "56",
              name: "REVV",
              symbol: "REVV",
              address: "0x833f307ac507d47309fd8cdd1f835bef8d702a93",
              price: 0.00281561,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Playcent",
              symbol: "PCNT",
              address: "0x657B83A0336561C8f64389a6f5aDE675C04b0C3b",
              price: 0.00279512,
            },
            {
              chainId: "56",
              name: "Titan Hunters",
              symbol: "TITA",
              address: "0x0c1253a30da9580472064a91946c5ce0C58aCf7f",
              price: 0.00279178,
            },
            {
              chainId: "56",
              name: "VelasPad",
              symbol: "VLXPAD",
              address: "0xb8e3bB633F7276cc17735D86154E0ad5ec9928C0",
              price: 0.00260322,
            },
            {
              chainId: "56",
              name: "Linear",
              symbol: "LINA",
              address: "0x762539b45a1dcce3d36d080f74d1aed37844b878",
              price: 0.00256247,
            },
            {
              chainId: "137",
              name: "Karmaverse",
              symbol: "KNOT",
              address: "0xb763f1177e9b2fb66fbe0d50372e3e2575c043e5",
              price: 0.00253888,
            },
            {
              chainId: "56",
              name: "Mytheria",
              symbol: "MYRA",
              address: "0x6ef238e9e8cd2a96740897761c18894fc086b9d0",
              price: 0.0024599,
            },
            {
              chainId: "1",
              name: "Proxi DeFi",
              symbol: "CREDIT",
              address: "0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4",
              price: 0.00245371,
            },
            {
              chainId: "1",
              name: "EQIFI",
              symbol: "EQX",
              address: "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
              price: 0.0024537,
            },
            {
              chainId: "137",
              name: "Snook",
              symbol: "SNK",
              address: "0x689f8e5913c158ffb5ac5aeb83b3c875f5d20309",
              price: 0.00240428,
            },
            {
              chainId: "1",
              name: "GameCredits",
              symbol: "GAME",
              address: "0x63f88a2298a5c4aee3c216aa6d926b184a4b2437",
              price: 0.00234548,
            },
            {
              chainId: "1",
              name: "LSDx Finance",
              symbol: "LSD",
              address: "0xfAC77A24E52B463bA9857d6b758ba41aE20e31FF",
              price: 0.00234475,
            },
            {
              chainId: "56",
              name: "BabySwap",
              symbol: "BABY",
              address: "0x53e562b9b7e5e94b81f10e96ee70ad06df3d2657",
              price: 0.00233659,
            },
            {
              chainId: "1",
              name: "S.Finance",
              symbol: "SFG",
              address: "0x8a6aca71a218301c7081d4e96d64292d3b275ce0",
              price: 0.00232494,
            },
            {
              chainId: "56",
              name: "GunStar Metaverse",
              symbol: "GSTS",
              address: "0x7eDC0eC89F987ECd85617b891c44fE462a325869",
              price: 0.00229594,
            },
            {
              chainId: "56",
              name: "WonderHero",
              symbol: "WND",
              address: "0xD9931818D75A6ceF4Fb0092A73c6e87867A0751a",
              price: 0.00224673,
            },
            {
              chainId: "1",
              name: "Nsure Network",
              symbol: "NSURE",
              address: "0x20945cA1df56D237fD40036d47E866C7DcCD2114",
              price: 0.00222604,
            },
            {
              chainId: "56",
              name: "Degen Zoo",
              symbol: "DZOO",
              address: "0x56d06a78Ef8E95D6043341f24759e2834BE6f97B",
              price: 0.00222518,
            },
            {
              chainId: "56",
              name: "SugarBounce",
              symbol: "TIP",
              address: "0x40f906e19b14100d5247686e08053c4873c66192",
              price: 0.00221755,
            },
            {
              chainId: "1",
              name: "Acent",
              symbol: "ACE",
              address: "0xec5483804e637d45cde22fa0869656b64b5ab1ab",
              price: 0.00221717,
            },
            {
              chainId: "1",
              name: "Label",
              symbol: "LBL",
              address: "0x2162f572b25f7358db9376ab58a947a4e45cede1",
              price: 0.00220915,
            },
            {
              chainId: "56",
              name: "Label",
              symbol: "LBL",
              address: "0x77edfae59a7948d66e9911a30cc787d2172343d4",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "Label Foundation",
              symbol: "LBL",
              address: "0x2162f572B25f7358db9376AB58a947a4e45CeDE1",
              price: 0.00220915,
            },
            {
              chainId: "56",
              name: "Label Foundation",
              symbol: "LBL",
              address: "0x77edFaE59a7948d66E9911A30cC787d2172343d4",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "ETHA Lend",
              symbol: "ETHA",
              address: "0x59e9261255644c411afdd00bd89162d09d862e38",
              price: 0.00220437,
            },
            {
              chainId: "56",
              name: "Curate",
              symbol: "XCUR",
              address: "0xd52669712f253CD6b2Fe8A8638F66ed726cb770C",
              price: 0.00217892,
            },
            {
              chainId: "1",
              name: "Curate",
              symbol: "XCUR",
              address: "0xE1c7E30C42C24582888C758984f6e382096786bd",
              price: 0.00217892,
            },
            {
              chainId: "56",
              name: "Mist",
              symbol: "MIST",
              address: "0x68E374F856bF25468D365E539b700b648Bf94B67",
              price: 0.00214609,
            },
            {
              chainId: "1",
              name: "Carry Protocol",
              symbol: "CRE",
              address: "0x115eC79F1de567eC68B7AE7eDA501b406626478e",
              price: 0.00214345,
            },
            {
              chainId: "56",
              name: "Meta Gaming Guild",
              symbol: "MGG",
              address: "0x6125adcab2f171bc70cfe2caecfec5509273a86a",
              price: 0.00214186,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "HNB Protocol",
              symbol: "HNB",
              address: "0x6E0615a03eD9527a6013FcD5B556E36EF4DaB1FF",
              price: 0.00213527,
            },
            {
              chainId: "56",
              name: "WAM",
              symbol: "WAM",
              address: "0xebbaeff6217d22e7744394061d874015709b8141",
              price: 0.00212542,
            },
            {
              chainId: "56",
              name: "Lever Network",
              symbol: "LEV",
              address: "0xbc194e6f748a222754c3e8b9946922c09e7d4e91",
              price: 0.00211968,
            },
            {
              chainId: "1",
              name: "Lever Network",
              symbol: "LEV",
              address: "0xbc194e6f748a222754C3E8b9946922c09E7d4e91",
              price: 0.00211968,
            },
            {
              chainId: "137",
              name: "Affyn",
              symbol: "FYN",
              address: "0x3B56a704C01D650147ADE2b8cEE594066b3F9421",
              price: 0.00210564,
            },
            {
              chainId: "1",
              name: "Efforce",
              symbol: "WOZX",
              address: "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f",
              price: 0.00210115,
            },
            {
              chainId: "1",
              name: "BiFi",
              symbol: "BIFI",
              address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
              price: 0.00209525,
            },
            {
              chainId: "1",
              name: "Darwinia Network",
              symbol: "RING",
              address: "0x9469d013805bffb7d3debe5e7839237e535ec483",
              price: 0.00205759,
            },
            {
              chainId: "56",
              name: "Nerve Finance",
              symbol: "NRV",
              address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
              price: 0.00205256,
            },
            {
              chainId: "56",
              name: "Roseon",
              symbol: "ROSN",
              address: "0x651Cd665bD558175A956fb3D72206eA08Eb3dF5b",
              price: 0.00204619,
            },
            {
              chainId: "1",
              name: "DLP Duck Token",
              symbol: "DUCK",
              address: "0xc0ba369c8db6eb3924965e5c4fd0b4c1b91e305f",
              price: 0.00203704,
            },
            {
              chainId: "56",
              name: "Legend of Fantasy War",
              symbol: "LFW",
              address: "0xD71239a33C8542Bd42130c1B4ACA0673B4e4f48B",
              price: 0.00199829,
            },
            {
              chainId: "137",
              name: "Gaia Everworld",
              symbol: "GAIA",
              address: "0x723b17718289a91af252d616de2c77944962d122",
              price: 0.00197659,
            },
            {
              chainId: "1",
              name: "Ally",
              symbol: "ALY",
              address: "0x9d5686eadea7327f5a0c4820dca90457a0e88763",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "56",
              name: "MetaverseX",
              symbol: "METAX",
              address: "0x03f8fdc10d5bcf7508375585b04e93d656d36954",
              price: 0.00194733,
            },
            {
              chainId: "56",
              name: "NFTb",
              symbol: "NFTB",
              address: "0xde3dbbe30cfa9f437b293294d1fd64b26045c71a",
              price: 0.00194005,
            },
            {
              chainId: "1",
              name: "Zelwin",
              symbol: "ZLW",
              address: "0x5319e86F0e41a06E49eb37046b8c11D78bcAd68C",
              price: 0.00193295,
            },
            {
              chainId: "56",
              name: "Zelwin",
              symbol: "ZLW",
              address: "0x5dd1E31E1a0e2E077aC98d2a4b781F418ca50387",
              price: 0.00193295,
            },
            {
              chainId: "137",
              name: "Sheesha Finance Polygon",
              symbol: "mSHEESHA",
              address: "0x88C949b4eB85a90071f2C0beF861BDDEe1a7479D",
              price: 0.0019131,
            },
            {
              chainId: "56",
              name: "Mochi Market",
              symbol: "MOMA",
              address: "0xb72842d6f5fedf91d22d56202802bb9a79c6322e",
              price: 0.00190879,
            },
            {
              chainId: "1",
              name: "Mochi Market",
              symbol: "MOMA",
              address: "0xbd1848e1491d4308ad18287a745dd4db2a4bd55b",
              price: 0.00190879,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "56",
              name: "Deeper Network",
              symbol: "DPR",
              address: "0xA0A2eE912CAF7921eaAbC866c6ef6FEc8f7E90A4",
              price: 0.00189819,
            },
            {
              chainId: "137",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x64ca1571d1476b7a21c5aaf9f1a750a193a103c0",
              price: 0.00188807,
            },
            {
              chainId: "1",
              name: "Stater",
              symbol: "STR",
              address: "0x84bb947fcedba6b9c7dcead42df07e113bb03007",
              price: 0.00188553,
            },
            {
              chainId: "1",
              name: "Agility LSD",
              symbol: "AGI",
              address: "0x5f18ea482ad5cc6bc65803817c99f477043dce85",
              price: 0.00188163,
            },
            {
              chainId: "56",
              name: "delta.theta",
              symbol: "DLTA",
              address: "0x3a06212763caf64bf101daa4b0cebb0cd393fa1a",
              price: 0.00187792,
            },
            {
              chainId: "56",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0xcaf5191fc480f43e4df80106c7695eca56e48b18",
              price: 0.00187378,
            },
            {
              chainId: "1",
              name: "HYPERCOMIC",
              symbol: "HYCO",
              address: "0x77F76483399Dc6328456105B1db23e2Aca455bf9",
              price: 0.00187065,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "56",
              name: "Defina",
              symbol: "FINA",
              address: "0x426c72701833fdDBdFc06c944737C6031645c708",
              price: 0.00184425,
            },
            {
              chainId: "1",
              name: "Blind Boxes",
              symbol: "BLES",
              address: "0xe796d6ca1ceb1b022ece5296226bf784110031cd",
              price: 0.00182817,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "137",
              name: "MetaSoccer",
              symbol: "MSU",
              address: "0xe8377a076adabb3f9838afb77bee96eac101ffb1",
              price: 0.00175265,
            },
            {
              chainId: "1",
              name: "BnkToTheFuture",
              symbol: "BFT",
              address: "0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f",
              price: 0.00172378,
            },
            {
              chainId: "1",
              name: "VEMP",
              symbol: "VEMP",
              address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
              price: 0.00171918,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "56",
              name: "MetaVPad",
              symbol: "METAV",
              address: "0x62858686119135cc00C4A3102b436a0eB314D402",
              price: 0.00170521,
            },
            {
              chainId: "137",
              name: "Galaxy Fight Club",
              symbol: "GCOIN",
              address: "0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
              price: 0.0017042,
            },
            {
              chainId: "1",
              name: "IndiGG",
              symbol: "INDI",
              address: "0x3392d8a60b77f8d3eaa4fb58f09d835bd31add29",
              price: 0.00169575,
            },
            {
              chainId: "56",
              name: "KardiaChain",
              symbol: "KAI",
              address: "0x39ae8eefb05138f418bb27659c21632dc1ddab10",
              price: 0.0016948,
            },
            {
              chainId: "56",
              name: "Sinverse",
              symbol: "SIN",
              address: "0x6397de0f9aedc0f7a8fa8b438dde883b9c201010",
              price: 0.00168684,
            },
            {
              chainId: "1",
              name: "Basis Cash",
              symbol: "BAC",
              address: "0x3449FC1Cd036255BA1EB19d65fF4BA2b8903A69a",
              price: 0.00164413,
            },
            {
              chainId: "56",
              name: "PROJECT XENO",
              symbol: "GXE",
              address: "0x510975edA48A97E0cA228dD04d1217292487bea6",
              price: 0.00161158,
            },
            {
              chainId: "56",
              name: "NanoByte",
              symbol: "NBT",
              address: "0x1D3437E570e93581Bd94b2fd8Fbf202d4a65654A",
              price: 0.00159447,
            },
            {
              chainId: "1",
              name: "NiiFi",
              symbol: "NIIFI",
              address: "0x852e5427c86A3b46DD25e5FE027bb15f53c4BCb8",
              price: 0.00159166,
            },
            {
              chainId: "1",
              name: "Adappter Token",
              symbol: "ADP",
              address: "0xc314b0e758d5ff74f63e307a86ebfe183c95767b",
              price: 0.001579,
            },
            {
              chainId: "56",
              name: "Luna Rush",
              symbol: "LUS",
              address: "0xde301d6a2569aefcfe271b9d98f318baee1d30a4",
              price: 0.00156947,
            },
            {
              chainId: "1",
              name: "Blockchain Brawlers",
              symbol: "BRWL",
              address: "0x4086e77c5e993fdb90a406285d00111a974f877a",
              price: 0.00154996,
            },
            {
              chainId: "1",
              name: "ClearDAO",
              symbol: "CLH",
              address: "0xd7d8f3b8bc8bc48d3acc37879eaba7b85889fa52",
              price: 0.00154543,
            },
            {
              chainId: "1",
              name: "Aluna Social",
              symbol: "ALN",
              address: "0x8185bc4757572da2a610f887561c32298f1a5748",
              price: 0.00154177,
            },
            {
              chainId: "56",
              name: "BunnyPark ",
              symbol: "BP",
              address: "0xacb8f52dc63bb752a51186d1c55868adbffee9c1",
              price: 0.00153481,
            },
            {
              chainId: "1",
              name: "NFTLaunch",
              symbol: "NFTL",
              address: "0xe7f72bc0252ca7b16dbb72eeee1afcdb2429f2dd",
              price: 0.00153145,
            },
            {
              chainId: "56",
              name: "DOTMOOVS",
              symbol: "MOOV",
              address: "0x0ebd9537a25f56713e34c45b38f421a1e7191469",
              price: 0.00153091,
            },
            {
              chainId: "1",
              name: "DOTMOOVS",
              symbol: "MOOV",
              address: "0x24ec2ca132abf8f6f8a6e24a1b97943e31f256a7",
              price: 0.00153091,
            },
            {
              chainId: "42161",
              name: "handle.fi",
              symbol: "FOREX",
              address: "0xDb298285FE4C5410B05390cA80e8Fbe9DE1F259B",
              price: 0.00153034,
            },
            {
              chainId: "1",
              name: "Blockchain Monster Hunt",
              symbol: "BCMC",
              address: "0x2ba8349123de45e931a8c8264c332e6e9cf593f9",
              price: 0.00152033,
            },
            {
              chainId: "1",
              name: "ChainPort",
              symbol: "PORTX",
              address: "0x104f3152d8ebfc3f679392977356962ff36566ac",
              price: 0.0015154,
            },
            {
              chainId: "56",
              name: "ChainPort",
              symbol: "PORTX",
              address: "0x54c3b88b7e9702f915ddc6e483aaf369b2615f8d",
              price: 0.0015154,
            },
            {
              chainId: "1",
              name: "Razor Network",
              symbol: "RAZOR",
              address: "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
              price: 0.00149896,
            },
            {
              chainId: "1",
              name: "Morpheus Labs",
              symbol: "MITX",
              address: "0x4a527d8fc13c5203ab24ba0944f4cb14658d1db6",
              price: 0.00149118,
            },
            {
              chainId: "1",
              name: "Delphy",
              symbol: "DPY",
              address: "0x6c2adc2073994fb2ccc5032cc2906fa221e9b391",
              price: 0.0014884,
            },
            {
              chainId: "1",
              name: "PolkaRARE",
              symbol: "PRARE",
              address: "0x2C2f7e7C5604D162d75641256b80F1Bf6f4dC796",
              price: 0.00148141,
            },
            {
              chainId: "1",
              name: "Internet of Energy Network",
              symbol: "IOEN",
              address: "0x1e4e46b7bf03ece908c88ff7cc4975560010893a",
              price: 0.00144901,
            },
            {
              chainId: "137",
              name: "REVV",
              symbol: "REVV",
              address: "0x70c006878a5A50Ed185ac4C87d837633923De296",
              price: 0.00144624,
            },
            {
              chainId: "56",
              name: "JulSwap",
              symbol: "JULD",
              address: "0x5a41f637c3f7553dba6ddc2d3ca92641096577ea",
              price: 0.00143607,
            },
            {
              chainId: "1",
              name: "Vent Finance",
              symbol: "VENT",
              address: "0x5f0bc16d50f72d10b719dbf6845de2e599eb5624",
              price: 0.00143406,
            },
            {
              chainId: "56",
              name: "Vent Finance",
              symbol: "VENT",
              address: "0x872d068c25511be88c1f5990c53eeffcdf46c9b4",
              price: 0.00143406,
            },
            {
              chainId: "137",
              name: "Vent Finance",
              symbol: "VENT",
              address: "0xf21441f9ec4c1fe69cb7cf186eceab31af2b658d",
              price: 0.00143406,
            },
            {
              chainId: "1",
              name: "Akropolis Delphi",
              symbol: "ADEL",
              address: "0x94d863173ee77439e4292284ff13fad54b3ba182",
              price: 0.00141929,
            },
            {
              chainId: "56",
              name: "SONM",
              symbol: "SNM",
              address: "0x46d0DAc0926fa16707042CAdC23F1EB4141fe86B",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "ShoeFy",
              symbol: "SHOE",
              address: "0x0fd67b4ceb9b607ef206904ec73459c4880132c9",
              price: 0.0014028,
            },
            {
              chainId: "1",
              name: "Deeper Network",
              symbol: "DPR",
              address: "0xf3ae5d769e153ef72b4e3591ac004e89f48107a1",
              price: 0.00139342,
            },
            {
              chainId: "56",
              name: "Orion Money",
              symbol: "ORION",
              address: "0x5530ec23f4eE1521182bd158C09F4CA7efEC1ef0",
              price: 0.00138635,
            },
            {
              chainId: "1",
              name: "Orion Money",
              symbol: "ORION",
              address: "0x727f064a78dc734d33eec18d5370aef32ffd46e4",
              price: 0.00138635,
            },
            {
              chainId: "137",
              name: "Carrieverse",
              symbol: "CVTX",
              address: "0x40f97ec376ac1c503e755433bf57f21e3a49f440",
              price: 0.00137862,
            },
            {
              chainId: "137",
              name: "ChainPort",
              symbol: "PORTX",
              address: "0x189586b5f6317538ae50c20a976597da38984a24",
              price: 0.00137252,
            },
            {
              chainId: "1",
              name: "SmartMesh",
              symbol: "SMT",
              address: "0x55f93985431fc9304077687a35a1ba103dc1e081",
              price: 0.00135904,
            },
            {
              chainId: "137",
              name: "Sway Social",
              symbol: "SWAY",
              address: "0x262b8aa7542004f023b0eb02bc6b96350a02b728",
              price: 0.00135727,
            },
            {
              chainId: "1",
              name: "Mimir",
              symbol: "MIMIR",
              address: "0x71dc40668682a124231301414167e4cf7f55383c",
              price: 0.00135584,
            },
            {
              chainId: "1",
              name: "REVV",
              symbol: "REVV",
              address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
              price: 0.00135141,
            },
            {
              chainId: "1",
              name: "Unido",
              symbol: "UDO",
              address: "0xea3983fc6d0fbbc41fb6f6091f68f3e08894dc06",
              price: 0.0013405,
            },
            {
              chainId: "1",
              name: "CryptoArt.Ai",
              symbol: "CART",
              address: "0x5c8c8d560048f34e5f7f8ad71f2f81a89dbd273e",
              price: 0.00134019,
            },
            {
              chainId: "56",
              name: "Refinable",
              symbol: "FINE",
              address: "0x4e6415a5727ea08aAE4580057187923aeC331227",
              price: 0.00133929,
            },
            {
              chainId: "1",
              name: "Circuits of Value",
              symbol: "COVAL",
              address: "0x3d658390460295fb963f54dc0899cfb1c30776df",
              price: 0.00132492,
            },
            {
              chainId: "4200",
              name: "MerlinSwap Token",
              symbol: "MP",
              address: "0xbd40c74cb5cf9f9252B3298230Cb916d80430bBa",
              price: 0.00132486,
            },
            {
              chainId: "1",
              name: "AME Chain",
              symbol: "AME",
              address: "0x12513335ffD5DAfc2334e98625d27c1CA84bff86",
              price: 0.00131956,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "56",
              name: "Blin Metaverse",
              symbol: "BLIN",
              address: "0x811b279463a89E4B6E35805174C9190763f72614",
              price: 0.00131624,
            },
            {
              chainId: "1",
              name: "Colizeum",
              symbol: "ZEUM",
              address: "0x436dA116249044E8B4464F0Cf21Dd93311d88190",
              price: 0.00130109,
            },
            {
              chainId: "56",
              name: "Colizeum",
              symbol: "ZEUM",
              address: "0x482e6bd0a178f985818c5dfb9ac77918e8412fba",
              price: 0.00130109,
            },
            {
              chainId: "56",
              name: "MemePad",
              symbol: "MEPAD",
              address: "0x9d70a3ee3079a6fa2bb16591414678b7ad91f0b5",
              price: 0.00129437,
            },
            {
              chainId: "56",
              name: "Wizardia",
              symbol: "WZRD",
              address: "0xFa40d8FC324bcdD6Bbae0e086De886c571C225d4",
              price: 0.00127294,
            },
            {
              chainId: "1",
              name: "Kaizen Finance",
              symbol: "KZEN",
              address: "0x4550003152F12014558e5CE025707E4DD841100F",
              price: 0.00127135,
            },
            {
              chainId: "137",
              name: "Kaizen Finance",
              symbol: "KZEN",
              address: "0x4550003152F12014558e5CE025707E4DD841100F",
              price: 0.00127135,
            },
            {
              chainId: "56",
              name: "Kaizen Finance",
              symbol: "KZEN",
              address: "0x4550003152F12014558e5CE025707E4DD841100F",
              price: 0.00127135,
            },
            {
              chainId: "56",
              name: "ShopNEXT",
              symbol: "NEXT",
              address: "0xa6c59de838f1eeb82d86f5af0750f5f656439999",
              price: 0.00124268,
            },
            {
              chainId: "137",
              name: "The Unfettered",
              symbol: "SOULS",
              address: "0xefCFEce12A99d1DbBf6F3264ee97F8C045e97F1f",
              price: 0.00124112,
            },
            {
              chainId: "1",
              name: "YIELD App",
              symbol: "YLD",
              address: "0xf94b5c5651c888d928439ab6514b93944eee6f48",
              price: 0.00124088,
            },
            {
              chainId: "56",
              name: "Woonkly Power",
              symbol: "WOOP",
              address: "0x8b303d5bbfbbf46f1a4d9741e491e06986894e18",
              price: 0.00122232,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "56",
              name: "KickPAD",
              symbol: "KPAD",
              address: "0xCFEfA64B0dDD611b125157C41cD3827f2e8e8615",
              price: 0.00119791,
            },
            {
              chainId: "1",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
              price: 0.00119494,
            },
            {
              chainId: "1",
              name: "RioDeFi",
              symbol: "RFUEL",
              address: "0xaf9f549774ecedbd0966c52f250acc548d3f36e5",
              price: 0.00119316,
            },
            {
              chainId: "1",
              name: "SakeToken",
              symbol: "SAKE",
              address: "0x066798d9ef0833ccc719076dab77199ecbd178b0",
              price: 0.00117687,
            },
            {
              chainId: "1",
              name: "MixMarvel",
              symbol: "MIX",
              address: "0x5d285f735998f36631f678ff41fb56a10a4d0429",
              price: 0.00117,
            },
            {
              chainId: "1",
              name: "XREATORS",
              symbol: "ORT",
              address: "0x5c59a5b139b0538cb106d775a022cad98dd14b5a",
              price: 0.00115401,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "137",
              name: "Wistaverse",
              symbol: "WISTA",
              address: "0xB7042C40De76CFc607aC05e68F9C28A778F0C8a6",
              price: 0.0011396,
            },
            {
              chainId: "1",
              name: "Throne",
              symbol: "THN",
              address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
              price: 0.00113916,
            },
            {
              chainId: "56",
              name: "Prometheus",
              symbol: "MGA",
              address: "0x03aC6AB6A9a91a0fcdec7D85b38bDFBb719ec02f",
              price: 0.00113403,
            },
            {
              chainId: "137",
              name: "reBaked",
              symbol: "BAKED",
              address: "0x32515ffdc3a84cfbf9ad4db14ef8f0a535c7afd6",
              price: 0.00112583,
            },
            {
              chainId: "1",
              name: "reBaked",
              symbol: "BAKED",
              address: "0xa4cb0dce4849bdcad2d553e9e68644cf40e26cce",
              price: 0.00112583,
            },
            {
              chainId: "1",
              name: "Taxa Network",
              symbol: "TXT",
              address: "0x547b2F82ceCfAb9C2B1D36fddA96eF9F58C63B8C",
              price: 0.00112344,
            },
            {
              chainId: "1",
              name: "Sukhavati Network",
              symbol: "SKT",
              address: "0x012e0e6342308b247f36ee500ecb14dc77a7a8c1",
              price: 0.00111187,
            },
            {
              chainId: "56",
              name: "Plant vs Undead",
              symbol: "PVU",
              address: "0x31471e0791fcdbe82fbf4c44943255e923f1b794",
              price: 0.0011108,
            },
            {
              chainId: "1",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
              price: 0.00110671,
            },
            {
              chainId: "56",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x5d0158a5c3ddf47d4ea4517d8db0d76aa2e87563",
              price: 0.00110159,
            },
            {
              chainId: "56",
              name: "Warena",
              symbol: "RENA",
              address: "0xa9d75cc3405f0450955050c520843f99aff8749d",
              price: 0.00109399,
            },
            {
              chainId: "1",
              name: "Lokr",
              symbol: "LKR",
              address: "0x80ce3027a70e0a928d9268994e9b85d03bd4cdcf",
              price: 0.0010937,
            },
            {
              chainId: "1",
              name: "Astra Protocol",
              symbol: "ASTRA",
              address: "0x201332Bd45c8628D814F870bFb584B385A7C351e",
              price: 0.00107095,
            },
            {
              chainId: "56",
              name: "Metahero",
              symbol: "HERO",
              address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
              price: 0.00103651,
            },
            {
              chainId: "56",
              name: "King Shiba",
              symbol: "KINGSHIB",
              address: "0x84f4f7cdb4574c9556a494dab18ffc1d1d22316c",
              price: 0.00102812,
            },
            {
              chainId: "56",
              name: "XP Network",
              symbol: "XPNET",
              address: "0x8cf8238abf7b933bf8bb5ea2c7e4be101c11de2a",
              price: 0.00101716,
            },
            {
              chainId: "1",
              name: "Shyft Network",
              symbol: "SHFT",
              address: "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85",
              price: 0.00101292,
            },
            {
              chainId: "1",
              name: "Tap",
              symbol: "XTP",
              address: "0x6368e1E18c4C419DDFC608A0BEd1ccb87b9250fc",
              price: 0.00101058,
            },
            {
              chainId: "1",
              name: "Degen Zoo",
              symbol: "DZOO",
              address: "0xc97d6C52F3ADD91Fa1c5287a453d7444aECBca83",
              price: 0.00099931,
            },
            {
              chainId: "1",
              name: "NEST Protocol",
              symbol: "NEST",
              address: "0x04abeda201850ac0124161f037efd70c74ddc74c",
              price: 0.00099809,
            },
            {
              chainId: "1",
              name: "RFOX",
              symbol: "RFOX",
              address: "0xa1d6df714f91debf4e0802a542e13067f31b8262",
              price: 0.00099509,
            },
            {
              chainId: "56",
              name: "Sonar",
              symbol: "PING",
              address: "0x5546600f77eda1dcf2e8817ef4d617382e7f71f5",
              price: 0.00099006,
            },
            {
              chainId: "56",
              name: "KyberDyne",
              symbol: "KBD",
              address: "0xe3E3F8218562a7c9b594BEF2946Ec72f1b043ae8",
              price: 0.00098992,
            },
            {
              chainId: "137",
              name: "Blockchain Monster Hunt",
              symbol: "BCMC",
              address: "0xc10358f062663448a3489fC258139944534592ac",
              price: 0.00098674,
            },
            {
              chainId: "1",
              name: "handle.fi",
              symbol: "FOREX",
              address: "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b",
              price: 0.00097475,
            },
            {
              chainId: "137",
              name: "Trace Network Labs",
              symbol: "TRACE",
              address: "0x4287f07cbe6954f9f0decd91d0705c926d8d03a4",
              price: 0.00095784,
            },
            {
              chainId: "56",
              name: "Three Kingdoms",
              symbol: "TTK",
              address: "0x39703A67bAC0E39f9244d97f4c842D15Fbad9C1f",
              price: 0.00095019,
            },
            {
              chainId: "1",
              name: "BlackHole Protocol",
              symbol: "BLACK",
              address: "0xd714d91A169127e11D8FAb3665d72E8b7ef9Dbe2",
              price: 0.00094632,
            },
            {
              chainId: "56",
              name: "Enjinstarter",
              symbol: "EJS",
              address: "0x09f423aC3C9baBBfF6F94D372b16E4206e71439f",
              price: 0.00094122,
            },
            {
              chainId: "1",
              name: "SumoTex",
              symbol: "SMTX",
              address: "0x102203517ce35AC5Cab9a2cda80DF03f26c7419b",
              price: 0.00093735,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "56",
              name: "Step Hero",
              symbol: "HERO",
              address: "0xE8176d414560cFE1Bf82Fd73B986823B89E4F545",
              price: 0.00093207,
            },
            {
              chainId: "137",
              name: "NFT Champions",
              symbol: "CHAMP",
              address: "0x8f9e8e833a69aa467e42c46cca640da84dd4585f",
              price: 0.00092716,
            },
            {
              chainId: "1",
              name: "Primas",
              symbol: "PST",
              address: "0xe3fedaecd47aa8eab6b23227b0ee56f092c967a9",
              price: 0.00092638,
            },
            {
              chainId: "1",
              name: "Dash 2 Trade",
              symbol: "D2T",
              address: "0x4dd942baa75810a3c1e876e79d5cd35e09c97a76",
              price: 0.00092321,
            },
            {
              chainId: "1",
              name: "Sentinel",
              symbol: "DVPN",
              address: "0xa44E5137293E855B1b7bC7E2C6f8cD796fFCB037",
              price: 0.00092027,
            },
            {
              chainId: "1",
              name: "The Doge NFT",
              symbol: "DOG",
              address: "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
              price: 0.00091842,
            },
            {
              chainId: "56",
              name: "OneArt",
              symbol: "1ART",
              address: "0xD3c325848D7c6E29b574Cb0789998b2ff901f17E",
              price: 0.00090729,
            },
            {
              chainId: "56",
              name: "Nomad Exiles",
              symbol: "PRIDE",
              address: "0x085D15DB9c7Cd3Df188422f88Ec41ec573D691b9",
              price: 0.00090067,
            },
            {
              chainId: "1",
              name: "Sylo",
              symbol: "SYLO",
              address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
              price: 0.00089542,
            },
            {
              chainId: "1",
              name: "NightVerse Game",
              symbol: "NVG",
              address: "0x08f40811c7d6c013744166f3d4cb1a9a92d3d54e",
              price: 0.00089124,
            },
            {
              chainId: "56",
              name: "League of Ancients",
              symbol: "LOA",
              address: "0x94b69263FCA20119Ae817b6f783Fc0F13B02ad50",
              price: 0.00087305,
            },
            {
              chainId: "137",
              name: "Playermon",
              symbol: "PYM",
              address: "0x0bd49815ea8e2682220bcb41524c0dd10ba71d41",
              price: 0.00087029,
            },
            {
              chainId: "56",
              name: "SpaceMine",
              symbol: "MINE",
              address: "0x93713de5e0be3b7FcbD34257b6cadFb4d96e12b1",
              price: 0.00086926,
            },
            {
              chainId: "1",
              name: "SpaceMine",
              symbol: "MINE",
              address: "0xb7DE92bE975ccb27e7352a1D47512aCBdb0BaC32",
              price: 0.00086926,
            },
            {
              chainId: "56",
              name: "DekBox",
              symbol: "DEK",
              address: "0xe52C5A3590952F3ed6fcCf89A0bD7F38e11C5B98",
              price: 0.00086332,
            },
            {
              chainId: "137",
              name: "OrbCity",
              symbol: "ORB",
              address: "0x20c750c57c3bc5145af4b7a33d4fb66a8e79fe05",
              price: 0.00085895,
            },
            {
              chainId: "1",
              name: "OrbCity",
              symbol: "ORB",
              address: "0x3c917054e03485808137eb306eafa8da0ab695cd",
              price: 0.00085895,
            },
            {
              chainId: "1",
              name: "BeyondFi",
              symbol: "BYN",
              address: "0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca",
              price: 0.0008541,
            },
            {
              chainId: "56",
              name: "Shirtum",
              symbol: "SHI",
              address: "0x7269d98af4aa705e0b1a5d8512fadb4d45817d5a",
              price: 0.00082961,
            },
            {
              chainId: "1",
              name: "Shirtum",
              symbol: "SHI",
              address: "0xad996a45fd2373ed0b10efa4a8ecb9de445a4302",
              price: 0.00082961,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "FreeRossDAO",
              symbol: "FREE",
              address: "0x4cd0c43b0d53bc318cc5342b77eb6f124e47f526",
              price: 0.00082232,
            },
            {
              chainId: "56",
              name: "Hero Arena",
              symbol: "HERA",
              address: "0x49C7295ff86EaBf5bf58C6eBC858DB4805738c01",
              price: 0.0008193,
            },
            {
              chainId: "137",
              name: "VRJAM",
              symbol: "VRJAM",
              address: "0xe84c2edca71fc3cc570c70665178d90c8721623b",
              price: 0.00080633,
            },
            {
              chainId: "1",
              name: "DeFIL",
              symbol: "DFL",
              address: "0x09ce2b746c32528b7d864a1e3979bd97d2f095ab",
              price: 0.00080191,
            },
            {
              chainId: "56",
              name: "Heroes & Empires",
              symbol: "HE",
              address: "0x20d39a5130f799b95b55a930e5b7ebc589ea9ed8",
              price: 0.00080112,
            },
            {
              chainId: "56",
              name: "CryptoZoon",
              symbol: "ZOON",
              address: "0x9d173e6c594f479b4d47001f8e6a95a7adda42bc",
              price: 0.00080059,
            },
            {
              chainId: "1",
              name: "Wasder",
              symbol: "WAS",
              address: "0x0c572544a4Ee47904d54aaA6A970AF96B6f00E1b",
              price: 0.00079792,
            },
            {
              chainId: "1",
              name: "Creator Platform",
              symbol: "CTR",
              address: "0x923b83c26b3809d960ff80332ed00aa46d7ed375",
              price: 0.00078895,
            },
            {
              chainId: "56",
              name: "Creator Platform",
              symbol: "CTR",
              address: "0xd6cce248263ea1e2b8cb765178c944fc16ed0727",
              price: 0.00078895,
            },
            {
              chainId: "56",
              name: "Stella Fantasy",
              symbol: "SFTY",
              address: "0xe9d6d6d7cde5c7d45927f8c37460d932e612c902",
              price: 0.00078225,
            },
            {
              chainId: "1",
              name: "BitKan",
              symbol: "KAN",
              address: "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a",
              price: 0.00078224,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "56",
              name: "MagicCraft",
              symbol: "MCRT",
              address: "0x4b8285ab433d8f69cb48d5ad62b415ed1a221e4f",
              price: 0.00077029,
            },
            {
              chainId: "1",
              name: "Aegis",
              symbol: "AGS",
              address: "0xdb2f2bcce3efa95eda95a233af45f3e0d4f00e2a",
              price: 0.00076966,
            },
            {
              chainId: "56",
              name: "Cherry Network",
              symbol: "CHER",
              address: "0x8f36cc333f55b09bb71091409a3d7ade399e3b1c",
              price: 0.00076649,
            },
            {
              chainId: "1",
              name: "Finxflo",
              symbol: "FXF",
              address: "0x8a40c222996f9F3431f63Bf80244C36822060f12",
              price: 0.00075907,
            },
            {
              chainId: "1",
              name: "DigitalBits",
              symbol: "XDB",
              address: "0xb9eefc4b0d472a44be93970254df4f4016569d27",
              price: 0.00074882,
            },
            {
              chainId: "56",
              name: "Ispolink",
              symbol: "ISP",
              address: "0xD2e7B964770FCf51DF088a5F0Bb2D33a3c60CcCf",
              price: 0.00074786,
            },
            {
              chainId: "1",
              name: "Orao Network",
              symbol: "ORAO",
              address: "0xee1cea7665ba7aa97e982edeaecb26b59a04d035",
              price: 0.0007304,
            },
            {
              chainId: "56",
              name: "Legion Network",
              symbol: "LGX",
              address: "0x9096b4309224d751fcb43d7eb178dcffc122ad15",
              price: 0.00071825,
            },
            {
              chainId: "1",
              name: "Raze Network",
              symbol: "RAZE",
              address: "0x5Eaa69B29f99C84Fe5dE8200340b4e9b4Ab38EaC",
              price: 0.00071529,
            },
            {
              chainId: "1",
              name: "Rainmaker Games",
              symbol: "RAIN",
              address: "0x71Fc1F555a39E0B698653AB0b475488EC3c34D57",
              price: 0.00071487,
            },
            {
              chainId: "1",
              name: "MobiFi",
              symbol: "MOFI",
              address: "0xb2dbf14d0b47ed3ba02bdb7c954e05a72deb7544",
              price: 0.00071188,
            },
            {
              chainId: "56",
              name: "MyMasterWar",
              symbol: "MAT",
              address: "0xf3147987a00d35eecc10c731269003ca093740ca",
              price: 0.00071152,
            },
            {
              chainId: "56",
              name: "KingdomX",
              symbol: "KT",
              address: "0x52da44b5e584f730005dac8d2d2acbdee44d4ba3",
              price: 0.00070691,
            },
            {
              chainId: "56",
              name: "OIN Finance",
              symbol: "OIN",
              address: "0x658e64ffcf40d240a43d52ca9342140316ae44fa",
              price: 0.00070606,
            },
            {
              chainId: "137",
              name: "PolyPad",
              symbol: "POLYPAD",
              address: "0x30ea765d4dda26e0f89e1b23a7c7b2526b7d29ec",
              price: 0.00069386,
            },
            {
              chainId: "56",
              name: "PolyPad",
              symbol: "POLYPAD",
              address: "0x8ae619d633cce175a2fbcfa1cea119ddc80f1342",
              price: 0.00069386,
            },
            {
              chainId: "1",
              name: "MatrixETF",
              symbol: "MDF",
              address: "0x1a57367c6194199e5d9aea1ce027431682dfb411",
              price: 0.00068647,
            },
            {
              chainId: "1",
              name: "NvirWorld",
              symbol: "NVIR",
              address: "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
              price: 0.00067707,
            },
            {
              chainId: "1",
              name: "DAFI Protocol",
              symbol: "DAFI",
              address: "0xfc979087305a826c2b2a0056cfaba50aad3e6439",
              price: 0.00067118,
            },
            {
              chainId: "56",
              name: "Marnotaur",
              symbol: "TAUR",
              address: "0x19b99162ADAAB85134E781Ac0048C275C31b205a",
              price: 0.00065944,
            },
            {
              chainId: "1",
              name: "Marnotaur",
              symbol: "TAUR",
              address: "0xF71288618F919FF0A779c757489A8B2e45925dDd",
              price: 0.00065944,
            },
            {
              chainId: "1",
              name: "Trace Network Labs",
              symbol: "TRACE",
              address: "0x9f7fc686cfd64aa5ae15b351d03071e91533094b",
              price: 0.00065941,
            },
            {
              chainId: "1",
              name: "Mobius Finance",
              symbol: "MOT",
              address: "0x1E02cdbbA6729B6470de81Ad4D2cCA4c514521b9",
              price: 0.00065645,
            },
            {
              chainId: "137",
              name: "SAVAGE",
              symbol: "SAVG",
              address: "0x981aecc6eb4d382b96a02b75e931900705e95a31",
              price: 0.00065625,
            },
            {
              chainId: "1",
              name: "Snetwork",
              symbol: "SNET",
              address: "0xFf19138b039D938db46bDDA0067DC4BA132ec71C",
              price: 0.00065569,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "56",
              name: "Reef",
              symbol: "REEF",
              address: "0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e",
              price: 0.0006364,
            },
            {
              chainId: "56",
              name: "Kryptomon",
              symbol: "KMON",
              address: "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
              price: 0.00063578,
            },
            {
              chainId: "137",
              name: "Infinity Skies",
              symbol: "ISKY",
              address: "0x5DFD5edFde4d8EC9e632dCA9d09Fc7E833f74210",
              price: 0.00063164,
            },
            {
              chainId: "56",
              name: "Octopus Protocol",
              symbol: "OPS",
              address: "0xdf0121a3ba5c10816ea2943c722650c4a4b0dbe6",
              price: 0.00062649,
            },
            {
              chainId: "1",
              name: "Umee",
              symbol: "UMEE",
              address: "0xc0a4df35568f116c370e6a6a6022ceb908eeddac",
              price: 0.00062095,
            },
            {
              chainId: "56",
              name: "StreamCoin",
              symbol: "STRM",
              address: "0xc598275452fa319d75ee5f176fd3b8384925b425",
              price: 0.00061318,
            },
            {
              chainId: "56",
              name: "Operon Origins",
              symbol: "ORO",
              address: "0xFc4f5A4d1452B8Dc6C3CB745dB15B29c00812b19",
              price: 0.00060888,
            },
            {
              chainId: "1",
              name: "WeWay",
              symbol: "WWY",
              address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
              price: 0.00060192,
            },
            {
              chainId: "56",
              name: "WeWay",
              symbol: "WWY",
              address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
              price: 0.00060192,
            },
            {
              chainId: "1",
              name: "Creaticles",
              symbol: "CRE8",
              address: "0xc36b4311b21fc0c2ead46f1ea6ce97c9c4d98d3d",
              price: 0.00059873,
            },
            {
              chainId: "1",
              name: "Tokoin",
              symbol: "TOKO",
              address: "0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675",
              price: 0.0005868,
            },
            {
              chainId: "1",
              name: "Goons of Balatroon",
              symbol: "GOB",
              address: "0xd6929179D752d5D25c5efe2d9729eb77D7138A80",
              price: 0.00058607,
            },
            {
              chainId: "56",
              name: "XCarnival",
              symbol: "XCV",
              address: "0x4be63a9b26ee89b9a3a13fd0aa1d0b2427c135f8",
              price: 0.00058601,
            },
            {
              chainId: "56",
              name: "Argon",
              symbol: "ARGON",
              address: "0x851f7a700c5d67db59612b871338a85526752c25",
              price: 0.00058204,
            },
            {
              chainId: "56",
              name: "Tap Fantasy",
              symbol: "TAP",
              address: "0x35bEdBF9291b22218a0dA863170dcC9329Ef2563",
              price: 0.00057469,
            },
            {
              chainId: "1",
              name: "Fodl Finance",
              symbol: "FODL",
              address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
              price: 0.00056514,
            },
            {
              chainId: "56",
              name: "IGUP (IguVerse)",
              symbol: "IGUP",
              address: "0x522d0F9F3eFF479A5B256BB1C1108F47b8e1A153",
              price: 0.00055934,
            },
            {
              chainId: "1",
              name: "PulsePad",
              symbol: "PLSPAD",
              address: "0x8a74bc8c372bc7f0e9ca3f6ac0df51be15aec47a",
              price: 0.000549,
            },
            {
              chainId: "56",
              name: "PulsePad",
              symbol: "PLSPAD",
              address: "0x8a74BC8c372bC7f0E9cA3f6Ac0df51BE15aEC47A",
              price: 0.000549,
            },
            {
              chainId: "1",
              name: "Realm",
              symbol: "REALM",
              address: "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
              price: 0.00054807,
            },
            {
              chainId: "137",
              name: "Bloktopia",
              symbol: "BLOK",
              address: "0x229b1b6c23ff8953d663c4cbb519717e323a0a84",
              price: 0.00054651,
            },
            {
              chainId: "1",
              name: "Crafting Finance",
              symbol: "CRF",
              address: "0x508df5aa4746be37b5b6a69684dfd8bdc322219d",
              price: 0.00054557,
            },
            {
              chainId: "56",
              name: "ApeSwap",
              symbol: "BANANA",
              address: "0x603c7f932ed1fc6575303d8fb018fdcbb0f39a95",
              price: 0.00053242,
            },
            {
              chainId: "1",
              name: "Tamadoge",
              symbol: "TAMA",
              address: "0x12b6893ce26ea6341919fe289212ef77e51688c8",
              price: 0.00052927,
            },
            {
              chainId: "56",
              name: "Copycat Finance",
              symbol: "COPYCAT",
              address: "0xd635b32688f36ee4a7fe117b4c91dd811277acb6",
              price: 0.0005264,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "Definer",
              symbol: "FIN",
              address: "0x054f76beed60ab6dbeb23502178c52d6c5debe40",
              price: 0.00051712,
            },
            {
              chainId: "56",
              name: "DOSE",
              symbol: "DOSE",
              address: "0x7837fd820ba38f95c54d6dac4ca3751b81511357",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "DOSE",
              symbol: "DOSE",
              address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "Polinate",
              symbol: "POLI",
              address: "0xa1a36d3537bbe375cc9694795f663ddc8d516db9",
              price: 0.00051355,
            },
            {
              chainId: "1",
              name: "MoonDAO",
              symbol: "MOONEY",
              address: "0x20d4DB1946859E2Adb0e5ACC2eac58047aD41395",
              price: 0.0005079,
            },
            {
              chainId: "56",
              name: "Green Beli",
              symbol: "GRBE",
              address: "0x5ca4e7294b14ea5745ee2a688990e0cb68503219",
              price: 0.00050117,
            },
            {
              chainId: "56",
              name: "TechTreesCoin",
              symbol: "TTC",
              address: "0x6A684b3578f5B07c0Aa02fAFc33ED248AE0c2dB2",
              price: 0.00050028,
            },
            {
              chainId: "1",
              name: "Skeb Coin",
              symbol: "SKEB",
              address: "0x6D614686550B9E1c1DF4b2cD8f91C9D4df66C810",
              price: 0.00050016,
            },
            {
              chainId: "56",
              name: "PolkaWar",
              symbol: "PWAR",
              address: "0x16153214e683018d5aa318864c8e692b66e16778",
              price: 0.00049844,
            },
            {
              chainId: "1",
              name: "MultiVAC",
              symbol: "MTV",
              address: "0x8aa688AB789d1848d131C65D98CEAA8875D97eF1",
              price: 0.00049522,
            },
            {
              chainId: "56",
              name: "BitLocus",
              symbol: "BTL",
              address: "0x51e7b598c9155b9dccb04eb42519f6eec9c841e9",
              price: 0.00049479,
            },
            {
              chainId: "1",
              name: "DOS Network",
              symbol: "DOS",
              address: "0x0A913beaD80F321E7Ac35285Ee10d9d922659cB7",
              price: 0.00049359,
            },
            {
              chainId: "1",
              name: "Ethermon",
              symbol: "EMON",
              address: "0xd6a5ab46ead26f49b03bbb1f9eb1ad5c1767974a",
              price: 0.0004856,
            },
            {
              chainId: "56",
              name: "Starpunk",
              symbol: "SRP",
              address: "0xcb2b25e783a414f0d20a65afa741c51b1ad84c49",
              price: 0.00048459,
            },
            {
              chainId: "1",
              name: "EdgeSwap",
              symbol: "EGS",
              address: "0xB009BFaAF85e53F55d8657781Eb69feAaed83672",
              price: 0.00048175,
            },
            {
              chainId: "1",
              name: "Formation Fi",
              symbol: "FORM",
              address: "0x21381e026Ad6d8266244f2A583b35F9E4413FA2a",
              price: 0.00048081,
            },
            {
              chainId: "56",
              name: "Formation Fi",
              symbol: "FORM",
              address: "0x25a528af62e56512a19ce8c3cab427807c28cc19",
              price: 0.00048081,
            },
            {
              chainId: "1",
              name: "Evanesco",
              symbol: "EVA",
              address: "0xd6caf5bd23cf057f5fccce295dcc50c01c198707",
              price: 0.00047749,
            },
            {
              chainId: "56",
              name: "PlayPad",
              symbol: "PPAD",
              address: "0x93bb13e90678ccd8bbab07d1daef15086746dc9b",
              price: 0.00047399,
            },
            {
              chainId: "56",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0x0f9e4d49f25de22c2202af916b681fbb3790497b",
              price: 0.00047299,
            },
            {
              chainId: "1",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0xeca82185adce47f39c684352b0439f030f860318",
              price: 0.00047299,
            },
            {
              chainId: "56",
              name: "STEPG",
              symbol: "STEPG",
              address: "0x5e6d3bb496301ecdfa34fa1ed2d3bada250f0409",
              price: 0.00046609,
            },
            {
              chainId: "1",
              name: "AAG Ventures",
              symbol: "AAG",
              address: "0x5ba19d656b65f1684cfea4af428c23b9f3628f97",
              price: 0.00046456,
            },
            {
              chainId: "1",
              name: "Crypto Prophecies",
              symbol: "TCP",
              address: "0x06576eb3b212d605b797dc15523d9dc9f4f66db4",
              price: 0.00045914,
            },
            {
              chainId: "1",
              name: "CoinFi",
              symbol: "COFI",
              address: "0x3136ef851592acf49ca4c825131e364170fa32b3",
              price: 0.00045401,
            },
            {
              chainId: "1",
              name: "Trade Token",
              symbol: "TIO",
              address: "0x80bc5512561c7f85a3a9508c7df7901b370fa1df",
              price: 0.00045062,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "56",
              name: "Monster Galaxy",
              symbol: "GGM",
              address: "0x4301a638fcb45c4bb65230b87f3797c213f832b8",
              price: 0.00044662,
            },
            {
              chainId: "1",
              name: "MetaOctagon",
              symbol: "MOTG",
              address: "0x171d76d931529384639BC9aad5b77b77041ED604",
              price: 0.00044182,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Define",
              symbol: "DFA",
              address: "0x62959c699a52ec647622c91e79ce73344e4099f5",
              price: 0.00043759,
            },
            {
              chainId: "56",
              name: "HoDooi",
              symbol: "HOD",
              address: "0x19A4866a85c652EB4a2ED44c42e4CB2863a62D51",
              price: 0.00043752,
            },
            {
              chainId: "1",
              name: "Scry.info",
              symbol: "DDD",
              address: "0x9F5F3CFD7a32700C93F971637407ff17b91c7342",
              price: 0.00043413,
            },
            {
              chainId: "1",
              name: "Ares Protocol",
              symbol: "ARES",
              address: "0x358AA737e033F34df7c54306960a38d09AaBd523",
              price: 0.00043409,
            },
            {
              chainId: "56",
              name: "Spellfire",
              symbol: "SPELLFIRE",
              address: "0xd6f28f15a5cafc8d29556393c08177124b88de0d",
              price: 0.00043186,
            },
            {
              chainId: "1",
              name: "Spellfire",
              symbol: "SPELLFIRE",
              address: "0x3A0b022f32b3191D44E5847da12dc0B63fb07C91",
              price: 0.00043085,
            },
            {
              chainId: "1",
              name: "Yield Protocol",
              symbol: "YIELD",
              address: "0xa8B61CfF52564758A204F841E636265bEBC8db9B",
              price: 0.0004297,
            },
            {
              chainId: "56",
              name: "Infinity Pad",
              symbol: "IPAD",
              address: "0xA7266989B0DF675cC8257d53B6bc1358fAF6626a",
              price: 0.00042256,
            },
            {
              chainId: "1",
              name: "Lympo",
              symbol: "LYM",
              address: "0x57ad67acf9bf015e4820fbd66ea1a21bed8852ec",
              price: 0.00041799,
            },
            {
              chainId: "56",
              name: "Nafter",
              symbol: "NAFT",
              address: "0xd7730681b1dc8f6f969166b29d8a5ea8568616a3",
              price: 0.00041089,
            },
            {
              chainId: "1",
              name: "POPKON",
              symbol: "POPK",
              address: "0xaC12e8f6b0C17d7B736A800920b336d764b59973",
              price: 0.00040965,
            },
            {
              chainId: "1",
              name: "Kudoe",
              symbol: "KDOE",
              address: "0x5f190f9082878ca141f858c1c90b4c59fe2782c5",
              price: 0.00040861,
            },
            {
              chainId: "1",
              name: "Geojam",
              symbol: "JAM",
              address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
              price: 0.00040671,
            },
            {
              chainId: "1",
              name: "Envoy Network",
              symbol: "ENV",
              address: "0xf1d1a5306daae314af6c5d027a492b313e07e1a0",
              price: 0.00040197,
            },
            {
              chainId: "1",
              name: "MARS4",
              symbol: "MARS4",
              address: "0x16cda4028e9e872a38acb903176719299beaed87",
              price: 0.00038566,
            },
            {
              chainId: "1",
              name: "Game.com",
              symbol: "GTC",
              address: "0xB70835D7822eBB9426B56543E391846C107bd32C",
              price: 0.00038213,
            },
            {
              chainId: "56",
              name: "WagyuSwap",
              symbol: "WAG",
              address: "0x7fa7df4996ac59f398476892cfb195ed38543520",
              price: 0.00038054,
            },
            {
              chainId: "1",
              name: "Ispolink",
              symbol: "ISP",
              address: "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
              price: 0.00037618,
            },
            {
              chainId: "56",
              name: "Babylons",
              symbol: "BABI",
              address: "0xec15a508a187e8ddfe572a5423faa82bbdd65120",
              price: 0.00037568,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "BaconDAO",
              symbol: "BACON",
              address: "0x34f797e7190C131cF630524655A618b5BD8738e7",
              price: 0.00036992,
            },
            {
              chainId: "1",
              name: "ARMOR",
              symbol: "ARMOR",
              address: "0x1337def16f9b486faed0293eb623dc8395dfe46a",
              price: 0.00036815,
            },
            {
              chainId: "56",
              name: "DOGGY",
              symbol: "DOGGY",
              address: "0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6",
              price: 0.00036625,
            },
            {
              chainId: "1",
              name: "ROOBEE",
              symbol: "ROOBEE",
              address: "0xa31b1767e09f842ecfd4bc471fe44f830e3891aa",
              price: 0.00035719,
            },
            {
              chainId: "1",
              name: "DinoX",
              symbol: "DNXC",
              address: "0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a",
              price: 0.00035326,
            },
            {
              chainId: "56",
              name: "DinoX",
              symbol: "DNXC",
              address: "0x3c1748d647e6a56b37b66fcd2b5626d0461d3aa0",
              price: 0.00035326,
            },
            {
              chainId: "1",
              name: "Saitama V2",
              symbol: "SAITAMA",
              address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
              price: 0.00035045,
            },
            {
              chainId: "56",
              name: "Katana Inu",
              symbol: "KATA",
              address: "0x6D6bA21E4C4b29CA7Bfa1c344Ba1E35B8DaE7205",
              price: 0.00034779,
            },
            {
              chainId: "56",
              name: "Paralink Network",
              symbol: "PARA",
              address: "0x076ddce096c93dcf5d51fe346062bf0ba9523493",
              price: 0.0003335,
            },
            {
              chainId: "1",
              name: "Paralink Network",
              symbol: "PARA",
              address: "0x3a8d5BC8A8948b68DfC0Ce9C14aC4150e083518c",
              price: 0.0003335,
            },
            {
              chainId: "56",
              name: "BambooDeFi",
              symbol: "BAMBOO",
              address: "0x198abb2d13faa2e52e577d59209b5c23c20cd6b3",
              price: 0.00033189,
            },
            {
              chainId: "1",
              name: "BambooDeFi",
              symbol: "BAMBOO",
              address: "0xf56842Af3B56Fd72d17cB103f92d027bBa912e89",
              price: 0.00033189,
            },
            {
              chainId: "1",
              name: "DeSpace Protocol",
              symbol: "DES",
              address: "0x634239cfa331df0291653139d1a6083b9cf705e3",
              price: 0.0003307,
            },
            {
              chainId: "56",
              name: "DeSpace Protocol",
              symbol: "DES",
              address: "0xb38b3c34e4bb6144c1e5283af720e046ee833a2a",
              price: 0.0003307,
            },
            {
              chainId: "1",
              name: "NFTMart",
              symbol: "NMT",
              address: "0xd81b71cbb89b2800cdb000aa277dc1491dc923c3",
              price: 0.00032821,
            },
            {
              chainId: "137",
              name: "Monsoon Finance",
              symbol: "MCASH",
              address: "0xa25610a77077390a75ad9072a084c5fbc7d43a0d",
              price: 0.00032656,
            },
            {
              chainId: "1",
              name: "TE-FOOD",
              symbol: "TONE",
              address: "0x2ab6bb8408ca3199b8fa6c92d5b455f820af03c4",
              price: 0.00032284,
            },
            {
              chainId: "1",
              name: "eosDAC",
              symbol: "EOSDAC",
              address: "0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba",
              price: 0.00032044,
            },
            {
              chainId: "56",
              name: "AMAZY",
              symbol: "AZY",
              address: "0x7b665b2f633d9363b89a98b094b1f9e732bd8f86",
              price: 0.00031764,
            },
            {
              chainId: "1",
              name: "YIN Finance",
              symbol: "YIN",
              address: "0x794Baab6b878467F93EF17e2f2851ce04E3E34C8",
              price: 0.00031524,
            },
            {
              chainId: "56",
              name: "YIN Finance",
              symbol: "YIN",
              address: "0x794Baab6b878467F93EF17e2f2851ce04E3E34C8",
              price: 0.00031524,
            },
            {
              chainId: "1",
              name: "Spume",
              symbol: "SPUME",
              address: "0xa16a609fF4e1A15b6cCb469E7a5dD14E89305283",
              price: 0.00031453,
            },
            {
              chainId: "56",
              name: "Battle Saga",
              symbol: "BTL",
              address: "0x708955Db0d4c52FFBf9AA34aF7f3CA8bf07390a8",
              price: 0.00031292,
            },
            {
              chainId: "56",
              name: "Franklin",
              symbol: "FLY",
              address: "0x681fd3e49a6188fc526784ee70aa1c269ee2b887",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Franklin",
              symbol: "FLY",
              address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Medicalchain",
              symbol: "MTN",
              address: "0x41dbecc1cdc5517c6f76f6a6e836adbee2754de3",
              price: 0.00031106,
            },
            {
              chainId: "1",
              name: "Busy",
              symbol: "BUSY",
              address: "0x5cb3ce6d081fb00d5f6677d196f2d70010ea3f4a",
              price: 0.00030676,
            },
            {
              chainId: "56",
              name: "Gifto",
              symbol: "GFT",
              address: "0x72ff5742319ef07061836f5c924ac6d72c919080",
              price: 0.00030183,
            },
            {
              chainId: "56",
              name: "Kaby Arena",
              symbol: "KABY",
              address: "0x02a40c048ee2607b5f5606e445cfc3633fb20b58",
              price: 0.0003015,
            },
            {
              chainId: "137",
              name: "Kaby Arena",
              symbol: "KABY",
              address: "0x5198E7cC1640049dE37D1Bd10b03Fa5A3AFDA120",
              price: 0.0003015,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "56",
              name: "TokenClub",
              symbol: "TCT",
              address: "0xCA0a9Df6a8cAD800046C1DDc5755810718b65C44",
              price: 0.00030147,
            },
            {
              chainId: "56",
              name: "Binemon",
              symbol: "BIN",
              address: "0xe56842ed550ff2794f010738554db45e60730371",
              price: 0.0003,
            },
            {
              chainId: "1",
              name: "Skyrim Finance",
              symbol: "SKYRIM",
              address: "0x2610f0bfc21ef389fe4d03cfb7de9ac1e6c99d6e",
              price: 0.00029897,
            },
            {
              chainId: "56",
              name: "Ftribe Fighters",
              symbol: "F2C",
              address: "0x657b632714e08ac66b79444ad3f3875526ee6689",
              price: 0.00029854,
            },
            {
              chainId: "56",
              name: "Moo Monster",
              symbol: "MOO",
              address: "0xA29b6f4E762874846c081E20ed1142FF83faaFEF",
              price: 0.00029308,
            },
            {
              chainId: "1",
              name: "Sekuritance",
              symbol: "SKRT",
              address: "0x887168120cb89fb06f3e74dc4af20d67df0977f6",
              price: 0.00028474,
            },
            {
              chainId: "56",
              name: "Realm",
              symbol: "REALM",
              address: "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
              price: 0.0002804,
            },
            {
              chainId: "1",
              name: "Ecomi",
              symbol: "OMI",
              address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
              price: 0.00027862,
            },
            {
              chainId: "1",
              name: "Enjinstarter",
              symbol: "EJS",
              address: "0x96610186F3ab8d73EBEe1CF950C750f3B1Fb79C2",
              price: 0.00027744,
            },
            {
              chainId: "1",
              name: "Niftify",
              symbol: "NIFT",
              address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
              price: 0.00027324,
            },
            {
              chainId: "56",
              name: "Taboo Token",
              symbol: "TABOO",
              address: "0x9abdba20edfba06b782126b4d8d72a5853918fd0",
              price: 0.00026221,
            },
            {
              chainId: "56",
              name: "Street Runner ",
              symbol: "SRG",
              address: "0x722f41f6511ff7cda73a1cb0a9ea2f731738c4a0",
              price: 0.00025963,
            },
            {
              chainId: "1",
              name: "Cratos",
              symbol: "CRTS",
              address: "0x678e840c640f619e17848045d23072844224dd37",
              price: 0.00025931,
            },
            {
              chainId: "56",
              name: "Cratos",
              symbol: "CRTS",
              address: "0x678e840c640f619e17848045d23072844224dd37",
              price: 0.00025931,
            },
            {
              chainId: "1",
              name: "Bottos",
              symbol: "BTO",
              address: "0x36905fc93280f52362a1cbab151f25dc46742fb5",
              price: 0.00025545,
            },
            {
              chainId: "1",
              name: "Dogechain",
              symbol: "DC",
              address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
              price: 0.00025429,
            },
            {
              chainId: "1",
              name: "The Protocol",
              symbol: "THE",
              address: "0x0cba60ca5ef4d42f92a5070a8fedd13be93e2861",
              price: 0.0002527,
            },
            {
              chainId: "56",
              name: "Nelore Coin",
              symbol: "NLC",
              address: "0x5f320c3b8f82acfe8f2bb1c85d63aa66a7ff524f",
              price: 0.00025055,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "137",
              name: "Goons of Balatroon",
              symbol: "GOB",
              address: "0x16d63619Cd67B15Ff822bFeB60388a226D2e452b",
              price: 0.00024645,
            },
            {
              chainId: "56",
              name: "NFTY Network",
              symbol: "NFTY",
              address: "0x5774b2fc3e91af89f89141eacf76545e74265982",
              price: 0.00024635,
            },
            {
              chainId: "1",
              name: "NFTY Network",
              symbol: "NFTY",
              address: "0xE1D7C7a4596B038CEd2A84bF65B8647271C53208",
              price: 0.00024635,
            },
            {
              chainId: "1",
              name: "Burp",
              symbol: "BURP",
              address: "0x33f391f4c4fe802b70b77ae37670037a92114a7c",
              price: 0.00024459,
            },
            {
              chainId: "137",
              name: "Burp",
              symbol: "BURP",
              address: "0x538d47d142f6993038a667e9d6210d3735749b36",
              price: 0.00024459,
            },
            {
              chainId: "1",
              name: "Wojak",
              symbol: "WOJAK",
              address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
              price: 0.00024381,
            },
            {
              chainId: "56",
              name: "Zodium",
              symbol: "ZODI",
              address: "0x0cca2f5561bb0fca88e5b9b48b7fbf000349c357",
              price: 0.00024169,
            },
            {
              chainId: "56",
              name: "MetaShooter",
              symbol: "MHUNT",
              address: "0x2C717059b366714d267039aF8F59125CAdce6D8c",
              price: 0.00023999,
            },
            {
              chainId: "137",
              name: "MetaShooter",
              symbol: "MHUNT",
              address: "0x61f95bd637e3034133335C1baA0148E518D438ad",
              price: 0.00023999,
            },
            {
              chainId: "1",
              name: "Beyond Protocol",
              symbol: "BP",
              address: "0xdF290B162a7D3E0A328cF198308D421954f08b94",
              price: 0.0002357,
            },
            {
              chainId: "1",
              name: "Spores Network",
              symbol: "SPO",
              address: "0xcbe771323587ea16dacb6016e269d7f08a7acc4e",
              price: 0.00023253,
            },
            {
              chainId: "56",
              name: "Falcon Swaps",
              symbol: "FALCONS",
              address: "0xb139ed26b743c7254a246cf91eb594d097238524",
              price: 0.0002323,
            },
            {
              chainId: "56",
              name: "XCAD Network",
              symbol: "PLAY",
              address: "0xD069599E718f963bD84502b49ba8F8657fAF5B3a",
              price: 0.00022962,
            },
            {
              chainId: "1",
              name: "Burency",
              symbol: "BUY",
              address: "0x31fdd1c6607f47c14a2821f599211c67ac20fa96",
              price: 0.00022943,
            },
            {
              chainId: "56",
              name: "Squid Game",
              symbol: "SQUID",
              address: "0x87230146e138d3f296a9a77e497a2a83012e9bc5",
              price: 0.0002264,
            },
            {
              chainId: "1",
              name: "Keystone of Opportunity & Knowledge",
              symbol: "KOK",
              address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
              price: 0.00022317,
            },
            {
              chainId: "1",
              name: "Olyseum",
              symbol: "OLY",
              address: "0x6595b8fd9c920c81500dca94e53cdc712513fb1f",
              price: 0.00021793,
            },
            {
              chainId: "1",
              name: "Rage.Fan",
              symbol: "RAGE",
              address: "0x94804dc4948184ffd7355f62ccbb221c9765886f",
              price: 0.00021547,
            },
            {
              chainId: "1",
              name: "Pando",
              symbol: "PANDO",
              address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
              price: 0.00021312,
            },
            {
              chainId: "1",
              name: "tehBag",
              symbol: "BAG",
              address: "0x235C8EE913d93c68D2902a8e0b5a643755705726",
              price: 0.00021269,
            },
            {
              chainId: "1",
              name: "SubDAO",
              symbol: "GOV",
              address: "0x274e7eb07b485cfde53d02270555213447570ac6",
              price: 0.00021092,
            },
            {
              chainId: "1",
              name: "EarthFund",
              symbol: "1EARTH",
              address: "0x9e04f519b094f5f8210441e285f603f4d2b50084",
              price: 0.00021091,
            },
            {
              chainId: "56",
              name: "Defi For You",
              symbol: "DFY",
              address: "0xd98560689c6e748dc37bc410b4d3096b1aa3d8c2",
              price: 0.00020364,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "Fringe Finance",
              symbol: "FRIN",
              address: "0xc9fe6e1c76210be83dc1b5b20ec7fd010b0b1d15",
              price: 0.00020197,
            },
            {
              chainId: "56",
              name: "Gafa",
              symbol: "GAFA",
              address: "0x495205d4c6307A73595C5C11B44Bee9B3418Ac69",
              price: 0.00019861,
            },
            {
              chainId: "56",
              name: "Outer Ring",
              symbol: "GQ",
              address: "0xf700d4c708c2be1463e355f337603183d20e0808",
              price: 0.00019658,
            },
            {
              chainId: "1",
              name: "BEPRO Network",
              symbol: "BEPRO",
              address: "0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a",
              price: 0.00019527,
            },
            {
              chainId: "56",
              name: "Carbon Coin",
              symbol: "CARBON",
              address: "0x793cEa0F1003411396b3A81A77d92Fe37015E7A9",
              price: 0.00019507,
            },
            {
              chainId: "137",
              name: "Permission",
              symbol: "ASK",
              address: "0xaa3717090cddc9b227e49d0d84a28ac0a996e6ff",
              price: 0.00019089,
            },
            {
              chainId: "1",
              name: "Sentinel Chain",
              symbol: "SENC",
              address: "0xa13f0743951b4f6e3e3aa039f682e17279f52bc3",
              price: 0.00018747,
            },
            {
              chainId: "1",
              name: "BoringDAO",
              symbol: "BORING",
              address: "0xbc19712feb3a26080ebf6f2f7849b417fdd792ca",
              price: 0.00018729,
            },
            {
              chainId: "56",
              name: "BoringDAO",
              symbol: "BORING",
              address: "0xffeecbf8d7267757c2dc3d13d730e97e15bfdf7f",
              price: 0.00018729,
            },
            {
              chainId: "1",
              name: "Electrify.Asia",
              symbol: "ELEC",
              address: "0xd49ff13661451313ca1553fd6954bd1d9b6e02b9",
              price: 0.00018687,
            },
            {
              chainId: "1",
              name: "Essentia",
              symbol: "ESS",
              address: "0xfc05987bd2be489ACCF0f509E44B0145d68240f7",
              price: 0.00018078,
            },
            {
              chainId: "1",
              name: "Bounty0x",
              symbol: "BNTY",
              address: "0xd2d6158683aee4cc838067727209a0aaf4359de3",
              price: 0.00017969,
            },
            {
              chainId: "1",
              name: "WoofWork.io",
              symbol: "WOOF",
              address: "0x6BC08509B36A98E829dFfAD49Fde5e412645d0a3",
              price: 0.00017883,
            },
            {
              chainId: "1",
              name: "Mithril",
              symbol: "MITH",
              address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
              price: 0.00017659,
            },
            {
              chainId: "1",
              name: "Ruff",
              symbol: "RUFF",
              address: "0xf278c1ca969095ffddded020290cf8b5c424ace2",
              price: 0.00017599,
            },
            {
              chainId: "56",
              name: "Metafluence",
              symbol: "METO",
              address: "0xa78775bba7a542f291e5ef7f13c6204e704a90ba",
              price: 0.00017527,
            },
            {
              chainId: "56",
              name: "BetU",
              symbol: "BETU",
              address: "0x0df1b3f30865c5b324797f8db9d339514cac4e94",
              price: 0.00017253,
            },
            {
              chainId: "1",
              name: "Konnect",
              symbol: "KCT",
              address: "0x4c601dc69AfFb0D4Fc8dE1Ac303705e432A4A27E",
              price: 0.00017204,
            },
            {
              chainId: "1",
              name: "Lithium Finance",
              symbol: "LITH",
              address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
              price: 0.0001711,
            },
            {
              chainId: "56",
              name: "Victory Gem",
              symbol: "VTG",
              address: "0x8de5aa37a7c40a53062ead382b8eead3b08a7a46",
              price: 0.00017093,
            },
            {
              chainId: "56",
              name: "PixelVerse",
              symbol: "PIXEL",
              address: "0x47db24e17c0c4622523449a239b3de746e2b0b23",
              price: 0.00016891,
            },
            {
              chainId: "1",
              name: "PixelVerse",
              symbol: "PIXEL",
              address: "0x65e6b60ea01668634d68d0513fe814679f925bad",
              price: 0.00016891,
            },
            {
              chainId: "56",
              name: "beFITTER",
              symbol: "FIU",
              address: "0xef7d50069406a2f5a53806f7250a6c0f17ad9dcd",
              price: 0.00016726,
            },
            {
              chainId: "1",
              name: "UNION",
              symbol: "UNN",
              address: "0x226f7b842E0F0120b7E194D05432b3fd14773a9D",
              price: 0.00016565,
            },
            {
              chainId: "56",
              name: "Reign of Terror",
              symbol: "REIGN",
              address: "0xaA88FD757Fa81EbbBcE0EB1F324172d0E446093E",
              price: 0.00016456,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "56",
              name: "MetaPioneers",
              symbol: "MPI",
              address: "0x82555cc48a532fa4e2194ab883eb6d465149f80e",
              price: 0.00016348,
            },
            {
              chainId: "56",
              name: "Superpower Squad",
              symbol: "SQUAD",
              address: "0x724a32dfff9769a0a0e1f0515c0012d1fb14c3bd",
              price: 0.00016309,
            },
            {
              chainId: "1",
              name: "Pawtocol",
              symbol: "UPI",
              address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
              price: 0.00016276,
            },
            {
              chainId: "1",
              name: "Sator",
              symbol: "SAO",
              address: "0x3ef389f264e07fff3106a3926f2a166d1393086f",
              price: 0.00016216,
            },
            {
              chainId: "1",
              name: "WallStreetBets DApp",
              symbol: "WSB",
              address: "0xe1590a6fa0cff9c960181cb77d8a873601772f64",
              price: 0.00016178,
            },
            {
              chainId: "56",
              name: "MTG",
              symbol: "MTG",
              address: "0xF1B602fC211e3E2976eF44E4017b764a778197E0",
              price: 0.00015687,
            },
            {
              chainId: "56",
              name: "OptionRoom",
              symbol: "ROOM",
              address: "0x3C45A24d36Ab6fc1925533C1F57bC7e1b6fbA8a4",
              price: 0.00015276,
            },
            {
              chainId: "56",
              name: "X World Games",
              symbol: "XWG",
              address: "0x6b23c89196deb721e6fd9726e6c76e4810a464bc",
              price: 0.0001516,
            },
            {
              chainId: "1",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "56",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "1",
              name: "Yesports",
              symbol: "YESP",
              address: "0x46cca329970b33e1a007dd4ef0594a1cedb3e72a",
              price: 0.00014418,
            },
            {
              chainId: "1",
              name: "Vera",
              symbol: "VERA",
              address: "0xd7f0cc50ad69408ae58be033f4f85d2367c2e468",
              price: 0.00014392,
            },
            {
              chainId: "56",
              name: "Everdome",
              symbol: "DOME",
              address: "0x475bfaa1848591ae0e6ab69600f48d828f61a80e",
              price: 0.000143,
            },
            {
              chainId: "56",
              name: "Fame MMA",
              symbol: "FAME",
              address: "0x28ce223853d123b52c74439b10b43366d73fd3b5",
              price: 0.00014272,
            },
            {
              chainId: "137",
              name: "Catheon Gaming",
              symbol: "CATHEON",
              address: "0x7e7737C40878e720b32e7bC9CD096259f876d69f",
              price: 0.00014013,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Dreamverse",
              symbol: "DV",
              address: "0x2a03a891add2dc6d0f7b94419086630ba5cb65b6",
              price: 0.00013514,
            },
            {
              chainId: "137",
              name: "Attack Wagon",
              symbol: "ATK",
              address: "0xF868939Ee81F04f463010BC52EAb91c0839eF08c",
              price: 0.00013393,
            },
            {
              chainId: "56",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xbbcf57177d8752b21d080bf30a06ce20ad6333f8",
              price: 0.00013236,
            },
            {
              chainId: "1",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xd373576a9e738F37Dc6882328358Ff69c4cAf4c6",
              price: 0.00013236,
            },
            {
              chainId: "1",
              name: "RankerDAO",
              symbol: "RANKER",
              address: "0x6431FA4B812a2DCC062A38CB55cc7D18135AdEAd",
              price: 0.00013079,
            },
            {
              chainId: "56",
              name: "RankerDAO",
              symbol: "RANKER",
              address: "0xdE4512Db1a7a7519818dA38DB86eC1363d70A711",
              price: 0.00013079,
            },
            {
              chainId: "1",
              name: "BlockCDN",
              symbol: "BCDN",
              address: "0x1e797Ce986C3CFF4472F7D38d5C4aba55DfEFE40",
              price: 0.00013067,
            },
            {
              chainId: "1",
              name: "Idavoll DAO",
              symbol: "IDV",
              address: "0x92ec47df1aa167806dfa4916d9cfb99da6953b8f",
              price: 0.00012983,
            },
            {
              chainId: "1",
              name: "Unit Protocol",
              symbol: "DUCK",
              address: "0x92e187a03b6cd19cb6af293ba17f2745fd2357d5",
              price: 0.00012977,
            },
            {
              chainId: "56",
              name: "MetaWear",
              symbol: "WEAR",
              address: "0x9d39ef3bbca5927909dde44476656b81bbe4ee75",
              price: 0.00012949,
            },
            {
              chainId: "1",
              name: "Pacific",
              symbol: "PAF",
              address: "0x6a969d379700b2e5ea4e684d273d63c1c050ba49",
              price: 0.00012709,
            },
            {
              chainId: "56",
              name: "Seek Tiger",
              symbol: "STI",
              address: "0x4f5f7a7Dca8BA0A7983381D23dFc5eaF4be9C79a",
              price: 0.00012665,
            },
            {
              chainId: "56",
              name: "Real Realm",
              symbol: "REAL",
              address: "0xE91cd52Bd65fe23A3EAE40E3eB87180E8306399F",
              price: 0.00012563,
            },
            {
              chainId: "1",
              name: "SparkPoint",
              symbol: "SRK",
              address: "0x0488401c3f535193fa8df029d9ffe615a06e74e6",
              price: 0.00012406,
            },
            {
              chainId: "56",
              name: "AstroSwap",
              symbol: "ASTRO",
              address: "0x72eb7ca07399ec402c5b7aa6a65752b6a1dc0c27",
              price: 0.00012153,
            },
            {
              chainId: "1",
              name: "Decentralized Vulnerability Platform",
              symbol: "DVP",
              address: "0x8e30ea2329d95802fd804f4291220b0e2f579812",
              price: 0.0001192,
            },
            {
              chainId: "56",
              name: "Hydraverse",
              symbol: "HDV",
              address: "0x8Cd0d76C0ad377378aB6Ce878a7BE686223497eE",
              price: 0.00011836,
            },
            {
              chainId: "56",
              name: "DRAC Network",
              symbol: "DRAC",
              address: "0x123458C167a371250d325Bd8B1ffF12C8AF692A7",
              price: 0.00011426,
            },
            {
              chainId: "56",
              name: "Option Panda",
              symbol: "OPA",
              address: "0xA2F89a3be1bAda5Eb9D58D23EDc2E2FE0F82F4b0",
              price: 0.00010923,
            },
            {
              chainId: "1",
              name: "DSLA Protocol",
              symbol: "DSLA",
              address: "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
              price: 0.00010587,
            },
            {
              chainId: "56",
              name: "SupreNFT",
              symbol: "SNFT",
              address: "0x4F8C689f2E17bA5ff0bAf4A7dd1C7493902DaC37",
              price: 0.00010291,
            },
            {
              chainId: "1",
              name: "FEG",
              symbol: "FEG",
              address: "0xbededdf2ef49e87037c4fb2ca34d1ff3d3992a11",
              price: 0.00010278,
            },
            {
              chainId: "56",
              name: "IL CAPO OF CRYPTO",
              symbol: "CAPO",
              address: "0x922722e9ef614ec9a3e94b78496e92abfbb5a624",
              price: 0.0001025,
            },
            {
              chainId: "56",
              name: "Gamium",
              symbol: "GMM",
              address: "0x5B6bf0c7f989dE824677cFBD507D9635965e9cD3",
              price: 0.00010076,
            },
            {
              chainId: "1",
              name: "Woozoo Music",
              symbol: "WZM",
              address: "0xd15a1a2a3211b58113e45809f05934252e34e2f8",
              price: 0.00010069,
            },
            {
              chainId: "56",
              name: "Cook Protocol",
              symbol: "COOK",
              address: "0x965b0df5bda0e7a0649324d78f03d5f7f2de086a",
              price: 0.00009959,
            },
            {
              chainId: "1",
              name: "Cook Protocol",
              symbol: "COOK",
              address: "0xff75ced57419bcaebe5f05254983b013b0646ef5",
              price: 0.00009959,
            },
            {
              chainId: "56",
              name: "Knight War Spirits",
              symbol: "KWS",
              address: "0x5d0e95c15ca50f13fb86938433269d03112409fe",
              price: 0.00009917,
            },
            {
              chainId: "1",
              name: "MediShares",
              symbol: "MDS",
              address: "0x66186008c1050627f979d464eabb258860563dbe",
              price: 0.00009541,
            },
            {
              chainId: "56",
              name: "Cloudname",
              symbol: "CNAME",
              address: "0xfc3514474306e2d4aa8350fd8fa9c46c165fe8cd",
              price: 0.0000947,
            },
            {
              chainId: "1",
              name: "LunchDAO",
              symbol: "LUNCH",
              address: "0x71a28feAEe902966DC8D355e7B8Aa427D421e7e0",
              price: 0.00009329,
            },
            {
              chainId: "1",
              name: "DexGame",
              symbol: "DXGM",
              address: "0x66f73d0fd4161cfad4302dc145ff994375c13475",
              price: 0.00009273,
            },
            {
              chainId: "1",
              name: "YOP Finance",
              symbol: "YOP",
              address: "0xae1eaae3f627aaca434127644371b67b18444051",
              price: 0.00009227,
            },
            {
              chainId: "56",
              name: "WINkLink",
              symbol: "WIN",
              address: "0xaef0d72a118ce24fee3cd1d43d383897d05b4e99",
              price: 0.00009064,
            },
            {
              chainId: "56",
              name: "DarkShield",
              symbol: "DKS",
              address: "0x121235cff4c59eec80b14c1d38b44e7de3a18287",
              price: 0.00009057,
            },
            {
              chainId: "1",
              name: "Theos",
              symbol: "THEOS",
              address: "0x9e10f61749c4952c320412a6b26901605ff6da1d",
              price: 0.00009025,
            },
            {
              chainId: "56",
              name: "Flurry Finance",
              symbol: "FLURRY",
              address: "0x47c9bcef4fe2dbcdf3abf508f147f1bbe8d4fef2",
              price: 0.00008633,
            },
            {
              chainId: "1",
              name: "Flurry Finance",
              symbol: "FLURRY",
              address: "0x60F63B76E2Fc1649E57a3489162732A90ACf59FE",
              price: 0.00008633,
            },
            {
              chainId: "56",
              name: "Altbase",
              symbol: "ALTB",
              address: "0x9b3a01f8b4abd2e2a74597b21b7c269abf4e9f41",
              price: 0.0000863,
            },
            {
              chainId: "1",
              name: "Luffy",
              symbol: "LUFFY",
              address: "0x54012cDF4119DE84218F7EB90eEB87e25aE6EBd7",
              price: 0.00008619,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Zeusshield",
              symbol: "ZSC",
              address: "0x7A41e0517a5ecA4FdbC7FbebA4D4c47B9fF6DC63",
              price: 0.00008384,
            },
            {
              chainId: "1",
              name: "Loon Network",
              symbol: "LOON",
              address: "0x7C5d5100B339Fe7D995a893AF6CB496B9474373c",
              price: 0.00008231,
            },
            {
              chainId: "1",
              name: "Skrumble Network",
              symbol: "SKM",
              address: "0xd99b8a7fa48e25cce83b81812220a3e03bf64e5f",
              price: 0.00007838,
            },
            {
              chainId: "56",
              name: "Genshiro",
              symbol: "GENS",
              address: "0x2cd14cba3f26254beed1d78158cd2b6f91809600",
              price: 0.00007749,
            },
            {
              chainId: "56",
              name: "LABS Group",
              symbol: "LABS",
              address: "0x510ca7d22a84599e7d0f15f09e674056a6255389",
              price: 0.00007704,
            },
            {
              chainId: "1",
              name: "ContentBox",
              symbol: "BOX",
              address: "0x63f584FA56E60e4D0fE8802b27C7e6E3b33E007f",
              price: 0.00007696,
            },
            {
              chainId: "56",
              name: "PlaceWar",
              symbol: "PLACE",
              address: "0x07728696eE70A28c9C032926577AF1D524Df30f9",
              price: 0.00007627,
            },
            {
              chainId: "1",
              name: "BABB",
              symbol: "BAX",
              address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
              price: 0.00007559,
            },
            {
              chainId: "1",
              name: "Smart Finance",
              symbol: "SMART",
              address: "0xce20BB92CCF9BbF5091ef85649E71E552819AD8c",
              price: 0.00007491,
            },
            {
              chainId: "1",
              name: "HistoryDAO",
              symbol: "HAO",
              address: "0x3c4008eca800ec1283e4cf500e68d06bfabc00a8",
              price: 0.00007464,
            },
            {
              chainId: "56",
              name: "Metagalaxy Land",
              symbol: "MEGALAND",
              address: "0x7cd8c22d3f4b66230f73d7ffcb48576233c3fe33",
              price: 0.00007456,
            },
            {
              chainId: "1",
              name: "Life Crypto",
              symbol: "LIFE",
              address: "0x6c936D4AE98E6d2172dB18c16C4b601C99918EE6",
              price: 0.00007288,
            },
            {
              chainId: "1",
              name: "DeHorizon",
              symbol: "DEVT",
              address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
              price: 0.00007233,
            },
            {
              chainId: "1",
              name: "DPRating",
              symbol: "RATING",
              address: "0xe8663a64a96169ff4d95b4299e7ae9a76b905b31",
              price: 0.00007075,
            },
            {
              chainId: "1",
              name: "Gems ",
              symbol: "GEM",
              address: "0xc7bba5b765581efb2cdd2679db5bea9ee79b201f",
              price: 0.00006988,
            },
            {
              chainId: "56",
              name: "ProjectX",
              symbol: "XIL",
              address: "0xf3be1a4a47576208c1592cc027087ce154b00672",
              price: 0.00006836,
            },
            {
              chainId: "56",
              name: "SafeMoon",
              symbol: "SFM",
              address: "0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
              price: 0.00006831,
            },
            {
              chainId: "56",
              name: "AI Earn",
              symbol: "AIE",
              address: "0x1E30bBEE322b3B11C60cb434a47F1605C2a99483",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "API INU",
              symbol: "API",
              address: "0xA1943Bc4a417ffd2E9e11A97383fa3f9548291c3",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "BitTorrent (new)",
              symbol: "BTT",
              address: "0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Bittorrent (old)",
              symbol: "BTTOLD",
              address: "0x8595f9da7b868b1822194faed312235e43007b49",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Conflux Network",
              symbol: "CFX",
              address: "0x045c4324039da91c52c55df5d785385aab073dcf",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "CryptoCars",
              symbol: "CCAR",
              address: "0x50332bdca94673f33401776365b66cc4e81ac81d",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Dragon Kart",
              symbol: "KART",
              address: "0x8bdd8dbcbdf0c066ca5f3286d33673aa7a553c10",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Empire Token",
              symbol: "EMPIRE",
              address: "0x293c3ee9abacb08bb8ced107987f00efd1539288",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Nemesis Wealth Projects BSC",
              symbol: "NMS",
              address: "0x8cb4fdb148d87f7ec493e69391347bdd3ff1163f",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Project SEED",
              symbol: "SHILL",
              address: "0xfb9C339b4BacE4Fe63ccc1dd9a3c3C531441D5fE",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "ShopNEXT (Old)",
              symbol: "NEXT",
              address: "0x9809e877192b510d767a94ba39a79429219a5afb",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "SuperCells",
              symbol: "SCT",
              address: "0x405e7454E71AEfe8897438ADc08E3f3e6d49Dfc1",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Trias Token",
              symbol: "TRIAS",
              address: "0xa4838122c683f732289805fc3c207febd55babdd",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Trust Wallet Token",
              symbol: "TWT",
              address: "0x4b0f1812e5df2a09796481ff14017e6005508003",
              price: 0.00006695,
            },
            {
              chainId: "56",
              name: "Oceanland",
              symbol: "OLAND",
              address: "0xB0461d7E8212D311b842A58e9989edE849ac6816",
              price: 0.00006664,
            },
            {
              chainId: "56",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0x06FDA0758c17416726f77Cb11305EAC94C074Ec0",
              price: 0.00006441,
            },
            {
              chainId: "1",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
              price: 0.00006441,
            },
            {
              chainId: "1",
              name: "Convergence Finance",
              symbol: "CONV",
              address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
              price: 0.00006394,
            },
            {
              chainId: "56",
              name: "AQUANEE",
              symbol: "AQDC",
              address: "0x840aca956c06f340083fbdc6d919bdf2368fca0e",
              price: 0.00006285,
            },
            {
              chainId: "1",
              name: "Phantom",
              symbol: "PHM",
              address: "0x3f9bec82c776c47405bcb38070d2395fd18f89d3",
              price: 0.00006206,
            },
            {
              chainId: "56",
              name: "Phantom",
              symbol: "PHM",
              address: "0x4399AE7538c33cA24edD4C28C5dd7Ce9a80acF81",
              price: 0.00006206,
            },
            {
              chainId: "1",
              name: "IHT Real Estate Protocol",
              symbol: "IHT",
              address: "0xEda8B016efA8b1161208Cf041cD86972eeE0F31E",
              price: 0.00006175,
            },
            {
              chainId: "56",
              name: "Demole",
              symbol: "DMLG",
              address: "0x1c796c140de269e255372ea687ef7644bab87935",
              price: 0.00006115,
            },
            {
              chainId: "56",
              name: "Menzy",
              symbol: "MNZ",
              address: "0x861f1E1397daD68289e8f6a09a2ebb567f1B895C",
              price: 0.00005955,
            },
            {
              chainId: "1",
              name: "Huobi Pool Token",
              symbol: "HPT",
              address: "0xa66daa57432024023db65477ba87d4e7f5f95213",
              price: 0.00005947,
            },
            {
              chainId: "1",
              name: "CouponBay",
              symbol: "CUP",
              address: "0x3209d14ff61766359e64aceff91877cec2ad968e",
              price: 0.00005903,
            },
            {
              chainId: "1",
              name: "Etherparty",
              symbol: "FUEL",
              address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
              price: 0.0000579,
            },
            {
              chainId: "56",
              name: "Fanadise",
              symbol: "FAN",
              address: "0xb6d48fcef36e19681ee29896b19c1b6cbd1eab1b",
              price: 0.00005784,
            },
            {
              chainId: "56",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xfb5B838b6cfEEdC2873aB27866079AC55363D37E",
              price: 0.00005734,
            },
            {
              chainId: "1",
              name: "CNNS",
              symbol: "CNNS",
              address: "0x6c3be406174349cfa4501654313d97e6a31072e1",
              price: 0.00005554,
            },
            {
              chainId: "1",
              name: "12Ships",
              symbol: "TSHP",
              address: "0x525794473f7ab5715c81d06d10f52d11cc052804",
              price: 0.0000536,
            },
            {
              chainId: "56",
              name: "Chumbi Valley",
              symbol: "CHMB",
              address: "0x5492Ef6aEebA1A3896357359eF039a8B11621b45",
              price: 0.00005322,
            },
            {
              chainId: "1",
              name: "Remme",
              symbol: "REM",
              address: "0x83984d6142934bb535793a82adb0a46ef0f66b6d",
              price: 0.00005281,
            },
            {
              chainId: "1",
              name: "BlockBank",
              symbol: "BBANK",
              address: "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
              price: 0.00005226,
            },
            {
              chainId: "137",
              name: "AirTnT",
              symbol: "TNT",
              address: "0x25c498781ca536547b147e2199f572e5393d36f0",
              price: 0.0000509,
            },
            {
              chainId: "56",
              name: "Frutti Dino",
              symbol: "FDT",
              address: "0x3a599e584075065eAAAc768D75EaEf85c2f2fF64",
              price: 0.00005039,
            },
            {
              chainId: "1",
              name: "Tidal Finance",
              symbol: "TIDAL",
              address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
              price: 0.00004985,
            },
            {
              chainId: "1",
              name: "Endor Protocol",
              symbol: "EDR",
              address: "0xc528c28fec0a90c083328bc45f587ee215760a0f",
              price: 0.00004926,
            },
            {
              chainId: "1",
              name: "Kollect",
              symbol: "KOL",
              address: "0x1cc30e2eac975416060ec6fe682041408420d414",
              price: 0.00004726,
            },
            {
              chainId: "56",
              name: "Youclout",
              symbol: "YCT",
              address: "0x23e3981052d5280c658e5e18d814fa9582bfbc9e",
              price: 0.00004491,
            },
            {
              chainId: "56",
              name: "MOVEZ",
              symbol: "MOVEZ",
              address: "0x039cd22cb49084142d55fcd4b6096a4f51ffb3b4",
              price: 0.00004472,
            },
            {
              chainId: "56",
              name: "Galactic Arena: The NFTverse",
              symbol: "GAN",
              address: "0x8f1408171eae06aec4549fd0a5808a42cee6dd84",
              price: 0.0000429,
            },
            {
              chainId: "1",
              name: "LemoChain",
              symbol: "LEMO",
              address: "0xB5AE848EdB296C21259b7467331467d2647eEcDf",
              price: 0.00004229,
            },
            {
              chainId: "1",
              name: "ReapChain",
              symbol: "REAP",
              address: "0x1fc5EF0337AEA85C5f9198853a6E3A579a7A6987",
              price: 0.00004155,
            },
            {
              chainId: "56",
              name: "Dragon Mainland Shards",
              symbol: "DMS",
              address: "0x9a26e6d24df036b0b015016d1b55011c19e76c87",
              price: 0.00004148,
            },
            {
              chainId: "56",
              name: "Sandwich Network",
              symbol: "SANDWICH",
              address: "0xd3253Fc0A42E6dcF4F66Ab147f628E3F29e9b214",
              price: 0.00004032,
            },
            {
              chainId: "56",
              name: "Meli Games",
              symbol: "MELI",
              address: "0xaD04AC36791d923DeB082dA4f91Ab71675dD18fB",
              price: 0.00003684,
            },
            {
              chainId: "1",
              name: "NuriFootBall",
              symbol: "NRFB",
              address: "0x00281dfce4cfd72c0b6fda2aaaf077258743f9e8",
              price: 0.00003648,
            },
            {
              chainId: "56",
              name: "TLabs",
              symbol: "TBS",
              address: "0x45fffed8d9651fe9ea0321fcc9b15ee5e052a208",
              price: 0.00003606,
            },
            {
              chainId: "137",
              name: "ITSBLOC",
              symbol: "ITSB",
              address: "0x998013798440d44c1dd4c767bdd9580e16e46e28",
              price: 0.00003493,
            },
            {
              chainId: "56",
              name: "DeFi Warrior",
              symbol: "FIWA",
              address: "0x633237C6FA30FAe46Cc5bB22014DA30e50a718cC",
              price: 0.00003454,
            },
            {
              chainId: "56",
              name: "Inflation Hedging Coin",
              symbol: "IHC",
              address: "0x86a53fcd199212fea44fa7e16eb1f28812be911d",
              price: 0.00003356,
            },
            {
              chainId: "1",
              name: "MetaVisa",
              symbol: "MESA",
              address: "0x5afff9876c1f98b7d2b53bcb69eb57e92408319f",
              price: 0.00003347,
            },
            {
              chainId: "56",
              name: "eCash",
              symbol: "XEC",
              address: "0x0Ef2e7602adD1733Bfdb17aC3094d0421B502cA3",
              price: 0.00003315,
            },
            {
              chainId: "1",
              name: "Element Black",
              symbol: "ELT",
              address: "0xc0ae17eb994fa828540ffa53776b3830233a1b02",
              price: 0.00003206,
            },
            {
              chainId: "56",
              name: "Lion Token",
              symbol: "LION",
              address: "0x7969dc3c6e925bccbea9f7fc466a63c74f0115b8",
              price: 0.00003168,
            },
            {
              chainId: "1",
              name: "Lion Token",
              symbol: "LION",
              address: "0xc8ff6772f605a139c40b32d5d87d54994c705c6b",
              price: 0.00003168,
            },
            {
              chainId: "56",
              name: "Bull BTC Club",
              symbol: "BBC",
              address: "0x37e5da11b6A4DC6d2f7Abe232cDd30B0B8Fc63B1",
              price: 0.00003127,
            },
            {
              chainId: "1",
              name: "Finance Blocks",
              symbol: "FBX",
              address: "0x60bb16c4a931b1a0b8a7d945c651dd90f41d42cf",
              price: 0.00003081,
            },
            {
              chainId: "1",
              name: "Vader Protocol",
              symbol: "VADER",
              address: "0x2602278ee1882889b946eb11dc0e810075650983",
              price: 0.00003072,
            },
            {
              chainId: "56",
              name: "Terra Classic",
              symbol: "LUNC",
              address: "0x156ab3346823B651294766e23e6Cf87254d68962",
              price: 0.0000307,
            },
            {
              chainId: "1",
              name: "Terra Classic",
              symbol: "LUNC",
              address: "0xbd31ea8212119f94a611fa969881cba3ea06fa3d",
              price: 0.0000307,
            },
            {
              chainId: "1",
              name: "Odyssey",
              symbol: "OCN",
              address: "0x4092678e4E78230F46A1534C0fbc8fA39780892B",
              price: 0.00003048,
            },
            {
              chainId: "56",
              name: "NFTBomb",
              symbol: "NBP",
              address: "0x74C22834744E8D5e36c79420Ff7b057964Aba8a7",
              price: 0.00003047,
            },
            {
              chainId: "137",
              name: "Nexus Dubai",
              symbol: "NXD",
              address: "0x228b5c21ac00155cf62c57bcc704c0da8187950b",
              price: 0.00003027,
            },
            {
              chainId: "56",
              name: "Pikaster",
              symbol: "MLS",
              address: "0x5f2f6c4c491b690216e0f8ea753ff49ef4e36ba6",
              price: 0.00002958,
            },
            {
              chainId: "137",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0xecc4176b90613ed78185f01bd1e42c5640c4f09d",
              price: 0.00002897,
            },
            {
              chainId: "1",
              name: "Metababy",
              symbol: "BABY",
              address: "0x1cCF27211e8bf052f6255329ed641B4E94E80603",
              price: 0.00002874,
            },
            {
              chainId: "1",
              name: "MurAll",
              symbol: "PAINT",
              address: "0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042",
              price: 0.00002857,
            },
            {
              chainId: "1",
              name: "Celestial",
              symbol: "CELT",
              address: "0xf6e06B54855eFf198a2d9A8686113665499a6134",
              price: 0.0000285,
            },
            {
              chainId: "56",
              name: "The Killbox",
              symbol: "KBOX",
              address: "0x3523d58d8036b1c5c9a13493143c97aefc5ad422",
              price: 0.00002708,
            },
            {
              chainId: "56",
              name: "GetKicks",
              symbol: "KICKS",
              address: "0xfEB4e9B932eF708c498Cc997ABe51D0EE39300cf",
              price: 0.00002682,
            },
            {
              chainId: "1",
              name: "Sponge",
              symbol: "$SPONGE",
              address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
              price: 0.00002552,
            },
            {
              chainId: "56",
              name: "Ellipsis",
              symbol: "EPX",
              address: "0xAf41054C1487b0e5E2B9250C0332eCBCe6CE9d71",
              price: 0.00002513,
            },
            {
              chainId: "1",
              name: "Refereum",
              symbol: "RFR",
              address: "0xd0929d411954c47438dc1d871dd6081f5c5e149c",
              price: 0.00002511,
            },
            {
              chainId: "1",
              name: "GoWithMi",
              symbol: "GMAT",
              address: "0xb13de094cc5cee6c4cc0a3737bf0290166d9ca5d",
              price: 0.00002481,
            },
            {
              chainId: "1",
              name: "GSENetwork",
              symbol: "GSE",
              address: "0xe530441f4f73bdb6dc2fa5af7c3fc5fd551ec838",
              price: 0.00002441,
            },
            {
              chainId: "1",
              name: "WATTTON",
              symbol: "WATT",
              address: "0xE67F943af5Eb6051ef56f05979cc30B732717fa6",
              price: 0.00002385,
            },
            {
              chainId: "1",
              name: "DxChain",
              symbol: "DX",
              address: "0x973e52691176d36453868d9d86572788d27041a9",
              price: 0.00002296,
            },
            {
              chainId: "56",
              name: "PRIMAL",
              symbol: "PRIMAL",
              address: "0xcb5327ed4649548e0d73e70b633cdfd99af6da87",
              price: 0.00002292,
            },
            {
              chainId: "42161",
              name: "Arbipad",
              symbol: "ARBI",
              address: "0x07DD5BEAffb65B8fF2e575d500BDf324a05295DC",
              price: 0.00002161,
            },
            {
              chainId: "56",
              name: "MoneySwap",
              symbol: "MSWAP",
              address: "0xdd5a149740c055bdcdc5c066888f739dbe0bf2d0",
              price: 0.0000213,
            },
            {
              chainId: "56",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0x4cfbbdfbd5bf0814472ff35c72717bd095ada055",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "Lemond",
              symbol: "LEMD",
              address: "0xf45f6c8bb3d77ea762175b8f7ca4d251941649fa",
              price: 0.00002096,
            },
            {
              chainId: "56",
              name: "LUSD",
              symbol: "LUSD",
              address: "0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e",
              price: 0.00001967,
            },
            {
              chainId: "1",
              name: "Seele",
              symbol: "SEELE",
              address: "0xb1e93236ab6073fdac58ada5564897177d4bcc43",
              price: 0.0000191,
            },
            {
              chainId: "56",
              name: "Arbipad",
              symbol: "ARBI",
              address: "0xa7bD657C5838472dDF85FF0797A2e6fce8fd4833",
              price: 0.00001872,
            },
            {
              chainId: "56",
              name: "Venus Reward Token",
              symbol: "VRT",
              address: "0x5f84ce30dc3cf7909101c69086c50de191895883",
              price: 0.00001755,
            },
            {
              chainId: "56",
              name: "Coinzix",
              symbol: "ZIX",
              address: "0x48077400FAF11183c043Feb5184a13ea628Bb0DB",
              price: 0.0000161,
            },
            {
              chainId: "56",
              name: "Hoge Finance",
              symbol: "HOGE",
              address: "0xa4FFfc757e8c4F24E7b209C033c123D20983Ad40",
              price: 0.00001589,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "56",
              name: "Infinity Angel",
              symbol: "ING",
              address: "0xAe7c682Ba26AD6835B6150FfB35F22Db9987f509",
              price: 0.00001461,
            },
            {
              chainId: "1",
              name: "Frontrow",
              symbol: "FRR",
              address: "0xe6602b34d8510b033e000975b3322537c7172441",
              price: 0.00001434,
            },
            {
              chainId: "1",
              name: "Krypton Galaxy Coin",
              symbol: "KGC",
              address: "0xa8262Eb913FccEa4C3f77fc95b8b4043B384cFbB",
              price: 0.00001418,
            },
            {
              chainId: "56",
              name: "Ariva ",
              symbol: "ARV",
              address: "0x6679eb24f59dfe111864aec72b443d1da666b360",
              price: 0.00001374,
            },
            {
              chainId: "56",
              name: "FitBurn",
              symbol: "CAL",
              address: "0x859C940F080B197659b3EfFc804fD622Df66f0a1",
              price: 0.00001373,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "56",
              name: "PIAS",
              symbol: "PIAS",
              address: "0xC669A70e0B3D07e3514aFd97eBFb3D134077A4a1",
              price: 0.00001333,
            },
            {
              chainId: "56",
              name: "Lucky Block V1",
              symbol: "LBLOCK",
              address: "0x2cd96e8c3ff6b5e01169f6e3b61d28204e7810bb",
              price: 0.00001313,
            },
            {
              chainId: "56",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
              price: 0.00001275,
            },
            {
              chainId: "42161",
              name: "POGAI",
              symbol: "POGAI",
              address: "0x6fD58f5a2F3468e35fEb098b5F59F04157002407",
              price: 0.00001271,
            },
            {
              chainId: "56",
              name: "RealFevr",
              symbol: "FEVR",
              address: "0x82030CDBD9e4B7c5bb0b811A61DA6360D69449cc",
              price: 0.00001159,
            },
            {
              chainId: "56",
              name: "BikeRush",
              symbol: "BRT",
              address: "0xfc9F81B107F51F2383fCE56650fEDB59C5fd59bD",
              price: 0.00001119,
            },
            {
              chainId: "1",
              name: "TomTomCoin",
              symbol: "TOMS",
              address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
              price: 0.00001099,
            },
            {
              chainId: "56",
              name: "WaultSwap",
              symbol: "WEX",
              address: "0xa9c41a46a6b3531d28d5c32f6633dd2ff05dfb90",
              price: 0.00001027,
            },
            {
              chainId: "1",
              name: "Every Game",
              symbol: "EGAME",
              address: "0x62d3c05b9c3d916fbc111819bbd3cee52906c1ae",
              price: 0.00001004,
            },
            {
              chainId: "56",
              name: "MetaRim",
              symbol: "RIM",
              address: "0xa25199a79a34cc04b15e5c0bba4e3a557364e532",
              price: 0.00001003,
            },
            {
              chainId: "1",
              name: "AXL INU",
              symbol: "AXL",
              address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
              price: 0.00000988,
            },
            {
              chainId: "56",
              name: "AXL INU",
              symbol: "AXL",
              address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
              price: 0.00000988,
            },
            {
              chainId: "1",
              name: "MiraQle",
              symbol: "MQL",
              address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
              price: 0.0000093,
            },
            {
              chainId: "1",
              name: "Hoge Finance",
              symbol: "HOGE",
              address: "0xfad45e47083e4607302aa43c65fb3106f1cd7607",
              price: 0.00000925,
            },
            {
              chainId: "56",
              name: "Lovely Inu",
              symbol: "LOVELY",
              address: "0x9E24415d1e549EBc626a13a482Bb117a2B43e9CF",
              price: 0.00000909,
            },
            {
              chainId: "1",
              name: "Vidy",
              symbol: "VIDY",
              address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
              price: 0.00000873,
            },
            {
              chainId: "1",
              name: "AdaSwap",
              symbol: "ASW",
              address: "0x56694577564FdD577a0ABB20FE95C1E2756C2a11",
              price: 0.00000799,
            },
            {
              chainId: "1",
              name: "SRT",
              symbol: "SRT",
              address: "0x22987407FD1fC5A971e3FDA3B3e74C88666cDa91",
              price: 0.00000766,
            },
            {
              chainId: "1",
              name: "FansTime",
              symbol: "FTI",
              address: "0x943ed852dadb5c3938ecdc6883718df8142de4c8",
              price: 0.0000075,
            },
            {
              chainId: "56",
              name: "Biconomy Exchange Token",
              symbol: "BIT",
              address: "0xc864019047b864b6ab609a968ae2725dfaee808a",
              price: 0.00000698,
            },
            {
              chainId: "137",
              name: "Kitsumon",
              symbol: "KMC",
              address: "0x44d09156c7b4acf0c64459fbcced7613f5519918",
              price: 0.0000064,
            },
            {
              chainId: "1",
              name: "SHARBI",
              symbol: "SHARBI",
              address: "0xf3a3023e6dede84ad88a656a3269f2a36e83c9a9",
              price: 0.00000616,
            },
            {
              chainId: "1",
              name: "Hashgard",
              symbol: "GARD",
              address: "0x5c64031c62061865e5fd0f53d3cdaef80f72e99d",
              price: 0.00000503,
            },
            {
              chainId: "1",
              name: "Hasaki",
              symbol: "HAHA",
              address: "0xd87D72248093597df8D56d2a53C1ab7c1A0Cc8DA",
              price: 0.00000475,
            },
            {
              chainId: "56",
              name: "Ouro",
              symbol: "OGS",
              address: "0x416947e6fc78f158fd9b775fa846b72d768879c2",
              price: 0.00000424,
            },
            {
              chainId: "137",
              name: "iNFTspace",
              symbol: "INS",
              address: "0xb988bd378a0754957d5d9471c96e0f8051645a26",
              price: 0.00000377,
            },
            {
              chainId: "1",
              name: "Nahmii",
              symbol: "NII",
              address: "0x7c8155909cd385F120A56eF90728dD50F9CcbE52",
              price: 0.00000368,
            },
            {
              chainId: "1",
              name: "HashCoin",
              symbol: "HSC",
              address: "0x2bba3cf6de6058cc1b4457ce00deb359e2703d7f",
              price: 0.00000362,
            },
            {
              chainId: "56",
              name: "Petals",
              symbol: "PTS",
              address: "0xFA53a4778431712af31a11621eDee4D0926dF1aC",
              price: 0.0000036,
            },
            {
              chainId: "1",
              name: "D Community",
              symbol: "DILI",
              address: "0x37f74e99794853777a10ea1dc08a64c86958f06a",
              price: 0.00000355,
            },
            {
              chainId: "1",
              name: "Facts",
              symbol: "BKC",
              address: "0x34bdf48A8F753de4822a6CFB1FEE275F9b4D662e",
              price: 0.00000339,
            },
            {
              chainId: "56",
              name: "Loser Coin",
              symbol: "LOWB",
              address: "0x843d4a358471547f51534e3e51fae91cb4dc3f28",
              price: 0.00000331,
            },
            {
              chainId: "1",
              name: "ADreward",
              symbol: "AD",
              address: "0xe973E453977195422B48e1852A207b7eE9C913C7",
              price: 0.00000307,
            },
            {
              chainId: "1",
              name: "TwitFi",
              symbol: "TWT",
              address: "0xd4Df22556e07148e591B4c7b4f555a17188CF5cF",
              price: 0.00000259,
            },
            {
              chainId: "56",
              name: "Mint Club",
              symbol: "MINT",
              address: "0x1f3af095cda17d63cad238358837321e95fc5915",
              price: 0.00000219,
            },
            {
              chainId: "1",
              name: "FourCoin",
              symbol: "FOUR",
              address: "0x244b797d622d4dee8b188b03546acaabd0cf91a0",
              price: 0.00000207,
            },
            {
              chainId: "56",
              name: "Smaugs NFT",
              symbol: "SMG",
              address: "0x6bfd576220e8444ca4cc5f89efbd7f02a4c94c16",
              price: 0.000002,
            },
            {
              chainId: "1",
              name: "Red Token",
              symbol: "RED",
              address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
              price: 0.00000179,
            },
            {
              chainId: "1",
              name: "Kiba Inu",
              symbol: "KIBA",
              address: "0x005D1123878Fc55fbd56b54C73963b234a64af3c",
              price: 0.00000168,
            },
            {
              chainId: "56",
              name: "Kiba Inu",
              symbol: "KIBA",
              address: "0xC3afDe95B6Eb9ba8553cDAea6645D45fB3a7FAF5",
              price: 0.00000168,
            },
            {
              chainId: "1",
              name: "Aeron",
              symbol: "ARNX",
              address: "0x0C37Bcf456bC661C14D596683325623076D7e283",
              price: 0.00000164,
            },
            {
              chainId: "1",
              name: "Moon Rabbit",
              symbol: "AAA",
              address: "0x8c6bf16c273636523c29db7db04396143770f6a0",
              price: 0.0000015,
            },
            {
              chainId: "56",
              name: "FastSwap",
              symbol: "FAST",
              address: "0x2322afaac81697e770c19a58df587d8739777536",
              price: 0.00000128,
            },
            {
              chainId: "1",
              name: "Cult DAO",
              symbol: "CULT",
              address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
              price: 0.00000126,
            },
            {
              chainId: "1",
              name: "LGCY Network",
              symbol: "LGCY",
              address: "0xae697f994fc5ebc000f8e22ebffee04612f98a0d",
              price: 0.00000107,
            },
            {
              chainId: "1",
              name: "Incube Chain",
              symbol: "ICB",
              address: "0x00166a5b93FD4f87ecA1c267d31D82dF3f133a7F",
              price: 0.00000103,
            },
            {
              chainId: "1",
              name: "CareCoin",
              symbol: "CARE",
              address: "0x329cf160F30D21006bCD24b67EAde561E54CDE4c",
              price: 0.000001,
            },
            {
              chainId: "56",
              name: "CryptoPlanes",
              symbol: "CPAN",
              address: "0x04260673729c5f2b9894a467736f3d85f8d34fc8",
              price: 0.000001,
            },
            {
              chainId: "1",
              name: "GM",
              symbol: "GM",
              address: "0xe5597f0723eeaba1b26948e06f008bf0fc1e37e6",
              price: 9.63776e-7,
            },
            {
              chainId: "1",
              name: "PawZone",
              symbol: "PAW",
              address: "0x1AA51bc7eb181ce48CE626Bf62f8956Fa9555136",
              price: 9.45328e-7,
            },
            {
              chainId: "56",
              name: "GoldMiner",
              symbol: "GM",
              address: "0xe2604c9561d490624aa35e156e65e590eb749519",
              price: 8.68905e-7,
            },
            {
              chainId: "1",
              name: "MoonieNFT",
              symbol: "MNY",
              address: "0xa6f7645ed967faf708a614a2fca8d4790138586f",
              price: 8.08469e-7,
            },
            {
              chainId: "56",
              name: "MoonieNFT",
              symbol: "MNY",
              address: "0xa6f7645ed967faf708a614a2fca8d4790138586f",
              price: 8.08469e-7,
            },
            {
              chainId: "1",
              name: "StarLink",
              symbol: "STARL",
              address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
              price: 7.98843e-7,
            },
            {
              chainId: "1",
              name: "PREMA",
              symbol: "PRMX",
              address: "0xe4dae00bc1c46ea2F44ae71B1BEb8b171C15d812",
              price: 6.08679e-7,
            },
            {
              chainId: "137",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x57194feaca970A4E98A19C365FE144fB54F657DB",
              price: 4.88719e-7,
            },
            {
              chainId: "56",
              name: "APENFT",
              symbol: "NFT",
              address: "0x1fC9004eC7E5722891f5f38baE7678efCB11d34D",
              price: 4.85702e-7,
            },
            {
              chainId: "1",
              name: "Gas DAO",
              symbol: "GAS",
              address: "0x6bba316c48b49bd1eac44573c5c871ff02958469",
              price: 4.73063e-7,
            },
            {
              chainId: "1",
              name: "Clips",
              symbol: "CLIPS",
              address: "0xecbee2fae67709f718426ddc3bf770b26b95ed20",
              price: 3.73805e-7,
            },
            {
              chainId: "56",
              name: "SB Group",
              symbol: "SBG",
              address: "0x5e95a952a7f79f978585afd54a053af0f51372fa",
              price: 3.67439e-7,
            },
            {
              chainId: "1",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "56",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "1",
              name: "TemDAO",
              symbol: "TEM",
              address: "0xaE0585a259A3BCAB258D6EE02FB583f7B33C2a12",
              price: 2.98575e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "56",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x7bd6FaBD64813c48545C9c0e312A0099d9be2540",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
              price: 2.36911e-7,
            },
            {
              chainId: "1",
              name: "The Rug Game",
              symbol: "TRG",
              address: "0x93eEB426782BD88fCD4B48D7b0368CF061044928",
              price: 1.66619e-7,
            },
            {
              chainId: "56",
              name: "CateCoin",
              symbol: "CATE",
              address: "0xE4FAE3Faa8300810C835970b9187c268f55D998F",
              price: 1.48973e-7,
            },
            {
              chainId: "56",
              name: "FREEdom Coin",
              symbol: "FREE",
              address: "0x12e34cdf6a031a10fe241864c32fb03a4fdad739",
              price: 1.38588e-7,
            },
            {
              chainId: "1",
              name: "FREEdom Coin",
              symbol: "FREE",
              address: "0x2F141Ce366a2462f02cEA3D12CF93E4DCa49e4Fd",
              price: 1.38588e-7,
            },
            {
              chainId: "56",
              name: "Popcoin",
              symbol: "POP",
              address: "0x63bc9770Ea9a2F21Df6cc1224D64d8dEc9c61a74",
              price: 1.07108e-7,
            },
            {
              chainId: "56",
              name: "Bitgert",
              symbol: "BRISE",
              address: "0x8fff93e810a2edaafc326edee51071da9d398e83",
              price: 1.00301e-7,
            },
            {
              chainId: "56",
              name: "AI DogeMini",
              symbol: "AIDOGEMINI",
              address: "0xf709e948daed701a6a018e6f6090ca1930055966",
              price: 9.3596e-8,
            },
            {
              chainId: "1",
              name: "Akita Inu",
              symbol: "AKITA",
              address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
              price: 8.8739e-8,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "56",
              name: "Fidance",
              symbol: "FDC",
              address: "0x6d1a4650e83708b583c35d5e0952a0b46354ca9b",
              price: 7.1059e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "56",
              name: "MAGIKAL.ai",
              symbol: "MGKL",
              address: "0x8abfa6a4f4b9865b0e7acfdce1839a2584636d06",
              price: 5.628e-8,
            },
            {
              chainId: "56",
              name: "Pancake Games",
              symbol: "GCAKE",
              address: "0x61d5822dd7b3ed495108733e6550d4529480c8f6",
              price: 4.9573e-8,
            },
            {
              chainId: "1",
              name: "A Hunters Dream",
              symbol: "CAW",
              address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
              price: 4.5523e-8,
            },
            {
              chainId: "56",
              name: "Vita Inu",
              symbol: "VINU",
              address: "0xfEbe8C1eD424DbF688551D4E2267e7A53698F0aa",
              price: 2.3883e-8,
            },
            {
              chainId: "56",
              name: "DegenReborn",
              symbol: "DEGEN",
              address: "0x1a131f7b106d58f33eaf0fe5b47db2f2045e5732",
              price: 2.1243e-8,
            },
            {
              chainId: "56",
              name: "Doge KaKi",
              symbol: "KAKI",
              address: "0x42414624c55a9cba80789f47c8f9828a7974e40f",
              price: 2.1208e-8,
            },
            {
              chainId: "56",
              name: "Pig Finance",
              symbol: "PIG",
              address: "0x8850d2c68c632e3b258e612abaa8fada7e6958e5",
              price: 1.8515e-8,
            },
            {
              chainId: "56",
              name: "Milo Inu",
              symbol: "MILO",
              address: "0xd9de2b1973e57dc9dba90c35d6cd940ae4a3cbe1",
              price: 1.6118e-8,
            },
            {
              chainId: "1",
              name: "Vita Inu",
              symbol: "VINU",
              address: "0xAFCdd4f666c84Fed1d8BD825aA762e3714F652c9",
              price: 1.2511e-8,
            },
            {
              chainId: "1",
              name: "Pawswap",
              symbol: "PAW",
              address: "0xdc63269ea166b70d4780b3a11f5c825c2b761b01",
              price: 1.0468e-8,
            },
            {
              chainId: "1",
              name: "POOH",
              symbol: "POOH",
              address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
              price: 1.0227e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "56",
              name: "Wiki Cat",
              symbol: "WKC",
              address: "0x6ec90334d89dbdc89e08a133271be3d104128edb",
              price: 8.941e-9,
            },
            {
              chainId: "137",
              name: "Revolt 2 Earn",
              symbol: "RVLT",
              address: "0xf0f9D895aCa5c8678f706FB8216fa22957685A13",
              price: 8.635e-9,
            },
            {
              chainId: "56",
              name: "Safemars",
              symbol: "SAFEMARS",
              address: "0x3ad9594151886ce8538c1ff615efa2385a8c3a88",
              price: 8.378e-9,
            },
            {
              chainId: "56",
              name: "TiFi Token",
              symbol: "TIFI",
              address: "0x17E65E6b9B166Fb8e7c59432F0db126711246BC0",
              price: 7.687e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "1",
              name: "WALL STREET BABY",
              symbol: "WSB",
              address: "0x15F20f9DFDf96CCf6AC96653b7C0aBfe4A9C9f0f",
              price: 6.511e-9,
            },
            {
              chainId: "56",
              name: "SafeMars Protocol",
              symbol: "SMARS",
              address: "0xc0366a104b429f0806bfa98d0008daa9555b2bed",
              price: 5.155e-9,
            },
            {
              chainId: "137",
              name: "PolyDoge",
              symbol: "POLYDOGE",
              address: "0x8A953CfE442c5E8855cc6c61b1293FA648BAE472",
              price: 5.07e-9,
            },
            {
              chainId: "56",
              name: "YooShi",
              symbol: "YOOSHI",
              address: "0x02ff5065692783374947393723dba9599e59f591",
              price: 4.406e-9,
            },
            {
              chainId: "56",
              name: "DogeKing",
              symbol: "DOGEKING",
              address: "0x641ec142e67ab213539815f67e4276975c2f8d50",
              price: 4.395e-9,
            },
            {
              chainId: "1",
              name: "Kuma Inu",
              symbol: "KUMA",
              address: "0x48c276e8d03813224bb1e55f953adb6d02fd3e02",
              price: 3.148e-9,
            },
            {
              chainId: "1",
              name: "Shib Original Vision",
              symbol: "SOV",
              address: "0x2c5bc2ba3614fd27fcc7022ea71d9172e2632c16",
              price: 2.836e-9,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
            {
              chainId: "56",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xc748673057861a797275cd8a068abb95a902e8de",
              price: 1.196e-9,
            },
            {
              chainId: "56",
              name: "WEB4 AI",
              symbol: "WEB4",
              address: "0xee7e8c85956d32c64bafdcded3f43b3c39b1ce2f",
              price: 1.137e-9,
            },
            {
              chainId: "56",
              name: "MangoMan Intelligent",
              symbol: "MMIT",
              address: "0x9767c8E438Aa18f550208e6d1fDf5f43541cC2c8",
              price: 9.80633e-10,
            },
            {
              chainId: "56",
              name: "SpacePi",
              symbol: "SPACEPI",
              address: "0x69b14e8D3CEBfDD8196Bfe530954A0C226E5008E",
              price: 9.35511e-10,
            },
            {
              chainId: "56",
              name: "Australian Safe Shepherd",
              symbol: "ASS",
              address: "0x7c63f96feafacd84e75a594c00fac3693386fbf0",
              price: 7.99906e-10,
            },
            {
              chainId: "1",
              name: "MultiPlanetary Inus",
              symbol: "INUS",
              address: "0x39207d2e2feef178fbda8083914554c59d9f8c00",
              price: 7.85747e-10,
            },
            {
              chainId: "56",
              name: "Hamster",
              symbol: "HAM",
              address: "0x679d5b2d94f454c950d683d159b87aa8eae37c9e",
              price: 7.71311e-10,
            },
            {
              chainId: "56",
              name: "Wall Street Games",
              symbol: "WSG",
              address: "0xa58950f05fea2277d2608748412bf9f802ea4901",
              price: 6.30438e-10,
            },
            {
              chainId: "56",
              name: "Rich Quack",
              symbol: "QUACK",
              address: "0xd74b782e05aa25c50e7330af541d46e18f36661c",
              price: 5.46908e-10,
            },
            {
              chainId: "42161",
              name: "Rekt",
              symbol: "REKT",
              address: "0x1d987200df3b744cfa9c14f713f5334cb4bc4d5d",
              price: 5.16042e-10,
            },
            {
              chainId: "56",
              name: "Teddy Doge V2",
              symbol: "TEDDY V2",
              address: "0xDB79c12d1d0670988A39B0E48b96e955eF922d24",
              price: 3.70909e-10,
            },
            {
              chainId: "56",
              name: "Pepe AI",
              symbol: "PEPEAI",
              address: "0x24086eab82dbdaa4771d0a5d66b0d810458b0e86",
              price: 3.19943e-10,
            },
            {
              chainId: "1",
              name: "Kishu Inu",
              symbol: "KISHU",
              address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
              price: 3.12047e-10,
            },
            {
              chainId: "42161",
              name: "ArbDoge AI",
              symbol: "AIDOGE",
              address: "0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b",
              price: 2.6422e-10,
            },
            {
              chainId: "137",
              name: "XEN Crypto (MXEN)",
              symbol: "MXEN",
              address: "0x2AB0e9e4eE70FFf1fB9D67031E44F6410170d00e",
              price: 1.9555e-10,
            },
            {
              chainId: "1",
              name: "Bear Inu",
              symbol: "BEAR",
              address: "0x17837004ea685690b32dbead02a274ec4333a26a",
              price: 1.83143e-10,
            },
            {
              chainId: "56",
              name: "T23",
              symbol: "T23",
              address: "0x897f2be515373cf1f899d864b5be2bd5efd4e653",
              price: 1.30485e-10,
            },
            {
              chainId: "42161",
              name: "BullBear AI",
              symbol: "AIBB",
              address: "0xB9AF4762c039D63e30039F1712dfaB77026408c7",
              price: 1.15256e-10,
            },
            {
              chainId: "1",
              name: "FEG token",
              symbol: "FEG",
              address: "0x389999216860ab8e0175387a0c90e5c52522c945",
              price: 9.0222e-11,
            },
            {
              chainId: "56",
              name: "Catgirl",
              symbol: "CATGIRL",
              address: "0x79ebc9a2ce02277a4b5b3a768b1c0a4ed75bd936",
              price: 1.6972e-11,
            },
            {
              chainId: "56",
              name: "MiniFootball",
              symbol: "MINIFOOTBALL",
              address: "0xd024ac1195762f6f13f8cfdf3cdd2c97b33b248b",
              price: 7.953e-12,
            },
            {
              chainId: "42161",
              name: "AiShiba",
              symbol: "SHIBAI",
              address: "0xFA296FcA3c7DBa4a92A42Ec0B5E2138DA3b29050",
              price: 3.891e-12,
            },
            {
              chainId: "56",
              name: "Oggy Inu",
              symbol: "OGGY",
              address: "0x92ed61fb8955cc4e392781cb8b7cd04aadc43d0c",
              price: 3.128e-12,
            },
            {
              chainId: "56",
              name: "FLOKI CEO",
              symbol: "FLOKICEO",
              address: "0x45289007706E7Ee7B42b1fA506661d97740Edfb4",
              price: 1.866e-12,
            },
            {
              chainId: "1",
              name: "Homer",
              symbol: "SIMPSON",
              address: "0x44aAd22aFbB2606d7828Ca1f8f9E5af00e779AE1",
              price: 1.68e-12,
            },
          ],
        },
        chainIds: [1, 10, 137, 204, 4200, 42161, 5000, 534352, 56, 81457],
        cexLabels: ["Unknown"],
        tags: [
          {
            _id: "66699a44ddf67ede9a5cb33c",
            value: "loot",
            color: "#D0D5DD",
          },
          {
            _id: "66699e21ddf67ede9a5cbd36",
            value: "lootex",
            color: "#EABBFB",
          },
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "666bfeca85672a7368da84d3",
            value: "OriginTrail",
            color: "#FCCEEE",
          },
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
          {
            _id: "66b2df85eb9d48f61f021fcc",
            value: "ARB holder",
            color: "#FAA7E0",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-08-07T02:44:57.547Z",
          type: "csvImport",
        },
      },
      {
        _id: "666bfc4d85672a7368da1936",
        uid: "666bfc4d85672a7368da1936",
        userIds: ["666bfc4d85672a7368da1936"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce87f90",
            ecosystem: "evm",
            walletAddress: "0x21a31Ee1afC51d94C2eFcCAa2092aD1028285549",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 293,
        walletTotalValue: 321956442.9301757,
        walletAge: "0y11m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "137",
              name: "WETH",
              symbol: "WETH",
              address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
              price: 2575,
            },
            {
              chainId: "1",
              name: "Wrapped Beacon ETH",
              symbol: "WBETH",
              address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
              price: 1918.25,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "56",
              name: "WETH",
              symbol: "WETH",
              address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
              price: 1795.73,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Olympus v1",
              symbol: "OHM",
              address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
              price: 126.31,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Tellor",
              symbol: "TRB",
              address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
              price: 35.2,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "Cream",
              symbol: "CREAM",
              address: "0x2ba592f78db6436527729929aaf6c908497cb200",
              price: 9.3,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "1",
              name: "MANTRA",
              symbol: "OM",
              address: "0x3593d125a4f7849a1b059e64f4517a86dd60c95d",
              price: 6.31,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Prom",
              symbol: "PROM",
              address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
              price: 5.3,
            },
            {
              chainId: "56",
              name: "Polkadot",
              symbol: "DOT",
              address: "0x7083609fce4d1d8dc0c979aab8c869ea2c873402",
              price: 4.87,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Binance Wrapped DOT",
              symbol: "BDOT",
              address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
              price: 4.29,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "Varen",
              symbol: "VRN",
              address: "0x72377f31e30a405282b522d588aebbea202b4f23",
              price: 2.28,
            },
            {
              chainId: "1",
              name: "Mettalex",
              symbol: "MTLX",
              address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
              price: 2.11,
            },
            {
              chainId: "1",
              name: "Strong",
              symbol: "STRONG",
              address: "0x990f341946a3fdb507ae7e52d17851b87168017c",
              price: 2.1,
            },
            {
              chainId: "56",
              name: "XRPL",
              symbol: "XRP",
              address: "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe",
              price: 2.06,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "137",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 1.44,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "Metal",
              symbol: "MTL",
              address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
              price: 1.12,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Binance USD",
              symbol: "BUSD",
              address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
              price: 1.005,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "137",
              name: "Tether",
              symbol: "USDT",
              address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
              price: 0.999982,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "Synthetix USD",
              symbol: "sUSD",
              address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
              price: 0.986225,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "Travala",
              symbol: "AVA",
              address: "0x442b153f6f61c0c99a33aa4170dcb31e1abda1d0",
              price: 0.871989,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "56",
              name: "Cardano",
              symbol: "ADA",
              address: "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
              price: 0.779615,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "56",
              name: "SafePal",
              symbol: "SFP",
              address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
              price: 0.64872,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "DIA Token",
              symbol: "DIA",
              address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
              price: 0.588598,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Augur",
              symbol: "REP",
              address: "0x221657776846890989a759BA2973e427DfF5C9bB",
              price: 0.56782,
            },
            {
              chainId: "1",
              name: "Crypto.com",
              symbol: "MCO",
              address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
              price: 0.550727,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Pundi X",
              symbol: "PUNDIX",
              address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
              price: 0.439679,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "Magic",
              symbol: "MAGIC",
              address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
              price: 0.361285,
            },
            {
              chainId: "1",
              name: "COMBO (Cocos-BCX)",
              symbol: "COMBO",
              address: "0xc4c7ea4fab34bd9fb9a5e1b1a98df76e26e6407c",
              price: 0.359251,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Golem",
              symbol: "GLM",
              address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
              price: 0.341553,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "137",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0xbbba073c31bf03b8acf7c28ef0738decf3695683",
              price: 0.32675,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "Power Ledger",
              symbol: "POWR",
              address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
              price: 0.264952,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "137",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x0000000000000000000000000000000000001010",
              price: 0.242044,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Cortex",
              symbol: "CTXC",
              address: "0xea11755ae41d889ceec39a63e6ff75a02bc1c00d",
              price: 0.210565,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "ERC20",
              symbol: "ERC20",
              address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
              price: 0.181667,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Ambire AdEx",
              symbol: "ADX",
              address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
              price: 0.168441,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Civic",
              symbol: "CVC",
              address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
              price: 0.146882,
            },
            {
              chainId: "1",
              name: "Cartesi",
              symbol: "CTSI",
              address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
              price: 0.131561,
            },
            {
              chainId: "1",
              name: "Audius",
              symbol: "AUDIO",
              address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
              price: 0.129838,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "Keep network",
              symbol: "KEEP",
              address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
              price: 0.126376,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Request",
              symbol: "REQ",
              address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
              price: 0.113254,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Automata Network",
              symbol: "ATA",
              address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
              price: 0.10699,
            },
            {
              chainId: "1",
              name: "STEPN",
              symbol: "GMT",
              address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
              price: 0.098677,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Genesis Vision",
              symbol: "GVT",
              address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
              price: 0.084401,
            },
            {
              chainId: "1",
              name: "NuCypher",
              symbol: "NU",
              address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
              price: 0.083335,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Viberate",
              symbol: "VIB",
              address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
              price: 0.066984,
            },
            {
              chainId: "1",
              name: "LTO Network",
              symbol: "LTO",
              address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
              price: 0.064516,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "UkraineDAO Flag NFT",
              symbol: "LOVE",
              address: "0x5380442d3c4ec4f5777f551f5edd2fa0f691a27c",
              price: 0.052924,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "AirSwap",
              symbol: "AST",
              address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
              price: 0.04582521,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Measurable Data Token",
              symbol: "MDT",
              address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
              price: 0.04354095,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "district0x",
              symbol: "DNT",
              address: "0x0abdace70d3790235af448c88547603b945604ea",
              price: 0.04080933,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "The Virtua Kolect",
              symbol: "TVK",
              address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
              price: 0.03756698,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "Unification",
              symbol: "FUND",
              address: "0xbe6ac6b50f577205c9d107f37b6e205aa6acc5d4",
              price: 0.03419847,
            },
            {
              chainId: "1",
              name: "Streamr DATAcoin",
              symbol: "DATA",
              address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
              price: 0.03407983,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "IoTeX",
              symbol: "IOTX",
              address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
              price: 0.0328816,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Quickswap",
              symbol: "QUICK",
              address: "0xd2ba23de8a19316a638dc1e7a9adda1d74233368",
              price: 0.0245393,
            },
            {
              chainId: "1",
              name: "Enigma",
              symbol: "ENG",
              address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
              price: 0.02276452,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "OAX",
              symbol: "OAX",
              address: "0x701c244b988a513c945973defa05de933b23fe1d",
              price: 0.02125365,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "Voyager Token",
              symbol: "VGX",
              address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
              price: 0.01113651,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "OnX Finance",
              symbol: "ONX",
              address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
              price: 0.00951438,
            },
            {
              chainId: "1",
              name: "EasyFi ",
              symbol: "EZ",
              address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
              price: 0.00815894,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "GYEN",
              symbol: "GYEN",
              address: "0xc08512927d12348f6620a698105e1baac6ecd911",
              price: 0.00638966,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Polkacity",
              symbol: "POLC",
              address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
              price: 0.00600761,
            },
            {
              chainId: "1",
              name: "Bread",
              symbol: "BRD",
              address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
              price: 0.00579243,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "StormX",
              symbol: "STMX",
              address: "0xbE9375C6a420D2eEB258962efB95551A5b722803",
              price: 0.00535924,
            },
            {
              chainId: "1",
              name: "SALT",
              symbol: "SALT",
              address: "0x4156D3342D5c385a87D264F90653733592000581",
              price: 0.00534483,
            },
            {
              chainId: "1",
              name: "TFS",
              symbol: "TFS",
              address: "0xc2A81eb482cB4677136D8812cC6Db6E0cB580883",
              price: 0.00405818,
            },
            {
              chainId: "1",
              name: "Solve",
              symbol: "SOLVE",
              address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
              price: 0.00402632,
            },
            {
              chainId: "1",
              name: "Raiden Network Token",
              symbol: "RDN",
              address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
              price: 0.00381733,
            },
            {
              chainId: "1",
              name: "Loom Network [OLD]",
              symbol: "LOOM",
              address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
              price: 0.00370114,
            },
            {
              chainId: "1",
              name: "Verasity",
              symbol: "VRA",
              address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
              price: 0.00366433,
            },
            {
              chainId: "1",
              name: "DREP",
              symbol: "DREP",
              address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
              price: 0.00339307,
            },
            {
              chainId: "1",
              name: "pNetwork",
              symbol: "PNT",
              address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
              price: 0.0033276,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "Bytom",
              symbol: "BTM",
              address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
              price: 0.00284996,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "Proton",
              symbol: "XPR",
              address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
              price: 0.00190436,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "56",
              name: "AI Trader",
              symbol: "AIT",
              address: "0x4238E5Ccc619dCC8c00ADE4cfc5d3D9020b24898",
              price: 0.00166909,
            },
            {
              chainId: "1",
              name: "SONM",
              symbol: "SNM",
              address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
              price: 0.00141279,
            },
            {
              chainId: "1",
              name: "Quantstamp",
              symbol: "QSP",
              address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
              price: 0.00131793,
            },
            {
              chainId: "1",
              name: "Dent",
              symbol: "DENT",
              address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
              price: 0.00120978,
            },
            {
              chainId: "1",
              name: "Wabi",
              symbol: "WABI",
              address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
              price: 0.00109904,
            },
            {
              chainId: "1",
              name: "Agrello",
              symbol: "DLT",
              address: "0x07e3c70653548B04f0A75970C1F81B4CBbFB606f",
              price: 0.00097389,
            },
            {
              chainId: "1",
              name: "Everex",
              symbol: "EVX",
              address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
              price: 0.00096603,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "Ripio Credit Network",
              symbol: "RCN",
              address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
              price: 0.00082467,
            },
            {
              chainId: "1",
              name: "Selfkey",
              symbol: "KEY",
              address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
              price: 0.00077915,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "PERL.eco",
              symbol: "PERL",
              address: "0xeca82185adce47f39c684352b0439f030f860318",
              price: 0.00047299,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Geojam",
              symbol: "JAM",
              address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
              price: 0.00040671,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "WePower",
              symbol: "WPR",
              address: "0x4CF488387F035FF08c371515562CBa712f9015d4",
              price: 0.00034799,
            },
            {
              chainId: "1",
              name: "Substratum",
              symbol: "SUB",
              address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
              price: 0.00034775,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "AppCoins",
              symbol: "APPC",
              address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
              price: 0.0001916,
            },
            {
              chainId: "1",
              name: "Mithril",
              symbol: "MITH",
              address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
              price: 0.00017659,
            },
            {
              chainId: "1",
              name: "OST",
              symbol: "OST",
              address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
              price: 0.00016351,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "Life Crypto",
              symbol: "LIFE",
              address: "0x6c936D4AE98E6d2172dB18c16C4b601C99918EE6",
              price: 0.00007288,
            },
            {
              chainId: "1",
              name: "MintySwap",
              symbol: "MINTYS",
              address: "0xbbd900e05b4af2124390d206f70bc4e583b1be85",
              price: 0.00006695,
            },
            {
              chainId: "1",
              name: "Etherparty",
              symbol: "FUEL",
              address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
              price: 0.0000579,
            },
            {
              chainId: "1",
              name: "SNGLS DAO",
              symbol: "SNGLS",
              address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
              price: 0.00004751,
            },
            {
              chainId: "1",
              name: "Vabble",
              symbol: "VAB",
              address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
              price: 0.00003008,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "56",
              name: "FitBurn",
              symbol: "CAL",
              address: "0x859C940F080B197659b3EfFc804fD622Df66f0a1",
              price: 0.00001373,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "56",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
              price: 0.00001275,
            },
            {
              chainId: "1",
              name: "VIBE",
              symbol: "VIBE",
              address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
              price: 0.00000115,
            },
            {
              chainId: "1",
              name: "Monkeys",
              symbol: "MONKEYS",
              address: "0xf2A22B900dde3ba18Ec2AeF67D4c8C1a0DAB6aAC",
              price: 3.9393e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "Baby Doge Coin",
              symbol: "BABYDOGE",
              address: "0xac57de9c1a09fec648e93eb98875b212db0d460b",
              price: 2.115e-9,
            },
            {
              chainId: "1",
              name: "Ben",
              symbol: "BEN",
              address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
              price: 1.157e-9,
            },
            {
              chainId: "1",
              name: "CanYaCoin",
              symbol: "CAN",
              address: "0x1d462414fe14cf489c7a21cac78509f4bf8cd7c0",
              price: 0,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 56],
        cexLabels: ["Binance"],
        tags: [
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666bfe3185672a7368da6c63",
            value: "Golem",
            color: "#E0FF89",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-17T11:28:54.078Z",
          type: "contractImport",
        },
      },
      {
        _id: "666bfc5285672a7368da1cf2",
        uid: "666bfc5285672a7368da1cf2",
        userIds: ["666bfc5285672a7368da1cf2"],
        wallets: [
          {
            status: "verified",
            walletId: "68373ec57a939d1fbce8784c",
            ecosystem: "evm",
            walletAddress: "0x75e89d5979E4f6Fba9F97c104c2F0AFB3F1dcB88",
          },
        ],
        emails: [],
        discords: [],
        telegrams: [],
        twitters: [],
        totalTokenCount: 964,
        walletTotalValue: 313511835.7253385,
        walletAge: "0y11m",
        tokens: {
          token: [
            {
              chainId: "1",
              name: "Wrapped Bitcoin",
              symbol: "WBTC",
              address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
              price: 81413,
            },
            {
              chainId: "1",
              name: "Whiteheart",
              symbol: "WHITE",
              address: "0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44",
              price: 6187.9,
            },
            {
              chainId: "1",
              name: "yearn.finance",
              symbol: "YFI",
              address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
              price: 5472.25,
            },
            {
              chainId: "1",
              name: "cVault.finance",
              symbol: "CORE",
              address: "0x62359ed7505efc61ff1d56fef82158ccaffa23d7",
              price: 3449.69,
            },
            {
              chainId: "1",
              name: "Tether Gold",
              symbol: "XAUT",
              address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
              price: 3216.94,
            },
            {
              chainId: "1",
              name: "PAX Gold",
              symbol: "PAXG",
              address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
              price: 2710.52,
            },
            {
              chainId: "1",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "42161",
              name: "ETH",
              symbol: "ETH",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 2575,
            },
            {
              chainId: "1",
              name: "weETH",
              symbol: "weETH",
              address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
              price: 1915.54,
            },
            {
              chainId: "1",
              name: "Maker DAO",
              symbol: "MKR",
              address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
              price: 1830.7,
            },
            {
              chainId: "1",
              name: "Lido Staked Ether",
              symbol: "STETH",
              address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
              price: 1798.14,
            },
            {
              chainId: "1",
              name: "WETH",
              symbol: "WETH",
              address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
              price: 1795.91,
            },
            {
              chainId: "1",
              name: "DIGG",
              symbol: "DIGG",
              address: "0x798D1bE841a82a273720CE31c822C61a67a601C3",
              price: 686.86,
            },
            {
              chainId: "56",
              name: "BNB",
              symbol: "BNB",
              address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
              price: 658.87,
            },
            {
              chainId: "56",
              name: "Wrapped BNB",
              symbol: "WBNB",
              address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
              price: 599.66,
            },
            {
              chainId: "1",
              name: "BNB",
              symbol: "BNB",
              address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
              price: 582.02,
            },
            {
              chainId: "1",
              name: "XMON",
              symbol: "XMON",
              address: "0x3aaDA3e213aBf8529606924d8D1c55CbDc70Bf74",
              price: 495.69,
            },
            {
              chainId: "1",
              name: "DFI.Money",
              symbol: "YFII",
              address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
              price: 306.47,
            },
            {
              chainId: "1",
              name: "UniCrypt",
              symbol: "UNCX",
              address: "0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
              price: 273.04,
            },
            {
              chainId: "1",
              name: "Doge Killer",
              symbol: "LEASH",
              address: "0x27c70cd1946795b66be9d954418546998b546634",
              price: 241.51,
            },
            {
              chainId: "1",
              name: "Aave",
              symbol: "AAVE",
              address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
              price: 160.14,
            },
            {
              chainId: "1",
              name: "Gnosis",
              symbol: "GNO",
              address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
              price: 148.09,
            },
            {
              chainId: "1",
              name: "Mixin",
              symbol: "XIN",
              address: "0xa974c709cfb4566686553a20790685a47aceaa33",
              price: 133.89,
            },
            {
              chainId: "1",
              name: "Olympus v1",
              symbol: "OHM",
              address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
              price: 126.31,
            },
            {
              chainId: "1",
              name: "Quant",
              symbol: "QNT",
              address: "0x4a220e6096b25eadb88358cb44068a3248254675",
              price: 104.44,
            },
            {
              chainId: "1",
              name: "Wrapped NXM",
              symbol: "WNXM",
              address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
              price: 70.13,
            },
            {
              chainId: "1",
              name: "OKB",
              symbol: "OKB",
              address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
              price: 51.17,
            },
            {
              chainId: "1",
              name: "Compound ",
              symbol: "COMP",
              address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
              price: 49.57,
            },
            {
              chainId: "1",
              name: "Inverse Finance",
              symbol: "INV",
              address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
              price: 48.04,
            },
            {
              chainId: "1",
              name: "MetisDAO",
              symbol: "METIS",
              address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
              price: 34.47,
            },
            {
              chainId: "1",
              name: "Harvest Finance",
              symbol: "FARM",
              address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
              price: 30.32,
            },
            {
              chainId: "1",
              name: "COVER Protocol",
              symbol: "COVER",
              address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
              price: 27.95,
            },
            {
              chainId: "1",
              name: "Saffron.finance",
              symbol: "SFI",
              address: "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
              price: 21.19,
            },
            {
              chainId: "1",
              name: "Keep3rV1",
              symbol: "KP3R",
              address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
              price: 20.1,
            },
            {
              chainId: "1",
              name: "Deus Finance",
              symbol: "DEUS",
              address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
              price: 19.2,
            },
            {
              chainId: "1",
              name: "DeXe.network",
              symbol: "DEXE",
              address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
              price: 18.64,
            },
            {
              chainId: "1",
              name: "Alchemix",
              symbol: "ALCX",
              address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "Bounce",
              symbol: "AUCTION",
              address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
              price: 16.33,
            },
            {
              chainId: "1",
              name: "ChainLink",
              symbol: "LINK",
              address: "0x514910771af9ca656af840dff83e8264ecf986ca",
              price: 16.29,
            },
            {
              chainId: "1",
              name: "Enzyme Finance",
              symbol: "MLN",
              address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
              price: 15.67,
            },
            {
              chainId: "1",
              name: "Ethereum Name Service",
              symbol: "ENS",
              address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
              price: 15.65,
            },
            {
              chainId: "1",
              name: "Strike",
              symbol: "STRK",
              address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
              price: 12.59,
            },
            {
              chainId: "1",
              name: "Numeraire",
              symbol: "NMR",
              address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
              price: 12.43,
            },
            {
              chainId: "1",
              name: "Illuvium",
              symbol: "ILV",
              address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
              price: 11.43,
            },
            {
              chainId: "1",
              name: "UNIUM",
              symbol: "UNM",
              address: "0x6570ffe19da7e2b425329b157d9109b87f18304b",
              price: 9.66,
            },
            {
              chainId: "1",
              name: "Nation3",
              symbol: "NATION",
              address: "0x333a4823466879eef910a04d473505da62142069",
              price: 8.95,
            },
            {
              chainId: "1",
              name: "Injective",
              symbol: "INJ",
              address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
              price: 8.81,
            },
            {
              chainId: "1",
              name: "HAPI",
              symbol: "HAPI",
              address: "0xD9c2D319Cd7e6177336b0a9c93c21cb48d84Fb54",
              price: 8.41,
            },
            {
              chainId: "1",
              name: "Tornado Cash",
              symbol: "TORN",
              address: "0x77777feddddffc19ff86db637967013e6c6a116c",
              price: 7.93,
            },
            {
              chainId: "1",
              name: "Rake Finance",
              symbol: "RAK",
              address: "0xa8b0f154a688c22142e361707df64277e0a0be66",
              price: 7.57,
            },
            {
              chainId: "1",
              name: "Rocket Pool",
              symbol: "RPL",
              address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
              price: 6.8,
            },
            {
              chainId: "1",
              name: "Uniswap",
              symbol: "UNI",
              address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
              price: 6.32,
            },
            {
              chainId: "56",
              name: "Uniswap",
              symbol: "UNI",
              address: "0xbf5140a22578168fd562dccf235e5d43a02ce9b1",
              price: 6.02,
            },
            {
              chainId: "1",
              name: "Axie Infinity",
              symbol: "AXS",
              address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
              price: 5.83,
            },
            {
              chainId: "1",
              name: "SSV Network",
              symbol: "SSV",
              address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
              price: 5.72,
            },
            {
              chainId: "1",
              name: "Instadapp",
              symbol: "INST",
              address: "0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb",
              price: 5.45,
            },
            {
              chainId: "1",
              name: "Reflexer Ungovernance Token",
              symbol: "FLX",
              address: "0x6243d8cea23066d098a15582d81a598b4e8391f4",
              price: 5.12,
            },
            {
              chainId: "1",
              name: "Bitget Token",
              symbol: "BGB",
              address: "0x19de6b897ed14a376dda0fe53a5420d2ac828a28",
              price: 5.03,
            },
            {
              chainId: "1",
              name: "FloorDAO",
              symbol: "FLOOR",
              address: "0xf59257e961883636290411c11ec5ae622d19455e",
              price: 4.77,
            },
            {
              chainId: "1",
              name: "Ampleforth Governance Token ",
              symbol: "FORTH",
              address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
              price: 4.51,
            },
            {
              chainId: "1",
              name: "Metavault DAO",
              symbol: "MVD",
              address: "0x788B6D2B37Aa51D916F2837Ae25b05f0e61339d1",
              price: 4.3,
            },
            {
              chainId: "1",
              name: "Darwinia Commitment Token",
              symbol: "KTON",
              address: "0x9f284e1337a815fe77d2ff4ae46544645b20c5ff",
              price: 4.19,
            },
            {
              chainId: "1",
              name: "Euler",
              symbol: "EUL",
              address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
              price: 4.17,
            },
            {
              chainId: "1",
              name: "Badger DAO",
              symbol: "BADGER",
              address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
              price: 3.94,
            },
            {
              chainId: "1",
              name: "Hermez Network",
              symbol: "HEZ",
              address: "0xeef9f339514298c6a857efcfc1a762af84438dee",
              price: 3.82,
            },
            {
              chainId: "1",
              name: "Livepeer",
              symbol: "LPT",
              address: "0x58b6a8a3302369daec383334672404ee733ab239",
              price: 3.78,
            },
            {
              chainId: "1",
              name: "MX Token",
              symbol: "MX",
              address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
              price: 3.66,
            },
            {
              chainId: "1",
              name: "Wrapped Toncoin",
              symbol: "TONCOIN",
              address: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
              price: 3.53,
            },
            {
              chainId: "1",
              name: "Echelon Prime",
              symbol: "PRIME",
              address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
              price: 3.34,
            },
            {
              chainId: "1",
              name: "Render Token",
              symbol: "RNDR",
              address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
              price: 3.19,
            },
            {
              chainId: "1",
              name: "Pre-Retogeum",
              symbol: "PRTG",
              address: "0xbd04ccc050058a6a422851fa6c0f92bb65eb06ca",
              price: 3.09,
            },
            {
              chainId: "1",
              name: "Pendle",
              symbol: "PENDLE",
              address: "0x808507121b80c02388fad14726482e061b8da827",
              price: 3.06,
            },
            {
              chainId: "1",
              name: "Chicken Token",
              symbol: "KFC",
              address: "0xe63684bcf2987892cefb4caa79bd21b34e98a291",
              price: 3.01,
            },
            {
              chainId: "1",
              name: "ZURRENCY",
              symbol: "ZURR",
              address: "0x89509aa1d14a8e1e5364ec4c3b041213bcdbe08d",
              price: 2.64,
            },
            {
              chainId: "1",
              name: "Vulcan Forged",
              symbol: "PYR",
              address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
              price: 2.56,
            },
            {
              chainId: "1",
              name: "Index Cooperative",
              symbol: "INDEX",
              address: "0x0954906da0Bf32d5479e25f46056d22f08464cab",
              price: 2.53,
            },
            {
              chainId: "1",
              name: "MUX Protocol",
              symbol: "MCB",
              address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
              price: 2.48,
            },
            {
              chainId: "1",
              name: "Mask Network",
              symbol: "MASK",
              address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
              price: 2.41,
            },
            {
              chainId: "1",
              name: "VitaDAO",
              symbol: "VITA",
              address: "0x81f8f0bb1cb2a06649e51913a151f0e7ef6fa321",
              price: 2.25,
            },
            {
              chainId: "1",
              name: "Mettalex",
              symbol: "MTLX",
              address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
              price: 2.11,
            },
            {
              chainId: "1",
              name: "Convex Finance",
              symbol: "CVX",
              address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Dego Finance",
              symbol: "DEGO",
              address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
              price: 1.96,
            },
            {
              chainId: "1",
              name: "Ethernity Chain",
              symbol: "ERN",
              address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
              price: 1.84,
            },
            {
              chainId: "1",
              name: "Tokamak Network",
              symbol: "TON",
              address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
              price: 1.78,
            },
            {
              chainId: "1",
              name: "Alpha Quark Token",
              symbol: "AQT",
              address: "0x2a9bdcff37ab68b95a53435adfd8892e86084f93",
              price: 1.75,
            },
            {
              chainId: "1",
              name: "Balancer",
              symbol: "BAL",
              address: "0xba100000625a3754423978a60c9317c58a424e3D",
              price: 1.7,
            },
            {
              chainId: "1",
              name: "Galxe",
              symbol: "GAL",
              address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "UMA",
              symbol: "UMA",
              address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
              price: 1.65,
            },
            {
              chainId: "1",
              name: "Frax Share",
              symbol: "FXS",
              address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
              price: 1.6,
            },
            {
              chainId: "1",
              name: "Adventure Gold",
              symbol: "AGLD",
              address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
              price: 1.52,
            },
            {
              chainId: "1",
              name: "ApeX Protocol",
              symbol: "APEX",
              address: "0x52a8845df664d76c69d2eea607cd793565af42b8",
              price: 1.51,
            },
            {
              chainId: "1",
              name: "Poolz Finance",
              symbol: "POOLX",
              address: "0xEef66125BfcFfdb1642C7E85a432cD1B78038399",
              price: 1.49,
            },
            {
              chainId: "1",
              name: "Rarible",
              symbol: "RARI",
              address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
              price: 1.44,
            },
            {
              chainId: "56",
              name: "Anyswap",
              symbol: "ANY",
              address: "0xf68c9df95a18b2a5a5fa1124d79eeeffbad0b6fa",
              price: 1.4,
            },
            {
              chainId: "1",
              name: "API3",
              symbol: "API3",
              address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
              price: 1.3,
            },
            {
              chainId: "1",
              name: "Universal Liquidity Union",
              symbol: "ULU",
              address: "0x035bfe6057e15ea692c0dfdcab3bb41a64dd2ad4",
              price: 1.28,
            },
            {
              chainId: "1",
              name: "Nexo",
              symbol: "NEXO",
              address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
              price: 1.27,
            },
            {
              chainId: "1",
              name: "iExec RLC",
              symbol: "RLC",
              address: "0x607f4c5bb672230e8672085532f7e901544a7375",
              price: 1.25,
            },
            {
              chainId: "1",
              name: "FTX Token",
              symbol: "FTT",
              address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
              price: 1.24,
            },
            {
              chainId: "1",
              name: "Ampleforth",
              symbol: "AMPL",
              address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
              price: 1.22,
            },
            {
              chainId: "1",
              name: "Highstreet",
              symbol: "HIGH",
              address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
              price: 1.2,
            },
            {
              chainId: "1",
              name: "One Share",
              symbol: "ONS",
              address: "0x5BB29c33C4A3C29f56F8ACa40B4dB91d8a5fe2c5",
              price: 1.15,
            },
            {
              chainId: "1",
              name: "MetaX",
              symbol: "X1",
              address: "0xf6c2a37acc8ba45874808837486110dc0afc63c8",
              price: 1.099,
            },
            {
              chainId: "1",
              name: "Router Protocol",
              symbol: "ROUTE",
              address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
              price: 1.093,
            },
            {
              chainId: "1",
              name: "Arcblock",
              symbol: "ABT",
              address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
              price: 1.076,
            },
            {
              chainId: "1",
              name: "Radicle",
              symbol: "RAD",
              address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
              price: 1.063,
            },
            {
              chainId: "1",
              name: "Synthetix",
              symbol: "SNX",
              address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
              price: 1.045,
            },
            {
              chainId: "1",
              name: "AirTor Protocol",
              symbol: "ATOR",
              address: "0x0f7b3f5a8fed821c5eb60049538a548db2d479ce",
              price: 1.04,
            },
            {
              chainId: "1",
              name: "SuperVerse",
              symbol: "SUPER",
              address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
              price: 1.039,
            },
            {
              chainId: "1",
              name: "Euro Tether",
              symbol: "EURT",
              address: "0xc581b735a1688071a1746c968e0798d642ede491",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "Huobi Token",
              symbol: "HT",
              address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
              price: 1.032,
            },
            {
              chainId: "1",
              name: "My Neighbor Alice",
              symbol: "ALICE",
              address: "0xac51066d7bec65dc4589368da368b212745d63e8",
              price: 1.013,
            },
            {
              chainId: "1",
              name: "Lido DAO Token",
              symbol: "LDO",
              address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
              price: 1.001,
            },
            {
              chainId: "1",
              name: "Fei USD",
              symbol: "FEI",
              address: "0x956f47f50a910163d8bf957cf5846d573e7f87ca",
              price: 1,
            },
            {
              chainId: "56",
              name: "Tether",
              symbol: "USDT",
              address: "0x55d398326f99059ff775485246999027b3197955",
              price: 1,
            },
            {
              chainId: "1",
              name: "Tether",
              symbol: "USDT",
              address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
              price: 1,
            },
            {
              chainId: "137",
              name: "Tether",
              symbol: "USDT",
              address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
              price: 0.999982,
            },
            {
              chainId: "1",
              name: "USD Coin",
              symbol: "USDC",
              address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
              price: 0.999808,
            },
            {
              chainId: "1",
              name: "Pax Dollar",
              symbol: "USDP",
              address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
              price: 0.999705,
            },
            {
              chainId: "1",
              name: "Dai",
              symbol: "DAI",
              address: "0x6b175474e89094c44da98b954eedeac495271d0f",
              price: 0.9997,
            },
            {
              chainId: "1",
              name: "True USD",
              symbol: "TUSD",
              address: "0x0000000000085d4780B73119b644AE5ecd22b376",
              price: 0.99768,
            },
            {
              chainId: "1",
              name: "USDD",
              symbol: "USDD",
              address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
              price: 0.996134,
            },
            {
              chainId: "1",
              name: "Band Protocol",
              symbol: "BAND",
              address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
              price: 0.984288,
            },
            {
              chainId: "1",
              name: "Pickle Finance",
              symbol: "PICKLE",
              address: "0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
              price: 0.969209,
            },
            {
              chainId: "1",
              name: "Goldfinch",
              symbol: "GFI",
              address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
              price: 0.941368,
            },
            {
              chainId: "1",
              name: "Propy",
              symbol: "PRO",
              address: "0x226bb599a12c826476e3a771454697ea52e9e220",
              price: 0.936258,
            },
            {
              chainId: "1",
              name: "INVI",
              symbol: "INVI",
              address: "0x356a5160f2b34bc8d88fb084745465ebbbed0174",
              price: 0.905331,
            },
            {
              chainId: "1",
              name: "Liquity",
              symbol: "LQTY",
              address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
              price: 0.889973,
            },
            {
              chainId: "1",
              name: "RAE Token",
              symbol: "RAE",
              address: "0xe5a3229ccb22b6484594973a03a3851dcd948756",
              price: 0.87323,
            },
            {
              chainId: "1",
              name: "pBTC35A",
              symbol: "pBTC35A",
              address: "0xA8b12Cc90AbF65191532a12bb5394A714A46d358",
              price: 0.872876,
            },
            {
              chainId: "1",
              name: "Cobak Token",
              symbol: "CBK",
              address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
              price: 0.866028,
            },
            {
              chainId: "1",
              name: "APED",
              symbol: "APED",
              address: "0xe0151763455a8a021e64880c238ba1cff3787ff0",
              price: 0.819289,
            },
            {
              chainId: "1",
              name: "Base Protocol",
              symbol: "BASE",
              address: "0x07150e919b4de5fd6a63de1f9384828396f25fdc",
              price: 0.80542,
            },
            {
              chainId: "1",
              name: "Litentry",
              symbol: "LIT",
              address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
              price: 0.801914,
            },
            {
              chainId: "1",
              name: "Fetch AI",
              symbol: "FET",
              address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
              price: 0.791788,
            },
            {
              chainId: "1",
              name: "Aavegotchi",
              symbol: "GHST",
              address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
              price: 0.791164,
            },
            {
              chainId: "1",
              name: "Curve DAO",
              symbol: "CRV",
              address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
              price: 0.712811,
            },
            {
              chainId: "1",
              name: "Tokenlon",
              symbol: "LON",
              address: "0x0000000000095413afc295d19edeb1ad7b71c952",
              price: 0.700937,
            },
            {
              chainId: "1",
              name: "dYdX",
              symbol: "DYDX",
              address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
              price: 0.690752,
            },
            {
              chainId: "1",
              name: "Arbitrum",
              symbol: "ARB",
              address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
              price: 0.683708,
            },
            {
              chainId: "1",
              name: "ICHI",
              symbol: "ICHI",
              address: "0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6",
              price: 0.662571,
            },
            {
              chainId: "1",
              name: "RabbitX (Strips-Finance)",
              symbol: "STRP",
              address: "0x97872EAfd79940C7b24f7BCc1EADb1457347ADc9",
              price: 0.655342,
            },
            {
              chainId: "1",
              name: "Aragon",
              symbol: "ANT",
              address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
              price: 0.653017,
            },
            {
              chainId: "1",
              name: "CoW Protocol",
              symbol: "COW",
              address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
              price: 0.648403,
            },
            {
              chainId: "1",
              name: "Perpetual Protocol",
              symbol: "PERP",
              address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
              price: 0.624864,
            },
            {
              chainId: "1",
              name: "OriginTrail",
              symbol: "TRAC",
              address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
              price: 0.623907,
            },
            {
              chainId: "1",
              name: "Rook",
              symbol: "ROOK",
              address: "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
              price: 0.622491,
            },
            {
              chainId: "1",
              name: "WHALE",
              symbol: "WHALE",
              address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
              price: 0.620746,
            },
            {
              chainId: "1",
              name: "88mph",
              symbol: "MPH",
              address: "0x8888801af4d980682e47f1a9036e589479e835c5",
              price: 0.611573,
            },
            {
              chainId: "1",
              name: "Stader",
              symbol: "SD",
              address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
              price: 0.606721,
            },
            {
              chainId: "1",
              name: "Sushi",
              symbol: "SUSHI",
              address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
              price: 0.580131,
            },
            {
              chainId: "1",
              name: "Botto",
              symbol: "BOTTO",
              address: "0x9dfad1b7102d46b1b197b90095b5c4e9f5845bba",
              price: 0.578301,
            },
            {
              chainId: "1",
              name: "PepeCoin Cryptocurrency",
              symbol: "pepecoin",
              address: "0xA9E8aCf069C58aEc8825542845Fd754e41a9489A",
              price: 0.57721,
            },
            {
              chainId: "1",
              name: "Rhino.fi",
              symbol: "DVF",
              address: "0xdddddd4301a082e62e84e43f474f044423921918",
              price: 0.544063,
            },
            {
              chainId: "1",
              name: "Stake DAO",
              symbol: "SDT",
              address: "0x73968b9a57c6e53d41345fd57a6e6ae27d6cdb2f",
              price: 0.542468,
            },
            {
              chainId: "1",
              name: "Synapse",
              symbol: "SYN",
              address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
              price: 0.540441,
            },
            {
              chainId: "1",
              name: "Hifi Finance",
              symbol: "HIFI",
              address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
              price: 0.534052,
            },
            {
              chainId: "1",
              name: "ImmutableX",
              symbol: "IMX",
              address: "0xf57e7e7c23978c3caec3c3548e3d615c346e79ff",
              price: 0.529966,
            },
            {
              chainId: "1",
              name: "Crown Token",
              symbol: "CROWN",
              address: "0xF3Bb9F16677F2B86EfD1DFca1c141A99783Fde58",
              price: 0.519661,
            },
            {
              chainId: "1",
              name: "Gomining Token",
              symbol: "GMT",
              address: "0x7ddc52c4de30e94be3a6a0a2b259b2850f421989",
              price: 0.517705,
            },
            {
              chainId: "1",
              name: "Bella Protocol",
              symbol: "BEL",
              address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
              price: 0.503408,
            },
            {
              chainId: "1",
              name: "SingularityNET",
              symbol: "AGIX",
              address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
              price: 0.502446,
            },
            {
              chainId: "1",
              name: "Ocean Protocol",
              symbol: "OCEAN",
              address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
              price: 0.501678,
            },
            {
              chainId: "1",
              name: "Orion Protocol",
              symbol: "ORN",
              address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
              price: 0.468948,
            },
            {
              chainId: "1",
              name: "Unifi Protocol DAO",
              symbol: "UNFI",
              address: "0x441761326490cACF7aF299725B6292597EE822c2",
              price: 0.466356,
            },
            {
              chainId: "1",
              name: "Chintai",
              symbol: "CHEX",
              address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
              price: 0.465696,
            },
            {
              chainId: "1",
              name: "X Protocol",
              symbol: "POT",
              address: "0x049b98b31eF7D6448519f3642AAD92AB5b8aDa52",
              price: 0.452427,
            },
            {
              chainId: "1",
              name: "ROGin",
              symbol: "ROG",
              address: "0x5d43b66da68706D39f6C97F7f1415615672b446b",
              price: 0.44825,
            },
            {
              chainId: "1",
              name: "Stronger",
              symbol: "STRNGR",
              address: "0xdc0327d50e6c73db2f8117760592c8bbf1cdcf38",
              price: 0.445494,
            },
            {
              chainId: "1",
              name: "Storj",
              symbol: "STORJ",
              address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
              price: 0.444639,
            },
            {
              chainId: "1",
              name: "Fantom",
              symbol: "FTM",
              address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
              price: 0.435811,
            },
            {
              chainId: "1",
              name: "Float Protocol",
              symbol: "BANK",
              address: "0x24a6a37576377f63f194caa5f518a60f45b42921",
              price: 0.426757,
            },
            {
              chainId: "1",
              name: "ApeCoin",
              symbol: "APE",
              address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
              price: 0.416937,
            },
            {
              chainId: "1",
              name: "DexTools",
              symbol: "DEXT",
              address: "0xfb7b4564402e5500db5bb6d63ae671302777c75a",
              price: 0.413162,
            },
            {
              chainId: "1",
              name: "Monte",
              symbol: "MONTE",
              address: "0x318Ee488AF8881f9945B6d3D69e8B395Fb559bB1",
              price: 0.405615,
            },
            {
              chainId: "1",
              name: "Axelar",
              symbol: "WAXL",
              address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
              price: 0.405253,
            },
            {
              chainId: "1",
              name: "Prosper",
              symbol: "PROS",
              address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
              price: 0.402579,
            },
            {
              chainId: "1",
              name: "The Sandbox",
              symbol: "SAND",
              address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
              price: 0.400709,
            },
            {
              chainId: "1",
              name: "Cellframe ",
              symbol: "CELL",
              address: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
              price: 0.399025,
            },
            {
              chainId: "1",
              name: "Frontier",
              symbol: "FRONT",
              address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
              price: 0.389179,
            },
            {
              chainId: "1",
              name: "aelf",
              symbol: "ELF",
              address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
              price: 0.378857,
            },
            {
              chainId: "1",
              name: "BarnBridge",
              symbol: "BOND",
              address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
              price: 0.367329,
            },
            {
              chainId: "1",
              name: "Unicly",
              symbol: "UNIC",
              address: "0x94e0bab2f6ab1f19f4750e42d7349f2740513ad5",
              price: 0.366642,
            },
            {
              chainId: "1",
              name: "Bancor",
              symbol: "BNT",
              address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
              price: 0.362797,
            },
            {
              chainId: "1",
              name: "PoolTogether",
              symbol: "POOL",
              address: "0x0cec1a9154ff802e7934fc916ed7ca50bde6844e",
              price: 0.361803,
            },
            {
              chainId: "1",
              name: "Magic",
              symbol: "MAGIC",
              address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
              price: 0.361285,
            },
            {
              chainId: "1",
              name: "Swarm",
              symbol: "BZZ",
              address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
              price: 0.357921,
            },
            {
              chainId: "1",
              name: "Kryll",
              symbol: "KRL",
              address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
              price: 0.35556,
            },
            {
              chainId: "1",
              name: "Yield Guild Games",
              symbol: "YGG",
              address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
              price: 0.354012,
            },
            {
              chainId: "1",
              name: "Bone ShibaSwap",
              symbol: "BONE",
              address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
              price: 0.352201,
            },
            {
              chainId: "1",
              name: "HUNT",
              symbol: "HUNT",
              address: "0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5",
              price: 0.350634,
            },
            {
              chainId: "1",
              name: "Massive Protocol",
              symbol: "MAV",
              address: "0xbe1dBe6741fB988fb571AB1E28CfFB36e3C62629",
              price: 0.346507,
            },
            {
              chainId: "1",
              name: "Multichain",
              symbol: "MULTI",
              address: "0x65ef703f5594d2573eb71aaf55bc0cb548492df4",
              price: 0.343111,
            },
            {
              chainId: "1",
              name: "Mancium",
              symbol: "MANC",
              address: "0xe0c05ec44775e4ad62cdc2eecdf337aa7a143363",
              price: 0.34195,
            },
            {
              chainId: "1",
              name: "Kyber Network Crystal ",
              symbol: "KNC",
              address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
              price: 0.339838,
            },
            {
              chainId: "1",
              name: "TRIBE",
              symbol: "TRIBE",
              address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
              price: 0.337072,
            },
            {
              chainId: "1",
              name: "Decentraland",
              symbol: "MANA",
              address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
              price: 0.330283,
            },
            {
              chainId: "1",
              name: "All In",
              symbol: "ALLIN",
              address: "0x9B2b931d6AB97B6A887b2C5d8529537E6FE73Ebe",
              price: 0.315413,
            },
            {
              chainId: "1",
              name: "Ribbon Finance",
              symbol: "RBN",
              address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
              price: 0.31189,
            },
            {
              chainId: "1",
              name: "Gitcoin",
              symbol: "GTC",
              address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
              price: 0.309778,
            },
            {
              chainId: "1",
              name: "Equilibrium",
              symbol: "EQ",
              address: "0xA5eDE2FEE620ac3d68065EC01F26F9dd99850B82",
              price: 0.299051,
            },
            {
              chainId: "1",
              name: "Mysterium",
              symbol: "MYST",
              address: "0x4cf89ca06ad997bc732dc876ed2a7f26a9e7f361",
              price: 0.295197,
            },
            {
              chainId: "1",
              name: "0x Protocol",
              symbol: "ZRX",
              address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
              price: 0.284802,
            },
            {
              chainId: "1",
              name: "MetaFinance",
              symbol: "MFI",
              address: "0xEaDC218Ac4cB7895a5A56e6484646b48f841C45a",
              price: 0.283405,
            },
            {
              chainId: "1",
              name: "OVR",
              symbol: "OVR",
              address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
              price: 0.276292,
            },
            {
              chainId: "1",
              name: "UniLend",
              symbol: "UFT",
              address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
              price: 0.274623,
            },
            {
              chainId: "1",
              name: "IX Swap",
              symbol: "IXS",
              address: "0x73d7c860998ca3c01ce8c808f5577d94d545d1b4",
              price: 0.267945,
            },
            {
              chainId: "1",
              name: "Braintrust",
              symbol: "BTRST",
              address: "0x799ebfabe77a6e34311eeee9825190b9ece32824",
              price: 0.264272,
            },
            {
              chainId: "1",
              name: "Stratos ",
              symbol: "STOS",
              address: "0x08c32b0726C5684024ea6e141C50aDe9690bBdcc",
              price: 0.261778,
            },
            {
              chainId: "1",
              name: "Elan",
              symbol: "ELAN",
              address: "0x1b5036bec1b82d44d52fa953a370b3c6cd9328b5",
              price: 0.252788,
            },
            {
              chainId: "1",
              name: "Across Protocol",
              symbol: "ACX",
              address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
              price: 0.24398,
            },
            {
              chainId: "1",
              name: "Biconomy",
              symbol: "BICO",
              address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
              price: 0.242785,
            },
            {
              chainId: "1",
              name: "Polkastarter",
              symbol: "POLS",
              address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
              price: 0.241746,
            },
            {
              chainId: "1",
              name: "Phala",
              symbol: "PHA",
              address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
              price: 0.241271,
            },
            {
              chainId: "1",
              name: "1inch",
              symbol: "1INCH",
              address: "0x111111111117dc0aa78b770fa6a738034120c302",
              price: 0.232881,
            },
            {
              chainId: "1",
              name: "Tokemak",
              symbol: "TOKE",
              address: "0x2e9d63788249371f1DFC918a52f8d799F4a38C94",
              price: 0.232818,
            },
            {
              chainId: "56",
              name: "Dogecoin",
              symbol: "DOGE",
              address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
              price: 0.227176,
            },
            {
              chainId: "1",
              name: "Parsiq",
              symbol: "PRQ",
              address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
              price: 0.221725,
            },
            {
              chainId: "1",
              name: "Conic Finance",
              symbol: "CNC",
              address: "0x9ae380f0272e2162340a5bb646c354271c0f5cfc",
              price: 0.218317,
            },
            {
              chainId: "1",
              name: "Alkimi",
              symbol: "$ADS",
              address: "0x3106a0a076bedae847652f42ef07fd58589e001f",
              price: 0.215736,
            },
            {
              chainId: "1",
              name: "Vesper",
              symbol: "VSP",
              address: "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
              price: 0.212157,
            },
            {
              chainId: "1",
              name: "Wilder World",
              symbol: "WILD",
              address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
              price: 0.210464,
            },
            {
              chainId: "1",
              name: "SPACE ID",
              symbol: "ID",
              address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
              price: 0.207693,
            },
            {
              chainId: "1",
              name: "Stargate Finance",
              symbol: "STG",
              address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
              price: 0.206621,
            },
            {
              chainId: "1",
              name: "OMG Network",
              symbol: "OMG",
              address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
              price: 0.204659,
            },
            {
              chainId: "1",
              name: "Lien",
              symbol: "LIEN",
              address: "0xab37e1358b639fd877f015027bb62d3ddaa7557e",
              price: 0.203345,
            },
            {
              chainId: "1",
              name: "MATH",
              symbol: "MATH",
              address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
              price: 0.200963,
            },
            {
              chainId: "1",
              name: "Boson Protocol",
              symbol: "BOSON",
              address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
              price: 0.199344,
            },
            {
              chainId: "1",
              name: "Polygon",
              symbol: "MATIC",
              address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
              price: 0.192869,
            },
            {
              chainId: "1",
              name: "Orbler",
              symbol: "ORBR",
              address: "0xda30f261a962d5aae94c9ecd170544600d193766",
              price: 0.192141,
            },
            {
              chainId: "1",
              name: "LimeWire",
              symbol: "LMWR",
              address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
              price: 0.188497,
            },
            {
              chainId: "1",
              name: "AurusX",
              symbol: "AX",
              address: "0xCB0D82f4DFA503C9e3b8Abc7A3Caa01175b2dA39",
              price: 0.182755,
            },
            {
              chainId: "1",
              name: "SocialGood",
              symbol: "SG",
              address: "0xddf7fd345d54ff4b40079579d4c4670415dbfd0a",
              price: 0.182196,
            },
            {
              chainId: "1",
              name: "Octopus Network",
              symbol: "OCT",
              address: "0xf5cfbc74057c610c8ef151a439252680ac68c6dc",
              price: 0.181571,
            },
            {
              chainId: "1",
              name: "Aurora",
              symbol: "AURORA",
              address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
              price: 0.180916,
            },
            {
              chainId: "1",
              name: "Thales",
              symbol: "THALES",
              address: "0x8947da500eb47f82df21143d0c01a29862a8c3c5",
              price: 0.180527,
            },
            {
              chainId: "1",
              name: "WOO Network",
              symbol: "WOO",
              address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
              price: 0.173227,
            },
            {
              chainId: "1",
              name: "Dusk Network",
              symbol: "DUSK",
              address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
              price: 0.172283,
            },
            {
              chainId: "1",
              name: "Blocksquare",
              symbol: "BST",
              address: "0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a",
              price: 0.168565,
            },
            {
              chainId: "1",
              name: "Offshift",
              symbol: "XFT",
              address: "0xabe580e7ee158da464b51ee1a83ac0289622e6be",
              price: 0.168122,
            },
            {
              chainId: "1",
              name: "League of Kingdoms",
              symbol: "LOKA",
              address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
              price: 0.167624,
            },
            {
              chainId: "1",
              name: "FLEX",
              symbol: "FLEX",
              address: "0xfcf8eda095e37a41e002e266daad7efc1579bc0a",
              price: 0.167147,
            },
            {
              chainId: "1",
              name: "Loopring",
              symbol: "LRC",
              address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
              price: 0.166953,
            },
            {
              chainId: "1",
              name: "Hypercycle",
              symbol: "HYPC",
              address: "0xeA7B7DC089c9a4A916B5a7a37617f59fD54e37E4",
              price: 0.164976,
            },
            {
              chainId: "1",
              name: "Swarm Markets",
              symbol: "SMT",
              address: "0xb17548c7b510427baac4e267bea62e800b247173",
              price: 0.163673,
            },
            {
              chainId: "1",
              name: "Enjin Coin",
              symbol: "ENJ",
              address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
              price: 0.163571,
            },
            {
              chainId: "1",
              name: "Gelato",
              symbol: "GEL",
              address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
              price: 0.162866,
            },
            {
              chainId: "1",
              name: "Domani Protocol",
              symbol: "DEXTF",
              address: "0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0",
              price: 0.162639,
            },
            {
              chainId: "1",
              name: "Wrapped Telos",
              symbol: "WTLOS",
              address: "0x7825e833d495f3d1c28872415a4aee339d26ac88",
              price: 0.161006,
            },
            {
              chainId: "1",
              name: "XCAD Network",
              symbol: "XCAD",
              address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
              price: 0.158104,
            },
            {
              chainId: "1",
              name: "Gods Unchained",
              symbol: "GODS",
              address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
              price: 0.155797,
            },
            {
              chainId: "1",
              name: "Basic Attention Token",
              symbol: "BAT",
              address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
              price: 0.155777,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLUX",
              address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
              price: 0.151895,
            },
            {
              chainId: "1",
              name: "Crust",
              symbol: "CRU",
              address: "0x32a7c02e79c4ea1008dd6564b35f131428673c41",
              price: 0.151675,
            },
            {
              chainId: "1",
              name: "Nuco.cloud",
              symbol: "NCDT",
              address: "0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b",
              price: 0.14153,
            },
            {
              chainId: "1",
              name: "Lattice Token",
              symbol: "LTX",
              address: "0xa393473d64d2f9f026b60b6df7859a689715d092",
              price: 0.141237,
            },
            {
              chainId: "1",
              name: "Celsius",
              symbol: "CEL",
              address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
              price: 0.14096,
            },
            {
              chainId: "1",
              name: "Truebit Protocol",
              symbol: "TRU",
              address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
              price: 0.137801,
            },
            {
              chainId: "1",
              name: "DAO Maker",
              symbol: "DAO",
              address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
              price: 0.135215,
            },
            {
              chainId: "1",
              name: "Bobcoin",
              symbol: "BOBC",
              address: "0xe803178b48a0e560c2b19f3b3d4e504f79d229ce",
              price: 0.130772,
            },
            {
              chainId: "1",
              name: "Cronos",
              symbol: "CRO",
              address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
              price: 0.130769,
            },
            {
              chainId: "1",
              name: "Galileo Protocol",
              symbol: "LEOX",
              address: "0xa444ec96ee01bb219a44b285de47bf33c3447ad5",
              price: 0.129695,
            },
            {
              chainId: "1",
              name: "Coin98",
              symbol: "C98",
              address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
              price: 0.127611,
            },
            {
              chainId: "1",
              name: "Mines of Dalarnia",
              symbol: "DAR",
              address: "0x081131434f93063751813c619ecca9c4dc7862a3",
              price: 0.126616,
            },
            {
              chainId: "1",
              name: "Keep network",
              symbol: "KEEP",
              address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
              price: 0.126376,
            },
            {
              chainId: "1",
              name: "PowerPool",
              symbol: "CVP",
              address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
              price: 0.123939,
            },
            {
              chainId: "1",
              name: "TrustSwap",
              symbol: "SWAP",
              address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
              price: 0.122692,
            },
            {
              chainId: "1",
              name: "sudoswap",
              symbol: "SUDO",
              address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
              price: 0.119429,
            },
            {
              chainId: "1",
              name: "Aleph.im",
              symbol: "ALEPH",
              address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
              price: 0.116863,
            },
            {
              chainId: "1",
              name: "DODO",
              symbol: "DODO",
              address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
              price: 0.116718,
            },
            {
              chainId: "1",
              name: "The Graph",
              symbol: "GRT",
              address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
              price: 0.115199,
            },
            {
              chainId: "1",
              name: "Polychain Monsters",
              symbol: "PMON",
              address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
              price: 0.114137,
            },
            {
              chainId: "1",
              name: "Aergo",
              symbol: "AERGO",
              address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
              price: 0.112744,
            },
            {
              chainId: "1",
              name: "Xido Finance",
              symbol: "XIDO",
              address: "0xf6650117017ffd48b725b4ec5a00b414097108a7",
              price: 0.110139,
            },
            {
              chainId: "1",
              name: "Zignaly",
              symbol: "ZIG",
              address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
              price: 0.109712,
            },
            {
              chainId: "1",
              name: "Orchid",
              symbol: "OXT",
              address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
              price: 0.109529,
            },
            {
              chainId: "1",
              name: "Efinity Token",
              symbol: "EFI",
              address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
              price: 0.107764,
            },
            {
              chainId: "1",
              name: "Witch Token",
              symbol: "WITCH",
              address: "0xdc524e3c6910257744c1f93cf15e9f472b5bd236",
              price: 0.104827,
            },
            {
              chainId: "1",
              name: "Perion",
              symbol: "PERC",
              address: "0x60be1e1fe41c1370adaf5d8e66f07cf1c2df2268",
              price: 0.103679,
            },
            {
              chainId: "56",
              name: "Tenset",
              symbol: "10SET",
              address: "0x1AE369A6AB222aFF166325B7b87Eb9aF06C86E57",
              price: 0.10034,
            },
            {
              chainId: "1",
              name: "EdenLoop",
              symbol: "ELT",
              address: "0xfC1Cb4920dC1110fD61AfaB75Cf085C1f871b8C6",
              price: 0.100016,
            },
            {
              chainId: "1",
              name: "Forta",
              symbol: "FORT",
              address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
              price: 0.098713,
            },
            {
              chainId: "1",
              name: "Boba Network",
              symbol: "BOBA",
              address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
              price: 0.098352,
            },
            {
              chainId: "1",
              name: "Origin Protocol",
              symbol: "OGN",
              address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
              price: 0.09815,
            },
            {
              chainId: "1",
              name: "Blur",
              symbol: "BLUR",
              address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
              price: 0.097406,
            },
            {
              chainId: "1",
              name: "B20",
              symbol: "B20",
              address: "0xc4de189abf94c57f396bd4c52ab13b954febefd8",
              price: 0.095322,
            },
            {
              chainId: "1",
              name: "RSS3",
              symbol: "RSS3",
              address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
              price: 0.093066,
            },
            {
              chainId: "1",
              name: "Dimitra",
              symbol: "DMTR",
              address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
              price: 0.09274,
            },
            {
              chainId: "1",
              name: "Singularity DAO",
              symbol: "SDAO",
              address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
              price: 0.092064,
            },
            {
              chainId: "1",
              name: "COTI",
              symbol: "COTI",
              address: "0xddb3422497e61e13543bea06989c0789117555c5",
              price: 0.090589,
            },
            {
              chainId: "1",
              name: "Atlas Navi",
              symbol: "NAVI",
              address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
              price: 0.090082,
            },
            {
              chainId: "1",
              name: "SMART VALOR",
              symbol: "VALOR",
              address: "0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a",
              price: 0.088166,
            },
            {
              chainId: "1",
              name: "DeRace",
              symbol: "DERC",
              address: "0x9fa69536d1cda4a04cfb50688294de75b505a9ae",
              price: 0.084339,
            },
            {
              chainId: "1",
              name: "Hashflow",
              symbol: "HFT",
              address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
              price: 0.081956,
            },
            {
              chainId: "1",
              name: "XELS",
              symbol: "XELS",
              address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
              price: 0.080759,
            },
            {
              chainId: "1",
              name: "Newscrypto Coin",
              symbol: "NWC",
              address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
              price: 0.080218,
            },
            {
              chainId: "1",
              name: "dForce",
              symbol: "DF",
              address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
              price: 0.078772,
            },
            {
              chainId: "1",
              name: "NKN",
              symbol: "NKN",
              address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
              price: 0.07723,
            },
            {
              chainId: "1",
              name: "Push Protocol",
              symbol: "PUSH",
              address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
              price: 0.075692,
            },
            {
              chainId: "1",
              name: "Unizen",
              symbol: "ZCX",
              address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
              price: 0.074441,
            },
            {
              chainId: "1",
              name: "Chiliz",
              symbol: "CHZ",
              address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
              price: 0.074033,
            },
            {
              chainId: "1",
              name: "Oxygen",
              symbol: "OXY",
              address: "0x965697b4ef02f0de01384d0d4f9f782b1670c163",
              price: 0.073282,
            },
            {
              chainId: "1",
              name: "OccamFi",
              symbol: "OCC",
              address: "0x2f109021afe75b949429fe30523ee7c0d5b27207",
              price: 0.072545,
            },
            {
              chainId: "1",
              name: "Assemble Protocol",
              symbol: "ASM",
              address: "0x2565ae0385659badcada1031db704442e1b69982",
              price: 0.071723,
            },
            {
              chainId: "1",
              name: "SuperRare",
              symbol: "RARE",
              address: "0xba5bde662c17e2adff1075610382b9b691296350",
              price: 0.070354,
            },
            {
              chainId: "1",
              name: "RAMP",
              symbol: "RAMP",
              address: "0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
              price: 0.069918,
            },
            {
              chainId: "1",
              name: "TrueFi",
              symbol: "TRU",
              address: "0x4c19596f5aaff459fa38b0f7ed92f11ae6543784",
              price: 0.068365,
            },
            {
              chainId: "1",
              name: "Fable Of The Dragon",
              symbol: "TYRANT",
              address: "0x8ee325ae3e54e83956ef2d5952d3c8bc1fa6ec27",
              price: 0.066978,
            },
            {
              chainId: "1",
              name: "Coldstack",
              symbol: "CLS",
              address: "0x675bbc7514013e2073db7a919f6e4cbef576de37",
              price: 0.066447,
            },
            {
              chainId: "1",
              name: "Your Future Exchange",
              symbol: "YFX",
              address: "0xf55a93b613d172b86c2ba3981a849dae2aecde2f",
              price: 0.063911,
            },
            {
              chainId: "1",
              name: "Alpha Venture DAO",
              symbol: "ALPHA",
              address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
              price: 0.063808,
            },
            {
              chainId: "1",
              name: "Unmarshal",
              symbol: "MARSH",
              address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
              price: 0.063323,
            },
            {
              chainId: "1",
              name: "SUKU",
              symbol: "SUKU",
              address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
              price: 0.061202,
            },
            {
              chainId: "1",
              name: "HOPR Token",
              symbol: "HOPR",
              address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
              price: 0.060076,
            },
            {
              chainId: "1",
              name: "Opulous ",
              symbol: "OPUL",
              address: "0x80D55c03180349Fff4a229102F62328220A96444",
              price: 0.059933,
            },
            {
              chainId: "1",
              name: "Props",
              symbol: "PROPS",
              address: "0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41",
              price: 0.05987,
            },
            {
              chainId: "1",
              name: "Spool DAO",
              symbol: "SPOOL",
              address: "0x40803cea2b2a32bda1be61d3604af6a814e70976",
              price: 0.058031,
            },
            {
              chainId: "1",
              name: "K21",
              symbol: "K21",
              address: "0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af",
              price: 0.057013,
            },
            {
              chainId: "1",
              name: "Jubi Token",
              symbol: "JT",
              address: "0xEb7355C2f217b3485a591332Fe13C8c5A76A581D",
              price: 0.056977,
            },
            {
              chainId: "1",
              name: "Opium Network",
              symbol: "OPIUM",
              address: "0x888888888889c00c67689029d7856aac1065ec11",
              price: 0.05697,
            },
            {
              chainId: "1",
              name: "One Cash",
              symbol: "ONC",
              address: "0xD90E69f67203EBE02c917B5128629E77B4cd92dc",
              price: 0.056641,
            },
            {
              chainId: "1",
              name: "Loom Network",
              symbol: "LOOM",
              address: "0x42476f744292107e34519f9c357927074ea3f75d",
              price: 0.056162,
            },
            {
              chainId: "1",
              name: "Utrust",
              symbol: "UTK",
              address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
              price: 0.053109,
            },
            {
              chainId: "1",
              name: "UkraineDAO Flag NFT",
              symbol: "LOVE",
              address: "0x5380442d3c4ec4f5777f551f5edd2fa0f691a27c",
              price: 0.052924,
            },
            {
              chainId: "1",
              name: "Yam",
              symbol: "YAM",
              address: "0x0aacfbec6a24756c20d41914f2caba817c0d8521",
              price: 0.052444,
            },
            {
              chainId: "1",
              name: "Aladdin DAO",
              symbol: "ALD",
              address: "0xb26c4b3ca601136daf98593feaeff9e0ca702a8d",
              price: 0.051837,
            },
            {
              chainId: "1",
              name: "My Crypto Heroes",
              symbol: "MCHC",
              address: "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
              price: 0.051445,
            },
            {
              chainId: "1",
              name: "Flux",
              symbol: "FLX",
              address: "0x3Ea8ea4237344C9931214796d9417Af1A1180770",
              price: 0.051226,
            },
            {
              chainId: "1",
              name: "Optimus AI",
              symbol: "OPTIMUS",
              address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
              price: 0.04941991,
            },
            {
              chainId: "1",
              name: "IDEX",
              symbol: "IDEX",
              address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
              price: 0.04876791,
            },
            {
              chainId: "1",
              name: "Big Data Protocol",
              symbol: "BDP",
              address: "0xf3dcbc6D72a4E1892f7917b7C43b74131Df8480e",
              price: 0.04866796,
            },
            {
              chainId: "1",
              name: "Bluzelle",
              symbol: "BLZ",
              address: "0x5732046a883704404f284ce41ffadd5b007fd668",
              price: 0.04820927,
            },
            {
              chainId: "1",
              name: "BreederDAO",
              symbol: "BREED",
              address: "0x94E9EB8b5Ab9fd6B9ea3169D55FFAde62a01702e",
              price: 0.0468615,
            },
            {
              chainId: "1",
              name: "Graphlinq Protocol",
              symbol: "GLQ",
              address: "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24",
              price: 0.0451987,
            },
            {
              chainId: "1",
              name: "CLV",
              symbol: "CLV",
              address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
              price: 0.04513007,
            },
            {
              chainId: "1",
              name: "Fear",
              symbol: "FEAR",
              address: "0x88a9a52f944315d5b4e917b9689e65445c401e83",
              price: 0.04334569,
            },
            {
              chainId: "1",
              name: "HarryPotterObamaSonic10Inu",
              symbol: "BITCOIN",
              address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
              price: 0.04305609,
            },
            {
              chainId: "1",
              name: "QANplatform",
              symbol: "QANX",
              address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
              price: 0.04278893,
            },
            {
              chainId: "1",
              name: "SpaceY2025",
              symbol: "SPAY",
              address: "0x58FaD9E3C3AE54c9BA98c3f0E4bF88aB3E8Cf3c5",
              price: 0.04274345,
            },
            {
              chainId: "1",
              name: "PERI Finance",
              symbol: "PERI",
              address: "0x5d30aD9C6374Bf925D0A75454fa327AACf778492",
              price: 0.04269197,
            },
            {
              chainId: "1",
              name: "Zogi",
              symbol: "ZOGI",
              address: "0x7e80e4d7d5725499791cf8b17a4586f1f0672a0c",
              price: 0.04259615,
            },
            {
              chainId: "1",
              name: "ARPA",
              symbol: "ARPA",
              address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
              price: 0.04191628,
            },
            {
              chainId: "1",
              name: "Numbers Protocol",
              symbol: "NUM",
              address: "0x3496b523e5c00a4b4150d6721320cddb234c3079",
              price: 0.04150833,
            },
            {
              chainId: "1",
              name: "Shapeshift FOX Token",
              symbol: "FOX",
              address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
              price: 0.04043806,
            },
            {
              chainId: "1",
              name: "DerivaDAO",
              symbol: "DDX",
              address: "0x3a880652f47bfaa771908c07dd8673a787daed3a",
              price: 0.03982125,
            },
            {
              chainId: "1",
              name: "1MillionNFT ",
              symbol: "1MIL",
              address: "0xa4eF4b0B23C1fc81d3f9ecF93510e64f58A4A016",
              price: 0.03918949,
            },
            {
              chainId: "1",
              name: "Bifrost",
              symbol: "BFC",
              address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
              price: 0.03909674,
            },
            {
              chainId: "1",
              name: "Xend Finance",
              symbol: "XEND",
              address: "0xe4cfe9eaa8cdb0942a80b7bc68fd8ab0f6d44903",
              price: 0.03908406,
            },
            {
              chainId: "1",
              name: "Polymath",
              symbol: "POLY",
              address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
              price: 0.03875179,
            },
            {
              chainId: "1",
              name: "Humans.ai",
              symbol: "HEART",
              address: "0x8FAc8031e079F409135766C7d5De29cf22EF897C",
              price: 0.03829733,
            },
            {
              chainId: "1",
              name: "DeFinity Network",
              symbol: "DEFX",
              address: "0x5F474906637bdCDA05f29C74653F6962bb0f8eDa",
              price: 0.03779638,
            },
            {
              chainId: "1",
              name: "Basis Share",
              symbol: "BAS",
              address: "0x106538CC16F938776c7c180186975BCA23875287",
              price: 0.03715319,
            },
            {
              chainId: "1",
              name: "Baanx",
              symbol: "BXX",
              address: "0x6b1a8f210ec6b7b6643cea3583fb0c079f367898",
              price: 0.03686092,
            },
            {
              chainId: "1",
              name: "P00LS",
              symbol: "00",
              address: "0x881Ba05de1E78f549cC63a8f6Cabb1d4AD32250D",
              price: 0.03639498,
            },
            {
              chainId: "1",
              name: "XY Finance",
              symbol: "XY",
              address: "0x77777777772cf0455fb38ee0e75f38034dfa50de",
              price: 0.03625009,
            },
            {
              chainId: "1",
              name: "GamyFi",
              symbol: "GFX",
              address: "0x65ad6a2288b2dd23e466226397c8f5d1794e58fc",
              price: 0.03589222,
            },
            {
              chainId: "1",
              name: "Beta Finance",
              symbol: "BETA",
              address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
              price: 0.03540768,
            },
            {
              chainId: "1",
              name: "Exorde",
              symbol: "EXD",
              address: "0x02de007d412266a2e0fa9287c103474170f06560",
              price: 0.03479104,
            },
            {
              chainId: "1",
              name: "PolySwarm",
              symbol: "NCT",
              address: "0x9e46a38f5daabe8683e10793b06749eef7d733d1",
              price: 0.03448223,
            },
            {
              chainId: "1",
              name: "PlayDapp",
              symbol: "PLA",
              address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
              price: 0.03360926,
            },
            {
              chainId: "1",
              name: "mStable Governance Token",
              symbol: "MTA",
              address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
              price: 0.03171461,
            },
            {
              chainId: "1",
              name: "Spider Tanks",
              symbol: "SILK",
              address: "0xb045f7f363fe4949954811b113bd56d208c67b23",
              price: 0.03164766,
            },
            {
              chainId: "1",
              name: "THE9",
              symbol: "THE9",
              address: "0xefd113cea2f656fe7899a25a06243a6e40406e08",
              price: 0.03130026,
            },
            {
              chainId: "1",
              name: "pSTAKE",
              symbol: "PSTAKE",
              address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
              price: 0.03120796,
            },
            {
              chainId: "1",
              name: "Mintlayer",
              symbol: "ML",
              address: "0x059956483753947536204e89bfaD909E1a434Cc6",
              price: 0.03113184,
            },
            {
              chainId: "1",
              name: "UniLayer",
              symbol: "LAYER",
              address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
              price: 0.03082503,
            },
            {
              chainId: "1",
              name: "Town Star",
              symbol: "TOWN",
              address: "0x3dd98c8a089dbcff7e8fc8d4f532bd493501ab7f",
              price: 0.03080765,
            },
            {
              chainId: "1",
              name: "UniTrade",
              symbol: "TRADE",
              address: "0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
              price: 0.03005136,
            },
            {
              chainId: "1",
              name: "Hello Pets",
              symbol: "PET",
              address: "0xB870679a7Fa65b924026F496De7f27c1DD0e5C5F",
              price: 0.02987464,
            },
            {
              chainId: "1",
              name: "Blockchain Cuties Universe",
              symbol: "BCUG",
              address: "0x14da7b27b2e0fedefe0a664118b0c9bc68e2e9af",
              price: 0.02978755,
            },
            {
              chainId: "1",
              name: "ConstitutionDAO",
              symbol: "PEOPLE",
              address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
              price: 0.02955053,
            },
            {
              chainId: "1",
              name: "CEEK VR",
              symbol: "CEEK",
              address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
              price: 0.02935514,
            },
            {
              chainId: "1",
              name: "Metacade",
              symbol: "MCADE",
              address: "0xed328e9c1179a30ddc1e7595e036aed8760c22af",
              price: 0.02907905,
            },
            {
              chainId: "1",
              name: "BiLira",
              symbol: "TRYB",
              address: "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
              price: 0.02837526,
            },
            {
              chainId: "1",
              name: "Archimedes",
              symbol: "ARCH",
              address: "0x73C69d24ad28e2d43D03CBf35F79fE26EBDE1011",
              price: 0.02833991,
            },
            {
              chainId: "1",
              name: "dKargo",
              symbol: "DKA",
              address: "0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0",
              price: 0.02821723,
            },
            {
              chainId: "1",
              name: "DFX Finance",
              symbol: "DFX",
              address: "0x888888435fde8e7d4c54cab67f206e4199454c60",
              price: 0.02790167,
            },
            {
              chainId: "1",
              name: "AllianceBlock Nexera",
              symbol: "NXRA",
              address: "0x644192291cc835A93d6330b24EA5f5FEdD0eEF9e",
              price: 0.02779917,
            },
            {
              chainId: "1",
              name: "Mirror Protocol",
              symbol: "MIR",
              address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
              price: 0.02731259,
            },
            {
              chainId: "1",
              name: "VAIOT",
              symbol: "VAI",
              address: "0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c",
              price: 0.02690659,
            },
            {
              chainId: "1",
              name: "Ren",
              symbol: "REN",
              address: "0x408e41876cccdc0f92210600ef50372656052a38",
              price: 0.02678641,
            },
            {
              chainId: "1",
              name: "Status",
              symbol: "SNT",
              address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
              price: 0.02673688,
            },
            {
              chainId: "1",
              name: "Jasmy",
              symbol: "JASMY",
              address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
              price: 0.02658235,
            },
            {
              chainId: "1",
              name: "Fuse Network",
              symbol: "FUSE",
              address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
              price: 0.02641525,
            },
            {
              chainId: "1",
              name: "Serum",
              symbol: "SRM",
              address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
              price: 0.02636675,
            },
            {
              chainId: "1",
              name: "TRVL",
              symbol: "TRVL",
              address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
              price: 0.02585551,
            },
            {
              chainId: "1",
              name: "Guild of Guardians",
              symbol: "GOG",
              address: "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62",
              price: 0.02583595,
            },
            {
              chainId: "1",
              name: "GamerCoin",
              symbol: "GHX",
              address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
              price: 0.02555778,
            },
            {
              chainId: "1",
              name: "Changer",
              symbol: "CNG",
              address: "0x5C1d9aA868a30795F92fAe903eDc9eFF269044bf",
              price: 0.02548596,
            },
            {
              chainId: "1",
              name: "Threshold",
              symbol: "T",
              address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
              price: 0.02536993,
            },
            {
              chainId: "1",
              name: "Altered State Token",
              symbol: "ASTO",
              address: "0x823556202e86763853b40e9cde725f412e294689",
              price: 0.02506057,
            },
            {
              chainId: "1",
              name: "Cornucopias",
              symbol: "COPI",
              address: "0x42baf1f659d765c65ade5bb7e08eb2c680360d9d",
              price: 0.02493616,
            },
            {
              chainId: "1",
              name: "Wrapped Nine Chronicles",
              symbol: "WNCG",
              address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
              price: 0.0247011,
            },
            {
              chainId: "1",
              name: "WOM Protocol",
              symbol: "WOM",
              address: "0xbd356a39bff2cada8e9248532dd879147221cf76",
              price: 0.02389788,
            },
            {
              chainId: "1",
              name: "YVS Finance",
              symbol: "YVS",
              address: "0xEC681F28f4561c2a9534799AA38E0d36A83Cf478",
              price: 0.02377705,
            },
            {
              chainId: "1",
              name: "XDAO",
              symbol: "XDAO",
              address: "0x71eeba415a523f5c952cc2f06361d5443545ad28",
              price: 0.02270426,
            },
            {
              chainId: "1",
              name: "Gala",
              symbol: "GALA",
              address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
              price: 0.02242067,
            },
            {
              chainId: "1",
              name: "Stobox",
              symbol: "STBU",
              address: "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
              price: 0.02233193,
            },
            {
              chainId: "1",
              name: "Skale",
              symbol: "SKL",
              address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
              price: 0.02227517,
            },
            {
              chainId: "1",
              name: "ParaSwap",
              symbol: "PSP",
              address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
              price: 0.02181516,
            },
            {
              chainId: "1",
              name: "Gold Fever",
              symbol: "NGL",
              address: "0x2653891204f463fb2a2f4f412564b19e955166ae",
              price: 0.0217287,
            },
            {
              chainId: "1",
              name: "LBank",
              symbol: "LBK",
              address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
              price: 0.02154124,
            },
            {
              chainId: "1",
              name: "Kleros",
              symbol: "PNK",
              address: "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
              price: 0.02138943,
            },
            {
              chainId: "1",
              name: "Marginswap",
              symbol: "MFI",
              address: "0xaa4e3edb11afa93c41db59842b29de64b72e355b",
              price: 0.02123367,
            },
            {
              chainId: "1",
              name: "Onyxcoin",
              symbol: "XCN",
              address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
              price: 0.0207876,
            },
            {
              chainId: "1",
              name: "Hegic",
              symbol: "HEGIC",
              address: "0x584bc13c7d411c00c01a62e8019472de68768430",
              price: 0.02075563,
            },
            {
              chainId: "137",
              name: "Chain Games",
              symbol: "CHAIN",
              address: "0xd55fCe7CDaB84d84f2EF3F99816D765a2a94a509",
              price: 0.02059801,
            },
            {
              chainId: "1",
              name: "BlueSparrow Token",
              symbol: "BLUESPARROW",
              address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
              price: 0.02039473,
            },
            {
              chainId: "1",
              name: "Moeda Loyalty Points",
              symbol: "MDA",
              address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
              price: 0.02036443,
            },
            {
              chainId: "1",
              name: "Alchemy Pay",
              symbol: "ACH",
              address: "0xed04915c23f00a313a544955524eb7dbd823143d",
              price: 0.02024458,
            },
            {
              chainId: "1",
              name: "Oobit",
              symbol: "OBT",
              address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
              price: 0.02010881,
            },
            {
              chainId: "1",
              name: "Chainsquare",
              symbol: "CHS",
              address: "0xb41380174d0b06181513a5677b60200b93b5efb4",
              price: 0.02001937,
            },
            {
              chainId: "1",
              name: "OneSwap DAO Token",
              symbol: "ONES",
              address: "0x0b342c51d1592c41068d5d4b4da4a68c0a04d5a4",
              price: 0.01990884,
            },
            {
              chainId: "1",
              name: "Ankr Network",
              symbol: "ANKR",
              address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
              price: 0.01986,
            },
            {
              chainId: "1",
              name: "DecentraWeb",
              symbol: "DWEB",
              address: "0xe7f58a92476056627f9fdb92286778abd83b285f",
              price: 0.01957874,
            },
            {
              chainId: "1",
              name: "Chain Games",
              symbol: "CHAIN",
              address: "0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
              price: 0.01936457,
            },
            {
              chainId: "1",
              name: "Juggernaut",
              symbol: "JGN",
              address: "0x73374ea518de7addd4c2b624c0e8b113955ee041",
              price: 0.01925424,
            },
            {
              chainId: "1",
              name: "Value Liquidity",
              symbol: "VALUE",
              address: "0x49e833337ece7afe375e44f4e3e8481029218e5c",
              price: 0.01919647,
            },
            {
              chainId: "1",
              name: "KeyFi",
              symbol: "KEYFI",
              address: "0xb8647e90c0645152fccf4d9abb6b59eb4aa99052",
              price: 0.01908941,
            },
            {
              chainId: "1",
              name: "Minima",
              symbol: "WMINIMA",
              address: "0x669c01caf0edcad7c2b8dc771474ad937a7ca4af",
              price: 0.01862028,
            },
            {
              chainId: "1",
              name: "NAGA",
              symbol: "NGC",
              address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
              price: 0.0183165,
            },
            {
              chainId: "1",
              name: "Shopping.io Token",
              symbol: "SHOP",
              address: "0x64b78325d7495d6d4be92f234fa3f3b8d8964b8b",
              price: 0.01807887,
            },
            {
              chainId: "1",
              name: "Nord Finance",
              symbol: "NORD",
              address: "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
              price: 0.0180385,
            },
            {
              chainId: "1",
              name: "Maxity",
              symbol: "MAX",
              address: "0x63f7B1b538a78cB699E5399621B3d2e047C40de4",
              price: 0.01785833,
            },
            {
              chainId: "1",
              name: "Media Industry Licensing Content",
              symbol: "MLT",
              address: "0x9506d37f70eB4C3d79C398d326C871aBBf10521d",
              price: 0.017328,
            },
            {
              chainId: "1",
              name: "Poolz",
              symbol: "POOLZ",
              address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
              price: 0.01719548,
            },
            {
              chainId: "1",
              name: "Bit2Me",
              symbol: "B2M",
              address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
              price: 0.01691978,
            },
            {
              chainId: "1",
              name: "NuNet",
              symbol: "NTX",
              address: "0xf0d33beda4d734c72684b5f9abbebf715d0a7935",
              price: 0.01690763,
            },
            {
              chainId: "1",
              name: "Zero Tech",
              symbol: "ZERO",
              address: "0x0ec78ed49c2d27b315d462d43b5bab94d2c79bf8",
              price: 0.01595254,
            },
            {
              chainId: "1",
              name: "Marlin",
              symbol: "POND",
              address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
              price: 0.01590254,
            },
            {
              chainId: "1",
              name: "Bumper",
              symbol: "BUMP",
              address: "0x785c34312dfa6b74f6f1829f79ade39042222168",
              price: 0.01582964,
            },
            {
              chainId: "1",
              name: "Wrapped USTC",
              symbol: "USTC",
              address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
              price: 0.01571425,
            },
            {
              chainId: "1",
              name: "Hillstone",
              symbol: "HSF",
              address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
              price: 0.01562664,
            },
            {
              chainId: "1",
              name: "Medal of Honour",
              symbol: "MOH",
              address: "0xa59e341e8047498700ed244814b01b34547fb21b",
              price: 0.01559381,
            },
            {
              chainId: "1",
              name: "SmarDex",
              symbol: "SDEX",
              address: "0x5DE8ab7E27f6E7A1fFf3E5B337584Aa43961BEeF",
              price: 0.01537551,
            },
            {
              chainId: "1",
              name: "PieDAO DOUGH v2",
              symbol: "DOUGH",
              address: "0xad32a8e6220741182940c5abf610bde99e737b2d",
              price: 0.01528418,
            },
            {
              chainId: "1",
              name: "NFT Worlds",
              symbol: "WRLD",
              address: "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9",
              price: 0.01521822,
            },
            {
              chainId: "1",
              name: "Kromatika",
              symbol: "KROM",
              address: "0x3af33bef05c2dcb3c7288b77fe1c8d2aeba4d789",
              price: 0.01517433,
            },
            {
              chainId: "1",
              name: "Dvision Network",
              symbol: "DVI",
              address: "0x10633216e7e8281e33c86f02bf8e565a635d9770",
              price: 0.0148875,
            },
            {
              chainId: "1",
              name: "e-Radix",
              symbol: "EXRD",
              address: "0x6468e79a80c0eab0f9a2b574c8d5bc374af59414",
              price: 0.01474534,
            },
            {
              chainId: "1",
              name: "Celer Network",
              symbol: "CELR",
              address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
              price: 0.01456546,
            },
            {
              chainId: "1",
              name: "Bistroo",
              symbol: "BIST",
              address: "0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f",
              price: 0.01430946,
            },
            {
              chainId: "1",
              name: "Rubic",
              symbol: "RBC",
              address: "0x3330bfb7332ca23cd071631837dc289b09c33333",
              price: 0.01430848,
            },
            {
              chainId: "1",
              name: "THORWallet",
              symbol: "TGT",
              address: "0x108a850856db3f85d0269a2693d896b394c80325",
              price: 0.01414117,
            },
            {
              chainId: "1",
              name: "Choise.com",
              symbol: "CHO",
              address: "0xBBa39Fd2935d5769116ce38d46a71bde9cf03099",
              price: 0.01408598,
            },
            {
              chainId: "1",
              name: "Sienna Network",
              symbol: "SIENNA",
              address: "0x9b00e6E8D787b13756eb919786c9745054DB64f9",
              price: 0.0140206,
            },
            {
              chainId: "1",
              name: "LooksRare",
              symbol: "LOOKS",
              address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
              price: 0.01398385,
            },
            {
              chainId: "1",
              name: "EDEN",
              symbol: "EDEN",
              address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
              price: 0.01375941,
            },
            {
              chainId: "1",
              name: "Liquid Staking Derivative",
              symbol: "LSD",
              address: "0x97d4f49eeb0e2c96d5ebaa71ab8418e563ecd9fd",
              price: 0.01373326,
            },
            {
              chainId: "1",
              name: "STFX",
              symbol: "STFX",
              address: "0x9343e24716659A3551eB10Aff9472A2dcAD5Db2d",
              price: 0.0132033,
            },
            {
              chainId: "1",
              name: "Image Generation AI",
              symbol: "IMGNAI",
              address: "0xA735A3AF76CC30791C61c10d585833829d36CBe0",
              price: 0.01317426,
            },
            {
              chainId: "1",
              name: "Sperax",
              symbol: "SPA",
              address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
              price: 0.01312954,
            },
            {
              chainId: "1",
              name: "Bubblefong",
              symbol: "BBF",
              address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
              price: 0.01299892,
            },
            {
              chainId: "1",
              name: "Kapital DAO",
              symbol: "KAP",
              address: "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
              price: 0.01284343,
            },
            {
              chainId: "1",
              name: "Unibright",
              symbol: "UBT",
              address: "0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e",
              price: 0.01273273,
            },
            {
              chainId: "1",
              name: "Qredo",
              symbol: "QRDO",
              address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
              price: 0.01253742,
            },
            {
              chainId: "1",
              name: "Nexum",
              symbol: "NEXM",
              address: "0xe831f96a7a1dce1aa2eb760b1e296c6a74caa9d5",
              price: 0.01253069,
            },
            {
              chainId: "1",
              name: "Etherisc DIP Token",
              symbol: "DIP",
              address: "0xc719d010b63e5bbf2c0551872cd5316ed26acd83",
              price: 0.0124068,
            },
            {
              chainId: "1",
              name: "Locus Chain",
              symbol: "LOCUS",
              address: "0xc64500dd7b0f1794807e67802f8abbf5f8ffb054",
              price: 0.01212623,
            },
            {
              chainId: "1",
              name: "Hot Cross",
              symbol: "HOTCROSS",
              address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
              price: 0.01210312,
            },
            {
              chainId: "1",
              name: "Avocado DAO",
              symbol: "AVG",
              address: "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
              price: 0.01205359,
            },
            {
              chainId: "1",
              name: "Covenant",
              symbol: "COVN",
              address: "0x19ac2659599fd01c853de846919544276ad26f50",
              price: 0.01204608,
            },
            {
              chainId: "1",
              name: "UnoRe",
              symbol: "UNO",
              address: "0x474021845c4643113458ea4414bdb7fb74a01a77",
              price: 0.01192575,
            },
            {
              chainId: "1",
              name: "Sidus Heroes DAO",
              symbol: "SENATE",
              address: "0x34Be5b8C30eE4fDe069DC878989686aBE9884470",
              price: 0.01180915,
            },
            {
              chainId: "1",
              name: "HYVE.works",
              symbol: "HYVE",
              address: "0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4",
              price: 0.01167148,
            },
            {
              chainId: "1",
              name: "Delio DSP",
              symbol: "DSP",
              address: "0x8c661806f716652b637728355cc4e2620d428f99",
              price: 0.01162891,
            },
            {
              chainId: "1",
              name: "Alethea Artificial Liquid Intelligence",
              symbol: "ALI",
              address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
              price: 0.01152939,
            },
            {
              chainId: "1",
              name: "InsurAce",
              symbol: "INSUR",
              address: "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
              price: 0.01148638,
            },
            {
              chainId: "1",
              name: "PolkaBridge",
              symbol: "PBR",
              address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
              price: 0.01133285,
            },
            {
              chainId: "1",
              name: "Wrapped Accumulate",
              symbol: "WACME",
              address: "0xDF4Ef6EE483953fE3B84ABd08C6A060445c01170",
              price: 0.01129819,
            },
            {
              chainId: "1",
              name: "Evrynet",
              symbol: "EVRY",
              address: "0xd7dcd9b99787c619b4d57979521258d1a7267ad7",
              price: 0.01114784,
            },
            {
              chainId: "1",
              name: "Voyager Token",
              symbol: "VGX",
              address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
              price: 0.01113651,
            },
            {
              chainId: "1",
              name: "Victoria VR",
              symbol: "VR",
              address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
              price: 0.01112198,
            },
            {
              chainId: "1",
              name: "Origin Dollar Governance",
              symbol: "OGV",
              address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
              price: 0.01110801,
            },
            {
              chainId: "1",
              name: "Decentral Games",
              symbol: "DG",
              address: "0x4b520c812e8430659fc9f12f6d0c39026c83588d",
              price: 0.0109225,
            },
            {
              chainId: "1",
              name: "Hop Protocol",
              symbol: "HOP",
              address: "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
              price: 0.01089238,
            },
            {
              chainId: "1",
              name: "RAI Finance",
              symbol: "SOFI",
              address: "0xb49fa25978abf9a248b8212ab4b87277682301c0",
              price: 0.01080736,
            },
            {
              chainId: "1",
              name: "XYO",
              symbol: "XYO",
              address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
              price: 0.01080589,
            },
            {
              chainId: "1",
              name: "SportsIcon",
              symbol: "ICONS",
              address: "0x3F68e7B44e9bCB486C2FeAdB7A2289D9cdFC9088",
              price: 0.01073482,
            },
            {
              chainId: "1",
              name: "Daisy Protocol",
              symbol: "DAISY",
              address: "0x40955d77f87123b71b145098358a60573ac7be96",
              price: 0.01069602,
            },
            {
              chainId: "1",
              name: "Panther Protocol",
              symbol: "ZKP",
              address: "0x909E34d3f6124C324ac83DccA84b74398a6fa173",
              price: 0.01066803,
            },
            {
              chainId: "1",
              name: "ZeroSwap Token",
              symbol: "ZEE",
              address: "0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
              price: 0.01048836,
            },
            {
              chainId: "1",
              name: "Credefi ",
              symbol: "CREDI",
              address: "0xaE6e307c3Fe9E922E5674DBD7F830Ed49c014c6B",
              price: 0.01039157,
            },
            {
              chainId: "1",
              name: "PathDAO",
              symbol: "PATH",
              address: "0x2a2550e0a75acec6d811ae3930732f7f3ad67588",
              price: 0.01033196,
            },
            {
              chainId: "1",
              name: "Divergence",
              symbol: "DIVER",
              address: "0xfb782396c9b20e564a64896181c7ac8d8979d5f4",
              price: 0.01026706,
            },
            {
              chainId: "1",
              name: "Alien Worlds",
              symbol: "TLM",
              address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
              price: 0.01010439,
            },
            {
              chainId: "1",
              name: "QuarkChain",
              symbol: "QKC",
              address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
              price: 0.00992877,
            },
            {
              chainId: "1",
              name: "Lunr",
              symbol: "LUNR",
              address: "0xA87135285Ae208e22068AcDBFf64B11Ec73EAa5A",
              price: 0.00990949,
            },
            {
              chainId: "1",
              name: "TOMI",
              symbol: "TOMI",
              address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
              price: 0.00984896,
            },
            {
              chainId: "1",
              name: "OnX Finance",
              symbol: "ONX",
              address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
              price: 0.00951438,
            },
            {
              chainId: "1",
              name: "Gourmet Galaxy",
              symbol: "GUM",
              address: "0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24",
              price: 0.00917141,
            },
            {
              chainId: "1",
              name: "ACoconut",
              symbol: "AC",
              address: "0x9A0aBA393aac4dFbFf4333B06c407458002C6183",
              price: 0.00916872,
            },
            {
              chainId: "1",
              name: "Kylin Network",
              symbol: "KYL",
              address: "0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c",
              price: 0.00901207,
            },
            {
              chainId: "1",
              name: "Popcorn",
              symbol: "POP",
              address: "0xd0cd466b34a24fcb2f87676278af2005ca8a78c4",
              price: 0.00893715,
            },
            {
              chainId: "1",
              name: "BlockWallet",
              symbol: "BLANK",
              address: "0x41a3dba3d677e573636ba691a70ff2d606c29666",
              price: 0.00889921,
            },
            {
              chainId: "1",
              name: "New Paradigm Assets Solution",
              symbol: "NPAS",
              address: "0xEBe807bFDf8b2092E36e964C75463A8Aaa642139",
              price: 0.00873042,
            },
            {
              chainId: "1",
              name: "GroveCoin",
              symbol: "GRV",
              address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
              price: 0.00872181,
            },
            {
              chainId: "1",
              name: "Umbrella Network",
              symbol: "UMB",
              address: "0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2",
              price: 0.00848014,
            },
            {
              chainId: "1",
              name: "O3 Swap",
              symbol: "O3",
              address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
              price: 0.00803362,
            },
            {
              chainId: "1",
              name: "RabbitX",
              symbol: "RBX",
              address: "0x3Ba925fdeAe6B46d0BB4d424D829982Cb2F7309e",
              price: 0.00776972,
            },
            {
              chainId: "1",
              name: "AI Network",
              symbol: "AIN",
              address: "0x3a810ff7211b40c4fa76205a14efe161615d0385",
              price: 0.00774991,
            },
            {
              chainId: "1",
              name: "izumi Finance",
              symbol: "IZI",
              address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
              price: 0.00756683,
            },
            {
              chainId: "1",
              name: "Antimatter",
              symbol: "MATTER",
              address: "0x9B99CcA871Be05119B2012fd4474731dd653FEBe",
              price: 0.00753904,
            },
            {
              chainId: "1",
              name: "Amp",
              symbol: "AMP",
              address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
              price: 0.00748403,
            },
            {
              chainId: "1",
              name: "ELYSIA",
              symbol: "EL",
              address: "0x2781246fe707bb15cee3e5ea354e2154a2877b16",
              price: 0.00717642,
            },
            {
              chainId: "1",
              name: "GAMEE",
              symbol: "GMEE",
              address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
              price: 0.00696,
            },
            {
              chainId: "1",
              name: "IQ",
              symbol: "IQ",
              address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
              price: 0.00691163,
            },
            {
              chainId: "1",
              name: "EHash",
              symbol: "EHASH",
              address: "0x2942e3b38e33123965bfbc21e802be943a76bbc6",
              price: 0.00665937,
            },
            {
              chainId: "1",
              name: "LOTT",
              symbol: "LOTT",
              address: "0xba93ef534094f8b7001ece2691168140965341ab",
              price: 0.00657432,
            },
            {
              chainId: "1",
              name: "DuckDaoDime",
              symbol: "DDIM",
              address: "0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20",
              price: 0.00649844,
            },
            {
              chainId: "1",
              name: "Turbo",
              symbol: "TURBO",
              address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
              price: 0.00638475,
            },
            {
              chainId: "1",
              name: "Primate",
              symbol: "PRIMATE",
              address: "0x46e98FFE40E408bA6412bEb670507e083C8B95ff",
              price: 0.00638271,
            },
            {
              chainId: "1",
              name: "Reserve Rights",
              symbol: "RSR",
              address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
              price: 0.00636183,
            },
            {
              chainId: "1",
              name: "Acria.AI",
              symbol: "ACRIA",
              address: "0x44f5909e97e1cbf5fbbdf0fc92fd83cde5d5c58a",
              price: 0.00633067,
            },
            {
              chainId: "1",
              name: "BBS Network",
              symbol: "BBS",
              address: "0xfe459828c90c0ba4bc8b42f5c5d44f316700b430",
              price: 0.00629815,
            },
            {
              chainId: "1",
              name: "Swerve",
              symbol: "SWRV",
              address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
              price: 0.00628602,
            },
            {
              chainId: "1",
              name: "Gearbox Protocol",
              symbol: "GEAR",
              address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
              price: 0.00627808,
            },
            {
              chainId: "1",
              name: "FANC",
              symbol: "FANC",
              address: "0xbB126042235E6bD38B17744cb31a8bF4A206c045",
              price: 0.00622569,
            },
            {
              chainId: "1",
              name: "Integral",
              symbol: "ITGR",
              address: "0xd502f487e1841fdc805130e13eae80c61186bc98",
              price: 0.00617147,
            },
            {
              chainId: "1",
              name: "Dejitaru Tsuka",
              symbol: "TSUKA",
              address: "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed",
              price: 0.00611169,
            },
            {
              chainId: "1",
              name: "Polkacity",
              symbol: "POLC",
              address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
              price: 0.00600761,
            },
            {
              chainId: "1",
              name: "Bit.Store",
              symbol: "STORE",
              address: "0x31ea0de8119307aa264bb4b38727aab4e36b074f",
              price: 0.00598265,
            },
            {
              chainId: "1",
              name: "Golff",
              symbol: "GOF",
              address: "0x488E0369f9BC5C40C002eA7c1fe4fd01A198801c",
              price: 0.00590861,
            },
            {
              chainId: "1",
              name: "Cirus",
              symbol: "CIRUS",
              address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
              price: 0.00585288,
            },
            {
              chainId: "1",
              name: "EnterDAO",
              symbol: "ENTR",
              address: "0xd779eea9936b4e323cddff2529eb6f13d0a4d66e",
              price: 0.00578618,
            },
            {
              chainId: "1",
              name: "Fractal",
              symbol: "FCL",
              address: "0xf4d861575ecc9493420a3f5a14f85b13f0b50eb3",
              price: 0.00577273,
            },
            {
              chainId: "1",
              name: "FUNToken",
              symbol: "FUN",
              address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
              price: 0.00572421,
            },
            {
              chainId: "1",
              name: "Orbit Chain",
              symbol: "ORC",
              address: "0x662b67d00a13faf93254714dd601f5ed49ef2f51",
              price: 0.00547857,
            },
            {
              chainId: "1",
              name: "Vodra",
              symbol: "VDR",
              address: "0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe",
              price: 0.00541767,
            },
            {
              chainId: "1",
              name: "Arc",
              symbol: "ARC",
              address: "0xc82e3db60a52cf7529253b4ec688f631aad9e7c2",
              price: 0.00536411,
            },
            {
              chainId: "1",
              name: "PlotX",
              symbol: "PLOT",
              address: "0x72f020f8f3e8fd9382705723cd26380f8d0c66bb",
              price: 0.00529281,
            },
            {
              chainId: "1",
              name: "DoDreamChain",
              symbol: "DRM",
              address: "0x89551b940e2a8ed8eccf509935bac9213fe30584",
              price: 0.0052723,
            },
            {
              chainId: "1",
              name: "Rocki",
              symbol: "ROCKI",
              address: "0xff44b937788215eca197baaf9af69dbdc214aa04",
              price: 0.00521579,
            },
            {
              chainId: "1",
              name: "Deri Protocol",
              symbol: "DERI",
              address: "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
              price: 0.00517315,
            },
            {
              chainId: "1",
              name: "ADAPad",
              symbol: "ADAPAD",
              address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
              price: 0.00512253,
            },
            {
              chainId: "1",
              name: "Alpaca City",
              symbol: "ALPA",
              address: "0x7ca4408137eb639570f8e647d9bd7b7e8717514a",
              price: 0.00509111,
            },
            {
              chainId: "1",
              name: "Swash",
              symbol: "SWASH",
              address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
              price: 0.00505555,
            },
            {
              chainId: "1",
              name: "Hourglass",
              symbol: "WAIT",
              address: "0x2559813bbb508c4c79e9ccce4703bcb1f149edd7",
              price: 0.00497387,
            },
            {
              chainId: "1",
              name: "delta.theta",
              symbol: "DLTA",
              address: "0x0000000DE40dfa9B17854cBC7869D80f9F98D823",
              price: 0.00484398,
            },
            {
              chainId: "1",
              name: "Farmland Protocol",
              symbol: "FAR",
              address: "0xaae3cf9968d26925bdb73ce3864e0084a20f4687",
              price: 0.00481441,
            },
            {
              chainId: "1",
              name: "Konomi Network",
              symbol: "KONO",
              address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
              price: 0.00472211,
            },
            {
              chainId: "1",
              name: "Acquire.Fi",
              symbol: "ACQ",
              address: "0x4bdcb66b968060d9390c1d12bd29734496205581",
              price: 0.00468929,
            },
            {
              chainId: "1",
              name: "Hifi Finance (old)",
              symbol: "MFT",
              address: "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
              price: 0.00464541,
            },
            {
              chainId: "1",
              name: "The HUSL",
              symbol: "HUSL",
              address: "0xa2881f7f441267042f9778ffa0d4f834693426be",
              price: 0.00459769,
            },
            {
              chainId: "1",
              name: "Dfyn",
              symbol: "DFYN",
              address: "0x9695e0114e12C0d3A3636fAb5A18e6b737529023",
              price: 0.0045632,
            },
            {
              chainId: "1",
              name: "Blocery",
              symbol: "BLY",
              address: "0xf8aD7dFe656188A23e89da09506Adf7ad9290D5d",
              price: 0.00453355,
            },
            {
              chainId: "1",
              name: "Sweat Economy",
              symbol: "SWEAT",
              address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
              price: 0.00447261,
            },
            {
              chainId: "1",
              name: "Oddz Finance",
              symbol: "ODDZ",
              address: "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
              price: 0.00437637,
            },
            {
              chainId: "1",
              name: "SHOPX",
              symbol: "SHOPX",
              address: "0x7bef710a5759d197ec0bf621c3df802c2d60d848",
              price: 0.00435487,
            },
            {
              chainId: "1",
              name: "Peanut",
              symbol: "NUX",
              address: "0x89bd2e7e388fab44ae88bef4e1ad12b4f1e0911c",
              price: 0.00433468,
            },
            {
              chainId: "1",
              name: "Butterfly Protocol",
              symbol: "BFLY",
              address: "0xf680429328caaacabee69b7a9fdb21a71419c063",
              price: 0.00433267,
            },
            {
              chainId: "1",
              name: "Databroker",
              symbol: "DTX",
              address: "0x765f0c16d1ddc279295c1a7c24b0883f62d33f75",
              price: 0.00432293,
            },
            {
              chainId: "1",
              name: "Charged Particles",
              symbol: "IONX",
              address: "0x02d3a27ac3f55d5d91fb0f52759842696a864217",
              price: 0.00424643,
            },
            {
              chainId: "1",
              name: "Got Guaranteed",
              symbol: "GOTG",
              address: "0xceeb07dd26b36287b6d109f0b06d7e8202ce8c1d",
              price: 0.00419452,
            },
            {
              chainId: "1",
              name: "X2Y2",
              symbol: "X2Y2",
              address: "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9",
              price: 0.0041817,
            },
            {
              chainId: "1",
              name: "Abyss Finance",
              symbol: "ABYSS",
              address: "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
              price: 0.00411388,
            },
            {
              chainId: "1",
              name: "EpiK Protocol",
              symbol: "EPK",
              address: "0xdaf88906ac1de12ba2b1d2f7bfc94e9638ac40c4",
              price: 0.0040874,
            },
            {
              chainId: "1",
              name: "CPUcoin",
              symbol: "CPU",
              address: "0x6d52dfefb16bb9cdc78bfca09061e44574886626",
              price: 0.00400134,
            },
            {
              chainId: "1",
              name: "Open Platform",
              symbol: "OPEN",
              address: "0x9d86b1b2554ec410eccffbf111a6994910111340",
              price: 0.00396984,
            },
            {
              chainId: "1",
              name: "Add.xyz",
              symbol: "PLT",
              address: "0x9fbfed658919a896b5dc7b00456ce22d780f9b65",
              price: 0.00388478,
            },
            {
              chainId: "1",
              name: "Financie Token",
              symbol: "FNCT",
              address: "0x8af78f0c818302164f73b2365fe152c2d1fe80e1",
              price: 0.00388322,
            },
            {
              chainId: "1",
              name: "XI Protocol",
              symbol: "XI",
              address: "0x295B42684F90c77DA7ea46336001010F2791Ec8c",
              price: 0.0037862,
            },
            {
              chainId: "1",
              name: "Covalent",
              symbol: "CQT",
              address: "0xD417144312DbF50465b1C641d016962017Ef6240",
              price: 0.00377793,
            },
            {
              chainId: "1",
              name: "Coinweb",
              symbol: "CWEB",
              address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
              price: 0.00377525,
            },
            {
              chainId: "1",
              name: "Hord",
              symbol: "HORD",
              address: "0x43a96962254855f16b925556f9e97be436a43448",
              price: 0.00371826,
            },
            {
              chainId: "1",
              name: "PolkaFantasy",
              symbol: "XP",
              address: "0x948c70dc6169bfb10028fdbe96cbc72e9562b2ac",
              price: 0.00370077,
            },
            {
              chainId: "1",
              name: "AngelBlock",
              symbol: "THOL",
              address: "0x207e14389183A94343942de7aFbC607F57460618",
              price: 0.00367973,
            },
            {
              chainId: "1",
              name: "PandaDAO",
              symbol: "PANDA",
              address: "0x3cbb7f5d7499af626026e96a2f05df806f2200dc",
              price: 0.00367504,
            },
            {
              chainId: "1",
              name: "DotOracle",
              symbol: "DTO",
              address: "0xB57420FaD6731B004309D5a0ec7C6C906Adb8df7",
              price: 0.00363424,
            },
            {
              chainId: "1",
              name: "Furucombo",
              symbol: "COMBO",
              address: "0xfFffFffF2ba8F66D4e51811C5190992176930278",
              price: 0.00360684,
            },
            {
              chainId: "1",
              name: "MarX",
              symbol: "MARX",
              address: "0x2b100be232f90dd33d3b6e4b9ad70d1e8ac0e208",
              price: 0.00360275,
            },
            {
              chainId: "1",
              name: "Bright Union ",
              symbol: "BRIGHT",
              address: "0xbeab712832112bd7664226db7cd025b153d3af55",
              price: 0.00354967,
            },
            {
              chainId: "1",
              name: "STOA Network",
              symbol: "STA",
              address: "0x06874f973dc3c96dc22a10ef0d0609f877f335ea",
              price: 0.0035228,
            },
            {
              chainId: "1",
              name: "CoFiX",
              symbol: "COFI",
              address: "0x1a23a6BfBAdB59fa563008c0fB7cf96dfCF34Ea1",
              price: 0.00350266,
            },
            {
              chainId: "1",
              name: "Triall",
              symbol: "TRL",
              address: "0x58f9102bf53cf186682bd9a281d3cd3c616eec41",
              price: 0.00341673,
            },
            {
              chainId: "1",
              name: "Drops",
              symbol: "DOP",
              address: "0x6bb61215298f296c55b19ad842d3df69021da2ef",
              price: 0.00339802,
            },
            {
              chainId: "1",
              name: "ChainGuardians",
              symbol: "CGG",
              address: "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
              price: 0.00335146,
            },
            {
              chainId: "1",
              name: "NFTrade",
              symbol: "NFTD",
              address: "0x8e0fe2947752be0d5acf73aae77362daf79cb379",
              price: 0.00333074,
            },
            {
              chainId: "1",
              name: "NAOS Finance",
              symbol: "NAOS",
              address: "0x4a615bb7166210cce20e6642a6f8fb5d4d044496",
              price: 0.00331018,
            },
            {
              chainId: "1",
              name: "Smoothy",
              symbol: "SMTY",
              address: "0xbF776e4FCa664D791C4Ee3A71e2722990E003283",
              price: 0.00330507,
            },
            {
              chainId: "1",
              name: "APYSwap",
              symbol: "APYS",
              address: "0xf7413489c474ca4399eee604716c72879eea3615",
              price: 0.00329002,
            },
            {
              chainId: "1",
              name: "Kine Protocol",
              symbol: "KINE",
              address: "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d",
              price: 0.00328062,
            },
            {
              chainId: "1",
              name: "Futureswap",
              symbol: "FST",
              address: "0x0e192d382a36de7011f795acc4391cd302003606",
              price: 0.0032432,
            },
            {
              chainId: "1",
              name: "ForTube",
              symbol: "FOR",
              address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
              price: 0.00323763,
            },
            {
              chainId: "1",
              name: "Sashimi",
              symbol: "SASHIMI",
              address: "0xC28E27870558cF22ADD83540d2126da2e4b464c2",
              price: 0.0032074,
            },
            {
              chainId: "1",
              name: "CropBytes",
              symbol: "CBX",
              address: "0x37fc4b48ce93469dbea9918468993c735049642a",
              price: 0.00318043,
            },
            {
              chainId: "1",
              name: "Standard Protocol ",
              symbol: "STND",
              address: "0x9040e237C3bF18347bb00957Dc22167D0f2b999d",
              price: 0.00317739,
            },
            {
              chainId: "1",
              name: "HAVAH",
              symbol: "HVH",
              address: "0xd076c4ba62c57b3fa10800bcfd8da66742110e0e",
              price: 0.0030758,
            },
            {
              chainId: "1",
              name: "dAppstore",
              symbol: "DAPPX",
              address: "0x00d8318e44780edeefcf3020a5448f636788883c",
              price: 0.00302272,
            },
            {
              chainId: "1",
              name: "Blockchain Bets",
              symbol: "BCB",
              address: "0x2d886570a0da04885bfd6eb48ed8b8ff01a0eb7e",
              price: 0.00298175,
            },
            {
              chainId: "1",
              name: "Meta Gaming Guild",
              symbol: "MGG",
              address: "0x7237C0B30B1355f1B76355582f182F6f04B08740",
              price: 0.00294956,
            },
            {
              chainId: "1",
              name: "Virtue Poker",
              symbol: "VPP",
              address: "0x5eeaa2dcb23056f4e8654a349e57ebe5e76b5e6e",
              price: 0.00291414,
            },
            {
              chainId: "1",
              name: "DappRadar",
              symbol: "RADAR",
              address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
              price: 0.00291018,
            },
            {
              chainId: "1",
              name: "MXC",
              symbol: "MXC",
              address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
              price: 0.00281056,
            },
            {
              chainId: "1",
              name: "HEX",
              symbol: "HEX",
              address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
              price: 0.00280914,
            },
            {
              chainId: "1",
              name: "Decentr",
              symbol: "DEC",
              address: "0x30f271c9e86d2b7d00a6376cd96a1cfbd5f0b9b3",
              price: 0.00272244,
            },
            {
              chainId: "1",
              name: "Hakka Finance",
              symbol: "HAKKA",
              address: "0x0E29e5AbbB5FD88e28b2d355774e73BD47dE3bcd",
              price: 0.00270127,
            },
            {
              chainId: "1",
              name: "Proxi DeFi",
              symbol: "CREDIT",
              address: "0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4",
              price: 0.00245371,
            },
            {
              chainId: "1",
              name: "LSDx Finance",
              symbol: "LSD",
              address: "0xfAC77A24E52B463bA9857d6b758ba41aE20e31FF",
              price: 0.00234475,
            },
            {
              chainId: "1",
              name: "S.Finance",
              symbol: "SFG",
              address: "0x8a6aca71a218301c7081d4e96d64292d3b275ce0",
              price: 0.00232494,
            },
            {
              chainId: "1",
              name: "Art Gobblers Goo",
              symbol: "GOO",
              address: "0x600000000a36f3cd48407e35eb7c5c910dc1f7a8",
              price: 0.00222615,
            },
            {
              chainId: "1",
              name: "Nsure Network",
              symbol: "NSURE",
              address: "0x20945cA1df56D237fD40036d47E866C7DcCD2114",
              price: 0.00222604,
            },
            {
              chainId: "1",
              name: "Label",
              symbol: "LBL",
              address: "0x2162f572b25f7358db9376ab58a947a4e45cede1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "Label Foundation",
              symbol: "LBL",
              address: "0x2162f572B25f7358db9376AB58a947a4e45CeDE1",
              price: 0.00220915,
            },
            {
              chainId: "1",
              name: "ETHA Lend",
              symbol: "ETHA",
              address: "0x59e9261255644c411afdd00bd89162d09d862e38",
              price: 0.00220437,
            },
            {
              chainId: "1",
              name: "Holo",
              symbol: "HOT",
              address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
              price: 0.00214118,
            },
            {
              chainId: "1",
              name: "HNB Protocol",
              symbol: "HNB",
              address: "0x6E0615a03eD9527a6013FcD5B556E36EF4DaB1FF",
              price: 0.00213527,
            },
            {
              chainId: "1",
              name: "ZigZag",
              symbol: "ZZ",
              address: "0xc91a71a1ffa3d8b22ba615ba1b9c01b2bbbf55ad",
              price: 0.00210589,
            },
            {
              chainId: "1",
              name: "Efforce",
              symbol: "WOZX",
              address: "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f",
              price: 0.00210115,
            },
            {
              chainId: "1",
              name: "BiFi",
              symbol: "BIFI",
              address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
              price: 0.00209525,
            },
            {
              chainId: "1",
              name: "Universe.XYZ",
              symbol: "XYZ",
              address: "0x618679df9efcd19694bb1daa8d00718eacfa2883",
              price: 0.0020914,
            },
            {
              chainId: "1",
              name: "Darwinia Network",
              symbol: "RING",
              address: "0x9469d013805bffb7d3debe5e7839237e535ec483",
              price: 0.00205759,
            },
            {
              chainId: "137",
              name: "Gaia Everworld",
              symbol: "GAIA",
              address: "0x723b17718289a91af252d616de2c77944962d122",
              price: 0.00197659,
            },
            {
              chainId: "1",
              name: "Rally ",
              symbol: "RLY",
              address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
              price: 0.00195004,
            },
            {
              chainId: "1",
              name: "Agility LSD",
              symbol: "AGI",
              address: "0x5f18ea482ad5cc6bc65803817c99f477043dce85",
              price: 0.00188163,
            },
            {
              chainId: "1",
              name: "HYPERCOMIC",
              symbol: "HYCO",
              address: "0x77F76483399Dc6328456105B1db23e2Aca455bf9",
              price: 0.00187065,
            },
            {
              chainId: "1",
              name: "Linear",
              symbol: "LINA",
              address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
              price: 0.00185286,
            },
            {
              chainId: "1",
              name: "Blind Boxes",
              symbol: "BLES",
              address: "0xe796d6ca1ceb1b022ece5296226bf784110031cd",
              price: 0.00182817,
            },
            {
              chainId: "1",
              name: "Smooth Love Potion",
              symbol: "SLP",
              address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
              price: 0.00175882,
            },
            {
              chainId: "1",
              name: "VEMP",
              symbol: "VEMP",
              address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
              price: 0.00171918,
            },
            {
              chainId: "1",
              name: "Lambda",
              symbol: "LAMB",
              address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
              price: 0.00170616,
            },
            {
              chainId: "1",
              name: "Basis Cash",
              symbol: "BAC",
              address: "0x3449FC1Cd036255BA1EB19d65fF4BA2b8903A69a",
              price: 0.00164413,
            },
            {
              chainId: "1",
              name: "Arowana Token",
              symbol: "ARW",
              address: "0x351caa9045d65107b9d311d922d15887cfd634e4",
              price: 0.00162324,
            },
            {
              chainId: "1",
              name: "Ojamu",
              symbol: "OJA",
              address: "0x0aa7efe4945db24d95ca6e117bba65ed326e291a",
              price: 0.00159873,
            },
            {
              chainId: "1",
              name: "Project TXA",
              symbol: "TXA",
              address: "0x4463e6A3dEd0dBE3F6e15bC8420dFc55e5FeA830",
              price: 0.00158853,
            },
            {
              chainId: "1",
              name: "Adappter Token",
              symbol: "ADP",
              address: "0xc314b0e758d5ff74f63e307a86ebfe183c95767b",
              price: 0.001579,
            },
            {
              chainId: "1",
              name: "DOTMOOVS",
              symbol: "MOOV",
              address: "0x24ec2ca132abf8f6f8a6e24a1b97943e31f256a7",
              price: 0.00153091,
            },
            {
              chainId: "1",
              name: "Blockchain Monster Hunt",
              symbol: "BCMC",
              address: "0x2ba8349123de45e931a8c8264c332e6e9cf593f9",
              price: 0.00152033,
            },
            {
              chainId: "1",
              name: "Super Athletes Token",
              symbol: "SAT",
              address: "0x5ABf88cF3444611D13F6D1B39F3f3EE8575c91a2",
              price: 0.00151163,
            },
            {
              chainId: "1",
              name: "AllPay Coin",
              symbol: "APCG",
              address: "0x434Cb4fC4b952872967914D430878Eee53Ebd502",
              price: 0.00150962,
            },
            {
              chainId: "1",
              name: "Razor Network",
              symbol: "RAZOR",
              address: "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
              price: 0.00149896,
            },
            {
              chainId: "1",
              name: "PolkaRARE",
              symbol: "PRARE",
              address: "0x2C2f7e7C5604D162d75641256b80F1Bf6f4dC796",
              price: 0.00148141,
            },
            {
              chainId: "1",
              name: "Internet of Energy Network",
              symbol: "IOEN",
              address: "0x1e4e46b7bf03ece908c88ff7cc4975560010893a",
              price: 0.00144901,
            },
            {
              chainId: "1",
              name: "Akropolis Delphi",
              symbol: "ADEL",
              address: "0x94d863173ee77439e4292284ff13fad54b3ba182",
              price: 0.00141929,
            },
            {
              chainId: "1",
              name: "Deeper Network",
              symbol: "DPR",
              address: "0xf3ae5d769e153ef72b4e3591ac004e89f48107a1",
              price: 0.00139342,
            },
            {
              chainId: "1",
              name: "Fayre",
              symbol: "FAYRE",
              address: "0xAb4C44973BEFba9294F47e21E6BEB79A3C1D7d9F",
              price: 0.00138946,
            },
            {
              chainId: "1",
              name: "REVV",
              symbol: "REVV",
              address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
              price: 0.00135141,
            },
            {
              chainId: "1",
              name: "CryptoArt.Ai",
              symbol: "CART",
              address: "0x5c8c8d560048f34e5f7f8ad71f2f81a89dbd273e",
              price: 0.00134019,
            },
            {
              chainId: "1",
              name: "unshETH",
              symbol: "USH",
              address: "0xE60779CC1b2c1d0580611c526a8DF0E3f870EC48",
              price: 0.00132795,
            },
            {
              chainId: "1",
              name: "AME Chain",
              symbol: "AME",
              address: "0x12513335ffD5DAfc2334e98625d27c1CA84bff86",
              price: 0.00131956,
            },
            {
              chainId: "1",
              name: "Quidd",
              symbol: "QUIDD",
              address: "0xDA9FDAb21bC4A5811134A6E0Ba6CA06624e67c07",
              price: 0.00131618,
            },
            {
              chainId: "1",
              name: "ARTIC Foundation",
              symbol: "ARTIC",
              address: "0xe83d5fb2c60b3a2597452e248cf7b2f52a7e731e",
              price: 0.00129841,
            },
            {
              chainId: "1",
              name: "DeFiato",
              symbol: "DFIAT",
              address: "0x1045F5cCb01DAEA4f8eaB055F5FcBB7C0E7c89F0",
              price: 0.00128607,
            },
            {
              chainId: "1",
              name: "DEAPcoin",
              symbol: "DEP",
              address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
              price: 0.00119494,
            },
            {
              chainId: "1",
              name: "MixMarvel",
              symbol: "MIX",
              address: "0x5d285f735998f36631f678ff41fb56a10a4d0429",
              price: 0.00117,
            },
            {
              chainId: "1",
              name: "XREATORS",
              symbol: "ORT",
              address: "0x5c59a5b139b0538cb106d775a022cad98dd14b5a",
              price: 0.00115401,
            },
            {
              chainId: "1",
              name: "Cere Network",
              symbol: "CERE",
              address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
              price: 0.00114484,
            },
            {
              chainId: "1",
              name: "Throne",
              symbol: "THN",
              address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
              price: 0.00113916,
            },
            {
              chainId: "1",
              name: "Melos Studio",
              symbol: "MELOS",
              address: "0x1afb69dbc9f54d08dab1bd3436f8da1af819e647",
              price: 0.00113651,
            },
            {
              chainId: "1",
              name: "DMM: Governance",
              symbol: "DMG",
              address: "0xEd91879919B71bB6905f23af0A68d231EcF87b14",
              price: 0.00113509,
            },
            {
              chainId: "1",
              name: "TradeStars",
              symbol: "TSX",
              address: "0x734c90044a0ba31b3f2e640c10dc5d3540499bfd",
              price: 0.00111912,
            },
            {
              chainId: "1",
              name: "Sukhavati Network",
              symbol: "SKT",
              address: "0x012e0e6342308b247f36ee500ecb14dc77a7a8c1",
              price: 0.00111187,
            },
            {
              chainId: "1",
              name: "Bondly",
              symbol: "BONDLY",
              address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
              price: 0.00110671,
            },
            {
              chainId: "1",
              name: "Lend Flare",
              symbol: "LFT",
              address: "0xB620Be8a1949AA9532e6a3510132864EF9Bc3F82",
              price: 0.0011057,
            },
            {
              chainId: "1",
              name: "BlockchainSpace",
              symbol: "GUILD",
              address: "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
              price: 0.00109601,
            },
            {
              chainId: "1",
              name: "Tower",
              symbol: "TOWER",
              address: "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
              price: 0.00109538,
            },
            {
              chainId: "1",
              name: "Artizen",
              symbol: "ATNT",
              address: "0xAA2d8c9a8bd0F7945143bfD509bE3ff23dd78918",
              price: 0.00108477,
            },
            {
              chainId: "1",
              name: "Astra Protocol",
              symbol: "ASTRA",
              address: "0x201332Bd45c8628D814F870bFb584B385A7C351e",
              price: 0.00107095,
            },
            {
              chainId: "1",
              name: "DEVITA",
              symbol: "LIFE",
              address: "0x8640353CDc9778DEaB0dF45D12FB3013dEAC079C",
              price: 0.00106792,
            },
            {
              chainId: "1",
              name: "Shyft Network",
              symbol: "SHFT",
              address: "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85",
              price: 0.00101292,
            },
            {
              chainId: "1",
              name: "RFOX",
              symbol: "RFOX",
              address: "0xa1d6df714f91debf4e0802a542e13067f31b8262",
              price: 0.00099509,
            },
            {
              chainId: "1",
              name: "TrustVerse",
              symbol: "TRV",
              address: "0x72955ecff76e48f2c8abcce11d54e5734d6f3657",
              price: 0.00096659,
            },
            {
              chainId: "1",
              name: "BollyCoin",
              symbol: "BOLLY",
              address: "0x6bd361e10c1afed0d95259e7c0115f3a60e4ea99",
              price: 0.00096568,
            },
            {
              chainId: "1",
              name: "BlackHole Protocol",
              symbol: "BLACK",
              address: "0xd714d91A169127e11D8FAb3665d72E8b7ef9Dbe2",
              price: 0.00094632,
            },
            {
              chainId: "1",
              name: "Reef",
              symbol: "REEF",
              address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
              price: 0.00093609,
            },
            {
              chainId: "1",
              name: "Sentinel",
              symbol: "DVPN",
              address: "0xa44E5137293E855B1b7bC7E2C6f8cD796fFCB037",
              price: 0.00092027,
            },
            {
              chainId: "1",
              name: "The Doge NFT",
              symbol: "DOG",
              address: "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
              price: 0.00091842,
            },
            {
              chainId: "1",
              name: "Joystick",
              symbol: "JOY",
              address: "0x4e114d405b9ba2f59524941733e505ae03fb1fb5",
              price: 0.0009034,
            },
            {
              chainId: "1",
              name: "Sylo",
              symbol: "SYLO",
              address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
              price: 0.00089542,
            },
            {
              chainId: "1",
              name: "Lyra Finance",
              symbol: "LYRA",
              address: "0x01ba67aac7f75f647d94220cc98fb30fcc5105bf",
              price: 0.00088367,
            },
            {
              chainId: "1",
              name: "Qlindo",
              symbol: "QLINDO",
              address: "0xc18c07a18198a6340cf4d94855fe5eb6dd33b46e",
              price: 0.00086279,
            },
            {
              chainId: "1",
              name: "Koyo",
              symbol: "KOY",
              address: "0x198065e69a86cb8a9154b333aad8efe7a3c256f8",
              price: 0.0008542,
            },
            {
              chainId: "1",
              name: "BeyondFi",
              symbol: "BYN",
              address: "0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca",
              price: 0.0008541,
            },
            {
              chainId: "1",
              name: "CryptoAI",
              symbol: "CAI",
              address: "0xf36C5f04127F7470834ed6f98bDDC1BE62aba48D",
              price: 0.00084809,
            },
            {
              chainId: "1",
              name: "FreeRossDAO",
              symbol: "FREE",
              address: "0x4cd0c43b0d53bc318cc5342b77eb6f124e47f526",
              price: 0.00082232,
            },
            {
              chainId: "1",
              name: "Wasder",
              symbol: "WAS",
              address: "0x0c572544a4Ee47904d54aaA6A970AF96B6f00E1b",
              price: 0.00079792,
            },
            {
              chainId: "1",
              name: "Erugo World Coin",
              symbol: "EWC",
              address: "0xcd74cf66c43e45abd5703f3642f73d0675d6aff7",
              price: 0.00079585,
            },
            {
              chainId: "1",
              name: "Olea Token",
              symbol: "OLEA",
              address: "0xc6cc3d07c705e39d11c7f60d8836c7c78d4ac5f1",
              price: 0.00079006,
            },
            {
              chainId: "1",
              name: "BitKan",
              symbol: "KAN",
              address: "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a",
              price: 0.00078224,
            },
            {
              chainId: "1",
              name: "UniX Gaming",
              symbol: "UNIX",
              address: "0xddd6a0ecc3c6f6c102e5ea3d8af7b801d1a77ac8",
              price: 0.00078189,
            },
            {
              chainId: "1",
              name: "Airbloc",
              symbol: "ABL",
              address: "0xf8b358b3397a8ea5464f8cc753645d42e14b79ea",
              price: 0.00074102,
            },
            {
              chainId: "1",
              name: "Betswap.gg",
              symbol: "BSGG",
              address: "0x69570f3e84f51ea70b7b68055c8d667e77735a25",
              price: 0.0007367,
            },
            {
              chainId: "1",
              name: "Rainmaker Games",
              symbol: "RAIN",
              address: "0x71Fc1F555a39E0B698653AB0b475488EC3c34D57",
              price: 0.00071487,
            },
            {
              chainId: "1",
              name: "MatrixETF",
              symbol: "MDF",
              address: "0x1a57367c6194199e5d9aea1ce027431682dfb411",
              price: 0.00068647,
            },
            {
              chainId: "1",
              name: "NvirWorld",
              symbol: "NVIR",
              address: "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
              price: 0.00067707,
            },
            {
              chainId: "1",
              name: "Spell Token",
              symbol: "SPELL",
              address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
              price: 0.00064614,
            },
            {
              chainId: "1",
              name: "Umee",
              symbol: "UMEE",
              address: "0xc0a4df35568f116c370e6a6a6022ceb908eeddac",
              price: 0.00062095,
            },
            {
              chainId: "1",
              name: "iDeFiYieldProtocol",
              symbol: "IDYP",
              address: "0xbd100d061e120b2c67a24453cf6368e63f1be056",
              price: 0.00062002,
            },
            {
              chainId: "1",
              name: "EYES Protocol",
              symbol: "EYES",
              address: "0xe42B7A17336B343569C82f682a493a837B7e0755",
              price: 0.00060086,
            },
            {
              chainId: "1",
              name: "Creaticles",
              symbol: "CRE8",
              address: "0xc36b4311b21fc0c2ead46f1ea6ce97c9c4d98d3d",
              price: 0.00059873,
            },
            {
              chainId: "1",
              name: "Yieldification",
              symbol: "YDF",
              address: "0x30dcba0405004cf124045793e1933c798af9e66a",
              price: 0.00058824,
            },
            {
              chainId: "1",
              name: "Stablz",
              symbol: "STABLZ",
              address: "0xa4eb9c64ec359d093eac7b65f51ef933d6e5f7cd",
              price: 0.00056856,
            },
            {
              chainId: "1",
              name: "Fodl Finance",
              symbol: "FODL",
              address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
              price: 0.00056514,
            },
            {
              chainId: "1",
              name: "Crafting Finance",
              symbol: "CRF",
              address: "0x508df5aa4746be37b5b6a69684dfd8bdc322219d",
              price: 0.00054557,
            },
            {
              chainId: "1",
              name: "LeverFi",
              symbol: "LEVER",
              address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
              price: 0.00052136,
            },
            {
              chainId: "1",
              name: "Definer",
              symbol: "FIN",
              address: "0x054f76beed60ab6dbeb23502178c52d6c5debe40",
              price: 0.00051712,
            },
            {
              chainId: "1",
              name: "DOSE",
              symbol: "DOSE",
              address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
              price: 0.00051644,
            },
            {
              chainId: "1",
              name: "MoonDAO",
              symbol: "MOONEY",
              address: "0x20d4DB1946859E2Adb0e5ACC2eac58047aD41395",
              price: 0.0005079,
            },
            {
              chainId: "1",
              name: "Sakura Planet",
              symbol: "SAK",
              address: "0xb269Ab3B20E09e6fd17C3ED5B4CECF3dEA1a5141",
              price: 0.00050048,
            },
            {
              chainId: "1",
              name: "MultiVAC",
              symbol: "MTV",
              address: "0x8aa688AB789d1848d131C65D98CEAA8875D97eF1",
              price: 0.00049522,
            },
            {
              chainId: "1",
              name: "DOS Network",
              symbol: "DOS",
              address: "0x0A913beaD80F321E7Ac35285Ee10d9d922659cB7",
              price: 0.00049359,
            },
            {
              chainId: "1",
              name: "Ethermon",
              symbol: "EMON",
              address: "0xd6a5ab46ead26f49b03bbb1f9eb1ad5c1767974a",
              price: 0.0004856,
            },
            {
              chainId: "1",
              name: "Neighbourhoods",
              symbol: "NHT",
              address: "0x84342e932797FC62814189f01F0Fb05F52519708",
              price: 0.00048342,
            },
            {
              chainId: "1",
              name: "EdgeSwap",
              symbol: "EGS",
              address: "0xB009BFaAF85e53F55d8657781Eb69feAaed83672",
              price: 0.00048175,
            },
            {
              chainId: "1",
              name: "Formation Fi",
              symbol: "FORM",
              address: "0x21381e026Ad6d8266244f2A583b35F9E4413FA2a",
              price: 0.00048081,
            },
            {
              chainId: "1",
              name: "Evanesco",
              symbol: "EVA",
              address: "0xd6caf5bd23cf057f5fccce295dcc50c01c198707",
              price: 0.00047749,
            },
            {
              chainId: "1",
              name: "AAG Ventures",
              symbol: "AAG",
              address: "0x5ba19d656b65f1684cfea4af428c23b9f3628f97",
              price: 0.00046456,
            },
            {
              chainId: "1",
              name: "Monetha",
              symbol: "MTH",
              address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
              price: 0.00044949,
            },
            {
              chainId: "1",
              name: "PDX",
              symbol: "PDX",
              address: "0x5f33d158ca7275848f70a3f149b421190df85b32",
              price: 0.00044645,
            },
            {
              chainId: "1",
              name: "Unifarm",
              symbol: "UFARM",
              address: "0x40986a85b4cfcdb054a6cbfb1210194fee51af88",
              price: 0.00044526,
            },
            {
              chainId: "1",
              name: "MetaOctagon",
              symbol: "MOTG",
              address: "0x171d76d931529384639BC9aad5b77b77041ED604",
              price: 0.00044182,
            },
            {
              chainId: "1",
              name: "Akropolis",
              symbol: "AKRO",
              address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
              price: 0.0004383,
            },
            {
              chainId: "1",
              name: "Define",
              symbol: "DFA",
              address: "0x62959c699a52ec647622c91e79ce73344e4099f5",
              price: 0.00043759,
            },
            {
              chainId: "1",
              name: "ORE Network",
              symbol: "ORE",
              address: "0x4f640f2529ee0cf119a2881485845fa8e61a782a",
              price: 0.00043538,
            },
            {
              chainId: "1",
              name: "Scry.info",
              symbol: "DDD",
              address: "0x9F5F3CFD7a32700C93F971637407ff17b91c7342",
              price: 0.00043413,
            },
            {
              chainId: "1",
              name: "Ares Protocol",
              symbol: "ARES",
              address: "0x358AA737e033F34df7c54306960a38d09AaBd523",
              price: 0.00043409,
            },
            {
              chainId: "1",
              name: "Spellfire",
              symbol: "SPELLFIRE",
              address: "0x3A0b022f32b3191D44E5847da12dc0B63fb07C91",
              price: 0.00043085,
            },
            {
              chainId: "1",
              name: "Kambria",
              symbol: "KAT",
              address: "0x14da230d6726c50f759bc1838717f8ce6373509c",
              price: 0.00042042,
            },
            {
              chainId: "1",
              name: "POPKON",
              symbol: "POPK",
              address: "0xaC12e8f6b0C17d7B736A800920b336d764b59973",
              price: 0.00040965,
            },
            {
              chainId: "1",
              name: "Kudoe",
              symbol: "KDOE",
              address: "0x5f190f9082878ca141f858c1c90b4c59fe2782c5",
              price: 0.00040861,
            },
            {
              chainId: "1",
              name: "BendDAO",
              symbol: "BEND",
              address: "0x0d02755a5700414b26ff040e1de35d337df56218",
              price: 0.00040832,
            },
            {
              chainId: "1",
              name: "EnterButton",
              symbol: "ENTC",
              address: "0x3ecab35b64345bfc472477a653e4a3abe70532d9",
              price: 0.00040056,
            },
            {
              chainId: "1",
              name: "MARS4",
              symbol: "MARS4",
              address: "0x16cda4028e9e872a38acb903176719299beaed87",
              price: 0.00038566,
            },
            {
              chainId: "1",
              name: "PEAKDEFI",
              symbol: "PEAK",
              address: "0x630d98424efe0ea27fb1b3ab7741907dffeaad78",
              price: 0.00038338,
            },
            {
              chainId: "1",
              name: "Game.com",
              symbol: "GTC",
              address: "0xB70835D7822eBB9426B56543E391846C107bd32C",
              price: 0.00038213,
            },
            {
              chainId: "1",
              name: "Ispolink",
              symbol: "ISP",
              address: "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
              price: 0.00037618,
            },
            {
              chainId: "1",
              name: "Cindicator",
              symbol: "CND",
              address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
              price: 0.00037224,
            },
            {
              chainId: "1",
              name: "ARMOR",
              symbol: "ARMOR",
              address: "0x1337def16f9b486faed0293eb623dc8395dfe46a",
              price: 0.00036815,
            },
            {
              chainId: "1",
              name: "DinoX",
              symbol: "DNXC",
              address: "0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a",
              price: 0.00035326,
            },
            {
              chainId: "1",
              name: "Saitama V2",
              symbol: "SAITAMA",
              address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
              price: 0.00035045,
            },
            {
              chainId: "1",
              name: "Katana Inu",
              symbol: "KATA",
              address: "0x2e85ae1C47602f7927bCabc2Ff99C40aA222aE15",
              price: 0.00034779,
            },
            {
              chainId: "1",
              name: "BambooDeFi",
              symbol: "BAMBOO",
              address: "0xf56842Af3B56Fd72d17cB103f92d027bBa912e89",
              price: 0.00033189,
            },
            {
              chainId: "1",
              name: "DoubleDice",
              symbol: "DODI",
              address: "0x4e08f03079c5cd3083ea331ec61bcc87538b7665",
              price: 0.00033147,
            },
            {
              chainId: "1",
              name: "NFTMart",
              symbol: "NMT",
              address: "0xd81b71cbb89b2800cdb000aa277dc1491dc923c3",
              price: 0.00032821,
            },
            {
              chainId: "1",
              name: "YIN Finance",
              symbol: "YIN",
              address: "0x794Baab6b878467F93EF17e2f2851ce04E3E34C8",
              price: 0.00031524,
            },
            {
              chainId: "1",
              name: "Spume",
              symbol: "SPUME",
              address: "0xa16a609fF4e1A15b6cCb469E7a5dD14E89305283",
              price: 0.00031453,
            },
            {
              chainId: "1",
              name: "Play It Forward DAO",
              symbol: "PIF",
              address: "0xb30f5d11b94efbbfdeaa4de38edffceec0be6513",
              price: 0.00031324,
            },
            {
              chainId: "1",
              name: "Franklin",
              symbol: "FLY",
              address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
              price: 0.00031205,
            },
            {
              chainId: "1",
              name: "Busy",
              symbol: "BUSY",
              address: "0x5cb3ce6d081fb00d5f6677d196f2d70010ea3f4a",
              price: 0.00030676,
            },
            {
              chainId: "1",
              name: "TokenClub",
              symbol: "TCT",
              address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
              price: 0.00030147,
            },
            {
              chainId: "1",
              name: "Ecomi",
              symbol: "OMI",
              address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
              price: 0.00027862,
            },
            {
              chainId: "1",
              name: "Enjinstarter",
              symbol: "EJS",
              address: "0x96610186F3ab8d73EBEe1CF950C750f3B1Fb79C2",
              price: 0.00027744,
            },
            {
              chainId: "1",
              name: "Niftify",
              symbol: "NIFT",
              address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
              price: 0.00027324,
            },
            {
              chainId: "1",
              name: "2crazyNFT",
              symbol: "2CRZ",
              address: "0x2c9c19ce3b15ae77c6d80aec3c1194cfd6f7f3fa",
              price: 0.00027164,
            },
            {
              chainId: "1",
              name: "Handy",
              symbol: "HANDY",
              address: "0x8bbe1a2961B41340468D0548c2cd5B7DFA9b684c",
              price: 0.00026091,
            },
            {
              chainId: "1",
              name: "Cratos",
              symbol: "CRTS",
              address: "0x678e840c640f619e17848045d23072844224dd37",
              price: 0.00025931,
            },
            {
              chainId: "1",
              name: "Bottos",
              symbol: "BTO",
              address: "0x36905fc93280f52362a1cbab151f25dc46742fb5",
              price: 0.00025545,
            },
            {
              chainId: "1",
              name: "Dogechain",
              symbol: "DC",
              address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
              price: 0.00025429,
            },
            {
              chainId: "1",
              name: "The Protocol",
              symbol: "THE",
              address: "0x0cba60ca5ef4d42f92a5070a8fedd13be93e2861",
              price: 0.0002527,
            },
            {
              chainId: "1",
              name: "Cred",
              symbol: "LBA",
              address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
              price: 0.00024927,
            },
            {
              chainId: "1",
              name: "NFTY Network",
              symbol: "NFTY",
              address: "0xE1D7C7a4596B038CEd2A84bF65B8647271C53208",
              price: 0.00024635,
            },
            {
              chainId: "1",
              name: "Atari Token",
              symbol: "ATRI",
              address: "0xdacd69347de42babfaecd09dc88958378780fb62",
              price: 0.00024522,
            },
            {
              chainId: "1",
              name: "Burp",
              symbol: "BURP",
              address: "0x33f391f4c4fe802b70b77ae37670037a92114a7c",
              price: 0.00024459,
            },
            {
              chainId: "1",
              name: "Wojak",
              symbol: "WOJAK",
              address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
              price: 0.00024381,
            },
            {
              chainId: "1",
              name: "Beyond Protocol",
              symbol: "BP",
              address: "0xdF290B162a7D3E0A328cF198308D421954f08b94",
              price: 0.0002357,
            },
            {
              chainId: "1",
              name: "Burency",
              symbol: "BUY",
              address: "0x31fdd1c6607f47c14a2821f599211c67ac20fa96",
              price: 0.00022943,
            },
            {
              chainId: "1",
              name: "Pando",
              symbol: "PANDO",
              address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
              price: 0.00021312,
            },
            {
              chainId: "1",
              name: "SubDAO",
              symbol: "GOV",
              address: "0x274e7eb07b485cfde53d02270555213447570ac6",
              price: 0.00021092,
            },
            {
              chainId: "1",
              name: "Cardiocoin",
              symbol: "CRDC",
              address: "0xF81421fc15300c5a8CCa9aFE12F5CBAd502Fa756",
              price: 0.0002024,
            },
            {
              chainId: "1",
              name: "Myria",
              symbol: "MYRIA",
              address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
              price: 0.00020218,
            },
            {
              chainId: "1",
              name: "TokenBot",
              symbol: "TKB",
              address: "0x16594930D16f3970e1a4317c6016555cb2e7b7Fc",
              price: 0.00019114,
            },
            {
              chainId: "1",
              name: "Edoverse",
              symbol: "ZENI",
              address: "0x9c6666d5ff4B53b5eB3bd866664c15d0BFcECaa7",
              price: 0.00019005,
            },
            {
              chainId: "1",
              name: "BoringDAO",
              symbol: "BORING",
              address: "0xbc19712feb3a26080ebf6f2f7849b417fdd792ca",
              price: 0.00018729,
            },
            {
              chainId: "1",
              name: "LandWorld",
              symbol: "LWD",
              address: "0x786e995A975C2ab7C1dd252A9019fB0c91c9Ca83",
              price: 0.00018524,
            },
            {
              chainId: "1",
              name: "Essentia",
              symbol: "ESS",
              address: "0xfc05987bd2be489ACCF0f509E44B0145d68240f7",
              price: 0.00018078,
            },
            {
              chainId: "1",
              name: "WoofWork.io",
              symbol: "WOOF",
              address: "0x6BC08509B36A98E829dFfAD49Fde5e412645d0a3",
              price: 0.00017883,
            },
            {
              chainId: "1",
              name: "Ruff",
              symbol: "RUFF",
              address: "0xf278c1ca969095ffddded020290cf8b5c424ace2",
              price: 0.00017599,
            },
            {
              chainId: "1",
              name: "Lithium Finance",
              symbol: "LITH",
              address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
              price: 0.0001711,
            },
            {
              chainId: "1",
              name: "PixelVerse",
              symbol: "PIXEL",
              address: "0x65e6b60ea01668634d68d0513fe814679f925bad",
              price: 0.00016891,
            },
            {
              chainId: "1",
              name: "Pawtocol",
              symbol: "UPI",
              address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
              price: 0.00016276,
            },
            {
              chainId: "1",
              name: "Unbound Finance",
              symbol: "UNB",
              address: "0x8db253a1943dddf1af9bcf8706ac9a0ce939d922",
              price: 0.00015672,
            },
            {
              chainId: "56",
              name: "OptionRoom",
              symbol: "ROOM",
              address: "0x3C45A24d36Ab6fc1925533C1F57bC7e1b6fbA8a4",
              price: 0.00015276,
            },
            {
              chainId: "1",
              name: "SoonSwap",
              symbol: "SOON",
              address: "0x574D22E2555cAc0ce71e44778f6De2e7487aE229",
              price: 0.00015237,
            },
            {
              chainId: "1",
              name: "RACA",
              symbol: "RACA",
              address: "0x12BB890508c125661E03b09EC06E404bc9289040",
              price: 0.00014931,
            },
            {
              chainId: "1",
              name: "Yesports",
              symbol: "YESP",
              address: "0x46cca329970b33e1a007dd4ef0594a1cedb3e72a",
              price: 0.00014418,
            },
            {
              chainId: "1",
              name: "CoverCompared",
              symbol: "CVR",
              address: "0x3c03b4ec9477809072ff9cc9292c9b25d4a8e6c6",
              price: 0.00014248,
            },
            {
              chainId: "1",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
              price: 0.00013609,
            },
            {
              chainId: "1",
              name: "Dreamverse",
              symbol: "DV",
              address: "0x2a03a891add2dc6d0f7b94419086630ba5cb65b6",
              price: 0.00013514,
            },
            {
              chainId: "1",
              name: "CyberVein",
              symbol: "CVT",
              address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
              price: 0.00013269,
            },
            {
              chainId: "1",
              name: "Zam.io",
              symbol: "ZAM",
              address: "0xd373576a9e738F37Dc6882328358Ff69c4cAf4c6",
              price: 0.00013236,
            },
            {
              chainId: "1",
              name: "RankerDAO",
              symbol: "RANKER",
              address: "0x6431FA4B812a2DCC062A38CB55cc7D18135AdEAd",
              price: 0.00013079,
            },
            {
              chainId: "1",
              name: "AllianceBlock",
              symbol: "ALBT",
              address: "0x00a8b738E453fFd858a7edf03bcCfe20412f0Eb0",
              price: 0.00013065,
            },
            {
              chainId: "1",
              name: "Idavoll DAO",
              symbol: "IDV",
              address: "0x92ec47df1aa167806dfa4916d9cfb99da6953b8f",
              price: 0.00012983,
            },
            {
              chainId: "1",
              name: "Unit Protocol",
              symbol: "DUCK",
              address: "0x92e187a03b6cd19cb6af293ba17f2745fd2357d5",
              price: 0.00012977,
            },
            {
              chainId: "1",
              name: "SparkPoint",
              symbol: "SRK",
              address: "0x0488401c3f535193fa8df029d9ffe615a06e74e6",
              price: 0.00012406,
            },
            {
              chainId: "1",
              name: "Aurora Chain",
              symbol: "AOA",
              address: "0x9ab165d795019b6d8b3e971dda91071421305e5a",
              price: 0.00012375,
            },
            {
              chainId: "1",
              name: "AssangeDAO",
              symbol: "JUSTICE",
              address: "0x59d1e836F7b7210A978b25a855085cc46fd090B5",
              price: 0.00012251,
            },
            {
              chainId: "1",
              name: "Cell Network",
              symbol: "ECELL",
              address: "0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f",
              price: 0.00011999,
            },
            {
              chainId: "1",
              name: "Versailles Heroes",
              symbol: "VRH",
              address: "0xead482da0793b00bbae0e34c8cfae6daf29a44b2",
              price: 0.00011931,
            },
            {
              chainId: "1",
              name: "Blocksport",
              symbol: "BSPT",
              address: "0xa350da05405cc204e551c4eed19c3039646528d5",
              price: 0.00011649,
            },
            {
              chainId: "1",
              name: "Nucleus Vision",
              symbol: "NCASH",
              address: "0x809826cceab68c387726af962713b64cb5cb3cca",
              price: 0.00011582,
            },
            {
              chainId: "1",
              name: "Aster Coin",
              symbol: "ATC",
              address: "0x0eb3032bcac2be1fa95e296442f225edb80fc3cd",
              price: 0.00011286,
            },
            {
              chainId: "1",
              name: "BTRIPS",
              symbol: "BTR",
              address: "0x5ea82c27efc7634f1c5ad20a3561c453433a2f3a",
              price: 0.00011052,
            },
            {
              chainId: "1",
              name: "Plasma Finance",
              symbol: "PPAY",
              address: "0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2",
              price: 0.00010669,
            },
            {
              chainId: "1",
              name: "DSLA Protocol",
              symbol: "DSLA",
              address: "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
              price: 0.00010587,
            },
            {
              chainId: "1",
              name: "Poken",
              symbol: "PKN",
              address: "0xdf09a216fac5adc3e640db418c0b956076509503",
              price: 0.000104,
            },
            {
              chainId: "1",
              name: "Woozoo Music",
              symbol: "WZM",
              address: "0xd15a1a2a3211b58113e45809f05934252e34e2f8",
              price: 0.00010069,
            },
            {
              chainId: "1",
              name: "Open Proprietary Protocol",
              symbol: "OPP",
              address: "0xf51ccB15d3F2D304Ae6C409303e8b3a3e397A80b",
              price: 0.00009986,
            },
            {
              chainId: "1",
              name: "Cook Protocol",
              symbol: "COOK",
              address: "0xff75ced57419bcaebe5f05254983b013b0646ef5",
              price: 0.00009959,
            },
            {
              chainId: "1",
              name: "Tokenplace",
              symbol: "TOK",
              address: "0x4fb721ef3bf99e0f2c193847afa296b9257d3c30",
              price: 0.00009882,
            },
            {
              chainId: "1",
              name: "Shibarium Perpetuals",
              symbol: "SERP",
              address: "0xfd414e39155f91e94443a9fe97e856569d0f5eec",
              price: 0.00009335,
            },
            {
              chainId: "1",
              name: "LunchDAO",
              symbol: "LUNCH",
              address: "0x71a28feAEe902966DC8D355e7B8Aa427D421e7e0",
              price: 0.00009329,
            },
            {
              chainId: "1",
              name: "DexGame",
              symbol: "DXGM",
              address: "0x66f73d0fd4161cfad4302dc145ff994375c13475",
              price: 0.00009273,
            },
            {
              chainId: "1",
              name: "PolkaPets",
              symbol: "PETS",
              address: "0x6afcff9189e8ed3fcc1cffa184feb1276f6a82a5",
              price: 0.00009212,
            },
            {
              chainId: "1",
              name: "KStarCoin",
              symbol: "KSC",
              address: "0x990e081a7b7d3ccba26a2f49746a68cc4ff73280",
              price: 0.00009181,
            },
            {
              chainId: "1",
              name: "Theos",
              symbol: "THEOS",
              address: "0x9e10f61749c4952c320412a6b26901605ff6da1d",
              price: 0.00009025,
            },
            {
              chainId: "1",
              name: "ANIVERSE",
              symbol: "ANV",
              address: "0x3D382228C54736d831FAC2748F4734D9177c7332",
              price: 0.00008965,
            },
            {
              chainId: "1",
              name: "BNS",
              symbol: "BNS",
              address: "0x19e2a43fbbc643c3b2d9667d858d49cad17bc2b5",
              price: 0.00008747,
            },
            {
              chainId: "1",
              name: "Flurry Finance",
              symbol: "FLURRY",
              address: "0x60F63B76E2Fc1649E57a3489162732A90ACf59FE",
              price: 0.00008633,
            },
            {
              chainId: "1",
              name: "Luffy",
              symbol: "LUFFY",
              address: "0x54012cDF4119DE84218F7EB90eEB87e25aE6EBd7",
              price: 0.00008619,
            },
            {
              chainId: "1",
              name: "Ooki",
              symbol: "OOKI",
              address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
              price: 0.00008529,
            },
            {
              chainId: "1",
              name: "SaitaRealty",
              symbol: "SRLTY",
              address: "0x142a774E8b52550E88E196CedD7A5835acB646D0",
              price: 0.00008246,
            },
            {
              chainId: "1",
              name: "Loon Network",
              symbol: "LOON",
              address: "0x7C5d5100B339Fe7D995a893AF6CB496B9474373c",
              price: 0.00008231,
            },
            {
              chainId: "1",
              name: "BABB",
              symbol: "BAX",
              address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
              price: 0.00007559,
            },
            {
              chainId: "1",
              name: "MOVE Network",
              symbol: "MOVD",
              address: "0x12300ed54f65648524c1bfaf86712927da6cc6fc",
              price: 0.00007517,
            },
            {
              chainId: "1",
              name: "Smart Finance",
              symbol: "SMART",
              address: "0xce20BB92CCF9BbF5091ef85649E71E552819AD8c",
              price: 0.00007491,
            },
            {
              chainId: "1",
              name: "HistoryDAO",
              symbol: "HAO",
              address: "0x3c4008eca800ec1283e4cf500e68d06bfabc00a8",
              price: 0.00007464,
            },
            {
              chainId: "1",
              name: "Life Crypto",
              symbol: "LIFE",
              address: "0x6c936D4AE98E6d2172dB18c16C4b601C99918EE6",
              price: 0.00007288,
            },
            {
              chainId: "1",
              name: "DeHorizon",
              symbol: "DEVT",
              address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
              price: 0.00007233,
            },
            {
              chainId: "1",
              name: "Animal Concerts",
              symbol: "ANML",
              address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
              price: 0.00006441,
            },
            {
              chainId: "1",
              name: "Convergence Finance",
              symbol: "CONV",
              address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
              price: 0.00006394,
            },
            {
              chainId: "1",
              name: "Hyprr",
              symbol: "UDOO",
              address: "0x12f649a9e821f90bb143089a6e56846945892ffb",
              price: 0.00006301,
            },
            {
              chainId: "1",
              name: "GAMB",
              symbol: "GMB",
              address: "0xa0008f510fe9ee696e7e320c9e5cbf61e27791ee",
              price: 0.00006169,
            },
            {
              chainId: "1",
              name: "EverRise",
              symbol: "RISE",
              address: "0xC17c30e98541188614dF99239cABD40280810cA3",
              price: 0.00006012,
            },
            {
              chainId: "1",
              name: "CouponBay",
              symbol: "CUP",
              address: "0x3209d14ff61766359e64aceff91877cec2ad968e",
              price: 0.00005903,
            },
            {
              chainId: "1",
              name: "Glosfer",
              symbol: "GLO",
              address: "0xc0e6737a29de7a00e2f6011924eb257106cb082f",
              price: 0.00005764,
            },
            {
              chainId: "56",
              name: "FLOKI",
              symbol: "FLOKI",
              address: "0xfb5B838b6cfEEdC2873aB27866079AC55363D37E",
              price: 0.00005734,
            },
            {
              chainId: "1",
              name: "BlockBank",
              symbol: "BBANK",
              address: "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
              price: 0.00005226,
            },
            {
              chainId: "1",
              name: "artèQ",
              symbol: "ARTEQ",
              address: "0x805C2077f3ab224D889f9c3992B41B2F4722c787",
              price: 0.00005007,
            },
            {
              chainId: "1",
              name: "Tidal Finance",
              symbol: "TIDAL",
              address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
              price: 0.00004985,
            },
            {
              chainId: "1",
              name: "Gera Coin",
              symbol: "GERA",
              address: "0x80d4F13AcC30968fD6225b1Ea79f5779f09FEE60",
              price: 0.00004776,
            },
            {
              chainId: "1",
              name: "Kollect",
              symbol: "KOL",
              address: "0x1cc30e2eac975416060ec6fe682041408420d414",
              price: 0.00004726,
            },
            {
              chainId: "1",
              name: "Saddle",
              symbol: "SDL",
              address: "0xf1Dc500FdE233A4055e25e5BbF516372BC4F6871",
              price: 0.00004657,
            },
            {
              chainId: "1",
              name: "TribeOne",
              symbol: "HAKA",
              address: "0xd85ad783cc94bd04196a13dc042a3054a9b52210",
              price: 0.00004609,
            },
            {
              chainId: "1",
              name: "Naetion",
              symbol: "NTN",
              address: "0x56D3d0B333D29b48DD7c01d516A737B8866fBEe2",
              price: 0.00004523,
            },
            {
              chainId: "1",
              name: "ReapChain",
              symbol: "REAP",
              address: "0x1fc5EF0337AEA85C5f9198853a6E3A579a7A6987",
              price: 0.00004155,
            },
            {
              chainId: "1",
              name: "Astra Guild Ventures",
              symbol: "AGV",
              address: "0xf4f618eff5ef36cde2fca4fbd86554c62fb1382b",
              price: 0.00004036,
            },
            {
              chainId: "1",
              name: "NuriFootBall",
              symbol: "NRFB",
              address: "0x00281dfce4cfd72c0b6fda2aaaf077258743f9e8",
              price: 0.00003648,
            },
            {
              chainId: "1",
              name: "Deesse",
              symbol: "LOVE",
              address: "0xde4ce5447ce0c67920a1371605a39187cb6847c8",
              price: 0.00003584,
            },
            {
              chainId: "1",
              name: "Bitspawn",
              symbol: "SPWN",
              address: "0xe516d78d784c77d479977be58905b3f2b1111126",
              price: 0.0000353,
            },
            {
              chainId: "1",
              name: "BonFi",
              symbol: "BNF",
              address: "0x1DE5e000C41C8d35b9f1f4985C23988f05831057",
              price: 0.00003525,
            },
            {
              chainId: "1",
              name: "MetaVisa",
              symbol: "MESA",
              address: "0x5afff9876c1f98b7d2b53bcb69eb57e92408319f",
              price: 0.00003347,
            },
            {
              chainId: "1",
              name: "Launchblock",
              symbol: "LBP",
              address: "0xa23C1194d421F252b4e6D5edcc3205F7650a4eBE",
              price: 0.00003319,
            },
            {
              chainId: "1",
              name: "Finance Blocks",
              symbol: "FBX",
              address: "0x60bb16c4a931b1a0b8a7d945c651dd90f41d42cf",
              price: 0.00003081,
            },
            {
              chainId: "1",
              name: "Vader Protocol",
              symbol: "VADER",
              address: "0x2602278ee1882889b946eb11dc0e810075650983",
              price: 0.00003072,
            },
            {
              chainId: "1",
              name: "SOCOL",
              symbol: "SIMP",
              address: "0x41C21693e60FC1a5dBb7c50e54E7A6016aA44C99",
              price: 0.00003014,
            },
            {
              chainId: "1",
              name: "Vabble",
              symbol: "VAB",
              address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
              price: 0.00003008,
            },
            {
              chainId: "1",
              name: "Golden Goal",
              symbol: "GDG",
              address: "0xFD020998A1bB316dfE7B136Fe59Ae4B365D79978",
              price: 0.00002975,
            },
            {
              chainId: "1",
              name: "Metababy",
              symbol: "BABY",
              address: "0x1cCF27211e8bf052f6255329ed641B4E94E80603",
              price: 0.00002874,
            },
            {
              chainId: "1",
              name: "MurAll",
              symbol: "PAINT",
              address: "0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042",
              price: 0.00002857,
            },
            {
              chainId: "1",
              name: "Kay Pacha",
              symbol: "PACHA",
              address: "0x2Dd1B9410c73E16b60240E529e38E30425F00d4E",
              price: 0.00002785,
            },
            {
              chainId: "1",
              name: "JPEG'd",
              symbol: "JPEG",
              address: "0xE80C0cd204D654CEbe8dd64A4857cAb6Be8345a3",
              price: 0.00002773,
            },
            {
              chainId: "1",
              name: "Ceji",
              symbol: "CEJI",
              address: "0x189fC141854BFc6146777406d53fbC89F4e70407",
              price: 0.00002732,
            },
            {
              chainId: "1",
              name: "MIRL",
              symbol: "MIRL",
              address: "0x8770b7Dd89E5f759eE3b226e0C45e890f87dDc48",
              price: 0.0000265,
            },
            {
              chainId: "1",
              name: "Sponge",
              symbol: "$SPONGE",
              address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
              price: 0.00002552,
            },
            {
              chainId: "1",
              name: "Time New Bank",
              symbol: "TNB",
              address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
              price: 0.00002548,
            },
            {
              chainId: "1",
              name: "SpiderDAO",
              symbol: "SPDR",
              address: "0xbcd4b7de6fde81025f74426d43165a5b0d790fdd",
              price: 0.00002524,
            },
            {
              chainId: "1",
              name: "Ludos",
              symbol: "LUD",
              address: "0xe64b47931f28f89cc7a0c6965ecf89eadb4975f5",
              price: 0.00002484,
            },
            {
              chainId: "1",
              name: "WATTTON",
              symbol: "WATT",
              address: "0xE67F943af5Eb6051ef56f05979cc30B732717fa6",
              price: 0.00002385,
            },
            {
              chainId: "1",
              name: "Dapp.com",
              symbol: "DAPPT",
              address: "0x96184d9c811ea0624fc30c80233b1d749b9e485b",
              price: 0.00002315,
            },
            {
              chainId: "1",
              name: "Quarashi",
              symbol: "QUA",
              address: "0xd35c06a2781f648c75290976ecF71E71582188B7",
              price: 0.00002271,
            },
            {
              chainId: "1",
              name: "Suterusu",
              symbol: "SUTER",
              address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
              price: 0.00002117,
            },
            {
              chainId: "1",
              name: "Seele",
              symbol: "SEELE",
              address: "0xb1e93236ab6073fdac58ada5564897177d4bcc43",
              price: 0.0000191,
            },
            {
              chainId: "1",
              name: "Old Bitcoin",
              symbol: "BC",
              address: "0xe03B2642A5111aD0EFc0cbCe766498c2dd562Ae9",
              price: 0.00001681,
            },
            {
              chainId: "1",
              name: "SHIBA INU",
              symbol: "SHIB",
              address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
              price: 0.00001514,
            },
            {
              chainId: "1",
              name: "COVA",
              symbol: "COVA",
              address: "0xb37a769b37224449d92aac57de379e1267cd3b00",
              price: 0.00001469,
            },
            {
              chainId: "1",
              name: "Frontrow",
              symbol: "FRR",
              address: "0xe6602b34d8510b033e000975b3322537c7172441",
              price: 0.00001434,
            },
            {
              chainId: "1",
              name: "BOB",
              symbol: "BOB",
              address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
              price: 0.00001366,
            },
            {
              chainId: "1",
              name: "Pepe",
              symbol: "PEPE",
              address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
              price: 0.00001345,
            },
            {
              chainId: "1",
              name: "Cryptomeda",
              symbol: "TECH",
              address: "0x6286A9e6f7e745A6D884561D88F94542d6715698",
              price: 0.0000127,
            },
            {
              chainId: "1",
              name: "Mongol NFT",
              symbol: "MNFT",
              address: "0x3235B13708F178Af6F110dE7177ED5De10c1093d",
              price: 0.00001181,
            },
            {
              chainId: "1",
              name: "TomTomCoin",
              symbol: "TOMS",
              address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
              price: 0.00001099,
            },
            {
              chainId: "1",
              name: "NPICK BLOCK",
              symbol: "NPICK",
              address: "0xc3dca8f61b275d1e88f3ea31b3e311c49f56b24b",
              price: 0.00001096,
            },
            {
              chainId: "1",
              name: "TrueFeedBack",
              symbol: "TFBX",
              address: "0x4057db5bd9f67a566aa10e5587b1a964affc6a16",
              price: 0.00001061,
            },
            {
              chainId: "1",
              name: "Musk Dao",
              symbol: "MUSK",
              address: "0x719e7f0daDFdeA25B78595da944F44d15d7E6795",
              price: 0.00001054,
            },
            {
              chainId: "1",
              name: "McPepe's",
              symbol: "PEPES",
              address: "0x6bf765c43030387a983f429c1438e9d2025b7e12",
              price: 0.00001005,
            },
            {
              chainId: "1",
              name: "Every Game",
              symbol: "EGAME",
              address: "0x62d3c05b9c3d916fbc111819bbd3cee52906c1ae",
              price: 0.00001004,
            },
            {
              chainId: "1",
              name: "Centaurify",
              symbol: "CENT",
              address: "0x08ba718f288c3b12b01146816bef9fa03cc635bc",
              price: 0.00001,
            },
            {
              chainId: "1",
              name: "The Midas Touch Gold",
              symbol: "TMTG",
              address: "0x10086399DD8c1e3De736724AF52587a2044c9fA2",
              price: 0.00000999,
            },
            {
              chainId: "1",
              name: "AXL INU",
              symbol: "AXL",
              address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
              price: 0.00000988,
            },
            {
              chainId: "1",
              name: "MiraQle",
              symbol: "MQL",
              address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
              price: 0.0000093,
            },
            {
              chainId: "1",
              name: "Vidy",
              symbol: "VIDY",
              address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
              price: 0.00000873,
            },
            {
              chainId: "1",
              name: "XMax",
              symbol: "XMX",
              address: "0x0f8c45b896784a1e408526b9300519ef8660209c",
              price: 0.00000823,
            },
            {
              chainId: "1",
              name: "Silent Notary",
              symbol: "UBSN",
              address: "0x86EFc496DcA70bcFD92D19194290e8457a375773",
              price: 0.0000077,
            },
            {
              chainId: "1",
              name: "SRT",
              symbol: "SRT",
              address: "0x22987407FD1fC5A971e3FDA3B3e74C88666cDa91",
              price: 0.00000766,
            },
            {
              chainId: "1",
              name: "Jigstack",
              symbol: "STAK",
              address: "0x1f8a626883d7724dbd59ef51cbd4bf1cf2016d13",
              price: 0.00000761,
            },
            {
              chainId: "1",
              name: "SHARBI",
              symbol: "SHARBI",
              address: "0xf3a3023e6dede84ad88a656a3269f2a36e83c9a9",
              price: 0.00000616,
            },
            {
              chainId: "42161",
              name: "SHARBI",
              symbol: "SHARBI",
              address: "0xaa54e84A3e6e5A80288d2C2f8e36eA5cA3A3Ca30",
              price: 0.0000058,
            },
            {
              chainId: "1",
              name: "Hashgard",
              symbol: "GARD",
              address: "0x5c64031c62061865e5fd0f53d3cdaef80f72e99d",
              price: 0.00000503,
            },
            {
              chainId: "1",
              name: "AiWork ",
              symbol: "AWO",
              address: "0x68c85b9f78f30a0df5ac5723e4e700037f185415",
              price: 0.00000491,
            },
            {
              chainId: "1",
              name: "Hasaki",
              symbol: "HAHA",
              address: "0xd87D72248093597df8D56d2a53C1ab7c1A0Cc8DA",
              price: 0.00000475,
            },
            {
              chainId: "1",
              name: "Global Digital Content",
              symbol: "GDC",
              address: "0x301C755bA0fcA00B1923768Fffb3Df7f4E63aF31",
              price: 0.00000445,
            },
            {
              chainId: "1",
              name: "POP Network",
              symbol: "POP",
              address: "0x5d858bcd53e085920620549214a8b27ce2f04670",
              price: 0.00000429,
            },
            {
              chainId: "1",
              name: "Giftedhands",
              symbol: "GHD",
              address: "0x3b544e6fcf6c8dce9d8b45a4fdf21c9b02f9fda9",
              price: 0.00000397,
            },
            {
              chainId: "1",
              name: "Zipper",
              symbol: "ZIP",
              address: "0xa9d2927d3a04309e008b6af6e2e282ae2952e7fd",
              price: 0.0000037,
            },
            {
              chainId: "1",
              name: "D Community",
              symbol: "DILI",
              address: "0x37f74e99794853777a10ea1dc08a64c86958f06a",
              price: 0.00000355,
            },
            {
              chainId: "1",
              name: "MEMEME",
              symbol: "MEMEME",
              address: "0x1a963df363d01eebb2816b366d61c917f20e1ebe",
              price: 0.00000296,
            },
            {
              chainId: "1",
              name: "TwitFi",
              symbol: "TWT",
              address: "0xd4Df22556e07148e591B4c7b4f555a17188CF5cF",
              price: 0.00000259,
            },
            {
              chainId: "1",
              name: "Soulsaver",
              symbol: "SOUL",
              address: "0x992D339532A9C42F1b0E59A57e95F38da38c66F6",
              price: 0.00000239,
            },
            {
              chainId: "1",
              name: "FourCoin",
              symbol: "FOUR",
              address: "0x244b797d622d4dee8b188b03546acaabd0cf91a0",
              price: 0.00000207,
            },
            {
              chainId: "1",
              name: "Red Token",
              symbol: "RED",
              address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
              price: 0.00000179,
            },
            {
              chainId: "1",
              name: "Kiba Inu",
              symbol: "KIBA",
              address: "0x005D1123878Fc55fbd56b54C73963b234a64af3c",
              price: 0.00000168,
            },
            {
              chainId: "1",
              name: "Moon Rabbit",
              symbol: "AAA",
              address: "0x8c6bf16c273636523c29db7db04396143770f6a0",
              price: 0.0000015,
            },
            {
              chainId: "1",
              name: "VKT",
              symbol: "VKT",
              address: "0xcab7ffC5a5759AB8C4F9a366F33A032BdAc28aC1",
              price: 0.00000129,
            },
            {
              chainId: "1",
              name: "Cult DAO",
              symbol: "CULT",
              address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
              price: 0.00000126,
            },
            {
              chainId: "1",
              name: "MixTrust",
              symbol: "MXT",
              address: "0x6251e725cd45fb1af99354035a414a2c0890b929",
              price: 0.00000107,
            },
            {
              chainId: "1",
              name: "Incube Chain",
              symbol: "ICB",
              address: "0x00166a5b93FD4f87ecA1c267d31D82dF3f133a7F",
              price: 0.00000103,
            },
            {
              chainId: "1",
              name: "CareCoin",
              symbol: "CARE",
              address: "0x329cf160F30D21006bCD24b67EAde561E54CDE4c",
              price: 0.000001,
            },
            {
              chainId: "1",
              name: "SPGBB",
              symbol: "SPGBB",
              address: "0x64551fA4093c2D6c298cf1792740F884084a8F69",
              price: 9.62942e-7,
            },
            {
              chainId: "1",
              name: "PawZone",
              symbol: "PAW",
              address: "0x1AA51bc7eb181ce48CE626Bf62f8956Fa9555136",
              price: 9.45328e-7,
            },
            {
              chainId: "1",
              name: "The Youth Pay",
              symbol: "TYP",
              address: "0xb46eda6219ba121cE9280388e7afb7dc84be3fF2",
              price: 8.10131e-7,
            },
            {
              chainId: "1",
              name: "StarLink",
              symbol: "STARL",
              address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
              price: 7.98843e-7,
            },
            {
              chainId: "1",
              name: "PREMA",
              symbol: "PRMX",
              address: "0xe4dae00bc1c46ea2F44ae71B1BEb8b171C15d812",
              price: 6.08679e-7,
            },
            {
              chainId: "1",
              name: "ordinex",
              symbol: "ORD",
              address: "0xbe00734799a67a62af2819825580318ac1b1e4ec",
              price: 5.71202e-7,
            },
            {
              chainId: "1",
              name: "5KM RUN",
              symbol: "RUN",
              address: "0x5f4c148d17effd165c2e2d46b46d2bd6e3ebdc3e",
              price: 5.30733e-7,
            },
            {
              chainId: "1",
              name: "ASKO",
              symbol: "ASKO",
              address: "0xeEEE2a622330E6d2036691e983DEe87330588603",
              price: 5.06195e-7,
            },
            {
              chainId: "1",
              name: "Gas DAO",
              symbol: "GAS",
              address: "0x6bba316c48b49bd1eac44573c5c871ff02958469",
              price: 4.73063e-7,
            },
            {
              chainId: "1",
              name: "Nothing",
              symbol: "THING",
              address: "0xffd822149fa6749176c7a1424e71a417f26189c8",
              price: 4.67942e-7,
            },
            {
              chainId: "1",
              name: "Metanept",
              symbol: "NEPT",
              address: "0x355a824bea1adc22733978a3748271e1bbb34130",
              price: 4.49685e-7,
            },
            {
              chainId: "1",
              name: "Clips",
              symbol: "CLIPS",
              address: "0xecbee2fae67709f718426ddc3bf770b26b95ed20",
              price: 3.73805e-7,
            },
            {
              chainId: "1",
              name: "Laika",
              symbol: "LAIKA",
              address: "0x77f9CF0bd8C500CfFdF420e72343893aeCC2EC0b",
              price: 3.10944e-7,
            },
            {
              chainId: "1",
              name: "Volt Inu",
              symbol: "VOLT",
              address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
              price: 3.02761e-7,
            },
            {
              chainId: "1",
              name: "Patrick",
              symbol: "PAT",
              address: "0xdd78B3E430361560A70B9CBB7d98d961f0428b61",
              price: 2.82219e-7,
            },
            {
              chainId: "1",
              name: "Dogelon Mars",
              symbol: "ELON",
              address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
              price: 2.4413e-7,
            },
            {
              chainId: "1",
              name: "UFO Gaming",
              symbol: "UFO",
              address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
              price: 2.36911e-7,
            },
            {
              chainId: "1",
              name: "Shita-kiri Suzume",
              symbol: "SUZUME",
              address: "0x0b452278223d3954f4ac050949d7998e373e7e43",
              price: 2.0934e-7,
            },
            {
              chainId: "1",
              name: "The Rug Game",
              symbol: "TRG",
              address: "0x93eEB426782BD88fCD4B48D7b0368CF061044928",
              price: 1.66619e-7,
            },
            {
              chainId: "1",
              name: "FREEdom Coin",
              symbol: "FREE",
              address: "0x2F141Ce366a2462f02cEA3D12CF93E4DCa49e4Fd",
              price: 1.38588e-7,
            },
            {
              chainId: "1",
              name: "P Pizza",
              symbol: "PPIZZA",
              address: "0xab306326bC72c2335Bd08F42cbec383691eF8446",
              price: 1.35035e-7,
            },
            {
              chainId: "1",
              name: "Akita Inu",
              symbol: "AKITA",
              address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
              price: 8.8739e-8,
            },
            {
              chainId: "1",
              name: "Vinlink",
              symbol: "VNLNK",
              address: "0x0f1e49d6dcfc9eefcce9d5ae3c660f8ead75061a",
              price: 8.6647e-8,
            },
            {
              chainId: "1",
              name: "XEN Crypto",
              symbol: "XEN",
              address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
              price: 7.29e-8,
            },
            {
              chainId: "1",
              name: "RUGame",
              symbol: "RUG",
              address: "0xDD782657af86492771BdB369CaEB8c246bE362f5",
              price: 7.0945e-8,
            },
            {
              chainId: "1",
              name: "Milady Meme Coin",
              symbol: "LADYS",
              address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
              price: 6.316e-8,
            },
            {
              chainId: "1",
              name: "TORG",
              symbol: "TORG",
              address: "0xcfa0885131f602d11d4da248d2c65a62063567a9",
              price: 5.6788e-8,
            },
            {
              chainId: "1",
              name: "Pancake Games",
              symbol: "GCAKE",
              address: "0x5f944b0c4315cb7c3a846b025ab4045da44abf6c",
              price: 4.9573e-8,
            },
            {
              chainId: "1",
              name: "A Hunters Dream",
              symbol: "CAW",
              address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
              price: 4.5523e-8,
            },
            {
              chainId: "1",
              name: "First Ever NFT",
              symbol: "FEN",
              address: "0x995a6c0944322b7285d0712824acf0cf9bf3993a",
              price: 3.2543e-8,
            },
            {
              chainId: "1",
              name: "Meta MVRS",
              symbol: "MVRS",
              address: "0xBEDE1F59Fa4412556fEF69f1B9969F2003E3f8c1",
              price: 2.2978e-8,
            },
            {
              chainId: "1",
              name: "Die Protocol",
              symbol: "DIE",
              address: "0x6ef6610d24593805144d73b13d4405e00a4e4ac7",
              price: 1.6031e-8,
            },
            {
              chainId: "1",
              name: "Pawswap",
              symbol: "PAW",
              address: "0xdc63269ea166b70d4780b3a11f5c825c2b761b01",
              price: 1.0468e-8,
            },
            {
              chainId: "1",
              name: "POOH",
              symbol: "POOH",
              address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
              price: 1.0227e-8,
            },
            {
              chainId: "1",
              name: "OpenDAO",
              symbol: "SOS",
              address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
              price: 9.065e-9,
            },
            {
              chainId: "1",
              name: "PEEPO",
              symbol: "PEEPO",
              address: "0xaADA04204e9e1099DaF67cf3D5D137E84E41CF41",
              price: 7.817e-9,
            },
            {
              chainId: "1",
              name: "Troll",
              symbol: "TROLL",
              address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
              price: 7.575e-9,
            },
            {
              chainId: "1",
              name: "MongCoin",
              symbol: "$MONG",
              address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
              price: 6.846e-9,
            },
            {
              chainId: "1",
              name: "WALL STREET BABY",
              symbol: "WSB",
              address: "0x15F20f9DFDf96CCf6AC96653b7C0aBfe4A9C9f0f",
              price: 6.511e-9,
            },
            {
              chainId: "1",
              name: "Shiba Predator",
              symbol: "QOM",
              address: "0xa71d0588eaf47f12b13cf8ec750430d21df04974",
              price: 3.923e-9,
            },
            {
              chainId: "1",
              name: "GroupDao",
              symbol: "GDO",
              address: "0x16f78145ad0b9af58747e9a97ebd99175378bd3d",
              price: 3.72e-9,
            },
            {
              chainId: "1",
              name: "RushCoin",
              symbol: "RUSH",
              address: "0x382A1667C9062F0621362F49076Ef6e4fE4C9eC7",
              price: 3.602e-9,
            },
            {
              chainId: "1",
              name: "Shib Original Vision",
              symbol: "SOV",
              address: "0x2c5bc2ba3614fd27fcc7022ea71d9172e2632c16",
              price: 2.836e-9,
            },
            {
              chainId: "1",
              name: "Cogecoin",
              symbol: "COGE",
              address: "0xc382e04099a435439725bb40647e2b32dc136806",
              price: 2.466e-9,
            },
            {
              chainId: "1",
              name: "I will poop it NFT",
              symbol: "SHIT",
              address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
              price: 1.538e-9,
            },
            {
              chainId: "1",
              name: "Ribbit",
              symbol: "RIBBIT",
              address: "0xb794ad95317f75c44090f64955954c3849315ffe",
              price: 1.476e-9,
            },
            {
              chainId: "1",
              name: "Ben",
              symbol: "BEN",
              address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
              price: 1.157e-9,
            },
            {
              chainId: "1",
              name: "NFTDAO",
              symbol: "NAO",
              address: "0xd049206fb408a611e543791f2d8f102a8bc253dc",
              price: 4.10326e-10,
            },
            {
              chainId: "1",
              name: "EthereumMax",
              symbol: "EMAX",
              address: "0x15874d65e649880c2614e7a480cb7c9a55787ff6",
              price: 3.72568e-10,
            },
            {
              chainId: "1",
              name: "Kishu Inu",
              symbol: "KISHU",
              address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
              price: 3.12047e-10,
            },
            {
              chainId: "1",
              name: "Bear Inu",
              symbol: "BEAR",
              address: "0x17837004ea685690b32dbead02a274ec4333a26a",
              price: 1.83143e-10,
            },
            {
              chainId: "1",
              name: "FEG token",
              symbol: "FEG",
              address: "0x389999216860ab8e0175387a0c90e5c52522c945",
              price: 9.0222e-11,
            },
            {
              chainId: "1",
              name: "TigerCoin",
              symbol: "TIGER",
              address: "0xB83c27805aAcA5C7082eB45C868d955Cf04C337F",
              price: 5.6329e-11,
            },
            {
              chainId: "1",
              name: "Bezoge Earth",
              symbol: "BEZOGE",
              address: "0xdc349913d53b446485e98b76800b6254f43df695",
              price: 1.0045e-11,
            },
            {
              chainId: "1",
              name: "Homer",
              symbol: "SIMPSON",
              address: "0x44aAd22aFbB2606d7828Ca1f8f9E5af00e779AE1",
              price: 1.68e-12,
            },
            {
              chainId: "1",
              name: "Shiryo",
              symbol: "SHIRYO-INU",
              address: "0x1E2F15302B90EddE696593607b6bD444B64e8F02",
              price: 4.95996e-13,
            },
          ],
        },
        chainIds: [1, 10, 137, 42161, 56],
        cexLabels: ["Unknown"],
        tags: [
          {
            _id: "666bfc4a85672a7368da18ec",
            value: "livepeer",
            color: "#BBFDA4",
          },
          {
            _id: "666c001d85672a7368dac150",
            value: "Aethir",
            color: "#C2F0B6",
          },
          {
            _id: "66701deae46eaf2674e9ac4e",
            value: "AAVE",
            color: "#FDA19B",
          },
        ],
        source: {
          type: "contract",
        },
        lastEngagement: {
          date: "2024-06-17T11:28:54.078Z",
          type: "contractImport",
        },
      },
    ],
  },
  tickets: {
    tickets: [
      {
        _id: "66c81c113fca890388d73799",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        isAiChat: true,
        entity: "66c8189a5fb810015d64d11e",
        userWallet: {
          _id: "66c81e7b592cb9a4e42aef4c",
          address: "0x175fd9b68973c4b2a5f371909FB624b0aEb88Cc5",
        },
        user: "66c81e7b592cb9a4e42aef5c",
        type: {
          _id: "66c81c4c592cb9a4e42991eb",
          name: "dLP & Locking",
        },
        title: "I cannot withdraw my USDT",
        description:
          "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
        status: "New",
        hasNewMessage: true,
        created: "2024-12-19T15:32:00.548Z",
        __v: 0,
        source: "widget",
        ongoingTime: null,
        widgetConfig: {
          _id: "66c81a6b5fb810015d68acaa",
          name: "dApp Widget",
        },
        sourceName: "dApp Widget",
      },
      {
        _id: "66c81c113fca890388d73798",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        userWallet: {
          _id: "66c81e7b592cb9a4e42aef4c",
          address: "0x175fd9b68973c4b2a5f371909FB624b0aEb88Cc5",
        },
        user: "66c81e7b592cb9a4e42aef5c",
        type: {
          _id: "66c81c4c592cb9a4e42991da",
          name: "General Help",
        },
        title: "I want to become a mod for Radiant Capital",
        description: "Do you have any job opening??",
        status: "Done",
        hasNewMessage: false,
        created: "2024-12-19T15:31:42.537Z",
        __v: 0,
        team: {
          _id: "65807639f8cb06835c94a856",
          address: "0x9Ec346743B1db8729B590c27df61Df796C0E3254",
          entity: "65807639e63d945efa37a621",
          __v: 0,
          created: "2023-12-18T16:41:29.859Z",
          email: null,
          name: "MetaCRM Operation",
          role: "65dc742107682dc82c77a925",
          internal: true,
          latestLogin: "2024-11-01T06:29:17.245Z",
          telegram: "",
        },
        source: "dApp Widget",
        manualCloseDate: "2023-12-19T15:31:44.138Z",
        source: "widget",
        ongoingTime: null,
        widgetConfig: {
          _id: "66c81a6b5fb810015d68acaa",
          name: "dApp Widget",
        },
        sourceName: "dApp Widget",
      },
      {
        _id: "66c81c113fca890388d73797",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        userWallet: {
          _id: "66c81f15592cb9a4e42bb568",
          address: "0xdC1CAD9195f5EC858E9A00a62a454A53AB9eEF51",
        },
        user: "66c81f15592cb9a4e42bb576",
        type: {
          _id: "66c81c4c592cb9a4e42991eb",
          name: "dLP & Locking",
        },
        title: "I want to become a mod for Radiant Capital",
        description: "Do you have any job opening??",
        status: "Done",
        hasNewMessage: false,
        created: "2023-12-19T15:06:22.082Z",
        __v: 0,
        team: {
          _id: "65807639f8cb06835c94a856",
          address: "0x9Ec346743B1db8729B590c27df61Df796C0E3254",
          entity: "65807639e63d945efa37a621",
          __v: 0,
          created: "2023-12-18T16:41:29.859Z",
          email: null,
          name: "MetaCRM Operation",
          role: "65dc742107682dc82c77a925",
          internal: true,
          latestLogin: "2024-11-01T06:29:17.245Z",
          telegram: "",
        },
        source: "dApp Widget",
        manualCloseDate: "2023-12-19T15:06:23.546Z",
        ongoingTime: null,
        source: "widget",
        ongoingTime: null,
        widgetConfig: {
          _id: "66c81a6b5fb810015d68acaa",
          name: "dApp Widget",
        },
        sourceName: "dApp Widget",
      },
      {
        _id: "66c81c113fca890388d73796",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        userWallet: {
          _id: "66c81f15592cb9a4e42bb568",
          address: "0xdC1CAD9195f5EC858E9A00a62a454A53AB9eEF51",
        },
        user: "66c81f15592cb9a4e42bb576",
        type: {
          _id: "66c81c4c592cb9a4e42991da",
          name: "General Help",
        },
        title: "I cannot withdraw my USDT",
        description:
          "Hello, I tried to withdraw my USDT, but it shows error. Could you help me?",
        status: "Done",
        hasNewMessage: true,
        created: "2023-12-19T15:05:18.021Z",
        __v: 0,
        source: "supportCenter",
        manualCloseDate: "2023-12-19T15:05:20.948Z",
        ongoingTime: null,
        source: "widget",
        ongoingTime: null,
        widgetConfig: {
          _id: "66c81a6b5fb810015d68acaa",
          name: "dApp Widget",
        },
        sourceName: "dApp Widget",
      },
      {
        _id: "66c81c113fca890388d73790",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        title: "Withdrawing DLP and breaking up the assets",
        user: "66c81e7b592cb9a4e42aef30",
        userWallet: {
          _id: "66c81e7b592cb9a4e42aef23",
          address: "0x35C37AA99f9D95D96F700Af9Cfa20AEE8bC17178",
        },
        __v: 0,
        comment: "This is def an OG!",
        created: "2023-06-27T16:56:04.221Z",
        description:
          "Hi, I have some tokens locked in RDNT - WETH dlp at the moment. How do I redeem the assets and withdraw from Radiant Capital",
        hasNewMessage: false,
        status: "New",
        type: {
          _id: "66c81c4c592cb9a4e42991eb",
          name: "dLP & Locking",
        },
        source: "widget",
        ongoingTime: null,
        widgetConfig: {
          _id: "66c81a6b5fb810015d68acaa",
          name: "dApp Widget",
        },
        sourceName: "dApp Widget",
      },
      {
        _id: "66c81c113fca890388d73794",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        title: "Hi I'm a newbie",
        user: "66c81e7b592cb9a4e42aeef1",
        userWallet: {
          _id: "66c81e7b592cb9a4e42aeee0",
          address: "0xeee70fc4F25CD24e17e6664dD93C725A5aE6Aa58",
        },
        __v: 0,
        created: "2023-04-13T05:49:12.436Z",
        description: "Please teach me how to use this protocol",
        status: "New",
        type: {
          _id: "66c81c4c592cb9a4e42991da",
          name: "General Help",
        },
        source: "discord",
        ongoingTime: null,
        sourceName: null,
      },
      {
        _id: "66c81c113fca890388d73795",
        lastUserResponse: "2024-12-28T08:47:51.964Z",
        tagTeam: [],
        tags: [],
        isSurveySent: false,
        entity: "66c8189a5fb810015d64d11e",
        title: "Hi From Telegram",
        user: "66c81e7b592cb9a4e42aeef1",
        userWallet: {
          _id: "66c81e7b592cb9a4e42aeee0",
          address: "0xeee70fc4F25CD24e17e6664dD93C725A5aE6Aa58",
        },
        __v: 0,
        created: "2023-04-13T05:49:12.436Z",
        description: "Please teach me how to use this protocol",
        status: "New",
        type: {
          _id: "66c81c4c592cb9a4e42991da",
          name: "General Help",
        },
        source: "telegram",
        ongoingTime: null,
        sourceName: null,
      },
    ],
    user: {
      source: {
        _id: "6475bb169565b6c7ef71a097",
        type: "metadesk",
        date: "2024-11-22T03:18:01.573Z",
      },
      lastEngagement: {
        type: "ticketChat",
        date: "2024-11-22T03:18:14.038Z",
      },
      addresses: [],
      discordIDs: [
        {
          _id: "64c86ef1f27224537922e3c7",
          handle: "felixtang",
        },
      ],
      twitterIDs: [],
      telegramIDs: [],
      tags: [
        {
          _id: "658d37107d7a9c632bba0fa5",
          entity: "63846af6f5b5c78186e0ae77",
          type: "user",
          value: "new",
          color: "#C2F0B6",
          __v: 0,
        },
      ],
      importedCsvFields: [],
      importedSmartContracts: [],
      sources: ["6475bb169565b6c7ef71a097", "6585269624dd3a7cd3fb6fbd"],
      importedFields: [],
      protocols: [],
      _id: "64c86ef1f27224537922e3d4",
      __v: 3,
      created: "2023-08-01T02:33:21.522Z",
      updated: "2023-12-28T08:51:52.055Z",
      mostRecentDiscordID: "64c86ef1f27224537922e3c7",
      previousTags: [],
      entity: "63846af6f5b5c78186e0ae77",
    },
    groups: [],
    avgScoring: 4.5,
  },
  reports: {
    userCount: 9629,
    walletCount: 7713,
    walletValue: 105161189623.78937,
    chainPortfolio: [
      {
        id: "1",
        name: "Ethereum",
        value: 5038,
      },
      {
        id: "42161",
        name: "Arbitrum",
        value: 2754,
      },
      {
        id: "56",
        name: "BNB Chain",
        value: 1122,
      },
      {
        id: "137",
        name: "Polygon",
        value: 897,
      },
      {
        id: "10",
        name: "Optimism",
        value: 726,
      },
      {
        id: "5000",
        name: "Mantle",
        value: 75,
      },
      {
        id: "169",
        name: "Manta",
        value: 9,
      },
      {
        id: "81457",
        name: "Blast",
        value: 8,
      },
      {
        id: "1284",
        name: "Moonbeam",
        value: 7,
      },
      {
        id: "8453",
        name: "Base",
        value: 4,
      },
      {
        id: "8217",
        name: "Kaia",
        value: 3,
      },
      {
        id: "59144",
        name: "Linea",
        value: 3,
      },
      {
        id: "4200",
        name: "Merlin",
        value: 2,
      },
      {
        id: "534352",
        name: "Scroll",
        value: 2,
      },
      {
        id: "204",
        name: "opBNB",
        value: 2,
      },
      {
        id: "200901",
        name: "Bitlayer",
        value: 1,
      },
      {
        id: "1946",
        name: "1946",
        value: 1,
      },
      {
        id: "100",
        name: "Gnosis Chain",
        value: 1,
      },
      {
        id: "1329",
        name: "Sei",
        value: 1,
      },
      {
        id: "25",
        name: "Cronos",
        value: 1,
      },
      {
        id: "1088",
        name: "Metis",
        value: 1,
      },
      {
        id: "1116",
        name: "CORE",
        value: 1,
      },
      {
        id: "324",
        name: "zkSync",
        value: 1,
      },
    ],
    tokenHoldings: [
      {
        id: "1",
        name: "ETH",
        value: 4639,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 14161541905.31057,
      },
      {
        id: "42161",
        name: "ETH",
        value: 2377,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 1838518299.164234,
      },
      {
        id: "42161",
        name: "ARB",
        value: 2024,
        tokenType: "alt",
        address: "0x912ce59144191c1204e64559fe8253a0e49e6548",
        icon: null,
        usdValue: 4855976039.8055525,
      },
      {
        id: "56",
        name: "BNB",
        value: 1242,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 312037978.77212036,
      },
      {
        id: "137",
        name: "MATIC",
        value: 932,
        tokenType: "native",
        address: "0x0000000000000000000000000000000000001010",
        icon: null,
        usdValue: 113887937.1696429,
      },
      {
        id: "56",
        name: "ANY",
        value: 838,
        tokenType: "alt",
        address: "0xf68c9df95a18b2a5a5fa1124d79eeeffbad0b6fa",
        icon: null,
        usdValue: 23999.47483365724,
      },
      {
        id: "1",
        name: "USDC",
        value: 815,
        tokenType: "stable",
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        icon: null,
        usdValue: 5040364835.9688225,
      },
      {
        id: "1",
        name: "USDT",
        value: 786,
        tokenType: "stable",
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        icon: null,
        usdValue: 24423408293.703007,
      },
      {
        id: "1",
        name: "LINK",
        value: 536,
        tokenType: "alt",
        address: "0x514910771af9ca656af840dff83e8264ecf986ca",
        icon: null,
        usdValue: 2871869462.1428003,
      },
      {
        id: "1",
        name: "WETH",
        value: 513,
        tokenType: "alt",
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        icon: null,
        usdValue: 60719813.08853398,
      },
      {
        id: "1",
        name: "UNI",
        value: 498,
        tokenType: "alt",
        address: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984",
        icon: null,
        usdValue: 1004871762.1922507,
      },
      {
        id: "10",
        name: "op",
        value: 442,
        tokenType: "alt",
        address: "0x4200000000000000000000000000000000000042",
        icon: null,
        usdValue: 414024474.64021826,
      },
      {
        id: "1",
        name: "CRV",
        value: 425,
        tokenType: "alt",
        address: "0xd533a949740bb3306d119cc777fa900ba034cd52",
        icon: null,
        usdValue: 526902750.94525415,
      },
      {
        id: "1",
        name: "MATIC",
        value: 394,
        tokenType: "alt",
        address: "0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0",
        icon: null,
        usdValue: 357902064.264723,
      },
      {
        id: "42161",
        name: "USDT",
        value: 390,
        tokenType: "stable",
        address: "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9",
        icon: null,
        usdValue: 2012062226.193504,
      },
      {
        id: "1",
        name: "LDO",
        value: 390,
        tokenType: "alt",
        address: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
        icon: null,
        usdValue: 541554581.1423149,
      },
      {
        id: "1",
        name: "AAVE",
        value: 390,
        tokenType: "alt",
        address: "0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9",
        icon: null,
        usdValue: 1240081716.4664962,
      },
      {
        id: "1",
        name: "COMP",
        value: 373,
        tokenType: "alt",
        address: "0xc00e94cb662c3520282e6f5717214004a7f26888",
        icon: null,
        usdValue: 192881977.03520513,
      },
      {
        id: "1",
        name: "SHIB",
        value: 373,
        tokenType: "alt",
        address: "0x95ad61b0a150d79219dcf64e1e6cc01f0b64c4ce",
        icon: null,
        usdValue: 3046664542.3002763,
      },
      {
        id: "1",
        name: "LPT",
        value: 367,
        tokenType: "alt",
        address: "0x58b6a8a3302369daec383334672404ee733ab239",
        icon: null,
        usdValue: 157776448.2751794,
      },
      {
        id: "1",
        name: "DAI",
        value: 366,
        tokenType: "stable",
        address: "0x6b175474e89094c44da98b954eedeac495271d0f",
        icon: null,
        usdValue: 77710172.49769531,
      },
      {
        id: "1",
        name: "APE",
        value: 366,
        tokenType: "alt",
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        icon: null,
        usdValue: 384907933.09665656,
      },
      {
        id: "1",
        name: "GRT",
        value: 364,
        tokenType: "alt",
        address: "0xc944e90c64b2c07662a292be6244bdf05cda44a7",
        icon: null,
        usdValue: 381111211.64569086,
      },
      {
        id: "1",
        name: "PEPE",
        value: 363,
        tokenType: "alt",
        address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
        icon: null,
        usdValue: 3674428755.4309635,
      },
      {
        id: "1",
        name: "IMX",
        value: 361,
        tokenType: "alt",
        address: "0x7b35ce522cb72e4077baeb96cb923a5529764a00",
        icon: null,
        usdValue: 275859479.1171305,
      },
      {
        id: "1",
        name: "DYDX",
        value: 354,
        tokenType: "alt",
        address: "0x92d6c1e31e14520e676a687f0a93788b716beff5",
        icon: null,
        usdValue: 306014154.36253726,
      },
      {
        id: "56",
        name: "USDT",
        value: 349,
        tokenType: "stable",
        address: "0x55d398326f99059ff775485246999027b3197955",
        icon: null,
        usdValue: 770261624.0858494,
      },
      {
        id: "42161",
        name: "USDC",
        value: 345,
        tokenType: "stable",
        address: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
        icon: null,
        usdValue: 116587206.82756086,
      },
      {
        id: "1",
        name: "SUSHI",
        value: 343,
        tokenType: "alt",
        address: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
        icon: null,
        usdValue: 230721262.9401027,
      },
      {
        id: "1",
        name: "MKR",
        value: 342,
        tokenType: "alt",
        address: "0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2",
        icon: null,
        usdValue: 490980216.60666955,
      },
      {
        id: "42161",
        name: "WETH",
        value: 342,
        tokenType: "alt",
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        icon: null,
        usdValue: 77417725.28705095,
      },
      {
        id: "1",
        name: "SNX",
        value: 340,
        tokenType: "alt",
        address: "0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f",
        icon: null,
        usdValue: 171542260.53177422,
      },
      {
        id: "1",
        name: "MANA",
        value: 340,
        tokenType: "alt",
        address: "0x0f5d2fb29fb7d3cfee444a200298f468908cc942",
        icon: null,
        usdValue: 270900803.1716628,
      },
      {
        id: "1",
        name: "ENS",
        value: 328,
        tokenType: "alt",
        address: "0xc18360217d8f7ab5e7c516566761ea12ce7f9d72",
        icon: null,
        usdValue: 777655888.8702797,
      },
      {
        id: "1",
        name: "1INCH",
        value: 326,
        tokenType: "alt",
        address: "0x111111111117dc0aa78b770fa6a738034120c302",
        icon: null,
        usdValue: 193347704.35149494,
      },
      {
        id: "1",
        name: "SAND",
        value: 323,
        tokenType: "alt",
        address: "0x3845badade8e6dff049820680d1f14bd3903a5d0",
        icon: null,
        usdValue: 627214338.487092,
      },
      {
        id: "1",
        name: "WBTC",
        value: 318,
        tokenType: "alt",
        address: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
        icon: null,
        usdValue: 1288519330.8548408,
      },
      {
        id: "1",
        name: "RNDR",
        value: 310,
        tokenType: "alt",
        address: "0x6de037ef9ad2725eb40118bb1702ebb27e4aeb24",
        icon: null,
        usdValue: 431662375.2028835,
      },
      {
        id: "1",
        name: "LRC",
        value: 295,
        tokenType: "alt",
        address: "0xbbbbca6a901c926f240b89eacb641d8aec7aeafd",
        icon: null,
        usdValue: 115314992.79876547,
      },
      {
        id: "1",
        name: "AXS",
        value: 288,
        tokenType: "alt",
        address: "0xbb0e17ef65f82ab018d8edd776e8dd940327b28b",
        icon: null,
        usdValue: 103977821.52772465,
      },
      {
        id: "1",
        name: "BLUR",
        value: 287,
        tokenType: "alt",
        address: "0x5283d291dbcf85356a21ba090e6db59121208b44",
        icon: null,
        usdValue: 228428677.72657034,
      },
      {
        id: "1",
        name: "FET",
        value: 286,
        tokenType: "alt",
        address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
        icon: null,
        usdValue: 968093335.5212995,
      },
      {
        id: "1",
        name: "YFI",
        value: 285,
        tokenType: "alt",
        address: "0x0bc529c00c6401aef6d220be8c6ea1667f6ad93e",
        icon: null,
        usdValue: 124002755.09353656,
      },
      {
        id: "1",
        name: "ZRX",
        value: 282,
        tokenType: "alt",
        address: "0xe41d2489571d322189246dafa5ebde1f4699f498",
        icon: null,
        usdValue: 88008153.17085807,
      },
      {
        id: "1",
        name: "QNT",
        value: 278,
        tokenType: "alt",
        address: "0x4a220e6096b25eadb88358cb44068a3248254675",
        icon: null,
        usdValue: 301177227.3211193,
      },
      {
        id: "1",
        name: "CHZ",
        value: 278,
        tokenType: "alt",
        address: "0x3506424f91fd33084466f402d5d97f05f8e3b4af",
        icon: null,
        usdValue: 161948115.52320844,
      },
      {
        id: "1",
        name: "BAT",
        value: 276,
        tokenType: "alt",
        address: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
        icon: null,
        usdValue: 102749209.97994646,
      },
      {
        id: "1",
        name: "CVX",
        value: 265,
        tokenType: "alt",
        address: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
        icon: null,
        usdValue: 92276187.07402456,
      },
      {
        id: "1",
        name: "PENDLE",
        value: 265,
        tokenType: "alt",
        address: "0x808507121b80c02388fad14726482e061b8da827",
        icon: null,
        usdValue: 392942733.7281407,
      },
      {
        id: "1",
        name: "BAL",
        value: 263,
        tokenType: "alt",
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        icon: null,
        usdValue: 62341364.09489499,
      },
      {
        id: "1",
        name: "FXS",
        value: 255,
        tokenType: "alt",
        address: "0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0",
        icon: null,
        usdValue: 87775744.50239453,
      },
      {
        id: "1",
        name: "OMG",
        value: 244,
        tokenType: "alt",
        address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
        icon: null,
        usdValue: 54598845.65217699,
      },
      {
        id: "42161",
        name: "MAGIC",
        value: 243,
        tokenType: "alt",
        address: "0x539bde0d7dbd336b79148aa742883198bbf60342",
        icon: null,
        usdValue: 63828032.72251239,
      },
      {
        id: "1",
        name: "FTM",
        value: 236,
        tokenType: "alt",
        address: "0x4e15361fd6b4bb609fa63c81a2be19d873717870",
        icon: null,
        usdValue: 722249862.3155245,
      },
      {
        id: "1",
        name: "STORJ",
        value: 234,
        tokenType: "alt",
        address: "0xb64ef51c888972c908cfacf59b47c1afbc0ab8ac",
        icon: null,
        usdValue: 57013648.47482888,
      },
      {
        id: "1",
        name: "GTC",
        value: 232,
        tokenType: "alt",
        address: "0xde30da39c46104798bb5aa3fe8b9e0e1f348163f",
        icon: null,
        usdValue: 47246427.42995522,
      },
      {
        id: "1",
        name: "STETH",
        value: 229,
        tokenType: "alt",
        address: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
        icon: null,
        usdValue: 424453210.81275433,
      },
      {
        id: "1",
        name: "GLM",
        value: 229,
        tokenType: "alt",
        address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
        icon: null,
        usdValue: 101916740.36412534,
      },
      {
        id: "1",
        name: "UMA",
        value: 227,
        tokenType: "alt",
        address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
        icon: null,
        usdValue: 82181516.27773632,
      },
      {
        id: "1",
        name: "ANKR",
        value: 221,
        tokenType: "alt",
        address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
        icon: null,
        usdValue: 91943195.05982956,
      },
      {
        id: "1",
        name: "REN",
        value: 221,
        tokenType: "alt",
        address: "0x408e41876cccdc0f92210600ef50372656052a38",
        icon: null,
        usdValue: 33913981.78647144,
      },
      {
        id: "1",
        name: "ENJ",
        value: 220,
        tokenType: "alt",
        address: "0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c",
        icon: null,
        usdValue: 53269820.78835963,
      },
      {
        id: "1",
        name: "GALA",
        value: 220,
        tokenType: "alt",
        address: "0x15d4c048f83bd7e37d49ea4c83a07267ec4203da",
        icon: null,
        usdValue: 1305967950.805835,
      },
      {
        id: "1",
        name: "ILV",
        value: 219,
        tokenType: "alt",
        address: "0x767fe9edc9e0df98e07454847909b5e959d7ca0e",
        icon: null,
        usdValue: 109267069.26743333,
      },
      {
        id: "1",
        name: "STG",
        value: 218,
        tokenType: "alt",
        address: "0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6",
        icon: null,
        usdValue: 44389969.47685126,
      },
      {
        id: "42161",
        name: "GMX",
        value: 217,
        tokenType: "alt",
        address: "0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a",
        icon: null,
        usdValue: 53683923.518113755,
      },
      {
        id: "1",
        name: "MASK",
        value: 217,
        tokenType: "alt",
        address: "0x69af81e73a73b40adf4f3d4223cd9b1ece623074",
        icon: null,
        usdValue: 203130505.79411033,
      },
      {
        id: "137",
        name: "WETH",
        value: 216,
        tokenType: "alt",
        address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
        icon: null,
        usdValue: 1294759.0762202688,
      },
      {
        id: "1",
        name: "BNT",
        value: 213,
        tokenType: "alt",
        address: "0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c",
        icon: null,
        usdValue: 25307622.424545962,
      },
      {
        id: "10",
        name: "ETH",
        value: 210,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 1178832881.6002665,
      },
      {
        id: "1",
        name: "RPL",
        value: 210,
        tokenType: "alt",
        address: "0xd33526068d116ce69f19a9ee46f0bd304f21a51f",
        icon: null,
        usdValue: 33705382.84143498,
      },
      {
        id: "1",
        name: "API3",
        value: 210,
        tokenType: "alt",
        address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
        icon: null,
        usdValue: 83218087.66559121,
      },
      {
        id: "1",
        name: "KNC",
        value: 209,
        tokenType: "alt",
        address: "0xdd974d5c2e2928dea5f71b9825b8b646686bd200",
        icon: null,
        usdValue: 54832468.83059379,
      },
      {
        id: "1",
        name: "AGIX",
        value: 206,
        tokenType: "alt",
        address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
        icon: null,
        usdValue: 87152127.49917424,
      },
      {
        id: "1",
        name: "FLOKI",
        value: 203,
        tokenType: "alt",
        address: "0xcf0C122c6b73ff809C693DB761e7BaeBe62b6a2E",
        icon: null,
        usdValue: 338327035.76612025,
      },
      {
        id: "1",
        name: "OCEAN",
        value: 202,
        tokenType: "alt",
        address: "0x967da4048cd07ab37855c090aaf366e4ce1b9f48",
        icon: null,
        usdValue: 42322882.640839025,
      },
      {
        id: "1",
        name: "OGN",
        value: 201,
        tokenType: "alt",
        address: "0x8207c1ffc5b6804f6024322ccf34f29c3541ae26",
        icon: null,
        usdValue: 36847898.2369809,
      },
      {
        id: "1",
        name: "SKL",
        value: 199,
        tokenType: "alt",
        address: "0x00c83aecc790e8a4453e5dd3b0b4b3680501a7a7",
        icon: null,
        usdValue: 115734605.59793907,
      },
      {
        id: "1",
        name: "AUDIO",
        value: 199,
        tokenType: "alt",
        address: "0x18aaa7115705e8be94bffebde57af9bfc265b998",
        icon: null,
        usdValue: 68119447.85055405,
      },
      {
        id: "1",
        name: "JASMY",
        value: 199,
        tokenType: "alt",
        address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
        icon: null,
        usdValue: 676675817.3558179,
      },
      {
        id: "1",
        name: "HFT",
        value: 198,
        tokenType: "alt",
        address: "0xb3999F658C0391d94A37f7FF328F3feC942BcADC",
        icon: null,
        usdValue: 112319569.52385642,
      },
      {
        id: "1",
        name: "GNO",
        value: 193,
        tokenType: "alt",
        address: "0x6810e776880c02933d47db1b9fc05908e5386b96",
        icon: null,
        usdValue: 34180235.6223811,
      },
      {
        id: "1",
        name: "RSR",
        value: 193,
        tokenType: "alt",
        address: "0x320623b8e4ff03373931769a31fc52a4e78b5d70",
        icon: null,
        usdValue: 268155436.7815402,
      },
      {
        id: "1",
        name: "AMP",
        value: 193,
        tokenType: "alt",
        address: "0xff20817765cb7f73d4bde2e66e067e58d11095c2",
        icon: null,
        usdValue: 63928483.885194935,
      },
      {
        id: "137",
        name: "USDC",
        value: 192,
        tokenType: "stable",
        address: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
        icon: null,
        usdValue: 75339041.30459458,
      },
      {
        id: "1",
        name: "LOOKS",
        value: 189,
        tokenType: "alt",
        address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
        icon: null,
        usdValue: 43408907.075751655,
      },
      {
        id: "1",
        name: "BAND",
        value: 188,
        tokenType: "alt",
        address: "0xba11d00c5f74255f56a5e366f4f77f5a186d7f55",
        icon: null,
        usdValue: 14213936.771438744,
      },
      {
        id: "56",
        name: "BUSD",
        value: 187,
        tokenType: "stable",
        address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
        icon: null,
        usdValue: 725750.1545027603,
      },
      {
        id: "1",
        name: "YGG",
        value: 187,
        tokenType: "alt",
        address: "0x25f8087ead173b73d6e8b84329989a8eea16cf73",
        icon: null,
        usdValue: 198632538.30629247,
      },
      {
        id: "1",
        name: "TUSD",
        value: 186,
        tokenType: "stable",
        address: "0x0000000000085d4780B73119b644AE5ecd22b376",
        icon: null,
        usdValue: 69899478.41966783,
      },
      {
        id: "56",
        name: "USDC",
        value: 186,
        tokenType: "stable",
        address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
        icon: null,
        usdValue: 334213102.50674963,
      },
      {
        id: "56",
        name: "WETH",
        value: 185,
        tokenType: "alt",
        address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
        icon: null,
        usdValue: 448439422.9908792,
      },
      {
        id: "1",
        name: "GAL",
        value: 184,
        tokenType: "alt",
        address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
        icon: null,
        usdValue: 93046602.15184486,
      },
      {
        id: "1",
        name: "PERP",
        value: 183,
        tokenType: "alt",
        address: "0xbc396689893d065f41bc2c6ecbee5e0085233447",
        icon: null,
        usdValue: 75715187.55724561,
      },
      {
        id: "1",
        name: "LOOM",
        value: 183,
        tokenType: "alt",
        address: "0xa4e8c3ec456107ea67d3075bf9e3df3a75823db0",
        icon: null,
        usdValue: 11520878.45837365,
      },
      {
        id: "1",
        name: "PAXG",
        value: 183,
        tokenType: "alt",
        address: "0x45804880de22913dafe09f4980848ece6ecbaf78",
        icon: null,
        usdValue: 261005451.80147383,
      },
      {
        id: "1",
        name: "NMR",
        value: 182,
        tokenType: "alt",
        address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
        icon: null,
        usdValue: 44641780.1255606,
      },
      {
        id: "1",
        name: "INJ",
        value: 181,
        tokenType: "alt",
        address: "0xe28b3b32b6c345a34ff64674606124dd5aceca30",
        icon: null,
        usdValue: 62202008.60395748,
      },
      {
        id: "1",
        name: "TRU",
        value: 180,
        tokenType: "alt",
        address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
        icon: null,
        usdValue: 79015291.92132933,
      },
      {
        id: "1",
        name: "TRAC",
        value: 180,
        tokenType: "alt",
        address: "0xaa7a9ca87d3694b5755f213b5d04094b8d0f0a6f",
        icon: null,
        usdValue: 31393443.226076405,
      },
      {
        id: "1",
        name: "RLC",
        value: 179,
        tokenType: "alt",
        address: "0x607f4c5bb672230e8672085532f7e901544a7375",
        icon: null,
        usdValue: 71486412.70855834,
      },
      {
        id: "1",
        name: "BICO",
        value: 178,
        tokenType: "alt",
        address: "0xf17e65822b568b3903685a7c9f496cf7656cc6c2",
        icon: null,
        usdValue: 135211246.18325776,
      },
      {
        id: "1",
        name: "SUPER",
        value: 176,
        tokenType: "alt",
        address: "0xe53ec727dbdeb9e2d5456c3be40cff031ab40a55",
        icon: null,
        usdValue: 191304524.79158577,
      },
      {
        id: "42161",
        name: "WBTC",
        value: 174,
        tokenType: "alt",
        address: "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f",
        icon: null,
        usdValue: 121398654.2209511,
      },
      {
        id: "1",
        name: "BADGER",
        value: 174,
        tokenType: "alt",
        address: "0x3472a5a71965499acd81997a54bba8d852c6e53d",
        icon: null,
        usdValue: 73873967.14431143,
      },
      {
        id: "1",
        name: "CELR",
        value: 173,
        tokenType: "alt",
        address: "0x4f9254c83eb525f9fcf346490bbb3ed28a81c667",
        icon: null,
        usdValue: 61771072.06499597,
      },
      {
        id: "1",
        name: "FTT",
        value: 172,
        tokenType: "alt",
        address: "0x50d1c9771902476076ecfc8b2a83ad6b9355a4c9",
        icon: null,
        usdValue: 166404704.66715446,
      },
      {
        id: "56",
        name: "CAKE",
        value: 171,
        tokenType: "alt",
        address: "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82",
        icon: null,
        usdValue: 57352421.51181154,
      },
      {
        id: "42161",
        name: "RDNT",
        value: 170,
        tokenType: "alt",
        address: "0x3082cc23568ea640225c2467653db90e9250aaa0",
        icon: null,
        usdValue: 33067930.92727222,
      },
      {
        id: "1",
        name: "LQTY",
        value: 169,
        tokenType: "alt",
        address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
        icon: null,
        usdValue: 55441917.24063903,
      },
      {
        id: "1",
        name: "T",
        value: 169,
        tokenType: "alt",
        address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
        icon: null,
        usdValue: 38911559.32117295,
      },
      {
        id: "1",
        name: "HOT",
        value: 169,
        tokenType: "alt",
        address: "0x6c6ee5e31d828de241282b9606c8e98ea48526e2",
        icon: null,
        usdValue: 113123997.06919035,
      },
      {
        id: "1",
        name: "METIS",
        value: 168,
        tokenType: "alt",
        address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
        icon: null,
        usdValue: 10009137.400413958,
      },
      {
        id: "1",
        name: "TRB",
        value: 167,
        tokenType: "alt",
        address: "0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0",
        icon: null,
        usdValue: 192743873.91668603,
      },
      {
        id: "1",
        name: "SLP",
        value: 166,
        tokenType: "alt",
        address: "0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25",
        icon: null,
        usdValue: 39661275.11009895,
      },
      {
        id: "137",
        name: "USDT",
        value: 166,
        tokenType: "stable",
        address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
        icon: null,
        usdValue: 200392377.08123547,
      },
      {
        id: "1",
        name: "WOO",
        value: 163,
        tokenType: "alt",
        address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
        icon: null,
        usdValue: 125182086.49881795,
      },
      {
        id: "1",
        name: "SPELL",
        value: 162,
        tokenType: "alt",
        address: "0x090185f2135308bad17527004364ebcc2d37e5f6",
        icon: null,
        usdValue: 85809613.87191182,
      },
      {
        id: "1",
        name: "FORTH",
        value: 161,
        tokenType: "alt",
        address: "0x77fba179c79de5b7653f68b5039af940ada60ce0",
        icon: null,
        usdValue: 33441769.73955204,
      },
      {
        id: "1",
        name: "SNT",
        value: 159,
        tokenType: "alt",
        address: "0x744d70fdbe2ba4cf95131626614a1763df805b9e",
        icon: null,
        usdValue: 53305983.12812901,
      },
      {
        id: "1",
        name: "TURBO",
        value: 159,
        tokenType: "alt",
        address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
        icon: null,
        usdValue: 348319695.94552314,
      },
      {
        id: "1",
        name: "ALICE",
        value: 158,
        tokenType: "alt",
        address: "0xac51066d7bec65dc4589368da368b212745d63e8",
        icon: null,
        usdValue: 57935450.49037246,
      },
      {
        id: "1",
        name: "ACH",
        value: 158,
        tokenType: "alt",
        address: "0xed04915c23f00a313a544955524eb7dbd823143d",
        icon: null,
        usdValue: 93905479.51878329,
      },
      {
        id: "10",
        name: "usdc",
        value: 157,
        tokenType: "stable",
        address: "0x7f5c764cbc14f9669b88837ca1490cca17c31607",
        icon: null,
        usdValue: 22609846.464859553,
      },
      {
        id: "56",
        name: "WBNB",
        value: 155,
        tokenType: "alt",
        address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        icon: null,
        usdValue: 389295.9789304418,
      },
      {
        id: "1",
        name: "OM",
        value: 153,
        tokenType: "alt",
        address: "0x2baecdf43734f22fd5c152db08e3c27233f0c7d2",
        icon: null,
        usdValue: 475744647.05826706,
      },
      {
        id: "1",
        name: "HEX",
        value: 152,
        tokenType: "alt",
        address: "0x2b591e99afe9f32eaa6214f7b7629768c40eeb39",
        icon: null,
        usdValue: 5147337.226786308,
      },
      {
        id: "1",
        name: "OXT",
        value: 151,
        tokenType: "alt",
        address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
        icon: null,
        usdValue: 40708824.583903015,
      },
      {
        id: "1",
        name: "CVC",
        value: 151,
        tokenType: "alt",
        address: "0x41e5560054824ea6b0732e656e3ad64e20e94e45",
        icon: null,
        usdValue: 41534945.91364888,
      },
      {
        id: "1",
        name: "ARB",
        value: 150,
        tokenType: "alt",
        address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
        icon: null,
        usdValue: 18530564.426867653,
      },
      {
        id: "1",
        name: "POLS",
        value: 149,
        tokenType: "alt",
        address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
        icon: null,
        usdValue: 22636071.13976764,
      },
      {
        id: "42161",
        name: "DAI",
        value: 148,
        tokenType: "stable",
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        icon: null,
        usdValue: 2622139.509012404,
      },
      {
        id: "1",
        name: "POWR",
        value: 148,
        tokenType: "alt",
        address: "0x595832f8fc6bf59c85c527fec3740a1b7a361269",
        icon: null,
        usdValue: 66639063.88658597,
      },
      {
        id: "1",
        name: "CTSI",
        value: 148,
        tokenType: "alt",
        address: "0x491604c0fdf08347dd1fa4ee062a822a5dd06b5d",
        icon: null,
        usdValue: 97612668.31791726,
      },
      {
        id: "1",
        name: "FRONT",
        value: 147,
        tokenType: "alt",
        address: "0xf8c3527cc04340b208c854e985240c02f7b7793f",
        icon: null,
        usdValue: 30919801.223324668,
      },
      {
        id: "1",
        name: "AGLD",
        value: 146,
        tokenType: "alt",
        address: "0x32353a6c91143bfd6c7d363b546e62a9a2489a20",
        icon: null,
        usdValue: 197165103.56144616,
      },
      {
        id: "1",
        name: "SSV",
        value: 146,
        tokenType: "alt",
        address: "0x9d65ff81a3c488d585bbfb0bfe3c7707c7917f54",
        icon: null,
        usdValue: 77257072.78134046,
      },
      {
        id: "1",
        name: "RADAR",
        value: 144,
        tokenType: "alt",
        address: "0x44709a920fccf795fbc57baa433cc3dd53c44dbe",
        icon: null,
        usdValue: 4654503.119171435,
      },
      {
        id: "1",
        name: "ANT",
        value: 144,
        tokenType: "alt",
        address: "0xa117000000f279d81a1d3cc75430faa017fa5a2e",
        icon: null,
        usdValue: 19972309.34970939,
      },
      {
        id: "1",
        name: "WAXL",
        value: 144,
        tokenType: "alt",
        address: "0x467719ad09025fcc6cf6f8311755809d45a5e5f3",
        icon: null,
        usdValue: 22651444.343684264,
      },
      {
        id: "1",
        name: "ALCX",
        value: 141,
        tokenType: "alt",
        address: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",
        icon: null,
        usdValue: 20741264.096408002,
      },
      {
        id: "1",
        name: "DIA",
        value: 141,
        tokenType: "alt",
        address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
        icon: null,
        usdValue: 31250742.996065594,
      },
      {
        id: "1",
        name: "USDP",
        value: 141,
        tokenType: "stable",
        address: "0x8e870d67f660d95d5be530380d0ec0bd388289e1",
        icon: null,
        usdValue: 34167905.462252885,
      },
      {
        id: "1",
        name: "COTI",
        value: 141,
        tokenType: "alt",
        address: "0xddb3422497e61e13543bea06989c0789117555c5",
        icon: null,
        usdValue: 111968585.48548217,
      },
      {
        id: "1",
        name: "AUCTION",
        value: 140,
        tokenType: "alt",
        address: "0xa9b1eb5908cfc3cdf91f9b8b3a74108598009096",
        icon: null,
        usdValue: 125692671.95284091,
      },
      {
        id: "1",
        name: "RAD",
        value: 139,
        tokenType: "alt",
        address: "0x31c8eacbffdd875c74b94b077895bd78cf1e64a3",
        icon: null,
        usdValue: 34336063.99797703,
      },
      {
        id: "1",
        name: "ALPHA",
        value: 139,
        tokenType: "alt",
        address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
        icon: null,
        usdValue: 16110859.857125314,
      },
      {
        id: "1",
        name: "DENT",
        value: 139,
        tokenType: "alt",
        address: "0x3597bfd533a99c9aa083587b074434e61eb0a258",
        icon: null,
        usdValue: 66842917.38824225,
      },
      {
        id: "1",
        name: "FOX",
        value: 138,
        tokenType: "alt",
        address: "0xc770eefad204b5180df6a14ee197d99d808ee52d",
        icon: null,
        usdValue: 1734680.9054449294,
      },
      {
        id: "1",
        name: "PEOPLE",
        value: 138,
        tokenType: "alt",
        address: "0x7a58c0be72be218b41c608b7fe7c5bb630736c71",
        icon: null,
        usdValue: 384540606.4493326,
      },
      {
        id: "1",
        name: "PYR",
        value: 136,
        tokenType: "alt",
        address: "0x9534ad65fb398e27ac8f4251dae1780b989d136e",
        icon: null,
        usdValue: 55654261.1145037,
      },
      {
        id: "42161",
        name: "GRAIL",
        value: 136,
        tokenType: "alt",
        address: "0x3d9907f9a368ad0a51be60f7da3b97cf940982d8",
        icon: null,
        usdValue: 4815330.864382658,
      },
      {
        id: "1",
        name: "RARE",
        value: 135,
        tokenType: "alt",
        address: "0xba5bde662c17e2adff1075610382b9b691296350",
        icon: null,
        usdValue: 12151444.836761337,
      },
      {
        id: "1",
        name: "POND",
        value: 135,
        tokenType: "alt",
        address: "0x57b946008913b82e4df85f501cbaed910e58d26c",
        icon: null,
        usdValue: 44223086.185055055,
      },
      {
        id: "1",
        name: "ERN",
        value: 134,
        tokenType: "alt",
        address: "0xbbc2ae13b23d715c30720f079fcd9b4a74093505",
        icon: null,
        usdValue: 34973667.66453218,
      },
      {
        id: "1",
        name: "IDEX",
        value: 133,
        tokenType: "alt",
        address: "0xb705268213d593b8fd88d3fdeff93aff5cbdcfae",
        icon: null,
        usdValue: 38211985.76167455,
      },
      {
        id: "1",
        name: "PRIME",
        value: 132,
        tokenType: "alt",
        address: "0xb23d80f5fefcddaa212212f028021b41ded428cf",
        icon: null,
        usdValue: 84910006.7495847,
      },
      {
        id: "1",
        name: "BONE",
        value: 132,
        tokenType: "alt",
        address: "0x9813037ee2218799597d83d4a5b6f3b6778218d9",
        icon: null,
        usdValue: 49251418.754040316,
      },
      {
        id: "1",
        name: "SYN",
        value: 132,
        tokenType: "alt",
        address: "0x0f2d719407fdbeff09d87557abb7232601fd9f29",
        icon: null,
        usdValue: 16355407.847542984,
      },
      {
        id: "1",
        name: "REQ",
        value: 132,
        tokenType: "alt",
        address: "0x8f8221afbb33998d8584a2b05749ba73c37a938a",
        icon: null,
        usdValue: 31666097.614089653,
      },
      {
        id: "1",
        name: "DODO",
        value: 130,
        tokenType: "alt",
        address: "0x43dfc4159d86f3a37a5a4b3d4580b888ad7d4ddd",
        icon: null,
        usdValue: 57880979.72314296,
      },
      {
        id: "1",
        name: "BLZ",
        value: 130,
        tokenType: "alt",
        address: "0x5732046a883704404f284ce41ffadd5b007fd668",
        icon: null,
        usdValue: 20423924.204450447,
      },
      {
        id: "42161",
        name: "AIDOGE",
        value: 129,
        tokenType: "alt",
        address: "0x09e18590e8f76b6cf471b3cd75fe1a1a9d2b2c2b",
        icon: null,
        usdValue: 34014605.93723876,
      },
      {
        id: "1",
        name: "ELON",
        value: 129,
        tokenType: "alt",
        address: "0x761d38e5ddf6ccf6cf7c55759d5210750b5d60f3",
        icon: null,
        usdValue: 68608715.13100855,
      },
      {
        id: "1",
        name: "HIGH",
        value: 128,
        tokenType: "alt",
        address: "0x71ab77b7dbb4fa7e017bc15090b2163221420282",
        icon: null,
        usdValue: 35530300.586455174,
      },
      {
        id: "1",
        name: "FARM",
        value: 127,
        tokenType: "alt",
        address: "0xa0246c9032bc3a600820415ae600c6388619a14d",
        icon: null,
        usdValue: 44468155.214743,
      },
      {
        id: "1",
        name: "NEXO",
        value: 126,
        tokenType: "alt",
        address: "0xb62132e35a6c13ee1ee0f84dc5d40bad8d815206",
        icon: null,
        usdValue: 106261545.17087558,
      },
      {
        id: "1",
        name: "GHST",
        value: 126,
        tokenType: "alt",
        address: "0x3f382dbd960e3a9bbceae22651e88158d2791550",
        icon: null,
        usdValue: 20824471.521439534,
      },
      {
        id: "1",
        name: "SOS",
        value: 125,
        tokenType: "alt",
        address: "0x3b484b82567a09e2588a13d54d032153f0c0aee0",
        icon: null,
        usdValue: 1239392.8466514745,
      },
      {
        id: "1",
        name: "BOND",
        value: 125,
        tokenType: "alt",
        address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
        icon: null,
        usdValue: 11442290.178274056,
      },
      {
        id: "1",
        name: "SRM",
        value: 125,
        tokenType: "alt",
        address: "0x476c5e26a75bd202a9683ffd34359c0cc15be0ff",
        icon: null,
        usdValue: 3034343.71335193,
      },
      {
        id: "1",
        name: "CRO",
        value: 125,
        tokenType: "alt",
        address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
        icon: null,
        usdValue: 419292794.89470285,
      },
      {
        id: "1",
        name: "DUSK",
        value: 124,
        tokenType: "alt",
        address: "0x940a2db1b7008b6c776d4faaca729d6d4a4aa551",
        icon: null,
        usdValue: 37141931.63377724,
      },
      {
        id: "1",
        name: "FLUX",
        value: 124,
        tokenType: "alt",
        address: "0x720cd16b011b987da3518fbf38c3071d4f0d1495",
        icon: null,
        usdValue: 9898432.896988919,
      },
      {
        id: "1",
        name: "YFII",
        value: 122,
        tokenType: "alt",
        address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
        icon: null,
        usdValue: 13587657.885043964,
      },
      {
        id: "42161",
        name: "STG",
        value: 121,
        tokenType: "alt",
        address: "0x6694340fc020c5E6B96567843da2df01b2CE1eb6",
        icon: null,
        usdValue: 1618699.3502729116,
      },
      {
        id: "1",
        name: "MLN",
        value: 121,
        tokenType: "alt",
        address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
        icon: null,
        usdValue: 29373072.234016996,
      },
      {
        id: "1",
        name: "C98",
        value: 121,
        tokenType: "alt",
        address: "0xae12c5930881c53715b369cec7606b70d8eb229f",
        icon: null,
        usdValue: 24265676.40418644,
      },
      {
        id: "1",
        name: "MDT",
        value: 120,
        tokenType: "alt",
        address: "0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26",
        icon: null,
        usdValue: 32432947.380991597,
      },
      {
        id: "1",
        name: "BOBA",
        value: 118,
        tokenType: "alt",
        address: "0x42bbfa2e77757c645eeaad1655e0911a7553efbc",
        icon: null,
        usdValue: 26114449.309605967,
      },
      {
        id: "1",
        name: "PHA",
        value: 117,
        tokenType: "alt",
        address: "0x6c5bA91642F10282b576d91922Ae6448C9d52f4E",
        icon: null,
        usdValue: 154842370.80390805,
      },
      {
        id: "1",
        name: "LIT",
        value: 117,
        tokenType: "alt",
        address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
        icon: null,
        usdValue: 94383711.73995148,
      },
      {
        id: "1",
        name: "AKRO",
        value: 116,
        tokenType: "alt",
        address: "0x8ab7404063ec4dbcfd4598215992dc3f8ec853d7",
        icon: null,
        usdValue: 6687008.596068762,
      },
      {
        id: "1",
        name: "TLM",
        value: 116,
        tokenType: "alt",
        address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
        icon: null,
        usdValue: 43757808.703258045,
      },
      {
        id: "1",
        name: "TRIBE",
        value: 116,
        tokenType: "alt",
        address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
        icon: null,
        usdValue: 11571373.705714142,
      },
      {
        id: "1",
        name: "LINA",
        value: 116,
        tokenType: "alt",
        address: "0x3e9bc21c9b189c09df3ef1b824798658d5011937",
        icon: null,
        usdValue: 29908741.77442615,
      },
      {
        id: "1",
        name: "ARPA",
        value: 115,
        tokenType: "alt",
        address: "0xba50933c268f567bdc86e1ac131be072c6b0b71a",
        icon: null,
        usdValue: 58925826.64133206,
      },
      {
        id: "1",
        name: "BUSD",
        value: 114,
        tokenType: "stable",
        address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
        icon: null,
        usdValue: 27698343.668693934,
      },
      {
        id: "1",
        name: "LOKA",
        value: 114,
        tokenType: "alt",
        address: "0x61e90a50137e1f645c9ef4a0d3a4f01477738406",
        icon: null,
        usdValue: 16114052.250858413,
      },
      {
        id: "1",
        name: "KP3R",
        value: 114,
        tokenType: "alt",
        address: "0x1ceb5cb57c4d4e2b2433641b95dd330a33185a44",
        icon: null,
        usdValue: 6414424.728375361,
      },
      {
        id: "1",
        name: "UTK",
        value: 113,
        tokenType: "alt",
        address: "0xdc9Ac3C20D1ed0B540dF9b1feDC10039Df13F99c",
        icon: null,
        usdValue: 17108562.87961378,
      },
      {
        id: "1",
        name: "AERGO",
        value: 113,
        tokenType: "alt",
        address: "0x91af0fbb28aba7e31403cb457106ce79397fd4e6",
        icon: null,
        usdValue: 15049047.348864945,
      },
      {
        id: "1",
        name: "PUNDIX",
        value: 113,
        tokenType: "alt",
        address: "0x0fd10b9899882a6f2fcb5c371e17e70fdee00c38",
        icon: null,
        usdValue: 33818435.118699566,
      },
      {
        id: "1",
        name: "REEF",
        value: 113,
        tokenType: "alt",
        address: "0xfe3e6a25e6b192a42a44ecddcd13796471735acf",
        icon: null,
        usdValue: 7538952.994147895,
      },
      {
        id: "137",
        name: "WMATIC",
        value: 112,
        tokenType: "alt",
        address: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
        icon: null,
        usdValue: 48904.602716518944,
      },
      {
        id: "1",
        name: "CLV",
        value: 112,
        tokenType: "alt",
        address: "0x80c62fe4487e1351b47ba49809ebd60ed085bf52",
        icon: null,
        usdValue: 62336476.981740706,
      },
      {
        id: "1",
        name: "ACX",
        value: 111,
        tokenType: "alt",
        address: "0x44108f0223a3c3028f5fe7aec7f9bb2e66bef82f",
        icon: null,
        usdValue: 149975944.93198848,
      },
      {
        id: "1",
        name: "RARI",
        value: 111,
        tokenType: "alt",
        address: "0xfca59cd816ab1ead66534d82bc21e7515ce441cf",
        icon: null,
        usdValue: 11118726.098937808,
      },
      {
        id: "1",
        name: "ELF",
        value: 111,
        tokenType: "alt",
        address: "0xbf2179859fc6D5BEE9Bf9158632Dc51678a4100e",
        icon: null,
        usdValue: 27744687.634911813,
      },
      {
        id: "1",
        name: "ORN",
        value: 111,
        tokenType: "alt",
        address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
        icon: null,
        usdValue: 38358811.952169605,
      },
      {
        id: "1",
        name: "WNXM",
        value: 110,
        tokenType: "alt",
        address: "0x0d438f3b5175bebc262bf23753c1e53d03432bde",
        icon: null,
        usdValue: 23012020.755646076,
      },
      {
        id: "1",
        name: "ID",
        value: 110,
        tokenType: "alt",
        address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
        icon: null,
        usdValue: 101370422.05461645,
      },
      {
        id: "1",
        name: "MIR",
        value: 108,
        tokenType: "alt",
        address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
        icon: null,
        usdValue: 2198508.710184544,
      },
      {
        id: "1",
        name: "LEVER",
        value: 108,
        tokenType: "alt",
        address: "0x4b5f49487ea7b3609b1ad05459be420548789f1f",
        icon: null,
        usdValue: 50351027.39289715,
      },
      {
        id: "1",
        name: "AIOZ",
        value: 107,
        tokenType: "alt",
        address: "0x626e8036deb333b408be468f951bdb42433cbf18",
        icon: null,
        usdValue: 146140554.26200044,
      },
      {
        id: "1",
        name: "CREAM",
        value: 107,
        tokenType: "alt",
        address: "0x2ba592f78db6436527729929aaf6c908497cb200",
        icon: null,
        usdValue: 37058193.79298654,
      },
      {
        id: "1",
        name: "UNFI",
        value: 106,
        tokenType: "alt",
        address: "0x441761326490cACF7aF299725B6292597EE822c2",
        icon: null,
        usdValue: 12209989.916925019,
      },
      {
        id: "1",
        name: "MTL",
        value: 106,
        tokenType: "alt",
        address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
        icon: null,
        usdValue: 5838101.121344262,
      },
      {
        id: "1",
        name: "GMT",
        value: 105,
        tokenType: "alt",
        address: "0xe3c408BD53c31C085a1746AF401A4042954ff740",
        icon: null,
        usdValue: 61169733.37971143,
      },
      {
        id: "1",
        name: "TORN",
        value: 104,
        tokenType: "alt",
        address: "0x77777feddddffc19ff86db637967013e6c6a116c",
        icon: null,
        usdValue: 16886191.585387543,
      },
      {
        id: "1",
        name: "GAS",
        value: 103,
        tokenType: "alt",
        address: "0x6bba316c48b49bd1eac44573c5c871ff02958469",
        icon: null,
        usdValue: 119464.10151647913,
      },
      {
        id: "1",
        name: "PLA",
        value: 103,
        tokenType: "alt",
        address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
        icon: null,
        usdValue: 10321809.402268019,
      },
      {
        id: "1",
        name: "NKN",
        value: 102,
        tokenType: "alt",
        address: "0x5cf04716ba20127f1e2297addcf4b5035000c9eb",
        icon: null,
        usdValue: 18639150.135670424,
      },
      {
        id: "1",
        name: "HIFI",
        value: 102,
        tokenType: "alt",
        address: "0x4b9278b94a1112cAD404048903b8d343a810B07e",
        icon: null,
        usdValue: 21433724.752781916,
      },
      {
        id: "1",
        name: "FUN",
        value: 102,
        tokenType: "alt",
        address: "0x419d0d8bdd9af5e606ae2232ed285aff190e711b",
        icon: null,
        usdValue: 22665612.225588832,
      },
      {
        id: "1",
        name: "REP",
        value: 102,
        tokenType: "alt",
        address: "0x221657776846890989a759BA2973e427DfF5C9bB",
        icon: null,
        usdValue: 6870522.51511906,
      },
      {
        id: "1",
        name: "SD",
        value: 101,
        tokenType: "alt",
        address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
        icon: null,
        usdValue: 17020083.5914549,
      },
      {
        id: "1",
        name: "RSS3",
        value: 101,
        tokenType: "alt",
        address: "0xc98d64da73a6616c42117b582e832812e7b8d57f",
        icon: null,
        usdValue: 92222495.5265806,
      },
      {
        id: "1",
        name: "AST",
        value: 100,
        tokenType: "alt",
        address: "0x27054b13b1b798b345b591a4d22e6562d47ea75a",
        icon: null,
        usdValue: 22385028.55814982,
      },
      {
        id: "1",
        name: "CQT",
        value: 99,
        tokenType: "alt",
        address: "0xD417144312DbF50465b1C641d016962017Ef6240",
        icon: null,
        usdValue: 26486289.455992583,
      },
      {
        id: "1",
        name: "WOJAK",
        value: 99,
        tokenType: "alt",
        address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
        icon: null,
        usdValue: 17644783.98853578,
      },
      {
        id: "10",
        name: "snx",
        value: 98,
        tokenType: "alt",
        address: "0x8700daec35af8ff88c16bdf0418774cb3d7599b4",
        icon: null,
        usdValue: 42434065.50452247,
      },
      {
        id: "1",
        name: "LADYS",
        value: 98,
        tokenType: "alt",
        address: "0x12970E6868f88f6557B76120662c1B3E50A646bf",
        icon: null,
        usdValue: 78575275.53011772,
      },
      {
        id: "1",
        name: "KEY",
        value: 98,
        tokenType: "alt",
        address: "0x4cc19356f2d37338b9802aa8e8fc58b0373296e7",
        icon: null,
        usdValue: 9364745.794395825,
      },
      {
        id: "1",
        name: "CVP",
        value: 97,
        tokenType: "alt",
        address: "0x38e4adb44ef08f22f5b5b76a8f0c2d0dcbe7dca1",
        icon: null,
        usdValue: 12326781.9499599,
      },
      {
        id: "1",
        name: "XYO",
        value: 97,
        tokenType: "alt",
        address: "0x55296f69f40ea6d20e478533c15a6b08b654e758",
        icon: null,
        usdValue: 34256321.45411788,
      },
      {
        id: "56",
        name: "BTCB",
        value: 97,
        tokenType: "alt",
        address: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
        icon: null,
        usdValue: 191528181.7189499,
      },
      {
        id: "1",
        name: "MYRIA",
        value: 97,
        tokenType: "alt",
        address: "0xA0Ef786Bf476fE0810408CaBA05E536aC800ff86",
        icon: null,
        usdValue: 9643253.207281647,
      },
      {
        id: "1",
        name: "XEN",
        value: 96,
        tokenType: "alt",
        address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
        icon: null,
        usdValue: 10775349.07265695,
      },
      {
        id: "1",
        name: "GODS",
        value: 96,
        tokenType: "alt",
        address: "0xccc8cb5229b0ac8069c51fd58367fd1e622afd97",
        icon: null,
        usdValue: 9895234.338548426,
      },
      {
        id: "1",
        name: "GEAR",
        value: 94,
        tokenType: "alt",
        address: "0xba3335588d9403515223f109edc4eb7269a9ab5d",
        icon: null,
        usdValue: 11918452.733018762,
      },
      {
        id: "42161",
        name: "LINK",
        value: 93,
        tokenType: "alt",
        address: "0xf97f4df75117a78c1a5a0dbb814af92458539fb4",
        icon: null,
        usdValue: 1028080.70079771,
      },
      {
        id: "1",
        name: "COW",
        value: 93,
        tokenType: "alt",
        address: "0xdef1ca1fb7fbcdc777520aa7f396b4e015f497ab",
        icon: null,
        usdValue: 83776877.84536292,
      },
      {
        id: "1",
        name: "UFT",
        value: 93,
        tokenType: "alt",
        address: "0x0202Be363B8a4820f3F4DE7FaF5224fF05943AB1",
        icon: null,
        usdValue: 13411544.10156518,
      },
      {
        id: "1",
        name: "OGV",
        value: 93,
        tokenType: "alt",
        address: "0x9c354503c38481a7a7a51629142963f98ecc12d0",
        icon: null,
        usdValue: 3136375.5722700194,
      },
      {
        id: "1",
        name: "SIDUS",
        value: 93,
        tokenType: "alt",
        address: "0x549020a9Cb845220D66d3E9c6D9F9eF61C981102",
        icon: null,
        usdValue: 18883833.81854272,
      },
      {
        id: "1",
        name: "XCN",
        value: 92,
        tokenType: "alt",
        address: "0xa2cd3d43c775978a96bdbf12d733d5a1ed94fb18",
        icon: null,
        usdValue: 17425856.15922153,
      },
      {
        id: "1",
        name: "BOSON",
        value: 91,
        tokenType: "alt",
        address: "0xC477D038d5420C6A9e0b031712f61c5120090de9",
        icon: null,
        usdValue: 17881211.51307914,
      },
      {
        id: "1",
        name: "PSTAKE",
        value: 89,
        tokenType: "alt",
        address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
        icon: null,
        usdValue: 26815505.3885809,
      },
      {
        id: "1",
        name: "ADX",
        value: 88,
        tokenType: "alt",
        address: "0xade00c28244d5ce17d72e40330b1c318cd12b7c3",
        icon: null,
        usdValue: 19840471.590554673,
      },
      {
        id: "1",
        name: "sUSD",
        value: 88,
        tokenType: "stable",
        address: "0x57ab1ec28d129707052df4df418d58a2d46d5f51",
        icon: null,
        usdValue: 458606.671992327,
      },
      {
        id: "1",
        name: "DNT",
        value: 88,
        tokenType: "alt",
        address: "0x0abdace70d3790235af448c88547603b945604ea",
        icon: null,
        usdValue: 2253322.8904146864,
      },
      {
        id: "1",
        name: "QRDO",
        value: 87,
        tokenType: "alt",
        address: "0x4123a133ae3c521fd134d7b13a2dec35b56c2463",
        icon: null,
        usdValue: 13110447.306447655,
      },
      {
        id: "1",
        name: "KISHU",
        value: 87,
        tokenType: "alt",
        address: "0xA2b4C0Af19cC16a6CfAcCe81F192B024d625817D",
        icon: null,
        usdValue: 46815607.97391506,
      },
      {
        id: "1",
        name: "OOKI",
        value: 87,
        tokenType: "alt",
        address: "0x0de05f6447ab4d22c8827449ee4ba2d5c288379b",
        icon: null,
        usdValue: 2062297.310086108,
      },
      {
        id: "1",
        name: "HEGIC",
        value: 86,
        tokenType: "alt",
        address: "0x584bc13c7d411c00c01a62e8019472de68768430",
        icon: null,
        usdValue: 3571623.1004193765,
      },
      {
        id: "1",
        name: "DAO",
        value: 86,
        tokenType: "alt",
        address: "0x0f51bb10119727a7e5ea3538074fb341f56b09ad",
        icon: null,
        usdValue: 6492263.190589149,
      },
      {
        id: "1",
        name: "BOB",
        value: 86,
        tokenType: "alt",
        address: "0x7D8146cf21e8D7cbe46054e01588207b51198729",
        icon: null,
        usdValue: 17893698.544197947,
      },
      {
        id: "1",
        name: "IQ",
        value: 86,
        tokenType: "alt",
        address: "0x579cea1889991f68acc35ff5c3dd0621ff29b0c9",
        icon: null,
        usdValue: 56522954.0335529,
      },
      {
        id: "56",
        name: "MGP",
        value: 86,
        tokenType: "alt",
        address: "0xd06716e1ff2e492cc5034c2e81805562dd3b45fa",
        icon: null,
        usdValue: 340124.314495103,
      },
      {
        id: "1",
        name: "UOS",
        value: 86,
        tokenType: "alt",
        address: "0xd13c7342e1ef687c5ad21b27c2b65d772cab5c8c",
        icon: null,
        usdValue: 9633626.731487669,
      },
      {
        id: "1",
        name: "PRQ",
        value: 86,
        tokenType: "alt",
        address: "0x362bc847a3a9637d3af6624eec853618a43ed7d2",
        icon: null,
        usdValue: 12476039.318463992,
      },
      {
        id: "1",
        name: "VGX",
        value: 86,
        tokenType: "alt",
        address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
        icon: null,
        usdValue: 5585522.144078188,
      },
      {
        id: "1",
        name: "RLY",
        value: 84,
        tokenType: "alt",
        address: "0xf1f955016ecbcd7321c7266bccfb96c68ea5e49b",
        icon: null,
        usdValue: 2906022.8298992775,
      },
      {
        id: "1",
        name: "ORBS",
        value: 84,
        tokenType: "alt",
        address: "0xff56cc6b1e6ded347aa0b7676c85ab0b3d08b0fa",
        icon: null,
        usdValue: 16106324.2926763,
      },
      {
        id: "1",
        name: "PROM",
        value: 84,
        tokenType: "alt",
        address: "0xfc82bb4ba86045af6f327323a46e80412b91b27d",
        icon: null,
        usdValue: 27218308.605076067,
      },
      {
        id: "1",
        name: "RBN",
        value: 83,
        tokenType: "alt",
        address: "0x6123b0049f904d730db3c36a31167d9d4121fa6b",
        icon: null,
        usdValue: 8408648.89756324,
      },
      {
        id: "1",
        name: "POLY",
        value: 83,
        tokenType: "alt",
        address: "0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec",
        icon: null,
        usdValue: 417581.2358808354,
      },
      {
        id: "1",
        name: "CPOOL",
        value: 82,
        tokenType: "alt",
        address: "0x66761fa41377003622aee3c7675fc7b5c1c2fac5",
        icon: null,
        usdValue: 82340813.38909326,
      },
      {
        id: "1",
        name: "BETA",
        value: 81,
        tokenType: "alt",
        address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
        icon: null,
        usdValue: 17578838.374594923,
      },
      {
        id: "1",
        name: "ZCX",
        value: 81,
        tokenType: "alt",
        address: "0xc52c326331e9ce41f04484d3b5e5648158028804",
        icon: null,
        usdValue: 10584063.714354785,
      },
      {
        id: "1",
        name: "DAR",
        value: 81,
        tokenType: "alt",
        address: "0x081131434f93063751813c619ecca9c4dc7862a3",
        icon: null,
        usdValue: 22506216.681994103,
      },
      {
        id: "1",
        name: "LEASH",
        value: 80,
        tokenType: "alt",
        address: "0x27c70cd1946795b66be9d954418546998b546634",
        icon: null,
        usdValue: 19995342.337457355,
      },
      {
        id: "1",
        name: "SWEAT",
        value: 80,
        tokenType: "alt",
        address: "0xb4b9dc1c77bdbb135ea907fd5a08094d98883a35",
        icon: null,
        usdValue: 9373320.803892724,
      },
      {
        id: "1",
        name: "OKB",
        value: 79,
        tokenType: "alt",
        address: "0x75231f58b43240c9718dd58b4967c5114342a86c",
        icon: null,
        usdValue: 388673220.7645274,
      },
      {
        id: "42161",
        name: "JONES",
        value: 78,
        tokenType: "alt",
        address: "0x10393c20975cf177a3513071bc110f7962cd67da",
        icon: null,
        usdValue: 1946538.1272169384,
      },
      {
        id: "1",
        name: "LMWR",
        value: 78,
        tokenType: "alt",
        address: "0x628a3b2e302c7e896acc432d2d0dd22b6cb9bc88",
        icon: null,
        usdValue: 37871072.81984323,
      },
      {
        id: "1",
        name: "VIB",
        value: 78,
        tokenType: "alt",
        address: "0x2c974b2d0ba1716e644c1fc59982a89ddd2ff724",
        icon: null,
        usdValue: 13627722.132466378,
      },
      {
        id: "1",
        name: "MPL",
        value: 77,
        tokenType: "alt",
        address: "0x33349b282065b0284d756f0577fb39c158f935e6",
        icon: null,
        usdValue: 6626120.585126312,
      },
      {
        id: "1",
        name: "XAUT",
        value: 77,
        tokenType: "alt",
        address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
        icon: null,
        usdValue: 110800741.84481737,
      },
      {
        id: "1",
        name: "DEXE",
        value: 77,
        tokenType: "alt",
        address: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
        icon: null,
        usdValue: 67782483.57550806,
      },
      {
        id: "1",
        name: "GFI",
        value: 76,
        tokenType: "alt",
        address: "0xdab396ccf3d84cf2d07c4454e10c8a6f5b008d2b",
        icon: null,
        usdValue: 17525803.44931711,
      },
      {
        id: "1",
        name: "ERC20",
        value: 76,
        tokenType: "alt",
        address: "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
        icon: null,
        usdValue: 741520846.5825152,
      },
      {
        id: "1",
        name: "STARL",
        value: 76,
        tokenType: "alt",
        address: "0x8e6cd950ad6ba651f6dd608dc70e5886b1aa6b24",
        icon: null,
        usdValue: 6737056.09478743,
      },
      {
        id: "1",
        name: "ALI",
        value: 76,
        tokenType: "alt",
        address: "0x6b0b3a982b4634ac68dd83a4dbf02311ce324181",
        icon: null,
        usdValue: 11494685.97442175,
      },
      {
        id: "1",
        name: "CEL",
        value: 76,
        tokenType: "alt",
        address: "0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d",
        icon: null,
        usdValue: 61167485.90273713,
      },
      {
        id: "5000",
        name: "MNT",
        value: 75,
        tokenType: "native",
        address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead0000",
        icon: null,
        usdValue: 6880265.364970442,
      },
      {
        id: "1",
        name: "QKC",
        value: 75,
        tokenType: "alt",
        address: "0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664",
        icon: null,
        usdValue: 17438942.981614698,
      },
      {
        id: "42161",
        name: "DPX",
        value: 74,
        tokenType: "alt",
        address: "0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55",
        icon: null,
        usdValue: 2586104.224768392,
      },
      {
        id: "1",
        name: "BITCOIN",
        value: 74,
        tokenType: "alt",
        address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
        icon: null,
        usdValue: 57035709.3791269,
      },
      {
        id: "1",
        name: "$MONG",
        value: 73,
        tokenType: "alt",
        address: "0x1ce270557C1f68Cfb577b856766310Bf8B47FD9C",
        icon: null,
        usdValue: 5684815.159057064,
      },
      {
        id: "1",
        name: "IOTX",
        value: 72,
        tokenType: "alt",
        address: "0x6fb3e0a217407efff7ca062d46c26e5d60a14d69",
        icon: null,
        usdValue: 6747277.257458281,
      },
      {
        id: "1",
        name: "UFO",
        value: 72,
        tokenType: "alt",
        address: "0x249e38ea4102d0cf8264d3701f1a0e39c4f2dc3b",
        icon: null,
        usdValue: 5326321.772215467,
      },
      {
        id: "1",
        name: "GUSD",
        value: 72,
        tokenType: "stable",
        address: "0x056fd409e1d7a124bd7017459dfea2f387b6d5cd",
        icon: null,
        usdValue: 1958164.5728612593,
      },
      {
        id: "1",
        name: "AMPL",
        value: 72,
        tokenType: "alt",
        address: "0xd46ba6d942050d489dbd938a2c909a5d5039a161",
        icon: null,
        usdValue: 11139339.506395362,
      },
      {
        id: "1",
        name: "HOP",
        value: 71,
        tokenType: "alt",
        address: "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
        icon: null,
        usdValue: 409718.3955382506,
      },
      {
        id: "56",
        name: "SHIB",
        value: 71,
        tokenType: "alt",
        address: "0x2859e4544c4bb03966803b044a93563bd2d0dd4d",
        icon: null,
        usdValue: 61241963.187769264,
      },
      {
        id: "1",
        name: "TOMI",
        value: 71,
        tokenType: "alt",
        address: "0x4385328cc4d643ca98dfea734360c0f596c83449",
        icon: null,
        usdValue: 17800799.892922025,
      },
      {
        id: "1",
        name: "DF",
        value: 71,
        tokenType: "alt",
        address: "0x431ad2ff6a9c365805ebad47ee021148d6f7dbe0",
        icon: null,
        usdValue: 30968809.138134122,
      },
      {
        id: "1",
        name: "LTO",
        value: 71,
        tokenType: "alt",
        address: "0xd01409314acb3b245cea9500ece3f6fd4d70ea30",
        icon: null,
        usdValue: 15586000.401962353,
      },
      {
        id: "1",
        name: "WILD",
        value: 71,
        tokenType: "alt",
        address: "0x2a3bff78b79a009976eea096a51a948a3dc00e34",
        icon: null,
        usdValue: 12628225.095334914,
      },
      {
        id: "42161",
        name: "GNS",
        value: 71,
        tokenType: "alt",
        address: "0x18c11FD286C5EC11c3b683Caa813B77f5163A122",
        icon: null,
        usdValue: 1920554.9221090379,
      },
      {
        id: "10",
        name: "usdt",
        value: 70,
        tokenType: "stable",
        address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        icon: null,
        usdValue: 401689236.5432753,
      },
      {
        id: "1",
        name: "QUICK",
        value: 70,
        tokenType: "alt",
        address: "0x6c28aef8977c9b773996d0e8376d2ee379446f2f",
        icon: null,
        usdValue: 1514770.0657297657,
      },
      {
        id: "1",
        name: "BNB",
        value: 70,
        tokenType: "alt",
        address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
        icon: null,
        usdValue: 72645959.06684247,
      },
      {
        id: "1",
        name: "BLUESPARROW",
        value: 70,
        tokenType: "alt",
        address: "0x24ccedebf841544c9e6a62af4e8c2fa6e5a46fde",
        icon: null,
        usdValue: 31866.993152869272,
      },
      {
        id: "1",
        name: "REVV",
        value: 69,
        tokenType: "alt",
        address: "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
        icon: null,
        usdValue: 2611720.6880657785,
      },
      {
        id: "1",
        name: "EUL",
        value: 69,
        tokenType: "alt",
        address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
        icon: null,
        usdValue: 1938737.369752546,
      },
      {
        id: "56",
        name: "ID",
        value: 69,
        tokenType: "alt",
        address: "0x2dff88a56767223a5529ea5960da7a3f5f766406",
        icon: null,
        usdValue: 16126659.313859494,
      },
      {
        id: "42161",
        name: "FXS",
        value: 69,
        tokenType: "alt",
        address: "0x9d2F299715D94d8A7E6F5eaa8E654E8c74a988A7",
        icon: null,
        usdValue: 21391.87150144701,
      },
      {
        id: "1",
        name: "AURORA",
        value: 69,
        tokenType: "alt",
        address: "0xaaaaaa20d9e0e2461697782ef11675f668207961",
        icon: null,
        usdValue: 13826598.799196558,
      },
      {
        id: "1",
        name: "ATOR",
        value: 69,
        tokenType: "alt",
        address: "0x0f7b3f5a8fed821c5eb60049538a548db2d479ce",
        icon: null,
        usdValue: 68936835.47992037,
      },
      {
        id: "1",
        name: "PUSH",
        value: 68,
        tokenType: "alt",
        address: "0xf418588522d5dd018b425e472991e52ebbeeeeee",
        icon: null,
        usdValue: 3063624.9674839573,
      },
      {
        id: "1",
        name: "SWRV",
        value: 68,
        tokenType: "alt",
        address: "0xb8baa0e4287890a5f79863ab62b7f175cecbd433",
        icon: null,
        usdValue: 358558.8548360941,
      },
      {
        id: "1",
        name: "JAM",
        value: 68,
        tokenType: "alt",
        address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
        icon: null,
        usdValue: 5751974.383119511,
      },
      {
        id: "56",
        name: "SFP",
        value: 68,
        tokenType: "alt",
        address: "0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb",
        icon: null,
        usdValue: 4563977.166955891,
      },
      {
        id: "1",
        name: "CUDOS",
        value: 68,
        tokenType: "alt",
        address: "0x817bbdbc3e8a1204f3691d14bb44992841e3db35",
        icon: null,
        usdValue: 12044553.680396233,
      },
      {
        id: "1",
        name: "TRADE",
        value: 68,
        tokenType: "alt",
        address: "0x6F87D756DAf0503d08Eb8993686c7Fc01Dc44fB1",
        icon: null,
        usdValue: 3670083.200473929,
      },
      {
        id: "1",
        name: "MITH",
        value: 68,
        tokenType: "alt",
        address: "0x3893b9422cd5d70a81edeffe3d5a1c6a978310bb",
        icon: null,
        usdValue: 625465.3746856416,
      },
      {
        id: "10",
        name: "susd",
        value: 67,
        tokenType: "stable",
        address: "0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9",
        icon: null,
        usdValue: 127551.48063171908,
      },
      {
        id: "1",
        name: "MCO",
        value: 67,
        tokenType: "alt",
        address: "0xb63b606ac810a52cca15e44bb630fd42d8d1d83d",
        icon: null,
        usdValue: 2327530.1845583064,
      },
      {
        id: "1",
        name: "TROLL",
        value: 67,
        tokenType: "alt",
        address: "0xf8ebf4849F1Fa4FaF0DFF2106A173D3A6CB2eB3A",
        icon: null,
        usdValue: 6556190.080311208,
      },
      {
        id: "137",
        name: "DAI",
        value: 66,
        tokenType: "stable",
        address: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
        icon: null,
        usdValue: 1583806.6566447436,
      },
      {
        id: "1",
        name: "STMX",
        value: 66,
        tokenType: "alt",
        address: "0xbe9375c6a420d2eeb258962efb95551a5b722803",
        icon: null,
        usdValue: 727242.5387266906,
      },
      {
        id: "1",
        name: "NXRA",
        value: 66,
        tokenType: "alt",
        address: "0x644192291cc835A93d6330b24EA5f5FEdD0eEF9e",
        icon: null,
        usdValue: 24444565.32141925,
      },
      {
        id: "1",
        name: "RCN",
        value: 66,
        tokenType: "alt",
        address: "0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6",
        icon: null,
        usdValue: 204415.8464154977,
      },
      {
        id: "1",
        name: "USTC",
        value: 66,
        tokenType: "alt",
        address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
        icon: null,
        usdValue: 6568181.692302652,
      },
      {
        id: "1",
        name: "BEL",
        value: 66,
        tokenType: "alt",
        address: "0xa91ac63d040deb1b7a5e4d4134ad23eb0ba07e14",
        icon: null,
        usdValue: 16959912.750671122,
      },
      {
        id: "1",
        name: "FORT",
        value: 65,
        tokenType: "alt",
        address: "0x41545f8b9472d758bb669ed8eaeeecd7a9c4ec29",
        icon: null,
        usdValue: 8492713.030488819,
      },
      {
        id: "1",
        name: "ABT",
        value: 65,
        tokenType: "alt",
        address: "0xb98d4c97425d9908e66e53a6fdf673acca0be986",
        icon: null,
        usdValue: 31715403.8902768,
      },
      {
        id: "1",
        name: "AKITA",
        value: 65,
        tokenType: "alt",
        address: "0x3301ee63fb29f863f2333bd4466acb46cd8323e6",
        icon: null,
        usdValue: 14166841.997905739,
      },
      {
        id: "1",
        name: "WSB",
        value: 65,
        tokenType: "alt",
        address: "0x15F20f9DFDf96CCf6AC96653b7C0aBfe4A9C9f0f",
        icon: null,
        usdValue: 303617.2216484604,
      },
      {
        id: "1",
        name: "VR",
        value: 65,
        tokenType: "alt",
        address: "0x7d5121505149065b562c789a0145ed750e6e8cdd",
        icon: null,
        usdValue: 19926488.60462486,
      },
      {
        id: "1",
        name: "CERE",
        value: 64,
        tokenType: "alt",
        address: "0x2da719db753dfa10a62e140f436e1d67f2ddb0d6",
        icon: null,
        usdValue: 7332283.241468826,
      },
      {
        id: "1",
        name: "FOR",
        value: 64,
        tokenType: "alt",
        address: "0x1fcdce58959f536621d76f5b7ffb955baa5a672f",
        icon: null,
        usdValue: 3528325.241479323,
      },
      {
        id: "1",
        name: "TONCOIN",
        value: 64,
        tokenType: "alt",
        address: "0x582d872a1b094fc48f5de31d3b73f2d9be47def1",
        icon: null,
        usdValue: 28255084.45172612,
      },
      {
        id: "1",
        name: "BABYDOGE",
        value: 64,
        tokenType: "alt",
        address: "0xac8e13ecc30da7ff04b842f21a62a1fb0f10ebd5",
        icon: null,
        usdValue: 2691056.0329390997,
      },
      {
        id: "1",
        name: "ATA",
        value: 64,
        tokenType: "alt",
        address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
        icon: null,
        usdValue: 30769454.108163316,
      },
      {
        id: "1",
        name: "DEGO",
        value: 63,
        tokenType: "alt",
        address: "0x88ef27e69108b2633f8e1c184cc37940a075cc02",
        icon: null,
        usdValue: 58902989.347514704,
      },
      {
        id: "1",
        name: "FLX",
        value: 63,
        tokenType: "alt",
        address: "0x6243d8cea23066d098a15582d81a598b4e8391f4",
        icon: null,
        usdValue: 317798.6353136899,
      },
      {
        id: "56",
        name: "FLOKI",
        value: 63,
        tokenType: "alt",
        address: "0xfb5B838b6cfEEdC2873aB27866079AC55363D37E",
        icon: null,
        usdValue: 93674761.98131748,
      },
      {
        id: "1",
        name: "SOV",
        value: 63,
        tokenType: "alt",
        address: "0x2c5bc2ba3614fd27fcc7022ea71d9172e2632c16",
        icon: null,
        usdValue: 2395402.5024846094,
      },
      {
        id: "1",
        name: "EURT",
        value: 63,
        tokenType: "stable",
        address: "0xc581b735a1688071a1746c968e0798d642ede491",
        icon: null,
        usdValue: 5806231.375112695,
      },
      {
        id: "1",
        name: "RDN",
        value: 62,
        tokenType: "alt",
        address: "0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6",
        icon: null,
        usdValue: 468781.5828830483,
      },
      {
        id: "1",
        name: "SDAO",
        value: 62,
        tokenType: "alt",
        address: "0x993864e43caa7f7f12953ad6feb1d1ca635b875f",
        icon: null,
        usdValue: 8444446.405932833,
      },
      {
        id: "1",
        name: "BFC",
        value: 62,
        tokenType: "alt",
        address: "0x0c7D5ae016f806603CB1782bEa29AC69471CAb9c",
        icon: null,
        usdValue: 790646.9775519365,
      },
      {
        id: "1",
        name: "BEN",
        value: 62,
        tokenType: "alt",
        address: "0x9bf1D7D63dD7a4ce167CF4866388226EEefa702E",
        icon: null,
        usdValue: 45501.93843977731,
      },
      {
        id: "1",
        name: "DC",
        value: 62,
        tokenType: "alt",
        address: "0x7b4328c127b85369d9f82ca0503b000d09cf9180",
        icon: null,
        usdValue: 293423.37636367173,
      },
      {
        id: "1",
        name: "ML",
        value: 62,
        tokenType: "alt",
        address: "0x059956483753947536204e89bfaD909E1a434Cc6",
        icon: null,
        usdValue: 13632390.170347113,
      },
      {
        id: "1",
        name: "TOKE",
        value: 61,
        tokenType: "alt",
        address: "0x98ddc72bd02d448f68c4226f26122c66c5bd711e",
        icon: null,
        usdValue: 821672.5738439204,
      },
      {
        id: "10",
        name: "weth",
        value: 61,
        tokenType: "alt",
        address: "0x4200000000000000000000000000000000000006",
        icon: null,
        usdValue: 88937.55404640191,
      },
      {
        id: "1",
        name: "RFUEL",
        value: 61,
        tokenType: "alt",
        address: "0xaf9f549774ecedbd0966c52f250acc548d3f36e5",
        icon: null,
        usdValue: 120792.95899770931,
      },
      {
        id: "1",
        name: "DOG",
        value: 61,
        tokenType: "alt",
        address: "0xbaac2b4491727d78d2b78815144570b9f2fe8899",
        icon: null,
        usdValue: 3017574.662803781,
      },
      {
        id: "1",
        name: "KEEP",
        value: 61,
        tokenType: "alt",
        address: "0x85eee30c52b0b379b046fb0f85f4f3dc3009afec",
        icon: null,
        usdValue: 1609853.3148784337,
      },
      {
        id: "1",
        name: "GHX",
        value: 61,
        tokenType: "alt",
        address: "0x728f30fa2f100742c7949d1961804fa8e0b1387d",
        icon: null,
        usdValue: 37852313.76409748,
      },
      {
        id: "1",
        name: "OAX",
        value: 60,
        tokenType: "alt",
        address: "0x701c244b988a513c945973defa05de933b23fe1d",
        icon: null,
        usdValue: 3527684.401680334,
      },
      {
        id: "1",
        name: "SALT",
        value: 60,
        tokenType: "alt",
        address: "0x4156D3342D5c385a87D264F90653733592000581",
        icon: null,
        usdValue: 243429.95793709467,
      },
      {
        id: "1",
        name: "VAI",
        value: 60,
        tokenType: "alt",
        address: "0xD13cfD3133239a3c73a9E535A5c4DadEE36b395c",
        icon: null,
        usdValue: 18692545.04987891,
      },
      {
        id: "1",
        name: "LMR",
        value: 60,
        tokenType: "alt",
        address: "0x4b1d0b9f081468d780ca1d5d79132b64301085d1",
        icon: null,
        usdValue: 1438605.2638978143,
      },
      {
        id: "1",
        name: "OPUL",
        value: 60,
        tokenType: "alt",
        address: "0x80D55c03180349Fff4a229102F62328220A96444",
        icon: null,
        usdValue: 2846372.3143827836,
      },
      {
        id: "1",
        name: "XCAD",
        value: 60,
        tokenType: "alt",
        address: "0x7659ce147d0e714454073a5dd7003544234b6aa0",
        icon: null,
        usdValue: 6752323.132538871,
      },
      {
        id: "1",
        name: "QSP",
        value: 60,
        tokenType: "alt",
        address: "0x99ea4db9ee77acd40b119bd1dc4e33e1c070b80d",
        icon: null,
        usdValue: 469657.72904575506,
      },
      {
        id: "1",
        name: "TVK",
        value: 59,
        tokenType: "alt",
        address: "0xd084b83c305dafd76ae3e1b4e1f1fe2ecccb3988",
        icon: null,
        usdValue: 5507584.985796893,
      },
      {
        id: "1",
        name: "BYN",
        value: 59,
        tokenType: "alt",
        address: "0x4bb3205bf648b7f59ef90dee0f1b62f6116bc7ca",
        icon: null,
        usdValue: 96880.85558337517,
      },
      {
        id: "1",
        name: "ORAI",
        value: 59,
        tokenType: "alt",
        address: "0x4c11249814f11b9346808179cf06e71ac328c1b5",
        icon: null,
        usdValue: 6173113.155579895,
      },
      {
        id: "56",
        name: "WOM",
        value: 59,
        tokenType: "alt",
        address: "0xAD6742A35fB341A9Cc6ad674738Dd8da98b94Fb1",
        icon: null,
        usdValue: 259698.37715025456,
      },
      {
        id: "1",
        name: "WCFG",
        value: 59,
        tokenType: "alt",
        address: "0xc221b7e65ffc80de234bbb6667abdd46593d34f0",
        icon: null,
        usdValue: 34960019.031526156,
      },
      {
        id: "1",
        name: "EFI",
        value: 59,
        tokenType: "alt",
        address: "0x656c00e1bcd96f256f224ad9112ff426ef053733",
        icon: null,
        usdValue: 775702.2616875648,
      },
      {
        id: "1",
        name: "PERL",
        value: 59,
        tokenType: "alt",
        address: "0xeca82185adce47f39c684352b0439f030f860318",
        icon: null,
        usdValue: 710815.1642497289,
      },
      {
        id: "1",
        name: "HT",
        value: 59,
        tokenType: "alt",
        address: "0x6f259637dcd74c767781e37bc6133cd6a68aa161",
        icon: null,
        usdValue: 40903055.33381773,
      },
      {
        id: "42161",
        name: "VELA",
        value: 59,
        tokenType: "alt",
        address: "0x088cd8f5ef3652623c22d48b1605dcfe860cd704",
        icon: null,
        usdValue: 2125581.24829312,
      },
      {
        id: "1",
        name: "PNT",
        value: 59,
        tokenType: "alt",
        address: "0x89Ab32156e46F46D02ade3FEcbe5Fc4243B9AAeD",
        icon: null,
        usdValue: 379665.7422611366,
      },
      {
        id: "1",
        name: "LIFE",
        value: 59,
        tokenType: "alt",
        address: "0x6c936D4AE98E6d2172dB18c16C4b601C99918EE6",
        icon: null,
        usdValue: 209064.99968019346,
      },
      {
        id: "1",
        name: "DEXT",
        value: 58,
        tokenType: "alt",
        address: "0xfb7b4564402e5500db5bb6d63ae671302777c75a",
        icon: null,
        usdValue: 1548254.043613571,
      },
      {
        id: "1",
        name: "MTA",
        value: 58,
        tokenType: "alt",
        address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
        icon: null,
        usdValue: 114624.27564800823,
      },
      {
        id: "1",
        name: "OHM",
        value: 58,
        tokenType: "alt",
        address: "0x383518188c0c6d7730d91b2c03a03c837814a899",
        icon: null,
        usdValue: 1547750.6485243866,
      },
      {
        id: "1",
        name: "CND",
        value: 57,
        tokenType: "alt",
        address: "0xd4c435f5b09f855c3317c8524cb1f586e42795fa",
        icon: null,
        usdValue: 207549.79840132038,
      },
      {
        id: "1",
        name: "COVER",
        value: 57,
        tokenType: "alt",
        address: "0x4688a8b1f292fdab17e9a90c8bc379dc1dbd8713",
        icon: null,
        usdValue: 2070212.7823815113,
      },
      {
        id: "1",
        name: "MC",
        value: 57,
        tokenType: "alt",
        address: "0x949d48eca67b17269629c7194f4b727d4ef9e5d6",
        icon: null,
        usdValue: 653459.177831461,
      },
      {
        id: "1",
        name: "ROUTE",
        value: 57,
        tokenType: "alt",
        address: "0x16eccfdbb4ee1a85a33f3a9b21175cd7ae753db4",
        icon: null,
        usdValue: 8225745.636108583,
      },
      {
        id: "1",
        name: "SMT",
        value: 57,
        tokenType: "alt",
        address: "0xb17548c7b510427baac4e267bea62e800b247173",
        icon: null,
        usdValue: 12217664.69031947,
      },
      {
        id: "1",
        name: "WNCG",
        value: 57,
        tokenType: "alt",
        address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
        icon: null,
        usdValue: 5376914.117265971,
      },
      {
        id: "1",
        name: "LITH",
        value: 57,
        tokenType: "alt",
        address: "0x188e817b02e635d482ae4d81e25dda98a97c4a42",
        icon: null,
        usdValue: 8541482.364273708,
      },
      {
        id: "1",
        name: "SIS",
        value: 57,
        tokenType: "alt",
        address: "0xd38bb40815d2b0c2d2c866e0c72c5728ffc76dd9",
        icon: null,
        usdValue: 19802713.92179803,
      },
      {
        id: "1",
        name: "PRO",
        value: 57,
        tokenType: "alt",
        address: "0x226bb599a12c826476e3a771454697ea52e9e220",
        icon: null,
        usdValue: 12425728.156594051,
      },
      {
        id: "1",
        name: "GEL",
        value: 56,
        tokenType: "alt",
        address: "0x15b7c0c907e4c6b9adaaaabc300c08991d6cea05",
        icon: null,
        usdValue: 5058952.009053621,
      },
      {
        id: "56",
        name: "AVAX",
        value: 56,
        tokenType: "alt",
        address: "0x1CE0c2827e2eF14D5C4f29a091d735A204794041",
        icon: null,
        usdValue: 800766.1700498825,
      },
      {
        id: "1",
        name: "RIO",
        value: 56,
        tokenType: "alt",
        address: "0xf21661d0d1d76d3ecb8e1b9f1c923dbfffae4097",
        icon: null,
        usdValue: 2206203.5604223353,
      },
      {
        id: "1",
        name: "SUDO",
        value: 55,
        tokenType: "alt",
        address: "0x3446dd70b2d52a6bf4a5a192d9b0a161295ab7f9",
        icon: null,
        usdValue: 2238708.4972676574,
      },
      {
        id: "1",
        name: "KONO",
        value: 55,
        tokenType: "alt",
        address: "0x850aab69f0e0171a9a49db8be3e71351c8247df4",
        icon: null,
        usdValue: 824357.0761312504,
      },
      {
        id: "1",
        name: "CAW",
        value: 55,
        tokenType: "alt",
        address: "0xf3b9569f82b18aef890de263b84189bd33ebe452",
        icon: null,
        usdValue: 45558570.612103924,
      },
      {
        id: "56",
        name: "HAY",
        value: 55,
        tokenType: "stable",
        address: "0x0782b6d8c4551B9760e74c0545a9bCD90bdc41E5",
        icon: null,
        usdValue: 14060.007411749433,
      },
      {
        id: "1",
        name: "SWETH",
        value: 55,
        tokenType: "alt",
        address: "0xf951E335afb289353dc249e82926178EaC7DEd78",
        icon: null,
        usdValue: 420018.8789167432,
      },
      {
        id: "1",
        name: "POLC",
        value: 55,
        tokenType: "alt",
        address: "0xaa8330fb2b4d5d07abfe7a72262752a8505c6b37",
        icon: null,
        usdValue: 626588.2261687621,
      },
      {
        id: "1",
        name: "DREP",
        value: 55,
        tokenType: "alt",
        address: "0x3ab6ed69ef663bd986ee59205ccad8a20f98b4c2",
        icon: null,
        usdValue: 520403.1538564338,
      },
      {
        id: "1",
        name: "DEP",
        value: 55,
        tokenType: "alt",
        address: "0x1a3496c18d558bd9c6c8f609e1b129f67ab08163",
        icon: null,
        usdValue: 4884932.5154677555,
      },
      {
        id: "1",
        name: "SUKU",
        value: 55,
        tokenType: "alt",
        address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
        icon: null,
        usdValue: 1322123.236027387,
      },
      {
        id: "42161",
        name: "SPA",
        value: 54,
        tokenType: "alt",
        address: "0x5575552988a3a80504bbaeb1311674fcfd40ad4b",
        icon: null,
        usdValue: 512771.78863026365,
      },
      {
        id: "42161",
        name: "RDPX",
        value: 54,
        tokenType: "alt",
        address: "0x32eb7902d4134bf98a28b963d26de779af92a212",
        icon: null,
        usdValue: 1230255.292995398,
      },
      {
        id: "1",
        name: "NOIA",
        value: 54,
        tokenType: "alt",
        address: "0xa8c8CfB141A3bB59FEA1E2ea6B79b5ECBCD7b6ca",
        icon: null,
        usdValue: 1550479.8074173704,
      },
      {
        id: "1",
        name: "CONV",
        value: 54,
        tokenType: "alt",
        address: "0xc834fa996fa3bec7aad3693af486ae53d8aa8b50",
        icon: null,
        usdValue: 4613988.168032369,
      },
      {
        id: "1",
        name: "CULT",
        value: 54,
        tokenType: "alt",
        address: "0xf0f9d895aca5c8678f706fb8216fa22957685a13",
        icon: null,
        usdValue: 2455483.959561552,
      },
      {
        id: "56",
        name: "ADA",
        value: 54,
        tokenType: "alt",
        address: "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47",
        icon: null,
        usdValue: 966743.9185169043,
      },
      {
        id: "1",
        name: "SENATE",
        value: 54,
        tokenType: "alt",
        address: "0x34Be5b8C30eE4fDe069DC878989686aBE9884470",
        icon: null,
        usdValue: 514225.46138723346,
      },
      {
        id: "1",
        name: "COMBO",
        value: 54,
        tokenType: "alt",
        address: "0xfFffFffF2ba8F66D4e51811C5190992176930278",
        icon: null,
        usdValue: 169894.58659120198,
      },
      {
        id: "1",
        name: "BZZ",
        value: 54,
        tokenType: "alt",
        address: "0x19062190b1925b5b6689d7073fdfc8c2976ef8cb",
        icon: null,
        usdValue: 20579558.544230577,
      },
      {
        id: "1",
        name: "KRL",
        value: 54,
        tokenType: "alt",
        address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
        icon: null,
        usdValue: 5170057.167563901,
      },
      {
        id: "1",
        name: "MAGIC",
        value: 54,
        tokenType: "alt",
        address: "0xb0c7a3ba49c7a6eaba6cd4a96c55a1391070ac9a",
        icon: null,
        usdValue: 57163.703731869406,
      },
      {
        id: "1",
        name: "SWAP",
        value: 53,
        tokenType: "alt",
        address: "0xcc4304a31d09258b0029ea7fe63d032f52e44efe",
        icon: null,
        usdValue: 2284203.7362980153,
      },
      {
        id: "1",
        name: "PAW",
        value: 53,
        tokenType: "alt",
        address: "0xdc63269ea166b70d4780b3a11f5c825c2b761b01",
        icon: null,
        usdValue: 2141146.4809298986,
      },
      {
        id: "1",
        name: "DDIM",
        value: 53,
        tokenType: "alt",
        address: "0xfbeea1c75e4c4465cb2fccc9c6d6afe984558e20",
        icon: null,
        usdValue: 486392.3889412066,
      },
      {
        id: "1",
        name: "BDP",
        value: 53,
        tokenType: "alt",
        address: "0xf3dcbc6D72a4E1892f7917b7C43b74131Df8480e",
        icon: null,
        usdValue: 4510246.253178351,
      },
      {
        id: "1",
        name: "DATA",
        value: 53,
        tokenType: "alt",
        address: "0x0cf0ee63788a0849fe5297f3407f701e122cc023",
        icon: null,
        usdValue: 590548.5854428766,
      },
      {
        id: "1",
        name: "PNK",
        value: 53,
        tokenType: "alt",
        address: "0x93ed3fbe21207ec2e8f2d3c3de6e058cb73bc04d",
        icon: null,
        usdValue: 3778981.093442136,
      },
      {
        id: "1",
        name: "GOG",
        value: 53,
        tokenType: "alt",
        address: "0x9ab7bb7fdc60f4357ecfef43986818a2a3569c62",
        icon: null,
        usdValue: 5865207.451913093,
      },
      {
        id: "1",
        name: "OMI",
        value: 53,
        tokenType: "alt",
        address: "0xed35af169af46a02ee13b9d79eb57d6d68c1749e",
        icon: null,
        usdValue: 11480671.589643847,
      },
      {
        id: "1",
        name: "VEGA",
        value: 53,
        tokenType: "alt",
        address: "0xcb84d72e61e383767c4dfeb2d8ff7f4fb89abc6e",
        icon: null,
        usdValue: 1581726.7910519845,
      },
      {
        id: "1",
        name: "DOSE",
        value: 53,
        tokenType: "alt",
        address: "0xb31ef9e52d94d4120eb44fe1ddfde5b4654a6515",
        icon: null,
        usdValue: 7903503.623106981,
      },
      {
        id: "1",
        name: "SAITAMA",
        value: 52,
        tokenType: "alt",
        address: "0xce3f08e664693ca792cace4af1364d5e220827b2",
        icon: null,
        usdValue: 4208486.081728108,
      },
      {
        id: "1",
        name: "XDEFI",
        value: 52,
        tokenType: "alt",
        address: "0x72b886d09c117654ab7da13a14d603001de0b777",
        icon: null,
        usdValue: 2348695.0071503073,
      },
      {
        id: "1",
        name: "LEO",
        value: 52,
        tokenType: "alt",
        address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
        icon: null,
        usdValue: 86074360.71178716,
      },
      {
        id: "1",
        name: "GMEE",
        value: 52,
        tokenType: "alt",
        address: "0xd9016a907dc0ecfa3ca425ab20b6b785b42f2373",
        icon: null,
        usdValue: 3754130.8611231083,
      },
      {
        id: "1",
        name: "DMTR",
        value: 52,
        tokenType: "alt",
        address: "0x51cb253744189f11241becb29bedd3f1b5384fdb",
        icon: null,
        usdValue: 18490895.323633082,
      },
      {
        id: "1",
        name: "MXC",
        value: 52,
        tokenType: "alt",
        address: "0x5ca381bbfb58f0092df149bd3d243b08b9a8386e",
        icon: null,
        usdValue: 1715101.833570569,
      },
      {
        id: "1",
        name: "LBA",
        value: 52,
        tokenType: "alt",
        address: "0xfe5f141bf94fe84bc28ded0ab966c16b17490657",
        icon: null,
        usdValue: 372062.47647683835,
      },
      {
        id: "42161",
        name: "PLS",
        value: 51,
        tokenType: "alt",
        address: "0x51318b7d00db7acc4026c88c3952b66278b6a67f",
        icon: null,
        usdValue: 1126895.2150068814,
      },
      {
        id: "1",
        name: "KINE",
        value: 51,
        tokenType: "alt",
        address: "0xcbfef8fdd706cde6f208460f2bf39aa9c785f05d",
        icon: null,
        usdValue: 5087048.0958467405,
      },
      {
        id: "56",
        name: "DOGE",
        value: 51,
        tokenType: "alt",
        address: "0xba2ae424d960c26247dd6c32edc70b295c744c43",
        icon: null,
        usdValue: 17149670.47431528,
      },
      {
        id: "1",
        name: "VEMP",
        value: 51,
        tokenType: "alt",
        address: "0xcfeb09c3c5f0f78ad72166d55f9e6e9a60e96eec",
        icon: null,
        usdValue: 1045895.7909214575,
      },
      {
        id: "1",
        name: "PROS",
        value: 51,
        tokenType: "alt",
        address: "0x8642A849D0dcb7a15a974794668ADcfbe4794B56",
        icon: null,
        usdValue: 113252623.51762208,
      },
      {
        id: "1",
        name: "FUSE",
        value: 51,
        tokenType: "alt",
        address: "0x970b9bb2c0444f5e81e9d0efb84c8ccdcdcaf84d",
        icon: null,
        usdValue: 1711120.5870723522,
      },
      {
        id: "1",
        name: "SOLVE",
        value: 51,
        tokenType: "alt",
        address: "0x446c9033e7516d820cc9a2ce2d0b7328b579406f",
        icon: null,
        usdValue: 1456430.4747495127,
      },
      {
        id: "1",
        name: "SWFTC",
        value: 51,
        tokenType: "alt",
        address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
        icon: null,
        usdValue: 20708684.4090681,
      },
      {
        id: "1",
        name: "RACA",
        value: 51,
        tokenType: "alt",
        address: "0x12BB890508c125661E03b09EC06E404bc9289040",
        icon: null,
        usdValue: 3633578.8750961674,
      },
      {
        id: "1",
        name: "CRPT",
        value: 51,
        tokenType: "alt",
        address: "0x08389495D7456E1951ddF7c3a1314A4bfb646d8B",
        icon: null,
        usdValue: 1619418.8585430714,
      },
      {
        id: "1",
        name: "BIT",
        value: 50,
        tokenType: "alt",
        address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
        icon: null,
        usdValue: 71957625.73878065,
      },
      {
        id: "1",
        name: "BEND",
        value: 50,
        tokenType: "alt",
        address: "0x0d02755a5700414b26ff040e1de35d337df56218",
        icon: null,
        usdValue: 215935.7247099573,
      },
      {
        id: "1",
        name: "OPTIMUS",
        value: 50,
        tokenType: "alt",
        address: "0x562e362876c8aee4744fc2c6aac8394c312d215d",
        icon: null,
        usdValue: 6765408.878380241,
      },
      {
        id: "1",
        name: "LCX",
        value: 50,
        tokenType: "alt",
        address: "0x037a54aab062628c9bbae1fdb1583c195585fe41",
        icon: null,
        usdValue: 11271978.757948663,
      },
      {
        id: "1",
        name: "ALEPH",
        value: 50,
        tokenType: "alt",
        address: "0x27702a26126e0b3702af63ee09ac4d1a084ef628",
        icon: null,
        usdValue: 2949278.748631708,
      },
      {
        id: "1",
        name: "FREE",
        value: 50,
        tokenType: "alt",
        address: "0x4cd0c43b0d53bc318cc5342b77eb6f124e47f526",
        icon: null,
        usdValue: 1134539.553699425,
      },
      {
        id: "56",
        name: "THE",
        value: 50,
        tokenType: "alt",
        address: "0xF4C8E32EaDEC4BFe97E0F595AdD0f4450a863a11",
        icon: null,
        usdValue: 7452645.318405521,
      },
      {
        id: "1",
        name: "pepecoin",
        value: 50,
        tokenType: "alt",
        address: "0xA9E8aCf069C58aEc8825542845Fd754e41a9489A",
        icon: null,
        usdValue: 25499697.53331949,
      },
      {
        id: "1",
        name: "NU",
        value: 50,
        tokenType: "alt",
        address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
        icon: null,
        usdValue: 425709.7814573025,
      },
      {
        id: "1",
        name: "XPR",
        value: 50,
        tokenType: "alt",
        address: "0xd7efb00d12c2c13131fd319336fdf952525da2af",
        icon: null,
        usdValue: 3152034.714821224,
      },
      {
        id: "1",
        name: "TCT",
        value: 50,
        tokenType: "alt",
        address: "0x4824a7b64e3966b0133f4f4ffb1b9d6beb75fff7",
        icon: null,
        usdValue: 1248862.0364438575,
      },
      {
        id: "1",
        name: "CRU",
        value: 49,
        tokenType: "alt",
        address: "0x32a7c02e79c4ea1008dd6564b35f131428673c41",
        icon: null,
        usdValue: 496765.75648184883,
      },
      {
        id: "1",
        name: "EUROC",
        value: 49,
        tokenType: "stable",
        address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
        icon: null,
        usdValue: 1010475.6749914653,
      },
      {
        id: "1",
        name: "CEEK",
        value: 49,
        tokenType: "alt",
        address: "0xb056c38f6b7dc4064367403e26424cd2c60655e1",
        icon: null,
        usdValue: 12066564.41223249,
      },
      {
        id: "1",
        name: "HOPR",
        value: 49,
        tokenType: "alt",
        address: "0xf5581dfefd8fb0e4aec526be659cfab1f8c781da",
        icon: null,
        usdValue: 7658623.952775647,
      },
      {
        id: "56",
        name: "XVS",
        value: 49,
        tokenType: "alt",
        address: "0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63",
        icon: null,
        usdValue: 4306293.137311914,
      },
      {
        id: "1",
        name: "GLQ",
        value: 49,
        tokenType: "alt",
        address: "0x9f9c8ec3534c3ce16f928381372bfbfbfb9f4d24",
        icon: null,
        usdValue: 870389.122861158,
      },
      {
        id: "1",
        name: "ASTO",
        value: 49,
        tokenType: "alt",
        address: "0x823556202e86763853b40e9cde725f412e294689",
        icon: null,
        usdValue: 7314966.283615696,
      },
      {
        id: "56",
        name: "LINK",
        value: 48,
        tokenType: "alt",
        address: "0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd",
        icon: null,
        usdValue: 1037029.428433027,
      },
      {
        id: "1",
        name: "PSP",
        value: 48,
        tokenType: "alt",
        address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
        icon: null,
        usdValue: 1699826.7895582786,
      },
      {
        id: "1",
        name: "FRAX",
        value: 48,
        tokenType: "stable",
        address: "0x853d955acef822db058eb8505911ed77f175b99e",
        icon: null,
        usdValue: 77518.3480142611,
      },
      {
        id: "56",
        name: "FXS",
        value: 48,
        tokenType: "alt",
        address: "0xe48A3d7d0Bc88d552f730B62c006bC925eadB9eE",
        icon: null,
        usdValue: 7693.6176399313135,
      },
      {
        id: "1",
        name: "HAPI",
        value: 48,
        tokenType: "alt",
        address: "0xD9c2D319Cd7e6177336b0a9c93c21cb48d84Fb54",
        icon: null,
        usdValue: 3083461.461161742,
      },
      {
        id: "56",
        name: "FIL",
        value: 48,
        tokenType: "alt",
        address: "0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153",
        icon: null,
        usdValue: 818307.3920204685,
      },
      {
        id: "56",
        name: "GAL",
        value: 48,
        tokenType: "alt",
        address: "0xe4cc45bb5dbda06db6183e8bf016569f40497aa5",
        icon: null,
        usdValue: 191475.80990392645,
      },
      {
        id: "1",
        name: "CBK",
        value: 48,
        tokenType: "alt",
        address: "0xD85a6Ae55a7f33B0ee113C234d2EE308EdeAF7fD",
        icon: null,
        usdValue: 4392358.757804492,
      },
      {
        id: "1",
        name: "MDA",
        value: 48,
        tokenType: "alt",
        address: "0x51db5ad35c671a87207d88fc11d593ac0c8415bd",
        icon: null,
        usdValue: 1266618.1995339473,
      },
      {
        id: "1",
        name: "MTH",
        value: 47,
        tokenType: "alt",
        address: "0xaf4dce16da2877f8c9e00544c93b62ac40631f16",
        icon: null,
        usdValue: 395652.332272536,
      },
      {
        id: "137",
        name: "INS",
        value: 47,
        tokenType: "alt",
        address: "0xb988bd378a0754957d5d9471c96e0f8051645a26",
        icon: null,
        usdValue: 859.2259221942436,
      },
      {
        id: "1",
        name: "0X0",
        value: 47,
        tokenType: "alt",
        address: "0x5a3e6a77ba2f983ec0d371ea3b475f8bc0811ad5",
        icon: null,
        usdValue: 11991346.764087865,
      },
      {
        id: "1",
        name: "NCT",
        value: 47,
        tokenType: "alt",
        address: "0x8a9c4dfe8b9d8962b31e4e16f8321c44d48e246e",
        icon: null,
        usdValue: 2266328.559841858,
      },
      {
        id: "56",
        name: "GMT",
        value: 47,
        tokenType: "alt",
        address: "0x3019BF2a2eF8040C242C9a4c5c4BD4C81678b2A1",
        icon: null,
        usdValue: 4855191.968988521,
      },
      {
        id: "1",
        name: "LAMB",
        value: 47,
        tokenType: "alt",
        address: "0x8971f9fd7196e5cee2c1032b50f656855af7dd26",
        icon: null,
        usdValue: 28446609.769529156,
      },
      {
        id: "1",
        name: "XRT",
        value: 46,
        tokenType: "alt",
        address: "0x7de91b204c1c737bcee6f000aaa6569cf7061cb7",
        icon: null,
        usdValue: 242014.2198653274,
      },
      {
        id: "1",
        name: "WSTETH",
        value: 46,
        tokenType: "alt",
        address: "0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0",
        icon: null,
        usdValue: 126902258.90022253,
      },
      {
        id: "1",
        name: "AURA",
        value: 46,
        tokenType: "alt",
        address: "0xc0c293ce456ff0ed870add98a0828dd4d2903dbf",
        icon: null,
        usdValue: 74914.4913166283,
      },
      {
        id: "1",
        name: "TXA",
        value: 46,
        tokenType: "alt",
        address: "0x4463e6A3dEd0dBE3F6e15bC8420dFc55e5FeA830",
        icon: null,
        usdValue: 284706.14465930907,
      },
      {
        id: "56",
        name: "DAI",
        value: 46,
        tokenType: "stable",
        address: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
        icon: null,
        usdValue: 12763016.691026926,
      },
      {
        id: "56",
        name: "RACA",
        value: 46,
        tokenType: "alt",
        address: "0x12bb890508c125661e03b09ec06e404bc9289040",
        icon: null,
        usdValue: 12476192.590549292,
      },
      {
        id: "1",
        name: "SPA",
        value: 46,
        tokenType: "alt",
        address: "0xB4A3B0Faf0Ab53df58001804DdA5Bfc6a3D59008",
        icon: null,
        usdValue: 6495527.544363385,
      },
      {
        id: "1",
        name: "NAVI",
        value: 46,
        tokenType: "alt",
        address: "0xFc1C93a2507975E98b9d0E9260Ded61A00152BF1",
        icon: null,
        usdValue: 9529084.218387095,
      },
      {
        id: "56",
        name: "HOOK",
        value: 46,
        tokenType: "alt",
        address: "0xa260E12d2B924cb899AE80BB58123ac3fEE1E2F0",
        icon: null,
        usdValue: 28296996.022855267,
      },
      {
        id: "1",
        name: "LBL",
        value: 46,
        tokenType: "alt",
        address: "0x2162f572B25f7358db9376AB58a947a4e45CeDE1",
        icon: null,
        usdValue: 538450.605538379,
      },
      {
        id: "1",
        name: "PAINT",
        value: 45,
        tokenType: "alt",
        address: "0x4c6ec08cf3fc987c6c4beb03184d335a2dfc4042",
        icon: null,
        usdValue: 463074.8537170842,
      },
      {
        id: "56",
        name: "SPAY",
        value: 45,
        tokenType: "alt",
        address: "0x13a637026df26f846d55acc52775377717345c06",
        icon: null,
        usdValue: 672640.0938572963,
      },
      {
        id: "137",
        name: "WBTC",
        value: 45,
        tokenType: "alt",
        address: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
        icon: null,
        usdValue: 34689.198628344006,
      },
      {
        id: "1",
        name: "LSD",
        value: 45,
        tokenType: "alt",
        address: "0xfAC77A24E52B463bA9857d6b758ba41aE20e31FF",
        icon: null,
        usdValue: 71371.8102834428,
      },
      {
        id: "1",
        name: "ZIG",
        value: 45,
        tokenType: "alt",
        address: "0xb2617246d0c6c0087f18703d576831899ca94f01",
        icon: null,
        usdValue: 111986360.46393824,
      },
      {
        id: "1",
        name: "O3",
        value: 45,
        tokenType: "alt",
        address: "0xEe9801669C6138E84bD50dEB500827b776777d28",
        icon: null,
        usdValue: 68536.05668041902,
      },
      {
        id: "1",
        name: "EDEN",
        value: 45,
        tokenType: "alt",
        address: "0x1559fa1b8f28238fd5d76d9f434ad86fd20d1559",
        icon: null,
        usdValue: 506278.4891776136,
      },
      {
        id: "1",
        name: "STRK",
        value: 45,
        tokenType: "alt",
        address: "0x74232704659ef37c08995e386a2e26cc27a8d7b1",
        icon: null,
        usdValue: 996116.5378132145,
      },
      {
        id: "1",
        name: "$SPONGE",
        value: 45,
        tokenType: "alt",
        address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
        icon: null,
        usdValue: 187138.00274685043,
      },
      {
        id: "1",
        name: "GF",
        value: 44,
        tokenType: "alt",
        address: "0xaaef88cea01475125522e117bfe45cf32044e238",
        icon: null,
        usdValue: 202515.438124447,
      },
      {
        id: "1",
        name: "VEE",
        value: 44,
        tokenType: "alt",
        address: "0x340d2bde5eb28c1eed91b2f790723e3b160613b7",
        icon: null,
        usdValue: 2468881.836468304,
      },
      {
        id: "1",
        name: "ALD",
        value: 44,
        tokenType: "alt",
        address: "0xb26c4b3ca601136daf98593feaeff9e0ca702a8d",
        icon: null,
        usdValue: 82768.24006275224,
      },
      {
        id: "56",
        name: "STG",
        value: 44,
        tokenType: "alt",
        address: "0xb0d502e938ed5f4df2e681fe6e419ff29631d62b",
        icon: null,
        usdValue: 165107.64660213207,
      },
      {
        id: "1",
        name: "BONDLY",
        value: 44,
        tokenType: "alt",
        address: "0x91dfbee3965baaee32784c2d546b7a0c62f268c9",
        icon: null,
        usdValue: 362051.06166690314,
      },
      {
        id: "1",
        name: "CELL",
        value: 44,
        tokenType: "alt",
        address: "0x26c8afbbfe1ebaca03c2bb082e69d0476bffe099",
        icon: null,
        usdValue: 3078121.8976053265,
      },
      {
        id: "1",
        name: "LON",
        value: 44,
        tokenType: "alt",
        address: "0x0000000000095413afc295d19edeb1ad7b71c952",
        icon: null,
        usdValue: 5823123.450875928,
      },
      {
        id: "1",
        name: "NCASH",
        value: 44,
        tokenType: "alt",
        address: "0x809826cceab68c387726af962713b64cb5cb3cca",
        icon: null,
        usdValue: 245335.56895813093,
      },
      {
        id: "1",
        name: "weETH",
        value: 44,
        tokenType: "alt",
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        icon: null,
        usdValue: 11070258.061059037,
      },
      {
        id: "1",
        name: "BRD",
        value: 44,
        tokenType: "alt",
        address: "0x558ec3152e2eb2174905cd19aea4e34a23de9ad6",
        icon: null,
        usdValue: 316313.55005537154,
      },
      {
        id: "56",
        name: "XRP",
        value: 43,
        tokenType: "alt",
        address: "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe",
        icon: null,
        usdValue: 353291.4698955358,
      },
      {
        id: "56",
        name: "WMX",
        value: 43,
        tokenType: "alt",
        address: "0xa75d9ca2a0a1D547409D82e1B06618EC284A2CeD",
        icon: null,
        usdValue: 1149.2862743101869,
      },
      {
        id: "1",
        name: "UNO",
        value: 43,
        tokenType: "alt",
        address: "0x474021845c4643113458ea4414bdb7fb74a01a77",
        icon: null,
        usdValue: 1334748.8815920278,
      },
      {
        id: "1",
        name: "ONX",
        value: 43,
        tokenType: "alt",
        address: "0xe0ad1806fd3e7edf6ff52fdb822432e847411033",
        icon: null,
        usdValue: 96733.59376818979,
      },
      {
        id: "56",
        name: "DOT",
        value: 43,
        tokenType: "alt",
        address: "0x7083609fce4d1d8dc0c979aab8c869ea2c873402",
        icon: null,
        usdValue: 2259779.409309726,
      },
      {
        id: "1",
        name: "EQX",
        value: 43,
        tokenType: "alt",
        address: "0xbd3de9a069648c84d27d74d701c9fa3253098b15",
        icon: null,
        usdValue: 574662.6417647265,
      },
      {
        id: "1",
        name: "RAIN",
        value: 43,
        tokenType: "alt",
        address: "0x71Fc1F555a39E0B698653AB0b475488EC3c34D57",
        icon: null,
        usdValue: 1867109.4588915436,
      },
      {
        id: "1",
        name: "CHO",
        value: 43,
        tokenType: "alt",
        address: "0xBBa39Fd2935d5769116ce38d46a71bde9cf03099",
        icon: null,
        usdValue: 6511172.421922155,
      },
      {
        id: "1",
        name: "MULTI",
        value: 43,
        tokenType: "alt",
        address: "0x65ef703f5594d2573eb71aaf55bc0cb548492df4",
        icon: null,
        usdValue: 517630.4159584449,
      },
      {
        id: "1",
        name: "SYLO",
        value: 43,
        tokenType: "alt",
        address: "0xf293d23bf2cdc05411ca0eddd588eb1977e8dcd4",
        icon: null,
        usdValue: 1981115.4618225165,
      },
      {
        id: "1",
        name: "EVX",
        value: 43,
        tokenType: "alt",
        address: "0xf3db5fa2c66b7af3eb0c0b782510816cbe4813b8",
        icon: null,
        usdValue: 34199.84686610277,
      },
      {
        id: "1",
        name: "SFI",
        value: 42,
        tokenType: "alt",
        address: "0xb753428af26e81097e7fd17f40c88aaa3e04902c",
        icon: null,
        usdValue: 227781.1977829953,
      },
      {
        id: "137",
        name: "PYR",
        value: 42,
        tokenType: "alt",
        address: "0x430ef9263e76dae63c84292c3409d61c598e9682",
        icon: null,
        usdValue: 3056336.672664346,
      },
      {
        id: "1",
        name: "RAI",
        value: 42,
        tokenType: "stable",
        address: "0x03ab458634910aad20ef5f1c8ee96f1d6ac54919",
        icon: null,
        usdValue: 61361.322905204244,
      },
      {
        id: "1",
        name: "VSP",
        value: 42,
        tokenType: "alt",
        address: "0x1b40183efb4dd766f11bda7a7c3ad8982e998421",
        icon: null,
        usdValue: 71383.47577656806,
      },
      {
        id: "1",
        name: "PICKLE",
        value: 42,
        tokenType: "alt",
        address: "0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5",
        icon: null,
        usdValue: 369105.64715790766,
      },
      {
        id: "56",
        name: "MATIC",
        value: 42,
        tokenType: "alt",
        address: "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
        icon: null,
        usdValue: 1096919.5047636754,
      },
      {
        id: "56",
        name: "WNEAR",
        value: 42,
        tokenType: "alt",
        address: "0x1fa4a73a3f0133f0025378af00236f3abdee5d63",
        icon: null,
        usdValue: 1206014.0426424013,
      },
      {
        id: "1",
        name: "CORE",
        value: 41,
        tokenType: "alt",
        address: "0x62359ed7505efc61ff1d56fef82158ccaffa23d7",
        icon: null,
        usdValue: 62128.14976618731,
      },
      {
        id: "1",
        name: "LAYER",
        value: 41,
        tokenType: "alt",
        address: "0x0fF6ffcFDa92c53F615a4A75D982f399C989366b",
        icon: null,
        usdValue: 1009047.8448854395,
      },
      {
        id: "1",
        name: "QOM",
        value: 41,
        tokenType: "alt",
        address: "0xa71d0588eaf47f12b13cf8ec750430d21df04974",
        icon: null,
        usdValue: 1716622.103956106,
      },
      {
        id: "1",
        name: "INV",
        value: 41,
        tokenType: "alt",
        address: "0x41d5d79431a913c4ae7d69a668ecdfe5ff9dfb68",
        icon: null,
        usdValue: 902357.8268804301,
      },
      {
        id: "1",
        name: "KEX",
        value: 41,
        tokenType: "alt",
        address: "0x16980b3B4a3f9D89E33311B5aa8f80303E5ca4F8",
        icon: null,
        usdValue: 1064321.8981639931,
      },
      {
        id: "1",
        name: "MTLX",
        value: 41,
        tokenType: "alt",
        address: "0x2e1E15C44Ffe4Df6a0cb7371CD00d5028e571d14",
        icon: null,
        usdValue: 818699.0763623974,
      },
      {
        id: "1",
        name: "RAZOR",
        value: 41,
        tokenType: "alt",
        address: "0x50de6856358cc35f3a9a57eaaa34bd4cb707d2cd",
        icon: null,
        usdValue: 543977.4433269445,
      },
      {
        id: "56",
        name: "UNI",
        value: 41,
        tokenType: "alt",
        address: "0xbf5140a22578168fd562dccf235e5d43a02ce9b1",
        icon: null,
        usdValue: 245623.99822934004,
      },
      {
        id: "1",
        name: "EPIK",
        value: 41,
        tokenType: "alt",
        address: "0x4da0c48376c277cdbd7fc6fdc6936dee3e4adf75",
        icon: null,
        usdValue: 3001842.7043910846,
      },
      {
        id: "1",
        name: "FEG",
        value: 41,
        tokenType: "alt",
        address: "0x389999216860ab8e0175387a0c90e5c52522c945",
        icon: null,
        usdValue: 68999.0456791218,
      },
      {
        id: "56",
        name: "SFUND",
        value: 41,
        tokenType: "alt",
        address: "0x477bc8d23c634c154061869478bce96be6045d12",
        icon: null,
        usdValue: 17185705.462008845,
      },
      {
        id: "1",
        name: "USDD",
        value: 41,
        tokenType: "stable",
        address: "0x0c10bf8fcb7bf5412187a595ab97a3609160b5c6",
        icon: null,
        usdValue: 1569463.7349445256,
      },
      {
        id: "1",
        name: "IZI",
        value: 41,
        tokenType: "alt",
        address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
        icon: null,
        usdValue: 5242391.077365218,
      },
      {
        id: "1",
        name: "ELT",
        value: 41,
        tokenType: "alt",
        address: "0xc0ae17eb994fa828540ffa53776b3830233a1b02",
        icon: null,
        usdValue: 480692.398874465,
      },
      {
        id: "56",
        name: "ALPACA",
        value: 40,
        tokenType: "alt",
        address: "0x8f0528ce5ef7b51152a59745befdd91d97091d2f",
        icon: null,
        usdValue: 2493066.091944559,
      },
      {
        id: "42161",
        name: "LPT",
        value: 40,
        tokenType: "alt",
        address: "0x289ba1701c2f088cf0faf8b3705246331cb8a839",
        icon: null,
        usdValue: 548355.0590979101,
      },
      {
        id: "1",
        name: "SNM",
        value: 40,
        tokenType: "alt",
        address: "0x983f6d60db79ea8ca4eb9968c6aff8cfa04b3c63",
        icon: null,
        usdValue: 24500.438257591282,
      },
      {
        id: "42161",
        name: "SUSHI",
        value: 40,
        tokenType: "alt",
        address: "0xd4d42f0b6def4ce0383636770ef773390d85c61a",
        icon: null,
        usdValue: 115438.78404512042,
      },
      {
        id: "1",
        name: "LUSD",
        value: 40,
        tokenType: "stable",
        address: "0x5f98805a4e8be255a32880fdec7f6728c6568ba0",
        icon: null,
        usdValue: 258534.5194691043,
      },
      {
        id: "1",
        name: "UBT",
        value: 40,
        tokenType: "alt",
        address: "0x8400d94a5cb0fa0d041a3788e395285d61c9ee5e",
        icon: null,
        usdValue: 171473.66968386754,
      },
      {
        id: "1",
        name: "X2Y2",
        value: 40,
        tokenType: "alt",
        address: "0x1e4ede388cbc9f4b5c79681b7f94d36a11abebc9",
        icon: null,
        usdValue: 633979.1189584028,
      },
      {
        id: "1",
        name: "MNW",
        value: 40,
        tokenType: "alt",
        address: "0xd3e4ba569045546d09cf021ecc5dfe42b1d7f6e4",
        icon: null,
        usdValue: 4429415.855985657,
      },
      {
        id: "1",
        name: "DG",
        value: 40,
        tokenType: "alt",
        address: "0x4b520c812e8430659fc9f12f6d0c39026c83588d",
        icon: null,
        usdValue: 194283.0356014296,
      },
      {
        id: "1",
        name: "OVR",
        value: 40,
        tokenType: "alt",
        address: "0x21bfbda47a0b4b5b1248c767ee49f7caa9b23697",
        icon: null,
        usdValue: 2435702.686055122,
      },
      {
        id: "1",
        name: "CREDI",
        value: 40,
        tokenType: "alt",
        address: "0xaE6e307c3Fe9E922E5674DBD7F830Ed49c014c6B",
        icon: null,
        usdValue: 6533547.670453632,
      },
      {
        id: "1",
        name: "WBETH",
        value: 40,
        tokenType: "alt",
        address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
        icon: null,
        usdValue: 5480647514.311469,
      },
      {
        id: "1",
        name: "MATH",
        value: 40,
        tokenType: "alt",
        address: "0x08d967bb0134f2d07f7cfb6e246680c53927dd30",
        icon: null,
        usdValue: 3706609.583900882,
      },
      {
        id: "1",
        name: "VRA",
        value: 40,
        tokenType: "alt",
        address: "0xdf1d6405df92d981a2fb3ce68f6a03bac6c0e41f",
        icon: null,
        usdValue: 4416664.361692333,
      },
      {
        id: "1",
        name: "EZ",
        value: 40,
        tokenType: "alt",
        address: "0x00aba6fe5557de1a1d565658cbddddf7c710a1eb",
        icon: null,
        usdValue: 223558.39260059732,
      },
      {
        id: "1",
        name: "TRVL",
        value: 40,
        tokenType: "alt",
        address: "0xd47bdf574b4f76210ed503e0efe81b58aa061f3d",
        icon: null,
        usdValue: 4701569.041560854,
      },
      {
        id: "1",
        name: "GYEN",
        value: 40,
        tokenType: "stable",
        address: "0xc08512927d12348f6620a698105e1baac6ecd911",
        icon: null,
        usdValue: 681494.1809046357,
      },
      {
        id: "1",
        name: "POOL",
        value: 39,
        tokenType: "alt",
        address: "0x0cec1a9154ff802e7934fc916ed7ca50bde6844e",
        icon: null,
        usdValue: 304716.1461741916,
      },
      {
        id: "1",
        name: "DZOO",
        value: 39,
        tokenType: "alt",
        address: "0xc97d6C52F3ADD91Fa1c5287a453d7444aECBca83",
        icon: null,
        usdValue: 53873.51081797541,
      },
      {
        id: "1",
        name: "ZKP",
        value: 39,
        tokenType: "alt",
        address: "0x909E34d3f6124C324ac83DccA84b74398a6fa173",
        icon: null,
        usdValue: 221124.95793692188,
      },
      {
        id: "1",
        name: "JPEG",
        value: 39,
        tokenType: "alt",
        address: "0xE80C0cd204D654CEbe8dd64A4857cAb6Be8345a3",
        icon: null,
        usdValue: 267953.05256827554,
      },
      {
        id: "1",
        name: "CGG",
        value: 39,
        tokenType: "alt",
        address: "0x1fe24f25b1cf609b9c4e7e12d802e3640dfa5e43",
        icon: null,
        usdValue: 321875.49564991734,
      },
      {
        id: "56",
        name: "BNX",
        value: 39,
        tokenType: "alt",
        address: "0x8c851d1a123ff703bd1f9dabe631b69902df5f97",
        icon: null,
        usdValue: 6645382.657030368,
      },
      {
        id: "1",
        name: "FOLD",
        value: 39,
        tokenType: "alt",
        address: "0xd084944d3c05cd115c09d072b9f44ba3e0e45921",
        icon: null,
        usdValue: 1008946.7931099404,
      },
      {
        id: "1",
        name: "INSUR",
        value: 39,
        tokenType: "alt",
        address: "0x544c42fbb96b39b21df61cf322b5edc285ee7429",
        icon: null,
        usdValue: 333780.62710805115,
      },
      {
        id: "56",
        name: "CGPT",
        value: 39,
        tokenType: "alt",
        address: "0x9840652DC04fb9db2C43853633f0F62BE6f00f98",
        icon: null,
        usdValue: 50223094.261533126,
      },
      {
        id: "1",
        name: "BRWL",
        value: 39,
        tokenType: "alt",
        address: "0x4086e77c5e993fdb90a406285d00111a974f877a",
        icon: null,
        usdValue: 3162747.4237724487,
      },
      {
        id: "1",
        name: "OCC",
        value: 39,
        tokenType: "alt",
        address: "0x2f109021afe75b949429fe30523ee7c0d5b27207",
        icon: null,
        usdValue: 1868337.4319405844,
      },
      {
        id: "1",
        name: "BTRST",
        value: 39,
        tokenType: "alt",
        address: "0x799ebfabe77a6e34311eeee9825190b9ece32824",
        icon: null,
        usdValue: 3499476.2610628926,
      },
      {
        id: "1",
        name: "RING",
        value: 38,
        tokenType: "alt",
        address: "0x9469d013805bffb7d3debe5e7839237e535ec483",
        icon: null,
        usdValue: 565987.8830918112,
      },
      {
        id: "1",
        name: "YAM",
        value: 38,
        tokenType: "alt",
        address: "0x0aacfbec6a24756c20d41914f2caba817c0d8521",
        icon: null,
        usdValue: 42257.43453805916,
      },
      {
        id: "1",
        name: "THALES",
        value: 38,
        tokenType: "alt",
        address: "0x8947da500eb47f82df21143d0c01a29862a8c3c5",
        icon: null,
        usdValue: 74827.1618620909,
      },
      {
        id: "1",
        name: "PAID",
        value: 38,
        tokenType: "alt",
        address: "0x1614f18fc94f47967a3fbe5ffcd46d4e7da3d787",
        icon: null,
        usdValue: 191458.24016354856,
      },
      {
        id: "137",
        name: "CHAIN",
        value: 38,
        tokenType: "alt",
        address: "0xd55fCe7CDaB84d84f2EF3F99816D765a2a94a509",
        icon: null,
        usdValue: 11140.777998115758,
      },
      {
        id: "1",
        name: "INDEX",
        value: 38,
        tokenType: "alt",
        address: "0x0954906da0Bf32d5479e25f46056d22f08464cab",
        icon: null,
        usdValue: 291531.8136548239,
      },
      {
        id: "56",
        name: "DAO",
        value: 38,
        tokenType: "alt",
        address: "0x4d2d32d8652058bf98c772953e1df5c5c85d9f45",
        icon: null,
        usdValue: 8395947.083093401,
      },
      {
        id: "1",
        name: "BBANK",
        value: 38,
        tokenType: "alt",
        address: "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
        icon: null,
        usdValue: 13012.11324041921,
      },
      {
        id: "1",
        name: "ISP",
        value: 38,
        tokenType: "alt",
        address: "0xc8807f0f5ba3fa45ffbdc66928d71c5289249014",
        icon: null,
        usdValue: 4499068.3380133035,
      },
      {
        id: "137",
        name: "MT",
        value: 38,
        tokenType: "alt",
        address: "0xbd6d86ad2fab81c6b5ce48e9e788884ec13019c9",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "POSI",
        value: 38,
        tokenType: "alt",
        address: "0x5CA42204cDaa70d5c773946e69dE942b85CA6706",
        icon: null,
        usdValue: 19053.624683787253,
      },
      {
        id: "56",
        name: "MBOX",
        value: 38,
        tokenType: "alt",
        address: "0x3203c9e46ca618c8c1ce5dc67e7e9d75f5da2377",
        icon: null,
        usdValue: 21805825.663258284,
      },
      {
        id: "1",
        name: "DEVT",
        value: 38,
        tokenType: "alt",
        address: "0xb5c578947de0fd71303f71f2c3d41767438bd0de",
        icon: null,
        usdValue: 76995.2431321722,
      },
      {
        id: "1",
        name: "OST",
        value: 38,
        tokenType: "alt",
        address: "0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca",
        icon: null,
        usdValue: 374717.6137211189,
      },
      {
        id: "1",
        name: "WTLOS",
        value: 38,
        tokenType: "alt",
        address: "0x7825e833d495f3d1c28872415a4aee339d26ac88",
        icon: null,
        usdValue: 4737944.577043895,
      },
      {
        id: "56",
        name: "ATOM",
        value: 37,
        tokenType: "alt",
        address: "0x0eb3a705fc54725037cc9e008bdede697f62f335",
        icon: null,
        usdValue: 639635.9391459362,
      },
      {
        id: "1",
        name: "ADEL",
        value: 37,
        tokenType: "alt",
        address: "0x94d863173ee77439e4292284ff13fad54b3ba182",
        icon: null,
        usdValue: 30172.759043924085,
      },
      {
        id: "42161",
        name: "UNI",
        value: 37,
        tokenType: "alt",
        address: "0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0",
        icon: null,
        usdValue: 2652881.2493145983,
      },
      {
        id: "1",
        name: "GAMMA",
        value: 37,
        tokenType: "alt",
        address: "0x6bea7cfef803d1e3d5f7c0103f7ded065644e197",
        icon: null,
        usdValue: 153197.26035871392,
      },
      {
        id: "1",
        name: "RGT",
        value: 37,
        tokenType: "alt",
        address: "0xd291e7a03283640fdc51b121ac401383a46cc623",
        icon: null,
        usdValue: 8161.790228733982,
      },
      {
        id: "56",
        name: "BSW",
        value: 37,
        tokenType: "alt",
        address: "0x965f527d9159dce6288a2219db51fc6eef120dd1",
        icon: null,
        usdValue: 2868039.4259204427,
      },
      {
        id: "1",
        name: "AVT",
        value: 37,
        tokenType: "alt",
        address: "0x0d88ed6e74bbfd96b831231638b66c05571e824f",
        icon: null,
        usdValue: 1618694.1837524776,
      },
      {
        id: "56",
        name: "HERO",
        value: 37,
        tokenType: "alt",
        address: "0xD40bEDb44C081D2935eebA6eF5a3c8A31A1bBE13",
        icon: null,
        usdValue: 4099236.786089716,
      },
      {
        id: "1",
        name: "STRONG",
        value: 37,
        tokenType: "alt",
        address: "0x990f341946a3fdb507ae7e52d17851b87168017c",
        icon: null,
        usdValue: 21460.313445300686,
      },
      {
        id: "1",
        name: "PAY",
        value: 37,
        tokenType: "alt",
        address: "0xb97048628db6b661d4c2aa833e95dbe1a905b280",
        icon: null,
        usdValue: 690659.5301360792,
      },
      {
        id: "56",
        name: "ANKR",
        value: 37,
        tokenType: "alt",
        address: "0xf307910a4c7bbc79691fd374889b36d8531b08e3",
        icon: null,
        usdValue: 503789.15300224215,
      },
      {
        id: "5000",
        name: "wETH",
        value: 37,
        tokenType: "alt",
        address: "0xdeaddeaddeaddeaddeaddeaddeaddeaddead1111",
        icon: null,
        usdValue: 483805.58079937246,
      },
      {
        id: "1",
        name: "CBX",
        value: 37,
        tokenType: "alt",
        address: "0x37fc4b48ce93469dbea9918468993c735049642a",
        icon: null,
        usdValue: 1016397.6551286635,
      },
      {
        id: "1",
        name: "SUB",
        value: 37,
        tokenType: "alt",
        address: "0x8D75959f1E61EC2571aa72798237101F084DE63a",
        icon: null,
        usdValue: 113579.60316891632,
      },
      {
        id: "1",
        name: "BORING",
        value: 37,
        tokenType: "alt",
        address: "0xbc19712feb3a26080ebf6f2f7849b417fdd792ca",
        icon: null,
        usdValue: 4615536.847437893,
      },
      {
        id: "1",
        name: "UMEE",
        value: 37,
        tokenType: "alt",
        address: "0xc0a4df35568f116c370e6a6a6022ceb908eeddac",
        icon: null,
        usdValue: 333289.6702411996,
      },
      {
        id: "1",
        name: "KOK",
        value: 37,
        tokenType: "alt",
        address: "0x9b9647431632af44be02ddd22477ed94d14aacaa",
        icon: null,
        usdValue: 647772.750082195,
      },
      {
        id: "1",
        name: "EXRD",
        value: 37,
        tokenType: "alt",
        address: "0x6468e79a80c0eab0f9a2b574c8d5bc374af59414",
        icon: null,
        usdValue: 7145931.519159843,
      },
      {
        id: "1",
        name: "AQT",
        value: 36,
        tokenType: "alt",
        address: "0x2a9bdcff37ab68b95a53435adfd8892e86084f93",
        icon: null,
        usdValue: 1725089.6977021513,
      },
      {
        id: "1",
        name: "DUCK",
        value: 36,
        tokenType: "alt",
        address: "0x92e187a03b6cd19cb6af293ba17f2745fd2357d5",
        icon: null,
        usdValue: 123596.13609547919,
      },
      {
        id: "1",
        name: "BASE",
        value: 36,
        tokenType: "alt",
        address: "0x07150e919b4de5fd6a63de1f9384828396f25fdc",
        icon: null,
        usdValue: 731237.1009624742,
      },
      {
        id: "1",
        name: "MARSH",
        value: 36,
        tokenType: "alt",
        address: "0x5a666c7d92e5fa7edcb6390e4efd6d0cdd69cf37",
        icon: null,
        usdValue: 1772981.4504231366,
      },
      {
        id: "1",
        name: "KYL",
        value: 36,
        tokenType: "alt",
        address: "0x67b6d479c7bb412c54e03dca8e1bc6740ce6b99c",
        icon: null,
        usdValue: 1407915.5707291916,
      },
      {
        id: "1",
        name: "TIDAL",
        value: 36,
        tokenType: "alt",
        address: "0x29cbd0510eec0327992cd6006e63f9fa8e7f33b7",
        icon: null,
        usdValue: 586056.149678972,
      },
      {
        id: "1",
        name: "IXS",
        value: 36,
        tokenType: "alt",
        address: "0x73d7c860998ca3c01ce8c808f5577d94d545d1b4",
        icon: null,
        usdValue: 1278680.9513907835,
      },
      {
        id: "1",
        name: "RBX",
        value: 36,
        tokenType: "alt",
        address: "0x3Ba925fdeAe6B46d0BB4d424D829982Cb2F7309e",
        icon: null,
        usdValue: 964559.2964241797,
      },
      {
        id: "1",
        name: "VAB",
        value: 36,
        tokenType: "alt",
        address: "0xe7ae6d0c56cacaf007b7e4d312f9af686a9e9a04",
        icon: null,
        usdValue: 3122.5469251379277,
      },
      {
        id: "1",
        name: "ELA",
        value: 36,
        tokenType: "alt",
        address: "0xe6fd75ff38adca4b97fbcd938c86b98772431867",
        icon: null,
        usdValue: 3542545.591434927,
      },
      {
        id: "1",
        name: "ENG",
        value: 36,
        tokenType: "alt",
        address: "0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4",
        icon: null,
        usdValue: 63074.44047875683,
      },
      {
        id: "1",
        name: "FUEL",
        value: 35,
        tokenType: "alt",
        address: "0xea38eaa3c86c8f9b751533ba2e562deb9acded40",
        icon: null,
        usdValue: 184717.41736191817,
      },
      {
        id: "1",
        name: "MCB",
        value: 35,
        tokenType: "alt",
        address: "0x4e352cf164e64adcbad318c3a1e222e9eba4ce42",
        icon: null,
        usdValue: 364918.0651002365,
      },
      {
        id: "56",
        name: "SOL",
        value: 35,
        tokenType: "alt",
        address: "0x570a5d26f7765ecb712c0924e4de545b89fd43df",
        icon: null,
        usdValue: 2173165.1929309126,
      },
      {
        id: "1",
        name: "YLD",
        value: 35,
        tokenType: "alt",
        address: "0xf94b5c5651c888d928439ab6514b93944eee6f48",
        icon: null,
        usdValue: 553434.8675284279,
      },
      {
        id: "137",
        name: "GNS",
        value: 35,
        tokenType: "alt",
        address: "0xe5417af564e4bfda1c483642db72007871397896",
        icon: null,
        usdValue: 1444943.4782031714,
      },
      {
        id: "1",
        name: "ZKS",
        value: 35,
        tokenType: "alt",
        address: "0xe4815ae53b124e7263f08dcdbbb757d41ed658c6",
        icon: null,
        usdValue: 1119933.0340494562,
      },
      {
        id: "1",
        name: "CRE",
        value: 35,
        tokenType: "alt",
        address: "0x162433c934aa74ba147e05150b1206b2c922f71d",
        icon: null,
        usdValue: 127717.42273681633,
      },
      {
        id: "1",
        name: "BTM",
        value: 35,
        tokenType: "alt",
        address: "0xcb97e65f07da24d46bcdd078ebebd7c6e6e3d750",
        icon: null,
        usdValue: 5458.404401787733,
      },
      {
        id: "1",
        name: "TSUKA",
        value: 35,
        tokenType: "alt",
        address: "0xc5fb36dd2fb59d3b98deff88425a3f425ee469ed",
        icon: null,
        usdValue: 2692838.147604468,
      },
      {
        id: "1",
        name: "WPR",
        value: 35,
        tokenType: "alt",
        address: "0x4cf488387f035ff08c371515562cba712f9015d4",
        icon: null,
        usdValue: 92712.98242566048,
      },
      {
        id: "1",
        name: "FEAR",
        value: 35,
        tokenType: "alt",
        address: "0x88a9a52f944315d5b4e917b9689e65445c401e83",
        icon: null,
        usdValue: 557173.3287767369,
      },
      {
        id: "1",
        name: "POOH",
        value: 35,
        tokenType: "alt",
        address: "0xb69753c06bb5c366be51e73bfc0cc2e3dc07e371",
        icon: null,
        usdValue: 2362285.7802918046,
      },
      {
        id: "1",
        name: "MARS4",
        value: 34,
        tokenType: "alt",
        address: "0x16cda4028e9e872a38acb903176719299beaed87",
        icon: null,
        usdValue: 628519.9758668921,
      },
      {
        id: "42161",
        name: "SYN",
        value: 34,
        tokenType: "alt",
        address: "0x080f6aed32fc474dd5717105dba5ea57268f46eb",
        icon: null,
        usdValue: 211242.3108700305,
      },
      {
        id: "1",
        name: "POLK",
        value: 34,
        tokenType: "alt",
        address: "0xD478161C952357F05f0292B56012Cd8457F1cfbF",
        icon: null,
        usdValue: 709454.4132885997,
      },
      {
        id: "1",
        name: "ANGLE",
        value: 34,
        tokenType: "alt",
        address: "0x31429d1856ad1377a8a0079410b297e1a9e214c2",
        icon: null,
        usdValue: 29066.227484836898,
      },
      {
        id: "56",
        name: "BAKE",
        value: 34,
        tokenType: "alt",
        address: "0xe02df9e3e622debdd69fb838bb799e3f168902c5",
        icon: null,
        usdValue: 12285124.180718727,
      },
      {
        id: "1",
        name: "MX",
        value: 34,
        tokenType: "alt",
        address: "0x11eef04c884e24d9b7b4760e7476d06ddf797f36",
        icon: null,
        usdValue: 90711196.07951884,
      },
      {
        id: "137",
        name: "GAIA",
        value: 34,
        tokenType: "alt",
        address: "0x723b17718289a91af252d616de2c77944962d122",
        icon: null,
        usdValue: 583880.9846051876,
      },
      {
        id: "1",
        name: "AAPX",
        value: 34,
        tokenType: "alt",
        address: "0xbfd815347d024f449886c171f78fa5b8e6790811",
        icon: null,
        usdValue: 1819.3897283833087,
      },
      {
        id: "1",
        name: "OCT",
        value: 34,
        tokenType: "alt",
        address: "0xf5cfbc74057c610c8ef151a439252680ac68c6dc",
        icon: null,
        usdValue: 1949616.9106072725,
      },
      {
        id: "56",
        name: "1INCH",
        value: 34,
        tokenType: "alt",
        address: "0x111111111117dc0aa78b770fa6a738034120c302",
        icon: null,
        usdValue: 1319079.4761953529,
      },
      {
        id: "1",
        name: "$ADS",
        value: 34,
        tokenType: "alt",
        address: "0x3106a0a076bedae847652f42ef07fd58589e001f",
        icon: null,
        usdValue: 3599188.74376474,
      },
      {
        id: "1",
        name: "NUM",
        value: 34,
        tokenType: "alt",
        address: "0x3496b523e5c00a4b4150d6721320cddb234c3079",
        icon: null,
        usdValue: 2780957.7317950833,
      },
      {
        id: "1",
        name: "GAME",
        value: 34,
        tokenType: "alt",
        address: "0xD567B5F02b9073aD3a982a099a23Bf019FF11d1c",
        icon: null,
        usdValue: 396925.067509784,
      },
      {
        id: "56",
        name: "BABYDOGE",
        value: 34,
        tokenType: "alt",
        address: "0xc748673057861a797275cd8a068abb95a902e8de",
        icon: null,
        usdValue: 82490872.81728923,
      },
      {
        id: "56",
        name: "BRISE",
        value: 34,
        tokenType: "alt",
        address: "0x8fff93e810a2edaafc326edee51071da9d398e83",
        icon: null,
        usdValue: 7462900.802695346,
      },
      {
        id: "1",
        name: "VXV",
        value: 34,
        tokenType: "alt",
        address: "0x7D29A64504629172a429e64183D6673b9dAcbFCe",
        icon: null,
        usdValue: 3672348.3975175475,
      },
      {
        id: "1",
        name: "SNGLS",
        value: 34,
        tokenType: "alt",
        address: "0xaec2e87e0a235266d9c5adc9deb4b2e29b54d009",
        icon: null,
        usdValue: 19173.795525869995,
      },
      {
        id: "1",
        name: "GDT",
        value: 33,
        tokenType: "alt",
        address: "0xc67b12049c2d0cf6e476bc64c7f82fc6c63cffc5",
        icon: null,
        usdValue: 256273.7903484392,
      },
      {
        id: "56",
        name: "INJ",
        value: 33,
        tokenType: "alt",
        address: "0xa2b726b1145a4773f68593cf171187d8ebe4d495",
        icon: null,
        usdValue: 2754993.634744616,
      },
      {
        id: "1",
        name: "EURS",
        value: 33,
        tokenType: "stable",
        address: "0xdb25f211ab05b1c97d595516f45794528a807ad8",
        icon: null,
        usdValue: 740844.5878599999,
      },
      {
        id: "1",
        name: "TOWER",
        value: 33,
        tokenType: "alt",
        address: "0x1c9922314ed1415c95b9fd453c3818fd41867d0b",
        icon: null,
        usdValue: 1083509.074803186,
      },
      {
        id: "1",
        name: "BUMP",
        value: 33,
        tokenType: "alt",
        address: "0x785c34312dfa6b74f6f1829f79ade39042222168",
        icon: null,
        usdValue: 375450.62945825956,
      },
      {
        id: "56",
        name: "KBOX",
        value: 33,
        tokenType: "alt",
        address: "0x3523d58d8036b1c5c9a13493143c97aefc5ad422",
        icon: null,
        usdValue: 99380.51708006376,
      },
      {
        id: "137",
        name: "NAKA",
        value: 33,
        tokenType: "alt",
        address: "0x311434160d7537be358930def317afb606c0d737",
        icon: null,
        usdValue: 28653595.180027705,
      },
      {
        id: "1",
        name: "QANX",
        value: 33,
        tokenType: "alt",
        address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
        icon: null,
        usdValue: 5561207.8203759035,
      },
      {
        id: "1",
        name: "SHFT",
        value: 33,
        tokenType: "alt",
        address: "0xb17c88bda07d28b3838e0c1de6a30eafbcf52d85",
        icon: null,
        usdValue: 241661.05039154933,
      },
      {
        id: "1",
        name: "RBC",
        value: 33,
        tokenType: "alt",
        address: "0x3330bfb7332ca23cd071631837dc289b09c33333",
        icon: null,
        usdValue: 1225511.5350489013,
      },
      {
        id: "1",
        name: "MVL",
        value: 33,
        tokenType: "alt",
        address: "0xa849eaae994fb86afa73382e9bd88c2b6b18dc71",
        icon: null,
        usdValue: 11022086.16967106,
      },
      {
        id: "1",
        name: "ARC",
        value: 33,
        tokenType: "alt",
        address: "0xc82e3db60a52cf7529253b4ec688f631aad9e7c2",
        icon: null,
        usdValue: 12526777.840840787,
      },
      {
        id: "1",
        name: "PLU",
        value: 33,
        tokenType: "alt",
        address: "0xD8912C10681D8B21Fd3742244f44658dBA12264E",
        icon: null,
        usdValue: 1296114.1773374784,
      },
      {
        id: "56",
        name: "C98",
        value: 33,
        tokenType: "alt",
        address: "0xaec945e04baf28b135fa7c640f624f8d90f1c3a6",
        icon: null,
        usdValue: 26003595.426379833,
      },
      {
        id: "56",
        name: "MULTI",
        value: 33,
        tokenType: "alt",
        address: "0x9fb9a33956351cf4fa040f65a13b835a3c8764e3",
        icon: null,
        usdValue: 471046.58925408777,
      },
      {
        id: "1",
        name: "NWC",
        value: 33,
        tokenType: "alt",
        address: "0x968f6f898a6df937fc1859b323ac2f14643e3fed",
        icon: null,
        usdValue: 1216847.473133939,
      },
      {
        id: "1",
        name: "VINU",
        value: 33,
        tokenType: "alt",
        address: "0xAFCdd4f666c84Fed1d8BD825aA762e3714F652c9",
        icon: null,
        usdValue: 3494148.519489082,
      },
      {
        id: "1",
        name: "APPC",
        value: 33,
        tokenType: "alt",
        address: "0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db",
        icon: null,
        usdValue: 36299.00872498026,
      },
      {
        id: "1",
        name: "JUSTICE",
        value: 32,
        tokenType: "alt",
        address: "0x59d1e836F7b7210A978b25a855085cc46fd090B5",
        icon: null,
        usdValue: 599253.3942314077,
      },
      {
        id: "1",
        name: "FODL",
        value: 32,
        tokenType: "alt",
        address: "0x4c2e59d098df7b6cbae0848d66de2f8a4889b9c3",
        icon: null,
        usdValue: 193340.11067659094,
      },
      {
        id: "10",
        name: "collab",
        value: 32,
        tokenType: "alt",
        address: "0x8b21e9b7daf2c4325bf3d18c1beb79a347fe902a",
        icon: null,
        usdValue: 14092.539869300004,
      },
      {
        id: "42161",
        name: "CRV",
        value: 32,
        tokenType: "alt",
        address: "0x11cdb42b0eb46d95f990bedd4695a6e3fa034978",
        icon: null,
        usdValue: 1519175.9483777264,
      },
      {
        id: "137",
        name: "AAVE",
        value: 32,
        tokenType: "alt",
        address: "0xd6df932a45c0f255f85145f286ea0b292b21c90b",
        icon: null,
        usdValue: 21287.599262370375,
      },
      {
        id: "1",
        name: "ZEE",
        value: 32,
        tokenType: "alt",
        address: "0x2eDf094dB69d6Dcd487f1B3dB9febE2eeC0dd4c5",
        icon: null,
        usdValue: 845140.47144248,
      },
      {
        id: "1",
        name: "WHALE",
        value: 32,
        tokenType: "alt",
        address: "0x9355372396e3f6daf13359b7b607a3374cc638e0",
        icon: null,
        usdValue: 468776.8722360936,
      },
      {
        id: "1",
        name: "HBTC",
        value: 32,
        tokenType: "alt",
        address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
        icon: null,
        usdValue: 12067683.796145638,
      },
      {
        id: "56",
        name: "vBSWAP",
        value: 32,
        tokenType: "alt",
        address: "0x4f0ed527e8a95ecaa132af214dfd41f30b361600",
        icon: null,
        usdValue: 4.3451579303035185e-10,
      },
      {
        id: "1",
        name: "DINO",
        value: 32,
        tokenType: "alt",
        address: "0x49642110b712c1fd7261bc074105e9e44676c68f",
        icon: null,
        usdValue: 480885.0249771723,
      },
      {
        id: "56",
        name: "CSIX",
        value: 32,
        tokenType: "alt",
        address: "0x04756126F044634C9a0f0E985e60c88a51ACC206",
        icon: null,
        usdValue: 3972542.6186566157,
      },
      {
        id: "137",
        name: "BLOK",
        value: 32,
        tokenType: "alt",
        address: "0x229b1b6c23ff8953d663c4cbb519717e323a0a84",
        icon: null,
        usdValue: 3107635.909994552,
      },
      {
        id: "42161",
        name: "WINR",
        value: 32,
        tokenType: "alt",
        address: "0xd77b108d4f6cefaa0cae9506a934e825becca46e",
        icon: null,
        usdValue: 462293.1743358958,
      },
      {
        id: "1",
        name: "DSLA",
        value: 32,
        tokenType: "alt",
        address: "0x3affcca64c2a6f4e3b6bd9c64cd2c969efd1ecbe",
        icon: null,
        usdValue: 1287717.3664786203,
      },
      {
        id: "1",
        name: "AGI",
        value: 32,
        tokenType: "alt",
        address: "0x5f18ea482ad5cc6bc65803817c99f477043dce85",
        icon: null,
        usdValue: 27118.621517362924,
      },
      {
        id: "1",
        name: "CAPS",
        value: 32,
        tokenType: "alt",
        address: "0x03be5c903c727ee2c8c4e9bc0acc860cca4715e2",
        icon: null,
        usdValue: 3243473.8439371027,
      },
      {
        id: "1",
        name: "SHR",
        value: 32,
        tokenType: "alt",
        address: "0xd98F75b1A3261dab9eEd4956c93F33749027a964",
        icon: null,
        usdValue: 4296487.685978555,
      },
      {
        id: "1",
        name: "EJS",
        value: 32,
        tokenType: "alt",
        address: "0x96610186F3ab8d73EBEe1CF950C750f3B1Fb79C2",
        icon: null,
        usdValue: 40894.16343709341,
      },
      {
        id: "1",
        name: "SDEX",
        value: 32,
        tokenType: "alt",
        address: "0x5DE8ab7E27f6E7A1fFf3E5B337584Aa43961BEeF",
        icon: null,
        usdValue: 6836673.385490406,
      },
      {
        id: "56",
        name: "WOO",
        value: 32,
        tokenType: "alt",
        address: "0x4691937a7508860f876c9c0a2a617e7d9e945d4b",
        icon: null,
        usdValue: 18436265.188950237,
      },
      {
        id: "56",
        name: "GALA",
        value: 32,
        tokenType: "alt",
        address: "0x7ddee176f665cd201f93eede625770e2fd911990",
        icon: null,
        usdValue: 6846130.839763558,
      },
      {
        id: "1",
        name: "RED",
        value: 32,
        tokenType: "alt",
        address: "0xC744df3419A8c9Bd4D6b9852A503eb1C5308A326",
        icon: null,
        usdValue: 549657.2037441256,
      },
      {
        id: "1",
        name: "NGC",
        value: 32,
        tokenType: "alt",
        address: "0x72dd4b6bd852a3aa172be4d6c5a6dbec588cf131",
        icon: null,
        usdValue: 1026310.9204989204,
      },
      {
        id: "1",
        name: "KAN",
        value: 32,
        tokenType: "alt",
        address: "0x1410434b0346f5be678d0fb554e5c7ab620f8f4a",
        icon: null,
        usdValue: 2237048.1019294104,
      },
      {
        id: "1",
        name: "GVT",
        value: 32,
        tokenType: "alt",
        address: "0x103c3a209da59d3e7c4a89307e66521e081cfdf0",
        icon: null,
        usdValue: 97609.7258806464,
      },
      {
        id: "1",
        name: "SHOPX",
        value: 31,
        tokenType: "alt",
        address: "0x7bef710a5759d197ec0bf621c3df802c2d60d848",
        icon: null,
        usdValue: 251549.01106192803,
      },
      {
        id: "1",
        name: "BANK",
        value: 31,
        tokenType: "alt",
        address: "0x24a6a37576377f63f194caa5f518a60f45b42921",
        icon: null,
        usdValue: 68324.49819241095,
      },
      {
        id: "1",
        name: "MOFI",
        value: 31,
        tokenType: "alt",
        address: "0xb2dbf14d0b47ed3ba02bdb7c954e05a72deb7544",
        icon: null,
        usdValue: 37757.84294083981,
      },
      {
        id: "1",
        name: "FOUR",
        value: 31,
        tokenType: "alt",
        address: "0x4730fb1463a6f1f44aeb45f6c5c422427f37f4d0",
        icon: null,
        usdValue: 89459.1804799902,
      },
      {
        id: "1",
        name: "BMI",
        value: 31,
        tokenType: "alt",
        address: "0x725c263e32c72ddc3a19bea12c5a0479a81ee688",
        icon: null,
        usdValue: 211399.8869749208,
      },
      {
        id: "56",
        name: "XAI",
        value: 31,
        tokenType: "alt",
        address: "0xD16EaabA33a0822f5cBe4E0C63CA51D3c3fbB08B",
        icon: null,
        usdValue: 287009573480.88885,
      },
      {
        id: "10",
        name: "velo",
        value: 31,
        tokenType: "alt",
        address: "0x3c8b650257cfb5f272f799f5e2b4e65093a11a05",
        icon: null,
        usdValue: 9994.6340629096,
      },
      {
        id: "1",
        name: "KST",
        value: 31,
        tokenType: "alt",
        address: "0xBc17729fDf562723f0267F79FF25aDE441056d87",
        icon: null,
        usdValue: 216782.22632101428,
      },
      {
        id: "1",
        name: "RAMP",
        value: 31,
        tokenType: "alt",
        address: "0x33D0568941C0C64ff7e0FB4fbA0B11BD37deEd9f",
        icon: null,
        usdValue: 57076.37061965718,
      },
      {
        id: "1",
        name: "SRK",
        value: 31,
        tokenType: "alt",
        address: "0x0488401c3f535193fa8df029d9ffe615a06e74e6",
        icon: null,
        usdValue: 249832.0859330203,
      },
      {
        id: "1",
        name: "DFYN",
        value: 31,
        tokenType: "alt",
        address: "0x9695e0114e12C0d3A3636fAb5A18e6b737529023",
        icon: null,
        usdValue: 578374.9536141037,
      },
      {
        id: "1",
        name: "LSS",
        value: 31,
        tokenType: "alt",
        address: "0x3b9be07d622accaed78f479bc0edabfd6397e320",
        icon: null,
        usdValue: 2287771.314352823,
      },
      {
        id: "1",
        name: "ORC",
        value: 31,
        tokenType: "alt",
        address: "0x662b67d00a13faf93254714dd601f5ed49ef2f51",
        icon: null,
        usdValue: 456658.4980020168,
      },
      {
        id: "1",
        name: "SWASH",
        value: 31,
        tokenType: "alt",
        address: "0xa130e3a33a4d84b04c3918c4e5762223ae252f80",
        icon: null,
        usdValue: 991072.6709837706,
      },
      {
        id: "42161",
        name: "BAL",
        value: 31,
        tokenType: "alt",
        address: "0x040d1edc9569d4bab2d15287dc5a4f10f56a56b8",
        icon: null,
        usdValue: 1025962.3552885929,
      },
      {
        id: "56",
        name: "LTC",
        value: 31,
        tokenType: "alt",
        address: "0x4338665cbb7b2485a8855a139b75d5e34ab0db94",
        icon: null,
        usdValue: 1453182.0076457192,
      },
      {
        id: "1",
        name: "TAMA",
        value: 31,
        tokenType: "alt",
        address: "0x12b6893ce26ea6341919fe289212ef77e51688c8",
        icon: null,
        usdValue: 720742.1756626485,
      },
      {
        id: "1",
        name: "DIMO",
        value: 31,
        tokenType: "alt",
        address: "0x5fab9761d60419c9eeebe3915a8fa1ed7e8d2e1b",
        icon: null,
        usdValue: 4145489.00654172,
      },
      {
        id: "1",
        name: "VIDY",
        value: 31,
        tokenType: "alt",
        address: "0xc77b230f31b517f1ef362e59c173c2be6540b5e8",
        icon: null,
        usdValue: 171783.07215078853,
      },
      {
        id: "1",
        name: "SIMPSON",
        value: 31,
        tokenType: "alt",
        address: "0x44aAd22aFbB2606d7828Ca1f8f9E5af00e779AE1",
        icon: null,
        usdValue: 869008.3358094494,
      },
      {
        id: "1",
        name: "AVA",
        value: 31,
        tokenType: "alt",
        address: "0x442b153f6f61c0c99a33aa4170dcb31e1abda1d0",
        icon: null,
        usdValue: 1776154.2581619034,
      },
      {
        id: "1",
        name: "THE",
        value: 30,
        tokenType: "alt",
        address: "0x0cba60ca5ef4d42f92a5070a8fedd13be93e2861",
        icon: null,
        usdValue: 250260.54221161662,
      },
      {
        id: "1",
        name: "VALUE",
        value: 30,
        tokenType: "alt",
        address: "0x49e833337ece7afe375e44f4e3e8481029218e5c",
        icon: null,
        usdValue: 197466.66995320973,
      },
      {
        id: "1",
        name: "COLL",
        value: 30,
        tokenType: "alt",
        address: "0x957891c11616d3e0b0a76a76fb42724c382e0ef3",
        icon: null,
        usdValue: 1237.8217890562737,
      },
      {
        id: "1",
        name: "STND",
        value: 30,
        tokenType: "alt",
        address: "0x9040e237C3bF18347bb00957Dc22167D0f2b999d",
        icon: null,
        usdValue: 1528277.697842938,
      },
      {
        id: "1",
        name: "MFT",
        value: 30,
        tokenType: "alt",
        address: "0xdf2c7238198ad8b389666574f2d8bc411a4b7428",
        icon: null,
        usdValue: 311362.3832879519,
      },
      {
        id: "1",
        name: "MPH",
        value: 30,
        tokenType: "alt",
        address: "0x8888801af4d980682e47f1a9036e589479e835c5",
        icon: null,
        usdValue: 97858.86073240268,
      },
      {
        id: "56",
        name: "AAVE",
        value: 30,
        tokenType: "alt",
        address: "0xfb6115445bff7b52feb98650c87f44907e58f802",
        icon: null,
        usdValue: 145193.92645186352,
      },
      {
        id: "137",
        name: "QUICK",
        value: 30,
        tokenType: "alt",
        address: "0x831753dd7087cac61ab5644b308642cc1c33dc13",
        icon: null,
        usdValue: 865995.4034411351,
      },
      {
        id: "1",
        name: "BEPRO",
        value: 30,
        tokenType: "alt",
        address: "0xcf3c8be2e2c42331da80ef210e9b1b307c03d36a",
        icon: null,
        usdValue: 2356760.024678774,
      },
      {
        id: "1",
        name: "CWEB",
        value: 30,
        tokenType: "alt",
        address: "0x505b5eda5e25a67e1c24a2bf1a527ed9eb88bf04",
        icon: null,
        usdValue: 3267243.7432412608,
      },
      {
        id: "1",
        name: "VOLT",
        value: 30,
        tokenType: "alt",
        address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
        icon: null,
        usdValue: 86465.04530722884,
      },
      {
        id: "1",
        name: "DPR",
        value: 30,
        tokenType: "alt",
        address: "0xf3ae5d769e153ef72b4e3591ac004e89f48107a1",
        icon: null,
        usdValue: 469294.06566462084,
      },
      {
        id: "1",
        name: "WAS",
        value: 30,
        tokenType: "alt",
        address: "0x0c572544a4Ee47904d54aaA6A970AF96B6f00E1b",
        icon: null,
        usdValue: 579517.9979395171,
      },
      {
        id: "1",
        name: "WOZX",
        value: 30,
        tokenType: "alt",
        address: "0x34950ff2b487d9e5282c5ab342d08a2f712eb79f",
        icon: null,
        usdValue: 1779640.5351256912,
      },
      {
        id: "1",
        name: "BREED",
        value: 30,
        tokenType: "alt",
        address: "0x94E9EB8b5Ab9fd6B9ea3169D55FFAde62a01702e",
        icon: null,
        usdValue: 1518273.39053506,
      },
      {
        id: "56",
        name: "SANTOS",
        value: 30,
        tokenType: "alt",
        address: "0xA64455a4553C9034236734FadDAddbb64aCE4Cc7",
        icon: null,
        usdValue: 1695534.8179703434,
      },
      {
        id: "1",
        name: "RFOX",
        value: 30,
        tokenType: "alt",
        address: "0xa1d6df714f91debf4e0802a542e13067f31b8262",
        icon: null,
        usdValue: 1993347.7564835753,
      },
      {
        id: "1",
        name: "ANML",
        value: 30,
        tokenType: "alt",
        address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
        icon: null,
        usdValue: 322447.392421677,
      },
      {
        id: "1",
        name: "FX",
        value: 30,
        tokenType: "alt",
        address: "0x8c15ef5b4b21951d50e53e4fbda8298ffad25057",
        icon: null,
        usdValue: 659629.6113129479,
      },
      {
        id: "1",
        name: "BIFI",
        value: 30,
        tokenType: "alt",
        address: "0x2791bfd60d232150bff86b39b7146c0eaaa2ba81",
        icon: null,
        usdValue: 657350.2147746218,
      },
      {
        id: "1",
        name: "PRMX",
        value: 30,
        tokenType: "alt",
        address: "0xe4dae00bc1c46ea2F44ae71B1BEb8b171C15d812",
        icon: null,
        usdValue: 143701.03372273507,
      },
      {
        id: "1",
        name: "CTXC",
        value: 30,
        tokenType: "alt",
        address: "0xea11755ae41d889ceec39a63e6ff75a02bc1c00d",
        icon: null,
        usdValue: 2377570.081278382,
      },
      {
        id: "56",
        name: "REC",
        value: 30,
        tokenType: "alt",
        address: "0xb922AA024e71A25077D78B593Bd6f11f2F412e72",
        icon: null,
        usdValue: 714.7358243263177,
      },
      {
        id: "10",
        name: "dai",
        value: 29,
        tokenType: "stable",
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        icon: null,
        usdValue: 28894.875084521722,
      },
      {
        id: "137",
        name: "VOXEL",
        value: 29,
        tokenType: "alt",
        address: "0xd0258a3fd00f38aa8090dfee343f10a9d4d30d3f",
        icon: null,
        usdValue: 3914788.7402396374,
      },
      {
        id: "1",
        name: "XSUSHI",
        value: 29,
        tokenType: "alt",
        address: "0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272",
        icon: null,
        usdValue: 137337.36279738086,
      },
      {
        id: "1",
        name: "ITGR",
        value: 29,
        tokenType: "alt",
        address: "0xd502f487e1841fdc805130e13eae80c61186bc98",
        icon: null,
        usdValue: 261025.7936361428,
      },
      {
        id: "1",
        name: "HDX",
        value: 29,
        tokenType: "alt",
        address: "0x6FCb6408499a7c0f242E32D77EB51fFa1dD28a7E",
        icon: null,
        usdValue: 24149.29207493784,
      },
      {
        id: "1",
        name: "BOTTO",
        value: 29,
        tokenType: "alt",
        address: "0x9dfad1b7102d46b1b197b90095b5c4e9f5845bba",
        icon: null,
        usdValue: 8612382.818046663,
      },
      {
        id: "1",
        name: "ARMOR",
        value: 29,
        tokenType: "alt",
        address: "0x1337def16f9b486faed0293eb623dc8395dfe46a",
        icon: null,
        usdValue: 26148.44827629663,
      },
      {
        id: "137",
        name: "STG",
        value: 29,
        tokenType: "alt",
        address: "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
        icon: null,
        usdValue: 2760.8440174752386,
      },
      {
        id: "137",
        name: "ATK",
        value: 29,
        tokenType: "alt",
        address: "0xF868939Ee81F04f463010BC52EAb91c0839eF08c",
        icon: null,
        usdValue: 12362.378631072257,
      },
      {
        id: "1",
        name: "SKEB",
        value: 29,
        tokenType: "alt",
        address: "0x6D614686550B9E1c1DF4b2cD8f91C9D4df66C810",
        icon: null,
        usdValue: 400746.0197458036,
      },
      {
        id: "1",
        name: "STRP",
        value: 29,
        tokenType: "alt",
        address: "0x97872EAfd79940C7b24f7BCc1EADb1457347ADc9",
        icon: null,
        usdValue: 125187.29106917107,
      },
      {
        id: "1",
        name: "DIGG",
        value: 29,
        tokenType: "alt",
        address: "0x798D1bE841a82a273720CE31c822C61a67a601C3",
        icon: null,
        usdValue: 64773.45233279667,
      },
      {
        id: "1",
        name: "DMG",
        value: 29,
        tokenType: "alt",
        address: "0xEd91879919B71bB6905f23af0A68d231EcF87b14",
        icon: null,
        usdValue: 42201.704397215115,
      },
      {
        id: "1",
        name: "STFX",
        value: 29,
        tokenType: "alt",
        address: "0x9343e24716659A3551eB10Aff9472A2dcAD5Db2d",
        icon: null,
        usdValue: 57235.20879273365,
      },
      {
        id: "1",
        name: "LOVE",
        value: 29,
        tokenType: "alt",
        address: "0x5380442d3c4ec4f5777f551f5edd2fa0f691a27c",
        icon: null,
        usdValue: 71279.53058153926,
      },
      {
        id: "1",
        name: "RETH",
        value: 29,
        tokenType: "alt",
        address: "0xae78736cd615f374d3085123a210448e74fc6393",
        icon: null,
        usdValue: 74620.55873021438,
      },
      {
        id: "1",
        name: "XY",
        value: 29,
        tokenType: "alt",
        address: "0x77777777772cf0455fb38ee0e75f38034dfa50de",
        icon: null,
        usdValue: 147575.29442308837,
      },
      {
        id: "42161",
        name: "PSI",
        value: 29,
        tokenType: "alt",
        address: "0x602eb0d99a5e3e76d1510372c4d2020e12eaea8a",
        icon: null,
        usdValue: 219503.87591682447,
      },
      {
        id: "1",
        name: "ESS",
        value: 29,
        tokenType: "alt",
        address: "0xfc05987bd2be489ACCF0f509E44B0145d68240f7",
        icon: null,
        usdValue: 351537.18961124285,
      },
      {
        id: "1",
        name: "DRGN",
        value: 29,
        tokenType: "alt",
        address: "0x419c4db4b9e25d6db2ad9691ccb832c8d9fda05e",
        icon: null,
        usdValue: 6512764.6409626,
      },
      {
        id: "56",
        name: "FTM",
        value: 29,
        tokenType: "alt",
        address: "0xad29abb318791d579433d831ed122afeaf29dcfe",
        icon: null,
        usdValue: 960961.1582873887,
      },
      {
        id: "1",
        name: "STOS",
        value: 29,
        tokenType: "alt",
        address: "0x08c32b0726C5684024ea6e141C50aDe9690bBdcc",
        icon: null,
        usdValue: 6321859.848560579,
      },
      {
        id: "1",
        name: "DORA",
        value: 29,
        tokenType: "alt",
        address: "0xbc4171f45ef0ef66e76f979df021a34b46dcc81d",
        icon: null,
        usdValue: 839983.5563934565,
      },
      {
        id: "1",
        name: "LUFFY",
        value: 29,
        tokenType: "alt",
        address: "0x54012cDF4119DE84218F7EB90eEB87e25aE6EBd7",
        icon: null,
        usdValue: 2933497.512082415,
      },
      {
        id: "56",
        name: "ZIL",
        value: 29,
        tokenType: "alt",
        address: "0xb86AbCb37C3A4B64f74f59301AFF131a1BEcC787",
        icon: null,
        usdValue: 106857.83771350308,
      },
      {
        id: "1",
        name: "SOL",
        value: 29,
        tokenType: "alt",
        address: "0xd31a59c85ae9d8edefec411d448f90841571b89c",
        icon: null,
        usdValue: 164889.5597303839,
      },
      {
        id: "1",
        name: "APEX",
        value: 29,
        tokenType: "alt",
        address: "0x52a8845df664d76c69d2eea607cd793565af42b8",
        icon: null,
        usdValue: 139468008.73089007,
      },
      {
        id: "1",
        name: "ASM",
        value: 29,
        tokenType: "alt",
        address: "0x2565ae0385659badcada1031db704442e1b69982",
        icon: null,
        usdValue: 2856647.2438896787,
      },
      {
        id: "1",
        name: "NGL",
        value: 29,
        tokenType: "alt",
        address: "0x2653891204f463fb2a2f4f412564b19e955166ae",
        icon: null,
        usdValue: 2199438.8221290465,
      },
      {
        id: "1",
        name: "WABI",
        value: 29,
        tokenType: "alt",
        address: "0x286bda1413a2df81731d4930ce2f862a35a609fe",
        icon: null,
        usdValue: 60222.53710342035,
      },
      {
        id: "1",
        name: "DOS",
        value: 28,
        tokenType: "alt",
        address: "0x0A913beaD80F321E7Ac35285Ee10d9d922659cB7",
        icon: null,
        usdValue: 45202.15259592519,
      },
      {
        id: "1",
        name: "ALBT",
        value: 28,
        tokenType: "alt",
        address: "0x00a8b738E453fFd858a7edf03bcCfe20412f0Eb0",
        icon: null,
        usdValue: 18344.3608095386,
      },
      {
        id: "1",
        name: "YIELD",
        value: 28,
        tokenType: "alt",
        address: "0xa8b61cff52564758a204f841e636265bebc8db9b",
        icon: null,
        usdValue: 24636.229106154828,
      },
      {
        id: "137",
        name: "GHST",
        value: 28,
        tokenType: "alt",
        address: "0x385eeac5cb85a38a9a07a70c73e0a3271cfb54a7",
        icon: null,
        usdValue: 301993.7114175261,
      },
      {
        id: "1",
        name: "MCHC",
        value: 28,
        tokenType: "alt",
        address: "0xd69f306549e9d96f183b1aeca30b8f4353c2ecc3",
        icon: null,
        usdValue: 83166.19216049115,
      },
      {
        id: "56",
        name: "METIS",
        value: 28,
        tokenType: "alt",
        address: "0xe552fb52a4f19e44ef5a967632dbc320b0820639",
        icon: null,
        usdValue: 26896747.556461528,
      },
      {
        id: "1",
        name: "PKF",
        value: 28,
        tokenType: "alt",
        address: "0x8b39b70e39aa811b69365398e0aace9bee238aeb",
        icon: null,
        usdValue: 100657.79116370958,
      },
      {
        id: "1",
        name: "COVAL",
        value: 28,
        tokenType: "alt",
        address: "0x3d658390460295fb963f54dc0899cfb1c30776df",
        icon: null,
        usdValue: 857116.8411121109,
      },
      {
        id: "137",
        name: "SAND",
        value: 28,
        tokenType: "alt",
        address: "0xbbba073c31bf03b8acf7c28ef0738decf3695683",
        icon: null,
        usdValue: 96568.67971866905,
      },
      {
        id: "1",
        name: "OPIUM",
        value: 28,
        tokenType: "alt",
        address: "0x888888888889c00c67689029d7856aac1065ec11",
        icon: null,
        usdValue: 72654.43177669715,
      },
      {
        id: "1",
        name: "GPT",
        value: 28,
        tokenType: "alt",
        address: "0xD04E772BC0d591fBD288f2E2a86aFA3D3CB647F8",
        icon: null,
        usdValue: 5781225.430650415,
      },
      {
        id: "56",
        name: "LABS",
        value: 28,
        tokenType: "alt",
        address: "0x510ca7d22a84599e7d0f15f09e674056a6255389",
        icon: null,
        usdValue: 1025601.9263530279,
      },
      {
        id: "56",
        name: "DAR",
        value: 28,
        tokenType: "alt",
        address: "0x23ce9e926048273ef83be0a3a8ba9cb6d45cd978",
        icon: null,
        usdValue: 1834505.5042748193,
      },
      {
        id: "1",
        name: "BFT",
        value: 28,
        tokenType: "alt",
        address: "0x01ff50f8b7f74e4f00580d9596cd3d0d6d6e326f",
        icon: null,
        usdValue: 146187.62127984563,
      },
      {
        id: "1",
        name: "MIX",
        value: 28,
        tokenType: "alt",
        address: "0x5d285f735998f36631f678ff41fb56a10a4d0429",
        icon: null,
        usdValue: 7087027.733950275,
      },
      {
        id: "1",
        name: "SAITO",
        value: 28,
        tokenType: "alt",
        address: "0xfa14fa6958401314851a17d6c5360ca29f74b57b",
        icon: null,
        usdValue: 2883039.5840953635,
      },
      {
        id: "1",
        name: "PERI",
        value: 28,
        tokenType: "alt",
        address: "0x5d30aD9C6374Bf925D0A75454fa327AACf778492",
        icon: null,
        usdValue: 98454.84484544361,
      },
      {
        id: "56",
        name: "CHESS",
        value: 28,
        tokenType: "alt",
        address: "0x20de22029ab63cf9a7cf5feb2b737ca1ee4c82a6",
        icon: null,
        usdValue: 3215255.030836961,
      },
      {
        id: "1",
        name: "HYVE",
        value: 28,
        tokenType: "alt",
        address: "0xd794DD1CAda4cf79C9EebaAb8327a1B0507ef7d4",
        icon: null,
        usdValue: 588805.2660538721,
      },
      {
        id: "1",
        name: "ODDZ",
        value: 28,
        tokenType: "alt",
        address: "0xcd2828fc4d8e8a0ede91bb38cf64b1a81de65bf6",
        icon: null,
        usdValue: 452376.9500903604,
      },
      {
        id: "1",
        name: "FLY",
        value: 28,
        tokenType: "alt",
        address: "0x85f6eb2bd5a062f5f8560be93fb7147e16c81472",
        icon: null,
        usdValue: 1211372.7187397436,
      },
      {
        id: "1",
        name: "VERSE",
        value: 28,
        tokenType: "alt",
        address: "0x249cA82617eC3DfB2589c4c17ab7EC9765350a18",
        icon: null,
        usdValue: 323229.7820459421,
      },
      {
        id: "56",
        name: "DOME",
        value: 28,
        tokenType: "alt",
        address: "0x475bfaa1848591ae0e6ab69600f48d828f61a80e",
        icon: null,
        usdValue: 7002318.246261507,
      },
      {
        id: "1",
        name: "PMON",
        value: 28,
        tokenType: "alt",
        address: "0x1796ae0b0fa4862485106a0de9b654eFE301D0b2",
        icon: null,
        usdValue: 431443.704332526,
      },
      {
        id: "1",
        name: "CLIPS",
        value: 28,
        tokenType: "alt",
        address: "0xecbee2fae67709f718426ddc3bf770b26b95ed20",
        icon: null,
        usdValue: 109838.11815169224,
      },
      {
        id: "1",
        name: "LOOT",
        value: 28,
        tokenType: "alt",
        address: "0x721A1B990699eE9D90b6327FaaD0A3E840aE8335",
        icon: null,
        usdValue: 500059.0664305309,
      },
      {
        id: "56",
        name: "IOTX",
        value: 28,
        tokenType: "alt",
        address: "0x9678E42ceBEb63F23197D726B29b1CB20d0064E5",
        icon: null,
        usdValue: 600917.0284366045,
      },
      {
        id: "1",
        name: "SUTER",
        value: 27,
        tokenType: "alt",
        address: "0xaa2ce7ae64066175e0b90497ce7d9c190c315db4",
        icon: null,
        usdValue: 239192.88419740522,
      },
      {
        id: "137",
        name: "MegaDoge",
        value: 27,
        tokenType: "alt",
        address: "0xcbf4ab00b6aa19b4d5d29c7c3508b393a1c01fe3",
        icon: null,
        usdValue: 2.4457053001969182,
      },
      {
        id: "1",
        name: "SILO",
        value: 27,
        tokenType: "alt",
        address: "0x6f80310ca7f2c654691d1383149fa1a57d8ab1f8",
        icon: null,
        usdValue: 204815.7839669381,
      },
      {
        id: "1",
        name: "K21",
        value: 27,
        tokenType: "alt",
        address: "0xb9d99c33ea2d86ec5ec6b8a4dd816ebba64404af",
        icon: null,
        usdValue: 182571.8684880589,
      },
      {
        id: "1",
        name: "B20",
        value: 27,
        tokenType: "alt",
        address: "0xc4de189abf94c57f396bd4c52ab13b954febefd8",
        icon: null,
        usdValue: 41106.92133206883,
      },
      {
        id: "1",
        name: "OCTO",
        value: 27,
        tokenType: "alt",
        address: "0x7240aC91f01233BaAf8b064248E80feaA5912BA3",
        icon: null,
        usdValue: 488667.19042574195,
      },
      {
        id: "1",
        name: "KEL",
        value: 27,
        tokenType: "alt",
        address: "0x4abb9cc67bd3da9eb966d1159a71a0e68bd15432",
        icon: null,
        usdValue: 2068.767825460574,
      },
      {
        id: "1",
        name: "SYNR",
        value: 27,
        tokenType: "alt",
        address: "0xbc6e06778708177a18210181b073da747c88490a",
        icon: null,
        usdValue: 45234.81811279463,
      },
      {
        id: "56",
        name: "BIFI",
        value: 27,
        tokenType: "alt",
        address: "0xca3f508b8e4dd382ee878a314789373d80a5190a",
        icon: null,
        usdValue: 27575.31764123851,
      },
      {
        id: "1",
        name: "DPI",
        value: 27,
        tokenType: "alt",
        address: "0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b",
        icon: null,
        usdValue: 94848.20518223195,
      },
      {
        id: "1",
        name: "SPWN",
        value: 27,
        tokenType: "alt",
        address: "0xe516d78d784c77d479977be58905b3f2b1111126",
        icon: null,
        usdValue: 1901.0582651322534,
      },
      {
        id: "1",
        name: "MLT",
        value: 27,
        tokenType: "alt",
        address: "0x9506d37f70eB4C3d79C398d326C871aBBf10521d",
        icon: null,
        usdValue: 3519878.1739675426,
      },
      {
        id: "81457",
        name: "ETH",
        value: 27,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 208360.9414506831,
      },
      {
        id: "1",
        name: "INST",
        value: 27,
        tokenType: "alt",
        address: "0x6f40d4a6237c257fff2db00fa0510deeecd303eb",
        icon: null,
        usdValue: 14081158.40377579,
      },
      {
        id: "1",
        name: "ROOK",
        value: 27,
        tokenType: "alt",
        address: "0xfa5047c9c78b8877af97bdcb85db743fd7313d4a",
        icon: null,
        usdValue: 45781.89189142081,
      },
      {
        id: "1",
        name: "CIRUS",
        value: 27,
        tokenType: "alt",
        address: "0xa01199c61841fce3b3dafb83fefc1899715c8756",
        icon: null,
        usdValue: 1515851.3821950834,
      },
      {
        id: "1",
        name: "MOONEY",
        value: 27,
        tokenType: "alt",
        address: "0x20d4DB1946859E2Adb0e5ACC2eac58047aD41395",
        icon: null,
        usdValue: 68644.20583267002,
      },
      {
        id: "56",
        name: "LAZIO",
        value: 27,
        tokenType: "alt",
        address: "0x77d547256a2cd95f32f67ae0313e450ac200648d",
        icon: null,
        usdValue: 821862.9060224062,
      },
      {
        id: "1",
        name: "HEART",
        value: 27,
        tokenType: "alt",
        address: "0x8FAc8031e079F409135766C7d5De29cf22EF897C",
        icon: null,
        usdValue: 8497185.269098004,
      },
      {
        id: "1",
        name: "PDEX",
        value: 27,
        tokenType: "alt",
        address: "0xf59ae934f6fe444afc309586cc60a84a0f89aaea",
        icon: null,
        usdValue: 334497.2590848568,
      },
      {
        id: "1",
        name: "TOWN",
        value: 27,
        tokenType: "alt",
        address: "0x3dd98c8a089dbcff7e8fc8d4f532bd493501ab7f",
        icon: null,
        usdValue: 3690928.595523047,
      },
      {
        id: "1",
        name: "CHEX",
        value: 27,
        tokenType: "alt",
        address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
        icon: null,
        usdValue: 12560675.616427498,
      },
      {
        id: "1",
        name: "LUNR",
        value: 27,
        tokenType: "alt",
        address: "0xA87135285Ae208e22068AcDBFf64B11Ec73EAa5A",
        icon: null,
        usdValue: 2904782.8263268066,
      },
      {
        id: "42161",
        name: "VSTA",
        value: 26,
        tokenType: "alt",
        address: "0xa684cd057951541187f288294a1e1c2646aa2d24",
        icon: null,
        usdValue: 17322.227359849705,
      },
      {
        id: "1",
        name: "PARA",
        value: 26,
        tokenType: "alt",
        address: "0x3a8d5BC8A8948b68DfC0Ce9C14aC4150e083518c",
        icon: null,
        usdValue: 262973.44490542175,
      },
      {
        id: "1",
        name: "FST",
        value: 26,
        tokenType: "alt",
        address: "0x0e192d382a36de7011f795acc4391cd302003606",
        icon: null,
        usdValue: 129343.85473998029,
      },
      {
        id: "1",
        name: "ASD",
        value: 26,
        tokenType: "alt",
        address: "0xff742d05420b6aca4481f635ad8341f81a6300c2",
        icon: null,
        usdValue: 337531.07848872355,
      },
      {
        id: "1",
        name: "XMON",
        value: 26,
        tokenType: "alt",
        address: "0x3aaDA3e213aBf8529606924d8D1c55CbDc70Bf74",
        icon: null,
        usdValue: 238131.5235483067,
      },
      {
        id: "1",
        name: "FRM",
        value: 26,
        tokenType: "alt",
        address: "0xe5caef4af8780e59df925470b050fb23c43ca68c",
        icon: null,
        usdValue: 562043.2443273693,
      },
      {
        id: "1",
        name: "NFTX",
        value: 26,
        tokenType: "alt",
        address: "0x87d73e916d7057945c9bcd8cdd94e42a6f47f776",
        icon: null,
        usdValue: 75242.95810927238,
      },
      {
        id: "56",
        name: "LIME",
        value: 26,
        tokenType: "alt",
        address: "0x7bc75e291e656e8658d66be1cc8154a3769a35dd",
        icon: null,
        usdValue: 10309635.419003256,
      },
      {
        id: "10",
        name: "thales",
        value: 26,
        tokenType: "alt",
        address: "0x217d47011b23bb961eb6d93ca9945b7501a5bb11",
        icon: null,
        usdValue: 133155.79784501297,
      },
      {
        id: "56",
        name: "ALPHA",
        value: 26,
        tokenType: "alt",
        address: "0xa1faa113cbe53436df28ff0aee54275c13b40975",
        icon: null,
        usdValue: 1435778.9420210323,
      },
      {
        id: "1",
        name: "CBETH",
        value: 26,
        tokenType: "alt",
        address: "0xbe9895146f7af43049ca1c1ae358b0541ea49704",
        icon: null,
        usdValue: 880604.3425679923,
      },
      {
        id: "1",
        name: "DLT",
        value: 26,
        tokenType: "alt",
        address: "0x07e3c70653548B04f0A75970C1F81B4CBbFB606f",
        icon: null,
        usdValue: 78278.40480944655,
      },
      {
        id: "1",
        name: "WTC",
        value: 26,
        tokenType: "alt",
        address: "0xb7cb1c96db6b22b0d3d9536e0108d062bd488f74",
        icon: null,
        usdValue: 2326.8725333244497,
      },
      {
        id: "1",
        name: "NFTY",
        value: 26,
        tokenType: "alt",
        address: "0xE1D7C7a4596B038CEd2A84bF65B8647271C53208",
        icon: null,
        usdValue: 89077.81217665909,
      },
      {
        id: "56",
        name: "HZN",
        value: 26,
        tokenType: "alt",
        address: "0xc0eff7749b125444953ef89682201fb8c6a917cd",
        icon: null,
        usdValue: 37357.915399111225,
      },
      {
        id: "56",
        name: "PORTO",
        value: 26,
        tokenType: "alt",
        address: "0x49f2145d6366099e13B10FbF80646C0F377eE7f6",
        icon: null,
        usdValue: 719712.2569021153,
      },
      {
        id: "1",
        name: "WOOF",
        value: 26,
        tokenType: "alt",
        address: "0x6BC08509B36A98E829dFfAD49Fde5e412645d0a3",
        icon: null,
        usdValue: 191545.16102047628,
      },
      {
        id: "1",
        name: "JGN",
        value: 26,
        tokenType: "alt",
        address: "0x73374ea518de7addd4c2b624c0e8b113955ee041",
        icon: null,
        usdValue: 737938.9355148494,
      },
      {
        id: "1",
        name: "DERC",
        value: 26,
        tokenType: "alt",
        address: "0x9fa69536d1cda4a04cfb50688294de75b505a9ae",
        icon: null,
        usdValue: 13591.811710619804,
      },
      {
        id: "56",
        name: "CEEK",
        value: 26,
        tokenType: "alt",
        address: "0xe0f94ac5462997d2bc57287ac3a3ae4c31345d66",
        icon: null,
        usdValue: 8472754.436826237,
      },
      {
        id: "1",
        name: "APED",
        value: 26,
        tokenType: "alt",
        address: "0xe0151763455a8a021e64880c238ba1cff3787ff0",
        icon: null,
        usdValue: 369524.73422189144,
      },
      {
        id: "1",
        name: "IMGNAI",
        value: 26,
        tokenType: "alt",
        address: "0xA735A3AF76CC30791C61c10d585833829d36CBe0",
        icon: null,
        usdValue: 2516322.3612291715,
      },
      {
        id: "1",
        name: "SHOE",
        value: 26,
        tokenType: "alt",
        address: "0x0fd67b4ceb9b607ef206904ec73459c4880132c9",
        icon: null,
        usdValue: 38531.26866115448,
      },
      {
        id: "1",
        name: "BXX",
        value: 26,
        tokenType: "alt",
        address: "0x6b1a8f210ec6b7b6643cea3583fb0c079f367898",
        icon: null,
        usdValue: 5760366.83150971,
      },
      {
        id: "1",
        name: "TONE",
        value: 26,
        tokenType: "alt",
        address: "0x2ab6bb8408ca3199b8fa6c92d5b455f820af03c4",
        icon: null,
        usdValue: 26066.003208039474,
      },
      {
        id: "1",
        name: "KIBA",
        value: 26,
        tokenType: "alt",
        address: "0x005D1123878Fc55fbd56b54C73963b234a64af3c",
        icon: null,
        usdValue: 39874.827668385464,
      },
      {
        id: "1",
        name: "PBR",
        value: 26,
        tokenType: "alt",
        address: "0x298d492e8c1d909d3f63bc4a36c66c64acb3d695",
        icon: null,
        usdValue: 2513244.2018111595,
      },
      {
        id: "1",
        name: "UMB",
        value: 26,
        tokenType: "alt",
        address: "0x6fC13EACE26590B80cCCAB1ba5d51890577D83B2",
        icon: null,
        usdValue: 279746.72222794074,
      },
      {
        id: "1",
        name: "NEST",
        value: 26,
        tokenType: "alt",
        address: "0x04abeda201850ac0124161f037efd70c74ddc74c",
        icon: null,
        usdValue: 3108.405919747826,
      },
      {
        id: "56",
        name: "ATA",
        value: 26,
        tokenType: "alt",
        address: "0xa2120b9e674d3fc3875f415a7df52e382f141225",
        icon: null,
        usdValue: 1510536.4181659522,
      },
      {
        id: "1",
        name: "ECOx",
        value: 26,
        tokenType: "alt",
        address: "0xcccD1Ba9f7acD6117834E0D28F25645dECb1736a",
        icon: null,
        usdValue: 2247466.4768549157,
      },
      {
        id: "1",
        name: "PANDO",
        value: 26,
        tokenType: "alt",
        address: "0x252b9F56359901a0BDE52d0675b1f1130d86F471",
        icon: null,
        usdValue: 809527.9802547543,
      },
      {
        id: "1",
        name: "AGRS",
        value: 26,
        tokenType: "alt",
        address: "0x738865301a9b7dd80dc3666dd48cf034ec42bdda",
        icon: null,
        usdValue: 5036356.26008725,
      },
      {
        id: "1",
        name: "PROPS",
        value: 26,
        tokenType: "alt",
        address: "0x6fe56c0bcdd471359019fcbc48863d6c3e9d4f41",
        icon: null,
        usdValue: 9025613.369709069,
      },
      {
        id: "1",
        name: "RANKER",
        value: 26,
        tokenType: "alt",
        address: "0x6431FA4B812a2DCC062A38CB55cc7D18135AdEAd",
        icon: null,
        usdValue: 289026.3521435708,
      },
      {
        id: "42161",
        name: "REKT",
        value: 25,
        tokenType: "alt",
        address: "0x1d987200df3b744cfa9c14f713f5334cb4bc4d5d",
        icon: null,
        usdValue: 366612.6722904064,
      },
      {
        id: "42161",
        name: "UMAMI",
        value: 25,
        tokenType: "alt",
        address: "0x1622bf67e6e5747b81866fe0b85178a93c7f86e3",
        icon: null,
        usdValue: 15354.619100472883,
      },
      {
        id: "1",
        name: "BTRFLY",
        value: 25,
        tokenType: "alt",
        address: "0xc55126051b22ebb829d00368f4b12bde432de5da",
        icon: null,
        usdValue: 511503.8580220502,
      },
      {
        id: "1",
        name: "VPP",
        value: 25,
        tokenType: "alt",
        address: "0x5eeaa2dcb23056f4e8654a349e57ebe5e76b5e6e",
        icon: null,
        usdValue: 6792.333094011416,
      },
      {
        id: "1",
        name: "ORO",
        value: 25,
        tokenType: "alt",
        address: "0xc3Eb2622190c57429aac3901808994443b64B466",
        icon: null,
        usdValue: 23089.603810329943,
      },
      {
        id: "1",
        name: "NORD",
        value: 25,
        tokenType: "alt",
        address: "0x6e9730ecffbed43fd876a264c982e254ef05a0de",
        icon: null,
        usdValue: 296026.9737076804,
      },
      {
        id: "1",
        name: "DEPAY",
        value: 25,
        tokenType: "alt",
        address: "0xa0bEd124a09ac2Bd941b10349d8d224fe3c955eb",
        icon: null,
        usdValue: 237.5077262213553,
      },
      {
        id: "1",
        name: "KTON",
        value: 25,
        tokenType: "alt",
        address: "0x9f284e1337a815fe77d2ff4ae46544645b20c5ff",
        icon: null,
        usdValue: 350768.2977279199,
      },
      {
        id: "1",
        name: "ASH",
        value: 25,
        tokenType: "alt",
        address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
        icon: null,
        usdValue: 11802.682689988436,
      },
      {
        id: "1",
        name: "WAVES",
        value: 25,
        tokenType: "alt",
        address: "0x1cf4592ebffd730c7dc92c1bdffdfc3b9efcf29a",
        icon: null,
        usdValue: 2375854.207512922,
      },
      {
        id: "56",
        name: "THG",
        value: 25,
        tokenType: "alt",
        address: "0x9fd87aefe02441b123c3c32466cd9db4c578618f",
        icon: null,
        usdValue: 1082267.868268032,
      },
      {
        id: "56",
        name: "EDU",
        value: 25,
        tokenType: "alt",
        address: "0xBdEAe1cA48894A1759A8374D63925f21f2Ee2639",
        icon: null,
        usdValue: 6721833.627238113,
      },
      {
        id: "1",
        name: "KATA",
        value: 25,
        tokenType: "alt",
        address: "0x2e85ae1C47602f7927bCabc2Ff99C40aA222aE15",
        icon: null,
        usdValue: 3748402.9408002123,
      },
      {
        id: "1",
        name: "PNL",
        value: 25,
        tokenType: "alt",
        address: "0x9fc8f0ca1668e87294941b7f627e9c15ea06b459",
        icon: null,
        usdValue: 221842.77468505278,
      },
      {
        id: "56",
        name: "GGG",
        value: 25,
        tokenType: "alt",
        address: "0xd8047afecb86e44eff3add991b9f063ed4ca716b",
        icon: null,
        usdValue: 1687494.1594350643,
      },
      {
        id: "1",
        name: "BST",
        value: 25,
        tokenType: "alt",
        address: "0x509a38b7a1cc0dcd83aa9d06214663d9ec7c7f4a",
        icon: null,
        usdValue: 3256896.0677795243,
      },
      {
        id: "1",
        name: "COOK",
        value: 25,
        tokenType: "alt",
        address: "0xff75ced57419bcaebe5f05254983b013b0646ef5",
        icon: null,
        usdValue: 407842.549644263,
      },
      {
        id: "1",
        name: "XEND",
        value: 25,
        tokenType: "alt",
        address: "0xe4cfe9eaa8cdb0942a80b7bc68fd8ab0f6d44903",
        icon: null,
        usdValue: 276584.0440639702,
      },
      {
        id: "1",
        name: "SPELLFIRE",
        value: 25,
        tokenType: "alt",
        address: "0x3A0b022f32b3191D44E5847da12dc0B63fb07C91",
        icon: null,
        usdValue: 126446.44364349906,
      },
      {
        id: "1",
        name: "TOTM",
        value: 25,
        tokenType: "alt",
        address: "0x6ff1bfa14a57594a5874b37ff6ac5efbd9f9599a",
        icon: null,
        usdValue: 47725.297370453845,
      },
      {
        id: "1",
        name: "HMT",
        value: 25,
        tokenType: "alt",
        address: "0xd1ba9bac957322d6e8c07a160a3a8da11a0d2867",
        icon: null,
        usdValue: 1849031.1712076485,
      },
      {
        id: "1",
        name: "ACQ",
        value: 25,
        tokenType: "alt",
        address: "0x4bdcb66b968060d9390c1d12bd29734496205581",
        icon: null,
        usdValue: 540166.6727949511,
      },
      {
        id: "1",
        name: "LBP",
        value: 25,
        tokenType: "alt",
        address: "0xa23C1194d421F252b4e6D5edcc3205F7650a4eBE",
        icon: null,
        usdValue: 586049.6116674353,
      },
      {
        id: "56",
        name: "CAPO",
        value: 25,
        tokenType: "alt",
        address: "0x922722e9ef614ec9a3e94b78496e92abfbb5a624",
        icon: null,
        usdValue: 101099.21044509902,
      },
      {
        id: "56",
        name: "APX",
        value: 25,
        tokenType: "alt",
        address: "0x78f5d389f5cdccfc41594abab4b0ed02f31398b3",
        icon: null,
        usdValue: 3843165.6887225974,
      },
      {
        id: "56",
        name: "WAXL",
        value: 25,
        tokenType: "alt",
        address: "0x8b1f4432f943c465a973fedc6d7aa50fc96f1f65",
        icon: null,
        usdValue: 1365331.6067313305,
      },
      {
        id: "1",
        name: "TIME",
        value: 25,
        tokenType: "alt",
        address: "0x485d17a6f1b8780392d53d64751824253011a260",
        icon: null,
        usdValue: 2829112.2667875397,
      },
      {
        id: "56",
        name: "BCH",
        value: 25,
        tokenType: "alt",
        address: "0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf",
        icon: null,
        usdValue: 425745.5544328238,
      },
      {
        id: "56",
        name: "AXS",
        value: 25,
        tokenType: "alt",
        address: "0x715d400f88c167884bbcc41c5fea407ed4d2f8a0",
        icon: null,
        usdValue: 1823239.0443411751,
      },
      {
        id: "1",
        name: "MOOV",
        value: 25,
        tokenType: "alt",
        address: "0x24ec2ca132abf8f6f8a6e24a1b97943e31f256a7",
        icon: null,
        usdValue: 929773.618438749,
      },
      {
        id: "1",
        name: "ROOBEE",
        value: 25,
        tokenType: "alt",
        address: "0xa31b1767e09f842ecfd4bc471fe44f830e3891aa",
        icon: null,
        usdValue: 251412.04573969674,
      },
      {
        id: "1",
        name: "WBT",
        value: 25,
        tokenType: "alt",
        address: "0x925206b8a707096Ed26ae47C84747fE0bb734F59",
        icon: null,
        usdValue: 497138393.41528213,
      },
      {
        id: "1",
        name: "BGB",
        value: 25,
        tokenType: "alt",
        address: "0x19de6b897ed14a376dda0fe53a5420d2ac828a28",
        icon: null,
        usdValue: 153361546.61317563,
      },
      {
        id: "1",
        name: "LPOOL",
        value: 24,
        tokenType: "alt",
        address: "0x6149c26cd2f7b5ccdb32029af817123f6e37df5b",
        icon: null,
        usdValue: 185.71311840300913,
      },
      {
        id: "1",
        name: "MITX",
        value: 24,
        tokenType: "alt",
        address: "0x4a527d8fc13c5203ab24ba0944f4cb14658d1db6",
        icon: null,
        usdValue: 2039519.819365363,
      },
      {
        id: "1",
        name: "ELEC",
        value: 24,
        tokenType: "alt",
        address: "0xd49ff13661451313ca1553fd6954bd1d9b6e02b9",
        icon: null,
        usdValue: 93197.29513534045,
      },
      {
        id: "42161",
        name: "SPELL",
        value: 24,
        tokenType: "alt",
        address: "0x3e6648c5a70a150a88bce65f4ad4d506fe15d2af",
        icon: null,
        usdValue: 125084.07075823797,
      },
      {
        id: "1",
        name: "FRIN",
        value: 24,
        tokenType: "alt",
        address: "0xc9fe6e1c76210be83dc1b5b20ec7fd010b0b1d15",
        icon: null,
        usdValue: 269363.66770248476,
      },
      {
        id: "1",
        name: "YF-DAI",
        value: 24,
        tokenType: "alt",
        address: "0xf4cd3d3fda8d7fd6c5a500203e38640a70bf9577",
        icon: null,
        usdValue: 438179.6687826681,
      },
      {
        id: "56",
        name: "EPX",
        value: 24,
        tokenType: "alt",
        address: "0xAf41054C1487b0e5E2B9250C0332eCBCe6CE9d71",
        icon: null,
        usdValue: 1175062.5751126832,
      },
      {
        id: "56",
        name: "ERTHA",
        value: 24,
        tokenType: "alt",
        address: "0x62823659d09f9f9d2222058878f89437425eb261",
        icon: null,
        usdValue: 1715105.5205362344,
      },
      {
        id: "1",
        name: "LOON",
        value: 24,
        tokenType: "alt",
        address: "0x7c5d5100b339fe7d995a893af6cb496b9474373c",
        icon: null,
        usdValue: 216868.71135208406,
      },
      {
        id: "1",
        name: "UNB",
        value: 24,
        tokenType: "alt",
        address: "0x8db253a1943dddf1af9bcf8706ac9a0ce939d922",
        icon: null,
        usdValue: 331983.1049389467,
      },
      {
        id: "1",
        name: "VADER",
        value: 24,
        tokenType: "alt",
        address: "0x2602278ee1882889b946eb11dc0e810075650983",
        icon: null,
        usdValue: 151930.5274863572,
      },
      {
        id: "1",
        name: "BURP",
        value: 24,
        tokenType: "alt",
        address: "0x33f391f4c4fe802b70b77ae37670037a92114a7c",
        icon: null,
        usdValue: 39887.49984220507,
      },
      {
        id: "42161",
        name: "AIBB",
        value: 24,
        tokenType: "alt",
        address: "0xb9af4762c039d63e30039f1712dfab77026408c7",
        icon: null,
        usdValue: 973914.9960848243,
      },
      {
        id: "1",
        name: "NAOS",
        value: 24,
        tokenType: "alt",
        address: "0x4a615bb7166210cce20e6642a6f8fb5d4d044496",
        icon: null,
        usdValue: 29208.80436012786,
      },
      {
        id: "1",
        name: "NTX",
        value: 24,
        tokenType: "alt",
        address: "0xf0d33beda4d734c72684b5f9abbebf715d0a7935",
        icon: null,
        usdValue: 3555091.0991792954,
      },
      {
        id: "56",
        name: "CUSD",
        value: 24,
        tokenType: "stable",
        address: "0xfa4ba88cf97e282c505bea095297786c16070129",
        icon: null,
        usdValue: 161.05817211166544,
      },
      {
        id: "56",
        name: "ETC",
        value: 24,
        tokenType: "alt",
        address: "0x3d6545b08693dae087e957cb1180ee38b9e3c25e",
        icon: null,
        usdValue: 4120775.575967282,
      },
      {
        id: "56",
        name: "FLUX",
        value: 24,
        tokenType: "alt",
        address: "0xaff9084f2374585879e8b434c399e29e80cce635",
        icon: null,
        usdValue: 794129.0902018946,
      },
      {
        id: "1",
        name: "UPI",
        value: 24,
        tokenType: "alt",
        address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
        icon: null,
        usdValue: 61134.55493131885,
      },
      {
        id: "1",
        name: "HOTCROSS",
        value: 24,
        tokenType: "alt",
        address: "0x4297394c20800e8a38a619a243e9bbe7681ff24e",
        icon: null,
        usdValue: 1032530.2009479298,
      },
      {
        id: "1",
        name: "HAHA",
        value: 24,
        tokenType: "alt",
        address: "0xd87D72248093597df8D56d2a53C1ab7c1A0Cc8DA",
        icon: null,
        usdValue: 432503.87966401345,
      },
      {
        id: "1",
        name: "ADP",
        value: 24,
        tokenType: "alt",
        address: "0xc314b0e758d5ff74f63e307a86ebfe183c95767b",
        icon: null,
        usdValue: 627423.6325147288,
      },
      {
        id: "1",
        name: "TNB",
        value: 24,
        tokenType: "alt",
        address: "0xf7920b0768ecb20a123fac32311d07d193381d6f",
        icon: null,
        usdValue: 57110.876039975265,
      },
      {
        id: "1",
        name: "DDX",
        value: 23,
        tokenType: "alt",
        address: "0x3a880652f47bfaa771908c07dd8673a787daed3a",
        icon: null,
        usdValue: 8453.011915341487,
      },
      {
        id: "1",
        name: "VITA",
        value: 23,
        tokenType: "alt",
        address: "0x81f8f0bb1cb2a06649e51913a151f0e7ef6fa321",
        icon: null,
        usdValue: 149396.59051449248,
      },
      {
        id: "1",
        name: "DAFI",
        value: 23,
        tokenType: "alt",
        address: "0xfc979087305a826c2b2a0056cfaba50aad3e6439",
        icon: null,
        usdValue: 42213.160725197806,
      },
      {
        id: "1",
        name: "CHAIN",
        value: 23,
        tokenType: "alt",
        address: "0xC4C2614E694cF534D407Ee49F8E44D125E4681c4",
        icon: null,
        usdValue: 811489.3028492652,
      },
      {
        id: "1",
        name: "PPAY",
        value: 23,
        tokenType: "alt",
        address: "0x054d64b73d3d8a21af3d764efd76bcaa774f3bb2",
        icon: null,
        usdValue: 2877.071955295596,
      },
      {
        id: "56",
        name: "SCLP",
        value: 23,
        tokenType: "alt",
        address: "0xF2c96E402c9199682d5dED26D3771c6B192c01af",
        icon: null,
        usdValue: 5261003.698328949,
      },
      {
        id: "1",
        name: "WALLET",
        value: 23,
        tokenType: "alt",
        address: "0x88800092ff476844f74dc2fc427974bbee2794ae",
        icon: null,
        usdValue: 2280698.570479072,
      },
      {
        id: "1",
        name: "DFX",
        value: 23,
        tokenType: "alt",
        address: "0x888888435fde8e7d4c54cab67f206e4199454c60",
        icon: null,
        usdValue: 33324.32464106326,
      },
      {
        id: "137",
        name: "TRY",
        value: 23,
        tokenType: "alt",
        address: "0xEFeE2de82343BE622Dcb4E545f75a3b9f50c272D",
        icon: null,
        usdValue: 698.4043421996494,
      },
      {
        id: "1",
        name: "LYXE",
        value: 23,
        tokenType: "alt",
        address: "0xa8b919680258d369114910511cc87595aec0be6d",
        icon: null,
        usdValue: 15664.83418819509,
      },
      {
        id: "56",
        name: "HIGH",
        value: 23,
        tokenType: "alt",
        address: "0x5f4bde007dc06b867f86ebfe4802e34a1ffeed63",
        icon: null,
        usdValue: 302277.9513341397,
      },
      {
        id: "1",
        name: "UNN",
        value: 23,
        tokenType: "alt",
        address: "0x226f7b842E0F0120b7E194D05432b3fd14773a9D",
        icon: null,
        usdValue: 29494.26731325344,
      },
      {
        id: "56",
        name: "UIM",
        value: 23,
        tokenType: "alt",
        address: "0x1bb132d6039b81faedc524a30e52586b6ca15f48",
        icon: null,
        usdValue: 1252.2249227484738,
      },
      {
        id: "137",
        name: "UPO",
        value: 23,
        tokenType: "alt",
        address: "0x9dBfc1cbf7a1E711503a29B4b5F9130ebeCcaC96",
        icon: null,
        usdValue: 21696.87164889496,
      },
      {
        id: "1",
        name: "FACTR",
        value: 23,
        tokenType: "alt",
        address: "0xdefac16715671b7b6aeefe012125f1e19ee4b7d7",
        icon: null,
        usdValue: 923118.7497616472,
      },
      {
        id: "56",
        name: "FREE",
        value: 23,
        tokenType: "alt",
        address: "0x12e34cdf6a031a10fe241864c32fb03a4fdad739",
        icon: null,
        usdValue: 8405.80179608659,
      },
      {
        id: "56",
        name: "SIN",
        value: 23,
        tokenType: "alt",
        address: "0x6397de0f9aedc0f7a8fa8b438dde883b9c201010",
        icon: null,
        usdValue: 991256.9921575711,
      },
      {
        id: "1",
        name: "STORE",
        value: 23,
        tokenType: "alt",
        address: "0x31ea0de8119307aa264bb4b38727aab4e36b074f",
        icon: null,
        usdValue: 966588.598703045,
      },
      {
        id: "1",
        name: "DVF",
        value: 23,
        tokenType: "alt",
        address: "0xdddddd4301a082e62e84e43f474f044423921918",
        icon: null,
        usdValue: 1845457.795509294,
      },
      {
        id: "1",
        name: "AAA",
        value: 23,
        tokenType: "alt",
        address: "0x8c6bf16c273636523c29db7db04396143770f6a0",
        icon: null,
        usdValue: 157148.50839894617,
      },
      {
        id: "56",
        name: "MMETA",
        value: 23,
        tokenType: "alt",
        address: "0x7a9c8d33963aecca9a821802adfaf5bd9392351f",
        icon: null,
        usdValue: 327797.7243888551,
      },
      {
        id: "1",
        name: "HOGE",
        value: 23,
        tokenType: "alt",
        address: "0xfad45e47083e4607302aa43c65fb3106f1cd7607",
        icon: null,
        usdValue: 456029.00661256845,
      },
      {
        id: "1",
        name: "AGS",
        value: 23,
        tokenType: "alt",
        address: "0xdb2f2bcce3efa95eda95a233af45f3e0d4f00e2a",
        icon: null,
        usdValue: 96504.5701626912,
      },
      {
        id: "1",
        name: "POOLZ",
        value: 23,
        tokenType: "alt",
        address: "0x69a95185ee2a045cdc4bcd1b1df10710395e4e23",
        icon: null,
        usdValue: 21871.027990920298,
      },
      {
        id: "1",
        name: "VIBE",
        value: 23,
        tokenType: "alt",
        address: "0xe8ff5c9c75deb346acac493c463c8950be03dfba",
        icon: null,
        usdValue: 355.023131118041,
      },
      {
        id: "169",
        name: "ETH",
        value: 23,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 18039.199602053603,
      },
      {
        id: "56",
        name: "ONT",
        value: 23,
        tokenType: "alt",
        address: "0xfd7b3a77848f1c2d67e05e54d78d174a0c850335",
        icon: null,
        usdValue: 41945.49479815801,
      },
      {
        id: "56",
        name: "HFT",
        value: 23,
        tokenType: "alt",
        address: "0x44Ec807ce2F4a6F2737A92e985f318d035883e47",
        icon: null,
        usdValue: 2105109.682497379,
      },
      {
        id: "56",
        name: "PLAY",
        value: 23,
        tokenType: "alt",
        address: "0xD069599E718f963bD84502b49ba8F8657fAF5B3a",
        icon: null,
        usdValue: 404117.28601336037,
      },
      {
        id: "1",
        name: "MTO",
        value: 23,
        tokenType: "alt",
        address: "0xe66b3aa360bb78468c00bebe163630269db3324f",
        icon: null,
        usdValue: 135638.60899610716,
      },
      {
        id: "56",
        name: "PHB",
        value: 23,
        tokenType: "alt",
        address: "0x0409633A72D846fc5BBe2f98D88564D35987904D",
        icon: null,
        usdValue: 6072555.487510242,
      },
      {
        id: "56",
        name: "UNFI",
        value: 23,
        tokenType: "alt",
        address: "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
        icon: null,
        usdValue: 2402832.729709701,
      },
      {
        id: "1",
        name: "MAHA",
        value: 23,
        tokenType: "alt",
        address: "0x745407c86DF8DB893011912d3aB28e68B62E49B0",
        icon: null,
        usdValue: 965660.7583957093,
      },
      {
        id: "1",
        name: "DKA",
        value: 23,
        tokenType: "alt",
        address: "0x5dc60C4D5e75D22588FA17fFEB90A63E535efCE0",
        icon: null,
        usdValue: 8396832.544928096,
      },
      {
        id: "1",
        name: "EL",
        value: 23,
        tokenType: "alt",
        address: "0x2781246fe707bb15cee3e5ea354e2154a2877b16",
        icon: null,
        usdValue: 162910.57163826705,
      },
      {
        id: "1",
        name: "WXT",
        value: 23,
        tokenType: "alt",
        address: "0xa02120696c7b8fe16c09c749e4598819b2b0e915",
        icon: null,
        usdValue: 4469956.549162762,
      },
      {
        id: "1",
        name: "D2T",
        value: 23,
        tokenType: "alt",
        address: "0x4dd942baa75810a3c1e876e79d5cd35e09c97a76",
        icon: null,
        usdValue: 101477.22795338585,
      },
      {
        id: "1",
        name: "TOKO",
        value: 23,
        tokenType: "alt",
        address: "0xa0f0546eb5e3ee7e8cfc5da12e5949f3ae622675",
        icon: null,
        usdValue: 1470812.2070519177,
      },
      {
        id: "1",
        name: "HSF",
        value: 23,
        tokenType: "alt",
        address: "0xba6b0dbb2ba8daa8f5d6817946393aef8d3a4487",
        icon: null,
        usdValue: 1450554.1968290554,
      },
      {
        id: "1",
        name: "EGAME",
        value: 23,
        tokenType: "alt",
        address: "0x62d3c05b9c3d916fbc111819bbd3cee52906c1ae",
        icon: null,
        usdValue: 481320.91541626625,
      },
      {
        id: "56",
        name: "VINU",
        value: 23,
        tokenType: "alt",
        address: "0xfEbe8C1eD424DbF688551D4E2267e7A53698F0aa",
        icon: null,
        usdValue: 39121022.943750985,
      },
      {
        id: "56",
        name: "STRM",
        value: 23,
        tokenType: "alt",
        address: "0xc598275452fa319d75ee5f176fd3b8384925b425",
        icon: null,
        usdValue: 901180.5625868482,
      },
      {
        id: "1",
        name: "BDOT",
        value: 23,
        tokenType: "alt",
        address: "0x7884f51dc1410387371ce61747cb6264e1daee0b",
        icon: null,
        usdValue: 2458935.005443746,
      },
      {
        id: "1",
        name: "MELOS",
        value: 23,
        tokenType: "alt",
        address: "0x1afb69dbc9f54d08dab1bd3436f8da1af819e647",
        icon: null,
        usdValue: 1070844.3093125853,
      },
      {
        id: "1",
        name: "CNC",
        value: 22,
        tokenType: "alt",
        address: "0x9ae380f0272e2162340a5bb646c354271c0f5cfc",
        icon: null,
        usdValue: 10484.837221452619,
      },
      {
        id: "1",
        name: "TNT",
        value: 22,
        tokenType: "alt",
        address: "0x08f5a9235b08173b7569f83645d2c7fb55e8ccd8",
        icon: null,
        usdValue: 667753.0859961718,
      },
      {
        id: "1",
        name: "XED",
        value: 22,
        tokenType: "alt",
        address: "0xee573a945b01b788b9287ce062a0cfc15be9fd86",
        icon: null,
        usdValue: 139879.73342047076,
      },
      {
        id: "1",
        name: "AURABAL",
        value: 22,
        tokenType: "alt",
        address: "0x616e8bfa43f920657b3497dbf40d6b1a02d4608d",
        icon: null,
        usdValue: 2384.7779505860613,
      },
      {
        id: "1",
        name: "TON",
        value: 22,
        tokenType: "alt",
        address: "0x2be5e8c109e2197d077d13a82daead6a9b3433c5",
        icon: null,
        usdValue: 1015741.6109921052,
      },
      {
        id: "1",
        name: "DOWS",
        value: 22,
        tokenType: "alt",
        address: "0x661ab0ed68000491d98c796146bcf28c20d7c559",
        icon: null,
        usdValue: 10304.747739224631,
      },
      {
        id: "1",
        name: "SHARE",
        value: 22,
        tokenType: "alt",
        address: "0x39795344CBCc76cC3Fb94B9D1b15C23c2070C66D",
        icon: null,
        usdValue: 195956.97066657624,
      },
      {
        id: "56",
        name: "BTL",
        value: 22,
        tokenType: "alt",
        address: "0x708955Db0d4c52FFBf9AA34aF7f3CA8bf07390a8",
        icon: null,
        usdValue: 331555.7040701976,
      },
      {
        id: "56",
        name: "SKILL",
        value: 22,
        tokenType: "alt",
        address: "0x154a9f9cbd3449ad22fdae23044319d6ef2a1fab",
        icon: null,
        usdValue: 267443.5637366767,
      },
      {
        id: "56",
        name: "GQ",
        value: 22,
        tokenType: "alt",
        address: "0xf700d4c708c2be1463e355f337603183d20e0808",
        icon: null,
        usdValue: 716197.5566743768,
      },
      {
        id: "56",
        name: "MDX",
        value: 22,
        tokenType: "alt",
        address: "0x9c65ab58d8d978db963e63f2bfb7121627e3a739",
        icon: null,
        usdValue: 217376.5746348385,
      },
      {
        id: "56",
        name: "ALU",
        value: 22,
        tokenType: "alt",
        address: "0x8263cd1601fe73c066bf49cc09841f35348e3be0",
        icon: null,
        usdValue: 4943347.495854301,
      },
      {
        id: "1",
        name: "THEOS",
        value: 22,
        tokenType: "alt",
        address: "0x9e10f61749c4952c320412a6b26901605ff6da1d",
        icon: null,
        usdValue: 17171.80617663197,
      },
      {
        id: "56",
        name: "LOA",
        value: 22,
        tokenType: "alt",
        address: "0x94b69263fca20119ae817b6f783fc0f13b02ad50",
        icon: null,
        usdValue: 42324.77919467893,
      },
      {
        id: "1",
        name: "COFI",
        value: 22,
        tokenType: "alt",
        address: "0x1a23a6BfBAdB59fa563008c0fB7cf96dfCF34Ea1",
        icon: null,
        usdValue: 118877.67634335639,
      },
      {
        id: "56",
        name: "MCRT",
        value: 22,
        tokenType: "alt",
        address: "0x4b8285ab433d8f69cb48d5ad62b415ed1a221e4f",
        icon: null,
        usdValue: 4390453.919773875,
      },
      {
        id: "56",
        name: "MIT",
        value: 22,
        tokenType: "alt",
        address: "0xe6906717f129427eebade5406de68cadd57aa0c0",
        icon: null,
        usdValue: 14444.704473886602,
      },
      {
        id: "1",
        name: "DADI",
        value: 22,
        tokenType: "alt",
        address: "0xfb2f26f266fb2805a387230f2aa0a331b4d96fba",
        icon: null,
        usdValue: 19053571.35762445,
      },
      {
        id: "1",
        name: "LIEN",
        value: 22,
        tokenType: "alt",
        address: "0xab37e1358b639fd877f015027bb62d3ddaa7557e",
        icon: null,
        usdValue: 28381.7068981897,
      },
      {
        id: "56",
        name: "POT",
        value: 22,
        tokenType: "alt",
        address: "0x4c7b04d50e070848E3c7757995A57624563e0245",
        icon: null,
        usdValue: 18229938.275149107,
      },
      {
        id: "1",
        name: "NTVRK",
        value: 22,
        tokenType: "alt",
        address: "0xfc0d6cf33e38bce7ca7d89c0e292274031b7157a",
        icon: null,
        usdValue: 1022083.999956761,
      },
      {
        id: "56",
        name: "LINA",
        value: 22,
        tokenType: "alt",
        address: "0x762539b45a1dcce3d36d080f74d1aed37844b878",
        icon: null,
        usdValue: 198731.09507552907,
      },
      {
        id: "1",
        name: "DOP",
        value: 22,
        tokenType: "alt",
        address: "0x6bb61215298f296c55b19ad842d3df69021da2ef",
        icon: null,
        usdValue: 43179.81560230887,
      },
      {
        id: "1",
        name: "XCUR",
        value: 22,
        tokenType: "alt",
        address: "0xE1c7E30C42C24582888C758984f6e382096786bd",
        icon: null,
        usdValue: 16901.261657040584,
      },
      {
        id: "56",
        name: "PRIMAL",
        value: 22,
        tokenType: "alt",
        address: "0xcb5327ed4649548e0d73e70b633cdfd99af6da87",
        icon: null,
        usdValue: 28820.965372169303,
      },
      {
        id: "56",
        name: "MOVEZ",
        value: 22,
        tokenType: "alt",
        address: "0x039cd22cb49084142d55fcd4b6096a4f51ffb3b4",
        icon: null,
        usdValue: 591288.4412350617,
      },
      {
        id: "1",
        name: "FUND",
        value: 22,
        tokenType: "alt",
        address: "0xbe6ac6b50f577205c9d107f37b6e205aa6acc5d4",
        icon: null,
        usdValue: 1111549.2516869148,
      },
      {
        id: "56",
        name: "XEC",
        value: 22,
        tokenType: "alt",
        address: "0x5f7a1a4dafd0718caee1184caa4862543f75edb1",
        icon: null,
        usdValue: 29786.302250172073,
      },
      {
        id: "42161",
        name: "Visit https://eth-tokens.us to claim Airdrop",
        value: 22,
        tokenType: "alt",
        address: "0x26c5a1d330c3e46130a5613811990f65646c7c86",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "GERMANY",
        value: 22,
        tokenType: "alt",
        address: "0xd9d0e3dd09c78930de4ac83856bd0af6d3dd2022",
        icon: null,
        usdValue: 3.7928e-26,
      },
      {
        id: "4200",
        name: "BTC",
        value: 22,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 177330.36960622258,
      },
      {
        id: "1",
        name: "SHIT",
        value: 22,
        tokenType: "alt",
        address: "0x4e4a47cac6a28a62dcc20990ed2cda9bc659469f",
        icon: null,
        usdValue: 184610.8756041677,
      },
      {
        id: "1",
        name: "MET",
        value: 22,
        tokenType: "alt",
        address: "0x2Ebd53d035150f328bd754D6DC66B99B0eDB89aa",
        icon: null,
        usdValue: 120507.86757884081,
      },
      {
        id: "56",
        name: "SUPER",
        value: 22,
        tokenType: "alt",
        address: "0x51ba0b044d96c3abfca52b64d733603ccc4f0d4d",
        icon: null,
        usdValue: 43757.65438501025,
      },
      {
        id: "56",
        name: "DZOO",
        value: 22,
        tokenType: "alt",
        address: "0x56d06a78Ef8E95D6043341f24759e2834BE6f97B",
        icon: null,
        usdValue: 1000304.1126016896,
      },
      {
        id: "1",
        name: "OUSD",
        value: 22,
        tokenType: "stable",
        address: "0x2a8e1e676ec238d8a992307b495b45b3feaa5e86",
        icon: null,
        usdValue: 1782135.5726758735,
      },
      {
        id: "1",
        name: "B2M",
        value: 22,
        tokenType: "alt",
        address: "0xd7c302fc3ac829c7e896a32c4bd126f3e8bd0a1f",
        icon: null,
        usdValue: 8615986.257179534,
      },
      {
        id: "1",
        name: "THN",
        value: 22,
        tokenType: "alt",
        address: "0x2e95cea14dd384429eb3c4331b776c4cfbb6fcd9",
        icon: null,
        usdValue: 4847599.513519243,
      },
      {
        id: "1",
        name: "LBK",
        value: 22,
        tokenType: "alt",
        address: "0x9cb1aeafcc8a9406632c5b084246ea72f62d37b6",
        icon: null,
        usdValue: 1179951.226247111,
      },
      {
        id: "1",
        name: "TOMS",
        value: 22,
        tokenType: "alt",
        address: "0xbe9ab37a414c517b2be2bfa5945665bb07379054",
        icon: null,
        usdValue: 409947.5550414952,
      },
      {
        id: "1",
        name: "ASTRA",
        value: 22,
        tokenType: "alt",
        address: "0x201332Bd45c8628D814F870bFb584B385A7C351e",
        icon: null,
        usdValue: 1535126.7573842132,
      },
      {
        id: "1",
        name: "EGS",
        value: 22,
        tokenType: "alt",
        address: "0xB009BFaAF85e53F55d8657781Eb69feAaed83672",
        icon: null,
        usdValue: 71395.91526326635,
      },
      {
        id: "137",
        name: "ACCESS [ETHNA.CC] TO CLAIM",
        value: 22,
        tokenType: "alt",
        address: "0x57912d26a5285bc5d614bbf4e9be0e42406ede54",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "OLY",
        value: 21,
        tokenType: "alt",
        address: "0x6595b8fd9c920c81500dca94e53cdc712513fb1f",
        icon: null,
        usdValue: 18458.534080797195,
      },
      {
        id: "1",
        name: "SOMM",
        value: 21,
        tokenType: "alt",
        address: "0xa670d7237398238DE01267472C6f13e5B8010FD1",
        icon: null,
        usdValue: 465815.99375452666,
      },
      {
        id: "1",
        name: "HAKKA",
        value: 21,
        tokenType: "alt",
        address: "0x0E29e5AbbB5FD88e28b2d355774e73BD47dE3bcd",
        icon: null,
        usdValue: 1077.5529977458348,
      },
      {
        id: "1",
        name: "EDR",
        value: 21,
        tokenType: "alt",
        address: "0xc528c28fec0a90c083328bc45f587ee215760a0f",
        icon: null,
        usdValue: 16012.445839040798,
      },
      {
        id: "56",
        name: "KPAD",
        value: 21,
        tokenType: "alt",
        address: "0xCFEfA64B0dDD611b125157C41cD3827f2e8e8615",
        icon: null,
        usdValue: 191897.15566035343,
      },
      {
        id: "1",
        name: "ZZ",
        value: 21,
        tokenType: "alt",
        address: "0xc91a71a1ffa3d8b22ba615ba1b9c01b2bbbf55ad",
        icon: null,
        usdValue: 76876.59428054678,
      },
      {
        id: "1",
        name: "XTP",
        value: 21,
        tokenType: "alt",
        address: "0x6368e1E18c4C419DDFC608A0BEd1ccb87b9250fc",
        icon: null,
        usdValue: 1113560.9958084524,
      },
      {
        id: "56",
        name: "GPT",
        value: 21,
        tokenType: "alt",
        address: "0x153C0c947177e631e3DFc594ba28750d3a921FB5",
        icon: null,
        usdValue: 11204.88543908848,
      },
      {
        id: "56",
        name: "MGA",
        value: 21,
        tokenType: "alt",
        address: "0x03aC6AB6A9a91a0fcdec7D85b38bDFBb719ec02f",
        icon: null,
        usdValue: 197037.91948281258,
      },
      {
        id: "56",
        name: "NFTB",
        value: 21,
        tokenType: "alt",
        address: "0xde3dbbe30cfa9f437b293294d1fd64b26045c71a",
        icon: null,
        usdValue: 993637.2956898441,
      },
      {
        id: "1",
        name: "PERC",
        value: 21,
        tokenType: "alt",
        address: "0x60be1e1fe41c1370adaf5d8e66f07cf1c2df2268",
        icon: null,
        usdValue: 907548.8334223124,
      },
      {
        id: "1",
        name: "MIST",
        value: 21,
        tokenType: "alt",
        address: "0x88acdd2a6425c3faae4bc9650fd7e27e0bebb7ab",
        icon: null,
        usdValue: 1687.81481075607,
      },
      {
        id: "56",
        name: "XWG",
        value: 21,
        tokenType: "alt",
        address: "0x6b23c89196deb721e6fd9726e6c76e4810a464bc",
        icon: null,
        usdValue: 1277557.592144288,
      },
      {
        id: "1",
        name: "OPEN",
        value: 21,
        tokenType: "alt",
        address: "0x9d86b1b2554ec410eccffbf111a6994910111340",
        icon: null,
        usdValue: 11183055.244240696,
      },
      {
        id: "1",
        name: "IPOR",
        value: 21,
        tokenType: "alt",
        address: "0x1e4746dc744503b53b4a082cb3607b169a289090",
        icon: null,
        usdValue: 1853626.6633987601,
      },
      {
        id: "1",
        name: "KUMA",
        value: 21,
        tokenType: "alt",
        address: "0x48c276e8d03813224bb1e55f953adb6d02fd3e02",
        icon: null,
        usdValue: 296506.33073007595,
      },
      {
        id: "1",
        name: "LFT",
        value: 21,
        tokenType: "alt",
        address: "0xb620be8a1949aa9532e6a3510132864ef9bc3f82",
        icon: null,
        usdValue: 63503.65243785419,
      },
      {
        id: "56",
        name: "CUMMIES",
        value: 21,
        tokenType: "alt",
        address: "0x27ae27110350b98d564b9a3eed31baebc82d878d",
        icon: null,
        usdValue: 413475.04331494437,
      },
      {
        id: "1",
        name: "FEI",
        value: 21,
        tokenType: "stable",
        address: "0x956f47f50a910163d8bf957cf5846d573e7f87ca",
        icon: null,
        usdValue: 219387.34226082038,
      },
      {
        id: "1",
        name: "SEELE",
        value: 21,
        tokenType: "alt",
        address: "0xb1e93236ab6073fdac58ada5564897177d4bcc43",
        icon: null,
        usdValue: 43487.17309927351,
      },
      {
        id: "1",
        name: "MODA",
        value: 21,
        tokenType: "alt",
        address: "0x1117ac6ad6cdf1a3bc543bad3b133724620522d5",
        icon: null,
        usdValue: 240607.79904941045,
      },
      {
        id: "1",
        name: "BUY",
        value: 21,
        tokenType: "alt",
        address: "0x396eC402B42066864C406d1ac3bc86B575003ed8",
        icon: null,
        usdValue: 10957.670801781835,
      },
      {
        id: "1",
        name: "CRF",
        value: 21,
        tokenType: "alt",
        address: "0x508df5aa4746be37b5b6a69684dfd8bdc322219d",
        icon: null,
        usdValue: 306537.3617330467,
      },
      {
        id: "1",
        name: "PEEPO",
        value: 21,
        tokenType: "alt",
        address: "0xaADA04204e9e1099DaF67cf3D5D137E84E41CF41",
        icon: null,
        usdValue: 508576.9380751625,
      },
      {
        id: "1",
        name: "BLANK",
        value: 21,
        tokenType: "alt",
        address: "0x41a3dba3d677e573636ba691a70ff2d606c29666",
        icon: null,
        usdValue: 170070.56830458782,
      },
      {
        id: "1",
        name: "PIXEL",
        value: 21,
        tokenType: "alt",
        address: "0x65e6b60ea01668634d68d0513fe814679f925bad",
        icon: null,
        usdValue: 143785.44232905214,
      },
      {
        id: "56",
        name: "SUSHI",
        value: 21,
        tokenType: "alt",
        address: "0x947950bcc74888a40ffa2593c5798f11fc9124c4",
        icon: null,
        usdValue: 170154.96968819993,
      },
      {
        id: "1",
        name: "BIRD",
        value: 21,
        tokenType: "alt",
        address: "0x70401dfd142a16dc7031c56e862fc88cb9537ce0",
        icon: null,
        usdValue: 151306.5784962075,
      },
      {
        id: "56",
        name: "TLM",
        value: 21,
        tokenType: "alt",
        address: "0x2222227e22102fe3322098e4cbfe18cfebd57c95",
        icon: null,
        usdValue: 483001.5103606086,
      },
      {
        id: "1",
        name: "LEOX",
        value: 21,
        tokenType: "alt",
        address: "0xa444ec96ee01bb219a44b285de47bf33c3447ad5",
        icon: null,
        usdValue: 4166276.973205169,
      },
      {
        id: "1",
        name: "IONX",
        value: 21,
        tokenType: "alt",
        address: "0x02d3a27ac3f55d5d91fb0f52759842696a864217",
        icon: null,
        usdValue: 141879.6084554096,
      },
      {
        id: "56",
        name: "REEF",
        value: 21,
        tokenType: "alt",
        address: "0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e",
        icon: null,
        usdValue: 261687.11441657163,
      },
      {
        id: "1",
        name: "00",
        value: 21,
        tokenType: "alt",
        address: "0x881Ba05de1E78f549cC63a8f6Cabb1d4AD32250D",
        icon: null,
        usdValue: 307820.11766154546,
      },
      {
        id: "1",
        name: "MCO2",
        value: 21,
        tokenType: "alt",
        address: "0xfc98e825a2264d890f9a1e68ed50e1526abccacd",
        icon: null,
        usdValue: 136006.27044224465,
      },
      {
        id: "56",
        name: "ALPINE",
        value: 21,
        tokenType: "alt",
        address: "0x287880ea252b52b63cc5f40a2d3e5a44aa665a76",
        icon: null,
        usdValue: 575695.3378218948,
      },
      {
        id: "56",
        name: "ALICE",
        value: 21,
        tokenType: "alt",
        address: "0xac51066d7bec65dc4589368da368b212745d63e8",
        icon: null,
        usdValue: 5029106.095821191,
      },
      {
        id: "56",
        name: "PSG",
        value: 21,
        tokenType: "alt",
        address: "0xBc5609612b7C44BEf426De600B5fd1379DB2EcF1",
        icon: null,
        usdValue: 164301.8076,
      },
      {
        id: "56",
        name: "GFT",
        value: 21,
        tokenType: "alt",
        address: "0x72ff5742319ef07061836f5c924ac6d72c919080",
        icon: null,
        usdValue: 2691999.369206322,
      },
      {
        id: "137",
        name: "DIMO",
        value: 21,
        tokenType: "alt",
        address: "0xe261d618a959afffd53168cd07d12e37b26761db",
        icon: null,
        usdValue: 623902.7374212656,
      },
      {
        id: "1",
        name: "ETHA",
        value: 21,
        tokenType: "alt",
        address: "0x59e9261255644c411afdd00bd89162d09d862e38",
        icon: null,
        usdValue: 273386.7007450977,
      },
      {
        id: "1",
        name: "EVER",
        value: 21,
        tokenType: "alt",
        address: "0x29d578CEc46B50Fa5C88a99C6A4B70184C062953",
        icon: null,
        usdValue: 101867.34316505885,
      },
      {
        id: "1",
        name: "XIN",
        value: 21,
        tokenType: "alt",
        address: "0xa974c709cfb4566686553a20790685a47aceaa33",
        icon: null,
        usdValue: 92535.81431315192,
      },
      {
        id: "1",
        name: "DYP",
        value: 21,
        tokenType: "alt",
        address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
        icon: null,
        usdValue: 5906.95140820222,
      },
      {
        id: "1",
        name: "KOL",
        value: 21,
        tokenType: "alt",
        address: "0x1cc30e2eac975416060ec6fe682041408420d414",
        icon: null,
        usdValue: 71179.07627501902,
      },
      {
        id: "1",
        name: "SFG",
        value: 21,
        tokenType: "alt",
        address: "0x8a6aca71a218301c7081d4e96d64292d3b275ce0",
        icon: null,
        usdValue: 147069.5037478665,
      },
      {
        id: "1",
        name: "KDOE",
        value: 21,
        tokenType: "alt",
        address: "0x5f190f9082878ca141f858c1c90b4c59fe2782c5",
        icon: null,
        usdValue: 17096.86966025945,
      },
      {
        id: "1",
        name: "DVI",
        value: 21,
        tokenType: "alt",
        address: "0x10633216e7e8281e33c86f02bf8e565a635d9770",
        icon: null,
        usdValue: 573484.4528633825,
      },
      {
        id: "1",
        name: "PXP",
        value: 21,
        tokenType: "alt",
        address: "0x95aa5d2dbd3c16ee3fdea82d5c6ec3e38ce3314f",
        icon: null,
        usdValue: 437325.79181155085,
      },
      {
        id: "1",
        name: "CAN",
        value: 21,
        tokenType: "alt",
        address: "0x1d462414fe14cf489c7a21cac78509f4bf8cd7c0",
        icon: null,
        usdValue: 395.19888681296203,
      },
      {
        id: "1",
        name: "TITAN",
        value: 21,
        tokenType: "alt",
        address: "0x3A8cCCB969a61532d1E6005e2CE12C200caeCe87",
        icon: null,
        usdValue: 619783.9560993474,
      },
      {
        id: "137",
        name: "CHAMP",
        value: 20,
        tokenType: "alt",
        address: "0x8f9e8e833a69aa467e42c46cca640da84dd4585f",
        icon: null,
        usdValue: 241208.4857835447,
      },
      {
        id: "1",
        name: "GET",
        value: 20,
        tokenType: "alt",
        address: "0x8a854288a5976036a725879164ca3e91d30c6a1b",
        icon: null,
        usdValue: 316504.21138669935,
      },
      {
        id: "1",
        name: "CARD",
        value: 20,
        tokenType: "alt",
        address: "0xb07ec2c28834b889b1ce527ca0f19364cd38935c",
        icon: null,
        usdValue: 13960.405340586323,
      },
      {
        id: "10",
        name: "hop",
        value: 20,
        tokenType: "alt",
        address: "0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc",
        icon: null,
        usdValue: 2059.9618106733956,
      },
      {
        id: "1",
        name: "SDT",
        value: 20,
        tokenType: "alt",
        address: "0x73968b9a57c6e53d41345fd57a6e6ae27d6cdb2f",
        icon: null,
        usdValue: 4533.098840735485,
      },
      {
        id: "1",
        name: "OIN",
        value: 20,
        tokenType: "alt",
        address: "0x9aeB50f542050172359A0e1a25a9933Bc8c01259",
        icon: null,
        usdValue: 106914.65871477331,
      },
      {
        id: "1",
        name: "PET",
        value: 20,
        tokenType: "alt",
        address: "0xB870679a7Fa65b924026F496De7f27c1DD0e5C5F",
        icon: null,
        usdValue: 4217234.739174432,
      },
      {
        id: "1",
        name: "SASHIMI",
        value: 20,
        tokenType: "alt",
        address: "0xC28E27870558cF22ADD83540d2126da2e4b464c2",
        icon: null,
        usdValue: 346873.93679041235,
      },
      {
        id: "1",
        name: "MEL",
        value: 20,
        tokenType: "alt",
        address: "0xed0889f7e1c7c7267407222be277e1f1ef4d4892",
        icon: null,
        usdValue: 297.75826735023776,
      },
      {
        id: "1",
        name: "UPP",
        value: 20,
        tokenType: "alt",
        address: "0xc86d054809623432210c107af2e3f619dcfbf652",
        icon: null,
        usdValue: 129495.79415911833,
      },
      {
        id: "56",
        name: "CREO",
        value: 20,
        tokenType: "alt",
        address: "0x9521728bF66a867BC65A93Ece4a543D817871Eb7",
        icon: null,
        usdValue: 4326245.283029114,
      },
      {
        id: "1",
        name: "MIM",
        value: 20,
        tokenType: "stable",
        address: "0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3",
        icon: null,
        usdValue: 2163.4729445126663,
      },
      {
        id: "56",
        name: "AUTO",
        value: 20,
        tokenType: "alt",
        address: "0xa184088a740c695e156f91f5cc086a06bb78b827",
        icon: null,
        usdValue: 361807.7672572074,
      },
      {
        id: "1",
        name: "WTAO",
        value: 20,
        tokenType: "alt",
        address: "0x77E06c9eCCf2E797fd462A92B6D7642EF85b0A44",
        icon: null,
        usdValue: 556752.1733368966,
      },
      {
        id: "56",
        name: "HOD",
        value: 20,
        tokenType: "alt",
        address: "0x19A4866a85c652EB4a2ED44c42e4CB2863a62D51",
        icon: null,
        usdValue: 1073664.017992828,
      },
      {
        id: "1",
        name: "MM",
        value: 20,
        tokenType: "alt",
        address: "0x6b4c7a5e3f0b99fcd83e9c089bddd6c7fce5c611",
        icon: null,
        usdValue: 21132.083721525272,
      },
      {
        id: "56",
        name: "KATA",
        value: 20,
        tokenType: "alt",
        address: "0x6D6bA21E4C4b29CA7Bfa1c344Ba1E35B8DaE7205",
        icon: null,
        usdValue: 68830.4490148155,
      },
      {
        id: "1",
        name: "IAG",
        value: 20,
        tokenType: "alt",
        address: "0x40eb746dee876ac1e78697b7ca85142d178a1fc8",
        icon: null,
        usdValue: 13728.846210403137,
      },
      {
        id: "56",
        name: "MONS",
        value: 20,
        tokenType: "alt",
        address: "0xe4c797d43631f4d660ec67b5cb0b78ef5c902532",
        icon: null,
        usdValue: 30916.633903374517,
      },
      {
        id: "1",
        name: "VTX",
        value: 20,
        tokenType: "alt",
        address: "0xceb286C9604c542d3cc08b41AA6C9675B078A832",
        icon: null,
        usdValue: 249.57693662292283,
      },
      {
        id: "1",
        name: "WRLD",
        value: 20,
        tokenType: "alt",
        address: "0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9",
        icon: null,
        usdValue: 215978.65494453404,
      },
      {
        id: "1",
        name: "FAYRE",
        value: 20,
        tokenType: "alt",
        address: "0xAb4C44973BEFba9294F47e21E6BEB79A3C1D7d9F",
        icon: null,
        usdValue: 23172.63443101212,
      },
      {
        id: "1",
        name: "PAF",
        value: 20,
        tokenType: "alt",
        address: "0x6a969d379700b2e5ea4e684d273d63c1c050ba49",
        icon: null,
        usdValue: 35800.37335083933,
      },
      {
        id: "56",
        name: "GOV",
        value: 20,
        tokenType: "alt",
        address: "0xcc7a91413769891de2e9ebbfc96d2eb1874b5760",
        icon: null,
        usdValue: 2864.671716983127,
      },
      {
        id: "56",
        name: "BAND",
        value: 20,
        tokenType: "alt",
        address: "0xad6caeb32cd2c308980a548bd0bc5aa4306c6c18",
        icon: null,
        usdValue: 259573.69503480967,
      },
      {
        id: "1",
        name: "HAKA",
        value: 20,
        tokenType: "alt",
        address: "0xd85ad783cc94bd04196a13dc042a3054a9b52210",
        icon: null,
        usdValue: 304145.64017596876,
      },
      {
        id: "1",
        name: "PLOT",
        value: 20,
        tokenType: "alt",
        address: "0x72f020f8f3e8fd9382705723cd26380f8d0c66bb",
        icon: null,
        usdValue: 16351.674669223128,
      },
      {
        id: "56",
        name: "POOLX",
        value: 20,
        tokenType: "alt",
        address: "0xbAeA9aBA1454DF334943951d51116aE342eAB255",
        icon: null,
        usdValue: 529543.3311308231,
      },
      {
        id: "1",
        name: "VLX",
        value: 20,
        tokenType: "alt",
        address: "0x8C543AED163909142695f2d2aCd0D55791a9Edb9",
        icon: null,
        usdValue: 155823.5372623284,
      },
      {
        id: "56",
        name: "NUM",
        value: 20,
        tokenType: "alt",
        address: "0xeceb87cf00dcbf2d4e2880223743ff087a995ad9",
        icon: null,
        usdValue: 305006.8028546371,
      },
      {
        id: "1",
        name: "NFTD",
        value: 20,
        tokenType: "alt",
        address: "0x8e0fe2947752be0d5acf73aae77362daf79cb379",
        icon: null,
        usdValue: 123765.92436105655,
      },
      {
        id: "1",
        name: "IOI",
        value: 20,
        tokenType: "alt",
        address: "0x8b3870df408ff4d7c3a26df852d41034eda11d81",
        icon: null,
        usdValue: 465973.8331327501,
      },
      {
        id: "56",
        name: "AIPAD",
        value: 20,
        tokenType: "alt",
        address: "0xe55d97a97ae6a17706ee281486e98a84095d8aaf",
        icon: null,
        usdValue: 131928.6269174743,
      },
      {
        id: "42161",
        name: "POGAI",
        value: 20,
        tokenType: "alt",
        address: "0x6fD58f5a2F3468e35fEb098b5F59F04157002407",
        icon: null,
        usdValue: 1173660.4410069203,
      },
      {
        id: "56",
        name: "VET",
        value: 20,
        tokenType: "alt",
        address: "0x6FDcdfef7c496407cCb0cEC90f9C5Aaa1Cc8D888",
        icon: null,
        usdValue: 8292310.662786911,
      },
      {
        id: "56",
        name: "FEVR",
        value: 20,
        tokenType: "alt",
        address: "0x82030CDBD9e4B7c5bb0b811A61DA6360D69449cc",
        icon: null,
        usdValue: 149867.79869519276,
      },
      {
        id: "56",
        name: "BAT",
        value: 20,
        tokenType: "alt",
        address: "0x101d82428437127bf1608f699cd651e6abf9766e",
        icon: null,
        usdValue: 119265.36693126455,
      },
      {
        id: "56",
        name: "WIN",
        value: 20,
        tokenType: "alt",
        address: "0xaef0d72a118ce24fee3cd1d43d383897d05b4e99",
        icon: null,
        usdValue: 31174.583849660157,
      },
      {
        id: "1",
        name: "CRTS",
        value: 20,
        tokenType: "alt",
        address: "0x678e840c640f619e17848045d23072844224dd37",
        icon: null,
        usdValue: 866366.877450184,
      },
      {
        id: "1",
        name: "BOA",
        value: 20,
        tokenType: "alt",
        address: "0x746dda2ea243400d5a63e0700f190ab79f06489e",
        icon: null,
        usdValue: 285482.1736229301,
      },
      {
        id: "1",
        name: "GUM",
        value: 20,
        tokenType: "alt",
        address: "0x4f5fa8f2d12e5eb780f6082dd656c565c48e0f24",
        icon: null,
        usdValue: 153486.05853676604,
      },
      {
        id: "1",
        name: "NVIR",
        value: 20,
        tokenType: "alt",
        address: "0x9d71ce49ab8a0e6d2a1e7bfb89374c9392fd6804",
        icon: null,
        usdValue: 6989828.857130401,
      },
      {
        id: "1",
        name: "OBT",
        value: 20,
        tokenType: "alt",
        address: "0x07f9702ce093db82dfdc92c2c6e578d6ea8d5e22",
        icon: null,
        usdValue: 10908165.472796498,
      },
      {
        id: "1",
        name: "FORM",
        value: 20,
        tokenType: "alt",
        address: "0x21381e026Ad6d8266244f2A583b35F9E4413FA2a",
        icon: null,
        usdValue: 108085.60637204318,
      },
      {
        id: "1",
        name: "MESA",
        value: 20,
        tokenType: "alt",
        address: "0x5afff9876c1f98b7d2b53bcb69eb57e92408319f",
        icon: null,
        usdValue: 187115.49872346316,
      },
      {
        id: "1",
        name: "INDI",
        value: 20,
        tokenType: "alt",
        address: "0x3392d8a60b77f8d3eaa4fb58f09d835bd31add29",
        icon: null,
        usdValue: 88569.14935284376,
      },
      {
        id: "1",
        name: "XSGD",
        value: 20,
        tokenType: "alt",
        address: "0x70e8de73ce538da2beed35d14187f6959a8eca96",
        icon: null,
        usdValue: 1297931.0568915436,
      },
      {
        id: "1",
        name: "HUNT",
        value: 20,
        tokenType: "alt",
        address: "0x9aab071b4129b083b01cb5a0cb513ce7eca26fa5",
        icon: null,
        usdValue: 72097.42851828404,
      },
      {
        id: "1",
        name: "LOCUS",
        value: 20,
        tokenType: "alt",
        address: "0xc64500dd7b0f1794807e67802f8abbf5f8ffb054",
        icon: null,
        usdValue: 8069202.431345037,
      },
      {
        id: "1",
        name: "FRR",
        value: 19,
        tokenType: "alt",
        address: "0xe6602b34d8510b033e000975b3322537c7172441",
        icon: null,
        usdValue: 387065.0646608182,
      },
      {
        id: "1",
        name: "SNOW",
        value: 19,
        tokenType: "alt",
        address: "0xfe9a29ab92522d14fc65880d817214261d8479ae",
        icon: null,
        usdValue: 59273.10573706827,
      },
      {
        id: "56",
        name: "AIT",
        value: 19,
        tokenType: "alt",
        address: "0x4238E5Ccc619dCC8c00ADE4cfc5d3D9020b24898",
        icon: null,
        usdValue: 2587.089500000001,
      },
      {
        id: "1",
        name: "DHT",
        value: 19,
        tokenType: "alt",
        address: "0xca1207647Ff814039530D7d35df0e1Dd2e91Fa84",
        icon: null,
        usdValue: 332423.49600450223,
      },
      {
        id: "1",
        name: "AMKT",
        value: 19,
        tokenType: "alt",
        address: "0xf17a3fe536f8f7847f1385ec1bc967b2ca9cae8d",
        icon: null,
        usdValue: 460904.5312457611,
      },
      {
        id: "10",
        name: "stg",
        value: 19,
        tokenType: "alt",
        address: "0x296f55f8fb28e498b858d0bcda06d955b2cb3f97",
        icon: null,
        usdValue: 1629.1552848785886,
      },
      {
        id: "137",
        name: "RBW",
        value: 19,
        tokenType: "alt",
        address: "0x431cd3c9ac9fc73644bf68bf5691f4b83f9e104f",
        icon: null,
        usdValue: 597041.7081520673,
      },
      {
        id: "1",
        name: "CHSB",
        value: 19,
        tokenType: "alt",
        address: "0xba9d4199fab4f26efe3551d490e3821486f135ba",
        icon: null,
        usdValue: 711625.6903336056,
      },
      {
        id: "1",
        name: "GUILD",
        value: 19,
        tokenType: "alt",
        address: "0x83e9f223e1edb3486f876ee888d76bfba26c475a",
        icon: null,
        usdValue: 165802.31571029226,
      },
      {
        id: "1",
        name: "MINT",
        value: 19,
        tokenType: "alt",
        address: "0x0cdf9acd87e940837ff21bb40c9fd55f68bba059",
        icon: null,
        usdValue: 15773.469321830427,
      },
      {
        id: "1",
        name: "NUX",
        value: 19,
        tokenType: "alt",
        address: "0x89bd2e7e388fab44ae88bef4e1ad12b4f1e0911c",
        icon: null,
        usdValue: 255726.2062904958,
      },
      {
        id: "56",
        name: "TAP",
        value: 19,
        tokenType: "alt",
        address: "0xb229c47132d42576a15037a2931f9edd01ac0c2a",
        icon: null,
        usdValue: 852512.391359692,
      },
      {
        id: "1",
        name: "UNCX",
        value: 19,
        tokenType: "alt",
        address: "0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
        icon: null,
        usdValue: 54560.44247586002,
      },
      {
        id: "1",
        name: "ICE",
        value: 19,
        tokenType: "alt",
        address: "0xf16e81dce15b08f326220742020379b855b87df9",
        icon: null,
        usdValue: 46534.237152663954,
      },
      {
        id: "1",
        name: "UDO",
        value: 19,
        tokenType: "alt",
        address: "0xea3983fc6d0fbbc41fb6f6091f68f3e08894dc06",
        icon: null,
        usdValue: 76090.89513768007,
      },
      {
        id: "56",
        name: "ZAM",
        value: 19,
        tokenType: "alt",
        address: "0xbbcf57177d8752b21d080bf30a06ce20ad6333f8",
        icon: null,
        usdValue: 315109.4881609418,
      },
      {
        id: "1",
        name: "UFARM",
        value: 19,
        tokenType: "alt",
        address: "0x40986a85b4cfcdb054a6cbfb1210194fee51af88",
        icon: null,
        usdValue: 4155.4780576463045,
      },
      {
        id: "1",
        name: "GEEQ",
        value: 19,
        tokenType: "alt",
        address: "0x6b9f031d718dded0d681c20cb754f97b3bb81b78",
        icon: null,
        usdValue: 787801.7180113752,
      },
      {
        id: "1",
        name: "ZERO",
        value: 19,
        tokenType: "alt",
        address: "0x0ec78ed49c2d27b315d462d43b5bab94d2c79bf8",
        icon: null,
        usdValue: 120320.1479698155,
      },
      {
        id: "1",
        name: "DEXTF",
        value: 19,
        tokenType: "alt",
        address: "0x5F64Ab1544D28732F0A24F4713c2C8ec0dA089f0",
        icon: null,
        usdValue: 297509.73721089517,
      },
      {
        id: "42161",
        name: "RAM",
        value: 19,
        tokenType: "alt",
        address: "0xaaa6c1e32c55a7bfa8066a6fae9b42650f262418",
        icon: null,
        usdValue: 37673.55022280887,
      },
      {
        id: "1",
        name: "XNL",
        value: 19,
        tokenType: "alt",
        address: "0x06a00715e6f92210af9d7680b584931faf71a833",
        icon: null,
        usdValue: 317383.85988435,
      },
      {
        id: "1",
        name: "WMINIMA",
        value: 19,
        tokenType: "alt",
        address: "0x669c01caf0edcad7c2b8dc771474ad937a7ca4af",
        icon: null,
        usdValue: 1202434.0214702312,
      },
      {
        id: "1",
        name: "ZCN",
        value: 19,
        tokenType: "alt",
        address: "0xb9ef770b6a5e12e45983c5d80545258aa38f3b78",
        icon: null,
        usdValue: 409354.3581662579,
      },
      {
        id: "1",
        name: "XI",
        value: 19,
        tokenType: "alt",
        address: "0x295B42684F90c77DA7ea46336001010F2791Ec8c",
        icon: null,
        usdValue: 201227.68784119052,
      },
      {
        id: "56",
        name: "REVO",
        value: 19,
        tokenType: "alt",
        address: "0x155040625D7ae3e9caDA9a73E3E44f76D3Ed1409",
        icon: null,
        usdValue: 130602.71380117748,
      },
      {
        id: "1",
        name: "NCR",
        value: 19,
        tokenType: "alt",
        address: "0xdb5c3c46e28b53a39c255aa39a411dd64e5fed9c",
        icon: null,
        usdValue: 82067.54391097071,
      },
      {
        id: "56",
        name: "KNC",
        value: 19,
        tokenType: "alt",
        address: "0xfe56d5892bdffc7bf58f2e84be1b2c32d21c308b",
        icon: null,
        usdValue: 100485.13737751092,
      },
      {
        id: "42161",
        name: "WAXL",
        value: 19,
        tokenType: "alt",
        address: "0x23ee2343B892b1BB63503a4FAbc840E0e2C6810f",
        icon: null,
        usdValue: 1248865.2675662362,
      },
      {
        id: "56",
        name: "BABY",
        value: 19,
        tokenType: "alt",
        address: "0x53e562b9b7e5e94b81f10e96ee70ad06df3d2657",
        icon: null,
        usdValue: 400729.9726636042,
      },
      {
        id: "56",
        name: "KUNCI",
        value: 19,
        tokenType: "alt",
        address: "0x6cf271270662be1c4fc1b7bb7d7d7fc60cc19125",
        icon: null,
        usdValue: 155886.91409421794,
      },
      {
        id: "56",
        name: "BETA",
        value: 19,
        tokenType: "alt",
        address: "0xbe1a001fe942f96eea22ba08783140b9dcc09d28",
        icon: null,
        usdValue: 478122.8597845987,
      },
      {
        id: "1",
        name: "SHPING",
        value: 19,
        tokenType: "alt",
        address: "0x7c84e62859d0715eb77d1b1c4154ecd6abb21bec",
        icon: null,
        usdValue: 488062.21075412765,
      },
      {
        id: "1",
        name: "DFA",
        value: 19,
        tokenType: "alt",
        address: "0x62959c699a52ec647622c91e79ce73344e4099f5",
        icon: null,
        usdValue: 168951.14967505255,
      },
      {
        id: "1",
        name: "DXGM",
        value: 19,
        tokenType: "alt",
        address: "0x66f73d0fd4161cfad4302dc145ff994375c13475",
        icon: null,
        usdValue: 315181.5038120688,
      },
      {
        id: "1",
        name: "BAX",
        value: 19,
        tokenType: "alt",
        address: "0xf920e4f3fbef5b3ad0a25017514b769bdc4ac135",
        icon: null,
        usdValue: 4745710.759309586,
      },
      {
        id: "1",
        name: "STBU",
        value: 19,
        tokenType: "alt",
        address: "0xa6422e3e219ee6d4c1b18895275fe43556fd50ed",
        icon: null,
        usdValue: 2692106.498757724,
      },
      {
        id: "1",
        name: "WOM",
        value: 19,
        tokenType: "alt",
        address: "0xbd356a39bff2cada8e9248532dd879147221cf76",
        icon: null,
        usdValue: 303581.5147844678,
      },
      {
        id: "1",
        name: "BEST",
        value: 19,
        tokenType: "alt",
        address: "0x1b073382e63411e3bcffe90ac1b9a43fefa1ec6f",
        icon: null,
        usdValue: 512301.01186291664,
      },
      {
        id: "1",
        name: "IMPT",
        value: 19,
        tokenType: "alt",
        address: "0x04c17b9d3b29a78f7bd062a57cf44fc633e71f85",
        icon: null,
        usdValue: 1060677.1073812174,
      },
      {
        id: "1",
        name: "1EARTH",
        value: 19,
        tokenType: "alt",
        address: "0x9e04f519b094f5f8210441e285f603f4d2b50084",
        icon: null,
        usdValue: 147235.6820391288,
      },
      {
        id: "56",
        name: "TKO",
        value: 19,
        tokenType: "alt",
        address: "0x9f589e3eabe42ebc94a44727b3f3531c0c877809",
        icon: null,
        usdValue: 2561125.8656226983,
      },
      {
        id: "56",
        name: "WWY",
        value: 19,
        tokenType: "alt",
        address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
        icon: null,
        usdValue: 2855763.7628581095,
      },
      {
        id: "1",
        name: "NCDT",
        value: 19,
        tokenType: "alt",
        address: "0xe0c8b298db4cffe05d1bea0bb1ba414522b33c1b",
        icon: null,
        usdValue: 2495666.388316375,
      },
      {
        id: "1",
        name: "ALPHR",
        value: 18,
        tokenType: "alt",
        address: "0xaa99199d1e9644b588796F3215089878440D58e0",
        icon: null,
        usdValue: 248653.35747535154,
      },
      {
        id: "1",
        name: "FWB",
        value: 18,
        tokenType: "alt",
        address: "0x35bd01fc9d6d5d81ca9e055db88dc49aa2c699a8",
        icon: null,
        usdValue: 16407.428859370346,
      },
      {
        id: "137",
        name: "PORTX",
        value: 18,
        tokenType: "alt",
        address: "0x189586b5f6317538ae50c20a976597da38984a24",
        icon: null,
        usdValue: 268615.21050070703,
      },
      {
        id: "1",
        name: "RAIL",
        value: 18,
        tokenType: "alt",
        address: "0xe76c6c83af64e4c60245d8c7de953df673a7a33d",
        icon: null,
        usdValue: 63700.807630885014,
      },
      {
        id: "56",
        name: "ARBI",
        value: 18,
        tokenType: "alt",
        address: "0xa7bD657C5838472dDF85FF0797A2e6fce8fd4833",
        icon: null,
        usdValue: 146552.8754486486,
      },
      {
        id: "56",
        name: "RPG",
        value: 18,
        tokenType: "alt",
        address: "0x01e0d17a533e5930a349c2bb71304f04f20ab12b",
        icon: null,
        usdValue: 982.0765526553159,
      },
      {
        id: "1",
        name: "PLT",
        value: 18,
        tokenType: "alt",
        address: "0x9fbfed658919a896b5dc7b00456ce22d780f9b65",
        icon: null,
        usdValue: 1356078.7483288478,
      },
      {
        id: "1",
        name: "OCN",
        value: 18,
        tokenType: "alt",
        address: "0x4092678e4E78230F46A1534C0fbc8fA39780892B",
        icon: null,
        usdValue: 669096.3763647948,
      },
      {
        id: "1",
        name: "RVF",
        value: 18,
        tokenType: "alt",
        address: "0xdc8af07a7861bedd104b8093ae3e9376fc8596d2",
        icon: null,
        usdValue: 239430.82660136078,
      },
      {
        id: "56",
        name: "LVL",
        value: 18,
        tokenType: "alt",
        address: "0xb64e280e9d1b5dbec4accedb2257a87b400db149",
        icon: null,
        usdValue: 68870.94283595654,
      },
      {
        id: "1",
        name: "PINE",
        value: 18,
        tokenType: "alt",
        address: "0x569424c5EE13884A193773fDC5d1c5f79C443a51",
        icon: null,
        usdValue: 32850.89463672725,
      },
      {
        id: "1",
        name: "MRCH",
        value: 18,
        tokenType: "alt",
        address: "0xbed4ab0019ff361d83ddeb74883dac8a70f5ea1e",
        icon: null,
        usdValue: 140554.37633886925,
      },
      {
        id: "1",
        name: "EBOX",
        value: 18,
        tokenType: "alt",
        address: "0x33840024177a7daca3468912363bed8b425015c5",
        icon: null,
        usdValue: 1873.9690159683023,
      },
      {
        id: "1",
        name: "ARCH",
        value: 18,
        tokenType: "alt",
        address: "0x1f3f9d3068568f8040775be2e8c03c103c61f3af",
        icon: null,
        usdValue: 6000.641633213155,
      },
      {
        id: "1",
        name: "AVG",
        value: 18,
        tokenType: "alt",
        address: "0xa41f142b6eb2b164f8164cae0716892ce02f311f",
        icon: null,
        usdValue: 68165.77181497576,
      },
      {
        id: "56",
        name: "WAM",
        value: 18,
        tokenType: "alt",
        address: "0xebbaeff6217d22e7744394061d874015709b8141",
        icon: null,
        usdValue: 1170461.7864992209,
      },
      {
        id: "1",
        name: "SHOP",
        value: 18,
        tokenType: "alt",
        address: "0x64b78325d7495d6d4be92f234fa3f3b8d8964b8b",
        icon: null,
        usdValue: 7897.983095178218,
      },
      {
        id: "1",
        name: "ZEUM",
        value: 18,
        tokenType: "alt",
        address: "0x436dA116249044E8B4464F0Cf21Dd93311d88190",
        icon: null,
        usdValue: 68052.98271328308,
      },
      {
        id: "137",
        name: "GSG",
        value: 18,
        tokenType: "alt",
        address: "0x778949e707A0eb6c32ca20b1F9E0Db9685d18024",
        icon: null,
        usdValue: 15098.183108664954,
      },
      {
        id: "1",
        name: "RVST",
        value: 18,
        tokenType: "alt",
        address: "0x120a3879da835a5af037bb2d1456bebd6b54d4ba",
        icon: null,
        usdValue: 94074.83104027365,
      },
      {
        id: "1",
        name: "RFR",
        value: 18,
        tokenType: "alt",
        address: "0xd0929d411954c47438dc1d871dd6081f5c5e149c",
        icon: null,
        usdValue: 24259.19260632765,
      },
      {
        id: "137",
        name: "PAXW",
        value: 18,
        tokenType: "alt",
        address: "0xC79Ae93D9C215EAa8c8DA5C77E465baC7dE28891",
        icon: null,
        usdValue: 204.58886236720025,
      },
      {
        id: "1",
        name: "ULU",
        value: 18,
        tokenType: "alt",
        address: "0x035bfe6057e15ea692c0dfdcab3bb41a64dd2ad4",
        icon: null,
        usdValue: 19688.62123388453,
      },
      {
        id: "137",
        name: "MCASH",
        value: 18,
        tokenType: "alt",
        address: "0xa25610a77077390a75ad9072a084c5fbc7d43a0d",
        icon: null,
        usdValue: 209882.29599313554,
      },
      {
        id: "1",
        name: "CTR",
        value: 18,
        tokenType: "alt",
        address: "0x923b83c26b3809d960ff80332ed00aa46d7ed375",
        icon: null,
        usdValue: 44920.70674777271,
      },
      {
        id: "56",
        name: "QUACK",
        value: 18,
        tokenType: "alt",
        address: "0xd74b782e05aa25c50e7330af541d46e18f36661c",
        icon: null,
        usdValue: 6093354.769236048,
      },
      {
        id: "56",
        name: "AIOZ",
        value: 18,
        tokenType: "alt",
        address: "0x33d08d8c7a168333a85285a68c0042b39fc3741d",
        icon: null,
        usdValue: 5106121.324115095,
      },
      {
        id: "1",
        name: "DHV",
        value: 18,
        tokenType: "alt",
        address: "0x62dc4817588d53a056cbbd18231d91ffccd34b2a",
        icon: null,
        usdValue: 53587.17795557668,
      },
      {
        id: "1",
        name: "BAG",
        value: 18,
        tokenType: "alt",
        address: "0x28a06c02287e657ec3f8e151a13c36a1d43814b0",
        icon: null,
        usdValue: 3200.156747860766,
      },
      {
        id: "1",
        name: "ABYSS",
        value: 18,
        tokenType: "alt",
        address: "0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6",
        icon: null,
        usdValue: 147781.39934967094,
      },
      {
        id: "42161",
        name: "TND",
        value: 18,
        tokenType: "alt",
        address: "0xc47d9753f3b32aa9548a7c3f30b6aec3b2d2798c",
        icon: null,
        usdValue: 40729.79400917019,
      },
      {
        id: "1",
        name: "GOVI",
        value: 18,
        tokenType: "alt",
        address: "0xeeaa40b28a2d1b0b08f6f97bb1dd4b75316c6107",
        icon: null,
        usdValue: 192988.80089436658,
      },
      {
        id: "56",
        name: "TENFI",
        value: 18,
        tokenType: "alt",
        address: "0xd15c444f1199ae72795eba15e8c1db44e47abf62",
        icon: null,
        usdValue: 165.32357087920877,
      },
      {
        id: "56",
        name: "GFAL",
        value: 18,
        tokenType: "alt",
        address: "0x47c454cA6be2f6DEf6f32b638C80F91c9c3c5949",
        icon: null,
        usdValue: 10556238.089956643,
      },
      {
        id: "56",
        name: "CAL",
        value: 18,
        tokenType: "alt",
        address: "0x859C940F080B197659b3EfFc804fD622Df66f0a1",
        icon: null,
        usdValue: 165982.42322934535,
      },
      {
        id: "56",
        name: "PMG",
        value: 18,
        tokenType: "alt",
        address: "0x0733618Ab62eEEC815f2d1739b7a50bF9E74d8a2",
        icon: null,
        usdValue: 4465113.938599577,
      },
      {
        id: "56",
        name: "SPACEPI",
        value: 18,
        tokenType: "alt",
        address: "0x69b14e8D3CEBfDD8196Bfe530954A0C226E5008E",
        icon: null,
        usdValue: 1945.9086834010636,
      },
      {
        id: "56",
        name: "EOS",
        value: 18,
        tokenType: "alt",
        address: "0x56b6fB708fC5732DEC1Afc8D8556423A2EDcCbD6",
        icon: null,
        usdValue: 258028.36027943535,
      },
      {
        id: "56",
        name: "SNX",
        value: 18,
        tokenType: "alt",
        address: "0x9ac983826058b8a9c7aa1c9171441191232e8404",
        icon: null,
        usdValue: 34996.388285279754,
      },
      {
        id: "56",
        name: "IOTA",
        value: 18,
        tokenType: "alt",
        address: "0xd944f1d1e9d5f9bb90b62f9d45e447d989580782",
        icon: null,
        usdValue: 4073776.4392029843,
      },
      {
        id: "56",
        name: "YFI",
        value: 18,
        tokenType: "alt",
        address: "0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e",
        icon: null,
        usdValue: 65810.7990399568,
      },
      {
        id: "1",
        name: "OXY",
        value: 18,
        tokenType: "alt",
        address: "0x965697b4ef02f0de01384d0d4f9f782b1670c163",
        icon: null,
        usdValue: 15372882.647060381,
      },
      {
        id: "1",
        name: "SKT",
        value: 18,
        tokenType: "alt",
        address: "0x012e0e6342308b247f36ee500ecb14dc77a7a8c1",
        icon: null,
        usdValue: 114535.63917698852,
      },
      {
        id: "1",
        name: "SPUME",
        value: 18,
        tokenType: "alt",
        address: "0xa16a609fF4e1A15b6cCb469E7a5dD14E89305283",
        icon: null,
        usdValue: 22791.5502763696,
      },
      {
        id: "1",
        name: "COPI",
        value: 18,
        tokenType: "alt",
        address: "0x42baf1f659d765c65ade5bb7e08eb2c680360d9d",
        icon: null,
        usdValue: 623741.5357961531,
      },
      {
        id: "1",
        name: "TALK",
        value: 18,
        tokenType: "alt",
        address: "0xcaabcaa4ca42e1d86de1a201c818639def0ba7a7",
        icon: null,
        usdValue: 1303550.1255344658,
      },
      {
        id: "1",
        name: "ZAM",
        value: 18,
        tokenType: "alt",
        address: "0xd373576a9e738F37Dc6882328358Ff69c4cAf4c6",
        icon: null,
        usdValue: 55622.98703074476,
      },
      {
        id: "1",
        name: "CTI",
        value: 18,
        tokenType: "alt",
        address: "0xcb8fb2438a805664cd8c3e640b85ac473da5be87",
        icon: null,
        usdValue: 1882093.4110270087,
      },
      {
        id: "1",
        name: "REAP",
        value: 18,
        tokenType: "alt",
        address: "0x1fc5EF0337AEA85C5f9198853a6E3A579a7A6987",
        icon: null,
        usdValue: 72155.45388701133,
      },
      {
        id: "1",
        name: "NRFB",
        value: 18,
        tokenType: "alt",
        address: "0x00281dfce4cfd72c0b6fda2aaaf077258743f9e8",
        icon: null,
        usdValue: 78128.45300382,
      },
      {
        id: "1",
        name: "BOX",
        value: 18,
        tokenType: "alt",
        address: "0x63f584FA56E60e4D0fE8802b27C7e6E3b33E007f",
        icon: null,
        usdValue: 4395.667938094597,
      },
      {
        id: "1",
        name: "CDT",
        value: 18,
        tokenType: "alt",
        address: "0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af",
        icon: null,
        usdValue: 3479099.049821533,
      },
      {
        id: "1",
        name: "BBF",
        value: 18,
        tokenType: "alt",
        address: "0xde075d9adbd0240b4462f124af926452ad0bac91",
        icon: null,
        usdValue: 2279965.3484721244,
      },
      {
        id: "1",
        name: "SRT",
        value: 18,
        tokenType: "alt",
        address: "0x22987407FD1fC5A971e3FDA3B3e74C88666cDa91",
        icon: null,
        usdValue: 97411.02267282718,
      },
      {
        id: "1",
        name: "HNB",
        value: 18,
        tokenType: "alt",
        address: "0x6E0615a03eD9527a6013FcD5B556E36EF4DaB1FF",
        icon: null,
        usdValue: 3858213.459414257,
      },
      {
        id: "1",
        name: "KAP",
        value: 18,
        tokenType: "alt",
        address: "0x9625ce7753ace1fa1865a47aae2c5c2ce4418569",
        icon: null,
        usdValue: 406946.2018137636,
      },
      {
        id: "1",
        name: "TRG",
        value: 18,
        tokenType: "alt",
        address: "0x93eEB426782BD88fCD4B48D7b0368CF061044928",
        icon: null,
        usdValue: 107957.82902186824,
      },
      {
        id: "1",
        name: "HAO",
        value: 18,
        tokenType: "alt",
        address: "0x3c4008eca800ec1283e4cf500e68d06bfabc00a8",
        icon: null,
        usdValue: 354184.536676231,
      },
      {
        id: "56",
        name: "USTC",
        value: 18,
        tokenType: "alt",
        address: "0x23396cf899ca06c4472205fc903bdb4de249d6fc",
        icon: null,
        usdValue: 493147.371474996,
      },
      {
        id: "56",
        name: "VOLT",
        value: 18,
        tokenType: "alt",
        address: "0x7db5af2B9624e1b3B4Bb69D6DeBd9aD1016A58Ac",
        icon: null,
        usdValue: 301.73406124998087,
      },
      {
        id: "1",
        name: "CVT",
        value: 18,
        tokenType: "alt",
        address: "0xbe428c3867f05dea2a89fc76a102b544eac7f772",
        icon: null,
        usdValue: 574531.6315497454,
      },
      {
        id: "1",
        name: "SIMP",
        value: 18,
        tokenType: "alt",
        address: "0x41C21693e60FC1a5dBb7c50e54E7A6016aA44C99",
        icon: null,
        usdValue: 193750.06146668678,
      },
      {
        id: "1",
        name: "PRIMATE",
        value: 18,
        tokenType: "alt",
        address: "0x46e98FFE40E408bA6412bEb670507e083C8B95ff",
        icon: null,
        usdValue: 27828.700544070536,
      },
      {
        id: "1",
        name: "BPT",
        value: 17,
        tokenType: "alt",
        address: "0x0eC9F76202a7061eB9b3a7D6B59D36215A7e37da",
        icon: null,
        usdValue: 127.35579916658655,
      },
      {
        id: "1",
        name: "BID",
        value: 17,
        tokenType: "alt",
        address: "0x00000000000045166c45af0fc6e4cf31d9e14b9a",
        icon: null,
        usdValue: 3470.076921798857,
      },
      {
        id: "1",
        name: "YOP",
        value: 17,
        tokenType: "alt",
        address: "0xae1eaae3f627aaca434127644371b67b18444051",
        icon: null,
        usdValue: 560.5128311472179,
      },
      {
        id: "1",
        name: "DEFX",
        value: 17,
        tokenType: "alt",
        address: "0x5f474906637bdcda05f29c74653f6962bb0f8eda",
        icon: null,
        usdValue: 1114.4222471154417,
      },
      {
        id: "1",
        name: "GOHM",
        value: 17,
        tokenType: "alt",
        address: "0x0ab87046fBb341D058F17CBC4c1133F25a20a52f",
        icon: null,
        usdValue: 145353.73682177524,
      },
      {
        id: "1",
        name: "LGCY",
        value: 17,
        tokenType: "alt",
        address: "0xae697f994fc5ebc000f8e22ebffee04612f98a0d",
        icon: null,
        usdValue: 1948.7795132367153,
      },
      {
        id: "56",
        name: "BBANK",
        value: 17,
        tokenType: "alt",
        address: "0xf4b5470523ccd314c6b9da041076e7d79e0df267",
        icon: null,
        usdValue: 4569.431129507879,
      },
      {
        id: "1",
        name: "DIVER",
        value: 17,
        tokenType: "alt",
        address: "0xfb782396c9b20e564a64896181c7ac8d8979d5f4",
        icon: null,
        usdValue: 327762.6582013886,
      },
      {
        id: "137",
        name: "DFYN",
        value: 17,
        tokenType: "alt",
        address: "0xC168E40227E4ebD8C1caE80F7a55a4F0e6D66C97",
        icon: null,
        usdValue: 5288.909995298521,
      },
      {
        id: "137",
        name: "AMKT",
        value: 17,
        tokenType: "alt",
        address: "0xb87904db461005fc716a6bf9f2d451c33b10b80b",
        icon: null,
        usdValue: 573.1393470068163,
      },
      {
        id: "1",
        name: "EOSDAC",
        value: 17,
        tokenType: "alt",
        address: "0x7e9e431a0b8c4d532c745b1043c7fa29a48d4fba",
        icon: null,
        usdValue: 8484.875344608176,
      },
      {
        id: "56",
        name: "ZIX",
        value: 17,
        tokenType: "alt",
        address: "0x48077400FAF11183c043Feb5184a13ea628Bb0DB",
        icon: null,
        usdValue: 55055.80455217296,
      },
      {
        id: "137",
        name: "CRV",
        value: 17,
        tokenType: "alt",
        address: "0x172370d5cd63279efa6d502dab29171933a610af",
        icon: null,
        usdValue: 4904.926287239052,
      },
      {
        id: "137",
        name: "CATHEON",
        value: 17,
        tokenType: "alt",
        address: "0x7e7737C40878e720b32e7bC9CD096259f876d69f",
        icon: null,
        usdValue: 763949.3284406578,
      },
      {
        id: "42161",
        name: "MIM",
        value: 17,
        tokenType: "stable",
        address: "0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a",
        icon: null,
        usdValue: 1395.4876301828408,
      },
      {
        id: "1",
        name: "CHAD",
        value: 17,
        tokenType: "alt",
        address: "0x6b89b97169a797d94f057f4a0b01e2ca303155e4",
        icon: null,
        usdValue: 108407.36538092888,
      },
      {
        id: "56",
        name: "O3",
        value: 17,
        tokenType: "alt",
        address: "0xee9801669c6138e84bd50deb500827b776777d28",
        icon: null,
        usdValue: 354483.2232946524,
      },
      {
        id: "1",
        name: "HORD",
        value: 17,
        tokenType: "alt",
        address: "0x43a96962254855f16b925556f9e97be436a43448",
        icon: null,
        usdValue: 146519.39985439822,
      },
      {
        id: "1",
        name: "NSURE",
        value: 17,
        tokenType: "alt",
        address: "0x20945cA1df56D237fD40036d47E866C7DcCD2114",
        icon: null,
        usdValue: 115057.97758970222,
      },
      {
        id: "1",
        name: "DOUGH",
        value: 17,
        tokenType: "alt",
        address: "0xad32a8e6220741182940c5abf610bde99e737b2d",
        icon: null,
        usdValue: 4888.23634392499,
      },
      {
        id: "1",
        name: "MXT",
        value: 17,
        tokenType: "alt",
        address: "0x6251e725cd45fb1af99354035a414a2c0890b929",
        icon: null,
        usdValue: 23345.76267154617,
      },
      {
        id: "1",
        name: "BAC",
        value: 17,
        tokenType: "alt",
        address: "0x3449fc1cd036255ba1eb19d65ff4ba2b8903a69a",
        icon: null,
        usdValue: 154168.33714407036,
      },
      {
        id: "1",
        name: "MFI",
        value: 17,
        tokenType: "alt",
        address: "0xaa4e3edb11afa93c41db59842b29de64b72e355b",
        icon: null,
        usdValue: 15148.72748267155,
      },
      {
        id: "56",
        name: "EJS",
        value: 17,
        tokenType: "alt",
        address: "0x09f423aC3C9baBBfF6F94D372b16E4206e71439f",
        icon: null,
        usdValue: 364555.684765154,
      },
      {
        id: "137",
        name: "KASTA",
        value: 17,
        tokenType: "alt",
        address: "0x235737dbb56e8517391473f7c964db31fa6ef280",
        icon: null,
        usdValue: 20567467.75586597,
      },
      {
        id: "1",
        name: "ATRI",
        value: 17,
        tokenType: "alt",
        address: "0xdacd69347de42babfaecd09dc88958378780fb62",
        icon: null,
        usdValue: 15226.49616936,
      },
      {
        id: "56",
        name: "CREDI",
        value: 17,
        tokenType: "alt",
        address: "0x2235e79086dd23135119366da45851c741874e5b",
        icon: null,
        usdValue: 105100.2238305254,
      },
      {
        id: "56",
        name: "OCTANE",
        value: 17,
        tokenType: "alt",
        address: "0x5416ab2b4b5a40f740b67a83dc5939591b5c08be",
        icon: null,
        usdValue: 324.0917977042112,
      },
      {
        id: "56",
        name: "PARA",
        value: 17,
        tokenType: "alt",
        address: "0x076ddce096c93dcf5d51fe346062bf0ba9523493",
        icon: null,
        usdValue: 227450.28290382042,
      },
      {
        id: "1",
        name: "pBTC35A",
        value: 17,
        tokenType: "alt",
        address: "0xA8b12Cc90AbF65191532a12bb5394A714A46d358",
        icon: null,
        usdValue: 49267.82003655707,
      },
      {
        id: "1",
        name: "AGV",
        value: 17,
        tokenType: "alt",
        address: "0xf4f618eff5ef36cde2fca4fbd86554c62fb1382b",
        icon: null,
        usdValue: 1675.9110767497423,
      },
      {
        id: "1",
        name: "OLE",
        value: 17,
        tokenType: "alt",
        address: "0x92CfbEC26C206C90aeE3b7C66A9AE673754FaB7e",
        icon: null,
        usdValue: 17433.61107451714,
      },
      {
        id: "1",
        name: "ASW",
        value: 17,
        tokenType: "alt",
        address: "0x56694577564FdD577a0ABB20FE95C1E2756C2a11",
        icon: null,
        usdValue: 20179.915448244166,
      },
      {
        id: "1",
        name: "HYPC",
        value: 17,
        tokenType: "alt",
        address: "0xeA7B7DC089c9a4A916B5a7a37617f59fD54e37E4",
        icon: null,
        usdValue: 4893013.582190483,
      },
      {
        id: "1",
        name: "BP",
        value: 17,
        tokenType: "alt",
        address: "0xdF290B162a7D3E0A328cF198308D421954f08b94",
        icon: null,
        usdValue: 221622.26271314782,
      },
      {
        id: "56",
        name: "DOMI",
        value: 17,
        tokenType: "alt",
        address: "0xbbca42c60b5290f2c48871a596492f93ff0ddc82",
        icon: null,
        usdValue: 541916.5985740275,
      },
      {
        id: "56",
        name: "KMON",
        value: 17,
        tokenType: "alt",
        address: "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
        icon: null,
        usdValue: 494.2658506054931,
      },
      {
        id: "1",
        name: "EGT",
        value: 17,
        tokenType: "alt",
        address: "0x450e7f6e3a2f247a51b98c39297a9a5bfbdb3170",
        icon: null,
        usdValue: 44764.805518400775,
      },
      {
        id: "1",
        name: "SHI",
        value: 17,
        tokenType: "alt",
        address: "0x243cacb4d5ff6814ad668c3e225246efa886ad5a",
        icon: null,
        usdValue: 112537.77859322424,
      },
      {
        id: "1",
        name: "SKEY",
        value: 17,
        tokenType: "alt",
        address: "0x06a01a4d579479dd5d884ebf61a31727a3d8d442",
        icon: null,
        usdValue: 4722685.389718875,
      },
      {
        id: "8217",
        name: "KAIA",
        value: 17,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 28098599.86788286,
      },
      {
        id: "56",
        name: "TONCOIN",
        value: 17,
        tokenType: "alt",
        address: "0x76A797A59Ba2C17726896976B7B3747BfD1d220f",
        icon: null,
        usdValue: 5953341.109506703,
      },
      {
        id: "56",
        name: "KINGSHIB",
        value: 17,
        tokenType: "alt",
        address: "0x84f4f7cdb4574c9556a494dab18ffc1d1d22316c",
        icon: null,
        usdValue: 2742.525385673257,
      },
      {
        id: "1",
        name: "DNXC",
        value: 17,
        tokenType: "alt",
        address: "0x20a8cec5fffea65be7122bcab2ffe32ed4ebf03a",
        icon: null,
        usdValue: 34006.48597778149,
      },
      {
        id: "56",
        name: "DPR",
        value: 17,
        tokenType: "alt",
        address: "0xA0A2eE912CAF7921eaAbC866c6ef6FEc8f7E90A4",
        icon: null,
        usdValue: 927570.851606581,
      },
      {
        id: "137",
        name: "CVTX",
        value: 17,
        tokenType: "alt",
        address: "0x40f97ec376ac1c503e755433bf57f21e3a49f440",
        icon: null,
        usdValue: 1207874.1369573898,
      },
      {
        id: "42161",
        name: "APEX",
        value: 17,
        tokenType: "alt",
        address: "0x61a1ff55c5216b636a294a07d77c6f4df10d3b56",
        icon: null,
        usdValue: 42809880.50884567,
      },
      {
        id: "1",
        name: "EMON",
        value: 17,
        tokenType: "alt",
        address: "0xd6a5ab46ead26f49b03bbb1f9eb1ad5c1767974a",
        icon: null,
        usdValue: 157122.62661125764,
      },
      {
        id: "1",
        name: "AXIS",
        value: 17,
        tokenType: "alt",
        address: "0xecc0f1f860a82ab3b442382d93853c02d6384389",
        icon: null,
        usdValue: 1015185.9404833349,
      },
      {
        id: "1",
        name: "URUS",
        value: 17,
        tokenType: "alt",
        address: "0xc6dddb5bc6e61e0841c54f3e723ae1f3a807260b",
        icon: null,
        usdValue: 3670.398407515503,
      },
      {
        id: "1",
        name: "GOF",
        value: 17,
        tokenType: "alt",
        address: "0x488E0369f9BC5C40C002eA7c1fe4fd01A198801c",
        icon: null,
        usdValue: 117063.21305832255,
      },
      {
        id: "1",
        name: "DLTA",
        value: 17,
        tokenType: "alt",
        address: "0x0000000DE40dfa9B17854cBC7869D80f9F98D823",
        icon: null,
        usdValue: 116414.45079833416,
      },
      {
        id: "1",
        name: "GRV",
        value: 17,
        tokenType: "alt",
        address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
        icon: null,
        usdValue: 29037.262658486758,
      },
      {
        id: "1",
        name: "BABY",
        value: 17,
        tokenType: "alt",
        address: "0x1cCF27211e8bf052f6255329ed641B4E94E80603",
        icon: null,
        usdValue: 79962.12917693834,
      },
      {
        id: "56",
        name: "OM",
        value: 17,
        tokenType: "alt",
        address: "0xf78d2e7936f5fe18308a3b2951a93b6c4a41f5e2",
        icon: null,
        usdValue: 677033.1873815826,
      },
      {
        id: "56",
        name: "ORT",
        value: 17,
        tokenType: "alt",
        address: "0x9e711221b34a2d4b8f552bd5f4a6c4e7934920f7",
        icon: null,
        usdValue: 6326148.461878803,
      },
      {
        id: "5000",
        name: "USDT",
        value: 17,
        tokenType: "stable",
        address: "0x201eba5cc46d216ce6dc03f6a759e8e766e956ae",
        icon: null,
        usdValue: 290434.3432956481,
      },
      {
        id: "42161",
        name: "SHIBAI",
        value: 17,
        tokenType: "alt",
        address: "0xFA296FcA3c7DBa4a92A42Ec0B5E2138DA3b29050",
        icon: null,
        usdValue: 1110412.049145889,
      },
      {
        id: "1",
        name: "AI",
        value: 17,
        tokenType: "alt",
        address: "0xc91b523a59acc63a64f61fc7bbfb4bfc82dd25f2",
        icon: null,
        usdValue: 1843433.016428604,
      },
      {
        id: "1",
        name: "POE",
        value: 17,
        tokenType: "alt",
        address: "0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195",
        icon: null,
        usdValue: 340.18524850784496,
      },
      {
        id: "1",
        name: "TMTG",
        value: 17,
        tokenType: "alt",
        address: "0x10086399DD8c1e3De736724AF52587a2044c9fA2",
        icon: null,
        usdValue: 80570.55813956667,
      },
      {
        id: "1",
        name: "KAT",
        value: 17,
        tokenType: "alt",
        address: "0x14da230d6726c50f759bc1838717f8ce6373509c",
        icon: null,
        usdValue: 28851.462788299643,
      },
      {
        id: "56",
        name: "WSG",
        value: 16,
        tokenType: "alt",
        address: "0xa58950f05fea2277d2608748412bf9f802ea4901",
        icon: null,
        usdValue: 347494.1863193832,
      },
      {
        id: "1",
        name: "BEE",
        value: 16,
        tokenType: "alt",
        address: "0x4d8fc1453a0f359e99c9675954e656d80d996fbf",
        icon: null,
        usdValue: 5599.257058980688,
      },
      {
        id: "1",
        name: "ZAP",
        value: 16,
        tokenType: "alt",
        address: "0x6781a0f84c7e9e846dcb84a9a5bd49333067b104",
        icon: null,
        usdValue: 2270292.9053088706,
      },
      {
        id: "1",
        name: "GARD",
        value: 16,
        tokenType: "alt",
        address: "0x5c64031c62061865e5fd0f53d3cdaef80f72e99d",
        icon: null,
        usdValue: 147.73719146671297,
      },
      {
        id: "1",
        name: "FXF",
        value: 16,
        tokenType: "alt",
        address: "0x8a40c222996f9F3431f63Bf80244C36822060f12",
        icon: null,
        usdValue: 42020.90334465504,
      },
      {
        id: "56",
        name: "BNT",
        value: 16,
        tokenType: "alt",
        address: "0xA069008A669e2Af00a86673D9D584cfb524A42Cc",
        icon: null,
        usdValue: 7364.887605198107,
      },
      {
        id: "56",
        name: "LUNC",
        value: 16,
        tokenType: "alt",
        address: "0x156ab3346823B651294766e23e6Cf87254d68962",
        icon: null,
        usdValue: 3177.031444324708,
      },
      {
        id: "56",
        name: "KALM",
        value: 16,
        tokenType: "alt",
        address: "0x4ba0057f784858a48fe351445c672ff2a3d43515",
        icon: null,
        usdValue: 88360.54537931585,
      },
      {
        id: "1",
        name: "BYTES",
        value: 16,
        tokenType: "alt",
        address: "0x7d647b1A0dcD5525e9C6B3D14BE58f27674f8c95",
        icon: null,
        usdValue: 42181.61796212775,
      },
      {
        id: "1",
        name: "LTX",
        value: 16,
        tokenType: "alt",
        address: "0xa393473d64d2f9f026b60b6df7859a689715d092",
        icon: null,
        usdValue: 706584.0751354484,
      },
      {
        id: "1",
        name: "SPHRI",
        value: 16,
        tokenType: "alt",
        address: "0x8a0cdfab62ed35b836dc0633482798421c81b3ec",
        icon: null,
        usdValue: 166988.35997905137,
      },
      {
        id: "1",
        name: "CREDIT",
        value: 16,
        tokenType: "alt",
        address: "0xc4cb5793bd58bad06bf51fb37717b86b02cbe8a4",
        icon: null,
        usdValue: 913549.3381057996,
      },
      {
        id: "1",
        name: "KROM",
        value: 16,
        tokenType: "alt",
        address: "0x3af33bef05c2dcb3c7288b77fe1c8d2aeba4d789",
        icon: null,
        usdValue: 14410.657879950793,
      },
      {
        id: "56",
        name: "FAST",
        value: 16,
        tokenType: "alt",
        address: "0x391088b4594e41c003463c7e3a56a8ba00b8e7a9",
        icon: null,
        usdValue: 40722.62842482159,
      },
      {
        id: "56",
        name: "SCRL",
        value: 16,
        tokenType: "alt",
        address: "0x52c1751C89fc913ed274d72e8d56DcE4Ee44A5cf",
        icon: null,
        usdValue: 575.9396885918778,
      },
      {
        id: "1",
        name: "GLCH",
        value: 16,
        tokenType: "alt",
        address: "0x038a68ff68c393373ec894015816e33ad41bd564",
        icon: null,
        usdValue: 152338.0696788587,
      },
      {
        id: "1",
        name: "SDL",
        value: 16,
        tokenType: "alt",
        address: "0xf1dc500fde233a4055e25e5bbf516372bc4f6871",
        icon: null,
        usdValue: 154.53222759274107,
      },
      {
        id: "137",
        name: "PYM",
        value: 16,
        tokenType: "alt",
        address: "0x0bd49815ea8e2682220bcb41524c0dd10ba71d41",
        icon: null,
        usdValue: 438741.05653885193,
      },
      {
        id: "1",
        name: "HGET",
        value: 16,
        tokenType: "alt",
        address: "0x7968bc6a03017eA2de509AAA816F163Db0f35148",
        icon: null,
        usdValue: 149811.88796220487,
      },
      {
        id: "42161",
        name: "LODE",
        value: 16,
        tokenType: "alt",
        address: "0xf19547f9ed24aa66b03c3a552d181ae334fbb8db",
        icon: null,
        usdValue: 27734.028539577303,
      },
      {
        id: "56",
        name: "DRUG",
        value: 16,
        tokenType: "alt",
        address: "0x27e2A0E643c7f17959F84C345d2123B77bbd412c",
        icon: null,
        usdValue: 529.99577727025,
      },
      {
        id: "1",
        name: "GEM",
        value: 16,
        tokenType: "alt",
        address: "0xc7bba5b765581efb2cdd2679db5bea9ee79b201f",
        icon: null,
        usdValue: 341852.29851777275,
      },
      {
        id: "137",
        name: "LINK",
        value: 16,
        tokenType: "alt",
        address: "0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39",
        icon: null,
        usdValue: 5779.302027405904,
      },
      {
        id: "1",
        name: "BSPT",
        value: 16,
        tokenType: "alt",
        address: "0xa350da05405cc204e551c4eed19c3039646528d5",
        icon: null,
        usdValue: 139300.43817445787,
      },
      {
        id: "56",
        name: "SEOR",
        value: 16,
        tokenType: "alt",
        address: "0x800a25741a414ea6e6e2b382435081a479a8cc3c",
        icon: null,
        usdValue: 867834.3078623844,
      },
      {
        id: "56",
        name: "DES",
        value: 16,
        tokenType: "alt",
        address: "0xb38b3c34e4bb6144c1e5283af720e046ee833a2a",
        icon: null,
        usdValue: 85151.02035039541,
      },
      {
        id: "1",
        name: "2CRZ",
        value: 16,
        tokenType: "alt",
        address: "0x2c9c19ce3b15ae77c6d80aec3c1194cfd6f7f3fa",
        icon: null,
        usdValue: 1430.6408916026544,
      },
      {
        id: "1",
        name: "POP",
        value: 16,
        tokenType: "alt",
        address: "0x5d858bcd53e085920620549214a8b27ce2f04670",
        icon: null,
        usdValue: 18189.02590891611,
      },
      {
        id: "1",
        name: "PRARE",
        value: 16,
        tokenType: "alt",
        address: "0x2C2f7e7C5604D162d75641256b80F1Bf6f4dC796",
        icon: null,
        usdValue: 42533.74074551568,
      },
      {
        id: "56",
        name: "PROS",
        value: 16,
        tokenType: "alt",
        address: "0xed8c8aa8299c10f067496bb66f8cc7fb338a3405",
        icon: null,
        usdValue: 39420.471996198874,
      },
      {
        id: "1",
        name: "VERI",
        value: 16,
        tokenType: "alt",
        address: "0x8f3470A7388c05eE4e7AF3d01D8C722b0FF52374",
        icon: null,
        usdValue: 13202.096744465345,
      },
      {
        id: "56",
        name: "MLT",
        value: 16,
        tokenType: "alt",
        address: "0x4518231a8fdf6ac553b9bbd51bbb86825b583263",
        icon: null,
        usdValue: 178051.024099847,
      },
      {
        id: "1",
        name: "VDR",
        value: 16,
        tokenType: "alt",
        address: "0xed3d4e446a96dc3b181b64b75c3c70da41dc3cbe",
        icon: null,
        usdValue: 2105497.033481521,
      },
      {
        id: "1",
        name: "HUSL",
        value: 16,
        tokenType: "alt",
        address: "0xa2881f7f441267042f9778ffa0d4f834693426be",
        icon: null,
        usdValue: 311061.5482655577,
      },
      {
        id: "1",
        name: "ALPA",
        value: 16,
        tokenType: "alt",
        address: "0x7ca4408137eb639570f8e647d9bd7b7e8717514a",
        icon: null,
        usdValue: 26944.415857082302,
      },
      {
        id: "1",
        name: "KFC",
        value: 16,
        tokenType: "alt",
        address: "0xe63684bcf2987892cefb4caa79bd21b34e98a291",
        icon: null,
        usdValue: 631676.1273278291,
      },
      {
        id: "56",
        name: "TIME",
        value: 16,
        tokenType: "alt",
        address: "0x3b198e26e473b8fab2085b37978e36c9de5d7f68",
        icon: null,
        usdValue: 2365840.286889529,
      },
      {
        id: "1",
        name: "SIENNA",
        value: 16,
        tokenType: "alt",
        address: "0x9b00e6E8D787b13756eb919786c9745054DB64f9",
        icon: null,
        usdValue: 73224.18734111356,
      },
      {
        id: "1",
        name: "BUSY",
        value: 16,
        tokenType: "alt",
        address: "0x5cb3ce6d081fb00d5f6677d196f2d70010ea3f4a",
        icon: null,
        usdValue: 115438.86418125883,
      },
      {
        id: "56",
        name: "USDD",
        value: 16,
        tokenType: "stable",
        address: "0xd17479997f34dd9156deef8f95a52d81d265be9c",
        icon: null,
        usdValue: 537.0636556523312,
      },
      {
        id: "56",
        name: "QUO",
        value: 16,
        tokenType: "alt",
        address: "0x08b450e4a48C04CDF6DB2bD4cf24057f7B9563fF",
        icon: null,
        usdValue: 1575.840432559365,
      },
      {
        id: "56",
        name: "WBETH",
        value: 16,
        tokenType: "alt",
        address: "0xa2E3356610840701BDf5611a53974510Ae27E2e1",
        icon: null,
        usdValue: 1754.8467325209967,
      },
      {
        id: "56",
        name: "OGGY",
        value: 16,
        tokenType: "alt",
        address: "0x92ed61fb8955cc4e392781cb8b7cd04aadc43d0c",
        icon: null,
        usdValue: 6458.166839062782,
      },
      {
        id: "56",
        name: "MILO",
        value: 16,
        tokenType: "alt",
        address: "0xd9de2b1973e57dc9dba90c35d6cd940ae4a3cbe1",
        icon: null,
        usdValue: 1601638.3249657857,
      },
      {
        id: "1",
        name: "DEUS",
        value: 16,
        tokenType: "alt",
        address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
        icon: null,
        usdValue: 130574.84801525268,
      },
      {
        id: "1",
        name: "WBNB",
        value: 16,
        tokenType: "alt",
        address: "0x418D75f65a02b3D53B2418FB8E1fe493759c7605",
        icon: null,
        usdValue: 73144.49174513597,
      },
      {
        id: "1",
        name: "ROG",
        value: 16,
        tokenType: "alt",
        address: "0x5d43b66da68706D39f6C97F7f1415615672b446b",
        icon: null,
        usdValue: 2990772.050237015,
      },
      {
        id: "56",
        name: "MASK",
        value: 16,
        tokenType: "alt",
        address: "0x2ed9a5c8c13b93955103b9a7c167b67ef4d568a3",
        icon: null,
        usdValue: 168324.25391174204,
      },
      {
        id: "56",
        name: "DIA",
        value: 16,
        tokenType: "alt",
        address: "0x99956d38059cf7beda96ec91aa7bb2477e0901dd",
        icon: null,
        usdValue: 6643316.994226684,
      },
      {
        id: "56",
        name: "ASR",
        value: 16,
        tokenType: "alt",
        address: "0x80D5f92C2c8C682070C95495313dDB680B267320",
        icon: null,
        usdValue: 4659.737700000002,
      },
      {
        id: "1",
        name: "REALM",
        value: 16,
        tokenType: "alt",
        address: "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
        icon: null,
        usdValue: 159623.0154873029,
      },
      {
        id: "1",
        name: "ARES",
        value: 16,
        tokenType: "alt",
        address: "0x358AA737e033F34df7c54306960a38d09AaBd523",
        icon: null,
        usdValue: 150456.3487600753,
      },
      {
        id: "1",
        name: "IOEN",
        value: 16,
        tokenType: "alt",
        address: "0x1e4e46b7bf03ece908c88ff7cc4975560010893a",
        icon: null,
        usdValue: 359243.82332534133,
      },
      {
        id: "1",
        name: "MAP",
        value: 16,
        tokenType: "alt",
        address: "0x9e976f211daea0d652912ab99b0dc21a7fd728e4",
        icon: null,
        usdValue: 191174.41812802275,
      },
      {
        id: "1",
        name: "CELT",
        value: 16,
        tokenType: "alt",
        address: "0xf6e06B54855eFf198a2d9A8686113665499a6134",
        icon: null,
        usdValue: 108189.09369708678,
      },
      {
        id: "1",
        name: "BLES",
        value: 16,
        tokenType: "alt",
        address: "0xe796d6ca1ceb1b022ece5296226bf784110031cd",
        icon: null,
        usdValue: 131571.01443137595,
      },
      {
        id: "1",
        name: "MQL",
        value: 16,
        tokenType: "alt",
        address: "0x428dc22668e6f3468273634067e5545ed5417a3e",
        icon: null,
        usdValue: 1548.744162908723,
      },
      {
        id: "1",
        name: "POT",
        value: 16,
        tokenType: "alt",
        address: "0x049b98b31eF7D6448519f3642AAD92AB5b8aDa52",
        icon: null,
        usdValue: 2953257.178417192,
      },
      {
        id: "1",
        name: "DOMI",
        value: 16,
        tokenType: "alt",
        address: "0x45c2f8c9b4c0bdc76200448cc26c48ab6ffef83f",
        icon: null,
        usdValue: 1233966.6713342748,
      },
      {
        id: "1",
        name: "WAMPL",
        value: 16,
        tokenType: "alt",
        address: "0xedb171c18ce90b633db442f2a6f72874093b49ef",
        icon: null,
        usdValue: 529665.6947525576,
      },
      {
        id: "1",
        name: "ORBR",
        value: 16,
        tokenType: "alt",
        address: "0xda30f261a962d5aae94c9ecd170544600d193766",
        icon: null,
        usdValue: 340095.7895413142,
      },
      {
        id: "1",
        name: "YESP",
        value: 16,
        tokenType: "alt",
        address: "0x46cca329970b33e1a007dd4ef0594a1cedb3e72a",
        icon: null,
        usdValue: 75118.41732069151,
      },
      {
        id: "1",
        name: "CROWN",
        value: 16,
        tokenType: "alt",
        address: "0xF3Bb9F16677F2B86EfD1DFca1c141A99783Fde58",
        icon: null,
        usdValue: 6059644.771966902,
      },
      {
        id: "56",
        name: "AVA",
        value: 16,
        tokenType: "alt",
        address: "0x13616f44ba82d63c8c0dc3ff843d36a8ec1c05a9",
        icon: null,
        usdValue: 5297.428041387899,
      },
      {
        id: "56",
        name: "POLC",
        value: 16,
        tokenType: "alt",
        address: "0x6ae9701b9c423f40d54556c9a443409d79ce170a",
        icon: null,
        usdValue: 1491204.0040660058,
      },
      {
        id: "1",
        name: "FB",
        value: 16,
        tokenType: "alt",
        address: "0xfb19075d77a0f111796fb259819830f4780f1429",
        icon: null,
        usdValue: 8209229.318625421,
      },
      {
        id: "1",
        name: "STA",
        value: 15,
        tokenType: "alt",
        address: "0xa7de087329bfcda5639247f96140f9dabe3deed1",
        icon: null,
        usdValue: 134246.02026867997,
      },
      {
        id: "56",
        name: "PIG",
        value: 15,
        tokenType: "alt",
        address: "0x8850d2c68c632e3b258e612abaa8fada7e6958e5",
        icon: null,
        usdValue: 257000.21192458412,
      },
      {
        id: "1",
        name: "USH",
        value: 15,
        tokenType: "alt",
        address: "0xE60779CC1b2c1d0580611c526a8DF0E3f870EC48",
        icon: null,
        usdValue: 10362.41845510349,
      },
      {
        id: "1",
        name: "SPC",
        value: 15,
        tokenType: "alt",
        address: "0x86ed939b500e121c0c5f493f399084db596dad20",
        icon: null,
        usdValue: 317795.582451785,
      },
      {
        id: "1",
        name: "LEV",
        value: 15,
        tokenType: "alt",
        address: "0xbc194e6f748a222754C3E8b9946922c09E7d4e91",
        icon: null,
        usdValue: 19288.405472712246,
      },
      {
        id: "10",
        name: "kwenta",
        value: 15,
        tokenType: "alt",
        address: "0x920cf626a271321c151d027030d5d08af699456b",
        icon: null,
        usdValue: 81753.2314018036,
      },
      {
        id: "42161",
        name: "FRAX",
        value: 15,
        tokenType: "stable",
        address: "0x17fc002b466eec40dae837fc4be5c67993ddbd6f",
        icon: null,
        usdValue: 1833331.7716371436,
      },
      {
        id: "1",
        name: "STK",
        value: 15,
        tokenType: "alt",
        address: "0xaE73B38d1c9A8b274127ec30160a4927C4d71824",
        icon: null,
        usdValue: 2629646541.289388,
      },
      {
        id: "1",
        name: "SAKE",
        value: 15,
        tokenType: "alt",
        address: "0x066798d9ef0833ccc719076dab77199ecbd178b0",
        icon: null,
        usdValue: 13624.78834810845,
      },
      {
        id: "1",
        name: "STN",
        value: 15,
        tokenType: "alt",
        address: "0xe63d6b308bce0f6193aec6b7e6eba005f41e36ab",
        icon: null,
        usdValue: 348462.65840780345,
      },
      {
        id: "1",
        name: "CUBE",
        value: 15,
        tokenType: "alt",
        address: "0xdf801468a808a32656d2ed2d2d80b72a129739f4",
        icon: null,
        usdValue: 162478.49630878758,
      },
      {
        id: "1",
        name: "SFRXETH",
        value: 15,
        tokenType: "alt",
        address: "0xac3e018457b222d93114458476f3e3416abbe38f",
        icon: null,
        usdValue: 1790347.180454769,
      },
      {
        id: "1",
        name: "UNIC",
        value: 15,
        tokenType: "alt",
        address: "0x94e0bab2f6ab1f19f4750e42d7349f2740513ad5",
        icon: null,
        usdValue: 68502.29703514578,
      },
      {
        id: "56",
        name: "PZP",
        value: 15,
        tokenType: "alt",
        address: "0x6ad9E9c098a45B2B41b519119C31c3DcB02ACcB2",
        icon: null,
        usdValue: 1067468.2247219998,
      },
      {
        id: "56",
        name: "DVDX",
        value: 15,
        tokenType: "alt",
        address: "0x4b4135a99775368f349b6f904808b648a9948393",
        icon: null,
        usdValue: 95.21008085193598,
      },
      {
        id: "1",
        name: "LYRA",
        value: 15,
        tokenType: "alt",
        address: "0x01ba67aac7f75f647d94220cc98fb30fcc5105bf",
        icon: null,
        usdValue: 54210.81165971719,
      },
      {
        id: "42161",
        name: "FCTR",
        value: 15,
        tokenType: "alt",
        address: "0x6dd963c510c2d2f09d5eddb48ede45fed063eb36",
        icon: null,
        usdValue: 2586.110589475355,
      },
      {
        id: "1",
        name: "STRNGR",
        value: 15,
        tokenType: "alt",
        address: "0xdc0327d50e6c73db2f8117760592c8bbf1cdcf38",
        icon: null,
        usdValue: 2819.692695016741,
      },
      {
        id: "1",
        name: "SKYRIM",
        value: 15,
        tokenType: "alt",
        address: "0x2610f0bfc21ef389fe4d03cfb7de9ac1e6c99d6e",
        icon: null,
        usdValue: 153103.99563945574,
      },
      {
        id: "137",
        name: "MNFT",
        value: 15,
        tokenType: "alt",
        address: "0xd281aF594Cbb99E8469f3591D57A0C72EB725bdB",
        icon: null,
        usdValue: 470.4589244071034,
      },
      {
        id: "56",
        name: "PUMP",
        value: 15,
        tokenType: "alt",
        address: "0x22b4fa9a13a0d303ad258ee6d62a6ac60364b0c9",
        icon: null,
        usdValue: 4.0334595534714,
      },
      {
        id: "1",
        name: "MATTER",
        value: 15,
        tokenType: "alt",
        address: "0x9B99CcA871Be05119B2012fd4474731dd653FEBe",
        icon: null,
        usdValue: 206629.49123336127,
      },
      {
        id: "1",
        name: "UM",
        value: 15,
        tokenType: "alt",
        address: "0xb19Dd661F076998e3B0456935092a233e12C2280",
        icon: null,
        usdValue: 72.71881397706977,
      },
      {
        id: "1",
        name: "OJA",
        value: 15,
        tokenType: "alt",
        address: "0x0aa7efe4945db24d95ca6e117bba65ed326e291a",
        icon: null,
        usdValue: 119674.03471360847,
      },
      {
        id: "56",
        name: "MIST",
        value: 15,
        tokenType: "alt",
        address: "0x68E374F856bF25468D365E539b700b648Bf94B67",
        icon: null,
        usdValue: 983944.9162936669,
      },
      {
        id: "56",
        name: "DOR",
        value: 15,
        tokenType: "alt",
        address: "0x3465fD2D9f900e34280aBab60E8d9987B5b5bb47",
        icon: null,
        usdValue: 292.3990009958639,
      },
      {
        id: "56",
        name: "LGX",
        value: 15,
        tokenType: "alt",
        address: "0x9096b4309224d751fcb43d7eb178dcffc122ad15",
        icon: null,
        usdValue: 1113235.095893392,
      },
      {
        id: "137",
        name: "FYN",
        value: 15,
        tokenType: "alt",
        address: "0x3B56a704C01D650147ADE2b8cEE594066b3F9421",
        icon: null,
        usdValue: 114266.34429138203,
      },
      {
        id: "137",
        name: "ANML",
        value: 15,
        tokenType: "alt",
        address: "0xecc4176b90613ed78185f01bd1e42c5640c4f09d",
        icon: null,
        usdValue: 302948.3477073396,
      },
      {
        id: "1",
        name: "TOK",
        value: 15,
        tokenType: "alt",
        address: "0x4fb721ef3bf99e0f2c193847afa296b9257d3c30",
        icon: null,
        usdValue: 1987.6367161035828,
      },
      {
        id: "1",
        name: "GS",
        value: 15,
        tokenType: "alt",
        address: "0xe0b9a2c3e9f40cf74b2c7f591b2b0cca055c3112",
        icon: null,
        usdValue: 5623.669082888276,
      },
      {
        id: "1",
        name: "APYS",
        value: 15,
        tokenType: "alt",
        address: "0xf7413489c474ca4399eee604716c72879eea3615",
        icon: null,
        usdValue: 20183.60192429439,
      },
      {
        id: "1",
        name: "SPO",
        value: 15,
        tokenType: "alt",
        address: "0xcbe771323587ea16dacb6016e269d7f08a7acc4e",
        icon: null,
        usdValue: 867140.9663497267,
      },
      {
        id: "56",
        name: "COPI",
        value: 15,
        tokenType: "alt",
        address: "0xfea292e5ea4510881bdb840e3cec63abd43f936f",
        icon: null,
        usdValue: 1305450.5171128388,
      },
      {
        id: "56",
        name: "HELLO",
        value: 15,
        tokenType: "alt",
        address: "0x0f1cbed8efa0e012adbccb1638d0ab0147d5ac00",
        icon: null,
        usdValue: 2984819.7727156924,
      },
      {
        id: "1",
        name: "NII",
        value: 15,
        tokenType: "alt",
        address: "0x7c8155909cd385F120A56eF90728dD50F9CcbE52",
        icon: null,
        usdValue: 13633.77398143668,
      },
      {
        id: "137",
        name: "mSHEESHA",
        value: 15,
        tokenType: "alt",
        address: "0x88C949b4eB85a90071f2C0beF861BDDEe1a7479D",
        icon: null,
        usdValue: 344.7758496435335,
      },
      {
        id: "1",
        name: "SMTY",
        value: 15,
        tokenType: "alt",
        address: "0xbF776e4FCa664D791C4Ee3A71e2722990E003283",
        icon: null,
        usdValue: 80582.07269778672,
      },
      {
        id: "137",
        name: "MIMATIC",
        value: 15,
        tokenType: "alt",
        address: "0xa3fa99a148fa48d14ed51d610c367c61876997f1",
        icon: null,
        usdValue: 1124.6279937514241,
      },
      {
        id: "56",
        name: "OLE",
        value: 15,
        tokenType: "alt",
        address: "0xa865197a84e780957422237b5d152772654341f3",
        icon: null,
        usdValue: 6595.311164451433,
      },
      {
        id: "1",
        name: "EVA",
        value: 15,
        tokenType: "alt",
        address: "0xd6caf5bd23cf057f5fccce295dcc50c01c198707",
        icon: null,
        usdValue: 46972.841263898306,
      },
      {
        id: "56",
        name: "MNZ",
        value: 15,
        tokenType: "alt",
        address: "0x861f1E1397daD68289e8f6a09a2ebb567f1B895C",
        icon: null,
        usdValue: 126560.59254646781,
      },
      {
        id: "1",
        name: "ICHI",
        value: 15,
        tokenType: "alt",
        address: "0x903bef1736cddf2a537176cf3c64579c3867a881",
        icon: null,
        usdValue: 16599.998608474158,
      },
      {
        id: "1",
        name: "MEMEME",
        value: 15,
        tokenType: "alt",
        address: "0x1a963df363d01eebb2816b366d61c917f20e1ebe",
        icon: null,
        usdValue: 45003.79790216368,
      },
      {
        id: "56",
        name: "FRONT",
        value: 15,
        tokenType: "alt",
        address: "0x928e55dab735aa8260af3cedada18b5f70c72f1b",
        icon: null,
        usdValue: 5003458.057879075,
      },
      {
        id: "25",
        name: "CRO",
        value: 15,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 48.984679433292754,
      },
      {
        id: "1088",
        name: "METIS",
        value: 15,
        tokenType: "native",
        address: "0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000",
        icon: null,
        usdValue: 220.23649125673342,
      },
      {
        id: "1116",
        name: "CORE",
        value: 15,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 94.37767556339999,
      },
      {
        id: "1329",
        name: "SEI",
        value: 15,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 74.4309069381735,
      },
      {
        id: "1946",
        name: "ETH",
        value: 15,
        tokenType: "alt",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 5080.7022036331855,
      },
      {
        id: "200901",
        name: "BTC",
        value: 15,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 86.1014431313679,
      },
      {
        id: "1",
        name: "LUNCH",
        value: 15,
        tokenType: "alt",
        address: "0x71a28feAEe902966DC8D355e7B8Aa427D421e7e0",
        icon: null,
        usdValue: 32863.70515326443,
      },
      {
        id: "56",
        name: "CELR",
        value: 15,
        tokenType: "alt",
        address: "0x1f9f6a696c6fd109cd3956f45dc709d2b3902163",
        icon: null,
        usdValue: 129190.75316036944,
      },
      {
        id: "56",
        name: "SLP",
        value: 15,
        tokenType: "alt",
        address: "0x070a08BeEF8d36734dD67A491202fF35a6A16d97",
        icon: null,
        usdValue: 217209.19223041926,
      },
      {
        id: "1",
        name: "UNDEAD",
        value: 15,
        tokenType: "alt",
        address: "0x310C8F00b9dE3c31Ab95ea68feb6C877538f7947",
        icon: null,
        usdValue: 3234634.8801154564,
      },
      {
        id: "1",
        name: "CRE8",
        value: 15,
        tokenType: "alt",
        address: "0xc36b4311b21fc0c2ead46f1ea6ce97c9c4d98d3d",
        icon: null,
        usdValue: 57951.56908084871,
      },
      {
        id: "1",
        name: "CLH",
        value: 15,
        tokenType: "alt",
        address: "0xd7d8f3b8bc8bc48d3acc37879eaba7b85889fa52",
        icon: null,
        usdValue: 505696.06194450875,
      },
      {
        id: "1",
        name: "VERA",
        value: 15,
        tokenType: "alt",
        address: "0xd7f0cc50ad69408ae58be033f4f85d2367c2e468",
        icon: null,
        usdValue: 11265.787640796798,
      },
      {
        id: "1",
        name: "AAG",
        value: 15,
        tokenType: "alt",
        address: "0x5ba19d656b65f1684cfea4af428c23b9f3628f97",
        icon: null,
        usdValue: 55643.51889623667,
      },
      {
        id: "1",
        name: "MGG",
        value: 15,
        tokenType: "alt",
        address: "0x7237C0B30B1355f1B76355582f182F6f04B08740",
        icon: null,
        usdValue: 201772.46175007298,
      },
      {
        id: "1",
        name: "LUNC",
        value: 15,
        tokenType: "alt",
        address: "0xbd31ea8212119f94a611fa969881cba3ea06fa3d",
        icon: null,
        usdValue: 761.756851214365,
      },
      {
        id: "1",
        name: "ORB",
        value: 15,
        tokenType: "alt",
        address: "0x3c917054e03485808137eb306eafa8da0ab695cd",
        icon: null,
        usdValue: 26867.82670842119,
      },
      {
        id: "1",
        name: "DVPN",
        value: 15,
        tokenType: "alt",
        address: "0xa44E5137293E855B1b7bC7E2C6f8cD796fFCB037",
        icon: null,
        usdValue: 1150.7515446897462,
      },
      {
        id: "1",
        name: "XELS",
        value: 15,
        tokenType: "alt",
        address: "0x397deb686c72384fad502a81f4d7fdb89e1f1280",
        icon: null,
        usdValue: 1447544.9074675918,
      },
      {
        id: "1",
        name: "DERI",
        value: 15,
        tokenType: "alt",
        address: "0xa487bf43cf3b10dffc97a9a744cbb7036965d3b9",
        icon: null,
        usdValue: 286904.1335746159,
      },
      {
        id: "1",
        name: "ACE",
        value: 15,
        tokenType: "alt",
        address: "0xec5483804e637d45cde22fa0869656b64b5ab1ab",
        icon: null,
        usdValue: 975173.775978337,
      },
      {
        id: "1",
        name: "FIN",
        value: 15,
        tokenType: "alt",
        address: "0x054f76beed60ab6dbeb23502178c52d6c5debe40",
        icon: null,
        usdValue: 247737.93979288734,
      },
      {
        id: "1",
        name: "KCT",
        value: 15,
        tokenType: "alt",
        address: "0x4c601dc69AfFb0D4Fc8dE1Ac303705e432A4A27E",
        icon: null,
        usdValue: 882573.3179396093,
      },
      {
        id: "1",
        name: "AME",
        value: 15,
        tokenType: "alt",
        address: "0x12513335ffD5DAfc2334e98625d27c1CA84bff86",
        icon: null,
        usdValue: 126403.07129976279,
      },
      {
        id: "1",
        name: "NIFT",
        value: 15,
        tokenType: "alt",
        address: "0x4a1d542b52a95ad01ddc70c2e7df0c7bbaadc56f",
        icon: null,
        usdValue: 18857.56629325843,
      },
      {
        id: "56",
        name: "SLG",
        value: 15,
        tokenType: "alt",
        address: "0x2348b010fa9c0ce30bb042d54c298a3411361a01",
        icon: null,
        usdValue: 12991.955641347486,
      },
      {
        id: "56",
        name: "FET",
        value: 15,
        tokenType: "alt",
        address: "0x031b41e504677879370e9dbcf937283a8691fa7f",
        icon: null,
        usdValue: 5989715.313599697,
      },
      {
        id: "56",
        name: "MMIT",
        value: 15,
        tokenType: "alt",
        address: "0x9767c8E438Aa18f550208e6d1fDf5f43541cC2c8",
        icon: null,
        usdValue: 1265029.112312187,
      },
      {
        id: "56",
        name: "POLS",
        value: 15,
        tokenType: "alt",
        address: "0x7e624fa0e1c4abfd309cc15719b7e2580887f570",
        icon: null,
        usdValue: 6517.637287038674,
      },
      {
        id: "56",
        name: "CLV",
        value: 15,
        tokenType: "alt",
        address: "0x09e889bb4d5b474f561db0491c38702f367a4e4d",
        icon: null,
        usdValue: 1881788.465474649,
      },
      {
        id: "56",
        name: "MDAO",
        value: 15,
        tokenType: "alt",
        address: "0x60322971a672b81bcce5947706d22c19daecf6fb",
        icon: null,
        usdValue: 2947514.387076432,
      },
      {
        id: "56",
        name: "BETH",
        value: 15,
        tokenType: "alt",
        address: "0x250632378e573c6be1ac2f97fcdf00515d0aa91b",
        icon: null,
        usdValue: 46362.372907822304,
      },
      {
        id: "137",
        name: "NXD",
        value: 15,
        tokenType: "alt",
        address: "0x228b5c21ac00155cf62c57bcc704c0da8187950b",
        icon: null,
        usdValue: 337224.01903129567,
      },
      {
        id: "137",
        name: "MV",
        value: 15,
        tokenType: "alt",
        address: "0xA3c322Ad15218fBFAEd26bA7f616249f7705D945",
        icon: null,
        usdValue: 1744215.4843394412,
      },
      {
        id: "1",
        name: "PMA",
        value: 15,
        tokenType: "alt",
        address: "0x846c66cf71c43f80403b51fe3906b3599d63336f",
        icon: null,
        usdValue: 186880.64177419696,
      },
      {
        id: "1",
        name: "WTK",
        value: 15,
        tokenType: "alt",
        address: "0x4cff49d0a19ed6ff845a9122fa912abcfb1f68a6",
        icon: null,
        usdValue: 18065303.011823997,
      },
      {
        id: "1",
        name: "APM",
        value: 15,
        tokenType: "alt",
        address: "0xc8c424b91d8ce0137bab4b832b7f7d154156ba6c",
        icon: null,
        usdValue: 3307896.860109484,
      },
      {
        id: "1",
        name: "FANC",
        value: 15,
        tokenType: "alt",
        address: "0xbB126042235E6bD38B17744cb31a8bF4A206c045",
        icon: null,
        usdValue: 322471.4365277821,
      },
      {
        id: "1",
        name: "AIN",
        value: 15,
        tokenType: "alt",
        address: "0x3a810ff7211b40c4fa76205a14efe161615d0385",
        icon: null,
        usdValue: 1159525.456328857,
      },
      {
        id: "1",
        name: "CTX",
        value: 15,
        tokenType: "alt",
        address: "0x321c2fe4446c7c963dc41dd58879af648838f98d",
        icon: null,
        usdValue: 183064.0872397636,
      },
      {
        id: "1",
        name: "SKM",
        value: 14,
        tokenType: "alt",
        address: "0x048fe49be32adfc9ed68c37d32b5ec9df17b3603",
        icon: null,
        usdValue: 72843.91725428538,
      },
      {
        id: "137",
        name: "KMC",
        value: 14,
        tokenType: "alt",
        address: "0x44d09156c7b4acf0c64459fbcced7613f5519918",
        icon: null,
        usdValue: 16674.16312693869,
      },
      {
        id: "1",
        name: "WHITE",
        value: 14,
        tokenType: "alt",
        address: "0x5f0e628b693018f639d10e4a4f59bd4d8b2b6b44",
        icon: null,
        usdValue: 18263272.37966407,
      },
      {
        id: "1",
        name: "ENTR",
        value: 14,
        tokenType: "alt",
        address: "0xd779eea9936b4e323cddff2529eb6f13d0a4d66e",
        icon: null,
        usdValue: 12083.871041019565,
      },
      {
        id: "1",
        name: "SPANK",
        value: 14,
        tokenType: "alt",
        address: "0x42d6622dece394b54999fbd73d108123806f6a18",
        icon: null,
        usdValue: 358649.22397531936,
      },
      {
        id: "10",
        name: "mimatic",
        value: 14,
        tokenType: "alt",
        address: "0xdfa46478f9e5ea86d57387849598dbfb2e964b02",
        icon: null,
        usdValue: 18604.435955663215,
      },
      {
        id: "137",
        name: "FRAX",
        value: 14,
        tokenType: "stable",
        address: "0x45c32fA6DF82ead1e2EF74d17b76547EDdFaFF89",
        icon: null,
        usdValue: 249.72702668246814,
      },
      {
        id: "42161",
        name: "ARBIS",
        value: 14,
        tokenType: "alt",
        address: "0x9f20de1fc9b161b34089cbeae888168b44b03461",
        icon: null,
        usdValue: 34.976714786026264,
      },
      {
        id: "56",
        name: "VERA",
        value: 14,
        tokenType: "alt",
        address: "0x4a0a3902e091cdb3aec4279a6bfac50297f0a79e",
        icon: null,
        usdValue: 26217.449503830863,
      },
      {
        id: "1",
        name: "PHCR",
        value: 14,
        tokenType: "alt",
        address: "0x37e83a94c6b1bdb816b59ac71dd02cf154d8111f",
        icon: null,
        usdValue: 11019.485915152625,
      },
      {
        id: "1",
        name: "INFI",
        value: 14,
        tokenType: "alt",
        address: "0x159751323a9e0415dd3d6d42a1212fe9f4a0848c",
        icon: null,
        usdValue: 264.00254004814616,
      },
      {
        id: "137",
        name: "UNIM",
        value: 14,
        tokenType: "alt",
        address: "0x64060ab139feaae7f06ca4e63189d86adeb51691",
        icon: null,
        usdValue: 476.5751381892398,
      },
      {
        id: "137",
        name: "BAL",
        value: 14,
        tokenType: "alt",
        address: "0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3",
        icon: null,
        usdValue: 107.18775513731877,
      },
      {
        id: "56",
        name: "ASS",
        value: 14,
        tokenType: "alt",
        address: "0x7c63f96feafacd84e75a594c00fac3693386fbf0",
        icon: null,
        usdValue: 110773.00056898652,
      },
      {
        id: "42161",
        name: "PREMIA",
        value: 14,
        tokenType: "alt",
        address: "0x51fc0f6660482ea73330e414efd7808811a57fa2",
        icon: null,
        usdValue: 119844.2525498365,
      },
      {
        id: "10",
        name: "wbtc",
        value: 14,
        tokenType: "alt",
        address: "0x68f180fcce6836688e9084f035309e29bf0a2095",
        icon: null,
        usdValue: 14585.038425660001,
      },
      {
        id: "1",
        name: "GTH",
        value: 14,
        tokenType: "alt",
        address: "0xeb986da994e4a118d5956b02d8b7c3c7ce373674",
        icon: null,
        usdValue: 396.80056668970946,
      },
      {
        id: "1",
        name: "BAO",
        value: 14,
        tokenType: "alt",
        address: "0x374cb8c27130e2c9e04f44303f3c8351b9de61c1",
        icon: null,
        usdValue: 40447.55738735815,
      },
      {
        id: "1",
        name: "HAI",
        value: 14,
        tokenType: "alt",
        address: "0x05Fb86775Fd5c16290f1E838F5caaa7342bD9a63",
        icon: null,
        usdValue: 353391.5631881516,
      },
      {
        id: "1",
        name: "XFT",
        value: 14,
        tokenType: "alt",
        address: "0xabe580e7ee158da464b51ee1a83ac0289622e6be",
        icon: null,
        usdValue: 20095.596159829307,
      },
      {
        id: "1",
        name: "FCL",
        value: 14,
        tokenType: "alt",
        address: "0xf4d861575ecc9493420a3f5a14f85b13f0b50eb3",
        icon: null,
        usdValue: 510902.1441517679,
      },
      {
        id: "1",
        name: "STAK",
        value: 14,
        tokenType: "alt",
        address: "0x1f8a626883d7724dbd59ef51cbd4bf1cf2016d13",
        icon: null,
        usdValue: 684.264945840761,
      },
      {
        id: "1",
        name: "TARA",
        value: 14,
        tokenType: "alt",
        address: "0xf001937650bb4f62b57521824b2c20f5b91bea05",
        icon: null,
        usdValue: 14317319.858281484,
      },
      {
        id: "56",
        name: "DODO",
        value: 14,
        tokenType: "alt",
        address: "0x67ee3cb086f8a16f34bee3ca72fad36f7db929e2",
        icon: null,
        usdValue: 1148969.4177824971,
      },
      {
        id: "56",
        name: "KING",
        value: 14,
        tokenType: "alt",
        address: "0x0cCD575bf9378c06f6DCa82f8122F570769F00C2",
        icon: null,
        usdValue: 819.6581812506097,
      },
      {
        id: "1",
        name: "SWISE",
        value: 14,
        tokenType: "alt",
        address: "0x48c3399719b582dd63eb5aadf12a40b4c3f52fa2",
        icon: null,
        usdValue: 65748.28351488424,
      },
      {
        id: "1",
        name: "UCN",
        value: 14,
        tokenType: "alt",
        address: "0xaaf37055188feee4869de63464937e683d61b2a1",
        icon: null,
        usdValue: 1161.4178900808506,
      },
      {
        id: "1",
        name: "SHIK",
        value: 14,
        tokenType: "alt",
        address: "0x24da31e7bb182cb2cabfef1d88db19c2ae1f5572",
        icon: null,
        usdValue: 18095.956948108094,
      },
      {
        id: "56",
        name: "PAID",
        value: 14,
        tokenType: "alt",
        address: "0xAD86d0E9764ba90DDD68747D64BFfBd79879a238",
        icon: null,
        usdValue: 301855.68354534137,
      },
      {
        id: "56",
        name: "AOG",
        value: 14,
        tokenType: "alt",
        address: "0x40c8225329bd3e28a043b029e0d07a5344d2c27c",
        icon: null,
        usdValue: 500064.664935318,
      },
      {
        id: "56",
        name: "FIRE",
        value: 14,
        tokenType: "alt",
        address: "0x0f0Dd5E2c0e0c4A41F8908D73D36B8D142F6745a",
        icon: null,
        usdValue: 2479.435100245899,
      },
      {
        id: "56",
        name: "FIU",
        value: 14,
        tokenType: "alt",
        address: "0xef7d50069406a2f5a53806f7250a6c0f17ad9dcd",
        icon: null,
        usdValue: 114252.3282532198,
      },
      {
        id: "1",
        name: "KIF",
        value: 14,
        tokenType: "alt",
        address: "0x177ba0cac51bfc7ea24bad39d81dcefd59d74faa",
        icon: null,
        usdValue: 258699.21130315503,
      },
      {
        id: "1",
        name: "SPOOL",
        value: 14,
        tokenType: "alt",
        address: "0x40803cea2b2a32bda1be61d3604af6a814e70976",
        icon: null,
        usdValue: 233676.2142471082,
      },
      {
        id: "56",
        name: "XEND",
        value: 14,
        tokenType: "alt",
        address: "0x4a080377f83d669d7bb83b3184a8a5e61b500608",
        icon: null,
        usdValue: 5234.527610839508,
      },
      {
        id: "1",
        name: "SIPHER",
        value: 14,
        tokenType: "alt",
        address: "0x9F52c8ecbEe10e00D9faaAc5Ee9Ba0fF6550F511",
        icon: null,
        usdValue: 75542.51143894161,
      },
      {
        id: "1",
        name: "APY",
        value: 14,
        tokenType: "alt",
        address: "0x95a4492F028aa1fd432Ea71146b433E7B4446611",
        icon: null,
        usdValue: 288.2815492661985,
      },
      {
        id: "1",
        name: "KOI",
        value: 14,
        tokenType: "alt",
        address: "0xe84d9e32dC8cE819b8D6c83e50EDAfD46c6354dB",
        icon: null,
        usdValue: 9066.998764828324,
      },
      {
        id: "56",
        name: "MF",
        value: 14,
        tokenType: "alt",
        address: "0xBb6cDedac5CaB4A420211a4A8e8B5DCA879B31De",
        icon: null,
        usdValue: 843.0707972385883,
      },
      {
        id: "56",
        name: "TIP",
        value: 14,
        tokenType: "alt",
        address: "0x40f906e19b14100d5247686e08053c4873c66192",
        icon: null,
        usdValue: 757685.496449129,
      },
      {
        id: "1",
        name: "PCNT",
        value: 14,
        tokenType: "alt",
        address: "0x657B83A0336561C8f64389a6f5aDE675C04b0C3b",
        icon: null,
        usdValue: 29025.427961292404,
      },
      {
        id: "1",
        name: "RAGE",
        value: 14,
        tokenType: "alt",
        address: "0x94804dc4948184ffd7355f62ccbb221c9765886f",
        icon: null,
        usdValue: 55656.99521627229,
      },
      {
        id: "56",
        name: "XCAD",
        value: 14,
        tokenType: "alt",
        address: "0xa026ad2ceda16ca5fc28fd3c72f99e2c332c8a26",
        icon: null,
        usdValue: 688.5713920304863,
      },
      {
        id: "56",
        name: "DOGGY",
        value: 14,
        tokenType: "alt",
        address: "0x74926b3d118a63f6958922d3dc05eb9c6e6e00c6",
        icon: null,
        usdValue: 1851190.8809871268,
      },
      {
        id: "1",
        name: "RJV",
        value: 14,
        tokenType: "alt",
        address: "0x02c3296C6eb50249f290AE596F2bE9454bFfadaB",
        icon: null,
        usdValue: 22236.80036619864,
      },
      {
        id: "56",
        name: "GMM",
        value: 14,
        tokenType: "alt",
        address: "0x5B6bf0c7f989dE824677cFBD507D9635965e9cD3",
        icon: null,
        usdValue: 882651.1200965858,
      },
      {
        id: "1",
        name: "YIN",
        value: 14,
        tokenType: "alt",
        address: "0x794Baab6b878467F93EF17e2f2851ce04E3E34C8",
        icon: null,
        usdValue: 150.25564608004518,
      },
      {
        id: "1",
        name: "RAZE",
        value: 14,
        tokenType: "alt",
        address: "0x5Eaa69B29f99C84Fe5dE8200340b4e9b4Ab38EaC",
        icon: null,
        usdValue: 167579.49388033175,
      },
      {
        id: "1",
        name: "UNIX",
        value: 14,
        tokenType: "alt",
        address: "0xddd6a0ecc3c6f6c102e5ea3d8af7b801d1a77ac8",
        icon: null,
        usdValue: 10770.551634373649,
      },
      {
        id: "1",
        name: "LKR",
        value: 14,
        tokenType: "alt",
        address: "0x80ce3027a70e0a928d9268994e9b85d03bd4cdcf",
        icon: null,
        usdValue: 59033.049742014126,
      },
      {
        id: "56",
        name: "WTLOS",
        value: 14,
        tokenType: "alt",
        address: "0xb6c53431608e626ac81a9776ac3e999c5556717c",
        icon: null,
        usdValue: 20906.40909654846,
      },
      {
        id: "1",
        name: "MINI",
        value: 14,
        tokenType: "alt",
        address: "0x4d953cf077c0c95ba090226e59a18fcf97db44ec",
        icon: null,
        usdValue: 830988.4088087025,
      },
      {
        id: "1",
        name: "STMATIC",
        value: 14,
        tokenType: "alt",
        address: "0x9ee91f9f426fa633d227f7a9b000e28b9dfd8599",
        icon: null,
        usdValue: 170888.25935637872,
      },
      {
        id: "1",
        name: "BCB",
        value: 14,
        tokenType: "alt",
        address: "0x2d886570a0da04885bfd6eb48ed8b8ff01a0eb7e",
        icon: null,
        usdValue: 1478115.9852354922,
      },
      {
        id: "56",
        name: "PVU",
        value: 14,
        tokenType: "alt",
        address: "0x31471e0791fcdbe82fbf4c44943255e923f1b794",
        icon: null,
        usdValue: 346877.37538405333,
      },
      {
        id: "56",
        name: "ARV",
        value: 14,
        tokenType: "alt",
        address: "0x6679eb24f59dfe111864aec72b443d1da666b360",
        icon: null,
        usdValue: 332667.68750359386,
      },
      {
        id: "56",
        name: "XCN",
        value: 14,
        tokenType: "alt",
        address: "0x7324c7c0d95cebc73eea7e85cbaac0dbdf88a05b",
        icon: null,
        usdValue: 5059860.887011332,
      },
      {
        id: "56",
        name: "GAFI",
        value: 14,
        tokenType: "alt",
        address: "0x89Af13A10b32F1b2f8d1588f93027F69B6F4E27e",
        icon: null,
        usdValue: 1695695.0854905958,
      },
      {
        id: "56",
        name: "COTI",
        value: 14,
        tokenType: "alt",
        address: "0xadbaf88b39d37dc68775ed1541f1bf83a5a45feb",
        icon: null,
        usdValue: 76923.19975155283,
      },
      {
        id: "56",
        name: "QANX",
        value: 14,
        tokenType: "alt",
        address: "0xaaa9214f675316182eaa21c85f0ca99160cc3aaa",
        icon: null,
        usdValue: 4448497.571176704,
      },
      {
        id: "56",
        name: "PERL",
        value: 14,
        tokenType: "alt",
        address: "0x0f9e4d49f25de22c2202af916b681fbb3790497b",
        icon: null,
        usdValue: 191.6624466097412,
      },
      {
        id: "56",
        name: "SFTY",
        value: 14,
        tokenType: "alt",
        address: "0xe9d6d6d7cde5c7d45927f8c37460d932e612c902",
        icon: null,
        usdValue: 109185.23396016478,
      },
      {
        id: "56",
        name: "WFLOW",
        value: 14,
        tokenType: "alt",
        address: "0xC943c5320B9c18C153d1e2d12cC3074bebfb31A2",
        icon: null,
        usdValue: 169165.69557009565,
      },
      {
        id: "1",
        name: "BCMC",
        value: 14,
        tokenType: "alt",
        address: "0x2ba8349123de45e931a8c8264c332e6e9cf593f9",
        icon: null,
        usdValue: 74230.21120731813,
      },
      {
        id: "1",
        name: "BLY",
        value: 14,
        tokenType: "alt",
        address: "0xf8aD7dFe656188A23e89da09506Adf7ad9290D5d",
        icon: null,
        usdValue: 172369.38009811923,
      },
      {
        id: "1",
        name: "SLICE",
        value: 14,
        tokenType: "alt",
        address: "0x0aee8703d34dd9ae107386d3eff22ae75dd616d1",
        icon: null,
        usdValue: 63159.9069610259,
      },
      {
        id: "1",
        name: "HID",
        value: 14,
        tokenType: "alt",
        address: "0xB14eBF566511B9e6002bB286016AB2497B9b9c9D",
        icon: null,
        usdValue: 316604.8797125618,
      },
      {
        id: "1",
        name: "MDF",
        value: 14,
        tokenType: "alt",
        address: "0x1a57367c6194199e5d9aea1ce027431682dfb411",
        icon: null,
        usdValue: 219100.79220953438,
      },
      {
        id: "1",
        name: "SMART",
        value: 14,
        tokenType: "alt",
        address: "0xce20BB92CCF9BbF5091ef85649E71E552819AD8c",
        icon: null,
        usdValue: 303505.7262268829,
      },
      {
        id: "1",
        name: "EVRY",
        value: 14,
        tokenType: "alt",
        address: "0xd7dcd9b99787c619b4d57979521258d1a7267ad7",
        icon: null,
        usdValue: 99213.58938082648,
      },
      {
        id: "1",
        name: "BBS",
        value: 14,
        tokenType: "alt",
        address: "0xfe459828c90c0ba4bc8b42f5c5d44f316700b430",
        icon: null,
        usdValue: 2052456.0123998816,
      },
      {
        id: "1",
        name: "TBTC",
        value: 14,
        tokenType: "alt",
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        icon: null,
        usdValue: 659699.0866772374,
      },
      {
        id: "1",
        name: "CFI",
        value: 14,
        tokenType: "alt",
        address: "0x63b4f3e3fa4e438698ce330e365e831f7ccd1ef4",
        icon: null,
        usdValue: 59343.781947070136,
      },
      {
        id: "1",
        name: "BCUG",
        value: 14,
        tokenType: "alt",
        address: "0x14da7b27b2e0fedefe0a664118b0c9bc68e2e9af",
        icon: null,
        usdValue: 169484.84257234292,
      },
      {
        id: "1",
        name: "SPAY",
        value: 14,
        tokenType: "alt",
        address: "0x58FaD9E3C3AE54c9BA98c3f0E4bF88aB3E8Cf3c5",
        icon: null,
        usdValue: 13811.70684264955,
      },
      {
        id: "1",
        name: "WZM",
        value: 14,
        tokenType: "alt",
        address: "0xd15a1a2a3211b58113e45809f05934252e34e2f8",
        icon: null,
        usdValue: 122495.43152339154,
      },
      {
        id: "1",
        name: "POPK",
        value: 14,
        tokenType: "alt",
        address: "0xaC12e8f6b0C17d7B736A800920b336d764b59973",
        icon: null,
        usdValue: 46681.79926504982,
      },
      {
        id: "1",
        name: "WATT",
        value: 14,
        tokenType: "alt",
        address: "0xE67F943af5Eb6051ef56f05979cc30B732717fa6",
        icon: null,
        usdValue: 96118.34886157006,
      },
      {
        id: "1",
        name: "CARE",
        value: 14,
        tokenType: "alt",
        address: "0x329cf160F30D21006bCD24b67EAde561E54CDE4c",
        icon: null,
        usdValue: 296069.3422770085,
      },
      {
        id: "1",
        name: "FBX",
        value: 14,
        tokenType: "alt",
        address: "0x60bb16c4a931b1a0b8a7d945c651dd90f41d42cf",
        icon: null,
        usdValue: 640.1106110108622,
      },
      {
        id: "56",
        name: "NEXT",
        value: 14,
        tokenType: "alt",
        address: "0x9809e877192b510d767a94ba39a79429219a5afb",
        icon: null,
        usdValue: 56844.58389465154,
      },
      {
        id: "56",
        name: "LOOM",
        value: 14,
        tokenType: "alt",
        address: "0xe6ce27025f13f5213bbc560dc275e292965a392f",
        icon: null,
        usdValue: 1709401.6067856299,
      },
      {
        id: "56",
        name: "LTO",
        value: 14,
        tokenType: "alt",
        address: "0x857b222fc79e1cbbf8ca5f78cb133d1b7cf34bbd",
        icon: null,
        usdValue: 16739.4539009202,
      },
      {
        id: "56",
        name: "LBL",
        value: 14,
        tokenType: "alt",
        address: "0x77edfae59a7948d66e9911a30cc787d2172343d4",
        icon: null,
        usdValue: 127027.26878258034,
      },
      {
        id: "56",
        name: "FAME",
        value: 14,
        tokenType: "alt",
        address: "0x28ce223853d123b52c74439b10b43366d73fd3b5",
        icon: null,
        usdValue: 1000998.0876391577,
      },
      {
        id: "56",
        name: "TTC",
        value: 14,
        tokenType: "alt",
        address: "0x152ad7Dc399269FA65D19BD7A790Ea8aa5b23DaD",
        icon: null,
        usdValue: 4109.285886860282,
      },
      {
        id: "1",
        name: "WPCI",
        value: 14,
        tokenType: "alt",
        address: "0x3c2a309d9005433c1bc2c92ef1be06489e5bf258",
        icon: null,
        usdValue: 6249275.496905671,
      },
      {
        id: "1",
        name: "SG",
        value: 14,
        tokenType: "alt",
        address: "0xddf7fd345d54ff4b40079579d4c4670415dbfd0a",
        icon: null,
        usdValue: 166658.00356865552,
      },
      {
        id: "1",
        name: "VPAD",
        value: 14,
        tokenType: "alt",
        address: "0x51FE2E572e97BFEB1D719809d743Ec2675924EDc",
        icon: null,
        usdValue: 231690.4425745081,
      },
      {
        id: "1",
        name: "NFTL",
        value: 13,
        tokenType: "alt",
        address: "0x3c8d2fce49906e11e71cb16fa0ffeb2b16c29638",
        icon: null,
        usdValue: 16106.003593526932,
      },
      {
        id: "42161",
        name: "OPENBET",
        value: 13,
        tokenType: "alt",
        address: "0x2c7513F299778A84797F293503DB1A73A15FD48D",
        icon: null,
        usdValue: 704.5753300469034,
      },
      {
        id: "56",
        name: "UFI",
        value: 13,
        tokenType: "alt",
        address: "0xe2a59D5E33c6540E18aAA46BF98917aC3158Db0D",
        icon: null,
        usdValue: 1360834.6353889871,
      },
      {
        id: "1",
        name: "ROCKI",
        value: 13,
        tokenType: "alt",
        address: "0xff44b937788215eca197baaf9af69dbdc214aa04",
        icon: null,
        usdValue: 1106295.1727645898,
      },
      {
        id: "1",
        name: "NIIFI",
        value: 13,
        tokenType: "alt",
        address: "0x852e5427c86A3b46DD25e5FE027bb15f53c4BCb8",
        icon: null,
        usdValue: 237759.4825988564,
      },
      {
        id: "1",
        name: "ARGO",
        value: 13,
        tokenType: "alt",
        address: "0x28cca76f6e8ec81e4550ecd761f899110b060e97",
        icon: null,
        usdValue: 1894.040223677141,
      },
      {
        id: "137",
        name: "POLYDOGE",
        value: 13,
        tokenType: "alt",
        address: "0x8A953CfE442c5E8855cc6c61b1293FA648BAE472",
        icon: null,
        usdValue: 2525330.7984552584,
      },
      {
        id: "1",
        name: "ALN",
        value: 13,
        tokenType: "alt",
        address: "0x8185bc4757572da2a610f887561c32298f1a5748",
        icon: null,
        usdValue: 31495.27011892928,
      },
      {
        id: "56",
        name: "CATE",
        value: 13,
        tokenType: "alt",
        address: "0xE4FAE3Faa8300810C835970b9187c268f55D998F",
        icon: null,
        usdValue: 1238576.3644348988,
      },
      {
        id: "1",
        name: "SPDR",
        value: 13,
        tokenType: "alt",
        address: "0xbcd4b7de6fde81025f74426d43165a5b0d790fdd",
        icon: null,
        usdValue: 3024.9377973717533,
      },
      {
        id: "1",
        name: "XP",
        value: 13,
        tokenType: "alt",
        address: "0x948c70dc6169bfb10028fdbe96cbc72e9562b2ac",
        icon: null,
        usdValue: 13302.213657895443,
      },
      {
        id: "1",
        name: "GETH",
        value: 13,
        tokenType: "alt",
        address: "0xdD69DB25F6D620A7baD3023c5d32761D353D3De9",
        icon: null,
        usdValue: 215.31776335325682,
      },
      {
        id: "137",
        name: "TRADE",
        value: 13,
        tokenType: "alt",
        address: "0x692ac1e363ae34b6b489148152b12e2785a3d8d6",
        icon: null,
        usdValue: 198854.2251502433,
      },
      {
        id: "1",
        name: "GOO",
        value: 13,
        tokenType: "alt",
        address: "0x600000000a36f3cd48407e35eb7c5c910dc1f7a8",
        icon: null,
        usdValue: 5426.113057138498,
      },
      {
        id: "56",
        name: "AZY",
        value: 13,
        tokenType: "alt",
        address: "0x7b665b2f633d9363b89a98b094b1f9e732bd8f86",
        icon: null,
        usdValue: 127711.05871599747,
      },
      {
        id: "1",
        name: "KTN",
        value: 13,
        tokenType: "alt",
        address: "0x491e136ff7ff03e6ab097e54734697bb5802fc1c",
        icon: null,
        usdValue: 232447.69981437924,
      },
      {
        id: "56",
        name: "DERI",
        value: 13,
        tokenType: "alt",
        address: "0xe60eaf5A997DFAe83739e035b005A33AfdCc6df5",
        icon: null,
        usdValue: 719765.2270488963,
      },
      {
        id: "137",
        name: "ZKP",
        value: 13,
        tokenType: "alt",
        address: "0x9A06Db14D639796B25A6ceC6A1bf614fd98815EC",
        icon: null,
        usdValue: 1213.0177556529154,
      },
      {
        id: "1",
        name: "TOL",
        value: 13,
        tokenType: "alt",
        address: "0xd07d9fe2d2cc067015e2b4917d24933804f42cfa",
        icon: null,
        usdValue: 1936.4104901271771,
      },
      {
        id: "56",
        name: "BANANA",
        value: 13,
        tokenType: "alt",
        address: "0x603c7f932ed1fc6575303d8fb018fdcbb0f39a95",
        icon: null,
        usdValue: 111.43751914147285,
      },
      {
        id: "56",
        name: "NRV",
        value: 13,
        tokenType: "alt",
        address: "0x42F6f551ae042cBe50C739158b4f0CAC0Edb9096",
        icon: null,
        usdValue: 339623.58510356524,
      },
      {
        id: "42161",
        name: "ARBINU",
        value: 13,
        tokenType: "alt",
        address: "0xdd8e557c8804d326c72074e987de02a23ae6ef84",
        icon: null,
        usdValue: 1192.040830757618,
      },
      {
        id: "42161",
        name: "TROVE",
        value: 13,
        tokenType: "alt",
        address: "0x982239D38Af50B0168dA33346d85Fb12929c4c07",
        icon: null,
        usdValue: 66809.28774538336,
      },
      {
        id: "1",
        name: "PREMIA",
        value: 13,
        tokenType: "alt",
        address: "0x6399C842dD2bE3dE30BF99Bc7D1bBF6Fa3650E70",
        icon: null,
        usdValue: 19181.521669391987,
      },
      {
        id: "1",
        name: "CLS",
        value: 13,
        tokenType: "alt",
        address: "0x675bbc7514013e2073db7a919f6e4cbef576de37",
        icon: null,
        usdValue: 514289.48260533676,
      },
      {
        id: "42161",
        name: "AICODE",
        value: 13,
        tokenType: "alt",
        address: "0x7c8a1a80fdd00c9cccd6ebd573e9ecb49bfa2a59",
        icon: null,
        usdValue: 434170.901784721,
      },
      {
        id: "1",
        name: "DEC",
        value: 13,
        tokenType: "alt",
        address: "0x30f271c9e86d2b7d00a6376cd96a1cfbd5f0b9b3",
        icon: null,
        usdValue: 8736.61088353569,
      },
      {
        id: "1",
        name: "SERP",
        value: 13,
        tokenType: "alt",
        address: "0xfd414e39155f91e94443a9fe97e856569d0f5eec",
        icon: null,
        usdValue: 21735.145530849386,
      },
      {
        id: "56",
        name: "ROOM",
        value: 13,
        tokenType: "alt",
        address: "0x3C45A24d36Ab6fc1925533C1F57bC7e1b6fbA8a4",
        icon: null,
        usdValue: 4254.18386469348,
      },
      {
        id: "56",
        name: "SBG",
        value: 13,
        tokenType: "alt",
        address: "0x5e95a952a7f79f978585afd54a053af0f51372fa",
        icon: null,
        usdValue: 234.7578364704413,
      },
      {
        id: "1",
        name: "BNTY",
        value: 13,
        tokenType: "alt",
        address: "0xd2d6158683aee4cc838067727209a0aaf4359de3",
        icon: null,
        usdValue: 264093.578974456,
      },
      {
        id: "1",
        name: "NOTE",
        value: 13,
        tokenType: "alt",
        address: "0xcfeaead4947f0705a14ec42ac3d44129e1ef3ed5",
        icon: null,
        usdValue: 71679.41804873213,
      },
      {
        id: "137",
        name: "UM",
        value: 13,
        tokenType: "alt",
        address: "0x3b1a0c9252ee7403093ff55b4a5886d49a3d837a",
        icon: null,
        usdValue: 538.9909413819042,
      },
      {
        id: "56",
        name: "ORO",
        value: 13,
        tokenType: "alt",
        address: "0xFc4f5A4d1452B8Dc6C3CB745dB15B29c00812b19",
        icon: null,
        usdValue: 166193.2038427756,
      },
      {
        id: "56",
        name: "EARN",
        value: 13,
        tokenType: "alt",
        address: "0xB0eB3e295B44d7D405ba8026A9734A9ab354a8B2",
        icon: null,
        usdValue: 220.22361936294496,
      },
      {
        id: "56",
        name: "SANDWICH",
        value: 13,
        tokenType: "alt",
        address: "0xd3253Fc0A42E6dcF4F66Ab147f628E3F29e9b214",
        icon: null,
        usdValue: 8011.124417840608,
      },
      {
        id: "1",
        name: "PHTR",
        value: 13,
        tokenType: "alt",
        address: "0xE1Fc4455f62a6E89476f1072530C20CF1A0622dA",
        icon: null,
        usdValue: 90938.2042534098,
      },
      {
        id: "137",
        name: "BURP",
        value: 13,
        tokenType: "alt",
        address: "0x538d47d142f6993038a667e9d6210d3735749b36",
        icon: null,
        usdValue: 119.32968464078029,
      },
      {
        id: "1",
        name: "DWEB",
        value: 13,
        tokenType: "alt",
        address: "0xe7f58a92476056627f9fdb92286778abd83b285f",
        icon: null,
        usdValue: 4705.628131195127,
      },
      {
        id: "56",
        name: "TRVL",
        value: 13,
        tokenType: "alt",
        address: "0x6a8fd46f88dbd7bdc2d536c604f811c63052ce0f",
        icon: null,
        usdValue: 1252.4260599986092,
      },
      {
        id: "1",
        name: "REVO",
        value: 13,
        tokenType: "alt",
        address: "0x155040625D7ae3e9caDA9a73E3E44f76D3Ed1409",
        icon: null,
        usdValue: 93883.5694081094,
      },
      {
        id: "42161",
        name: "TCR",
        value: 13,
        tokenType: "alt",
        address: "0xa72159fc390f0e3c6d415e658264c7c4051e9b87",
        icon: null,
        usdValue: 0.000018725884405075858,
      },
      {
        id: "1",
        name: "MIMIR",
        value: 13,
        tokenType: "alt",
        address: "0x71dc40668682a124231301414167e4cf7f55383c",
        icon: null,
        usdValue: 111674.93948629592,
      },
      {
        id: "1",
        name: "SENC",
        value: 13,
        tokenType: "alt",
        address: "0xa13f0743951b4f6e3e3aa039f682e17279f52bc3",
        icon: null,
        usdValue: 5641.005777755796,
      },
      {
        id: "1",
        name: "CWS",
        value: 13,
        tokenType: "alt",
        address: "0xac0104cca91d167873b8601d2e71eb3d4d8c33e0",
        icon: null,
        usdValue: 202850.57014074613,
      },
      {
        id: "1",
        name: "QUIDD",
        value: 13,
        tokenType: "alt",
        address: "0xDA9FDAb21bC4A5811134A6E0Ba6CA06624e67c07",
        icon: null,
        usdValue: 1301.5252839661619,
      },
      {
        id: "56",
        name: "CHMB",
        value: 13,
        tokenType: "alt",
        address: "0x5492Ef6aEebA1A3896357359eF039a8B11621b45",
        icon: null,
        usdValue: 1498.6669922424107,
      },
      {
        id: "56",
        name: "MONI",
        value: 13,
        tokenType: "alt",
        address: "0x9573c88aE3e37508f87649f87c4dd5373C9F31e0",
        icon: null,
        usdValue: 217013.5467126902,
      },
      {
        id: "1",
        name: "FOAM",
        value: 13,
        tokenType: "alt",
        address: "0x4946Fcea7C692606e8908002e55A582af44AC121",
        icon: null,
        usdValue: 45407.34779819241,
      },
      {
        id: "1",
        name: "RIBBIT",
        value: 13,
        tokenType: "alt",
        address: "0xb794ad95317f75c44090f64955954c3849315ffe",
        icon: null,
        usdValue: 206463.61142410507,
      },
      {
        id: "56",
        name: "10SET",
        value: 13,
        tokenType: "alt",
        address: "0x1AE369A6AB222aFF166325B7b87Eb9aF06C86E57",
        icon: null,
        usdValue: 188947.44636628203,
      },
      {
        id: "1",
        name: "SKRT",
        value: 13,
        tokenType: "alt",
        address: "0x887168120cb89fb06f3e74dc4af20d67df0977f6",
        icon: null,
        usdValue: 72751.0427281047,
      },
      {
        id: "56",
        name: "AI-A",
        value: 13,
        tokenType: "alt",
        address: "0xd048b4c23af828e5be412505a51a8dd7b37782dd",
        icon: null,
        usdValue: 178348.70963095923,
      },
      {
        id: "56",
        name: "Factr",
        value: 13,
        tokenType: "alt",
        address: "0x396d8805d184ef5325b5ccd107638adfd38ccff8",
        icon: null,
        usdValue: 39133.14134046311,
      },
      {
        id: "56",
        name: "MGRT",
        value: 13,
        tokenType: "alt",
        address: "0x71753d0586ea6b979dfccbb492a45e611e0e0ad6",
        icon: null,
        usdValue: 1316.9749693388503,
      },
      {
        id: "137",
        name: "Visit ethena-2l.com to claim rewards",
        value: 13,
        tokenType: "alt",
        address: "0x39679dae5bff60f337d925ffd0b34a257e8a520d",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Claim: zks-mainnet.com",
        value: 13,
        tokenType: "alt",
        address: "0x9e99acced32e848388c52c8d771af32c42501a12",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "TONCrypto.io",
        value: 13,
        tokenType: "alt",
        address: "0xcaf8ac112fbabdb629baedf49929bfac527f2a4a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "8453",
        name: "ETH",
        value: 13,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 9120.293548591586,
      },
      {
        id: "56",
        name: "SQUAD",
        value: 13,
        tokenType: "alt",
        address: "0x724a32dfff9769a0a0e1f0515c0012d1fb14c3bd",
        icon: null,
        usdValue: 380706.80112371984,
      },
      {
        id: "1",
        name: "LAKE",
        value: 13,
        tokenType: "alt",
        address: "0xf9ca9523e5b5a42c3018c62b084db8543478c400",
        icon: null,
        usdValue: 691128.4629782775,
      },
      {
        id: "56",
        name: "ETERNAL",
        value: 13,
        tokenType: "alt",
        address: "0xd44fd09d74cd13838f137b590497595d6b3feea4",
        icon: null,
        usdValue: 579494.7998284781,
      },
      {
        id: "137",
        name: "AXL",
        value: 13,
        tokenType: "alt",
        address: "0x6e4e624106cb12e168e6533f8ec7c82263358940",
        icon: null,
        usdValue: 76883.45568258922,
      },
      {
        id: "56",
        name: "LOVELY",
        value: 13,
        tokenType: "alt",
        address: "0x9E24415d1e549EBc626a13a482Bb117a2B43e9CF",
        icon: null,
        usdValue: 9317773.300830737,
      },
      {
        id: "56",
        name: "TABOO",
        value: 13,
        tokenType: "alt",
        address: "0x9abdba20edfba06b782126b4d8d72a5853918fd0",
        icon: null,
        usdValue: 475745.4926931858,
      },
      {
        id: "56",
        name: "ACH",
        value: 13,
        tokenType: "alt",
        address: "0xbc7d6b50616989655afd682fb42743507003056d",
        icon: null,
        usdValue: 1350542.3157887482,
      },
      {
        id: "56",
        name: "DERC",
        value: 13,
        tokenType: "alt",
        address: "0x373e768f79c820aa441540d254dca6d045c6d25b",
        icon: null,
        usdValue: 963.5951924866092,
      },
      {
        id: "1",
        name: "LOCG",
        value: 13,
        tokenType: "alt",
        address: "0x60eb57d085c59932d5faa6c6026268a4386927d0",
        icon: null,
        usdValue: 557582.4967613508,
      },
      {
        id: "1",
        name: "MDS",
        value: 13,
        tokenType: "alt",
        address: "0x66186008c1050627f979d464eabb258860563dbe",
        icon: null,
        usdValue: 111209.22314018101,
      },
      {
        id: "1",
        name: "REM",
        value: 13,
        tokenType: "alt",
        address: "0x83984d6142934bb535793a82adb0a46ef0f66b6d",
        icon: null,
        usdValue: 232109.56964025146,
      },
      {
        id: "1",
        name: "ONC",
        value: 13,
        tokenType: "alt",
        address: "0xD90E69f67203EBE02c917B5128629E77B4cd92dc",
        icon: null,
        usdValue: 307490.5110359815,
      },
      {
        id: "1",
        name: "VRX",
        value: 13,
        tokenType: "alt",
        address: "0x87DE305311D5788e8da38D19bb427645b09CB4e5",
        icon: null,
        usdValue: 243424.0301650406,
      },
      {
        id: "1",
        name: "CUP",
        value: 13,
        tokenType: "alt",
        address: "0x3209d14ff61766359e64aceff91877cec2ad968e",
        icon: null,
        usdValue: 147777.72730858432,
      },
      {
        id: "1",
        name: "BEAR",
        value: 13,
        tokenType: "alt",
        address: "0x17837004ea685690b32dbead02a274ec4333a26a",
        icon: null,
        usdValue: 358377.6328205607,
      },
      {
        id: "1",
        name: "XTM",
        value: 13,
        tokenType: "alt",
        address: "0xcd1faff6e578fa5cac469d2418c95671ba1a62fe",
        icon: null,
        usdValue: 2459.999128868024,
      },
      {
        id: "1",
        name: "BAMBOO",
        value: 13,
        tokenType: "alt",
        address: "0xf56842Af3B56Fd72d17cB103f92d027bBa912e89",
        icon: null,
        usdValue: 3391.8632758053354,
      },
      {
        id: "1",
        name: "AXL",
        value: 13,
        tokenType: "alt",
        address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
        icon: null,
        usdValue: 1110809.6492338786,
      },
      {
        id: "1",
        name: "MTN",
        value: 13,
        tokenType: "alt",
        address: "0x41dbecc1cdc5517c6f76f6a6e836adbee2754de3",
        icon: null,
        usdValue: 131950.37155792268,
      },
      {
        id: "1",
        name: "EQ",
        value: 13,
        tokenType: "alt",
        address: "0xA5eDE2FEE620ac3d68065EC01F26F9dd99850B82",
        icon: null,
        usdValue: 1712157538.7971451,
      },
      {
        id: "1",
        name: "DV",
        value: 13,
        tokenType: "alt",
        address: "0x2a03a891add2dc6d0f7b94419086630ba5cb65b6",
        icon: null,
        usdValue: 126145.9139256059,
      },
      {
        id: "1",
        name: "MOTG",
        value: 13,
        tokenType: "alt",
        address: "0x171d76d931529384639BC9aad5b77b77041ED604",
        icon: null,
        usdValue: 1167463.0526161604,
      },
      {
        id: "1",
        name: "ICB",
        value: 13,
        tokenType: "alt",
        address: "0x00166a5b93FD4f87ecA1c267d31D82dF3f133a7F",
        icon: null,
        usdValue: 2848.701880046385,
      },
      {
        id: "1",
        name: "TEM",
        value: 13,
        tokenType: "alt",
        address: "0xaE0585a259A3BCAB258D6EE02FB583f7B33C2a12",
        icon: null,
        usdValue: 45170.97089349054,
      },
      {
        id: "1",
        name: "HYCO",
        value: 13,
        tokenType: "alt",
        address: "0x77F76483399Dc6328456105B1db23e2Aca455bf9",
        icon: null,
        usdValue: 11633.299763583145,
      },
      {
        id: "56",
        name: "DEGO",
        value: 13,
        tokenType: "alt",
        address: "0x3da932456d082cba208feb0b096d49b202bf89c8",
        icon: null,
        usdValue: 95889.07824782468,
      },
      {
        id: "56",
        name: "NBT",
        value: 13,
        tokenType: "alt",
        address: "0x1D3437E570e93581Bd94b2fd8Fbf202d4a65654A",
        icon: null,
        usdValue: 529376.4596232376,
      },
      {
        id: "56",
        name: "WSI",
        value: 13,
        tokenType: "alt",
        address: "0x837a130aed114300bab4f9f1f4f500682f7efd48",
        icon: null,
        usdValue: 925494.8799752302,
      },
      {
        id: "1",
        name: "MCADE",
        value: 13,
        tokenType: "alt",
        address: "0xed328e9c1179a30ddc1e7595e036aed8760c22af",
        icon: null,
        usdValue: 369934.0402864118,
      },
      {
        id: "1",
        name: "ONIT",
        value: 13,
        tokenType: "alt",
        address: "0x410e731c2970Dce3AdD351064AcF5cE9E33FDBf0",
        icon: null,
        usdValue: 126324.56981587116,
      },
      {
        id: "1",
        name: "KEYFI",
        value: 13,
        tokenType: "alt",
        address: "0xb8647e90c0645152fccf4d9abb6b59eb4aa99052",
        icon: null,
        usdValue: 14361.201240112763,
      },
      {
        id: "1",
        name: "SAN",
        value: 13,
        tokenType: "alt",
        address: "0x7c5a0ce9267ed19b22f8cae653f198e3e8daf098",
        icon: null,
        usdValue: 12774792.042770429,
      },
      {
        id: "1",
        name: "GCAKE",
        value: 13,
        tokenType: "alt",
        address: "0x5f944b0c4315cb7c3a846b025ab4045da44abf6c",
        icon: null,
        usdValue: 426355.9365689179,
      },
      {
        id: "1",
        name: "NATION",
        value: 13,
        tokenType: "alt",
        address: "0x333a4823466879eef910a04d473505da62142069",
        icon: null,
        usdValue: 1209.4696419088546,
      },
      {
        id: "1",
        name: "BOBC",
        value: 13,
        tokenType: "alt",
        address: "0xe803178b48a0e560c2b19f3b3d4e504f79d229ce",
        icon: null,
        usdValue: 114310.11570343409,
      },
      {
        id: "1",
        name: "HVH",
        value: 13,
        tokenType: "alt",
        address: "0xd076c4ba62c57b3fa10800bcfd8da66742110e0e",
        icon: null,
        usdValue: 5082899.397335247,
      },
      {
        id: "1",
        name: "REV",
        value: 13,
        tokenType: "alt",
        address: "0x2ef52ed7de8c5ce03a4ef0efbe9b7450f2d7edc9",
        icon: null,
        usdValue: 232590.60994103563,
      },
      {
        id: "1",
        name: "HXRO",
        value: 13,
        tokenType: "alt",
        address: "0x4bd70556ae3f8a6ec6c4080a0c327b24325438f3",
        icon: null,
        usdValue: 34330.9058296135,
      },
      {
        id: "1",
        name: "UDOO",
        value: 12,
        tokenType: "alt",
        address: "0x12f649a9e821f90bb143089a6e56846945892ffb",
        icon: null,
        usdValue: 12093.933251764496,
      },
      {
        id: "1",
        name: "AUC",
        value: 12,
        tokenType: "alt",
        address: "0xc12d099be31567add4e4e4d0d45691c3f58f5663",
        icon: null,
        usdValue: 644.3196873662527,
      },
      {
        id: "1",
        name: "LA",
        value: 12,
        tokenType: "alt",
        address: "0xe50365f5d679cb98a1dd62d6f6e58e59321bcddf",
        icon: null,
        usdValue: 23860.447095856183,
      },
      {
        id: "1",
        name: "LSETH",
        value: 12,
        tokenType: "alt",
        address: "0x628eBC64A38269E031AFBDd3C5BA857483B5d048",
        icon: null,
        usdValue: 65211.02966365274,
      },
      {
        id: "1",
        name: "LORDS",
        value: 12,
        tokenType: "alt",
        address: "0x686f2404e77ab0d9070a46cdfb0b7fecdd2318b0",
        icon: null,
        usdValue: 108313.85557973383,
      },
      {
        id: "56",
        name: "IDEX",
        value: 12,
        tokenType: "alt",
        address: "0x0856978F7fFff0a2471B4520E3521c4B3343e36f",
        icon: null,
        usdValue: 1299.477696673271,
      },
      {
        id: "56",
        name: "SFM",
        value: 12,
        tokenType: "alt",
        address: "0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
        icon: null,
        usdValue: 883483.0919958462,
      },
      {
        id: "1",
        name: "POLI",
        value: 12,
        tokenType: "alt",
        address: "0xa1a36d3537bbe375cc9694795f663ddc8d516db9",
        icon: null,
        usdValue: 28895.65906315104,
      },
      {
        id: "10",
        name: "wsteth",
        value: 12,
        tokenType: "alt",
        address: "0x1f32b1c2345538c0c6f582fcb022739c4a194ebb",
        icon: null,
        usdValue: 89341.8783625586,
      },
      {
        id: "56",
        name: "PORTX",
        value: 12,
        tokenType: "alt",
        address: "0x54c3b88b7e9702f915ddc6e483aaf369b2615f8d",
        icon: null,
        usdValue: 166.71400147300497,
      },
      {
        id: "10",
        name: "sonne",
        value: 12,
        tokenType: "alt",
        address: "0x1db2466d9f5e10d7090e7152b68d62703a2245f0",
        icon: null,
        usdValue: 55402.91818217891,
      },
      {
        id: "1",
        name: "IBY",
        value: 12,
        tokenType: "alt",
        address: "0x6a68de599e8e0b1856e322ce5bd11c5c3c79712b",
        icon: null,
        usdValue: 524.51530033,
      },
      {
        id: "56",
        name: "VLX",
        value: 12,
        tokenType: "alt",
        address: "0xE9C803F48dFFE50180Bd5B01dC04DA939E3445Fc",
        icon: null,
        usdValue: 13517.803142647579,
      },
      {
        id: "1",
        name: "JBX",
        value: 12,
        tokenType: "alt",
        address: "0x3abf2a4f8452ccc2cf7b4c1e4663147600646f66",
        icon: null,
        usdValue: 5359.324614742038,
      },
      {
        id: "1",
        name: "FOREX",
        value: 12,
        tokenType: "alt",
        address: "0xdb298285fe4c5410b05390ca80e8fbe9de1f259b",
        icon: null,
        usdValue: 36704.51625326011,
      },
      {
        id: "56",
        name: "DPET",
        value: 12,
        tokenType: "alt",
        address: "0xfb62ae373aca027177d1c18ee0862817f9080d08",
        icon: null,
        usdValue: 89046.89194255255,
      },
      {
        id: "56",
        name: "GAN",
        value: 12,
        tokenType: "alt",
        address: "0x8f1408171eae06aec4549fd0a5808a42cee6dd84",
        icon: null,
        usdValue: 133970.8458588746,
      },
      {
        id: "42161",
        name: "LEX",
        value: 12,
        tokenType: "alt",
        address: "0x6bb7a17acc227fd1f6781d1eedeae01b42047ee0",
        icon: null,
        usdValue: 3169.2781737378027,
      },
      {
        id: "1",
        name: "IDLE",
        value: 12,
        tokenType: "alt",
        address: "0x875773784af8135ea0ef43b5a374aad105c5d39e",
        icon: null,
        usdValue: 323151.67920156743,
      },
      {
        id: "42161",
        name: "FUC",
        value: 12,
        tokenType: "alt",
        address: "0x1F52145666C862eD3E2f1Da213d479E61b2892af",
        icon: null,
        usdValue: 31.31895293737327,
      },
      {
        id: "1",
        name: "CENT",
        value: 12,
        tokenType: "alt",
        address: "0x08ba718f288c3b12b01146816bef9fa03cc635bc",
        icon: null,
        usdValue: 1155.9875244646428,
      },
      {
        id: "1",
        name: "MOMA",
        value: 12,
        tokenType: "alt",
        address: "0xbd1848e1491d4308ad18287a745dd4db2a4bd55b",
        icon: null,
        usdValue: 44437.85080663463,
      },
      {
        id: "56",
        name: "FLASH",
        value: 12,
        tokenType: "alt",
        address: "0x5f0366c9962193fa774cdce9602195593b49f23c",
        icon: null,
        usdValue: 297.4623928357387,
      },
      {
        id: "56",
        name: "SDJT",
        value: 12,
        tokenType: "alt",
        address: "0xbb368656efa67361b0063fe0f11cb08bd460246d",
        icon: null,
        usdValue: 0.0726888704617495,
      },
      {
        id: "137",
        name: "KNIGHT",
        value: 12,
        tokenType: "alt",
        address: "0x4455ef8b4b4a007a93daa12de63a47eeac700d9d",
        icon: null,
        usdValue: 38485.981583748275,
      },
      {
        id: "42161",
        name: "OX",
        value: 12,
        tokenType: "alt",
        address: "0xba0dda8762c24da9487f5fa026a9b64b695a07ea",
        icon: null,
        usdValue: 0.47942063782969757,
      },
      {
        id: "1",
        name: "XRUNE",
        value: 12,
        tokenType: "alt",
        address: "0x69fa0fee221ad11012bab0fdb45d444d3d2ce71c",
        icon: null,
        usdValue: 6333.3305050087765,
      },
      {
        id: "10",
        name: "lyra",
        value: 12,
        tokenType: "alt",
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        icon: null,
        usdValue: 3886.562045307732,
      },
      {
        id: "1",
        name: "MOVD",
        value: 12,
        tokenType: "alt",
        address: "0x12300ed54f65648524c1bfaf86712927da6cc6fc",
        icon: null,
        usdValue: 10526.92333519607,
      },
      {
        id: "1",
        name: "DES",
        value: 12,
        tokenType: "alt",
        address: "0x634239cfa331df0291653139d1a6083b9cf705e3",
        icon: null,
        usdValue: 2590.288754816976,
      },
      {
        id: "56",
        name: "DEFLY",
        value: 12,
        tokenType: "alt",
        address: "0x0fe6a599c280853621a11c12e1a68e6949cbd08a",
        icon: null,
        usdValue: 157.54123123075016,
      },
      {
        id: "56",
        name: "MOOO",
        value: 12,
        tokenType: "alt",
        address: "0xa0b9bb05da11e3b19ffd64554400f59d4a378515",
        icon: null,
        usdValue: 135910.24480745965,
      },
      {
        id: "1",
        name: "PDX",
        value: 12,
        tokenType: "alt",
        address: "0x5f33d158ca7275848f70a3f149b421190df85b32",
        icon: null,
        usdValue: 605366.6931850791,
      },
      {
        id: "1",
        name: "CHR",
        value: 12,
        tokenType: "alt",
        address: "0x915044526758533dfB918ecEb6e44bc21632060D",
        icon: null,
        usdValue: 798092.073060138,
      },
      {
        id: "1",
        name: "STARS",
        value: 12,
        tokenType: "alt",
        address: "0xc55c2175e90a46602fd42e931f62b3acc1a013ca",
        icon: null,
        usdValue: 198.21531115192306,
      },
      {
        id: "1",
        name: "TECH",
        value: 12,
        tokenType: "alt",
        address: "0x6286A9e6f7e745A6D884561D88F94542d6715698",
        icon: null,
        usdValue: 263.28367746925085,
      },
      {
        id: "1",
        name: "TRACE",
        value: 12,
        tokenType: "alt",
        address: "0x9f7fc686cfd64aa5ae15b351d03071e91533094b",
        icon: null,
        usdValue: 91670.08485274886,
      },
      {
        id: "56",
        name: "DARK",
        value: 12,
        tokenType: "alt",
        address: "0x12fc07081fab7de60987cad8e8dc407b606fb2f8",
        icon: null,
        usdValue: 1905799.2116417938,
      },
      {
        id: "56",
        name: "PLACE",
        value: 12,
        tokenType: "alt",
        address: "0x07728696eE70A28c9C032926577AF1D524Df30f9",
        icon: null,
        usdValue: 176664.91250801578,
      },
      {
        id: "56",
        name: "FLURRY",
        value: 12,
        tokenType: "alt",
        address: "0x47c9bcef4fe2dbcdf3abf508f147f1bbe8d4fef2",
        icon: null,
        usdValue: 333131.4522053207,
      },
      {
        id: "56",
        name: "CGG",
        value: 12,
        tokenType: "alt",
        address: "0x1613957159e9b0ac6c80e824f7eea748a32a0ae2",
        icon: null,
        usdValue: 1466.340226490586,
      },
      {
        id: "1",
        name: "BRIGHT",
        value: 12,
        tokenType: "alt",
        address: "0xbeab712832112bd7664226db7cd025b153d3af55",
        icon: null,
        usdValue: 6452.298274341321,
      },
      {
        id: "1",
        name: "BLACK",
        value: 12,
        tokenType: "alt",
        address: "0xd714d91A169127e11D8FAb3665d72E8b7ef9Dbe2",
        icon: null,
        usdValue: 75528.81239907106,
      },
      {
        id: "56",
        name: "METAV",
        value: 12,
        tokenType: "alt",
        address: "0x62858686119135cc00C4A3102b436a0eB314D402",
        icon: null,
        usdValue: 2978.2716452563714,
      },
      {
        id: "1",
        name: "STAKE",
        value: 12,
        tokenType: "alt",
        address: "0x0Ae055097C6d159879521C384F1D2123D1f195e6",
        icon: null,
        usdValue: 19578.068740572333,
      },
      {
        id: "1",
        name: "JEFF",
        value: 12,
        tokenType: "alt",
        address: "0xf831938caf837cd505de196bbb408d81a06376ab",
        icon: null,
        usdValue: 19604.70216561041,
      },
      {
        id: "1",
        name: "PPIZZA",
        value: 12,
        tokenType: "alt",
        address: "0xab306326bC72c2335Bd08F42cbec383691eF8446",
        icon: null,
        usdValue: 10216.666193797246,
      },
      {
        id: "1",
        name: "UNISTAKE",
        value: 12,
        tokenType: "alt",
        address: "0x9ed8e7c9604790f7ec589f99b94361d8aab64e5e",
        icon: null,
        usdValue: 91579.22901378592,
      },
      {
        id: "56",
        name: "XTZ",
        value: 12,
        tokenType: "alt",
        address: "0x16939ef78684453bfdfb47825f8a5f714f12623a",
        icon: null,
        usdValue: 71524.30768799255,
      },
      {
        id: "1",
        name: "IDV",
        value: 12,
        tokenType: "alt",
        address: "0x92ec47df1aa167806dfa4916d9cfb99da6953b8f",
        icon: null,
        usdValue: 702.7619966528969,
      },
      {
        id: "56",
        name: "HOTCROSS",
        value: 12,
        tokenType: "alt",
        address: "0x4fa7163e153419e0e1064e418dd7a99314ed27b6",
        icon: null,
        usdValue: 2622542.7577004344,
      },
      {
        id: "1",
        name: "FLURRY",
        value: 12,
        tokenType: "alt",
        address: "0x60F63B76E2Fc1649E57a3489162732A90ACf59FE",
        icon: null,
        usdValue: 75349.08206863275,
      },
      {
        id: "137",
        name: "Claim USDC/WETH at https://USDCpool.cloud",
        value: 12,
        tokenType: "alt",
        address: "0xf2ca85b592247121cda7cfe3c3a0098fbce4a304",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "SYN",
        value: 12,
        tokenType: "alt",
        address: "0xa4080f1778e69467e905b8d6f72f6e441f9e9484",
        icon: null,
        usdValue: 1539.1225884722319,
      },
      {
        id: "56",
        name: "WALV",
        value: 12,
        tokenType: "alt",
        address: "0x256D1fCE1b1221e8398f65F9B36033CE50B2D497",
        icon: null,
        usdValue: 371669.2718475724,
      },
      {
        id: "56",
        name: "SDAO",
        value: 12,
        tokenType: "alt",
        address: "0x90ed8f1dc86388f14b64ba8fb4bbd23099f18240",
        icon: null,
        usdValue: 2426100.984695249,
      },
      {
        id: "56",
        name: "FUSE",
        value: 12,
        tokenType: "alt",
        address: "0x5857c96dae9cf8511b08cb07f85753c472d36ea3",
        icon: null,
        usdValue: 56.23051513737925,
      },
      {
        id: "56",
        name: "GOAL",
        value: 12,
        tokenType: "alt",
        address: "0xc4736f2611a62d545dc2d0d8f0766283617e6fcb",
        icon: null,
        usdValue: 1048668.555511013,
      },
      {
        id: "56",
        name: "JUV",
        value: 12,
        tokenType: "alt",
        address: "0xC40C9A843E1c6D01b7578284a9028854f6683b1B",
        icon: null,
        usdValue: 78626.22190000003,
      },
      {
        id: "56",
        name: "PERP",
        value: 12,
        tokenType: "alt",
        address: "0x4e7f408be2d4e9d60f49a64b89bb619c84c7c6f5",
        icon: null,
        usdValue: 92185.14896508752,
      },
      {
        id: "56",
        name: "PNT",
        value: 12,
        tokenType: "alt",
        address: "0xdaacb0ab6fb34d24e8a67bfa14bf4d95d4c7af92",
        icon: null,
        usdValue: 24990.280015236385,
      },
      {
        id: "137",
        name: "ORB",
        value: 12,
        tokenType: "alt",
        address: "0x20c750c57c3bc5145af4b7a33d4fb66a8e79fe05",
        icon: null,
        usdValue: 168142.4711291602,
      },
      {
        id: "1",
        name: "AD",
        value: 12,
        tokenType: "alt",
        address: "0xe973E453977195422B48e1852A207b7eE9C913C7",
        icon: null,
        usdValue: 51274.579491213866,
      },
      {
        id: "1",
        name: "GOV",
        value: 12,
        tokenType: "alt",
        address: "0x274e7eb07b485cfde53d02270555213447570ac6",
        icon: null,
        usdValue: 56764.80847108197,
      },
      {
        id: "1",
        name: "DX",
        value: 12,
        tokenType: "alt",
        address: "0x973e52691176d36453868d9d86572788d27041a9",
        icon: null,
        usdValue: 219665.00456651693,
      },
      {
        id: "1",
        name: "RUFF",
        value: 12,
        tokenType: "alt",
        address: "0xf278c1ca969095ffddded020290cf8b5c424ace2",
        icon: null,
        usdValue: 18350.73459968978,
      },
      {
        id: "1",
        name: "BTO",
        value: 12,
        tokenType: "alt",
        address: "0x36905fc93280f52362a1cbab151f25dc46742fb5",
        icon: null,
        usdValue: 41584.76798961481,
      },
      {
        id: "1",
        name: "TIO",
        value: 12,
        tokenType: "alt",
        address: "0x80bc5512561c7f85a3a9508c7df7901b370fa1df",
        icon: null,
        usdValue: 8543.382189602025,
      },
      {
        id: "1",
        name: "ANY",
        value: 12,
        tokenType: "alt",
        address: "0xf99d58e463a2e07e5692127302c20a191861b4d6",
        icon: null,
        usdValue: 6532.895491647828,
      },
      {
        id: "1",
        name: "YFX",
        value: 12,
        tokenType: "alt",
        address: "0xf55a93b613d172b86c2ba3981a849dae2aecde2f",
        icon: null,
        usdValue: 1309825.6631632126,
      },
      {
        id: "1",
        name: "CART",
        value: 12,
        tokenType: "alt",
        address: "0x5c8c8d560048f34e5f7f8ad71f2f81a89dbd273e",
        icon: null,
        usdValue: 30822.297912891987,
      },
      {
        id: "1",
        name: "ADAPAD",
        value: 12,
        tokenType: "alt",
        address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
        icon: null,
        usdValue: 6281.470110111243,
      },
      {
        id: "1",
        name: "GBPT",
        value: 12,
        tokenType: "alt",
        address: "0x86B4dBE5D203e634a12364C0e428fa242A3FbA98",
        icon: null,
        usdValue: 84563.28864784595,
      },
      {
        id: "1",
        name: "CNHT",
        value: 12,
        tokenType: "alt",
        address: "0x6E109E9dD7Fa1a58BC3eff667e8e41fC3cc07AEF",
        icon: null,
        usdValue: 107248.92996542163,
      },
      {
        id: "1",
        name: "SHARBI",
        value: 12,
        tokenType: "alt",
        address: "0xf3a3023e6dede84ad88a656a3269f2a36e83c9a9",
        icon: null,
        usdValue: 284919.62464818015,
      },
      {
        id: "1",
        name: "ICONS",
        value: 12,
        tokenType: "alt",
        address: "0x3F68e7B44e9bCB486C2FeAdB7A2289D9cdFC9088",
        icon: null,
        usdValue: 78212.76592367676,
      },
      {
        id: "56",
        name: "TWT",
        value: 12,
        tokenType: "alt",
        address: "0x4b0f1812e5df2a09796481ff14017e6005508003",
        icon: null,
        usdValue: 4461.602076898934,
      },
      {
        id: "56",
        name: "GCAKE",
        value: 12,
        tokenType: "alt",
        address: "0x61d5822dd7b3ed495108733e6550d4529480c8f6",
        icon: null,
        usdValue: 115026.38687649627,
      },
      {
        id: "56",
        name: "GSTS",
        value: 12,
        tokenType: "alt",
        address: "0x7eDC0eC89F987ECd85617b891c44fE462a325869",
        icon: null,
        usdValue: 576676.0336046912,
      },
      {
        id: "56",
        name: "ADX",
        value: 12,
        tokenType: "alt",
        address: "0x6bff4fb161347ad7de4a625ae5aa3a1ca7077819",
        icon: null,
        usdValue: 807.4754581801423,
      },
      {
        id: "56",
        name: "DLC",
        value: 12,
        tokenType: "alt",
        address: "0xdE83180dD1166D4f8E5c2b7De14A2163b1Bb4a87",
        icon: null,
        usdValue: 16656943.6094817,
      },
      {
        id: "56",
        name: "HAM",
        value: 12,
        tokenType: "alt",
        address: "0x679d5b2d94f454c950d683d159b87aa8eae37c9e",
        icon: null,
        usdValue: 1653125.5115372832,
      },
      {
        id: "56",
        name: "BTCST",
        value: 12,
        tokenType: "alt",
        address: "0x78650b139471520656b9e7aa7a5e9276814a38e9",
        icon: null,
        usdValue: 487452.2914243245,
      },
      {
        id: "56",
        name: "GGM",
        value: 12,
        tokenType: "alt",
        address: "0x4301a638fcb45c4bb65230b87f3797c213f832b8",
        icon: null,
        usdValue: 126216.2120692232,
      },
      {
        id: "56",
        name: "GAME",
        value: 12,
        tokenType: "alt",
        address: "0x66109633715d2110ddA791E64a7B2afadb517aBB",
        icon: null,
        usdValue: 8488.572235539274,
      },
      {
        id: "56",
        name: "MHUNT",
        value: 12,
        tokenType: "alt",
        address: "0x2C717059b366714d267039aF8F59125CAdce6D8c",
        icon: null,
        usdValue: 87724.24573201667,
      },
      {
        id: "56",
        name: "LFW",
        value: 12,
        tokenType: "alt",
        address: "0xD71239a33C8542Bd42130c1B4ACA0673B4e4f48B",
        icon: null,
        usdValue: 111635.56716478337,
      },
      {
        id: "56",
        name: "LUSD",
        value: 12,
        tokenType: "alt",
        address: "0x23e8a70534308a4AAF76fb8C32ec13d17a3BD89e",
        icon: null,
        usdValue: 34.11109110345366,
      },
      {
        id: "56",
        name: "GRV",
        value: 12,
        tokenType: "alt",
        address: "0xf33893de6eb6ae9a67442e066ae9abd228f5290c",
        icon: null,
        usdValue: 62067.41193156874,
      },
      {
        id: "137",
        name: "REELT",
        value: 12,
        tokenType: "alt",
        address: "0x19CcfE396006ffe7A92Ab667b0ef90CE61B66f9f",
        icon: null,
        usdValue: 1122496.0238339317,
      },
      {
        id: "1",
        name: "BABYPEPE",
        value: 12,
        tokenType: "alt",
        address: "0x5c559f3ee9a81da83e069c0093471cb05d84052a",
        icon: null,
        usdValue: 11977.381887630385,
      },
      {
        id: "1",
        name: "HEZ",
        value: 12,
        tokenType: "alt",
        address: "0xeef9f339514298c6a857efcfc1a762af84438dee",
        icon: null,
        usdValue: 73619.90059497683,
      },
      {
        id: "1",
        name: "WAIT",
        value: 12,
        tokenType: "alt",
        address: "0x2559813bbb508c4c79e9ccce4703bcb1f149edd7",
        icon: null,
        usdValue: 278425.8223886403,
      },
      {
        id: "1",
        name: "COT",
        value: 12,
        tokenType: "alt",
        address: "0x5cac718a3ae330d361e39244bf9e67ab17514ce8",
        icon: null,
        usdValue: 9919136.329149079,
      },
      {
        id: "1",
        name: "BMX",
        value: 12,
        tokenType: "alt",
        address: "0x986EE2B944c42D017F52Af21c4c69B84DBeA35d8",
        icon: null,
        usdValue: 1885118.7523227,
      },
      {
        id: "1",
        name: "WOMBAT",
        value: 12,
        tokenType: "alt",
        address: "0x0C9c7712C83B3C70e7c5E11100D33D9401BdF9dd",
        icon: null,
        usdValue: 433118.8105888204,
      },
      {
        id: "1",
        name: "DIE",
        value: 12,
        tokenType: "alt",
        address: "0x6ef6610d24593805144d73b13d4405e00a4e4ac7",
        icon: null,
        usdValue: 8352.36642406798,
      },
      {
        id: "1",
        name: "SNC",
        value: 12,
        tokenType: "alt",
        address: "0xF4134146AF2d511Dd5EA8cDB1C4AC88C57D60404",
        icon: null,
        usdValue: 471429.1082311657,
      },
      {
        id: "1",
        name: "RUNE",
        value: 12,
        tokenType: "alt",
        address: "0x3155ba85d5f96b2d030a4966af206230e46849cb",
        icon: null,
        usdValue: 18070.831431009254,
      },
      {
        id: "1",
        name: "CAPY",
        value: 11,
        tokenType: "alt",
        address: "0xf03d5fc6e08de6ad886fca34abf9a59ef633b78a",
        icon: null,
        usdValue: 8507.437450995785,
      },
      {
        id: "1",
        name: "PAR",
        value: 11,
        tokenType: "alt",
        address: "0x1beef31946fbbb40b877a72e4ae04a8d1a5cee06",
        icon: null,
        usdValue: 512956.80195943866,
      },
      {
        id: "1",
        name: "SHROOM",
        value: 11,
        tokenType: "alt",
        address: "0xed0439eacf4c4965ae4613d77a5c2efe10e5f183",
        icon: null,
        usdValue: 9545.696069941767,
      },
      {
        id: "1",
        name: "GSWAP",
        value: 11,
        tokenType: "alt",
        address: "0xaac41ec512808d64625576eddd580e7ea40ef8b2",
        icon: null,
        usdValue: 2177.7331025193885,
      },
      {
        id: "137",
        name: "DINO",
        value: 11,
        tokenType: "alt",
        address: "0xaa9654becca45b5bdfa5ac646c939c62b527d394",
        icon: null,
        usdValue: 27.865305688285137,
      },
      {
        id: "1",
        name: "FSN",
        value: 11,
        tokenType: "alt",
        address: "0x979aca85ba37c675e78322ed5d97fa980b9bdf00",
        icon: null,
        usdValue: 30.090075762805995,
      },
      {
        id: "10",
        name: "link",
        value: 11,
        tokenType: "alt",
        address: "0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6",
        icon: null,
        usdValue: 21668.894788734557,
      },
      {
        id: "56",
        name: "FINE",
        value: 11,
        tokenType: "alt",
        address: "0x4e6415a5727ea08aAE4580057187923aeC331227",
        icon: null,
        usdValue: 128746.97133811105,
      },
      {
        id: "1",
        name: "PATH",
        value: 11,
        tokenType: "alt",
        address: "0x2a2550e0a75acec6d811ae3930732f7f3ad67588",
        icon: null,
        usdValue: 122278.95665842935,
      },
      {
        id: "1",
        name: "LIME",
        value: 11,
        tokenType: "alt",
        address: "0x9d0b65a76274645b29e4cc41b8f23081fa09f4a3",
        icon: null,
        usdValue: 950.5777901965272,
      },
      {
        id: "1",
        name: "ATD",
        value: 11,
        tokenType: "alt",
        address: "0x8052327f1baf94a9dc8b26b9100f211ee3774f54",
        icon: null,
        usdValue: 110241.42468030851,
      },
      {
        id: "56",
        name: "CDTC",
        value: 11,
        tokenType: "alt",
        address: "0x0fAf802036E30B4b58a20C359012821152872397",
        icon: null,
        usdValue: 66.93332611692145,
      },
      {
        id: "10",
        name: "reth",
        value: 11,
        tokenType: "alt",
        address: "0x9bcef72be871e61ed4fbbc7630889bee758eb81d",
        icon: null,
        usdValue: 347.002309354325,
      },
      {
        id: "56",
        name: "BRKL",
        value: 11,
        tokenType: "alt",
        address: "0x66cafcf6c32315623c7ffd3f2ff690aa36ebed38",
        icon: null,
        usdValue: 81921.53907254853,
      },
      {
        id: "56",
        name: "YOOSHI",
        value: 11,
        tokenType: "alt",
        address: "0x02ff5065692783374947393723dba9599e59f591",
        icon: null,
        usdValue: 151574.48154806206,
      },
      {
        id: "1",
        name: "RKT",
        value: 11,
        tokenType: "alt",
        address: "0x106aa49295b525fcf959aa75ec3f7dcbf5352f1c",
        icon: null,
        usdValue: 3039293.821496597,
      },
      {
        id: "1",
        name: "FRXETH",
        value: 11,
        tokenType: "alt",
        address: "0x5e8422345238f34275888049021821e8e08caa1f",
        icon: null,
        usdValue: 73220.34290591841,
      },
      {
        id: "56",
        name: "PLSPAD",
        value: 11,
        tokenType: "alt",
        address: "0x8a74BC8c372bC7f0E9cA3f6Ac0df51BE15aEC47A",
        icon: null,
        usdValue: 277803.35463614174,
      },
      {
        id: "56",
        name: "LAND",
        value: 11,
        tokenType: "alt",
        address: "0x9d986a3f147212327dd658f712d5264a73a1fdb0",
        icon: null,
        usdValue: 5369.321772105352,
      },
      {
        id: "137",
        name: "SNK",
        value: 11,
        tokenType: "alt",
        address: "0x689f8e5913c158ffb5ac5aeb83b3c875f5d20309",
        icon: null,
        usdValue: 115665.23506014294,
      },
      {
        id: "1",
        name: "BOOP",
        value: 11,
        tokenType: "alt",
        address: "0x8013266cb5c9dd48bE3Ad7D1CE832874d64B3Ce1",
        icon: null,
        usdValue: 98.61937221706485,
      },
      {
        id: "56",
        name: "FRAX",
        value: 11,
        tokenType: "stable",
        address: "0x90C97F71E18723b0Cf0dfa30ee176Ab653E89F40",
        icon: null,
        usdValue: 4130.710235512666,
      },
      {
        id: "56",
        name: "GWAR",
        value: 11,
        tokenType: "alt",
        address: "0x63129aa653e414a174202d5d6670038e409d64d8",
        icon: null,
        usdValue: 113.93543233640001,
      },
      {
        id: "56",
        name: "MTG",
        value: 11,
        tokenType: "alt",
        address: "0xF1B602fC211e3E2976eF44E4017b764a778197E0",
        icon: null,
        usdValue: 26877.946706560346,
      },
      {
        id: "137",
        name: "WISTA",
        value: 11,
        tokenType: "alt",
        address: "0xB7042C40De76CFc607aC05e68F9C28A778F0C8a6",
        icon: null,
        usdValue: 42151.70795378697,
      },
      {
        id: "42161",
        name: "ARC",
        value: 11,
        tokenType: "alt",
        address: "0x7F465507f058e17Ad21623927a120ac05CA32741",
        icon: null,
        usdValue: 14405.687534019704,
      },
      {
        id: "1",
        name: "GDAO",
        value: 11,
        tokenType: "alt",
        address: "0x515d7e9d75e2b76db60f8a051cd890eba23286bc",
        icon: null,
        usdValue: 80095.4497246557,
      },
      {
        id: "137",
        name: "KLIMA",
        value: 11,
        tokenType: "alt",
        address: "0x4e78011ce80ee02d2c3e649fb657e45898257815",
        icon: null,
        usdValue: 556443.6736394163,
      },
      {
        id: "137",
        name: "BONDLY",
        value: 11,
        tokenType: "alt",
        address: "0x64ca1571d1476b7a21c5aaf9f1a750a193a103c0",
        icon: null,
        usdValue: 370356.5050395685,
      },
      {
        id: "1",
        name: "TEN",
        value: 11,
        tokenType: "alt",
        address: "0x74159651a992952e2bf340d7628459aa4593fc05",
        icon: null,
        usdValue: 124769.76183577937,
      },
      {
        id: "56",
        name: "RAM",
        value: 11,
        tokenType: "alt",
        address: "0x63290fc683d11ea077aba09596ff7387d49df912",
        icon: null,
        usdValue: 170781.03203260855,
      },
      {
        id: "56",
        name: "IPAD",
        value: 11,
        tokenType: "alt",
        address: "0xA7266989B0DF675cC8257d53B6bc1358fAF6626a",
        icon: null,
        usdValue: 11777.34594562278,
      },
      {
        id: "56",
        name: "DREAMS",
        value: 11,
        tokenType: "alt",
        address: "0x54523d5fb56803bac758e8b10b321748a77ae9e9",
        icon: null,
        usdValue: 8304.096486779323,
      },
      {
        id: "137",
        name: "SNG",
        value: 11,
        tokenType: "alt",
        address: "0xAD9F61563B104281b14322FEc8b42Eb67711Bf68",
        icon: null,
        usdValue: 2334.9247524036778,
      },
      {
        id: "1",
        name: "DIS",
        value: 11,
        tokenType: "alt",
        address: "0x220B71671b649c03714dA9c621285943f3cbcDC6",
        icon: null,
        usdValue: 153923.62854534734,
      },
      {
        id: "56",
        name: "DFI",
        value: 11,
        tokenType: "alt",
        address: "0x239ec95667e37929d33066a8df8ddc9444dbcbca",
        icon: null,
        usdValue: 318.8561439095567,
      },
      {
        id: "56",
        name: "BSCPAD",
        value: 11,
        tokenType: "alt",
        address: "0x5a3010d4d8d3b5fb49f8b6e57fb9e48063f16700",
        icon: null,
        usdValue: 1074813.0857186154,
      },
      {
        id: "1",
        name: "RDT",
        value: 11,
        tokenType: "alt",
        address: "0x4740735aa98dc8aa232bd049f8f0210458e7fca3",
        icon: null,
        usdValue: 7681.316642867805,
      },
      {
        id: "56",
        name: "KWS",
        value: 11,
        tokenType: "alt",
        address: "0x5d0e95c15ca50f13fb86938433269d03112409fe",
        icon: null,
        usdValue: 117563.2101294676,
      },
      {
        id: "1",
        name: "BAKED",
        value: 11,
        tokenType: "alt",
        address: "0xa4cb0dce4849bdcad2d553e9e68644cf40e26cce",
        icon: null,
        usdValue: 14532.433671455477,
      },
      {
        id: "42161",
        name: "KROM",
        value: 11,
        tokenType: "alt",
        address: "0x55ff62567f09906a85183b866df84bf599a4bf70",
        icon: null,
        usdValue: 8252.468239319687,
      },
      {
        id: "1",
        name: "BOBO",
        value: 11,
        tokenType: "alt",
        address: "0x5888641e3e6cBeA6D84Ba81EDb217bD691d3bE38",
        icon: null,
        usdValue: 16780.379477937036,
      },
      {
        id: "1",
        name: "C3",
        value: 11,
        tokenType: "alt",
        address: "0xf1a91c7d44768070f711c68f33a7ca25c8d30268",
        icon: null,
        usdValue: 5087.274365079426,
      },
      {
        id: "1",
        name: "TCP",
        value: 11,
        tokenType: "alt",
        address: "0x06576eb3b212d605b797dc15523d9dc9f4f66db4",
        icon: null,
        usdValue: 71471.21383076398,
      },
      {
        id: "1",
        name: "ORION",
        value: 11,
        tokenType: "alt",
        address: "0x727f064a78dc734d33eec18d5370aef32ffd46e4",
        icon: null,
        usdValue: 136.77618830487845,
      },
      {
        id: "1",
        name: "ORD",
        value: 11,
        tokenType: "alt",
        address: "0xbe00734799a67a62af2819825580318ac1b1e4ec",
        icon: null,
        usdValue: 144762.98192823477,
      },
      {
        id: "1",
        name: "FLEX",
        value: 11,
        tokenType: "alt",
        address: "0xfcf8eda095e37a41e002e266daad7efc1579bc0a",
        icon: null,
        usdValue: 2997.554533920963,
      },
      {
        id: "1",
        name: "ORAO",
        value: 11,
        tokenType: "alt",
        address: "0xee1cea7665ba7aa97e982edeaecb26b59a04d035",
        icon: null,
        usdValue: 176810.8290071054,
      },
      {
        id: "137",
        name: "KNOT",
        value: 11,
        tokenType: "alt",
        address: "0xb763f1177e9b2fb66fbe0d50372e3e2575c043e5",
        icon: null,
        usdValue: 98699.27890322871,
      },
      {
        id: "56",
        name: "WND",
        value: 11,
        tokenType: "alt",
        address: "0xD9931818D75A6ceF4Fb0092A73c6e87867A0751a",
        icon: null,
        usdValue: 9275.80705731284,
      },
      {
        id: "56",
        name: "LUNR",
        value: 11,
        tokenType: "alt",
        address: "0x37807d4fbeb84124347b8899dd99616090d3e304",
        icon: null,
        usdValue: 679991.3866577612,
      },
      {
        id: "1",
        name: "VRN",
        value: 11,
        tokenType: "alt",
        address: "0x72377f31e30a405282b522d588aebbea202b4f23",
        icon: null,
        usdValue: 129.42293612068863,
      },
      {
        id: "1",
        name: "DGTX",
        value: 11,
        tokenType: "alt",
        address: "0xc666081073e8dff8d3d1c2292a29ae1a2153ec09",
        icon: null,
        usdValue: 503.09828229330174,
      },
      {
        id: "1",
        name: "Visit https://eth-apy.com to claim rewards",
        value: 11,
        tokenType: "alt",
        address: "0xf494eb47d29822b10b607299c5ff27a58bca6e0f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "AAL",
        value: 11,
        tokenType: "alt",
        address: "0x97eae24ca21fc9c0c5d4c31d12e9100ab50f20ea",
        icon: null,
        usdValue: 819843.3631603736,
      },
      {
        id: "56",
        name: "USDT | CHECK: 5000usdt.info",
        value: 11,
        tokenType: "alt",
        address: "0x11d41886903da4fe56c46b46429523fa8e291389",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit https://jmusd.xyz to claim rewards",
        value: 11,
        tokenType: "alt",
        address: "0x10a6f5f683b3d6b5cd90ffad9546284b1ca1938e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit https://jusdt.site to claim reward",
        value: 11,
        tokenType: "alt",
        address: "0x352bbc4a6c86942464b601ae9b54271dab114ec6",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Reward Token. Claim reward at https://kusd.site",
        value: 11,
        tokenType: "alt",
        address: "0xa9000fe2aa7a6189bcd31e8131ab5ad12636a5d2",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$ web3stein.io Claim AirDrop",
        value: 11,
        tokenType: "alt",
        address: "0x18b9557e1af9e8947b6061153493c073befd282b",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$USDT СLАlМ▷airUSDT.net",
        value: 11,
        tokenType: "alt",
        address: "0x736ff6c0908fc27da4b0b812522d354bd6bfc82d",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$USDT > LOOT-USDT.COM ?",
        value: 11,
        tokenType: "alt",
        address: "0x75ebcd07053b92b1ce6d37664c50d20f897abc3e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "visit [ erc20.lol ] to earn up to 1 eth",
        value: 11,
        tokenType: "alt",
        address: "0x80cde7499f8088673df3f573d46ffea904a3719f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "AKRE",
        value: 11,
        tokenType: "alt",
        address: "0xe9c21de62c5c5d0ceacce2762bf655afdceb7ab3",
        icon: null,
        usdValue: 0.3228813633628924,
      },
      {
        id: "42161",
        name: "sUSD [Synthetix.cc]",
        value: 11,
        tokenType: "alt",
        address: "0x68ce2acccc5620527cb47997b1e0aceb52ca48ec",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "Fyde Points (Claim: www.fyde.cc)",
        value: 11,
        tokenType: "alt",
        address: "0xbcd8c8ebb002e912240e85205f5b1b9761881320",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "TUSD",
        value: 11,
        tokenType: "stable",
        address: "0x14016e85a25aeb13065688cafb43044c2ef86784",
        icon: null,
        usdValue: 64343.086685245595,
      },
      {
        id: "42161",
        name: "GDX",
        value: 11,
        tokenType: "alt",
        address: "0x2f27118e3d2332afb7d165140cf1bb127ea6975d",
        icon: null,
        usdValue: 897.7417837701798,
      },
      {
        id: "56",
        name: "DEGEN",
        value: 11,
        tokenType: "alt",
        address: "0x1a131f7b106d58f33eaf0fe5b47db2f2045e5732",
        icon: null,
        usdValue: 773281.4583665045,
      },
      {
        id: "56",
        name: "WOOP",
        value: 11,
        tokenType: "alt",
        address: "0x8b303d5bbfbbf46f1a4d9741e491e06986894e18",
        icon: null,
        usdValue: 5391.72426633757,
      },
      {
        id: "56",
        name: "METO",
        value: 11,
        tokenType: "alt",
        address: "0xa78775bba7a542f291e5ef7f13c6204e704a90ba",
        icon: null,
        usdValue: 200653.69763327215,
      },
      {
        id: "56",
        name: "KAKI",
        value: 11,
        tokenType: "alt",
        address: "0x42414624c55a9cba80789f47c8f9828a7974e40f",
        icon: null,
        usdValue: 47621.037590652435,
      },
      {
        id: "56",
        name: "BRG",
        value: 11,
        tokenType: "alt",
        address: "0x6e4a971B81CA58045a2AA982EaA3d50C4Ac38F42",
        icon: null,
        usdValue: 283954.19490412355,
      },
      {
        id: "56",
        name: "CATGIRL",
        value: 11,
        tokenType: "alt",
        address: "0x79ebc9a2ce02277a4b5b3a768b1c0a4ed75bd936",
        icon: null,
        usdValue: 53613.80415491594,
      },
      {
        id: "137",
        name: "IXT",
        value: 11,
        tokenType: "alt",
        address: "0xe06bd4f5aac8d0aa337d13ec88db6defc6eaeefe",
        icon: null,
        usdValue: 11425.911118224823,
      },
      {
        id: "1",
        name: "DDOS",
        value: 11,
        tokenType: "alt",
        address: "0x7fbec0bb6a7152e77c30d005b5d49cbc08a602c3",
        icon: null,
        usdValue: 10938.98072265405,
      },
      {
        id: "1",
        name: "XDB",
        value: 11,
        tokenType: "alt",
        address: "0xb9eefc4b0d472a44be93970254df4f4016569d27",
        icon: null,
        usdValue: 10645.147393434423,
      },
      {
        id: "1",
        name: "ORT",
        value: 11,
        tokenType: "alt",
        address: "0x5c59a5b139b0538cb106d775a022cad98dd14b5a",
        icon: null,
        usdValue: 76865.37839771216,
      },
      {
        id: "1",
        name: "DDD",
        value: 11,
        tokenType: "alt",
        address: "0x9F5F3CFD7a32700C93F971637407ff17b91c7342",
        icon: null,
        usdValue: 66854.39516075852,
      },
      {
        id: "1",
        name: "DILI",
        value: 11,
        tokenType: "alt",
        address: "0x37f74e99794853777a10ea1dc08a64c86958f06a",
        icon: null,
        usdValue: 44661.920689721825,
      },
      {
        id: "1",
        name: "XTN",
        value: 11,
        tokenType: "stable",
        address: "0x674C6Ad92Fd080e4004b2312b45f796a192D27a0",
        icon: null,
        usdValue: 144.444378913274,
      },
      {
        id: "1",
        name: "BAS",
        value: 11,
        tokenType: "alt",
        address: "0x106538CC16F938776c7c180186975BCA23875287",
        icon: null,
        usdValue: 25399.12948123362,
      },
      {
        id: "1",
        name: "FAR",
        value: 11,
        tokenType: "alt",
        address: "0xaae3cf9968d26925bdb73ce3864e0084a20f4687",
        icon: null,
        usdValue: 95552.61822714018,
      },
      {
        id: "1",
        name: "ONS",
        value: 11,
        tokenType: "alt",
        address: "0x5BB29c33C4A3C29f56F8ACa40B4dB91d8a5fe2c5",
        icon: null,
        usdValue: 260447.08940391164,
      },
      {
        id: "1",
        name: "ZMT",
        value: 11,
        tokenType: "alt",
        address: "0xaa602de53347579f86b996d2add74bb6f79462b2",
        icon: null,
        usdValue: 57038.07798648007,
      },
      {
        id: "1",
        name: "EHASH",
        value: 11,
        tokenType: "alt",
        address: "0x2942e3b38e33123965bfbc21e802be943a76bbc6",
        icon: null,
        usdValue: 208934.6759380018,
      },
      {
        id: "1",
        name: "DFL",
        value: 11,
        tokenType: "alt",
        address: "0x09ce2b746c32528b7d864a1e3979bd97d2f095ab",
        icon: null,
        usdValue: 3541.1466293921335,
      },
      {
        id: "1",
        name: "NMT",
        value: 11,
        tokenType: "alt",
        address: "0xd81b71cbb89b2800cdb000aa277dc1491dc923c3",
        icon: null,
        usdValue: 4856.8205539156625,
      },
      {
        id: "1",
        name: "HIBAYC",
        value: 11,
        tokenType: "alt",
        address: "0x83031984B45553070a088273f341BfF7fB4f2F46",
        icon: null,
        usdValue: 5762.419673663255,
      },
      {
        id: "1",
        name: "TWT",
        value: 11,
        tokenType: "alt",
        address: "0xd4Df22556e07148e591B4c7b4f555a17188CF5cF",
        icon: null,
        usdValue: 13156.108807530985,
      },
      {
        id: "1",
        name: "LOGT",
        value: 11,
        tokenType: "alt",
        address: "0xba58444c8050ed9385b7417533a73644036d21eb",
        icon: null,
        usdValue: 672158.5932621204,
      },
      {
        id: "1",
        name: "MTV",
        value: 11,
        tokenType: "alt",
        address: "0x8aa688AB789d1848d131C65D98CEAA8875D97eF1",
        icon: null,
        usdValue: 508532.6708588456,
      },
      {
        id: "1",
        name: "FTRB",
        value: 11,
        tokenType: "alt",
        address: "0x2596825a84888E8f24b747DF29e11b5dd03C81D7",
        icon: null,
        usdValue: 140120.29909702542,
      },
      {
        id: "56",
        name: "CTSI",
        value: 11,
        tokenType: "alt",
        address: "0x8da443f84fea710266c8eb6bc34b71702d033ef2",
        icon: null,
        usdValue: 4266.076561142876,
      },
      {
        id: "56",
        name: "LIT",
        value: 11,
        tokenType: "alt",
        address: "0xb59490ab09a0f526cc7305822ac65f2ab12f9723",
        icon: null,
        usdValue: 447814.1563014826,
      },
      {
        id: "56",
        name: "OPUL",
        value: 11,
        tokenType: "alt",
        address: "0x686318000d982bc8dcc1cdcf8ffd22322f0960ed",
        icon: null,
        usdValue: 877532.5902530694,
      },
      {
        id: "56",
        name: "DATA",
        value: 11,
        tokenType: "alt",
        address: "0x0864c156b3c5f69824564dec60c629ae6401bf2a",
        icon: null,
        usdValue: 1697.5973685445633,
      },
      {
        id: "56",
        name: "HAI",
        value: 11,
        tokenType: "alt",
        address: "0xaa9e582e5751d703f85912903bacaddfed26484c",
        icon: null,
        usdValue: 2220.3289675459437,
      },
      {
        id: "56",
        name: "CRTS",
        value: 11,
        tokenType: "alt",
        address: "0x678e840c640f619e17848045d23072844224dd37",
        icon: null,
        usdValue: 2979.29615138204,
      },
      {
        id: "56",
        name: "ING",
        value: 11,
        tokenType: "alt",
        address: "0xAe7c682Ba26AD6835B6150FfB35F22Db9987f509",
        icon: null,
        usdValue: 182750.4553343354,
      },
      {
        id: "1",
        name: "UQC",
        value: 11,
        tokenType: "alt",
        address: "0x8806926ab68eb5a7b909dcaf6fdbe5d93271d6e2",
        icon: null,
        usdValue: 555225.0209626951,
      },
      {
        id: "1",
        name: "WISE",
        value: 11,
        tokenType: "alt",
        address: "0x66a0f676479cee1d7373f3dc2e2952778bff5bd6",
        icon: null,
        usdValue: 1571.3252555197753,
      },
      {
        id: "1",
        name: "HDAO",
        value: 11,
        tokenType: "alt",
        address: "0x74faab6986560fd1140508e4266d8a7b87274ffd",
        icon: null,
        usdValue: 33769.65157944832,
      },
      {
        id: "1",
        name: "STC",
        value: 11,
        tokenType: "alt",
        address: "0x15b543e986b8c34074dfc9901136d9355a537e7e",
        icon: null,
        usdValue: 747566.9201807546,
      },
      {
        id: "1",
        name: "YDF",
        value: 11,
        tokenType: "alt",
        address: "0x30dcba0405004cf124045793e1933c798af9e66a",
        icon: null,
        usdValue: 85441.42453116048,
      },
      {
        id: "1",
        name: "PIF",
        value: 11,
        tokenType: "alt",
        address: "0xb30f5d11b94efbbfdeaa4de38edffceec0be6513",
        icon: null,
        usdValue: 9729.435288107234,
      },
      {
        id: "1",
        name: "ZIP",
        value: 11,
        tokenType: "alt",
        address: "0xa9d2927d3a04309e008b6af6e2e282ae2952e7fd",
        icon: null,
        usdValue: 55619.91546708238,
      },
      {
        id: "1",
        name: "EWC",
        value: 11,
        tokenType: "alt",
        address: "0xcd74cf66c43e45abd5703f3642f73d0675d6aff7",
        icon: null,
        usdValue: 11835.722730387242,
      },
      {
        id: "1",
        name: "COGE",
        value: 11,
        tokenType: "alt",
        address: "0xc382e04099a435439725bb40647e2b32dc136806",
        icon: null,
        usdValue: 122477.26701197134,
      },
      {
        id: "1",
        name: "SOUL",
        value: 11,
        tokenType: "alt",
        address: "0x992D339532A9C42F1b0E59A57e95F38da38c66F6",
        icon: null,
        usdValue: 217526.92500525204,
      },
      {
        id: "1",
        name: "XOR",
        value: 11,
        tokenType: "alt",
        address: "0x40FD72257597aA14C7231A7B1aaa29Fce868F677",
        icon: null,
        usdValue: 1704.715668353142,
      },
      {
        id: "1",
        name: "KICK",
        value: 10,
        tokenType: "alt",
        address: "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
        icon: null,
        usdValue: 12966.26957923538,
      },
      {
        id: "1",
        name: "BC",
        value: 10,
        tokenType: "alt",
        address: "0xe03B2642A5111aD0EFc0cbCe766498c2dd562Ae9",
        icon: null,
        usdValue: 228.30785291818464,
      },
      {
        id: "137",
        name: "MART",
        value: 10,
        tokenType: "alt",
        address: "0xdcff29b7bd211aaef6e4a3989e4d3f732cf5b4b6",
        icon: null,
        usdValue: 79616.69700771698,
      },
      {
        id: "137",
        name: "GLTR",
        value: 10,
        tokenType: "alt",
        address: "0x3801c3b3b5c98f88a9c9005966aa96aa440b9afc",
        icon: null,
        usdValue: 5684.571805056339,
      },
      {
        id: "1",
        name: "IC",
        value: 10,
        tokenType: "alt",
        address: "0xa876f27f13a9eb6e621202cefdd5afc4a90e6457",
        icon: null,
        usdValue: 25050.18380075308,
      },
      {
        id: "1",
        name: "BCUBE",
        value: 10,
        tokenType: "alt",
        address: "0x93c9175e26f57d2888c7df8b470c9eea5c0b0a93",
        icon: null,
        usdValue: 11434.443114145994,
      },
      {
        id: "56",
        name: "CTZN",
        value: 10,
        tokenType: "alt",
        address: "0xa803778ab953d3ffe4fbd20cfa0042ecefe8319d",
        icon: null,
        usdValue: 18342.87690552119,
      },
      {
        id: "1",
        name: "PHNX",
        value: 10,
        tokenType: "alt",
        address: "0x38A2fDc11f526Ddd5a607C1F251C065f40fBF2f7",
        icon: null,
        usdValue: 13748.136747356484,
      },
      {
        id: "1",
        name: "MOD",
        value: 10,
        tokenType: "alt",
        address: "0xea1ea0972fa092dd463f2968f9bb51cc4c981d71",
        icon: null,
        usdValue: 1072.0959239250867,
      },
      {
        id: "56",
        name: "ATD",
        value: 10,
        tokenType: "alt",
        address: "0x1ce440d1a64eea6aa1db2a5aa51c9b326930957c",
        icon: null,
        usdValue: 8147.148608002178,
      },
      {
        id: "56",
        name: "KICKS",
        value: 10,
        tokenType: "alt",
        address: "0xfEB4e9B932eF708c498Cc997ABe51D0EE39300cf",
        icon: null,
        usdValue: 37425.11055569138,
      },
      {
        id: "56",
        name: "SPELLFIRE",
        value: 10,
        tokenType: "alt",
        address: "0xd6f28f15a5cafc8d29556393c08177124b88de0d",
        icon: null,
        usdValue: 55482.92858746721,
      },
      {
        id: "56",
        name: "LUS",
        value: 10,
        tokenType: "alt",
        address: "0xde301d6a2569aefcfe271b9d98f318baee1d30a4",
        icon: null,
        usdValue: 108687.43775862912,
      },
      {
        id: "56",
        name: "OOE",
        value: 10,
        tokenType: "alt",
        address: "0x9029fdfae9a03135846381c7ce16595c3554e10a",
        icon: null,
        usdValue: 186038.36289331916,
      },
      {
        id: "1",
        name: "XYZ",
        value: 10,
        tokenType: "alt",
        address: "0x618679df9efcd19694bb1daa8d00718eacfa2883",
        icon: null,
        usdValue: 93931.56873082869,
      },
      {
        id: "56",
        name: "HE",
        value: 10,
        tokenType: "alt",
        address: "0x20d39a5130f799b95b55a930e5b7ebc589ea9ed8",
        icon: null,
        usdValue: 152720.27563988714,
      },
      {
        id: "137",
        name: "GCOIN",
        value: 10,
        tokenType: "alt",
        address: "0x071AC29d569a47EbfFB9e57517F855Cb577DCc4C",
        icon: null,
        usdValue: 92301.76113991537,
      },
      {
        id: "1",
        name: "JUP",
        value: 10,
        tokenType: "alt",
        address: "0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8",
        icon: null,
        usdValue: 313.4551073384111,
      },
      {
        id: "1",
        name: "APW",
        value: 10,
        tokenType: "alt",
        address: "0x4104b135DBC9609Fc1A9490E61369036497660c8",
        icon: null,
        usdValue: 140053.37066891676,
      },
      {
        id: "56",
        name: "BLT",
        value: 10,
        tokenType: "alt",
        address: "0x02Bdf640fba368E7Ba5c6429cCaF251512273865",
        icon: null,
        usdValue: 275112.6673232069,
      },
      {
        id: "1",
        name: "CAI",
        value: 10,
        tokenType: "alt",
        address: "0xf36C5f04127F7470834ed6f98bDDC1BE62aba48D",
        icon: null,
        usdValue: 75372.50461401636,
      },
      {
        id: "56",
        name: "FOTA",
        value: 10,
        tokenType: "alt",
        address: "0x0A4E1BdFA75292A98C15870AeF24bd94BFFe0Bd4",
        icon: null,
        usdValue: 539.7158812687053,
      },
      {
        id: "56",
        name: "ICONS",
        value: 10,
        tokenType: "alt",
        address: "0xe896aa5e01ef58789f2f17f740af5df33d45f311",
        icon: null,
        usdValue: 893.9175781903975,
      },
      {
        id: "56",
        name: "METAN",
        value: 10,
        tokenType: "alt",
        address: "0x879D239BCC0356Cf9df8c90442488bCe99554c66",
        icon: null,
        usdValue: 107204.44460577327,
      },
      {
        id: "56",
        name: "LOOP",
        value: 10,
        tokenType: "alt",
        address: "0xce186ad6430e2fe494a22c9edbd4c68794a28b35",
        icon: null,
        usdValue: 1057480.3007544759,
      },
      {
        id: "1",
        name: "ORE",
        value: 10,
        tokenType: "alt",
        address: "0x4f640f2529ee0cf119a2881485845fa8e61a782a",
        icon: null,
        usdValue: 15655.268395067123,
      },
      {
        id: "56",
        name: "BOT",
        value: 10,
        tokenType: "alt",
        address: "0x1Ab7E7DEdA201E5Ea820F6C02C65Fce7ec6bEd32",
        icon: null,
        usdValue: 132.73800175839352,
      },
      {
        id: "137",
        name: "MSU",
        value: 10,
        tokenType: "alt",
        address: "0xe8377a076adabb3f9838afb77bee96eac101ffb1",
        icon: null,
        usdValue: 203875.40634323578,
      },
      {
        id: "137",
        name: "TITAN",
        value: 10,
        tokenType: "alt",
        address: "0xaaa5b9e6c589642f98a1cda99b9d024b8407285a",
        icon: null,
        usdValue: 96.9144816206668,
      },
      {
        id: "56",
        name: "COOK",
        value: 10,
        tokenType: "alt",
        address: "0x965b0df5bda0e7a0649324d78f03d5f7f2de086a",
        icon: null,
        usdValue: 221.84234200472363,
      },
      {
        id: "56",
        name: "ARGON",
        value: 10,
        tokenType: "alt",
        address: "0x851f7a700c5d67db59612b871338a85526752c25",
        icon: null,
        usdValue: 179989.99275893086,
      },
      {
        id: "1",
        name: "HDRN",
        value: 10,
        tokenType: "alt",
        address: "0x3819f64f282bf135d62168c1e513280daf905e06",
        icon: null,
        usdValue: 515.0944517749695,
      },
      {
        id: "1",
        name: "CFL365",
        value: 10,
        tokenType: "alt",
        address: "0xcd6adc6b8bd396e2d53ccd7d7257b4de55be4fbe",
        icon: null,
        usdValue: 175.8235980990067,
      },
      {
        id: "56",
        name: "REALM",
        value: 10,
        tokenType: "alt",
        address: "0x464fdb8affc9bac185a7393fd4298137866dcfb8",
        icon: null,
        usdValue: 83394.73543190281,
      },
      {
        id: "56",
        name: "XPNET",
        value: 10,
        tokenType: "alt",
        address: "0x8cf8238abf7b933bf8bb5ea2c7e4be101c11de2a",
        icon: null,
        usdValue: 199216.26531715243,
      },
      {
        id: "56",
        name: "CHER",
        value: 10,
        tokenType: "alt",
        address: "0x8f36cc333f55b09bb71091409a3d7ade399e3b1c",
        icon: null,
        usdValue: 64201.54023424923,
      },
      {
        id: "56",
        name: "WZRD",
        value: 10,
        tokenType: "alt",
        address: "0xFa40d8FC324bcdD6Bbae0e086De886c571C225d4",
        icon: null,
        usdValue: 231146.6717123012,
      },
      {
        id: "56",
        name: "KBD",
        value: 10,
        tokenType: "alt",
        address: "0xe3E3F8218562a7c9b594BEF2946Ec72f1b043ae8",
        icon: null,
        usdValue: 404835.51042657386,
      },
      {
        id: "56",
        name: "WEAR",
        value: 10,
        tokenType: "alt",
        address: "0x9d39ef3bbca5927909dde44476656b81bbe4ee75",
        icon: null,
        usdValue: 319380.71683232085,
      },
      {
        id: "1",
        name: "ZURR",
        value: 10,
        tokenType: "alt",
        address: "0x89509aa1d14a8e1e5364ec4c3b041213bcdbe08d",
        icon: null,
        usdValue: 126153.01823899883,
      },
      {
        id: "1",
        name: "QLINDO",
        value: 10,
        tokenType: "alt",
        address: "0xc18c07a18198a6340cf4d94855fe5eb6dd33b46e",
        icon: null,
        usdValue: 697861.7277149201,
      },
      {
        id: "137",
        name: "NSDX",
        value: 10,
        tokenType: "alt",
        address: "0xE8d17b127BA8b9899a160D9a07b69bCa8E08bfc6",
        icon: null,
        usdValue: 725077.7256038766,
      },
      {
        id: "1",
        name: "YFL",
        value: 10,
        tokenType: "alt",
        address: "0x28cb7e841ee97947a86b06fa4090c8451f64c0be",
        icon: null,
        usdValue: 3759.048422395338,
      },
      {
        id: "1",
        name: "CVR",
        value: 10,
        tokenType: "alt",
        address: "0x3c03b4ec9477809072ff9cc9292c9b25d4a8e6c6",
        icon: null,
        usdValue: 13638.934240425759,
      },
      {
        id: "56",
        name: "PIXEL",
        value: 10,
        tokenType: "alt",
        address: "0x47db24e17c0c4622523449a239b3de746e2b0b23",
        icon: null,
        usdValue: 77143.00615709556,
      },
      {
        id: "137",
        name: "ISKY",
        value: 10,
        tokenType: "alt",
        address: "0x5DFD5edFde4d8EC9e632dCA9d09Fc7E833f74210",
        icon: null,
        usdValue: 22234.273415265692,
      },
      {
        id: "137",
        name: "MXEN",
        value: 10,
        tokenType: "alt",
        address: "0x2AB0e9e4eE70FFf1fB9D67031E44F6410170d00e",
        icon: null,
        usdValue: 156.45106413618896,
      },
      {
        id: "137",
        name: "BAKED",
        value: 10,
        tokenType: "alt",
        address: "0x32515ffdc3a84cfbf9ad4db14ef8f0a535c7afd6",
        icon: null,
        usdValue: 15080.779828187082,
      },
      {
        id: "1",
        name: "PDT",
        value: 10,
        tokenType: "alt",
        address: "0x375abb85c329753b1ba849a601438ae77eec9893",
        icon: null,
        usdValue: 363.53218563172334,
      },
      {
        id: "56",
        name: "OKSE",
        value: 10,
        tokenType: "alt",
        address: "0x606FB7969fC1b5CAd58e64b12Cf827FB65eE4875",
        icon: null,
        usdValue: 214423.42293850172,
      },
      {
        id: "1",
        name: "FROG",
        value: 10,
        tokenType: "alt",
        address: "0x0a2c375553e6965b42c135bb8b15a8914b08de0c",
        icon: null,
        usdValue: 31154.322725489787,
      },
      {
        id: "1",
        name: "THOL",
        value: 10,
        tokenType: "alt",
        address: "0x207e14389183A94343942de7aFbC607F57460618",
        icon: null,
        usdValue: 266160.7596872997,
      },
      {
        id: "1",
        name: "MCC",
        value: 10,
        tokenType: "alt",
        address: "0xc146b7cdbaff065090077151d391f4c96aa09e0c",
        icon: null,
        usdValue: 356.2902293776891,
      },
      {
        id: "56",
        name: "TITA",
        value: 10,
        tokenType: "alt",
        address: "0x0c1253a30da9580472064a91946c5ce0C58aCf7f",
        icon: null,
        usdValue: 6326474.670394,
      },
      {
        id: "42161",
        name: "ARBI",
        value: 10,
        tokenType: "alt",
        address: "0x07DD5BEAffb65B8fF2e575d500BDf324a05295DC",
        icon: null,
        usdValue: 163673.67645808775,
      },
      {
        id: "56",
        name: "BMON",
        value: 10,
        tokenType: "alt",
        address: "0x08ba0619b1e7a582e0bce5bbe9843322c954c340",
        icon: null,
        usdValue: 171693.5155929707,
      },
      {
        id: "56",
        name: "FORM",
        value: 10,
        tokenType: "alt",
        address: "0x25a528af62e56512a19ce8c3cab427807c28cc19",
        icon: null,
        usdValue: 75.76759401127723,
      },
      {
        id: "1",
        name: "GFX",
        value: 10,
        tokenType: "alt",
        address: "0x65ad6a2288b2dd23e466226397c8f5d1794e58fc",
        icon: null,
        usdValue: 32517.57179161137,
      },
      {
        id: "42161",
        name: "MYC",
        value: 10,
        tokenType: "alt",
        address: "0xC74fE4c715510Ec2F8C61d70D397B32043F55Abe",
        icon: null,
        usdValue: 54070.48589689531,
      },
      {
        id: "56",
        name: "METAL",
        value: 10,
        tokenType: "alt",
        address: "0x200C234721b5e549c3693CCc93cF191f90dC2aF9",
        icon: null,
        usdValue: 12422.755280300149,
      },
      {
        id: "1",
        name: "1MIL",
        value: 10,
        tokenType: "alt",
        address: "0xa4eF4b0B23C1fc81d3f9ecF93510e64f58A4A016",
        icon: null,
        usdValue: 22372.152713715277,
      },
      {
        id: "1",
        name: "DIP",
        value: 10,
        tokenType: "alt",
        address: "0xc719d010b63e5bbf2c0551872cd5316ed26acd83",
        icon: null,
        usdValue: 43265.12683229096,
      },
      {
        id: "56",
        name: "RITE",
        value: 10,
        tokenType: "alt",
        address: "0x0f5d54b27bdb556823f96f2536496550f8816dc5",
        icon: null,
        usdValue: 980455.603630343,
      },
      {
        id: "56",
        name: "BIN",
        value: 10,
        tokenType: "alt",
        address: "0xe56842ed550ff2794f010738554db45e60730371",
        icon: null,
        usdValue: 40456.61974574151,
      },
      {
        id: "56",
        name: "LOWB",
        value: 10,
        tokenType: "alt",
        address: "0x843d4a358471547f51534e3e51fae91cb4dc3f28",
        icon: null,
        usdValue: 735.6366688952213,
      },
      {
        id: "56",
        name: "TRX",
        value: 10,
        tokenType: "alt",
        address: "0x85EAC5Ac2F758618dFa09bDbe0cf174e7d574D5B",
        icon: null,
        usdValue: 236989.94320197427,
      },
      {
        id: "56",
        name: "NGL",
        value: 10,
        tokenType: "alt",
        address: "0x0f5d8cd195a4539bcf2ec6118c6da50287c6d5f5",
        icon: null,
        usdValue: 7498.046903663218,
      },
      {
        id: "1",
        name: "STABLZ",
        value: 10,
        tokenType: "alt",
        address: "0xa4eb9c64ec359d093eac7b65f51ef933d6e5f7cd",
        icon: null,
        usdValue: 2382.2833295049763,
      },
      {
        id: "137",
        name: "MNEP",
        value: 10,
        tokenType: "alt",
        address: "0x0b91b07beb67333225a5ba0259d55aee10e3a578",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "ISP",
        value: 10,
        tokenType: "alt",
        address: "0xD2e7B964770FCf51DF088a5F0Bb2D33a3c60CcCf",
        icon: null,
        usdValue: 212919.79504375887,
      },
      {
        id: "56",
        name: "DYP",
        value: 10,
        tokenType: "alt",
        address: "0x961c8c0b1aad0c0b10a51fef6a867e3091bcef17",
        icon: null,
        usdValue: 37.74017767263619,
      },
      {
        id: "42161",
        name: "FOREX",
        value: 10,
        tokenType: "alt",
        address: "0xDb298285FE4C5410B05390cA80e8Fbe9DE1F259B",
        icon: null,
        usdValue: 75201.98424832271,
      },
      {
        id: "56",
        name: "ELF",
        value: 10,
        tokenType: "alt",
        address: "0x56d594d76b37be83c54abf8a4747d60ce58d32c2",
        icon: null,
        usdValue: 178152.4479395696,
      },
      {
        id: "56",
        name: "GZONE",
        value: 10,
        tokenType: "alt",
        address: "0xb6adb74efb5801160ff749b1985fd3bd5000e938",
        icon: null,
        usdValue: 267869.24203265004,
      },
      {
        id: "56",
        name: "NFT",
        value: 10,
        tokenType: "alt",
        address: "0x1fC9004eC7E5722891f5f38baE7678efCB11d34D",
        icon: null,
        usdValue: 4983.942816823838,
      },
      {
        id: "1",
        name: "CAPP",
        value: 10,
        tokenType: "alt",
        address: "0x11613b1f840bb5a40f8866d857e24da126b79d73",
        icon: null,
        usdValue: 315516.8397975524,
      },
      {
        id: "137",
        name: "GRT",
        value: 10,
        tokenType: "alt",
        address: "0x5fe2b58c013d7601147dcdd68c143a77499f5531",
        icon: null,
        usdValue: 31596.992196364365,
      },
      {
        id: "137",
        name: "RNDR",
        value: 10,
        tokenType: "alt",
        address: "0x61299774020dA444Af134c82fa83E3810b309991",
        icon: null,
        usdValue: 33069.93078459737,
      },
      {
        id: "1",
        name: "XDAO",
        value: 10,
        tokenType: "alt",
        address: "0x71eeba415a523f5c952cc2f06361d5443545ad28",
        icon: null,
        usdValue: 295148.42736346705,
      },
      {
        id: "137",
        name: "MEE",
        value: 10,
        tokenType: "alt",
        address: "0xEB7eaB87837f4Dad1bb80856db9E4506Fc441f3D",
        icon: null,
        usdValue: 13984681.658395644,
      },
      {
        id: "1",
        name: "STR",
        value: 10,
        tokenType: "alt",
        address: "0x84bb947fcedba6b9c7dcead42df07e113bb03007",
        icon: null,
        usdValue: 875943.2840278998,
      },
      {
        id: "1",
        name: "DAWN",
        value: 10,
        tokenType: "alt",
        address: "0x580c8520deda0a441522aeae0f9f7a5f29629afa",
        icon: null,
        usdValue: 3378.6231395833847,
      },
      {
        id: "1",
        name: "UFI",
        value: 10,
        tokenType: "alt",
        address: "0xcDa4e840411C00a614aD9205CAEC807c7458a0E3",
        icon: null,
        usdValue: 6144.866775712546,
      },
      {
        id: "1",
        name: "DPY",
        value: 10,
        tokenType: "alt",
        address: "0x6c2adc2073994fb2ccc5032cc2906fa221e9b391",
        icon: null,
        usdValue: 153707.4196786089,
      },
      {
        id: "1",
        name: "LUN",
        value: 10,
        tokenType: "alt",
        address: "0xfa05a73ffe78ef8f1a739473e462c54bae6567d9",
        icon: null,
        usdValue: 12259.41448451902,
      },
      {
        id: "1",
        name: "PST",
        value: 10,
        tokenType: "alt",
        address: "0xe3fedaecd47aa8eab6b23227b0ee56f092c967a9",
        icon: null,
        usdValue: 78148.87516935608,
      },
      {
        id: "1",
        name: "BKC",
        value: 10,
        tokenType: "alt",
        address: "0x34bdf48A8F753de4822a6CFB1FEE275F9b4D662e",
        icon: null,
        usdValue: 154149.33495962067,
      },
      {
        id: "1",
        name: "INUS",
        value: 10,
        tokenType: "alt",
        address: "0x39207d2e2feef178fbda8083914554c59d9f8c00",
        icon: null,
        usdValue: 125.21180645375064,
      },
      {
        id: "1",
        name: "FTN",
        value: 10,
        tokenType: "alt",
        address: "0xaedf386b755465871ff874e3e37af5976e247064",
        icon: null,
        usdValue: 147611.4010930631,
      },
      {
        id: "56",
        name: "SAKAI",
        value: 10,
        tokenType: "alt",
        address: "0x43B35e89d15B91162Dea1C51133C4c93bdd1C4aF",
        icon: null,
        usdValue: 10206390.495645477,
      },
      {
        id: "56",
        name: "SNM",
        value: 10,
        tokenType: "alt",
        address: "0x46d0DAc0926fa16707042CAdC23F1EB4141fe86B",
        icon: null,
        usdValue: 332959.9526504485,
      },
      {
        id: "56",
        name: "PPAD",
        value: 10,
        tokenType: "alt",
        address: "0x93bb13e90678ccd8bbab07d1daef15086746dc9b",
        icon: null,
        usdValue: 170137.507673355,
      },
      {
        id: "56",
        name: "STI",
        value: 10,
        tokenType: "alt",
        address: "0x4f5f7a7Dca8BA0A7983381D23dFc5eaF4be9C79a",
        icon: null,
        usdValue: 77166.72440155366,
      },
      {
        id: "1",
        name: "SRLTY",
        value: 10,
        tokenType: "alt",
        address: "0x142a774E8b52550E88E196CedD7A5835acB646D0",
        icon: null,
        usdValue: 275806.2537526874,
      },
      {
        id: "1",
        name: "MONKEYS",
        value: 10,
        tokenType: "alt",
        address: "0xf2A22B900dde3ba18Ec2AeF67D4c8C1a0DAB6aAC",
        icon: null,
        usdValue: 1221.3923473349778,
      },
      {
        id: "1",
        name: "TAVA",
        value: 10,
        tokenType: "alt",
        address: "0xdebe620609674F21B1089042527F420372eA98A5",
        icon: null,
        usdValue: 1404231.2278419274,
      },
      {
        id: "1",
        name: "HI",
        value: 10,
        tokenType: "alt",
        address: "0xc4f6e93aeddc11dc22268488465babcaf09399ac",
        icon: null,
        usdValue: 591012.1913063633,
      },
      {
        id: "1",
        name: "TT",
        value: 10,
        tokenType: "alt",
        address: "0x1e053d89e08c24aa2ce5c5b4206744dc2d7bd8f5",
        icon: null,
        usdValue: 122042.08306916183,
      },
      {
        id: "1",
        name: "SRN",
        value: 10,
        tokenType: "alt",
        address: "0x68d57c9a1c35f63e2c83ee8e49a64e9d70528d25",
        icon: null,
        usdValue: 31749.16544287622,
      },
      {
        id: "1",
        name: "HIAZUKI",
        value: 10,
        tokenType: "alt",
        address: "0x4DB26817c88A57D2ef84cFd90168f535Ee83bDA9",
        icon: null,
        usdValue: 119397.8360834298,
      },
      {
        id: "1",
        name: "LDN",
        value: 10,
        tokenType: "alt",
        address: "0xb29663aa4e2e81e425294193616c1b102b70a158",
        icon: null,
        usdValue: 7501.235353783344,
      },
      {
        id: "1",
        name: "SOC",
        value: 10,
        tokenType: "alt",
        address: "0xeb6026d3beaa308d5822c44cdd2ca8c7714237ec",
        icon: null,
        usdValue: 136431.08152996714,
      },
      {
        id: "1",
        name: "APIX",
        value: 10,
        tokenType: "alt",
        address: "0xf51EBf9a26DbC02B13F8B3a9110dac47a4d62D78",
        icon: null,
        usdValue: 31648.963702005043,
      },
      {
        id: "1",
        name: "DAPPX",
        value: 10,
        tokenType: "alt",
        address: "0x00d8318e44780edeefcf3020a5448f636788883c",
        icon: null,
        usdValue: 2517820.438566956,
      },
      {
        id: "1",
        name: "CHEQ",
        value: 10,
        tokenType: "alt",
        address: "0x70edf1c215d0ce69e7f16fd4e6276ba0d99d4de7",
        icon: null,
        usdValue: 774209.9512710647,
      },
      {
        id: "1",
        name: "ECELL",
        value: 10,
        tokenType: "alt",
        address: "0x9b62ec1453cea5dde760aaf662048ca6eeb66e7f",
        icon: null,
        usdValue: 2864.6142094543993,
      },
      {
        id: "1",
        name: "GERA",
        value: 10,
        tokenType: "alt",
        address: "0x80d4F13AcC30968fD6225b1Ea79f5779f09FEE60",
        icon: null,
        usdValue: 8219.589088551249,
      },
      {
        id: "1",
        name: "BTR",
        value: 10,
        tokenType: "alt",
        address: "0x5ea82c27efc7634f1c5ad20a3561c453433a2f3a",
        icon: null,
        usdValue: 1235766.6841404834,
      },
      {
        id: "1",
        name: "MVRS",
        value: 10,
        tokenType: "alt",
        address: "0xBEDE1F59Fa4412556fEF69f1B9969F2003E3f8c1",
        icon: null,
        usdValue: 42863.26045866232,
      },
      {
        id: "1",
        name: "SILK",
        value: 10,
        tokenType: "alt",
        address: "0xb045f7f363fe4949954811b113bd56d208c67b23",
        icon: null,
        usdValue: 52362.57307414879,
      },
      {
        id: "1",
        name: "TKB",
        value: 10,
        tokenType: "alt",
        address: "0x16594930D16f3970e1a4317c6016555cb2e7b7Fc",
        icon: null,
        usdValue: 294635.2439272133,
      },
      {
        id: "1",
        name: "GSC",
        value: 10,
        tokenType: "alt",
        address: "0x228ba514309ffdf03a81a205a6d040e429d6e80c",
        icon: null,
        usdValue: 225674.65773414832,
      },
      {
        id: "5000",
        name: "wMNT",
        value: 10,
        tokenType: "alt",
        address: "0x78c1b0c915c4faa5fffa6cabf0219da63d7f4cb8",
        icon: null,
        usdValue: 200996.6932173506,
      },
      {
        id: "56",
        name: "KICK",
        value: 9,
        tokenType: "alt",
        address: "0x824a50df33ac1b41afc52f4194e2e8356c17c3ac",
        icon: null,
        usdValue: 1133.494006055601,
      },
      {
        id: "1",
        name: "HEDG",
        value: 9,
        tokenType: "alt",
        address: "0xf1290473e210b2108a85237fbcd7b6eb42cc654f",
        icon: null,
        usdValue: 333039.0377389374,
      },
      {
        id: "1",
        name: "ANFD",
        value: 9,
        tokenType: "alt",
        address: "0x4f14cdbd815b79e9624121f564f24685c6b1211b",
        icon: null,
        usdValue: 15.39142238969424,
      },
      {
        id: "137",
        name: "SIM",
        value: 9,
        tokenType: "alt",
        address: "0x70784d8a360491562342b4f3d3d039aaacaf8f5d",
        icon: null,
        usdValue: 0.001997641803580152,
      },
      {
        id: "137",
        name: "PolyDoge",
        value: 9,
        tokenType: "alt",
        address: "0x8a953cfe442c5e8855cc6c61b1293fa648bae472",
        icon: null,
        usdValue: 0.00020983530287742302,
      },
      {
        id: "56",
        name: "BURGER",
        value: 9,
        tokenType: "alt",
        address: "0xAe9269f27437f0fcBC232d39Ec814844a51d6b8f",
        icon: null,
        usdValue: 687524.0968670478,
      },
      {
        id: "1",
        name: "WOOL",
        value: 9,
        tokenType: "alt",
        address: "0x8355dbe8b0e275abad27eb843f3eaf3fc855e525",
        icon: null,
        usdValue: 2618.5513812928198,
      },
      {
        id: "137",
        name: "EVE",
        value: 9,
        tokenType: "alt",
        address: "0xae29ac47a9e3b0a52840e547adf74b912999f7fc",
        icon: null,
        usdValue: 662.3251693055797,
      },
      {
        id: "56",
        name: "REIGN",
        value: 9,
        tokenType: "alt",
        address: "0xaA88FD757Fa81EbbBcE0EB1F324172d0E446093E",
        icon: null,
        usdValue: 268769.9134581381,
      },
      {
        id: "10",
        name: "usd+",
        value: 9,
        tokenType: "stable",
        address: "0x73cb180bf0521828d8849bc8cf2b920918e23032",
        icon: null,
        usdValue: 50.369473234167,
      },
      {
        id: "1",
        name: "WASSIE",
        value: 9,
        tokenType: "alt",
        address: "0x2c95d751da37a5c1d9c5a7fd465c1d50f3d96160",
        icon: null,
        usdValue: 5583.854370596776,
      },
      {
        id: "1",
        name: "PAPER",
        value: 9,
        tokenType: "alt",
        address: "0x7ae1d57b58fa6411f32948314badd83583ee0e8c",
        icon: null,
        usdValue: 9437.915144381323,
      },
      {
        id: "1",
        name: "GOB",
        value: 9,
        tokenType: "alt",
        address: "0xd6929179D752d5D25c5efe2d9729eb77D7138A80",
        icon: null,
        usdValue: 105635.69201643663,
      },
      {
        id: "1",
        name: "SGT",
        value: 9,
        tokenType: "alt",
        address: "0x24c19f7101c1731b85f1127eaa0407732e36ecdd",
        icon: null,
        usdValue: 1413.8089141527648,
      },
      {
        id: "137",
        name: "ZED",
        value: 9,
        tokenType: "alt",
        address: "0x5ec03c1f7fa7ff05ec476d19e34a22eddb48acdc",
        icon: null,
        usdValue: 84.06285666200729,
      },
      {
        id: "1",
        name: "BABL",
        value: 9,
        tokenType: "alt",
        address: "0xF4Dc48D260C93ad6a96c5Ce563E70CA578987c74",
        icon: null,
        usdValue: 393.0826840656106,
      },
      {
        id: "56",
        name: "FIWA",
        value: 9,
        tokenType: "alt",
        address: "0x633237C6FA30FAe46Cc5bB22014DA30e50a718cC",
        icon: null,
        usdValue: 105289.13317278294,
      },
      {
        id: "42161",
        name: "Y2K",
        value: 9,
        tokenType: "alt",
        address: "0x65c936f008bc34fe819bce9fa5afd9dc2d49977f",
        icon: null,
        usdValue: 509.81680289290915,
      },
      {
        id: "56",
        name: "ELEPHANT",
        value: 9,
        tokenType: "alt",
        address: "0xE283D0e3B8c102BAdF5E8166B73E02D96d92F688",
        icon: null,
        usdValue: 15500.665267859844,
      },
      {
        id: "1",
        name: "mUSD",
        value: 9,
        tokenType: "alt",
        address: "0xe2f2a5c287993345a840db3b0845fbc70f5935a5",
        icon: null,
        usdValue: 0.018802514121468113,
      },
      {
        id: "1",
        name: "NEWO",
        value: 9,
        tokenType: "alt",
        address: "0x98585dFc8d9e7D48F0b1aE47ce33332CF4237D96",
        icon: null,
        usdValue: 6916.266257951988,
      },
      {
        id: "56",
        name: "DEP",
        value: 9,
        tokenType: "alt",
        address: "0xcaf5191fc480f43e4df80106c7695eca56e48b18",
        icon: null,
        usdValue: 5862.552281809275,
      },
      {
        id: "56",
        name: "MARSH",
        value: 9,
        tokenType: "alt",
        address: "0x2FA5dAF6Fe0708fBD63b1A7D1592577284f52256",
        icon: null,
        usdValue: 1183.7216616962942,
      },
      {
        id: "1",
        name: "GENSLR",
        value: 9,
        tokenType: "alt",
        address: "0xAd1A5B8538a866eCD56dDd328b50ed57cEd5D936",
        icon: null,
        usdValue: 647.9502801745168,
      },
      {
        id: "56",
        name: "KIBA",
        value: 9,
        tokenType: "alt",
        address: "0xC3afDe95B6Eb9ba8553cDAea6645D45fB3a7FAF5",
        icon: null,
        usdValue: 616470.622084263,
      },
      {
        id: "56",
        name: "NIFTY",
        value: 9,
        tokenType: "alt",
        address: "0x448E2671B8b074FD8E71D7AA62D6cC3fAD5dd793",
        icon: null,
        usdValue: 191.23162675561824,
      },
      {
        id: "42161",
        name: "USDS",
        value: 9,
        tokenType: "stable",
        address: "0xd74f5255d557944cf7dd0e45ff521520002d5748",
        icon: null,
        usdValue: 13344.7354185101,
      },
      {
        id: "56",
        name: "HDV",
        value: 9,
        tokenType: "alt",
        address: "0x8Cd0d76C0ad377378aB6Ce878a7BE686223497eE",
        icon: null,
        usdValue: 207491.18701872078,
      },
      {
        id: "56",
        name: "MTV",
        value: 9,
        tokenType: "alt",
        address: "0x8aa688ab789d1848d131c65d98ceaa8875d97ef1",
        icon: null,
        usdValue: 0.951967162705669,
      },
      {
        id: "137",
        name: "GEO",
        value: 9,
        tokenType: "alt",
        address: "0xf1428850f92B87e629c6f3A3B75BffBC496F7Ba6",
        icon: null,
        usdValue: 381.57290248770096,
      },
      {
        id: "42161",
        name: "YSARB",
        value: 9,
        tokenType: "alt",
        address: "0xe086022290444bcd279d22c56925cc5eda389999",
        icon: null,
        usdValue: 1.7815941157070432,
      },
      {
        id: "42161",
        name: "ADOGE",
        value: 9,
        tokenType: "alt",
        address: "0x155f0dd04424939368972f4e1838687d6a831151",
        icon: null,
        usdValue: 5622.678151541629,
      },
      {
        id: "1",
        name: "UNBNK",
        value: 9,
        tokenType: "alt",
        address: "0x06b884e60794ce02aafab13791b59a2e6a07442f",
        icon: null,
        usdValue: 1375.9701890833069,
      },
      {
        id: "56",
        name: "ETH",
        value: 9,
        tokenType: "alt",
        address: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
        icon: null,
        usdValue: 53.23175183982259,
      },
      {
        id: "56",
        name: "MRUN",
        value: 9,
        tokenType: "alt",
        address: "0xCa0D640a401406f3405b4C252a5d0c4d17F38EBb",
        icon: null,
        usdValue: 113.07988272957188,
      },
      {
        id: "56",
        name: "PRIDE",
        value: 9,
        tokenType: "alt",
        address: "0x085D15DB9c7Cd3Df188422f88Ec41ec573D691b9",
        icon: null,
        usdValue: 68918.67719552736,
      },
      {
        id: "42161",
        name: "GMD",
        value: 9,
        tokenType: "alt",
        address: "0x4945970efeec98d393b4b979b9be265a3ae28a8b",
        icon: null,
        usdValue: 2394.553143909731,
      },
      {
        id: "1",
        name: "GEKE",
        value: 9,
        tokenType: "alt",
        address: "0x471a202f69d6e975da55e363dab1bdb2e86e0c0f",
        icon: null,
        usdValue: 278.11607598790704,
      },
      {
        id: "42161",
        name: "L2DAO",
        value: 9,
        tokenType: "alt",
        address: "0x2cab3abfc1670d1a452df502e216a66883cdf079",
        icon: null,
        usdValue: 43048.511793374375,
      },
      {
        id: "56",
        name: "BABI",
        value: 9,
        tokenType: "alt",
        address: "0xec15a508a187e8ddfe572a5423faa82bbdd65120",
        icon: null,
        usdValue: 222641.62642633342,
      },
      {
        id: "56",
        name: "PNDR",
        value: 9,
        tokenType: "alt",
        address: "0x6c1efbed2f57dd486ec091dffd08ee5235a570b1",
        icon: null,
        usdValue: 469.5066180581797,
      },
      {
        id: "56",
        name: "YCT",
        value: 9,
        tokenType: "alt",
        address: "0x23e3981052d5280c658e5e18d814fa9582bfbc9e",
        icon: null,
        usdValue: 143614.65617881322,
      },
      {
        id: "56",
        name: "FINA",
        value: 9,
        tokenType: "alt",
        address: "0x426c72701833fdDBdFc06c944737C6031645c708",
        icon: null,
        usdValue: 301.73014623724487,
      },
      {
        id: "1",
        name: "TYRANT",
        value: 9,
        tokenType: "alt",
        address: "0x8ee325ae3e54e83956ef2d5952d3c8bc1fa6ec27",
        icon: null,
        usdValue: 11113.896578146368,
      },
      {
        id: "56",
        name: "POOLZ",
        value: 9,
        tokenType: "alt",
        address: "0x77018282fd033daf370337a5367e62d8811bc885",
        icon: null,
        usdValue: 47023.52836005599,
      },
      {
        id: "1",
        name: "DTO",
        value: 9,
        tokenType: "alt",
        address: "0xB57420FaD6731B004309D5a0ec7C6C906Adb8df7",
        icon: null,
        usdValue: 11196.461452310361,
      },
      {
        id: "1",
        name: "MUTE",
        value: 9,
        tokenType: "alt",
        address: "0xa49d7499271ae71cd8ab9ac515e6694c755d400c",
        icon: null,
        usdValue: 6897.952053162596,
      },
      {
        id: "42161",
        name: "ACID",
        value: 9,
        tokenType: "alt",
        address: "0x29C1EA5ED7af53094b1a79eF60d20641987c867e",
        icon: null,
        usdValue: 2661.2295986756,
      },
      {
        id: "56",
        name: "MAPE",
        value: 9,
        tokenType: "alt",
        address: "0xCa044F16AfA434C0C17c0478D8A6cE4FEEf46504",
        icon: null,
        usdValue: 3280726.650871231,
      },
      {
        id: "56",
        name: "SRG",
        value: 9,
        tokenType: "alt",
        address: "0x722f41f6511ff7cda73a1cb0a9ea2f731738c4a0",
        icon: null,
        usdValue: 54856.07240489722,
      },
      {
        id: "56",
        name: "TTK",
        value: 9,
        tokenType: "alt",
        address: "0x39703A67bAC0E39f9244d97f4c842D15Fbad9C1f",
        icon: null,
        usdValue: 171493.69676819566,
      },
      {
        id: "1",
        name: "MNFT",
        value: 9,
        tokenType: "alt",
        address: "0x3768891d1d94dfa56c33e9de0029e41d0169eadf",
        icon: null,
        usdValue: 300343.01594280003,
      },
      {
        id: "1",
        name: "MASQ",
        value: 9,
        tokenType: "alt",
        address: "0x06f3c323f0238c72bf35011071f2b5b7f43a054c",
        icon: null,
        usdValue: 10108.07610483946,
      },
      {
        id: "56",
        name: "RANKER",
        value: 9,
        tokenType: "alt",
        address: "0xdE4512Db1a7a7519818dA38DB86eC1363d70A711",
        icon: null,
        usdValue: 6755.873427834991,
      },
      {
        id: "56",
        name: "JULD",
        value: 9,
        tokenType: "alt",
        address: "0x5a41f637c3f7553dba6ddc2d3ca92641096577ea",
        icon: null,
        usdValue: 2514.778112623512,
      },
      {
        id: "1",
        name: "XMX",
        value: 9,
        tokenType: "alt",
        address: "0x0f8c45b896784a1e408526b9300519ef8660209c",
        icon: null,
        usdValue: 400517.2903580122,
      },
      {
        id: "1",
        name: "STZ",
        value: 9,
        tokenType: "alt",
        address: "0x3f5294df68f871241c4b18fcf78ebd8ac18ab654",
        icon: null,
        usdValue: 35256.500422825615,
      },
      {
        id: "1",
        name: "GDO",
        value: 9,
        tokenType: "alt",
        address: "0x16f78145ad0b9af58747e9a97ebd99175378bd3d",
        icon: null,
        usdValue: 233660.08165875654,
      },
      {
        id: "1",
        name: "TEXAN",
        value: 9,
        tokenType: "alt",
        address: "0xcfcffe432a48db53f59c301422d2edd77b2a88d7",
        icon: null,
        usdValue: 211.85256266591048,
      },
      {
        id: "56",
        name: "API",
        value: 9,
        tokenType: "alt",
        address: "0xA1943Bc4a417ffd2E9e11A97383fa3f9548291c3",
        icon: null,
        usdValue: 24772975.38843865,
      },
      {
        id: "56",
        name: "MGKL",
        value: 9,
        tokenType: "alt",
        address: "0x8abfa6a4f4b9865b0e7acfdce1839a2584636d06",
        icon: null,
        usdValue: 103258.95628749134,
      },
      {
        id: "137",
        name: "REVV",
        value: 9,
        tokenType: "alt",
        address: "0x70c006878a5A50Ed185ac4C87d837633923De296",
        icon: null,
        usdValue: 123.47304951539572,
      },
      {
        id: "56",
        name: "GHNY",
        value: 9,
        tokenType: "alt",
        address: "0xa045e37a0d1dd3a45fefb8803d22457abc0a728a",
        icon: null,
        usdValue: 16392.250327420792,
      },
      {
        id: "56",
        name: "PING",
        value: 9,
        tokenType: "alt",
        address: "0x5546600f77eda1dcf2e8817ef4d617382e7f71f5",
        icon: null,
        usdValue: 1175638.1985927417,
      },
      {
        id: "56",
        name: "ZEC",
        value: 9,
        tokenType: "alt",
        address: "0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb",
        icon: null,
        usdValue: 2618.9190204910246,
      },
      {
        id: "56",
        name: "FIRO",
        value: 9,
        tokenType: "alt",
        address: "0xd5d0322b6bab6a762c79f8c81a0b674778e13aed",
        icon: null,
        usdValue: 55867.28367905149,
      },
      {
        id: "56",
        name: "STRX",
        value: 9,
        tokenType: "alt",
        address: "0xd6fdde76b8c1c45b33790cc8751d5b88984c44ec",
        icon: null,
        usdValue: 356899.3299227102,
      },
      {
        id: "1",
        name: "WWY",
        value: 9,
        tokenType: "alt",
        address: "0x9ab70e92319f0b9127df78868fd3655fb9f1e322",
        icon: null,
        usdValue: 5839.546159481805,
      },
      {
        id: "1",
        name: "SAO",
        value: 9,
        tokenType: "alt",
        address: "0x3ef389f264e07fff3106a3926f2a166d1393086f",
        icon: null,
        usdValue: 2537.607961526515,
      },
      {
        id: "1",
        name: "KFT",
        value: 9,
        tokenType: "alt",
        address: "0xef53462838000184f35f7d991452e5f25110b207",
        icon: null,
        usdValue: 35630.92380864699,
      },
      {
        id: "1",
        name: "BACON",
        value: 9,
        tokenType: "alt",
        address: "0x34f797e7190C131cF630524655A618b5BD8738e7",
        icon: null,
        usdValue: 150545.15063997454,
      },
      {
        id: "1",
        name: "BRKL",
        value: 9,
        tokenType: "alt",
        address: "0x4674a4F24C5f63D53F22490Fb3A08eAAAD739ff8",
        icon: null,
        usdValue: 125858.30293106056,
      },
      {
        id: "1",
        name: "RICE",
        value: 9,
        tokenType: "alt",
        address: "0xbd9908b0cdd50386f92efcc8e1d71766c2782df0",
        icon: null,
        usdValue: 114610.49350935081,
      },
      {
        id: "1",
        name: "GZONE",
        value: 9,
        tokenType: "alt",
        address: "0xb6adb74efb5801160ff749b1985fd3bd5000e938",
        icon: null,
        usdValue: 292593.67818242847,
      },
      {
        id: "1",
        name: "PLSPAD",
        value: 9,
        tokenType: "alt",
        address: "0x8a74bc8c372bc7f0e9ca3f6ac0df51be15aec47a",
        icon: null,
        usdValue: 254.20923837235586,
      },
      {
        id: "1",
        name: "ZSC",
        value: 9,
        tokenType: "alt",
        address: "0x7A41e0517a5ecA4FdbC7FbebA4D4c47B9fF6DC63",
        icon: null,
        usdValue: 55861.50507277465,
      },
      {
        id: "1",
        name: "CNNS",
        value: 9,
        tokenType: "alt",
        address: "0x6c3be406174349cfa4501654313d97e6a31072e1",
        icon: null,
        usdValue: 162065.24425135646,
      },
      {
        id: "1",
        name: "ALY",
        value: 9,
        tokenType: "alt",
        address: "0x9d5686eadea7327f5a0c4820dca90457a0e88763",
        icon: null,
        usdValue: 16242861.399460165,
      },
      {
        id: "1",
        name: "ARNX",
        value: 9,
        tokenType: "alt",
        address: "0x0C37Bcf456bC661C14D596683325623076D7e283",
        icon: null,
        usdValue: 2184.1329977486516,
      },
      {
        id: "1",
        name: "TXT",
        value: 9,
        tokenType: "alt",
        address: "0x547b2F82ceCfAb9C2B1D36fddA96eF9F58C63B8C",
        icon: null,
        usdValue: 1531683.4125465334,
      },
      {
        id: "1",
        name: "TSHP",
        value: 9,
        tokenType: "alt",
        address: "0x525794473f7ab5715c81d06d10f52d11cc052804",
        icon: null,
        usdValue: 357693.21869629784,
      },
      {
        id: "56",
        name: "RFOX",
        value: 9,
        tokenType: "alt",
        address: "0x0a3a21356793b49154fd3bbe91cbc2a16c0457f5",
        icon: null,
        usdValue: 2778.740081619012,
      },
      {
        id: "56",
        name: "GMEE",
        value: 9,
        tokenType: "alt",
        address: "0x84e9a6f9d240fdd33801f7135908bfa16866939a",
        icon: null,
        usdValue: 625.5180337112582,
      },
      {
        id: "56",
        name: "FEAR",
        value: 9,
        tokenType: "alt",
        address: "0x9ba6a67a6f3b21705a46b380a1b97373a33da311",
        icon: null,
        usdValue: 572.4519379010516,
      },
      {
        id: "56",
        name: "DMS",
        value: 9,
        tokenType: "alt",
        address: "0x9a26e6d24df036b0b015016d1b55011c19e76c87",
        icon: null,
        usdValue: 199555.55339048378,
      },
      {
        id: "56",
        name: "PHA",
        value: 9,
        tokenType: "alt",
        address: "0x0112e557d400474717056C4e6D40eDD846F38351",
        icon: null,
        usdValue: 2198.6158064243837,
      },
      {
        id: "56",
        name: "DUSK",
        value: 9,
        tokenType: "alt",
        address: "0xb2bd0749dbe21f623d9baba856d3b0f0e1bfec9c",
        icon: null,
        usdValue: 4846.8372223737915,
      },
      {
        id: "56",
        name: "DF",
        value: 9,
        tokenType: "stable",
        address: "0x4A9A2b2b04549C3927dd2c9668A5eF3fCA473623",
        icon: null,
        usdValue: 41081.858802480005,
      },
      {
        id: "56",
        name: "PRQ",
        value: 9,
        tokenType: "alt",
        address: "0xd21d29b38374528675c34936bf7d5dd693d2a577",
        icon: null,
        usdValue: 7180.590124012069,
      },
      {
        id: "56",
        name: "MATH",
        value: 9,
        tokenType: "alt",
        address: "0xf218184af829cf2b0019f8e6f0b2423498a36983",
        icon: null,
        usdValue: 1920.648902777808,
      },
      {
        id: "56",
        name: "MOOV",
        value: 9,
        tokenType: "alt",
        address: "0x0ebd9537a25f56713e34c45b38f421a1e7191469",
        icon: null,
        usdValue: 1546.2674741091691,
      },
      {
        id: "56",
        name: "EPIK",
        value: 9,
        tokenType: "alt",
        address: "0x368ce786Ea190f32439074e8d22e12ecb718B44c",
        icon: null,
        usdValue: 17473.587400609842,
      },
      {
        id: "56",
        name: "UBXS",
        value: 9,
        tokenType: "alt",
        address: "0x4f1960e29b2ca581a38c5c474e123f420f8092db",
        icon: null,
        usdValue: 1861167.4445383279,
      },
      {
        id: "56",
        name: "STBU",
        value: 9,
        tokenType: "alt",
        address: "0xb0c4080a8Fa7afa11a09473f3be14d44AF3f8743",
        icon: null,
        usdValue: 853628.9730064003,
      },
      {
        id: "56",
        name: "BVT",
        value: 9,
        tokenType: "alt",
        address: "0x1DaCbcD9B3fc2d6A341Dca3634439D12bC71cA4d",
        icon: null,
        usdValue: 632569.2796543306,
      },
      {
        id: "56",
        name: "BSCS",
        value: 9,
        tokenType: "alt",
        address: "0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d",
        icon: null,
        usdValue: 364362.4076913984,
      },
      {
        id: "56",
        name: "MSWAP",
        value: 9,
        tokenType: "alt",
        address: "0xdd5a149740c055bdcdc5c066888f739dbe0bf2d0",
        icon: null,
        usdValue: 86379.89201045659,
      },
      {
        id: "56",
        name: "DREP",
        value: 9,
        tokenType: "alt",
        address: "0xec583f25a049cc145da9a256cdbe9b6201a705ff",
        icon: null,
        usdValue: 5103.286337457112,
      },
      {
        id: "56",
        name: "EZ",
        value: 9,
        tokenType: "alt",
        address: "0x5512014efa6Cd57764Fa743756F7a6Ce3358cC83",
        icon: null,
        usdValue: 300.40860512463075,
      },
      {
        id: "56",
        name: "MEPAD",
        value: 9,
        tokenType: "alt",
        address: "0x9d70a3ee3079a6fa2bb16591414678b7ad91f0b5",
        icon: null,
        usdValue: 173763.945288026,
      },
      {
        id: "56",
        name: "OPS",
        value: 9,
        tokenType: "alt",
        address: "0xdf0121a3ba5c10816ea2943c722650c4a4b0dbe6",
        icon: null,
        usdValue: 264947.8430192743,
      },
      {
        id: "56",
        name: "BETU",
        value: 9,
        tokenType: "alt",
        address: "0x0df1b3f30865c5b324797f8db9d339514cac4e94",
        icon: null,
        usdValue: 3347.0349435005583,
      },
      {
        id: "56",
        name: "EVRY",
        value: 9,
        tokenType: "alt",
        address: "0xC2d4A3709e076A7A3487816362994a78ddaeabB6",
        icon: null,
        usdValue: 419737.18111134565,
      },
      {
        id: "56",
        name: "XCV",
        value: 9,
        tokenType: "alt",
        address: "0x4be63a9b26ee89b9a3a13fd0aa1d0b2427c135f8",
        icon: null,
        usdValue: 133253.22934441952,
      },
      {
        id: "56",
        name: "SQUID",
        value: 9,
        tokenType: "alt",
        address: "0x87230146e138d3f296a9a77e497a2a83012e9bc5",
        icon: null,
        usdValue: 68483.92634590251,
      },
      {
        id: "56",
        name: "LBLOCK",
        value: 9,
        tokenType: "alt",
        address: "0x2cd96e8c3ff6b5e01169f6e3b61d28204e7810bb",
        icon: null,
        usdValue: 6713.782667797508,
      },
      {
        id: "56",
        name: "BRN",
        value: 9,
        tokenType: "alt",
        address: "0x926ecC7687fCFB296E97a2b4501F41A6f5F8C214",
        icon: null,
        usdValue: 1030491.9132645434,
      },
      {
        id: "56",
        name: "VTG",
        value: 9,
        tokenType: "alt",
        address: "0x8de5aa37a7c40a53062ead382b8eead3b08a7a46",
        icon: null,
        usdValue: 62988.33386792897,
      },
      {
        id: "56",
        name: "DEBT",
        value: 9,
        tokenType: "alt",
        address: "0xc632f90affec7121120275610bf17df9963f181c",
        icon: null,
        usdValue: 29107.896496181205,
      },
      {
        id: "56",
        name: "DRAC",
        value: 9,
        tokenType: "alt",
        address: "0x123458C167a371250d325Bd8B1ffF12C8AF692A7",
        icon: null,
        usdValue: 805.9184157755378,
      },
      {
        id: "56",
        name: "BBC",
        value: 9,
        tokenType: "alt",
        address: "0x37e5da11b6A4DC6d2f7Abe232cDd30B0B8Fc63B1",
        icon: null,
        usdValue: 182709.74434388347,
      },
      {
        id: "56",
        name: "PIAS",
        value: 9,
        tokenType: "alt",
        address: "0xC669A70e0B3D07e3514aFd97eBFb3D134077A4a1",
        icon: null,
        usdValue: 393467.0742487109,
      },
      {
        id: "56",
        name: "CHEEL",
        value: 9,
        tokenType: "alt",
        address: "0x1f1c90aeb2fd13ea972f0a71e35c0753848e3db0",
        icon: null,
        usdValue: 867887.3524925229,
      },
      {
        id: "56",
        name: "T23",
        value: 9,
        tokenType: "alt",
        address: "0x897f2be515373cf1f899d864b5be2bd5efd4e653",
        icon: null,
        usdValue: 379013.1184589481,
      },
      {
        id: "56",
        name: "DNXC",
        value: 9,
        tokenType: "alt",
        address: "0x3c1748d647e6a56b37b66fcd2b5626d0461d3aa0",
        icon: null,
        usdValue: 2250.4717567021758,
      },
      {
        id: "56",
        name: "GMPD",
        value: 9,
        tokenType: "alt",
        address: "0x9720CA160Bbd4E7f3dD4bb3f8BD4227ca0342e63",
        icon: null,
        usdValue: 207557.57773808797,
      },
      {
        id: "137",
        name: "STBU",
        value: 9,
        tokenType: "alt",
        address: "0xcf403036bc139d30080d2cf0f5b48066f98191bb",
        icon: null,
        usdValue: 1042768.8675203798,
      },
      {
        id: "1",
        name: "MIMO",
        value: 9,
        tokenType: "alt",
        address: "0x90b831fa3bebf58e9744a14d638e25b4ee06f9bc",
        icon: null,
        usdValue: 1282344.1765570224,
      },
      {
        id: "1",
        name: "EC",
        value: 9,
        tokenType: "alt",
        address: "0x12fd19dac0fab61bed5e0f09091b470c452d4d61",
        icon: null,
        usdValue: 40586.17094986493,
      },
      {
        id: "1",
        name: "AIPAD",
        value: 9,
        tokenType: "alt",
        address: "0xe55d97a97ae6a17706ee281486e98a84095d8aaf",
        icon: null,
        usdValue: 309287.6114279946,
      },
      {
        id: "1",
        name: "TRYB",
        value: 9,
        tokenType: "alt",
        address: "0x2c537e5624e4af88a7ae4060c022609376c8d0eb",
        icon: null,
        usdValue: 545048.444929619,
      },
      {
        id: "1",
        name: "TGT",
        value: 9,
        tokenType: "alt",
        address: "0x108a850856db3f85d0269a2693d896b394c80325",
        icon: null,
        usdValue: 556080.9188233787,
      },
      {
        id: "1",
        name: "CNG",
        value: 9,
        tokenType: "alt",
        address: "0x5C1d9aA868a30795F92fAe903eDc9eFF269044bf",
        icon: null,
        usdValue: 5327.975740176784,
      },
      {
        id: "1",
        name: "DRM",
        value: 9,
        tokenType: "alt",
        address: "0x89551b940e2a8ed8eccf509935bac9213fe30584",
        icon: null,
        usdValue: 9046.929932750958,
      },
      {
        id: "1",
        name: "ANV",
        value: 9,
        tokenType: "alt",
        address: "0x3D382228C54736d831FAC2748F4734D9177c7332",
        icon: null,
        usdValue: 9784.023664569024,
      },
      {
        id: "1",
        name: "ENTC",
        value: 9,
        tokenType: "alt",
        address: "0x3ecab35b64345bfc472477a653e4a3abe70532d9",
        icon: null,
        usdValue: 4669389.669810077,
      },
      {
        id: "1",
        name: "CEJI",
        value: 9,
        tokenType: "alt",
        address: "0x189fC141854BFc6146777406d53fbC89F4e70407",
        icon: null,
        usdValue: 18721.943677593423,
      },
      {
        id: "1",
        name: "MOH",
        value: 9,
        tokenType: "alt",
        address: "0xa59e341e8047498700ed244814b01b34547fb21b",
        icon: null,
        usdValue: 33519.13654151818,
      },
      {
        id: "1",
        name: "ZENI",
        value: 9,
        tokenType: "alt",
        address: "0x9c6666d5ff4B53b5eB3bd866664c15d0BFcECaa7",
        icon: null,
        usdValue: 87790.3685864294,
      },
      {
        id: "1",
        name: "DTA",
        value: 9,
        tokenType: "alt",
        address: "0x69b148395ce0015c13e36bffbad63f49ef874e03",
        icon: null,
        usdValue: 1560.0217566852853,
      },
      {
        id: "1",
        name: "MTC",
        value: 9,
        tokenType: "alt",
        address: "0x905E337c6c8645263D3521205Aa37bf4d034e745",
        icon: null,
        usdValue: 333746.8884858813,
      },
      {
        id: "56",
        name: "BCT",
        value: 9,
        tokenType: "alt",
        address: "0xf6d2657EBb5602bF823901412c5e41e030f3ece2",
        icon: null,
        usdValue: 44.88799999999999,
      },
      {
        id: "1",
        name: "DPX",
        value: 9,
        tokenType: "alt",
        address: "0xeec2be5c91ae7f8a338e1e5f3b5de49d07afdc81",
        icon: null,
        usdValue: 210.29419684763138,
      },
      {
        id: "1",
        name: "DINGER",
        value: 8,
        tokenType: "alt",
        address: "0x9e5bd9d9fad182ff0a93ba8085b664bcab00fa68",
        icon: null,
        usdValue: 474.5479278142306,
      },
      {
        id: "1",
        name: "ATMI",
        value: 8,
        tokenType: "alt",
        address: "0x97aeb5066e1a590e868b511457beb6fe99d329f5",
        icon: null,
        usdValue: 20.0025678125,
      },
      {
        id: "42161",
        name: "GRT",
        value: 8,
        tokenType: "alt",
        address: "0x23a941036ae778ac51ab04cea08ed6e2fe103614",
        icon: null,
        usdValue: 280.559610452832,
      },
      {
        id: "1",
        name: "F9",
        value: 8,
        tokenType: "alt",
        address: "0x38a94e92a19e970c144ded0b2dd47278ca11cc1f",
        icon: null,
        usdValue: 6207.388640206482,
      },
      {
        id: "1",
        name: "XFUND",
        value: 8,
        tokenType: "alt",
        address: "0x892a6f9df0147e5f079b0993f486f9aca3c87881",
        icon: null,
        usdValue: 4918.984516038291,
      },
      {
        id: "1",
        name: "UNIDX",
        value: 8,
        tokenType: "alt",
        address: "0x95b3497bbcccc46a8f45f5cf54b0878b39f8d96c",
        icon: null,
        usdValue: 9511.199239341411,
      },
      {
        id: "137",
        name: "RVLT",
        value: 8,
        tokenType: "alt",
        address: "0xf0f9D895aCa5c8678f706FB8216fa22957685A13",
        icon: null,
        usdValue: 281.4279179627012,
      },
      {
        id: "137",
        name: "QI",
        value: 8,
        tokenType: "alt",
        address: "0x580a84c73811e1839f75d86d75d88cca0c241ff4",
        icon: null,
        usdValue: 408.89843018961386,
      },
      {
        id: "1",
        name: "MEM",
        value: 8,
        tokenType: "alt",
        address: "0x42dbbd5ae373fea2fc320f62d44c058522bb3758",
        icon: null,
        usdValue: 621.5219667857656,
      },
      {
        id: "137",
        name: "GOB",
        value: 8,
        tokenType: "alt",
        address: "0x16d63619Cd67B15Ff822bFeB60388a226D2e452b",
        icon: null,
        usdValue: 78.99689021831023,
      },
      {
        id: "1",
        name: "MAGE",
        value: 8,
        tokenType: "alt",
        address: "0xd52aae39a2b5cc7812f7b9450ebb61dfef702b15",
        icon: null,
        usdValue: 76.17111167516687,
      },
      {
        id: "1",
        name: "DBI",
        value: 8,
        tokenType: "alt",
        address: "0x2de509bf0014ddf697b220be628213034d320ece",
        icon: null,
        usdValue: 14798.770038173852,
      },
      {
        id: "56",
        name: "VRT",
        value: 8,
        tokenType: "alt",
        address: "0x5f84ce30dc3cf7909101c69086c50de191895883",
        icon: null,
        usdValue: 89877.42675261211,
      },
      {
        id: "56",
        name: "LEV",
        value: 8,
        tokenType: "alt",
        address: "0xbc194e6f748a222754c3e8b9946922c09e7d4e91",
        icon: null,
        usdValue: 58360.90710096522,
      },
      {
        id: "56",
        name: "DLTA",
        value: 8,
        tokenType: "alt",
        address: "0x3a06212763caf64bf101daa4b0cebb0cd393fa1a",
        icon: null,
        usdValue: 854.2600983017437,
      },
      {
        id: "56",
        name: "CTR",
        value: 8,
        tokenType: "alt",
        address: "0xd6cce248263ea1e2b8cb765178c944fc16ed0727",
        icon: null,
        usdValue: 16521.02329238154,
      },
      {
        id: "56",
        name: "CHIM",
        value: 8,
        tokenType: "alt",
        address: "0x3544a07e9f771ef0f6c80c6e79715869ed291086",
        icon: null,
        usdValue: 513.9102529703115,
      },
      {
        id: "42161",
        name: "PRY",
        value: 8,
        tokenType: "alt",
        address: "0x1824a51C106EFC27d35A74efB56d9BF54dDb22d4",
        icon: null,
        usdValue: 87927.49711066837,
      },
      {
        id: "56",
        name: "INVEST",
        value: 8,
        tokenType: "alt",
        address: "0x853a8ab1c365ea54719eb13a54d6b22f1fbe7feb",
        icon: null,
        usdValue: 474.269764186705,
      },
      {
        id: "56",
        name: "XIL",
        value: 8,
        tokenType: "alt",
        address: "0xf3be1a4a47576208c1592cc027087ce154b00672",
        icon: null,
        usdValue: 171680.6375314645,
      },
      {
        id: "56",
        name: "HOL",
        value: 8,
        tokenType: "alt",
        address: "0xa797fa4bda7c5a4b3afe73573b9d2ab942365c6f",
        icon: null,
        usdValue: 2382.3793394338404,
      },
      {
        id: "56",
        name: "LGO",
        value: 8,
        tokenType: "alt",
        address: "0xBe2B6C5E31F292009f495DDBda88e28391C9815E",
        icon: null,
        usdValue: 355.38777805444,
      },
      {
        id: "137",
        name: "axlUSDC",
        value: 8,
        tokenType: "alt",
        address: "0x750e4C4984a9e0f12978eA6742Bc1c5D248f40ed",
        icon: null,
        usdValue: 178.97305780079998,
      },
      {
        id: "56",
        name: "APC",
        value: 8,
        tokenType: "alt",
        address: "0x2aa504586d6cab3c59fa629f74c586d78b93a025",
        icon: null,
        usdValue: 0.047418748206624096,
      },
      {
        id: "137",
        name: "SUSHI",
        value: 8,
        tokenType: "alt",
        address: "0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a",
        icon: null,
        usdValue: 2447.954136201927,
      },
      {
        id: "56",
        name: "SUTER",
        value: 8,
        tokenType: "alt",
        address: "0x4cfbbdfbd5bf0814472ff35c72717bd095ada055",
        icon: null,
        usdValue: 103.65635703666565,
      },
      {
        id: "1",
        name: "EXD",
        value: 8,
        tokenType: "alt",
        address: "0x02de007d412266a2e0fa9287c103474170f06560",
        icon: null,
        usdValue: 1226172.7196246528,
      },
      {
        id: "1",
        name: "SURE",
        value: 8,
        tokenType: "alt",
        address: "0xcb86c6a22cb56b6cf40cafedb06ba0df188a416e",
        icon: null,
        usdValue: 6653.619135425908,
      },
      {
        id: "1",
        name: "EMAX",
        value: 8,
        tokenType: "alt",
        address: "0x15874d65e649880c2614e7a480cb7c9a55787ff6",
        icon: null,
        usdValue: 1524.213198359918,
      },
      {
        id: "1",
        name: "BITE",
        value: 8,
        tokenType: "alt",
        address: "0x34103e1190b824a44c6a638438d425cba21143ba",
        icon: null,
        usdValue: 83.96471094215545,
      },
      {
        id: "1",
        name: "FREL",
        value: 8,
        tokenType: "alt",
        address: "0x29CeDDCF0Da3c1D8068a7DFbD0FB06c2E438FF70",
        icon: null,
        usdValue: 360.68787397323575,
      },
      {
        id: "1",
        name: "PTF",
        value: 8,
        tokenType: "alt",
        address: "0xC57d533c50bC22247d49a368880fb49a1caA39F7",
        icon: null,
        usdValue: 18965.354135149326,
      },
      {
        id: "1",
        name: "UGT",
        value: 8,
        tokenType: "alt",
        address: "0x9cf98eb8a8b28c83e8612046cf55701ce3eb0063",
        icon: null,
        usdValue: 168.99481279830044,
      },
      {
        id: "56",
        name: "STACK",
        value: 8,
        tokenType: "alt",
        address: "0x6855f7bb6287f94ddcc8915e37e73a3c9fee5cf3",
        icon: null,
        usdValue: 18919.88645225367,
      },
      {
        id: "56",
        name: "BGS",
        value: 8,
        tokenType: "alt",
        address: "0xf339e8c294046e6e7ef6ad4f6fa9e202b59b556b",
        icon: null,
        usdValue: 142.4117210931,
      },
      {
        id: "1",
        name: "TSX",
        value: 8,
        tokenType: "alt",
        address: "0x734c90044a0ba31b3f2e640c10dc5d3540499bfd",
        icon: null,
        usdValue: 1970.4702060041245,
      },
      {
        id: "56",
        name: "HERA",
        value: 8,
        tokenType: "alt",
        address: "0x49C7295ff86EaBf5bf58C6eBC858DB4805738c01",
        icon: null,
        usdValue: 270576.92756887607,
      },
      {
        id: "56",
        name: "XPRESS",
        value: 8,
        tokenType: "alt",
        address: "0xaa9826732f3a4973ff8b384b3f4e3c70c2984651",
        icon: null,
        usdValue: 238965.46858450983,
      },
      {
        id: "56",
        name: "MOO",
        value: 8,
        tokenType: "alt",
        address: "0xA29b6f4E762874846c081E20ed1142FF83faaFEF",
        icon: null,
        usdValue: 47450.84389487315,
      },
      {
        id: "1",
        name: "UTU",
        value: 8,
        tokenType: "alt",
        address: "0xa58a4f5c4bb043d2cc1e170613b74e767c94189b",
        icon: null,
        usdValue: 1532.6640091740583,
      },
      {
        id: "1",
        name: "OIL",
        value: 8,
        tokenType: "alt",
        address: "0x0275E1001e293C46CFe158B3702AADe0B99f88a5",
        icon: null,
        usdValue: 199.82475116720204,
      },
      {
        id: "42161",
        name: "ELK",
        value: 8,
        tokenType: "alt",
        address: "0xeeeeeb57642040be42185f49c52f7e9b38f8eeee",
        icon: null,
        usdValue: 0.007349488779777008,
      },
      {
        id: "1",
        name: "DFIAT",
        value: 8,
        tokenType: "alt",
        address: "0x1045F5cCb01DAEA4f8eaB055F5FcBB7C0E7c89F0",
        icon: null,
        usdValue: 9528.630216768088,
      },
      {
        id: "56",
        name: "MYRA",
        value: 8,
        tokenType: "alt",
        address: "0x6ef238e9e8cd2a96740897761c18894fc086b9d0",
        icon: null,
        usdValue: 90232.12004725604,
      },
      {
        id: "1",
        name: "BFLY",
        value: 8,
        tokenType: "alt",
        address: "0xf680429328caaacabee69b7a9fdb21a71419c063",
        icon: null,
        usdValue: 10845.313714891892,
      },
      {
        id: "1",
        name: "RETH2",
        value: 8,
        tokenType: "alt",
        address: "0x20bc832ca081b91433ff6c17f85701b6e92486c5",
        icon: null,
        usdValue: 207.031438604814,
      },
      {
        id: "1",
        name: "TRL",
        value: 8,
        tokenType: "alt",
        address: "0x58f9102bf53cf186682bd9a281d3cd3c616eec41",
        icon: null,
        usdValue: 17790.106022258646,
      },
      {
        id: "56",
        name: "KT",
        value: 8,
        tokenType: "alt",
        address: "0x52da44b5e584f730005dac8d2d2acbdee44d4ba3",
        icon: null,
        usdValue: 233681.66740755984,
      },
      {
        id: "56",
        name: "BORING",
        value: 8,
        tokenType: "alt",
        address: "0xffeecbf8d7267757c2dc3d13d730e97e15bfdf7f",
        icon: null,
        usdValue: 31.00506156957959,
      },
      {
        id: "56",
        name: "ROSN",
        value: 8,
        tokenType: "alt",
        address: "0x651Cd665bD558175A956fb3D72206eA08Eb3dF5b",
        icon: null,
        usdValue: 17690.41170505833,
      },
      {
        id: "56",
        name: "BLOCK",
        value: 8,
        tokenType: "alt",
        address: "0xbc7a566b85ef73f935e640a06b5a8b031cd975df",
        icon: null,
        usdValue: 6277415.464092493,
      },
      {
        id: "56",
        name: "CARBON",
        value: 8,
        tokenType: "alt",
        address: "0x793cEa0F1003411396b3A81A77d92Fe37015E7A9",
        icon: null,
        usdValue: 6204348.993795655,
      },
      {
        id: "56",
        name: "POG",
        value: 8,
        tokenType: "alt",
        address: "0xFCb0f2D2f83a32A847D8ABb183B724C214CD7dD8",
        icon: null,
        usdValue: 78768.32917336244,
      },
      {
        id: "56",
        name: "F2C",
        value: 8,
        tokenType: "alt",
        address: "0x657b632714e08ac66b79444ad3f3875526ee6689",
        icon: null,
        usdValue: 102043.53508990874,
      },
      {
        id: "137",
        name: "MHUNT",
        value: 8,
        tokenType: "alt",
        address: "0x61f95bd637e3034133335C1baA0148E518D438ad",
        icon: null,
        usdValue: 32957.18417058232,
      },
      {
        id: "56",
        name: "BNBx",
        value: 8,
        tokenType: "alt",
        address: "0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275",
        icon: null,
        usdValue: 251.2197674644073,
      },
      {
        id: "1",
        name: "QUARTZ",
        value: 8,
        tokenType: "alt",
        address: "0xba8a621b4a54e61c442f5ec623687e2a942225ef",
        icon: null,
        usdValue: 22296.132517277376,
      },
      {
        id: "56",
        name: "PNL",
        value: 8,
        tokenType: "alt",
        address: "0xb346c52874c7023df183068c39478c3b7b2515bc",
        icon: null,
        usdValue: 103836.30466487372,
      },
      {
        id: "56",
        name: "VMT",
        value: 8,
        tokenType: "alt",
        address: "0xE615C5e7219f9801C3b75bc76E45a4dab3c38e51",
        icon: null,
        usdValue: 58955.60179046768,
      },
      {
        id: "56",
        name: "GST",
        value: 8,
        tokenType: "alt",
        address: "0x4a2c860cEC6471b9F5F5a336eB4F38bb21683c98",
        icon: null,
        usdValue: 772837.2226151292,
      },
      {
        id: "56",
        name: "DFY",
        value: 8,
        tokenType: "alt",
        address: "0xd98560689c6e748dc37bc410b4d3096b1aa3d8c2",
        icon: null,
        usdValue: 148571.72278029495,
      },
      {
        id: "56",
        name: "HORD",
        value: 8,
        tokenType: "alt",
        address: "0x39d4549908e7adcee9b439429294eeb4c65c2c9e",
        icon: null,
        usdValue: 53.55615502978943,
      },
      {
        id: "56",
        name: "PWAR",
        value: 8,
        tokenType: "alt",
        address: "0x16153214e683018d5aa318864c8e692b66e16778",
        icon: null,
        usdValue: 208876.60584473627,
      },
      {
        id: "56",
        name: "ZEUM",
        value: 8,
        tokenType: "alt",
        address: "0x482e6bd0a178f985818c5dfb9ac77918e8412fba",
        icon: null,
        usdValue: 951.0448324956891,
      },
      {
        id: "1",
        name: "ANRX",
        value: 8,
        tokenType: "alt",
        address: "0xcae72a7a0fd9046cf6b165ca54c9e3a3872109e0",
        icon: null,
        usdValue: 927.0637941956787,
      },
      {
        id: "56",
        name: "TOOLS",
        value: 8,
        tokenType: "alt",
        address: "0x1311b352467d2b5c296881badea82850bcd8f886",
        icon: null,
        usdValue: 99111.85750589576,
      },
      {
        id: "56",
        name: "BRY",
        value: 8,
        tokenType: "alt",
        address: "0xf859bf77cbe8699013d6dbc7c2b926aaf307f830",
        icon: null,
        usdValue: 111986.21895864846,
      },
      {
        id: "56",
        name: "BLP",
        value: 8,
        tokenType: "alt",
        address: "0xfe1d7f7a8f0bda6e415593a2e4f82c64b446d404",
        icon: null,
        usdValue: 527.9884867571503,
      },
      {
        id: "137",
        name: "SWAY",
        value: 8,
        tokenType: "alt",
        address: "0x262b8aa7542004f023b0eb02bc6b96350a02b728",
        icon: null,
        usdValue: 156175.64865846693,
      },
      {
        id: "42161",
        name: "DOG",
        value: 8,
        tokenType: "alt",
        address: "0x4425742f1ec8d98779690b5a3a6276db85ddc01a",
        icon: null,
        usdValue: 978.1283907670813,
      },
      {
        id: "56",
        name: "PLUTO",
        value: 8,
        tokenType: "alt",
        address: "0x219fb136944d6fa707da40d0f54fac1a4ed04654",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "Cake-LP",
        value: 8,
        tokenType: "alt",
        address: "0xa1a1a15526c510fa60dc56812a269d0e82d6b596",
        icon: null,
        usdValue: 0.025396169578125648,
      },
      {
        id: "42161",
        name: "AIEN",
        value: 8,
        tokenType: "alt",
        address: "0x0d8f04522c5792c7378e39c92ab348f315f4fc4f",
        icon: null,
        usdValue: 16836.089066894117,
      },
      {
        id: "56",
        name: "QMALL",
        value: 8,
        tokenType: "alt",
        address: "0x07e551e31a793e20dc18494ff6b03095a8f8ee36",
        icon: null,
        usdValue: 831955.1524221835,
      },
      {
        id: "56",
        name: "SPS",
        value: 8,
        tokenType: "alt",
        address: "0x1633b7157e7638c4d6593436111bf125ee74703f",
        icon: null,
        usdValue: 681665.5253576424,
      },
      {
        id: "56",
        name: "WKC",
        value: 8,
        tokenType: "alt",
        address: "0x6ec90334d89dbdc89e08a133271be3d104128edb",
        icon: null,
        usdValue: 459995.3108024579,
      },
      {
        id: "56",
        name: "MINT",
        value: 8,
        tokenType: "alt",
        address: "0x1f3af095cda17d63cad238358837321e95fc5915",
        icon: null,
        usdValue: 297531.31362335756,
      },
      {
        id: "56",
        name: "VLXPAD",
        value: 8,
        tokenType: "alt",
        address: "0xb8e3bB633F7276cc17735D86154E0ad5ec9928C0",
        icon: null,
        usdValue: 30167.629004589424,
      },
      {
        id: "137",
        name: "SMT",
        value: 8,
        tokenType: "alt",
        address: "0xE631DABeF60c37a37d70d3B4f812871df663226f",
        icon: null,
        usdValue: 1597.399919442866,
      },
      {
        id: "137",
        name: "AVAX",
        value: 8,
        tokenType: "alt",
        address: "0x2C89bbc92BD86F8075d1DEcc58C7F4E0107f286b",
        icon: null,
        usdValue: 3218.394269710447,
      },
      {
        id: "42161",
        name: "BFR",
        value: 8,
        tokenType: "alt",
        address: "0x1A5B0aaF478bf1FDA7b934c76E7692D722982a6D",
        icon: null,
        usdValue: 154778.776369864,
      },
      {
        id: "137",
        name: "UFO",
        value: 8,
        tokenType: "alt",
        address: "0x57194feaca970A4E98A19C365FE144fB54F657DB",
        icon: null,
        usdValue: 1564.8101958543114,
      },
      {
        id: "56",
        name: "KAI",
        value: 8,
        tokenType: "alt",
        address: "0x39ae8eefb05138f418bb27659c21632dc1ddab10",
        icon: null,
        usdValue: 412.6701371030973,
      },
      {
        id: "56",
        name: "NAFT",
        value: 8,
        tokenType: "alt",
        address: "0xd7730681b1dc8f6f969166b29d8a5ea8568616a3",
        icon: null,
        usdValue: 410498.3315022715,
      },
      {
        id: "137",
        name: "CRETA",
        value: 8,
        tokenType: "alt",
        address: "0x202655af326de310491cb54f120e02ee0da92b55",
        icon: null,
        usdValue: 6058442.744292879,
      },
      {
        id: "1",
        name: "FT",
        value: 8,
        tokenType: "alt",
        address: "0x8b70c94f3471ca83dddb048f20ed64470e4c107e",
        icon: null,
        usdValue: 1746918.9215521463,
      },
      {
        id: "56",
        name: "HALO",
        value: 8,
        tokenType: "alt",
        address: "0xB6b8CCD230Bb4235C7b87986274E7aB550b72261",
        icon: null,
        usdValue: 183730.68420870032,
      },
      {
        id: "1",
        name: "MNY",
        value: 8,
        tokenType: "alt",
        address: "0xa6f7645ed967faf708a614a2fca8d4790138586f",
        icon: null,
        usdValue: 979.3029762607101,
      },
      {
        id: "1",
        name: "MOT",
        value: 8,
        tokenType: "alt",
        address: "0x1E02cdbbA6729B6470de81Ad4D2cCA4c514521b9",
        icon: null,
        usdValue: 1338.8279270161356,
      },
      {
        id: "1",
        name: "IHT",
        value: 8,
        tokenType: "alt",
        address: "0xEda8B016efA8b1161208Cf041cD86972eeE0F31E",
        icon: null,
        usdValue: 32603.762992722182,
      },
      {
        id: "1",
        name: "BMEX",
        value: 8,
        tokenType: "alt",
        address: "0xb113c6cf239f60d380359b762e95c13817275277",
        icon: null,
        usdValue: 803901.2439526118,
      },
      {
        id: "1",
        name: "TPT",
        value: 8,
        tokenType: "alt",
        address: "0x4161725d019690a3e0de50f6be67b07a86a9fae1",
        icon: null,
        usdValue: 5507.24127464271,
      },
      {
        id: "1",
        name: "VITE",
        value: 8,
        tokenType: "alt",
        address: "0x1b793E49237758dBD8b752AFC9Eb4b329d5Da016",
        icon: null,
        usdValue: 552.1761299393995,
      },
      {
        id: "1",
        name: "EGG",
        value: 8,
        tokenType: "alt",
        address: "0x65ccd72c0813ce6f2703593b633202a0f3ca6a0c",
        icon: null,
        usdValue: 183038.369102323,
      },
      {
        id: "1",
        name: "LYM",
        value: 8,
        tokenType: "alt",
        address: "0x57ad67acf9bf015e4820fbd66ea1a21bed8852ec",
        icon: null,
        usdValue: 94851.54785061901,
      },
      {
        id: "1",
        name: "FTI",
        value: 8,
        tokenType: "alt",
        address: "0x943ed852dadb5c3938ecdc6883718df8142de4c8",
        icon: null,
        usdValue: 6931.431375945884,
      },
      {
        id: "1",
        name: "MCG",
        value: 8,
        tokenType: "alt",
        address: "0x9ccf191169a613eca433a249d3f40131178caebc",
        icon: null,
        usdValue: 4058670.5069820425,
      },
      {
        id: "1",
        name: "HPT",
        value: 8,
        tokenType: "alt",
        address: "0xa66daa57432024023db65477ba87d4e7f5f95213",
        icon: null,
        usdValue: 110004.06500006448,
      },
      {
        id: "1",
        name: "KGC",
        value: 8,
        tokenType: "alt",
        address: "0xa8262Eb913FccEa4C3f77fc95b8b4043B384cFbB",
        icon: null,
        usdValue: 150240.26991702264,
      },
      {
        id: "1",
        name: "DVP",
        value: 8,
        tokenType: "alt",
        address: "0x8e30ea2329d95802fd804f4291220b0e2f579812",
        icon: null,
        usdValue: 141533.75605562972,
      },
      {
        id: "1",
        name: "CRBN",
        value: 8,
        tokenType: "alt",
        address: "0xCdeee767beD58c5325f68500115d4B722b3724EE",
        icon: null,
        usdValue: 70051.62399674121,
      },
      {
        id: "1",
        name: "PHM",
        value: 8,
        tokenType: "alt",
        address: "0x3f9bec82c776c47405bcb38070d2395fd18f89d3",
        icon: null,
        usdValue: 76703.71022703897,
      },
      {
        id: "1",
        name: "MINE",
        value: 8,
        tokenType: "alt",
        address: "0xb7DE92bE975ccb27e7352a1D47512aCBdb0BaC32",
        icon: null,
        usdValue: 199530.13063191745,
      },
      {
        id: "1",
        name: "SMTX",
        value: 8,
        tokenType: "alt",
        address: "0x102203517ce35AC5Cab9a2cda80DF03f26c7419b",
        icon: null,
        usdValue: 116.3811890946938,
      },
      {
        id: "1",
        name: "DAISY",
        value: 8,
        tokenType: "alt",
        address: "0x40955d77f87123b71b145098358a60573ac7be96",
        icon: null,
        usdValue: 5013.789033380891,
      },
      {
        id: "1",
        name: "SATT",
        value: 8,
        tokenType: "alt",
        address: "0xdf49c9f599a0a9049d97cff34d0c30e468987389",
        icon: null,
        usdValue: 20004.734479782408,
      },
      {
        id: "1",
        name: "YOUC",
        value: 8,
        tokenType: "alt",
        address: "0x3d371413dd5489f3a04c07c0c2ce369c20986ceb",
        icon: null,
        usdValue: 7478.909403286793,
      },
      {
        id: "1",
        name: "TFS",
        value: 8,
        tokenType: "alt",
        address: "0xc2A81eb482cB4677136D8812cC6Db6E0cB580883",
        icon: null,
        usdValue: 501.03677729765343,
      },
      {
        id: "1",
        name: "TFBX",
        value: 8,
        tokenType: "alt",
        address: "0x4057db5bd9f67a566aa10e5587b1a964affc6a16",
        icon: null,
        usdValue: 114811.4281981134,
      },
      {
        id: "1",
        name: "IDYP",
        value: 8,
        tokenType: "alt",
        address: "0xbd100d061e120b2c67a24453cf6368e63f1be056",
        icon: null,
        usdValue: 297.0083442625181,
      },
      {
        id: "1",
        name: "ACRIA",
        value: 8,
        tokenType: "alt",
        address: "0x44f5909e97e1cbf5fbbdf0fc92fd83cde5d5c58a",
        icon: null,
        usdValue: 58432.96298836447,
      },
      {
        id: "1",
        name: "SOFI",
        value: 8,
        tokenType: "alt",
        address: "0xb49fa25978abf9a248b8212ab4b87277682301c0",
        icon: null,
        usdValue: 191156.68269647277,
      },
      {
        id: "1",
        name: "UBSN",
        value: 8,
        tokenType: "alt",
        address: "0x86EFc496DcA70bcFD92D19194290e8457a375773",
        icon: null,
        usdValue: 202147.73201748,
      },
      {
        id: "1",
        name: "MVD",
        value: 8,
        tokenType: "alt",
        address: "0x788B6D2B37Aa51D916F2837Ae25b05f0e61339d1",
        icon: null,
        usdValue: 12541.385333177579,
      },
      {
        id: "1",
        name: "DTX",
        value: 8,
        tokenType: "alt",
        address: "0x765f0c16d1ddc279295c1a7c24b0883f62d33f75",
        icon: null,
        usdValue: 14168.518487904856,
      },
      {
        id: "1",
        name: "AC",
        value: 8,
        tokenType: "alt",
        address: "0x9A0aBA393aac4dFbFf4333B06c407458002C6183",
        icon: null,
        usdValue: 14518.036901865808,
      },
      {
        id: "1",
        name: "HANDY",
        value: 8,
        tokenType: "alt",
        address: "0x8bbe1a2961B41340468D0548c2cd5B7DFA9b684c",
        icon: null,
        usdValue: 666856.8789031055,
      },
      {
        id: "1",
        name: "ARW",
        value: 8,
        tokenType: "alt",
        address: "0x351caa9045d65107b9d311d922d15887cfd634e4",
        icon: null,
        usdValue: 19142.84994936438,
      },
      {
        id: "1",
        name: "INVI",
        value: 8,
        tokenType: "alt",
        address: "0x356a5160f2b34bc8d88fb084745465ebbbed0174",
        icon: null,
        usdValue: 19396492.12829794,
      },
      {
        id: "1",
        name: "DODI",
        value: 8,
        tokenType: "alt",
        address: "0x4e08f03079c5cd3083ea331ec61bcc87538b7665",
        icon: null,
        usdValue: 54532.05846725768,
      },
      {
        id: "1",
        name: "TORG",
        value: 8,
        tokenType: "alt",
        address: "0xcfa0885131f602d11d4da248d2c65a62063567a9",
        icon: null,
        usdValue: 15240.085615247623,
      },
      {
        id: "1",
        name: "SHIRYO-INU",
        value: 8,
        tokenType: "alt",
        address: "0x1E2F15302B90EddE696593607b6bD444B64e8F02",
        icon: null,
        usdValue: 151618.10606002563,
      },
      {
        id: "1",
        name: "CPU",
        value: 8,
        tokenType: "alt",
        address: "0x6d52dfefb16bb9cdc78bfca09061e44574886626",
        icon: null,
        usdValue: 465293.09488725784,
      },
      {
        id: "1",
        name: "NEPT",
        value: 8,
        tokenType: "alt",
        address: "0x355a824bea1adc22733978a3748271e1bbb34130",
        icon: null,
        usdValue: 27807.98938481574,
      },
      {
        id: "1",
        name: "ELAN",
        value: 8,
        tokenType: "alt",
        address: "0x1b5036bec1b82d44d52fa953a370b3c6cd9328b5",
        icon: null,
        usdValue: 203947.61284584322,
      },
      {
        id: "1",
        name: "ALLIN",
        value: 8,
        tokenType: "alt",
        address: "0x9B2b931d6AB97B6A887b2C5d8529537E6FE73Ebe",
        icon: null,
        usdValue: 516887.72256217443,
      },
      {
        id: "1",
        name: "AX",
        value: 8,
        tokenType: "alt",
        address: "0xCB0D82f4DFA503C9e3b8Abc7A3Caa01175b2dA39",
        icon: null,
        usdValue: 142827.40457537517,
      },
      {
        id: "1",
        name: "MUSK",
        value: 8,
        tokenType: "alt",
        address: "0x719e7f0daDFdeA25B78595da944F44d15d7E6795",
        icon: null,
        usdValue: 162620.29534546277,
      },
      {
        id: "1",
        name: "RUG",
        value: 8,
        tokenType: "alt",
        address: "0xDD782657af86492771BdB369CaEB8c246bE362f5",
        icon: null,
        usdValue: 4347.736199145078,
      },
      {
        id: "1",
        name: "SOON",
        value: 8,
        tokenType: "alt",
        address: "0x574D22E2555cAc0ce71e44778f6De2e7487aE229",
        icon: null,
        usdValue: 5424225.538442411,
      },
      {
        id: "1",
        name: "DAPPT",
        value: 8,
        tokenType: "alt",
        address: "0x96184d9c811ea0624fc30c80233b1d749b9e485b",
        icon: null,
        usdValue: 17558.980869954565,
      },
      {
        id: "1",
        name: "SSP",
        value: 8,
        tokenType: "alt",
        address: "0x624d520bab2e4ad83935fa503fb130614374e850",
        icon: null,
        usdValue: 80272.61542250557,
      },
      {
        id: "1",
        name: "MTD",
        value: 8,
        tokenType: "alt",
        address: "0x809e130e10e787139c54e1d12d3d1971b7a675bf",
        icon: null,
        usdValue: 280216.43505946826,
      },
      {
        id: "1",
        name: "CIND",
        value: 8,
        tokenType: "alt",
        address: "0xac0968a3e2020ac8ca83e60ccf69081ebc6d3bc3",
        icon: null,
        usdValue: 474575.05392568867,
      },
      {
        id: "1",
        name: "PLY",
        value: 8,
        tokenType: "alt",
        address: "0x1ab43204a195a0fd37edec621482afd3792ef90b",
        icon: null,
        usdValue: 195398.51619845146,
      },
      {
        id: "1",
        name: "SHIH",
        value: 8,
        tokenType: "alt",
        address: "0x841fb148863454a3b3570f515414759be9091465",
        icon: null,
        usdValue: 132546.3161823907,
      },
      {
        id: "1",
        name: "SX",
        value: 8,
        tokenType: "alt",
        address: "0x99fe3b1391503a1bc1788051347a1324bff41452",
        icon: null,
        usdValue: 127198.14646962783,
      },
      {
        id: "56",
        name: "BIDR",
        value: 8,
        tokenType: "alt",
        address: "0x9a2f5556e9a637e8fbce886d8e3cf8b316a1d8a2",
        icon: null,
        usdValue: 1744.5131868248022,
      },
      {
        id: "1",
        name: "TKING",
        value: 8,
        tokenType: "alt",
        address: "0x24e89bdf2f65326b94e36978a7edeac63623dafa",
        icon: null,
        usdValue: 4286.5927627238025,
      },
      {
        id: "137",
        name: "USD0 [www.usual.finance]",
        value: 8,
        tokenType: "alt",
        address: "0x0a5333a1ef20dc556682af804dd41758e04ff959",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Fyde Points (Claim: www.fyde.cc)",
        value: 8,
        tokenType: "alt",
        address: "0xb524ee3436c8cdc305181b7e6a00a2c911ee80b4",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "RYOSHI",
        value: 7,
        tokenType: "alt",
        address: "0x777E2ae845272a2F540ebf6a3D03734A5a8f618e",
        icon: null,
        usdValue: 5189.393016426377,
      },
      {
        id: "1",
        name: "BIOS",
        value: 7,
        tokenType: "alt",
        address: "0xAACa86B876ca011844b5798ECA7a67591A9743C8",
        icon: null,
        usdValue: 63.627470541620795,
      },
      {
        id: "1",
        name: "TEL",
        value: 7,
        tokenType: "alt",
        address: "0x85e076361cc813a908ff672f9bad1541474402b2",
        icon: null,
        usdValue: 3419.640027301,
      },
      {
        id: "137",
        name: "USD+",
        value: 7,
        tokenType: "stable",
        address: "0x236eeC6359fb44CCe8f97E99387aa7F8cd5cdE1f",
        icon: null,
        usdValue: 1447.3697610000002,
      },
      {
        id: "1",
        name: "ERSDL",
        value: 7,
        tokenType: "alt",
        address: "0x5218E472cFCFE0b64A064F055B43b4cdC9EfD3A6",
        icon: null,
        usdValue: 7853.790705073928,
      },
      {
        id: "56",
        name: "NFTFY",
        value: 7,
        tokenType: "alt",
        address: "0xbf6ff49ffd3d104302ef0ab0f10f5a84324c091c",
        icon: null,
        usdValue: 259.09806362523835,
      },
      {
        id: "137",
        name: "AGEUR",
        value: 7,
        tokenType: "stable",
        address: "0xe0b52e49357fd4daf2c15e02058dce6bc0057db4",
        icon: null,
        usdValue: 17.86878863042767,
      },
      {
        id: "42161",
        name: "BIFI",
        value: 7,
        tokenType: "alt",
        address: "0x99c409e5f62e4bd2ac142f17cafb6810b8f0baae",
        icon: null,
        usdValue: 1940.5881149807096,
      },
      {
        id: "137",
        name: "TEL",
        value: 7,
        tokenType: "alt",
        address: "0xdf7837de1f2fa4631d716cf2502f8b230f1dcc32",
        icon: null,
        usdValue: 1179045.8524623625,
      },
      {
        id: "137",
        name: "AXN",
        value: 7,
        tokenType: "alt",
        address: "0x839f1a22a59eaaf26c85958712ab32f80fea23d9",
        icon: null,
        usdValue: 560.3803380053704,
      },
      {
        id: "56",
        name: "CREAM",
        value: 7,
        tokenType: "alt",
        address: "0xd4cb328a82bdf5f03eb737f37fa6b370aef3e888",
        icon: null,
        usdValue: 83100.85828063305,
      },
      {
        id: "1",
        name: "DOLA",
        value: 7,
        tokenType: "stable",
        address: "0x865377367054516e17014ccded1e7d814edc9ce4",
        icon: null,
        usdValue: 418.700492097301,
      },
      {
        id: "1",
        name: "BLT",
        value: 7,
        tokenType: "alt",
        address: "0x107c4504cd79c5d2696ea0030a8dd4e92601b82e",
        icon: null,
        usdValue: 9479.718574065813,
      },
      {
        id: "56",
        name: "OPV",
        value: 7,
        tokenType: "alt",
        address: "0x36C7B164F85D6F775cD128966D5819c7d36FEfF3",
        icon: null,
        usdValue: 40374.09009658302,
      },
      {
        id: "56",
        name: "KAMPAY",
        value: 7,
        tokenType: "alt",
        address: "0x8E984e03ab35795C60242c902ECe2450242C90e9",
        icon: null,
        usdValue: 1262.1241028765876,
      },
      {
        id: "1",
        name: "EROWAN",
        value: 7,
        tokenType: "alt",
        address: "0x07bac35846e5ed502aa91adf6a9e7aa210f2dcbe",
        icon: null,
        usdValue: 28.267867330930123,
      },
      {
        id: "1",
        name: "MFG",
        value: 7,
        tokenType: "alt",
        address: "0x6710c63432a2de02954fc0f851db07146a6c0312",
        icon: null,
        usdValue: 6046.165297523426,
      },
      {
        id: "1",
        name: "OSQTH",
        value: 7,
        tokenType: "alt",
        address: "0xf1b99e3e573a1a9c5e6b2ce818b617f0e664e86b",
        icon: null,
        usdValue: 263.06478782986557,
      },
      {
        id: "56",
        name: "SCH",
        value: 7,
        tokenType: "alt",
        address: "0xe485b2780c3822a62da88857fd6481018ea8cb95",
        icon: null,
        usdValue: 40.935772294409986,
      },
      {
        id: "1",
        name: "JRT",
        value: 7,
        tokenType: "alt",
        address: "0x8a9c67fee641579deba04928c4bc45f66e26343a",
        icon: null,
        usdValue: 4629.423464917422,
      },
      {
        id: "1",
        name: "KEK",
        value: 7,
        tokenType: "alt",
        address: "0x67954768e721fad0f0f21e33e874497c73ed6a82",
        icon: null,
        usdValue: 1126.860738317402,
      },
      {
        id: "56",
        name: "HUSL",
        value: 7,
        tokenType: "alt",
        address: "0x284AC5aF363BDe6eF5296036aF8fb0e9Cc347B41",
        icon: null,
        usdValue: 6609.658309796957,
      },
      {
        id: "56",
        name: "BPLUS",
        value: 7,
        tokenType: "alt",
        address: "0x542312eca286c95a42495f9b7c89d3d2453e2b6a",
        icon: null,
        usdValue: 27.437844666329056,
      },
      {
        id: "56",
        name: "OATH",
        value: 7,
        tokenType: "alt",
        address: "0xd3c6ceedd1cc7bd4304f72b011d53441d631e662",
        icon: null,
        usdValue: 1201.2268316148215,
      },
      {
        id: "1",
        name: "YAE",
        value: 7,
        tokenType: "alt",
        address: "0x4ee438be38f8682abb089f2bfea48851c5e71eaf",
        icon: null,
        usdValue: 76.31710481738526,
      },
      {
        id: "1",
        name: "PUNK",
        value: 7,
        tokenType: "alt",
        address: "0x269616d549d7e8eaa82dfb17028d0b212d11232a",
        icon: null,
        usdValue: 9038.971200860271,
      },
      {
        id: "1",
        name: "RAINI",
        value: 7,
        tokenType: "alt",
        address: "0xeb953eda0dc65e3246f43dc8fa13f35623bdd5ed",
        icon: null,
        usdValue: 927.7340586790526,
      },
      {
        id: "56",
        name: "GMS",
        value: 7,
        tokenType: "alt",
        address: "0xDae3C2Cb0AC034a4A491B112D2922f12427201A6",
        icon: null,
        usdValue: 130.0129524332463,
      },
      {
        id: "1",
        name: "CLIQ",
        value: 7,
        tokenType: "alt",
        address: "0x0Def8d8addE14c9eF7c2a986dF3eA4Bd65826767",
        icon: null,
        usdValue: 40.86212086399669,
      },
      {
        id: "1",
        name: "BANCA",
        value: 7,
        tokenType: "alt",
        address: "0x998b3b82bc9dba173990be7afb772788b5acb8bd",
        icon: null,
        usdValue: 10227.540226341718,
      },
      {
        id: "56",
        name: "ASVA",
        value: 7,
        tokenType: "alt",
        address: "0xf7b6d7e3434cb9441982f9534e6998c43eef144a",
        icon: null,
        usdValue: 144.34992554130676,
      },
      {
        id: "56",
        name: "ALM",
        value: 7,
        tokenType: "alt",
        address: "0x7C38870e93A1f959cB6c533eB10bBc3e438AaC11",
        icon: null,
        usdValue: 254.80810257964276,
      },
      {
        id: "56",
        name: "KKT",
        value: 7,
        tokenType: "alt",
        address: "0xe64017bdacbe7dfc84886c3704a26d566e7550de",
        icon: null,
        usdValue: 1040.0333185790419,
      },
      {
        id: "1",
        name: "POL",
        value: 7,
        tokenType: "alt",
        address: "0xc17fbe1d709dDf6C0B6665Dd0591046815AC7554",
        icon: null,
        usdValue: 1417900.803756142,
      },
      {
        id: "56",
        name: "AI",
        value: 7,
        tokenType: "alt",
        address: "0xa9b038285f43cd6fe9e16b4c80b4b9bccd3c161b",
        icon: null,
        usdValue: 317.2148794045862,
      },
      {
        id: "1",
        name: "CNFI",
        value: 7,
        tokenType: "alt",
        address: "0xeabb8996ea1662cad2f7fb715127852cd3262ae9",
        icon: null,
        usdValue: 208.24284525370444,
      },
      {
        id: "1",
        name: "STACK",
        value: 7,
        tokenType: "alt",
        address: "0x56a86d648c435dc707c8405b78e2ae8eb4e60ba4",
        icon: null,
        usdValue: 146.91351355024446,
      },
      {
        id: "56",
        name: "SMCW",
        value: 7,
        tokenType: "alt",
        address: "0xb2ea51BAa12C461327d12A2069d47b30e680b69D",
        icon: null,
        usdValue: 206.87664221713555,
      },
      {
        id: "1",
        name: "RIN",
        value: 7,
        tokenType: "alt",
        address: "0x07ca256267128fbe1a79b74fc7b0e6ed3359ad08",
        icon: null,
        usdValue: 117.7263325050802,
      },
      {
        id: "56",
        name: "SON",
        value: 7,
        tokenType: "alt",
        address: "0x3b0e967ce7712ec68131a809db4f78ce9490e779",
        icon: null,
        usdValue: 1498952.5892930191,
      },
      {
        id: "56",
        name: "MNFT",
        value: 7,
        tokenType: "alt",
        address: "0x36953b5ec00a13edceceb3af258d034913d2a79d",
        icon: null,
        usdValue: 85.79684414589656,
      },
      {
        id: "1",
        name: "PC",
        value: 7,
        tokenType: "alt",
        address: "0xe1eC350ea16D1DdAFF57F31387B2d9708Eb7ce28",
        icon: null,
        usdValue: 64.7805793226083,
      },
      {
        id: "1",
        name: "RELAY",
        value: 7,
        tokenType: "alt",
        address: "0x5d843fa9495d23de997c394296ac7b4d721e841c",
        icon: null,
        usdValue: 481.7026183715306,
      },
      {
        id: "56",
        name: "MSTR",
        value: 7,
        tokenType: "alt",
        address: "0x2290C6bD9560E6498dFDf10F9eCB17997CA131f2",
        icon: null,
        usdValue: 190365.59506793268,
      },
      {
        id: "137",
        name: "WELT",
        value: 7,
        tokenType: "alt",
        address: "0x23e8b6a3f6891254988b84da3738d2bfe5e703b9",
        icon: null,
        usdValue: 285077.12423812953,
      },
      {
        id: "42161",
        name: "VEE",
        value: 7,
        tokenType: "alt",
        address: "0x0CAAdd427A6Feb5B5Fc1137eB05aA7Ddd9c08ce9",
        icon: null,
        usdValue: 44.9910272669366,
      },
      {
        id: "42161",
        name: "DBL",
        value: 7,
        tokenType: "alt",
        address: "0xd3f1da62cafb7e7bc6531ff1cef6f414291f03d3",
        icon: null,
        usdValue: 291.89633354972347,
      },
      {
        id: "10",
        name: "knc",
        value: 7,
        tokenType: "alt",
        address: "0xa00e3a3511aac35ca78530c85007afcd31753819",
        icon: null,
        usdValue: 75010.15895238658,
      },
      {
        id: "42161",
        name: "MIMATIC",
        value: 7,
        tokenType: "alt",
        address: "0x3f56e0c36d275367b8c502090edf38289b3dea0d",
        icon: null,
        usdValue: 3461757.7149817334,
      },
      {
        id: "1",
        name: "RVP",
        value: 7,
        tokenType: "alt",
        address: "0x17ef75aa22dd5f6c2763b8304ab24f40ee54d48a",
        icon: null,
        usdValue: 116563.54002254059,
      },
      {
        id: "1",
        name: "APEFI",
        value: 7,
        tokenType: "alt",
        address: "0x4332f8a38f14bd3d8d1553af27d7c7ac6c27278d",
        icon: null,
        usdValue: 180.15200103521624,
      },
      {
        id: "8453",
        name: "DEGEN",
        value: 7,
        tokenType: "alt",
        address: "0x4ed4e862860bed51a9570b96d89af5e1b0efefed",
        icon: null,
        usdValue: 554659.5156882145,
      },
      {
        id: "1",
        name: "SFIL",
        value: 7,
        tokenType: "alt",
        address: "0x965b85d4674f64422c4898c8f8083187f02b32c0",
        icon: null,
        usdValue: 22897.48454419606,
      },
      {
        id: "1",
        name: "ENV",
        value: 7,
        tokenType: "alt",
        address: "0xf1d1a5306daae314af6c5d027a492b313e07e1a0",
        icon: null,
        usdValue: 81262.30534933477,
      },
      {
        id: "1",
        name: "LM",
        value: 7,
        tokenType: "alt",
        address: "0x7bec98609cb6378d6f995e8f8097ee78376fbec9",
        icon: null,
        usdValue: 2189722.35874853,
      },
      {
        id: "1",
        name: "GM",
        value: 7,
        tokenType: "alt",
        address: "0xe5597f0723eeaba1b26948e06f008bf0fc1e37e6",
        icon: null,
        usdValue: 227.7166855932738,
      },
      {
        id: "1",
        name: "ZLW",
        value: 7,
        tokenType: "alt",
        address: "0x5319e86F0e41a06E49eb37046b8c11D78bcAd68C",
        icon: null,
        usdValue: 156281.06331650406,
      },
      {
        id: "1",
        name: "KZEN",
        value: 7,
        tokenType: "alt",
        address: "0x4550003152F12014558e5CE025707E4DD841100F",
        icon: null,
        usdValue: 16067.673387118464,
      },
      {
        id: "1",
        name: "BCDN",
        value: 7,
        tokenType: "alt",
        address: "0x1e797Ce986C3CFF4472F7D38d5C4aba55DfEFE40",
        icon: null,
        usdValue: 26731.942101353583,
      },
      {
        id: "1",
        name: "SNET",
        value: 7,
        tokenType: "alt",
        address: "0xFf19138b039D938db46bDDA0067DC4BA132ec71C",
        icon: null,
        usdValue: 116650.32524448661,
      },
      {
        id: "1",
        name: "GSE",
        value: 7,
        tokenType: "alt",
        address: "0xe530441f4f73bdb6dc2fa5af7c3fc5fd551ec838",
        icon: null,
        usdValue: 208007.3739458757,
      },
      {
        id: "1",
        name: "RATING",
        value: 7,
        tokenType: "alt",
        address: "0xe8663a64a96169ff4d95b4299e7ae9a76b905b31",
        icon: null,
        usdValue: 177046.70514424605,
      },
      {
        id: "1",
        name: "HSC",
        value: 7,
        tokenType: "alt",
        address: "0x2bba3cf6de6058cc1b4457ce00deb359e2703d7f",
        icon: null,
        usdValue: 375628.9432159194,
      },
      {
        id: "1",
        name: "GMAT",
        value: 7,
        tokenType: "alt",
        address: "0xb13de094cc5cee6c4cc0a3737bf0290166d9ca5d",
        icon: null,
        usdValue: 203259.1157185975,
      },
      {
        id: "1",
        name: "LEMD",
        value: 7,
        tokenType: "alt",
        address: "0xf45f6c8bb3d77ea762175b8f7ca4d251941649fa",
        icon: null,
        usdValue: 217108.646726924,
      },
      {
        id: "1",
        name: "LION",
        value: 7,
        tokenType: "alt",
        address: "0xc8ff6772f605a139c40b32d5d87d54994c705c6b",
        icon: null,
        usdValue: 182375.71106624344,
      },
      {
        id: "1",
        name: "VENT",
        value: 7,
        tokenType: "alt",
        address: "0x5f0bc16d50f72d10b719dbf6845de2e599eb5624",
        icon: null,
        usdValue: 679.8999184972355,
      },
      {
        id: "1",
        name: "TAUR",
        value: 7,
        tokenType: "alt",
        address: "0xF71288618F919FF0A779c757489A8B2e45925dDd",
        icon: null,
        usdValue: 109400.53225577559,
      },
      {
        id: "1",
        name: "PORTX",
        value: 7,
        tokenType: "alt",
        address: "0x104f3152d8ebfc3f679392977356962ff36566ac",
        icon: null,
        usdValue: 72855.00588308414,
      },
      {
        id: "1",
        name: "ESG",
        value: 7,
        tokenType: "alt",
        address: "0x20cd2e7ec8f5d8b337fe46a4f565ccef1561b9a9",
        icon: null,
        usdValue: 161627.11656817998,
      },
      {
        id: "1",
        name: "NVG",
        value: 7,
        tokenType: "alt",
        address: "0x08f40811c7d6c013744166f3d4cb1a9a92d3d54e",
        icon: null,
        usdValue: 22029.108744103363,
      },
      {
        id: "1",
        name: "LEMO",
        value: 7,
        tokenType: "alt",
        address: "0xB5AE848EdB296C21259b7467331467d2647eEcDf",
        icon: null,
        usdValue: 1777.8932612212604,
      },
      {
        id: "1",
        name: "eETH",
        value: 7,
        tokenType: "alt",
        address: "0x35fA164735182de50811E8e2E824cFb9B6118ac2",
        icon: null,
        usdValue: 4029.1198748085017,
      },
      {
        id: "10",
        name: "acx",
        value: 7,
        tokenType: "alt",
        address: "0xff733b2a3557a7ed6697007ab5d11b79fdd1b76b",
        icon: null,
        usdValue: 4833600.035712349,
      },
      {
        id: "56",
        name: "LQR",
        value: 7,
        tokenType: "alt",
        address: "0xbc81ea817b579ec0334bca8e65e436b7cb540147",
        icon: null,
        usdValue: 9.893028919887502,
      },
      {
        id: "56",
        name: "BAMBOO",
        value: 7,
        tokenType: "alt",
        address: "0x198abb2d13faa2e52e577d59209b5c23c20cd6b3",
        icon: null,
        usdValue: 21019.903009633814,
      },
      {
        id: "56",
        name: "CFX",
        value: 7,
        tokenType: "alt",
        address: "0x045c4324039da91c52c55df5d785385aab073dcf",
        icon: null,
        usdValue: 2908.8704316510466,
      },
      {
        id: "56",
        name: "BTT",
        value: 7,
        tokenType: "alt",
        address: "0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
        icon: null,
        usdValue: 545188.4573429695,
      },
      {
        id: "56",
        name: "TRIAS",
        value: 7,
        tokenType: "alt",
        address: "0xa4838122c683f732289805fc3c207febd55babdd",
        icon: null,
        usdValue: 21.388625682551943,
      },
      {
        id: "56",
        name: "SHILL",
        value: 7,
        tokenType: "alt",
        address: "0xfb9C339b4BacE4Fe63ccc1dd9a3c3C531441D5fE",
        icon: null,
        usdValue: 6441.3061120382035,
      },
      {
        id: "56",
        name: "1ART",
        value: 7,
        tokenType: "alt",
        address: "0xD3c325848D7c6E29b574Cb0789998b2ff901f17E",
        icon: null,
        usdValue: 344942.97121155664,
      },
      {
        id: "56",
        name: "NSDX",
        value: 7,
        tokenType: "alt",
        address: "0x417871f0682db63924b931fc16ba3ff40343cdcb",
        icon: null,
        usdValue: 241483.91202068614,
      },
      {
        id: "56",
        name: "UNCX",
        value: 7,
        tokenType: "alt",
        address: "0x09a6c44c3947b69e2b45f4d51b67e6a39acfb506",
        icon: null,
        usdValue: 2237.552692763588,
      },
      {
        id: "56",
        name: "EMPIRE",
        value: 7,
        tokenType: "alt",
        address: "0x293c3ee9abacb08bb8ced107987f00efd1539288",
        icon: null,
        usdValue: 41102.64742129989,
      },
      {
        id: "56",
        name: "CCAR",
        value: 7,
        tokenType: "alt",
        address: "0x50332bdca94673f33401776365b66cc4e81ac81d",
        icon: null,
        usdValue: 5827.072849632106,
      },
      {
        id: "56",
        name: "KART",
        value: 7,
        tokenType: "alt",
        address: "0x8bdd8dbcbdf0c066ca5f3286d33673aa7a553c10",
        icon: null,
        usdValue: 4696.78907672226,
      },
      {
        id: "56",
        name: "REAL",
        value: 7,
        tokenType: "alt",
        address: "0xE91cd52Bd65fe23A3EAE40E3eB87180E8306399F",
        icon: null,
        usdValue: 172985.86589293447,
      },
      {
        id: "56",
        name: "DAL",
        value: 7,
        tokenType: "alt",
        address: "0x53e4b7Aa6cACcb9576548Be3259e62dE4Ddd4417",
        icon: null,
        usdValue: 107181.29569242854,
      },
      {
        id: "56",
        name: "ZODI",
        value: 7,
        tokenType: "alt",
        address: "0x0cca2f5561bb0fca88e5b9b48b7fbf000349c357",
        icon: null,
        usdValue: 851885.8403491391,
      },
      {
        id: "56",
        name: "GM",
        value: 7,
        tokenType: "alt",
        address: "0xe2604c9561d490624aa35e156e65e590eb749519",
        icon: null,
        usdValue: 174791.9154312188,
      },
      {
        id: "56",
        name: "OGS",
        value: 7,
        tokenType: "alt",
        address: "0x416947e6fc78f158fd9b775fa846b72d768879c2",
        icon: null,
        usdValue: 2967999.9999999995,
      },
      {
        id: "56",
        name: "NMS",
        value: 7,
        tokenType: "alt",
        address: "0x8cb4fdb148d87f7ec493e69391347bdd3ff1163f",
        icon: null,
        usdValue: 23.4278135,
      },
      {
        id: "56",
        name: "FLOKICEO",
        value: 7,
        tokenType: "alt",
        address: "0x45289007706E7Ee7B42b1fA506661d97740Edfb4",
        icon: null,
        usdValue: 119652.88447025232,
      },
      {
        id: "56",
        name: "SCT",
        value: 7,
        tokenType: "alt",
        address: "0x405e7454E71AEfe8897438ADc08E3f3e6d49Dfc1",
        icon: null,
        usdValue: 3389.770738103702,
      },
      {
        id: "56",
        name: "WOR",
        value: 7,
        tokenType: "alt",
        address: "0xd6edbb510af7901b2c049ce778b65a740c4aeb7f",
        icon: null,
        usdValue: 11.491265586258429,
      },
      {
        id: "56",
        name: "METFI",
        value: 7,
        tokenType: "alt",
        address: "0x3E7f1039896454B9cb27c53CC7383e1AB9D9512a",
        icon: null,
        usdValue: 360775.2662448966,
      },
      {
        id: "56",
        name: "AIE",
        value: 7,
        tokenType: "alt",
        address: "0x1E30bBEE322b3B11C60cb434a47F1605C2a99483",
        icon: null,
        usdValue: 84223455.39073493,
      },
      {
        id: "56",
        name: "PEPEAI",
        value: 7,
        tokenType: "alt",
        address: "0x24086eab82dbdaa4771d0a5d66b0d810458b0e86",
        icon: null,
        usdValue: 22.39601,
      },
      {
        id: "56",
        name: "BTTOLD",
        value: 7,
        tokenType: "alt",
        address: "0x8595f9da7b868b1822194faed312235e43007b49",
        icon: null,
        usdValue: 35.48855494411195,
      },
      {
        id: "56",
        name: "ELON",
        value: 7,
        tokenType: "alt",
        address: "0x7bd6FaBD64813c48545C9c0e312A0099d9be2540",
        icon: null,
        usdValue: 945.377006204933,
      },
      {
        id: "56",
        name: "YFII",
        value: 7,
        tokenType: "alt",
        address: "0x7f70642d88cf1c4a3a7abb072b53b929b653eda5",
        icon: null,
        usdValue: 4334.82795348565,
      },
      {
        id: "56",
        name: "HYPC",
        value: 7,
        tokenType: "alt",
        address: "0x7881cD2B5724431372F57C50E91611352557A606",
        icon: null,
        usdValue: 111.38381316619201,
      },
      {
        id: "56",
        name: "MMPRO",
        value: 7,
        tokenType: "alt",
        address: "0x6067490d05f3cf2fdffc0e353b1f5fd6e5ccdf70",
        icon: null,
        usdValue: 439992.1461076508,
      },
      {
        id: "56",
        name: "OG",
        value: 7,
        tokenType: "alt",
        address: "0xf05E45aD22150677a017Fbd94b84fBB63dc9b44c",
        icon: null,
        usdValue: 1836.5676,
      },
      {
        id: "56",
        name: "HOGE",
        value: 7,
        tokenType: "alt",
        address: "0xa4FFfc757e8c4F24E7b209C033c123D20983Ad40",
        icon: null,
        usdValue: 7723.455326633899,
      },
      {
        id: "56",
        name: "LSS",
        value: 7,
        tokenType: "alt",
        address: "0xf7686f43591302cd9b4b9c4fe1291473fae7d9c9",
        icon: null,
        usdValue: 240.11291811831188,
      },
      {
        id: "56",
        name: "URUS",
        value: 7,
        tokenType: "alt",
        address: "0xc6DdDB5bc6E61e0841C54f3e723Ae1f3A807260b",
        icon: null,
        usdValue: 252400.190535998,
      },
      {
        id: "56",
        name: "ALT",
        value: 7,
        tokenType: "alt",
        address: "0x1BD55090B8878630E57FAE6eBd11FD61d16DFC9f",
        icon: null,
        usdValue: 3381.3810088007795,
      },
      {
        id: "56",
        name: "REVV",
        value: 7,
        tokenType: "alt",
        address: "0x833f307ac507d47309fd8cdd1f835bef8d702a93",
        icon: null,
        usdValue: 1925.0098453539727,
      },
      {
        id: "56",
        name: "ATOZ",
        value: 7,
        tokenType: "alt",
        address: "0x3606f220daeaeb3d47ac1923a8ce2a61205c88cd",
        icon: null,
        usdValue: 327962.5545861658,
      },
      {
        id: "56",
        name: "MLS",
        value: 7,
        tokenType: "alt",
        address: "0x5f2f6c4c491b690216e0f8ea753ff49ef4e36ba6",
        icon: null,
        usdValue: 9.419270584391327,
      },
      {
        id: "56",
        name: "TRR",
        value: 7,
        tokenType: "alt",
        address: "0xbB95cc1c662D89822bda29D2e147B124406e6e42",
        icon: null,
        usdValue: 2052253.6096923898,
      },
      {
        id: "56",
        name: "BONDLY",
        value: 7,
        tokenType: "alt",
        address: "0x5d0158a5c3ddf47d4ea4517d8db0d76aa2e87563",
        icon: null,
        usdValue: 349609.98235341895,
      },
      {
        id: "56",
        name: "DOSE",
        value: 7,
        tokenType: "alt",
        address: "0x7837fd820ba38f95c54d6dac4ca3751b81511357",
        icon: null,
        usdValue: 41.469698586098076,
      },
      {
        id: "56",
        name: "RJV",
        value: 7,
        tokenType: "alt",
        address: "0x1135883a1bc6776bf90c97845adc491922106dfb",
        icon: null,
        usdValue: 6107.6625693968945,
      },
      {
        id: "56",
        name: "TIFI",
        value: 7,
        tokenType: "alt",
        address: "0x17E65E6b9B166Fb8e7c59432F0db126711246BC0",
        icon: null,
        usdValue: 3771.757136199275,
      },
      {
        id: "56",
        name: "PRX",
        value: 7,
        tokenType: "alt",
        address: "0x90e3414e00e231b962666bd94adb811d5bcd0c2a",
        icon: null,
        usdValue: 1048363.0137530447,
      },
      {
        id: "56",
        name: "CTI",
        value: 7,
        tokenType: "alt",
        address: "0x7c3b67b30efbacc8f787f7ebd3bdc65234299f4c",
        icon: null,
        usdValue: 2775.2499141499998,
      },
      {
        id: "56",
        name: "BIT",
        value: 7,
        tokenType: "alt",
        address: "0xc864019047b864b6ab609a968ae2725dfaee808a",
        icon: null,
        usdValue: 64.83604091773155,
      },
      {
        id: "56",
        name: "STEPG",
        value: 7,
        tokenType: "alt",
        address: "0x5e6d3bb496301ecdfa34fa1ed2d3bada250f0409",
        icon: null,
        usdValue: 1103798.932985718,
      },
      {
        id: "56",
        name: "IOI",
        value: 7,
        tokenType: "alt",
        address: "0x959229D94c9060552daea25AC17193bcA65D7884",
        icon: null,
        usdValue: 40.522776792942494,
      },
      {
        id: "56",
        name: "CWS",
        value: 7,
        tokenType: "alt",
        address: "0xbcf39f0edda668c58371e519af37ca705f2bfcbd",
        icon: null,
        usdValue: 11536.687368139525,
      },
      {
        id: "56",
        name: "MEGALAND",
        value: 7,
        tokenType: "alt",
        address: "0x7cd8c22d3f4b66230f73d7ffcb48576233c3fe33",
        icon: null,
        usdValue: 8370.6,
      },
      {
        id: "56",
        name: "TCT",
        value: 7,
        tokenType: "alt",
        address: "0xCA0a9Df6a8cAD800046C1DDc5755810718b65C44",
        icon: null,
        usdValue: 36.00241358365366,
      },
      {
        id: "56",
        name: "ZOON",
        value: 7,
        tokenType: "alt",
        address: "0x9d173e6c594f479b4d47001f8e6a95a7adda42bc",
        icon: null,
        usdValue: 305178.72548159235,
      },
      {
        id: "56",
        name: "SMTY",
        value: 7,
        tokenType: "alt",
        address: "0xbF776e4FCa664D791C4Ee3A71e2722990E003283",
        icon: null,
        usdValue: 44021.77359269156,
      },
      {
        id: "56",
        name: "FLY",
        value: 7,
        tokenType: "alt",
        address: "0x681fd3e49a6188fc526784ee70aa1c269ee2b887",
        icon: null,
        usdValue: 41127.51404006725,
      },
      {
        id: "56",
        name: "BRT",
        value: 7,
        tokenType: "alt",
        address: "0xfc9F81B107F51F2383fCE56650fEDB59C5fd59bD",
        icon: null,
        usdValue: 377585.3389030549,
      },
      {
        id: "56",
        name: "MGG",
        value: 7,
        tokenType: "alt",
        address: "0x6125adcab2f171bc70cfe2caecfec5509273a86a",
        icon: null,
        usdValue: 145277.23418339618,
      },
      {
        id: "56",
        name: "DXCT",
        value: 7,
        tokenType: "alt",
        address: "0x5b1baec64af6dc54e6e04349315919129a6d3c23",
        icon: null,
        usdValue: 56580.735089214955,
      },
      {
        id: "56",
        name: "XCUR",
        value: 7,
        tokenType: "alt",
        address: "0xd52669712f253CD6b2Fe8A8638F66ed726cb770C",
        icon: null,
        usdValue: 25004.303118975244,
      },
      {
        id: "56",
        name: "RENA",
        value: 7,
        tokenType: "alt",
        address: "0xa9d75cc3405f0450955050c520843f99aff8749d",
        icon: null,
        usdValue: 190983.78190672785,
      },
      {
        id: "56",
        name: "AXL",
        value: 7,
        tokenType: "alt",
        address: "0x25b24b3c47918b7962b3e49c4f468367f73cc0e0",
        icon: null,
        usdValue: 191529.82273692547,
      },
      {
        id: "56",
        name: "OLAND",
        value: 7,
        tokenType: "alt",
        address: "0xB0461d7E8212D311b842A58e9989edE849ac6816",
        icon: null,
        usdValue: 38494.766330704355,
      },
      {
        id: "56",
        name: "MNY",
        value: 7,
        tokenType: "alt",
        address: "0xa6f7645ed967faf708a614a2fca8d4790138586f",
        icon: null,
        usdValue: 11448.821467999413,
      },
      {
        id: "56",
        name: "STZ",
        value: 7,
        tokenType: "alt",
        address: "0x7fe378c5e0b5c32af2ecc8829bedf02245a0e4ef",
        icon: null,
        usdValue: 156.64138209197313,
      },
      {
        id: "56",
        name: "KZEN",
        value: 7,
        tokenType: "alt",
        address: "0x4550003152F12014558e5CE025707E4DD841100F",
        icon: null,
        usdValue: 74645.42836776903,
      },
      {
        id: "56",
        name: "ANML",
        value: 7,
        tokenType: "alt",
        address: "0x06FDA0758c17416726f77Cb11305EAC94C074Ec0",
        icon: null,
        usdValue: 120453.43611661684,
      },
      {
        id: "56",
        name: "GUM",
        value: 7,
        tokenType: "alt",
        address: "0xc53708664b99DF348dd27C3Ac0759d2DA9c40462",
        icon: null,
        usdValue: 880.0875559738383,
      },
      {
        id: "56",
        name: "OIN",
        value: 7,
        tokenType: "alt",
        address: "0x658e64ffcf40d240a43d52ca9342140316ae44fa",
        icon: null,
        usdValue: 238.2581374209274,
      },
      {
        id: "56",
        name: "SAFEMARS",
        value: 7,
        tokenType: "alt",
        address: "0x3ad9594151886ce8538c1ff615efa2385a8c3a88",
        icon: null,
        usdValue: 361230.6663021378,
      },
      {
        id: "56",
        name: "MCRN",
        value: 7,
        tokenType: "alt",
        address: "0xacb2d47827c9813ae26de80965845d80935afd0b",
        icon: null,
        usdValue: 31890.614334942737,
      },
      {
        id: "56",
        name: "DKS",
        value: 7,
        tokenType: "alt",
        address: "0x121235cff4c59eec80b14c1d38b44e7de3a18287",
        icon: null,
        usdValue: 261218.385520604,
      },
      {
        id: "56",
        name: "SMG",
        value: 7,
        tokenType: "alt",
        address: "0x6bfd576220e8444ca4cc5f89efbd7f02a4c94c16",
        icon: null,
        usdValue: 92.08151677703344,
      },
      {
        id: "56",
        name: "SMARS",
        value: 7,
        tokenType: "alt",
        address: "0xc0366a104b429f0806bfa98d0008daa9555b2bed",
        icon: null,
        usdValue: 16554.784609053888,
      },
      {
        id: "56",
        name: "KTN",
        value: 7,
        tokenType: "alt",
        address: "0xDAe6c2A48BFAA66b43815c5548b10800919c993E",
        icon: null,
        usdValue: 296.0547949589373,
      },
      {
        id: "56",
        name: "GS",
        value: 7,
        tokenType: "alt",
        address: "0x9bA4c78b048EEed69f4eD3CFddeda7B51BAF7cA8",
        icon: null,
        usdValue: 1223.4867443020462,
      },
      {
        id: "56",
        name: "DEK",
        value: 7,
        tokenType: "alt",
        address: "0xe52C5A3590952F3ed6fcCf89A0bD7F38e11C5B98",
        icon: null,
        usdValue: 414387.964950847,
      },
      {
        id: "56",
        name: "MOMA",
        value: 7,
        tokenType: "alt",
        address: "0xb72842d6f5fedf91d22d56202802bb9a79c6322e",
        icon: null,
        usdValue: 2960.004104711402,
      },
      {
        id: "56",
        name: "DOGEKING",
        value: 7,
        tokenType: "alt",
        address: "0x641ec142e67ab213539815f67e4276975c2f8d50",
        icon: null,
        usdValue: 75.31394369973492,
      },
      {
        id: "56",
        name: "LION",
        value: 7,
        tokenType: "alt",
        address: "0x7969dc3c6e925bccbea9f7fc466a63c74f0115b8",
        icon: null,
        usdValue: 116848.00956783457,
      },
      {
        id: "56",
        name: "PHM",
        value: 7,
        tokenType: "alt",
        address: "0x4399AE7538c33cA24edD4C28C5dd7Ce9a80acF81",
        icon: null,
        usdValue: 138107.21008729044,
      },
      {
        id: "56",
        name: "CTT",
        value: 7,
        tokenType: "alt",
        address: "0x464863745ed3af8b9f8871f1082211c55f8f884d",
        icon: null,
        usdValue: 20509.479268421328,
      },
      {
        id: "56",
        name: "OPA",
        value: 7,
        tokenType: "alt",
        address: "0xA2F89a3be1bAda5Eb9D58D23EDc2E2FE0F82F4b0",
        icon: null,
        usdValue: 231284.8197392595,
      },
      {
        id: "56",
        name: "NBP",
        value: 7,
        tokenType: "alt",
        address: "0x74C22834744E8D5e36c79420Ff7b057964Aba8a7",
        icon: null,
        usdValue: 202169.9537157607,
      },
      {
        id: "56",
        name: "GENS",
        value: 7,
        tokenType: "alt",
        address: "0x2cd14cba3f26254beed1d78158cd2b6f91809600",
        icon: null,
        usdValue: 80859.79390709393,
      },
      {
        id: "56",
        name: "WAG",
        value: 7,
        tokenType: "alt",
        address: "0x7fa7df4996ac59f398476892cfb195ed38543520",
        icon: null,
        usdValue: 204547.56451715727,
      },
      {
        id: "56",
        name: "FAN",
        value: 7,
        tokenType: "alt",
        address: "0xb6d48fcef36e19681ee29896b19c1b6cbd1eab1b",
        icon: null,
        usdValue: 12685.80969149447,
      },
      {
        id: "56",
        name: "BP",
        value: 7,
        tokenType: "alt",
        address: "0xacb8f52dc63bb752a51186d1c55868adbffee9c1",
        icon: null,
        usdValue: 172079.60839964994,
      },
      {
        id: "56",
        name: "BATH",
        value: 7,
        tokenType: "alt",
        address: "0x0bc89aa98ad94e6798ec822d0814d934ccd0c0ce",
        icon: null,
        usdValue: 124241.81884945749,
      },
      {
        id: "56",
        name: "RIM",
        value: 7,
        tokenType: "alt",
        address: "0xa25199a79a34cc04b15e5c0bba4e3a557364e532",
        icon: null,
        usdValue: 11048.682591228504,
      },
      {
        id: "56",
        name: "MM",
        value: 7,
        tokenType: "alt",
        address: "0xBF05279F9Bf1CE69bBFEd670813b7e431142Afa4",
        icon: null,
        usdValue: 271.64852182815093,
      },
      {
        id: "56",
        name: "SHI",
        value: 7,
        tokenType: "alt",
        address: "0x7269d98af4aa705e0b1a5d8512fadb4d45817d5a",
        icon: null,
        usdValue: 84715.61823528344,
      },
      {
        id: "56",
        name: "VENT",
        value: 7,
        tokenType: "alt",
        address: "0x872d068c25511be88c1f5990c53eeffcdf46c9b4",
        icon: null,
        usdValue: 75165.03954735213,
      },
      {
        id: "56",
        name: "BLIN",
        value: 7,
        tokenType: "alt",
        address: "0x811b279463a89E4B6E35805174C9190763f72614",
        icon: null,
        usdValue: 348777.7332779011,
      },
      {
        id: "56",
        name: "CPAN",
        value: 7,
        tokenType: "alt",
        address: "0x04260673729c5f2b9894a467736f3d85f8d34fc8",
        icon: null,
        usdValue: 2087.899588724692,
      },
      {
        id: "56",
        name: "TAUR",
        value: 7,
        tokenType: "alt",
        address: "0x19b99162ADAAB85134E781Ac0048C275C31b205a",
        icon: null,
        usdValue: 196.89053729519998,
      },
      {
        id: "56",
        name: "KABY",
        value: 7,
        tokenType: "alt",
        address: "0x02a40c048ee2607b5f5606e445cfc3633fb20b58",
        icon: null,
        usdValue: 70130.83484309498,
      },
      {
        id: "56",
        name: "ADAPAD",
        value: 7,
        tokenType: "alt",
        address: "0xdb0170e2d0c1cc1b2e7a90313d9b9afa4f250289",
        icon: null,
        usdValue: 78563.13229871687,
      },
      {
        id: "56",
        name: "SRP",
        value: 7,
        tokenType: "alt",
        address: "0xcb2b25e783a414f0d20a65afa741c51b1ad84c49",
        icon: null,
        usdValue: 94070.33867927761,
      },
      {
        id: "56",
        name: "GRBE",
        value: 7,
        tokenType: "alt",
        address: "0x5ca4e7294b14ea5745ee2a688990e0cb68503219",
        icon: null,
        usdValue: 667554.487729128,
      },
      {
        id: "56",
        name: "ORION",
        value: 7,
        tokenType: "alt",
        address: "0x5530ec23f4eE1521182bd158C09F4CA7efEC1ef0",
        icon: null,
        usdValue: 50.39230043843381,
      },
      {
        id: "56",
        name: "MAT",
        value: 7,
        tokenType: "alt",
        address: "0xf3147987a00d35eecc10c731269003ca093740ca",
        icon: null,
        usdValue: 58197.80994730577,
      },
      {
        id: "56",
        name: "PSB",
        value: 7,
        tokenType: "alt",
        address: "0x36bfBb1d5B3C9b336f3D64976599B6020cA805F1",
        icon: null,
        usdValue: 107090.10151971545,
      },
      {
        id: "56",
        name: "DMLG",
        value: 7,
        tokenType: "alt",
        address: "0x1c796c140de269e255372ea687ef7644bab87935",
        icon: null,
        usdValue: 129219.7125959135,
      },
      {
        id: "56",
        name: "IHC",
        value: 7,
        tokenType: "alt",
        address: "0x86a53fcd199212fea44fa7e16eb1f28812be911d",
        icon: null,
        usdValue: 187540.00604368246,
      },
      {
        id: "56",
        name: "ASTRO",
        value: 7,
        tokenType: "alt",
        address: "0x72eb7ca07399ec402c5b7aa6a65752b6a1dc0c27",
        icon: null,
        usdValue: 86703.87067249829,
      },
      {
        id: "56",
        name: "FALCONS",
        value: 7,
        tokenType: "alt",
        address: "0xb139ed26b743c7254a246cf91eb594d097238524",
        icon: null,
        usdValue: 57130.630284883555,
      },
      {
        id: "56",
        name: "METAX",
        value: 7,
        tokenType: "alt",
        address: "0x03f8fdc10d5bcf7508375585b04e93d656d36954",
        icon: null,
        usdValue: 257248.78535123524,
      },
      {
        id: "56",
        name: "YIN",
        value: 7,
        tokenType: "alt",
        address: "0x794Baab6b878467F93EF17e2f2851ce04E3E34C8",
        icon: null,
        usdValue: 128252.53724299475,
      },
      {
        id: "56",
        name: "ALTB",
        value: 7,
        tokenType: "alt",
        address: "0x9b3a01f8b4abd2e2a74597b21b7c269abf4e9f41",
        icon: null,
        usdValue: 20234.580528502513,
      },
      {
        id: "56",
        name: "MELI",
        value: 7,
        tokenType: "alt",
        address: "0xaD04AC36791d923DeB082dA4f91Ab71675dD18fB",
        icon: null,
        usdValue: 248761.4294475889,
      },
      {
        id: "56",
        name: "SNFT",
        value: 7,
        tokenType: "alt",
        address: "0x4F8C689f2E17bA5ff0bAf4A7dd1C7493902DaC37",
        icon: null,
        usdValue: 467661.85937562044,
      },
      {
        id: "56",
        name: "SUPE",
        value: 7,
        tokenType: "alt",
        address: "0xb972c4027818223bb7b9399b3ca3ca58186e1590",
        icon: null,
        usdValue: 5605857.398720396,
      },
      {
        id: "56",
        name: "AQDC",
        value: 7,
        tokenType: "alt",
        address: "0x840aca956c06f340083fbdc6d919bdf2368fca0e",
        icon: null,
        usdValue: 352097.4243302587,
      },
      {
        id: "56",
        name: "TEDDY V2",
        value: 7,
        tokenType: "alt",
        address: "0xDB79c12d1d0670988A39B0E48b96e955eF922d24",
        icon: null,
        usdValue: 1405.43327390476,
      },
      {
        id: "56",
        name: "CNAME",
        value: 7,
        tokenType: "alt",
        address: "0xfc3514474306e2d4aa8350fd8fa9c46c165fe8cd",
        icon: null,
        usdValue: 120506.91123182068,
      },
      {
        id: "56",
        name: "SAFUU",
        value: 7,
        tokenType: "alt",
        address: "0xE5bA47fD94CB645ba4119222e34fB33F59C7CD90",
        icon: null,
        usdValue: 32.72334087617,
      },
      {
        id: "56",
        name: "GAFA",
        value: 7,
        tokenType: "alt",
        address: "0x495205d4c6307A73595C5C11B44Bee9B3418Ac69",
        icon: null,
        usdValue: 1273.687290107539,
      },
      {
        id: "56",
        name: "NFTY",
        value: 7,
        tokenType: "alt",
        address: "0x5774b2fc3e91af89f89141eacf76545e74265982",
        icon: null,
        usdValue: 20145.396485073983,
      },
      {
        id: "56",
        name: "POLYPAD",
        value: 7,
        tokenType: "alt",
        address: "0x8ae619d633cce175a2fbcfa1cea119ddc80f1342",
        icon: null,
        usdValue: 502.14652315105855,
      },
      {
        id: "56",
        name: "MINE",
        value: 7,
        tokenType: "alt",
        address: "0x93713de5e0be3b7FcbD34257b6cadFb4d96e12b1",
        icon: null,
        usdValue: 1964189.288984764,
      },
      {
        id: "56",
        name: "ATR",
        value: 7,
        tokenType: "alt",
        address: "0x7559C49c3Aec50E763A486bB232fA8d0d76078e4",
        icon: null,
        usdValue: 216.62881589351014,
      },
      {
        id: "56",
        name: "COPYCAT",
        value: 7,
        tokenType: "alt",
        address: "0xd635b32688f36ee4a7fe117b4c91dd811277acb6",
        icon: null,
        usdValue: 214.9051448338824,
      },
      {
        id: "56",
        name: "AMAZINGTEAM",
        value: 7,
        tokenType: "alt",
        address: "0x44ece1031e5b5e2d9169546cc10ea5c95ba96237",
        icon: null,
        usdValue: 96317.74480527497,
      },
      {
        id: "56",
        name: "WNDR",
        value: 7,
        tokenType: "alt",
        address: "0xDfd7b0dD7Bf1012DfDf3307a964c36b972300Ac8",
        icon: null,
        usdValue: 302034.44909733237,
      },
      {
        id: "56",
        name: "WEX",
        value: 7,
        tokenType: "alt",
        address: "0xa9c41a46a6b3531d28d5c32f6633dd2ff05dfb90",
        icon: null,
        usdValue: 14599.065717046029,
      },
      {
        id: "56",
        name: "PTS",
        value: 7,
        tokenType: "alt",
        address: "0xFA53a4778431712af31a11621eDee4D0926dF1aC",
        icon: null,
        usdValue: 221695.89009545825,
      },
      {
        id: "56",
        name: "NLC",
        value: 7,
        tokenType: "alt",
        address: "0x5f320c3b8f82acfe8f2bb1c85d63aa66a7ff524f",
        icon: null,
        usdValue: 17380.28632389867,
      },
      {
        id: "56",
        name: "EGON",
        value: 7,
        tokenType: "alt",
        address: "0x05995a068bdac17c582eC75AB46bb8e7394be1d9",
        icon: null,
        usdValue: 246.0899898920792,
      },
      {
        id: "56",
        name: "TBS",
        value: 7,
        tokenType: "alt",
        address: "0x45fffed8d9651fe9ea0321fcc9b15ee5e052a208",
        icon: null,
        usdValue: 138078.19201913037,
      },
      {
        id: "56",
        name: "SAFE",
        value: 7,
        tokenType: "alt",
        address: "0x4d7fa587ec8e50bd0e9cd837cb4da796f47218a1",
        icon: null,
        usdValue: 2304.685241096667,
      },
      {
        id: "56",
        name: "FOF",
        value: 7,
        tokenType: "alt",
        address: "0xe8a8db73f7fb1ab5f05c619a8a631c8930c782ae",
        icon: null,
        usdValue: 1350146.3579341173,
      },
      {
        id: "56",
        name: "RDF",
        value: 7,
        tokenType: "alt",
        address: "0xf29CCcC3460506e8F9bc038D4716C05b76b0441e",
        icon: null,
        usdValue: 140815.21812195235,
      },
      {
        id: "56",
        name: "FDC",
        value: 7,
        tokenType: "alt",
        address: "0x6d1a4650e83708b583c35d5e0952a0b46354ca9b",
        icon: null,
        usdValue: 172652.91639939835,
      },
      {
        id: "56",
        name: "SN",
        value: 7,
        tokenType: "alt",
        address: "0x939Dd9E433552e325D78C33a16EF4cD8004D2F9C",
        icon: null,
        usdValue: 450190.40138107695,
      },
      {
        id: "56",
        name: "FDT",
        value: 7,
        tokenType: "alt",
        address: "0x3a599e584075065eAAAc768D75EaEf85c2f2fF64",
        icon: null,
        usdValue: 202209.0654542581,
      },
      {
        id: "56",
        name: "GXE",
        value: 7,
        tokenType: "alt",
        address: "0x510975edA48A97E0cA228dD04d1217292487bea6",
        icon: null,
        usdValue: 474786.0334449605,
      },
      {
        id: "56",
        name: "CTG",
        value: 7,
        tokenType: "alt",
        address: "0xb3ba14f6a482dfdebc3c2fb726ac10df91ee504c",
        icon: null,
        usdValue: 1368573.8424692142,
      },
      {
        id: "56",
        name: "POP",
        value: 7,
        tokenType: "alt",
        address: "0x63bc9770Ea9a2F21Df6cc1224D64d8dEc9c61a74",
        icon: null,
        usdValue: 237331.96620465897,
      },
      {
        id: "56",
        name: "MINIFOOTBALL",
        value: 7,
        tokenType: "alt",
        address: "0xd024ac1195762f6f13f8cfdf3cdd2c97b33b248b",
        icon: null,
        usdValue: 148156.6123832437,
      },
      {
        id: "56",
        name: "IGUP",
        value: 7,
        tokenType: "alt",
        address: "0x522d0F9F3eFF479A5B256BB1C1108F47b8e1A153",
        icon: null,
        usdValue: 75.39485005979522,
      },
      {
        id: "56",
        name: "AIDOGEMINI",
        value: 7,
        tokenType: "alt",
        address: "0xf709e948daed701a6a018e6f6090ca1930055966",
        icon: null,
        usdValue: 3275.86,
      },
      {
        id: "56",
        name: "MPI",
        value: 7,
        tokenType: "alt",
        address: "0x82555cc48a532fa4e2194ab883eb6d465149f80e",
        icon: null,
        usdValue: 59597.929392743565,
      },
      {
        id: "56",
        name: "WEB4",
        value: 7,
        tokenType: "alt",
        address: "0xee7e8c85956d32c64bafdcded3f43b3c39b1ce2f",
        icon: null,
        usdValue: 2730.837173105622,
      },
      {
        id: "56",
        name: "NEUROS",
        value: 7,
        tokenType: "alt",
        address: "0x95b0FFfabD2817959Ce410070600D77BcE93D454",
        icon: null,
        usdValue: 9.544939425,
      },
      {
        id: "56",
        name: "ZLW",
        value: 7,
        tokenType: "alt",
        address: "0x5dd1E31E1a0e2E077aC98d2a4b781F418ca50387",
        icon: null,
        usdValue: 99011.23650884572,
      },
      {
        id: "137",
        name: "VENT",
        value: 7,
        tokenType: "alt",
        address: "0xf21441f9ec4c1fe69cb7cf186eceab31af2b658d",
        icon: null,
        usdValue: 20474.161559722048,
      },
      {
        id: "137",
        name: "KABY",
        value: 7,
        tokenType: "alt",
        address: "0x5198E7cC1640049dE37D1Bd10b03Fa5A3AFDA120",
        icon: null,
        usdValue: 23090.273170807326,
      },
      {
        id: "137",
        name: "BCMC",
        value: 7,
        tokenType: "alt",
        address: "0xc10358f062663448a3489fC258139944534592ac",
        icon: null,
        usdValue: 102182.11533361481,
      },
      {
        id: "137",
        name: "POT",
        value: 7,
        tokenType: "alt",
        address: "0xBCB98D98704FCe7Abda63bF733Af2a9e28C161C8",
        icon: null,
        usdValue: 44183571.89637989,
      },
      {
        id: "137",
        name: "SAVG",
        value: 7,
        tokenType: "alt",
        address: "0x981aecc6eb4d382b96a02b75e931900705e95a31",
        icon: null,
        usdValue: 7236.9014526771125,
      },
      {
        id: "137",
        name: "POLYPAD",
        value: 7,
        tokenType: "alt",
        address: "0x30ea765d4dda26e0f89e1b23a7c7b2526b7d29ec",
        icon: null,
        usdValue: 154535.18019183996,
      },
      {
        id: "137",
        name: "ITSB",
        value: 7,
        tokenType: "alt",
        address: "0x998013798440d44c1dd4c767bdd9580e16e46e28",
        icon: null,
        usdValue: 144891.23765352665,
      },
      {
        id: "137",
        name: "VATRENI",
        value: 7,
        tokenType: "alt",
        address: "0xd60deba014459f07bbcc077a5b817f31dafd5229",
        icon: null,
        usdValue: 1683956.1885786399,
      },
      {
        id: "137",
        name: "BUSD",
        value: 7,
        tokenType: "stable",
        address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
        icon: null,
        usdValue: 3195.066616279299,
      },
      {
        id: "137",
        name: "GLM",
        value: 7,
        tokenType: "alt",
        address: "0x0B220b82F3eA3B7F6d9A1D8ab58930C064A2b5Bf",
        icon: null,
        usdValue: 364.99983616009337,
      },
      {
        id: "137",
        name: "TIME",
        value: 7,
        tokenType: "alt",
        address: "0xb970Bc1BD4fCD639c37aa8eFD6713eaDc577252f",
        icon: null,
        usdValue: 360830.2162944675,
      },
      {
        id: "137",
        name: "PBR",
        value: 7,
        tokenType: "alt",
        address: "0x0d6ae2a429df13e44a07cd2969e085e4833f64a0",
        icon: null,
        usdValue: 337.9422907690328,
      },
      {
        id: "137",
        name: "LIME",
        value: 7,
        tokenType: "alt",
        address: "0x7f67639Ffc8C93dD558d452b8920b28815638c44",
        icon: null,
        usdValue: 5241299.41685501,
      },
      {
        id: "137",
        name: "RBLS",
        value: 7,
        tokenType: "alt",
        address: "0xe26cda27c13f4f87cFFc2F437C5900b27eBb5bbB",
        icon: null,
        usdValue: 331057.9868010859,
      },
      {
        id: "137",
        name: "FTRB",
        value: 7,
        tokenType: "alt",
        address: "0xC3f56d567E7663e8932E65d85ae4be7Eb5575cA7",
        icon: null,
        usdValue: 107.18766092770097,
      },
      {
        id: "137",
        name: "PERI",
        value: 7,
        tokenType: "alt",
        address: "0xdc0e17eae3b9651875030244b971fa0223a1764f",
        icon: null,
        usdValue: 343172.4701690072,
      },
      {
        id: "137",
        name: "KZEN",
        value: 7,
        tokenType: "alt",
        address: "0x4550003152F12014558e5CE025707E4DD841100F",
        icon: null,
        usdValue: 13755.27168825918,
      },
      {
        id: "137",
        name: "SOULS",
        value: 7,
        tokenType: "alt",
        address: "0xefCFEce12A99d1DbBf6F3264ee97F8C045e97F1f",
        icon: null,
        usdValue: 17098.614461487443,
      },
      {
        id: "137",
        name: "MCRN",
        value: 7,
        tokenType: "alt",
        address: "0xba25b552c8a098afdf276324c32c71fe28e0ad40",
        icon: null,
        usdValue: 43.733338840107834,
      },
      {
        id: "137",
        name: "PINE",
        value: 7,
        tokenType: "alt",
        address: "0x612D833c0c7A54cdfBe9a4328B6d658020563Ec0",
        icon: null,
        usdValue: 50667.13692137473,
      },
      {
        id: "137",
        name: "TNT",
        value: 7,
        tokenType: "alt",
        address: "0x25c498781ca536547b147e2199f572e5393d36f0",
        icon: null,
        usdValue: 299247.80020284135,
      },
      {
        id: "137",
        name: "VRJAM",
        value: 7,
        tokenType: "alt",
        address: "0xe84c2edca71fc3cc570c70665178d90c8721623b",
        icon: null,
        usdValue: 90338.79405961749,
      },
      {
        id: "137",
        name: "ASK",
        value: 7,
        tokenType: "alt",
        address: "0xaa3717090cddc9b227e49d0d84a28ac0a996e6ff",
        icon: null,
        usdValue: 282603.5122800341,
      },
      {
        id: "137",
        name: "DEUS",
        value: 7,
        tokenType: "alt",
        address: "0xde5ed76e7c05ec5e4572cfc88d1acea165109e44",
        icon: null,
        usdValue: 65311.67488764913,
      },
      {
        id: "137",
        name: "VP",
        value: 7,
        tokenType: "alt",
        address: "0xf46cb10e8c5fb9368bbf497a3176b80c0af66d44",
        icon: null,
        usdValue: 723988.5494350765,
      },
      {
        id: "137",
        name: "TRACE",
        value: 7,
        tokenType: "alt",
        address: "0x4287f07cbe6954f9f0decd91d0705c926d8d03a4",
        icon: null,
        usdValue: 7.498469596799998,
      },
      {
        id: "204",
        name: "BNB",
        value: 7,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 4186693.1584327132,
      },
      {
        id: "204",
        name: "USDT",
        value: 7,
        tokenType: "stable",
        address: "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
        icon: null,
        usdValue: 22019.699033348854,
      },
      {
        id: "204",
        name: "FDUSD",
        value: 7,
        tokenType: "stable",
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        icon: null,
        usdValue: 786.193674731705,
      },
      {
        id: "4200",
        name: "MERL",
        value: 7,
        tokenType: "native",
        address: "0x5c46bFF4B38dc1EAE09C5BAc65872a1D8bc87378",
        icon: null,
        usdValue: 10632998.058150573,
      },
      {
        id: "4200",
        name: "VOYA",
        value: 7,
        tokenType: "alt",
        address: "0x480E158395cC5b41e5584347c495584cA2cAf78d",
        icon: null,
        usdValue: 2376516.335582266,
      },
      {
        id: "4200",
        name: "MP",
        value: 7,
        tokenType: "alt",
        address: "0xbd40c74cb5cf9f9252B3298230Cb916d80430bBa",
        icon: null,
        usdValue: 5997702.628784439,
      },
      {
        id: "4200",
        name: "WBTC",
        value: 7,
        tokenType: "alt",
        address: "0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA",
        icon: null,
        usdValue: 336.3045,
      },
      {
        id: "534352",
        name: "ETH",
        value: 7,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 821.2067096564645,
      },
      {
        id: "534352",
        name: "USDT",
        value: 7,
        tokenType: "stable",
        address: "0xf55BEC9cafDbE8730f096Aa55dad6D22d44099Df",
        icon: null,
        usdValue: 2091.490183322666,
      },
      {
        id: "137",
        name: "UNI",
        value: 7,
        tokenType: "alt",
        address: "0xb33eaad8d922b1083446dc23f610c2567fb5180f",
        icon: null,
        usdValue: 12992.438781257122,
      },
      {
        id: "1",
        name: "LAIKA",
        value: 7,
        tokenType: "alt",
        address: "0x77f9CF0bd8C500CfFdF420e72343893aeCC2EC0b",
        icon: null,
        usdValue: 73711.6326991925,
      },
      {
        id: "1",
        name: "GENE",
        value: 7,
        tokenType: "alt",
        address: "0x21413c119b0c11c5d96ae1bd328917bc5c8ed67e",
        icon: null,
        usdValue: 735.1535976184621,
      },
      {
        id: "1",
        name: "PKN",
        value: 7,
        tokenType: "alt",
        address: "0xdf09a216fac5adc3e640db418c0b956076509503",
        icon: null,
        usdValue: 8965.500295026462,
      },
      {
        id: "1",
        name: "DCN",
        value: 7,
        tokenType: "alt",
        address: "0x08d32b0da63e2C3bcF8019c9c5d849d7a9d791e6",
        icon: null,
        usdValue: 3985.024288642775,
      },
      {
        id: "1",
        name: "PAN",
        value: 7,
        tokenType: "alt",
        address: "0x536381a8628dbcc8c70ac9a30a7258442eab4c92",
        icon: null,
        usdValue: 243234.29875664672,
      },
      {
        id: "56",
        name: "WEYU",
        value: 7,
        tokenType: "alt",
        address: "0xfafd4cb703b25cb22f43d017e7e0d75febc26743",
        icon: null,
        usdValue: 48.83920551548306,
      },
      {
        id: "1",
        name: "MINTYS",
        value: 7,
        tokenType: "alt",
        address: "0xbbd900e05b4af2124390d206f70bc4e583b1be85",
        icon: null,
        usdValue: 86.53071111458154,
      },
      {
        id: "1",
        name: "HIOD",
        value: 7,
        tokenType: "alt",
        address: "0x7a83FF237e7870d8d6C3485920EBe654D2841315",
        icon: null,
        usdValue: 38117.126320344425,
      },
      {
        id: "1",
        name: "HIPENGUINS",
        value: 7,
        tokenType: "alt",
        address: "0x669dB4c47f89f21554Ebd825A744888725FD9491",
        icon: null,
        usdValue: 180341.34901495467,
      },
      {
        id: "1",
        name: "PLEB",
        value: 7,
        tokenType: "alt",
        address: "0xe19f85c920b572ca48942315b06d6cac86585c87",
        icon: null,
        usdValue: 10935.430483594137,
      },
      {
        id: "1",
        name: "GDC",
        value: 7,
        tokenType: "alt",
        address: "0x301C755bA0fcA00B1923768Fffb3Df7f4E63aF31",
        icon: null,
        usdValue: 11984.530624291474,
      },
      {
        id: "1",
        name: "MYST",
        value: 7,
        tokenType: "alt",
        address: "0x4cf89ca06ad997bc732dc876ed2a7f26a9e7f361",
        icon: null,
        usdValue: 214242.9717586719,
      },
      {
        id: "1",
        name: "RUSH",
        value: 7,
        tokenType: "alt",
        address: "0x382A1667C9062F0621362F49076Ef6e4fE4C9eC7",
        icon: null,
        usdValue: 186658.4279774294,
      },
      {
        id: "1",
        name: "CRDC",
        value: 7,
        tokenType: "alt",
        address: "0xF81421fc15300c5a8CCa9aFE12F5CBAd502Fa756",
        icon: null,
        usdValue: 229915.79955881482,
      },
      {
        id: "1",
        name: "AOA",
        value: 7,
        tokenType: "alt",
        address: "0x9ab165d795019b6d8b3e971dda91071421305e5a",
        icon: null,
        usdValue: 27537.81040397616,
      },
      {
        id: "1",
        name: "BSGG",
        value: 7,
        tokenType: "alt",
        address: "0x69570f3e84f51ea70b7b68055c8d667e77735a25",
        icon: null,
        usdValue: 2682.841507465114,
      },
      {
        id: "1",
        name: "COVA",
        value: 7,
        tokenType: "alt",
        address: "0xb37a769b37224449d92aac57de379e1267cd3b00",
        icon: null,
        usdValue: 17104.57861932054,
      },
      {
        id: "1",
        name: "COVN",
        value: 7,
        tokenType: "alt",
        address: "0x19ac2659599fd01c853de846919544276ad26f50",
        icon: null,
        usdValue: 273262.18646775535,
      },
      {
        id: "1",
        name: "EYES",
        value: 7,
        tokenType: "alt",
        address: "0xe42B7A17336B343569C82f682a493a837B7e0755",
        icon: null,
        usdValue: 71455.0678476221,
      },
      {
        id: "1",
        name: "NPAS",
        value: 7,
        tokenType: "alt",
        address: "0xEBe807bFDf8b2092E36e964C75463A8Aaa642139",
        icon: null,
        usdValue: 67353.54564916251,
      },
      {
        id: "1",
        name: "MAV",
        value: 7,
        tokenType: "alt",
        address: "0xbe1dBe6741fB988fb571AB1E28CfFB36e3C62629",
        icon: null,
        usdValue: 916375.62122613,
      },
      {
        id: "1",
        name: "BEZOGE",
        value: 7,
        tokenType: "alt",
        address: "0xdc349913d53b446485e98b76800b6254f43df695",
        icon: null,
        usdValue: 2207.9693855852,
      },
      {
        id: "1",
        name: "LWD",
        value: 7,
        tokenType: "alt",
        address: "0x786e995A975C2ab7C1dd252A9019fB0c91c9Ca83",
        icon: null,
        usdValue: 34052.55578443448,
      },
      {
        id: "1",
        name: "LOTT",
        value: 7,
        tokenType: "alt",
        address: "0xba93ef534094f8b7001ece2691168140965341ab",
        icon: null,
        usdValue: 385885.8706861401,
      },
      {
        id: "1",
        name: "WACME",
        value: 7,
        tokenType: "alt",
        address: "0xDF4Ef6EE483953fE3B84ABd08C6A060445c01170",
        icon: null,
        usdValue: 145263.74485330834,
      },
      {
        id: "1",
        name: "OLEA",
        value: 7,
        tokenType: "alt",
        address: "0xc6cc3d07c705e39d11c7f60d8836c7c78d4ac5f1",
        icon: null,
        usdValue: 1355752.3306723656,
      },
      {
        id: "1",
        name: "FNCT",
        value: 7,
        tokenType: "alt",
        address: "0x8af78f0c818302164f73b2365fe152c2d1fe80e1",
        icon: null,
        usdValue: 2866249.036395674,
      },
      {
        id: "1",
        name: "MAX",
        value: 7,
        tokenType: "alt",
        address: "0x63f7B1b538a78cB699E5399621B3d2e047C40de4",
        icon: null,
        usdValue: 457810.1881505906,
      },
      {
        id: "1",
        name: "DOTR",
        value: 7,
        tokenType: "alt",
        address: "0x26524e35e44e265eb181c7ba6ec084983181aae3",
        icon: null,
        usdValue: 7980.766820903319,
      },
      {
        id: "1",
        name: "ADS",
        value: 7,
        tokenType: "alt",
        address: "0xcfcecfe2bd2fed07a9145222e8a7ad9cf1ccd22a",
        icon: null,
        usdValue: 82608.72319270292,
      },
      {
        id: "1",
        name: "TPY",
        value: 7,
        tokenType: "alt",
        address: "0x968Cbe62c830A0Ccf4381614662398505657A2A9",
        icon: null,
        usdValue: 186505.8083843668,
      },
      {
        id: "1",
        name: "HITOP",
        value: 7,
        tokenType: "alt",
        address: "0x01022591fCe0609B57670bebA60102dFd2b95D77",
        icon: null,
        usdValue: 218172.90108072272,
      },
      {
        id: "137",
        name: "ROND",
        value: 7,
        tokenType: "alt",
        address: "0x204820B6e6FEae805e376D2C6837446186e57981",
        icon: null,
        usdValue: 1774627.8530685934,
      },
      {
        id: "1",
        name: "PTU",
        value: 7,
        tokenType: "alt",
        address: "0xC229c69eB3BB51828D0cAA3509A05a51083898dd",
        icon: null,
        usdValue: 13203556.913095528,
      },
      {
        id: "1",
        name: "XCHF",
        value: 7,
        tokenType: "alt",
        address: "0xb4272071ecadd69d933adcd19ca99fe80664fc08",
        icon: null,
        usdValue: 221295.5103784494,
      },
      {
        id: "56",
        name: "DUET",
        value: 6,
        tokenType: "alt",
        address: "0x95EE03e1e2C5c4877f9A298F1C0D6c98698FAB7B",
        icon: null,
        usdValue: 51.82882080738618,
      },
      {
        id: "1",
        name: "CHART",
        value: 6,
        tokenType: "alt",
        address: "0x1d37986f252d0e349522ea6c3b98cb935495e63e",
        icon: null,
        usdValue: 19.431688549027097,
      },
      {
        id: "1",
        name: "CHI",
        value: 6,
        tokenType: "alt",
        address: "0x0000000000004946c0e9f43f4dee607b0ef1fa1c",
        icon: null,
        usdValue: 23.59787527266367,
      },
      {
        id: "1",
        name: "FLASH",
        value: 6,
        tokenType: "alt",
        address: "0xb1f1f47061a7be15c69f378cb3f69423bd58f2f8",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Dyl",
        value: 6,
        tokenType: "alt",
        address: "0x4a506181f07da5ddfda4ca4c2fa4c67001db94b4",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Reaper",
        value: 6,
        tokenType: "alt",
        address: "0xb1d58054b351a4fbb327cac2296e3a2e93bbe7e5",
        icon: null,
        usdValue: 0.15142240076350724,
      },
      {
        id: "1",
        name: "SWM",
        value: 6,
        tokenType: "alt",
        address: "0x9e88613418cf03dca54d6a2cf6ad934a78c7a17a",
        icon: null,
        usdValue: 10465.223378269138,
      },
      {
        id: "1",
        name: "SKIN",
        value: 6,
        tokenType: "alt",
        address: "0x2bdc0d42996017fce214b21607a515da41a9e0c5",
        icon: null,
        usdValue: 55.91019641386426,
      },
      {
        id: "42161",
        name: "LSETH",
        value: 6,
        tokenType: "alt",
        address: "0x8ffd9f31980f26fbf4ac693678db700f1d8c51f6",
        icon: null,
        usdValue: 209.37816322910203,
      },
      {
        id: "10",
        name: "dola",
        value: 6,
        tokenType: "stable",
        address: "0x8ae125e8653821e851f12a49f7765db9a9ce7384",
        icon: null,
        usdValue: 368.1720029806875,
      },
      {
        id: "56",
        name: "SCOTTY",
        value: 6,
        tokenType: "alt",
        address: "0x000351d035D8BBf2aa3131EbFECD66Fb21836f6c",
        icon: null,
        usdValue: 315.5491127623585,
      },
      {
        id: "10",
        name: "aave",
        value: 6,
        tokenType: "alt",
        address: "0x76fb31fb4af56892a25e32cfc43de717950c9278",
        icon: null,
        usdValue: 34.14630463268712,
      },
      {
        id: "1",
        name: "BANANA",
        value: 6,
        tokenType: "alt",
        address: "0x94e496474f1725f1c1824cb5bdb92d7691a4f03a",
        icon: null,
        usdValue: 1697.9339046656883,
      },
      {
        id: "1",
        name: "eQuad",
        value: 6,
        tokenType: "alt",
        address: "0xc28e931814725bbeb9e670676fabbcb694fe7df2",
        icon: null,
        usdValue: 2717.8741634028493,
      },
      {
        id: "1",
        name: "ZEFU",
        value: 6,
        tokenType: "alt",
        address: "0xb1e9157c2fdcc5a856c8da8b2d89b6c32b3c1229",
        icon: null,
        usdValue: 350.7269105827278,
      },
      {
        id: "1",
        name: "FYZ",
        value: 6,
        tokenType: "alt",
        address: "0x6BFf2fE249601ed0Db3a87424a2E923118BB0312",
        icon: null,
        usdValue: 28.846178125681227,
      },
      {
        id: "1",
        name: "PARTY",
        value: 6,
        tokenType: "alt",
        address: "0x0fe0ed7f146cb12e4b9759aff4fa8d34571802ca",
        icon: null,
        usdValue: 214.68770399344248,
      },
      {
        id: "1",
        name: "AGEUR",
        value: 6,
        tokenType: "stable",
        address: "0x1a7e4e63778b4f12a199c062f3efdd288afcbce8",
        icon: null,
        usdValue: 14497.91505636772,
      },
      {
        id: "42161",
        name: "LEVI",
        value: 6,
        tokenType: "alt",
        address: "0x954ac1c73e16c77198e83c088ade88f6223f3d44",
        icon: null,
        usdValue: 862.7643356105235,
      },
      {
        id: "56",
        name: "EPS",
        value: 6,
        tokenType: "alt",
        address: "0xa7f552078dcc247c2684336020c03648500c6d9f",
        icon: null,
        usdValue: 2340.867414750703,
      },
      {
        id: "10",
        name: "crv",
        value: 6,
        tokenType: "alt",
        address: "0x0994206dfe8de6ec6920ff4d779b0d950605fb53",
        icon: null,
        usdValue: 546.9384408710804,
      },
      {
        id: "56",
        name: "CANU",
        value: 6,
        tokenType: "alt",
        address: "0xdbb66eb9f4d737b49ae5cd4de25e6c8da8b034f9",
        icon: null,
        usdValue: 168.20818712735917,
      },
      {
        id: "1",
        name: "HARAMBE",
        value: 6,
        tokenType: "alt",
        address: "0xade6fdaba1643e4d1eef68da7170f234470938c6",
        icon: null,
        usdValue: 1251.1398066026845,
      },
      {
        id: "1",
        name: "VIDYA",
        value: 6,
        tokenType: "alt",
        address: "0x3d3d35bb9bec23b06ca00fe472b50e7a4c692c30",
        icon: null,
        usdValue: 11600.53603467035,
      },
      {
        id: "1",
        name: "MNET",
        value: 6,
        tokenType: "alt",
        address: "0x829c97092c0cc92efe7397dd3ddb831cc5835bae",
        icon: null,
        usdValue: 191.24725731404862,
      },
      {
        id: "56",
        name: "nuBTC",
        value: 6,
        tokenType: "alt",
        address: "0x0dea5ac2898e6aa637ece0db750fd6d35e460392",
        icon: null,
        usdValue: 0.7868394298225146,
      },
      {
        id: "56",
        name: "DOM",
        value: 6,
        tokenType: "alt",
        address: "0x8c282ea9eacd1b95d44a3a18dcdd1d0472868998",
        icon: null,
        usdValue: 52.05727522812514,
      },
      {
        id: "137",
        name: "FACTR",
        value: 6,
        tokenType: "alt",
        address: "0xe0bceef36f3a6efdd5eebfacd591423f8549b9d5",
        icon: null,
        usdValue: 8783.98780837664,
      },
      {
        id: "137",
        name: "PIG",
        value: 6,
        tokenType: "alt",
        address: "0xe9bc9ad74cca887aff32ba09a121b1256fc9f052",
        icon: null,
        usdValue: 0.0014607898227887788,
      },
      {
        id: "42161",
        name: "ARBYS",
        value: 6,
        tokenType: "alt",
        address: "0x86a1012d437bbff84fbdf62569d12d4fd3396f8c",
        icon: null,
        usdValue: 1170.792746083423,
      },
      {
        id: "1",
        name: "ETHPAD",
        value: 6,
        tokenType: "alt",
        address: "0x8db1d28ee0d822367af8d220c0dc7cb6fe9dc442",
        icon: null,
        usdValue: 748.1852275099452,
      },
      {
        id: "1",
        name: "OKLG",
        value: 6,
        tokenType: "alt",
        address: "0x5dbb9f64cd96e2dbbca58d14863d615b67b42f2e",
        icon: null,
        usdValue: 14.114011360341555,
      },
      {
        id: "1",
        name: "TREATS",
        value: 6,
        tokenType: "alt",
        address: "0xb4e1bba882e1058dc9088c69f26f832394cabc77",
        icon: null,
        usdValue: 3.9386126454576376,
      },
      {
        id: "1",
        name: "KIRA",
        value: 6,
        tokenType: "alt",
        address: "0xf98ab0874b13a7fdc39d7295dedd49850a5d426b",
        icon: null,
        usdValue: 1205.7644704300365,
      },
      {
        id: "56",
        name: "MOJO",
        value: 6,
        tokenType: "alt",
        address: "0x8087e4c1735c1373f0d04b88d4dbe1fae1149123",
        icon: null,
        usdValue: 0.00011087550935183614,
      },
      {
        id: "1",
        name: "BLOOD",
        value: 6,
        tokenType: "alt",
        address: "0x95392f142af1c12f6e39897ff9b09c599666b50c",
        icon: null,
        usdValue: 929.6031561904605,
      },
      {
        id: "1",
        name: "PAD",
        value: 6,
        tokenType: "alt",
        address: "0xea7cc765ebc94c4805e3bff28d7e4ae48d06468a",
        icon: null,
        usdValue: 464.43205757832754,
      },
      {
        id: "56",
        name: "DOLA",
        value: 6,
        tokenType: "stable",
        address: "0x2f29bc0ffaf9bff337b31cbe6cb5fb3bf12e5840",
        icon: null,
        usdValue: 114.02628953670018,
      },
      {
        id: "42161",
        name: "MCB",
        value: 6,
        tokenType: "alt",
        address: "0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42",
        icon: null,
        usdValue: 60055.43607472609,
      },
      {
        id: "1",
        name: "YDR",
        value: 6,
        tokenType: "alt",
        address: "0x3757232b55e60da4a8793183ac030cfce4c3865d",
        icon: null,
        usdValue: 252.66509467947293,
      },
      {
        id: "1",
        name: "BNS",
        value: 6,
        tokenType: "alt",
        address: "0x19e2a43fbbc643c3b2d9667d858d49cad17bc2b5",
        icon: null,
        usdValue: 81909.45345222714,
      },
      {
        id: "56",
        name: "AIRI",
        value: 6,
        tokenType: "alt",
        address: "0x7e2a35c746f2f7c240b664f1da4dd100141ae71f",
        icon: null,
        usdValue: 962.4720238799359,
      },
      {
        id: "1",
        name: "CAG",
        value: 6,
        tokenType: "alt",
        address: "0x7d4b8cce0591c9044a22ee543533b72e976e36c3",
        icon: null,
        usdValue: 4573.925595604529,
      },
      {
        id: "1",
        name: "FNC",
        value: 6,
        tokenType: "alt",
        address: "0x7f280dac515121dcda3eac69eb4c13a52392cace",
        icon: null,
        usdValue: 117.21176996928291,
      },
      {
        id: "1",
        name: "PACHA",
        value: 6,
        tokenType: "alt",
        address: "0x2Dd1B9410c73E16b60240E529e38E30425F00d4E",
        icon: null,
        usdValue: 6847.264316526976,
      },
      {
        id: "56",
        name: "GRAV",
        value: 6,
        tokenType: "alt",
        address: "0xa6168c7e5eb7c5c379f3a1d7cf1073e09b2f031e",
        icon: null,
        usdValue: 15.283632610910995,
      },
      {
        id: "56",
        name: "HPL",
        value: 6,
        tokenType: "alt",
        address: "0x0d0621ad4ec89da1cf0f371d6205229f04bcb378",
        icon: null,
        usdValue: 109.51570550105372,
      },
      {
        id: "1",
        name: "SVD",
        value: 6,
        tokenType: "alt",
        address: "0xbdeb4b83251fb146687fa19d1c660f99411eefe3",
        icon: null,
        usdValue: 2736.674555641343,
      },
      {
        id: "42161",
        name: "CHR",
        value: 6,
        tokenType: "alt",
        address: "0x15b2fb8f08e4ac1ce019eadae02ee92aedf06851",
        icon: null,
        usdValue: 473.5305418003196,
      },
      {
        id: "56",
        name: "DNL",
        value: 6,
        tokenType: "alt",
        address: "0x6B9481FB5465ef9Ab9347b332058D894aB09B2f6",
        icon: null,
        usdValue: 167.7890190652992,
      },
      {
        id: "56",
        name: "BLXM",
        value: 6,
        tokenType: "alt",
        address: "0x40e51e0ec04283e300f12f6bb98da157bb22036e",
        icon: null,
        usdValue: 931.5912691142004,
      },
      {
        id: "42161",
        name: "YFX",
        value: 6,
        tokenType: "alt",
        address: "0xaaE0c3856e665ff9b3E2872B6D75939D810b7E40",
        icon: null,
        usdValue: 28.306731286458557,
      },
      {
        id: "1",
        name: "KARMA",
        value: 6,
        tokenType: "alt",
        address: "0xdfe691f37b6264a90ff507eb359c45d55037951c",
        icon: null,
        usdValue: 73.21797508620794,
      },
      {
        id: "1",
        name: "DEBASE",
        value: 6,
        tokenType: "alt",
        address: "0x9248c485b0b80f76da451f167a8db30f33c70907",
        icon: null,
        usdValue: 6.5849467142097615e-19,
      },
      {
        id: "42161",
        name: "PLSDPX",
        value: 6,
        tokenType: "alt",
        address: "0xF236ea74B515eF96a9898F5a4ed4Aa591f253Ce1",
        icon: null,
        usdValue: 313.0838828503802,
      },
      {
        id: "56",
        name: "ZOMFI",
        value: 6,
        tokenType: "alt",
        address: "0xb1a05d0ee3c8d936f70b77318a348c0de2f8a396",
        icon: null,
        usdValue: 38.446386614687995,
      },
      {
        id: "56",
        name: "BEST",
        value: 6,
        tokenType: "alt",
        address: "0x667bEbFf5cda3C4A460B514aB478Da0A8cF80910",
        icon: null,
        usdValue: 116.70228283249999,
      },
      {
        id: "1",
        name: "FVT",
        value: 6,
        tokenType: "alt",
        address: "0x45080a6531d671ddff20db42f93792a489685e32",
        icon: null,
        usdValue: 421.0251508721006,
      },
      {
        id: "1",
        name: "AVINOC",
        value: 6,
        tokenType: "alt",
        address: "0xf1ca9cb74685755965c7458528a36934df52a3ef",
        icon: null,
        usdValue: 340.4869464498618,
      },
      {
        id: "42161",
        name: "ZYB",
        value: 6,
        tokenType: "alt",
        address: "0x3B475F6f2f41853706afc9Fa6a6b8C5dF1a2724c",
        icon: null,
        usdValue: 34166.656462173676,
      },
      {
        id: "42161",
        name: "WUSDR",
        value: 6,
        tokenType: "alt",
        address: "0xddc0385169797937066bbd8ef409b5b3c0dfeb52",
        icon: null,
        usdValue: 388.2781349971871,
      },
      {
        id: "1",
        name: "sETH",
        value: 6,
        tokenType: "alt",
        address: "0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb",
        icon: null,
        usdValue: 1644.1202929547924,
      },
      {
        id: "1",
        name: "PLBT",
        value: 6,
        tokenType: "alt",
        address: "0x0affa06e7fbe5bc9a764c979aa66e8256a631f02",
        icon: null,
        usdValue: 1072.670604246902,
      },
      {
        id: "1",
        name: "WQT",
        value: 6,
        tokenType: "alt",
        address: "0x06677dc4fe12d3ba3c7ccfd0df8cd45e4d4095bf",
        icon: null,
        usdValue: 4737.919284983507,
      },
      {
        id: "137",
        name: "KOM",
        value: 6,
        tokenType: "alt",
        address: "0xC004e2318722EA2b15499D6375905d75Ee5390B8",
        icon: null,
        usdValue: 12.723070058603106,
      },
      {
        id: "1",
        name: "TEMP",
        value: 6,
        tokenType: "alt",
        address: "0xa36fdbbae3c9d55a1d67ee5821d53b50b63a1ab9",
        icon: null,
        usdValue: 2269.619996066191,
      },
      {
        id: "1",
        name: "BLOCKS",
        value: 6,
        tokenType: "alt",
        address: "0x22bb7d3f4dcf074b979021ca4e214361e14c6b26",
        icon: null,
        usdValue: 766.8483566064303,
      },
      {
        id: "56",
        name: "LITT",
        value: 6,
        tokenType: "alt",
        address: "0xCEbEf3DF1F3C5Bfd90FDE603E71F31a53B11944D",
        icon: null,
        usdValue: 506174.224816725,
      },
      {
        id: "137",
        name: "DxDex.io",
        value: 6,
        tokenType: "alt",
        address: "0x81067076dcb7d3168ccf7036117b9d72051205e2",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "FlowDAO.io",
        value: 6,
        tokenType: "alt",
        address: "0xa85f8a198d59f0fda82333be9aeeb50f24dd59ff",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "ANKRBNB",
        value: 6,
        tokenType: "alt",
        address: "0x52F24a5e03aee338Da5fd9Df68D2b6FAe1178827",
        icon: null,
        usdValue: 1555.399200387046,
      },
      {
        id: "1",
        name: "BOLLY",
        value: 6,
        tokenType: "alt",
        address: "0x6bd361e10c1afed0d95259e7c0115f3a60e4ea99",
        icon: null,
        usdValue: 1874.6096767878564,
      },
      {
        id: "42161",
        name: "OATH",
        value: 6,
        tokenType: "alt",
        address: "0xa1150db5105987cec5fd092273d1e3cbb22b378b",
        icon: null,
        usdValue: 341.28355458961624,
      },
      {
        id: "56",
        name: "BFG",
        value: 6,
        tokenType: "alt",
        address: "0xbb46693ebbea1ac2070e59b4d043b47e2e095f86",
        icon: null,
        usdValue: 356.6445787358428,
      },
      {
        id: "56",
        name: "CHRP",
        value: 6,
        tokenType: "alt",
        address: "0xed00fc7d48b57b81fe65d1ce71c0985e4cf442cb",
        icon: null,
        usdValue: 2174353.403533132,
      },
      {
        id: "56",
        name: "TRIVIA",
        value: 6,
        tokenType: "alt",
        address: "0xb465f3cb6Aba6eE375E12918387DE1eaC2301B05",
        icon: null,
        usdValue: 7229.9146950539,
      },
      {
        id: "42161",
        name: "SECT",
        value: 6,
        tokenType: "alt",
        address: "0x0b63c61bba4a876a6eb8b5e596800f7649a9b71e",
        icon: null,
        usdValue: 484.5772244511053,
      },
      {
        id: "56",
        name: "STC",
        value: 6,
        tokenType: "alt",
        address: "0x340724464cf51a551106cC6657606Ee7d87B28b9",
        icon: null,
        usdValue: 27080.976148155434,
      },
      {
        id: "1",
        name: "PEAK",
        value: 6,
        tokenType: "alt",
        address: "0x630d98424efe0ea27fb1b3ab7741907dffeaad78",
        icon: null,
        usdValue: 18586.841389693145,
      },
      {
        id: "56",
        name: "JADE",
        value: 6,
        tokenType: "alt",
        address: "0x7ad7242a99f21aa543f9650a56d141c57e4f6081",
        icon: null,
        usdValue: 1022.7527527047598,
      },
      {
        id: "1",
        name: "AWC",
        value: 6,
        tokenType: "alt",
        address: "0xaD22f63404f7305e4713CcBd4F296f34770513f4",
        icon: null,
        usdValue: 3397.4419648105854,
      },
      {
        id: "1",
        name: "FLP",
        value: 6,
        tokenType: "alt",
        address: "0x3a1bda28adb5b0a812a7cf10a1950c920f79bcd3",
        icon: null,
        usdValue: 100.88586927547173,
      },
      {
        id: "1",
        name: "SHIDO",
        value: 6,
        tokenType: "alt",
        address: "0x173E552Bf97BBD50b455514ac52991Ef639ba703",
        icon: null,
        usdValue: 42.31908186886294,
      },
      {
        id: "1",
        name: "ASIA",
        value: 6,
        tokenType: "alt",
        address: "0xf519381791c03dd7666c142d4e49fd94d3536011",
        icon: null,
        usdValue: 19.894461326692394,
      },
      {
        id: "1",
        name: "HIVALHALLA",
        value: 6,
        tokenType: "alt",
        address: "0x5C0590cDE44569bf39ef79e859B367e39cB000F1",
        icon: null,
        usdValue: 154109.66244735793,
      },
      {
        id: "1",
        name: "LOC",
        value: 6,
        tokenType: "alt",
        address: "0x5e3346444010135322268a4630d2ed5f8d09446c",
        icon: null,
        usdValue: 1087.92532373821,
      },
      {
        id: "1",
        name: "HIENS3",
        value: 6,
        tokenType: "alt",
        address: "0xa88842ae47dbe87116cf7001dddd1b246fcd8262",
        icon: null,
        usdValue: 221999.52794519867,
      },
      {
        id: "1",
        name: "HIDOODLES",
        value: 6,
        tokenType: "alt",
        address: "0x3700Adfd26d5bC062cB8b8a77e68fbd43F58eCAB",
        icon: null,
        usdValue: 435957.46314424067,
      },
      {
        id: "1",
        name: "HIMOONBIRDS",
        value: 6,
        tokenType: "alt",
        address: "0x0a7b89e66a1dc16633abdfd132bae05827d3bfa5",
        icon: null,
        usdValue: 57410.70134753045,
      },
      {
        id: "1",
        name: "HIFRIENDS",
        value: 6,
        tokenType: "alt",
        address: "0xeb2f5a4e1441df330670dc7b0cf4eac0f7ab5fa5",
        icon: null,
        usdValue: 93959.08396683079,
      },
      {
        id: "1",
        name: "HIBEANZ",
        value: 6,
        tokenType: "alt",
        address: "0x23ddbd36547d43627afa9b42d4e9fb0515f48b09",
        icon: null,
        usdValue: 100988.71317852785,
      },
      {
        id: "1",
        name: "HIENS4",
        value: 6,
        tokenType: "alt",
        address: "0x00a7ec2f2b451cb0233e8adbf4c9a951027c2b02",
        icon: null,
        usdValue: 116454.02457251154,
      },
      {
        id: "1",
        name: "HISAND33",
        value: 6,
        tokenType: "alt",
        address: "0x12AEf5C60C2C86c8ECD3079f22F285f326371340",
        icon: null,
        usdValue: 45048.759155764266,
      },
      {
        id: "1",
        name: "NAO",
        value: 6,
        tokenType: "alt",
        address: "0xd049206fb408a611e543791f2d8f102a8bc253dc",
        icon: null,
        usdValue: 50364.38018829626,
      },
      {
        id: "1",
        name: "TIGER",
        value: 6,
        tokenType: "alt",
        address: "0xB83c27805aAcA5C7082eB45C868d955Cf04C337F",
        icon: null,
        usdValue: 10646.243940064776,
      },
      {
        id: "1",
        name: "PRTG",
        value: 6,
        tokenType: "alt",
        address: "0xbd04ccc050058a6a422851fa6c0f92bb65eb06ca",
        icon: null,
        usdValue: 7241209.6806000015,
      },
      {
        id: "1",
        name: "RAE",
        value: 6,
        tokenType: "alt",
        address: "0xe5a3229ccb22b6484594973a03a3851dcd948756",
        icon: null,
        usdValue: 6672.449047441463,
      },
      {
        id: "1",
        name: "NHT",
        value: 6,
        tokenType: "alt",
        address: "0x84342e932797FC62814189f01F0Fb05F52519708",
        icon: null,
        usdValue: 935092.7563313303,
      },
      {
        id: "1",
        name: "EPK",
        value: 6,
        tokenType: "alt",
        address: "0xdaf88906ac1de12ba2b1d2f7bfc94e9638ac40c4",
        icon: null,
        usdValue: 14459.672890792586,
      },
      {
        id: "1",
        name: "JT",
        value: 6,
        tokenType: "alt",
        address: "0xEb7355C2f217b3485a591332Fe13C8c5A76A581D",
        icon: null,
        usdValue: 305679.3307470233,
      },
      {
        id: "1",
        name: "ATC",
        value: 6,
        tokenType: "alt",
        address: "0x0eb3032bcac2be1fa95e296442f225edb80fc3cd",
        icon: null,
        usdValue: 333139.11419830075,
      },
      {
        id: "1",
        name: "CHS",
        value: 6,
        tokenType: "alt",
        address: "0xb41380174d0b06181513a5677b60200b93b5efb4",
        icon: null,
        usdValue: 29646.347886504755,
      },
      {
        id: "1",
        name: "BIST",
        value: 6,
        tokenType: "alt",
        address: "0x6e8908cfa881c9f6f2c64d3436e7b80b1bf0093f",
        icon: null,
        usdValue: 362999.3729487214,
      },
      {
        id: "1",
        name: "GDG",
        value: 6,
        tokenType: "alt",
        address: "0xFD020998A1bB316dfE7B136Fe59Ae4B365D79978",
        icon: null,
        usdValue: 20590.31701314,
      },
      {
        id: "1",
        name: "XIDO",
        value: 6,
        tokenType: "alt",
        address: "0xf6650117017ffd48b725b4ec5a00b414097108a7",
        icon: null,
        usdValue: 45431.661251478145,
      },
      {
        id: "1",
        name: "AWO",
        value: 6,
        tokenType: "alt",
        address: "0x68c85b9f78f30a0df5ac5723e4e700037f185415",
        icon: null,
        usdValue: 108771.14569727707,
      },
      {
        id: "1",
        name: "UNM",
        value: 6,
        tokenType: "alt",
        address: "0x6570ffe19da7e2b425329b157d9109b87f18304b",
        icon: null,
        usdValue: 33693443.78082116,
      },
      {
        id: "1",
        name: "NEXM",
        value: 6,
        tokenType: "alt",
        address: "0xe831f96a7a1dce1aa2eb760b1e296c6a74caa9d5",
        icon: null,
        usdValue: 1536807.085053545,
      },
      {
        id: "1",
        name: "ATNT",
        value: 6,
        tokenType: "alt",
        address: "0xAA2d8c9a8bd0F7945143bfD509bE3ff23dd78918",
        icon: null,
        usdValue: 399498.2098684333,
      },
      {
        id: "1",
        name: "APCG",
        value: 6,
        tokenType: "alt",
        address: "0x434Cb4fC4b952872967914D430878Eee53Ebd502",
        icon: null,
        usdValue: 28707.002773164357,
      },
      {
        id: "1",
        name: "NPICK",
        value: 6,
        tokenType: "alt",
        address: "0xc3dca8f61b275d1e88f3ea31b3e311c49f56b24b",
        icon: null,
        usdValue: 8022.217062604777,
      },
      {
        id: "1",
        name: "GOTG",
        value: 6,
        tokenType: "alt",
        address: "0xceeb07dd26b36287b6d109f0b06d7e8202ce8c1d",
        icon: null,
        usdValue: 413783.82335613086,
      },
      {
        id: "1",
        name: "OPP",
        value: 6,
        tokenType: "alt",
        address: "0xf51ccB15d3F2D304Ae6C409303e8b3a3e397A80b",
        icon: null,
        usdValue: 9578.812623340636,
      },
      {
        id: "1",
        name: "TYP",
        value: 6,
        tokenType: "alt",
        address: "0xb46eda6219ba121cE9280388e7afb7dc84be3fF2",
        icon: null,
        usdValue: 9223.522368037276,
      },
      {
        id: "1",
        name: "VRH",
        value: 6,
        tokenType: "alt",
        address: "0xead482da0793b00bbae0e34c8cfae6daf29a44b2",
        icon: null,
        usdValue: 8882.128121942727,
      },
      {
        id: "1",
        name: "SAT",
        value: 6,
        tokenType: "alt",
        address: "0x5ABf88cF3444611D13F6D1B39F3f3EE8575c91a2",
        icon: null,
        usdValue: 418945.158060165,
      },
      {
        id: "1",
        name: "ZOGI",
        value: 6,
        tokenType: "alt",
        address: "0x7e80e4d7d5725499791cf8b17a4586f1f0672a0c",
        icon: null,
        usdValue: 116940.07374408857,
      },
      {
        id: "1",
        name: "MONTE",
        value: 6,
        tokenType: "alt",
        address: "0x318Ee488AF8881f9945B6d3D69e8B395Fb559bB1",
        icon: null,
        usdValue: 518511.90944092814,
      },
      {
        id: "1",
        name: "THING",
        value: 6,
        tokenType: "alt",
        address: "0xffd822149fa6749176c7a1424e71a417f26189c8",
        icon: null,
        usdValue: 39717.72390533365,
      },
      {
        id: "1",
        name: "WITCH",
        value: 6,
        tokenType: "alt",
        address: "0xdc524e3c6910257744c1f93cf15e9f472b5bd236",
        icon: null,
        usdValue: 438907.1529048766,
      },
      {
        id: "1",
        name: "SALE",
        value: 6,
        tokenType: "alt",
        address: "0xf063fe1ab7a291c5d06a86e14730b00bf24cb589",
        icon: null,
        usdValue: 384.5076402082698,
      },
      {
        id: "137",
        name: "BIFI",
        value: 6,
        tokenType: "alt",
        address: "0xfbdd194376de19a88118e84e279b977f165d01b8",
        icon: null,
        usdValue: 10565.046887101847,
      },
      {
        id: "1",
        name: "STQ",
        value: 6,
        tokenType: "alt",
        address: "0x5c3a228510d246b78a3765c20221cbf3082b44a4",
        icon: null,
        usdValue: 2164.0412104337906,
      },
      {
        id: "1",
        name: "KDAG",
        value: 6,
        tokenType: "alt",
        address: "0x95e40e065afb3059dcabe4aaf404c1f92756603a",
        icon: null,
        usdValue: 193890.05847764274,
      },
      {
        id: "1",
        name: "CAST",
        value: 6,
        tokenType: "alt",
        address: "0x3fab0bbaa03bceaf7c49e2b12877db0142be65fc",
        icon: null,
        usdValue: 160876.7985349941,
      },
      {
        id: "1",
        name: "SEAN",
        value: 6,
        tokenType: "alt",
        address: "0xA719CB79Af39A9C10eDA2755E0938bCE35e9DE24",
        icon: null,
        usdValue: 29051.871420667372,
      },
      {
        id: "1",
        name: "LUXO",
        value: 6,
        tokenType: "alt",
        address: "0xd39a2cecba2657e125ba6a5c98ad2f6b6d7e83fd",
        icon: null,
        usdValue: 463333.46139100386,
      },
      {
        id: "1",
        name: "AMAS",
        value: 6,
        tokenType: "alt",
        address: "0x65a8fba02f641a13bb7b01d5e1129b0521004f52",
        icon: null,
        usdValue: 1422.5299332622142,
      },
      {
        id: "56",
        name: "COL",
        value: 6,
        tokenType: "alt",
        address: "0x9ce116224459296abc7858627abd5879514bc629",
        icon: null,
        usdValue: 332096.8302036969,
      },
      {
        id: "1",
        name: "WFLOW",
        value: 6,
        tokenType: "alt",
        address: "0x5c147e74d63b1d31aa3fd78eb229b65161983b2b",
        icon: null,
        usdValue: 38444.10046353659,
      },
      {
        id: "56",
        name: "TORN",
        value: 6,
        tokenType: "alt",
        address: "0x1bA8D3C4c219B124d351F603060663BD1bcd9bbF",
        icon: null,
        usdValue: 780.0597709855083,
      },
      {
        id: "1",
        name: "HMR",
        value: 6,
        tokenType: "alt",
        address: "0xb1a30851e3f7d841b231b086479608e17198363a",
        icon: null,
        usdValue: 32805.67152320867,
      },
      {
        id: "56",
        name: "FND",
        value: 6,
        tokenType: "alt",
        address: "0x264387ad73d19408e34b5d5e13a93174a35cea33",
        icon: null,
        usdValue: 1471.4019602942387,
      },
      {
        id: "5000",
        name: "USDC",
        value: 6,
        tokenType: "stable",
        address: "0x09bc4e0d864854c6afb6eb9a9cdf58ac190d0df9",
        icon: null,
        usdValue: 600269.7112547568,
      },
      {
        id: "1",
        name: "CMS",
        value: 5,
        tokenType: "alt",
        address: "0xf83301c5cd1ccbb86f466a6b3c53316ed2f8465a",
        icon: null,
        usdValue: 91.39793987905699,
      },
      {
        id: "10",
        name: "beets",
        value: 5,
        tokenType: "alt",
        address: "0x97513e975a7fa9072c72c92d8000b0db90b163c5",
        icon: null,
        usdValue: 323.98594634975325,
      },
      {
        id: "1",
        name: "LAMBO",
        value: 5,
        tokenType: "alt",
        address: "0x3d2b66bc4f9d6388bd2d97b95b565be1686aefb3",
        icon: null,
        usdValue: 48.045084935521295,
      },
      {
        id: "1",
        name: "EPAN",
        value: 5,
        tokenType: "alt",
        address: "0x72630b1e3b42874bf335020ba0249e3e9e47bafc",
        icon: null,
        usdValue: 19387.96360358541,
      },
      {
        id: "56",
        name: "ICE",
        value: 5,
        tokenType: "alt",
        address: "0xf16e81dce15b08f326220742020379b855b87df9",
        icon: null,
        usdValue: 279.8245689102106,
      },
      {
        id: "1",
        name: "FOTA",
        value: 5,
        tokenType: "alt",
        address: "0x4270bb238f6dd8b1c3ca01f96ca65b2647c06d3c",
        icon: null,
        usdValue: 866502.9716900619,
      },
      {
        id: "1",
        name: "FPIS",
        value: 5,
        tokenType: "alt",
        address: "0xc2544a32872a91f4a553b404c6950e89de901fdb",
        icon: null,
        usdValue: 349.4841984486893,
      },
      {
        id: "1",
        name: "YEL",
        value: 5,
        tokenType: "alt",
        address: "0x7815bda662050d84718b988735218cffd32f75ea",
        icon: null,
        usdValue: 11.037605684538581,
      },
      {
        id: "137",
        name: "GENE",
        value: 5,
        tokenType: "alt",
        address: "0x34667ed7c36cbbbf2d5d5c5c8d6eb76a094edb9f",
        icon: null,
        usdValue: 2176.9441200040637,
      },
      {
        id: "1",
        name: "0xBTC",
        value: 5,
        tokenType: "alt",
        address: "0xb6ed7644c69416d67b522e20bc294a9a9b405b31",
        icon: null,
        usdValue: 1026.261158685539,
      },
      {
        id: "56",
        name: "TRAVA",
        value: 5,
        tokenType: "alt",
        address: "0x0391be54e72f7e001f6bbc331777710b4f2999ef",
        icon: null,
        usdValue: 6121.615912974901,
      },
      {
        id: "1",
        name: "XFIT",
        value: 5,
        tokenType: "alt",
        address: "0x4aa41bc1649c9c3177ed16caaa11482295fc7441",
        icon: null,
        usdValue: 305.6188362566286,
      },
      {
        id: "1",
        name: "RWS",
        value: 5,
        tokenType: "alt",
        address: "0x08ad83d779bdf2bbe1ad9cc0f78aa0d24ab97802",
        icon: null,
        usdValue: 67.29397881209873,
      },
      {
        id: "1",
        name: "DXD",
        value: 5,
        tokenType: "alt",
        address: "0xa1d65e8fb6e87b60feccbc582f7f97804b725521",
        icon: null,
        usdValue: 47.588558237742525,
      },
      {
        id: "1",
        name: "XTK",
        value: 5,
        tokenType: "alt",
        address: "0x7f3edcdd180dbe4819bd98fee8929b5cedb3adeb",
        icon: null,
        usdValue: 5025.081102912621,
      },
      {
        id: "1",
        name: "CXO",
        value: 5,
        tokenType: "alt",
        address: "0xb6ee9668771a79be7967ee29a63d4184f8097143",
        icon: null,
        usdValue: 2236.3026238550697,
      },
      {
        id: "1",
        name: "UNV",
        value: 5,
        tokenType: "alt",
        address: "0xf009f5531de69067435e32c4b9d36077f4c4a673",
        icon: null,
        usdValue: 589.2613544015547,
      },
      {
        id: "56",
        name: "SNP",
        value: 5,
        tokenType: "alt",
        address: "0x6911F552842236bd9E8ea8DDBB3fb414e2C5FA9d",
        icon: null,
        usdValue: 1585.2040209603497,
      },
      {
        id: "56",
        name: "WONE",
        value: 5,
        tokenType: "alt",
        address: "0x03fF0ff224f904be3118461335064bB48Df47938",
        icon: null,
        usdValue: 132.58495877550476,
      },
      {
        id: "56",
        name: "MONO",
        value: 5,
        tokenType: "alt",
        address: "0xD4099A517f2Fbe8a730d2ECaad1D0824B75e084a",
        icon: null,
        usdValue: 13.639045728955402,
      },
      {
        id: "56",
        name: "GOIN",
        value: 5,
        tokenType: "alt",
        address: "0x32ff208a18A5fbC81F6Fd262020b1415bfcb3b33",
        icon: null,
        usdValue: 74.4589949046154,
      },
      {
        id: "137",
        name: "BULL",
        value: 5,
        tokenType: "alt",
        address: "0x9f95e17b2668afe01f8fbd157068b0a4405cc08d",
        icon: null,
        usdValue: 182.12546344021615,
      },
      {
        id: "56",
        name: "SHEESHA",
        value: 5,
        tokenType: "alt",
        address: "0x232fb065d9d24c34708eedbf03724f2e95abe768",
        icon: null,
        usdValue: 243.83605960286755,
      },
      {
        id: "137",
        name: "WNT",
        value: 5,
        tokenType: "alt",
        address: "0x82a0e6c02b91ec9f6ff943c0a933c03dbaa19689",
        icon: null,
        usdValue: 25.63435530713681,
      },
      {
        id: "56",
        name: "ETHPAD",
        value: 5,
        tokenType: "alt",
        address: "0x8db1d28ee0d822367af8d220c0dc7cb6fe9dc442",
        icon: null,
        usdValue: 24.81935386066654,
      },
      {
        id: "1",
        name: "CWAP",
        value: 5,
        tokenType: "alt",
        address: "0xe74dc43867e0cbeb208f1a012fc60dcbbf0e3044",
        icon: null,
        usdValue: 28.665736962507527,
      },
      {
        id: "1",
        name: "PLSD",
        value: 5,
        tokenType: "alt",
        address: "0x34f0915a5f15a66eba86f6a58be1a471fb7836a7",
        icon: null,
        usdValue: 250.17633381705286,
      },
      {
        id: "56",
        name: "NEOFI",
        value: 5,
        tokenType: "alt",
        address: "0xa1578bdcd26773e16631Ac626803Bf388449c53c",
        icon: null,
        usdValue: 245.53772912594434,
      },
      {
        id: "56",
        name: "COGI",
        value: 5,
        tokenType: "alt",
        address: "0x6cb755c4b82e11e727c05f697c790fdbc4253957",
        icon: null,
        usdValue: 169.20070743472598,
      },
      {
        id: "56",
        name: "AGV",
        value: 5,
        tokenType: "alt",
        address: "0xf4f618eff5ef36cde2fca4fbd86554c62fb1382b",
        icon: null,
        usdValue: 43.17409276612564,
      },
      {
        id: "56",
        name: "RGEN",
        value: 5,
        tokenType: "alt",
        address: "0x25382fb31e4b22e0ea09cb0761863df5ad97ed72",
        icon: null,
        usdValue: 55.95252082664874,
      },
      {
        id: "1",
        name: "CHX",
        value: 5,
        tokenType: "alt",
        address: "0x1460a58096d80a50a2F1f956DDA497611Fa4f165",
        icon: null,
        usdValue: 47.45962121465291,
      },
      {
        id: "56",
        name: "EBOX",
        value: 5,
        tokenType: "alt",
        address: "0x33840024177a7daca3468912363bed8b425015c5",
        icon: null,
        usdValue: 1666.4198578285195,
      },
      {
        id: "1",
        name: "XIV",
        value: 5,
        tokenType: "alt",
        address: "0x44f262622248027f8e2a8fb1090c4cf85072392c",
        icon: null,
        usdValue: 116.23804701538054,
      },
      {
        id: "42161",
        name: "HDX",
        value: 5,
        tokenType: "alt",
        address: "0xf4fe727c855c2d395852ca43f645cab4b504af23",
        icon: null,
        usdValue: 401048.2439207287,
      },
      {
        id: "56",
        name: "AFP",
        value: 5,
        tokenType: "alt",
        address: "0x9a3321e1acd3b9f6debee5e042dd2411a1742002",
        icon: null,
        usdValue: 11225.502640288309,
      },
      {
        id: "56",
        name: "MESA",
        value: 5,
        tokenType: "alt",
        address: "0xb192d5fc358d35194282a1a06814aba006198010",
        icon: null,
        usdValue: 57.68747122411179,
      },
      {
        id: "137",
        name: "UGT",
        value: 5,
        tokenType: "alt",
        address: "0xBa4c54Ea2d66b904C82847A7d2357d22B857E812",
        icon: null,
        usdValue: 16.903697408744,
      },
      {
        id: "1",
        name: "DEFIT",
        value: 5,
        tokenType: "alt",
        address: "0x84cffa78b2fbbeec8c37391d2b12a04d2030845e",
        icon: null,
        usdValue: 106.80207605788144,
      },
      {
        id: "1",
        name: "STF",
        value: 5,
        tokenType: "alt",
        address: "0x1f4cb968b76931c494ff92ed80ccb169ad641cb1",
        icon: null,
        usdValue: 544.4277861022102,
      },
      {
        id: "1",
        name: "NIOX",
        value: 5,
        tokenType: "alt",
        address: "0xc813ea5e3b48bebeedb796ab42a30c5599b01740",
        icon: null,
        usdValue: 66.28879020950784,
      },
      {
        id: "1",
        name: "SPARK",
        value: 5,
        tokenType: "alt",
        address: "0x5f5c86a9f8aaf63ce27b82fab3b33df73cbc3d12",
        icon: null,
        usdValue: 1723.9973798471894,
      },
      {
        id: "56",
        name: "YAY",
        value: 5,
        tokenType: "alt",
        address: "0x524df384bffb18c0c8f3f43d012011f8f9795579",
        icon: null,
        usdValue: 57.68769745732425,
      },
      {
        id: "56",
        name: "BPAD",
        value: 5,
        tokenType: "alt",
        address: "0x29132062319aa375e764ef8ef756f2b28c77a9c9",
        icon: null,
        usdValue: 187.03918496580798,
      },
      {
        id: "56",
        name: "WANA",
        value: 5,
        tokenType: "alt",
        address: "0x339c72829ab7dd45c3c52f965e7abe358dd8761e",
        icon: null,
        usdValue: 124.31528379,
      },
      {
        id: "56",
        name: "TRY",
        value: 5,
        tokenType: "alt",
        address: "0x75d107de2217ffe2cd574a1b3297c70c8fafd159",
        icon: null,
        usdValue: 23.592379949157863,
      },
      {
        id: "137",
        name: "ALGB",
        value: 5,
        tokenType: "alt",
        address: "0x0169eC1f8f639B32Eec6D923e24C2A2ff45B9DD6",
        icon: null,
        usdValue: 9710.2375452139,
      },
      {
        id: "1",
        name: "EIGEN",
        value: 5,
        tokenType: "alt",
        address: "0xec53bf9167f50cdeb3ae105f56099aaab9061f83",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "CHEESUS",
        value: 5,
        tokenType: "alt",
        address: "0x736a9964c921b75d9fb94f30cdfed8bd5be43d0e",
        icon: null,
        usdValue: 37.7054078380923,
      },
      {
        id: "56",
        name: "GEAR",
        value: 5,
        tokenType: "alt",
        address: "0xb4404DaB7C0eC48b428Cf37DeC7fb628bcC41B36",
        icon: null,
        usdValue: 273.98436895449515,
      },
      {
        id: "56",
        name: "ARENA",
        value: 5,
        tokenType: "alt",
        address: "0x2a17dc11a1828725cdb318e0036acf12727d27a2",
        icon: null,
        usdValue: 14.3757308350816,
      },
      {
        id: "56",
        name: "LQT",
        value: 5,
        tokenType: "alt",
        address: "0xbd2c43da85d007b0b3cd856fd55c299578d832bc",
        icon: null,
        usdValue: 125.41567105772998,
      },
      {
        id: "1",
        name: "MEGA",
        value: 5,
        tokenType: "alt",
        address: "0x1892f6ff5fbe11c31158f8c6f6f6e33106c5b10e",
        icon: null,
        usdValue: 493.84532233550505,
      },
      {
        id: "1",
        name: "OIO",
        value: 5,
        tokenType: "alt",
        address: "0xa3efef1a1e3d1ad72b9d0f4253e7c9c084c2c08b",
        icon: null,
        usdValue: 34.82812051535721,
      },
      {
        id: "1",
        name: "ARCONA",
        value: 5,
        tokenType: "alt",
        address: "0x0f71b8de197a1c84d31de0f1fa7926c365f052b3",
        icon: null,
        usdValue: 769.1926738221983,
      },
      {
        id: "1",
        name: "WONE",
        value: 5,
        tokenType: "alt",
        address: "0xD5cd84D6f044AbE314Ee7E414d37cae8773ef9D3",
        icon: null,
        usdValue: 337.28063307674415,
      },
      {
        id: "56",
        name: "CALO",
        value: 5,
        tokenType: "alt",
        address: "0xb6b91269413b6b99242b1c0bc611031529999999",
        icon: null,
        usdValue: 1759.0322826976762,
      },
      {
        id: "10",
        name: "ldo",
        value: 5,
        tokenType: "alt",
        address: "0xfdb794692724153d1488ccdbe0c56c252596735f",
        icon: null,
        usdValue: 41905.09805210631,
      },
      {
        id: "1",
        name: "ROYA",
        value: 5,
        tokenType: "alt",
        address: "0x7eaf9c89037e4814dc0d9952ac7f888c784548db",
        icon: null,
        usdValue: 55.677359668769355,
      },
      {
        id: "1",
        name: "ONES",
        value: 5,
        tokenType: "alt",
        address: "0x0b342c51d1592c41068d5d4b4da4a68c0a04d5a4",
        icon: null,
        usdValue: 1699.319324196298,
      },
      {
        id: "56",
        name: "WNK",
        value: 5,
        tokenType: "alt",
        address: "0xb160a5f19ebccd8e0549549327e43ddd1d023526",
        icon: null,
        usdValue: 1363.950830896104,
      },
      {
        id: "137",
        name: "SFL",
        value: 5,
        tokenType: "alt",
        address: "0xd1f9c58e33933a993a3891f8acfe05a68e1afc05",
        icon: null,
        usdValue: 16263.799410844971,
      },
      {
        id: "1",
        name: "VNLNK",
        value: 5,
        tokenType: "alt",
        address: "0x0f1e49d6dcfc9eefcce9d5ae3c660f8ead75061a",
        icon: null,
        usdValue: 526.3449573411617,
      },
      {
        id: "1",
        name: "CV",
        value: 5,
        tokenType: "alt",
        address: "0x50bc2ecc0bfdf5666640048038c1aba7b7525683",
        icon: null,
        usdValue: 244.74129061105324,
      },
      {
        id: "1",
        name: "TR3",
        value: 5,
        tokenType: "alt",
        address: "0xF61BF4d1A948487d61b8fa63808AAC06bda55F98",
        icon: null,
        usdValue: 4885.731675811732,
      },
      {
        id: "1",
        name: "SAIL",
        value: 5,
        tokenType: "alt",
        address: "0xd8f1460044925d2d5c723c7054cd9247027415b7",
        icon: null,
        usdValue: 12.273742811459062,
      },
      {
        id: "1",
        name: "Blur Pool",
        value: 5,
        tokenType: "alt",
        address: "0x0000000000a39bb272e79075ade125fd351887ac",
        icon: null,
        usdValue: 0.6137025,
      },
      {
        id: "1",
        name: "agEUREUROC-f",
        value: 5,
        tokenType: "alt",
        address: "0xba3436fd341f2c8a928452db3c5a3670d1d5cc73",
        icon: null,
        usdValue: 41.74434454463697,
      },
      {
        id: "42161",
        name: "SWPR",
        value: 5,
        tokenType: "alt",
        address: "0xde903e2712288a1da82942dddf2c20529565ac30",
        icon: null,
        usdValue: 0.0001956768161154088,
      },
      {
        id: "42161",
        name: "WOM",
        value: 5,
        tokenType: "alt",
        address: "0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96",
        icon: null,
        usdValue: 2.748567583290302e-10,
      },
      {
        id: "42161",
        name: "JOE",
        value: 5,
        tokenType: "alt",
        address: "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07",
        icon: null,
        usdValue: 3.040680979745529e-18,
      },
      {
        id: "42161",
        name: "ARBK",
        value: 5,
        tokenType: "alt",
        address: "0xa8258c76506e0f56fdb9e9d0577a802cae4cecfc",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "LSDOGE",
        value: 5,
        tokenType: "alt",
        address: "0x4c70d32295de15fdf302d3bcbb7fc2631ace1c91",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "BRC",
        value: 5,
        tokenType: "alt",
        address: "0xb5de3f06af62d8428a8bf7b4400ea42ad2e0bc53",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "HOP-LP-USDC",
        value: 5,
        tokenType: "alt",
        address: "0xb67c014fa700e69681a673876eb8bafaa36bff71",
        icon: null,
        usdValue: 0.015207643121083744,
      },
      {
        id: "42161",
        name: "TLIP",
        value: 5,
        tokenType: "alt",
        address: "0xc385267adfb56fa7608c3d509d368fd84c033613",
        icon: null,
        usdValue: 0.16076261335258882,
      },
      {
        id: "42161",
        name: "Claim $DPX airdrop at https://dopexhub.com",
        value: 5,
        tokenType: "alt",
        address: "0x0be7dff0b9bf9d68ce1b1879e047dfa8c3ff31d6",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "SLP",
        value: 5,
        tokenType: "alt",
        address: "0x905dfcd5649217c42684f23958568e533c711aa3",
        icon: null,
        usdValue: 107.29926196401894,
      },
      {
        id: "42161",
        name: "XDOG",
        value: 5,
        tokenType: "alt",
        address: "0xb07d1a2c55e4973723b11278d6ffaa7c04b73a2e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "PNP",
        value: 5,
        tokenType: "alt",
        address: "0x2ac2b254bc18cd4999f64773a966e4f4869c34ee",
        icon: null,
        usdValue: 8.721537748877523,
      },
      {
        id: "42161",
        name: "mWOM",
        value: 5,
        tokenType: "alt",
        address: "0x509fd25ee2ac7833a017f17ee8a6fb4aaf947876",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "HOOT",
        value: 5,
        tokenType: "alt",
        address: "0x558bd058a9ac4ffe5b51d4dd61019d18dab8844d",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "gBRC",
        value: 5,
        tokenType: "alt",
        address: "0x62c7e128e7c3205964429f58a0c6f63a776d10d1",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "HFWC1",
        value: 5,
        tokenType: "alt",
        address: "0x6d6768a0b24299bede0492a4571d79f535c330d8",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "mPendle",
        value: 5,
        tokenType: "alt",
        address: "0xb688ba096b7bb75d7841e47163cd12d18b36a5bf",
        icon: null,
        usdValue: 9.234051308959831,
      },
      {
        id: "42161",
        name: "HOP-LP-USDT",
        value: 5,
        tokenType: "alt",
        address: "0xce3b19d820cb8b9ae370e423b0a329c4314335fe",
        icon: null,
        usdValue: 0.05270577244533072,
      },
      {
        id: "10",
        name: "bal",
        value: 5,
        tokenType: "alt",
        address: "0xfe8b128ba8c78aabc59d4c64cee7ff28e9379921",
        icon: null,
        usdValue: 36.861150207261105,
      },
      {
        id: "137",
        name: "FXS",
        value: 5,
        tokenType: "alt",
        address: "0x1a3acf6D19267E2d3e7f898f42803e90C9219062",
        icon: null,
        usdValue: 11.397757532187017,
      },
      {
        id: "1284",
        name: "GLMR",
        value: 5,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 23.99948301772885,
      },
      {
        id: "10",
        name: "psp",
        value: 5,
        tokenType: "alt",
        address: "0xd3594e879b358f430e20f82bea61e83562d49d48",
        icon: null,
        usdValue: 10.695318401466116,
      },
      {
        id: "59144",
        name: "ETH",
        value: 5,
        tokenType: "native",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
        icon: null,
        usdValue: 33.78777034083911,
      },
      {
        id: "56",
        name: "WELT",
        value: 5,
        tokenType: "alt",
        address: "0x1785113910847770290F5F840b4c74fc46451201",
        icon: null,
        usdValue: 50779.92195025804,
      },
      {
        id: "169",
        name: "MANTA",
        value: 5,
        tokenType: "alt",
        address: "0x95cef13441be50d20ca4558cc0a27b601ac544e5",
        icon: null,
        usdValue: 392236.52382534166,
      },
      {
        id: "8453",
        name: "mfer",
        value: 5,
        tokenType: "alt",
        address: "0xe3086852a4b125803c815a158249ae468a3254ca",
        icon: null,
        usdValue: 88655.41787622396,
      },
      {
        id: "8453",
        name: "AERO",
        value: 5,
        tokenType: "alt",
        address: "0x940181a94a35a4569e4529a3cdfb74e38fd98631",
        icon: null,
        usdValue: 199888.42064963395,
      },
      {
        id: "8453",
        name: "AYB",
        value: 5,
        tokenType: "alt",
        address: "0x7ed613ab8b2b4c6a781ddc97ea98a666c6437511",
        icon: null,
        usdValue: 15.799999999999999,
      },
      {
        id: "8453",
        name: "BRETT",
        value: 5,
        tokenType: "alt",
        address: "0x532f27101965dd16442e59d40670faf5ebb142e4",
        icon: null,
        usdValue: 865431.7229606074,
      },
      {
        id: "8453",
        name: "DOG",
        value: 5,
        tokenType: "alt",
        address: "0xafb89a09d82fbde58f18ac6437b3fc81724e4df6",
        icon: null,
        usdValue: 316.67817031944105,
      },
      {
        id: "8453",
        name: "HIGHER",
        value: 5,
        tokenType: "alt",
        address: "0x0578d8a44db98b23bf096a382e016e29a5ce0ffe",
        icon: null,
        usdValue: 476701.97979024384,
      },
      {
        id: "8453",
        name: "NORMIE",
        value: 5,
        tokenType: "alt",
        address: "0x7f12d13b34f5f4f0a9449c16bcd42f0da47af200",
        icon: null,
        usdValue: 68176567.74405019,
      },
      {
        id: "8453",
        name: "NPC",
        value: 5,
        tokenType: "alt",
        address: "0xb166e8b140d35d9d8226e40c09f757bac5a4d87d",
        icon: null,
        usdValue: 36812.936520600095,
      },
      {
        id: "8453",
        name: "SEAM",
        value: 5,
        tokenType: "alt",
        address: "0x1c7a460413dd4e964f96d8dfc56e7223ce88cd85",
        icon: null,
        usdValue: 380170.06610473245,
      },
      {
        id: "8453",
        name: "TOSHI",
        value: 5,
        tokenType: "alt",
        address: "0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4",
        icon: null,
        usdValue: 328050.93285362027,
      },
      {
        id: "8453",
        name: "USDC",
        value: 5,
        tokenType: "stable",
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        icon: null,
        usdValue: 705060.7071573334,
      },
      {
        id: "8453",
        name: "VIRTUAL",
        value: 5,
        tokenType: "alt",
        address: "0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b",
        icon: null,
        usdValue: 241120.85856540437,
      },
      {
        id: "81457",
        name: "YES",
        value: 5,
        tokenType: "alt",
        address: "0x20fe91f17ec9080e3cac2d688b4ecb48c5ac3a9c",
        icon: null,
        usdValue: 90028.7142001806,
      },
      {
        id: "1",
        name: "GMB",
        value: 5,
        tokenType: "alt",
        address: "0xa0008f510fe9ee696e7e320c9e5cbf61e27791ee",
        icon: null,
        usdValue: 277.83777615778564,
      },
      {
        id: "1",
        name: "UBXT",
        value: 5,
        tokenType: "alt",
        address: "0x8564653879a18c560e7c0ea0e084c516c62f5653",
        icon: null,
        usdValue: 787108.6235396658,
      },
      {
        id: "56",
        name: "GINOA",
        value: 5,
        tokenType: "alt",
        address: "0x2ff90b0c29ededdaf11c847925ea4a17789e88c3",
        icon: null,
        usdValue: 281605.1695401961,
      },
      {
        id: "56",
        name: "SHIBLITE",
        value: 5,
        tokenType: "alt",
        address: "0x76ef2a25b1ea6eb5dc4d079ae82c767d55b0a99e",
        icon: null,
        usdValue: 181.38113793917728,
      },
      {
        id: "1",
        name: "MARVIN",
        value: 5,
        tokenType: "alt",
        address: "0xcaa9ed6d7502595b555113d4517668ae24038c8a",
        icon: null,
        usdValue: 45.1277643377828,
      },
      {
        id: "1",
        name: "HIODBS",
        value: 5,
        tokenType: "alt",
        address: "0x33bD66c334274989b673a8e8C8d1A3f1B8De5889",
        icon: null,
        usdValue: 225024.19871987312,
      },
      {
        id: "1",
        name: "HIMFERS",
        value: 5,
        tokenType: "alt",
        address: "0xB755D5bC7de83232b9df1886bD5CdB38895933B0",
        icon: null,
        usdValue: 92602.68721179228,
      },
      {
        id: "1",
        name: "HIRENGA",
        value: 5,
        tokenType: "alt",
        address: "0x1de852cd18323bc5ebda842b8eef46c6e551aa47",
        icon: null,
        usdValue: 27617.96778095815,
      },
      {
        id: "1",
        name: "XIDR",
        value: 5,
        tokenType: "alt",
        address: "0xebF2096E01455108bAdCbAF86cE30b6e5A72aa52",
        icon: null,
        usdValue: 991.4183887517241,
      },
      {
        id: "1",
        name: "MANC",
        value: 5,
        tokenType: "alt",
        address: "0xe0c05ec44775e4ad62cdc2eecdf337aa7a143363",
        icon: null,
        usdValue: 414122.51090253994,
      },
      {
        id: "1",
        name: "FLOOR",
        value: 5,
        tokenType: "alt",
        address: "0xf59257e961883636290411c11ec5ae622d19455e",
        icon: null,
        usdValue: 5758.254575421929,
      },
      {
        id: "1",
        name: "VALOR",
        value: 5,
        tokenType: "alt",
        address: "0x297e4e5e59ad72b1b0a2fd446929e76117be0e0a",
        icon: null,
        usdValue: 15455.882731657355,
      },
      {
        id: "1",
        name: "ARTEQ",
        value: 5,
        tokenType: "alt",
        address: "0x805C2077f3ab224D889f9c3992B41B2F4722c787",
        icon: null,
        usdValue: 23889.30747288,
      },
      {
        id: "1",
        name: "YVS",
        value: 5,
        tokenType: "alt",
        address: "0xEC681F28f4561c2a9534799AA38E0d36A83Cf478",
        icon: null,
        usdValue: 18107.302619709222,
      },
      {
        id: "1",
        name: "ASKO",
        value: 5,
        tokenType: "alt",
        address: "0xeEEE2a622330E6d2036691e983DEe87330588603",
        icon: null,
        usdValue: 40.82024319663701,
      },
      {
        id: "1",
        name: "BNF",
        value: 5,
        tokenType: "alt",
        address: "0x1DE5e000C41C8d35b9f1f4985C23988f05831057",
        icon: null,
        usdValue: 5099.272286061334,
      },
      {
        id: "1",
        name: "ARTIC",
        value: 5,
        tokenType: "alt",
        address: "0xe83d5fb2c60b3a2597452e248cf7b2f52a7e731e",
        icon: null,
        usdValue: 2432.408750359041,
      },
      {
        id: "1",
        name: "PETS",
        value: 5,
        tokenType: "alt",
        address: "0x6afcff9189e8ed3fcc1cffa184feb1276f6a82a5",
        icon: null,
        usdValue: 585.7700502940785,
      },
      {
        id: "1",
        name: "DSP",
        value: 5,
        tokenType: "alt",
        address: "0x8c661806f716652b637728355cc4e2620d428f99",
        icon: null,
        usdValue: 166943.75142268848,
      },
      {
        id: "1",
        name: "SUZUME",
        value: 5,
        tokenType: "alt",
        address: "0x0b452278223d3954f4ac050949d7998e373e7e43",
        icon: null,
        usdValue: 14361.610506136973,
      },
      {
        id: "1",
        name: "KOY",
        value: 5,
        tokenType: "alt",
        address: "0x198065e69a86cb8a9154b333aad8efe7a3c256f8",
        icon: null,
        usdValue: 337790.3533764884,
      },
      {
        id: "1",
        name: "SPGBB",
        value: 5,
        tokenType: "alt",
        address: "0x64551fA4093c2D6c298cf1792740F884084a8F69",
        icon: null,
        usdValue: 23828.096307797285,
      },
      {
        id: "1",
        name: "ABL",
        value: 5,
        tokenType: "alt",
        address: "0xf8b358b3397a8ea5464f8cc753645d42e14b79ea",
        icon: null,
        usdValue: 128.6224421643803,
      },
      {
        id: "1",
        name: "THE9",
        value: 5,
        tokenType: "alt",
        address: "0xefd113cea2f656fe7899a25a06243a6e40406e08",
        icon: null,
        usdValue: 1967790.0032694547,
      },
      {
        id: "1",
        name: "AIT",
        value: 5,
        tokenType: "alt",
        address: "0x79650799e7899a802cb96c0bc33a6a8d4ce4936c",
        icon: null,
        usdValue: 42.646314662884215,
      },
      {
        id: "1",
        name: "EXE",
        value: 5,
        tokenType: "alt",
        address: "0x412d397ddca07d753e3e0c61e367fb1b474b3e7d",
        icon: null,
        usdValue: 11.022717455651213,
      },
      {
        id: "1",
        name: "GNY",
        value: 5,
        tokenType: "alt",
        address: "0xb1f871ae9462f1b2c6826e88a7827e76f86751d4",
        icon: null,
        usdValue: 32874.61380820816,
      },
      {
        id: "1",
        name: "CIV",
        value: 5,
        tokenType: "alt",
        address: "0x37fe0f067fa808ffbdd12891c0858532cfe7361d",
        icon: null,
        usdValue: 611.8233435452772,
      },
      {
        id: "1",
        name: "CMCX",
        value: 5,
        tokenType: "alt",
        address: "0x5b685863494c33f344081f75e5430c260c224a32",
        icon: null,
        usdValue: 5015.019464016955,
      },
      {
        id: "1",
        name: "FLZ",
        value: 5,
        tokenType: "alt",
        address: "0x8e964e35a76103af4c7d7318e1b1a82c682ae296",
        icon: null,
        usdValue: 2493402.6131702075,
      },
      {
        id: "1",
        name: "ONG",
        value: 5,
        tokenType: "alt",
        address: "0xd341d1680eeee3255b8c4c75bcce7eb57f144dae",
        icon: null,
        usdValue: 28.658879106354888,
      },
      {
        id: "1",
        name: "CORX",
        value: 5,
        tokenType: "alt",
        address: "0x26a604DFFE3ddaB3BEE816097F81d3C4a2A4CF97",
        icon: null,
        usdValue: 70.87508779737333,
      },
      {
        id: "1",
        name: "PILOT",
        value: 5,
        tokenType: "alt",
        address: "0x37c997b35c619c21323f3518b9357914e8b99525",
        icon: null,
        usdValue: 541.6980440901522,
      },
      {
        id: "1",
        name: "DBX",
        value: 5,
        tokenType: "alt",
        address: "0x3cbc780d2934d55a06069e837fabd3e6fc23dab0",
        icon: null,
        usdValue: 11681.939498300493,
      },
      {
        id: "137",
        name: "WOMBAT",
        value: 5,
        tokenType: "alt",
        address: "0x0c9c7712c83b3c70e7c5e11100d33d9401bdf9dd",
        icon: null,
        usdValue: 9110.197478822547,
      },
      {
        id: "137",
        name: "WOO",
        value: 5,
        tokenType: "alt",
        address: "0x1B815d120B3eF02039Ee11dC2d33DE7aA4a8C603",
        icon: null,
        usdValue: 4903761.539907233,
      },
      {
        id: "1",
        name: "SHANG",
        value: 5,
        tokenType: "alt",
        address: "0xee772cec929d8430b4fa7a01cd7fbd159a68aa83",
        icon: null,
        usdValue: 299.1253751432716,
      },
      {
        id: "1",
        name: "DEFY",
        value: 5,
        tokenType: "alt",
        address: "0x205eD31C867bF715E4182137Af95AFE9177Cd8E7",
        icon: null,
        usdValue: 121190.94405480551,
      },
      {
        id: "56",
        name: "OKG",
        value: 5,
        tokenType: "alt",
        address: "0x7758a52c1Bb823d02878B67aD87B6bA37a0CDbF5",
        icon: null,
        usdValue: 60893.80613075454,
      },
      {
        id: "56",
        name: "3P",
        value: 5,
        tokenType: "alt",
        address: "0xB806FA32eBDC04E5Dbdd2ad83E75C8F7D8E8ef8b",
        icon: null,
        usdValue: 252661.21271537273,
      },
      {
        id: "56",
        name: "HEC",
        value: 5,
        tokenType: "alt",
        address: "0x638eebe886b0e9e7c6929e69490064a6c94d204d",
        icon: null,
        usdValue: 7.240000000000001,
      },
      {
        id: "56",
        name: "MMC",
        value: 5,
        tokenType: "alt",
        address: "0xbe3fd4d1e0d244ddd98686a28f67355efe223346",
        icon: null,
        usdValue: 409298.4518122891,
      },
      {
        id: "56",
        name: "ANTEX",
        value: 5,
        tokenType: "alt",
        address: "0xCA1aCAB14e85F30996aC83c64fF93Ded7586977C",
        icon: null,
        usdValue: 2686.3690847499997,
      },
      {
        id: "56",
        name: "DRIV",
        value: 5,
        tokenType: "alt",
        address: "0x461dab902f38210b42b7d8b4bfc71296e0629006",
        icon: null,
        usdValue: 7408.808621359756,
      },
      {
        id: "56",
        name: "KENKA",
        value: 5,
        tokenType: "alt",
        address: "0x578300CC8db63F871643307D553E485982E4f2C1",
        icon: null,
        usdValue: 22.483851975,
      },
      {
        id: "137",
        name: "COT",
        value: 5,
        tokenType: "alt",
        address: "0x8d520c8e66091cfd6743fe37fbe3a09505616c4b",
        icon: null,
        usdValue: 539811.7920923209,
      },
      {
        id: "137",
        name: "BEAT",
        value: 5,
        tokenType: "alt",
        address: "0xb78cf9ac0f47f1d69cba861deda29814d285c834",
        icon: null,
        usdValue: 7.8981826,
      },
      {
        id: "1",
        name: "QTF",
        value: 5,
        tokenType: "alt",
        address: "0x0fcbc31c503b4a9ed90e87f8ff46c318a4a14260",
        icon: null,
        usdValue: 3962432.7722009113,
      },
      {
        id: "1",
        name: "CCX",
        value: 5,
        tokenType: "alt",
        address: "0x1D6405138A335cE5FD7364086334EfB3E4F28B59",
        icon: null,
        usdValue: 121955.49691404408,
      },
      {
        id: "137",
        name: "claim rewards on blast2l.com",
        value: 5,
        tokenType: "alt",
        address: "0x72c9074565879ce29a69b53a6aa6abed3a33c129",
        icon: null,
        usdValue: 0,
      },
      {
        id: "5000",
        name: "mETH",
        value: 5,
        tokenType: "alt",
        address: "0xcda86a272531e8640cd7f1a92c01839911b90bb0",
        icon: null,
        usdValue: 61549.74960180402,
      },
      {
        id: "42161",
        name: "ERC1967Proxy",
        value: 5,
        tokenType: "alt",
        address: "0xACC51FFDeF63fB0c014c882267C3A17261A5eD50",
        icon: null,
        usdValue: 10973.019474949286,
      },
      {
        id: "56",
        name: "POV",
        value: 4,
        tokenType: "alt",
        address: "0xc2eaAf69e6439AbaB12dD21f560bA0EC7f17CFf7",
        icon: null,
        usdValue: 5.348158547529637,
      },
      {
        id: "1",
        name: "AIR",
        value: 4,
        tokenType: "alt",
        address: "0x27dce1ec4d3f72c3e457cc50354f1f975ddef488",
        icon: null,
        usdValue: 25.525357,
      },
      {
        id: "137",
        name: "TECH",
        value: 4,
        tokenType: "alt",
        address: "0x6286A9e6f7e745A6D884561D88F94542d6715698",
        icon: null,
        usdValue: 73.30945029072839,
      },
      {
        id: "1",
        name: "LQD",
        value: 4,
        tokenType: "alt",
        address: "0xD29F0b5b3F50b07Fe9a9511F7d86F4f4bAc3f8c4",
        icon: null,
        usdValue: 6.02687512622,
      },
      {
        id: "10",
        name: "lusd",
        value: 4,
        tokenType: "stable",
        address: "0xc40f949f8a4e094d1b49a23ea9241d289b7b2819",
        icon: null,
        usdValue: 30754.9907333066,
      },
      {
        id: "1",
        name: "FWT",
        value: 4,
        tokenType: "alt",
        address: "0x20e7125677311fca903a8897042b9983f22ea295",
        icon: null,
        usdValue: 57.401151529021384,
      },
      {
        id: "1",
        name: "BLXM",
        value: 4,
        tokenType: "alt",
        address: "0x38d9eb07a7b8df7d86f440a4a5c4a4c1a27e1a08",
        icon: null,
        usdValue: 86515.27945043381,
      },
      {
        id: "56",
        name: "FOC",
        value: 4,
        tokenType: "alt",
        address: "0x3051CFb958dcD408FBa70256073Adba943Fdf552",
        icon: null,
        usdValue: 33.526518689334544,
      },
      {
        id: "56",
        name: "REVA",
        value: 4,
        tokenType: "alt",
        address: "0x4FdD92Bd67Acf0676bfc45ab7168b3996F7B4A3B",
        icon: null,
        usdValue: 19.677343868330706,
      },
      {
        id: "56",
        name: "BUNNY",
        value: 4,
        tokenType: "alt",
        address: "0xc9849e6fdb743d08faee3e34dd2d1bc69ea11a51",
        icon: null,
        usdValue: 33.6678576750768,
      },
      {
        id: "42161",
        name: "BBO",
        value: 4,
        tokenType: "alt",
        address: "0x86efb351b092A32D833a1Ad7374d9BF0fc164aAb",
        icon: null,
        usdValue: 734555.8468235128,
      },
      {
        id: "1",
        name: "OOE",
        value: 4,
        tokenType: "alt",
        address: "0x7778360f035c589fce2f4ea5786cbd8b36e5396b",
        icon: null,
        usdValue: 209.3201686184199,
      },
      {
        id: "10",
        name: "frxeth",
        value: 4,
        tokenType: "alt",
        address: "0x6806411765af15bddd26f8f544a34cc40cb9838b",
        icon: null,
        usdValue: 26.258540826848787,
      },
      {
        id: "1",
        name: "HER",
        value: 4,
        tokenType: "alt",
        address: "0x5c2975269e74cb3a8514e5b800a1e66c694d4df8",
        icon: null,
        usdValue: 1556.4005213873613,
      },
      {
        id: "42161",
        name: "NISHIB",
        value: 4,
        tokenType: "alt",
        address: "0x4DAD357726b41bb8932764340ee9108cC5AD33a0",
        icon: null,
        usdValue: 54.060793256353364,
      },
      {
        id: "1",
        name: "BTT",
        value: 4,
        tokenType: "alt",
        address: "0xc669928185dbce49d2230cc9b0979be6dc797957",
        icon: null,
        usdValue: 17.81434663957041,
      },
      {
        id: "1",
        name: "HMX",
        value: 4,
        tokenType: "alt",
        address: "0xb012be90957d70d9a070918027655f998c123a88",
        icon: null,
        usdValue: 11.317954405469388,
      },
      {
        id: "137",
        name: "MILK",
        value: 4,
        tokenType: "alt",
        address: "0x1599fe55cda767b1f631ee7d414b41f5d6de393d",
        icon: null,
        usdValue: 64.15706395078507,
      },
      {
        id: "1",
        name: "IHF",
        value: 4,
        tokenType: "alt",
        address: "0xaf1250fa68d7decd34fd75de8742bc03b29bd58e",
        icon: null,
        usdValue: 10320.929332712285,
      },
      {
        id: "1",
        name: "ASTRO",
        value: 4,
        tokenType: "alt",
        address: "0x7b22938ca841aa392c93dbb7f4c42178e3d65e88",
        icon: null,
        usdValue: 1146.8721237113798,
      },
      {
        id: "56",
        name: "DRF",
        value: 4,
        tokenType: "alt",
        address: "0x9400aa8eb5126d20cde45c7822836bfb70f19878",
        icon: null,
        usdValue: 261.17940423655665,
      },
      {
        id: "56",
        name: "ARDN",
        value: 4,
        tokenType: "alt",
        address: "0xa0a9961b7477d1a530f06a1ee805d5e532e73d97",
        icon: null,
        usdValue: 54.6348961662,
      },
      {
        id: "56",
        name: "PMON",
        value: 4,
        tokenType: "alt",
        address: "0x1796ae0b0fa4862485106a0de9b654efe301d0b2",
        icon: null,
        usdValue: 49.47349938604484,
      },
      {
        id: "56",
        name: "GENE",
        value: 4,
        tokenType: "alt",
        address: "0x9df465460938f9EBDF51C38CC87D72184471F8F0",
        icon: null,
        usdValue: 4558.617681844438,
      },
      {
        id: "1",
        name: "MONA",
        value: 4,
        tokenType: "alt",
        address: "0x275f5Ad03be0Fa221B4C6649B8AeE09a42D9412A",
        icon: null,
        usdValue: 2015.28967263609,
      },
      {
        id: "56",
        name: "ILA",
        value: 4,
        tokenType: "alt",
        address: "0x4fBEdC7b946e489208DED562e8E5f2bc83B7de42",
        icon: null,
        usdValue: 39.6855025518,
      },
      {
        id: "56",
        name: "DHR",
        value: 4,
        tokenType: "alt",
        address: "0x9fEf6766ecf9e105b2753f7f8968Dc8293A69460",
        icon: null,
        usdValue: 23.046514417999997,
      },
      {
        id: "137",
        name: "GDDY",
        value: 4,
        tokenType: "alt",
        address: "0x67eb41a14c0fe5cd701fc9d5a3d6597a72f641a6",
        icon: null,
        usdValue: 1068.043257387296,
      },
      {
        id: "1",
        name: "WFAIR",
        value: 4,
        tokenType: "alt",
        address: "0xC6065B9fc8171Ad3D29bad510709249681758972",
        icon: null,
        usdValue: 720.0353065701534,
      },
      {
        id: "1",
        name: "GENI",
        value: 4,
        tokenType: "alt",
        address: "0x444444444444c1a66f394025ac839a535246fcc8",
        icon: null,
        usdValue: 57.304778800659726,
      },
      {
        id: "56",
        name: "GENI",
        value: 4,
        tokenType: "alt",
        address: "0x444444444444c1a66f394025ac839a535246fcc8",
        icon: null,
        usdValue: 10.982300561379205,
      },
      {
        id: "42161",
        name: "DSQ",
        value: 4,
        tokenType: "alt",
        address: "0xdb0c6fc9e01cd95eb1d3bbae6689962de489cd7b",
        icon: null,
        usdValue: 312.17059264049277,
      },
      {
        id: "1",
        name: "ONDO",
        value: 4,
        tokenType: "alt",
        address: "0xfAbA6f8e4a5E8Ab82F62fe7C39859FA577269BE3",
        icon: null,
        usdValue: 4561.518002446876,
      },
      {
        id: "1",
        name: "ALOHA",
        value: 4,
        tokenType: "alt",
        address: "0x455f7ef6d8bcfc35f9337e85aee1b0600a59fabe",
        icon: null,
        usdValue: 10.589584750056428,
      },
      {
        id: "137",
        name: "NITRO",
        value: 4,
        tokenType: "alt",
        address: "0x695fc8b80f344411f34bdbcb4e621aa69ada384b",
        icon: null,
        usdValue: 10.916480187966172,
      },
      {
        id: "1",
        name: "MILADY",
        value: 4,
        tokenType: "alt",
        address: "0x227c7DF69D3ed1ae7574A1a7685fDEd90292EB48",
        icon: null,
        usdValue: 3549.3572809477973,
      },
      {
        id: "137",
        name: "ELON",
        value: 4,
        tokenType: "alt",
        address: "0xe0339c80ffde91f3e20494df88d4206d86024cdf",
        icon: null,
        usdValue: 698.3497449561065,
      },
      {
        id: "137",
        name: "GOGO",
        value: 4,
        tokenType: "alt",
        address: "0xdd2af2e723547088d3846841fbdcc6a8093313d6",
        icon: null,
        usdValue: 63.54036724692461,
      },
      {
        id: "1",
        name: "IGG",
        value: 4,
        tokenType: "alt",
        address: "0x8ffe40a3d0f80c0ce6b203d5cdc1a6a86d9acaea",
        icon: null,
        usdValue: 1152.2248280666247,
      },
      {
        id: "56",
        name: "$MANGA",
        value: 4,
        tokenType: "alt",
        address: "0xc2cb89bbb5bba6e21db1dfe13493dfd7dcbabd68",
        icon: null,
        usdValue: 563.9063678418089,
      },
      {
        id: "56",
        name: "BVC",
        value: 4,
        tokenType: "alt",
        address: "0x9bee0c15676a65ef3c8cdb38cb3dd31c675bbd12",
        icon: null,
        usdValue: 165.12958425393128,
      },
      {
        id: "42161",
        name: "ALIEN",
        value: 4,
        tokenType: "alt",
        address: "0x6740Acb82ac5C63A7ad2397ee1faed7c788F5f8c",
        icon: null,
        usdValue: 503.3096645743172,
      },
      {
        id: "1",
        name: "DOR",
        value: 4,
        tokenType: "alt",
        address: "0x906b3f8b7845840188eab53c3f5ad348a787752f",
        icon: null,
        usdValue: 288.3936939113253,
      },
      {
        id: "56",
        name: "WELD",
        value: 4,
        tokenType: "alt",
        address: "0x5b6ebb33eea2d12eefd4a9b2aeaf733231169684",
        icon: null,
        usdValue: 1603.0718172184427,
      },
      {
        id: "56",
        name: "XIV",
        value: 4,
        tokenType: "alt",
        address: "0x00518f36d2e0e514e8eb94d34124fc18ee756f10",
        icon: null,
        usdValue: 20.446216,
      },
      {
        id: "1",
        name: "CPC",
        value: 4,
        tokenType: "alt",
        address: "0xfae4ee59cdd86e3be9e8b90b53aa866327d7c090",
        icon: null,
        usdValue: 3765.7175803620016,
      },
      {
        id: "1",
        name: "ARTX",
        value: 4,
        tokenType: "alt",
        address: "0x741b0428efdf4372a8df6fb54b018db5e5ab7710",
        icon: null,
        usdValue: 163.1241565324663,
      },
      {
        id: "1",
        name: "STREETH",
        value: 4,
        tokenType: "alt",
        address: "0xB840d10D840eF47c233FEC1fd040F5B145a6DfA5",
        icon: null,
        usdValue: 426.5559086213842,
      },
      {
        id: "56",
        name: "CBD",
        value: 4,
        tokenType: "alt",
        address: "0x0e2b41ea957624a314108cc4e33703e9d78f4b3c",
        icon: null,
        usdValue: 357.9240675164169,
      },
      {
        id: "1",
        name: "OH",
        value: 4,
        tokenType: "alt",
        address: "0x16ba8efe847ebdfef99d399902ec29397d403c30",
        icon: null,
        usdValue: 35.33101075789408,
      },
      {
        id: "56",
        name: "KWT",
        value: 4,
        tokenType: "alt",
        address: "0x257a8d1e03d17b8535a182301f15290f11674b53",
        icon: null,
        usdValue: 82.6607952222129,
      },
      {
        id: "1",
        name: "SHEESHA",
        value: 4,
        tokenType: "alt",
        address: "0x232FB065D9d24c34708eeDbF03724f2e95ABE768",
        icon: null,
        usdValue: 2657.3538385310126,
      },
      {
        id: "137",
        name: "SCA",
        value: 4,
        tokenType: "alt",
        address: "0x11a819beb0aa3327e39f52f90d65cc9bca499f33",
        icon: null,
        usdValue: 15.640592256,
      },
      {
        id: "1",
        name: "AMLT",
        value: 4,
        tokenType: "alt",
        address: "0xca0e7269600d353f70b14ad118a49575455c0f2f",
        icon: null,
        usdValue: 15.44152599479743,
      },
      {
        id: "56",
        name: "TRK",
        value: 4,
        tokenType: "alt",
        address: "0xA2E3e2817F00822F3c1E71A604eCa4196Af923d6",
        icon: null,
        usdValue: 24.83407398489732,
      },
      {
        id: "56",
        name: "UNB",
        value: 4,
        tokenType: "alt",
        address: "0x301af3eff0c904dc5ddd06faa808f653474f7fcc",
        icon: null,
        usdValue: 141.11367298501284,
      },
      {
        id: "1",
        name: "EQZ",
        value: 4,
        tokenType: "alt",
        address: "0x1da87b114f35e1dc91f72bf57fc07a768ad40bb0",
        icon: null,
        usdValue: 168.64673560851836,
      },
      {
        id: "56",
        name: "SIP",
        value: 4,
        tokenType: "alt",
        address: "0x9e5965d28e8d44cae8f9b809396e0931f9df71ca",
        icon: null,
        usdValue: 75.12429126398153,
      },
      {
        id: "1",
        name: "BCDT",
        value: 4,
        tokenType: "alt",
        address: "0xacfa209fb73bf3dd5bbfb1101b9bc999c49062a5",
        icon: null,
        usdValue: 7059.24433580234,
      },
      {
        id: "1",
        name: "BOMB",
        value: 4,
        tokenType: "alt",
        address: "0x1C95b093d6C236d3EF7c796fE33f9CC6b8606714",
        icon: null,
        usdValue: 24.822180000000003,
      },
      {
        id: "56",
        name: "ALGOBLK",
        value: 4,
        tokenType: "alt",
        address: "0xfecCa80fF6DeB2B492E93df3B67f0C523Cfd3a48",
        icon: null,
        usdValue: 24.565904393731422,
      },
      {
        id: "56",
        name: "ELMON",
        value: 4,
        tokenType: "alt",
        address: "0xE3233fdb23F1c27aB37Bd66A19a1f1762fCf5f3F",
        icon: null,
        usdValue: 611.5354664280619,
      },
      {
        id: "1",
        name: "THOR",
        value: 4,
        tokenType: "alt",
        address: "0xa5f2211B9b8170F694421f2046281775E8468044",
        icon: null,
        usdValue: 40201.79278420061,
      },
      {
        id: "56",
        name: "RVF",
        value: 4,
        tokenType: "alt",
        address: "0x872a34ebb2d54af86827810eebc7b9dc6b2144aa",
        icon: null,
        usdValue: 24090.71949662011,
      },
      {
        id: "1",
        name: "PSDN",
        value: 4,
        tokenType: "alt",
        address: "0xa5b947687163fe88c3e6af5b17ae69896f4abccf",
        icon: null,
        usdValue: 40.276033027908355,
      },
      {
        id: "1",
        name: "XLON",
        value: 4,
        tokenType: "alt",
        address: "0x36ff4dae0e88113d68b1209e245b0e3af92e9d58",
        icon: null,
        usdValue: 82.28613607717128,
      },
      {
        id: "56",
        name: "NABOX",
        value: 4,
        tokenType: "alt",
        address: "0x755f34709e369d37c6fa52808ae84a32007d1155",
        icon: null,
        usdValue: 410.2068283004136,
      },
      {
        id: "1",
        name: "CENNZ",
        value: 4,
        tokenType: "alt",
        address: "0x1122b6a0e00dce0563082b6e2953f3a943855c1f",
        icon: null,
        usdValue: 168.58400898575925,
      },
      {
        id: "1",
        name: "NITRO",
        value: 4,
        tokenType: "alt",
        address: "0x0335A7610D817aeCA1bEBbEfbd392ecC2eD587B8",
        icon: null,
        usdValue: 118.90898574405423,
      },
      {
        id: "56",
        name: "LinkP.io",
        value: 4,
        tokenType: "alt",
        address: "0xd5e3bf9045cfb1e6ded4b35d1b9c34be16d6eec3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "DOGGGO",
        value: 4,
        tokenType: "alt",
        address: "0x857dd3b493c49a8b060faf227d2b901e72621293",
        icon: null,
        usdValue: 4.067921858424e-9,
      },
      {
        id: "56",
        name: "BTCX",
        value: 4,
        tokenType: "alt",
        address: "0x93813e3c4b63931224bbb68ac0179551d5c98b8a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "PIPPO",
        value: 4,
        tokenType: "alt",
        address: "0xcca6d1d4205a81e140d2f84c23f10fe5720c92ae",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "BLID",
        value: 4,
        tokenType: "alt",
        address: "0x766afcf83fd5eaf884b3d529b432ca27a6d84617",
        icon: null,
        usdValue: 42.2177462983246,
      },
      {
        id: "56",
        name: "PEEL",
        value: 4,
        tokenType: "alt",
        address: "0x734548a9e43d2D564600b1B2ed5bE9C2b911c6aB",
        icon: null,
        usdValue: 1730.6080796567276,
      },
      {
        id: "56",
        name: "SCAR",
        value: 4,
        tokenType: "alt",
        address: "0x8d9fb713587174ee97e91866050c383b5cee6209",
        icon: null,
        usdValue: 254.18192694854005,
      },
      {
        id: "42161",
        name: "LIQD",
        value: 4,
        tokenType: "alt",
        address: "0x93c15cd7de26f07265f0272e0b831c5d7fab174f",
        icon: null,
        usdValue: 2388.255530626073,
      },
      {
        id: "1",
        name: "SLD",
        value: 4,
        tokenType: "alt",
        address: "0x1ef6a7e2c966fb7c5403efefde38338b1a95a084",
        icon: null,
        usdValue: 5.6983476,
      },
      {
        id: "56",
        name: "UMB",
        value: 4,
        tokenType: "alt",
        address: "0x6fc13eace26590b80cccab1ba5d51890577d83b2",
        icon: null,
        usdValue: 142.74649733808735,
      },
      {
        id: "10",
        name: "frax",
        value: 4,
        tokenType: "stable",
        address: "0x2e3d870790dc77a83dd1d18184acc7439a53f475",
        icon: null,
        usdValue: 44.650419656551236,
      },
      {
        id: "56",
        name: "8PAY",
        value: 4,
        tokenType: "alt",
        address: "0xfeea0bdd3d07eb6fe305938878c0cadbfa169042",
        icon: null,
        usdValue: 146.56611602253486,
      },
      {
        id: "42161",
        name: "MVD",
        value: 4,
        tokenType: "alt",
        address: "0x15a808ed3846D25e88AE868DE79F1bcB1Ac382B5",
        icon: null,
        usdValue: 436.45098948678,
      },
      {
        id: "1",
        name: "BIX",
        value: 4,
        tokenType: "alt",
        address: "0x009c43b42aefac590c719e971020575974122803",
        icon: null,
        usdValue: 14011.317736025325,
      },
      {
        id: "10",
        name: "unidx",
        value: 4,
        tokenType: "alt",
        address: "0x5d47baba0d66083c52009271faf3f50dcc01023c",
        icon: null,
        usdValue: 312.58471132585174,
      },
      {
        id: "1",
        name: "CBC",
        value: 4,
        tokenType: "alt",
        address: "0x26DB5439F651CAF491A87d48799dA81F191bDB6b",
        icon: null,
        usdValue: 1968.3969728489237,
      },
      {
        id: "137",
        name: "Acces Liquid-ether.com to claim rewards",
        value: 4,
        tokenType: "alt",
        address: "0x879e08670dcecfbca3143694ac9f37c5b5fd8e8b",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit [5000usdc.org] to claim Airdrop",
        value: 4,
        tokenType: "alt",
        address: "0x90962a35289395269da527537a4500f5b40184b2",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "BEC",
        value: 4,
        tokenType: "alt",
        address: "0x3495ffcee09012ab7d827abf3e3b3ae428a38443",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "ICSA",
        value: 4,
        tokenType: "alt",
        address: "0xfc4913214444af5c715cc9f7b52655e788a569ed",
        icon: null,
        usdValue: 5291.890631856919,
      },
      {
        id: "1",
        name: "SETH2",
        value: 4,
        tokenType: "alt",
        address: "0xFe2e637202056d30016725477c5da089Ab0A043A",
        icon: null,
        usdValue: 174.72017913294155,
      },
      {
        id: "1",
        name: "HAIR",
        value: 4,
        tokenType: "alt",
        address: "0x9Ce115f0341ae5daBC8B477b74E83db2018A6f42",
        icon: null,
        usdValue: 32.828790320659,
      },
      {
        id: "56",
        name: "BXEN",
        value: 4,
        tokenType: "alt",
        address: "0x2AB0e9e4eE70FFf1fB9D67031E44F6410170d00e",
        icon: null,
        usdValue: 804.65356276986,
      },
      {
        id: "56",
        name: "KMD",
        value: 4,
        tokenType: "alt",
        address: "0x2003f7ba57Ea956B05B85C60B4B2Ceea9b111256",
        icon: null,
        usdValue: 2499.732989901475,
      },
      {
        id: "1",
        name: "RSV",
        value: 4,
        tokenType: "stable",
        address: "0x196f4727526eA7FB1e17b2071B3d8eAA38486988",
        icon: null,
        usdValue: 444.10603624724814,
      },
      {
        id: "1",
        name: "HISQUIGGLE",
        value: 4,
        tokenType: "alt",
        address: "0x51395AdE06Eae126f590e7B06Dc8F6Baf511f13F",
        icon: null,
        usdValue: 87789.05731124543,
      },
      {
        id: "1",
        name: "HIUNDEAD",
        value: 4,
        tokenType: "alt",
        address: "0x70d0ff0d3b3F5E69220c09bEFC70606Fa5F89293",
        icon: null,
        usdValue: 101208.05073327018,
      },
      {
        id: "1",
        name: "HIPUNKS",
        value: 4,
        tokenType: "alt",
        address: "0xb1f136a74e18E4E2921feBbf25820d1Bb65B5647",
        icon: null,
        usdValue: 125378.67200888514,
      },
      {
        id: "1",
        name: "HIMAYC",
        value: 4,
        tokenType: "alt",
        address: "0x635F15eb7Aa2e62d122f6B1f9f519fDCcf4aBdda",
        icon: null,
        usdValue: 225126.8939681924,
      },
      {
        id: "1",
        name: "HIMEEBITS",
        value: 4,
        tokenType: "alt",
        address: "0xBBeca80A4c99c3b1BD3C10E64595d0Fc7dC26eE0",
        icon: null,
        usdValue: 68962.3156120127,
      },
      {
        id: "1",
        name: "HIGAZERS",
        value: 4,
        tokenType: "alt",
        address: "0xc1ad0aa69454603a5dee55cf9bd9341e01328544",
        icon: null,
        usdValue: 47403.07428729962,
      },
      {
        id: "1",
        name: "HICLONEX",
        value: 4,
        tokenType: "alt",
        address: "0x764104dc24DAdFf01150253a58C82337984B4319",
        icon: null,
        usdValue: 73047.16186435093,
      },
      {
        id: "1",
        name: "MORE",
        value: 4,
        tokenType: "alt",
        address: "0xbeef3bb9da340ebdf0f5bae2e85368140d7d85d0",
        icon: null,
        usdValue: 10.64704,
      },
      {
        id: "1",
        name: "VXL",
        value: 4,
        tokenType: "alt",
        address: "0x16CC8367055aE7e9157DBcB9d86Fd6CE82522b31",
        icon: null,
        usdValue: 8576.984524254454,
      },
      {
        id: "1",
        name: "RISE",
        value: 4,
        tokenType: "alt",
        address: "0xC17c30e98541188614dF99239cABD40280810cA3",
        icon: null,
        usdValue: 6850.179478867853,
      },
      {
        id: "1",
        name: "TRV",
        value: 4,
        tokenType: "alt",
        address: "0x72955ecff76e48f2c8abcce11d54e5734d6f3657",
        icon: null,
        usdValue: 13604.354677384361,
      },
      {
        id: "1",
        name: "KSC",
        value: 4,
        tokenType: "alt",
        address: "0x990e081a7b7d3ccba26a2f49746a68cc4ff73280",
        icon: null,
        usdValue: 6384.055638103867,
      },
      {
        id: "1",
        name: "LUD",
        value: 4,
        tokenType: "alt",
        address: "0xe64b47931f28f89cc7a0c6965ecf89eadb4975f5",
        icon: null,
        usdValue: 20612.501270600424,
      },
      {
        id: "1",
        name: "RAK",
        value: 4,
        tokenType: "alt",
        address: "0xa8b0f154a688c22142e361707df64277e0a0be66",
        icon: null,
        usdValue: 172166.41545822192,
      },
      {
        id: "1",
        name: "GHD",
        value: 4,
        tokenType: "alt",
        address: "0x3b544e6fcf6c8dce9d8b45a4fdf21c9b02f9fda9",
        icon: null,
        usdValue: 2823.391857241297,
      },
      {
        id: "1",
        name: "FEN",
        value: 4,
        tokenType: "alt",
        address: "0x995a6c0944322b7285d0712824acf0cf9bf3993a",
        icon: null,
        usdValue: 51057.97423131199,
      },
      {
        id: "1",
        name: "MARX",
        value: 4,
        tokenType: "alt",
        address: "0x2b100be232f90dd33d3b6e4b9ad70d1e8ac0e208",
        icon: null,
        usdValue: 52338.894847166855,
      },
      {
        id: "1",
        name: "QUA",
        value: 4,
        tokenType: "alt",
        address: "0xd35c06a2781f648c75290976ecF71E71582188B7",
        icon: null,
        usdValue: 181.68,
      },
      {
        id: "1",
        name: "RUN",
        value: 4,
        tokenType: "alt",
        address: "0x5f4c148d17effd165c2e2d46b46d2bd6e3ebdc3e",
        icon: null,
        usdValue: 4945.292736726093,
      },
      {
        id: "1",
        name: "VKT",
        value: 4,
        tokenType: "alt",
        address: "0xcab7ffC5a5759AB8C4F9a366F33A032BdAc28aC1",
        icon: null,
        usdValue: 6034.435311982569,
      },
      {
        id: "1",
        name: "X1",
        value: 4,
        tokenType: "alt",
        address: "0xf6c2a37acc8ba45874808837486110dc0afc63c8",
        icon: null,
        usdValue: 5742.802519999999,
      },
      {
        id: "1",
        name: "JOY",
        value: 4,
        tokenType: "alt",
        address: "0x4e114d405b9ba2f59524941733e505ae03fb1fb5",
        icon: null,
        usdValue: 548.5090001178331,
      },
      {
        id: "1",
        name: "NTN",
        value: 4,
        tokenType: "alt",
        address: "0x56D3d0B333D29b48DD7c01d516A737B8866fBEe2",
        icon: null,
        usdValue: 13013.683285808927,
      },
      {
        id: "1",
        name: "POOLX",
        value: 4,
        tokenType: "alt",
        address: "0xEef66125BfcFfdb1642C7E85a432cD1B78038399",
        icon: null,
        usdValue: 144291.6,
      },
      {
        id: "1",
        name: "PAT",
        value: 4,
        tokenType: "alt",
        address: "0xdd78B3E430361560A70B9CBB7d98d961f0428b61",
        icon: null,
        usdValue: 14957.03933419822,
      },
      {
        id: "1",
        name: "MIRL",
        value: 4,
        tokenType: "alt",
        address: "0x8770b7Dd89E5f759eE3b226e0C45e890f87dDc48",
        icon: null,
        usdValue: 1202.3094006173683,
      },
      {
        id: "1",
        name: "GLO",
        value: 4,
        tokenType: "alt",
        address: "0xc0e6737a29de7a00e2f6011924eb257106cb082f",
        icon: null,
        usdValue: 27070.93638803377,
      },
      {
        id: "1",
        name: "SAK",
        value: 4,
        tokenType: "alt",
        address: "0xb269Ab3B20E09e6fd17C3ED5B4CECF3dEA1a5141",
        icon: null,
        usdValue: 16430.060934141387,
      },
      {
        id: "1",
        name: "PEPES",
        value: 4,
        tokenType: "alt",
        address: "0x6bf765c43030387a983f429c1438e9d2025b7e12",
        icon: null,
        usdValue: 27716.435880445257,
      },
      {
        id: "1",
        name: "PANDA",
        value: 4,
        tokenType: "alt",
        address: "0x3cbb7f5d7499af626026e96a2f05df806f2200dc",
        icon: null,
        usdValue: 17561.965329254468,
      },
      {
        id: "42161",
        name: "SHARBI",
        value: 4,
        tokenType: "alt",
        address: "0xaa54e84A3e6e5A80288d2C2f8e36eA5cA3A3Ca30",
        icon: null,
        usdValue: 39.122868082212804,
      },
      {
        id: "1",
        name: "FCT",
        value: 4,
        tokenType: "alt",
        address: "0xE1bAD922F84b198A08292FB600319300ae32471b",
        icon: null,
        usdValue: 5153.88318273291,
      },
      {
        id: "1",
        name: "AMM",
        value: 4,
        tokenType: "alt",
        address: "0x8b1f49491477e0fb46a29fef53f1ea320d13c349",
        icon: null,
        usdValue: 18420.753762821925,
      },
      {
        id: "56",
        name: "VITE",
        value: 4,
        tokenType: "alt",
        address: "0x2794dad4077602ed25a88d03781528d1637898b4",
        icon: null,
        usdValue: 34170.471780027765,
      },
      {
        id: "1",
        name: "BAAS",
        value: 4,
        tokenType: "alt",
        address: "0x5d929aa919e489505ccaad8a199619c6dca0c2de",
        icon: null,
        usdValue: 712036.729596903,
      },
      {
        id: "1",
        name: "OBOT",
        value: 4,
        tokenType: "alt",
        address: "0xeDADeB5fAa413e6c8623461849DFD0B7C3790c32",
        icon: null,
        usdValue: 3111.943384840761,
      },
      {
        id: "1",
        name: "CYCLUB",
        value: 4,
        tokenType: "alt",
        address: "0x3b58c52c03ca5eb619eba171091c86c34d603e5f",
        icon: null,
        usdValue: 83845.07706603999,
      },
      {
        id: "1",
        name: "1SOL",
        value: 4,
        tokenType: "alt",
        address: "0x009178997aff09a67d4caccfeb897fb79d036214",
        icon: null,
        usdValue: 32159.2017265173,
      },
      {
        id: "1",
        name: "MT",
        value: 4,
        tokenType: "alt",
        address: "0x9b4e2b4b13d125238aa0480dd42b4f6fc71b37cc",
        icon: null,
        usdValue: 16623.919541266234,
      },
      {
        id: "1",
        name: "UUU",
        value: 4,
        tokenType: "alt",
        address: "0x3543638ed4a9006e4840b105944271bcea15605d",
        icon: null,
        usdValue: 38302.29731329717,
      },
      {
        id: "1",
        name: "EKO",
        value: 4,
        tokenType: "alt",
        address: "0xa6a840e50bcaa50da017b91a0d86b8b2d41156ee",
        icon: null,
        usdValue: 10408.174239669606,
      },
      {
        id: "1",
        name: "SIGN",
        value: 4,
        tokenType: "alt",
        address: "0xb06B8186cc008A79FD6722B1eefad07c14E97dA0",
        icon: null,
        usdValue: 215561.32910000152,
      },
      {
        id: "1",
        name: "ARV",
        value: 4,
        tokenType: "alt",
        address: "0x28fDA76721a8077A5dE802Ab0212849B8c38429E",
        icon: null,
        usdValue: 741.9806484821083,
      },
      {
        id: "1",
        name: "FUTURE-AI",
        value: 4,
        tokenType: "alt",
        address: "0x0FF534801E98A4976246D1f418E441783fc9aa15",
        icon: null,
        usdValue: 202.09495315588714,
      },
      {
        id: "1",
        name: "DAX",
        value: 4,
        tokenType: "alt",
        address: "0x0b4bdc478791897274652dc15ef5c135cae61e60",
        icon: null,
        usdValue: 206220.21447472248,
      },
      {
        id: "1",
        name: "ATT",
        value: 4,
        tokenType: "alt",
        address: "0x89Fb927240750c1B15d4743cd58440fc5f14A11C",
        icon: null,
        usdValue: 353413.9371283665,
      },
      {
        id: "1",
        name: "PXG",
        value: 4,
        tokenType: "alt",
        address: "0x47e67ba66b0699500f18a53f94e2b9db3d47437e",
        icon: null,
        usdValue: 43439.76494542269,
      },
      {
        id: "1",
        name: "HART",
        value: 4,
        tokenType: "alt",
        address: "0x52928c95c4c7e934e0efcfab08853a0e4558861d",
        icon: null,
        usdValue: 235089.96746609433,
      },
      {
        id: "56",
        name: "KRD",
        value: 4,
        tokenType: "alt",
        address: "0xb020805e0Bc7F0e353D1343d67A239F417D57Bbf",
        icon: null,
        usdValue: 115414.11218757258,
      },
      {
        id: "56",
        name: "MRS",
        value: 4,
        tokenType: "alt",
        address: "0x238d02ee3f80fbf5e381f049616025c186889b68",
        icon: null,
        usdValue: 169380.69562255248,
      },
      {
        id: "56",
        name: "H2O",
        value: 4,
        tokenType: "alt",
        address: "0xaf3287cae99c982586c07401c0d911bf7de6cd82",
        icon: null,
        usdValue: 636793.4698541656,
      },
      {
        id: "56",
        name: "NUSA",
        value: 4,
        tokenType: "alt",
        address: "0xe11f1d5eee6be945bee3fa20dbf46febbc9f4a19",
        icon: null,
        usdValue: 272539.0357166044,
      },
      {
        id: "56",
        name: "VCG",
        value: 4,
        tokenType: "alt",
        address: "0x1f36fb2d91d9951cf58ae4c1956c0b77e224f1e9",
        icon: null,
        usdValue: 93402.33118745804,
      },
      {
        id: "56",
        name: "DFG",
        value: 4,
        tokenType: "alt",
        address: "0xb661f4576d5e0b622fee6ab041fd5451fe02ba4c",
        icon: null,
        usdValue: 116682.1720860612,
      },
      {
        id: "56",
        name: "MURA",
        value: 4,
        tokenType: "alt",
        address: "0x166295ebd6a938c7aaf61350eb5161a9939ab2b7",
        icon: null,
        usdValue: 268377.0876910581,
      },
      {
        id: "56",
        name: "ALIF",
        value: 4,
        tokenType: "alt",
        address: "0x967784950655b8e74a2d3d3503933f0015660074",
        icon: null,
        usdValue: 139378.4906404969,
      },
      {
        id: "56",
        name: "UW3S",
        value: 4,
        tokenType: "alt",
        address: "0x961e149db8bfbdb318c182152725ac806d7be3f4",
        icon: null,
        usdValue: 190525.98924192612,
      },
      {
        id: "56",
        name: "CHT",
        value: 4,
        tokenType: "alt",
        address: "0x67d8e0080b612afae75a7f7229bfed3cdb998462",
        icon: null,
        usdValue: 221227.1807283901,
      },
      {
        id: "56",
        name: "POR",
        value: 4,
        tokenType: "alt",
        address: "0x9000cac49c3841926baac5b2e13c87d43e51b6a4",
        icon: null,
        usdValue: 437752.24121274496,
      },
      {
        id: "1",
        name: "SLEEPEE",
        value: 4,
        tokenType: "alt",
        address: "0x80CD73baDb406eA36B9a7CDeb8df06AeFa7E12d9",
        icon: null,
        usdValue: 692.3989298482583,
      },
      {
        id: "1",
        name: "MEMAG",
        value: 4,
        tokenType: "alt",
        address: "0x6e39a587691b8c9d4341ce0a960998ed6f537af6",
        icon: null,
        usdValue: 61647.82983386627,
      },
      {
        id: "1",
        name: "HOICHI",
        value: 4,
        tokenType: "alt",
        address: "0xc4ee0aa2d993ca7c9263ecfa26c6f7e13009d2b6",
        icon: null,
        usdValue: 40492.39075805635,
      },
      {
        id: "1",
        name: "THEO",
        value: 4,
        tokenType: "alt",
        address: "0xfac0403a24229d7e2edd994d50f5940624cbeac2",
        icon: null,
        usdValue: 504.50444911172673,
      },
      {
        id: "56",
        name: "ONI",
        value: 4,
        tokenType: "alt",
        address: "0xea89199344a492853502a7a699cc4230854451b8",
        icon: null,
        usdValue: 14770.47197913511,
      },
      {
        id: "56",
        name: "CDT",
        value: 4,
        tokenType: "alt",
        address: "0x0cbd6fadcf8096cc9a43d90b45f65826102e3ece",
        icon: null,
        usdValue: 16995.009208497315,
      },
      {
        id: "1",
        name: "VNXAU",
        value: 4,
        tokenType: "alt",
        address: "0x6d57B2E05F26C26b549231c866bdd39779e4a488",
        icon: null,
        usdValue: 1052.9051119265248,
      },
      {
        id: "1",
        name: "FGHT",
        value: 4,
        tokenType: "alt",
        address: "0xe0ffDdF8fd7d63Cf907e433c9293069704D4d40D",
        icon: null,
        usdValue: 1712.2046147634178,
      },
      {
        id: "1",
        name: "METRO",
        value: 4,
        tokenType: "alt",
        address: "0xD77401A76d6cDB7Ac3bb031Bf25dEc07615509E7",
        icon: null,
        usdValue: 10836.191239846146,
      },
      {
        id: "1",
        name: "GXT",
        value: 4,
        tokenType: "alt",
        address: "0x4674672bcddda2ea5300f5207e1158185c944bc0",
        icon: null,
        usdValue: 4397.314654367988,
      },
      {
        id: "1",
        name: "MXNT",
        value: 4,
        tokenType: "alt",
        address: "0xed03ed872159e199065401b6d0d487d78d9464aa",
        icon: null,
        usdValue: 1886142.7869071495,
      },
      {
        id: "1",
        name: "ULT",
        value: 4,
        tokenType: "alt",
        address: "0x09617f6fd6cf8a71278ec86e23bbab29c04353a7",
        icon: null,
        usdValue: 273.46862688649543,
      },
      {
        id: "56",
        name: "VRGW",
        value: 4,
        tokenType: "alt",
        address: "0xfdd2374be7ae7a71138b9f6b93d9ef034a49edb6",
        icon: null,
        usdValue: 35377.41710521042,
      },
      {
        id: "137",
        name: "SWP",
        value: 4,
        tokenType: "alt",
        address: "0xabEDe05598760E399ed7EB24900b30C51788f00F",
        icon: null,
        usdValue: 4271.013398992314,
      },
      {
        id: "42161",
        name: "SIS",
        value: 4,
        tokenType: "alt",
        address: "0x9e758b8a98a42d612b3d38b66a22074dc03d7370",
        icon: null,
        usdValue: 49200.40161455261,
      },
      {
        id: "1",
        name: "ASAP",
        value: 3,
        tokenType: "alt",
        address: "0xcc665390b03c5d324d8faf81c15ecee29a73bcb4",
        icon: null,
        usdValue: 1.3240681083469492,
      },
      {
        id: "1",
        name: "TKN",
        value: 3,
        tokenType: "alt",
        address: "0xaaaf91d9b90df800df4f55c205fd6989c977e73a",
        icon: null,
        usdValue: 44.99130290520738,
      },
      {
        id: "1",
        name: "GERO",
        value: 3,
        tokenType: "alt",
        address: "0x3431f91b3a388115f00c5ba9fdb899851d005fb5",
        icon: null,
        usdValue: 25.211221967848587,
      },
      {
        id: "1",
        name: "PPBLZ",
        value: 3,
        tokenType: "alt",
        address: "0x4d2ee5dae46c86da2ff521f7657dad98834f97b8",
        icon: null,
        usdValue: 0.0072065333900692575,
      },
      {
        id: "1",
        name: "ROGUE",
        value: 3,
        tokenType: "alt",
        address: "0x6ac665c0de9a6ca72b85757b141aa9c428828aca",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "NDR",
        value: 3,
        tokenType: "alt",
        address: "0x739763a258640919981f9ba610ae65492455be53",
        icon: null,
        usdValue: 4.646582671129153,
      },
      {
        id: "1",
        name: "COIN",
        value: 3,
        tokenType: "alt",
        address: "0x87b008e57f640d94ee44fd893f0323af933f9195",
        icon: null,
        usdValue: 65.93530626894689,
      },
      {
        id: "1",
        name: "FOLO",
        value: 3,
        tokenType: "alt",
        address: "0xb2a63a5dd36c91ec2da59b188ff047f66fac122a",
        icon: null,
        usdValue: 29.959791212276933,
      },
      {
        id: "1",
        name: "ETHY",
        value: 3,
        tokenType: "alt",
        address: "0xd1afbccc9a2c2187ea544363b986ea0ab6ef08b5",
        icon: null,
        usdValue: 298.06512194308357,
      },
      {
        id: "137",
        name: "PolyShiba",
        value: 3,
        tokenType: "alt",
        address: "0x9240d4bfa7f1d64bec2fdc8af2f70c04aec4293b",
        icon: null,
        usdValue: 5.993034203197288,
      },
      {
        id: "137",
        name: "KITTY",
        value: 3,
        tokenType: "alt",
        address: "0xb4228798ff437ecd8fa43429664e9992256fe6ac",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "CSWAP",
        value: 3,
        tokenType: "alt",
        address: "0xe0b0c16038845bed3fcf70304d3e167df81ce225",
        icon: null,
        usdValue: 202.23848510116278,
      },
      {
        id: "1",
        name: "ABR",
        value: 3,
        tokenType: "alt",
        address: "0xa11bd36801d8fa4448f0ac4ea7a62e3634ce8c7c",
        icon: null,
        usdValue: 87.7779484860221,
      },
      {
        id: "1",
        name: "PTON",
        value: 3,
        tokenType: "alt",
        address: "0x4946583c5b86e01ccd30c71a05617d06e3e73060",
        icon: null,
        usdValue: 3193130180.375632,
      },
      {
        id: "1",
        name: "XMT",
        value: 3,
        tokenType: "alt",
        address: "0x3E5D9D8a63CC8a88748f229999CF59487e90721e",
        icon: null,
        usdValue: 168.40680184973206,
      },
      {
        id: "56",
        name: "ROAD",
        value: 3,
        tokenType: "alt",
        address: "0x1a3057027032a1af433f6f596cab15271e4d8196",
        icon: null,
        usdValue: 114.16334241773751,
      },
      {
        id: "1",
        name: "DON",
        value: 3,
        tokenType: "alt",
        address: "0x217ddead61a42369a266f1fb754eb5d3ebadc88a",
        icon: null,
        usdValue: 139.87297373641997,
      },
      {
        id: "1",
        name: "MNB",
        value: 3,
        tokenType: "alt",
        address: "0x42b91f1d05afea671a2da3c780eda2abf0a2a366",
        icon: null,
        usdValue: 6.134639576641808,
      },
      {
        id: "56",
        name: "DFIAT",
        value: 3,
        tokenType: "alt",
        address: "0xF64eD9Ad397A1Ae657F31131d4B189220A7f1cc7",
        icon: null,
        usdValue: 18.77112,
      },
      {
        id: "56",
        name: "BBS",
        value: 3,
        tokenType: "alt",
        address: "0xa477a79a118a84a0d371a53c8f46f8ce883ec1dd",
        icon: null,
        usdValue: 219.3368695,
      },
      {
        id: "137",
        name: "ELK",
        value: 3,
        tokenType: "alt",
        address: "0xeEeEEb57642040bE42185f49C52F7E9B38f8eeeE",
        icon: null,
        usdValue: 292.0071552003832,
      },
      {
        id: "1",
        name: "NEU",
        value: 3,
        tokenType: "alt",
        address: "0xa823e6722006afe99e91c30ff5295052fe6b8e32",
        icon: null,
        usdValue: 18.319183135130835,
      },
      {
        id: "10",
        name: "alusd",
        value: 3,
        tokenType: "stable",
        address: "0xcb8fa9a76b8e203d8c3797bf438d8fb81ea3326a",
        icon: null,
        usdValue: 7.370274249693578,
      },
      {
        id: "56",
        name: "MYNE",
        value: 3,
        tokenType: "alt",
        address: "0xD254dC670Ff725753a826a5F29A4001600CcE29c",
        icon: null,
        usdValue: 33.920855913400004,
      },
      {
        id: "56",
        name: "BTCMT",
        value: 3,
        tokenType: "alt",
        address: "0x410a56541bd912f9b60943fcb344f1e3d6f09567",
        icon: null,
        usdValue: 10.598669999999998,
      },
      {
        id: "56",
        name: "BETS",
        value: 3,
        tokenType: "alt",
        address: "0x3e0a7c7db7bb21bda290a80c9811de6d47781671",
        icon: null,
        usdValue: 3810.57808862594,
      },
      {
        id: "56",
        name: "RAVEN",
        value: 3,
        tokenType: "alt",
        address: "0xcd7c5025753a49f1881b31c48caa7c517bb46308",
        icon: null,
        usdValue: 12298.42158647118,
      },
      {
        id: "42161",
        name: "BRR",
        value: 3,
        tokenType: "alt",
        address: "0xd6e7c8af05d2d06a76811d44917613bdd258b995",
        icon: null,
        usdValue: 28.775463183451937,
      },
      {
        id: "137",
        name: "MODA",
        value: 3,
        tokenType: "alt",
        address: "0x5e430f88d1be82eb3ef92b6ff06125168fd5dcf2",
        icon: null,
        usdValue: 643.4312998914245,
      },
      {
        id: "1",
        name: "ETHYS",
        value: 3,
        tokenType: "alt",
        address: "0xd0d3ebcad6a20ce69bc3bc0e1ec964075425e533",
        icon: null,
        usdValue: 0.1130371210642333,
      },
      {
        id: "56",
        name: "PROPEL",
        value: 3,
        tokenType: "alt",
        address: "0x9b44df3318972be845d83f961735609137c4c23c",
        icon: null,
        usdValue: 0.0009609665732564999,
      },
      {
        id: "137",
        name: "TNGBL",
        value: 3,
        tokenType: "alt",
        address: "0x49e6a20f1bbdfeec2a8222e052000bbb14ee6007",
        icon: null,
        usdValue: 17.31862797626157,
      },
      {
        id: "1",
        name: "IPL",
        value: 3,
        tokenType: "alt",
        address: "0x64CdF819d3E75Ac8eC217B3496d7cE167Be42e80",
        icon: null,
        usdValue: 2617.1545554398162,
      },
      {
        id: "56",
        name: "SCIX",
        value: 3,
        tokenType: "alt",
        address: "0x2cfc48cdfea0678137854f010b5390c5144c0aa5",
        icon: null,
        usdValue: 82.96446929290926,
      },
      {
        id: "56",
        name: "PSR",
        value: 3,
        tokenType: "alt",
        address: "0xb72ba371c900aa68bb9fa473e93cfbe212030fcb",
        icon: null,
        usdValue: 9.378253206639005,
      },
      {
        id: "56",
        name: "FROYO",
        value: 3,
        tokenType: "alt",
        address: "0xe369fec23380f9F14ffD07a1DC4b7c1a9fdD81c9",
        icon: null,
        usdValue: 51.4594698505384,
      },
      {
        id: "56",
        name: "NFTPAD",
        value: 3,
        tokenType: "alt",
        address: "0x4a72af9609d22bf2ff227aec333c7d0860f3db36",
        icon: null,
        usdValue: 241.18710420000002,
      },
      {
        id: "56",
        name: "STRIP",
        value: 3,
        tokenType: "alt",
        address: "0x0fe178b9a471b3698cB6FcB4625DF9A756A2C55C",
        icon: null,
        usdValue: 453.2026574147097,
      },
      {
        id: "42161",
        name: "MZR",
        value: 3,
        tokenType: "alt",
        address: "0xBBEa044f9e7c0520195e49Ad1e561572E7E1B948",
        icon: null,
        usdValue: 27026.00010074409,
      },
      {
        id: "1",
        name: "SAVM",
        value: 3,
        tokenType: "alt",
        address: "0x15e6e0d4ebeac120f9a97e71faa6a0235b85ed12",
        icon: null,
        usdValue: 109310.62558253307,
      },
      {
        id: "1",
        name: "APUFF",
        value: 3,
        tokenType: "alt",
        address: "0x2be056e595110b30ddd5eaf674bdac54615307d9",
        icon: null,
        usdValue: 60564.64176150879,
      },
      {
        id: "1",
        name: "SHL",
        value: 3,
        tokenType: "alt",
        address: "0x2e703d658f8dd21709a7b458967ab4081f8d3d05",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "GRO",
        value: 3,
        tokenType: "alt",
        address: "0x3ec8798b81485a254928b70cda1cf0a2bb0b74d7",
        icon: null,
        usdValue: 0.0000029774434420448338,
      },
      {
        id: "1",
        name: "MAZZE",
        value: 3,
        tokenType: "alt",
        address: "0x4a029f7bcf33acb03547d8fa7be840347973e24e",
        icon: null,
        usdValue: 76327.81372014363,
      },
      {
        id: "1",
        name: "MIS",
        value: 3,
        tokenType: "alt",
        address: "0x4b4d2e899658fb59b1d518b68fe836b100ee8958",
        icon: null,
        usdValue: 0.08446268747581286,
      },
      {
        id: "1",
        name: "BITTO",
        value: 3,
        tokenType: "alt",
        address: "0x55a290f08bb4cae8dcf1ea5635a3fcfd4da60456",
        icon: null,
        usdValue: 0.750129710893414,
      },
      {
        id: "1",
        name: "DEV",
        value: 3,
        tokenType: "alt",
        address: "0x5caf454ba92e6f2c929df14667ee360ed9fd5b26",
        icon: null,
        usdValue: 699.2055855418664,
      },
      {
        id: "1",
        name: "OS",
        value: 3,
        tokenType: "alt",
        address: "0x6100dd79fcaa88420750dcee3f735d168abcb771",
        icon: null,
        usdValue: 4475.064631468024,
      },
      {
        id: "1",
        name: "TKX",
        value: 3,
        tokenType: "alt",
        address: "0x667102bd3413bfeaa3dffb48fa8288819e480a88",
        icon: null,
        usdValue: 0.0016621757748696152,
      },
      {
        id: "1",
        name: "PRT",
        value: 3,
        tokenType: "alt",
        address: "0x6d0f5149c502faf215c89ab306ec3e50b15e2892",
        icon: null,
        usdValue: 1449.6278153379349,
      },
      {
        id: "1",
        name: "SIG",
        value: 3,
        tokenType: "alt",
        address: "0x7777777777697cfeecf846a76326da79cc606517",
        icon: null,
        usdValue: 0.0725685883039059,
      },
      {
        id: "1",
        name: "LEAG",
        value: 3,
        tokenType: "alt",
        address: "0x7b39917f9562c8bc83c7a6c2950ff571375d505d",
        icon: null,
        usdValue: 9.162099093518024e-9,
      },
      {
        id: "1",
        name: "Game",
        value: 3,
        tokenType: "alt",
        address: "0x882e5b370d595e50c24b2a0e7a94e87cc32adda1",
        icon: null,
        usdValue: 562.8944990443485,
      },
      {
        id: "1",
        name: "ARCX",
        value: 3,
        tokenType: "alt",
        address: "0x8e4d27d772099e18900caf5dcc36cb612dcee886",
        icon: null,
        usdValue: 3833.31160118396,
      },
      {
        id: "1",
        name: "SHIBA2",
        value: 3,
        tokenType: "alt",
        address: "0xa0335820dc549dbfae5b8d691331cadfca7026e0",
        icon: null,
        usdValue: 7.01712443216087,
      },
      {
        id: "1",
        name: "SACKS",
        value: 3,
        tokenType: "alt",
        address: "0xa6610ed604047e7b76c1da288172d15bcda57596",
        icon: null,
        usdValue: 4882.446324484004,
      },
      {
        id: "1",
        name: "TUNA",
        value: 3,
        tokenType: "alt",
        address: "0xadd353fb2e2c563383ff3272a500f3e7134dafe4",
        icon: null,
        usdValue: 31239.108330642408,
      },
      {
        id: "1",
        name: "REL",
        value: 3,
        tokenType: "alt",
        address: "0xb6c4267c4877bb0d6b1685cfd85b0fbe82f105ec",
        icon: null,
        usdValue: 234.32263374044675,
      },
      {
        id: "1",
        name: "MUSE",
        value: 3,
        tokenType: "alt",
        address: "0xb6ca7399b4f9ca56fc27cbff44f4d2e4eef1fc81",
        icon: null,
        usdValue: 248617.43593404593,
      },
      {
        id: "1",
        name: "STABLEx",
        value: 3,
        tokenType: "alt",
        address: "0xcd91538b91b4ba7797d39a2f66e63810b50a33d0",
        icon: null,
        usdValue: 2.662509943828687,
      },
      {
        id: "1",
        name: "ORBK",
        value: 3,
        tokenType: "alt",
        address: "0xce6e54daa1ea95fb3530859d69d4bdb978dd821b",
        icon: null,
        usdValue: 11377.133945631373,
      },
      {
        id: "1",
        name: "BBL",
        value: 3,
        tokenType: "alt",
        address: "0xd979c468a68062e7bdff4ba6df7842dfd3492e0f",
        icon: null,
        usdValue: 58.185,
      },
      {
        id: "1",
        name: "FNT",
        value: 3,
        tokenType: "alt",
        address: "0xdc5864ede28bd4405aa04d93e05a0531797d9d59",
        icon: null,
        usdValue: 0.01190189231757,
      },
      {
        id: "1",
        name: "AIUS",
        value: 3,
        tokenType: "alt",
        address: "0xe3dbc4f88eaa632ddf9708732e2832eeaa6688ab",
        icon: null,
        usdValue: 1.8097366895819342,
      },
      {
        id: "56",
        name: "EDE",
        value: 3,
        tokenType: "alt",
        address: "0x4136129ac3ac90cf9817548b24d35e73e9457e05",
        icon: null,
        usdValue: 0.0014797123101528192,
      },
      {
        id: "56",
        name: "SpacePi",
        value: 3,
        tokenType: "alt",
        address: "0x69b14e8d3cebfdd8196bfe530954a0c226e5008e",
        icon: null,
        usdValue: 0.0015288534615000003,
      },
      {
        id: "56",
        name: "OFN",
        value: 3,
        tokenType: "alt",
        address: "0x8899ec96ed8c96b5c86c23c3f069c3def75b6d97",
        icon: null,
        usdValue: 117528.91792301161,
      },
      {
        id: "56",
        name: "RXT",
        value: 3,
        tokenType: "alt",
        address: "0x8d1427a32f0a4c4bf052252e68e7ff1b2ba80c01",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "LGT",
        value: 3,
        tokenType: "alt",
        address: "0xb0fd95723534af7a08021813bc9f792a083947b2",
        icon: null,
        usdValue: 0.00220952797250361,
      },
      {
        id: "137",
        name: "METAL",
        value: 3,
        tokenType: "alt",
        address: "0x200c234721b5e549c3693ccc93cf191f90dc2af9",
        icon: null,
        usdValue: 46196.33164743801,
      },
      {
        id: "137",
        name: "MEEB",
        value: 3,
        tokenType: "alt",
        address: "0x64afdf9e28946419e325d801fb3053d8b8ffdc23",
        icon: null,
        usdValue: 0.000016064435901648775,
      },
      {
        id: "137",
        name: "fcc",
        value: 3,
        tokenType: "alt",
        address: "0xb6c3c00d730acca326db40e418353f04f7444e2b",
        icon: null,
        usdValue: 0.02092019452130364,
      },
      {
        id: "137",
        name: "WIFI",
        value: 3,
        tokenType: "alt",
        address: "0xe238ecb42c424e877652ad82d8a939183a04c35f",
        icon: null,
        usdValue: 162074.6246800716,
      },
      {
        id: "137",
        name: "GEO$",
        value: 3,
        tokenType: "alt",
        address: "0xf1428850f92b87e629c6f3a3b75bffbc496f7ba6",
        icon: null,
        usdValue: 141.5704158505228,
      },
      {
        id: "42161",
        name: "GRB",
        value: 3,
        tokenType: "alt",
        address: "0x5fd71280b6385157b291b9962f22153fc9e79000",
        icon: null,
        usdValue: 0.5345850145933764,
      },
      {
        id: "42161",
        name: "STAR",
        value: 3,
        tokenType: "alt",
        address: "0xb299751b088336e165da313c33e3195b8c6663a6",
        icon: null,
        usdValue: 558.4891597001874,
      },
      {
        id: "42161",
        name: "HONEY",
        value: 3,
        tokenType: "alt",
        address: "0xde31e75182276738b0c025daa8f80020a4f2fbfe",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "CARBON",
        value: 3,
        tokenType: "alt",
        address: "0xfa42da1bd08341537a44a4ca9d236d1c00a98b40",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "vBNT",
        value: 3,
        tokenType: "alt",
        address: "0x48fb253446873234f2febbf9bdeaa72d9d387f94",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "RFI",
        value: 3,
        tokenType: "alt",
        address: "0xa1afffe3f4d611d252010e3eaf6f4d77088b0cd7",
        icon: null,
        usdValue: 0.03619607412265953,
      },
      {
        id: "1",
        name: "MINER",
        value: 3,
        tokenType: "alt",
        address: "0x23cbb9f0de3258de03baad2bcea4fccc55233af0",
        icon: null,
        usdValue: 1737.452374948427,
      },
      {
        id: "1",
        name: "BAPE",
        value: 3,
        tokenType: "alt",
        address: "0x9b7f20195a848072feacb4d3a6a75e2beb8f8ca1",
        icon: null,
        usdValue: 136.7665090520997,
      },
      {
        id: "1",
        name: "CHZB",
        value: 3,
        tokenType: "alt",
        address: "0xadd8abdea5cb95f4dcd8e128eeef64f023615a6a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "HLD",
        value: 3,
        tokenType: "alt",
        address: "0xca1308e38340c69e848061aa2c3880daeb958187",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "C4G3",
        value: 3,
        tokenType: "alt",
        address: "0xf2ef3551c1945a7218fc4ec0a75c9ecfdf012a4f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "bShiba",
        value: 3,
        tokenType: "alt",
        address: "0x6158b3435dc3bc54a19a32da2a2ed22aec3bef3e",
        icon: null,
        usdValue: 0.009567850093838216,
      },
      {
        id: "56",
        name: "ECP",
        value: 3,
        tokenType: "alt",
        address: "0x375483cfa7fc18f6b455e005d835a8335fbdbb1f",
        icon: null,
        usdValue: 67.43631033409395,
      },
      {
        id: "56",
        name: "ZEFU",
        value: 3,
        tokenType: "alt",
        address: "0x23ec58e45ac5313bcb6681f4f7827b8a8453ac45",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "OCTI",
        value: 3,
        tokenType: "alt",
        address: "0x6c1de9907263f0c12261d88b65ca18f31163f29d",
        icon: null,
        usdValue: 0.0017442886287435309,
      },
      {
        id: "56",
        name: "QBIT",
        value: 3,
        tokenType: "alt",
        address: "0xa38898a4ae982cb0131104a6746f77fa0da57aaa",
        icon: null,
        usdValue: 4.543210305354001e-7,
      },
      {
        id: "56",
        name: "$MFLATE",
        value: 3,
        tokenType: "alt",
        address: "0xafe3321309a994831884fc1725f4c3236ac79f76",
        icon: null,
        usdValue: 1.1112354807791656,
      },
      {
        id: "56",
        name: "SWAPZ",
        value: 3,
        tokenType: "alt",
        address: "0xd522a1dce1ca4b138dda042a78672307eb124cc2",
        icon: null,
        usdValue: 0.0016219385996389278,
      },
      {
        id: "56",
        name: "FREL",
        value: 3,
        tokenType: "alt",
        address: "0xfd5af95c12446b60d23e16a4ea95690ce942e5dc",
        icon: null,
        usdValue: 1.5045516337587945,
      },
      {
        id: "137",
        name: "WGC",
        value: 3,
        tokenType: "alt",
        address: "0x04565fe9aa3ae571ada8e1bebf8282c4e5247b2a",
        icon: null,
        usdValue: 0.0331568868503574,
      },
      {
        id: "137",
        name: "OMEN",
        value: 3,
        tokenType: "alt",
        address: "0x76e63a3e7ba1e2e61d3da86a87479f983de89a7e",
        icon: null,
        usdValue: 0.49770193667951834,
      },
      {
        id: "137",
        name: "ELET",
        value: 3,
        tokenType: "alt",
        address: "0x07738eb4ce8932ca961c815cb12c9d4ab5bd0da4",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "ZOO",
        value: 3,
        tokenType: "alt",
        address: "0x7ffc1243232da3ac001994208e2002816b57c669",
        icon: null,
        usdValue: 85.29578205407907,
      },
      {
        id: "56",
        name: "NNT",
        value: 3,
        tokenType: "alt",
        address: "0x3A2927E68749Dd6ad0A568d7c05b587863C0bC10",
        icon: null,
        usdValue: 133.376625527136,
      },
      {
        id: "137",
        name: "YEL",
        value: 3,
        tokenType: "alt",
        address: "0xd3b71117e6c1558c1553305b44988cd944e97300",
        icon: null,
        usdValue: 4.571439999999999,
      },
      {
        id: "56",
        name: "MXY",
        value: 3,
        tokenType: "alt",
        address: "0x965d3704de812f5e1e7eef1ac22fe92174258bd9",
        icon: null,
        usdValue: 38.27928896160544,
      },
      {
        id: "56",
        name: "HIMO",
        value: 3,
        tokenType: "alt",
        address: "0x469aCf8e1F29C1B5Db99394582464Fad45A1fC6F",
        icon: null,
        usdValue: 157.41426591900003,
      },
      {
        id: "56",
        name: "DORA",
        value: 3,
        tokenType: "alt",
        address: "0x18d7050dfd1aebb5f83ef144d95b6eaf5d4e6ff3",
        icon: null,
        usdValue: 1950.630506354387,
      },
      {
        id: "56",
        name: "KKMA",
        value: 3,
        tokenType: "alt",
        address: "0x18D3BE5ecDdF79279004e2d90d507594c2D46f85",
        icon: null,
        usdValue: 313.651320346877,
      },
      {
        id: "42161",
        name: "VOLTA",
        value: 3,
        tokenType: "alt",
        address: "0x417a1afd44250314bffb11ff68e989775e990ab6",
        icon: null,
        usdValue: 164.3525739274021,
      },
      {
        id: "1",
        name: "UTNP",
        value: 3,
        tokenType: "alt",
        address: "0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7",
        icon: null,
        usdValue: 39451974042.5064,
      },
      {
        id: "1",
        name: "NPX",
        value: 3,
        tokenType: "alt",
        address: "0x28b5e12cce51f15594b0b91d5b5adaa70f684a02",
        icon: null,
        usdValue: 47.691944843099996,
      },
      {
        id: "56",
        name: "MNST",
        value: 3,
        tokenType: "alt",
        address: "0x6a6Ccf15B38DA4b5B0eF4C8fe9FefCB472A893F9",
        icon: null,
        usdValue: 50.197446104968506,
      },
      {
        id: "56",
        name: "YAE",
        value: 3,
        tokenType: "alt",
        address: "0x4ee438be38f8682abb089f2bfea48851c5e71eaf",
        icon: null,
        usdValue: 58.005196919281204,
      },
      {
        id: "1",
        name: "AUDT",
        value: 3,
        tokenType: "alt",
        address: "0xb90cb79b72eb10c39cbdf86e50b1c89f6a235f2e",
        icon: null,
        usdValue: 12470.643590055051,
      },
      {
        id: "1",
        name: "$HACHI",
        value: 3,
        tokenType: "alt",
        address: "0x967b0c95295ead8faef70d26a7846aecd349aaff",
        icon: null,
        usdValue: 67.1773870295294,
      },
      {
        id: "1",
        name: "DRCT",
        value: 3,
        tokenType: "alt",
        address: "0x9d561d63375672abd02119b9bc4fb90eb9e307ca",
        icon: null,
        usdValue: 481.5417260277167,
      },
      {
        id: "56",
        name: "LACE",
        value: 3,
        tokenType: "alt",
        address: "0xA3499dd7dBBBD93CB0f8303f8a8AcE8D02508E73",
        icon: null,
        usdValue: 31.926103482571342,
      },
      {
        id: "1",
        name: "XBASE",
        value: 3,
        tokenType: "alt",
        address: "0x4d13d624a87baa278733c068a174412afa9ca6c8",
        icon: null,
        usdValue: 62.58990751668746,
      },
      {
        id: "56",
        name: "GULL",
        value: 3,
        tokenType: "alt",
        address: "0xca830317146BfdDE71e7C0B880e2ec1f66E273EE",
        icon: null,
        usdValue: 47.29720288662132,
      },
      {
        id: "1",
        name: "NUTS",
        value: 3,
        tokenType: "alt",
        address: "0x981dc247745800bd2ca28a4bf147f0385eaa0bc0",
        icon: null,
        usdValue: 0.9475253739357765,
      },
      {
        id: "1",
        name: "NEBO",
        value: 3,
        tokenType: "alt",
        address: "0x7f0c8b125040f707441cad9e5ed8a8408673b455",
        icon: null,
        usdValue: 36148.02591205659,
      },
      {
        id: "1",
        name: "HBT",
        value: 3,
        tokenType: "alt",
        address: "0x0ace32f6e87ac1457a5385f8eb0208f37263b415",
        icon: null,
        usdValue: 4.044571060013485,
      },
      {
        id: "1",
        name: "MYTH",
        value: 3,
        tokenType: "alt",
        address: "0xba41ddf06b7ffd89d1267b5a93bfef2424eb2003",
        icon: null,
        usdValue: 5.8722367656347706e-18,
      },
      {
        id: "1",
        name: "WSH",
        value: 3,
        tokenType: "alt",
        address: "0x12996c7b23c4012149bf9f5663ff9aa08a9cf2e4",
        icon: null,
        usdValue: 0.0910222173747,
      },
      {
        id: "1",
        name: "PEBBLE",
        value: 3,
        tokenType: "alt",
        address: "0xdc98c5543f3004debfaad8966ec403093d0aa4a8",
        icon: null,
        usdValue: 2319.3297705010336,
      },
      {
        id: "1",
        name: "NFTT",
        value: 3,
        tokenType: "alt",
        address: "0x5fa2e9ba5757504b3d6e8f6da03cc40d4ce19499",
        icon: null,
        usdValue: 53.76199331143393,
      },
      {
        id: "1",
        name: "CUDL",
        value: 3,
        tokenType: "alt",
        address: "0xecd20f0ebc3da5e514b4454e3dc396e7da18ca6a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "WARP",
        value: 3,
        tokenType: "alt",
        address: "0xed40834a13129509a89be39a9be9c0e96a0ddd71",
        icon: null,
        usdValue: 853.7713508304521,
      },
      {
        id: "1",
        name: "KBTC",
        value: 3,
        tokenType: "alt",
        address: "0xe6c3502997f97f9bde34cb165fbce191065e068f",
        icon: null,
        usdValue: 18.764740907506894,
      },
      {
        id: "1",
        name: "DIGITS",
        value: 3,
        tokenType: "alt",
        address: "0xbe56ab825fd35678a32dc35bc4eb17e238e1404f",
        icon: null,
        usdValue: 34902.747099789915,
      },
      {
        id: "1",
        name: "ORCH",
        value: 3,
        tokenType: "alt",
        address: "0xc4cefdf1bc9fde0ef82cdfe609dc743ee23ff1ca",
        icon: null,
        usdValue: 124.22740466207036,
      },
      {
        id: "1",
        name: "pPEAS",
        value: 3,
        tokenType: "alt",
        address: "0x027ce48b9b346728557e8d420fe936a72bf9b1c7",
        icon: null,
        usdValue: 31191.538672736708,
      },
      {
        id: "1",
        name: "BRAIN",
        value: 3,
        tokenType: "alt",
        address: "0x3ddebf2ead6325b1923ba5ff8fd239325c70e9a2",
        icon: null,
        usdValue: 9747.759179685476,
      },
      {
        id: "1",
        name: "BNSD",
        value: 3,
        tokenType: "alt",
        address: "0x668dbf100635f593a3847c0bdaf21f0a09380188",
        icon: null,
        usdValue: 0.25856515809412517,
      },
      {
        id: "1",
        name: "TATSU",
        value: 3,
        tokenType: "alt",
        address: "0x92f419fb7a750aed295b0ddf536276bf5a40124f",
        icon: null,
        usdValue: 2147.4275396122557,
      },
      {
        id: "1",
        name: "FGATE",
        value: 3,
        tokenType: "alt",
        address: "0x97808df7afb14134d37a91576bdb8b95dfcd2e92",
        icon: null,
        usdValue: 303.277111245136,
      },
      {
        id: "1",
        name: "SAGE",
        value: 3,
        tokenType: "alt",
        address: "0xa71261c2b51cb8030700f5601ca597c522dc232e",
        icon: null,
        usdValue: 53089.12278853009,
      },
      {
        id: "1",
        name: "HILO",
        value: 3,
        tokenType: "alt",
        address: "0xbb9fd9fa4863c03c574007ff3370787b9ce65ff6",
        icon: null,
        usdValue: 1.3625864349970815e-19,
      },
      {
        id: "1",
        name: "DUPE",
        value: 3,
        tokenType: "alt",
        address: "0xc78a697ca2eec28682d6784ce588ab774c101cd2",
        icon: null,
        usdValue: 3732.0852389390075,
      },
      {
        id: "1",
        name: "TGL",
        value: 3,
        tokenType: "alt",
        address: "0xcc4450edefbbeb450e2f205f4eceff7232d54e92",
        icon: null,
        usdValue: 0,
      },
      {
        id: "10",
        name: "USDC",
        value: 3,
        tokenType: "alt",
        address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        icon: null,
        usdValue: 15922.887822,
      },
      {
        id: "56",
        name: "SABA",
        value: 3,
        tokenType: "alt",
        address: "0xff12afb3841b737289d1b02dfedbe4c85a8ec6e6",
        icon: null,
        usdValue: 747.1226898765001,
      },
      {
        id: "56",
        name: "GYRO",
        value: 3,
        tokenType: "alt",
        address: "0x1b239abe619e74232c827fbe5e49a4c072bd869d",
        icon: null,
        usdValue: 0.00020779382042519654,
      },
      {
        id: "56",
        name: "MOONLIGHT",
        value: 3,
        tokenType: "alt",
        address: "0xb1ced2e320e3f4c8e3511b1dc59203303493f382",
        icon: null,
        usdValue: 5885.138370419949,
      },
      {
        id: "56",
        name: "CODEX",
        value: 3,
        tokenType: "alt",
        address: "0x9e95cb3d0560f9cba88991f828322526851bfb56",
        icon: null,
        usdValue: 0.04825642496830078,
      },
      {
        id: "56",
        name: "APEFUND",
        value: 3,
        tokenType: "alt",
        address: "0xf81f3ff200abd5451e78105eaa7ee9f8e8dd20f8",
        icon: null,
        usdValue: 2.665480039699724,
      },
      {
        id: "137",
        name: "DHC",
        value: 3,
        tokenType: "alt",
        address: "0xf9c1f70f9bf57fad5f63c6e1e25c2e895f04c0a6",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "fxVRSW",
        value: 3,
        tokenType: "alt",
        address: "0x57999936fc9a9ec0751a8d146cce11901be8bed0",
        icon: null,
        usdValue: 3538.4544826104475,
      },
      {
        id: "137",
        name: "GFI",
        value: 3,
        tokenType: "alt",
        address: "0x874e178a2f3f3f9d34db862453cd756e7eab0381",
        icon: null,
        usdValue: 14.92744447856893,
      },
      {
        id: "137",
        name: "tPOKT",
        value: 3,
        tokenType: "alt",
        address: "0x5430a0b6c11f870571ffa891d59dec8c4608ea9a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "ARRAY",
        value: 3,
        tokenType: "alt",
        address: "0x164731CD270daA4A94bc70761E53320e48367B8B",
        icon: null,
        usdValue: 247.38501599999998,
      },
      {
        id: "42161",
        name: "plsDPX",
        value: 3,
        tokenType: "alt",
        address: "0xf236ea74b515ef96a9898f5a4ed4aa591f253ce1",
        icon: null,
        usdValue: 29.57391090751986,
      },
      {
        id: "42161",
        name: "HAMI",
        value: 3,
        tokenType: "alt",
        address: "0x02150e97271fdc0d6e3a16d9094a0948266f07dd",
        icon: null,
        usdValue: 2076.1205461916843,
      },
      {
        id: "42161",
        name: "BUGS",
        value: 3,
        tokenType: "alt",
        address: "0x3350748459411d148e9c9e2cb3dcb3b4bdc509cb",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "LOTTO",
        value: 3,
        tokenType: "alt",
        address: "0x4a35ca865abec4205430081ccdf768610e06bfbc",
        icon: null,
        usdValue: 148.19682249416672,
      },
      {
        id: "42161",
        name: "tigUSD",
        value: 3,
        tokenType: "alt",
        address: "0x7e491f53bf807f836e2dd6c4a4fbd193e1913efd",
        icon: null,
        usdValue: 92.37956999240765,
      },
      {
        id: "42161",
        name: "FCT",
        value: 3,
        tokenType: "alt",
        address: "0x97d4a4d04f41b4f958290bfdda45c1f3db4adda3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "P4D",
        value: 3,
        tokenType: "alt",
        address: "0xefc43cf79f406d62960e34d3a62c729a0eebec4b",
        icon: null,
        usdValue: 0.00006907595966553608,
      },
      {
        id: "42161",
        name: "MGN",
        value: 3,
        tokenType: "alt",
        address: "0xfc77b86f3ade71793e1eec1e7944db074922856e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "SANCTA",
        value: 3,
        tokenType: "alt",
        address: "0x810cf1757b51963102e0b4fe9fdfcdf749dea98a",
        icon: null,
        usdValue: 1130.9058,
      },
      {
        id: "1",
        name: "SNP",
        value: 3,
        tokenType: "alt",
        address: "0x6911f552842236bd9e8ea8ddbb3fb414e2c5fa9d",
        icon: null,
        usdValue: 119.39880606,
      },
      {
        id: "56",
        name: "JIG",
        value: 3,
        tokenType: "alt",
        address: "0x1a122941ff2ef376f065e0404a0a9cecbfe94551",
        icon: null,
        usdValue: 175.88913852072,
      },
      {
        id: "1",
        name: "KYOKO",
        value: 3,
        tokenType: "alt",
        address: "0x14a32f050FACF226Ec60882398A9BF36d91DBaC2",
        icon: null,
        usdValue: 1113.6019261090119,
      },
      {
        id: "56",
        name: "GMI",
        value: 3,
        tokenType: "alt",
        address: "0x93d8d25e3c9a847a5da79f79ecac89461feca846",
        icon: null,
        usdValue: 116.28952645451778,
      },
      {
        id: "1",
        name: "BORPA",
        value: 3,
        tokenType: "alt",
        address: "0x2f1ea376e52d2dd9dd9b1f00e17c90c301fe68d8",
        icon: null,
        usdValue: 226.33841931033075,
      },
      {
        id: "1",
        name: "BLAST",
        value: 3,
        tokenType: "alt",
        address: "0x3127294f1fd3c097ef31e54301069346b29d0209",
        icon: null,
        usdValue: 30.842476109627704,
      },
      {
        id: "1",
        name: "TRUMP",
        value: 3,
        tokenType: "alt",
        address: "0x34afcfb71204ca05047bc28086683db877b52024",
        icon: null,
        usdValue: 15.439867502897684,
      },
      {
        id: "1",
        name: "BM",
        value: 3,
        tokenType: "alt",
        address: "0x8a28ad3476228a1ca5a8762dd64cbfe0b28724e9",
        icon: null,
        usdValue: 25.708975146480782,
      },
      {
        id: "1",
        name: "METH",
        value: 3,
        tokenType: "alt",
        address: "0x9892fce0bd34806cf9ac39a3fe921f5c96852926",
        icon: null,
        usdValue: 2.1499416803033626,
      },
      {
        id: "1",
        name: "BABYELON",
        value: 3,
        tokenType: "alt",
        address: "0xdfb4a81727aa961b6ee830720843104fae0fdff9",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "YOURAI",
        value: 3,
        tokenType: "alt",
        address: "0x27f16d9a5095b763baeadd7dd78e83288af29cf4",
        icon: null,
        usdValue: 3.4245,
      },
      {
        id: "137",
        name: "FOLK",
        value: 3,
        tokenType: "alt",
        address: "0xe05fba9fb4796dedf2e81e6f85f11d0fd6f1ade0",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "TOOB",
        value: 3,
        tokenType: "alt",
        address: "0x676f7ed2d4829460f73468b36be49e0d6505107f",
        icon: null,
        usdValue: 7.871751712071216,
      },
      {
        id: "56",
        name: "XCT",
        value: 3,
        tokenType: "alt",
        address: "0xe8670901e86818745b28c8b30b17986958fce8cc",
        icon: null,
        usdValue: 219.20403755000004,
      },
      {
        id: "137",
        name: "AUDT",
        value: 3,
        tokenType: "alt",
        address: "0x91c5a5488c0decde1eacd8a4f10e0942fb925067",
        icon: null,
        usdValue: 783.5017944734757,
      },
      {
        id: "1",
        name: "DGMV",
        value: 3,
        tokenType: "alt",
        address: "0x8eedefe828a0f16c8fc80e46a87bc0f1de2d960c",
        icon: null,
        usdValue: 34.416248766162134,
      },
      {
        id: "56",
        name: "LEZ",
        value: 3,
        tokenType: "alt",
        address: "0xC23BE03F64a834B3Fa6aE62C97ac8B40F3Eec6A9",
        icon: null,
        usdValue: 527.191675816975,
      },
      {
        id: "56",
        name: "EBA",
        value: 3,
        tokenType: "alt",
        address: "0x3944ac66b9b9b40a6474022d6962b6caa001b5e3",
        icon: null,
        usdValue: 88.22398763013082,
      },
      {
        id: "1",
        name: "IBEX",
        value: 3,
        tokenType: "alt",
        address: "0xf655c8567e0f213e6c634cd2a68d992152161dc6",
        icon: null,
        usdValue: 148.96637141256,
      },
      {
        id: "56",
        name: "CPO",
        value: 3,
        tokenType: "alt",
        address: "0xea395dfafed39924988b475f2ca7f4c72655203a",
        icon: null,
        usdValue: 278.47531651921395,
      },
      {
        id: "137",
        name: "OKLP",
        value: 3,
        tokenType: "alt",
        address: "0x5d48a5e5a3e737322ae27e25897f1c9e19ecc941",
        icon: null,
        usdValue: 174.35091098880002,
      },
      {
        id: "1",
        name: "EVED",
        value: 3,
        tokenType: "alt",
        address: "0x5aaefe84e0fb3dd1f0fcff6fa7468124986b91bd",
        icon: null,
        usdValue: 130.06677272709413,
      },
      {
        id: "56",
        name: "DEPO",
        value: 3,
        tokenType: "alt",
        address: "0x7d99eda556388Ad7743A1B658b9C4FC67D7A9d74",
        icon: null,
        usdValue: 57.3713664,
      },
      {
        id: "1",
        name: "NAME",
        value: 3,
        tokenType: "alt",
        address: "0xe1a4c5bbb704a92599fedb191f451e0d3a1ed842",
        icon: null,
        usdValue: 35.6031202684758,
      },
      {
        id: "1",
        name: "ALCA",
        value: 3,
        tokenType: "alt",
        address: "0xBb556b0eE2CBd89ed95DdEA881477723A3Aa8F8b",
        icon: null,
        usdValue: 6295.1165775277295,
      },
      {
        id: "56",
        name: "WOD",
        value: 3,
        tokenType: "alt",
        address: "0x298632d8ea20d321fab1c9b473df5dbda249b2b6",
        icon: null,
        usdValue: 102.81991489540005,
      },
      {
        id: "1",
        name: "TOON",
        value: 3,
        tokenType: "alt",
        address: "0xaeE433ADeBe0FBB88dAa47eF0C1A513CaA52EF02",
        icon: null,
        usdValue: 153.5423049642883,
      },
      {
        id: "56",
        name: "CANDY",
        value: 3,
        tokenType: "alt",
        address: "0x03436Fe878e33Be3C8CAEbd205ebc04A66aA3248",
        icon: null,
        usdValue: 6.244304867079393,
      },
      {
        id: "137",
        name: "WHEY",
        value: 3,
        tokenType: "alt",
        address: "0x0cfbbb89fd58f6b49b7bf5665397ddc84003d47c",
        icon: null,
        usdValue: 0.36550070574486015,
      },
      {
        id: "56",
        name: "CFL365",
        value: 3,
        tokenType: "alt",
        address: "0xc1e0510a0df7646817b6632d32caa681a425a5e6",
        icon: null,
        usdValue: 1117.3686500645408,
      },
      {
        id: "56",
        name: "FARA",
        value: 3,
        tokenType: "alt",
        address: "0xF4Ed363144981D3A65f42e7D0DC54FF9EEf559A1",
        icon: null,
        usdValue: 36.042688167998755,
      },
      {
        id: "56",
        name: "NFTS",
        value: 3,
        tokenType: "alt",
        address: "0x08037036451c768465369431da5c671ad9b37dbc",
        icon: null,
        usdValue: 404.35931328675,
      },
      {
        id: "56",
        name: "KXA",
        value: 3,
        tokenType: "alt",
        address: "0x2223bF1D7c19EF7C06DAB88938EC7B85952cCd89",
        icon: null,
        usdValue: 105.40542082200001,
      },
      {
        id: "1",
        name: "TENSHI",
        value: 3,
        tokenType: "alt",
        address: "0x52662717e448be36cb54588499d5a8328bd95292",
        icon: null,
        usdValue: 0.005502737590367275,
      },
      {
        id: "1",
        name: "EQL",
        value: 3,
        tokenType: "alt",
        address: "0x81428a8047cca11177a4e15789e368d6806da376",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "SAS",
        value: 3,
        tokenType: "alt",
        address: "0x4c38d0e726b6c86f64c1b281348e725973542043",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "ETHFI",
        value: 3,
        tokenType: "alt",
        address: "0xfe0c30065b384f05761f15d0cc899d4f9f9cc0eb",
        icon: null,
        usdValue: 93.52935183140976,
      },
      {
        id: "1",
        name: "RCH",
        value: 3,
        tokenType: "alt",
        address: "0x57b96d4af698605563a4653d882635da59bf11af",
        icon: null,
        usdValue: 66534.31969086805,
      },
      {
        id: "1",
        name: "LUNA",
        value: 3,
        tokenType: "alt",
        address: "0xd2877702675e6ceb975b4a1dff9fb7baf4c91ea9",
        icon: null,
        usdValue: 0.03637061809197936,
      },
      {
        id: "1",
        name: "PGT",
        value: 3,
        tokenType: "alt",
        address: "0xeaccb6e0f24d66cf4aa6cbda33971b9231d332a1",
        icon: null,
        usdValue: 273.3500876986177,
      },
      {
        id: "1",
        name: "MIC",
        value: 3,
        tokenType: "alt",
        address: "0x368b3a58b5f49392e5c9e4c998cb0bb966752e51",
        icon: null,
        usdValue: 0.00016227420045859995,
      },
      {
        id: "1",
        name: "eef",
        value: 3,
        tokenType: "alt",
        address: "0x6412816b834caa82d8be0c601ea4aa60ed97a871",
        icon: null,
        usdValue: 427.2705194517612,
      },
      {
        id: "1",
        name: "Metis",
        value: 3,
        tokenType: "alt",
        address: "0x9e32b13ce7f2e80a01932b42553652e053d6ed8e",
        icon: null,
        usdValue: 1.5588e-16,
      },
      {
        id: "1",
        name: "sBTC",
        value: 3,
        tokenType: "alt",
        address: "0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6",
        icon: null,
        usdValue: 2423.091204173039,
      },
      {
        id: "1",
        name: "PEIPEI",
        value: 3,
        tokenType: "alt",
        address: "0x3ffeea07a27fab7ad1df5297fa75e77a43cb5790",
        icon: null,
        usdValue: 2.9474374521900004e-25,
      },
      {
        id: "1",
        name: "PEDO",
        value: 3,
        tokenType: "alt",
        address: "0xe9cdb1639bf18be40a231525c22844b3bd0eee66",
        icon: null,
        usdValue: 304.82892853508037,
      },
      {
        id: "1",
        name: "TETE",
        value: 3,
        tokenType: "alt",
        address: "0xfce6e94f0759b35470bc8360bf4fcdd228843937",
        icon: null,
        usdValue: 172.91881781570828,
      },
      {
        id: "1",
        name: "Mars",
        value: 3,
        tokenType: "alt",
        address: "0x66c0dded8433c9ea86c8cf91237b14e10b4d70b7",
        icon: null,
        usdValue: 0.00014980934681652584,
      },
      {
        id: "1",
        name: "BOOST",
        value: 3,
        tokenType: "alt",
        address: "0x4e0fca55a6c3a94720ded91153a27f60e26b9aa8",
        icon: null,
        usdValue: 0.7164682756420487,
      },
      {
        id: "1",
        name: "EverApe ",
        value: 3,
        tokenType: "alt",
        address: "0x3f9078b8fbcb1c4e03b41fa9e5a0532a28848db7",
        icon: null,
        usdValue: 0.0002707557853268578,
      },
      {
        id: "1",
        name: "WORLD",
        value: 3,
        tokenType: "alt",
        address: "0xbf494f02ee3fde1f20bee6242bce2d1ed0c15e47",
        icon: null,
        usdValue: 3.7243824637612146,
      },
      {
        id: "1",
        name: "DFIO",
        value: 3,
        tokenType: "alt",
        address: "0xee3b9b531f4c564c70e14b7b3bb7d516f33513ff",
        icon: null,
        usdValue: 940.4924487906383,
      },
      {
        id: "1",
        name: "BSD",
        value: 3,
        tokenType: "alt",
        address: "0x003e0af2916e598fa5ea5cb2da4edfda9aed9fde",
        icon: null,
        usdValue: 1.0178883033501722,
      },
      {
        id: "1",
        name: "XDEX",
        value: 3,
        tokenType: "alt",
        address: "0x000000000000d0151e748d25b766e77efe2a6c83",
        icon: null,
        usdValue: 135.87347788475256,
      },
      {
        id: "1",
        name: "oneETH",
        value: 3,
        tokenType: "alt",
        address: "0x6fcbbb527fb2954bed2b224a5bb7c23c5aeeb6e1",
        icon: null,
        usdValue: 0.0012764364936465595,
      },
      {
        id: "1",
        name: "APUGURL",
        value: 3,
        tokenType: "alt",
        address: "0x069f01cdd1e32d7bab5fc81527df191835136c9d",
        icon: null,
        usdValue: 68.97231097558914,
      },
      {
        id: "1",
        name: "FMA",
        value: 3,
        tokenType: "alt",
        address: "0x0f8794f66c7170c4f9163a8498371a747114f6c4",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "GOLF",
        value: 3,
        tokenType: "alt",
        address: "0x1979f13bc93ac74106469b7ca8b9081359131986",
        icon: null,
        usdValue: 136.5244395894124,
      },
      {
        id: "1",
        name: "SEED",
        value: 3,
        tokenType: "alt",
        address: "0x30cf203b48edaa42c3b4918e955fed26cd012a3f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "HATCH",
        value: 3,
        tokenType: "alt",
        address: "0x6f3009663470475f0749a6b76195375f95495fcb",
        icon: null,
        usdValue: 7.535635757420798e-16,
      },
      {
        id: "1",
        name: "KAPPA",
        value: 3,
        tokenType: "alt",
        address: "0x924422ef5b3aedf535f79dbc48eef22db466bac9",
        icon: null,
        usdValue: 349.44233677044565,
      },
      {
        id: "1",
        name: "DOGEFI",
        value: 3,
        tokenType: "alt",
        address: "0x9b9087756eca997c5d595c840263001c9a26646d",
        icon: null,
        usdValue: 24.10924018389054,
      },
      {
        id: "1",
        name: "SHIBX",
        value: 3,
        tokenType: "alt",
        address: "0xc31b0ef60e4f482bbe3d78cc8c9450aec6f813af",
        icon: null,
        usdValue: 430.18836377074354,
      },
      {
        id: "1",
        name: "FFYI",
        value: 3,
        tokenType: "alt",
        address: "0xca76baa777d749de63ca044853d22d56bc70bb47",
        icon: null,
        usdValue: 31.705708427775413,
      },
      {
        id: "1",
        name: "ROT",
        value: 3,
        tokenType: "alt",
        address: "0xd04785c4d8195e4a54d9dec3a9043872875ae9e2",
        icon: null,
        usdValue: 0.021483618924450915,
      },
      {
        id: "1",
        name: "SPURDO",
        value: 3,
        tokenType: "alt",
        address: "0xd3999188ff689b99d8097a4876f61e70b22f7881",
        icon: null,
        usdValue: 0.1728081751927518,
      },
      {
        id: "1",
        name: "renFIL",
        value: 3,
        tokenType: "alt",
        address: "0xd5147bc8e386d91cc5dbe72099dac6c9b99276f5",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "GIV",
        value: 3,
        tokenType: "alt",
        address: "0xf6537fe0df7f0cc0985cf00792cc98249e73efa0",
        icon: null,
        usdValue: 5.47094084640433,
      },
      {
        id: "1",
        name: "FIRE",
        value: 3,
        tokenType: "alt",
        address: "0xf921ae2dac5fa128dc0f6168bf153ea0943d2d43",
        icon: null,
        usdValue: 7.67334438711828,
      },
      {
        id: "1",
        name: "SIL",
        value: 3,
        tokenType: "alt",
        address: "0x133bb423d9248a336d2b3086b8f44a7dbff3a13c",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "VEC",
        value: 3,
        tokenType: "alt",
        address: "0x1bb9b64927e0c5e207c9db4093b3738eef5d8447",
        icon: null,
        usdValue: 8.199082457562254e-8,
      },
      {
        id: "1",
        name: "FROGE",
        value: 3,
        tokenType: "alt",
        address: "0x29502fe4d233ef0b45c3647101fa1252ce0634bd",
        icon: null,
        usdValue: 6.68585602074e-16,
      },
      {
        id: "1",
        name: "$WTRUMP",
        value: 3,
        tokenType: "alt",
        address: "0x39c6d5065f6c9cbf7ea07e4e1be35d2ca3738ab7",
        icon: null,
        usdValue: 36.510015816817116,
      },
      {
        id: "1",
        name: "FLUT",
        value: 3,
        tokenType: "alt",
        address: "0x4f08705fb8f33affc231ed66e626b40e84a71870",
        icon: null,
        usdValue: 4.41145792048461e-15,
      },
      {
        id: "1",
        name: "WJD",
        value: 3,
        tokenType: "alt",
        address: "0x7bce8642652b3c61682b03202481d589f1e0d333",
        icon: null,
        usdValue: 7.524676962750001e-16,
      },
      {
        id: "1",
        name: "KEKEI",
        value: 3,
        tokenType: "alt",
        address: "0x7d30e44f8fde0446ed0023bce2e9fc8db89d7df2",
        icon: null,
        usdValue: 322.54168891495766,
      },
      {
        id: "1",
        name: "TRIB",
        value: 3,
        tokenType: "alt",
        address: "0xe09216f1d343dd39d6aa732a08036fee48555af0",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "PCD ",
        value: 3,
        tokenType: "alt",
        address: "0xceb24c99579e6140517d59c8dd4f5b36d84ed6de",
        icon: null,
        usdValue: 0.14270523264811216,
      },
      {
        id: "56",
        name: "GO!",
        value: 3,
        tokenType: "alt",
        address: "0x7ae1cbec5c315b31948dd2a5a7c2a6a6040d3d5b",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "WOLF",
        value: 3,
        tokenType: "alt",
        address: "0x8f18dc399594b451eda8c5da02d0563c0b2d0f16",
        icon: null,
        usdValue: 0.00008133280213335322,
      },
      {
        id: "137",
        name: "CP",
        value: 3,
        tokenType: "alt",
        address: "0xf9d3d8b25b95bcda979025b74fdfa7ac3f380f9f",
        icon: null,
        usdValue: 3.407233233e-8,
      },
      {
        id: "42161",
        name: "MEOW",
        value: 3,
        tokenType: "alt",
        address: "0xfb1f65955e168e0ef500b170eed4a4efeb99ae32",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "BUCK",
        value: 3,
        tokenType: "alt",
        address: "0xafd871f684f21ab9d7137608c71808f83d75e6fc",
        icon: null,
        usdValue: 212.39420103346714,
      },
      {
        id: "42161",
        name: "DTL",
        value: 3,
        tokenType: "alt",
        address: "0x12f7cf4f2e3f87678ec5207fc920c815e31524df",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "esBFR",
        value: 3,
        tokenType: "alt",
        address: "0x92914a456ebe5db6a69905f029d6160cf51d3e6a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "HOOP",
        value: 3,
        tokenType: "alt",
        address: "0xF19cfb40B3774dF6Eed83169Ad5aB0Aaf6865F25",
        icon: null,
        usdValue: 40.0649638948795,
      },
      {
        id: "1",
        name: "KALLY",
        value: 3,
        tokenType: "alt",
        address: "0xfd30c9bea1a952feeed2ef2c6b2ff8a8fc4aad07",
        icon: null,
        usdValue: 62.572235771775915,
      },
      {
        id: "1",
        name: "BISC",
        value: 3,
        tokenType: "alt",
        address: "0x4295c8556AFEE00264C0789dde2ddd2dba71AcFe",
        icon: null,
        usdValue: 187.89604465807062,
      },
      {
        id: "56",
        name: "HELMET",
        value: 3,
        tokenType: "alt",
        address: "0x948d2a81086A075b3130BAc19e4c6DEe1D2E3fE8",
        icon: null,
        usdValue: 143.14503795387185,
      },
      {
        id: "42161",
        name: "ARKEN",
        value: 3,
        tokenType: "alt",
        address: "0xAf5db6E1CC585ca312E8c8F7c499033590cf5C98",
        icon: null,
        usdValue: 5.852371047,
      },
      {
        id: "137",
        name: "SYN",
        value: 3,
        tokenType: "alt",
        address: "0xf8f9efc0db77d8881500bb06ff5d6abc3070e695",
        icon: null,
        usdValue: 202.0912131443534,
      },
      {
        id: "137",
        name: "FOX",
        value: 3,
        tokenType: "alt",
        address: "0x65A05DB8322701724c197AF82C9CaE41195B0aA8",
        icon: null,
        usdValue: 175.3549784799153,
      },
      {
        id: "56",
        name: "ELK",
        value: 3,
        tokenType: "alt",
        address: "0xeEeEEb57642040bE42185f49C52F7E9B38f8eeeE",
        icon: null,
        usdValue: 20.302733651257913,
      },
      {
        id: "137",
        name: "HEX",
        value: 3,
        tokenType: "alt",
        address: "0x23D29D30e35C5e8D321e1dc9A8a61BFD846D4C5C",
        icon: null,
        usdValue: 283.50112179559414,
      },
      {
        id: "42161",
        name: "GOHM",
        value: 3,
        tokenType: "alt",
        address: "0x8D9bA570D6cb60C7e3e0F31343Efe75AB8E65FB1",
        icon: null,
        usdValue: 15427.659911482197,
      },
      {
        id: "8453",
        name: "WETH",
        value: 3,
        tokenType: "alt",
        address: "0x4200000000000000000000000000000000000006",
        icon: null,
        usdValue: 588.5212368528283,
      },
      {
        id: "137",
        name: "MIM",
        value: 3,
        tokenType: "stable",
        address: "0x49a0400587a7f65072c87c4910449fdcc5c47242",
        icon: null,
        usdValue: 8.58264926957484,
      },
      {
        id: "1",
        name: "MATICX",
        value: 3,
        tokenType: "alt",
        address: "0xf03a7eb46d01d9ecaa104558c732cf82f6b6b645",
        icon: null,
        usdValue: 524802.8189478155,
      },
      {
        id: "56",
        name: "AIR",
        value: 3,
        tokenType: "alt",
        address: "0xd8a2ae43fd061d24acd538e3866ffc2c05151b53",
        icon: null,
        usdValue: 356.25210887907906,
      },
      {
        id: "1",
        name: "HUM",
        value: 3,
        tokenType: "alt",
        address: "0x174aFE7A032b5A33a3270a9f6C30746E25708532",
        icon: null,
        usdValue: 42.60416059731655,
      },
      {
        id: "10",
        name: "OATH",
        value: 3,
        tokenType: "alt",
        address: "0x39fde572a18448f8139b7788099f0a0740f51205",
        icon: null,
        usdValue: 19.91936804645111,
      },
      {
        id: "137",
        name: "DPI",
        value: 3,
        tokenType: "alt",
        address: "0x85955046df4668e1dd369d2de9f3aeb98dd2a369",
        icon: null,
        usdValue: 106.97688110990754,
      },
      {
        id: "10",
        name: "grain",
        value: 3,
        tokenType: "alt",
        address: "0xfd389dc9533717239856190f42475d3f263a270d",
        icon: null,
        usdValue: 131.90003854165238,
      },
      {
        id: "1",
        name: "FIEF",
        value: 3,
        tokenType: "alt",
        address: "0xea068fba19ce95f12d252ad8cb2939225c4ea02d",
        icon: null,
        usdValue: 338.9548245795906,
      },
      {
        id: "10",
        name: "uni",
        value: 3,
        tokenType: "alt",
        address: "0x6fd9d7ad17242c41f7131d257212c54a0e816691",
        icon: null,
        usdValue: 27.147955444594672,
      },
      {
        id: "1",
        name: "EURe",
        value: 3,
        tokenType: "stable",
        address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
        icon: null,
        usdValue: 18.679228556897517,
      },
      {
        id: "137",
        name: "KNC",
        value: 3,
        tokenType: "alt",
        address: "0x1c954e8fe737f99f68fa1ccda3e51ebdb291948c",
        icon: null,
        usdValue: 31.202996964421978,
      },
      {
        id: "1",
        name: "BERRY",
        value: 3,
        tokenType: "alt",
        address: "0x6aeb95f06cda84ca345c2de0f3b7f96923a44f4c",
        icon: null,
        usdValue: 28.37787441013526,
      },
      {
        id: "56",
        name: "AFD",
        value: 3,
        tokenType: "alt",
        address: "0x198271b868daE875bFea6e6E4045cDdA5d6B9829",
        icon: null,
        usdValue: 12.040901913105243,
      },
      {
        id: "56",
        name: "SHIDO",
        value: 3,
        tokenType: "alt",
        address: "0x733Af324146DCfe743515D8D77DC25140a07F9e0",
        icon: null,
        usdValue: 24.017556622460656,
      },
      {
        id: "1",
        name: "COM",
        value: 3,
        tokenType: "alt",
        address: "0x5a9780bfe63f3ec57f01b087cd65bd656c9034a8",
        icon: null,
        usdValue: 1160.639481105144,
      },
      {
        id: "1",
        name: "PLSB",
        value: 3,
        tokenType: "alt",
        address: "0x5ee84583f67d5ecea5420dbb42b462896e7f8d06",
        icon: null,
        usdValue: 51.90400203766323,
      },
      {
        id: "1",
        name: "STONE",
        value: 3,
        tokenType: "alt",
        address: "0x7122985656e38BDC0302Db86685bb972b145bD3C",
        icon: null,
        usdValue: 7.361437563437578,
      },
      {
        id: "10",
        name: "dht",
        value: 3,
        tokenType: "alt",
        address: "0xaf9fe3b5ccdae78188b1f8b9a49da7ae9510f151",
        icon: null,
        usdValue: 10.423193172234752,
      },
      {
        id: "1",
        name: "MCRT",
        value: 3,
        tokenType: "alt",
        address: "0xde16Ce60804a881e9F8c4eBB3824646EDecd478D",
        icon: null,
        usdValue: 117.4742283836235,
      },
      {
        id: "1",
        name: "CARR",
        value: 3,
        tokenType: "alt",
        address: "0x884ddbb5dc6c2cef77d3e74c6ccca315797d655b",
        icon: null,
        usdValue: 53.114875996090674,
      },
      {
        id: "1",
        name: "XAUR",
        value: 3,
        tokenType: "alt",
        address: "0x4df812f6064def1e5e029f1ca858777cc98d2d81",
        icon: null,
        usdValue: 8136.415395155469,
      },
      {
        id: "1",
        name: "GOLD",
        value: 3,
        tokenType: "alt",
        address: "0x40d1f63b5d2048e67e9bedb1b4c2f1a9fb4b6817",
        icon: null,
        usdValue: 18051.245959852837,
      },
      {
        id: "1",
        name: "NGM",
        value: 3,
        tokenType: "alt",
        address: "0xed0d5747a9ab03a75fbfec3228cd55848245b75d",
        icon: null,
        usdValue: 6841.825374610549,
      },
      {
        id: "1",
        name: "HIFIDENZA",
        value: 3,
        tokenType: "alt",
        address: "0xb3e6Ee8d2c586FA03Ab70Aef96B8aE6D12D64eC7",
        icon: null,
        usdValue: 89569.01789747339,
      },
      {
        id: "1",
        name: "HICOOLCATS",
        value: 3,
        tokenType: "alt",
        address: "0x082716b6734b31791407d7Dd0e2a2c41260029b2",
        icon: null,
        usdValue: 117047.59385604187,
      },
      {
        id: "1",
        name: "HIFLUF",
        value: 3,
        tokenType: "alt",
        address: "0x79c9e0410b6615e7ba9dd69614b0519325a2b047",
        icon: null,
        usdValue: 66279.58763985535,
      },
      {
        id: "1",
        name: "FTX",
        value: 3,
        tokenType: "alt",
        address: "0xd559f20296FF4895da39b5bd9ADd54b442596a61",
        icon: null,
        usdValue: 55.099677471629846,
      },
      {
        id: "1",
        name: "WBX",
        value: 3,
        tokenType: "alt",
        address: "0xbb97e381f1d1e94ffa2a5844f6875e6146981009",
        icon: null,
        usdValue: 53854.485023815374,
      },
      {
        id: "1",
        name: "PLAY",
        value: 3,
        tokenType: "alt",
        address: "0xe477292f1b3268687a29376116b0ed27a9c76170",
        icon: null,
        usdValue: 20.03551138399587,
      },
      {
        id: "1",
        name: "INXT",
        value: 3,
        tokenType: "alt",
        address: "0x4a8f5f96d5436e43112c2fbc6a9f70da9e4e16d4",
        icon: null,
        usdValue: 9640.813152529478,
      },
      {
        id: "1",
        name: "HMQ",
        value: 3,
        tokenType: "alt",
        address: "0xcbcc0f036ed4788f63fc0fee32873d6a7487b908",
        icon: null,
        usdValue: 61487.57614165431,
      },
      {
        id: "1",
        name: "BKR",
        value: 3,
        tokenType: "alt",
        address: "0x77271813bd9167e75b5df9c230cf58d64f0a58fd",
        icon: null,
        usdValue: 1178.4971395615707,
      },
      {
        id: "1",
        name: "ONSTON",
        value: 3,
        tokenType: "alt",
        address: "0x47b9f01b16e9c9cb99191dca68c9cc5bf6403957",
        icon: null,
        usdValue: 2568.4509126769035,
      },
      {
        id: "1",
        name: "METAV",
        value: 3,
        tokenType: "alt",
        address: "0x62858686119135cc00C4A3102b436a0eB314D402",
        icon: null,
        usdValue: 94.2168513328848,
      },
      {
        id: "1",
        name: "WSI",
        value: 3,
        tokenType: "alt",
        address: "0x361a8c6ef166ea5904a82f6e8b085f0ee4408a6b",
        icon: null,
        usdValue: 8.624737953262827,
      },
      {
        id: "1",
        name: "TEST",
        value: 3,
        tokenType: "alt",
        address: "0x807534b396919783b7e30383fe57d857bc084338",
        icon: null,
        usdValue: 28.66852663583321,
      },
      {
        id: "1",
        name: "RSC",
        value: 3,
        tokenType: "alt",
        address: "0xd101dcc414f310268c37eeb4cd376ccfa507f571",
        icon: null,
        usdValue: 744.1829349978243,
      },
      {
        id: "10",
        name: "sETH",
        value: 3,
        tokenType: "alt",
        address: "0xe405de8f52ba7559f9df3c368500b6e6ae6cee49",
        icon: null,
        usdValue: 73.81875951044648,
      },
      {
        id: "42161",
        name: "PET",
        value: 3,
        tokenType: "alt",
        address: "0x43c25f828390de5a3648864eb485cc523e039e67",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "EVERETH",
        value: 3,
        tokenType: "alt",
        address: "0x16dcc0ec78e91e868dca64be86aec62bf7c61037",
        icon: null,
        usdValue: 9.345589440000001,
      },
      {
        id: "56",
        name: "TKING",
        value: 3,
        tokenType: "alt",
        address: "0x9b4bdddaeb68d85b0848bab7774e6855439fd94e",
        icon: null,
        usdValue: 85.04622,
      },
      {
        id: "56",
        name: "SEAMLESS",
        value: 3,
        tokenType: "alt",
        address: "0x2fc9e0f34d86f65b495de7ee3bb5cbeac7f92b04",
        icon: null,
        usdValue: 6.14908503,
      },
      {
        id: "56",
        name: "ATX",
        value: 3,
        tokenType: "alt",
        address: "0xF892bb5a36C4457901130E041Bdeb470bD72242f",
        icon: null,
        usdValue: 23.741508000000003,
      },
      {
        id: "137",
        name: "ADS",
        value: 3,
        tokenType: "alt",
        address: "0x598e49f01befeb1753737934a5b11fea9119c796",
        icon: null,
        usdValue: 13.691141919428873,
      },
      {
        id: "42161",
        name: "ACR",
        value: 3,
        tokenType: "alt",
        address: "0xdd389517320720f09db75d20a27d8a2cfa5f8568",
        icon: null,
        usdValue: 15.487752290808825,
      },
      {
        id: "1",
        name: "POLA",
        value: 3,
        tokenType: "alt",
        address: "0xc691bc298a304d591Ad9b352c7A8D216dE9f2CED",
        icon: null,
        usdValue: 142.976819845253,
      },
      {
        id: "1",
        name: "TRR",
        value: 3,
        tokenType: "alt",
        address: "0x490e3f4af13e1616ec97a8c6600c1061a8d0253e",
        icon: null,
        usdValue: 3706.483312912368,
      },
      {
        id: "1",
        name: "SHIELD",
        value: 3,
        tokenType: "alt",
        address: "0xc944273b805debd35c63011943abc5ab9eddb8e3",
        icon: null,
        usdValue: 40306.524995745975,
      },
      {
        id: "1",
        name: "KISHIMOTO",
        value: 3,
        tokenType: "alt",
        address: "0xae36155a55f04a696b8362777620027882b31db5",
        icon: null,
        usdValue: 4945.053041874419,
      },
      {
        id: "1",
        name: "VCHF",
        value: 3,
        tokenType: "stable",
        address: "0x79d4f0232A66c4c91b89c76362016A1707CFBF4f",
        icon: null,
        usdValue: 908.207156608495,
      },
      {
        id: "1",
        name: "IDEA",
        value: 3,
        tokenType: "alt",
        address: "0x5d3a4F62124498092Ce665f865E0b38fF6F5FbEa",
        icon: null,
        usdValue: 455773.3981388303,
      },
      {
        id: "1",
        name: "RND",
        value: 3,
        tokenType: "alt",
        address: "0x1c7e83f8c581a967940dbfa7984744646ae46b29",
        icon: null,
        usdValue: 485.0518338427376,
      },
      {
        id: "1",
        name: "NABOX",
        value: 3,
        tokenType: "alt",
        address: "0x03d1e72765545729a035e909edd9371a405f77fb",
        icon: null,
        usdValue: 82.17147704165181,
      },
      {
        id: "1",
        name: "HELIOS",
        value: 3,
        tokenType: "alt",
        address: "0xc6d1f1d5a46de07e73091f1c8793293b203f01a1",
        icon: null,
        usdValue: 101192.84686261966,
      },
      {
        id: "1",
        name: "SWITCH",
        value: 3,
        tokenType: "alt",
        address: "0xb10cc888cb2cce7036f4c7ecad8a57da16161338",
        icon: null,
        usdValue: 111596.4884976604,
      },
      {
        id: "1",
        name: "IZE",
        value: 3,
        tokenType: "alt",
        address: "0x6944d3e38973C4831dA24E954fbD790c7E688bDd",
        icon: null,
        usdValue: 2438847.120986103,
      },
      {
        id: "1",
        name: "MYC",
        value: 3,
        tokenType: "alt",
        address: "0x4b13006980acb09645131b91d259eaa111eaf5ba",
        icon: null,
        usdValue: 52.90814608158209,
      },
      {
        id: "1",
        name: "NFTS",
        value: 3,
        tokenType: "alt",
        address: "0x08037036451c768465369431da5c671ad9b37dbc",
        icon: null,
        usdValue: 353.88711662627287,
      },
      {
        id: "1",
        name: "SPOT",
        value: 3,
        tokenType: "alt",
        address: "0xc1f33e0cf7e40a67375007104b929e49a581bafe",
        icon: null,
        usdValue: 33358.7334381644,
      },
      {
        id: "1",
        name: "STONKS",
        value: 3,
        tokenType: "alt",
        address: "0x3d9a4d8ab4f5bd1d5d08ae3a95e8ed8bb4d7e3b9",
        icon: null,
        usdValue: 234.09473501765152,
      },
      {
        id: "1",
        name: " IYKYK",
        value: 3,
        tokenType: "alt",
        address: "0x7cB683151A83c2B10A30cBB003CDA9996228a2bA",
        icon: null,
        usdValue: 84.51063751055705,
      },
      {
        id: "1",
        name: "MATRIX",
        value: 3,
        tokenType: "alt",
        address: "0xc8d3dcb63c38607cb0c9d3f55e8ecce628a01c36",
        icon: null,
        usdValue: 30.663317683992695,
      },
      {
        id: "1",
        name: "DXP",
        value: 3,
        tokenType: "alt",
        address: "0x88aa4a6c5050b9a1b2aa7e34d0582025ca6ab745",
        icon: null,
        usdValue: 1736.8362549447552,
      },
      {
        id: "1",
        name: "AEGIS",
        value: 3,
        tokenType: "alt",
        address: "0x15Dd37a83564559927bBDcDbfcF85F60A2C6a419",
        icon: null,
        usdValue: 4843.672228107578,
      },
      {
        id: "1",
        name: "CVNT",
        value: 3,
        tokenType: "alt",
        address: "0x6400b5522f8d448c0803e6245436dd1c81df09ce",
        icon: null,
        usdValue: 4096.196334769824,
      },
      {
        id: "56",
        name: "SSS",
        value: 3,
        tokenType: "alt",
        address: "0xc3028fbc1742a16a5d69de1b334cbce28f5d7eb3",
        icon: null,
        usdValue: 22.76628220969866,
      },
      {
        id: "56",
        name: "WING",
        value: 3,
        tokenType: "alt",
        address: "0x3cb7378565718c64ab86970802140cc48ef1f969",
        icon: null,
        usdValue: 7.70572116345,
      },
      {
        id: "56",
        name: "AURA",
        value: 3,
        tokenType: "alt",
        address: "0x23c5D1164662758b3799103Effe19cC064d897D6",
        icon: null,
        usdValue: 12911.5856321403,
      },
      {
        id: "56",
        name: "OMC",
        value: 3,
        tokenType: "alt",
        address: "0x1f926B439FAe4595E5951029D47616FeCa401B77",
        icon: null,
        usdValue: 31376.259275706325,
      },
      {
        id: "56",
        name: "BPRIVA",
        value: 3,
        tokenType: "alt",
        address: "0xd0f4afa85a667d27837e9c07c81169869c16dd16",
        icon: null,
        usdValue: 20537.8827470469,
      },
      {
        id: "56",
        name: "WKD",
        value: 3,
        tokenType: "alt",
        address: "0x5344c20fd242545f31723689662ac12b9556fc3d",
        icon: null,
        usdValue: 3579.095485079401,
      },
      {
        id: "56",
        name: "DRACE",
        value: 3,
        tokenType: "alt",
        address: "0xa6c897caaca3db7fd6e2d2ce1a00744f40ab87bb",
        icon: null,
        usdValue: 8.969054413249548,
      },
      {
        id: "56",
        name: "SPAT",
        value: 3,
        tokenType: "alt",
        address: "0x62cd26cb698FA8067D9c76f8ccb26922F6a86909",
        icon: null,
        usdValue: 565.2635580244485,
      },
      {
        id: "56",
        name: "CHARGE",
        value: 3,
        tokenType: "alt",
        address: "0x1c6bc8e962427deb4106ae06a7fa2d715687395c",
        icon: null,
        usdValue: 20.186200243218455,
      },
      {
        id: "56",
        name: "HUB",
        value: 3,
        tokenType: "alt",
        address: "0xee7B7c840de85ad277CdddaEf63b3b29672a3C58",
        icon: null,
        usdValue: 10427.127765444837,
      },
      {
        id: "56",
        name: "VT",
        value: 3,
        tokenType: "alt",
        address: "0xed66ec1acb7dbd0c01cccff33e3ff1f423057c21",
        icon: null,
        usdValue: 613161.4292066402,
      },
      {
        id: "56",
        name: "FUTURE-AI",
        value: 3,
        tokenType: "alt",
        address: "0x0FF534801E98A4976246D1f418E441783fc9aa15",
        icon: null,
        usdValue: 218520.9318653961,
      },
      {
        id: "56",
        name: "ROOBEE",
        value: 3,
        tokenType: "alt",
        address: "0xF77351D8f4eE853135961A936BB8d2e4fFa75f9D",
        icon: null,
        usdValue: 3.8863380636726204,
      },
      {
        id: "56",
        name: "AREA",
        value: 3,
        tokenType: "alt",
        address: "0x3cb26f04223e948b8d810a7bd170620afbd42e67",
        icon: null,
        usdValue: 1603632.1288779925,
      },
      {
        id: "56",
        name: "KissMyMoon",
        value: 3,
        tokenType: "alt",
        address: "0x6001600a144166e14075963ee9bf03e194f638fe",
        icon: null,
        usdValue: 0.0000018579787786374115,
      },
      {
        id: "56",
        name: "HNW",
        value: 3,
        tokenType: "alt",
        address: "0x8173ccc721111b5a93ce7fa6fec0fc077b58b1b7",
        icon: null,
        usdValue: 2.0189206822808003,
      },
      {
        id: "56",
        name: "FASTMOON",
        value: 3,
        tokenType: "alt",
        address: "0x869dd7a64afbe5370a8c591d9b8650be60c0b8f6",
        icon: null,
        usdValue: 0.0016467280113980874,
      },
      {
        id: "56",
        name: "RISQ",
        value: 3,
        tokenType: "alt",
        address: "0xc2c82622a7cb7159d44cea7e39843a495f2674de",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "AURUM",
        value: 3,
        tokenType: "alt",
        address: "0x34d4ab47bee066f361fa52d792e69ac7bd05ee23",
        icon: null,
        usdValue: 14.123302810709934,
      },
      {
        id: "137",
        name: "PolyMoon",
        value: 3,
        tokenType: "alt",
        address: "0xefb3009ddac87e8144803d78e235e7fb4cd36e61",
        icon: null,
        usdValue: 6.705216076573541,
      },
      {
        id: "1",
        name: "INTX",
        value: 3,
        tokenType: "alt",
        address: "0x7533D63A2558965472398Ef473908e1320520AE2",
        icon: null,
        usdValue: 5766.257495153182,
      },
      {
        id: "1",
        name: "BITCCA",
        value: 3,
        tokenType: "alt",
        address: "0xe4d75e9b493458d032a5c3cc1ee9b0712c1ece06",
        icon: null,
        usdValue: 181709.9148379992,
      },
      {
        id: "1",
        name: "STON",
        value: 3,
        tokenType: "alt",
        address: "0xdc47f2ba852669b178699449e50682d6ceaf8c07",
        icon: null,
        usdValue: 15847.252564210425,
      },
      {
        id: "42161",
        name: "RAB",
        value: 3,
        tokenType: "alt",
        address: "0x24ef78c7092d255ed14a0281ac1800c359af3afe",
        icon: null,
        usdValue: 57637.872095490326,
      },
      {
        id: "42161",
        name: "MOD",
        value: 3,
        tokenType: "alt",
        address: "0x244ae62439c1ef3187f244d8604ac2c391ef2b53",
        icon: null,
        usdValue: 33.65227064840702,
      },
      {
        id: "1",
        name: "REZ",
        value: 3,
        tokenType: "alt",
        address: "0x3b50805453023a91a8bf641e279401a0b23fa6f9",
        icon: null,
        usdValue: 4507.479123131323,
      },
      {
        id: "1",
        name: "USDe",
        value: 3,
        tokenType: "alt",
        address: "0x4c9edd5852cd905f086c759e8383e09bff1e68b3",
        icon: null,
        usdValue: 2.9604564771389503,
      },
      {
        id: "56",
        name: "SFUEL",
        value: 3,
        tokenType: "alt",
        address: "0x37ac4d6140e54304d77437a5c11924f61a2d976f",
        icon: null,
        usdValue: 1.6574625602764628,
      },
      {
        id: "42161",
        name: "GAST",
        value: 3,
        tokenType: "alt",
        address: "0x6f9590958ce2beaf9c92a3a8fca6d1ddf310e052",
        icon: null,
        usdValue: 0.7377377455195876,
      },
      {
        id: "42161",
        name: "wstETH",
        value: 3,
        tokenType: "alt",
        address: "0x5979d7b546e38e414f7e9822514be443a4800529",
        icon: null,
        usdValue: 828.5335968762759,
      },
      {
        id: "42161",
        name: "VKA",
        value: 3,
        tokenType: "alt",
        address: "0xafccb724e3aec1657fc9514e3e53a0e71e80622d",
        icon: null,
        usdValue: 15208.747950885563,
      },
      {
        id: "56",
        name: "ORK",
        value: 2,
        tokenType: "alt",
        address: "0xced0ce92f4bdc3c2201e255faf12f05cf8206da8",
        icon: null,
        usdValue: 14.232903464377367,
      },
      {
        id: "1",
        name: "STAR",
        value: 2,
        tokenType: "alt",
        address: "0xf70a642bd387f94380ffb90451c2c81d4eb82cbc",
        icon: null,
        usdValue: 2.591277392189333,
      },
      {
        id: "10",
        name: "paper",
        value: 2,
        tokenType: "alt",
        address: "0x00f932f0fe257456b32deda4758922e56a4f4b42",
        icon: null,
        usdValue: 5.36848,
      },
      {
        id: "1",
        name: "TCAP",
        value: 2,
        tokenType: "alt",
        address: "0x16c52ceece2ed57dad87319d91b5e3637d50afa4",
        icon: null,
        usdValue: 305.59696643462865,
      },
      {
        id: "56",
        name: "WOW",
        value: 2,
        tokenType: "alt",
        address: "0x4da996c5fe84755c80e108cf96fe705174c5e36a",
        icon: null,
        usdValue: 9.285156844916978,
      },
      {
        id: "137",
        name: "MEM",
        value: 2,
        tokenType: "alt",
        address: "0x42dbbd5ae373fea2fc320f62d44c058522bb3758",
        icon: null,
        usdValue: 70.03001445028208,
      },
      {
        id: "137",
        name: "BANANA",
        value: 2,
        tokenType: "alt",
        address: "0xbc91347e80886453f3f8bbd6d7ac07c122d87735",
        icon: null,
        usdValue: 434.9708615350924,
      },
      {
        id: "1",
        name: "BCT",
        value: 2,
        tokenType: "alt",
        address: "0xf5839f46ed000d70cbab1fcd03e29e85f3aecd82",
        icon: null,
        usdValue: 11.689470000000002,
      },
      {
        id: "10",
        name: "zip",
        value: 2,
        tokenType: "alt",
        address: "0xfa436399d0458dbe8ab890c3441256e3e09022a8",
        icon: null,
        usdValue: 140.4237323628533,
      },
      {
        id: "56",
        name: "BOUNTIE",
        value: 2,
        tokenType: "alt",
        address: "0x00f80a8f39bb4D04a3038C497E3642bf1B0A304e",
        icon: null,
        usdValue: 2.7988199999999996,
      },
      {
        id: "56",
        name: "QUIDD",
        value: 2,
        tokenType: "alt",
        address: "0x7961ade0a767c0e5b67dd1a1f78ba44f727642ed",
        icon: null,
        usdValue: 28184.535099863748,
      },
      {
        id: "42161",
        name: "PICKLE",
        value: 2,
        tokenType: "alt",
        address: "0x965772e0e9c84b6f359c8597c891108dcf1c5b1a",
        icon: null,
        usdValue: 6638.242798539777,
      },
      {
        id: "1",
        name: "TOP",
        value: 2,
        tokenType: "alt",
        address: "0xdcD85914b8aE28c1E62f1C488E1D968D5aaFfE2b",
        icon: null,
        usdValue: 21.741216286507427,
      },
      {
        id: "1",
        name: "FKX",
        value: 2,
        tokenType: "alt",
        address: "0x009e864923b49263c7f10d19b7f8ab7a9a5aad33",
        icon: null,
        usdValue: 84.44996464182357,
      },
      {
        id: "1",
        name: "GFARM2",
        value: 2,
        tokenType: "alt",
        address: "0x831091da075665168e01898c6dac004a867f1e1b",
        icon: null,
        usdValue: 51.14461744699769,
      },
      {
        id: "10",
        name: "aleth",
        value: 2,
        tokenType: "alt",
        address: "0x3e29d3a9316dab217754d13b28646b76607c5f04",
        icon: null,
        usdValue: 101636.18932352315,
      },
      {
        id: "1",
        name: "ELTCOIN",
        value: 2,
        tokenType: "alt",
        address: "0x44197a4c44d6a059297caf6be4f7e172bd56caaf",
        icon: null,
        usdValue: 5.007199999999999,
      },
      {
        id: "56",
        name: "WTF",
        value: 2,
        tokenType: "alt",
        address: "0xd73f32833b6d5d9c8070c23e599e283a3039823c",
        icon: null,
        usdValue: 3.9766528618,
      },
      {
        id: "137",
        name: "ETHA",
        value: 2,
        tokenType: "alt",
        address: "0x59e9261255644c411afdd00bd89162d09d862e38",
        icon: null,
        usdValue: 52.5319253317244,
      },
      {
        id: "137",
        name: "POOL",
        value: 2,
        tokenType: "alt",
        address: "0x25788a1a171ec66da6502f9975a15b609ff54cf6",
        icon: null,
        usdValue: 5823.48,
      },
      {
        id: "137",
        name: "STACK",
        value: 2,
        tokenType: "alt",
        address: "0x980111ae1b84e50222c8843e3a7a038f36fecd2b",
        icon: null,
        usdValue: 11600.186500015923,
      },
      {
        id: "1",
        name: "NAAL",
        value: 2,
        tokenType: "alt",
        address: "0xc133529e57681b2999708f9458be5634e293995e",
        icon: null,
        usdValue: 9.373,
      },
      {
        id: "56",
        name: "SFC",
        value: 2,
        tokenType: "alt",
        address: "0x9f7b0f336f7fc969b4713615d6c42af86bb7c903",
        icon: null,
        usdValue: 276.68628,
      },
      {
        id: "56",
        name: "WAI",
        value: 2,
        tokenType: "alt",
        address: "0x934c9198582bf2631128c5d4b051aacef9a6224f",
        icon: null,
        usdValue: 125.1385702660009,
      },
      {
        id: "56",
        name: "HRO",
        value: 2,
        tokenType: "alt",
        address: "0xfb1a34eb2585b0ad7976420d7a21ef2f4aebeeb6",
        icon: null,
        usdValue: 4.956661508410101,
      },
      {
        id: "56",
        name: "CRUX",
        value: 2,
        tokenType: "alt",
        address: "0xe0191fEfdd0D2B39b1a2E4E029cCDA8A481b7995",
        icon: null,
        usdValue: 2232.408,
      },
      {
        id: "56",
        name: "CKT",
        value: 2,
        tokenType: "alt",
        address: "0x3837e18b901629fcb200e0ad9c2f2441804bd6c8",
        icon: null,
        usdValue: 29.794145282992883,
      },
      {
        id: "137",
        name: "ORARE",
        value: 2,
        tokenType: "alt",
        address: "0xff2382bd52efacef02cc895bcbfc4618608aa56f",
        icon: null,
        usdValue: 279.19314,
      },
      {
        id: "56",
        name: "MONSTA",
        value: 2,
        tokenType: "alt",
        address: "0x8a5d7fcd4c90421d21d30fcc4435948ac3618b2f",
        icon: null,
        usdValue: 3.3836284913532904,
      },
      {
        id: "1",
        name: "HND",
        value: 2,
        tokenType: "alt",
        address: "0x10010078a54396f62c96df8532dc2b4847d47ed3",
        icon: null,
        usdValue: 11533.446522293443,
      },
      {
        id: "1",
        name: "TCR",
        value: 2,
        tokenType: "alt",
        address: "0x9c4a4204b79dd291d6b6571c5be8bbcd0622f050",
        icon: null,
        usdValue: 52.81534961002006,
      },
      {
        id: "56",
        name: "DKT",
        value: 2,
        tokenType: "alt",
        address: "0x7ceb519718a80dd78a8545ad8e7f401de4f2faa7",
        icon: null,
        usdValue: 6.402302514926154,
      },
      {
        id: "1",
        name: "CERBY",
        value: 2,
        tokenType: "alt",
        address: "0xdef1fac7bf08f173d286bbbdcbeeade695129840",
        icon: null,
        usdValue: 10.630296077651625,
      },
      {
        id: "56",
        name: "Duke",
        value: 2,
        tokenType: "alt",
        address: "0xaee234825dc4687fae606485c1ebd06336052bcc",
        icon: null,
        usdValue: 8.960375026160493,
      },
      {
        id: "137",
        name: "PS1",
        value: 2,
        tokenType: "alt",
        address: "0x32Cd1BCB75473845b5d1dB6ecE60AEC6E41d8518",
        icon: null,
        usdValue: 940.99888254,
      },
      {
        id: "10",
        name: "pika",
        value: 2,
        tokenType: "alt",
        address: "0x9a601c5bb360811d96a23689066af316a30c3027",
        icon: null,
        usdValue: 3393.9044945892765,
      },
      {
        id: "56",
        name: "POCO",
        value: 2,
        tokenType: "alt",
        address: "0x394bba8f309f3462b31238b3fd04b83f71a98848",
        icon: null,
        usdValue: 5.996689078,
      },
      {
        id: "1",
        name: "BTTY",
        value: 2,
        tokenType: "alt",
        address: "0x9cc83d580180f0d37d00e5d86ce868f73b6e3d0a",
        icon: null,
        usdValue: 1262.607667731214,
      },
      {
        id: "56",
        name: "SUB",
        value: 2,
        tokenType: "alt",
        address: "0xfd290c590866f8282d89671a85ac9964b165d682",
        icon: null,
        usdValue: 270.916128263902,
      },
      {
        id: "56",
        name: "LFG",
        value: 2,
        tokenType: "alt",
        address: "0xF93f6b686f4A6557151455189a9173735D668154",
        icon: null,
        usdValue: 24.530063601840002,
      },
      {
        id: "56",
        name: "TEN",
        value: 2,
        tokenType: "alt",
        address: "0x25B9d4b9535920194c359d2879dB6a1382c2ff26",
        icon: null,
        usdValue: 62.3249001492182,
      },
      {
        id: "137",
        name: "VHC",
        value: 2,
        tokenType: "alt",
        address: "0x51b5619F5180e333d18b6310C8D540AEa43a0371",
        icon: null,
        usdValue: 140.83751847564903,
      },
      {
        id: "42161",
        name: "MMT",
        value: 2,
        tokenType: "alt",
        address: "0x27D8De4c30ffDE34e982482AE504fC7F23061f61",
        icon: null,
        usdValue: 23.747573390644373,
      },
      {
        id: "56",
        name: "SHUSH",
        value: 2,
        tokenType: "alt",
        address: "0x4c3031Ad4cf224BFA893775271CB39f845716e8F",
        icon: null,
        usdValue: 68.36071684,
      },
      {
        id: "10",
        name: "perp",
        value: 2,
        tokenType: "alt",
        address: "0x9e1028f5f1d5ede59748ffcee5532509976840e0",
        icon: null,
        usdValue: 27.870065739671027,
      },
      {
        id: "1",
        name: "QRL",
        value: 2,
        tokenType: "alt",
        address: "0x697beac28b09e122c4332d163985e8a73121b97f",
        icon: null,
        usdValue: 33.76561152665584,
      },
      {
        id: "1",
        name: "MOC",
        value: 2,
        tokenType: "alt",
        address: "0x865ec58b06bF6305B886793AA20A2da31D034E68",
        icon: null,
        usdValue: 41201.517396532945,
      },
      {
        id: "56",
        name: "LKN",
        value: 2,
        tokenType: "alt",
        address: "0x31acfce536b824ad0739e8d7b27cefaa4b8e4673",
        icon: null,
        usdValue: 21.160416229070474,
      },
      {
        id: "56",
        name: "$MUNDO",
        value: 2,
        tokenType: "alt",
        address: "0x44757fa720548d472b5a87a119401627f935a6a2",
        icon: null,
        usdValue: 742.0714320265439,
      },
      {
        id: "1",
        name: "DECI",
        value: 2,
        tokenType: "alt",
        address: "0x6b32022693210cd2cfc466b9ac0085de8fc34ea6",
        icon: null,
        usdValue: 911.53535,
      },
      {
        id: "1",
        name: "TEAM",
        value: 2,
        tokenType: "alt",
        address: "0xb7c9e99da8a857ce576a830a9c19312114d9de02",
        icon: null,
        usdValue: 81.20868,
      },
      {
        id: "56",
        name: "SNAP",
        value: 2,
        tokenType: "alt",
        address: "0x57cd5a91c18d21dedd72d3bcf255b60aef290f53",
        icon: null,
        usdValue: 3.2825211208156113,
      },
      {
        id: "56",
        name: "XGT",
        value: 2,
        tokenType: "alt",
        address: "0xc25af3123d2420054c8fcd144c21113aa2853f39",
        icon: null,
        usdValue: 828.8398861252886,
      },
      {
        id: "56",
        name: "EFT",
        value: 2,
        tokenType: "alt",
        address: "0xae98e63db1c4646bf5b40b29c664bc922f71bc65",
        icon: null,
        usdValue: 36.732283319208676,
      },
      {
        id: "56",
        name: "xGRO",
        value: 2,
        tokenType: "alt",
        address: "0x4AdAE3Ad22c4e8fb56D4Ae5C7Eb3abC0dd2d3379",
        icon: null,
        usdValue: 8.487438011020977,
      },
      {
        id: "56",
        name: "TAU",
        value: 2,
        tokenType: "alt",
        address: "0x70d7109d3afe13ee8f9015566272838519578c6b",
        icon: null,
        usdValue: 155.8276707377203,
      },
      {
        id: "56",
        name: "TEX",
        value: 2,
        tokenType: "alt",
        address: "0x049Dd7532148826CdE956c7B45fec8c30b514052",
        icon: null,
        usdValue: 116.743968,
      },
      {
        id: "56",
        name: "AMPL",
        value: 2,
        tokenType: "alt",
        address: "0xDB021b1B247fe2F1fa57e0A87C748Cc1E321F07F",
        icon: null,
        usdValue: 4.76648523053,
      },
      {
        id: "137",
        name: "PGX",
        value: 2,
        tokenType: "alt",
        address: "0xc1c93d475dc82fe72dbc7074d55f5a734f8ceeae",
        icon: null,
        usdValue: 11122.790738509331,
      },
      {
        id: "56",
        name: "MIMIR",
        value: 2,
        tokenType: "alt",
        address: "0x336f5A68fD46A25056a6C1D9c06072c691486acC",
        icon: null,
        usdValue: 25.6537656,
      },
      {
        id: "56",
        name: "INP",
        value: 2,
        tokenType: "alt",
        address: "0xf0f88d49d3fea2ee07002b9565f47666ba7439ea",
        icon: null,
        usdValue: 20306.962,
      },
      {
        id: "1",
        name: "NORMIE",
        value: 2,
        tokenType: "alt",
        address: "0x772c44b5166647B135BB4836AbC4E06c28E94978",
        icon: null,
        usdValue: 71.52868433635165,
      },
      {
        id: "56",
        name: "IOEN",
        value: 2,
        tokenType: "alt",
        address: "0x033DcfeF3366772FbCDEa4f33F1D96dB8f93676B",
        icon: null,
        usdValue: 392.61466196809624,
      },
      {
        id: "56",
        name: "DFH",
        value: 2,
        tokenType: "alt",
        address: "0x5fdab5bdbad5277b383b3482d085f4bfef68828c",
        icon: null,
        usdValue: 14.535650249999998,
      },
      {
        id: "137",
        name: "SAFLE",
        value: 2,
        tokenType: "alt",
        address: "0x04b33078ea1aef29bf3fb29c6ab7b200c58ea126",
        icon: null,
        usdValue: 272.8104781949459,
      },
      {
        id: "1",
        name: "L3P",
        value: 2,
        tokenType: "alt",
        address: "0xdef1da03061ddd2a5ef6c59220c135dec623116d",
        icon: null,
        usdValue: 6.1118655,
      },
      {
        id: "1",
        name: "UNT",
        value: 2,
        tokenType: "alt",
        address: "0xe4b5936Dce1820f84509C89CcE0F28C87988Bad8",
        icon: null,
        usdValue: 55.791510450000004,
      },
      {
        id: "1",
        name: "PRG",
        value: 2,
        tokenType: "alt",
        address: "0x7728dFEF5aBd468669EB7f9b48A7f70a501eD29D",
        icon: null,
        usdValue: 141.938874104962,
      },
      {
        id: "56",
        name: "ANOM",
        value: 2,
        tokenType: "alt",
        address: "0x5224F552f110eC78E6E0468138950AE5F3040942",
        icon: null,
        usdValue: 57.8925,
      },
      {
        id: "1",
        name: "$MAID",
        value: 2,
        tokenType: "alt",
        address: "0x4af698b479d0098229dc715655c667ceb6cd8433",
        icon: null,
        usdValue: 35.33006623847215,
      },
      {
        id: "56",
        name: "POC",
        value: 2,
        tokenType: "alt",
        address: "0x1b6609830c695f1c0692123bd2fd6d01f6794b98",
        icon: null,
        usdValue: 93.08551589888,
      },
      {
        id: "137",
        name: "SNE",
        value: 2,
        tokenType: "alt",
        address: "0x32934cb16da43fd661116468c1b225fc26cf9a8c",
        icon: null,
        usdValue: 27.188399999999998,
      },
      {
        id: "42161",
        name: "NIFLOKI",
        value: 2,
        tokenType: "alt",
        address: "0x1fae2a29940015632f2a6ce006dfa7e3225515a7",
        icon: null,
        usdValue: 2275.8101152057666,
      },
      {
        id: "56",
        name: "KSC",
        value: 2,
        tokenType: "alt",
        address: "0x3ac0f8cecc1fb0ee6c2017a072d52e85b00c6694",
        icon: null,
        usdValue: 105.49633237346744,
      },
      {
        id: "1",
        name: "FABRIC",
        value: 2,
        tokenType: "alt",
        address: "0x8c6fa66c21ae3fc435790e451946a9ea82e6e523",
        icon: null,
        usdValue: 74.97662163571796,
      },
      {
        id: "56",
        name: "RISE",
        value: 2,
        tokenType: "alt",
        address: "0xC17c30e98541188614dF99239cABD40280810cA3",
        icon: null,
        usdValue: 164.169473983535,
      },
      {
        id: "1",
        name: "GAINS",
        value: 2,
        tokenType: "alt",
        address: "0xd9b312d77bc7bed9b9cecb56636300bed4fe5ce9",
        icon: null,
        usdValue: 45.79164004569304,
      },
      {
        id: "56",
        name: "WSB",
        value: 2,
        tokenType: "alt",
        address: "0x22168882276e5d5e1da694343b41dd7726eeb288",
        icon: null,
        usdValue: 33.12099953180117,
      },
      {
        id: "1",
        name: "PAYT",
        value: 2,
        tokenType: "alt",
        address: "0x8EF47555856f6Ce2E0cd7C36AeF4FAb317d2e2E2",
        icon: null,
        usdValue: 27.00617751315196,
      },
      {
        id: "56",
        name: "INTER",
        value: 2,
        tokenType: "alt",
        address: "0x5C7bb1e6C45B055A7831f0c82740f9677bbf6D43",
        icon: null,
        usdValue: 133.55874241951167,
      },
      {
        id: "1",
        name: "OLT",
        value: 2,
        tokenType: "alt",
        address: "0x64a60493d888728cf42616e034a0dfeae38efcf0",
        icon: null,
        usdValue: 59.38144440847976,
      },
      {
        id: "56",
        name: "TANK",
        value: 2,
        tokenType: "alt",
        address: "0x4444a19c8bb86e9bdbc023709a363bbce91af33e",
        icon: null,
        usdValue: 98.70797268318657,
      },
      {
        id: "56",
        name: "GEMG",
        value: 2,
        tokenType: "alt",
        address: "0x885c5fb8f0e67b2b0cf3a437e6cc6ebc0f9f9014",
        icon: null,
        usdValue: 21.6328586364,
      },
      {
        id: "56",
        name: "VST",
        value: 2,
        tokenType: "alt",
        address: "0xacf34edcc424128cccc730bf85cdaceebcb3eece",
        icon: null,
        usdValue: 2761.36764178015,
      },
      {
        id: "56",
        name: "4PLAY",
        value: 2,
        tokenType: "alt",
        address: "0xf787e1b31e12c4be0cbfa46844c5ec851eba098d",
        icon: null,
        usdValue: 10.0584,
      },
      {
        id: "137",
        name: "ORE",
        value: 2,
        tokenType: "alt",
        address: "0xd52f6ca48882be8fbaa98ce390db18e1dbe1062d",
        icon: null,
        usdValue: 17.310651620599998,
      },
      {
        id: "56",
        name: "WSBT",
        value: 2,
        tokenType: "alt",
        address: "0x7f4e04aa61b9a46403c1634e91bf31df3bc554cf",
        icon: null,
        usdValue: 500.20032666,
      },
      {
        id: "56",
        name: "MERKLE",
        value: 2,
        tokenType: "alt",
        address: "0x000000000ca5171087c18fb271ca844a2370fc0a",
        icon: null,
        usdValue: 158.6823738179187,
      },
      {
        id: "137",
        name: "PLOT",
        value: 2,
        tokenType: "alt",
        address: "0xe82808eaA78339b06a691fd92E1Be79671cAd8D3",
        icon: null,
        usdValue: 209.7700454200819,
      },
      {
        id: "1",
        name: "BULK",
        value: 2,
        tokenType: "alt",
        address: "0xa143ac515dca260a46c742c7251ef3b268639593",
        icon: null,
        usdValue: 2449.7458964816187,
      },
      {
        id: "56",
        name: "TFI",
        value: 2,
        tokenType: "alt",
        address: "0x7565ab68d3f9dadff127f864103c8c706cf28235",
        icon: null,
        usdValue: 504.6798533290946,
      },
      {
        id: "56",
        name: "CPLT",
        value: 2,
        tokenType: "alt",
        address: "0x1cCAbE9A0d53636770f0d5c6Ce33f797E698C9D0",
        icon: null,
        usdValue: 30804.548648919572,
      },
      {
        id: "1",
        name: "MEZZ",
        value: 2,
        tokenType: "alt",
        address: "0xC4c346eDc55504574cCEB00AA1091d22404A4bC3",
        icon: null,
        usdValue: 76.37339844030203,
      },
      {
        id: "137",
        name: "MASQ",
        value: 2,
        tokenType: "alt",
        address: "0xee9a352f6aac4af1a5b9f467f6a93e0ffbe9dd35",
        icon: null,
        usdValue: 2127.1181434110426,
      },
      {
        id: "1",
        name: "PNODE",
        value: 2,
        tokenType: "alt",
        address: "0xAF691508BA57d416f895e32a1616dA1024e882D2",
        icon: null,
        usdValue: 10.795756222430644,
      },
      {
        id: "137",
        name: "IGG",
        value: 2,
        tokenType: "alt",
        address: "0xe6FC6C7CB6d2c31b359A49A33eF08aB87F4dE7CE",
        icon: null,
        usdValue: 52.61338027465956,
      },
      {
        id: "1",
        name: "EVN",
        value: 2,
        tokenType: "alt",
        address: "0xd780ae2bf04cd96e577d3d014762f831d97129d0",
        icon: null,
        usdValue: 185.25903387079998,
      },
      {
        id: "56",
        name: "HUSKY",
        value: 2,
        tokenType: "alt",
        address: "0x52d88a9a2a20a840d7a336d21e427e9ad093deea",
        icon: null,
        usdValue: 216.60708791512556,
      },
      {
        id: "1",
        name: "PETRO",
        value: 2,
        tokenType: "alt",
        address: "0x60cc21d2bf120707f666c76aa6711cb6ff4f8650",
        icon: null,
        usdValue: 3578.331893737216,
      },
      {
        id: "56",
        name: "CHEERS",
        value: 2,
        tokenType: "alt",
        address: "0xbBBcB350C64Fe974e5C42A55c7070644191823f3",
        icon: null,
        usdValue: 133.76460726752384,
      },
      {
        id: "1",
        name: "DMOD",
        value: 2,
        tokenType: "alt",
        address: "0x5f6c5c2fb289db2228d159c69621215e354218d7",
        icon: null,
        usdValue: 14.557909128978476,
      },
      {
        id: "1",
        name: "FMT",
        value: 2,
        tokenType: "alt",
        address: "0x99c6e435eC259A7E8d65E1955C9423DB624bA54C",
        icon: null,
        usdValue: 21.15872520335014,
      },
      {
        id: "56",
        name: "BUNI",
        value: 2,
        tokenType: "alt",
        address: "0x0e7beec376099429b85639eb3abe7cf22694ed49",
        icon: null,
        usdValue: 16.299687297031554,
      },
      {
        id: "1",
        name: "N1",
        value: 2,
        tokenType: "alt",
        address: "0xacbd826394189cf2623c6df98a18b41fc8ffc16d",
        icon: null,
        usdValue: 60.401720780118936,
      },
      {
        id: "56",
        name: "POLAR",
        value: 2,
        tokenType: "alt",
        address: "0xc64c9b30c981fc2ee4e13d0ca3f08258e725fd24",
        icon: null,
        usdValue: 6.03445860624,
      },
      {
        id: "56",
        name: "TBC",
        value: 2,
        tokenType: "alt",
        address: "0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1",
        icon: null,
        usdValue: 13.803510992800001,
      },
      {
        id: "56",
        name: "IDIA",
        value: 2,
        tokenType: "alt",
        address: "0x0b15ddf19d47e6a86a56148fb4afffc6929bcb89",
        icon: null,
        usdValue: 1265.3825,
      },
      {
        id: "56",
        name: "MFO",
        value: 2,
        tokenType: "alt",
        address: "0xb46049c79d77ff1d555a67835fba6978536581af",
        icon: null,
        usdValue: 26.957600000000003,
      },
      {
        id: "56",
        name: "IF",
        value: 2,
        tokenType: "alt",
        address: "0xb0e1fc65c1a741b4662b813eb787d369b8614af1",
        icon: null,
        usdValue: 6.0639,
      },
      {
        id: "56",
        name: "mWOM",
        value: 2,
        tokenType: "alt",
        address: "0x027a9d301fb747cd972cfb29a63f3bda551dfc5c",
        icon: null,
        usdValue: 12.826680837292848,
      },
      {
        id: "56",
        name: "lisUSD",
        value: 2,
        tokenType: "alt",
        address: "0x0782b6d8c4551b9760e74c0545a9bcd90bdc41e5",
        icon: null,
        usdValue: 0.4704041372367888,
      },
      {
        id: "56",
        name: "SD",
        value: 2,
        tokenType: "alt",
        address: "0x3bc5ac0dfdc871b365d159f728dd1b9a0b5481e8",
        icon: null,
        usdValue: 0.587839544142722,
      },
      {
        id: "56",
        name: "PSTAKE",
        value: 2,
        tokenType: "alt",
        address: "0x4c882ec256823ee773b25b414d36f92ef58a7c0c",
        icon: null,
        usdValue: 0.03585413372450206,
      },
      {
        id: "56",
        name: "SHIK",
        value: 2,
        tokenType: "alt",
        address: "0x3b5e17d47109a73169795550a4b70fe4387b775d",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "NASA",
        value: 2,
        tokenType: "alt",
        address: "0x63510325ea96e2f0bbe1c3bb395d79644fe21c4a",
        icon: null,
        usdValue: 8666.294119008435,
      },
      {
        id: "56",
        name: "APT",
        value: 2,
        tokenType: "alt",
        address: "0xec811fbcd12f67874891cdbbbc95d9f73db3fbb0",
        icon: null,
        usdValue: 686.2514879836181,
      },
      {
        id: "56",
        name: "wADAX",
        value: 2,
        tokenType: "alt",
        address: "0x35122d1fe8001296f61290b8ba42ef597af31fb7",
        icon: null,
        usdValue: 2597.131552044776,
      },
      {
        id: "56",
        name: "rDRIP",
        value: 2,
        tokenType: "alt",
        address: "0xa02a0b2d67d4fa48677a79cadc483e114049916d",
        icon: null,
        usdValue: 1269.4604878727632,
      },
      {
        id: "56",
        name: "SGC",
        value: 2,
        tokenType: "alt",
        address: "0x7aa3a53360541283ffa9192972223b47a902dc0c",
        icon: null,
        usdValue: 2582.7655821760522,
      },
      {
        id: "56",
        name: "FTT",
        value: 2,
        tokenType: "alt",
        address: "0xed96fdfc15ea82c5ae2469320236ddfc18de243e",
        icon: null,
        usdValue: 678.0679918498901,
      },
      {
        id: "56",
        name: "ABCD",
        value: 2,
        tokenType: "alt",
        address: "0xa0cc3a881aef241d6cb3b7db3168bd26094560be",
        icon: null,
        usdValue: 19.575288748056284,
      },
      {
        id: "137",
        name: "polyBUNNY",
        value: 2,
        tokenType: "alt",
        address: "0x4c16f69302ccb511c5fac682c7626b9ef0dc126a",
        icon: null,
        usdValue: 2.503882422837832,
      },
      {
        id: "56",
        name: "KRS",
        value: 2,
        tokenType: "alt",
        address: "0x37b53894e7429f794B56F22a32E1695567Ee9913",
        icon: null,
        usdValue: 5.349766092918457,
      },
      {
        id: "56",
        name: "LIBERA",
        value: 2,
        tokenType: "alt",
        address: "0x3a806a3315e35b3f5f46111adb6e2baf4b14a70d",
        icon: null,
        usdValue: 31.618365090733782,
      },
      {
        id: "56",
        name: "VAI",
        value: 2,
        tokenType: "stable",
        address: "0x4bd17003473389a42daf6a0a729f6fdb328bbbd7",
        icon: null,
        usdValue: 11.509640634802503,
      },
      {
        id: "56",
        name: "JMPT",
        value: 2,
        tokenType: "alt",
        address: "0x88d7e9b65dc24cf54f5edef929225fc3e1580c25",
        icon: null,
        usdValue: 3.652,
      },
      {
        id: "56",
        name: "DOUGH",
        value: 2,
        tokenType: "alt",
        address: "0xede5020492be8e265db6141cb0a1d2df9dbae9bb",
        icon: null,
        usdValue: 13.478481263975285,
      },
      {
        id: "56",
        name: "RADAR",
        value: 2,
        tokenType: "alt",
        address: "0x489580eb70a50515296ef31e8179ff3e77e24965",
        icon: null,
        usdValue: 26.838754982364605,
      },
      {
        id: "42161",
        name: "URD",
        value: 2,
        tokenType: "alt",
        address: "0x842216E0aa2ae608699F7b1063F26ce6b30c5311",
        icon: null,
        usdValue: 1775.5682706222235,
      },
      {
        id: "56",
        name: "PS1",
        value: 2,
        tokenType: "alt",
        address: "0x6451C6484D23889003C20BE51819D6Aa7dbd2b35",
        icon: null,
        usdValue: 3.1551849520827133,
      },
      {
        id: "137",
        name: "TOWER",
        value: 2,
        tokenType: "alt",
        address: "0x2bc07124d8dac638e290f401046ad584546bc47b",
        icon: null,
        usdValue: 5.962272487266266,
      },
      {
        id: "56",
        name: "MCC",
        value: 2,
        tokenType: "alt",
        address: "0xc146b7cdbaff065090077151d391f4c96aa09e0c",
        icon: null,
        usdValue: 7.632168273839648,
      },
      {
        id: "56",
        name: "MIM",
        value: 2,
        tokenType: "stable",
        address: "0xfe19f0b51438fd612f6fd59c1dbb3ea319f433ba",
        icon: null,
        usdValue: 3.159960394960782,
      },
      {
        id: "10",
        name: "mim",
        value: 2,
        tokenType: "stable",
        address: "0xb153fb3d196a8eb25522705560ac152eeec57901",
        icon: null,
        usdValue: 4.930127286328163,
      },
      {
        id: "42161",
        name: "GMUSD",
        value: 2,
        tokenType: "alt",
        address: "0xEC13336bbd50790a00CDc0fEddF11287eaF92529",
        icon: null,
        usdValue: 213.35595755606323,
      },
      {
        id: "56",
        name: "OBT",
        value: 2,
        tokenType: "alt",
        address: "0x8da6113655309f84127e0837fcf5c389892578b3",
        icon: null,
        usdValue: 1009.6542853625874,
      },
      {
        id: "56",
        name: "WATCH",
        value: 2,
        tokenType: "alt",
        address: "0x7a9f28eb62c791422aa23ceae1da9c847cbec9b0",
        icon: null,
        usdValue: 7.850472,
      },
      {
        id: "56",
        name: "FUR",
        value: 2,
        tokenType: "alt",
        address: "0x48378891d6e459ca9a56b88b406e8f4eab2e39bf",
        icon: null,
        usdValue: 5.797059997380009,
      },
      {
        id: "56",
        name: "MDB",
        value: 2,
        tokenType: "alt",
        address: "0x0557a288A93ed0DF218785F2787dac1cd077F8f3",
        icon: null,
        usdValue: 9.916406070917999,
      },
      {
        id: "1",
        name: "LBR",
        value: 2,
        tokenType: "alt",
        address: "0xC98835e792553e505AE46e73a6fD27a23985aCcA",
        icon: null,
        usdValue: 89.4656,
      },
      {
        id: "42161",
        name: "DF",
        value: 2,
        tokenType: "stable",
        address: "0xaE6aab43C4f3E0cea4Ab83752C278f8dEbabA689",
        icon: null,
        usdValue: 6283.034255494145,
      },
      {
        id: "56",
        name: "bStake.net",
        value: 2,
        tokenType: "alt",
        address: "0x1f040f15ab15b7e0dfac935873fadbe43d015535",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "BowDao.net",
        value: 2,
        tokenType: "alt",
        address: "0x3bab61ad5d103bb5b203c9092eb3a5e11677a5d0",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "usdswap.io",
        value: 2,
        tokenType: "alt",
        address: "0xb2ad5142b8ccb380731866bc42b3619759f3f7b3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "ART",
        value: 2,
        tokenType: "alt",
        address: "0x949e0a0672299e6fcd6bec3bd1735d6647b20618",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "PDot.io",
        value: 2,
        tokenType: "alt",
        address: "0x8bd0e87273364ebbe3482efc166f7e0d34d82c25",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "$ sUSD [Synthetix.cc]",
        value: 2,
        tokenType: "alt",
        address: "0xa172dc4531ee63c9b4f024f229f1220026abea94",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "MMdex.io",
        value: 2,
        tokenType: "alt",
        address: "0xdc4cb4c3587532409a4545aa79a15d967bed1c08",
        icon: null,
        usdValue: 31397.6,
      },
      {
        id: "137",
        name: "DPEX",
        value: 2,
        tokenType: "alt",
        address: "0x3ed4c2d63def617f436eb031bacae16f478f3b00",
        icon: null,
        usdValue: 0.014782027017003199,
      },
      {
        id: "137",
        name: "PUNKWL.XYZ",
        value: 2,
        tokenType: "alt",
        address: "0x0000065a20d6689430601581a21f28014594f74e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Claim USDC/WETH at https://USDCpool.xyz",
        value: 2,
        tokenType: "alt",
        address: "0x624471968090742312d1cd37a7f80c16b344d2af",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Claim at LINKBonus.io",
        value: 2,
        tokenType: "alt",
        address: "0x17868e575a7c6a65460272c8ec74ac4ac89e385e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "DogX.AI NFT",
        value: 2,
        tokenType: "alt",
        address: "0x2aad6b23c189b82e50d8c24c8c1c6058a3ef9960",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "zerolends.com",
        value: 2,
        tokenType: "alt",
        address: "0xb9191c4d8b85ee734d70d1d44d46af521d52a546",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "www.zkfair.events",
        value: 2,
        tokenType: "alt",
        address: "0x771956bcdaa1eb800d5d87acab82e4bae2a6d97f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "MOVL",
        value: 2,
        tokenType: "alt",
        address: "0x7e8b2cd72949f512fff33168f50dbda6643ecc12",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit Rocketpool.win to claim reward.",
        value: 2,
        tokenType: "alt",
        address: "0xed314a7d85eb37ccc1bb49dd242b4a05ae1a0ed8",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "LINKBonus.io",
        value: 2,
        tokenType: "alt",
        address: "0x2efebacc71f0e281989acbb497b92d55c828777a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$ sUSD [Synthetix.cc]",
        value: 2,
        tokenType: "alt",
        address: "0x01c9550e731a97f24b34a2064252498c2da74e7c",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit getSHIBA.us to claim rewards",
        value: 2,
        tokenType: "alt",
        address: "0x139ffe1a1d499416ba2504d079285e3420474baa",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "WWW.MSTAKE.XYZ",
        value: 2,
        tokenType: "alt",
        address: "0x309bc5415f90f6b302e505e477eebb189362e4c3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "WWW.POOFERS.FUN",
        value: 2,
        tokenType: "alt",
        address: "0x31aa79fbfc21d447aa29c5744a2211603cdc7378",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "RAFFLE TICKET",
        value: 2,
        tokenType: "alt",
        address: "0x3b9d5c5ab592137e3cd7ad7d69f75e625992f8d3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Claim USDC/WETH at https://USDCpool.tech",
        value: 2,
        tokenType: "alt",
        address: "0x68b21ee3e943e7f6299e34af1a8382fe58088ef7",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit getUSDcoin.org to claim rewards",
        value: 2,
        tokenType: "alt",
        address: "0x755c032168e74866b397ff3611e7e9bafce73a4f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$ Check: blastcode.io Your AirDrop Code",
        value: 2,
        tokenType: "alt",
        address: "0x7bd45df2fa3a03ea69362fd3469dadb62e806028",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "50RBW-50WETH",
        value: 2,
        tokenType: "alt",
        address: "0x8f9dd2064eb38e8e40f2ab67bde27c0e16ea9b08",
        icon: null,
        usdValue: 4.3294323145251677e-10,
      },
      {
        id: "137",
        name: "app.uniswap.cab",
        value: 2,
        tokenType: "alt",
        address: "0x9d6e2332f1e138a6d12cf86b3c013eff74dbf73e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$USDT СLАIМ▷lootusdt.com",
        value: 2,
        tokenType: "alt",
        address: "0xc48a73cc69e726a3b8474c916bc852402a3e4e5f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Celestia.icu",
        value: 2,
        tokenType: "alt",
        address: "0xf00a9145c9beff89da4ae46bce921f123169e8bf",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "ACX   [via www.across.events]",
        value: 2,
        tokenType: "alt",
        address: "0xf31b1555cd7c8305bc7b27399f7aee263979d884",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "CU",
        value: 2,
        tokenType: "alt",
        address: "0x89c49a3fa372920ac23ce757a029e6936c0b8e02",
        icon: null,
        usdValue: 0.03120612121456375,
      },
      {
        id: "42161",
        name: "ACX   [via www.across.events]",
        value: 2,
        tokenType: "alt",
        address: "0xde25d8b7172c616d549c22ef83f702aab54b6936",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "Claim $ENS rewards at https://enstoken.io",
        value: 2,
        tokenType: "alt",
        address: "0x4ad5cc13a8be82c776089622879dec7495acf93c",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "Claim: https://aerodrome.supply",
        value: 2,
        tokenType: "alt",
        address: "0x5f4653440420456f26e8276e25136cd5d98f9120",
        icon: null,
        usdValue: 0,
      },
      {
        id: "10",
        name: "3000OP voucher at opchain.lol",
        value: 2,
        tokenType: "alt",
        address: "0x346d47e65c05bce2392fe9a02e4224f3a084e337",
        icon: null,
        usdValue: 0,
      },
      {
        id: "10",
        name: "claim $foxy at me-qr.com/dHY9RTeC",
        value: 2,
        tokenType: "alt",
        address: "0x9c4f617de0712d73169cc3cf8036de0cee13a40e",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit Mylido.xyz to claim rewards",
        value: 2,
        tokenType: "alt",
        address: "0x50658e31ec229f6e2df5ba3135982ab2f0d80ad5",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit to get rewards: Get-lido.xyz",
        value: 2,
        tokenType: "alt",
        address: "0x55fe3af21f5d52b33b93febc40822410d20da7df",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$Eigen claim link: eigenclaim.xyz",
        value: 2,
        tokenType: "alt",
        address: "0xc46bc7f4d6f50a4156f8951d016d70651b318ef9",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Claim: https://aerodrome.supply",
        value: 2,
        tokenType: "alt",
        address: "0x0334fab36d2d4877770408efe4111e3bace2678b",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit stETH official website:  steth-voucher.site",
        value: 2,
        tokenType: "alt",
        address: "0x05a60d85e62d4fbc6f9c069e9a32de32d954b017",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit Chain-Link.ltd",
        value: 2,
        tokenType: "alt",
        address: "0x689825d4169d9ea67dcdc285cda40c6f60367dba",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "ACCESS [ETHENA-ENA.ORG] TO FARM YOUR COINS",
        value: 2,
        tokenType: "alt",
        address: "0x8359fd7c3fb48ddf9433e2d0deb552f604443a97",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "ACCESS [ETH-BONK.VIP] TO FARM YOUR COINS",
        value: 2,
        tokenType: "alt",
        address: "0x91b3bb32971bae85854b2b0158aea65033724a6c",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "ACX [via www.across.cash]",
        value: 2,
        tokenType: "alt",
        address: "0xc7d8bd336012e6d4a743878aaaa89aca50f37af7",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "$ ACCESS portal-zk.com }",
        value: 2,
        tokenType: "alt",
        address: "0xed9d17fd2fe2d6583dcb7ee4ee46345f03645a5d",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "Visit mylido.xyz to claim rewards",
        value: 2,
        tokenType: "alt",
        address: "0xf72eb3d94590941024c35705e5c9111254785e3f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "42161",
        name: "ACCESS [ PENDLE.UNO ] TO CLAIM AIRDROP",
        value: 2,
        tokenType: "alt",
        address: "0x31e47d2d842533eff3ccfd7cc408992c420ef8be",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "waUSD",
        value: 2,
        tokenType: "alt",
        address: "0xc2db4c131adaf01c15a1db654c040c8578929d55",
        icon: null,
        usdValue: 27.610113721589435,
      },
      {
        id: "1",
        name: "NUG",
        value: 2,
        tokenType: "alt",
        address: "0x245ef47d4d0505ecf3ac463f4d81f41ade8f1fd1",
        icon: null,
        usdValue: 0.4719789574729188,
      },
      {
        id: "1",
        name: "UGAS",
        value: 2,
        tokenType: "alt",
        address: "0x8716fc5da009d3a208f0178b637a50f4ef42400f",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "PAI",
        value: 2,
        tokenType: "alt",
        address: "0xb9bb08ab7e9fa0a1356bd4a39ec0ca267e03b0b3",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "MSG",
        value: 2,
        tokenType: "alt",
        address: "0xbd10eaccc4004f379b30562835668f3a74433714",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "FUSD",
        value: 2,
        tokenType: "alt",
        address: "0xbd9267a87e39a96482b8c52604ec22b56f909600",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "ICST",
        value: 2,
        tokenType: "alt",
        address: "0xe6bc60a00b81c7f3cbc8f4ef3b0a6805b6851753",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "waBTC",
        value: 2,
        tokenType: "alt",
        address: "0xfd8e70e83e399307db3978d3f34b060a06792c36",
        icon: null,
        usdValue: 0,
      },
      {
        id: "56",
        name: "FT",
        value: 2,
        tokenType: "alt",
        address: "0xb119a5cd4d5bf31bb6641dbab181833637c29d5a",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "AeFX.io",
        value: 2,
        tokenType: "alt",
        address: "0x2744861accb5bd435017c1cfee789b6ebab42082",
        icon: null,
        usdValue: 0,
      },
      {
        id: "137",
        name: "FT",
        value: 2,
        tokenType: "alt",
        address: "0xf357867d2e398d4f15566bfb04a337839647b76b",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "BNANA",
        value: 2,
        tokenType: "alt",
        address: "0x07ef9e82721ac16809d24dafbe1792ce01654db4",
        icon: null,
        usdValue: 1141.9558866335333,
      },
      {
        id: "56",
        name: "ADS",
        value: 2,
        tokenType: "alt",
        address: "0xcfcecfe2bd2fed07a9145222e8a7ad9cf1ccd22a",
        icon: null,
        usdValue: 7.3057921444221225,
      },
      {
        id: "56",
        name: "ECH",
        value: 2,
        tokenType: "alt",
        address: "0x00eafc9c1fb1b7f7889c7e91441ab62de0259ad5",
        icon: null,
        usdValue: 918.0000144978677,
      },
      {
        id: "1",
        name: "VLXPAD",
        value: 2,
        tokenType: "alt",
        address: "0xb8e3bB633F7276cc17735D86154E0ad5ec9928C0",
        icon: null,
        usdValue: 14.811116075825225,
      },
      {
        id: "137",
        name: "DOG",
        value: 2,
        tokenType: "alt",
        address: "0xeEe3371B89FC43Ea970E908536Fcddd975135D8a",
        icon: null,
        usdValue: 3.2125391999999997,
      },
      {
        id: "1",
        name: "PRIX",
        value: 2,
        tokenType: "alt",
        address: "0x3adfc4999f77d04c8341bac5f3a76f58dff5b37a",
        icon: null,
        usdValue: 6.798463288187377,
      },
      {
        id: "1",
        name: "PAWTH",
        value: 2,
        tokenType: "alt",
        address: "0xaecc217a749c2405b5ebc9857a16d58bdc1c367f",
        icon: null,
        usdValue: 5.83901516456158,
      },
      {
        id: "1",
        name: "TRENDAI",
        value: 2,
        tokenType: "alt",
        address: "0x6fc73113fc1afab4c28d3dd4c537a1da6045d47d",
        icon: null,
        usdValue: 24.48182300835499,
      },
      {
        id: "56",
        name: "LITHO",
        value: 2,
        tokenType: "alt",
        address: "0x61909950e1bfb5d567c5463cbd33dc1cdc85ee93",
        icon: null,
        usdValue: 567.9822774374542,
      },
      {
        id: "56",
        name: "PALM",
        value: 2,
        tokenType: "alt",
        address: "0x29745314b4d294b7c77cdb411b8aaa95923aae38",
        icon: null,
        usdValue: 942.2923681173538,
      },
      {
        id: "56",
        name: "TLC",
        value: 2,
        tokenType: "alt",
        address: "0x29A5DaF6E3FDF964DEf07706eA1ABee7EC03D021",
        icon: null,
        usdValue: 142.39456443274958,
      },
      {
        id: "56",
        name: "PARMA",
        value: 2,
        tokenType: "alt",
        address: "0xf7F0dc9fD88e436847580D883319137Ec2aA6b94",
        icon: null,
        usdValue: 5.058005670493421,
      },
      {
        id: "56",
        name: "GXT",
        value: 2,
        tokenType: "alt",
        address: "0x3107C0A1126268CA303f8d99c712392fA596e6D7",
        icon: null,
        usdValue: 2.3157405723681572,
      },
      {
        id: "56",
        name: "BRS",
        value: 2,
        tokenType: "alt",
        address: "0x98C6fD0281A9A0300cB88553Bf386a3492bb70F7",
        icon: null,
        usdValue: 5.361506880722568,
      },
      {
        id: "56",
        name: "XODEX",
        value: 2,
        tokenType: "alt",
        address: "0xddD9d7D280c78b564C55BEb26562E367d4b9Bd8a",
        icon: null,
        usdValue: 40.37897816,
      },
      {
        id: "56",
        name: "CLOUD",
        value: 2,
        tokenType: "alt",
        address: "0x5C10E4660eC45a89dE85a1FD1B22355B0398fB66",
        icon: null,
        usdValue: 24.882712876024993,
      },
      {
        id: "1",
        name: "BNK",
        value: 2,
        tokenType: "alt",
        address: "0x7707aAdA3Ce7722Ac63B91727DAF1999849F6835",
        icon: null,
        usdValue: 2952.3380408560083,
      },
      {
        id: "1",
        name: "CPAY",
        value: 2,
        tokenType: "alt",
        address: "0x0ebb614204e47c09b6c3feb9aaecad8ee060e23e",
        icon: null,
        usdValue: 8.89141038,
      },
      {
        id: "1",
        name: "UTT",
        value: 2,
        tokenType: "alt",
        address: "0x16f812be7fff02caf662b85d5d58a5da6572d4df",
        icon: null,
        usdValue: 3444.4399098362,
      },
      {
        id: "1",
        name: "XBP",
        value: 2,
        tokenType: "alt",
        address: "0x28dee01d53fed0edf5f6e310bf8ef9311513ae40",
        icon: null,
        usdValue: 56.95323448723603,
      },
      {
        id: "1",
        name: "HIT",
        value: 2,
        tokenType: "alt",
        address: "0x74b1af114274335598da72f5c6ed7b954a016eed",
        icon: null,
        usdValue: 739257.608897024,
      },
      {
        id: "1",
        name: "SWT",
        value: 2,
        tokenType: "alt",
        address: "0xb9e7f8568e08d5659f5d29c4997173d84cdf2607",
        icon: null,
        usdValue: 15113.880609315589,
      },
      {
        id: "1",
        name: "CGT",
        value: 2,
        tokenType: "alt",
        address: "0xf5238462e7235c7b62811567e63dd17d12c2eaa0",
        icon: null,
        usdValue: 37110.4469705624,
      },
      {
        id: "1",
        name: "COV",
        value: 2,
        tokenType: "alt",
        address: "0xe2fb6529ef566a080e6d23de0bd351311087d567",
        icon: null,
        usdValue: 287.1098266785617,
      },
      {
        id: "1",
        name: "DMT",
        value: 2,
        tokenType: "alt",
        address: "0x2ccbff3a042c68716ed2a2cb0c544a9f1d1935e1",
        icon: null,
        usdValue: 5855.526327710273,
      },
      {
        id: "1",
        name: "MTS",
        value: 2,
        tokenType: "alt",
        address: "0xA9598333B99d14D90Bc81CAd8Af82C4C70625e75",
        icon: null,
        usdValue: 215.55806040893324,
      },
      {
        id: "1",
        name: "GPX",
        value: 2,
        tokenType: "alt",
        address: "0x3e7804c51a70ba26e904c2e0ab440c5623a8a83f",
        icon: null,
        usdValue: 137363.6167288108,
      },
      {
        id: "1",
        name: "TOM",
        value: 2,
        tokenType: "alt",
        address: "0xf7970499814654cd13cb7b6e7634a12a7a8a9abc",
        icon: null,
        usdValue: 9093.899067479191,
      },
      {
        id: "1",
        name: "BMP",
        value: 2,
        tokenType: "alt",
        address: "0x01b23286ff60a543ec29366ae8d6b6274ca20541",
        icon: null,
        usdValue: 8315.423331991375,
      },
      {
        id: "1",
        name: "FIT",
        value: 2,
        tokenType: "alt",
        address: "0x3c72fca8523686fd9e5740b0826fa4bb376e0241",
        icon: null,
        usdValue: 4306.304024836308,
      },
      {
        id: "1",
        name: "POLL",
        value: 2,
        tokenType: "alt",
        address: "0x4b0f027d0b694aae2761ed2d426295d4f949f5d0",
        icon: null,
        usdValue: 24512.2156479909,
      },
      {
        id: "1",
        name: "ZPTC",
        value: 2,
        tokenType: "alt",
        address: "0x39ae6d231d831756079ec23589d2d37a739f2e89",
        icon: null,
        usdValue: 2886.453629885549,
      },
      {
        id: "1",
        name: "MTRA",
        value: 2,
        tokenType: "alt",
        address: "0xc62def1701309bb76e6b39b6ab8b5fac910a3c87",
        icon: null,
        usdValue: 2865.7669964925203,
      },
      {
        id: "1",
        name: "MYCE",
        value: 2,
        tokenType: "alt",
        address: "0xe9966c1184f8552fcb16f65addba9dd08fe8f4ea",
        icon: null,
        usdValue: 38.05277714133532,
      },
      {
        id: "1",
        name: "SML",
        value: 2,
        tokenType: "alt",
        address: "0x1A403E1c96792dFedb8232cF56400Eb72Ab95Acb",
        icon: null,
        usdValue: 2817.204808825883,
      },
      {
        id: "1",
        name: "LWC",
        value: 2,
        tokenType: "alt",
        address: "0xa6a1cc527d48585538b137e6abc14b2a55489d11",
        icon: null,
        usdValue: 185968.22681882032,
      },
      {
        id: "1",
        name: "CHANGE",
        value: 2,
        tokenType: "alt",
        address: "0x7051faed0775f664a0286af4f75ef5ed74e02754",
        icon: null,
        usdValue: 58.768371713989495,
      },
      {
        id: "1",
        name: "QTO",
        value: 2,
        tokenType: "alt",
        address: "0xea01906843ea8d910658a2c485ffce7c104ab2b6",
        icon: null,
        usdValue: 14083.59286225832,
      },
      {
        id: "1",
        name: "WINTER",
        value: 2,
        tokenType: "alt",
        address: "0xccba0b2bc4babe4cbfb6bd2f1edc2a9e86b7845f",
        icon: null,
        usdValue: 759.1621929551434,
      },
      {
        id: "1",
        name: "CIX",
        value: 2,
        tokenType: "alt",
        address: "0x6d60a8dfb16d09f67d46fcd36a0cd310078257ca",
        icon: null,
        usdValue: 78392.02388025713,
      },
      {
        id: "1",
        name: "TBC",
        value: 2,
        tokenType: "alt",
        address: "0x9798dF2f5d213a872c787bD03b2b91F54D0D04A1",
        icon: null,
        usdValue: 2890484.805742964,
      },
      {
        id: "1",
        name: "WNK",
        value: 2,
        tokenType: "alt",
        address: "0xE1BDA0c3Bfa2bE7f740f0119B6a34F057BD58Eba",
        icon: null,
        usdValue: 4587.396171259538,
      },
      {
        id: "1",
        name: "YCO",
        value: 2,
        tokenType: "alt",
        address: "0x3d0293f06daf4311b482564330d57c8db6c10893",
        icon: null,
        usdValue: 35733.31724453664,
      },
      {
        id: "1",
        name: "XDNA",
        value: 2,
        tokenType: "alt",
        address: "0x8e57c27761EBBd381b0f9d09Bb92CeB51a358AbB",
        icon: null,
        usdValue: 261.22498703397287,
      },
      {
        id: "1",
        name: "METANO",
        value: 2,
        tokenType: "alt",
        address: "0x9d9e399e5385e2b9a58d4f775a1e16441b571afb",
        icon: null,
        usdValue: 9312.078321719879,
      },
      {
        id: "10",
        name: "BUSD",
        value: 2,
        tokenType: "stable",
        address: "0x9c9e5fd8bbc25984b178fdce6117defa39d2db39",
        icon: null,
        usdValue: 110.77827244000001,
      },
      {
        id: "56",
        name: "STARS",
        value: 2,
        tokenType: "alt",
        address: "0xbd83010eb60f12112908774998f65761cf9f6f9a",
        icon: null,
        usdValue: 36.096426227296625,
      },
      {
        id: "56",
        name: "SPIN",
        value: 2,
        tokenType: "alt",
        address: "0x6aa217312960a21adbde1478dc8cbcf828110a67",
        icon: null,
        usdValue: 261.6052240369589,
      },
      {
        id: "56",
        name: "XWIN",
        value: 2,
        tokenType: "alt",
        address: "0xd88ca08d8eec1e9e09562213ae83a7853ebb5d28",
        icon: null,
        usdValue: 16.855308468915435,
      },
      {
        id: "56",
        name: "FaceDAO",
        value: 2,
        tokenType: "alt",
        address: "0xb700597d8425ced17677bc68042d7d92764acf59",
        icon: null,
        usdValue: 349.8478188827158,
      },
      {
        id: "56",
        name: "PACOCA",
        value: 2,
        tokenType: "alt",
        address: "0x55671114d774ee99d653d6c12460c780a67f1d18",
        icon: null,
        usdValue: 23.345214458353148,
      },
      {
        id: "56",
        name: "NTX",
        value: 2,
        tokenType: "alt",
        address: "0x5C4Bcc4DbaEAbc7659f6435bCE4E659314ebad87",
        icon: null,
        usdValue: 203.19644845362598,
      },
      {
        id: "56",
        name: "RYIU",
        value: 2,
        tokenType: "alt",
        address: "0x5dc2085fe510bbaaba2119d71b09c25098caca3f",
        icon: null,
        usdValue: 492.4029496551113,
      },
      {
        id: "137",
        name: "MVX",
        value: 2,
        tokenType: "alt",
        address: "0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7",
        icon: null,
        usdValue: 1170.6753433991844,
      },
      {
        id: "137",
        name: "ATOM",
        value: 2,
        tokenType: "alt",
        address: "0xac51C4c48Dc3116487eD4BC16542e27B5694Da1b",
        icon: null,
        usdValue: 43.302655,
      },
      {
        id: "137",
        name: "SUPER",
        value: 2,
        tokenType: "alt",
        address: "0xa1428174f516f527fafdd146b883bb4428682737",
        icon: null,
        usdValue: 390.4426841029698,
      },
      {
        id: "42161",
        name: "BADGER",
        value: 2,
        tokenType: "alt",
        address: "0xbfa641051ba0a0ad1b0acf549a89536a0d76472e",
        icon: null,
        usdValue: 67071.34028076855,
      },
      {
        id: "42161",
        name: "EMAX",
        value: 2,
        tokenType: "alt",
        address: "0x123389C2f0e9194d9bA98c21E63c375B67614108",
        icon: null,
        usdValue: 610.768439698004,
      },
      {
        id: "1",
        name: "G",
        value: 2,
        tokenType: "alt",
        address: "0xE1005BfBBC9A17d5d844C7a4371CBF6B2B387380",
        icon: null,
        usdValue: 4.410416537495999,
      },
      {
        id: "1",
        name: "CSR",
        value: 2,
        tokenType: "alt",
        address: "0x75ecb52e403c617679fbd3e77a50f9d10a842387",
        icon: null,
        usdValue: 702.1112112216,
      },
      {
        id: "56",
        name: "GAMI",
        value: 2,
        tokenType: "alt",
        address: "0x1236a887ef31b4d32e1f0a2b5e4531f52cec7e75",
        icon: null,
        usdValue: 67047.2133114871,
      },
      {
        id: "56",
        name: "SNFTS",
        value: 2,
        tokenType: "alt",
        address: "0x6f51a1674befdd77f7ab1246b83adb9f13613762",
        icon: null,
        usdValue: 1458.11392233619,
      },
      {
        id: "56",
        name: "OMAX",
        value: 2,
        tokenType: "alt",
        address: "0xeb84be66c8e71f07ea57cf3b21626d7784f32a7f",
        icon: null,
        usdValue: 443.54795901680274,
      },
      {
        id: "56",
        name: "BGVT",
        value: 2,
        tokenType: "alt",
        address: "0xa03110800894b3CcF8723D991d80875561F96777",
        icon: null,
        usdValue: 6402.909501709396,
      },
      {
        id: "56",
        name: "VEMP",
        value: 2,
        tokenType: "alt",
        address: "0xedf3ce4dd6725650a8e9398e5c6398d061fa7955",
        icon: null,
        usdValue: 15.607287956763367,
      },
      {
        id: "56",
        name: "ACT",
        value: 2,
        tokenType: "alt",
        address: "0x9f3bcbe48e8b754f331dfc694a894e8e686ac31d",
        icon: null,
        usdValue: 12.406891138362573,
      },
      {
        id: "56",
        name: "FWC",
        value: 2,
        tokenType: "alt",
        address: "0x6d3a160b86edcd46d8f9bba25c2f88cccade19fc",
        icon: null,
        usdValue: 1772.1368401535965,
      },
      {
        id: "56",
        name: "LNR",
        value: 2,
        tokenType: "alt",
        address: "0xc1A59a17F87ba6651Eb8E8F707db7672647c45bD",
        icon: null,
        usdValue: 4530.435941419636,
      },
      {
        id: "56",
        name: "TRDC",
        value: 2,
        tokenType: "alt",
        address: "0x7e8db69dcff9209e486a100e611b0af300c3374e",
        icon: null,
        usdValue: 928.391613303,
      },
      {
        id: "56",
        name: "OKS",
        value: 2,
        tokenType: "alt",
        address: "0x18acf236eb40c0d4824fb8f2582ebbecd325ef6a",
        icon: null,
        usdValue: 4233.9516386957575,
      },
      {
        id: "56",
        name: "DEVO",
        value: 2,
        tokenType: "alt",
        address: "0x0fd98b8c58560167a236f1d0553a9c2a42342ccf",
        icon: null,
        usdValue: 3937.2959713645077,
      },
      {
        id: "56",
        name: "MR",
        value: 2,
        tokenType: "alt",
        address: "0x2456bbad80bfad346aecea45fa38c81a6963132d",
        icon: null,
        usdValue: 4197.381395026387,
      },
      {
        id: "56",
        name: "GHD",
        value: 2,
        tokenType: "alt",
        address: "0xfDFD27aE39cebefDBaAc8615F18aa68DDD0F15f5",
        icon: null,
        usdValue: 6.063219813511084,
      },
      {
        id: "56",
        name: "TBCC",
        value: 2,
        tokenType: "alt",
        address: "0xf29480344d8e21efeab7fde39f8d8299056a7fea",
        icon: null,
        usdValue: 210506.682647885,
      },
      {
        id: "56",
        name: "DND",
        value: 2,
        tokenType: "alt",
        address: "0x14c358b573a4cE45364a3DBD84BBb4Dae87af034",
        icon: null,
        usdValue: 15.37287457507965,
      },
      {
        id: "56",
        name: "APRIL",
        value: 2,
        tokenType: "alt",
        address: "0xbfea674ce7d16e26e39e3c088810367a708ef94c",
        icon: null,
        usdValue: 63.072062466606184,
      },
      {
        id: "56",
        name: "WOJ",
        value: 2,
        tokenType: "alt",
        address: "0x55f96c7005d7c684a65ee653b07b5fe1507c56ab",
        icon: null,
        usdValue: 2651.350217672562,
      },
      {
        id: "56",
        name: "PULI",
        value: 2,
        tokenType: "alt",
        address: "0xaef0a177c8c329cbc8508292bb7e06c00786bbfc",
        icon: null,
        usdValue: 891.5059881316649,
      },
      {
        id: "56",
        name: "CMCX",
        value: 2,
        tokenType: "alt",
        address: "0xb2343143f814639c9b1f42961c698247171df34a",
        icon: null,
        usdValue: 855.3823990970806,
      },
      {
        id: "56",
        name: "NTR",
        value: 2,
        tokenType: "alt",
        address: "0x8182ac1c5512eb67756a89c40fadb2311757bd32",
        icon: null,
        usdValue: 106.78368462276708,
      },
      {
        id: "56",
        name: "$GREED",
        value: 2,
        tokenType: "alt",
        address: "0x5905df3d03e29a22e22462d3257e6ac731e22c15",
        icon: null,
        usdValue: 208.1261287290826,
      },
      {
        id: "56",
        name: "XLD",
        value: 2,
        tokenType: "alt",
        address: "0xc79d1fd14f514cd713b5ca43d288a782ae53eab2",
        icon: null,
        usdValue: 3995.4539220129445,
      },
      {
        id: "56",
        name: "SHIELD",
        value: 2,
        tokenType: "alt",
        address: "0xc944273b805debd35c63011943abc5ab9eddb8e3",
        icon: null,
        usdValue: 4619480.525429045,
      },
      {
        id: "56",
        name: "SQUA",
        value: 2,
        tokenType: "alt",
        address: "0xb82beb6ee0063abd5fc8e544c852237aa62cbb14",
        icon: null,
        usdValue: 25.681578870173254,
      },
      {
        id: "56",
        name: "FENOMY",
        value: 2,
        tokenType: "alt",
        address: "0x1e226f8527d9f73048f4b660af44d902d4508bc2",
        icon: null,
        usdValue: 2.1483310936366613,
      },
      {
        id: "56",
        name: "FRZSS",
        value: 2,
        tokenType: "alt",
        address: "0xac41fb8013c0b63588fc63997785a5d79e73eb28",
        icon: null,
        usdValue: 128.69811300226587,
      },
      {
        id: "56",
        name: "PHL",
        value: 2,
        tokenType: "alt",
        address: "0x68dd887d012abdf99d3492621e4d576a3f75019d",
        icon: null,
        usdValue: 7130.089538286751,
      },
      {
        id: "56",
        name: "FGD",
        value: 2,
        tokenType: "alt",
        address: "0x0566b9a8ffb8908682796751eed00722da967be0",
        icon: null,
        usdValue: 304.0539215071334,
      },
      {
        id: "56",
        name: "PATH",
        value: 2,
        tokenType: "alt",
        address: "0x3c0b6fcb2f62990f477d9af611e4da3ff1f08222",
        icon: null,
        usdValue: 2.8078232,
      },
      {
        id: "56",
        name: "NNI",
        value: 2,
        tokenType: "alt",
        address: "0xf0eB3c9088718a533C8FD64Dbcaa5927faed6D18",
        icon: null,
        usdValue: 116.05433547626895,
      },
      {
        id: "56",
        name: "QUINT",
        value: 2,
        tokenType: "alt",
        address: "0x64619f611248256F7F4b72fE83872F89d5d60d64",
        icon: null,
        usdValue: 925.3406707162598,
      },
      {
        id: "56",
        name: "JOLT",
        value: 2,
        tokenType: "alt",
        address: "0x7db21353a0c4659b6a9a0519066aa8d52639dfa5",
        icon: null,
        usdValue: 16770.472466400002,
      },
      {
        id: "56",
        name: "SLEEPEE",
        value: 2,
        tokenType: "alt",
        address: "0x80cd73badb406ea36b9a7cdeb8df06aefa7e12d9",
        icon: null,
        usdValue: 34.01908178461655,
      },
      {
        id: "56",
        name: "MFET",
        value: 2,
        tokenType: "alt",
        address: "0x6d23970ce32Cb0F1929bECE7C56D71319e1b4F01",
        icon: null,
        usdValue: 1098.2936854331322,
      },
      {
        id: "56",
        name: "DBEA",
        value: 2,
        tokenType: "alt",
        address: "0xA44B2D7805Dc7Fc24A7e8e38D8EFed5078cDf640",
        icon: null,
        usdValue: 562.9541894592923,
      },
      {
        id: "56",
        name: "SPY",
        value: 2,
        tokenType: "alt",
        address: "0x17fd3caa66502c6f1cbd5600d8448f3af8f2aba1",
        icon: null,
        usdValue: 214.9798273,
      },
      {
        id: "56",
        name: "CLEG",
        value: 2,
        tokenType: "alt",
        address: "0x4027d91eCD3140e53AE743d657549adfeEbB27AB",
        icon: null,
        usdValue: 23905.028214298356,
      },
      {
        id: "56",
        name: "CPS",
        value: 2,
        tokenType: "alt",
        address: "0x569f4957176Ffa0dff76c507604f6a66d4B9C578",
        icon: null,
        usdValue: 2422.822325499084,
      },
      {
        id: "56",
        name: "BIBL",
        value: 2,
        tokenType: "alt",
        address: "0xdd041e030ade3db3b2221ce681b65f9650f250d7",
        icon: null,
        usdValue: 553923.4075539999,
      },
      {
        id: "56",
        name: "YES",
        value: 2,
        tokenType: "alt",
        address: "0xB9d35811424600fa9E8cD62A0471fBd025131cb8",
        icon: null,
        usdValue: 30336.16881652252,
      },
      {
        id: "56",
        name: "ZILLIONXO",
        value: 2,
        tokenType: "alt",
        address: "0x9a2478c4036548864d96a97fbf93f6a3341fedac",
        icon: null,
        usdValue: 10299.732883584415,
      },
      {
        id: "56",
        name: "GYMNET",
        value: 2,
        tokenType: "alt",
        address: "0x0012365F0a1E5F30a5046c680DCB21D07b15FcF7",
        icon: null,
        usdValue: 30065.20582623324,
      },
      {
        id: "56",
        name: "AMA",
        value: 2,
        tokenType: "alt",
        address: "0xa77d560e34bd6a8d7265f754b4fcd65d9a8e5619",
        icon: null,
        usdValue: 90.94003880708357,
      },
      {
        id: "56",
        name: "PRM",
        value: 2,
        tokenType: "alt",
        address: "0x2668BAbeAB11780c516B1d3aD02011668AFF8aa0",
        icon: null,
        usdValue: 162.8907711045664,
      },
      {
        id: "56",
        name: "TYV",
        value: 2,
        tokenType: "alt",
        address: "0x90a8bbf934fde975555632addcb258e895c69de1",
        icon: null,
        usdValue: 573190.2772059011,
      },
      {
        id: "56",
        name: "HYPER",
        value: 2,
        tokenType: "alt",
        address: "0xee5b03b769ca6c690d140cafb52fc8de3f38fc28",
        icon: null,
        usdValue: 12386.532702338462,
      },
      {
        id: "56",
        name: "LIUX",
        value: 2,
        tokenType: "alt",
        address: "0x94ade5a1dd2349e604aeb2c0b2cfac486c7e19ae",
        icon: null,
        usdValue: 458.7803044881254,
      },
      {
        id: "56",
        name: "GLD",
        value: 2,
        tokenType: "alt",
        address: "0x6ef7e2d571f9806ab8faab73a76a97442bf78e3b",
        icon: null,
        usdValue: 615.1394818260368,
      },
      {
        id: "137",
        name: "SX",
        value: 2,
        tokenType: "alt",
        address: "0x840195888db4d6a99ed9f73fcd3b225bb3cb1a79",
        icon: null,
        usdValue: 82.93990518273219,
      },
      {
        id: "137",
        name: "MMF",
        value: 2,
        tokenType: "alt",
        address: "0x22a31bd4cb694433b6de19e0acc2899e553e9481",
        icon: null,
        usdValue: 367.65928864560004,
      },
      {
        id: "137",
        name: "SALE",
        value: 2,
        tokenType: "alt",
        address: "0x8f6196901a4a153d8ee8f3fa779a042f6092d908",
        icon: null,
        usdValue: 1244.0721683506476,
      },
      {
        id: "137",
        name: "FXY",
        value: 2,
        tokenType: "alt",
        address: "0x4ec465d5db20a01bc8404dc84f33bb7a398b8335",
        icon: null,
        usdValue: 5.574930420112043,
      },
      {
        id: "1",
        name: "MON",
        value: 2,
        tokenType: "alt",
        address: "0x1ea48b9965bb5086f3b468e50ed93888a661fc17",
        icon: null,
        usdValue: 2.9135806901891725,
      },
      {
        id: "1",
        name: "UPR",
        value: 2,
        tokenType: "alt",
        address: "0xf720e38f678b29b243f7d53b56acbf5de98f2385",
        icon: null,
        usdValue: 58.227901833667154,
      },
      {
        id: "1",
        name: "✺RUG",
        value: 2,
        tokenType: "alt",
        address: "0xd2d8d78087d0e43bc4804b6f946674b2ee406b80",
        icon: null,
        usdValue: 6.01902194603812,
      },
      {
        id: "1",
        name: "CW",
        value: 2,
        tokenType: "alt",
        address: "0xd55236d48606c295adebf129dad04fc74bfaa708",
        icon: null,
        usdValue: 31.597842298249663,
      },
      {
        id: "1",
        name: "MAPS",
        value: 2,
        tokenType: "alt",
        address: "0x2b915b505c017abb1547aa5ab355fbe69865cc6d",
        icon: null,
        usdValue: 29.4113129601967,
      },
      {
        id: "1",
        name: "LBLOCK",
        value: 2,
        tokenType: "alt",
        address: "0x2b867efD2dE4Ad2B583Ca0CB3dF9C4040Ef4D329",
        icon: null,
        usdValue: 18115.17917600815,
      },
      {
        id: "1",
        name: "AKTIO",
        value: 2,
        tokenType: "alt",
        address: "0xe65d37F18A770643CB14c8611ACa7A67244BA480",
        icon: null,
        usdValue: 2.843657278799935,
      },
      {
        id: "1",
        name: "COGO",
        value: 2,
        tokenType: "alt",
        address: "0x5F2b130BA4486B2bE05B646B5BCb9A01E4ff51E3",
        icon: null,
        usdValue: 212.54034538464,
      },
      {
        id: "1",
        name: "AMD",
        value: 2,
        tokenType: "alt",
        address: "0xDEF575Aea01bFC170d1839b7Ebd2E5B8eA58c13e",
        icon: null,
        usdValue: 15901594573.788757,
      },
      {
        id: "1",
        name: "NTP",
        value: 2,
        tokenType: "alt",
        address: "0x1aF4F195A8AAa7FFd752C28A13B719b84056f0d6",
        icon: null,
        usdValue: 4038.61874416,
      },
      {
        id: "1",
        name: "GBC",
        value: 2,
        tokenType: "alt",
        address: "0xB7447364eF42CfF09425a0FEaE703EE0b72647f9",
        icon: null,
        usdValue: 94.72478978900166,
      },
      {
        id: "1",
        name: "BKN",
        value: 2,
        tokenType: "alt",
        address: "0x0a638f07acc6969abf392bb009f216d22adea36d",
        icon: null,
        usdValue: 145.44229454593065,
      },
      {
        id: "1",
        name: "BDT",
        value: 2,
        tokenType: "alt",
        address: "0x216e9D8A521d93EC769635859c57938119fE5369",
        icon: null,
        usdValue: 118.1936624469038,
      },
      {
        id: "1",
        name: "ARTII",
        value: 2,
        tokenType: "alt",
        address: "0x07a858fc699f99ddf2b186bf162fd7f4d42f7f63",
        icon: null,
        usdValue: 140.86983183386428,
      },
      {
        id: "1",
        name: "FON",
        value: 2,
        tokenType: "alt",
        address: "0xa4be4cDC552891a6702E1aE9645EF445179a4463",
        icon: null,
        usdValue: 4763.275403849621,
      },
      {
        id: "56",
        name: "MNG",
        value: 2,
        tokenType: "alt",
        address: "0x13dfe44c7b461222e10597e517e4485ff4766582",
        icon: null,
        usdValue: 58.00849868409483,
      },
      {
        id: "1",
        name: "CYMI",
        value: 2,
        tokenType: "alt",
        address: "0x7449c93abe66457e83b3799bcf1a99e92d58a93b",
        icon: null,
        usdValue: 451090.83585321857,
      },
      {
        id: "1",
        name: "ZINU",
        value: 2,
        tokenType: "alt",
        address: "0xc5fdf3569af74f3b3e97e46a187a626352d2d508",
        icon: null,
        usdValue: 96.80276103975493,
      },
      {
        id: "1",
        name: "EYE",
        value: 2,
        tokenType: "alt",
        address: "0x9A257C90Fa239fBA07771ef7da2d554D148c2E89",
        icon: null,
        usdValue: 81.28263876900961,
      },
      {
        id: "1",
        name: "MNDCC",
        value: 2,
        tokenType: "alt",
        address: "0xcdb9d30a3ba48cdfcb0ecbe19317e6cf783672f1",
        icon: null,
        usdValue: 10000.713770234232,
      },
      {
        id: "1",
        name: "WCA",
        value: 2,
        tokenType: "alt",
        address: "0x506b8f75bdef0edac36b0a6f9cf313485e4341b0",
        icon: null,
        usdValue: 14743.837003392107,
      },
      {
        id: "1",
        name: "DIO",
        value: 2,
        tokenType: "alt",
        address: "0x35a5cb585d51d836922b78a9bb1f5c04635c39b6",
        icon: null,
        usdValue: 12943.24295625,
      },
      {
        id: "1",
        name: "DOV",
        value: 2,
        tokenType: "alt",
        address: "0xac3211a5025414af2866ff09c23fc18bc97e79b1",
        icon: null,
        usdValue: 16.365707718722,
      },
      {
        id: "1",
        name: "ETHO",
        value: 2,
        tokenType: "alt",
        address: "0x0b5326da634f9270fb84481dd6f94d3dc2ca7096",
        icon: null,
        usdValue: 18.317849454712473,
      },
      {
        id: "1",
        name: "EDDA",
        value: 2,
        tokenType: "alt",
        address: "0xfbbe9b1142c699512545f47937ee6fae0e4b0aa9",
        icon: null,
        usdValue: 29.690010990820166,
      },
      {
        id: "1",
        name: "PPC",
        value: 2,
        tokenType: "alt",
        address: "0x044d078f1c86508e13328842cc75ac021b272958",
        icon: null,
        usdValue: 116.26919822521802,
      },
      {
        id: "1",
        name: "INSTAR",
        value: 2,
        tokenType: "alt",
        address: "0x8193711b2763bc7dfd67da0d6c8c26642eafdaf3",
        icon: null,
        usdValue: 155.66001881346398,
      },
      {
        id: "1",
        name: "XCM",
        value: 2,
        tokenType: "alt",
        address: "0x36ac219f90f5a6a3c77f2a7b660e3cc701f68e25",
        icon: null,
        usdValue: 48.69165549281158,
      },
      {
        id: "1",
        name: "LCS",
        value: 2,
        tokenType: "alt",
        address: "0xaa19961b6b858d9f18a115f25aa1d98abc1fdba8",
        icon: null,
        usdValue: 378.6918656331243,
      },
      {
        id: "1",
        name: "TXL",
        value: 2,
        tokenType: "alt",
        address: "0x8eEF5a82E6Aa222a60F009ac18c24EE12dBf4b41",
        icon: null,
        usdValue: 18.39869361027156,
      },
      {
        id: "1",
        name: "KANGAL",
        value: 2,
        tokenType: "alt",
        address: "0x6e765d26388a17a6e86c49a8e41df3f58abcd337",
        icon: null,
        usdValue: 163.58905714139823,
      },
      {
        id: "1",
        name: "WAG",
        value: 2,
        tokenType: "alt",
        address: "0x7FA7dF4996AC59F398476892cfB195eD38543520",
        icon: null,
        usdValue: 4.71006395536652,
      },
      {
        id: "1",
        name: "SCA",
        value: 2,
        tokenType: "alt",
        address: "0x1FbD3dF007eB8A7477A1Eab2c63483dCc24EfFD6",
        icon: null,
        usdValue: 15.328812756993173,
      },
      {
        id: "1",
        name: "CSWAP",
        value: 2,
        tokenType: "alt",
        address: "0xe0b0c16038845bed3fcf70304d3e167df81ce225",
        icon: null,
        usdValue: 101.90392917877705,
      },
      {
        id: "1",
        name: "ETHM",
        value: 2,
        tokenType: "alt",
        address: "0xfd957f21bd95e723645c07c48a2d8acb8ffb3794",
        icon: null,
        usdValue: 130.20249420981844,
      },
      {
        id: "1",
        name: "DHP",
        value: 2,
        tokenType: "alt",
        address: "0xc40F23A3E9613E012944f7957edCe97899Fa920d",
        icon: null,
        usdValue: 11.29233233752597,
      },
      {
        id: "1",
        name: "POW",
        value: 2,
        tokenType: "alt",
        address: "0x43ab765ee05075d78ad8aa79dcb1978ca3079258",
        icon: null,
        usdValue: 64.38904485216874,
      },
      {
        id: "1",
        name: "MECHA",
        value: 2,
        tokenType: "alt",
        address: "0xc5bcc8ba3f33ab0d64f3473e861bdc0685b19ef5",
        icon: null,
        usdValue: 2.621656150221799,
      },
      {
        id: "1",
        name: "ELFI",
        value: 2,
        tokenType: "alt",
        address: "0x4da34f8264cb33a5c9f17081b9ef5ff6091116f4",
        icon: null,
        usdValue: 36.06580710164762,
      },
      {
        id: "1",
        name: "COREDAO",
        value: 2,
        tokenType: "alt",
        address: "0xf66cd2f8755a21d3c8683a10269f795c0532dd58",
        icon: null,
        usdValue: 194.19829495482568,
      },
      {
        id: "1",
        name: "QUAD",
        value: 2,
        tokenType: "alt",
        address: "0xab2a7b5876d707e0126b3a75ef7781c77c8877ee",
        icon: null,
        usdValue: 9.317521852137794,
      },
      {
        id: "1",
        name: "WCSOV",
        value: 2,
        tokenType: "alt",
        address: "0x68e9c0d9aa450254aed2cd102503d4dff6b3c37c",
        icon: null,
        usdValue: 17.354472004448866,
      },
      {
        id: "1",
        name: "ZENIQ",
        value: 2,
        tokenType: "alt",
        address: "0x5b52bfb8062ce664d74bbcd4cd6dc7df53fd7233",
        icon: null,
        usdValue: 87.83825042044322,
      },
      {
        id: "1",
        name: "oDOGE",
        value: 2,
        tokenType: "alt",
        address: "0x796a4503b444a71b331c9556bef0815237ddeabc",
        icon: null,
        usdValue: 126.29103792033152,
      },
      {
        id: "1",
        name: "DXN",
        value: 2,
        tokenType: "alt",
        address: "0x80f0C1c49891dcFDD40b6e0F960F84E6042bcB6F",
        icon: null,
        usdValue: 411.42612863506446,
      },
      {
        id: "1",
        name: "GBYTE",
        value: 2,
        tokenType: "alt",
        address: "0x31F69dE127C8A0fF10819C0955490a4Ae46fcc2a",
        icon: null,
        usdValue: 54.79287567362384,
      },
      {
        id: "1",
        name: "ULX",
        value: 2,
        tokenType: "alt",
        address: "0x5aa158404fed6b4730c13f49d3a7f820e14a636f",
        icon: null,
        usdValue: 52.52605991080695,
      },
      {
        id: "1",
        name: "JAR",
        value: 2,
        tokenType: "alt",
        address: "0xa249de6948022783765fee4850d7b85e43118fcc",
        icon: null,
        usdValue: 3596.535205082986,
      },
      {
        id: "1",
        name: "xDG",
        value: 2,
        tokenType: "alt",
        address: "0x4f81c790581b240a5c948afd173620ecc8c71c8d",
        icon: null,
        usdValue: 264.17181665429115,
      },
      {
        id: "1",
        name: "PIB",
        value: 2,
        tokenType: "alt",
        address: "0x1864ce27e9f7517047933caae530674e8c70b8a7",
        icon: null,
        usdValue: 3.981165552067351,
      },
      {
        id: "1",
        name: "BRIDGE",
        value: 2,
        tokenType: "alt",
        address: "0x92868a5255c628da08f550a858a802f5351c5223",
        icon: null,
        usdValue: 99.68227429787011,
      },
      {
        id: "1",
        name: "PHONON",
        value: 2,
        tokenType: "alt",
        address: "0x758b4684be769e92eefea93f60dda0181ea303ec",
        icon: null,
        usdValue: 3875.0445428174107,
      },
      {
        id: "1",
        name: "EUROE",
        value: 2,
        tokenType: "stable",
        address: "0x820802fa8a99901f52e39acd21177b0be6ee2974",
        icon: null,
        usdValue: 836.99,
      },
      {
        id: "137",
        name: "EDAT",
        value: 2,
        tokenType: "alt",
        address: "0xdd9ba3b2571bea0854beb0508ce10fed0eca7e3e",
        icon: null,
        usdValue: 4.643632223999999,
      },
      {
        id: "137",
        name: "WBNB",
        value: 2,
        tokenType: "alt",
        address: "0xeCDCB5B88F8e3C15f95c720C51c71c9E2080525d",
        icon: null,
        usdValue: 115.21662398699999,
      },
      {
        id: "5000",
        name: "CLEO",
        value: 2,
        tokenType: "alt",
        address: "0xc1e0c8c30f251a07a894609616580ad2ceb547f2",
        icon: null,
        usdValue: 2945.488702530528,
      },
      {
        id: "42161",
        name: "HTE",
        value: 2,
        tokenType: "alt",
        address: "0x80DD74145B8bb10Cef01BF914f796BD8B54d7809",
        icon: null,
        usdValue: 8303.134137535506,
      },
      {
        id: "42161",
        name: "MMF",
        value: 2,
        tokenType: "alt",
        address: "0x56b251d4b493ee3956E3f899D36b7290902D2326",
        icon: null,
        usdValue: 24.669681143171697,
      },
      {
        id: "137",
        name: "AX",
        value: 2,
        tokenType: "alt",
        address: "0x1a763170B96F23f15576D0fa0b2619d1254c437d",
        icon: null,
        usdValue: 24216.1995875383,
      },
      {
        id: "56",
        name: "TFT",
        value: 2,
        tokenType: "alt",
        address: "0x8f0FB159380176D324542b3a7933F0C2Fd0c2bbf",
        icon: null,
        usdValue: 10.239266965132188,
      },
      {
        id: "56",
        name: "COW",
        value: 2,
        tokenType: "alt",
        address: "0x422e3af98bc1de5a1838be31a56f75db4ad43730",
        icon: null,
        usdValue: 2.443832124229748,
      },
      {
        id: "56",
        name: "CHEX",
        value: 2,
        tokenType: "alt",
        address: "0x9ce84f6a69986a83d92c324df10bc8e64771030f",
        icon: null,
        usdValue: 59.22028518264894,
      },
      {
        id: "42161",
        name: "UND",
        value: 2,
        tokenType: "alt",
        address: "0xB5a628803ee72D82098D4bcaF29a42e63531B441",
        icon: null,
        usdValue: 2.719442557566666,
      },
      {
        id: "56",
        name: "CWT",
        value: 1,
        tokenType: "alt",
        address: "0x5a726a26edb0df8fd55f03cc30af8a7cea81e78d",
        icon: null,
        usdValue: 10828.664999999999,
      },
      {
        id: "56",
        name: "AVXL",
        value: 1,
        tokenType: "alt",
        address: "0xbd29490383edfd560426c3b63d01534408bc2da6",
        icon: null,
        usdValue: 4.8068186625,
      },
      {
        id: "137",
        name: "POLX",
        value: 1,
        tokenType: "alt",
        address: "0x187ae45f2d361cbce37c6a8622119c91148f261b",
        icon: null,
        usdValue: 1238.328,
      },
      {
        id: "56",
        name: "PEPEBNB",
        value: 1,
        tokenType: "alt",
        address: "0x47fd014706081068448b89fc6baca2730977216a",
        icon: null,
        usdValue: 2.032007318750295,
      },
      {
        id: "56",
        name: "TREAT",
        value: 1,
        tokenType: "alt",
        address: "0x01bd7acb6ff3b6dd5aefa05cf085f2104f3fc53f",
        icon: null,
        usdValue: 6904.024042646914,
      },
      {
        id: "56",
        name: "HOTDOGE",
        value: 1,
        tokenType: "alt",
        address: "0x1991501f1398663f69dd7391c055bb0df6514f76",
        icon: null,
        usdValue: 1.7424942486689334,
      },
      {
        id: "137",
        name: "BCT",
        value: 1,
        tokenType: "alt",
        address: "0x2f800db0fdb5223b3c3f354886d907a671414a7f",
        icon: null,
        usdValue: 1.2802733753704747,
      },
      {
        id: "137",
        name: "TUSD",
        value: 1,
        tokenType: "stable",
        address: "0x2e1ad108ff1d8c782fcbbb89aad783ac49586756",
        icon: null,
        usdValue: 13.01163858629176,
      },
      {
        id: "10",
        name: "sfrxETH",
        value: 1,
        tokenType: "alt",
        address: "0x484c2d6e3cdd945a8b2df735e079178c1036578c",
        icon: null,
        usdValue: 1.0329338846408935,
      },
      {
        id: "56",
        name: "UPR",
        value: 1,
        tokenType: "alt",
        address: "0xf720e38f678b29b243f7d53b56acbf5de98f2385",
        icon: null,
        usdValue: 74.31668746109368,
      },
      {
        id: "137",
        name: "0xBTC",
        value: 1,
        tokenType: "alt",
        address: "0x71b821aa52a49f32eed535fca6eb5aa130085978",
        icon: null,
        usdValue: 31.398166351432604,
      },
      {
        id: "1",
        name: "PKT",
        value: 1,
        tokenType: "alt",
        address: "0x2604fa406be957e542beb89e6754fcde6815e83f",
        icon: null,
        usdValue: 58.108803113718395,
      },
      {
        id: "56",
        name: "KOCHI",
        value: 1,
        tokenType: "alt",
        address: "0x41b2F7acc00035F9b1cec868B5054a6238C0a910",
        icon: null,
        usdValue: 980.7002870959898,
      },
      {
        id: "56",
        name: "HAKKA",
        value: 1,
        tokenType: "alt",
        address: "0x1d1eb8e8293222e1a29d2c0e4ce6c0acfd89aaac",
        icon: null,
        usdValue: 183.67499999999998,
      },
      {
        id: "56",
        name: "BSCX",
        value: 1,
        tokenType: "alt",
        address: "0x5ac52ee5b2a633895292ff6d8a89bb9190451587",
        icon: null,
        usdValue: 9.314071462898154,
      },
      {
        id: "56",
        name: "BTH",
        value: 1,
        tokenType: "alt",
        address: "0x57bc18f6177cdaffb34ace048745bc913a1b1b54",
        icon: null,
        usdValue: 8.585627513182223,
      },
      {
        id: "56",
        name: "BELT",
        value: 1,
        tokenType: "alt",
        address: "0xe0e514c71282b6f4e823703a39374cf58dc3ea4f",
        icon: null,
        usdValue: 1.2348498039209173,
      },
      {
        id: "56",
        name: "SPRT",
        value: 1,
        tokenType: "alt",
        address: "0x56156fb7860d7eb0b4b1a5356c5354b295194a45",
        icon: null,
        usdValue: 2.80046548294,
      },
      {
        id: "56",
        name: "DPT",
        value: 1,
        tokenType: "alt",
        address: "0xE69cAef10A488D7AF31Da46c89154d025546e990",
        icon: null,
        usdValue: 1.2162816857946719,
      },
      {
        id: "56",
        name: "SWAMP",
        value: 1,
        tokenType: "alt",
        address: "0xc5a49b4cbe004b6fd55b30ba1de6ac360ff9765d",
        icon: null,
        usdValue: 1.1501773692539101,
      },
      {
        id: "56",
        name: "CBT",
        value: 1,
        tokenType: "alt",
        address: "0x7c73967dC8c804Ea028247f5A953052f0CD5Fd58",
        icon: null,
        usdValue: 6.86669781292,
      },
      {
        id: "137",
        name: "ANRX",
        value: 1,
        tokenType: "alt",
        address: "0x554f074d9cCda8F483d1812d4874cBebD682644E",
        icon: null,
        usdValue: 4.858791586660348,
      },
      {
        id: "56",
        name: "IPX",
        value: 1,
        tokenType: "alt",
        address: "0xCDB96d3aEf363a036c6CF6c9b5736d79f0E404e2",
        icon: null,
        usdValue: 288.2035775918184,
      },
      {
        id: "56",
        name: "DESU",
        value: 1,
        tokenType: "alt",
        address: "0x32f1518baace69e85b9e5ff844ebd617c52573ac",
        icon: null,
        usdValue: 130.44058816568943,
      },
      {
        id: "56",
        name: "BRB",
        value: 1,
        tokenType: "alt",
        address: "0xca0823d3d04b9faea7803ccb87fa8596775190dd",
        icon: null,
        usdValue: 9.420976125877582,
      },
      {
        id: "56",
        name: "BOG",
        value: 1,
        tokenType: "alt",
        address: "0xb09fe1613fe03e7361319d2a43edc17422f36b09",
        icon: null,
        usdValue: 31.35821337637427,
      },
      {
        id: "56",
        name: "OASIS",
        value: 1,
        tokenType: "alt",
        address: "0xb19289b436b2f7a92891ac391d8f52580d3087e4",
        icon: null,
        usdValue: 173.44420445173344,
      },
      {
        id: "56",
        name: "ZUKI",
        value: 1,
        tokenType: "alt",
        address: "0xE81257d932280AE440B17AFc5f07C8A110D21432",
        icon: null,
        usdValue: 2.15903163894462,
      },
      {
        id: "56",
        name: "CIFI",
        value: 1,
        tokenType: "alt",
        address: "0x4DCd4700B38ce6562730c27Da557F6de819b347B",
        icon: null,
        usdValue: 259.02091499595383,
      },
      {
        id: "56",
        name: "BCF",
        value: 1,
        tokenType: "alt",
        address: "0xe78AD8967e523a29D4D3a8e76422Aa7ab2B6A47E",
        icon: null,
        usdValue: 14.408783599924723,
      },
      {
        id: "137",
        name: "GENI",
        value: 1,
        tokenType: "alt",
        address: "0x444444444444c1a66f394025ac839a535246fcc8",
        icon: null,
        usdValue: 7.596183247696698,
      },
      {
        id: "56",
        name: "ROYA",
        value: 1,
        tokenType: "alt",
        address: "0x99415856b37be9e75c0153615c7954f9ddb97a6e",
        icon: null,
        usdValue: 7.97084,
      },
      {
        id: "137",
        name: "WUSDR",
        value: 1,
        tokenType: "alt",
        address: "0xaf0d9d65fc54de245cda37af3d18cbec860a4d4b",
        icon: null,
        usdValue: 10.50672100181998,
      },
      {
        id: "56",
        name: "MECH",
        value: 1,
        tokenType: "alt",
        address: "0xc7b7844494c516b840a7a4575ff3e60ff0f056a9",
        icon: null,
        usdValue: 10.9637261351348,
      },
      {
        id: "56",
        name: "AQT",
        value: 1,
        tokenType: "alt",
        address: "0xda5be69074afd12354173b4350ec9117e73e92e2",
        icon: null,
        usdValue: 11,
      },
      {
        id: "56",
        name: "FACTR",
        value: 1,
        tokenType: "alt",
        address: "0xdefac16715671b7b6aeefe012125f1e19ee4b7d7",
        icon: null,
        usdValue: 694.4429748750003,
      },
      {
        id: "56",
        name: "CWE",
        value: 1,
        tokenType: "alt",
        address: "0x9c6b7221cdda3b8136fbf9d27ac07aeecc1087b5",
        icon: null,
        usdValue: 7.4257468849470785,
      },
      {
        id: "56",
        name: "GWT",
        value: 1,
        tokenType: "alt",
        address: "0x552594612f935441c01c6854edf111f343c1ca07",
        icon: null,
        usdValue: 6.7975593048691,
      },
      {
        id: "56",
        name: "SDLN",
        value: 1,
        tokenType: "alt",
        address: "0x8e2e96a890dfaca6957ea899e1c37411a111afd2",
        icon: null,
        usdValue: 107.75872383529584,
      },
      {
        id: "56",
        name: "TGDAO",
        value: 1,
        tokenType: "alt",
        address: "0x46F275321107d7c49cF80216371AbF1a1599c36F",
        icon: null,
        usdValue: 12.043729968637846,
      },
      {
        id: "56",
        name: "LFC",
        value: 1,
        tokenType: "alt",
        address: "0xD9474595Edb03E35C5843335F90eb18671921246",
        icon: null,
        usdValue: 4.811356698069599,
      },
      {
        id: "56",
        name: "INAZ",
        value: 1,
        tokenType: "alt",
        address: "0x6E551e88D0eD3EBD56F6b1F42B03BF9E4d68C47f",
        icon: null,
        usdValue: 71.00606639707972,
      },
      {
        id: "56",
        name: "TARO",
        value: 1,
        tokenType: "alt",
        address: "0x424aa711301c82252ecCaccF01301aD7Ad7b5D40",
        icon: null,
        usdValue: 1.553530125,
      },
      {
        id: "137",
        name: "PGEN",
        value: 1,
        tokenType: "alt",
        address: "0x01d35cbC2070a3B76693Ce2b6364Eae24eb88591",
        icon: null,
        usdValue: 45.41418828,
      },
      {
        id: "56",
        name: "ITAMCUBE",
        value: 1,
        tokenType: "alt",
        address: "0x9b08f10d8c250714f6485212300a7b72f973f1fd",
        icon: null,
        usdValue: 125814.85855238607,
      },
      {
        id: "1",
        name: "ePhiat",
        value: 1,
        tokenType: "alt",
        address: "0xE9F721E7419423f11863e83DbD710b5D6127b5b0",
        icon: null,
        usdValue: 61.90329957345818,
      },
      {
        id: "137",
        name: "HAKKA",
        value: 1,
        tokenType: "alt",
        address: "0x978338A9d2d0aa2fF388d3dc98b9bF25bfF5efB4",
        icon: null,
        usdValue: 2.755125,
      },
      {
        id: "137",
        name: "BAT",
        value: 1,
        tokenType: "alt",
        address: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
        icon: null,
        usdValue: 20.266489138057636,
      },
      {
        id: "56",
        name: "VNLA",
        value: 1,
        tokenType: "alt",
        address: "0x22517fA2A5341453f1F9ebd5Ecb8620a90dc8E4b",
        icon: null,
        usdValue: 18.66208512210835,
      },
      {
        id: "56",
        name: "CURVE",
        value: 1,
        tokenType: "alt",
        address: "0xecbddf83687e9842837e08c5a650658f2260b376",
        icon: null,
        usdValue: 1.8887,
      },
      {
        id: "56",
        name: "BRICKS",
        value: 1,
        tokenType: "alt",
        address: "0x13e1070e3a388e53ec35480ff494538f9ffc5b8d",
        icon: null,
        usdValue: 114.66747434356502,
      },
      {
        id: "56",
        name: "FIT",
        value: 1,
        tokenType: "alt",
        address: "0x77922A521182a719A48ba650aC2A040269888888",
        icon: null,
        usdValue: 387.3272314605703,
      },
      {
        id: "56",
        name: "BRAND",
        value: 1,
        tokenType: "alt",
        address: "0x4d993ec7b44276615bb2f6f20361ab34fbf0ec49",
        icon: null,
        usdValue: 1.4807731200049317,
      },
      {
        id: "1",
        name: "MUNCH",
        value: 1,
        tokenType: "alt",
        address: "0x944eee930933be5e23b690c8589021ec8619a301",
        icon: null,
        usdValue: 1.2968692812718094,
      },
      {
        id: "56",
        name: "SCB",
        value: 1,
        tokenType: "alt",
        address: "0x0d36cc179019db9a65aa3b85db59e4bb52df0b12",
        icon: null,
        usdValue: 29.76,
      },
      {
        id: "10",
        name: "bomb",
        value: 1,
        tokenType: "alt",
        address: "0x74ccbe53f77b08632ce0cb91d3a545bf6b8e0979",
        icon: null,
        usdValue: 559.1472236492715,
      },
      {
        id: "56",
        name: "EQX",
        value: 1,
        tokenType: "alt",
        address: "0x436c52a8cee41d5e9c5e6f4cb146e66d552fb700",
        icon: null,
        usdValue: 48.67149739747869,
      },
      {
        id: "56",
        name: "RELAY",
        value: 1,
        tokenType: "alt",
        address: "0xe338d4250a4d959f88ff8789eaae8c32700bd175",
        icon: null,
        usdValue: 90.75115922939483,
      },
      {
        id: "137",
        name: "FRXETH",
        value: 1,
        tokenType: "alt",
        address: "0xee327f889d5947c1dc1934bb208a1e792f953e96",
        icon: null,
        usdValue: 30.932511402156976,
      },
      {
        id: "56",
        name: "SFEX",
        value: 1,
        tokenType: "alt",
        address: "0x5392Ff4a9BD006DC272C1855af6640e17Cc5ec0B",
        icon: null,
        usdValue: 58.916368689749994,
      },
      {
        id: "137",
        name: "AIMX",
        value: 1,
        tokenType: "alt",
        address: "0x33b6d77c607ea499ab5db7e2201c5a516a78a5db",
        icon: null,
        usdValue: 2.6973810039000004,
      },
      {
        id: "137",
        name: "SKRT",
        value: 1,
        tokenType: "alt",
        address: "0xe51e88dd08499762b8e4eb3a9f3da9b8e79608c3",
        icon: null,
        usdValue: 2.6537971513999996,
      },
      {
        id: "137",
        name: "GAMER",
        value: 1,
        tokenType: "alt",
        address: "0x3f6b3595ecf70735d3f48d69b09c4e4506db3f47",
        icon: null,
        usdValue: 3.34807044,
      },
      {
        id: "42161",
        name: "LG",
        value: 1,
        tokenType: "alt",
        address: "0x9c8ef67c9168587134e1f29a71405dc753500a45",
        icon: null,
        usdValue: 10.927610843594348,
      },
      {
        id: "56",
        name: "BHO",
        value: 1,
        tokenType: "alt",
        address: "0x8717e80eff08f53a45b4a925009957e14860a8a8",
        icon: null,
        usdValue: 63.34442586143967,
      },
      {
        id: "56",
        name: "LAVAX",
        value: 1,
        tokenType: "alt",
        address: "0xa9be3cd803fa19f2af24412ff0a2a4a67a29de88",
        icon: null,
        usdValue: 51.99345169821144,
      },
      {
        id: "137",
        name: "MM",
        value: 1,
        tokenType: "alt",
        address: "0x5647Fe4281F8F6F01E84BCE775AD4b828A7b8927",
        icon: null,
        usdValue: 204.99999999999997,
      },
      {
        id: "56",
        name: "SEA",
        value: 1,
        tokenType: "alt",
        address: "0x26193c7fa4354ae49ec53ea2cebc513dc39a10aa",
        icon: null,
        usdValue: 390.8079215574097,
      },
      {
        id: "56",
        name: "FIGHT",
        value: 1,
        tokenType: "alt",
        address: "0x4f39c3319188A723003670c3F9B9e7EF991E52F3",
        icon: null,
        usdValue: 18.043482621532,
      },
      {
        id: "56",
        name: "ARKER",
        value: 1,
        tokenType: "alt",
        address: "0x9c67638c4Fa06FD47fB8900fC7F932f7EAB589De",
        icon: null,
        usdValue: 113.58408719060002,
      },
      {
        id: "56",
        name: "BIG",
        value: 1,
        tokenType: "alt",
        address: "0x6fdda284250795dfbab53955da78de4b6f72c4f9",
        icon: null,
        usdValue: 7.216449587984001,
      },
      {
        id: "1",
        name: "PRUF",
        value: 1,
        tokenType: "alt",
        address: "0xa49811140e1d6f653dec28037be0924c811c4538",
        icon: null,
        usdValue: 1.5122,
      },
      {
        id: "42161",
        name: "MPEPE",
        value: 1,
        tokenType: "alt",
        address: "0xCe0B3F1258189Da17BBd8c7E0509f5f7E001a998",
        icon: null,
        usdValue: 22.67487210473035,
      },
      {
        id: "56",
        name: "ADR",
        value: 1,
        tokenType: "alt",
        address: "0x36F1f32c728C3F330409eC1F0928Fa3aB3C8A76F",
        icon: null,
        usdValue: 13.48842573,
      },
      {
        id: "56",
        name: "ACY",
        value: 1,
        tokenType: "alt",
        address: "0xc94595b56e301f3ffedb8ccc2d672882d623e53a",
        icon: null,
        usdValue: 8.821018931363794,
      },
      {
        id: "56",
        name: "LIGHT",
        value: 1,
        tokenType: "alt",
        address: "0x037838b556d9c9d654148a284682c55bb5f56ef4",
        icon: null,
        usdValue: 4.74993956120457,
      },
      {
        id: "56",
        name: "BONFIRE",
        value: 1,
        tokenType: "alt",
        address: "0x5e90253fbae4dab78aa351f4e6fed08a64ab5590",
        icon: null,
        usdValue: 58.686157726002136,
      },
      {
        id: "56",
        name: "RABBIT",
        value: 1,
        tokenType: "alt",
        address: "0x95a1199eba84ac5f19546519e287d43d2f0e1b41",
        icon: null,
        usdValue: 11.890822013330085,
      },
      {
        id: "56",
        name: "GFN",
        value: 1,
        tokenType: "alt",
        address: "0xf209ce1960fb7e750ff30ba7794ea11c6acdc1f3",
        icon: null,
        usdValue: 10.728759577740723,
      },
      {
        id: "56",
        name: "ARKN",
        value: 1,
        tokenType: "alt",
        address: "0xaA20c2e278D99f978989dAa4460F933745F862d5",
        icon: null,
        usdValue: 15.075554048,
      },
      {
        id: "56",
        name: "KRAC",
        value: 1,
        tokenType: "alt",
        address: "0xb91F0fdFfdDE4d6D53ac4066AcC32aA81fC6DE2C",
        icon: null,
        usdValue: 25.72932,
      },
      {
        id: "56",
        name: "MNSTRS",
        value: 1,
        tokenType: "alt",
        address: "0x287db351d5230716246cfb46af8153025eda6a0a",
        icon: null,
        usdValue: 3.6014025,
      },
      {
        id: "56",
        name: "ALTRU",
        value: 1,
        tokenType: "alt",
        address: "0x377ef66728d344bfa2bb370186ab4b57092577bd",
        icon: null,
        usdValue: 1.6843107599999998,
      },
      {
        id: "56",
        name: "LIBERO",
        value: 1,
        tokenType: "alt",
        address: "0x0DFCb45EAE071B3b846E220560Bbcdd958414d78",
        icon: null,
        usdValue: 9.963397373165764,
      },
      {
        id: "42161",
        name: "SLIZ",
        value: 1,
        tokenType: "alt",
        address: "0x463913D3a3D3D291667D53B8325c598Eb88D3B0e",
        icon: null,
        usdValue: 147.3403500836456,
      },
      {
        id: "56",
        name: "CXPAD",
        value: 1,
        tokenType: "alt",
        address: "0xe90d1567ecef9282cc1ab348d9e9e2ac95659b99",
        icon: null,
        usdValue: 1.0514035293242299,
      },
      {
        id: "42161",
        name: "FLUID",
        value: 1,
        tokenType: "alt",
        address: "0x876ec6be52486eeec06bc06434f3e629d695c6ba",
        icon: null,
        usdValue: 935.834773193643,
      },
      {
        id: "56",
        name: "BSL",
        value: 1,
        tokenType: "alt",
        address: "0xb60501346240fcde1615de56ea9fff1ac1da5673",
        icon: null,
        usdValue: 23.72021412037036,
      },
      {
        id: "10",
        name: "opx",
        value: 1,
        tokenType: "alt",
        address: "0xcdb4bb51801a1f399d4402c61bc098a72c382e65",
        icon: null,
        usdValue: 79.24405013040328,
      },
      {
        id: "1",
        name: "LTY",
        value: 1,
        tokenType: "alt",
        address: "0x85ffb35957203dfd12061eaecd708db623bd567c",
        icon: null,
        usdValue: 339.05111745330294,
      },
      {
        id: "56",
        name: "HAPPY",
        value: 1,
        tokenType: "alt",
        address: "0xf5d8a096cccb31b9d7bce5afe812be23e3d4690d",
        icon: null,
        usdValue: 1.7834183085864612,
      },
      {
        id: "56",
        name: "TPAD",
        value: 1,
        tokenType: "alt",
        address: "0xADCFC6bf853a0a8ad7f9Ff4244140D10cf01363C",
        icon: null,
        usdValue: 1.3925013596724978,
      },
      {
        id: "56",
        name: "CORAI",
        value: 1,
        tokenType: "alt",
        address: "0x17C8C198c06f16a8dB68148d9ac460F5aED029d8",
        icon: null,
        usdValue: 1.0869263999999998,
      },
      {
        id: "10",
        name: "dai+",
        value: 1,
        tokenType: "stable",
        address: "0x970d50d09f3a656b43e11b0d45241a84e3a6e011",
        icon: null,
        usdValue: 21.47991938274006,
      },
      {
        id: "1",
        name: "DPET",
        value: 1,
        tokenType: "alt",
        address: "0xfb62ae373aca027177d1c18ee0862817f9080d08",
        icon: null,
        usdValue: 45.108107000000004,
      },
      {
        id: "56",
        name: "TRUST",
        value: 1,
        tokenType: "alt",
        address: "0x2dBd86A424a815AD2A08a2D8dAE07007fed6Dc91",
        icon: null,
        usdValue: 423.5419987973937,
      },
      {
        id: "56",
        name: "INR",
        value: 1,
        tokenType: "alt",
        address: "0xab725d0a10c3f24725c89f5765ae5794a26c1336",
        icon: null,
        usdValue: 12.391905713600002,
      },
      {
        id: "56",
        name: "BEM",
        value: 1,
        tokenType: "alt",
        address: "0x7B86b0836f3454e50C6F6a190cd692bB17da1928",
        icon: null,
        usdValue: 1.6978368,
      },
      {
        id: "56",
        name: "FRAG",
        value: 1,
        tokenType: "alt",
        address: "0x1a73308d8eeb3c1a2b771e9ace73508c52706b76",
        icon: null,
        usdValue: 8.36193599281365,
      },
      {
        id: "137",
        name: "FID",
        value: 1,
        tokenType: "alt",
        address: "0x9A4Eb698e5DE3D3Df0a68F681789072DE1E50222",
        icon: null,
        usdValue: 641.8503000000001,
      },
      {
        id: "137",
        name: "OJA",
        value: 1,
        tokenType: "alt",
        address: "0x26373ec913876c9e6d38494dde458cb8649cb30c",
        icon: null,
        usdValue: 84.98766112413985,
      },
      {
        id: "56",
        name: "HAVEN",
        value: 1,
        tokenType: "alt",
        address: "0x9cae753b661142ae766374cefa5dc800d80446ac",
        icon: null,
        usdValue: 96.50189797400216,
      },
      {
        id: "42161",
        name: "CAP",
        value: 1,
        tokenType: "alt",
        address: "0x031d35296154279dc1984dcd93e392b1f946737b",
        icon: null,
        usdValue: 54.50870610805487,
      },
      {
        id: "56",
        name: "ORE",
        value: 1,
        tokenType: "alt",
        address: "0x4ef285c8cbe52267c022c39da98b97ca4b7e2ff9",
        icon: null,
        usdValue: 68.31020811840035,
      },
      {
        id: "137",
        name: "RAIDER",
        value: 1,
        tokenType: "alt",
        address: "0xcd7361ac3307d1c5a46b63086a90742ff44c63b3",
        icon: null,
        usdValue: 25.42141793457999,
      },
      {
        id: "137",
        name: "MUST",
        value: 1,
        tokenType: "alt",
        address: "0x9C78EE466D6Cb57A4d01Fd887D2b5dFb2D46288f",
        icon: null,
        usdValue: 6.6788799999999995,
      },
      {
        id: "56",
        name: "VLTY",
        value: 1,
        tokenType: "alt",
        address: "0x38a5cbe2fb53d1d407dd5a22c4362daf48eb8526",
        icon: null,
        usdValue: 1.694061823542,
      },
      {
        id: "56",
        name: "MATTER",
        value: 1,
        tokenType: "alt",
        address: "0x1c9491865a1de77c5b6e19d2e6a5f1d7a6f2b25f",
        icon: null,
        usdValue: 1.1115092,
      },
      {
        id: "56",
        name: "NINO",
        value: 1,
        tokenType: "alt",
        address: "0x6CAD12b3618a3C7ef1FEb6C91FdC3251f58c2a90",
        icon: null,
        usdValue: 13.1097507,
      },
      {
        id: "56",
        name: "ULTRA",
        value: 1,
        tokenType: "alt",
        address: "0x0b3f42481c228f70756dbfa0309d3ddc2a5e0f6a",
        icon: null,
        usdValue: 5.2401619081307445,
      },
      {
        id: "56",
        name: "SALE",
        value: 1,
        tokenType: "alt",
        address: "0x04f73a09e2eb410205be256054794fb452f0d245",
        icon: null,
        usdValue: 53.0313,
      },
      {
        id: "137",
        name: "CBY",
        value: 1,
        tokenType: "alt",
        address: "0xb6a5ae40e79891e4deadad06c8a7ca47396df21c",
        icon: null,
        usdValue: 1335.7415468849856,
      },
      {
        id: "1",
        name: "UNIFI",
        value: 1,
        tokenType: "alt",
        address: "0x9E78b8274e1D6a76a0dBbf90418894DF27cBCEb5",
        icon: null,
        usdValue: 4.12679845,
      },
      {
        id: "137",
        name: "OM",
        value: 1,
        tokenType: "alt",
        address: "0xc3ec80343d2bae2f8e680fdadde7c17e71e114ea",
        icon: null,
        usdValue: 4.884368767532884,
      },
      {
        id: "137",
        name: "GLCH",
        value: 1,
        tokenType: "alt",
        address: "0xbe5cf150e1ff59ca7f2499eaa13bfc40aae70e78",
        icon: null,
        usdValue: 2.294627803745735,
      },
      {
        id: "56",
        name: "EGC",
        value: 1,
        tokenType: "alt",
        address: "0xC001BBe2B87079294C63EcE98BdD0a88D761434e",
        icon: null,
        usdValue: 1.082593239639019,
      },
      {
        id: "137",
        name: "FISH",
        value: 1,
        tokenType: "alt",
        address: "0x3a3df212b7aa91aa0402b9035b098891d276572b",
        icon: null,
        usdValue: 4.115281280244712,
      },
      {
        id: "56",
        name: "CPD",
        value: 1,
        tokenType: "alt",
        address: "0x2406dCe4dA5aB125A18295f4fB9FD36a0f7879A2",
        icon: null,
        usdValue: 441.09,
      },
      {
        id: "56",
        name: "KIAN",
        value: 1,
        tokenType: "alt",
        address: "0x5ECE3F1542C4e1a06767457e4D8286beA772fc41",
        icon: null,
        usdValue: 1.1906010448149627,
      },
      {
        id: "56",
        name: "GOD",
        value: 1,
        tokenType: "alt",
        address: "0x2aaa5cb023cf458e7dfa765fd48b64cd95995ab7",
        icon: null,
        usdValue: 2.832470405469475,
      },
      {
        id: "56",
        name: "DDN",
        value: 1,
        tokenType: "alt",
        address: "0x180caf92a1989efc5af3efe154db0dd73199930f",
        icon: null,
        usdValue: 103.80675204081,
      },
      {
        id: "56",
        name: "ADT",
        value: 1,
        tokenType: "alt",
        address: "0xc008debbb1f33d9453ffd2104feb1fe7e9663524",
        icon: null,
        usdValue: 2.0701486239999998,
      },
      {
        id: "56",
        name: "VPK",
        value: 1,
        tokenType: "alt",
        address: "0x37Ac5F3bfd18a164Fc6cF0f0f0ECD334D9179d57",
        icon: null,
        usdValue: 244.11568302,
      },
      {
        id: "56",
        name: "ERA",
        value: 1,
        tokenType: "alt",
        address: "0x6f9F0c4ad9Af7EbD61Ac5A1D4e0F2227F7B0E5f9",
        icon: null,
        usdValue: 3.0063011294671202,
      },
      {
        id: "56",
        name: "ETM",
        value: 1,
        tokenType: "alt",
        address: "0x75bDEd6BF44bb01527138673dCc064DBe3E7d96d",
        icon: null,
        usdValue: 38.08893329279589,
      },
      {
        id: "137",
        name: "FLAME",
        value: 1,
        tokenType: "alt",
        address: "0x22e3f02f86bc8ea0d73718a2ae8851854e62adc5",
        icon: null,
        usdValue: 3038.8954151757744,
      },
      {
        id: "1",
        name: "NFTFY",
        value: 1,
        tokenType: "alt",
        address: "0xBf6Ff49FfD3d104302Ef0AB0F10f5a84324c091c",
        icon: null,
        usdValue: 4.5661600474999995,
      },
      {
        id: "56",
        name: "XMS",
        value: 1,
        tokenType: "alt",
        address: "0x7859b01bbf675d67da8cd128a50d155cd881b576",
        icon: null,
        usdValue: 23.52797535172047,
      },
      {
        id: "56",
        name: "POL",
        value: 1,
        tokenType: "alt",
        address: "0x273a4ffceb31b8473d51051ad2a2edbb7ac8ce02",
        icon: null,
        usdValue: 15.91003391,
      },
      {
        id: "56",
        name: "EQZ",
        value: 1,
        tokenType: "alt",
        address: "0x1Da87b114f35E1DC91F72bF57fc07A768Ad40Bb0",
        icon: null,
        usdValue: 12.1796228842,
      },
      {
        id: "56",
        name: "TOON",
        value: 1,
        tokenType: "alt",
        address: "0xaee433adebe0fbb88daa47ef0c1a513caa52ef02",
        icon: null,
        usdValue: 3.0684003652812635,
      },
      {
        id: "56",
        name: "DDOS",
        value: 1,
        tokenType: "alt",
        address: "0x7fbec0bb6a7152e77c30d005b5d49cbc08a602c3",
        icon: null,
        usdValue: 23.126587385000004,
      },
      {
        id: "56",
        name: "CIRUS",
        value: 1,
        tokenType: "alt",
        address: "0x4c888e116d57a32f84865f3789dcb131fdc9fab6",
        icon: null,
        usdValue: 140.24188402,
      },
      {
        id: "137",
        name: "IOEN",
        value: 1,
        tokenType: "alt",
        address: "0xd0e9c8f5Fae381459cf07Ec506C1d2896E8b5df6",
        icon: null,
        usdValue: 174.07744497000002,
      },
      {
        id: "137",
        name: "CIRUS",
        value: 1,
        tokenType: "alt",
        address: "0x2a82437475a60bebd53e33997636fade77604fc2",
        icon: null,
        usdValue: 34.31829338,
      },
      {
        id: "56",
        name: "DEFX",
        value: 1,
        tokenType: "alt",
        address: "0xbe4cb2c354480042a39350a0c6c26bf54786539f",
        icon: null,
        usdValue: 1076.6948413059333,
      },
      {
        id: "56",
        name: "BUX",
        value: 1,
        tokenType: "alt",
        address: "0x211ffbe424b90e25a15531ca322adf1559779e45",
        icon: null,
        usdValue: 29.068861869616,
      },
      {
        id: "56",
        name: "PRL",
        value: 1,
        tokenType: "alt",
        address: "0xd07e82440A395f3F3551b42dA9210CD1Ef4f8B24",
        icon: null,
        usdValue: 1.7134404889393264,
      },
      {
        id: "137",
        name: "XPND",
        value: 1,
        tokenType: "alt",
        address: "0x03f61137BFb86be07394f0FD07a33984020F96D8",
        icon: null,
        usdValue: 9.42867120736975,
      },
      {
        id: "56",
        name: "ZENIQ",
        value: 1,
        tokenType: "alt",
        address: "0x5b52bfb8062ce664d74bbcd4cd6dc7df53fd7233",
        icon: null,
        usdValue: 1.6923005950988956,
      },
      {
        id: "56",
        name: "FXF",
        value: 1,
        tokenType: "alt",
        address: "0x8a40c222996f9f3431f63bf80244c36822060f12",
        icon: null,
        usdValue: 2.4815707554543063,
      },
      {
        id: "56",
        name: "NFTART",
        value: 1,
        tokenType: "alt",
        address: "0xf7844cb890f4c339c497aeab599abdc3c874b67a",
        icon: null,
        usdValue: 1.7745001854964242,
      },
      {
        id: "10",
        name: "syn",
        value: 1,
        tokenType: "alt",
        address: "0x5a5fff6f753d7c11a56a52fe47a177a87e431655",
        icon: null,
        usdValue: 434.11221078303964,
      },
      {
        id: "10",
        name: "hnd",
        value: 1,
        tokenType: "alt",
        address: "0x10010078a54396f62c96df8532dc2b4847d47ed3",
        icon: null,
        usdValue: 12.257552334044927,
      },
      {
        id: "137",
        name: "BOLLY",
        value: 1,
        tokenType: "alt",
        address: "0x7dc47cfb674beb5827283f6140f635680a5ce992",
        icon: null,
        usdValue: 26.14817953,
      },
      {
        id: "56",
        name: "ASPO",
        value: 1,
        tokenType: "alt",
        address: "0x1a9b49e9f075c37fe5f86c916bac9deb33556d7e",
        icon: null,
        usdValue: 1.506494291119128,
      },
      {
        id: "56",
        name: "H2ON",
        value: 1,
        tokenType: "alt",
        address: "0xE0E81c29A68bFDd7c48072fD94e7c58F1f0146C1",
        icon: null,
        usdValue: 1.8378573248634151,
      },
      {
        id: "137",
        name: "MECHA",
        value: 1,
        tokenType: "alt",
        address: "0xacd4e2d936be9b16c01848a3742a34b3d5a5bdfa",
        icon: null,
        usdValue: 4.883337136161471,
      },
      {
        id: "137",
        name: "ICHI",
        value: 1,
        tokenType: "alt",
        address: "0x111111517e4929d3dcbdfa7cce55d30d4b6bc4d6",
        icon: null,
        usdValue: 1.1028910828123788,
      },
      {
        id: "56",
        name: "LSC",
        value: 1,
        tokenType: "alt",
        address: "0x74e2572a1c579b4df80d57e9698098b255f23c9e",
        icon: null,
        usdValue: 1.3106571670504,
      },
      {
        id: "137",
        name: "KROM",
        value: 1,
        tokenType: "alt",
        address: "0x14Af1F2f02DCcB1e43402339099A05a5E363b83c",
        icon: null,
        usdValue: 8.770199007881642,
      },
      {
        id: "137",
        name: "MCHC",
        value: 1,
        tokenType: "alt",
        address: "0xee7666aacaefaa6efeef62ea40176d3eb21953b9",
        icon: null,
        usdValue: 1812.5424160000002,
      },
      {
        id: "137",
        name: "CHP",
        value: 1,
        tokenType: "alt",
        address: "0x59B5654a17Ac44F3068b3882F298881433bB07Ef",
        icon: null,
        usdValue: 7.513766610432768,
      },
      {
        id: "56",
        name: "RVC",
        value: 1,
        tokenType: "alt",
        address: "0xbcbdecf8e76a5c32dba69de16985882ace1678c6",
        icon: null,
        usdValue: 20.429825169,
      },
      {
        id: "56",
        name: "GVT",
        value: 1,
        tokenType: "alt",
        address: "0xf25868b9e9c62f12192650ac668a2aa69f965f44",
        icon: null,
        usdValue: 30.140049672652,
      },
      {
        id: "56",
        name: "PANDAI",
        value: 1,
        tokenType: "alt",
        address: "0x550d7984b7adfff88815e5528e12e322df6d3b9b",
        icon: null,
        usdValue: 1.2493835660345372,
      },
      {
        id: "56",
        name: "TITI",
        value: 1,
        tokenType: "alt",
        address: "0xE618eF7C64AFedE59A81CEf16d0161c914eBab17",
        icon: null,
        usdValue: 1.8660731599358706,
      },
      {
        id: "56",
        name: "HF",
        value: 1,
        tokenType: "alt",
        address: "0x759Bd4ed07A34b9ea761F8F2ED9f0e102675a29C",
        icon: null,
        usdValue: 10.297114195790027,
      },
      {
        id: "137",
        name: "PSP",
        value: 1,
        tokenType: "alt",
        address: "0x42d61d766b85431666b39b89c43011f24451bff6",
        icon: null,
        usdValue: 1.2075905778812521,
      },
      {
        id: "56",
        name: "SWTH",
        value: 1,
        tokenType: "alt",
        address: "0x250b211ee44459dad5cd3bca803dd6a7ecb5d46c",
        icon: null,
        usdValue: 2.31440311784487,
      },
      {
        id: "56",
        name: "WUSDR",
        value: 1,
        tokenType: "alt",
        address: "0x2952beb1326accbb5243725bd4da2fc937bca087",
        icon: null,
        usdValue: 1.9548304901240572,
      },
      {
        id: "56",
        name: "DDD",
        value: 1,
        tokenType: "alt",
        address: "0x84c97300a190676a19D1E13115629A11f8482Bd1",
        icon: null,
        usdValue: 304.8619820875106,
      },
      {
        id: "56",
        name: "COP",
        value: 1,
        tokenType: "alt",
        address: "0x8789337a176e6e7223ff115f1cd85c993d42c25c",
        icon: null,
        usdValue: 79.30691910640574,
      },
      {
        id: "56",
        name: "BCOIN",
        value: 1,
        tokenType: "alt",
        address: "0x00e1656e45f18ec6747f5a8496fd39b50b38396d",
        icon: null,
        usdValue: 2.497572433014502,
      },
      {
        id: "56",
        name: "DOV",
        value: 1,
        tokenType: "alt",
        address: "0xc9457161320210d22f0d0d5fc1309acb383d4609",
        icon: null,
        usdValue: 11.201819896479616,
      },
      {
        id: "56",
        name: "D3D",
        value: 1,
        tokenType: "alt",
        address: "0xd3c7e51CAaB1089002eC05569A04D14bCC478bC4",
        icon: null,
        usdValue: 15.709100000000001,
      },
      {
        id: "137",
        name: "W$C",
        value: 1,
        tokenType: "alt",
        address: "0x77A6f2e9A9E44fd5D5C3F9bE9E52831fC1C3C0A0",
        icon: null,
        usdValue: 1.375412961482557,
      },
      {
        id: "56",
        name: "AIRT",
        value: 1,
        tokenType: "alt",
        address: "0x016cf83732f1468150d87dcc5bdf67730b3934d3",
        icon: null,
        usdValue: 1.24837,
      },
      {
        id: "56",
        name: "BLOS",
        value: 1,
        tokenType: "alt",
        address: "0xd5e950837ad48d08bad2f87bfcf8ed7167bb44bc",
        icon: null,
        usdValue: 1.7780424732541353,
      },
      {
        id: "56",
        name: "ELVN",
        value: 1,
        tokenType: "alt",
        address: "0xE8DE5e3689c42729CE53BB950FfF2e625Ccf23A7",
        icon: null,
        usdValue: 4.138426087322725,
      },
      {
        id: "137",
        name: "FINT",
        value: 1,
        tokenType: "alt",
        address: "0xD0513DB39d87e8825389fEB10BD911dC53B3a153",
        icon: null,
        usdValue: 1.9032868032849002,
      },
      {
        id: "1",
        name: "ASX",
        value: 1,
        tokenType: "alt",
        address: "0x67d85a291fcdc862a78812a3c26d55e28ffb2701",
        icon: null,
        usdValue: 198.42503758214832,
      },
      {
        id: "56",
        name: "OCP",
        value: 1,
        tokenType: "alt",
        address: "0x3c70260eee0a2bfc4b375feb810325801f289fbd",
        icon: null,
        usdValue: 3.7020666861700002,
      },
      {
        id: "56",
        name: "UNW",
        value: 1,
        tokenType: "alt",
        address: "0x5b65cd9feb54f1df3d0c60576003344079f8dc06",
        icon: null,
        usdValue: 3.9744834096240007,
      },
      {
        id: "56",
        name: "TAROT",
        value: 1,
        tokenType: "alt",
        address: "0xa8cd6e4bf45724d3ac27f9e31e47ba4e399a7b52",
        icon: null,
        usdValue: 1.3996737018360346,
      },
      {
        id: "10",
        name: "xopenx",
        value: 1,
        tokenType: "alt",
        address: "0x2513486f18eee1498d7b6281f668b955181dd0d9",
        icon: null,
        usdValue: 1.4390879223522932,
      },
      {
        id: "56",
        name: "MCB",
        value: 1,
        tokenType: "alt",
        address: "0x5fe80d2cd054645b9419657d3d10d26391780a7b",
        icon: null,
        usdValue: 42.59854067726201,
      },
      {
        id: "56",
        name: "CVL",
        value: 1,
        tokenType: "alt",
        address: "0x9ae0290cd677dc69a5f2a1e435ef002400da70f5",
        icon: null,
        usdValue: 7.261100231713728,
      },
      {
        id: "137",
        name: "O3",
        value: 1,
        tokenType: "alt",
        address: "0xee9801669c6138e84bd50deb500827b776777d28",
        icon: null,
        usdValue: 11.8700023,
      },
      {
        id: "10",
        name: "openx",
        value: 1,
        tokenType: "alt",
        address: "0xc3864f98f2a61a7caeb95b039d031b4e2f55e0e9",
        icon: null,
        usdValue: 2.0150254305553927,
      },
      {
        id: "10",
        name: "opxvevelo",
        value: 1,
        tokenType: "alt",
        address: "0x46f21fda29f1339e0ab543763ff683d399e393ec",
        icon: null,
        usdValue: 1.216408057327676,
      },
      {
        id: "137",
        name: "MULTI",
        value: 1,
        tokenType: "alt",
        address: "0x9fb9a33956351cf4fa040f65a13b835a3c8764e3",
        icon: null,
        usdValue: 3.6248,
      },
      {
        id: "56",
        name: "ROCKI",
        value: 1,
        tokenType: "alt",
        address: "0xa01000c52b234a92563ba61e5649b7c76e1ba0f3",
        icon: null,
        usdValue: 115.74240435707394,
      },
      {
        id: "56",
        name: "PSP",
        value: 1,
        tokenType: "alt",
        address: "0xcafe001067cdef266afb7eb5a286dcfd277f3de5",
        icon: null,
        usdValue: 1.706065201679933,
      },
      {
        id: "137",
        name: "COMP",
        value: 1,
        tokenType: "alt",
        address: "0x8505b9d2254a7ae468c0e9dd10ccea3a837aef5c",
        icon: null,
        usdValue: 121.99438176,
      },
      {
        id: "137",
        name: "ICE",
        value: 1,
        tokenType: "alt",
        address: "0xc6c855ad634dcdad23e64da71ba85b8c51e5ad7c",
        icon: null,
        usdValue: 1.5959286799359078,
      },
      {
        id: "10",
        name: "usx",
        value: 1,
        tokenType: "stable",
        address: "0xbfd291da8a403daaf7e5e9dc1ec0aceacd4848b9",
        icon: null,
        usdValue: 2.3092034922461484,
      },
      {
        id: "10",
        name: "mta",
        value: 1,
        tokenType: "alt",
        address: "0x929b939f8524c3be977af57a4a0ad3fb1e374b50",
        icon: null,
        usdValue: 8.10339373991819,
      },
      {
        id: "42161",
        name: "LION",
        value: 1,
        tokenType: "alt",
        address: "0x8eBb85D53e6955e557b7c53acDE1D42fD68561Ec",
        icon: null,
        usdValue: 127.43609473296516,
      },
      {
        id: "56",
        name: "VALAS",
        value: 1,
        tokenType: "alt",
        address: "0xb1ebdd56729940089ecc3ad0bbeeb12b6842ea6f",
        icon: null,
        usdValue: 2.640346643000431,
      },
      {
        id: "56",
        name: "GLCH",
        value: 1,
        tokenType: "alt",
        address: "0xf0902eb0049a4003793bab33f3566a22d2834442",
        icon: null,
        usdValue: 4.148923007256173,
      },
      {
        id: "56",
        name: "MAHA",
        value: 1,
        tokenType: "alt",
        address: "0xCE86F7fcD3B40791F63B86C3ea3B8B355Ce2685b",
        icon: null,
        usdValue: 18.13848431095298,
      },
      {
        id: "56",
        name: "STUD",
        value: 1,
        tokenType: "alt",
        address: "0x56900be791fb3c6abf1932df0f20daae6208dbe0",
        icon: null,
        usdValue: 1.0580540474999998,
      },
      {
        id: "137",
        name: "GMEE",
        value: 1,
        tokenType: "alt",
        address: "0xcf32822ff397Ef82425153a9dcb726E5fF61DCA7",
        icon: null,
        usdValue: 2208.525587293304,
      },
      {
        id: "137",
        name: "XMATIC",
        value: 1,
        tokenType: "alt",
        address: "0xf6d5d14c5684fa5853a3be6d217cad19c6ab2164",
        icon: null,
        usdValue: 12.435179420967257,
      },
      {
        id: "56",
        name: "STEP",
        value: 1,
        tokenType: "alt",
        address: "0x465707181acba42ed01268a33f0507e320a154bd",
        icon: null,
        usdValue: 1.9700010000000001,
      },
      {
        id: "137",
        name: "EURe",
        value: 1,
        tokenType: "stable",
        address: "0x18ec0A6E18E5bc3784fDd3a3634b31245ab704F6",
        icon: null,
        usdValue: 203.5432848612771,
      },
      {
        id: "137",
        name: "Visit https://ubonus.tech to claim reward",
        value: 1,
        tokenType: "alt",
        address: "0xbed2130a73d1e63ef633b241dde5014c7b980c70",
        icon: null,
        usdValue: 0,
      },
      {
        id: "1",
        name: "AXPR",
        value: 1,
        tokenType: "alt",
        address: "0x9af2c6b1a28d3d6bc084bd267f70e90d49741d5b",
        icon: null,
        usdValue: 176.44799999999998,
      },
      {
        id: "1",
        name: "OATH",
        value: 1,
        tokenType: "alt",
        address: "0x6f9c26fa731c7ea4139fa669962cf8f1ce6c8b0b",
        icon: null,
        usdValue: 6.940673279056116,
      },
      {
        id: "1",
        name: "IQN",
        value: 1,
        tokenType: "alt",
        address: "0x0DB8D8b76BC361bAcbB72E2C491E06085A97Ab31",
        icon: null,
        usdValue: 170.312408574705,
      },
      {
        id: "1",
        name: "HYDRO",
        value: 1,
        tokenType: "alt",
        address: "0x946112efab61c3636cbd52de2e1392d7a75a6f01",
        icon: null,
        usdValue: 15735.506401508936,
      },
      {
        id: "1",
        name: "GUP",
        value: 1,
        tokenType: "alt",
        address: "0xf7b098298f7c69fc14610bf71d5e02c60792894c",
        icon: null,
        usdValue: 5366.63769937716,
      },
      {
        id: "1",
        name: "ALIS",
        value: 1,
        tokenType: "alt",
        address: "0xEA610B1153477720748DC13ED378003941d84fAB",
        icon: null,
        usdValue: 21.00233825549833,
      },
      {
        id: "1",
        name: "AID",
        value: 1,
        tokenType: "alt",
        address: "0x37e8789bb9996cac9156cd5f5fd32599e6b91289",
        icon: null,
        usdValue: 593.1608652816349,
      },
      {
        id: "1",
        name: "OPT",
        value: 1,
        tokenType: "alt",
        address: "0x4355fC160f74328f9b383dF2EC589bB3dFd82Ba0",
        icon: null,
        usdValue: 3098.1330052400003,
      },
      {
        id: "1",
        name: "REAL",
        value: 1,
        tokenType: "stable",
        address: "0x9214ec02cb71cba0ada6896b8da260736a67ab10",
        icon: null,
        usdValue: 15.797390399999998,
      },
      {
        id: "1",
        name: "VCK",
        value: 1,
        tokenType: "alt",
        address: "0xfa5b75a9e13df9775cf5b996a049d9cc07c15731",
        icon: null,
        usdValue: 5802.034715305679,
      },
      {
        id: "1",
        name: "FOXT",
        value: 1,
        tokenType: "alt",
        address: "0xfbe878ced08132bd8396988671b450793c44bc12",
        icon: null,
        usdValue: 1.8058664,
      },
      {
        id: "1",
        name: "MSB",
        value: 1,
        tokenType: "alt",
        address: "0x84c722e6f1363e8d5c6db3ea600bef9a006da824",
        icon: null,
        usdValue: 203.01369327780088,
      },
      {
        id: "1",
        name: "MF1",
        value: 1,
        tokenType: "alt",
        address: "0x9b5161a41b58498eb9c5febf89d60714089d2253",
        icon: null,
        usdValue: 2504.351930936424,
      },
      {
        id: "1",
        name: "1PECO",
        value: 1,
        tokenType: "alt",
        address: "0x7169ba45cf03e0377b464462aacbccdf1f721125",
        icon: null,
        usdValue: 1387.8376276069341,
      },
      {
        id: "1",
        name: "TRZ",
        value: 1,
        tokenType: "alt",
        address: "0x394a16744dcd805bb0ca7252e70691f0dcac56aa",
        icon: null,
        usdValue: 4131.316462409504,
      },
      {
        id: "1",
        name: "HRTS",
        value: 1,
        tokenType: "alt",
        address: "0xCeB53519a2B891d33b36E3826962D2a48f878e45",
        icon: null,
        usdValue: 1036.6927936660134,
      },
      {
        id: "1",
        name: "ANTE",
        value: 1,
        tokenType: "alt",
        address: "0xbb70AdbE39408cB1E5258702ea8ADa7c81165b73",
        icon: null,
        usdValue: 3599.5826047200003,
      },
      {
        id: "1",
        name: "VID",
        value: 1,
        tokenType: "alt",
        address: "0x2c9023bbc572ff8dc1228c7858a280046ea8c9e5",
        icon: null,
        usdValue: 3940.047132281709,
      },
      {
        id: "1",
        name: "SPRING",
        value: 1,
        tokenType: "alt",
        address: "0xf04af3f4e4929f7cd25a751e6149a3318373d4fe",
        icon: null,
        usdValue: 1211.7139691677755,
      },
      {
        id: "1",
        name: "XPN",
        value: 1,
        tokenType: "alt",
        address: "0x3b9e094d56103611f0acefdab43182347ba60df4",
        icon: null,
        usdValue: 79.67070222331944,
      },
      {
        id: "1",
        name: "GOM2",
        value: 1,
        tokenType: "alt",
        address: "0x48783486ddD7fa85ECa6B0C4AE8920Bc25DfbcD7",
        icon: null,
        usdValue: 502.4108822,
      },
      {
        id: "1",
        name: "BASIC",
        value: 1,
        tokenType: "alt",
        address: "0xf25c91c87e0b1fd9b4064af0f427157aab0193a7",
        icon: null,
        usdValue: 114.00317145403734,
      },
      {
        id: "1",
        name: "NFUP",
        value: 1,
        tokenType: "alt",
        address: "0x26CBC7008cD879f4B63B69a915378f2D9b17bBF0",
        icon: null,
        usdValue: 3235.3542346026043,
      },
      {
        id: "1",
        name: "CET",
        value: 1,
        tokenType: "alt",
        address: "0x081f67afa0ccf8c7b17540767bbe95df2ba8d97f",
        icon: null,
        usdValue: 619177.0217831106,
      },
      {
        id: "56",
        name: "TSX",
        value: 1,
        tokenType: "alt",
        address: "0x270388e0ca29cfd7c7e73903d9d933a23d1bab39",
        icon: null,
        usdValue: 2.4576495,
      },
      {
        id: "1",
        name: "EUM",
        value: 1,
        tokenType: "alt",
        address: "0x6aB4A7d75B0A42B6Bc83E852daB9E121F9C610Aa",
        icon: null,
        usdValue: 71842.97955023302,
      },
      {
        id: "1",
        name: "WELD",
        value: 1,
        tokenType: "alt",
        address: "0xdd2a36ae937bc134ea694d77fc7e2e36f5d86de0",
        icon: null,
        usdValue: 6992.421802208996,
      },
      {
        id: "1",
        name: "TRAXX",
        value: 1,
        tokenType: "alt",
        address: "0xd43be54c1aedf7ee4099104f2dae4ea88b18a249",
        icon: null,
        usdValue: 15576.329336017312,
      },
      {
        id: "1",
        name: "ODE",
        value: 1,
        tokenType: "alt",
        address: "0xbf52f2ab39e26e0951d2a02b49b7702abe30406a",
        icon: null,
        usdValue: 76.128,
      },
      {
        id: "1",
        name: "HPB",
        value: 1,
        tokenType: "alt",
        address: "0x38c6a68304cdefb9bec48bbfaaba5c5b47818bb2",
        icon: null,
        usdValue: 561.2125406687999,
      },
      {
        id: "1",
        name: "CHKN",
        value: 1,
        tokenType: "alt",
        address: "0xd55210bb6898c021a19de1f58d27b71f095921ee",
        icon: null,
        usdValue: 64.15530519727483,
      },
      {
        id: "1",
        name: "DHN",
        value: 1,
        tokenType: "alt",
        address: "0x32462ba310e447ef34ff0d15bce8613aa8c4a244",
        icon: null,
        usdValue: 2928.3,
      },
      {
        id: "1",
        name: "USDR",
        value: 1,
        tokenType: "alt",
        address: "0x7b43e3875440b44613dc3bc08e7763e6da63c8f8",
        icon: null,
        usdValue: 1169503.9429259999,
      },
      {
        id: "1",
        name: "GT",
        value: 1,
        tokenType: "alt",
        address: "0xe66747a101bff2dba3697199dcce5b743b454759",
        icon: null,
        usdValue: 5003085.419144999,
      },
      {
        id: "1",
        name: "WAGMI",
        value: 1,
        tokenType: "alt",
        address: "0x92cc36d66e9d739d50673d1f27929a371fb83a67",
        icon: null,
        usdValue: 123262.61888978831,
      },
      {
        id: "1",
        name: "APP",
        value: 1,
        tokenType: "alt",
        address: "0xc5d27f27f08d1fd1e3ebbaa50b3442e6c0d50439",
        icon: null,
        usdValue: 35548.7817343799,
      },
      {
        id: "1",
        name: "LIF3",
        value: 1,
        tokenType: "alt",
        address: "0x7138eb0d563f3f6722500936a11dcae99d738a2c",
        icon: null,
        usdValue: 470527.4849434228,
      },
      {
        id: "1",
        name: "PEEZY",
        value: 1,
        tokenType: "alt",
        address: "0x698b1d54e936b9f772b8f58447194bbc82ec1933",
        icon: null,
        usdValue: 23.65787662041972,
      },
      {
        id: "1",
        name: "KARATE",
        value: 1,
        tokenType: "alt",
        address: "0x80008bcd713c38af90a9930288d446bc3bd2e684",
        icon: null,
        usdValue: 477.5236670405124,
      },
      {
        id: "1",
        name: "ZENITH",
        value: 1,
        tokenType: "alt",
        address: "0x0343131c0257ac21ea5a8dc83841f071efd9285c",
        icon: null,
        usdValue: 1619.310536979592,
      },
      {
        id: "1",
        name: "GLR",
        value: 1,
        tokenType: "alt",
        address: "0xd54619e0b9899d74cc9b981354eb6b59732c43b1",
        icon: null,
        usdValue: 75008.68905986332,
      },
      {
        id: "1",
        name: "KUSUNOKI",
        value: 1,
        tokenType: "alt",
        address: "0x36919a60a2b67b6d2329863093d180d23d5a0308",
        icon: null,
        usdValue: 19661.370222640737,
      },
      {
        id: "1",
        name: "PRBLY",
        value: 1,
        tokenType: "alt",
        address: "0x6361f338ab8def2af3f2a1be7bd8a7db3156f7e7",
        icon: null,
        usdValue: 179.621661673905,
      },
      {
        id: "1",
        name: "BLID",
        value: 1,
        tokenType: "alt",
        address: "0x8a7adc1b690e81c758f1bd0f72dfe27ae6ec56a5",
        icon: null,
        usdValue: 6709.493130154923,
      },
      {
        id: "1",
        name: "IXP",
        value: 1,
        tokenType: "alt",
        address: "0x54cb643ab007f47882e8120a8c57b639005c2688",
        icon: null,
        usdValue: 13.254728330855166,
      },
      {
        id: "1",
        name: "MBASE",
        value: 1,
        tokenType: "alt",
        address: "0xbA3E5F8b4200a5eb856FF2C3E001aB29444491AA",
        icon: null,
        usdValue: 4428.231037484977,
      },
      {
        id: "1",
        name: "IMC",
        value: 1,
        tokenType: "alt",
        address: "0xbf0741e995f469d39e4f96c0780f9a8e43f4b978",
        icon: null,
        usdValue: 123.50979832196157,
      },
      {
        id: "1",
        name: "EBSO",
        value: 1,
        tokenType: "alt",
        address: "0x866f8a50a64e68ca66e97e032c5da99538b3f942",
        icon: null,
        usdValue: 131871.26954287456,
      },
      {
        id: "1",
        name: "CRI",
        value: 1,
        tokenType: "alt",
        address: "0x12E951934246186F50146235d541D3bD1D463E4d",
        icon: null,
        usdValue: 347442.4837220755,
      },
      {
        id: "1",
        name: "FSC",
        value: 1,
        tokenType: "alt",
        address: "0x5f4361971667c8198706dec8c59cf7607e405c6e",
        icon: null,
        usdValue: 1210967.13,
      },
      {
        id: "1",
        name: "FSCC",
        value: 1,
        tokenType: "alt",
        address: "0x0789dbAE94fb18e5789B8e4489BCB7A1ADB58622",
        icon: null,
        usdValue: 1.4299596250000002,
      },
      {
        id: "1",
        name: "0NE",
        value: 1,
        tokenType: "alt",
        address: "0x73a83269b9bbafc427e76be0a2c1a1db2a26f4c2",
        icon: null,
        usdValue: 3.0572976715884344,
      },
      {
        id: "1",
        name: "EGGS",
        value: 1,
        tokenType: "alt",
        address: "0x2e516BA5Bf3b7eE47fb99B09eaDb60BDE80a82e0",
        icon: null,
        usdValue: 1.4225844111721222,
      },
      {
        id: "1",
        name: "ROSE",
        value: 1,
        tokenType: "alt",
        address: "0x26B80FBfC01b71495f477d5237071242e0d959d7",
        icon: null,
        usdValue: 33.04010502124954,
      },
      {
        id: "1",
        name: "RDPX",
        value: 1,
        tokenType: "alt",
        address: "0x0ff5a8451a839f5f0bb3562689d9a44089738d11",
        icon: null,
        usdValue: 12.786536335408728,
      },
      {
        id: "1",
        name: "WING",
        value: 1,
        tokenType: "alt",
        address: "0xdb0f18081b505a7de20b18ac41856bcb4ba86a1a",
        icon: null,
        usdValue: 128.96854928019,
      },
      {
        id: "1",
        name: "QMALL",
        value: 1,
        tokenType: "alt",
        address: "0x2217e5921b7edfb4bb193a6228459974010d2198",
        icon: null,
        usdValue: 2.967455663115617,
      },
      {
        id: "1",
        name: "SWTH",
        value: 1,
        tokenType: "alt",
        address: "0xb4371da53140417cbb3362055374b10d97e420bb",
        icon: null,
        usdValue: 62.475475283847,
      },
      {
        id: "1",
        name: "CPD",
        value: 1,
        tokenType: "alt",
        address: "0x9b31bb425D8263fA1b8B9d090b83CF0C31665355",
        icon: null,
        usdValue: 68.26831050764304,
      },
      {
        id: "1",
        name: "TDX",
        value: 1,
        tokenType: "alt",
        address: "0x317eb4ad9cfaC6232f0046831322E895507bcBeb",
        icon: null,
        usdValue: 1.8324756427057203,
      },
      {
        id: "1",
        name: "BF",
        value: 1,
        tokenType: "alt",
        address: "0x5b71bee9d961b1b848f8485eec8d8787f80217f5",
        icon: null,
        usdValue: 2.9627977806556522,
      },
      {
        id: "1",
        name: "RPG",
        value: 1,
        tokenType: "alt",
        address: "0x0E5C8C387C5EBa2eCbc137aD012aeD5Fe729e251",
        icon: null,
        usdValue: 188.87903977622568,
      },
      {
        id: "1",
        name: "STANDARD",
        value: 1,
        tokenType: "alt",
        address: "0xda0c94c73d127ee191955fb46bacd7ff999b2bcd",
        icon: null,
        usdValue: 4.343905515915254,
      },
      {
        id: "1",
        name: "CTCN",
        value: 1,
        tokenType: "alt",
        address: "0xfd6c31bb6f05fc8db64f4b740ab758605c271fd8",
        icon: null,
        usdValue: 14.022439774638414,
      },
      {
        id: "1",
        name: "PKR",
        value: 1,
        tokenType: "alt",
        address: "0x001a8ffcb0f03e99141652ebcdecdb0384e3bd6c",
        icon: null,
        usdValue: 107.19742657622646,
      },
      {
        id: "1",
        name: "JET",
        value: 1,
        tokenType: "alt",
        address: "0x8727c112c712c4a03371ac87a74dd6ab104af768",
        icon: null,
        usdValue: 1.3169188732972266,
      },
      {
        id: "1",
        name: "YLC",
        value: 1,
        tokenType: "alt",
        address: "0x21d5678A62DFe63a47062469Ebb2fAc2817D8832",
        icon: null,
        usdValue: 1.7760643526547846,
      },
      {
        id: "1",
        name: "HVN",
        value: 1,
        tokenType: "alt",
        address: "0xC0Eb85285d83217CD7c891702bcbC0FC401E2D9D",
        icon: null,
        usdValue: 27.959240426797034,
      },
      {
        id: "1",
        name: "IND",
        value: 1,
        tokenType: "alt",
        address: "0xf8e386eda857484f5a12e4b5daa9984e06e73705",
        icon: null,
        usdValue: 14.834345869921984,
      },
      {
        id: "1",
        name: "NEX",
        value: 1,
        tokenType: "alt",
        address: "0xe2dc070524a6e305ddb64d8513dc444b6a1ec845",
        icon: null,
        usdValue: 4.206144361277389,
      },
      {
        id: "1",
        name: "OPCT",
        value: 1,
        tokenType: "alt",
        address: "0xdb05ea0877a2622883941b939f0bb11d1ac7c400",
        icon: null,
        usdValue: 18.48130499477656,
      },
      {
        id: "1",
        name: "LOL",
        value: 1,
        tokenType: "alt",
        address: "0x5978708d6ccE1CC9640Eed47422D64c91BbD5171",
        icon: null,
        usdValue: 3.0331382807589753,
      },
      {
        id: "1",
        name: "PERX",
        value: 1,
        tokenType: "alt",
        address: "0x3C6ff50c9Ec362efa359317009428d52115fe643",
        icon: null,
        usdValue: 6.5865012484934455,
      },
      {
        id: "1",
        name: "BED",
        value: 1,
        tokenType: "alt",
        address: "0x2aF1dF3AB0ab157e1E2Ad8F88A7D04fbea0c7dc6",
        icon: null,
        usdValue: 160.39607384860506,
      },
      {
        id: "1",
        name: "YFO",
        value: 1,
        tokenType: "alt",
        address: "0xac0c8da4a4748d8d821a0973d00b157aa78c473d",
        icon: null,
        usdValue: 12.233678646778857,
      },
      {
        id: "1",
        name: "AXIAV3",
        value: 1,
        tokenType: "alt",
        address: "0x793786e2dd4Cc492ed366a94B88a3Ff9ba5E7546",
        icon: null,
        usdValue: 1.266731369733597,
      },
      {
        id: "1",
        name: "VCG",
        value: 1,
        tokenType: "alt",
        address: "0x1f36fb2d91d9951cf58ae4c1956c0b77e224f1e9",
        icon: null,
        usdValue: 1.2472200623559997,
      },
      {
        id: "1",
        name: "START",
        value: 1,
        tokenType: "alt",
        address: "0x1d7Ca62F6Af49ec66f6680b8606E634E55Ef22C1",
        icon: null,
        usdValue: 3.653884400782041,
      },
      {
        id: "1",
        name: "8PAY",
        value: 1,
        tokenType: "alt",
        address: "0xfeea0bdd3d07eb6fe305938878c0cadbfa169042",
        icon: null,
        usdValue: 22.394369342741182,
      },
      {
        id: "1",
        name: "MOAR",
        value: 1,
        tokenType: "alt",
        address: "0x187eff9690e1f1a61d578c7c492296eaab82701a",
        icon: null,
        usdValue: 6.68616499713632,
      },
      {
        id: "1",
        name: "KKO",
        value: 1,
        tokenType: "alt",
        address: "0x368c5290b13caa10284db58b4ad4f3e9ee8bf4c9",
        icon: null,
        usdValue: 1.396686634298015,
      },
      {
        id: "1",
        name: "RNBW",
        value: 1,
        tokenType: "alt",
        address: "0xe94b97b6b43639e238c851a7e693f50033efd75c",
        icon: null,
        usdValue: 3.2180754517041934,
      },
      {
        id: "1",
        name: "BLKC",
        value: 1,
        tokenType: "alt",
        address: "0x8bcd06492416a749c9369009b3429861b7f27f6e",
        icon: null,
        usdValue: 1.2291176001008628,
      },
      {
        id: "1",
        name: "CNT",
        value: 1,
        tokenType: "alt",
        address: "0x429876c4a6f89fb470e92456b8313879df98b63c",
        icon: null,
        usdValue: 2.0914283697555027,
      },
      {
        id: "1",
        name: "VEST",
        value: 1,
        tokenType: "alt",
        address: "0x1f19f83fc9a25f3c861260143e36c17706257986",
        icon: null,
        usdValue: 6.1881692239799335,
      },
      {
        id: "1",
        name: "HAPPY",
        value: 1,
        tokenType: "alt",
        address: "0x3079f61704e9efa2bcf1db412f735d8d4cfa26f4",
        icon: null,
        usdValue: 4.7061830751093385,
      },
      {
        id: "1",
        name: "NST",
        value: 1,
        tokenType: "alt",
        address: "0x70bef3bb2f001da2fddb207dae696cd9faff3f5d",
        icon: null,
        usdValue: 105.21396289896245,
      },
      {
        id: "1",
        name: "BTSG",
        value: 1,
        tokenType: "alt",
        address: "0x05079687d35b93538cbd59fe5596380cae9054a9",
        icon: null,
        usdValue: 3.231557845652431,
      },
      {
        id: "1",
        name: "ICC",
        value: 1,
        tokenType: "alt",
        address: "0x70E67ec0939ec87c3a77b089CA08E0443ea4a177",
        icon: null,
        usdValue: 255.61892528808534,
      },
      {
        id: "1",
        name: "UWU",
        value: 1,
        tokenType: "alt",
        address: "0x55C08ca52497e2f1534B59E2917BF524D4765257",
        icon: null,
        usdValue: 2.8210149796713613,
      },
      {
        id: "1",
        name: "HPO",
        value: 1,
        tokenType: "alt",
        address: "0xa0ed3c520dc0632657ad2eaaf19e26c4fd431a84",
        icon: null,
        usdValue: 2.161208545993154,
      },
      {
        id: "1",
        name: "SEURO",
        value: 1,
        tokenType: "alt",
        address: "0xb399511642FE1666c6a07f83483e6E4feAed9A00",
        icon: null,
        usdValue: 2.5214263382875926,
      },
      {
        id: "1",
        name: "XOLO",
        value: 1,
        tokenType: "alt",
        address: "0x3252d4221f92b7af3774da8312f01600ec84b252",
        icon: null,
        usdValue: 65.12699480041562,
      },
      {
        id: "1",
        name: "KTO",
        value: 1,
        tokenType: "alt",
        address: "0x616ef40d55c0d2c506f4d6873bda8090b79bf8fc",
        icon: null,
        usdValue: 3.510661623333329,
      },
      {
        id: "1",
        name: "DSETH",
        value: 1,
        tokenType: "alt",
        address: "0x341c05c0E9b33C0E38d64de76516b2Ce970bB3BE",
        icon: null,
        usdValue: 12.9940378,
      },
      {
        id: "1",
        name: "ANONUSD",
        value: 1,
        tokenType: "stable",
        address: "0x5a7e6c8204a1359db9aacab7ba5fc309b7981efd",
        icon: null,
        usdValue: 1.9147537082267478,
      },
      {
        id: "1",
        name: "MGKL",
        value: 1,
        tokenType: "alt",
        address: "0x6a26ee7755d939b96cdcd8a0370630d48902fd7c",
        icon: null,
        usdValue: 5.461687885391359,
      },
      {
        id: "1",
        name: "BTE",
        value: 1,
        tokenType: "alt",
        address: "0x73b708e84837ffccde2933e3a1531fe61d5e80ef",
        icon: null,
        usdValue: 9.15200816111884,
      },
      {
        id: "1",
        name: "ZEON",
        value: 1,
        tokenType: "alt",
        address: "0xe5b826ca2ca02f09c1725e9bd98d9a8874c30532",
        icon: null,
        usdValue: 18.077730610556603,
      },
      {
        id: "1",
        name: "CLNY",
        value: 1,
        tokenType: "alt",
        address: "0x3e828ac5c480069d4765654fb4b8733b910b13b2",
        icon: null,
        usdValue: 5.276908730464693,
      },
      {
        id: "1",
        name: "CTZN",
        value: 1,
        tokenType: "alt",
        address: "0xa803778ab953d3ffe4fbd20cfa0042ecefe8319d",
        icon: null,
        usdValue: 6.034133671033893,
      },
      {
        id: "1",
        name: "IPT",
        value: 1,
        tokenType: "alt",
        address: "0xd909c5862cdb164adb949d92622082f0092efc3d",
        icon: null,
        usdValue: 6.374712031287306,
      },
      {
        id: "1",
        name: "ZDEX",
        value: 1,
        tokenType: "alt",
        address: "0x5150956E082C748Ca837a5dFa0a7C10CA4697f9c",
        icon: null,
        usdValue: 3.60829,
      },
      {
        id: "5000",
        name: "JOE",
        value: 1,
        tokenType: "alt",
        address: "0x371c7ec6d8039ff7933a2aa28eb827ffe1f52f07",
        icon: null,
        usdValue: 3.5345310000000003,
      },
      {
        id: "1",
        name: "BOLT",
        value: 1,
        tokenType: "alt",
        address: "0x9f235d23354857efe6c541db92a9ef1877689bcb",
        icon: null,
        usdValue: 1.8864,
      },
      {
        id: "42161",
        name: "1MB",
        value: 1,
        tokenType: "alt",
        address: "0xbcb90845614747e561ceb9e08a79e22c5d3555e1",
        icon: null,
        usdValue: 60.89301106426246,
      },
      {
        id: "1",
        name: "RIFI",
        value: 1,
        tokenType: "alt",
        address: "0xc8ef1460277ea47d179dec66d1c5f8b7f7ae5a28",
        icon: null,
        usdValue: 33127.62055640557,
      },
      {
        id: "42161",
        name: "BLS",
        value: 1,
        tokenType: "alt",
        address: "0x8A66794E1aaEBC7018A7B75F61f384e30ae3b159",
        icon: null,
        usdValue: 33937.12903106068,
      },
      {
        id: "42161",
        name: "HOLD",
        value: 1,
        tokenType: "alt",
        address: "0xb4bbfe92702730ef7f1d28e4b9e42381182f48a5",
        icon: null,
        usdValue: 21579.920754185532,
      },
      {
        id: "42161",
        name: "PESOS",
        value: 1,
        tokenType: "alt",
        address: "0x17afc249db786fc300f2d26381fec5cf0c3913fb",
        icon: null,
        usdValue: 55.4276149045021,
      },
      {
        id: "1",
        name: "GEC",
        value: 1,
        tokenType: "alt",
        address: "0xe304283C3e60Cefaf7eA514007Cf4E8fdC3d869d",
        icon: null,
        usdValue: 42.893460000000005,
      },
      {
        id: "42161",
        name: "GOVI",
        value: 1,
        tokenType: "alt",
        address: "0x07e49d5de43dda6162fa28d24d5935c151875283",
        icon: null,
        usdValue: 93.15871519158368,
      },
      {
        id: "42161",
        name: "TAROT",
        value: 1,
        tokenType: "alt",
        address: "0x6688b00f0c23a4a546beaae51a7c90c439895d48",
        icon: null,
        usdValue: 111.31233073662828,
      },
      {
        id: "42161",
        name: "XCAL",
        value: 1,
        tokenType: "alt",
        address: "0xd2568accd10a4c98e87c44e9920360031ad89fcb",
        icon: null,
        usdValue: 19.397198878171192,
      },
      {
        id: "42161",
        name: "GNO",
        value: 1,
        tokenType: "alt",
        address: "0xa0b862f60edef4452f25b4160f177db44deb6cf1",
        icon: null,
        usdValue: 1.5672199628249357,
      },
      {
        id: "42161",
        name: "ZZ",
        value: 1,
        tokenType: "alt",
        address: "0xADA42bb73b42e0472A994218fb3799dFCDA21237",
        icon: null,
        usdValue: 2.1690414804040743,
      },
      {
        id: "8217",
        name: "oBNB",
        value: 1,
        tokenType: "alt",
        address: "0x574e9c26bda8b95d7329505b4657103710eb32ea",
        icon: null,
        usdValue: 12646.292140724943,
      },
      {
        id: "8217",
        name: "oETH",
        value: 1,
        tokenType: "alt",
        address: "0x34d21b1e550d73cee41151c77f3c73359527a396",
        icon: null,
        usdValue: 306.9263350484589,
      },
      {
        id: "8217",
        name: "oUSDT",
        value: 1,
        tokenType: "stable",
        address: "0xcee8faf64bb97a73bb51e115aa89c17ffa8dd167",
        icon: null,
        usdValue: 36825.89102770216,
      },
      {
        id: "8217",
        name: "oXRP",
        value: 1,
        tokenType: "alt",
        address: "0x9eaefb09fe4aabfbe6b1ca316a3c36afc83a393f",
        icon: null,
        usdValue: 436.65559571408403,
      },
      {
        id: "1",
        name: "UNIBOT",
        value: 1,
        tokenType: "alt",
        address: "0xf819d9cb1c2a819fd991781a822de3ca8607c3c9",
        icon: null,
        usdValue: 111.6919902543526,
      },
    ],
    nftHoldings: [
      {
        id: "42161",
        name: "Arbitrum Odyssey NFT",
        address: "0xfAe39eC09730CA0F14262A636D2d7C5539353752",
        value: 296,
      },
      {
        id: "10",
        name: "Uniswap V3 Positions",
        address: "0xC36442b4a4522E871399CD717aBDD847Ab11FE88",
        value: 166,
      },
      {
        id: "10",
        name: "Optimism Quests",
        address: "0xfA14e1157F35E1dAD95dC3F822A9d18c40e360E2",
        value: 130,
      },
      {
        id: "56",
        name: "SPACE ID - .bnb",
        address: "0xe3b1d32e43ce8d658368e2cbff95d57ef39be8a6",
        value: 130,
      },
      {
        id: "10",
        name: "Optimistic Explorer",
        address: "0x81b30ff521D1fEB67EDE32db726D95714eb00637",
        value: 94,
      },
      {
        id: "42161",
        name: "ARB ID Transferable",
        address: "0x08804c13d21da41d2f1d6334b80f3241ca72d2b7",
        value: 86,
      },
      {
        id: "1",
        name: "Art Blocks",
        address: "0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270",
        value: 85,
      },
      {
        id: "42161",
        name: "imTokenArbitrum",
        address: "0x8B81043ac0fE5676b31005b772BEC79d4aa19fE4",
        value: 73,
      },
      {
        id: "1",
        name: "Friendship Bracelets by Alexis André",
        address: "0x942bc2d3e7a589fe5bd4a5c6ef9727dfd82f5c8a",
        value: 40,
      },
      {
        id: "10",
        name: "Early Optimists",
        address: "0x0110Bb5739a6F82eafc748418e572Fc67d854a0F",
        value: 37,
      },
      {
        id: "42161",
        name: "6th Anniversary NFT",
        address: "0xb5E89dc549B070CdD51fc18F1072aE9eC6e7A7C2",
        value: 36,
      },
      {
        id: "42161",
        name: "Government Toucans",
        address: "0x642FfAb2752Df3BCE97083709F36080fb1482c80",
        value: 35,
      },
      {
        id: "1",
        name: "Wassies by Wassies",
        address: "0x1d20a51f088492a0f1c57f047a9e30c9ab5c07ea",
        value: 25,
      },
      {
        id: "42161",
        name: "Aboard Exchange Space Puzzle",
        address: "0xb3963985dE1B174462ddE56418ce7D419caA4c12",
        value: 25,
      },
      {
        id: "1",
        name: "Milady Maker",
        address: "0x5af0d9827e0c53e4799bb226655a1de152a425a5",
        value: 24,
      },
      {
        id: "42161",
        name: "GMX Blueberry Club",
        address: "0x17f4BAa9D35Ee54fFbCb2608e20786473c7aa49f",
        value: 24,
      },
      {
        id: "42161",
        name: "GMX Blueberry Club",
        address: "0x17f4baa9d35ee54ffbcb2608e20786473c7aa49f",
        value: 24,
      },
      {
        id: "1",
        name: "Clone X",
        address: "0x49cf6f5d44e70224e2e23fdcdd2c053f30ada28b",
        value: 21,
      },
      {
        id: "10",
        name: "OP Delegatooors",
        address: "0xac3B9b3f5956b52c448158c0a07DDFA9D5c53a3B",
        value: 21,
      },
      {
        id: "42161",
        name: "imToken & EtherPOAP Community AMA",
        address: "0x65aDFB30E1a712573644D52b9C9629388811ea26",
        value: 21,
      },
      {
        id: "56",
        name: "Lifeform Cartoon AVATAR",
        address: "0x6f282fc910cd6ecdccc9e0f06e6ea3e5602a24d5",
        value: 20,
      },
      {
        id: "56",
        name: "CryptoBlades character",
        address: "0xc6f252c2cdd4087e30608a35c022ce490b58179b",
        value: 20,
      },
      {
        id: "1",
        name: "HV-MTL",
        address: "0x4b15a9c28034dc83db40cd810001427d3bd7163d",
        value: 19,
      },
      {
        id: "137",
        name: "ZED RUN",
        address: "0x67f4732266c7300cca593c814d46bee72e40659f",
        value: 19,
      },
      {
        id: "1",
        name: "Pixelmon",
        address: "0x32973908faee0bf825a343000fe412ebe56f802a",
        value: 19,
      },
      {
        id: "42161",
        name: "Learn and Earn at imToken V",
        address: "0xb07b371Bf4f4634CF816051D2ee741164d4203FC",
        value: 19,
      },
      {
        id: "1",
        name: "MoonCats - Acclimated",
        address: "0xc3f733ca98e0dad0386979eb96fb1722a1a05e69",
        value: 18,
      },
      {
        id: "1",
        name: "Lil Pudgys",
        address: "0x524cab2ec69124574082676e6f654a18df49a048",
        value: 17,
      },
      {
        id: "1",
        name: "Meebits",
        address: "0x7Bd29408f11D2bFC23c34f18275bBf23bB716Bc7",
        value: 17,
      },
      {
        id: "42161",
        name: "imToken & ECN Community AMA",
        address: "0xD7648602bBd6d5287A0588E80D3e2eA1c6caf3AF",
        value: 17,
      },
      {
        id: "10",
        name: "Velodrome",
        address: "0x9c7305eb78a432ced5C4D14Cac27E8Ed569A2e26",
        value: 16,
      },
      {
        id: "1",
        name: "Pudgy Penguins",
        address: "0xBd3531dA5CF5857e7CfAA92426877b022e612cf8",
        value: 15,
      },
      {
        id: "1",
        name: "Otherdeed Expanded",
        address: "0x790b2cf29ed4f310bf7641f013c65d4560d28371",
        value: 15,
      },
      {
        id: "42161",
        name: "Bridgeworld Legions",
        address: "0xfe8c1ac365ba6780aec5a985d989b327c27670a1",
        value: 14,
      },
      {
        id: "1",
        name: "Mutant Ape Yacht Club",
        address: "0x60e4d786628fea6478f785a6d7e704777c86a7c6",
        value: 14,
      },
      {
        id: "42161",
        name: "Battlefly",
        address: "0x0aF85A5624D24E2C6e7Af3c0a0b102a28E36CeA3",
        value: 13,
      },
      {
        id: "1",
        name: "ALTS by adidas",
        address: "0x749f5ddf5ab4c1f26f74560a78300563c34b417d",
        value: 13,
      },
      {
        id: "1",
        name: "FLUF World",
        address: "0xccc441ac31f02cd96c153db6fd5fe0a2f4e6a68d",
        value: 13,
      },
      {
        id: "1",
        name: "Forgotten Runes Wizards Cult",
        address: "0x521f9c7505005cfa19a8e5786a9c3c9c9f5e6f42",
        value: 13,
      },
      {
        id: "1",
        name: "Otherdeed for Otherside",
        address: "0x34d85c9cdeb23fa97cb08333b511ac86e1c4e258",
        value: 13,
      },
      {
        id: "56",
        name: "Polychain Monsters | BNB Chain",
        address: "0x85f0e02cb992aa1f9f47112f815f519ef1a59e2d",
        value: 13,
      },
      {
        id: "1",
        name: "lootprints (for MoonCats)",
        address: "0x1e9385ee28c5c7d33f3472f732fb08ce3cebce1f",
        value: 12,
      },
      {
        id: "42161",
        name: "ArbiPunks",
        address: "0x4772fB92e6606c87f7cDDcCDB880f7677768815c",
        value: 12,
      },
      {
        id: "10",
        name: "Bored Town",
        address: "0x8E56343adAFA62DaC9C9A8ac8c742851B0fb8b03",
        value: 12,
      },
      {
        id: "1",
        name: "Moonbirds",
        address: "0x23581767a106ae21c074b2276d25e5c3e136a68b",
        value: 12,
      },
      {
        id: "1",
        name: "BEANZ Official",
        address: "0x306b1ea3ecdf94ab739f1910bbda052ed4a9f949",
        value: 12,
      },
      {
        id: "1",
        name: "Ready Player Cat",
        address: "0xcdb7c1a6fe7e112210ca548c214f656763e13533",
        value: 11,
      },
      {
        id: "10",
        name: "OptiPunks",
        address: "0xB8Df6Cc3050cC02F967Db1eE48330bA23276A492",
        value: 11,
      },
      {
        id: "1",
        name: "Azuki",
        address: "0xed5af388653567af2f388e6224dc7c4b3241c544",
        value: 11,
      },
      {
        id: "42161",
        name: "Bored Buddies Quest",
        address: "0x933Bf22534EF7deFF2721B36718eBbdCd387abDa",
        value: 11,
      },
      {
        id: "42161",
        name: "dGenesis Prime",
        address: "0xdaA9Ef8C2f3643CE62dA0EE4C8d25b91a639909e",
        value: 10,
      },
      {
        id: "10",
        name: "Optimistic Bunnies",
        address: "0x52782699900DF91B58eCD618e77847C5774dCD2e",
        value: 10,
      },
      {
        id: "137",
        name: "Crypto Unicorns",
        address: "0xdc0479cc5bba033b3e7de9f178607150b3abce1f",
        value: 10,
      },
      {
        id: "1",
        name: "DeGods",
        address: "0x8821bee2ba0df28761afff119d66390d594cd280",
        value: 10,
      },
      {
        id: "1",
        name: "Otherside Vessel",
        address: "0x5b1085136a811e55b2bb2ca1ea456ba82126a376",
        value: 10,
      },
      {
        id: "1",
        name: "Cool Cats",
        address: "0x1a92f7381b9f03921564a437210bb9396471050c",
        value: 9,
      },
      {
        id: "1",
        name: "Opepen Edition",
        address: "0x6339e5e072086621540d0362c4e3cea0d643e114",
        value: 9,
      },
      {
        id: "1",
        name: "CryptoPunks",
        address: "0xb47e3cd837dDF8e4c57F05d70Ab865de6e193BBB",
        value: 9,
      },
      {
        id: "42161",
        name: "ArbiDudes",
        address: "0x1ac7A2fC7f66fA4edf2713A88CD4Bad24220c86C",
        value: 9,
      },
      {
        id: "56",
        name: "Thetan Hero",
        address: "0x98eb46cbf76b19824105dfbcfa80ea8ed020c6f4",
        value: 9,
      },
      {
        id: "5000",
        name: "Pandra: PixelProwler",
        address: "0xcf995797cb2e65cc290e084f0127b1e8ebc692c8",
        value: 9,
      },
      {
        id: "1",
        name: "Bored Ape Yacht Club",
        address: "0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d",
        value: 9,
      },
      {
        id: "10",
        name: "Optimistic Apes",
        address: "0x4d40396b4Eb19Be0C1cE1B9544608068bDF6b0fC",
        value: 8,
      },
      {
        id: "1",
        name: "Decentraland",
        address: "0xF87E31492Faf9A91B02Ee0dEAAd50d51d56D5d4d",
        value: 8,
      },
      {
        id: "10",
        name: "OptiChads 🔴✨💪",
        address: "0x9B9F542456ad12796cCB8EB6644f29E3314e68e1",
        value: 8,
      },
      {
        id: "1",
        name: "Kanpai Pandas",
        address: "0xaCF63E56fd08970b43401492a02F6F38B6635C91",
        value: 8,
      },
      {
        id: "1",
        name: "RTFKT Animus Egg 🥚",
        address: "0x6c410cF0B8c113Dc6A7641b431390B11d5515082",
        value: 8,
      },
      {
        id: "10",
        name: "Layer2DAO Early Adopter - Level 3",
        address: "0xC5B00Eff93C8F96C73De8035F896Eca67255f465",
        value: 8,
      },
      {
        id: "42161",
        name: "Cryptids",
        address: "0x5A39174e7F2B669a51Ec179eF49b3eca7ddB96AB",
        value: 8,
      },
      {
        id: "5000",
        name: "Pandra: CodeConqueror",
        address: "0x03ddc4b60d6bbf399a8397d73462060fdfb83476",
        value: 8,
      },
      {
        id: "1",
        name: "0xca7ca7bcc765f77339be2d648ba53ce9c8a262bd",
        address: "0xca7ca7bcc765f77339be2d648ba53ce9c8a262bd",
        value: 7,
      },
      {
        id: "1",
        name: "Captainz",
        address: "0x769272677fab02575e84945f03eca517acc544cc",
        value: 7,
      },
      {
        id: "1",
        name: "Redacted Remilio Babies",
        address: "0xd3d9ddd0cf0a5f0bfb8f7fceae075df687eaebab",
        value: 7,
      },
      {
        id: "10",
        name: "Layer2DAO Early Adopter - Level 1",
        address: "0xF804D537c2530C79453C1cDBdd728a68F340CD9f",
        value: 7,
      },
      {
        id: "42161",
        name: "Mycelium OGs Arbitrum",
        address: "0xcf72978cF3f17a6194A394888A1d7a4E6EfFa405",
        value: 7,
      },
      {
        id: "1",
        name: "Otherside Koda",
        address: "0xe012baf811cf9c05c408e879c399960d1f305903",
        value: 7,
      },
      {
        id: "42161",
        name: "Robonaut",
        address: "0x2a4730B0Bd1Bb9E06F365C15403Fa264119d9a51",
        value: 7,
      },
      {
        id: "56",
        name: "Bomber Hero V3",
        address: "0x30cc0553f6fa1faf6d7847891b9b36eb559dc618",
        value: 7,
      },
      {
        id: "1",
        name: "Bored Ape Kennel Club",
        address: "0xba30e5f9bb24caa003e9f2f0497ad287fdf95623",
        value: 7,
      },
      {
        id: "1",
        name: "Nakamigos",
        address: "0xd774557b647330c91bf44cfeab205095f7e6c367",
        value: 6,
      },
      {
        id: "1",
        name: "0N1 Force",
        address: "0x3bf2922f4520a8ba0c2efc3d2a1539678dad5e9d",
        value: 6,
      },
      {
        id: "1",
        name: "rektguy",
        address: "0xB852c6b5892256C264Cc2C888eA462189154D8d7",
        value: 6,
      },
      {
        id: "137",
        name: "Trump Digital Trading Cards",
        address: "0x24a11e702cd90f034ea44faf1e180c0c654ac5d9",
        value: 6,
      },
      {
        id: "1",
        name: "mfers",
        address: "0x79fcdef22feed20eddacbb2587640e45491b757f",
        value: 6,
      },
      {
        id: "1",
        name: "Marcolian Bannerman [SE]",
        address: "0x76be3b62873462d2142405439777e971754e8e77",
        value: 6,
      },
      {
        id: "137",
        name: "Trump Digital Trading Cards Series 2",
        address: "0xe28d2d8746d855251ba677a91626009cb33aa4f9",
        value: 6,
      },
      {
        id: "1",
        name: "Terraforms by Mathcastles",
        address: "0x4e1f41613c9084fdb9e34e11fae9412427480e56",
        value: 6,
      },
      {
        id: "42161",
        name: "NovaNauts",
        address: "0xf5c4753A716F8B9f2a817f5c376eF2c29601639C",
        value: 6,
      },
      {
        id: "5000",
        name: "MantleNFT",
        address: "0x7cf4ac414c94e03ecb2a7d6ea8f79087453caef0",
        value: 6,
      },
      {
        id: "1",
        name: "Fewman",
        address: "0xad5f6cdda157694439ef9f6dd409424321c74628",
        value: 5,
      },
      {
        id: "56",
        name: "DODO Minions",
        address: "0x0d566fa989f601e3b5ab50330a14c1dcae7b5cb2",
        value: 5,
      },
      {
        id: "1",
        name: "CryptoPunks V1 (wrapped)",
        address: "0x282bdd42f4eb70e7a9d9f40c8fea0825b7f68c5d",
        value: 5,
      },
      {
        id: "42161",
        name: "Deri Festival on Arbitrum",
        address: "0x55FD6E7665617321C6b66c3D0279F8132adA527F",
        value: 5,
      },
      {
        id: "1",
        name: "Kubz",
        address: "0xEb2dFC54EbaFcA8F50eFcc1e21A9D100b5AEb349",
        value: 5,
      },
      {
        id: "42161",
        name: "Arbi Odyssey Penguins",
        address: "0xFCf6bEf0579D4e6Da537B8154fa3b28102a574ab",
        value: 5,
      },
      {
        id: "42161",
        name: "Smol Brain",
        address: "0x6325439389e0797ab35752b4f43a14c004f22a9c",
        value: 5,
      },
      {
        id: "42161",
        name: "Galactic Gan Quest",
        address: "0xA4A3458a76e42795106B74d10fA2648B39074385",
        value: 5,
      },
      {
        id: "1",
        name: "Doodles",
        address: "0x8a90cab2b38dba80c64b7734e58ee1db38b8992e",
        value: 5,
      },
      {
        id: "1",
        name: "CryptoDickbutts",
        address: "0x42069abfe407c60cf4ae4112bedead391dba1cdb",
        value: 5,
      },
      {
        id: "10",
        name: "CryptoTesters",
        address: "0x18a1bC18cEfdc952121F319039502FDD5f48B6fF",
        value: 5,
      },
      {
        id: "1",
        name: "Ultiverse - Electric Sheep",
        address: "0x3fD36d72f05fb1AF76EE7Ce9257ca850fAbA91ed",
        value: 5,
      },
      {
        id: "1",
        name: "CrypToadz",
        address: "0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6",
        value: 5,
      },
      {
        id: "10",
        name: "Layer2DAO Early Adopter - Level 2",
        address: "0x4fe576AA37B9858378425Ea981b8D1804A6367Ce",
        value: 5,
      },
      {
        id: "56",
        name: "Heroes & Empires Heroes",
        address: "0x4cd0ce1d5e10afbcaa565a0fe2a810ef0eb9b7e2",
        value: 5,
      },
      {
        id: "1",
        name: "VeeFriends Series 2",
        address: "0x9378368ba6b85c1fba5b131b530f5f5bedf21a18",
        value: 5,
      },
      {
        id: "10",
        name: "ETHEREA",
        address: "0x07193aC9ec2D35E24C6501e0966e5eF265400948",
        value: 5,
      },
      {
        id: "42161",
        name: "GIVnaut by GiveStation",
        address: "0xdf33ae70b6ec9dd3873d5f221c8786b0c1597ce8",
        value: 5,
      },
      {
        id: "5000",
        name: "Pandra: MelodyMaven",
        address: "0xe09828f0da805523878be66ea2a70240d312001e",
        value: 5,
      },
      {
        id: "1",
        name: "PROOF Collective",
        address: "0x08d7c0242953446436f34b4c78fe9da38c73668d",
        value: 5,
      },
      {
        id: "42161",
        name: "Realm",
        address: "0x4de95c1E202102E22E801590C51D7B979f167FBB",
        value: 4,
      },
      {
        id: "1",
        name: "Zappy",
        address: "0xfaff15c6cdaca61a4f87d329689293e07c98f578",
        value: 4,
      },
      {
        id: "1",
        name: "One Day I'll Be A Punk",
        address: "0x5537d90a4a2dc9d9b37bab49b490cf67d4c54e91",
        value: 4,
      },
      {
        id: "42161",
        name: "ArbiSocks",
        address: "0xdf8ac21a9c82b2e6d1e82207c918bc3b8e424e62",
        value: 4,
      },
      {
        id: "10",
        name: "Layer2DAO Early Adopter - Level 4",
        address: "0x65eecBf5E5BC6b1bdAf28Ab28A650e8c34d7ba04",
        value: 4,
      },
      {
        id: "1",
        name: "Chromie Squiggle by Snowfro",
        address: "0x059edd72cd353df5106d2b9cc5ab83a52287ac3a",
        value: 4,
      },
      {
        id: "10",
        name: "SpaceHook",
        address: "0xb752dfFA1d8Fbb107cde9aa6dBB511a89A7CFf49",
        value: 4,
      },
      {
        id: "10",
        name: "Hook Explorer Badge",
        address: "0xE70ab5DBe405723A31C7Aed81d93Ff0b14230913",
        value: 4,
      },
      {
        id: "1",
        name: "BLACK BOX - Series One",
        address: "0x236672ed575e1e479b8e101aeeb920f32361f6f9",
        value: 4,
      },
      {
        id: "42161",
        name: "DefiHeroes",
        address: "0x8Ec75Bc963181489D7fc1d892f687b8B0987d9eC",
        value: 4,
      },
      {
        id: "1",
        name: "FusionApes",
        address: "0xea6504ba9ec2352133e6a194bb35ad4b1a3b68e7",
        value: 4,
      },
      {
        id: "10",
        name: ".L2 (Layer2DAO + Punk Domains)",
        address: "0x9A7657d1593032C75d70950707870c3cC7ca45DC",
        value: 4,
      },
      {
        id: "10",
        name: "Ape Warrior Redux",
        address: "0x7bEE9cDBcE02d3640c2DEE4135fC93c0543DFE08",
        value: 4,
      },
      {
        id: "10",
        name: "Words  (viaMirror)",
        address: "0xa698713a3bc386970Cdc95A720B5754cC0f96931",
        value: 4,
      },
      {
        id: "42161",
        name: "Holograph x LayerZero 188719626670054478562669105609137414715460010957784007367725271895131",
        address: "0x2c4bd4e25d83285f417e26a44069f41d1a8ad0e7",
        value: 4,
      },
      {
        id: "56",
        name: "Mobox Avatar - Binance NFT",
        address: "0x24fadcefd2117719c4078c08b352b22c74542418",
        value: 4,
      },
      {
        id: "5000",
        name: "Mantle Cowboy",
        address: "0xa7236ac4ae735bcad76e3d56d07d929a9be865f6",
        value: 4,
      },
      {
        id: "1",
        name: "RENGA",
        address: "0x394e3d3044fc89fcdd966d3cb35ac0b32b0cda91",
        value: 4,
      },
      {
        id: "1",
        name: "Stash",
        address: "0xff796cbbe32b2150a4585a3791cadb213d0f35a3",
        value: 3,
      },
      {
        id: "1",
        name: "Don't Rug Me (DRM) - The Best Crypto CCG Game",
        address: "0x44d6e8933f8271abcf253c72f9ed7e0e4c0323b3",
        value: 3,
      },
      {
        id: "1",
        name: "FirstGM",
        address: "0x33fd426905f149f8376e227d0c9d3340aad17af1",
        value: 3,
      },
      {
        id: "1",
        name: "0x74ee68a33f6c9f113e22b3b77418b75f85d07d22",
        address: "0x74ee68a33f6c9f113e22b3b77418b75f85d07d22",
        value: 3,
      },
      {
        id: "1",
        name: "mirage",
        address: "0x94edd64585015a3bb06c6061a70fb63ef4bc3cef",
        value: 3,
      },
      {
        id: "1",
        name: "To Ethereum, with Love",
        address: "0x2bd938cf96430b7b0879f76b010b589aeec2127c",
        value: 3,
      },
      {
        id: "1",
        name: "Map",
        address: "0x511372b44231a31527025a3d273c1dc0a83d77af",
        value: 3,
      },
      {
        id: "1",
        name: "Sablier V2 Lockup Linear",
        address: "0xafb979d9afad1ad27c5eff4e27226e3ab9e5dcc9",
        value: 3,
      },
      {
        id: "1",
        name: "Base, Introduced 469278",
        address: "0xd4307e0acd12cf46fd6cf93bc264f5d5d1598792",
        value: 3,
      },
      {
        id: "1",
        name: "Gemesis",
        address: "0xbe9371326f91345777b04394448c23e2bfeaa826",
        value: 3,
      },
      {
        id: "1",
        name: "ARGUS GENESIS ◢ ✦ ◣ 19891",
        address: "0x9d7987d74c0b3ca8e8472f90c713c456dd656be8",
        value: 3,
      },
      {
        id: "1",
        name: "World of Women",
        address: "0xe785e82358879f061bc3dcac6f0444462d4b5330",
        value: 3,
      },
      {
        id: "42161",
        name: "Traversing the Lavender Sea",
        address: "0xfae39ec09730ca0f14262a636d2d7c5539353752",
        value: 3,
      },
      {
        id: "56",
        name: "MyNeighborAlice Land",
        address: "0xe218144c228863b03ccf85d120fd5b71bf97f3f4",
        value: 3,
      },
      {
        id: "10",
        name: "OptiNouns",
        address: "0x43b91b168D210F722f2896d258c2c236B9CeBB7b",
        value: 3,
      },
      {
        id: "1",
        name: "Keungz Genesis",
        address: "0x76Cc4742f7Eaa89a93576505dec37C2C66a76AB7",
        value: 3,
      },
      {
        id: "137",
        name: "y00ts",
        address: "0x670fd103b1a08628e9557cD66B87DeD841115190",
        value: 3,
      },
      {
        id: "1",
        name: "CyberKongz",
        address: "0x57a204aa1042f6e66dd7730813f4024114d74f37",
        value: 3,
      },
      {
        id: "1",
        name: "Deafbeef",
        address: "0xd754937672300ae6708a51229112de4017810934",
        value: 3,
      },
      {
        id: "137",
        name: "Cometh Spaceships",
        address: "0x85bc2e8aaad5dbc347db49ea45d95486279ed918",
        value: 3,
      },
      {
        id: "1",
        name: "The Currency",
        address: "0xaadc2d4261199ce24a4b0a57370c4fcf43bb60aa",
        value: 3,
      },
      {
        id: "1",
        name: "Wrapped Cryptopunks",
        address: "0xb7f7f6c52f2e2fdb1963eab30438024864c313f6",
        value: 3,
      },
      {
        id: "137",
        name: "PolygonPunks",
        address: "0x9498274b8c82b4a3127d67839f2127f2ae9753f4",
        value: 3,
      },
      {
        id: "56",
        name: "MetaWarden",
        address: "0xa5fdb0822bf82de3315f1766574547115e99016f",
        value: 3,
      },
      {
        id: "1",
        name: "10b57e6",
        address: "0x026224a2940bfe258d0dbe947919b62fe321f042",
        value: 3,
      },
      {
        id: "1",
        name: "Webaverse Genesis Pass",
        address: "0x543d43f390b7d681513045e8a85707438c463d80",
        value: 3,
      },
      {
        id: "1",
        name: "TIME Cats Love 'em! Hate 'em! - December 7th, 1981",
        address: "0x7581f8e289f00591818f6c467939da7f9ab5a777",
        value: 3,
      },
      {
        id: "1",
        name: "Bear",
        address: "0x2d097c1535988216499722df726617a3607b0f08",
        value: 3,
      },
      {
        id: "1",
        name: "MVIP Mineral",
        address: "0x09522f2ed48591af2c8df667d0152d223746c840",
        value: 3,
      },
      {
        id: "1",
        name: "COMIC",
        address: "0xbc8542e65ab801f7c9e3edd23238d37a2e3972d6",
        value: 3,
      },
      {
        id: "1",
        name: "Bushido",
        address: "0xd2aad45015090f8d45ad78e456b58dd61fb7cd79",
        value: 3,
      },
      {
        id: "1",
        name: "8Bit",
        address: "0xaae71bbbaa359be0d81d5cbc9b1e88a8b7c58a94",
        value: 3,
      },
      {
        id: "1",
        name: "Tie Dye Ninja",
        address: "0x5ec2642b5c9fb3c78ff39dcca37e277ed1695ff0",
        value: 3,
      },
      {
        id: "10",
        name: "motorheadz",
        address: "0x5c9D55b78FEBCC2061715BA4f57EcF8EA2711F2c",
        value: 3,
      },
      {
        id: "1",
        name: "X7 Pioneer",
        address: "0x70000299Ee8910cCaCD97B1bB560E34F49c9e4f7",
        value: 3,
      },
      {
        id: "1",
        name: "BitMate",
        address: "0xf8c18df7509c03b45e6247b2b9e73fcadef24dd6",
        value: 3,
      },
      {
        id: "1",
        name: "Mojimon",
        address: "0x15f7c142161469a58dc81339e4655d3dcb559d25",
        value: 3,
      },
      {
        id: "1",
        name: "CashmereLabs Testnet Early Adopter 10423",
        address: "0x3a40312a1c376aecf855ef784371d1fb1aa2d25d",
        value: 3,
      },
      {
        id: "1",
        name: "Sismo DAO - Gen[0] Ziki Membership",
        address: "0x10a9d6417f5289d2e5ccde29ad5a35cfc5c543f1",
        value: 3,
      },
      {
        id: "1",
        name: "!fundrop pass",
        address: "0x0000000000664ceffed39244a8312bd895470803",
        value: 3,
      },
      {
        id: "1",
        name: "My Pet Hooligan",
        address: "0x09233d553058c2f42ba751c87816a8e9fae7ef10",
        value: 3,
      },
      {
        id: "1",
        name: "Sappy Seals",
        address: "0x364C828eE171616a39897688A831c2499aD972ec",
        value: 3,
      },
      {
        id: "10",
        name: "Merge Bears",
        address: "0x63D29F9c28Ce781DacB284A99b1239A25E3e2159",
        value: 3,
      },
      {
        id: "42161",
        name: "Arbinauts Quest",
        address: "0xDFaA5A0FdD7a32F5E666EF68a3236f9cED036148",
        value: 3,
      },
      {
        id: "56",
        name: "Era7 NFT",
        address: "0x07d971c03553011a48e951a53f48632d37652ba1",
        value: 3,
      },
      {
        id: "56",
        name: "MoonPets BNB",
        address: "0xe32ae22ec60e21980247b4bdaa16e9aea265f919",
        value: 3,
      },
      {
        id: "10",
        name: "Optimism Ape Yacht Club",
        address: "0x0deaac29d8a3d4ebbaaa3ecd3cc97c9def00f720",
        value: 3,
      },
      {
        id: "10",
        name: "Oliens",
        address: "0x69a68eb548A37ee475D9f89646945588558796D1",
        value: 3,
      },
      {
        id: "56",
        name: "Zecrey Chameleon Avatar",
        address: "0x8c6be54dcca5eed3390b37c9d8ef9eb0358ac3a8",
        value: 3,
      },
      {
        id: "169",
        name: "Manta Girls",
        address: "0x3c19784f5247ca471e27ea1c604b48d266eb000c",
        value: 3,
      },
      {
        id: "10",
        name: "Burnt Ape",
        address: "0xc7a144C247DD503acF87B2dc65AFF3De3C10e3d1",
        value: 3,
      },
      {
        id: "5000",
        name: "Star Voyager Medal",
        address: "0xafc7649b722adb34463576a15eeb08bc0d692b4a",
        value: 3,
      },
      {
        id: "1",
        name: "Invisible Friends",
        address: "0x59468516a8259058bad1ca5f8f4bff190d30e066",
        value: 3,
      },
      {
        id: "1",
        name: "VeeFriends",
        address: "0xa3aee8bce55beea1951ef834b99f3ac60d1abeeb",
        value: 3,
      },
      {
        id: "1",
        name: "Dragons of Wonderquest",
        address: "0x08bebeb5f042ccbaeb128582da560cb25a5db7e9",
        value: 2,
      },
      {
        id: "1",
        name: "0xed595cfd58d32bb9d200aab5b9afd9dbdebdf9f4",
        address: "0xed595cfd58d32bb9d200aab5b9afd9dbdebdf9f4",
        value: 2,
      },
      {
        id: "1",
        name: "RPC OG - GIRL",
        address: "0x20178cd7721fdfc1fda815dd03acc809b82e9e40",
        value: 2,
      },
      {
        id: "1",
        name: "The Front",
        address: "0x6fad73936527d2a82aea5384d252462941b44042",
        value: 2,
      },
      {
        id: "1",
        name: "Noob Cannon",
        address: "0xd8cd8cb7f468ef175bc01c48497d3f7fa27b4653",
        value: 2,
      },
      {
        id: "1",
        name: "Blank Combat Helmet",
        address: "0x7daec605e9e2a1717326eedfd660601e2753a057",
        value: 2,
      },
      {
        id: "1",
        name: "Uniswap Unicorn",
        address: "0xf1f3ca6268f330fda08418db12171c3173ee39c9",
        value: 2,
      },
      {
        id: "1",
        name: "PunkScape",
        address: "0x51ae5e2533854495f6c587865af64119db8f59b4",
        value: 2,
      },
      {
        id: "1",
        name: "Genesis Egg",
        address: "0x9c008a22d71b6182029b694b0311486e4c0e53db",
        value: 2,
      },
      {
        id: "1",
        name: "0x1afef6b252cc35ec061efe6a9676c90915a73f18",
        address: "0x1afef6b252cc35ec061efe6a9676c90915a73f18",
        value: 2,
      },
      {
        id: "1",
        name: "0x575ec01a9e70bf3e192a774eb265c46ec993e4cc",
        address: "0x575ec01a9e70bf3e192a774eb265c46ec993e4cc",
        value: 2,
      },
      {
        id: "1",
        name: "Dream of Winter",
        address: "0x135511599d8d78e4e5d2ed7e224b54d80ff97309",
        value: 2,
      },
      {
        id: "1",
        name: "0x9237...cb1c",
        address: "0xe18a32192ed95b0fe9d70d19e5025f103475d7ba",
        value: 2,
      },
      {
        id: "1",
        name: "0xe51aac67b09eaed6d3d43e794d6bae679cbe09d8",
        address: "0xe51aac67b09eaed6d3d43e794d6bae679cbe09d8",
        value: 2,
      },
      {
        id: "1",
        name: "Unicorn GURU SeasonPass",
        address: "0xbe223020724cc3e2999f5dceda3120484fdbfef7",
        value: 2,
      },
      {
        id: "1",
        name: "CREYZIE",
        address: "0x19bb64b80cbf61e61965b0e5c2560cc7364c6546",
        value: 2,
      },
      {
        id: "1",
        name: "HyperLoot",
        address: "0x0290d49f53a8d186973b82faafdafe696b29acbb",
        value: 2,
      },
      {
        id: "1",
        name: "Palette",
        address: "0x1308c158e60d7c4565e369df2a86ebd853eef2fb",
        value: 2,
      },
      {
        id: "1",
        name: "0x932261f9fc8da46c4a22e31b45c4de60623848bf",
        address: "0x932261f9fc8da46c4a22e31b45c4de60623848bf",
        value: 2,
      },
      {
        id: "1",
        name: "Censored",
        address: "0xda22422592ee3623c8d3c40fe0059cdecf30ca79",
        value: 2,
      },
      {
        id: "1",
        name: "Zorb",
        address: "0xca21d4228cdcc68d4e23807e5e370c07577dd152",
        value: 2,
      },
      {
        id: "1",
        name: "akma",
        address: "0xc53dc593b69c67a209cf70d4172078c9125449bb",
        value: 2,
      },
      {
        id: "1",
        name: "Scape",
        address: "0xb7def63a9040ad5dc431aff79045617922f4023a",
        value: 2,
      },
      {
        id: "42161",
        name: "Rainbow Smol 20050",
        address: "0xa1e417c09211b9ec12ea25f97429d0772749bbf2",
        value: 2,
      },
      {
        id: "1",
        name: "DigiDaigaku",
        address: "0xd1258DB6Ac08eB0e625B75b371C023dA478E94A9",
        value: 2,
      },
      {
        id: "1",
        name: "a KID called BEAST",
        address: "0x77372a4cc66063575b05b44481f059be356964a4",
        value: 2,
      },
      {
        id: "10",
        name: "NerdApeDAONFT",
        address: "0x824BB1f0438A38Ea424e19171eF6665A4bCCe3A5",
        value: 2,
      },
      {
        id: "1",
        name: "Blitmap",
        address: "0x8d04a8c79ceb0889bdd12acdf3fa9d207ed3ff63",
        value: 2,
      },
      {
        id: "10",
        name: "L2StateOfMind",
        address: "0x66Deb6cC4d65dc9CB02875DC5E8751d71Fa5D50E",
        value: 2,
      },
      {
        id: "42161",
        name: "Sassy Walrus",
        address: "0xff3010e3355B592bdB0642F9c4e9BF41a011AFe5",
        value: 2,
      },
      {
        id: "56",
        name: "Catgirl NFT",
        address: "0xe796f4b5253a4b3edb4bb3f054c03f147122bacd",
        value: 2,
      },
      {
        id: "1",
        name: "Ace of Clubs",
        address: "0xc22616e971a670e72f35570337e562c3e515fbfe",
        value: 2,
      },
      {
        id: "1",
        name: "Lost Glitch",
        address: "0x8460bb8eb1251a923a31486af9567e500fc2f43f",
        value: 2,
      },
      {
        id: "1",
        name: "Truchet Styles",
        address: "0x6fd38882861a9610c718146d6bbccbefe9a4ce34",
        value: 2,
      },
      {
        id: "10",
        name: "Town Hall",
        address: "0x81b30ff521d1feb67ede32db726d95714eb00637",
        value: 2,
      },
      {
        id: "1",
        name: "Josie",
        address: "0xecf7ef42b57ee37a959bf507183c5dd6bf182081",
        value: 2,
      },
      {
        id: "1",
        name: "Simulation",
        address: "0xd5a73977e6effc252a7f1af4548ba11ff7187616",
        value: 2,
      },
      {
        id: "1",
        name: "PDII Core Pack Reservation",
        address: "0x38398a2d7a4278b8d83967e0d235164335a0394a",
        value: 2,
      },
      {
        id: "1",
        name: "Hopium",
        address: "0x4db52a61dc491e15a2f78f5ac001c14ffe3568cb",
        value: 2,
      },
      {
        id: "1",
        name: "Lobby Lobster",
        address: "0xc0cb81c1f89ab0873653f67eea42652f13cd8416",
        value: 2,
      },
      {
        id: "1",
        name: "Wassie Nuts",
        address: "0x63578ca1be3ab8e75d88854485e8c23b41d87b16",
        value: 2,
      },
      {
        id: "1",
        name: "796",
        address: "0xf729f878f95548bc7f14b127c96089cf121505f8",
        value: 2,
      },
      {
        id: "56",
        name: "MathVerse Land",
        address: "0x76681358854eb302e4f3cbdcaf6a7d4ecba65576",
        value: 2,
      },
      {
        id: "1",
        name: "GEN.ART Membership",
        address: "0x1ca39c7f0f65b4da24b094a9afac7acf626b7f38",
        value: 2,
      },
      {
        id: "1",
        name: "0x18c7766a10df15df8c971f6e8c1d2bba7c7a410b",
        address: "0x18c7766a10df15df8c971f6e8c1d2bba7c7a410b",
        value: 2,
      },
      {
        id: "1",
        name: "The Axie Infinity Card  – №29",
        address: "0x729cd6226751279030757f61b2cac4798c949fa1",
        value: 2,
      },
      {
        id: "1",
        name: "3445",
        address: "0x772c9181b0596229ce5ba898772ce45188284379",
        value: 2,
      },
      {
        id: "1",
        name: "Dissolution Drop Pod",
        address: "0xfaafdc07907ff5120a76b34b731b278c38d6043c",
        value: 2,
      },
      {
        id: "1",
        name: "Dream Machine",
        address: "0x4e2781e3ad94b2dfcf34c51de0d8e9358c69f296",
        value: 2,
      },
      {
        id: "1",
        name: "Genzee",
        address: "0x201675fbfaaac3a51371e4c31ff73ac14cee2a5a",
        value: 2,
      },
      {
        id: "1",
        name: "KektitanX: DAO space ship by KEK industries. First Moon Mission Ver. (Pocket Edition)",
        address: "0x74f1334e210bbd0ae2555ec212019cd77a6a36ff",
        value: 2,
      },
      {
        id: "1",
        name: "Fuxi",
        address: "0x22f26d7b074391c483a9952ef2e2b8f6b208d897",
        value: 2,
      },
      {
        id: "1",
        name: "/RUG COINS/",
        address: "0x280afd45d12103fed9effb9e8b045e5aaca0a97b",
        value: 2,
      },
      {
        id: "1",
        name: "lil",
        address: "0x8e0f07454850198f089ef10d083601a2a1644656",
        value: 2,
      },
      {
        id: "1",
        name: "The Winklevoss Twins Create Their Own Bitcoin",
        address: "0xacd42c32ca13b1d5d3292a97363498b20e8768b8",
        value: 2,
      },
      {
        id: "1",
        name: "NFT2040: PepeFrag",
        address: "0x792e792c61d8f2787a5c848e5465b76bbe282e49",
        value: 2,
      },
      {
        id: "1",
        name: "SneakerHeadz",
        address: "0x197fc873b3e498b7ca8fac410f466515ceec600b",
        value: 2,
      },
      {
        id: "1",
        name: "Simp Mermaid",
        address: "0x4ec18a357766bd7a5f35f0c47ea93136ff21e6a6",
        value: 2,
      },
      {
        id: "1",
        name: "0xVampire",
        address: "0xc9e2c9718ff7d3129b9ac12168195507e4275cea",
        value: 2,
      },
      {
        id: "1",
        name: "21 Lines",
        address: "0x0e8f7b4e4319c3506ae1c6f1d04375ddeb0374a3",
        value: 2,
      },
      {
        id: "1",
        name: "HatchDraco",
        address: "0xe453684ea037bac8268b336841711a0d9ec10581",
        value: 2,
      },
      {
        id: "1",
        name: "COVIDBot",
        address: "0x9525c4fe14addba627db8e45036767895181e559",
        value: 2,
      },
      {
        id: "1",
        name: "1700",
        address: "0x3de58785e9d021e9b2f3713717730b365309aa89",
        value: 2,
      },
      {
        id: "1",
        name: "Condom",
        address: "0xd126e02cf8b4559027f467ed5ab697e78c4ec569",
        value: 2,
      },
      {
        id: "1",
        name: "Person",
        address: "0x4335541d17f6344c29f2412e520ed71639150ead",
        value: 2,
      },
      {
        id: "1",
        name: "Time Variants",
        address: "0xb95e7a78764fefe89d9795c7641f6136278b7c28",
        value: 2,
      },
      {
        id: "1",
        name: "White Rabbit One",
        address: "0xf846261b048e0bbe815fa8d26d621090e70a2f3c",
        value: 2,
      },
      {
        id: "1",
        name: "United States",
        address: "0xd224b0eaf5b5799ca46d9fdb89a2c10941e66109",
        value: 2,
      },
      {
        id: "1",
        name: "0xc196ae96170c58eb7b78c917298064ce7192f046",
        address: "0xc196ae96170c58eb7b78c917298064ce7192f046",
        value: 2,
      },
      {
        id: "1",
        name: "Sad Girl",
        address: "0x335eeef8e93a7a757d9e7912044d9cd264e2b2d8",
        value: 2,
      },
      {
        id: "1",
        name: "gm",
        address: "0x355ab8d97eafe30d7063d62befe192a0c88fe424",
        value: 2,
      },
      {
        id: "1",
        name: "0xc49cd62d0a38bb06b72087e2ba889ae36ef1c873",
        address: "0xc49cd62d0a38bb06b72087e2ba889ae36ef1c873",
        value: 2,
      },
      {
        id: "1",
        name: "disgusted wrathful key",
        address: "0x7645eec8bb51862a5aa855c40971b2877dae81af",
        value: 2,
      },
      {
        id: "1",
        name: "Genesis Blocks",
        address: "0x26b925eef82525f514c0414db5cf65953d30a4ca",
        value: 2,
      },
      {
        id: "1",
        name: "Clines",
        address: "0xbbfb6e466f376e493da35b5665dbfc19f7204231",
        value: 2,
      },
      {
        id: "1",
        name: "Clever Girl 4404",
        address: "0xc29b546b57bda23a83e4537eb6096fab30a54ea5",
        value: 2,
      },
      {
        id: "1",
        name: "Genesis",
        address: "0x391f64a5a9af0ed15c95fd17c33fe6de81986c47",
        value: 2,
      },
      {
        id: "1",
        name: "On-Ramp to Abundance",
        address: "0x3a7011e7e2b32c2b52f7de1294ff35d6ff20310f",
        value: 2,
      },
      {
        id: "1",
        name: "0x4be3223f8708ca6b30d1e8b8926cf281ec83e770",
        address: "0x4be3223f8708ca6b30d1e8b8926cf281ec83e770",
        value: 2,
      },
      {
        id: "1",
        name: "Poet",
        address: "0x4b3406a41399c7fd2ba65cbc93697ad9e7ea61e5",
        value: 2,
      },
      {
        id: "1",
        name: "Storyverse Founders Pass",
        address: "0x8f1bc587ff2d87cfc0c5db69a04d094c523008d4",
        value: 2,
      },
      {
        id: "1",
        name: "Villa Devendome Paris ELK",
        address: "0xd433a216266d998c557441ce722c13307be3597f",
        value: 2,
      },
      {
        id: "42161",
        name: "Volmex NFT",
        address: "0x522810e92BFB808FEF392650fEEb2Cc33cE52815",
        value: 2,
      },
      {
        id: "10",
        name: "Steampunk Foxes",
        address: "0x6f0F15A58363E076a671B4d4165Cd3e53E507B83",
        value: 2,
      },
      {
        id: "1",
        name: "Quantum Pass",
        address: "0x495b01c1bc3b9203fde4362d9913c692fb661f3f",
        value: 2,
      },
      {
        id: "1",
        name: "Mystery land",
        address: "0x3f3915fb8769ee456035331bc2f7fbe380f6b4d2",
        value: 2,
      },
      {
        id: "1",
        name: "OG:Crystal 8923",
        address: "0x368ad4a7a7f49b8fa8f34476be0fc4d04ce622f5",
        value: 2,
      },
      {
        id: "1",
        name: "Space Capsule",
        address: "0xeafa25e962ee875f75fdc97e152d39bb4c8978ae",
        value: 2,
      },
      {
        id: "1",
        name: "0x4613becf8acb9e5adc4db994c2007769f37d3504",
        address: "0x4613becf8acb9e5adc4db994c2007769f37d3504",
        value: 2,
      },
      {
        id: "1",
        name: "To The Moon and Farther",
        address: "0x1522c79d2044bbc06f4368c07b88a32e9cd64bd1",
        value: 2,
      },
      {
        id: "1",
        name: "HoneyComb",
        address: "0xcb0477d1af5b8b05795d89d59f4667b59eae9244",
        value: 2,
      },
      {
        id: "1",
        name: "Beramonium",
        address: "0xb44adddbf9b19bcdd12f978df8b36723488b9b8b",
        value: 2,
      },
      {
        id: "1",
        name: "WATCH ID",
        address: "0xae667177ca6793e402e57a392a336849d6885114",
        value: 2,
      },
      {
        id: "1",
        name: "DegenScore Beacon",
        address: "0x0521fa0bf785ae9759c7cb3cbe7512ebf20fbdaa",
        value: 2,
      },
      {
        id: "1",
        name: "Transponder",
        address: "0x9d00d9b009ab80a18013675011c93796d89de6b4",
        value: 2,
      },
      {
        id: "1",
        name: "Sashimono - Justice",
        address: "0x8e81d22d0dc7ef48a81ab25b773d449f08059c33",
        value: 2,
      },
      {
        id: "1",
        name: "OSINT DAO 62/1000",
        address: "0x234ac38c27ba686e786954533c1c84933d5cfba6",
        value: 2,
      },
      {
        id: "1",
        name: "XORE Genesis",
        address: "0x8c0d927ecc615e1cb896a7e3c8f08ac7aac33c36",
        value: 2,
      },
      {
        id: "1",
        name: "Mirror Genesis",
        address: "0x84162fe2e695fedbf4d3bca1c3458fb616e44735",
        value: 2,
      },
      {
        id: "1",
        name: "Gitcoin Impact Report",
        address: "0x50296fa66ea1486e3255f2f1f4a815a58f2a5fb2",
        value: 2,
      },
      {
        id: "1",
        name: "100,000 Points",
        address: "0xffffffffb9059a7285849bafddf324e2c308c164",
        value: 2,
      },
      {
        id: "1",
        name: "Duel the Black Knight",
        address: "0x4de9d18fd8390c12465ba3c6cc8032992fd7655d",
        value: 2,
      },
      {
        id: "1",
        name: "Banquet",
        address: "0x615a610649e656485d9baf0ebe525496d7b78e24",
        value: 2,
      },
      {
        id: "1",
        name: "Spitfire Pudina",
        address: "0xee126216132b0ff09268657468b89eccc4f8a6b8",
        value: 2,
      },
      {
        id: "1",
        name: "1955",
        address: "0xf7c2df4db0ab7a1d4fc524a910b6a18eb108a960",
        value: 2,
      },
      {
        id: "1",
        name: "Sovereignty  77/1000",
        address: "0x972e96586b56b7d99e89e6e1838a8bf8d1e8ac70",
        value: 2,
      },
      {
        id: "1",
        name: "Grimalkins Unrevealed",
        address: "0xbfdd331f7193729a33159e9309f95281c931c7de",
        value: 2,
      },
      {
        id: "1",
        name: "Qtopia Phoebe NFT",
        address: "0xad5ba4029e65096ccc22933bbe95bd27f0f03734",
        value: 2,
      },
      {
        id: "1",
        name: "gigantic-baboon712.beb",
        address: "0x427b8efee2d6453bb1c59849f164c867e4b2b376",
        value: 2,
      },
      {
        id: "1",
        name: "Based Ghoul ⛧ 788",
        address: "0xef1a89cbfabe59397ffda11fc5df293e9bc5db90",
        value: 2,
      },
      {
        id: "1",
        name: "Birth",
        address: "0xccb9d89e0f77df3618eec9f6bf899be3b5561a89",
        value: 2,
      },
      {
        id: "1",
        name: "Proof of Merge",
        address: "0xf4dd946d1406e215a87029db56c69e1bcf3e1773",
        value: 2,
      },
      {
        id: "10",
        name: "V Buterin",
        address: "0xa3dffe601e086d0854c94487fd481312c374151e",
        value: 2,
      },
      {
        id: "10",
        name: "wontonomics for the hungry minds 372/500",
        address: "0x6005f42f7d0a2cd1068537b587d819683fa3792d",
        value: 2,
      },
      {
        id: "10",
        name: "Optimistic World 2912318",
        address: "0x6a886c76693ed6f4319a289e3fe2e670b803a2da",
        value: 2,
      },
      {
        id: "56",
        name: "@maryyyy",
        address: "0x2723522702093601e6360cae665518c4f63e9da6",
        value: 2,
      },
      {
        id: "42161",
        name: "Token",
        address: "0xbc14d8563b248b79689ecbc43bba53290e0b6b66",
        value: 2,
      },
      {
        id: "137",
        name: "EulerBeats Futura",
        address: "0xccc96454683970352a26ff06f4fb9ca83d19e9f7",
        value: 2,
      },
      {
        id: "42161",
        name: "Nitro Cartel Passport",
        address: "0x348fdfe2c35934a96c1353185f09d0f9efbada86",
        value: 2,
      },
      {
        id: "1",
        name: "Pranksy Rock X/10,000",
        address: "0x70f30556b10990cd28ee2a70d8045f7927788807",
        value: 2,
      },
      {
        id: "1",
        name: "Monster Block",
        address: "0xa56a4f2b9807311ac401c6afba695d3b0c31079d",
        value: 2,
      },
      {
        id: "1",
        name: "Bag",
        address: "0x1dfe7ca09e99d10835bf73044a23b73fc20623df",
        value: 2,
      },
      {
        id: "1",
        name: "More Or Less",
        address: "0x4d756257df43d5b00242461a60c94c906eedfe67",
        value: 2,
      },
      {
        id: "1",
        name: "Backpack",
        address: "0xd208ee54fde79d6ab54be4cc844d22c40bde2ddc",
        value: 2,
      },
      {
        id: "1",
        name: "DigiRock 2008",
        address: "0xebaeb894205666314f06b8e5f61fc0ffe8039ce4",
        value: 2,
      },
      {
        id: "1",
        name: "Panorama Landscapes 138",
        address: "0x875a48b0473cc94a1c786188ad9c4727091dc08f",
        value: 2,
      },
      {
        id: "1",
        name: "Dope Shiba",
        address: "0x763864f1a74d748015f45f7c1181b60e62e40804",
        value: 2,
      },
      {
        id: "1",
        name: "COVIDPunk",
        address: "0xe4cfae3aa41115cb94cff39bb5dbae8bd0ea9d41",
        value: 2,
      },
      {
        id: "1",
        name: "The Excited Silver Haze Woman",
        address: "0x80adb36595239fe918c7d118c1f81e07d070801a",
        value: 2,
      },
      {
        id: "1",
        name: "Wish You Were Beer",
        address: "0xfa932d5cbbdc8f6ed6d96cc6513153afa9b7487c",
        value: 2,
      },
      {
        id: "1",
        name: "Never Fear Truth",
        address: "0x399bd363426dfdd7f84fe8b917e1a3525b039309",
        value: 2,
      },
      {
        id: "1",
        name: "Adventure Cards",
        address: "0x329fd5e0d9aad262b13ca07c87d001bec716ed39",
        value: 2,
      },
      {
        id: "56",
        name: "Binemon",
        address: "0xf41936fa599f67391567fce3e4dfd054b25db3fe",
        value: 2,
      },
      {
        id: "56",
        name: "CyBloc",
        address: "0x13b5816396c5095a145af6994688e6e53fda6095",
        value: 2,
      },
      {
        id: "137",
        name: "Adidas for Prada",
        address: "0x7dec38e3874ecbc842cc61e66c1386aca0c0ea1f",
        value: 2,
      },
      {
        id: "137",
        name: "smartdiving.game",
        address: "0xf5f941cccf571a8bddd4420af269427394aed8fe",
        value: 2,
      },
      {
        id: "137",
        name: "0x4f70cc3162c904b62cda4ba50ff46a8af2bc0b1b",
        address: "0x4f70cc3162c904b62cda4ba50ff46a8af2bc0b1b",
        value: 2,
      },
      {
        id: "10",
        name: "Apetimism",
        address: "0x51E5426eDE4e2d4c2586371372313B5782387222",
        value: 2,
      },
      {
        id: "42161",
        name: "Apebitrum",
        address: "0xc2907944849d2793bcbd2ad24f55893092bed151",
        value: 2,
      },
      {
        id: "1",
        name: "0x5a0d4479aed030305a36a1fb516346d533e794fb",
        address: "0x5a0d4479aed030305a36a1fb516346d533e794fb",
        value: 2,
      },
      {
        id: "56",
        name: "Archive of PEACEMINUSONE",
        address: "0xd8DE41A2AE0E1D0e863E494F45B869789963b35d",
        value: 2,
      },
      {
        id: "56",
        name: "Cross Bosses",
        address: "0x9ddc83be1e5254669bdb366941c746a86194d61b",
        value: 2,
      },
      {
        id: "56",
        name: "ShitPunks",
        address: "0x11304895f41c5a9b7fbfb0c4b011a92f1020ef96",
        value: 2,
      },
      {
        id: "10",
        name: "Tickled Picklez",
        address: "0x0a71bab4673a408465e33b638d41e96f4f1652c4",
        value: 2,
      },
      {
        id: "56",
        name: "PixelSweeper",
        address: "0x5f41842cff838120271d772c6994f051d418a4ad",
        value: 2,
      },
      {
        id: "56",
        name: "JazDID BAB",
        address: "0xff1ae60287ed0c8a32e6fc6f9afe35ea3a726efc",
        value: 2,
      },
      {
        id: "10",
        name: "Global Gans",
        address: "0xbb1b0DA320CCC7a677A2FE00871F422e2E505fb1",
        value: 2,
      },
      {
        id: "10",
        name: "OP Orcas",
        address: "0xBf2794ADAF7A48A2a24EB344a7bA221A52fe2171",
        value: 2,
      },
      {
        id: "56",
        name: "Ultiverse - Moonlight",
        address: "0x50bd5cf91f81c54f24414b8d5f3f509d805613ca",
        value: 2,
      },
      {
        id: "169",
        name: "Golden Treasure Shovel",
        address: "0xf7be5affd97d072f9fbb58ffcd4393bd66f1ad91",
        value: 2,
      },
      {
        id: "1284",
        name: "Ultimate Harvest Moon Campaign",
        address: "0x51737fa634e26f5687e45c6ca07604e064076350",
        value: 2,
      },
      {
        id: "56",
        name: "Kalmy",
        address: "0x5cfbd085bdb4eb5097c829aadda69cad665b8031",
        value: 2,
      },
      {
        id: "1",
        name: "Valhalla",
        address: "0x231d3559aa848Bf10366fB9868590F01d34bF240",
        value: 2,
      },
      {
        id: "5000",
        name: "veCLEO",
        address: "0xaaaea1fb9f3de3f70e89f37b69ab11b47eb9ce6f",
        value: 2,
      },
      {
        id: "56",
        name: "YuliOriginGenOne",
        address: "0x735c4a681f1649f5eee8aac871aa1d89ff056217",
        value: 2,
      },
      {
        id: "1",
        name: "Space Doodles",
        address: "0x620b70123fb810f6c653da7644b5dd0b6312e4d8",
        value: 2,
      },
      {
        id: "42161",
        name: "ARBI PIRATE",
        address: "0xe00Cc435FFf6331963bfc2D984009Be524C282C8",
        value: 2,
      },
      {
        id: "42161",
        name: "NFTCLUB Arbitrum",
        address: "0x6EA3Cd6Bd90A18Fb528b39f53d5450bC36d2CFe8",
        value: 2,
      },
      {
        id: "137",
        name: "TulipArt Airdrop",
        address: "0xfe65f4253a53089779251f10ffe543eca69d01ea",
        value: 2,
      },
      {
        id: "1",
        name: "Surreal",
        address: "0xa406489360a47af2c74fc1004316a64e469646a5",
        value: 2,
      },
      {
        id: "137",
        name: "0xae7954747bed33932c0cc7975b71cff55ca5713f",
        address: "0xae7954747bed33932c0cc7975b71cff55ca5713f",
        value: 2,
      },
      {
        id: "137",
        name: "0xd24fc8496c110d017b5ac78269483e9f3f359380",
        address: "0xd24fc8496c110d017b5ac78269483e9f3f359380",
        value: 2,
      },
      {
        id: "1",
        name: "Flyfish Club",
        address: "0xc9d8f15803c645e98b17710a0b6593f097064bef",
        value: 2,
      },
      {
        id: "1",
        name: "SBF Common",
        address: "0xe4605d46fd0b3f8329d936a8b258d69276cba264",
        value: 1,
      },
      {
        id: "1",
        name: "0x548c407d35cdd3c812458d9ef6d135963f9f7ece",
        address: "0x548c407d35cdd3c812458d9ef6d135963f9f7ece",
        value: 1,
      },
      {
        id: "1",
        name: "0xc2c747e0f7004f9e8817db2ca4997657a7746928",
        address: "0xc2c747e0f7004f9e8817db2ca4997657a7746928",
        value: 1,
      },
      {
        id: "1",
        name: "BrickBreakers",
        address: "0x45929d1754e9fc5450acfbe11f3d620fa2316f3d",
        value: 1,
      },
      {
        id: "1",
        name: "Property's",
        address: "0x18cb9db75fa62a9717aa98292b939e579b7c7ccd",
        value: 1,
      },
      {
        id: "1",
        name: "0x4a8b01e437c65fa8612e8b699266c0e0a98ff65c",
        address: "0x4a8b01e437c65fa8612e8b699266c0e0a98ff65c",
        value: 1,
      },
      {
        id: "1",
        name: "Mutant Hounds",
        address: "0x354634c4621cdfb7a25e6486cca1e019777d841b",
        value: 1,
      },
      {
        id: "1",
        name: "0x3eacf2d8ce91b35c048c6ac6ec36341aae002fb9",
        address: "0x3eacf2d8ce91b35c048c6ac6ec36341aae002fb9",
        value: 1,
      },
      {
        id: "1",
        name: "Bored Ape Comic",
        address: "0x1eb7382976077f92cf25c27cc3b900a274fd0012",
        value: 1,
      },
      {
        id: "1",
        name: "Weird Whales 686",
        address: "0x96ed81c7f4406eff359e27bff6325dc3c9e042bd",
        value: 1,
      },
      {
        id: "1",
        name: "Quak",
        address: "0x07bbdaf30e89ea3ecf6cadc80d6e7c4b0843c729",
        value: 1,
      },
      {
        id: "1",
        name: "B-ball Pandas",
        address: "0x56c707414bc4c9d3fd71a19d3c266295cf7f7312",
        value: 1,
      },
      {
        id: "1",
        name: "Fucking Pickle",
        address: "0xf78296dfcf01a2612c2c847f68ad925801eeed80",
        value: 1,
      },
      {
        id: "1",
        name: "Poopoo Prime Person Participates",
        address: "0xba503dd9e11eabd91beb4ed87a7e57198eaa9d6b",
        value: 1,
      },
      {
        id: "1",
        name: "Pixelglyph",
        address: "0xf38d6bf300d52ba7880b43cddb3f94ee3c6c4ea6",
        value: 1,
      },
      {
        id: "1",
        name: "In Space No One Can Hear You Croak!",
        address: "0x72d16b256f82e4016726e00be827743b57b6d9d5",
        value: 1,
      },
      {
        id: "1",
        name: "Worm Hole",
        address: "0x5f48045f3a1a19ab9985418869f77612cfa752d6",
        value: 1,
      },
      {
        id: "1",
        name: "eternal vision",
        address: "0xa25bf81aacdb5e610eaf91a889975bba43398cf1",
        value: 1,
      },
      {
        id: "1",
        name: "Small Used Rug",
        address: "0x7c10bc61de6781caa00f2f6d8eb4822684337a2b",
        value: 1,
      },
      {
        id: "1",
        name: "Dencun: Open Edition",
        address: "0xaf9ba9f9d7db062a119371ea923ed274e3981163",
        value: 1,
      },
      {
        id: "1",
        name: "Forgotten Runes Comic: Issue",
        address: "0xb94c3fd0016888bab09dbc229f9397294e828a54",
        value: 1,
      },
      {
        id: "1",
        name: "START YOUR ENGINES",
        address: "0x2c3a2a9817b29551facd57324313086413c4205e",
        value: 1,
      },
      {
        id: "1",
        name: "Rift Valley Motel Coin",
        address: "0xbf42c1972877f39e102807e5e80ed2ff5d16aa5f",
        value: 1,
      },
      {
        id: "1",
        name: "YOUR ART, MY RULES",
        address: "0x3735b3550548a77692902a20befd49044475110a",
        value: 1,
      },
      {
        id: "1",
        name: "PUNKS 2: Elite Ape Entry Coins",
        address: "0xd0b53410454370a482979c0adaf3667c6308a801",
        value: 1,
      },
      {
        id: "1",
        name: "01 Baby Raccoon",
        address: "0xa8b33bd28ef0f19ca8dae5babdf9817a6897f3e5",
        value: 1,
      },
      {
        id: "1",
        name: "0x9bf335f61a80686fc33f97a3a7f2e762f0b42622",
        address: "0x9bf335f61a80686fc33f97a3a7f2e762f0b42622",
        value: 1,
      },
      {
        id: "1",
        name: "Apymon Monsters",
        address: "0x6e0baaa0d1c11dc160143c0c7213df76acdf4e17",
        value: 1,
      },
      {
        id: "1",
        name: "Mad Banana",
        address: "0x7eba76cc3f0ffb89d6a9eed8f50e3db0cd445852",
        value: 1,
      },
      {
        id: "1",
        name: "Light Steel Blue",
        address: "0xdb43bfcb0d99be6541c49b245c313ffe8efc8baf",
        value: 1,
      },
      {
        id: "1",
        name: "Blazed Cat",
        address: "0x8584e7a1817c795f74ce985a1d13b962758fe3ca",
        value: 1,
      },
      {
        id: "1",
        name: "Loading",
        address: "0x46c31b6b330c4522d6b37cb3cecdf2da9ff46f61",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoTrunk",
        address: "0x375ea781c49eafedde07afe6196f885761f166ae",
        value: 1,
      },
      {
        id: "1",
        name: "WoWG",
        address: "0xf61f24c2d93bf2de187546b14425bf631f28d6dc",
        value: 1,
      },
      {
        id: "1",
        name: "Mitosis",
        address: "0xbc5f05c9b0932aecb90f6286e2ed975c1e228514",
        value: 1,
      },
      {
        id: "1",
        name: "Gutter Punks Flyer - WoWG",
        address: "0x65498bf901a0c47ba9507c8a778d2bdee4db12b4",
        value: 1,
      },
      {
        id: "1",
        name: "0xfbb6684ebd6093989740e8ef3e7d57cf3813e5a4",
        address: "0xfbb6684ebd6093989740e8ef3e7d57cf3813e5a4",
        value: 1,
      },
      {
        id: "1",
        name: "5398",
        address: "0x325bad883b4e9a35277e99902d94dd18186ae219",
        value: 1,
      },
      {
        id: "1",
        name: "SMOWL",
        address: "0x03b8d129a8f6dc62a797b59aa5eebb11ad63dada",
        value: 1,
      },
      {
        id: "1",
        name: "One Year of Flux",
        address: "0x76723d9524a743d8908458082fbdfaaf7f60b3ed",
        value: 1,
      },
      {
        id: "1",
        name: "0x2308742aa28cc460522ff855d24a365f99deba7b",
        address: "0x2308742aa28cc460522ff855d24a365f99deba7b",
        value: 1,
      },
      {
        id: "1",
        name: "Nick",
        address: "0xe4deeb64e8701116b1d2bdb82dad4c6de2a28845",
        value: 1,
      },
      {
        id: "1",
        name: "Mint Genesis NFT",
        address: "0x8fb956ce2921954c45cb3bb41978c4c6c9736af2",
        value: 1,
      },
      {
        id: "1",
        name: "Trudy Impaler of the Forest",
        address: "0x9690b63eb85467be5267a3603f770589ab12dc95",
        value: 1,
      },
      {
        id: "1",
        name: "Nightmare Imp's Treat Box",
        address: "0x59775fd5f266c216d7566eb216153ab8863c9c84",
        value: 1,
      },
      {
        id: "1",
        name: "Binance US Hat",
        address: "0xa8ee490e4c4da48cc1653502c1a77479d4d818de",
        value: 1,
      },
      {
        id: "1",
        name: "Baba O'Riley",
        address: "0x35471f47c3c0bc5fc75025b97a19ecdde00f78f8",
        value: 1,
      },
      {
        id: "1",
        name: "raCC0ons",
        address: "0xebfdf99872ffe985eefb15bc1ae3a55f827cfc90",
        value: 1,
      },
      {
        id: "1",
        name: "Ape",
        address: "0x7a613660bc598b99228a1a37effe4d8393ae3c67",
        value: 1,
      },
      {
        id: "1",
        name: "Sminems",
        address: "0x0baad6e5d41b9c0f30e16d26e0bb811184b36c37",
        value: 1,
      },
      {
        id: "1",
        name: "KURT",
        address: "0x8bfd77f287b789d26f01ec81e966a6465ccb4283",
        value: 1,
      },
      {
        id: "1",
        name: "Checks - Squiggle Edition 8315",
        address: "0x50e9dc61b38854e55900b1bee88dc4183fc24127",
        value: 1,
      },
      {
        id: "1",
        name: "Tools (for Apes)",
        address: "0x9a56231ddb6486b8bd87942b0179f058f87b6dba",
        value: 1,
      },
      {
        id: "1",
        name: "Mint Method NFT",
        address: "0xf52fbd056ed1f1ab01d4296fce136d6c0a2bbfaf",
        value: 1,
      },
      {
        id: "1",
        name: "0xc108a114c966f137ede828dff0960d8b321f6ddb",
        address: "0xc108a114c966f137ede828dff0960d8b321f6ddb",
        value: 1,
      },
      {
        id: "1",
        name: "Bao Elder",
        address: "0x39c1f6e78c5200674c84c46dc5bf85ba9f6f630a",
        value: 1,
      },
      {
        id: "1",
        name: "Mystic Aleister of the Forest",
        address: "0x5a79182165a2917ef9cccf33f472fe22afffeff8",
        value: 1,
      },
      {
        id: "1",
        name: "Dev",
        address: "0x25ed58c027921e14d86380ea2646e3a1b5c55a8b",
        value: 1,
      },
      {
        id: "1",
        name: "0x00ea2894fe840f105ab99a8f8f75b1f17e94843a",
        address: "0x00ea2894fe840f105ab99a8f8f75b1f17e94843a",
        value: 1,
      },
      {
        id: "1",
        name: "Regenesis: Open Edition",
        address: "0xe42cad6fc883877a76a26a16ed92444ab177e306",
        value: 1,
      },
      {
        id: "1",
        name: "globalprivacynetwork.crypto",
        address: "0xd1e5b0ff1287aa9f9a268759062e4ab08b9dacbe",
        value: 1,
      },
      {
        id: "1",
        name: "PEPE 2.0",
        address: "0x60731f1d59dbece623f54bed45f28b08aba72cad",
        value: 1,
      },
      {
        id: "1",
        name: "adidas Virtual Gear: Genesis 01 — Wallrunner",
        address: "0xba0c9cf4da821dba98407cc4f9c11f6c7a5f9bbc",
        value: 1,
      },
      {
        id: "1",
        name: "Modules [14 8 23 12]",
        address: "0x34226136de5c72ddcfe68c14cb1b9cf474b253ec",
        value: 1,
      },
      {
        id: "1",
        name: "Gucci Grail 0N1",
        address: "0x572e33ffa523865791ab1c26b42a86ac244df784",
        value: 1,
      },
      {
        id: "1",
        name: "Genseng 475",
        address: "0x2e2691819d3441994e9709e776bd77d08cd9e89b",
        value: 1,
      },
      {
        id: "1",
        name: "0N1 Cat Ear Hoodie",
        address: "0x0cfb5d82be2b949e8fa73a656df91821e2ad99fd",
        value: 1,
      },
      {
        id: "1",
        name: "Primate Social Society",
        address: "0x76e51bc8fa0beebcf3e45de408fa43c9dc5ffb27",
        value: 1,
      },
      {
        id: "1",
        name: "RealCryptoPunk",
        address: "0x8b2bb0773ffae3f5aed484a929ed81f728c908dd",
        value: 1,
      },
      {
        id: "1",
        name: "AO Art Ball",
        address: "0x05844e9ae606f9867ae2047c93cac370d54ab2e1",
        value: 1,
      },
      {
        id: "1",
        name: "Copium Wars Slayer",
        address: "0x3853ec5742df47a6d7bafeb19c4716a9eedf8fc4",
        value: 1,
      },
      {
        id: "1",
        name: "Serum City HQ",
        address: "0xe87c167da4dd15eda3432b3f40df7941c6687aea",
        value: 1,
      },
      {
        id: "1",
        name: "Sadbros95",
        address: "0x55241ff1f5877cfca6b3e6ce2fce30183ea2436a",
        value: 1,
      },
      {
        id: "1",
        name: "BiG iNC Employee",
        address: "0x895688bf87d73cc7da27852221799d31b027e300",
        value: 1,
      },
      {
        id: "42161",
        name: "Arb Zorb",
        address: "0x9a6735518847e59b71530512941afdf014a8a74b",
        value: 1,
      },
      {
        id: "42161",
        name: "Art of Shell",
        address: "0x7cfCbbD2AFDA3c656C909AA6bA9E372A1d2bA9A4",
        value: 1,
      },
      {
        id: "1",
        name: "Cryptobot Genesis",
        address: "0x4df461f8c22c0bfb40a51560597d5b946d869d5c",
        value: 1,
      },
      {
        id: "1",
        name: "The Potatoz",
        address: "0x39ee2c7b3cb80254225884ca001f57118c8f21b6",
        value: 1,
      },
      {
        id: "1",
        name: "Live Like A Cat",
        address: "0x597d757f8502f1fe8e7dd6fc7fe884a51c5ae2b9",
        value: 1,
      },
      {
        id: "42161",
        name: "Unbroken despite appearances",
        address: "0x1a84c545D37Eb9513C92E2a2ab61f5E3D8DfBdD5",
        value: 1,
      },
      {
        id: "42161",
        name: "Lycoris",
        address: "0xC0CD6347f6993313f8D40CF64Bf7D9Bc6658e51a",
        value: 1,
      },
      {
        id: "1",
        name: "The Voter",
        address: "0x35f5a420ef9bcc748329021fbd4ed0986abdf201",
        value: 1,
      },
      {
        id: "1",
        name: "AlchemixEthPatron",
        address: "0xa797b1c128b314384fc3517d95be18fa76ba5835",
        value: 1,
      },
      {
        id: "1",
        name: "Web3 DApp 最佳编程实践指南 12/500",
        address: "0xdf5b5ee15cc96ba7d0cb6bd9b2c0fc4417ab6445",
        value: 1,
      },
      {
        id: "56",
        name: "Pancake Christmas 2021",
        address: "0xdf7952b35f24acf7fc0487d01c8d5690a60dba07",
        value: 1,
      },
      {
        id: "137",
        name: "Chumbi Valley Official",
        address: "0x5492ef6aeeba1a3896357359ef039a8b11621b45",
        value: 1,
      },
      {
        id: "137",
        name: "DEFY Genesis Masks",
        address: "0xfd257ddf743da7395470df9a0517a2dfbf66d156",
        value: 1,
      },
      {
        id: "1",
        name: "Bag",
        address: "0xff9c1b15b16263c61d017ee9f65c50e4ae0113d7",
        value: 1,
      },
      {
        id: "1",
        name: "Meka",
        address: "0x9a534628b4062e123ce7ee2222ec20b86e16ca8f",
        value: 1,
      },
      {
        id: "1",
        name: "6529 Gradient",
        address: "0x0c58ef43ff3032005e472cb5709f8908acb00205",
        value: 1,
      },
      {
        id: "1",
        name: "0xf1ef40f5aea5d1501c1b8bcd216cf305764fca40",
        address: "0xf1ef40f5aea5d1501c1b8bcd216cf305764fca40",
        value: 1,
      },
      {
        id: "1",
        name: "Fangster 1255",
        address: "0x9d418c2cae665d877f909a725402ebd3a0742844",
        value: 1,
      },
      {
        id: "1",
        name: "Library Onchain Pass",
        address: "0xb284f375cfe9bf68a5304a3a9a279e9e044fb7c1",
        value: 1,
      },
      {
        id: "1",
        name: "0xB79",
        address: "0x5bdf397bb2912859dbd8011f320a222f79a28d2e",
        value: 1,
      },
      {
        id: "1",
        name: "Diamond Paws",
        address: "0x1cbb182322aee8ce9f4f1f98d7460173ee30af1f",
        value: 1,
      },
      {
        id: "1",
        name: "Spectral Being 154",
        address: "0xc29eecf43c89071fa2e8febbbbad86c14d7f4c44",
        value: 1,
      },
      {
        id: "1",
        name: "Ode to Coco 3",
        address: "0xa6e5a1d2835329369031eedf5c478b55eda9ea33",
        value: 1,
      },
      {
        id: "1",
        name: "CyberV",
        address: "0x67ce4afa08ebf2d6d1f31737cc5d54ff116205e9",
        value: 1,
      },
      {
        id: "1",
        name: "DuskBreaker",
        address: "0x0beed7099af7514ccedf642cfea435731176fb02",
        value: 1,
      },
      {
        id: "1",
        name: "966",
        address: "0x89568fc8d04b3f833209144b77f39b71078e3cb0",
        value: 1,
      },
      {
        id: "1",
        name: "Umi Digital Elements Edition NFT",
        address: "0xd194f079cc291fe9db7dad95444eec1246413636",
        value: 1,
      },
      {
        id: "1",
        name: "0x8c578a6e31fc94b1facd58202be53a8385bacbf7",
        address: "0x8c578a6e31fc94b1facd58202be53a8385bacbf7",
        value: 1,
      },
      {
        id: "1",
        name: "Character",
        address: "0x7403ac30de7309a0bf019cda8eec034a5507cbb3",
        value: 1,
      },
      {
        id: "1",
        name: "AG Genesis Coin",
        address: "0x0eed5a82caf80b119f144af9599688f01dcbd1d5",
        value: 1,
      },
      {
        id: "1",
        name: "ML.01 - BAG",
        address: "0xd7162092f616ab0d9c14bfa29c38ab781d90d345",
        value: 1,
      },
      {
        id: "1",
        name: "Roots of Rage",
        address: "0xb798a123fe75292c3873768d01d7f5fc79e05efc",
        value: 1,
      },
      {
        id: "1",
        name: "Wassietopia Ticket",
        address: "0xd833a1990656c5c282b809cb82500455a8e6a205",
        value: 1,
      },
      {
        id: "1",
        name: "Portalpill",
        address: "0xa16891897378a82e9f0ad44a705b292c9753538c",
        value: 1,
      },
      {
        id: "1",
        name: "Look Up",
        address: "0x8240534f3fbf684c0e29635ab5c8f8efb6f66d42",
        value: 1,
      },
      {
        id: "1",
        name: "Bonsai",
        address: "0xec9c519d49856fd2f8133a0741b4dbe002ce211b",
        value: 1,
      },
      {
        id: "1",
        name: "GalaXY Kats",
        address: "0x71c4658acc7b53ee814a29ce31100ff85ca23ca7",
        value: 1,
      },
      {
        id: "1",
        name: "0x2216d47494e516d8206b70fca8585820ed3c4946",
        address: "0x2216d47494e516d8206b70fca8585820ed3c4946",
        value: 1,
      },
      {
        id: "1",
        name: "JOY-O-Matic Torch",
        address: "0x0574c34385b039c2bb8db898f61b7767024a9449",
        value: 1,
      },
      {
        id: "1",
        name: "Fortune Teller Tier 1: Robot by Dylan Has",
        address: "0x2ceb85a2402c94305526ab108e7597a102d6c175",
        value: 1,
      },
      {
        id: "1",
        name: "Bag",
        address: "0xede64feff210f406bff709e2f375611641c2a945",
        value: 1,
      },
      {
        id: "1",
        name: "Genesis Land",
        address: "0x2c88aa0956bc9813505d73575f653f69ada60923",
        value: 1,
      },
      {
        id: "1",
        name: "ERROR 404",
        address: "0x8d53afbeb62c18917b5f71385d52e8ba87669794",
        value: 1,
      },
      {
        id: "1",
        name: "Lyrell Fentson",
        address: "0x508d06b8f3a4b0fd363239ce61e0c4b0b82f3626",
        value: 1,
      },
      {
        id: "1",
        name: "The Bandwagon Effect",
        address: "0xf01dfd45f98f377d29d58340d509f04e0a46b57c",
        value: 1,
      },
      {
        id: "1",
        name: "Farmer",
        address: "0xbda2481db91fc0f942ed3f53de378ba45ba9d17e",
        value: 1,
      },
      {
        id: "1",
        name: "SV1-43631",
        address: "0xaaf03a65cbd8f01b512cd8d530a675b3963de255",
        value: 1,
      },
      {
        id: "1",
        name: "0x5c2877fb8992d22b8d764e7d799b7f89d8130ecb",
        address: "0x5c2877fb8992d22b8d764e7d799b7f89d8130ecb",
        value: 1,
      },
      {
        id: "1",
        name: "Introductory video to the cult",
        address: "0x6d4530149e5b4483d2f7e60449c02570531a0751",
        value: 1,
      },
      {
        id: "1",
        name: "LinksDAO Leisure Membership",
        address: "0x696115768bbef67be8bd408d760332a7efbee92d",
        value: 1,
      },
      {
        id: "1",
        name: "Feb 2021",
        address: "0x067ab2fbdbed63401af802d1dd786e6d83b0ff1b",
        value: 1,
      },
      {
        id: "1",
        name: "Wolf Game Relic",
        address: "0x905ca479ba0b5ca8c4c96e560db0609de865793c",
        value: 1,
      },
      {
        id: "1",
        name: "Cute Lil' Thimble",
        address: "0x8116e42c06d7e22e07d785aba535fa9ed6c1516d",
        value: 1,
      },
      {
        id: "10",
        name: "Introducing the Optimism Collective 51164/524120",
        address: "0xa95579592078783b409803ddc75bb402c217a924",
        value: 1,
      },
      {
        id: "10",
        name: "Canto Genesis 58/200",
        address: "0x3e21e1d8e89d675aca9708aee0ae05c7f6622c29",
        value: 1,
      },
      {
        id: "42161",
        name: "Blitpill",
        address: "0xea635ddc046eec4906911fce889c15376a4f6889",
        value: 1,
      },
      {
        id: "1",
        name: "The Sevens",
        address: "0xf497253c2bb7644ebb99e4d9ecc104ae7a79187a",
        value: 1,
      },
      {
        id: "1",
        name: "Fast Food Noun 511",
        address: "0xfba74f771fcee22f2ffec7a66ec14207c7075a32",
        value: 1,
      },
      {
        id: "1",
        name: "BEAN",
        address: "0x48355ce6ba377d06335be9499feaf735948484bc",
        value: 1,
      },
      {
        id: "1",
        name: "Derpy Birb",
        address: "0x91f7bb6900d65d004a659f34205beafc3b4e136c",
        value: 1,
      },
      {
        id: "1",
        name: "Role",
        address: "0xcd4d337554862f9bc9ffffb67465b7d643e4e3ad",
        value: 1,
      },
      {
        id: "1",
        name: "Humanoid",
        address: "0x3a5051566b2241285be871f650c445a88a970edd",
        value: 1,
      },
      {
        id: "1",
        name: "Thicc Frens",
        address: "0xdb691c32c75aa9c9c44a6b7ec94195a50716d2ec",
        value: 1,
      },
      {
        id: "1",
        name: "Gerbs",
        address: "0xae5dffa72a224238061966470fbf846838391dd4",
        value: 1,
      },
      {
        id: "1",
        name: "Founders Baseball Bat",
        address: "0x0cd925f268678d03057d184ded76d98552d7d837",
        value: 1,
      },
      {
        id: "1",
        name: "The Goose NFT",
        address: "0x22bbc41a725823ebb8f3ae7db74bc67133aaf969",
        value: 1,
      },
      {
        id: "1",
        name: "GM Pepe",
        address: "0xad364bde2420d8d49ecf276b80d2b2f1f5b3a80e",
        value: 1,
      },
      {
        id: "1",
        name: "S K I E S / /",
        address: "0x506543b7f2dce30e235714446dc9bd634efae8a1",
        value: 1,
      },
      {
        id: "1",
        name: "0x874dd3f2317beabb4f069b42b539010c54b195ec",
        address: "0x874dd3f2317beabb4f069b42b539010c54b195ec",
        value: 1,
      },
      {
        id: "1",
        name: "Moongang",
        address: "0x8a91221b094c428eac0462174b05b51d5a3aa869",
        value: 1,
      },
      {
        id: "1",
        name: "NOT AVAILABLE!",
        address: "0xc20cf2cda05d2355e218cb59f119e3948da65dfa",
        value: 1,
      },
      {
        id: "1",
        name: "Dastardly Duck",
        address: "0x5472896e283ebcb13924c659c9db594aa9dc05a4",
        value: 1,
      },
      {
        id: "1",
        name: "Apes of Space",
        address: "0xf6e2c197e96b63b982ca639262cdf0a5f296d528",
        value: 1,
      },
      {
        id: "1",
        name: "0x7f4dd825f2e9cb89ae1091134c65356ba36dd50e",
        address: "0x7f4dd825f2e9cb89ae1091134c65356ba36dd50e",
        value: 1,
      },
      {
        id: "1",
        name: "Fungi",
        address: "0x90ee3cf59fcde2fe11838b9075ea4681462362f1",
        value: 1,
      },
      {
        id: "1",
        name: "Cupcat Kitten 2378",
        address: "0x90d4ffbf13bf3203940e6dace392f7c23ff6b9ed",
        value: 1,
      },
      {
        id: "1",
        name: "Zodiac Friend",
        address: "0xb6353e6753c857ec4961ac16df4a4094bb923d97",
        value: 1,
      },
      {
        id: "1",
        name: "Baby Ghost",
        address: "0x030d5ffc1f8a64c58a040e0216b96e52c5cbe569",
        value: 1,
      },
      {
        id: "1",
        name: "Mystic Rooster",
        address: "0xcb52ee1e1ae95a0e2917ad48f5693623f0d2273c",
        value: 1,
      },
      {
        id: "1",
        name: "0xfd0af9ddbd3fd21e3593428830fe47c4f749b1fa",
        address: "0xfd0af9ddbd3fd21e3593428830fe47c4f749b1fa",
        value: 1,
      },
      {
        id: "1",
        name: "0xaf316251082fee7dff8412ca896601796674e0a6",
        address: "0xaf316251082fee7dff8412ca896601796674e0a6",
        value: 1,
      },
      {
        id: "1",
        name: "Ninja",
        address: "0x97e41d5ce9c8cb1f83947ef82a86e345aed673f3",
        value: 1,
      },
      {
        id: "1",
        name: "UNKNOWN Monkey",
        address: "0x46e81b2a992e0f7266cbb148b30bece11c3f327d",
        value: 1,
      },
      {
        id: "1",
        name: "Broken Backgrounds",
        address: "0xd6757d3e71fe863a0ce6f46bbcd9fb457588bdaa",
        value: 1,
      },
      {
        id: "1",
        name: "0x7ab2352b1d2e185560494d5e577f9d3c238b78c5",
        address: "0x7ab2352b1d2e185560494d5e577f9d3c238b78c5",
        value: 1,
      },
      {
        id: "1",
        name: "90SLOOT",
        address: "0xf102f6d0759b0cf6b5b61745ec51fc20f7f67a21",
        value: 1,
      },
      {
        id: "1",
        name: "BEANS PET",
        address: "0x767785a8f4f7583c3a79ae59183d605fdb8b3289",
        value: 1,
      },
      {
        id: "1",
        name: "Kid",
        address: "0xc67f5e3a5b697ae004edd8f84925189a81c6dc4b",
        value: 1,
      },
      {
        id: "1",
        name: "PixelBeast",
        address: "0xd539a3a5edb713e6587e559a9d007ffff92bd9ab",
        value: 1,
      },
      {
        id: "1",
        name: "Boss Beauties",
        address: "0xb5c747561a185a146f83cfff25bdfd2455b31ff4",
        value: 1,
      },
      {
        id: "1",
        name: "Derpy Egg",
        address: "0x8a5da222a428d46ff46bd7cc914d6aabd11d364f",
        value: 1,
      },
      {
        id: "1",
        name: "FoxyHound",
        address: "0xde3a8b06113d18e41949812b77716ea865aa8f48",
        value: 1,
      },
      {
        id: "1",
        name: "Skullx",
        address: "0x1dc5d3b2162f9500d7ddec14eb0ba9ccb43bc20c",
        value: 1,
      },
      {
        id: "1",
        name: "Rich Kid",
        address: "0x586e1dfa8ceb7d7c46c2f616a04b0d2e995520a4",
        value: 1,
      },
      {
        id: "1",
        name: "CurrencyPunk",
        address: "0xe433e90c5b898819544346e73a501d9e8013dbd8",
        value: 1,
      },
      {
        id: "1",
        name: "Uniswap Emerald 2871",
        address: "0xffc5c0fd34f9c1ba75838fa535a484a2b789e934",
        value: 1,
      },
      {
        id: "1",
        name: "/CRYPTOPIXEL/ Ivan on Tech",
        address: "0xde44a816b050fa0b880028c4644f339bdeb8542a",
        value: 1,
      },
      {
        id: "1",
        name: "Hashes ID",
        address: "0xd07e72b00431af84ad438ca995fd9a7f0207542d",
        value: 1,
      },
      {
        id: "1",
        name: "Clarise 'Lil Red' O'Flanny",
        address: "0x7c37463aa592c85c56069dc6d00685cd09b6a719",
        value: 1,
      },
      {
        id: "1",
        name: "Doadz",
        address: "0x8104137af7e7f0a124801ecd90f79ed1eb6fc06d",
        value: 1,
      },
      {
        id: "1",
        name: "SAMURAI cryptos SymbolNFT - Stardust",
        address: "0x9cc4db01c654883a009daa11ba3d019d0abfa2e3",
        value: 1,
      },
      {
        id: "1",
        name: "Propheth",
        address: "0x86f95f0a25e023346f4ac32b25ebcfa593120d45",
        value: 1,
      },
      {
        id: "1",
        name: "0xf4121a2880c225f90dc3b3466226908c9cb2b085",
        address: "0xf4121a2880c225f90dc3b3466226908c9cb2b085",
        value: 1,
      },
      {
        id: "1",
        name: "0x09be9a…d5eec8",
        address: "0x9d90308d16b94c38048c782bdd8104a964758a23",
        value: 1,
      },
      {
        id: "1",
        name: "The Cheetahs",
        address: "0x94ea4c3b679d96ed82aecbb9ca8f33567e4e1c58",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoTrunk",
        address: "0x4ad2d817b60db6ee79c1ae016429251a0d25423f",
        value: 1,
      },
      {
        id: "1",
        name: "Dented - Spy Card",
        address: "0x87a109a77edc287c384aeeb105e52a26bb2d194a",
        value: 1,
      },
      {
        id: "56",
        name: "Kate Savage",
        address: "0x1630a6aa99c35e2e5884ee741d1f1b06b7fe776c",
        value: 1,
      },
      {
        id: "42161",
        name: "Porigon Key",
        address: "0xe077e5f63c34b611a913b3fcbfadaa3b25991733",
        value: 1,
      },
      {
        id: "10",
        name: "Poop Nation",
        address: "0x2F0a7d2eAC59A453C82f51fEa8ba722d6c3560d2",
        value: 1,
      },
      {
        id: "1",
        name: "Ronin",
        address: "0x497a9a79e82e6fc0ff10a16f6f75e6fcd5ae65a8",
        value: 1,
      },
      {
        id: "1",
        name: "PROOF Pass",
        address: "0x2ced5bc349d9241a314d3739f12f5f6f2bda6a68",
        value: 1,
      },
      {
        id: "1",
        name: "NOR Third Aspect of The Nine_727",
        address: "0x1cf5b3a7dfc58cd00beecad18d04b03ad9e13b4f",
        value: 1,
      },
      {
        id: "1",
        name: "0xd0318da435dbce0b347cc6faa330b5a9889e3585",
        address: "0xd0318da435dbce0b347cc6faa330b5a9889e3585",
        value: 1,
      },
      {
        id: "1",
        name: "MPL",
        address: "0x139732c3f717071843f90977d93400393bdf9664",
        value: 1,
      },
      {
        id: "1",
        name: "Cosmic Kid",
        address: "0x4ab6d8ff68330d844a3056ea2f8179a7e19759ff",
        value: 1,
      },
      {
        id: "1",
        name: "Bit Bear",
        address: "0x32bb5a147b5371fd901aa4a72b7f82c58a87e36d",
        value: 1,
      },
      {
        id: "1",
        name: "Slade - Don | Band Bears",
        address: "0xb4e570232d3e55d2ee850047639dc74da83c7067",
        value: 1,
      },
      {
        id: "1",
        name: "Cyberpunk Bag",
        address: "0x13a48f723f4ad29b6da6e7215fe53172c027d98f",
        value: 1,
      },
      {
        id: "1",
        name: "Glue Factory Horse",
        address: "0x15c2b137e59620552bd0d712fe7279cf1f47468d",
        value: 1,
      },
      {
        id: "1",
        name: "Atom",
        address: "0xbdaed67214641b7eda3bf8d7431c3ae5fc46f466",
        value: 1,
      },
      {
        id: "1",
        name: "Gamma Squall",
        address: "0x085c091b71b9d77b8f52f073d738ce805dec369b",
        value: 1,
      },
      {
        id: "1",
        name: "Redemption -",
        address: "0x399aa4e3a65282eee090eb58aedd787431c4af2d",
        value: 1,
      },
      {
        id: "1",
        name: "Zhang - The Moonboy | DuckDAO Hunters",
        address: "0x9d34c91d03809bc012768d8c608e862c0c985b81",
        value: 1,
      },
      {
        id: "1",
        name: "Unrevealed Chef",
        address: "0x152cc0b640fa85fecff43d2a417fa9b369661b97",
        value: 1,
      },
      {
        id: "1",
        name: "Raid Project",
        address: "0xdff484a2bc81c3ab7368dc58f3e5894d426f957c",
        value: 1,
      },
      {
        id: "1",
        name: "Hero",
        address: "0x600c411c1195605cc75a7645f2bca782fcfc4d6c",
        value: 1,
      },
      {
        id: "1",
        name: "[LEGACY] WhelpsNFT",
        address: "0xa8934086a260f8ece9166296967d18bd9c8474a5",
        value: 1,
      },
      {
        id: "1",
        name: "Something Token 9243",
        address: "0x05e7f2499ff153fea2f20bbde0b5584c911c0af1",
        value: 1,
      },
      {
        id: "1",
        name: "Cryptowalkers Bored Box Jetpack",
        address: "0xf6b553b879f1beb3c46cf1635bc66039b59fc42d",
        value: 1,
      },
      {
        id: "1",
        name: "Voyager",
        address: "0x4591c791790f352685a29111eca67abdc878863e",
        value: 1,
      },
      {
        id: "1",
        name: "NFTY Labs Access Token V. 0.2.0",
        address: "0xefb43cee005f8c56eddd81ab8058a37b7558a534",
        value: 1,
      },
      {
        id: "1",
        name: "Junkyard Disk",
        address: "0x1525037d1ba92458861dcd4590e9d154507adb24",
        value: 1,
      },
      {
        id: "1",
        name: "You Got It",
        address: "0xca008c0bf62c0421b958de86b3d45c86ecae43f1",
        value: 1,
      },
      {
        id: "1",
        name: "Moonray Presale Pass",
        address: "0x4d57b36c1555b48a63feab9f90d38a9b7ebc4419",
        value: 1,
      },
      {
        id: "1",
        name: "Premium Club",
        address: "0x86d9d801d4dfa7403af763465fb6e369fe065591",
        value: 1,
      },
      {
        id: "1",
        name: "77-Bit Volume 1",
        address: "0x5347422623bf9acdbdf594fe469c906af63e71b5",
        value: 1,
      },
      {
        id: "1",
        name: "Guy SLD Chip",
        address: "0x48e854addccee85ccd4f7a5e660564eae4b577d0",
        value: 1,
      },
      {
        id: "1",
        name: "Relic",
        address: "0xc89e446323803c3011e4574ffbf12d9940453e40",
        value: 1,
      },
      {
        id: "1",
        name: "Bronze Launchpool Labs NFT",
        address: "0xde508b1313367309360ddd5f0f416c42102a0eef",
        value: 1,
      },
      {
        id: "1",
        name: "Darken the Shadow OST (Gothic Horror)",
        address: "0xe3782b8688ad2b0d5ba42842d400f7adf310f88d",
        value: 1,
      },
      {
        id: "1",
        name: "0xcdd5a1cacd12ad5f44e3a673b7900498237eb37c",
        address: "0xcdd5a1cacd12ad5f44e3a673b7900498237eb37c",
        value: 1,
      },
      {
        id: "1",
        name: "Gym A Club Mint Pass - Silver",
        address: "0x8d78ebf503ec71874427ba7f52ea75159e528585",
        value: 1,
      },
      {
        id: "1",
        name: "Marauder",
        address: "0x84f4226af1eb4b5e76c5dd203eef7f1f3452fb9d",
        value: 1,
      },
      {
        id: "1",
        name: "Crew Member",
        address: "0x746db7b1728af413c4e2b98216c6171b2fc9d00e",
        value: 1,
      },
      {
        id: "1",
        name: "97490-C",
        address: "0x6e4c6d9b0930073e958abd2aba516b885260b8ff",
        value: 1,
      },
      {
        id: "1",
        name: "0x082903f4e94c5e10a2b116a4284940a36afaed63",
        address: "0x082903f4e94c5e10a2b116a4284940a36afaed63",
        value: 1,
      },
      {
        id: "1",
        name: "Karma DAO",
        address: "0xf7e1feef85b9c2337a087439abf364b9dd21a562",
        value: 1,
      },
      {
        id: "1",
        name: "9705",
        address: "0x9f4292bd05a5c89f007bdef3a95fc32bc1021b99",
        value: 1,
      },
      {
        id: "1",
        name: "Second Self",
        address: "0xdea8e779d9b39f1022c546f8ae92430d85cca3ba",
        value: 1,
      },
      {
        id: "1",
        name: "Regen",
        address: "0x15d98e8762b2183d8ad313de3cb247c9064dfd5d",
        value: 1,
      },
      {
        id: "1",
        name: "Flex the Nuclear Surf Instructor from Caps",
        address: "0xea917326e8a95299c02655fe947962c43a11487f",
        value: 1,
      },
      {
        id: "1",
        name: "Invader",
        address: "0xe1a723b0b4f9d5fb75c103f393df5e3436256b02",
        value: 1,
      },
      {
        id: "1",
        name: "Cob Gobblers",
        address: "0x36f62a244955c0055cb667df6979466ab2c24d2d",
        value: 1,
      },
      {
        id: "1",
        name: "Limited Edition Genesis rootNFT",
        address: "0x20771a922b1719f1b1fb86e7ea9bf8f8fc823e9d",
        value: 1,
      },
      {
        id: "1",
        name: "Magic Rainbows",
        address: "0x18e0cd264a2bcfa690ac8ddf50dbc7e11dbef2bc",
        value: 1,
      },
      {
        id: "1",
        name: "NFTCult Member",
        address: "0x5d75c1b764afd64fe02a28b5eff79e2f81db5bad",
        value: 1,
      },
      {
        id: "1",
        name: "aciOS: Node",
        address: "0x9685362de58058be996723c19d5386e509848106",
        value: 1,
      },
      {
        id: "1",
        name: "Create Card",
        address: "0x5e7dd1e569e75a7c2c1395d625dac3275dc94012",
        value: 1,
      },
      {
        id: "1",
        name: "HUXLEY Comic: Issue 1 - First Edition",
        address: "0x9ca8887d13bc4591ae36972702fdf9de2c97957f",
        value: 1,
      },
      {
        id: "1",
        name: "0xf4f02b0df397b026eae4efb03a3b796cf9567fe6",
        address: "0x64931f06d3266049bf0195346973762e6996d764",
        value: 1,
      },
      {
        id: "1",
        name: "0x96be46c50e882dbd373081d08e0cde2b055adf6c",
        address: "0x96be46c50e882dbd373081d08e0cde2b055adf6c",
        value: 1,
      },
      {
        id: "1",
        name: "0x4c65dfeba1344e66f08c21adba6577369bccdd60",
        address: "0x4c65dfeba1344e66f08c21adba6577369bccdd60",
        value: 1,
      },
      {
        id: "1",
        name: "ShardPunk",
        address: "0x70993a6dfe0ef2d5253d6498c18d815a6c139163",
        value: 1,
      },
      {
        id: "1",
        name: "Icy Founders Club",
        address: "0x37d754d6d1668e32678fbeb2604da9cb4fbe993f",
        value: 1,
      },
      {
        id: "1",
        name: "0x020cdc4775366ae436f13a7d333143432e884934",
        address: "0x020cdc4775366ae436f13a7d333143432e884934",
        value: 1,
      },
      {
        id: "1",
        name: "Pro 3606",
        address: "0x6bca6de2dbdc4e0d41f7273011785ea16ba47182",
        value: 1,
      },
      {
        id: "1",
        name: "Enter The Hashverse",
        address: "0xb99e4e9b8fd99c2c90ad5382dbc6adfdfe3a33f3",
        value: 1,
      },
      {
        id: "1",
        name: "Ruby Access Card",
        address: "0xd1ad8ebfb0fb6306962e48260cf1e8062eb28cfa",
        value: 1,
      },
      {
        id: "1",
        name: "Bag - 243",
        address: "0x1ea66a857de297471bc12dd12d93853ff6617284",
        value: 1,
      },
      {
        id: "1",
        name: "Studio Pass",
        address: "0x5d72b691ac675e400b4d1f66754484ab221f9356",
        value: 1,
      },
      {
        id: "1",
        name: "Cicadas",
        address: "0xeb68f1fbb84db4a63bf19ff364cfc3e496daf910",
        value: 1,
      },
      {
        id: "1",
        name: "0xb8da418ffc2cb675b8b3d73dca0e3f10811fbbdd",
        address: "0xb8da418ffc2cb675b8b3d73dca0e3f10811fbbdd",
        value: 1,
      },
      {
        id: "1",
        name: "Bored Box - Genesis",
        address: "0x09d05293264edf390cd3cbd8cc86532207ae30b0",
        value: 1,
      },
      {
        id: "1",
        name: "Miium Hero",
        address: "0xa178a73f6e215531047d3486f8edc68d14548f6b",
        value: 1,
      },
      {
        id: "1",
        name: "Prophet",
        address: "0x26231a65ef80706307bbe71f032dc1e5bf28ce43",
        value: 1,
      },
      {
        id: "1",
        name: "CITADEL 858",
        address: "0xaf08134ea12494dc3aaa7f1efb23a8753b7f84c9",
        value: 1,
      },
      {
        id: "1",
        name: "Gen II",
        address: "0x86599b800e23036d761f43d7516092447295659f",
        value: 1,
      },
      {
        id: "10",
        name: "Honey Jar Ponzinomics 43/2355",
        address: "0x1cbc0e6d9592a45a20a2682397b78cf5bc7db91c",
        value: 1,
      },
      {
        id: "56",
        name: "Burgercities x Peking Monsters Meta Concert Badge",
        address: "0xa8f92ccadc28559c97c183639c840d808e1d9fda",
        value: 1,
      },
      {
        id: "56",
        name: "lock",
        address: "0xfbbf371c9b0b994eebfcc977cef603f7f31c070d",
        value: 1,
      },
      {
        id: "42161",
        name: "DeFi Riddler Exclusive Telegram Group - Participant Badge",
        address: "0x6de7555fec743e962c24c9a9f1980d6e7778e9a8",
        value: 1,
      },
      {
        id: "42161",
        name: "Boost Pass",
        address: "0x0bd0e39db7f3557ae9c071209b7b26808157a0aa",
        value: 1,
      },
      {
        id: "42161",
        name: "Mycelium OGs",
        address: "0xcf72978cf3f17a6194a394888a1d7a4e6effa405",
        value: 1,
      },
      {
        id: "42161",
        name: "BracketX Gold",
        address: "0x01a268761c79d0185fb479845390fab581a60707",
        value: 1,
      },
      {
        id: "56",
        name: "Genesis Pear Ticket",
        address: "0x60e8b899fe6aea55cdc2736f3626599e38844c2a",
        value: 1,
      },
      {
        id: "1",
        name: "13 須賀町",
        address: "0x79986af15539de2db9a5086382daeda917a9cf0c",
        value: 1,
      },
      {
        id: "1",
        name: "The Other Side",
        address: "0xcb4307f1c3b5556256748ddf5b86e81258990b3c",
        value: 1,
      },
      {
        id: "1",
        name: "0xc51029fb5fcd4f8748255fdf67a5410567b5566c",
        address: "0xc51029fb5fcd4f8748255fdf67a5410567b5566c",
        value: 1,
      },
      {
        id: "1",
        name: "Springfield Punks",
        address: "0x814c3ab3c08b6e10845706680d03e7306dd21491",
        value: 1,
      },
      {
        id: "1",
        name: "8liens",
        address: "0x740c178e10662bbb050bde257bfa318defe3cabc",
        value: 1,
      },
      {
        id: "1",
        name: "Starfall Traveler",
        address: "0x86486fe85545b57d06330acf1f3d63bb7b790cb4",
        value: 1,
      },
      {
        id: "1",
        name: "Gh0stlyGh0st",
        address: "0xa74ae2c6fca0cedbaef30a8ceef834b247186bcf",
        value: 1,
      },
      {
        id: "1",
        name: "Unknown Mortimarrow",
        address: "0x77b7d9a6513bfb1679c778b257c198f44a78fa69",
        value: 1,
      },
      {
        id: "1",
        name: "Wen Utility",
        address: "0xb10b88218e288cda2218d8b4cc81899ee5af4600",
        value: 1,
      },
      {
        id: "1",
        name: "An Oath to $er",
        address: "0x80ad01392b9b4a85535ec0bbff13b74c8da81070",
        value: 1,
      },
      {
        id: "1",
        name: "The Dev",
        address: "0xd57474e76c9ebecc01b65a1494f0a1211df7bcd8",
        value: 1,
      },
      {
        id: "1",
        name: "Loot (for Punks)",
        address: "0x6abab28fa94f76789844141b09a560a521fe5ba0",
        value: 1,
      },
      {
        id: "1",
        name: "PUMA Materializer",
        address: "0xd7504d848d3b83f0b0d2ef67f1ca14ec13f05904",
        value: 1,
      },
      {
        id: "1",
        name: "Rebel",
        address: "0x7deda0afe6df3da6a85a87b371f8b464c30c6803",
        value: 1,
      },
      {
        id: "1",
        name: "Pirate",
        address: "0x31fe9d95dde43cf9893b76160f63521a9e3d26b0",
        value: 1,
      },
      {
        id: "1",
        name: "Block Explorer",
        address: "0x662f65e49b2e6188784b859bc0e3eb4a422c4bb4",
        value: 1,
      },
      {
        id: "1",
        name: "0x9f648eef45b73e1a32ce7b624a44266226a85d88",
        address: "0x9f648eef45b73e1a32ce7b624a44266226a85d88",
        value: 1,
      },
      {
        id: "1",
        name: "Rare Apepe",
        address: "0x31d45de84fde2fb36575085e05754a4932dd5170",
        value: 1,
      },
      {
        id: "1",
        name: "Invest in Music Pass",
        address: "0xb711b181b3de33e18496b6fde1de4b7a19a6e0cd",
        value: 1,
      },
      {
        id: "1",
        name: "FaTPass",
        address: "0x407c5d2c02ab0e4b0a98d14778a5de180eb1357f",
        value: 1,
      },
      {
        id: "1",
        name: "GASH Genesis",
        address: "0x042551fee3753a4f892b69784774318cb3eff32e",
        value: 1,
      },
      {
        id: "1",
        name: "Z1 Serum",
        address: "0x37582c3b14ecbbe085bfdbf83f4bec1d82c1d355",
        value: 1,
      },
      {
        id: "1",
        name: "Super Nyan Balloon",
        address: "0x286e531f363768fed5e18b468f5b76a9ffc33af5",
        value: 1,
      },
      {
        id: "1",
        name: "M1 Mutant Serum",
        address: "0xa3de26661e786d7555493eca6d40d07ce14c4762",
        value: 1,
      },
      {
        id: "1",
        name: "Late Night Snack",
        address: "0xa72b658430b6d8bf741364ce3f2730cd4e7d9ba6",
        value: 1,
      },
      {
        id: "1",
        name: "God Love NFTees",
        address: "0xf8581210a6a5cb4821f1a85319f246c11067b84e",
        value: 1,
      },
      {
        id: "1",
        name: "Probably Yuki & Bobu",
        address: "0x02ddfc164f943130888fb736663985749f079128",
        value: 1,
      },
      {
        id: "1",
        name: "V3 Phunk",
        address: "0xb7d405bee01c70a9577316c1b9c2505f146e8842",
        value: 1,
      },
      {
        id: "1",
        name: "GRIFTERZ",
        address: "0x921d54ad60131ddc0bab58774bab9c38fb392aa2",
        value: 1,
      },
      {
        id: "1",
        name: "CHECKERS",
        address: "0xdad490e883d44e49e08d5bb15cdefb7a29168929",
        value: 1,
      },
      {
        id: "1",
        name: "DC",
        address: "0x08b1aaef9fd158bbdf21c3cad6408afa7d35df4c",
        value: 1,
      },
      {
        id: "1",
        name: "0xcb19c963dae413459bef4dc52144e00972abcdbd",
        address: "0xcb19c963dae413459bef4dc52144e00972abcdbd",
        value: 1,
      },
      {
        id: "1",
        name: "We Are SG",
        address: "0xa2d54d463a33ff10956428ef8fa5ba0027401071",
        value: 1,
      },
      {
        id: "1",
        name: "Early",
        address: "0x45a0c3fc2061b991bb7f0d85135c9c41cbf87d0a",
        value: 1,
      },
      {
        id: "1",
        name: "Sky Diver",
        address: "0x5188778677b9c337d6fc4e7e3751592c7e6a3992",
        value: 1,
      },
      {
        id: "1",
        name: "Jabber Walkie",
        address: "0xd3a0b315023243632a15fd623d6f33314193df4e",
        value: 1,
      },
      {
        id: "1",
        name: "House of Lee: Genesis",
        address: "0x091fc2e2bb9886d107ba3537defa42744282eaaa",
        value: 1,
      },
      {
        id: "1",
        name: "Strangers",
        address: "0x91ad60593710df6fd7995565702040808c2e182d",
        value: 1,
      },
      {
        id: "1",
        name: "Ovum Miraculi",
        address: "0xed1bd4a5244d35be12e84a3e9821290032a47a99",
        value: 1,
      },
      {
        id: "1",
        name: "Queen y00ts",
        address: "0xfd7c6a97ed8d42844dd163f5b3ab021202ac6802",
        value: 1,
      },
      {
        id: "1",
        name: "Devon DeJardin’s Vitruvian Guardian",
        address: "0x5eae28b7ed01ee83f2ad39221eb579a010a6b854",
        value: 1,
      },
      {
        id: "1",
        name: "What is an NFT?",
        address: "0x4e2d9546ccfec5b126706e02afd329ef53b3ae01",
        value: 1,
      },
      {
        id: "1",
        name: "ART IS FOR THE RICH",
        address: "0x3364fa210fa91e0d6177ca9e3cb42ba24f9dfe87",
        value: 1,
      },
      {
        id: "1",
        name: "2023 Volume 1 - The Year of Yuga",
        address: "0xae49b1754cd83938c88cee3a77a8568d9901bac4",
        value: 1,
      },
      {
        id: "1",
        name: "Opepengs",
        address: "0xcc1c94dc39b1ca5651483d5bd761f1e01e4f5a0f",
        value: 1,
      },
      {
        id: "1",
        name: "Blank Checks",
        address: "0xfbff3a96dc68bd308ac1320cc0fd9b8a22e560fe",
        value: 1,
      },
      {
        id: "1",
        name: "RektFreedom",
        address: "0x50297fc5c3866e04181eb166c585ae24e2986957",
        value: 1,
      },
      {
        id: "1",
        name: "Feed the Bird",
        address: "0x60f95e81408a974dd35aad8b504862b290d0ed5f",
        value: 1,
      },
      {
        id: "1",
        name: "Coordinate (12,34)",
        address: "0x3ca53be299c765cdc66cc1723f8b3eefb3aaa413",
        value: 1,
      },
      {
        id: "1",
        name: "cat",
        address: "0x14efa0d4b0f9850ba1787edc730324962446d7cc",
        value: 1,
      },
      {
        id: "1",
        name: "TubaDAO Pass",
        address: "0x66e2eabcf201ebaeafef27bd7fe3e62e9aacd363",
        value: 1,
      },
      {
        id: "1",
        name: "HAPE Community Badge",
        address: "0x6fa9f4b50e2950a8137a76649193816fb29dad2c",
        value: 1,
      },
      {
        id: "1",
        name: "Fire 12351",
        address: "0xa3c81f1f2598d5fb5447d95aa03f31bba7f1dd21",
        value: 1,
      },
      {
        id: "1",
        name: "Lady Apepe Yacht Club",
        address: "0xb95b47756953121c848ed2de66f4c920ab43bcc1",
        value: 1,
      },
      {
        id: "1",
        name: "0xRareApepeYachtClub",
        address: "0x68af811fb3a76a2dea8573a0306d05aeadfe0756",
        value: 1,
      },
      {
        id: "1",
        name: "0xdc09248d3dec997911ebcc2c6730764dd63e39b8",
        address: "0xdc09248d3dec997911ebcc2c6730764dd63e39b8",
        value: 1,
      },
      {
        id: "1",
        name: "Zorggle",
        address: "0x9ba596da06da0bf9105e58a792b455b7f9b15c70",
        value: 1,
      },
      {
        id: "1",
        name: "Grimes Gen 1 Avatar 27457",
        address: "0x054460490780a6eb15625d703db1754e0b78d846",
        value: 1,
      },
      {
        id: "1",
        name: "Replica, 2023",
        address: "0x27b435ccb4fe631e2f4318059b8ec69a183c9b82",
        value: 1,
      },
      {
        id: "1",
        name: "The Gatekeepers by Anon",
        address: "0xbcfbe223e61f88a2cc5b298d1f687a10c055ae40",
        value: 1,
      },
      {
        id: "1",
        name: "Introducing World App 4261",
        address: "0x4ebb2384cc1e86f578e37f2057b336b9027cb95a",
        value: 1,
      },
      {
        id: "1",
        name: "EigenLayer World Builders 11429",
        address: "0x36b73d268a441164ea0e4e5560a579573a475ebf",
        value: 1,
      },
      {
        id: "1",
        name: "Cartel Member 4276",
        address: "0x7abc4f4b015e3f23de7be8c89cd83167737a5d9d",
        value: 1,
      },
      {
        id: "1",
        name: "0xf2dc9a7ab5602afb95edc71d5aa6bbf7a56b185d",
        address: "0xf2dc9a7ab5602afb95edc71d5aa6bbf7a56b185d",
        value: 1,
      },
      {
        id: "1",
        name: "Alien",
        address: "0x4b30aacd5b2374e5eef189b57acda9cf0ab2dc60",
        value: 1,
      },
      {
        id: "1",
        name: "0x3539ac68bc96fc1f470d7739a49bbbf3d321fd5d",
        address: "0x3539ac68bc96fc1f470d7739a49bbbf3d321fd5d",
        value: 1,
      },
      {
        id: "1",
        name: "Rabby Desktop Genesis 18538",
        address: "0x1645787ddcb380932130f0d8c22e6bf53a38e725",
        value: 1,
      },
      {
        id: "1",
        name: "ERROR",
        address: "0x0c71c4e0e16ba9225f89337718ac46f64ac46851",
        value: 1,
      },
      {
        id: "1",
        name: "6740.ethscriptions.eth",
        address: "0xd4416b13d2b3a9abae7acd5d6c2bbdbe25686401",
        value: 1,
      },
      {
        id: "1",
        name: "Introducing Worldcoin 3008",
        address: "0x6e60bcdf52078a250932cf9fec174c5f67348845",
        value: 1,
      },
      {
        id: "1",
        name: "This Artwork Is Subject To Change",
        address: "0x6609e542e0626bc3fc2110f0ead172030fbe97ab",
        value: 1,
      },
      {
        id: "1",
        name: "Comet Explorer",
        address: "0xdfb848b573e0ba3a7c6b82af22db7a81f196f4c9",
        value: 1,
      },
      {
        id: "1",
        name: "Black Meta Multipass",
        address: "0x0389ca91dbc41d828f7d25347afc23610ad8a16d",
        value: 1,
      },
      {
        id: "1",
        name: "Shit",
        address: "0x26454a066c7b4220f9d9a396606e5a1c809362e4",
        value: 1,
      },
      {
        id: "1",
        name: "Invisible Freakz",
        address: "0xe57ad2dec4a0a43e25f89813e7bd442d5e9f6995",
        value: 1,
      },
      {
        id: "1",
        name: "0x9185a69970a150ec9d0dea6f18e62f40db9e94d2",
        address: "0x9185a69970a150ec9d0dea6f18e62f40db9e94d2",
        value: 1,
      },
      {
        id: "1",
        name: "1142",
        address: "0x1fc86ce8f2dd923c7cd33f2609770541dd689af8",
        value: 1,
      },
      {
        id: "1",
        name: "Launch Pass",
        address: "0x5f4336f57cf41821522f1777321462b108de55c2",
        value: 1,
      },
      {
        id: "1",
        name: "BUMONOMYED",
        address: "0xca55e77ea8a3c671ce330a6c72f0be604b797ee8",
        value: 1,
      },
      {
        id: "1",
        name: "OmniApes",
        address: "0xd2d7742b4b356ff2e76a211e784f702b3c52a55c",
        value: 1,
      },
      {
        id: "1",
        name: "raCC0ondenzas",
        address: "0x23021459669b2dc6a7a07419466868daa2753560",
        value: 1,
      },
      {
        id: "1",
        name: "Shanghai: Open Edition",
        address: "0x5f04d47d698f79d76f85e835930170ff4c4ebdb7",
        value: 1,
      },
      {
        id: "1",
        name: "The Gatekeepers by Anon",
        address: "0xd387b00bc58cf23d00433a0031adce3d8d34e9d2",
        value: 1,
      },
      {
        id: "1",
        name: "2021 Happy Holidays - Hashflow",
        address: "0x41e3d4b3a79e464f65fffe18aa063de983ef97de",
        value: 1,
      },
      {
        id: "1",
        name: "Rabbit wander",
        address: "0x899185d0f685465008185725d7c9f38426b66740",
        value: 1,
      },
      {
        id: "1",
        name: "The Rat Race",
        address: "0x61c82849091d7f2128e80b7f82d6d3003911ae6c",
        value: 1,
      },
      {
        id: "1",
        name: "eChibi 920",
        address: "0xd0489a1214b39daa6abf23628c6854539c8e39f8",
        value: 1,
      },
      {
        id: "1",
        name: "Buzzed Bear",
        address: "0x4923017f3b7fac4e096b46e401c0662f0b7e393f",
        value: 1,
      },
      {
        id: "1",
        name: "Cumulus (40x airdrop)",
        address: "0xf5de4342a4579545a7c2f6c58d80fe093427ac85",
        value: 1,
      },
      {
        id: "1",
        name: "0x938e5ed128458139a9c3306ace87c60bcba9c067",
        address: "0x938e5ed128458139a9c3306ace87c60bcba9c067",
        value: 1,
      },
      {
        id: "1",
        name: "Fall 2022: BLOC-711",
        address: "0x3ad059e4a22931e3658e69c44f36ed561dd5df17",
        value: 1,
      },
      {
        id: "1",
        name: "Clown Market",
        address: "0xabf24c41430ba5876005667a1f0ead8dcedc8c4a",
        value: 1,
      },
      {
        id: "1",
        name: "Pirate Nation - Mystery Chest",
        address: "0xd2bdd497db05622576b6cb8082fb08de042987ca",
        value: 1,
      },
      {
        id: "1",
        name: "Serenity",
        address: "0x29b4ea6b1164c7cd8a3a0a1dc4ad88d1e0589124",
        value: 1,
      },
      {
        id: "1",
        name: "Mythical.soul",
        address: "0x7ab73c2f083b2725e5b6e245e6ea945d5f3caaea",
        value: 1,
      },
      {
        id: "1",
        name: "Garbage University Student ID: 7145",
        address: "0x85c4209f7965d36742291f9222bd2cdb104df75c",
        value: 1,
      },
      {
        id: "1",
        name: "Intro to DAOs",
        address: "0xc9a42690912f6bd134dbc4e2493158b3d72cad21",
        value: 1,
      },
      {
        id: "1",
        name: "Mystery Atlantean",
        address: "0x47691834cbb96ce5fbcd1c82f3804fba63460370",
        value: 1,
      },
      {
        id: "1",
        name: "Atmos | Exordium Chapter 02",
        address: "0xebe826f0584cc5b429cb9ab0c11880e8957ddb5b",
        value: 1,
      },
      {
        id: "1",
        name: "DON'T LOOK DOWN (ft. Lizzy Land)",
        address: "0xadf8e726821ad3c97b0a1de5f58b2a9c86f0c10c",
        value: 1,
      },
      {
        id: "1",
        name: "Rainbow Zorb 41900",
        address: "0x7492e30d60d96c58ed0f0dc2fe536098c620c4c0",
        value: 1,
      },
      {
        id: "1",
        name: "117.glass",
        address: "0x28e5552e8f51de209e18cddf90d2a4f260f26216",
        value: 1,
      },
      {
        id: "1",
        name: "Mayordinals",
        address: "0x92144ec240e3f2cf694a44852c5225ed44132c6c",
        value: 1,
      },
      {
        id: "1",
        name: "Hisoka",
        address: "0x3f664a6dbd30c5896b303c8a5e8d6fb52706add8",
        value: 1,
      },
      {
        id: "1",
        name: "GoblinClan NFT Official",
        address: "0x8fcd1d3c1fae36819fd86eca6a84909534b0aa92",
        value: 1,
      },
      {
        id: "1",
        name: "Banana Gun Quest 1 - The Sniper",
        address: "0xfa7be418cb1aa1e3603059f36a7cb925c309382c",
        value: 1,
      },
      {
        id: "1",
        name: "Frame",
        address: "0x8961508f6c10d72b87a6d5d7fc1c579b84a984b8",
        value: 1,
      },
      {
        id: "1",
        name: "Legend Medal",
        address: "0x26aede53a9a3a533c4ee341922d84bc9c19dcd13",
        value: 1,
      },
      {
        id: "1",
        name: "Anticipation (of a future event)",
        address: "0x15c905dec8da0a90fa05f8121e8f8285d30ef1f4",
        value: 1,
      },
      {
        id: "1",
        name: "SBT CONVERGENCE",
        address: "0xdba6944d6b06f6f83c99baaa4d4d8c30db3f9f41",
        value: 1,
      },
      {
        id: "1",
        name: "EigenWorld",
        address: "0x8d0802559775c70fb505f22988a4fd4a4f6d3b62",
        value: 1,
      },
      {
        id: "1",
        name: "0x177f824323d3fe730720cb23e9ba95a8161e048a",
        address: "0x177f824323d3fe730720cb23e9ba95a8161e048a",
        value: 1,
      },
      {
        id: "1",
        name: "Ribbon OG",
        address: "0xf513bd4ba753548505a245be1877c39a4f0b5c96",
        value: 1,
      },
      {
        id: "1",
        name: "Pooly - Supporter 2293",
        address: "0x90b3832e2f2ade2fe382a911805b6933c056d6ed",
        value: 1,
      },
      {
        id: "1",
        name: "The Fear (Mija Cover)",
        address: "0xaa5f7158cf32b917677d104ab6dd2b9fac56f06e",
        value: 1,
      },
      {
        id: "1",
        name: "McPepe's",
        address: "0x3cf314571da3e56eaee61af2b30af56f75d3a602",
        value: 1,
      },
      {
        id: "1",
        name: "HoneyJar",
        address: "0xa20cf9b0874c3e46b344deaeea9c2e0c3e1db37d",
        value: 1,
      },
      {
        id: "1",
        name: "Stand with Crypto 27751",
        address: "0x9d90669665607f08005cae4a7098143f554c59ef",
        value: 1,
      },
      {
        id: "1",
        name: "Stelo Explorer 152",
        address: "0x82f094314407bcfff873603ee019efe9ef94e345",
        value: 1,
      },
      {
        id: "1",
        name: "Elf Wizard - 2017 Curio Card Concept",
        address: "0x8598a323a14c8ed2d6b4da9380f550d61d89b56e",
        value: 1,
      },
      {
        id: "1",
        name: "Club Pooly's (Nighttime)",
        address: "0x92b971d307ebfc7331c23429e204a5e4adf7a833",
        value: 1,
      },
      {
        id: "1",
        name: "Disciple of the Machina",
        address: "0xa766d1b50ebdbf1dde13db1f53d4a2c58ab5ec29",
        value: 1,
      },
      {
        id: "1",
        name: "Common Pass",
        address: "0xde07734c6a573371a5c88753b77e3c81055bdcc1",
        value: 1,
      },
      {
        id: "1",
        name: "HELIX - CITIZENS",
        address: "0xf6174443f1354b76248354537ce5f95d65313892",
        value: 1,
      },
      {
        id: "1",
        name: "Polyhedra 2024",
        address: "0xb7545014a3973b0d27a65ee76d1a5ee29d37b1c9",
        value: 1,
      },
      {
        id: "1",
        name: "DickPix",
        address: "0xd5b8b34644e39d9ee3f13bcae86de260ef51c6bb",
        value: 1,
      },
      {
        id: "10",
        name: "BeraFi: Bong Bears x NFTFi 127/571",
        address: "0x093312465e593c65b1f00e0ab8c5885634b2aa83",
        value: 1,
      },
      {
        id: "10",
        name: "PoolTogether Op Quest",
        address: "0xfa14e1157f35e1dad95dc3f822a9d18c40e360e2",
        value: 1,
      },
      {
        id: "10",
        name: "R.I.P. Liquidity Mining 14/500",
        address: "0xc52c79d0064056ab467417419e1d06a586876183",
        value: 1,
      },
      {
        id: "10",
        name: "Reveel Account - Beta",
        address: "0x03c0a7cb6da943de0b82c1b61af3c3a11d367f78",
        value: 1,
      },
      {
        id: "10",
        name: "The Future is Decentralized OFFICIAL",
        address: "0xbf104e65e04d53ec79aeb8d333e8897b9ff3d233",
        value: 1,
      },
      {
        id: "10",
        name: "Safe Stone – Subscriber Edition",
        address: "0xc0507025958724ff877c9c76cc7b1e4c16cf1b67",
        value: 1,
      },
      {
        id: "10",
        name: "BASEd and Optimistic",
        address: "0xe22fd22b3fc0ecd5217d2461d15159a7dfc38790",
        value: 1,
      },
      {
        id: "10",
        name: "Linea: Spring Thaw",
        address: "0x864edff094a4974ce2f665aad92e8d05ed5989cb",
        value: 1,
      },
      {
        id: "10",
        name: "Zerion Subscriber OGs",
        address: "0x93431a2e46023e0f37417304c357170b5615e138",
        value: 1,
      },
      {
        id: "10",
        name: "Bedrock",
        address: "0x1b36291ff8f503cfb4e3babe198a40398bcf54ad",
        value: 1,
      },
      {
        id: "10",
        name: "Taiko Alpha-3 Testnet is Live 10590",
        address: "0x5cd1854a24d072d235637bdc89902ebf5642088a",
        value: 1,
      },
      {
        id: "10",
        name: "berabonk overview, mission, and tokenomics!!! 75/100",
        address: "0x8eeb952fea667a9fe9513617c2a6fe58cb192aac",
        value: 1,
      },
      {
        id: "10",
        name: "Base Mainnet is Open for Builders 169",
        address: "0x092e34e00d4dbbafe6f640c3e5607647b0a6f8e9",
        value: 1,
      },
      {
        id: "10",
        name: "Base’s Security-First Approach 11266",
        address: "0x74ce067b0a0c195cd55f5458cbf217674e6c85ed",
        value: 1,
      },
      {
        id: "10",
        name: "Introducing Eclipse Mainnet: The Ethereum SVM L2 89",
        address: "0x4ee3280818f21d996e41b465775eaaa736ec2f87",
        value: 1,
      },
      {
        id: "10",
        name: "Guide to Optimism NFTs 4336/7500",
        address: "0xe9b321f1a1062ec46ed5d615d2f4acfbbb52760f",
        value: 1,
      },
      {
        id: "10",
        name: "The Base Guide to Governance Proposals 27063",
        address: "0x2a42380e1211b3edcf0e728f0541ebb2e8a3e0bd",
        value: 1,
      },
      {
        id: "10",
        name: "Introducing Vibe.xyz: $4m raised to create the paradigm shift of NFT-to-Product  295/500",
        address: "0xf9a468816263becb3d19110b206f73f9647a9f5f",
        value: 1,
      },
      {
        id: "10",
        name: "Base Beat: Newsletter",
        address: "0x9db15c3e163fb5141658a530561106b5e410c1f4",
        value: 1,
      },
      {
        id: "10",
        name: "Welcome to Ellas 17/101",
        address: "0x07cf502fe769eb5434994d77f88cbd25f6e79e48",
        value: 1,
      },
      {
        id: "10",
        name: "Claim Your Omega Edition Linea NFTs Now 3645/10000",
        address: "0x81445e3eaf01847f989745e3ccc22683f3b33eee",
        value: 1,
      },
      {
        id: "10",
        name: "Base Beat: Newsletter",
        address: "0x98dc95fe75a9d1041a8145359273e70dbade4ed9",
        value: 1,
      },
      {
        id: "10",
        name: "NFT Explorer",
        address: "0x74a002d13f5f8af7f9a971f006b9a46c9b31dabd",
        value: 1,
      },
      {
        id: "10",
        name: "How to Make and Sell Music NFTs as an Artist 4452/10000",
        address: "0xb4e9a5f2285fb8bc0935d3c39dc7c45977cca542",
        value: 1,
      },
      {
        id: "10",
        name: "Opside Validator Whitelist Round 1 - Pre Application 192/500",
        address: "0x40f63db825cbc159b73db324e3d6861e76435b7c",
        value: 1,
      },
      {
        id: "10",
        name: "Season 4: Our next experiment in community governance 1543",
        address: "0x32f79f0a0ffda9e8d31726f83844395d8a250477",
        value: 1,
      },
      {
        id: "10",
        name: "Introducing Base Camp: Learn Smart Contract Development At Your Own Pace 12993",
        address: "0xc944f918d65830125dbb43584f25ef4e3c0d10c9",
        value: 1,
      },
      {
        id: "10",
        name: "Onchain Masterpieces: Coca-Cola®'s Collection of Iconic Art 163",
        address: "0xc0ee62eabcc9e22caa882458621e87080bfc505d",
        value: 1,
      },
      {
        id: "10",
        name: '"Henlo, World!" 333/10000',
        address: "0xaff376b6a630b07b57f676a939748a321ff14734",
        value: 1,
      },
      {
        id: "10",
        name: "Synthetix, what comes next, part zero 24/500",
        address: "0x51807965c6750a5b362ffebf2676fa493ed85be7",
        value: 1,
      },
      {
        id: "10",
        name: "Contributing to the Scalability of Base and the OP Stack: A Technical Deep Dive 29591",
        address: "0xe668fefdb351d44c0e2e97ec1293624e92b2fd8c",
        value: 1,
      },
      {
        id: "10",
        name: "Polynomial Traders",
        address: "0x3f47bf627c4f7ab6a26fae2b314821acb89db1b9",
        value: 1,
      },
      {
        id: "10",
        name: "0x0110bb5739a6f82eafc748418e572fc67d854a0f",
        address: "0x0110bb5739a6f82eafc748418e572fc67d854a0f",
        value: 1,
      },
      {
        id: "10",
        name: "Prisma Finance, The end game for liquid staking tokens. 780",
        address: "0x26ab3d439428ab3a500d1a2b3f1e025e634c3946",
        value: 1,
      },
      {
        id: "10",
        name: "How to Hunt Token Airdrops With Just a Smartphone 1334/3000",
        address: "0x8057339c76850a5d878ccda831dfd1debf5230dd",
        value: 1,
      },
      {
        id: "10",
        name: "Introducing Writing NFTs 2.0 2102",
        address: "0x0e88826c69b2c920e442404e35606857d873d27d",
        value: 1,
      },
      {
        id: "10",
        name: "maryy's CoSoul",
        address: "0x47c2a56176335fb2b1ded8e7b5acb136d307dc2d",
        value: 1,
      },
      {
        id: "10",
        name: "Yeetarded Game Theory 64/69",
        address: "0xedc224c0ff3f05cfb75fd1a15926f0a2d32abc74",
        value: 1,
      },
      {
        id: "10",
        name: "Backed Community NFT",
        address: "0x63a9addf2327a0f4b71bcf9bfa757e333e1b7177",
        value: 1,
      },
      {
        id: "10",
        name: "I can hear the honey calling 128/500",
        address: "0x2c73d4e1e4874e302fad874bc13fe58dfe0c4a92",
        value: 1,
      },
      {
        id: "56",
        name: "Legendary Pandra King",
        address: "0xf250bf5953b601e42e93226f7a9e4e8b9e7435af",
        value: 1,
      },
      {
        id: "56",
        name: "SnBNB Early Adopters ⛏️",
        address: "0x6848dbcb498b32675a83e88841facfcd43ef8e32",
        value: 1,
      },
      {
        id: "56",
        name: "0x0fff7f99d2b32849848e31cb48090c5268e06f65",
        address: "0x0fff7f99d2b32849848e31cb48090c5268e06f65",
        value: 1,
      },
      {
        id: "56",
        name: "MemePigeon NFT",
        address: "0xe493628fa0197dc2688fb4e68a79534a8cdb8821",
        value: 1,
      },
      {
        id: "56",
        name: "PVU Reborn Gen 1",
        address: "0x6f1e007beb45368920fce709b1e47cc199745e98",
        value: 1,
      },
      {
        id: "56",
        name: "Tabi Artifact Chest",
        address: "0x4a37f6952ea5f91874220b0e398eeec0194393f4",
        value: 1,
      },
      {
        id: "56",
        name: "Tabi Reddit Creed",
        address: "0x1b7302d392a9cfebc7e0140403f1f960a7ee067d",
        value: 1,
      },
      {
        id: "42161",
        name: "Portikus OG: Archway Heliasts",
        address: "0x80a0974d484bc86000c78613984a3d7f9834b5c5",
        value: 1,
      },
      {
        id: "42161",
        name: "Silver Quantum Gift - Blueprint 3(Item ID: 654f6c8b98acf092a011e14e)",
        address: "0xa3abf5552cc5e1477009bbf90d0b8d2689883891",
        value: 1,
      },
      {
        id: "42161",
        name: "Arbzuki",
        address: "0xc6bdbb18717786726690c3a65e2af5c4c63887c2",
        value: 1,
      },
      {
        id: "42161",
        name: "M1 Fertilizer",
        address: "0x2152e6eb113e7cae97bbcbbdd72b165c03f6c71f",
        value: 1,
      },
      {
        id: "42161",
        name: "Trader Joe & Stargate",
        address: "0x04b5112928b7b75ec71ad9909bf0e5bcc427952b",
        value: 1,
      },
      {
        id: "42161",
        name: "Beradoge Gen 1",
        address: "0x75395f24644f1e65f66e346a414ff3412f131dd5",
        value: 1,
      },
      {
        id: "42161",
        name: "Earndrop Optimism Airdrop",
        address: "0x2b3d12a3b3a8f3f6e97ece0590a3f05880f8360d",
        value: 1,
      },
      {
        id: "42161",
        name: "Sapling",
        address: "0xdabf2de52037b517097fd999c173c447784806b2",
        value: 1,
      },
      {
        id: "42161",
        name: "Rodeo Bull Club - Green Horn  - Green Horn (NFT Buckle)",
        address: "0xbba59a5dd11fc0958f0ab802500c2929ababb956",
        value: 1,
      },
      {
        id: "42161",
        name: "Calderascope 907",
        address: "0x903bc2bd67a31aa628b18cab56bbb33cd7ce2d5c",
        value: 1,
      },
      {
        id: "42161",
        name: "Journey to Aark Digital: Engage with Aark Socials",
        address: "0x8659a4876369b94515a86048fe7f99daba6b9a7d",
        value: 1,
      },
      {
        id: "42161",
        name: "Tarochi Season 1 Pass",
        address: "0xefc6e332fdbb4afbb31abc0dad62fd6f6c95bac2",
        value: 1,
      },
      {
        id: "42161",
        name: "Duke of Florence",
        address: "0xd2cb35e060b4fd5d11e83dffe43f9c04b0dae8b9",
        value: 1,
      },
      {
        id: "42161",
        name: "Arbitrum L Makx",
        address: "0x8f68fea3fd9108c5133f61eeac407a5e525b26a5",
        value: 1,
      },
      {
        id: "1",
        name: "Pixel Vault Founder's DAO",
        address: "0xd0a07a76746707f6d6d36d9d5897b14a8e9ed493",
        value: 1,
      },
      {
        id: "1",
        name: "Shardenza Prereveal",
        address: "0xfceed70c8e9f38a0c3a0062d40d0ab06493063a1",
        value: 1,
      },
      {
        id: "1",
        name: "𝐑𝐄𝐃𝐋𝐈𝐎𝐍𝐄𝐘𝐄 𝐆𝐀𝐙𝐄𝐓𝐓𝐄",
        address: "0x7920f98733b912772f89dbdd95e221bb7e6d058f",
        value: 1,
      },
      {
        id: "1",
        name: "Sup? FOMO",
        address: "0x4898fe8a04b2b48f0617fcee551dfb95b0c00f11",
        value: 1,
      },
      {
        id: "1",
        name: "A1 Serum",
        address: "0x7ab7f10d09ae26e22bbcff5e322849be86da19a1",
        value: 1,
      },
      {
        id: "1",
        name: "SPOOKIES",
        address: "0x5e34dacda29837f2f220d3d1aeaaabd1edca5bd1",
        value: 1,
      },
      {
        id: "1",
        name: "Chill Frog",
        address: "0xa3b7cee4e082183e69a03fc03476f28b12c545a7",
        value: 1,
      },
      {
        id: "1",
        name: "Sneaky Cheetah Club",
        address: "0x4c3a2f61a4449667b7085734f24095c5f932b875",
        value: 1,
      },
      {
        id: "1",
        name: "0x7d7f6f004a421f980fc2d4522ba294eddc880a00",
        address: "0x7d7f6f004a421f980fc2d4522ba294eddc880a00",
        value: 1,
      },
      {
        id: "1",
        name: "Nefotorav",
        address: "0xfb3765e0e7ac73e736566af913fa58c3cfd686b7",
        value: 1,
      },
      {
        id: "1",
        name: "0x0bb3e1c80c0ffde985fb0ec6392aa18a1d2de40e",
        address: "0x0bb3e1c80c0ffde985fb0ec6392aa18a1d2de40e",
        value: 1,
      },
      {
        id: "1",
        name: "Naughty Tigers Costume Club",
        address: "0x990ee1df4c3047a4c94aac91a86be3c6bf40097d",
        value: 1,
      },
      {
        id: "1",
        name: "BabyLlama",
        address: "0x52d4a7906b15ce48d39eb8c7c962394b3aa2b42c",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoRug",
        address: "0x7685d54db7b41dd751ad1e1b62a62f92d3ce09be",
        value: 1,
      },
      {
        id: "1",
        name: "Bag",
        address: "0xb89a71f1abe992dc71349fc782b393da2b6fb4c2",
        value: 1,
      },
      {
        id: "1",
        name: "N",
        address: "0x05a46f1e545526fb803ff974c790acea34d1f2d6",
        value: 1,
      },
      {
        id: "1",
        name: "1314",
        address: "0x4961db588dd962abb20927aa38fa33e5225b3be2",
        value: 1,
      },
      {
        id: "1",
        name: "Lamb Duh",
        address: "0x1f0f72e6dc2ea6fde3a32a1b3fd47a26a3293dc9",
        value: 1,
      },
      {
        id: "1",
        name: "0x7d4a9ab145577ca2fd2810a08db1442c7bffea59",
        address: "0x7d4a9ab145577ca2fd2810a08db1442c7bffea59",
        value: 1,
      },
      {
        id: "1",
        name: "0xbd888e50969748805cdf77bcf283febe493f190c",
        address: "0xbd888e50969748805cdf77bcf283febe493f190c",
        value: 1,
      },
      {
        id: "1",
        name: "Full Body Mutant",
        address: "0xfdf4b4e70f90d431ab4672fef3be02e942c064bb",
        value: 1,
      },
      {
        id: "1",
        name: "Art for N",
        address: "0xb2ee306f1c8d314341b7c335014473aa8c2d5d71",
        value: 1,
      },
      {
        id: "1",
        name: "Nightkids Dream Membership",
        address: "0x83b7261db8c795701c6fc86d1fcd073ece940e10",
        value: 1,
      },
      {
        id: "1",
        name: "Sipher INU",
        address: "0x9c57d0278199c931cf149cc769f37bb7847091e7",
        value: 1,
      },
      {
        id: "1",
        name: "Coin Bender",
        address: "0xa0c38108bbb0f5f2fb46a2019d7314cce38f3f22",
        value: 1,
      },
      {
        id: "1",
        name: "PRSN",
        address: "0xbabafdd8045740449a42b788a26e9b3a32f88ac1",
        value: 1,
      },
      {
        id: "1",
        name: "Lost Pixels For N",
        address: "0xa42cad2e9a408ba55dd73068f632f6b5c9a0fc8c",
        value: 1,
      },
      {
        id: "1",
        name: "THEOS Strategy Droid B-4670",
        address: "0xa6794dec66df7d8b69752956df1b28ca93f77cd7",
        value: 1,
      },
      {
        id: "1",
        name: "Settlement",
        address: "0xdecc60000ba66700a009b8f9f7d82676b5cfa88a",
        value: 1,
      },
      {
        id: "1",
        name: "Sipher NEKO",
        address: "0x09e0df4ae51111ca27d6b85708cfb3f1f7cae982",
        value: 1,
      },
      {
        id: "1",
        name: "RKL Sneakers",
        address: "0x5180f2a553e76fac3cf019c8011711cf2b5c6035",
        value: 1,
      },
      {
        id: "1",
        name: "Hyperbole",
        address: "0xb80fbf6cdb49c33dc6ae4ca11af8ac47b0b4c0f3",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoPochi",
        address: "0x11111111384122718f7a44d48290bb70a3a9f793",
        value: 1,
      },
      {
        id: "1",
        name: "Kong",
        address: "0xef0182dc0574cd5874494a120750fd222fdb909a",
        value: 1,
      },
      {
        id: "42161",
        name: "heart + craft",
        address: "0x47a91457a3a1f700097199fd63c039c4784384ab",
        value: 1,
      },
      {
        id: "42161",
        name: "Bera Key",
        address: "0xc38f5a1aa46853be3bfbfcf00562e01856867ba7",
        value: 1,
      },
      {
        id: "56",
        name: "PreSend Retail Investors",
        address: "0x1615600fe62ed38342f82eb9785029a2b1290daf",
        value: 1,
      },
      {
        id: "1",
        name: "dotdotdot 2333",
        address: "0xce25e60a89f200b1fa40f6c313047ffe386992c3",
        value: 1,
      },
      {
        id: "1",
        name: "Unrevealed Raft",
        address: "0x6af88a2b51d37dd80b59cda3aaac55ee34c6ea07",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoBeasts Skape",
        address: "0xa74e199990ff572a320508547ab7f44ea51e6f28",
        value: 1,
      },
      {
        id: "1",
        name: "Metasaurs",
        address: "0xf7143ba42d40eaeb49b88dac0067e54af042e963",
        value: 1,
      },
      {
        id: "1",
        name: "Kiwami",
        address: "0x701a038af4bd0fc9b69a829ddcb2f61185a49568",
        value: 1,
      },
      {
        id: "1",
        name: "Castaway",
        address: "0xde721b3c38cbfabcdfcc29f0bc320efeb5c245ef",
        value: 1,
      },
      {
        id: "1",
        name: "The Block Times Community Key",
        address: "0x49c358afee381d32582700cbdd7e9746dc341973",
        value: 1,
      },
      {
        id: "1",
        name: "NFTHUD Member",
        address: "0xe34c28c7dc4fa20ceb7a9268345e83a5c7060136",
        value: 1,
      },
      {
        id: "1",
        name: "Laelaps Master Key",
        address: "0x691c77f69a6ae05f5c8cc9f46d7e46ce97fa2f3b",
        value: 1,
      },
      {
        id: "1",
        name: "Slot 297",
        address: "0x5138db27d140a3d44f23c549592322334c94f062",
        value: 1,
      },
      {
        id: "1",
        name: "Moon Protocol: Uniswap (01-11)",
        address: "0x69048fe9b3dfdf9fa6420617fa1acf2619696694",
        value: 1,
      },
      {
        id: "1",
        name: "Hikari",
        address: "0x01ea0a1c4cf5d6d948320ff16b1b6b972626e599",
        value: 1,
      },
      {
        id: "1",
        name: "0xcd17b6bd9dda3c703a3dcdda3e1178997802af1f",
        address: "0xcd17b6bd9dda3c703a3dcdda3e1178997802af1f",
        value: 1,
      },
      {
        id: "1",
        name: "RebelBot",
        address: "0xbbe23e96c48030dc5d4906e73c4876c254100d33",
        value: 1,
      },
      {
        id: "1",
        name: "Ether Cards Founder 9084",
        address: "0x97ca7fe0b0288f5eb85f386fed876618fb9b8ab8",
        value: 1,
      },
      {
        id: "1",
        name: "DEGEN",
        address: "0x986aea67c7d6a15036e18678065eb663fc5be883",
        value: 1,
      },
      {
        id: "1",
        name: "YOLO",
        address: "0x3a921bf2c96cb60d49aff09110a9f836c295713a",
        value: 1,
      },
      {
        id: "1",
        name: "Superuser Genesis Pass",
        address: "0xc97a4c9773ebfbba0f32ff147b9b29972aba0b38",
        value: 1,
      },
      {
        id: "1",
        name: "Template Token",
        address: "0x3a0335409a0becd0da1ff6e442b9b6874d4e87a1",
        value: 1,
      },
      {
        id: "1",
        name: "Dart Art Abstract",
        address: "0x01a5e3268e3987f0ee5e6eb12fe63fa2af992d83",
        value: 1,
      },
      {
        id: "1",
        name: "Farm Land",
        address: "0x5c1a0cc6dadf4d0fb31425461df35ba80fcbc110",
        value: 1,
      },
      {
        id: "1",
        name: "Museum Punk",
        address: "0x95ab7a1f8cf303a9724e077b34483372907e0701",
        value: 1,
      },
      {
        id: "1",
        name: "Royalty",
        address: "0x9f803635a5af311d9a3b73132482a95eb540f71a",
        value: 1,
      },
      {
        id: "1",
        name: "AFTERORDER - Kalduk",
        address: "0x6d198a396f6b51d8f539ed76168d2f19ab8f72aa",
        value: 1,
      },
      {
        id: "1",
        name: "Shabu Town Shiba",
        address: "0x743f80dc76f862a27598140196cc610006b2be68",
        value: 1,
      },
      {
        id: "1",
        name: "Ordinal Abstract",
        address: "0xa77cd337315cd59bcf204284588249286af7655d",
        value: 1,
      },
      {
        id: "1",
        name: "Wojakian",
        address: "0x5e198af285388ba69bd2475a2c60ed9a9b55098a",
        value: 1,
      },
      {
        id: "1",
        name: "WarGames by FAR",
        address: "0xed1d730ceaae6de14a5e48ff418192687195871c",
        value: 1,
      },
      {
        id: "1",
        name: "WonderPal",
        address: "0x3acce66cd37518a6d77d9ea3039e00b3a2955460",
        value: 1,
      },
      {
        id: "1",
        name: "UINTS 32991",
        address: "0x7c10c8816575e8fdfb11463dd3811cc794a1d407",
        value: 1,
      },
      {
        id: "1",
        name: "[R.A.W] Warrior",
        address: "0x15d2c0cd69ecc78334f55f1395ca46481246aace",
        value: 1,
      },
      {
        id: "1",
        name: "Genesis Pass",
        address: "0xc113400f83514c8f1924d6cf3cc7fec475800ccd",
        value: 1,
      },
      {
        id: "1",
        name: "0x549d38f104ac46d856c1b2bf2a20d170efdb2a8d",
        address: "0x549d38f104ac46d856c1b2bf2a20d170efdb2a8d",
        value: 1,
      },
      {
        id: "1",
        name: "Uniswap Background",
        address: "0xb644476e44a797db3b8a6a16f2e63e8d5a541b67",
        value: 1,
      },
      {
        id: "1",
        name: '"Gimme The Loot!" Box',
        address: "0x64feedfa14ca8fe8a366ac83e5c5788febd76eb9",
        value: 1,
      },
      {
        id: "1",
        name: "The Association NFT",
        address: "0xd7bea2b69c7a1015aadaa134e564eee6d34149c0",
        value: 1,
      },
      {
        id: "1",
        name: "Castaway",
        address: "0x7099fa90b98efe3079a9105576d0c03a1d933377",
        value: 1,
      },
      {
        id: "1",
        name: "The Association NFT",
        address: "0x9b8b9c7c02be0bd0aa4d669bf6a1f6003424c6dc",
        value: 1,
      },
      {
        id: "1",
        name: "Moonshot",
        address: "0x70be4e3761188d0a8c525e54bb81c4ea97712de4",
        value: 1,
      },
      {
        id: "1",
        name: "0x4ba0625052a8604e9d4fedb1728316a31e5506fd",
        address: "0x4ba0625052a8604e9d4fedb1728316a31e5506fd",
        value: 1,
      },
      {
        id: "1",
        name: "Pencil",
        address: "0x7eba6418388cac0b81c26f9b76d7ea6877bf8308",
        value: 1,
      },
      {
        id: "1",
        name: "3Landers",
        address: "0xb4d06d46a8285f4ec79fd294f78a881799d8ced9",
        value: 1,
      },
      {
        id: "1",
        name: "INIT SPACE",
        address: "0x02d91986f0c2b02830bdfc022f0da83529b78334",
        value: 1,
      },
      {
        id: "1",
        name: "Valentine",
        address: "0x6c869a43a9d362ef870d75dae56a01887578421d",
        value: 1,
      },
      {
        id: "1",
        name: "Sogette 7083",
        address: "0xe90d8fb7b79c8930b5c8891e61c298b412a6e81a",
        value: 1,
      },
      {
        id: "1",
        name: "Access Pass",
        address: "0x413788815307ce10428c624ed20998e2c35bbf2d",
        value: 1,
      },
      {
        id: "1",
        name: "Supercute World",
        address: "0xb334a4eb0a2d6cc24fd451e779c002b9b33228c3",
        value: 1,
      },
      {
        id: "1",
        name: "Dark Taverns",
        address: "0x4510ef604e0595f7151adcba0b958d39b8b16d40",
        value: 1,
      },
      {
        id: "1",
        name: "Death Row Mix: Vol. 1",
        address: "0x37a03d4af1d7046d1126987b20117a0fdcbf6535",
        value: 1,
      },
      {
        id: "1",
        name: "DEEPOBJECTS.ai - Strand",
        address: "0x5f93eff82825323cb8db096fda2abdb9d43c1720",
        value: 1,
      },
      {
        id: "1",
        name: "FWM!",
        address: "0x725ec751ab18192dadda654f2e60f8a964ce7d58",
        value: 1,
      },
      {
        id: "1",
        name: "Page",
        address: "0xa7206d878c5c3871826dfdb42191c49b1d11f466",
        value: 1,
      },
      {
        id: "1",
        name: "0581",
        address: "0xf17cb8dd05ff95510d8dad69c0801db49a90bba1",
        value: 1,
      },
      {
        id: "1",
        name: "HAHA PEW PEW",
        address: "0x11b3cf25f300b8ec587dfc349d419b5181084909",
        value: 1,
      },
      {
        id: "1",
        name: "Anonthology",
        address: "0x0d580638a7678980f276a10c3adfef775b62795c",
        value: 1,
      },
      {
        id: "1",
        name: "Collective Strangers",
        address: "0xa95cccbca85d4bb99549ec09e3d83ce1e88988ae",
        value: 1,
      },
      {
        id: "1",
        name: "🏴  247/1000",
        address: "0x2040c9c6691a732ad127fc054474efc31fbfc5f1",
        value: 1,
      },
      {
        id: "1",
        name: "surrender.",
        address: "0x3968a5679b86306923b7c9c4f45f0afd54683277",
        value: 1,
      },
      {
        id: "1",
        name: "FAKEOUT [PROD. SUPAH MARIO]",
        address: "0x7fe7e25b95d9976ec716f85dd3868884b69a816a",
        value: 1,
      },
      {
        id: "1",
        name: "Treasure Chest",
        address: "0x94693c9e342f759272d6f7b481703df8e83b1818",
        value: 1,
      },
      {
        id: "1",
        name: "Order and Chaos",
        address: "0x4acea6b489e84602b44bbe17ab80302c15adcd39",
        value: 1,
      },
      {
        id: "1",
        name: "I CAN'T BREATHE",
        address: "0xd69e70fcf53484b7e2c97987fa8ae57e5d3996eb",
        value: 1,
      },
      {
        id: "1",
        name: "Medium",
        address: "0xf7e47f61ba16b139f1ef7437651f675fd65e40ce",
        value: 1,
      },
      {
        id: "1",
        name: "Pepesaur's 1st Anniversary",
        address: "0xcb6768a968440187157cfe13b67cac82ef6cc5a4",
        value: 1,
      },
      {
        id: "1",
        name: "Blue",
        address: "0xedfc4f35060de1a30e08b0d8b9986a4adbdf6c59",
        value: 1,
      },
      {
        id: "1",
        name: "Last Tears",
        address: "0xd375749b73e014485c689dec691100242db8e5eb",
        value: 1,
      },
      {
        id: "1",
        name: "Snacks 638",
        address: "0x6a613a674963d6039a6a6aead6d97f8b5f127b17",
        value: 1,
      },
      {
        id: "1",
        name: "Afterorder Manga Chapter 1",
        address: "0xf7c305b6221c2641bd12e9c2107c47af5f17a31e",
        value: 1,
      },
      {
        id: "1",
        name: "Song 04 - Champagne Wishes Pt. 1 - Liquid Density",
        address: "0x62dccdd4fb1e68070b40f9fed4e99b94af2160f5",
        value: 1,
      },
      {
        id: "1",
        name: "Bloomin' Bud",
        address: "0xd79b945c14b4803de79d662e55afc56e6a6a6796",
        value: 1,
      },
      {
        id: "1",
        name: "Supercute ⚡️ Cutecoin",
        address: "0x2b256f7c4ff803a512dd3cc72dd0411c52981d07",
        value: 1,
      },
      {
        id: "1",
        name: "CityDAO Citizen",
        address: "0x7eef591a6cc0403b9652e98e88476fe1bf31ddeb",
        value: 1,
      },
      {
        id: "1",
        name: "The End Is Here",
        address: "0xce4aeed4a135aa2a9f6a04aaa68516d2f89a9697",
        value: 1,
      },
      {
        id: "1",
        name: "Cyborg Undead",
        address: "0xaad5995f9a343b35c5de2be75ac007c89561074b",
        value: 1,
      },
      {
        id: "1",
        name: "Memory City",
        address: "0x5aa92743846d5bb1e366af3325bfe717295c2e80",
        value: 1,
      },
      {
        id: "1",
        name: "a letter to you",
        address: "0xcced1df84f70048eaa13a098acab5d144d70c2a5",
        value: 1,
      },
      {
        id: "1",
        name: "Derpy",
        address: "0xbc1e44df6a4c09f87d4f2500c686c61429eea112",
        value: 1,
      },
      {
        id: "1",
        name: "Gummy Bear",
        address: "0xf32e1bde889ecf672ffae863721c8f7d280f853b",
        value: 1,
      },
      {
        id: "1",
        name: "World",
        address: "0xf53b18570db14c1e7dbc7dc74538c48d042f1332",
        value: 1,
      },
      {
        id: "1",
        name: "EthRainbow",
        address: "0xd85c10dd67339e5e68bf85312075271ad74f3e79",
        value: 1,
      },
      {
        id: "1",
        name: "Canada AI30",
        address: "0x32a984f84e056b6e553cd0c3729fddd2d897769c",
        value: 1,
      },
      {
        id: "1",
        name: "z1",
        address: "0xa51c5e7f5ab0699a4cc801651225ca33f30406f5",
        value: 1,
      },
      {
        id: "1",
        name: "CYBERPUNKS WORLD",
        address: "0x92e75761da2f7be030a0565b1153a33b29c1aa43",
        value: 1,
      },
      {
        id: "1",
        name: "Scare Squad",
        address: "0x050c2a38bcd6d7082e992d0fbd8e131e7a6d1f89",
        value: 1,
      },
      {
        id: "1",
        name: "Settlement",
        address: "0xc0981df196dc6c6fb8673b912b07956256d7e9ff",
        value: 1,
      },
      {
        id: "1",
        name: "Panda",
        address: "0x8e0543eacd5078ba9db88f34e2cbc24b7c2eb790",
        value: 1,
      },
      {
        id: "1",
        name: "SpaceCase",
        address: "0xd987c5800ef371844ceac3d0ee29e4ff29162d7c",
        value: 1,
      },
      {
        id: "1",
        name: "Crypto Tuner",
        address: "0x6e9ce8c208393244b7adbbe09e3cbb8be1cf1034",
        value: 1,
      },
      {
        id: "1",
        name: "Zunk 18021",
        address: "0x031920cc2d9f5c10b444fd44009cd64f829e7be2",
        value: 1,
      },
      {
        id: "1",
        name: "Direwolf",
        address: "0x8a5a8daeadc99ea86cffed5f65fecd34228df388",
        value: 1,
      },
      {
        id: "1",
        name: "Storyblock",
        address: "0xb7e17b0a6f56165b722b4ac8bba8f2c672c7b73b",
        value: 1,
      },
      {
        id: "1",
        name: "PsychoPunk",
        address: "0xa8bdf98e632e9d223dea24ce0b7f4d7c035170d6",
        value: 1,
      },
      {
        id: "1",
        name: "Graceful Dense Floater",
        address: "0x3769c5700da07fe5b8eee86be97e061f961ae340",
        value: 1,
      },
      {
        id: "1",
        name: "Degenz",
        address: "0xfb9e9e7150ccebfe42d58de1989c5283d0eaab2e",
        value: 1,
      },
      {
        id: "1",
        name: "Lofi Lofts",
        address: "0x248a74f64bbf422dae243ed5d58ef0dd7298b972",
        value: 1,
      },
      {
        id: "1",
        name: "blockface",
        address: "0x8ab89e0191f71903f97709d4b4653922d62e6bfb",
        value: 1,
      },
      {
        id: "1",
        name: "0x6fecaa110f74c8181e4a90285b1065be32596c9d",
        address: "0x6fecaa110f74c8181e4a90285b1065be32596c9d",
        value: 1,
      },
      {
        id: "1",
        name: "Nue Geo",
        address: "0xa8d235b3a1433cc7e6046973c1ce1994e6f14eea",
        value: 1,
      },
      {
        id: "1",
        name: "iso",
        address: "0x31eaa2e93d7afd237f87f30c0dbd3adeb9934f1b",
        value: 1,
      },
      {
        id: "1",
        name: "0x2ee6af0dff3a1ce3f7e3414c52c48fd50d73691e",
        address: "0x2ee6af0dff3a1ce3f7e3414c52c48fd50d73691e",
        value: 1,
      },
      {
        id: "1",
        name: "Quadratic Funding Open Edition 1340",
        address: "0x363c5dc3ff5a93c9ab1ec54337d211148e10f567",
        value: 1,
      },
      {
        id: "1",
        name: "Silky Suit-0",
        address: "0x7465d075c461e125c11f883c20a738c8ff19e757",
        value: 1,
      },
      {
        id: "1",
        name: "Rebel",
        address: "0x49fdbfa1126638ce7ef2ca1a0f7759109f12595d",
        value: 1,
      },
      {
        id: "1",
        name: "Fly Frog 6498",
        address: "0x31d4da52c12542ac3d6aadba5ed26a3a563a86dc",
        value: 1,
      },
      {
        id: "1",
        name: "Carbon RainDrop 29",
        address: "0xa9f237aee1b3bf78e1a93b8b5067619765c4dcba",
        value: 1,
      },
      {
        id: "1",
        name: "Stray Cat",
        address: "0x25baabaf41ce56565f448c6f6e16d44399812cad",
        value: 1,
      },
      {
        id: "1",
        name: "854",
        address: "0xa2dbd9e7e2969db08b6a8c6cbc9d002663e70147",
        value: 1,
      },
      {
        id: "1",
        name: "Stash",
        address: "0x9e5930272f5434dbdc12f918c1ba5198677dc6dc",
        value: 1,
      },
      {
        id: "1",
        name: "The Wizard's Hat Premiere 396",
        address: "0x21bb74bb4aab5b28eb845359f6e21a40c047ccbe",
        value: 1,
      },
      {
        id: "1",
        name: "omni_y",
        address: "0x41b40ca7b25e9014237690b05e7ed8d3c5edd362",
        value: 1,
      },
      {
        id: "1",
        name: "rum0rs 44",
        address: "0x06c61f83f443645d4f68343ebb5a02a14ac77a16",
        value: 1,
      },
      {
        id: "1",
        name: "0x3248e8ba90facc4fdd3814518c14f8cc4d980e4b",
        address: "0x3248e8ba90facc4fdd3814518c14f8cc4d980e4b",
        value: 1,
      },
      {
        id: "1",
        name: "Community PornNFT",
        address: "0xf6480475d503b91128477e6fe85c9841db4368fa",
        value: 1,
      },
      {
        id: "1",
        name: "MoonFlower",
        address: "0x8600d97b5dfa63d3e9a5e82d0257f97ee1e7bece",
        value: 1,
      },
      {
        id: "1",
        name: "[Gold] Maker Maggie -",
        address: "0x4ad4455ad5ef891695c221e8e683efa65fabede0",
        value: 1,
      },
      {
        id: "1",
        name: "Relentless LifeMap",
        address: "0xcd4c7819a017da7b726c825da21b1ce0c7280edc",
        value: 1,
      },
      {
        id: "1",
        name: "778",
        address: "0x3aa2139f828b3a111cc62887a915cc2d2856a74f",
        value: 1,
      },
      {
        id: "1",
        name: "Lushsux",
        address: "0x0b15727723690295a7981f12cf49b706a3eb555f",
        value: 1,
      },
      {
        id: "1",
        name: "0xdf9aa1012fa49dc1d2a306e3e65ef1797d2b5fbb",
        address: "0xdf9aa1012fa49dc1d2a306e3e65ef1797d2b5fbb",
        value: 1,
      },
      {
        id: "1",
        name: "Voxel Ville",
        address: "0x31c823260528ba98e3bf797b2add2302af097392",
        value: 1,
      },
      {
        id: "1",
        name: "0x974a46cfdf5018258e48f4506ce062691cda2936",
        address: "0x974a46cfdf5018258e48f4506ce062691cda2936",
        value: 1,
      },
      {
        id: "1",
        name: "0xb5068f4f23ce76f6f9e789e39b390de176a21e7f",
        address: "0xb5068f4f23ce76f6f9e789e39b390de176a21e7f",
        value: 1,
      },
      {
        id: "1",
        name: "EtherFreaker",
        address: "0x3a275655586a049fe860be867d10cdae2ffc0f33",
        value: 1,
      },
      {
        id: "1",
        name: "GARBAGE FIRE! (W REO CRAGUN & DLG.)",
        address: "0xbc0158b303b06bf3babe5e048e5de11f84f4634d",
        value: 1,
      },
      {
        id: "1",
        name: "Uniswap Emerald 4356",
        address: "0x1d2fc977cc1e1fbd57a8b7f81fcd5d541d8531dd",
        value: 1,
      },
      {
        id: "1",
        name: "Uniqly NFT-shirt",
        address: "0xecaab68e0d903067ebb89a0fefa6332ab93f7408",
        value: 1,
      },
      {
        id: "1",
        name: "Beefy Bloke",
        address: "0xe31e380cd0b6417ca72f82a15c17d6869c82739d",
        value: 1,
      },
      {
        id: "1",
        name: "Arch0",
        address: "0x550cb8e52ddf63114c26b8c673ae8fb5d7df2407",
        value: 1,
      },
      {
        id: "1",
        name: "Arc8 GameFest Pass | November '23",
        address: "0x1fe1ffffef6b4dca417d321ccd37e081f604d1c7",
        value: 1,
      },
      {
        id: "1",
        name: "lofi tape",
        address: "0x183bad0dc2958649823abcf16b9a5b6b653c98b5",
        value: 1,
      },
      {
        id: "1",
        name: "Waveblock",
        address: "0x90bae7c0d86b2583d02c072d45bd64ace0b8db86",
        value: 1,
      },
      {
        id: "1",
        name: "$mol Dollar 10701021030040307",
        address: "0xf9267911480fb5ce2ff2b4deb1295d9b2ab5bb69",
        value: 1,
      },
      {
        id: "1",
        name: "Dynamic Dueler",
        address: "0xa55130dca268e28aca298b12454f7612ae4910a3",
        value: 1,
      },
      {
        id: "1",
        name: "0x70c8eb24c5a2a429c635886a433571ee70a93db3",
        address: "0x70c8eb24c5a2a429c635886a433571ee70a93db3",
        value: 1,
      },
      {
        id: "1",
        name: "Werewulfz",
        address: "0x79471bb4cbb351a17fa1eadb5b77aa76795c423a",
        value: 1,
      },
      {
        id: "1",
        name: "Monarch",
        address: "0xc729ce9bf1030fbb639849a96fa8bbd013680b64",
        value: 1,
      },
      {
        id: "1",
        name: "Dice",
        address: "0x4cec6dca972bb810a1af1ef3c8366b22b390c5bc",
        value: 1,
      },
      {
        id: "1",
        name: "NEONPUNK",
        address: "0xf0ed050306c5f02ed9b579d7c4569f0cb87b6e12",
        value: 1,
      },
      {
        id: "1",
        name: "0xa58723e04af0e1c38213036b321e1243f8e16336",
        address: "0xa58723e04af0e1c38213036b321e1243f8e16336",
        value: 1,
      },
      {
        id: "1",
        name: "Silky Suit-0",
        address: "0x2090f5396b129c48d1d9d3e005e92936295f0aab",
        value: 1,
      },
      {
        id: "1",
        name: "0x812701d9ba747c01f9b94655de6fd4f089d76cb5",
        address: "0x812701d9ba747c01f9b94655de6fd4f089d76cb5",
        value: 1,
      },
      {
        id: "1",
        name: "Metasaurs Mini",
        address: "0xc342af57beb992957a63e912c4f2ef8229e4b46e",
        value: 1,
      },
      {
        id: "1",
        name: "3D Generativemasks",
        address: "0xd2c80a37aaa39f1ba76d5bb9ef809daa06716a02",
        value: 1,
      },
      {
        id: "1",
        name: "MORE MORE MORE",
        address: "0xfcd7cce82e24ec6f2a6afba2226533df8672050f",
        value: 1,
      },
      {
        id: "1",
        name: "Jackie Chan Pepe .Blue",
        address: "0xe817c927f34b3c8db9322fe03599bf2707a4491a",
        value: 1,
      },
      {
        id: "1",
        name: "0x87acae6df21385a74ed4fb55a1a29354e9bdc6c1",
        address: "0x87acae6df21385a74ed4fb55a1a29354e9bdc6c1",
        value: 1,
      },
      {
        id: "1",
        name: "Unlock Key",
        address: "0x9b4465894f818cac31e9ceb49a08bf41193d7e65",
        value: 1,
      },
      {
        id: "1",
        name: "Generativemasks",
        address: "0x80416304142fa37929f8a4eee83ee7d2dac12d7c",
        value: 1,
      },
      {
        id: "1",
        name: "Circleorzo",
        address: "0x0ae3c3a1504e41a6877de1b854c000ec64894bea",
        value: 1,
      },
      {
        id: "1",
        name: "Char0",
        address: "0xd44b96c6b4778cc652d91f1e4f1933517354febb",
        value: 1,
      },
      {
        id: "1",
        name: "Granate Pink",
        address: "0x10a7ecf97c46e3229fe1b801a5943153762e0cf0",
        value: 1,
      },
      {
        id: "1",
        name: "Stoner Cats",
        address: "0xd4d871419714b778ebec2e22c7c53572b573706e",
        value: 1,
      },
      {
        id: "1",
        name: "0xca61ad7aae3afbc15c2ba618612ffa2c2265c821",
        address: "0xca61ad7aae3afbc15c2ba618612ffa2c2265c821",
        value: 1,
      },
      {
        id: "1",
        name: "MultiPass",
        address: "0x22ca6c273d2d8be5bb11e762741efd67acdd3315",
        value: 1,
      },
      {
        id: "1",
        name: "Leviathan",
        address: "0xee52c053e091e8382902e7788ac27f19bbdfeedc",
        value: 1,
      },
      {
        id: "1",
        name: "BASTARD GAN PUNK V2",
        address: "0x31385d3520bced94f77aae104b406994d8f2168c",
        value: 1,
      },
      {
        id: "1",
        name: "EtherTulip",
        address: "0xd5fbd81cef9aba7464c5f17e529444918a8ecc57",
        value: 1,
      },
      {
        id: "1",
        name: "Brand New Second Hand Jesus In Stereo",
        address: "0xcb6b570b8aeabe38b449aff31f901b8e1b91e396",
        value: 1,
      },
      {
        id: "1",
        name: "Ethereans Official 933",
        address: "0xfd3fd9b793bac60e7f0a9b9fb759db3e250383cb",
        value: 1,
      },
      {
        id: "1",
        name: "State of Sound Vol. 1",
        address: "0x21768a5ffad9f1f64739fb37561846bc8f2fc8fd",
        value: 1,
      },
      {
        id: "1",
        name: "Good Jaime Coordination Bot",
        address: "0x82c7c02a52b75387db14fa375938496cbb984388",
        value: 1,
      },
      {
        id: "1",
        name: "t3rm.dev",
        address: "0x4655f41dea823d556f237dc23691a748b7ea5697",
        value: 1,
      },
      {
        id: "1",
        name: "0x18a276a01ce77057372f220e16ab3b44fed96288",
        address: "0x18a276a01ce77057372f220e16ab3b44fed96288",
        value: 1,
      },
      {
        id: "1",
        name: "Another Life by Violetta Zironi",
        address: "0x328b49c56a8a15fb34ab3ecd8883fac5f9512453",
        value: 1,
      },
      {
        id: "1",
        name: "Punk Stats",
        address: "0x985e5b415de11fc9c884ddceaaac657853044622",
        value: 1,
      },
      {
        id: "1",
        name: "Map",
        address: "0x8236afc3447c55a499dc62d62080321563d47342",
        value: 1,
      },
      {
        id: "1",
        name: "0xfa9937555dc20a020a161232de4d2b109c62aa9c",
        address: "0xfa9937555dc20a020a161232de4d2b109c62aa9c",
        value: 1,
      },
      {
        id: "1",
        name: "0xd73d8a44fd42b1a4b3a89c8a54f2bba3867a91be",
        address: "0xd73d8a44fd42b1a4b3a89c8a54f2bba3867a91be",
        value: 1,
      },
      {
        id: "1",
        name: "Swaggy Whales",
        address: "0x2b4d04339798ddb02bc376e1d8a7ebd72c64dbce",
        value: 1,
      },
      {
        id: "1",
        name: "NAVVAL 20/33",
        address: "0xf3ed088782e704d07159069662ac4c1bc13e6a89",
        value: 1,
      },
      {
        id: "1",
        name: "DeletedMessage",
        address: "0x066a1d0f1e228d945eb4d0855a6ced5f15f40f3f",
        value: 1,
      },
      {
        id: "1",
        name: "Gypsy Heart Mintpass",
        address: "0xdf4b0e27c0fc6d518770ce6e3f243e36d50125e8",
        value: 1,
      },
      {
        id: "1",
        name: "Prometheus Pass (Gold)",
        address: "0xc2c0fb5194cd13f282005f49c40613040ef685a4",
        value: 1,
      },
      {
        id: "1",
        name: "CyberKong VX",
        address: "0x7ea3cca10668b8346aec0bf1844a49e995527c8b",
        value: 1,
      },
      {
        id: "1",
        name: "Island",
        address: "0xb74137c48166dde6e306d0b9916be680b52af2a1",
        value: 1,
      },
      {
        id: "1",
        name: "Ascended Ape No. 0052",
        address: "0xdd407a053fa45172079916431d06e8e07f655042",
        value: 1,
      },
      {
        id: "1",
        name: "Toshie",
        address: "0x1562e3428ed1d6cdbdb1695cc505aba33ab4ea5e",
        value: 1,
      },
      {
        id: "1",
        name: "0xef9c21e3ba31a74910fc7e7cb3fc814ad842ad6e",
        address: "0xef9c21e3ba31a74910fc7e7cb3fc814ad842ad6e",
        value: 1,
      },
      {
        id: "1",
        name: "MANTLE: Airdrop Recipient",
        address: "0x08c30597f28478dd2dab657cf91d1c62c9eac450",
        value: 1,
      },
      {
        id: "1",
        name: "Washington",
        address: "0xa9cb55d05d3351dcd02dd5dc4614e764ce3e1d6e",
        value: 1,
      },
      {
        id: "1",
        name: "0x9abb7bddc43fa67c76a62d8c016513827f59be1b",
        address: "0x9abb7bddc43fa67c76a62d8c016513827f59be1b",
        value: 1,
      },
      {
        id: "1",
        name: "Space Dino",
        address: "0x5aa140dd5b946687e38d5f5ac4ef9e7b0154eff6",
        value: 1,
      },
      {
        id: "1",
        name: "DigiDaigaku Villains",
        address: "0x97abea635efdaf4cdc844b8677623cac8d776814",
        value: 1,
      },
      {
        id: "1",
        name: "goblinchest.wtf Mint Pass",
        address: "0x7b05bb2f59d8ab1c1376783be326ed8a09e91181",
        value: 1,
      },
      {
        id: "1",
        name: "Deeep Quantum 13",
        address: "0x8dfb3f483be6e8d668a10fb56d69e4b8bf3581b5",
        value: 1,
      },
      {
        id: "1",
        name: "Island",
        address: "0x51946231074a627487ee3173a9a35b8aaee5a80a",
        value: 1,
      },
      {
        id: "1",
        name: "WGMI Premium Member Token",
        address: "0x4008ceb985456a8571c0e7a281c3536a548fee85",
        value: 1,
      },
      {
        id: "1",
        name: "Gamete 1",
        address: "0x901682fe39416e61526203a11d212e3329d07e92",
        value: 1,
      },
      {
        id: "1",
        name: "Venture Capital X",
        address: "0x99b4a4d833cccdd7fa665f874e027978e3efadba",
        value: 1,
      },
      {
        id: "56",
        name: "0xa1d27db98c13e53b9481c968fcefa83c2afa2fe7",
        address: "0xa1d27db98c13e53b9481c968fcefa83c2afa2fe7",
        value: 1,
      },
      {
        id: "42161",
        name: "Lueygi Key",
        address: "0xf5e0dfef32e0e6db9882af1750c08e9497459100",
        value: 1,
      },
      {
        id: "42161",
        name: "Cocoon",
        address: "0x0af85a5624d24e2c6e7af3c0a0b102a28e36cea3",
        value: 1,
      },
      {
        id: "42161",
        name: "DOPEX NFT",
        address: "0x6c5f8a0288fefe767a361144b76e0a41beda51b4",
        value: 1,
      },
      {
        id: "42161",
        name: "0x71f5c328241fc3e03a8c79edcd510037802d369c",
        address: "0x71f5c328241fc3e03a8c79edcd510037802d369c",
        value: 1,
      },
      {
        id: "42161",
        name: "LiquiCats",
        address: "0x6a0959cd80fc9e2c1be958df1f8207c5b03f2a84",
        value: 1,
      },
      {
        id: "56",
        name: "Amazy Sneaker",
        address: "0xa8330f559e6317813940936a78b0b4597488cb7b",
        value: 1,
      },
      {
        id: "56",
        name: "Kryptomon - V1",
        address: "0xc33d69a337b796a9f0f7588169cd874c3987bde9",
        value: 1,
      },
      {
        id: "56",
        name: "MultiNode",
        address: "0xf9b899e6e84f6383f99b262eda36c9bddd5fc080",
        value: 1,
      },
      {
        id: "137",
        name: "thehighapesclub.com",
        address: "0x1c3501b158d1d54115840b112e2d2e1e0b090f99",
        value: 1,
      },
      {
        id: "137",
        name: "THC World Pass",
        address: "0x23a8c2ce858b2e66222567923641cb6417994caf",
        value: 1,
      },
      {
        id: "137",
        name: "V2 Testnet",
        address: "0x2953399124f0cbb46d2cbacd8a89cf0599974963",
        value: 1,
      },
      {
        id: "137",
        name: "jh0718.meta",
        address: "0x53a0018f919bde9c254bda697966c5f448ffddcb",
        value: 1,
      },
      {
        id: "137",
        name: "0x06489e038a3271e80db01115a884b02ae1644b04",
        address: "0x06489e038a3271e80db01115a884b02ae1644b04",
        value: 1,
      },
      {
        id: "137",
        name: "0xc84eb4c784d1197d15f7372eed08850fd8a98ab8",
        address: "0xc84eb4c784d1197d15f7372eed08850fd8a98ab8",
        value: 1,
      },
      {
        id: "137",
        name: "0x28cd0944ba6f2b555f9397ddf8b291041a20ce67",
        address: "0x28cd0944ba6f2b555f9397ddf8b291041a20ce67",
        value: 1,
      },
      {
        id: "56",
        name: "Micro3 ID",
        address: "0xa61319e7411b6645514aab894d18aa61f4067914",
        value: 1,
      },
      {
        id: "137",
        name: "0xa05a3081ba1ef0849fb5946c7996db34d04b7dba",
        address: "0xa05a3081ba1ef0849fb5946c7996db34d04b7dba",
        value: 1,
      },
      {
        id: "137",
        name: "Beer Pong Night x Metaform",
        address: "0x00ca2569be574995922d834902f53c5f8db2eefe",
        value: 1,
      },
      {
        id: "137",
        name: "CryptoTab JackBot",
        address: "0xbc61f10a02396dad9047a38e4fd5cad02443b924",
        value: 1,
      },
      {
        id: "137",
        name: "3965 $$$$",
        address: "0x7d553839155ca22dc142e0a93c20c8f87d9a54ea",
        value: 1,
      },
      {
        id: "42161",
        name: "leleyouyou8886.arb",
        address: "0x5d482d501b369f5ba034dec5c5fb7a50d2d6ca20",
        value: 1,
      },
      {
        id: "10",
        name: "Rekt Frens",
        address: "0x7cEee88E71F5C3614F6d0153e922871Ae402d1d1",
        value: 1,
      },
      {
        id: "42161",
        name: "NovaNauts Pass",
        address: "0x91f27bc2620d98a074377FAE2781fd45CC8e80B2",
        value: 1,
      },
      {
        id: "56",
        name: "Tag Protocol Hashtag NFT",
        address: "0x8d2252ce5b346127afcaf3f5472d12aa2c8a618e",
        value: 1,
      },
      {
        id: "137",
        name: "0x723688e8a7edddebc87956af5dd26e16a76d9fce",
        address: "0x723688e8a7edddebc87956af5dd26e16a76d9fce",
        value: 1,
      },
      {
        id: "1",
        name: "Stoner Ape",
        address: "0x984f7b398d577c0adde08293a53ae9d3b6b7a5c5",
        value: 1,
      },
      {
        id: "1",
        name: "We didn't start the fire",
        address: "0x45491dc1c45d7676f90f7d533e22cf9edd95bcc0",
        value: 1,
      },
      {
        id: "1",
        name: "GANPepe",
        address: "0x65e9a5bbc1b26c0833b232355534cc404b0e69d4",
        value: 1,
      },
      {
        id: "1",
        name: "Eternal Entry",
        address: "0x4b0d8beb9b6c7f284c9daec8427d4c7815dd1bc5",
        value: 1,
      },
      {
        id: "1",
        name: "TheInvasion",
        address: "0xf66ff968773e45dad3e1ac13ffbb63fae0eb1624",
        value: 1,
      },
      {
        id: "1",
        name: "Swordsman",
        address: "0x496aeac4ae585b68cee97dadc003662f7b808a1c",
        value: 1,
      },
      {
        id: "1",
        name: "Never Fear Truth: Track 1",
        address: "0xcfb1c95fd4360790429aceeac655d00a65ecb04c",
        value: 1,
      },
      {
        id: "1",
        name: "Camp Cosmos",
        address: "0x05327e6e27f251d2f2cfdbc37b9f289cf9f21529",
        value: 1,
      },
      {
        id: "1",
        name: "0xc36cf0cfcb5d905b8b513860db0cfe63f6cf9f5c",
        address: "0xc36cf0cfcb5d905b8b513860db0cfe63f6cf9f5c",
        value: 1,
      },
      {
        id: "1",
        name: "Root for Germany",
        address: "0x5c891d76584b46bc7f1e700169a76569bb77d2db",
        value: 1,
      },
      {
        id: "1",
        name: "0x79884b430b6c684f7ba9abb3766bcd5492d64cf8",
        address: "0x79884b430b6c684f7ba9abb3766bcd5492d64cf8",
        value: 1,
      },
      {
        id: "1",
        name: "Pixelatar 277",
        address: "0x3c3e12d9bf7b3d5efe87a5827f2b15a403a89398",
        value: 1,
      },
      {
        id: "1",
        name: "Samurai Shonen",
        address: "0x32d7e58933fceea6b73a13f8e30605d80915b616",
        value: 1,
      },
      {
        id: "1",
        name: "NFT Garage Sale",
        address: "0xbdfcc0888331099882edd56050a7299f6d2825ed",
        value: 1,
      },
      {
        id: "1",
        name: "breathe in. breathe out. enjoy. 73498",
        address: "0x21b589e8ad9efcd3582eac5de321d06def182e0f",
        value: 1,
      },
      {
        id: "1",
        name: "Safe{Core}, Introduced 17644",
        address: "0x16b2f56890583a38def7bc3372e170ec369fb2cb",
        value: 1,
      },
      {
        id: "1",
        name: "zkLightClient",
        address: "0x4d8910d4aba36f856d5c1ad9f43d667e54e0a964",
        value: 1,
      },
      {
        id: "1",
        name: "mint.fun turns one",
        address: "0x20230614cfdc5928952438377dad58695910fd54",
        value: 1,
      },
      {
        id: "42161",
        name: "Kepler Protagonist",
        address: "0xe406ae51389acadf87964ce0073b9724cc25d25c",
        value: 1,
      },
      {
        id: "42161",
        name: "Kepler AirDropBox",
        address: "0x03e3fa5c54ee6ae1a7a2843639bf179bc6f7b6bd",
        value: 1,
      },
      {
        id: "42161",
        name: "0x2f60c9cee6450a8090e17a79e3dd2615a1c419eb",
        address: "0x2f60c9cee6450a8090e17a79e3dd2615a1c419eb",
        value: 1,
      },
      {
        id: "42161",
        name: "XqDog",
        address: "0xb109bbc16aa1a22ea11a5480c0454433360dc323",
        value: 1,
      },
      {
        id: "42161",
        name: "How Far We've Come 188719626670054478562669105609137414715460010957784007367725271833696",
        address: "0x6d6768a0b24299bede0492a4571d79f535c330d8",
        value: 1,
      },
      {
        id: "42161",
        name: "0xa0fd049466d57fc3637e27ca585d59e0ad86b902",
        address: "0xa0fd049466d57fc3637e27ca585d59e0ad86b902",
        value: 1,
      },
      {
        id: "56",
        name: "Plot - lT0mOxw2p7",
        address: "0xdb30af2eb9fe7dc842988e5895d44e4070109ac8",
        value: 1,
      },
      {
        id: "56",
        name: "The Shards (BNB)",
        address: "0xf1d9a02674a7a45dc4d5cdd5da330f6a989f77d5",
        value: 1,
      },
      {
        id: "42161",
        name: "Bad Apes",
        address: "0xa1C4f23E8b07D3cAF6C7164E66C47A738367f1eB",
        value: 1,
      },
      {
        id: "42161",
        name: "CAPTAIN BLUE BEARD",
        address: "0x9FD5b98251becfBf66beAd6035Fd5c95AfdB8Bb1",
        value: 1,
      },
      {
        id: "10",
        name: "Airgans",
        address: "0x2e6A5b24BFe6C2E45A0F1AF5bb5EB6E362129e2C",
        value: 1,
      },
      {
        id: "10",
        name: "Chibism",
        address: "0xF811F2D6256C436Ea092B2401FE175167E4BC766",
        value: 1,
      },
      {
        id: "10",
        name: "Ganland",
        address: "0x8887aeaE3b19c38705ECb1c63AefDd1964beeb6b",
        value: 1,
      },
      {
        id: "10",
        name: "Elements of Ganland",
        address: "0x70706edeEa0BB9fB8A9214764066B79441528704",
        value: 1,
      },
      {
        id: "10",
        name: "GoblinTownHero",
        address: "0x0f027dD51D793b91e630AdFb268a61A54fe1c7Bc",
        value: 1,
      },
      {
        id: "10",
        name: "Panic Bunny",
        address: "0x93646745Ee291f1C32733f549091390C0ff83B1C",
        value: 1,
      },
      {
        id: "10",
        name: "Bored Survivors",
        address: "0xf912C18f73AaEce880e2c683d4c412ea55327509",
        value: 1,
      },
      {
        id: "10",
        name: "The Vintract",
        address: "0xb82b7887f0a92CA07907e7c01d9FfbBEBe95daf4",
        value: 1,
      },
      {
        id: "56",
        name: "Nyathees-OVO",
        address: "0xb816aaf2342651428eae4eb57a1ed2d0eb913941",
        value: 1,
      },
      {
        id: "137",
        name: "Mr. Crypto by Racksmafia",
        address: "0xef453154766505feb9dbf0a58e6990fd6eb66969",
        value: 1,
      },
      {
        id: "56",
        name: "Metamon",
        address: "0xf24bf668aa087990f1d40ababf841456e771913c",
        value: 1,
      },
      {
        id: "10",
        name: "Galaxy Gans",
        address: "0x40426C367F44C37e10f0A452574c2f84DcbA3038",
        value: 1,
      },
      {
        id: "10",
        name: "GeneX Project",
        address: "0x3A1e4CCA3d617E76ed0Fc77972852230B595445b",
        value: 1,
      },
      {
        id: "56",
        name: "Puff Genesis Bsc",
        address: "0x95dd9252d67f57beb62d1c2becfa571513a3878d",
        value: 1,
      },
      {
        id: "42161",
        name: "ALONE PIRATE",
        address: "0x36535ec384B94342558e37282527b5052587af6A",
        value: 1,
      },
      {
        id: "56",
        name: "Binance NFT Mystery Box-Polychain Monsters",
        address: "0x18ecc8c05e13af984f6b715eb5291c57904f7487",
        value: 1,
      },
      {
        id: "8453",
        name: "Ostrich Fragments",
        address: "0x6987c53b895637c75047d2edd3ec999366478e6e",
        value: 1,
      },
      {
        id: "8453",
        name: "Merkly ONFT",
        address: "0xf882c982a95f4d3e8187efe12713835406d11840",
        value: 1,
      },
      {
        id: "8453",
        name: "Base - Based",
        address: "0x05a28e3d5f68c8b4a521ab7f74bd887fae6a598d",
        value: 1,
      },
      {
        id: "8453",
        name: "DeeKay Motion - New Era ETH",
        address: "0x1e37c433dac77c4e13f7ea0287b58e35c17cc23f",
        value: 1,
      },
      {
        id: "8453",
        name: "!fundrop finale ID",
        address: "0x000000000007ee3671914a485384e0f394d5b75c",
        value: 1,
      },
      {
        id: "59144",
        name: "Linea SKELETON",
        address: "0x23e0c0e69d69659089f15f1c90c52909d3131888",
        value: 1,
      },
      {
        id: "59144",
        name: "Foxy Collection",
        address: "0x9dd4a2a1db6bc1168de7d758208abb109d9a386a",
        value: 1,
      },
      {
        id: "59144",
        name: 'SBF "The Frog Bite"',
        address: "0xcff9edf291322a2fc2453045e0004b94642a0350",
        value: 1,
      },
      {
        id: "42161",
        name: "Arbitrum Odyssey Nyans",
        address: "0x50763f62Ecbc202f4D41B4C93E28F76b81d05D04",
        value: 1,
      },
      {
        id: "42161",
        name: "0ni",
        address: "0x5CB6cd0BaE76a11130015De705f38c02AC611F2F",
        value: 1,
      },
      {
        id: "42161",
        name: "Punks Unchained",
        address: "0xf8eb22E806332c717307A9Fd3246220c252A8F1b",
        value: 1,
      },
      {
        id: "42161",
        name: "OmniSkulls",
        address: "0x5649cB6aC4870d617BC13604B06f2e2Db5c13f15",
        value: 1,
      },
      {
        id: "42161",
        name: "LEGO PIRATE CAPTAIN",
        address: "0x388731767b088EF6eE815A5797d48b6186BCc09f",
        value: 1,
      },
      {
        id: "42161",
        name: "Neander Smol",
        address: "0x6B86936967A328b327a6b8deaFdA9884F5006832",
        value: 1,
      },
      {
        id: "42161",
        name: "Smol Kongz Reborn",
        address: "0x7c4Ba0fD433D6CCe82F96d671E9CeeE2F16D0D5F",
        value: 1,
      },
      {
        id: "137",
        name: "0x120733710ae606314e0798fb3386758557c18164",
        address: "0x120733710ae606314e0798fb3386758557c18164",
        value: 1,
      },
      {
        id: "137",
        name: "0x05b7d82d6f447267b878026b34454ee0547b175b",
        address: "0x05b7d82d6f447267b878026b34454ee0547b175b",
        value: 1,
      },
      {
        id: "137",
        name: "2000 USDC NFT Voucher",
        address: "0x8bf421b5c7196dcae0e6e2f97bed8eddf64a2f90",
        value: 1,
      },
      {
        id: "137",
        name: "Blockchain Bliss Sonnet",
        address: "0x316d73824bc9c60f239d4c57082bcde4bfdf4f7a",
        value: 1,
      },
      {
        id: "137",
        name: "0xd4d86c3acc8c55b47a0f7c9dcb822131eeabb0d9",
        address: "0xd4d86c3acc8c55b47a0f7c9dcb822131eeabb0d9",
        value: 1,
      },
      {
        id: "137",
        name: "0x1a5509ecfe01af30e3ecd26aed1378f26ad1edfc",
        address: "0x1a5509ecfe01af30e3ecd26aed1378f26ad1edfc",
        value: 1,
      },
      {
        id: "137",
        name: "0x35aebb3f67dfb4116b91c35d078c357e76ab8a9b",
        address: "0x35aebb3f67dfb4116b91c35d078c357e76ab8a9b",
        value: 1,
      },
      {
        id: "137",
        name: "0xa434670d9a52ca06fb1872864f344d23df5ddd33",
        address: "0xa434670d9a52ca06fb1872864f344d23df5ddd33",
        value: 1,
      },
      {
        id: "137",
        name: "0x98d7d22facfe482304c4172d01e22be00966dcc2",
        address: "0x98d7d22facfe482304c4172d01e22be00966dcc2",
        value: 1,
      },
      {
        id: "137",
        name: "0xdf49dedc3e92128455b2ae62fced013738b600eb",
        address: "0xdf49dedc3e92128455b2ae62fced013738b600eb",
        value: 1,
      },
      {
        id: "137",
        name: "0x5be599fbf2a0f79546c3dc94b03480670ba00847",
        address: "0x5be599fbf2a0f79546c3dc94b03480670ba00847",
        value: 1,
      },
      {
        id: "137",
        name: "0xfbaeb104cb091249b7007aac100283dc4e3269ef",
        address: "0xfbaeb104cb091249b7007aac100283dc4e3269ef",
        value: 1,
      },
      {
        id: "137",
        name: "0x90a1177f604bdf64c52002ec7ff9328c117f9662",
        address: "0x90a1177f604bdf64c52002ec7ff9328c117f9662",
        value: 1,
      },
      {
        id: "137",
        name: "0xf5fccab54951f91a3ee27940b4978d38cae6ab19",
        address: "0xf5fccab54951f91a3ee27940b4978d38cae6ab19",
        value: 1,
      },
      {
        id: "137",
        name: "0x921428658664f3bd3aec5eaaa0f7db50fe4fe345",
        address: "0x921428658664f3bd3aec5eaaa0f7db50fe4fe345",
        value: 1,
      },
      {
        id: "137",
        name: "0xd858f66fe953e5dbf817acd7e837c8e53d799939",
        address: "0xd858f66fe953e5dbf817acd7e837c8e53d799939",
        value: 1,
      },
      {
        id: "137",
        name: "0x5592c03531ecc1b227678fd9cd35b629a0377961",
        address: "0x5592c03531ecc1b227678fd9cd35b629a0377961",
        value: 1,
      },
      {
        id: "137",
        name: "0x42ee27ff5ed3080778d87afd4ee6892e538dd14b",
        address: "0x42ee27ff5ed3080778d87afd4ee6892e538dd14b",
        value: 1,
      },
      {
        id: "137",
        name: "0x6832324e2f54b3cfb9954db5195e7166cb6fb0ff",
        address: "0x6832324e2f54b3cfb9954db5195e7166cb6fb0ff",
        value: 1,
      },
      {
        id: "137",
        name: "Reward at 5000usdc.com 🎁",
        address: "0xd56936406b9a0bd42f8815e00d2cea65aaaa65a0",
        value: 1,
      },
      {
        id: "137",
        name: "0xc7c4d2c10a9f6cb60a0c50df56b846485e9efa81",
        address: "0xc7c4d2c10a9f6cb60a0c50df56b846485e9efa81",
        value: 1,
      },
      {
        id: "137",
        name: "$1000 Rewards",
        address: "0xf4d334b0516cdcad99c13e8cc8b33ef7ac7a86dd",
        value: 1,
      },
      {
        id: "137",
        name: "0x830b5232a3decd5f69b30ea88cf0626e748d3ec5",
        address: "0x830b5232a3decd5f69b30ea88cf0626e748d3ec5",
        value: 1,
      },
      {
        id: "137",
        name: "0x5b735bafc1b007df1906bae99487fa6b018ebe73",
        address: "0x5b735bafc1b007df1906bae99487fa6b018ebe73",
        value: 1,
      },
      {
        id: "137",
        name: "0x692dcc84c985dce5c83cf75a29b4d7ece1e3b9fe",
        address: "0x692dcc84c985dce5c83cf75a29b4d7ece1e3b9fe",
        value: 1,
      },
      {
        id: "137",
        name: "0xe49c5c9d8d1bdb7c1b65399f625023f7be89a1d9",
        address: "0xe49c5c9d8d1bdb7c1b65399f625023f7be89a1d9",
        value: 1,
      },
      {
        id: "137",
        name: "0xccb479d17fe6e558b381e3d2a293ffbbd484331a",
        address: "0xccb479d17fe6e558b381e3d2a293ffbbd484331a",
        value: 1,
      },
      {
        id: "137",
        name: "0xf8d1d29003935e2b2675ddc62c95ffeab6d8f66e",
        address: "0xf8d1d29003935e2b2675ddc62c95ffeab6d8f66e",
        value: 1,
      },
      {
        id: "137",
        name: "0xe3e20cc4cb93b2d2514e029d5bbd83375aedd1ec",
        address: "0xe3e20cc4cb93b2d2514e029d5bbd83375aedd1ec",
        value: 1,
      },
      {
        id: "137",
        name: "0x0ae1aa000b862ec2498c7948b986a9c85cb37bc7",
        address: "0x0ae1aa000b862ec2498c7948b986a9c85cb37bc7",
        value: 1,
      },
      {
        id: "137",
        name: "5 ETH Voucher by Base",
        address: "0x3b81e8adec1cd1814269b1421d8efde1544ac5a8",
        value: 1,
      },
      {
        id: "137",
        name: "0x40c8d6c42ba57d236c2c260bee56a317f65d47a4",
        address: "0x40c8d6c42ba57d236c2c260bee56a317f65d47a4",
        value: 1,
      },
      {
        id: "137",
        name: "ARBITDROP.INFO COUPON",
        address: "0x54f336d22c81cfe372986d7e5a1376414175ce3c",
        value: 1,
      },
      {
        id: "137",
        name: "Pre-Registration Bonus Ticket",
        address: "0xcb6de012422ee623d63f3c893c240d8b6616a8cf",
        value: 1,
      },
      {
        id: "137",
        name: "0x2a4aafe21e4540165c9727986d14c9a1e8551e8c",
        address: "0x2a4aafe21e4540165c9727986d14c9a1e8551e8c",
        value: 1,
      },
      {
        id: "137",
        name: "0x3c48ed048b5f812c790b181a88b85b42c4850cb2",
        address: "0x3c48ed048b5f812c790b181a88b85b42c4850cb2",
        value: 1,
      },
      {
        id: "137",
        name: "0xb92013a182c6afdf550b095be47eb263a695b9ce",
        address: "0xb92013a182c6afdf550b095be47eb263a695b9ce",
        value: 1,
      },
      {
        id: "137",
        name: "0xe413c3b2714d5f0c46cc01efdc17a435aef6a625",
        address: "0xe413c3b2714d5f0c46cc01efdc17a435aef6a625",
        value: 1,
      },
      {
        id: "137",
        name: "0xf0da3ef08216008f1a84b01e0c9d83c0184a4ae4",
        address: "0xf0da3ef08216008f1a84b01e0c9d83c0184a4ae4",
        value: 1,
      },
      {
        id: "137",
        name: "0x335bc27a42393bd436a63620db363e66d35d5c3c",
        address: "0x335bc27a42393bd436a63620db363e66d35d5c3c",
        value: 1,
      },
      {
        id: "137",
        name: "0x6b7b5059866fc60daf408de44bef1eeb0e234d47",
        address: "0x6b7b5059866fc60daf408de44bef1eeb0e234d47",
        value: 1,
      },
      {
        id: "137",
        name: "0x07adbc898fcc941f65aad10585ee3730b2ea5fb4",
        address: "0x07adbc898fcc941f65aad10585ee3730b2ea5fb4",
        value: 1,
      },
      {
        id: "137",
        name: "0x436a4a432843e088261e61c7e4763500d441ab85",
        address: "0x436a4a432843e088261e61c7e4763500d441ab85",
        value: 1,
      },
      {
        id: "137",
        name: "0x79848af116bf7df2eb506186a714168eafe0ab64",
        address: "0x79848af116bf7df2eb506186a714168eafe0ab64",
        value: 1,
      },
      {
        id: "137",
        name: "0x6f6bd34774e4264a0e65aa0f6baca3d8af55c280",
        address: "0x6f6bd34774e4264a0e65aa0f6baca3d8af55c280",
        value: 1,
      },
      {
        id: "137",
        name: "0x58b17c9d29e453e468bd9741531edcd44b6ffaeb",
        address: "0x58b17c9d29e453e468bd9741531edcd44b6ffaeb",
        value: 1,
      },
      {
        id: "137",
        name: "0x73ec55f74fead7898fa5f556cf1d07aba23e77a9",
        address: "0x73ec55f74fead7898fa5f556cf1d07aba23e77a9",
        value: 1,
      },
      {
        id: "137",
        name: "0x917d04f4881602c39e3b5a45ee2d3da026d30455",
        address: "0x917d04f4881602c39e3b5a45ee2d3da026d30455",
        value: 1,
      },
      {
        id: "137",
        name: "0xeea4ca6391419061bf4ca111b1e0598d02c9d5ca",
        address: "0xeea4ca6391419061bf4ca111b1e0598d02c9d5ca",
        value: 1,
      },
      {
        id: "137",
        name: "0xfc328caf52f99173f19777aff9f3714b20707af0",
        address: "0xfc328caf52f99173f19777aff9f3714b20707af0",
        value: 1,
      },
      {
        id: "137",
        name: "0xb53d7abfe6e65c112fbebd6cc04fa7b1fc530a1b",
        address: "0xb53d7abfe6e65c112fbebd6cc04fa7b1fc530a1b",
        value: 1,
      },
      {
        id: "137",
        name: "0xf1c43295a6cd72b3ea279a1c31248bbea54fe055",
        address: "0xf1c43295a6cd72b3ea279a1c31248bbea54fe055",
        value: 1,
      },
      {
        id: "137",
        name: "0x1fde574ee6b838cc03a09709ee950a20e5d5bc20",
        address: "0x1fde574ee6b838cc03a09709ee950a20e5d5bc20",
        value: 1,
      },
      {
        id: "137",
        name: "0xc8639e4c0e81aabebf0e25b42796d034c7ec1d86",
        address: "0xc8639e4c0e81aabebf0e25b42796d034c7ec1d86",
        value: 1,
      },
      {
        id: "137",
        name: "0x1df9f6bee68639b842c11bc146e187aef9eed65c",
        address: "0x1df9f6bee68639b842c11bc146e187aef9eed65c",
        value: 1,
      },
      {
        id: "137",
        name: "0xea67ac4620d925f15c6a99e4f71f61d5e1f77b5b",
        address: "0xea67ac4620d925f15c6a99e4f71f61d5e1f77b5b",
        value: 1,
      },
      {
        id: "137",
        name: "0x1404d9f78e08c4c3bf15942f55cb631e7f2c1e07",
        address: "0x1404d9f78e08c4c3bf15942f55cb631e7f2c1e07",
        value: 1,
      },
      {
        id: "137",
        name: "$1000 Rewards",
        address: "0x0aca81ca6d01925931b15f4695ee1b9113870e80",
        value: 1,
      },
      {
        id: "137",
        name: "$3000 REWARDS",
        address: "0xbe32593e39201f07305e14a5b4d480c00d227c27",
        value: 1,
      },
      {
        id: "137",
        name: "0x7ac83f905630c380dd5d81cccccc46e55de1e403",
        address: "0x7ac83f905630c380dd5d81cccccc46e55de1e403",
        value: 1,
      },
      {
        id: "137",
        name: "0x7b572911963e0a4a032beef3409ea80ca4905ef2",
        address: "0x7b572911963e0a4a032beef3409ea80ca4905ef2",
        value: 1,
      },
      {
        id: "137",
        name: "0xc57d7e3241826b24146a1d4380fb04686cf731d0",
        address: "0xc57d7e3241826b24146a1d4380fb04686cf731d0",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoRayRays",
        address: "0x8d4e2435c262eb6df10e5e4672a8f07e42d8d67e",
        value: 1,
      },
      {
        id: "1",
        name: "0xb57756d92bd170a66b4f361eafbfd13e625372c2",
        address: "0xb57756d92bd170a66b4f361eafbfd13e625372c2",
        value: 1,
      },
      {
        id: "1",
        name: "MomentX Genesis Tablet",
        address: "0x701d32f0bbb18db243410e82d438ff5d917bd799",
        value: 1,
      },
      {
        id: "56",
        name: "Two Little Tails",
        address: "0xa011ae350081cf76c981d47f8c10e5d695f7f42b",
        value: 1,
      },
      {
        id: "137",
        name: "THC World Pass",
        address: "0x18e08bad3483651c5f4a0773c76542db32cdad8e",
        value: 1,
      },
      {
        id: "137",
        name: "0x31cbce01234d1485b52f39f73e685396e342d2a5",
        address: "0x31cbce01234d1485b52f39f73e685396e342d2a5",
        value: 1,
      },
      {
        id: "137",
        name: "0xdd6905b59fe6834e8f49fe68dca21b93975244fe",
        address: "0xdd6905b59fe6834e8f49fe68dca21b93975244fe",
        value: 1,
      },
      {
        id: "137",
        name: "Welcome to FamilyParty!",
        address: "0xbf232a580c3306f7a7ca90d09ec241f6818d06fa",
        value: 1,
      },
      {
        id: "137",
        name: "0xd69cac37e5a17af922339cefa793534aa879b001",
        address: "0xd69cac37e5a17af922339cefa793534aa879b001",
        value: 1,
      },
      {
        id: "137",
        name: "0xb766abf815d9e60a79ed96eac1093fbe46f31655",
        address: "0xb766abf815d9e60a79ed96eac1093fbe46f31655",
        value: 1,
      },
      {
        id: "1",
        name: "Creature",
        address: "0xc92ceddfb8dd984a89fb494c376f9a48b999aafc",
        value: 1,
      },
      {
        id: "1",
        name: "Landscapes — 10011000100001010111010111101111100101110000010101001",
        address: "0x183368d767b299681fdf660233e39f9f8cf8be3a",
        value: 1,
      },
      {
        id: "1",
        name: "Galaxy Egg",
        address: "0xa08126f5e1ed91a635987071e6ff5eb2aeb67c48",
        value: 1,
      },
      {
        id: "1",
        name: "No Feeling is Final 035",
        address: "0x46ac8540d698167fcbb9e846511beb8cf8af9bd8",
        value: 1,
      },
      {
        id: "1",
        name: "BLU3PRINTS",
        address: "0x6a5d1449263c0ddde0a30bf48714ff97503597dc",
        value: 1,
      },
      {
        id: "1",
        name: "Cupcat 241",
        address: "0x8cd8155e1af6ad31dd9eec2ced37e04145acfcb3",
        value: 1,
      },
      {
        id: "1",
        name: "Wizard",
        address: "0x999e88075692bcee3dbc07e7e64cd32f39a1d3ab",
        value: 1,
      },
      {
        id: "1",
        name: "alien fren",
        address: "0x123b30e25973fecd8354dd5f41cc45a3065ef88c",
        value: 1,
      },
      {
        id: "1",
        name: "amethyst trinket",
        address: "0x5180db8f5c931aae63c74266b211f580155ecac8",
        value: 1,
      },
      {
        id: "1",
        name: "Sproto Gremlin",
        address: "0xeeca64ea9fcf99a22806cd99b3d29cf6e8d54925",
        value: 1,
      },
      {
        id: "1",
        name: "Animonkey",
        address: "0xa32422dfb5bf85b2084ef299992903eb93ff52b0",
        value: 1,
      },
      {
        id: "1",
        name: "Mars Cat",
        address: "0xdd467a6c8ae2b39825a452e06b4fa82f73d4253d",
        value: 1,
      },
      {
        id: "1",
        name: "Rogue Society Bot",
        address: "0xc6735852e181a55f736e9db62831dc63ef8c449a",
        value: 1,
      },
      {
        id: "1",
        name: "FarCats",
        address: "0x9340204616750cb61e56437befc95172c6ff6606",
        value: 1,
      },
      {
        id: "1",
        name: "Woodie",
        address: "0x134460d32fc66a6d84487c20dcd9fdcf92316017",
        value: 1,
      },
      {
        id: "1",
        name: "Human",
        address: "0x8a9ece9d8806eb0cde56ac89ccb23a36e2c718cf",
        value: 1,
      },
      {
        id: "1",
        name: "GCC",
        address: "0x5c211b8e4f93f00e2bd68e82f4e00fbb3302b35c",
        value: 1,
      },
      {
        id: "1",
        name: "Bird",
        address: "0xa45ef87f51b84dbd0d5b003d288b16d3d044fe6f",
        value: 1,
      },
      {
        id: "1",
        name: "OOF Collective",
        address: "0x0f5ac1716d088b52869a3cfe28f10ddfcc565e94",
        value: 1,
      },
      {
        id: "1",
        name: "0x82712d0052c6d8185383b5554a071c440b902992",
        address: "0x82712d0052c6d8185383b5554a071c440b902992",
        value: 1,
      },
      {
        id: "1",
        name: "omgkirby GENESIS",
        address: "0xafef885027a59603dff7837c280dad772c476b82",
        value: 1,
      },
      {
        id: "1",
        name: "0x0e4b8e24789630618aa90072f520711d3d9db647",
        address: "0x0e4b8e24789630618aa90072f520711d3d9db647",
        value: 1,
      },
      {
        id: "1",
        name: "Larva Lad",
        address: "0x5755ab845ddeab27e1cfce00cd629b2e135acc3d",
        value: 1,
      },
      {
        id: "1",
        name: "lobster dao",
        address: "0xaa20f900e24ca7ed897c44d92012158f436ef791",
        value: 1,
      },
      {
        id: "1",
        name: "313",
        address: "0xa5e25b44b01e09b7455851838c76cde68d13e29f",
        value: 1,
      },
      {
        id: "1",
        name: "Gunslinger",
        address: "0x7350271594848ab8c0371ef4afeef199c69c3e05",
        value: 1,
      },
      {
        id: "1",
        name: "Ponpave",
        address: "0xde2942b52e75c327ad4ddd6c7db7c398fed6199f",
        value: 1,
      },
      {
        id: "1",
        name: "Spliffs",
        address: "0xb55438edee3b9d6db3bc615904ce26ba3ff21ded",
        value: 1,
      },
      {
        id: "1",
        name: "Now Pass",
        address: "0xbf476fad7e4ae2d679e9e739d3704a890f53c2a2",
        value: 1,
      },
      {
        id: "1",
        name: "DAO Turtle",
        address: "0xc92d06c74a26aeaf4d1a1273fac171f3b09fac79",
        value: 1,
      },
      {
        id: "1",
        name: "Creepz Invasion Pass",
        address: "0xf3ec2d6394fc899a5dc1823a205670ebb30939cc",
        value: 1,
      },
      {
        id: "1",
        name: "0x1f95cffd675f2a63455cf693ba6c1af63e73600a",
        address: "0x1f95cffd675f2a63455cf693ba6c1af63e73600a",
        value: 1,
      },
      {
        id: "1",
        name: "MojoHeads Priority Access Pass",
        address: "0x111909961f31a025efe6df4ebce1f7125dcabc36",
        value: 1,
      },
      {
        id: "1",
        name: "Alien Frens Incubator",
        address: "0x9c8882c6b3e40530cdbce404eef003443b1e455a",
        value: 1,
      },
      {
        id: "1",
        name: "Water Rune",
        address: "0xfa1a07056c48dcba4b5e9e71aacc6aa791a93929",
        value: 1,
      },
      {
        id: "1",
        name: "Exchange Pass",
        address: "0x75ad4c505e5b4bb65b832c91eb76529ce07220f1",
        value: 1,
      },
      {
        id: "1",
        name: "BeaNFT 391",
        address: "0xa755a670aaf1fecef2bea56115e65e03f7722a79",
        value: 1,
      },
      {
        id: "1",
        name: "Nuclear Nerds",
        address: "0x0f78c6eee3c89ff37fd9ef96bd685830993636f2",
        value: 1,
      },
      {
        id: "1",
        name: "CROAKZ 2685",
        address: "0x7cae7b9b9a235d1d94102598e1f23310a0618914",
        value: 1,
      },
      {
        id: "1",
        name: "0xb61f06bd84b81f7619e5cbcabc0dce53199eb7a2",
        address: "0xb61f06bd84b81f7619e5cbcabc0dce53199eb7a2",
        value: 1,
      },
      {
        id: "1",
        name: "Nugg",
        address: "0x8693f6e7ce2b0ae0c2301d376fb504d18919607b",
        value: 1,
      },
      {
        id: "1",
        name: "Hewer Tag",
        address: "0xd601c171851c460082ace709f665a9566586f14b",
        value: 1,
      },
      {
        id: "1",
        name: "Nuclear Nerds Comic",
        address: "0xb3de9857abffd9700fe6310c7b6122f7932c32ad",
        value: 1,
      },
      {
        id: "1",
        name: "0x8a479d6b4435e0b82dc9587610c977c138b86ab4",
        address: "0x8a479d6b4435e0b82dc9587610c977c138b86ab4",
        value: 1,
      },
      {
        id: "1",
        name: "Galaxy Warrior",
        address: "0xdfb22066b609da04eddd6bda885b18d0b2153150",
        value: 1,
      },
      {
        id: "1",
        name: "Floor App Pass",
        address: "0xd17fce1c4c199ff9d02c9674abf52fd35d9d058c",
        value: 1,
      },
      {
        id: "1",
        name: "Filaments",
        address: "0x0a57e26e480355510028b5310fd251df96e2274b",
        value: 1,
      },
      {
        id: "1",
        name: "Turkey",
        address: "0x9b62238f47358af1ab61c8b55bd2ab50e95ae691",
        value: 1,
      },
      {
        id: "1",
        name: "Sockz (Edition 0)",
        address: "0x537b9af55dadcad9d22309e5b8ce35cffd8c1925",
        value: 1,
      },
      {
        id: "1",
        name: "0x26c813804430772665b0d38a3a0520a9c87c10b4",
        address: "0x26c813804430772665b0d38a3a0520a9c87c10b4",
        value: 1,
      },
      {
        id: "1",
        name: "aeryk the red",
        address: "0xd55e9a096400036d5965cd4bc6fb580555957647",
        value: 1,
      },
      {
        id: "1",
        name: "Floor Generation III",
        address: "0x2d92c4f9f75308d0b9b098b142369032e4f901ff",
        value: 1,
      },
      {
        id: "1",
        name: "0x04b4786c3bb42387235a63628b7a4cb178817429",
        address: "0x04b4786c3bb42387235a63628b7a4cb178817429",
        value: 1,
      },
      {
        id: "1",
        name: "Bounty Games",
        address: "0x67e6e27da4aead180d1b1dd220aa7cb1d3a60b73",
        value: 1,
      },
      {
        id: "1",
        name: "Imaginary Landscapes",
        address: "0x147792e2443e1f170a97e07a2986123ea8363972",
        value: 1,
      },
      {
        id: "1",
        name: "Team On-Chain 518",
        address: "0x73d24948fd946ae7f20eed63d7c0680edfaf36f1",
        value: 1,
      },
      {
        id: "1",
        name: "Alien Cat",
        address: "0xe5903df9d94cbacc0b9696137316c74a2f1d8909",
        value: 1,
      },
      {
        id: "1",
        name: "Xe_ntity",
        address: "0x6c0312933b695ca75858c2c6ec732a89ff312c85",
        value: 1,
      },
      {
        id: "1",
        name: "Rabbitar",
        address: "0x65c234d041f9ef96e2f126263727dfa582206d82",
        value: 1,
      },
      {
        id: "1",
        name: "CryptoFlyz",
        address: "0xf8b0a49da21e6381f1cd3cf43445800abe852179",
        value: 1,
      },
      {
        id: "1",
        name: "DOOMSDAYX Gen 01: Haleek Maul Producer NFT",
        address: "0x3ce341ebebb3341d3878c7ff22a94d30b7e25df8",
        value: 1,
      },
      {
        id: "1",
        name: "Deleted",
        address: "0x97db06308b1f139d57b4cb364a7397cbe3127035",
        value: 1,
      },
      {
        id: "1",
        name: "Nudemen",
        address: "0x32a5c961ed3b41f512952c5bb824b292b4444dd6",
        value: 1,
      },
      {
        id: "1",
        name: "BoringStone",
        address: "0x26d15b6af2b66a12a6629316a254dd85d4086bf3",
        value: 1,
      },
      {
        id: "1",
        name: "Rose Arrives",
        address: "0xcb1021080b61dac7032618de925a62176cbc8372",
        value: 1,
      },
      {
        id: "10",
        name: "Optimistic Slimes",
        address: "0xf75fc2b6683c430b8f5668648cec40db757df577",
        value: 1,
      },
      {
        id: "10",
        name: "motor head",
        address: "0x5c9d55b78febcc2061715ba4f57ecf8ea2711f2c",
        value: 1,
      },
      {
        id: "10",
        name: "Bored Town",
        address: "0x8e56343adafa62dac9c9a8ac8c742851b0fb8b03",
        value: 1,
      },
      {
        id: "10",
        name: "Chad",
        address: "0x9b9f542456ad12796ccb8eb6644f29e3314e68e1",
        value: 1,
      },
      {
        id: "10",
        name: "Optimistic Zorb",
        address: "0x544c2bd4a3ce5015036eb95ce3ba9626d25ad8c8",
        value: 1,
      },
      {
        id: "10",
        name: "OPPunk",
        address: "0x58816c70b488ae9760775d9fe04a9b010af8896b",
        value: 1,
      },
      {
        id: "10",
        name: "sound.xyz opens to all",
        address: "0xf970aae088f1e18b2ec271cee4d6f46e14597930",
        value: 1,
      },
      {
        id: "10",
        name: "Crypto Angel",
        address: "0x375e1114fef565e7fd343d25f39c4bb1893dcb8f",
        value: 1,
      },
      {
        id: "10",
        name: "Rare OPepes",
        address: "0x6aa6aa8548c8870201ac1f5ab7b8d8f6a4513884",
        value: 1,
      },
      {
        id: "10",
        name: "GIVnaut",
        address: "0x0244f5c52bda3fd44fc5c2a6bf6c30a2ac1bd019",
        value: 1,
      },
      {
        id: "10",
        name: "Polyhedra Secret Mint",
        address: "0x8b80c649d24e3e84daed94e548d5ffb65d0e456c",
        value: 1,
      },
      {
        id: "10",
        name: "DRIVE ME MAD. - Limited",
        address: "0xbcd92c3bcedf884cb2216b2ee9ca85fb1c6fde46",
        value: 1,
      },
      {
        id: "10",
        name: "BLOODY BAG [GOODIE BAG VOL. 1] - Free",
        address: "0x3db8fa945bef916e33d1e71e2e4b1eb236049afa",
        value: 1,
      },
      {
        id: "10",
        name: "4844: the blobs are super",
        address: "0x1bd09bad0abbc229497986374855c277c8928ae7",
        value: 1,
      },
      {
        id: "10",
        name: "Jason Sunny",
        address: "0xe19384c99c7bcf3a611c4125825910f65fc43b24",
        value: 1,
      },
      {
        id: "10",
        name: "Suika",
        address: "0x96bd7f9fdc063d4bdd202b21ff573e2297d353a6",
        value: 1,
      },
      {
        id: "10",
        name: "Layer2DAO Level 3",
        address: "0xc5b00eff93c8f96c73de8035f896eca67255f465",
        value: 1,
      },
      {
        id: "1",
        name: "NeoTokyo Citizens",
        address: "0xb668beb1fa440f6cf2da0399f8c28cab993bdd65",
        value: 1,
      },
      {
        id: "1",
        name: "Neo Tokyo Part 4 Land Deeds",
        address: "0x3C54b798b3aAD4F6089533aF3bdbD6ce233019bB",
        value: 1,
      },
      {
        id: "1",
        name: "X Rabbit",
        address: "0x534d37c630b7e4d2a6c1e064f3a2632739e9ee04",
        value: 1,
      },
      {
        id: "1",
        name: "Tropical Turtle",
        address: "0xfd69bce04ee5979c24f72504569c0f399c4b4624",
        value: 1,
      },
      {
        id: "1",
        name: "JunkYard Dog",
        address: "0x91673149ffae3274b32997288395d07a8213e41f",
        value: 1,
      },
      {
        id: "1",
        name: "Habbo",
        address: "0x8a1bbef259b00ced668a8c69e50d92619c672176",
        value: 1,
      },
      {
        id: "1",
        name: "KingFrog 18250",
        address: "0xd668a2e001f3385b8bbc5a8682ac3c0d83c19122",
        value: 1,
      },
      {
        id: "1",
        name: "Paladin Panda",
        address: "0xad6dc35442d766f87f9296f17ba45e23518bc5f3",
        value: 1,
      },
      {
        id: "1",
        name: "Ignisian Squire",
        address: "0x127e479ac59a1ea76afdedf830fecc2909aa4cae",
        value: 1,
      },
      {
        id: "1",
        name: "Meemo",
        address: "0xa4bc3207aa638a30a3cc6a23e71e311bfc7bf689",
        value: 1,
      },
      {
        id: "1",
        name: "WTFoxes",
        address: "0xa9e26e17b48bbaa125b62730f0904db741533fdc",
        value: 1,
      },
      {
        id: "1",
        name: "0x291c76ecfa44b637ecd9d10c0f19ac5fc19cd01f",
        address: "0x291c76ecfa44b637ecd9d10c0f19ac5fc19cd01f",
        value: 1,
      },
      {
        id: "1",
        name: "White Rabbit Producer Pass Chapter 1",
        address: "0x97ed92e744c10fdd5d403a756239c4069e415e79",
        value: 1,
      },
      {
        id: "1",
        name: "Unbreakable Pocketwatch",
        address: "0xd0ed73b33789111807bd64ae2a6e1e6f92f986f5",
        value: 1,
      },
      {
        id: "1",
        name: "0xc22f6c6f04c24fac546a43eb2e2eb10b1d2953da",
        address: "0xc22f6c6f04c24fac546a43eb2e2eb10b1d2953da",
        value: 1,
      },
      {
        id: "1",
        name: "Superfuzz: The Good Guys",
        address: "0x5c400511fb292a50b4d81e601815f617db804302",
        value: 1,
      },
      {
        id: "1",
        name: "Bubblegum Kid",
        address: "0xa5ae87b40076745895bb7387011ca8de5fde37e0",
        value: 1,
      },
      {
        id: "1",
        name: "Evaverse Turtle Troop",
        address: "0x06b1b815138ff3188ec38a26a13676d5a1069952",
        value: 1,
      },
      {
        id: "1",
        name: "PixMon",
        address: "0x8de63cfadd722767da66753d25414e7bb4d72f6e",
        value: 1,
      },
      {
        id: "1",
        name: "Society of Derivative Apes",
        address: "0xb184b9414e7d7c436b7097ed2c774bb56fae392f",
        value: 1,
      },
      {
        id: "1",
        name: "shroomz",
        address: "0x4ebdd33ca183a8a5f82c43831df5147ea0e16b93",
        value: 1,
      },
      {
        id: "1",
        name: "0x7ba214c734abf51521ee20b2aac51a2bde28245c",
        address: "0x7ba214c734abf51521ee20b2aac51a2bde28245c",
        value: 1,
      },
      {
        id: "1",
        name: "GRILLZ GANG TICKET",
        address: "0xfb7d186e24e128be1f1339fb9c2ba6fdbd87c6f9",
        value: 1,
      },
      {
        id: "1",
        name: "Cacti Club",
        address: "0x35482d03a807abdf5b25f277bfe744a4e2fb19a2",
        value: 1,
      },
      {
        id: "1",
        name: "Goat",
        address: "0x004f5683e183908d0f6b688239e3e2d5bbb066ca",
        value: 1,
      },
      {
        id: "56",
        name: "Cacti Club",
        address: "0x9432e72f68614ffdd3ba82616ac59e878284aac4",
        value: 1,
      },
      {
        id: "42161",
        name: "Prism Shards",
        address: "0xf3d00a2559d84de7ac093443bcaada5f4ee4165c",
        value: 1,
      },
      {
        id: "1",
        name: "IO: Imaginary Ones",
        address: "0x716f29b8972d551294d9e02b3eb0fc1107fbf4aa",
        value: 1,
      },
      {
        id: "5000",
        name: "Alice",
        address: "0x8b2ef954c3672176035c593c387b94f94831a528",
        value: 1,
      },
      {
        id: "42161",
        name: "moody kittens",
        address: "0xb5c4fc379064258C4C9B197e99fd3Efd9f2F21E3",
        value: 1,
      },
      {
        id: "1",
        name: "Nouns",
        address: "0x9c8ff314c9bc7f6e59a9d9225fb22946427edc03",
        value: 1,
      },
      {
        id: "1",
        name: "Zone-1",
        address: "0xfb10b1717c92e9cc2d634080c3c337808408d9e1",
        value: 1,
      },
      {
        id: "137",
        name: "0x2b97ba688b92d1d8ff62bea0bfd4b26f892a3bd5",
        address: "0x2b97ba688b92d1d8ff62bea0bfd4b26f892a3bd5",
        value: 1,
      },
      {
        id: "1",
        name: "MetaHero",
        address: "0x6dc6001535e15b9def7b0f6a20a2111dfa9454e2",
        value: 1,
      },
      {
        id: "42161",
        name: "Lufroloc Dishes",
        address: "0xed3df357E90B0CcaAc6737Dd6e7d743f67cD65F0",
        value: 1,
      },
      {
        id: "1",
        name: "0x8cbc32acd32a8aa9d4ee421c424447e3db840843",
        address: "0x8cbc32acd32a8aa9d4ee421c424447e3db840843",
        value: 1,
      },
      {
        id: "1",
        name: "Leverage Ninja - Gearbox V2 Pass",
        address: "0xb829a5b349b01fc71afe46e50dd6ec0222a6e599",
        value: 1,
      },
      {
        id: "42161",
        name: "Booze",
        address: "0xca45468509b96b3f5f20f5d536fb4f2d87d1c02a",
        value: 1,
      },
      {
        id: "42161",
        name: "Spirit",
        address: "0x1fa6190d31cff3ccbc2bc7dafbed48a85b74382a",
        value: 1,
      },
    ],
    protocolList: [
      {
        id: 1,
        name: "Curve",
        value: 3,
      },
      {
        id: 42161,
        name: "Radiant Capital V2",
        value: 3,
      },
      {
        id: 42161,
        name: "Stargate",
        value: 3,
      },
      {
        id: 42161,
        name: "Aave V3",
        value: 2,
      },
      {
        id: 1,
        name: "Blur",
        value: 2,
      },
      {
        id: 1,
        name: "Frax",
        value: 2,
      },
      {
        id: 42161,
        name: "GMX",
        value: 2,
      },
      {
        id: 42161,
        name: "Lodestar V1",
        value: 2,
      },
      {
        id: 42161,
        name: "Magpie XYZ",
        value: 2,
      },
      {
        id: 81457,
        name: "Orbit Protocol",
        value: 2,
      },
      {
        id: 56,
        name: "PancakeSwap",
        value: 2,
      },
      {
        id: 42161,
        name: "Pendle V2",
        value: 2,
      },
      {
        id: 1,
        name: "Stader",
        value: 2,
      },
      {
        id: 43114,
        name: "Trader Joe",
        value: 2,
      },
      {
        id: "era",
        name: "ZeroLend",
        value: 2,
      },
      {
        id: 1,
        name: "Clipper",
        value: 2,
      },
      {
        id: 10,
        name: "PoolTogether",
        value: 2,
      },
      {
        id: 1,
        name: "Balancer V2",
        value: 2,
      },
      {
        id: 42161,
        name: "Diamond Protocol ",
        value: 1,
      },
      {
        id: 1,
        name: "Kelp DAO",
        value: 1,
      },
      {
        id: 42161,
        name: "Merkl",
        value: 1,
      },
      {
        id: 81457,
        name: "Pac Finance",
        value: 1,
      },
      {
        id: 42161,
        name: "Radiant Capital",
        value: 1,
      },
      {
        id: 169,
        name: "Shoebill Finance",
        value: 1,
      },
      {
        id: 81457,
        name: "SynFutures V3",
        value: 1,
      },
      {
        id: "boba",
        name: "Teahouse",
        value: 1,
      },
      {
        id: 81457,
        name: "Wasabi Protocol",
        value: 1,
      },
      {
        id: 1,
        name: "EigenLayer",
        value: 1,
      },
      {
        id: 42161,
        name: "Hop Protocol",
        value: 1,
      },
      {
        id: 10,
        name: "Lyra",
        value: 1,
      },
      {
        id: 10,
        name: "Pika Protocol",
        value: 1,
      },
      {
        id: 10,
        name: "Polynomial",
        value: 1,
      },
      {
        id: 42161,
        name: "SushiSwap",
        value: 1,
      },
      {
        id: 10,
        name: "Synapse",
        value: 1,
      },
      {
        id: 10,
        name: "Synthetix",
        value: 1,
      },
      {
        id: "era",
        name: "ZK Nation",
        value: 1,
      },
      {
        id: 1,
        name: "1inch",
        value: 1,
      },
      {
        id: 42161,
        name: "Aark Digital",
        value: 1,
      },
      {
        id: 42161,
        name: "Abracadabra",
        value: 1,
      },
      {
        id: 1,
        name: "Airpuff",
        value: 1,
      },
      {
        id: 10,
        name: "Alchemix V2",
        value: 1,
      },
      {
        id: 56,
        name: "Alpaca Finance",
        value: 1,
      },
      {
        id: 56,
        name: "Avalon Finance",
        value: 1,
      },
      {
        id: 42161,
        name: "Blackwing",
        value: 1,
      },
      {
        id: 81457,
        name: "Blitz",
        value: 1,
      },
      {
        id: 137,
        name: "BlockCentral",
        value: 1,
      },
      {
        id: 42161,
        name: "Camelot",
        value: 1,
      },
      {
        id: 42161,
        name: "CARV",
        value: 1,
      },
      {
        id: 81457,
        name: "Catalyst",
        value: 1,
      },
      {
        id: 42161,
        name: "Chronos Exchange",
        value: 1,
      },
      {
        id: 137,
        name: "CIAN",
        value: 1,
      },
      {
        id: "pze",
        name: "Clearpool",
        value: 1,
      },
      {
        id: 5000,
        name: "Cleopatra",
        value: 1,
      },
      {
        id: 10,
        name: "Compound V3",
        value: 1,
      },
      {
        id: 1,
        name: "Concentrator",
        value: 1,
      },
      {
        id: 42161,
        name: "Contango",
        value: 1,
      },
      {
        id: 1,
        name: "Convex",
        value: 1,
      },
      {
        id: 10,
        name: "Cyber",
        value: 1,
      },
      {
        id: "ink",
        name: "Dinero",
        value: 1,
      },
      {
        id: 42161,
        name: "Dolomite",
        value: 1,
      },
      {
        id: 1329,
        name: "DragonSwap",
        value: 1,
      },
      {
        id: "ink",
        name: "DYORSWAP",
        value: 1,
      },
      {
        id: "pze",
        name: "Dyson Finance",
        value: 1,
      },
      {
        id: 250,
        name: "Equalizer",
        value: 1,
      },
      {
        id: 42161,
        name: "Fluid",
        value: 1,
      },
      {
        id: "frax",
        name: "Fraxlend",
        value: 1,
      },
      {
        id: 56,
        name: "Galxe",
        value: 1,
      },
      {
        id: 1,
        name: "Gearbox",
        value: 1,
      },
      {
        id: 42161,
        name: "GMX V2",
        value: 1,
      },
      {
        id: 43114,
        name: "gogopool",
        value: 1,
      },
      {
        id: 137,
        name: "HaloFi",
        value: 1,
      },
      {
        id: "era",
        name: "Holdstation DeFutures",
        value: 1,
      },
      {
        id: 42161,
        name: "Hyperliquid",
        value: 1,
      },
      {
        id: 81457,
        name: "Hyperlock Finance",
        value: 1,
      },
      {
        id: "ink",
        name: "ICHI",
        value: 1,
      },
      {
        id: "lisk",
        name: "ionic",
        value: 1,
      },
      {
        id: 42161,
        name: "IPOR",
        value: 1,
      },
      {
        id: "mode",
        name: "Ironclad",
        value: 1,
      },
      {
        id: 8453,
        name: "Kaito AI",
        value: 1,
      },
      {
        id: 169,
        name: "KiloEx",
        value: 1,
      },
      {
        id: "mode",
        name: "Kim",
        value: 1,
      },
      {
        id: "kava",
        name: "Kinetix Perp",
        value: 1,
      },
      {
        id: "pze",
        name: "Kokonut Swap",
        value: 1,
      },
      {
        id: 56,
        name: "KTX.Finance",
        value: 1,
      },
      {
        id: 1,
        name: "Layer3",
        value: 1,
      },
      {
        id: 59144,
        name: "LayerBank",
        value: 1,
      },
      {
        id: 5000,
        name: "lendle.xyz",
        value: 1,
      },
      {
        id: 56,
        name: "Level",
        value: 1,
      },
      {
        id: 42161,
        name: "LFJ",
        value: 1,
      },
      {
        id: 42161,
        name: "Locus Finance",
        value: 1,
      },
      {
        id: "kroma",
        name: "LogX",
        value: 1,
      },
      {
        id: 42161,
        name: "Lumoz",
        value: 1,
      },
      {
        id: 59144,
        name: "Lynex",
        value: 1,
      },
      {
        id: 137,
        name: "Magic Alchemy",
        value: 1,
      },
      {
        id: 56,
        name: "Magic Store",
        value: 1,
      },
      {
        id: 169,
        name: "Manta CeDefi",
        value: 1,
      },
      {
        id: 5000,
        name: "Mantle Reward Station",
        value: 1,
      },
      {
        id: 8453,
        name: "Masa",
        value: 1,
      },
      {
        id: "era",
        name: "Maverick",
        value: 1,
      },
      {
        id: 8453,
        name: "Maverick V2",
        value: 1,
      },
      {
        id: 42161,
        name: "Metavault DAO",
        value: 1,
      },
      {
        id: 5000,
        name: "Minterest",
        value: 1,
      },
      {
        id: "mint",
        name: "MintSwap",
        value: 1,
      },
      {
        id: 42161,
        name: "Mitosis",
        value: 1,
      },
      {
        id: 1284,
        name: "Moonwell",
        value: 1,
      },
      {
        id: 534352,
        name: "NURI Exchange",
        value: 1,
      },
      {
        id: 43114,
        name: "Panoptic",
        value: 1,
      },
      {
        id: "mode",
        name: "Poolshark Protocol",
        value: 1,
      },
      {
        id: 42161,
        name: "Premia V3",
        value: 1,
      },
      {
        id: 5000,
        name: "PumpBTC",
        value: 1,
      },
      {
        id: 169,
        name: "QuickSwap",
        value: 1,
      },
      {
        id: "frax",
        name: "RA",
        value: 1,
      },
      {
        id: 42161,
        name: "RAMSES",
        value: 1,
      },
      {
        id: 5000,
        name: "Reax",
        value: 1,
      },
      {
        id: 1,
        name: "REDACTED",
        value: 1,
      },
      {
        id: 1,
        name: "Reddio",
        value: 1,
      },
      {
        id: 42161,
        name: "Rodeo Finance",
        value: 1,
      },
      {
        id: 42161,
        name: "Rysk",
        value: 1,
      },
      {
        id: 1868,
        name: "Sake",
        value: 1,
      },
      {
        id: 42161,
        name: "Savvy DeFi",
        value: 1,
      },
      {
        id: 8453,
        name: "Seamless Protocol",
        value: 1,
      },
      {
        id: 146,
        name: "Shadow Exchange",
        value: 1,
      },
      {
        id: 146,
        name: "Silo",
        value: 1,
      },
      {
        id: 56,
        name: "Solv",
        value: 1,
      },
      {
        id: 146,
        name: "Stability",
        value: 1,
      },
      {
        id: "era",
        name: "Stake DAO",
        value: 1,
      },
      {
        id: 137,
        name: "Steer Protocol",
        value: 1,
      },
      {
        id: 42161,
        name: "Stream Finance",
        value: 1,
      },
      {
        id: 8453,
        name: "Superfluid",
        value: 1,
      },
      {
        id: 1868,
        name: "SuperVol",
        value: 1,
      },
      {
        id: "mode",
        name: "Swap Mode",
        value: 1,
      },
      {
        id: 56,
        name: "Symbiosis",
        value: 1,
      },
      {
        id: 42161,
        name: "Thales",
        value: 1,
      },
      {
        id: 56,
        name: "Thena",
        value: 1,
      },
      {
        id: 56,
        name: "Thetanuts Finance",
        value: 1,
      },
      {
        id: 42161,
        name: "Umami Finance",
        value: 1,
      },
      {
        id: 42220,
        name: "Uniswap V3",
        value: 1,
      },
      {
        id: 42161,
        name: "Vertex",
        value: 1,
      },
      {
        id: 42161,
        name: "Vesta Finance",
        value: 1,
      },
      {
        id: 1,
        name: "Votium",
        value: 1,
      },
      {
        id: 56,
        name: "Wombat Exchange",
        value: 1,
      },
      {
        id: "era",
        name: "WOO Network",
        value: 1,
      },
      {
        id: "era",
        name: "zkDX",
        value: 1,
      },
      {
        id: "era",
        name: "zkSwap Finance",
        value: 1,
      },
      {
        id: "era",
        name: "Zomma",
        value: 1,
      },
      {
        id: 1,
        name: "LIDO",
        value: 1,
      },
    ],
    averageWalletAge: "1.8",
    walletAges: [
      {
        name: "< 1 year",
        value: 4830,
      },
      {
        name: "1-2 years",
        value: 1488,
      },
      {
        name: "2-3 years",
        value: 807,
      },
      {
        name: "> 3 years",
        value: 2504,
      },
      {
        name: "No data",
        value: 0,
      },
    ],
    cex: [
      {
        id: "Unknown",
        value: 9590,
      },
      {
        id: "Binance",
        value: 15,
      },
      {
        id: "OKX",
        value: 4,
      },
      {
        id: "Coinbase",
        value: 4,
      },
      {
        id: "KuCoin",
        value: 3,
      },
      {
        id: "Kraken",
        value: 3,
      },
      {
        id: "Luno",
        value: 1,
      },
      {
        id: "FTX",
        value: 1,
      },
      {
        id: "Gate.io",
        value: 1,
      },
      {
        id: "SwissBorg",
        value: 1,
      },
      {
        id: "SimpleSwap",
        value: 1,
      },
      {
        id: "Poloniex",
        value: 1,
      },
      {
        id: "Coinone",
        value: 1,
      },
      {
        id: "Bitget",
        value: 1,
      },
      {
        id: "Bitfinex",
        value: 1,
      },
      {
        id: "Bittrex",
        value: 1,
      },
    ],
    txns: {
      1: [
        {
          name: "1-25",
          value: 1993,
        },
        {
          name: "26-50",
          value: 440,
        },
        {
          name: "51-100",
          value: 411,
        },
        {
          name: "101-150",
          value: 221,
        },
        {
          name: "151-200",
          value: 149,
        },
        {
          name: "201-250",
          value: 108,
        },
        {
          name: "251-300",
          value: 100,
        },
        {
          name: "301-350",
          value: 99,
        },
        {
          name: "351-400",
          value: 66,
        },
        {
          name: ">400",
          value: 1451,
        },
      ],
      10: [
        {
          name: "1-25",
          value: 333,
        },
        {
          name: "26-50",
          value: 77,
        },
        {
          name: "51-100",
          value: 75,
        },
        {
          name: "101-150",
          value: 27,
        },
        {
          name: "151-200",
          value: 35,
        },
        {
          name: "201-250",
          value: 17,
        },
        {
          name: "251-300",
          value: 23,
        },
        {
          name: "301-350",
          value: 11,
        },
        {
          name: "351-400",
          value: 12,
        },
        {
          name: ">400",
          value: 116,
        },
      ],
      25: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      56: [
        {
          name: "1-25",
          value: 205,
        },
        {
          name: "26-50",
          value: 87,
        },
        {
          name: "51-100",
          value: 115,
        },
        {
          name: "101-150",
          value: 79,
        },
        {
          name: "151-200",
          value: 39,
        },
        {
          name: "201-250",
          value: 53,
        },
        {
          name: "251-300",
          value: 29,
        },
        {
          name: "301-350",
          value: 37,
        },
        {
          name: "351-400",
          value: 34,
        },
        {
          name: ">400",
          value: 444,
        },
      ],
      100: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      137: [
        {
          name: "1-25",
          value: 251,
        },
        {
          name: "26-50",
          value: 83,
        },
        {
          name: "51-100",
          value: 95,
        },
        {
          name: "101-150",
          value: 68,
        },
        {
          name: "151-200",
          value: 40,
        },
        {
          name: "201-250",
          value: 31,
        },
        {
          name: "251-300",
          value: 32,
        },
        {
          name: "301-350",
          value: 26,
        },
        {
          name: "351-400",
          value: 25,
        },
        {
          name: ">400",
          value: 246,
        },
      ],
      169: [
        {
          name: "1-25",
          value: 2,
        },
        {
          name: "26-50",
          value: 1,
        },
        {
          name: "51-100",
          value: 1,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 1,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 1,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 3,
        },
      ],
      204: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      324: [
        {
          name: "1-25",
          value: 0,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      1088: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      1116: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      1284: [
        {
          name: "1-25",
          value: 4,
        },
        {
          name: "26-50",
          value: 1,
        },
        {
          name: "51-100",
          value: 1,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      1329: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      1946: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      4200: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      5000: [
        {
          name: "1-25",
          value: 55,
        },
        {
          name: "26-50",
          value: 7,
        },
        {
          name: "51-100",
          value: 3,
        },
        {
          name: "101-150",
          value: 4,
        },
        {
          name: "151-200",
          value: 1,
        },
        {
          name: "201-250",
          value: 1,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 4,
        },
      ],
      8217: [
        {
          name: "1-25",
          value: 2,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      8453: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 1,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 2,
        },
      ],
      42161: [
        {
          name: "1-25",
          value: 1574,
        },
        {
          name: "26-50",
          value: 171,
        },
        {
          name: "51-100",
          value: 207,
        },
        {
          name: "101-150",
          value: 110,
        },
        {
          name: "151-200",
          value: 69,
        },
        {
          name: "201-250",
          value: 53,
        },
        {
          name: "251-300",
          value: 51,
        },
        {
          name: "301-350",
          value: 45,
        },
        {
          name: "351-400",
          value: 38,
        },
        {
          name: ">400",
          value: 436,
        },
      ],
      59144: [
        {
          name: "1-25",
          value: 2,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      81457: [
        {
          name: "1-25",
          value: 4,
        },
        {
          name: "26-50",
          value: 1,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 1,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 2,
        },
      ],
      200901: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 0,
        },
      ],
      534352: [
        {
          name: "1-25",
          value: 1,
        },
        {
          name: "26-50",
          value: 0,
        },
        {
          name: "51-100",
          value: 0,
        },
        {
          name: "101-150",
          value: 0,
        },
        {
          name: "151-200",
          value: 0,
        },
        {
          name: "201-250",
          value: 0,
        },
        {
          name: "251-300",
          value: 0,
        },
        {
          name: "301-350",
          value: 0,
        },
        {
          name: "351-400",
          value: 0,
        },
        {
          name: ">400",
          value: 1,
        },
      ],
      all: [
        {
          name: "1-25",
          value: 2685,
        },
        {
          name: "26-50",
          value: 413,
        },
        {
          name: "51-100",
          value: 397,
        },
        {
          name: "101-150",
          value: 200,
        },
        {
          name: "151-200",
          value: 173,
        },
        {
          name: "201-250",
          value: 105,
        },
        {
          name: "251-300",
          value: 100,
        },
        {
          name: "301-350",
          value: 109,
        },
        {
          name: "351-400",
          value: 73,
        },
        {
          name: ">400",
          value: 1868,
        },
      ],
    },
    walletValueDistribution: {
      all: {
        total: 105161189623.78937,
        q1: 0,
        q2: 16.2784749,
        q3: 10097.814872074903,
        q4: 1560400.2101871276,
      },
      stable: {
        total: 17973375253.18595,
        q1: 0,
        q2: 0,
        q3: 0,
        q4: 3990.94367232901,
      },
      native: {
        total: 10590168980.747635,
        q1: 0,
        q2: 0,
        q3: 116.75709411754012,
        q4: 17078.118738734218,
      },
      alt: {
        total: 76597645389.8555,
        q1: 0,
        q2: 0,
        q3: 4201.085796954235,
        q4: 1134550.1159841567,
      },
    },
  },
  history: [
    {
      tagIds: [
        {
          _id: "6780f5f73939eba1c5d9534f",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "LST Holder",
          color: "#FCCEEE",
          __v: 0,
        },
      ],
      _id: "6793588d2b302590f5ece76b",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "csv",
        _id: "6793588cf1170c6a0cb40389",
        status: "done",
      },
      type: "csv",
      importTime: "2025-01-24T09:08:29.269Z",
      addressCount: 1,
      validFields: 4,
      csvFilename:
        "https://storage.googleapis.com/metacrm-upload-dev/csv/0x02cAEBE02eFF4E759F3905C0d0675BC847DF6D60/importTest-26f52c25-e080-4bda-9b66-77434ea224db-1737709699.csv",
      __v: 0,
    },
    {
      tagIds: [
        {
          _id: "6787b203b8d36b3a3febdfd9",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "OG Role",
          color: "#F3E87F",
          __v: 0,
        },
      ],
      _id: "6787b50e34b2d440899ca8b5",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "csv",
        _id: "6787b2054220014db331a69a",
        status: "done",
      },
      type: "csv",
      importTime: "2025-01-15T13:15:58.948Z",
      addressCount: 4,
      validFields: 1,
      csvFilename:
        "https://storage.googleapis.com/metacrm-upload-dev/csv/0x81495eBd37c266ccb6516E037d7f76ABf016624e/myself-e82ec78e-12cb-40b5-99d0-44f82fefdb24-1736946951.csv",
      __v: 0,
    },
    {
      tagIds: [
        {
          _id: "6787b203b8d36b3a3febdfd9",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "OG Role",
          color: "#F3E87F",
          __v: 0,
        },
      ],
      _id: "6787b399c3fb063f643db7e4",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "csv",
        _id: "6787b2054220014db331a69a",
        status: "done",
      },
      type: "csv",
      importTime: "2025-01-15T13:09:45.105Z",
      addressCount: 0,
      validFields: 1,
      csvFilename:
        "https://storage.googleapis.com/metacrm-upload-dev/csv/0x81495eBd37c266ccb6516E037d7f76ABf016624e/myself-6d432d31-8a37-4663-8ab9-7a00b559c10c-1736946576.csv",
      __v: 0,
    },
    {
      tagIds: [
        {
          _id: "664599636961afd9649c310b",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "NFT Holder",
          color: "#C2F0B6",
          __v: 0,
        },
        {
          _id: "6645cd8ce7229314c29dd38b",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "New User",
          color: "#FDA19B",
          __v: 0,
        },
      ],
      _id: "67875637d20dff74508bd7b3",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        _id: "678756374220014db3f1bb3a",
        indicator: "singleUser",
        status: "done",
      },
      type: "singleUser",
      importTime: "2025-01-15T06:31:19.906Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [
        {
          _id: "664599636961afd9649c310b",
          entity: "659e2421a68ca1205a0faafa",
          type: "user",
          value: "NFT Holder",
          color: "#C2F0B6",
          __v: 0,
        },
      ],
      _id: "67875329df58454bf280388d",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "attribution",
        _id: "66725ae4c43376235d192df8",
        status: "done",
      },
      type: "singleUser",
      importTime: "2025-01-15T06:18:17.378Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786a2e828d077a259890a08",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T17:46:16.650Z",
      addressCount: 3,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786a2e528d077a2598909f8",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T17:46:13.019Z",
      addressCount: 3,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786a2bd28d077a259890956",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T17:45:33.702Z",
      addressCount: 2,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786a29728d077a259890890",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T17:44:55.143Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786a26c28d077a2598907e4",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T17:44:12.891Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "678631dd521b4784faed64d2",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T09:43:57.152Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "678631d8521b4784faed64b1",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T09:43:52.491Z",
      addressCount: 2,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "678631c2521b4784faed64a5",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T09:43:30.999Z",
      addressCount: 3,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786317e13893584909e54f4",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T09:42:22.960Z",
      addressCount: 3,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786247aed77b6738bfe38c6",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:46:50.841Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "67862457ed77b6738bfe388d",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:46:15.053Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "67862442ed77b6738bfe3864",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:45:54.027Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "678623e60762b77325eb9b42",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:44:22.318Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "6786233f6c22bd720581dd98",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:41:35.360Z",
      addressCount: 1,
      __v: 0,
    },
    {
      tagIds: [],
      _id: "678623086c22bd720581dcba",
      entity: "659e2421a68ca1205a0faafa",
      source: {
        indicator: "webhookUser",
        _id: "6784cdc5402497178bd6686f",
        status: "done",
      },
      type: "webhookUser",
      importTime: "2025-01-14T08:40:40.604Z",
      addressCount: 1,
      __v: 0,
    },
  ],
  basicInfo: {
    uid: "654dac0dd8e379834a15ddd5",
    clientUids: ["DEFI01", "DEFI02"],
    names: ["DEMO"],
    emails: [
      {
        handle: "demo@gmail.com",
        status: "verified",
      },
    ],
    location: "LA, USA",
    devices: ["Iphone", "Macbook"],
    lastEngagement: "ticketChat",
    source: "metadesk",
    wallets: [
      {
        handle: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
        status: "verified",
      },
      {
        handle: "9F8APqFYBQ1FYg1fVDt5sQ8A5UF1AXBjKPaoripTmacw",
        status: "verified",
      },
    ],
    discordHandles: [
      {
        handle: "demoDiscord",
        status: "verified",
      },
    ],
    telegramHandles: [
      {
        handle: "demoTelegram",
        status: "verified",
      },
    ],
    twitterHandles: [
      {
        handle: "demoTwitter",
        status: "verified",
      },
    ],
    tags: [
      {
        tagId: "6638a32ac4b6332ae748f546",
        value: "OG",
        color: "#A4BCFD",
        type: "user",
      },
    ],
  },
  onchainData: [
    {
      id: "683749437a939d1fbcfd4e98",
      address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      ecosystem: "evm",
      chains: [1, 10, 137, 42161],
      walletValues: [
        {
          chainId: 1,
          value: 42043616140.080345,
        },
        {
          chainId: 10,
          value: 258.7262115872267,
        },
        {
          chainId: 137,
          value: 170060.92077295363,
        },
        {
          chainId: 42161,
          value: 4322199.621913253,
        },
      ],
      walletAge: "7y 1m",
      cexLabel: "Bitfinex",
      lastUpdted: "2025-05-28T17:35:11.824Z",
    },
    {
      id: "683749437a939d1fbcfd4e99",
      address: "9F8APqFYBQ1FYg1fVDt5sQ8A5UF1AXBjKPaoripTmacw",
      ecosystem: "solana",
      chains: ["solana"],
      walletValues: [
        {
          chainId: "solana",
          value: 38111.080345,
        },
      ],
      walletAge: "3y 8m",
      cexLabel: "Binance",
      lastUpdted: "2025-05-28T17:35:11.824Z",
    },
  ],
  tokenHodings: [
    {
      token: {
        chainId: 1,
        name: "Universa",
        address: "0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7",
      },
      ecosystem: "evm",
      pinned: true,
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      balance: "1400.000000000000000000",
      value: "3947.000000000000000000",
    },
    {
      token: {
        chainId: 1,
        name: "ETH",
        address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
      },
      ecosystem: "evm",
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      balance: "935442.213961127300000000",
      value: "2408698219.994925500000000000",
    },
    {
      token: {
        chainId: 1,
        name: "UNUS SED LEO",
        address: "0x2af5d2ad76741191d15dfe7bf6ac92d4bd912ca3",
      },
      ecosystem: "evm",
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      balance: "8616761.256500000000000000",
      value: "76258337.120025000000000000",
    },
    {
      token: {
        chainId: 1,
        name: "Tether Gold",
        address: "0x68749665ff8d2d112fa859aa293f07a622782f38",
      },
      ecosystem: "evm",
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      balance: "18097.017670000000000000",
      value: "58217020.023329800000000000",
    },
    {
      token: {
        chainId: 1,
        name: "ChainLink",
        address: "0x514910771af9ca656af840dff83e8264ecf986ca",
      },
      ecosystem: "evm",
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
      balance: "952949.035930000000000000",
      value: "15523539.795299700000000000",
    },
  ],
  nftHoldings: [
    {
      token: {
        chainId: 42161,
        name: "GIVnaut by GiveStation",
        address: "0xdf33ae70b6ec9dd3873d5f221c8786b0c1597ce8",
      },
      ecosystem: "evm",
      walletAddress: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e",
    },
  ],
};
